(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global["@zilliqa-js/account"] = {}));
})(this, (function (exports) { 'use strict';

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (g && (g = 0, op[0] && (_ = 0)), _) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    }

    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    function getDefaultExportFromCjs (x) {
    	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }

    function getAugmentedNamespace(n) {
      if (n.__esModule) return n;
      var f = n.default;
    	if (typeof f == "function") {
    		var a = function a () {
    			if (this instanceof a) {
    				var args = [null];
    				args.push.apply(args, arguments);
    				var Ctor = Function.bind.apply(f, args);
    				return new Ctor();
    			}
    			return f.apply(this, arguments);
    		};
    		a.prototype = f.prototype;
      } else a = {};
      Object.defineProperty(a, '__esModule', {value: true});
    	Object.keys(n).forEach(function (k) {
    		var d = Object.getOwnPropertyDescriptor(n, k);
    		Object.defineProperty(a, k, d.get ? d : {
    			enumerable: true,
    			get: function () {
    				return n[k];
    			}
    		});
    	});
    	return a;
    }

    var bundle$2 = {exports: {}};

    bundle$2.exports;

    (function (module, exports) {
    	(function (global, factory) {
    	  factory(exports) ;
    	})(commonjsGlobal, (function (exports) {
    	  //  Copyright (C) 2018 Zilliqa
    	  //
    	  //  This file is part of zilliqa-js
    	  //
    	  //  This program is free software: you can redistribute it and/or modify
    	  //  it under the terms of the GNU General Public License as published by
    	  //  the Free Software Foundation, either version 3 of the License, or
    	  //  (at your option) any later version.
    	  //
    	  //  This program is distributed in the hope that it will be useful,
    	  //  but WITHOUT ANY WARRANTY; without even the implied warranty of
    	  //  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    	  //  GNU General Public License for more details.
    	  //
    	  //  You should have received a copy of the GNU General Public License
    	  //  along with this program.  If not, see <https://www.gnu.org/licenses/>.
    	  var Signer = /** @class */ (function () {
    	      function Signer() {
    	      }
    	      return Signer;
    	  }());
    	  exports.TransactionError = void 0;
    	  (function (TransactionError) {
    	      TransactionError[TransactionError["CHECKER_FAILED"] = 0] = "CHECKER_FAILED";
    	      TransactionError[TransactionError["RUNNER_FAILED"] = 1] = "RUNNER_FAILED";
    	      TransactionError[TransactionError["BALANCE_TRANSFER_FAILED"] = 2] = "BALANCE_TRANSFER_FAILED";
    	      TransactionError[TransactionError["EXECUTE_CMD_FAILED"] = 3] = "EXECUTE_CMD_FAILED";
    	      TransactionError[TransactionError["EXECUTE_CMD_TIMEOUT"] = 4] = "EXECUTE_CMD_TIMEOUT";
    	      TransactionError[TransactionError["NO_GAS_REMAINING_FOUND"] = 5] = "NO_GAS_REMAINING_FOUND";
    	      TransactionError[TransactionError["NO_ACCEPTED_FOUND"] = 6] = "NO_ACCEPTED_FOUND";
    	      TransactionError[TransactionError["CALL_CONTRACT_FAILED"] = 7] = "CALL_CONTRACT_FAILED";
    	      TransactionError[TransactionError["CREATE_CONTRACT_FAILED"] = 8] = "CREATE_CONTRACT_FAILED";
    	      TransactionError[TransactionError["JSON_OUTPUT_CORRUPTED"] = 9] = "JSON_OUTPUT_CORRUPTED";
    	      TransactionError[TransactionError["CONTRACT_NOT_EXIST"] = 10] = "CONTRACT_NOT_EXIST";
    	      TransactionError[TransactionError["STATE_CORRUPTED"] = 11] = "STATE_CORRUPTED";
    	      TransactionError[TransactionError["LOG_ENTRY_INSTALL_FAILED"] = 12] = "LOG_ENTRY_INSTALL_FAILED";
    	      TransactionError[TransactionError["MESSAGE_CORRUPTED"] = 13] = "MESSAGE_CORRUPTED";
    	      TransactionError[TransactionError["RECEIPT_IS_NULL"] = 14] = "RECEIPT_IS_NULL";
    	      TransactionError[TransactionError["MAX_DEPTH_REACHED"] = 15] = "MAX_DEPTH_REACHED";
    	      TransactionError[TransactionError["CHAIN_CALL_DIFF_SHARD"] = 16] = "CHAIN_CALL_DIFF_SHARD";
    	      TransactionError[TransactionError["PREPARATION_FAILED"] = 17] = "PREPARATION_FAILED";
    	      TransactionError[TransactionError["NO_OUTPUT"] = 18] = "NO_OUTPUT";
    	      TransactionError[TransactionError["OUTPUT_ILLEGAL"] = 19] = "OUTPUT_ILLEGAL";
    	  })(exports.TransactionError || (exports.TransactionError = {}));

    	  /******************************************************************************
    	  Copyright (c) Microsoft Corporation.

    	  Permission to use, copy, modify, and/or distribute this software for any
    	  purpose with or without fee is hereby granted.

    	  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    	  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    	  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    	  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    	  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    	  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    	  PERFORMANCE OF THIS SOFTWARE.
    	  ***************************************************************************** */
    	  /* global Reflect, Promise */

    	  var extendStatics = function(d, b) {
    	      extendStatics = Object.setPrototypeOf ||
    	          ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    	          function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    	      return extendStatics(d, b);
    	  };

    	  function __extends(d, b) {
    	      if (typeof b !== "function" && b !== null)
    	          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    	      extendStatics(d, b);
    	      function __() { this.constructor = d; }
    	      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    	  }

    	  var __assign = function() {
    	      __assign = Object.assign || function __assign(t) {
    	          for (var s, i = 1, n = arguments.length; i < n; i++) {
    	              s = arguments[i];
    	              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    	          }
    	          return t;
    	      };
    	      return __assign.apply(this, arguments);
    	  };

    	  function __awaiter(thisArg, _arguments, P, generator) {
    	      function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    	      return new (P || (P = Promise))(function (resolve, reject) {
    	          function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
    	          function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
    	          function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
    	          step((generator = generator.apply(thisArg, _arguments || [])).next());
    	      });
    	  }

    	  function __generator(thisArg, body) {
    	      var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    	      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    	      function verb(n) { return function (v) { return step([n, v]); }; }
    	      function step(op) {
    	          if (f) throw new TypeError("Generator is already executing.");
    	          while (g && (g = 0, op[0] && (_ = 0)), _) try {
    	              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
    	              if (y = 0, t) op = [op[0] & 2, t.value];
    	              switch (op[0]) {
    	                  case 0: case 1: t = op; break;
    	                  case 4: _.label++; return { value: op[1], done: false };
    	                  case 5: _.label++; y = op[1]; op = [0]; continue;
    	                  case 7: op = _.ops.pop(); _.trys.pop(); continue;
    	                  default:
    	                      if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
    	                      if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
    	                      if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
    	                      if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
    	                      if (t[2]) _.ops.pop();
    	                      _.trys.pop(); continue;
    	              }
    	              op = body.call(thisArg, _);
    	          } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
    	          if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    	      }
    	  }

    	  function __values(o) {
    	      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    	      if (m) return m.call(o);
    	      if (o && typeof o.length === "number") return {
    	          next: function () {
    	              if (o && i >= o.length) o = void 0;
    	              return { value: o && o[i++], done: !o };
    	          }
    	      };
    	      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    	  }

    	  function __read(o, n) {
    	      var m = typeof Symbol === "function" && o[Symbol.iterator];
    	      if (!m) return o;
    	      var i = m.call(o), r, ar = [], e;
    	      try {
    	          while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    	      }
    	      catch (error) { e = { error: error }; }
    	      finally {
    	          try {
    	              if (r && !r.done && (m = i["return"])) m.call(i);
    	          }
    	          finally { if (e) throw e.error; }
    	      }
    	      return ar;
    	  }

    	  function __spreadArray(to, from, pack) {
    	      if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    	          if (ar || !(i in from)) {
    	              if (!ar) ar = Array.prototype.slice.call(from, 0, i);
    	              ar[i] = from[i];
    	          }
    	      }
    	      return to.concat(ar || Array.prototype.slice.call(from));
    	  }

    	  //  Copyright (C) 2018 Zilliqa
    	  /**
    	   * sign
    	   *
    	   * This decorates a method by attempting to sign the first argument of the
    	   * intercepted method.
    	   *
    	   * @param {T} target
    	   * @param {K} key
    	   * @param {PropertyDescriptor} descriptor
    	   * @returns {PropertyDescriptor | undefined}
    	   */
    	  var sign = function (target, key, descriptor) {
    	      var original = descriptor.value;
    	      function interceptor(arg) {
    	          var args = [];
    	          for (var _i = 1; _i < arguments.length; _i++) {
    	              args[_i - 1] = arguments[_i];
    	          }
    	          return __awaiter(this, void 0, void 0, function () {
    	              var signed;
    	              return __generator(this, function (_a) {
    	                  switch (_a.label) {
    	                      case 0:
    	                          if (!(original && arg.bytes)) return [3 /*break*/, 2];
    	                          return [4 /*yield*/, this.signer.sign(arg)];
    	                      case 1:
    	                          signed = _a.sent();
    	                          return [2 /*return*/, original.call.apply(original, __spreadArray([this, signed], __read(args), false))];
    	                      case 2: return [2 /*return*/];
    	                  }
    	              });
    	          });
    	      }
    	      descriptor.value = interceptor;
    	      return descriptor;
    	  };

    	  (function(self) {

    	    if (self.fetch) {
    	      return
    	    }

    	    var support = {
    	      searchParams: 'URLSearchParams' in self,
    	      iterable: 'Symbol' in self && 'iterator' in Symbol,
    	      blob: 'FileReader' in self && 'Blob' in self && (function() {
    	        try {
    	          new Blob();
    	          return true
    	        } catch(e) {
    	          return false
    	        }
    	      })(),
    	      formData: 'FormData' in self,
    	      arrayBuffer: 'ArrayBuffer' in self
    	    };

    	    if (support.arrayBuffer) {
    	      var viewClasses = [
    	        '[object Int8Array]',
    	        '[object Uint8Array]',
    	        '[object Uint8ClampedArray]',
    	        '[object Int16Array]',
    	        '[object Uint16Array]',
    	        '[object Int32Array]',
    	        '[object Uint32Array]',
    	        '[object Float32Array]',
    	        '[object Float64Array]'
    	      ];

    	      var isDataView = function(obj) {
    	        return obj && DataView.prototype.isPrototypeOf(obj)
    	      };

    	      var isArrayBufferView = ArrayBuffer.isView || function(obj) {
    	        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    	      };
    	    }

    	    function normalizeName(name) {
    	      if (typeof name !== 'string') {
    	        name = String(name);
    	      }
    	      if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
    	        throw new TypeError('Invalid character in header field name')
    	      }
    	      return name.toLowerCase()
    	    }

    	    function normalizeValue(value) {
    	      if (typeof value !== 'string') {
    	        value = String(value);
    	      }
    	      return value
    	    }

    	    // Build a destructive iterator for the value list
    	    function iteratorFor(items) {
    	      var iterator = {
    	        next: function() {
    	          var value = items.shift();
    	          return {done: value === undefined, value: value}
    	        }
    	      };

    	      if (support.iterable) {
    	        iterator[Symbol.iterator] = function() {
    	          return iterator
    	        };
    	      }

    	      return iterator
    	    }

    	    function Headers(headers) {
    	      this.map = {};

    	      if (headers instanceof Headers) {
    	        headers.forEach(function(value, name) {
    	          this.append(name, value);
    	        }, this);
    	      } else if (Array.isArray(headers)) {
    	        headers.forEach(function(header) {
    	          this.append(header[0], header[1]);
    	        }, this);
    	      } else if (headers) {
    	        Object.getOwnPropertyNames(headers).forEach(function(name) {
    	          this.append(name, headers[name]);
    	        }, this);
    	      }
    	    }

    	    Headers.prototype.append = function(name, value) {
    	      name = normalizeName(name);
    	      value = normalizeValue(value);
    	      var oldValue = this.map[name];
    	      this.map[name] = oldValue ? oldValue+','+value : value;
    	    };

    	    Headers.prototype['delete'] = function(name) {
    	      delete this.map[normalizeName(name)];
    	    };

    	    Headers.prototype.get = function(name) {
    	      name = normalizeName(name);
    	      return this.has(name) ? this.map[name] : null
    	    };

    	    Headers.prototype.has = function(name) {
    	      return this.map.hasOwnProperty(normalizeName(name))
    	    };

    	    Headers.prototype.set = function(name, value) {
    	      this.map[normalizeName(name)] = normalizeValue(value);
    	    };

    	    Headers.prototype.forEach = function(callback, thisArg) {
    	      for (var name in this.map) {
    	        if (this.map.hasOwnProperty(name)) {
    	          callback.call(thisArg, this.map[name], name, this);
    	        }
    	      }
    	    };

    	    Headers.prototype.keys = function() {
    	      var items = [];
    	      this.forEach(function(value, name) { items.push(name); });
    	      return iteratorFor(items)
    	    };

    	    Headers.prototype.values = function() {
    	      var items = [];
    	      this.forEach(function(value) { items.push(value); });
    	      return iteratorFor(items)
    	    };

    	    Headers.prototype.entries = function() {
    	      var items = [];
    	      this.forEach(function(value, name) { items.push([name, value]); });
    	      return iteratorFor(items)
    	    };

    	    if (support.iterable) {
    	      Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
    	    }

    	    function consumed(body) {
    	      if (body.bodyUsed) {
    	        return Promise.reject(new TypeError('Already read'))
    	      }
    	      body.bodyUsed = true;
    	    }

    	    function fileReaderReady(reader) {
    	      return new Promise(function(resolve, reject) {
    	        reader.onload = function() {
    	          resolve(reader.result);
    	        };
    	        reader.onerror = function() {
    	          reject(reader.error);
    	        };
    	      })
    	    }

    	    function readBlobAsArrayBuffer(blob) {
    	      var reader = new FileReader();
    	      var promise = fileReaderReady(reader);
    	      reader.readAsArrayBuffer(blob);
    	      return promise
    	    }

    	    function readBlobAsText(blob) {
    	      var reader = new FileReader();
    	      var promise = fileReaderReady(reader);
    	      reader.readAsText(blob);
    	      return promise
    	    }

    	    function readArrayBufferAsText(buf) {
    	      var view = new Uint8Array(buf);
    	      var chars = new Array(view.length);

    	      for (var i = 0; i < view.length; i++) {
    	        chars[i] = String.fromCharCode(view[i]);
    	      }
    	      return chars.join('')
    	    }

    	    function bufferClone(buf) {
    	      if (buf.slice) {
    	        return buf.slice(0)
    	      } else {
    	        var view = new Uint8Array(buf.byteLength);
    	        view.set(new Uint8Array(buf));
    	        return view.buffer
    	      }
    	    }

    	    function Body() {
    	      this.bodyUsed = false;

    	      this._initBody = function(body) {
    	        this._bodyInit = body;
    	        if (!body) {
    	          this._bodyText = '';
    	        } else if (typeof body === 'string') {
    	          this._bodyText = body;
    	        } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
    	          this._bodyBlob = body;
    	        } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
    	          this._bodyFormData = body;
    	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
    	          this._bodyText = body.toString();
    	        } else if (support.arrayBuffer && support.blob && isDataView(body)) {
    	          this._bodyArrayBuffer = bufferClone(body.buffer);
    	          // IE 10-11 can't handle a DataView body.
    	          this._bodyInit = new Blob([this._bodyArrayBuffer]);
    	        } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
    	          this._bodyArrayBuffer = bufferClone(body);
    	        } else {
    	          throw new Error('unsupported BodyInit type')
    	        }

    	        if (!this.headers.get('content-type')) {
    	          if (typeof body === 'string') {
    	            this.headers.set('content-type', 'text/plain;charset=UTF-8');
    	          } else if (this._bodyBlob && this._bodyBlob.type) {
    	            this.headers.set('content-type', this._bodyBlob.type);
    	          } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
    	            this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
    	          }
    	        }
    	      };

    	      if (support.blob) {
    	        this.blob = function() {
    	          var rejected = consumed(this);
    	          if (rejected) {
    	            return rejected
    	          }

    	          if (this._bodyBlob) {
    	            return Promise.resolve(this._bodyBlob)
    	          } else if (this._bodyArrayBuffer) {
    	            return Promise.resolve(new Blob([this._bodyArrayBuffer]))
    	          } else if (this._bodyFormData) {
    	            throw new Error('could not read FormData body as blob')
    	          } else {
    	            return Promise.resolve(new Blob([this._bodyText]))
    	          }
    	        };

    	        this.arrayBuffer = function() {
    	          if (this._bodyArrayBuffer) {
    	            return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
    	          } else {
    	            return this.blob().then(readBlobAsArrayBuffer)
    	          }
    	        };
    	      }

    	      this.text = function() {
    	        var rejected = consumed(this);
    	        if (rejected) {
    	          return rejected
    	        }

    	        if (this._bodyBlob) {
    	          return readBlobAsText(this._bodyBlob)
    	        } else if (this._bodyArrayBuffer) {
    	          return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    	        } else if (this._bodyFormData) {
    	          throw new Error('could not read FormData body as text')
    	        } else {
    	          return Promise.resolve(this._bodyText)
    	        }
    	      };

    	      if (support.formData) {
    	        this.formData = function() {
    	          return this.text().then(decode)
    	        };
    	      }

    	      this.json = function() {
    	        return this.text().then(JSON.parse)
    	      };

    	      return this
    	    }

    	    // HTTP methods whose capitalization should be normalized
    	    var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

    	    function normalizeMethod(method) {
    	      var upcased = method.toUpperCase();
    	      return (methods.indexOf(upcased) > -1) ? upcased : method
    	    }

    	    function Request(input, options) {
    	      options = options || {};
    	      var body = options.body;

    	      if (input instanceof Request) {
    	        if (input.bodyUsed) {
    	          throw new TypeError('Already read')
    	        }
    	        this.url = input.url;
    	        this.credentials = input.credentials;
    	        if (!options.headers) {
    	          this.headers = new Headers(input.headers);
    	        }
    	        this.method = input.method;
    	        this.mode = input.mode;
    	        if (!body && input._bodyInit != null) {
    	          body = input._bodyInit;
    	          input.bodyUsed = true;
    	        }
    	      } else {
    	        this.url = String(input);
    	      }

    	      this.credentials = options.credentials || this.credentials || 'omit';
    	      if (options.headers || !this.headers) {
    	        this.headers = new Headers(options.headers);
    	      }
    	      this.method = normalizeMethod(options.method || this.method || 'GET');
    	      this.mode = options.mode || this.mode || null;
    	      this.referrer = null;

    	      if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    	        throw new TypeError('Body not allowed for GET or HEAD requests')
    	      }
    	      this._initBody(body);
    	    }

    	    Request.prototype.clone = function() {
    	      return new Request(this, { body: this._bodyInit })
    	    };

    	    function decode(body) {
    	      var form = new FormData();
    	      body.trim().split('&').forEach(function(bytes) {
    	        if (bytes) {
    	          var split = bytes.split('=');
    	          var name = split.shift().replace(/\+/g, ' ');
    	          var value = split.join('=').replace(/\+/g, ' ');
    	          form.append(decodeURIComponent(name), decodeURIComponent(value));
    	        }
    	      });
    	      return form
    	    }

    	    function parseHeaders(rawHeaders) {
    	      var headers = new Headers();
    	      // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    	      // https://tools.ietf.org/html/rfc7230#section-3.2
    	      var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    	      preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
    	        var parts = line.split(':');
    	        var key = parts.shift().trim();
    	        if (key) {
    	          var value = parts.join(':').trim();
    	          headers.append(key, value);
    	        }
    	      });
    	      return headers
    	    }

    	    Body.call(Request.prototype);

    	    function Response(bodyInit, options) {
    	      if (!options) {
    	        options = {};
    	      }

    	      this.type = 'default';
    	      this.status = options.status === undefined ? 200 : options.status;
    	      this.ok = this.status >= 200 && this.status < 300;
    	      this.statusText = 'statusText' in options ? options.statusText : 'OK';
    	      this.headers = new Headers(options.headers);
    	      this.url = options.url || '';
    	      this._initBody(bodyInit);
    	    }

    	    Body.call(Response.prototype);

    	    Response.prototype.clone = function() {
    	      return new Response(this._bodyInit, {
    	        status: this.status,
    	        statusText: this.statusText,
    	        headers: new Headers(this.headers),
    	        url: this.url
    	      })
    	    };

    	    Response.error = function() {
    	      var response = new Response(null, {status: 0, statusText: ''});
    	      response.type = 'error';
    	      return response
    	    };

    	    var redirectStatuses = [301, 302, 303, 307, 308];

    	    Response.redirect = function(url, status) {
    	      if (redirectStatuses.indexOf(status) === -1) {
    	        throw new RangeError('Invalid status code')
    	      }

    	      return new Response(null, {status: status, headers: {location: url}})
    	    };

    	    self.Headers = Headers;
    	    self.Request = Request;
    	    self.Response = Response;

    	    self.fetch = function(input, init) {
    	      return new Promise(function(resolve, reject) {
    	        var request = new Request(input, init);
    	        var xhr = new XMLHttpRequest();

    	        xhr.onload = function() {
    	          var options = {
    	            status: xhr.status,
    	            statusText: xhr.statusText,
    	            headers: parseHeaders(xhr.getAllResponseHeaders() || '')
    	          };
    	          options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
    	          var body = 'response' in xhr ? xhr.response : xhr.responseText;
    	          resolve(new Response(body, options));
    	        };

    	        xhr.onerror = function() {
    	          reject(new TypeError('Network request failed'));
    	        };

    	        xhr.ontimeout = function() {
    	          reject(new TypeError('Network request failed'));
    	        };

    	        xhr.open(request.method, request.url, true);

    	        if (request.credentials === 'include') {
    	          xhr.withCredentials = true;
    	        } else if (request.credentials === 'omit') {
    	          xhr.withCredentials = false;
    	        }

    	        if ('responseType' in xhr && support.blob) {
    	          xhr.responseType = 'blob';
    	        }

    	        request.headers.forEach(function(value, name) {
    	          xhr.setRequestHeader(name, value);
    	        });

    	        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    	      })
    	    };
    	    self.fetch.polyfill = true;
    	  })(typeof self !== 'undefined' ? self : undefined);

    	  /**
    	   * blockchain-side.
    	   */
    	  exports.RPCMethod = void 0;
    	  (function (RPCMethod) {
    	      // Network-related methods
    	      RPCMethod["GetNetworkId"] = "GetNetworkId";
    	      // Blockchain-related methods
    	      RPCMethod["GetBlockchainInfo"] = "GetBlockchainInfo";
    	      RPCMethod["GetShardingStructure"] = "GetShardingStructure";
    	      RPCMethod["GetDSBlock"] = "GetDsBlock";
    	      RPCMethod["GetLatestDSBlock"] = "GetLatestDsBlock";
    	      RPCMethod["GetNumDSBlocks"] = "GetNumDSBlocks";
    	      RPCMethod["GetDSBlockRate"] = "GetDSBlockRate";
    	      RPCMethod["DSBlockListing"] = "DSBlockListing";
    	      RPCMethod["GetTxBlock"] = "GetTxBlock";
    	      RPCMethod["GetLatestTxBlock"] = "GetLatestTxBlock";
    	      RPCMethod["GetNumTxBlocks"] = "GetNumTxBlocks";
    	      RPCMethod["GetTxBlockRate"] = "GetTxBlockRate";
    	      RPCMethod["TxBlockListing"] = "TxBlockListing";
    	      RPCMethod["GetNumTransactions"] = "GetNumTransactions";
    	      RPCMethod["GetTransactionRate"] = "GetTransactionRate";
    	      RPCMethod["GetCurrentMiniEpoch"] = "GetCurrentMiniEpoch";
    	      RPCMethod["GetCurrentDSEpoch"] = "GetCurrentDSEpoch";
    	      RPCMethod["GetPrevDifficulty"] = "GetPrevDifficulty";
    	      RPCMethod["GetPrevDSDifficulty"] = "GetPrevDSDifficulty";
    	      RPCMethod["GetTotalCoinSupply"] = "GetTotalCoinSupply";
    	      RPCMethod["GetMinerInfo"] = "GetMinerInfo";
    	      // Transaction-related methods
    	      RPCMethod["CreateTransaction"] = "CreateTransaction";
    	      RPCMethod["GetTransaction"] = "GetTransaction";
    	      RPCMethod["GetTransactionStatus"] = "GetTransactionStatus";
    	      RPCMethod["GetRecentTransactions"] = "GetRecentTransactions";
    	      RPCMethod["GetTransactionsForTxBlock"] = "GetTransactionsForTxBlock";
    	      RPCMethod["GetTransactionsForTxBlockEx"] = "GetTransactionsForTxBlockEx";
    	      RPCMethod["GetTxnBodiesForTxBlock"] = "GetTxnBodiesForTxBlock";
    	      RPCMethod["GetTxnBodiesForTxBlockEx"] = "GetTxnBodiesForTxBlockEx";
    	      RPCMethod["GetNumTxnsTxEpoch"] = "GetNumTxnsTxEpoch";
    	      RPCMethod["GetNumTxnsDSEpoch"] = "GetNumTxnsDSEpoch";
    	      RPCMethod["GetMinimumGasPrice"] = "GetMinimumGasPrice";
    	      // Contract-related methods
    	      RPCMethod["GetContractAddressFromTransactionID"] = "GetContractAddressFromTransactionID";
    	      RPCMethod["GetSmartContracts"] = "GetSmartContracts";
    	      RPCMethod["GetSmartContractCode"] = "GetSmartContractCode";
    	      RPCMethod["GetSmartContractInit"] = "GetSmartContractInit";
    	      RPCMethod["GetSmartContractState"] = "GetSmartContractState";
    	      RPCMethod["GetSmartContractSubState"] = "GetSmartContractSubState";
    	      RPCMethod["GetStateProof"] = "GetStateProof";
    	      // Account-related methods
    	      RPCMethod["GetBalance"] = "GetBalance";
    	  })(exports.RPCMethod || (exports.RPCMethod = {}));
    	  exports.RPCErrorCode = void 0;
    	  (function (RPCErrorCode) {
    	      // Standard JSON-RPC 2.0 errors
    	      // RPC_INVALID_REQUEST is internally mapped to HTTP_BAD_REQUEST (400).
    	      // It should not be used for application-layer errors.
    	      RPCErrorCode[RPCErrorCode["RPC_INVALID_REQUEST"] = -32600] = "RPC_INVALID_REQUEST";
    	      // RPC_METHOD_NOT_FOUND is internally mapped to HTTP_NOT_FOUND (404).
    	      // It should not be used for application-layer errors.
    	      RPCErrorCode[RPCErrorCode["RPC_METHOD_NOT_FOUND"] = -32601] = "RPC_METHOD_NOT_FOUND";
    	      RPCErrorCode[RPCErrorCode["RPC_INVALID_PARAMS"] = -32602] = "RPC_INVALID_PARAMS";
    	      // RPC_INTERNAL_ERROR should only be used for genuine errors in bitcoind
    	      // (for example datadir corruption).
    	      RPCErrorCode[RPCErrorCode["RPC_INTERNAL_ERROR"] = -32603] = "RPC_INTERNAL_ERROR";
    	      RPCErrorCode[RPCErrorCode["RPC_PARSE_ERROR"] = -32700] = "RPC_PARSE_ERROR";
    	      // General application defined errors
    	      RPCErrorCode[RPCErrorCode["RPC_MISC_ERROR"] = -1] = "RPC_MISC_ERROR";
    	      RPCErrorCode[RPCErrorCode["RPC_TYPE_ERROR"] = -3] = "RPC_TYPE_ERROR";
    	      RPCErrorCode[RPCErrorCode["RPC_INVALID_ADDRESS_OR_KEY"] = -5] = "RPC_INVALID_ADDRESS_OR_KEY";
    	      RPCErrorCode[RPCErrorCode["RPC_INVALID_PARAMETER"] = -8] = "RPC_INVALID_PARAMETER";
    	      RPCErrorCode[RPCErrorCode["RPC_DATABASE_ERROR"] = -20] = "RPC_DATABASE_ERROR";
    	      RPCErrorCode[RPCErrorCode["RPC_DESERIALIZATION_ERROR"] = -22] = "RPC_DESERIALIZATION_ERROR";
    	      RPCErrorCode[RPCErrorCode["RPC_VERIFY_ERROR"] = -25] = "RPC_VERIFY_ERROR";
    	      RPCErrorCode[RPCErrorCode["RPC_VERIFY_REJECTED"] = -26] = "RPC_VERIFY_REJECTED";
    	      RPCErrorCode[RPCErrorCode["RPC_IN_WARMUP"] = -28] = "RPC_IN_WARMUP";
    	      RPCErrorCode[RPCErrorCode["RPC_METHOD_DEPRECATED"] = -32] = "RPC_METHOD_DEPRECATED";
    	  })(exports.RPCErrorCode || (exports.RPCErrorCode = {}));
    	  var DEFAULT_HEADERS = { "Content-Type": "application/json" };
    	  var performRPC = function (request, handler) { return __awaiter(void 0, void 0, void 0, function () {
    	      var response, err_1;
    	      return __generator(this, function (_a) {
    	          switch (_a.label) {
    	              case 0:
    	                  _a.trys.push([0, 2, , 3]);
    	                  return [4 /*yield*/, fetch(request.url, {
    	                          method: "POST",
    	                          cache: "no-cache",
    	                          mode: "cors",
    	                          redirect: "follow",
    	                          body: JSON.stringify(request.payload),
    	                          headers: __assign(__assign({}, DEFAULT_HEADERS), ((request.options && request.options.headers) || {})),
    	                      })];
    	              case 1:
    	                  response = _a.sent();
    	                  return [2 /*return*/, response
    	                          .json()
    	                          .then(function (body) {
    	                          return __assign(__assign({}, body), { req: request });
    	                      })
    	                          .then(handler)];
    	              case 2:
    	                  err_1 = _a.sent();
    	                  throw err_1;
    	              case 3: return [2 /*return*/];
    	          }
    	      });
    	  }); };
    	  // identical to performRPC; difference is the response
    	  var performBatchRPC = function (request, handler // eslint-disable-line @typescript-eslint/no-unused-vars
    	  ) { return __awaiter(void 0, void 0, void 0, function () {
    	      var response, err_2;
    	      return __generator(this, function (_a) {
    	          switch (_a.label) {
    	              case 0:
    	                  _a.trys.push([0, 2, , 3]);
    	                  return [4 /*yield*/, fetch(request.url, {
    	                          method: "POST",
    	                          cache: "no-cache",
    	                          mode: "cors",
    	                          redirect: "follow",
    	                          referrer: "no-referrer",
    	                          body: JSON.stringify(request.payload),
    	                          headers: __assign(__assign({}, DEFAULT_HEADERS), ((request.options && request.options.headers) || {})),
    	                      })];
    	              case 1:
    	                  response = _a.sent();
    	                  return [2 /*return*/, (response
    	                          .json()
    	                          .then(function (batch_result) {
    	                          return { batch_result: batch_result, req: request };
    	                      })
    	                          // no handler as compared to performRPC to preserve the body array
    	                          // e.g. response
    	                          /*
    	                        { body:
    	                          [ { id: 1, jsonrpc: '2.0', result: [Object] },
    	                            { id: 1, jsonrpc: '2.0', result: [Object] } ],
    	                         req:
    	                          { url: 'https://dev-api.zilliqa.com',
    	                            payload: [ [Object], [Object] ] } }
    	                        */
    	                          .then())];
    	              case 2:
    	                  err_2 = _a.sent();
    	                  throw err_2;
    	              case 3: return [2 /*return*/];
    	          }
    	      });
    	  }); };

    	  //  Copyright (C) 2018 Zilliqa
    	  //
    	  //  This file is part of zilliqa-js
    	  //
    	  //  This program is free software: you can redistribute it and/or modify
    	  //  it under the terms of the GNU General Public License as published by
    	  //  the Free Software Foundation, either version 3 of the License, or
    	  //  (at your option) any later version.
    	  //
    	  //  This program is distributed in the hope that it will be useful,
    	  //  but WITHOUT ANY WARRANTY; without even the implied warranty of
    	  //  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    	  //  GNU General Public License for more details.
    	  //
    	  //  You should have received a copy of the GNU General Public License
    	  //  along with this program.  If not, see <https://www.gnu.org/licenses/>.
    	  function isValidResponse(response) {
    	      if (response.jsonrpc === '2.0' &&
    	          (response.id === '1' || response.id === 1) &&
    	          (response.error || response.result)) {
    	          return true;
    	      }
    	      return false;
    	  }
    	  function composeMiddleware() {
    	      var fns = [];
    	      for (var _i = 0; _i < arguments.length; _i++) {
    	          fns[_i] = arguments[_i];
    	      }
    	      if (fns.length === 0) {
    	          return function (arg) { return arg; };
    	      }
    	      if (fns.length === 1) {
    	          return fns[0];
    	      }
    	      return fns.reduce(function (a, b) { return function (arg) { return a(b(arg)); }; });
    	  }

    	  //  Copyright (C) 2018 Zilliqa
    	  var MiddlewareType;
    	  (function (MiddlewareType) {
    	      MiddlewareType[MiddlewareType["REQ"] = 0] = "REQ";
    	      MiddlewareType[MiddlewareType["RES"] = 1] = "RES";
    	  })(MiddlewareType || (MiddlewareType = {}));
    	  var BaseProvider = /** @class */ (function () {
    	      function BaseProvider(nodeURL, reqMiddleware, resMiddleware) {
    	          if (reqMiddleware === void 0) { reqMiddleware = new Map(); }
    	          if (resMiddleware === void 0) { resMiddleware = new Map(); }
    	          var _this = this;
    	          this.middleware = {
    	              request: {
    	                  use: function (fn, match) {
    	                      if (match === void 0) { match = '*'; }
    	                      _this.pushMiddleware(fn, 0 /* MiddlewareType.REQ */, match);
    	                  },
    	              },
    	              response: {
    	                  use: function (fn, match) {
    	                      if (match === void 0) { match = '*'; }
    	                      _this.pushMiddleware(fn, 1 /* MiddlewareType.RES */, match);
    	                  },
    	              },
    	          };
    	          this.nodeURL = nodeURL;
    	          this.reqMiddleware = reqMiddleware;
    	          this.resMiddleware = resMiddleware;
    	      }
    	      /**
    	       * pushMiddleware
    	       *
    	       * Adds the middleware to the appropriate middleware map.
    	       *
    	       * @param {ResMiddlewareFn}
    	       * @param {T} type
    	       * @param {Matcher} match
    	       * @returns {void}
    	       */
    	      BaseProvider.prototype.pushMiddleware = function (fn, type, match) {
    	          if (type !== 0 /* MiddlewareType.REQ */ && type !== 1 /* MiddlewareType.RES */) {
    	              throw new Error('Please specify the type of middleware being added');
    	          }
    	          if (type === 0 /* MiddlewareType.REQ */) {
    	              var current = this.reqMiddleware.get(match) || [];
    	              this.reqMiddleware.set(match, __spreadArray(__spreadArray([], __read(current), false), [fn], false));
    	          }
    	          else {
    	              var current = this.resMiddleware.get(match) || [];
    	              this.resMiddleware.set(match, __spreadArray(__spreadArray([], __read(current), false), [fn], false));
    	          }
    	      };
    	      /**
    	       * getMiddleware
    	       *
    	       * Returns the middleware that matches the matcher provided. Note that
    	       * middleware are called in order of specificity: string -> regexp ->
    	       * wildcard.
    	       *
    	       * @param {Matcher} match
    	       * @returns {[ReqMiddlewareFn[], ResMiddlewareFn[]]}
    	       */
    	      BaseProvider.prototype.getMiddleware = function (method) {
    	          var e_1, _a, e_2, _b;
    	          var reqFns = [];
    	          var resFns = [];
    	          try {
    	              for (var _c = __values(this.reqMiddleware.entries()), _d = _c.next(); !_d.done; _d = _c.next()) {
    	                  var _e = __read(_d.value, 2), key = _e[0], transformers = _e[1];
    	                  if (typeof key === 'string' && key !== '*' && key === method) {
    	                      reqFns.push.apply(reqFns, __spreadArray([], __read(transformers), false));
    	                  }
    	                  if (key instanceof RegExp && key.test(method)) {
    	                      reqFns.push.apply(reqFns, __spreadArray([], __read(transformers), false));
    	                  }
    	                  if (key === '*') {
    	                      reqFns.push.apply(reqFns, __spreadArray([], __read(transformers), false));
    	                  }
    	              }
    	          }
    	          catch (e_1_1) { e_1 = { error: e_1_1 }; }
    	          finally {
    	              try {
    	                  if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
    	              }
    	              finally { if (e_1) throw e_1.error; }
    	          }
    	          try {
    	              for (var _f = __values(this.resMiddleware.entries()), _g = _f.next(); !_g.done; _g = _f.next()) {
    	                  var _h = __read(_g.value, 2), key = _h[0], transformers = _h[1];
    	                  if (typeof key === 'string' && key !== '*' && key === method) {
    	                      resFns.push.apply(resFns, __spreadArray([], __read(transformers), false));
    	                  }
    	                  if (key instanceof RegExp && key.test(method)) {
    	                      resFns.push.apply(resFns, __spreadArray([], __read(transformers), false));
    	                  }
    	                  if (key === '*') {
    	                      resFns.push.apply(resFns, __spreadArray([], __read(transformers), false));
    	                  }
    	              }
    	          }
    	          catch (e_2_1) { e_2 = { error: e_2_1 }; }
    	          finally {
    	              try {
    	                  if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
    	              }
    	              finally { if (e_2) throw e_2.error; }
    	          }
    	          return [reqFns, resFns];
    	      };
    	      return BaseProvider;
    	  }());

    	  //  Copyright (C) 2018 Zilliqa
    	  var HTTPProvider = /** @class */ (function (_super) {
    	      __extends(HTTPProvider, _super);
    	      function HTTPProvider() {
    	          return _super !== null && _super.apply(this, arguments) || this;
    	      }
    	      HTTPProvider.prototype.buildPayload = function (method, params) {
    	          return {
    	              url: this.nodeURL,
    	              payload: { id: 1, jsonrpc: '2.0', method: method, params: params },
    	          };
    	      };
    	      HTTPProvider.prototype.buildBatchPayload = function (method, paramsList) {
    	          var payloads = [];
    	          for (var i = 0; i < paramsList.length; i++) {
    	              // most of the payloads should be a single param, e.g. GetTransaction
    	              // however, there are special cases e.g. GetSmartContractSubState & GetTransactionsForTxBlockEx
    	              // where the param field is a list
    	              var payloadParams = paramsList[i];
    	              var params = void 0;
    	              if (Array.isArray(payloadParams)) {
    	                  // for those param field that is already a list
    	                  params = payloadParams;
    	              }
    	              else {
    	                  params = [payloadParams];
    	              }
    	              // id start from index 1
    	              payloads.push({
    	                  id: i + 1,
    	                  jsonrpc: '2.0',
    	                  method: method,
    	                  params: params,
    	              });
    	          }
    	          return {
    	              url: this.nodeURL,
    	              payload: payloads,
    	          };
    	      };
    	      HTTPProvider.prototype.send = function (method) {
    	          var params = [];
    	          for (var _i = 1; _i < arguments.length; _i++) {
    	              params[_i - 1] = arguments[_i];
    	          }
    	          var _a = __read(this.getMiddleware(method), 2), tReq = _a[0], tRes = _a[1];
    	          var reqMiddleware = composeMiddleware.apply(void 0, __spreadArray([], __read(tReq), false));
    	          var resMiddleware = composeMiddleware.apply(void 0, __spreadArray([], __read(tRes), false));
    	          var req = reqMiddleware(this.buildPayload(method, params));
    	          return performRPC(req, resMiddleware);
    	      };
    	      HTTPProvider.prototype.sendBatch = function (method, params) {
    	          var _a = __read(this.getMiddleware(method), 2), tReq = _a[0], tRes = _a[1];
    	          var reqMiddleware = composeMiddleware.apply(void 0, __spreadArray([], __read(tReq), false));
    	          composeMiddleware.apply(void 0, __spreadArray([], __read(tRes), false));
    	          var batchPayload = this.buildBatchPayload(method, params);
    	          var req = reqMiddleware(batchPayload);
    	          return performBatchRPC(req);
    	      };
    	      HTTPProvider.prototype.subscribe = function (event, subscriber) {
    	          throw new Error('HTTPProvider does not support subscriptions.');
    	      };
    	      HTTPProvider.prototype.unsubscribe = function (token) {
    	          throw new Error('HTTPProvider does not support subscriptions.');
    	      };
    	      return HTTPProvider;
    	  }(BaseProvider));

    	  //  Copyright (C) 2018 Zilliqa
    	  //
    	  //  This file is part of zilliqa-js
    	  //
    	  //  This program is free software: you can redistribute it and/or modify
    	  //  it under the terms of the GNU General Public License as published by
    	  //  the Free Software Foundation, either version 3 of the License, or
    	  //  (at your option) any later version.
    	  //
    	  //  This program is distributed in the hope that it will be useful,
    	  //  but WITHOUT ANY WARRANTY; without even the implied warranty of
    	  //  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    	  //  GNU General Public License for more details.
    	  //
    	  //  You should have received a copy of the GNU General Public License
    	  //  along with this program.  If not, see <https://www.gnu.org/licenses/>.
    	  // this constant is used to indicate the number of times to poll the
    	  // blockchain for a transaction confirmation. this number has been selected by
    	  // using a heuristic to calculate the approximate maximum amount of time it
    	  // should take for a transaction to be confirmed, even during a PoW submission
    	  // round.
    	  var GET_TX_ATTEMPTS = 33;

    	  //      
    	  // An event handler can take an optional event argument
    	  // and should not return a value
    	                                            
    	                                                                 

    	  // An array of all currently registered event handlers for a type
    	                                              
    	                                                              
    	  // A map of event types and their corresponding event handlers.
    	                          
    	                                   
    	                                     
    	    

    	  /** Mitt: Tiny (~200b) functional event emitter / pubsub.
    	   *  @name mitt
    	   *  @returns {Mitt}
    	   */
    	  function mitt(all                 ) {
    	  	all = all || Object.create(null);

    	  	return {
    	  		/**
    	  		 * Register an event handler for the given type.
    	  		 *
    	  		 * @param  {String} type	Type of event to listen for, or `"*"` for all events
    	  		 * @param  {Function} handler Function to call in response to given event
    	  		 * @memberOf mitt
    	  		 */
    	  		on: function on(type        , handler              ) {
    	  			(all[type] || (all[type] = [])).push(handler);
    	  		},

    	  		/**
    	  		 * Remove an event handler for the given type.
    	  		 *
    	  		 * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
    	  		 * @param  {Function} handler Handler function to remove
    	  		 * @memberOf mitt
    	  		 */
    	  		off: function off(type        , handler              ) {
    	  			if (all[type]) {
    	  				all[type].splice(all[type].indexOf(handler) >>> 0, 1);
    	  			}
    	  		},

    	  		/**
    	  		 * Invoke all handlers for the given type.
    	  		 * If present, `"*"` handlers are invoked after type-matched handlers.
    	  		 *
    	  		 * @param {String} type  The event type to invoke
    	  		 * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
    	  		 * @memberOf mitt
    	  		 */
    	  		emit: function emit(type        , evt     ) {
    	  			(all[type] || []).slice().map(function (handler) { handler(evt); });
    	  			(all['*'] || []).slice().map(function (handler) { handler(type, evt); });
    	  		}
    	  	};
    	  }

    	  //  Copyright (C) 2018 Zilliqa
    	  var EventEmitter = /** @class */ (function () {
    	      function EventEmitter() {
    	          var _this = this;
    	          this.handlers = {};
    	          // TODO: As any added to solve
    	          // error TS7009: 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    	          this.emitter = new mitt(this.handlers);
    	          this.off = this.emitter.off.bind(this);
    	          this.emit = this.emitter.emit.bind(this);
    	          this.promise = new Promise(function (resolve, reject) {
    	              _this.resolve = resolve;
    	              _this.reject = reject;
    	          });
    	          this.then = this.promise.then.bind(this.promise);
    	      }
    	      EventEmitter.prototype.resetHandlers = function () {
    	          for (var i in this.handlers) {
    	              delete this.handlers[i];
    	          }
    	      };
    	      EventEmitter.prototype.on = function (type, handler) {
    	          this.emitter.on(type, handler);
    	          return this;
    	      };
    	      EventEmitter.prototype.once = function (type, handler) {
    	          var _this = this;
    	          this.emitter.on(type, function (e) {
    	              handler(e);
    	              _this.removeEventListener(type);
    	          });
    	      };
    	      EventEmitter.prototype.addEventListener = function (type, handler) {
    	          this.emitter.on(type, handler);
    	      };
    	      EventEmitter.prototype.removeEventListener = function (type, handler) {
    	          if (!type) {
    	              this.handlers = {};
    	              return;
    	          }
    	          if (!handler) {
    	              delete this.handlers[type];
    	          }
    	          else {
    	              return this.emitter.off(type, handler);
    	          }
    	      };
    	      EventEmitter.prototype.onError = function (error) {
    	          this.emitter.on('error', error);
    	          this.removeEventListener('*');
    	      };
    	      EventEmitter.prototype.onData = function (data) {
    	          this.emitter.on('data', data);
    	          this.removeEventListener('*');
    	      };
    	      EventEmitter.prototype.listenerCount = function (listenKey) {
    	          var count = 0;
    	          Object.keys(this.handlers).forEach(function (val) {
    	              if (listenKey === val) {
    	                  count += 1;
    	              }
    	          });
    	          return count;
    	      };
    	      return EventEmitter;
    	  }());

    	  exports.EventEmitter = EventEmitter;
    	  exports.GET_TX_ATTEMPTS = GET_TX_ATTEMPTS;
    	  exports.HTTPProvider = HTTPProvider;
    	  exports.Signer = Signer;
    	  exports.composeMiddleware = composeMiddleware;
    	  exports.isValidResponse = isValidResponse;
    	  exports.performBatchRPC = performBatchRPC;
    	  exports.performRPC = performRPC;
    	  exports.sign = sign;

    	  Object.defineProperty(exports, '__esModule', { value: true });

    	}));
    	
    } (bundle$2, bundle$2.exports));

    var bundleExports$2 = bundle$2.exports;

    var bundle$1 = {exports: {}};

    bundle$1.exports;

    (function (module, exports) {
    	(function (global, factory) {
    	  factory(exports) ;
    	})(commonjsGlobal, (function (exports) {
    	  //  Copyright (C) 2018 Zilliqa
    	  //
    	  //  This file is part of zilliqa-js
    	  //
    	  //  This program is free software: you can redistribute it and/or modify
    	  //  it under the terms of the GNU General Public License as published by
    	  //  the Free Software Foundation, either version 3 of the License, or
    	  //  (at your option) any later version.
    	  //
    	  //  This program is distributed in the hope that it will be useful,
    	  //  but WITHOUT ANY WARRANTY; without even the implied warranty of
    	  //  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    	  //  GNU General Public License for more details.
    	  //
    	  //  You should have received a copy of the GNU General Public License
    	  //  along with this program.  If not, see <https://www.gnu.org/licenses/>.
    	  /**
    	   * intToHexArray
    	   *
    	   * @param {number} int - the number to be converted to hex
    	   * @param {number)} size - the desired width of the hex value. will pad.
    	   *
    	   * @returns {string[]}
    	   */
    	  var intToHexArray = function (int, size) {
    	      var hex = [];
    	      var hexRep = [];
    	      var hexVal = int.toString(16);
    	      // TODO: this really needs to be refactored.
    	      for (var i = 0; i < hexVal.length; i++) {
    	          hexRep[i] = hexVal[i].toString();
    	      }
    	      for (var i = 0; i < size - hexVal.length; i++) {
    	          hex.push('0');
    	      }
    	      for (var i = 0; i < hexVal.length; i++) {
    	          hex.push(hexRep[i]);
    	      }
    	      return hex;
    	  };
    	  /**
    	   * intToByteArray
    	   *
    	   * Converts a number to Uint8Array
    	   *
    	   * @param {number} num
    	   * @param {number} size
    	   *
    	   * @returns {Uint8Array}
    	   */
    	  var intToByteArray = function (num, size) {
    	      var x = num;
    	      var res = [];
    	      while (x > 0) {
    	          res.push(x & 255);
    	          x = x >> 8;
    	      }
    	      var pad = size - res.length;
    	      for (var i = 0; i < pad; i++) {
    	          res.unshift(0);
    	      }
    	      return Uint8Array.from(res);
    	  };
    	  /**
    	   * hexToByteArray
    	   *
    	   * Convers a hex string to a Uint8Array
    	   *
    	   * @param {string} hex
    	   * @returns {Uint8Array}
    	   */
    	  var hexToByteArray = function (hex) {
    	      var res = new Uint8Array(hex.length / 2);
    	      for (var i = 0; i < hex.length; i += 2) {
    	          res[i / 2] = parseInt(hex.substring(i, i + 2), 16);
    	      }
    	      return res;
    	  };
    	  /**
    	   * hexToIntArray
    	   *
    	   * @param {string} hex
    	   * @returns {number[]}
    	   */
    	  var hexToIntArray = function (hex) {
    	      if (!hex || !isHex(hex)) {
    	          return [];
    	      }
    	      var res = [];
    	      for (var i = 0; i < hex.length; i++) {
    	          var c = hex.charCodeAt(i);
    	          var hi = c >> 8;
    	          var lo = c & 0xff;
    	          hi ? res.push(hi, lo) : res.push(lo);
    	      }
    	      return res;
    	  };
    	  /**
    	   * pack
    	   *
    	   * Takes two 16-bit integers and combines them. Used to compute version.
    	   *
    	   * @param {number} a
    	   * @param {number} b
    	   *
    	   * @returns {number} - a 32-bit number
    	   */
    	  var pack = function (a, b) {
    	      if (a >> 16 > 0 || b >> 16 > 0) {
    	          throw new Error('Both a and b must be 16 bits or less');
    	      }
    	      return (a << 16) + b;
    	  };
    	  /**
    	   * compareBytes
    	   *
    	   * A constant time HMAC comparison function.
    	   *
    	   * @param {string} a
    	   * @param {string} b
    	   * @returns {boolean}
    	   */
    	  var isEqual = function (a, b) {
    	      var bzA = hexToIntArray(a);
    	      var bzB = hexToIntArray(b);
    	      if (bzA.length !== bzB.length) {
    	          return false;
    	      }
    	      var result = 0;
    	      for (var i = 0; i < bzA.length; i++) {
    	          result |= bzA[i] ^ bzB[i];
    	      }
    	      return result === 0;
    	  };
    	  /**
    	   * isHex
    	   *
    	   * @param {string} str - string to be tested
    	   * @returns {boolean}
    	   */
    	  var isHex = function (str) {
    	      var plain = str.replace('0x', '');
    	      return /[0-9a-f]*$/i.test(plain);
    	  };

    	  var bytes = /*#__PURE__*/Object.freeze({
    	    __proto__: null,
    	    intToHexArray: intToHexArray,
    	    intToByteArray: intToByteArray,
    	    hexToByteArray: hexToByteArray,
    	    hexToIntArray: hexToIntArray,
    	    pack: pack,
    	    isEqual: isEqual,
    	    isHex: isHex
    	  });

    	  /******************************************************************************
    	  Copyright (c) Microsoft Corporation.

    	  Permission to use, copy, modify, and/or distribute this software for any
    	  purpose with or without fee is hereby granted.

    	  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    	  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    	  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    	  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    	  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    	  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    	  PERFORMANCE OF THIS SOFTWARE.
    	  ***************************************************************************** */

    	  function __values(o) {
    	      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    	      if (m) return m.call(o);
    	      if (o && typeof o.length === "number") return {
    	          next: function () {
    	              if (o && i >= o.length) o = void 0;
    	              return { value: o && o[i++], done: !o };
    	          }
    	      };
    	      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    	  }

    	  function __read(o, n) {
    	      var m = typeof Symbol === "function" && o[Symbol.iterator];
    	      if (!m) return o;
    	      var i = m.call(o), r, ar = [], e;
    	      try {
    	          while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    	      }
    	      catch (error) { e = { error: error }; }
    	      finally {
    	          try {
    	              if (r && !r.done && (m = i["return"])) m.call(i);
    	          }
    	          finally { if (e) throw e.error; }
    	      }
    	      return ar;
    	  }

    	  var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : {};

    	  function getDefaultExportFromCjs (x) {
    	  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    	  }

    	  function getAugmentedNamespace(n) {
    	    if (n.__esModule) return n;
    	    var f = n.default;
    	  	if (typeof f == "function") {
    	  		var a = function a () {
    	  			if (this instanceof a) {
    	  				var args = [null];
    	  				args.push.apply(args, arguments);
    	  				var Ctor = Function.bind.apply(f, args);
    	  				return new Ctor();
    	  			}
    	  			return f.apply(this, arguments);
    	  		};
    	  		a.prototype = f.prototype;
    	    } else a = {};
    	    Object.defineProperty(a, '__esModule', {value: true});
    	  	Object.keys(n).forEach(function (k) {
    	  		var d = Object.getOwnPropertyDescriptor(n, k);
    	  		Object.defineProperty(a, k, d.get ? d : {
    	  			enumerable: true,
    	  			get: function () {
    	  				return n[k];
    	  			}
    	  		});
    	  	});
    	  	return a;
    	  }

    	  var bn = {exports: {}};

    	  var global$1 = (typeof commonjsGlobal !== "undefined" ? commonjsGlobal :
    	    typeof self !== "undefined" ? self :
    	    typeof window !== "undefined" ? window : {});

    	  var lookup = [];
    	  var revLookup = [];
    	  var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
    	  var inited = false;
    	  function init () {
    	    inited = true;
    	    var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    	    for (var i = 0, len = code.length; i < len; ++i) {
    	      lookup[i] = code[i];
    	      revLookup[code.charCodeAt(i)] = i;
    	    }

    	    revLookup['-'.charCodeAt(0)] = 62;
    	    revLookup['_'.charCodeAt(0)] = 63;
    	  }

    	  function toByteArray (b64) {
    	    if (!inited) {
    	      init();
    	    }
    	    var i, j, l, tmp, placeHolders, arr;
    	    var len = b64.length;

    	    if (len % 4 > 0) {
    	      throw new Error('Invalid string. Length must be a multiple of 4')
    	    }

    	    // the number of equal signs (place holders)
    	    // if there are two placeholders, than the two characters before it
    	    // represent one byte
    	    // if there is only one, then the three characters before it represent 2 bytes
    	    // this is just a cheap hack to not do indexOf twice
    	    placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;

    	    // base64 is 4/3 + up to two characters of the original data
    	    arr = new Arr(len * 3 / 4 - placeHolders);

    	    // if there are placeholders, only get up to the last complete 4 chars
    	    l = placeHolders > 0 ? len - 4 : len;

    	    var L = 0;

    	    for (i = 0, j = 0; i < l; i += 4, j += 3) {
    	      tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)];
    	      arr[L++] = (tmp >> 16) & 0xFF;
    	      arr[L++] = (tmp >> 8) & 0xFF;
    	      arr[L++] = tmp & 0xFF;
    	    }

    	    if (placeHolders === 2) {
    	      tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4);
    	      arr[L++] = tmp & 0xFF;
    	    } else if (placeHolders === 1) {
    	      tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2);
    	      arr[L++] = (tmp >> 8) & 0xFF;
    	      arr[L++] = tmp & 0xFF;
    	    }

    	    return arr
    	  }

    	  function tripletToBase64 (num) {
    	    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
    	  }

    	  function encodeChunk (uint8, start, end) {
    	    var tmp;
    	    var output = [];
    	    for (var i = start; i < end; i += 3) {
    	      tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2]);
    	      output.push(tripletToBase64(tmp));
    	    }
    	    return output.join('')
    	  }

    	  function fromByteArray (uint8) {
    	    if (!inited) {
    	      init();
    	    }
    	    var tmp;
    	    var len = uint8.length;
    	    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    	    var output = '';
    	    var parts = [];
    	    var maxChunkLength = 16383; // must be multiple of 3

    	    // go through the array every three bytes, we'll deal with trailing stuff later
    	    for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    	      parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
    	    }

    	    // pad the end with zeros, but make sure to not forget the extra bytes
    	    if (extraBytes === 1) {
    	      tmp = uint8[len - 1];
    	      output += lookup[tmp >> 2];
    	      output += lookup[(tmp << 4) & 0x3F];
    	      output += '==';
    	    } else if (extraBytes === 2) {
    	      tmp = (uint8[len - 2] << 8) + (uint8[len - 1]);
    	      output += lookup[tmp >> 10];
    	      output += lookup[(tmp >> 4) & 0x3F];
    	      output += lookup[(tmp << 2) & 0x3F];
    	      output += '=';
    	    }

    	    parts.push(output);

    	    return parts.join('')
    	  }

    	  function read (buffer, offset, isLE, mLen, nBytes) {
    	    var e, m;
    	    var eLen = nBytes * 8 - mLen - 1;
    	    var eMax = (1 << eLen) - 1;
    	    var eBias = eMax >> 1;
    	    var nBits = -7;
    	    var i = isLE ? (nBytes - 1) : 0;
    	    var d = isLE ? -1 : 1;
    	    var s = buffer[offset + i];

    	    i += d;

    	    e = s & ((1 << (-nBits)) - 1);
    	    s >>= (-nBits);
    	    nBits += eLen;
    	    for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    	    m = e & ((1 << (-nBits)) - 1);
    	    e >>= (-nBits);
    	    nBits += mLen;
    	    for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    	    if (e === 0) {
    	      e = 1 - eBias;
    	    } else if (e === eMax) {
    	      return m ? NaN : ((s ? -1 : 1) * Infinity)
    	    } else {
    	      m = m + Math.pow(2, mLen);
    	      e = e - eBias;
    	    }
    	    return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
    	  }

    	  function write (buffer, value, offset, isLE, mLen, nBytes) {
    	    var e, m, c;
    	    var eLen = nBytes * 8 - mLen - 1;
    	    var eMax = (1 << eLen) - 1;
    	    var eBias = eMax >> 1;
    	    var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
    	    var i = isLE ? 0 : (nBytes - 1);
    	    var d = isLE ? 1 : -1;
    	    var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

    	    value = Math.abs(value);

    	    if (isNaN(value) || value === Infinity) {
    	      m = isNaN(value) ? 1 : 0;
    	      e = eMax;
    	    } else {
    	      e = Math.floor(Math.log(value) / Math.LN2);
    	      if (value * (c = Math.pow(2, -e)) < 1) {
    	        e--;
    	        c *= 2;
    	      }
    	      if (e + eBias >= 1) {
    	        value += rt / c;
    	      } else {
    	        value += rt * Math.pow(2, 1 - eBias);
    	      }
    	      if (value * c >= 2) {
    	        e++;
    	        c /= 2;
    	      }

    	      if (e + eBias >= eMax) {
    	        m = 0;
    	        e = eMax;
    	      } else if (e + eBias >= 1) {
    	        m = (value * c - 1) * Math.pow(2, mLen);
    	        e = e + eBias;
    	      } else {
    	        m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
    	        e = 0;
    	      }
    	    }

    	    for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

    	    e = (e << mLen) | m;
    	    eLen += mLen;
    	    for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

    	    buffer[offset + i - d] |= s * 128;
    	  }

    	  var toString = {}.toString;

    	  var isArray = Array.isArray || function (arr) {
    	    return toString.call(arr) == '[object Array]';
    	  };

    	  /*!
    	   * The buffer module from node.js, for the browser.
    	   *
    	   * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
    	   * @license  MIT
    	   */

    	  var INSPECT_MAX_BYTES = 50;

    	  /**
    	   * If `Buffer.TYPED_ARRAY_SUPPORT`:
    	   *   === true    Use Uint8Array implementation (fastest)
    	   *   === false   Use Object implementation (most compatible, even IE6)
    	   *
    	   * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
    	   * Opera 11.6+, iOS 4.2+.
    	   *
    	   * Due to various browser bugs, sometimes the Object implementation will be used even
    	   * when the browser supports typed arrays.
    	   *
    	   * Note:
    	   *
    	   *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
    	   *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
    	   *
    	   *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
    	   *
    	   *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
    	   *     incorrect length in some situations.

    	   * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
    	   * get the Object implementation, which is slower but behaves correctly.
    	   */
    	  Buffer.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined
    	    ? global$1.TYPED_ARRAY_SUPPORT
    	    : true;

    	  /*
    	   * Export kMaxLength after typed array support is determined.
    	   */
    	  var _kMaxLength = kMaxLength();

    	  function kMaxLength () {
    	    return Buffer.TYPED_ARRAY_SUPPORT
    	      ? 0x7fffffff
    	      : 0x3fffffff
    	  }

    	  function createBuffer (that, length) {
    	    if (kMaxLength() < length) {
    	      throw new RangeError('Invalid typed array length')
    	    }
    	    if (Buffer.TYPED_ARRAY_SUPPORT) {
    	      // Return an augmented `Uint8Array` instance, for best performance
    	      that = new Uint8Array(length);
    	      that.__proto__ = Buffer.prototype;
    	    } else {
    	      // Fallback: Return an object instance of the Buffer class
    	      if (that === null) {
    	        that = new Buffer(length);
    	      }
    	      that.length = length;
    	    }

    	    return that
    	  }

    	  /**
    	   * The Buffer constructor returns instances of `Uint8Array` that have their
    	   * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
    	   * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
    	   * and the `Uint8Array` methods. Square bracket notation works as expected -- it
    	   * returns a single octet.
    	   *
    	   * The `Uint8Array` prototype remains unmodified.
    	   */

    	  function Buffer (arg, encodingOrOffset, length) {
    	    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    	      return new Buffer(arg, encodingOrOffset, length)
    	    }

    	    // Common case.
    	    if (typeof arg === 'number') {
    	      if (typeof encodingOrOffset === 'string') {
    	        throw new Error(
    	          'If encoding is specified then the first argument must be a string'
    	        )
    	      }
    	      return allocUnsafe(this, arg)
    	    }
    	    return from(this, arg, encodingOrOffset, length)
    	  }

    	  Buffer.poolSize = 8192; // not used by this implementation

    	  // TODO: Legacy, not needed anymore. Remove in next major version.
    	  Buffer._augment = function (arr) {
    	    arr.__proto__ = Buffer.prototype;
    	    return arr
    	  };

    	  function from (that, value, encodingOrOffset, length) {
    	    if (typeof value === 'number') {
    	      throw new TypeError('"value" argument must not be a number')
    	    }

    	    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    	      return fromArrayBuffer(that, value, encodingOrOffset, length)
    	    }

    	    if (typeof value === 'string') {
    	      return fromString$1(that, value, encodingOrOffset)
    	    }

    	    return fromObject(that, value)
    	  }

    	  /**
    	   * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
    	   * if value is a number.
    	   * Buffer.from(str[, encoding])
    	   * Buffer.from(array)
    	   * Buffer.from(buffer)
    	   * Buffer.from(arrayBuffer[, byteOffset[, length]])
    	   **/
    	  Buffer.from = function (value, encodingOrOffset, length) {
    	    return from(null, value, encodingOrOffset, length)
    	  };

    	  if (Buffer.TYPED_ARRAY_SUPPORT) {
    	    Buffer.prototype.__proto__ = Uint8Array.prototype;
    	    Buffer.__proto__ = Uint8Array;
    	    if (typeof Symbol !== 'undefined' && Symbol.species &&
    	        Buffer[Symbol.species] === Buffer) ;
    	  }

    	  function assertSize (size) {
    	    if (typeof size !== 'number') {
    	      throw new TypeError('"size" argument must be a number')
    	    } else if (size < 0) {
    	      throw new RangeError('"size" argument must not be negative')
    	    }
    	  }

    	  function alloc (that, size, fill, encoding) {
    	    assertSize(size);
    	    if (size <= 0) {
    	      return createBuffer(that, size)
    	    }
    	    if (fill !== undefined) {
    	      // Only pay attention to encoding if it's a string. This
    	      // prevents accidentally sending in a number that would
    	      // be interpretted as a start offset.
    	      return typeof encoding === 'string'
    	        ? createBuffer(that, size).fill(fill, encoding)
    	        : createBuffer(that, size).fill(fill)
    	    }
    	    return createBuffer(that, size)
    	  }

    	  /**
    	   * Creates a new filled Buffer instance.
    	   * alloc(size[, fill[, encoding]])
    	   **/
    	  Buffer.alloc = function (size, fill, encoding) {
    	    return alloc(null, size, fill, encoding)
    	  };

    	  function allocUnsafe (that, size) {
    	    assertSize(size);
    	    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    	    if (!Buffer.TYPED_ARRAY_SUPPORT) {
    	      for (var i = 0; i < size; ++i) {
    	        that[i] = 0;
    	      }
    	    }
    	    return that
    	  }

    	  /**
    	   * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
    	   * */
    	  Buffer.allocUnsafe = function (size) {
    	    return allocUnsafe(null, size)
    	  };
    	  /**
    	   * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
    	   */
    	  Buffer.allocUnsafeSlow = function (size) {
    	    return allocUnsafe(null, size)
    	  };

    	  function fromString$1 (that, string, encoding) {
    	    if (typeof encoding !== 'string' || encoding === '') {
    	      encoding = 'utf8';
    	    }

    	    if (!Buffer.isEncoding(encoding)) {
    	      throw new TypeError('"encoding" must be a valid string encoding')
    	    }

    	    var length = byteLength(string, encoding) | 0;
    	    that = createBuffer(that, length);

    	    var actual = that.write(string, encoding);

    	    if (actual !== length) {
    	      // Writing a hex string, for example, that contains invalid characters will
    	      // cause everything after the first invalid character to be ignored. (e.g.
    	      // 'abxxcd' will be treated as 'ab')
    	      that = that.slice(0, actual);
    	    }

    	    return that
    	  }

    	  function fromArrayLike (that, array) {
    	    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    	    that = createBuffer(that, length);
    	    for (var i = 0; i < length; i += 1) {
    	      that[i] = array[i] & 255;
    	    }
    	    return that
    	  }

    	  function fromArrayBuffer (that, array, byteOffset, length) {
    	    array.byteLength; // this throws if `array` is not a valid ArrayBuffer

    	    if (byteOffset < 0 || array.byteLength < byteOffset) {
    	      throw new RangeError('\'offset\' is out of bounds')
    	    }

    	    if (array.byteLength < byteOffset + (length || 0)) {
    	      throw new RangeError('\'length\' is out of bounds')
    	    }

    	    if (byteOffset === undefined && length === undefined) {
    	      array = new Uint8Array(array);
    	    } else if (length === undefined) {
    	      array = new Uint8Array(array, byteOffset);
    	    } else {
    	      array = new Uint8Array(array, byteOffset, length);
    	    }

    	    if (Buffer.TYPED_ARRAY_SUPPORT) {
    	      // Return an augmented `Uint8Array` instance, for best performance
    	      that = array;
    	      that.__proto__ = Buffer.prototype;
    	    } else {
    	      // Fallback: Return an object instance of the Buffer class
    	      that = fromArrayLike(that, array);
    	    }
    	    return that
    	  }

    	  function fromObject (that, obj) {
    	    if (internalIsBuffer(obj)) {
    	      var len = checked(obj.length) | 0;
    	      that = createBuffer(that, len);

    	      if (that.length === 0) {
    	        return that
    	      }

    	      obj.copy(that, 0, 0, len);
    	      return that
    	    }

    	    if (obj) {
    	      if ((typeof ArrayBuffer !== 'undefined' &&
    	          obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
    	        if (typeof obj.length !== 'number' || isnan(obj.length)) {
    	          return createBuffer(that, 0)
    	        }
    	        return fromArrayLike(that, obj)
    	      }

    	      if (obj.type === 'Buffer' && isArray(obj.data)) {
    	        return fromArrayLike(that, obj.data)
    	      }
    	    }

    	    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
    	  }

    	  function checked (length) {
    	    // Note: cannot use `length < kMaxLength()` here because that fails when
    	    // length is NaN (which is otherwise coerced to zero.)
    	    if (length >= kMaxLength()) {
    	      throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
    	                           'size: 0x' + kMaxLength().toString(16) + ' bytes')
    	    }
    	    return length | 0
    	  }

    	  function SlowBuffer (length) {
    	    if (+length != length) { // eslint-disable-line eqeqeq
    	      length = 0;
    	    }
    	    return Buffer.alloc(+length)
    	  }
    	  Buffer.isBuffer = isBuffer;
    	  function internalIsBuffer (b) {
    	    return !!(b != null && b._isBuffer)
    	  }

    	  Buffer.compare = function compare (a, b) {
    	    if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
    	      throw new TypeError('Arguments must be Buffers')
    	    }

    	    if (a === b) return 0

    	    var x = a.length;
    	    var y = b.length;

    	    for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    	      if (a[i] !== b[i]) {
    	        x = a[i];
    	        y = b[i];
    	        break
    	      }
    	    }

    	    if (x < y) return -1
    	    if (y < x) return 1
    	    return 0
    	  };

    	  Buffer.isEncoding = function isEncoding (encoding) {
    	    switch (String(encoding).toLowerCase()) {
    	      case 'hex':
    	      case 'utf8':
    	      case 'utf-8':
    	      case 'ascii':
    	      case 'latin1':
    	      case 'binary':
    	      case 'base64':
    	      case 'ucs2':
    	      case 'ucs-2':
    	      case 'utf16le':
    	      case 'utf-16le':
    	        return true
    	      default:
    	        return false
    	    }
    	  };

    	  Buffer.concat = function concat (list, length) {
    	    if (!isArray(list)) {
    	      throw new TypeError('"list" argument must be an Array of Buffers')
    	    }

    	    if (list.length === 0) {
    	      return Buffer.alloc(0)
    	    }

    	    var i;
    	    if (length === undefined) {
    	      length = 0;
    	      for (i = 0; i < list.length; ++i) {
    	        length += list[i].length;
    	      }
    	    }

    	    var buffer = Buffer.allocUnsafe(length);
    	    var pos = 0;
    	    for (i = 0; i < list.length; ++i) {
    	      var buf = list[i];
    	      if (!internalIsBuffer(buf)) {
    	        throw new TypeError('"list" argument must be an Array of Buffers')
    	      }
    	      buf.copy(buffer, pos);
    	      pos += buf.length;
    	    }
    	    return buffer
    	  };

    	  function byteLength (string, encoding) {
    	    if (internalIsBuffer(string)) {
    	      return string.length
    	    }
    	    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
    	        (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    	      return string.byteLength
    	    }
    	    if (typeof string !== 'string') {
    	      string = '' + string;
    	    }

    	    var len = string.length;
    	    if (len === 0) return 0

    	    // Use a for loop to avoid recursion
    	    var loweredCase = false;
    	    for (;;) {
    	      switch (encoding) {
    	        case 'ascii':
    	        case 'latin1':
    	        case 'binary':
    	          return len
    	        case 'utf8':
    	        case 'utf-8':
    	        case undefined:
    	          return utf8ToBytes(string).length
    	        case 'ucs2':
    	        case 'ucs-2':
    	        case 'utf16le':
    	        case 'utf-16le':
    	          return len * 2
    	        case 'hex':
    	          return len >>> 1
    	        case 'base64':
    	          return base64ToBytes(string).length
    	        default:
    	          if (loweredCase) return utf8ToBytes(string).length // assume utf8
    	          encoding = ('' + encoding).toLowerCase();
    	          loweredCase = true;
    	      }
    	    }
    	  }
    	  Buffer.byteLength = byteLength;

    	  function slowToString (encoding, start, end) {
    	    var loweredCase = false;

    	    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    	    // property of a typed array.

    	    // This behaves neither like String nor Uint8Array in that we set start/end
    	    // to their upper/lower bounds if the value passed is out of range.
    	    // undefined is handled specially as per ECMA-262 6th Edition,
    	    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    	    if (start === undefined || start < 0) {
    	      start = 0;
    	    }
    	    // Return early if start > this.length. Done here to prevent potential uint32
    	    // coercion fail below.
    	    if (start > this.length) {
    	      return ''
    	    }

    	    if (end === undefined || end > this.length) {
    	      end = this.length;
    	    }

    	    if (end <= 0) {
    	      return ''
    	    }

    	    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    	    end >>>= 0;
    	    start >>>= 0;

    	    if (end <= start) {
    	      return ''
    	    }

    	    if (!encoding) encoding = 'utf8';

    	    while (true) {
    	      switch (encoding) {
    	        case 'hex':
    	          return hexSlice(this, start, end)

    	        case 'utf8':
    	        case 'utf-8':
    	          return utf8Slice(this, start, end)

    	        case 'ascii':
    	          return asciiSlice(this, start, end)

    	        case 'latin1':
    	        case 'binary':
    	          return latin1Slice(this, start, end)

    	        case 'base64':
    	          return base64Slice(this, start, end)

    	        case 'ucs2':
    	        case 'ucs-2':
    	        case 'utf16le':
    	        case 'utf-16le':
    	          return utf16leSlice(this, start, end)

    	        default:
    	          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
    	          encoding = (encoding + '').toLowerCase();
    	          loweredCase = true;
    	      }
    	    }
    	  }

    	  // The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
    	  // Buffer instances.
    	  Buffer.prototype._isBuffer = true;

    	  function swap (b, n, m) {
    	    var i = b[n];
    	    b[n] = b[m];
    	    b[m] = i;
    	  }

    	  Buffer.prototype.swap16 = function swap16 () {
    	    var len = this.length;
    	    if (len % 2 !== 0) {
    	      throw new RangeError('Buffer size must be a multiple of 16-bits')
    	    }
    	    for (var i = 0; i < len; i += 2) {
    	      swap(this, i, i + 1);
    	    }
    	    return this
    	  };

    	  Buffer.prototype.swap32 = function swap32 () {
    	    var len = this.length;
    	    if (len % 4 !== 0) {
    	      throw new RangeError('Buffer size must be a multiple of 32-bits')
    	    }
    	    for (var i = 0; i < len; i += 4) {
    	      swap(this, i, i + 3);
    	      swap(this, i + 1, i + 2);
    	    }
    	    return this
    	  };

    	  Buffer.prototype.swap64 = function swap64 () {
    	    var len = this.length;
    	    if (len % 8 !== 0) {
    	      throw new RangeError('Buffer size must be a multiple of 64-bits')
    	    }
    	    for (var i = 0; i < len; i += 8) {
    	      swap(this, i, i + 7);
    	      swap(this, i + 1, i + 6);
    	      swap(this, i + 2, i + 5);
    	      swap(this, i + 3, i + 4);
    	    }
    	    return this
    	  };

    	  Buffer.prototype.toString = function toString () {
    	    var length = this.length | 0;
    	    if (length === 0) return ''
    	    if (arguments.length === 0) return utf8Slice(this, 0, length)
    	    return slowToString.apply(this, arguments)
    	  };

    	  Buffer.prototype.equals = function equals (b) {
    	    if (!internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer')
    	    if (this === b) return true
    	    return Buffer.compare(this, b) === 0
    	  };

    	  Buffer.prototype.inspect = function inspect () {
    	    var str = '';
    	    var max = INSPECT_MAX_BYTES;
    	    if (this.length > 0) {
    	      str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
    	      if (this.length > max) str += ' ... ';
    	    }
    	    return '<Buffer ' + str + '>'
    	  };

    	  Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
    	    if (!internalIsBuffer(target)) {
    	      throw new TypeError('Argument must be a Buffer')
    	    }

    	    if (start === undefined) {
    	      start = 0;
    	    }
    	    if (end === undefined) {
    	      end = target ? target.length : 0;
    	    }
    	    if (thisStart === undefined) {
    	      thisStart = 0;
    	    }
    	    if (thisEnd === undefined) {
    	      thisEnd = this.length;
    	    }

    	    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    	      throw new RangeError('out of range index')
    	    }

    	    if (thisStart >= thisEnd && start >= end) {
    	      return 0
    	    }
    	    if (thisStart >= thisEnd) {
    	      return -1
    	    }
    	    if (start >= end) {
    	      return 1
    	    }

    	    start >>>= 0;
    	    end >>>= 0;
    	    thisStart >>>= 0;
    	    thisEnd >>>= 0;

    	    if (this === target) return 0

    	    var x = thisEnd - thisStart;
    	    var y = end - start;
    	    var len = Math.min(x, y);

    	    var thisCopy = this.slice(thisStart, thisEnd);
    	    var targetCopy = target.slice(start, end);

    	    for (var i = 0; i < len; ++i) {
    	      if (thisCopy[i] !== targetCopy[i]) {
    	        x = thisCopy[i];
    	        y = targetCopy[i];
    	        break
    	      }
    	    }

    	    if (x < y) return -1
    	    if (y < x) return 1
    	    return 0
    	  };

    	  // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    	  // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    	  //
    	  // Arguments:
    	  // - buffer - a Buffer to search
    	  // - val - a string, Buffer, or number
    	  // - byteOffset - an index into `buffer`; will be clamped to an int32
    	  // - encoding - an optional encoding, relevant is val is a string
    	  // - dir - true for indexOf, false for lastIndexOf
    	  function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
    	    // Empty buffer means no match
    	    if (buffer.length === 0) return -1

    	    // Normalize byteOffset
    	    if (typeof byteOffset === 'string') {
    	      encoding = byteOffset;
    	      byteOffset = 0;
    	    } else if (byteOffset > 0x7fffffff) {
    	      byteOffset = 0x7fffffff;
    	    } else if (byteOffset < -0x80000000) {
    	      byteOffset = -0x80000000;
    	    }
    	    byteOffset = +byteOffset;  // Coerce to Number.
    	    if (isNaN(byteOffset)) {
    	      // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    	      byteOffset = dir ? 0 : (buffer.length - 1);
    	    }

    	    // Normalize byteOffset: negative offsets start from the end of the buffer
    	    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    	    if (byteOffset >= buffer.length) {
    	      if (dir) return -1
    	      else byteOffset = buffer.length - 1;
    	    } else if (byteOffset < 0) {
    	      if (dir) byteOffset = 0;
    	      else return -1
    	    }

    	    // Normalize val
    	    if (typeof val === 'string') {
    	      val = Buffer.from(val, encoding);
    	    }

    	    // Finally, search either indexOf (if dir is true) or lastIndexOf
    	    if (internalIsBuffer(val)) {
    	      // Special case: looking for empty string/buffer always fails
    	      if (val.length === 0) {
    	        return -1
    	      }
    	      return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
    	    } else if (typeof val === 'number') {
    	      val = val & 0xFF; // Search for a byte value [0-255]
    	      if (Buffer.TYPED_ARRAY_SUPPORT &&
    	          typeof Uint8Array.prototype.indexOf === 'function') {
    	        if (dir) {
    	          return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
    	        } else {
    	          return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
    	        }
    	      }
    	      return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
    	    }

    	    throw new TypeError('val must be string, number or Buffer')
    	  }

    	  function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
    	    var indexSize = 1;
    	    var arrLength = arr.length;
    	    var valLength = val.length;

    	    if (encoding !== undefined) {
    	      encoding = String(encoding).toLowerCase();
    	      if (encoding === 'ucs2' || encoding === 'ucs-2' ||
    	          encoding === 'utf16le' || encoding === 'utf-16le') {
    	        if (arr.length < 2 || val.length < 2) {
    	          return -1
    	        }
    	        indexSize = 2;
    	        arrLength /= 2;
    	        valLength /= 2;
    	        byteOffset /= 2;
    	      }
    	    }

    	    function read (buf, i) {
    	      if (indexSize === 1) {
    	        return buf[i]
    	      } else {
    	        return buf.readUInt16BE(i * indexSize)
    	      }
    	    }

    	    var i;
    	    if (dir) {
    	      var foundIndex = -1;
    	      for (i = byteOffset; i < arrLength; i++) {
    	        if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
    	          if (foundIndex === -1) foundIndex = i;
    	          if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
    	        } else {
    	          if (foundIndex !== -1) i -= i - foundIndex;
    	          foundIndex = -1;
    	        }
    	      }
    	    } else {
    	      if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    	      for (i = byteOffset; i >= 0; i--) {
    	        var found = true;
    	        for (var j = 0; j < valLength; j++) {
    	          if (read(arr, i + j) !== read(val, j)) {
    	            found = false;
    	            break
    	          }
    	        }
    	        if (found) return i
    	      }
    	    }

    	    return -1
    	  }

    	  Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
    	    return this.indexOf(val, byteOffset, encoding) !== -1
    	  };

    	  Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
    	    return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
    	  };

    	  Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
    	    return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
    	  };

    	  function hexWrite (buf, string, offset, length) {
    	    offset = Number(offset) || 0;
    	    var remaining = buf.length - offset;
    	    if (!length) {
    	      length = remaining;
    	    } else {
    	      length = Number(length);
    	      if (length > remaining) {
    	        length = remaining;
    	      }
    	    }

    	    // must be an even number of digits
    	    var strLen = string.length;
    	    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

    	    if (length > strLen / 2) {
    	      length = strLen / 2;
    	    }
    	    for (var i = 0; i < length; ++i) {
    	      var parsed = parseInt(string.substr(i * 2, 2), 16);
    	      if (isNaN(parsed)) return i
    	      buf[offset + i] = parsed;
    	    }
    	    return i
    	  }

    	  function utf8Write (buf, string, offset, length) {
    	    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
    	  }

    	  function asciiWrite (buf, string, offset, length) {
    	    return blitBuffer(asciiToBytes(string), buf, offset, length)
    	  }

    	  function latin1Write (buf, string, offset, length) {
    	    return asciiWrite(buf, string, offset, length)
    	  }

    	  function base64Write (buf, string, offset, length) {
    	    return blitBuffer(base64ToBytes(string), buf, offset, length)
    	  }

    	  function ucs2Write (buf, string, offset, length) {
    	    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
    	  }

    	  Buffer.prototype.write = function write (string, offset, length, encoding) {
    	    // Buffer#write(string)
    	    if (offset === undefined) {
    	      encoding = 'utf8';
    	      length = this.length;
    	      offset = 0;
    	    // Buffer#write(string, encoding)
    	    } else if (length === undefined && typeof offset === 'string') {
    	      encoding = offset;
    	      length = this.length;
    	      offset = 0;
    	    // Buffer#write(string, offset[, length][, encoding])
    	    } else if (isFinite(offset)) {
    	      offset = offset | 0;
    	      if (isFinite(length)) {
    	        length = length | 0;
    	        if (encoding === undefined) encoding = 'utf8';
    	      } else {
    	        encoding = length;
    	        length = undefined;
    	      }
    	    // legacy write(string, encoding, offset, length) - remove in v0.13
    	    } else {
    	      throw new Error(
    	        'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    	      )
    	    }

    	    var remaining = this.length - offset;
    	    if (length === undefined || length > remaining) length = remaining;

    	    if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    	      throw new RangeError('Attempt to write outside buffer bounds')
    	    }

    	    if (!encoding) encoding = 'utf8';

    	    var loweredCase = false;
    	    for (;;) {
    	      switch (encoding) {
    	        case 'hex':
    	          return hexWrite(this, string, offset, length)

    	        case 'utf8':
    	        case 'utf-8':
    	          return utf8Write(this, string, offset, length)

    	        case 'ascii':
    	          return asciiWrite(this, string, offset, length)

    	        case 'latin1':
    	        case 'binary':
    	          return latin1Write(this, string, offset, length)

    	        case 'base64':
    	          // Warning: maxLength not taken into account in base64Write
    	          return base64Write(this, string, offset, length)

    	        case 'ucs2':
    	        case 'ucs-2':
    	        case 'utf16le':
    	        case 'utf-16le':
    	          return ucs2Write(this, string, offset, length)

    	        default:
    	          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
    	          encoding = ('' + encoding).toLowerCase();
    	          loweredCase = true;
    	      }
    	    }
    	  };

    	  Buffer.prototype.toJSON = function toJSON () {
    	    return {
    	      type: 'Buffer',
    	      data: Array.prototype.slice.call(this._arr || this, 0)
    	    }
    	  };

    	  function base64Slice (buf, start, end) {
    	    if (start === 0 && end === buf.length) {
    	      return fromByteArray(buf)
    	    } else {
    	      return fromByteArray(buf.slice(start, end))
    	    }
    	  }

    	  function utf8Slice (buf, start, end) {
    	    end = Math.min(buf.length, end);
    	    var res = [];

    	    var i = start;
    	    while (i < end) {
    	      var firstByte = buf[i];
    	      var codePoint = null;
    	      var bytesPerSequence = (firstByte > 0xEF) ? 4
    	        : (firstByte > 0xDF) ? 3
    	        : (firstByte > 0xBF) ? 2
    	        : 1;

    	      if (i + bytesPerSequence <= end) {
    	        var secondByte, thirdByte, fourthByte, tempCodePoint;

    	        switch (bytesPerSequence) {
    	          case 1:
    	            if (firstByte < 0x80) {
    	              codePoint = firstByte;
    	            }
    	            break
    	          case 2:
    	            secondByte = buf[i + 1];
    	            if ((secondByte & 0xC0) === 0x80) {
    	              tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
    	              if (tempCodePoint > 0x7F) {
    	                codePoint = tempCodePoint;
    	              }
    	            }
    	            break
    	          case 3:
    	            secondByte = buf[i + 1];
    	            thirdByte = buf[i + 2];
    	            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
    	              tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
    	              if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
    	                codePoint = tempCodePoint;
    	              }
    	            }
    	            break
    	          case 4:
    	            secondByte = buf[i + 1];
    	            thirdByte = buf[i + 2];
    	            fourthByte = buf[i + 3];
    	            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
    	              tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
    	              if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
    	                codePoint = tempCodePoint;
    	              }
    	            }
    	        }
    	      }

    	      if (codePoint === null) {
    	        // we did not generate a valid codePoint so insert a
    	        // replacement char (U+FFFD) and advance only 1 byte
    	        codePoint = 0xFFFD;
    	        bytesPerSequence = 1;
    	      } else if (codePoint > 0xFFFF) {
    	        // encode to utf16 (surrogate pair dance)
    	        codePoint -= 0x10000;
    	        res.push(codePoint >>> 10 & 0x3FF | 0xD800);
    	        codePoint = 0xDC00 | codePoint & 0x3FF;
    	      }

    	      res.push(codePoint);
    	      i += bytesPerSequence;
    	    }

    	    return decodeCodePointsArray(res)
    	  }

    	  // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    	  // the lowest limit is Chrome, with 0x10000 args.
    	  // We go 1 magnitude less, for safety
    	  var MAX_ARGUMENTS_LENGTH = 0x1000;

    	  function decodeCodePointsArray (codePoints) {
    	    var len = codePoints.length;
    	    if (len <= MAX_ARGUMENTS_LENGTH) {
    	      return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    	    }

    	    // Decode in chunks to avoid "call stack size exceeded".
    	    var res = '';
    	    var i = 0;
    	    while (i < len) {
    	      res += String.fromCharCode.apply(
    	        String,
    	        codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    	      );
    	    }
    	    return res
    	  }

    	  function asciiSlice (buf, start, end) {
    	    var ret = '';
    	    end = Math.min(buf.length, end);

    	    for (var i = start; i < end; ++i) {
    	      ret += String.fromCharCode(buf[i] & 0x7F);
    	    }
    	    return ret
    	  }

    	  function latin1Slice (buf, start, end) {
    	    var ret = '';
    	    end = Math.min(buf.length, end);

    	    for (var i = start; i < end; ++i) {
    	      ret += String.fromCharCode(buf[i]);
    	    }
    	    return ret
    	  }

    	  function hexSlice (buf, start, end) {
    	    var len = buf.length;

    	    if (!start || start < 0) start = 0;
    	    if (!end || end < 0 || end > len) end = len;

    	    var out = '';
    	    for (var i = start; i < end; ++i) {
    	      out += toHex(buf[i]);
    	    }
    	    return out
    	  }

    	  function utf16leSlice (buf, start, end) {
    	    var bytes = buf.slice(start, end);
    	    var res = '';
    	    for (var i = 0; i < bytes.length; i += 2) {
    	      res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    	    }
    	    return res
    	  }

    	  Buffer.prototype.slice = function slice (start, end) {
    	    var len = this.length;
    	    start = ~~start;
    	    end = end === undefined ? len : ~~end;

    	    if (start < 0) {
    	      start += len;
    	      if (start < 0) start = 0;
    	    } else if (start > len) {
    	      start = len;
    	    }

    	    if (end < 0) {
    	      end += len;
    	      if (end < 0) end = 0;
    	    } else if (end > len) {
    	      end = len;
    	    }

    	    if (end < start) end = start;

    	    var newBuf;
    	    if (Buffer.TYPED_ARRAY_SUPPORT) {
    	      newBuf = this.subarray(start, end);
    	      newBuf.__proto__ = Buffer.prototype;
    	    } else {
    	      var sliceLen = end - start;
    	      newBuf = new Buffer(sliceLen, undefined);
    	      for (var i = 0; i < sliceLen; ++i) {
    	        newBuf[i] = this[i + start];
    	      }
    	    }

    	    return newBuf
    	  };

    	  /*
    	   * Need to make sure that buffer isn't trying to write out of bounds.
    	   */
    	  function checkOffset (offset, ext, length) {
    	    if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
    	    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
    	  }

    	  Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
    	    offset = offset | 0;
    	    byteLength = byteLength | 0;
    	    if (!noAssert) checkOffset(offset, byteLength, this.length);

    	    var val = this[offset];
    	    var mul = 1;
    	    var i = 0;
    	    while (++i < byteLength && (mul *= 0x100)) {
    	      val += this[offset + i] * mul;
    	    }

    	    return val
    	  };

    	  Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
    	    offset = offset | 0;
    	    byteLength = byteLength | 0;
    	    if (!noAssert) {
    	      checkOffset(offset, byteLength, this.length);
    	    }

    	    var val = this[offset + --byteLength];
    	    var mul = 1;
    	    while (byteLength > 0 && (mul *= 0x100)) {
    	      val += this[offset + --byteLength] * mul;
    	    }

    	    return val
    	  };

    	  Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
    	    if (!noAssert) checkOffset(offset, 1, this.length);
    	    return this[offset]
    	  };

    	  Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
    	    if (!noAssert) checkOffset(offset, 2, this.length);
    	    return this[offset] | (this[offset + 1] << 8)
    	  };

    	  Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
    	    if (!noAssert) checkOffset(offset, 2, this.length);
    	    return (this[offset] << 8) | this[offset + 1]
    	  };

    	  Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
    	    if (!noAssert) checkOffset(offset, 4, this.length);

    	    return ((this[offset]) |
    	        (this[offset + 1] << 8) |
    	        (this[offset + 2] << 16)) +
    	        (this[offset + 3] * 0x1000000)
    	  };

    	  Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
    	    if (!noAssert) checkOffset(offset, 4, this.length);

    	    return (this[offset] * 0x1000000) +
    	      ((this[offset + 1] << 16) |
    	      (this[offset + 2] << 8) |
    	      this[offset + 3])
    	  };

    	  Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
    	    offset = offset | 0;
    	    byteLength = byteLength | 0;
    	    if (!noAssert) checkOffset(offset, byteLength, this.length);

    	    var val = this[offset];
    	    var mul = 1;
    	    var i = 0;
    	    while (++i < byteLength && (mul *= 0x100)) {
    	      val += this[offset + i] * mul;
    	    }
    	    mul *= 0x80;

    	    if (val >= mul) val -= Math.pow(2, 8 * byteLength);

    	    return val
    	  };

    	  Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
    	    offset = offset | 0;
    	    byteLength = byteLength | 0;
    	    if (!noAssert) checkOffset(offset, byteLength, this.length);

    	    var i = byteLength;
    	    var mul = 1;
    	    var val = this[offset + --i];
    	    while (i > 0 && (mul *= 0x100)) {
    	      val += this[offset + --i] * mul;
    	    }
    	    mul *= 0x80;

    	    if (val >= mul) val -= Math.pow(2, 8 * byteLength);

    	    return val
    	  };

    	  Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
    	    if (!noAssert) checkOffset(offset, 1, this.length);
    	    if (!(this[offset] & 0x80)) return (this[offset])
    	    return ((0xff - this[offset] + 1) * -1)
    	  };

    	  Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
    	    if (!noAssert) checkOffset(offset, 2, this.length);
    	    var val = this[offset] | (this[offset + 1] << 8);
    	    return (val & 0x8000) ? val | 0xFFFF0000 : val
    	  };

    	  Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
    	    if (!noAssert) checkOffset(offset, 2, this.length);
    	    var val = this[offset + 1] | (this[offset] << 8);
    	    return (val & 0x8000) ? val | 0xFFFF0000 : val
    	  };

    	  Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
    	    if (!noAssert) checkOffset(offset, 4, this.length);

    	    return (this[offset]) |
    	      (this[offset + 1] << 8) |
    	      (this[offset + 2] << 16) |
    	      (this[offset + 3] << 24)
    	  };

    	  Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
    	    if (!noAssert) checkOffset(offset, 4, this.length);

    	    return (this[offset] << 24) |
    	      (this[offset + 1] << 16) |
    	      (this[offset + 2] << 8) |
    	      (this[offset + 3])
    	  };

    	  Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
    	    if (!noAssert) checkOffset(offset, 4, this.length);
    	    return read(this, offset, true, 23, 4)
    	  };

    	  Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
    	    if (!noAssert) checkOffset(offset, 4, this.length);
    	    return read(this, offset, false, 23, 4)
    	  };

    	  Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
    	    if (!noAssert) checkOffset(offset, 8, this.length);
    	    return read(this, offset, true, 52, 8)
    	  };

    	  Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
    	    if (!noAssert) checkOffset(offset, 8, this.length);
    	    return read(this, offset, false, 52, 8)
    	  };

    	  function checkInt (buf, value, offset, ext, max, min) {
    	    if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
    	    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
    	    if (offset + ext > buf.length) throw new RangeError('Index out of range')
    	  }

    	  Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
    	    value = +value;
    	    offset = offset | 0;
    	    byteLength = byteLength | 0;
    	    if (!noAssert) {
    	      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    	      checkInt(this, value, offset, byteLength, maxBytes, 0);
    	    }

    	    var mul = 1;
    	    var i = 0;
    	    this[offset] = value & 0xFF;
    	    while (++i < byteLength && (mul *= 0x100)) {
    	      this[offset + i] = (value / mul) & 0xFF;
    	    }

    	    return offset + byteLength
    	  };

    	  Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
    	    value = +value;
    	    offset = offset | 0;
    	    byteLength = byteLength | 0;
    	    if (!noAssert) {
    	      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    	      checkInt(this, value, offset, byteLength, maxBytes, 0);
    	    }

    	    var i = byteLength - 1;
    	    var mul = 1;
    	    this[offset + i] = value & 0xFF;
    	    while (--i >= 0 && (mul *= 0x100)) {
    	      this[offset + i] = (value / mul) & 0xFF;
    	    }

    	    return offset + byteLength
    	  };

    	  Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
    	    value = +value;
    	    offset = offset | 0;
    	    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    	    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    	    this[offset] = (value & 0xff);
    	    return offset + 1
    	  };

    	  function objectWriteUInt16 (buf, value, offset, littleEndian) {
    	    if (value < 0) value = 0xffff + value + 1;
    	    for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    	      buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
    	        (littleEndian ? i : 1 - i) * 8;
    	    }
    	  }

    	  Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
    	    value = +value;
    	    offset = offset | 0;
    	    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    	    if (Buffer.TYPED_ARRAY_SUPPORT) {
    	      this[offset] = (value & 0xff);
    	      this[offset + 1] = (value >>> 8);
    	    } else {
    	      objectWriteUInt16(this, value, offset, true);
    	    }
    	    return offset + 2
    	  };

    	  Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
    	    value = +value;
    	    offset = offset | 0;
    	    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    	    if (Buffer.TYPED_ARRAY_SUPPORT) {
    	      this[offset] = (value >>> 8);
    	      this[offset + 1] = (value & 0xff);
    	    } else {
    	      objectWriteUInt16(this, value, offset, false);
    	    }
    	    return offset + 2
    	  };

    	  function objectWriteUInt32 (buf, value, offset, littleEndian) {
    	    if (value < 0) value = 0xffffffff + value + 1;
    	    for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    	      buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff;
    	    }
    	  }

    	  Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
    	    value = +value;
    	    offset = offset | 0;
    	    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    	    if (Buffer.TYPED_ARRAY_SUPPORT) {
    	      this[offset + 3] = (value >>> 24);
    	      this[offset + 2] = (value >>> 16);
    	      this[offset + 1] = (value >>> 8);
    	      this[offset] = (value & 0xff);
    	    } else {
    	      objectWriteUInt32(this, value, offset, true);
    	    }
    	    return offset + 4
    	  };

    	  Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
    	    value = +value;
    	    offset = offset | 0;
    	    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    	    if (Buffer.TYPED_ARRAY_SUPPORT) {
    	      this[offset] = (value >>> 24);
    	      this[offset + 1] = (value >>> 16);
    	      this[offset + 2] = (value >>> 8);
    	      this[offset + 3] = (value & 0xff);
    	    } else {
    	      objectWriteUInt32(this, value, offset, false);
    	    }
    	    return offset + 4
    	  };

    	  Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
    	    value = +value;
    	    offset = offset | 0;
    	    if (!noAssert) {
    	      var limit = Math.pow(2, 8 * byteLength - 1);

    	      checkInt(this, value, offset, byteLength, limit - 1, -limit);
    	    }

    	    var i = 0;
    	    var mul = 1;
    	    var sub = 0;
    	    this[offset] = value & 0xFF;
    	    while (++i < byteLength && (mul *= 0x100)) {
    	      if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
    	        sub = 1;
    	      }
    	      this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
    	    }

    	    return offset + byteLength
    	  };

    	  Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
    	    value = +value;
    	    offset = offset | 0;
    	    if (!noAssert) {
    	      var limit = Math.pow(2, 8 * byteLength - 1);

    	      checkInt(this, value, offset, byteLength, limit - 1, -limit);
    	    }

    	    var i = byteLength - 1;
    	    var mul = 1;
    	    var sub = 0;
    	    this[offset + i] = value & 0xFF;
    	    while (--i >= 0 && (mul *= 0x100)) {
    	      if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
    	        sub = 1;
    	      }
    	      this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
    	    }

    	    return offset + byteLength
    	  };

    	  Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
    	    value = +value;
    	    offset = offset | 0;
    	    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
    	    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    	    if (value < 0) value = 0xff + value + 1;
    	    this[offset] = (value & 0xff);
    	    return offset + 1
    	  };

    	  Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
    	    value = +value;
    	    offset = offset | 0;
    	    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    	    if (Buffer.TYPED_ARRAY_SUPPORT) {
    	      this[offset] = (value & 0xff);
    	      this[offset + 1] = (value >>> 8);
    	    } else {
    	      objectWriteUInt16(this, value, offset, true);
    	    }
    	    return offset + 2
    	  };

    	  Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
    	    value = +value;
    	    offset = offset | 0;
    	    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    	    if (Buffer.TYPED_ARRAY_SUPPORT) {
    	      this[offset] = (value >>> 8);
    	      this[offset + 1] = (value & 0xff);
    	    } else {
    	      objectWriteUInt16(this, value, offset, false);
    	    }
    	    return offset + 2
    	  };

    	  Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
    	    value = +value;
    	    offset = offset | 0;
    	    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    	    if (Buffer.TYPED_ARRAY_SUPPORT) {
    	      this[offset] = (value & 0xff);
    	      this[offset + 1] = (value >>> 8);
    	      this[offset + 2] = (value >>> 16);
    	      this[offset + 3] = (value >>> 24);
    	    } else {
    	      objectWriteUInt32(this, value, offset, true);
    	    }
    	    return offset + 4
    	  };

    	  Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
    	    value = +value;
    	    offset = offset | 0;
    	    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    	    if (value < 0) value = 0xffffffff + value + 1;
    	    if (Buffer.TYPED_ARRAY_SUPPORT) {
    	      this[offset] = (value >>> 24);
    	      this[offset + 1] = (value >>> 16);
    	      this[offset + 2] = (value >>> 8);
    	      this[offset + 3] = (value & 0xff);
    	    } else {
    	      objectWriteUInt32(this, value, offset, false);
    	    }
    	    return offset + 4
    	  };

    	  function checkIEEE754 (buf, value, offset, ext, max, min) {
    	    if (offset + ext > buf.length) throw new RangeError('Index out of range')
    	    if (offset < 0) throw new RangeError('Index out of range')
    	  }

    	  function writeFloat (buf, value, offset, littleEndian, noAssert) {
    	    if (!noAssert) {
    	      checkIEEE754(buf, value, offset, 4);
    	    }
    	    write(buf, value, offset, littleEndian, 23, 4);
    	    return offset + 4
    	  }

    	  Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
    	    return writeFloat(this, value, offset, true, noAssert)
    	  };

    	  Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
    	    return writeFloat(this, value, offset, false, noAssert)
    	  };

    	  function writeDouble (buf, value, offset, littleEndian, noAssert) {
    	    if (!noAssert) {
    	      checkIEEE754(buf, value, offset, 8);
    	    }
    	    write(buf, value, offset, littleEndian, 52, 8);
    	    return offset + 8
    	  }

    	  Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
    	    return writeDouble(this, value, offset, true, noAssert)
    	  };

    	  Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
    	    return writeDouble(this, value, offset, false, noAssert)
    	  };

    	  // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    	  Buffer.prototype.copy = function copy (target, targetStart, start, end) {
    	    if (!start) start = 0;
    	    if (!end && end !== 0) end = this.length;
    	    if (targetStart >= target.length) targetStart = target.length;
    	    if (!targetStart) targetStart = 0;
    	    if (end > 0 && end < start) end = start;

    	    // Copy 0 bytes; we're done
    	    if (end === start) return 0
    	    if (target.length === 0 || this.length === 0) return 0

    	    // Fatal error conditions
    	    if (targetStart < 0) {
    	      throw new RangeError('targetStart out of bounds')
    	    }
    	    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
    	    if (end < 0) throw new RangeError('sourceEnd out of bounds')

    	    // Are we oob?
    	    if (end > this.length) end = this.length;
    	    if (target.length - targetStart < end - start) {
    	      end = target.length - targetStart + start;
    	    }

    	    var len = end - start;
    	    var i;

    	    if (this === target && start < targetStart && targetStart < end) {
    	      // descending copy from end
    	      for (i = len - 1; i >= 0; --i) {
    	        target[i + targetStart] = this[i + start];
    	      }
    	    } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    	      // ascending copy from start
    	      for (i = 0; i < len; ++i) {
    	        target[i + targetStart] = this[i + start];
    	      }
    	    } else {
    	      Uint8Array.prototype.set.call(
    	        target,
    	        this.subarray(start, start + len),
    	        targetStart
    	      );
    	    }

    	    return len
    	  };

    	  // Usage:
    	  //    buffer.fill(number[, offset[, end]])
    	  //    buffer.fill(buffer[, offset[, end]])
    	  //    buffer.fill(string[, offset[, end]][, encoding])
    	  Buffer.prototype.fill = function fill (val, start, end, encoding) {
    	    // Handle string cases:
    	    if (typeof val === 'string') {
    	      if (typeof start === 'string') {
    	        encoding = start;
    	        start = 0;
    	        end = this.length;
    	      } else if (typeof end === 'string') {
    	        encoding = end;
    	        end = this.length;
    	      }
    	      if (val.length === 1) {
    	        var code = val.charCodeAt(0);
    	        if (code < 256) {
    	          val = code;
    	        }
    	      }
    	      if (encoding !== undefined && typeof encoding !== 'string') {
    	        throw new TypeError('encoding must be a string')
    	      }
    	      if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
    	        throw new TypeError('Unknown encoding: ' + encoding)
    	      }
    	    } else if (typeof val === 'number') {
    	      val = val & 255;
    	    }

    	    // Invalid ranges are not set to a default, so can range check early.
    	    if (start < 0 || this.length < start || this.length < end) {
    	      throw new RangeError('Out of range index')
    	    }

    	    if (end <= start) {
    	      return this
    	    }

    	    start = start >>> 0;
    	    end = end === undefined ? this.length : end >>> 0;

    	    if (!val) val = 0;

    	    var i;
    	    if (typeof val === 'number') {
    	      for (i = start; i < end; ++i) {
    	        this[i] = val;
    	      }
    	    } else {
    	      var bytes = internalIsBuffer(val)
    	        ? val
    	        : utf8ToBytes(new Buffer(val, encoding).toString());
    	      var len = bytes.length;
    	      for (i = 0; i < end - start; ++i) {
    	        this[i + start] = bytes[i % len];
    	      }
    	    }

    	    return this
    	  };

    	  // HELPER FUNCTIONS
    	  // ================

    	  var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

    	  function base64clean (str) {
    	    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    	    str = stringtrim(str).replace(INVALID_BASE64_RE, '');
    	    // Node converts strings with length < 2 to ''
    	    if (str.length < 2) return ''
    	    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    	    while (str.length % 4 !== 0) {
    	      str = str + '=';
    	    }
    	    return str
    	  }

    	  function stringtrim (str) {
    	    if (str.trim) return str.trim()
    	    return str.replace(/^\s+|\s+$/g, '')
    	  }

    	  function toHex (n) {
    	    if (n < 16) return '0' + n.toString(16)
    	    return n.toString(16)
    	  }

    	  function utf8ToBytes (string, units) {
    	    units = units || Infinity;
    	    var codePoint;
    	    var length = string.length;
    	    var leadSurrogate = null;
    	    var bytes = [];

    	    for (var i = 0; i < length; ++i) {
    	      codePoint = string.charCodeAt(i);

    	      // is surrogate component
    	      if (codePoint > 0xD7FF && codePoint < 0xE000) {
    	        // last char was a lead
    	        if (!leadSurrogate) {
    	          // no lead yet
    	          if (codePoint > 0xDBFF) {
    	            // unexpected trail
    	            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    	            continue
    	          } else if (i + 1 === length) {
    	            // unpaired lead
    	            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    	            continue
    	          }

    	          // valid lead
    	          leadSurrogate = codePoint;

    	          continue
    	        }

    	        // 2 leads in a row
    	        if (codePoint < 0xDC00) {
    	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    	          leadSurrogate = codePoint;
    	          continue
    	        }

    	        // valid surrogate pair
    	        codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    	      } else if (leadSurrogate) {
    	        // valid bmp char, but last char was a lead
    	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    	      }

    	      leadSurrogate = null;

    	      // encode utf8
    	      if (codePoint < 0x80) {
    	        if ((units -= 1) < 0) break
    	        bytes.push(codePoint);
    	      } else if (codePoint < 0x800) {
    	        if ((units -= 2) < 0) break
    	        bytes.push(
    	          codePoint >> 0x6 | 0xC0,
    	          codePoint & 0x3F | 0x80
    	        );
    	      } else if (codePoint < 0x10000) {
    	        if ((units -= 3) < 0) break
    	        bytes.push(
    	          codePoint >> 0xC | 0xE0,
    	          codePoint >> 0x6 & 0x3F | 0x80,
    	          codePoint & 0x3F | 0x80
    	        );
    	      } else if (codePoint < 0x110000) {
    	        if ((units -= 4) < 0) break
    	        bytes.push(
    	          codePoint >> 0x12 | 0xF0,
    	          codePoint >> 0xC & 0x3F | 0x80,
    	          codePoint >> 0x6 & 0x3F | 0x80,
    	          codePoint & 0x3F | 0x80
    	        );
    	      } else {
    	        throw new Error('Invalid code point')
    	      }
    	    }

    	    return bytes
    	  }

    	  function asciiToBytes (str) {
    	    var byteArray = [];
    	    for (var i = 0; i < str.length; ++i) {
    	      // Node's code seems to be doing this and not & 0x7F..
    	      byteArray.push(str.charCodeAt(i) & 0xFF);
    	    }
    	    return byteArray
    	  }

    	  function utf16leToBytes (str, units) {
    	    var c, hi, lo;
    	    var byteArray = [];
    	    for (var i = 0; i < str.length; ++i) {
    	      if ((units -= 2) < 0) break

    	      c = str.charCodeAt(i);
    	      hi = c >> 8;
    	      lo = c % 256;
    	      byteArray.push(lo);
    	      byteArray.push(hi);
    	    }

    	    return byteArray
    	  }


    	  function base64ToBytes (str) {
    	    return toByteArray(base64clean(str))
    	  }

    	  function blitBuffer (src, dst, offset, length) {
    	    for (var i = 0; i < length; ++i) {
    	      if ((i + offset >= dst.length) || (i >= src.length)) break
    	      dst[i + offset] = src[i];
    	    }
    	    return i
    	  }

    	  function isnan (val) {
    	    return val !== val // eslint-disable-line no-self-compare
    	  }


    	  // the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
    	  // The _isBuffer check is for Safari 5-7 support, because it's missing
    	  // Object.prototype.constructor. Remove this eventually
    	  function isBuffer(obj) {
    	    return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj))
    	  }

    	  function isFastBuffer (obj) {
    	    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
    	  }

    	  // For Node v0.10 support. Remove this eventually.
    	  function isSlowBuffer (obj) {
    	    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0))
    	  }

    	  var _polyfillNode_buffer = /*#__PURE__*/Object.freeze({
    	    __proto__: null,
    	    Buffer: Buffer,
    	    INSPECT_MAX_BYTES: INSPECT_MAX_BYTES,
    	    SlowBuffer: SlowBuffer,
    	    isBuffer: isBuffer,
    	    kMaxLength: _kMaxLength
    	  });

    	  var require$$0 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_buffer);

    	  bn.exports;

    	  (function (module) {
    	  	(function (module, exports) {

    	  	  // Utils
    	  	  function assert (val, msg) {
    	  	    if (!val) throw new Error(msg || 'Assertion failed');
    	  	  }

    	  	  // Could use `inherits` module, but don't want to move from single file
    	  	  // architecture yet.
    	  	  function inherits (ctor, superCtor) {
    	  	    ctor.super_ = superCtor;
    	  	    var TempCtor = function () {};
    	  	    TempCtor.prototype = superCtor.prototype;
    	  	    ctor.prototype = new TempCtor();
    	  	    ctor.prototype.constructor = ctor;
    	  	  }

    	  	  // BN

    	  	  function BN (number, base, endian) {
    	  	    if (BN.isBN(number)) {
    	  	      return number;
    	  	    }

    	  	    this.negative = 0;
    	  	    this.words = null;
    	  	    this.length = 0;

    	  	    // Reduction context
    	  	    this.red = null;

    	  	    if (number !== null) {
    	  	      if (base === 'le' || base === 'be') {
    	  	        endian = base;
    	  	        base = 10;
    	  	      }

    	  	      this._init(number || 0, base || 10, endian || 'be');
    	  	    }
    	  	  }
    	  	  if (typeof module === 'object') {
    	  	    module.exports = BN;
    	  	  } else {
    	  	    exports.BN = BN;
    	  	  }

    	  	  BN.BN = BN;
    	  	  BN.wordSize = 26;

    	  	  var Buffer;
    	  	  try {
    	  	    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
    	  	      Buffer = window.Buffer;
    	  	    } else {
    	  	      Buffer = require$$0.Buffer;
    	  	    }
    	  	  } catch (e) {
    	  	  }

    	  	  BN.isBN = function isBN (num) {
    	  	    if (num instanceof BN) {
    	  	      return true;
    	  	    }

    	  	    return num !== null && typeof num === 'object' &&
    	  	      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    	  	  };

    	  	  BN.max = function max (left, right) {
    	  	    if (left.cmp(right) > 0) return left;
    	  	    return right;
    	  	  };

    	  	  BN.min = function min (left, right) {
    	  	    if (left.cmp(right) < 0) return left;
    	  	    return right;
    	  	  };

    	  	  BN.prototype._init = function init (number, base, endian) {
    	  	    if (typeof number === 'number') {
    	  	      return this._initNumber(number, base, endian);
    	  	    }

    	  	    if (typeof number === 'object') {
    	  	      return this._initArray(number, base, endian);
    	  	    }

    	  	    if (base === 'hex') {
    	  	      base = 16;
    	  	    }
    	  	    assert(base === (base | 0) && base >= 2 && base <= 36);

    	  	    number = number.toString().replace(/\s+/g, '');
    	  	    var start = 0;
    	  	    if (number[0] === '-') {
    	  	      start++;
    	  	      this.negative = 1;
    	  	    }

    	  	    if (start < number.length) {
    	  	      if (base === 16) {
    	  	        this._parseHex(number, start, endian);
    	  	      } else {
    	  	        this._parseBase(number, base, start);
    	  	        if (endian === 'le') {
    	  	          this._initArray(this.toArray(), base, endian);
    	  	        }
    	  	      }
    	  	    }
    	  	  };

    	  	  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    	  	    if (number < 0) {
    	  	      this.negative = 1;
    	  	      number = -number;
    	  	    }
    	  	    if (number < 0x4000000) {
    	  	      this.words = [ number & 0x3ffffff ];
    	  	      this.length = 1;
    	  	    } else if (number < 0x10000000000000) {
    	  	      this.words = [
    	  	        number & 0x3ffffff,
    	  	        (number / 0x4000000) & 0x3ffffff
    	  	      ];
    	  	      this.length = 2;
    	  	    } else {
    	  	      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
    	  	      this.words = [
    	  	        number & 0x3ffffff,
    	  	        (number / 0x4000000) & 0x3ffffff,
    	  	        1
    	  	      ];
    	  	      this.length = 3;
    	  	    }

    	  	    if (endian !== 'le') return;

    	  	    // Reverse the bytes
    	  	    this._initArray(this.toArray(), base, endian);
    	  	  };

    	  	  BN.prototype._initArray = function _initArray (number, base, endian) {
    	  	    // Perhaps a Uint8Array
    	  	    assert(typeof number.length === 'number');
    	  	    if (number.length <= 0) {
    	  	      this.words = [ 0 ];
    	  	      this.length = 1;
    	  	      return this;
    	  	    }

    	  	    this.length = Math.ceil(number.length / 3);
    	  	    this.words = new Array(this.length);
    	  	    for (var i = 0; i < this.length; i++) {
    	  	      this.words[i] = 0;
    	  	    }

    	  	    var j, w;
    	  	    var off = 0;
    	  	    if (endian === 'be') {
    	  	      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
    	  	        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
    	  	        this.words[j] |= (w << off) & 0x3ffffff;
    	  	        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
    	  	        off += 24;
    	  	        if (off >= 26) {
    	  	          off -= 26;
    	  	          j++;
    	  	        }
    	  	      }
    	  	    } else if (endian === 'le') {
    	  	      for (i = 0, j = 0; i < number.length; i += 3) {
    	  	        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
    	  	        this.words[j] |= (w << off) & 0x3ffffff;
    	  	        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
    	  	        off += 24;
    	  	        if (off >= 26) {
    	  	          off -= 26;
    	  	          j++;
    	  	        }
    	  	      }
    	  	    }
    	  	    return this.strip();
    	  	  };

    	  	  function parseHex4Bits (string, index) {
    	  	    var c = string.charCodeAt(index);
    	  	    // 'A' - 'F'
    	  	    if (c >= 65 && c <= 70) {
    	  	      return c - 55;
    	  	    // 'a' - 'f'
    	  	    } else if (c >= 97 && c <= 102) {
    	  	      return c - 87;
    	  	    // '0' - '9'
    	  	    } else {
    	  	      return (c - 48) & 0xf;
    	  	    }
    	  	  }

    	  	  function parseHexByte (string, lowerBound, index) {
    	  	    var r = parseHex4Bits(string, index);
    	  	    if (index - 1 >= lowerBound) {
    	  	      r |= parseHex4Bits(string, index - 1) << 4;
    	  	    }
    	  	    return r;
    	  	  }

    	  	  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    	  	    // Create possibly bigger array to ensure that it fits the number
    	  	    this.length = Math.ceil((number.length - start) / 6);
    	  	    this.words = new Array(this.length);
    	  	    for (var i = 0; i < this.length; i++) {
    	  	      this.words[i] = 0;
    	  	    }

    	  	    // 24-bits chunks
    	  	    var off = 0;
    	  	    var j = 0;

    	  	    var w;
    	  	    if (endian === 'be') {
    	  	      for (i = number.length - 1; i >= start; i -= 2) {
    	  	        w = parseHexByte(number, start, i) << off;
    	  	        this.words[j] |= w & 0x3ffffff;
    	  	        if (off >= 18) {
    	  	          off -= 18;
    	  	          j += 1;
    	  	          this.words[j] |= w >>> 26;
    	  	        } else {
    	  	          off += 8;
    	  	        }
    	  	      }
    	  	    } else {
    	  	      var parseLength = number.length - start;
    	  	      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
    	  	        w = parseHexByte(number, start, i) << off;
    	  	        this.words[j] |= w & 0x3ffffff;
    	  	        if (off >= 18) {
    	  	          off -= 18;
    	  	          j += 1;
    	  	          this.words[j] |= w >>> 26;
    	  	        } else {
    	  	          off += 8;
    	  	        }
    	  	      }
    	  	    }

    	  	    this.strip();
    	  	  };

    	  	  function parseBase (str, start, end, mul) {
    	  	    var r = 0;
    	  	    var len = Math.min(str.length, end);
    	  	    for (var i = start; i < len; i++) {
    	  	      var c = str.charCodeAt(i) - 48;

    	  	      r *= mul;

    	  	      // 'a'
    	  	      if (c >= 49) {
    	  	        r += c - 49 + 0xa;

    	  	      // 'A'
    	  	      } else if (c >= 17) {
    	  	        r += c - 17 + 0xa;

    	  	      // '0' - '9'
    	  	      } else {
    	  	        r += c;
    	  	      }
    	  	    }
    	  	    return r;
    	  	  }

    	  	  BN.prototype._parseBase = function _parseBase (number, base, start) {
    	  	    // Initialize as zero
    	  	    this.words = [ 0 ];
    	  	    this.length = 1;

    	  	    // Find length of limb in base
    	  	    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
    	  	      limbLen++;
    	  	    }
    	  	    limbLen--;
    	  	    limbPow = (limbPow / base) | 0;

    	  	    var total = number.length - start;
    	  	    var mod = total % limbLen;
    	  	    var end = Math.min(total, total - mod) + start;

    	  	    var word = 0;
    	  	    for (var i = start; i < end; i += limbLen) {
    	  	      word = parseBase(number, i, i + limbLen, base);

    	  	      this.imuln(limbPow);
    	  	      if (this.words[0] + word < 0x4000000) {
    	  	        this.words[0] += word;
    	  	      } else {
    	  	        this._iaddn(word);
    	  	      }
    	  	    }

    	  	    if (mod !== 0) {
    	  	      var pow = 1;
    	  	      word = parseBase(number, i, number.length, base);

    	  	      for (i = 0; i < mod; i++) {
    	  	        pow *= base;
    	  	      }

    	  	      this.imuln(pow);
    	  	      if (this.words[0] + word < 0x4000000) {
    	  	        this.words[0] += word;
    	  	      } else {
    	  	        this._iaddn(word);
    	  	      }
    	  	    }

    	  	    this.strip();
    	  	  };

    	  	  BN.prototype.copy = function copy (dest) {
    	  	    dest.words = new Array(this.length);
    	  	    for (var i = 0; i < this.length; i++) {
    	  	      dest.words[i] = this.words[i];
    	  	    }
    	  	    dest.length = this.length;
    	  	    dest.negative = this.negative;
    	  	    dest.red = this.red;
    	  	  };

    	  	  BN.prototype.clone = function clone () {
    	  	    var r = new BN(null);
    	  	    this.copy(r);
    	  	    return r;
    	  	  };

    	  	  BN.prototype._expand = function _expand (size) {
    	  	    while (this.length < size) {
    	  	      this.words[this.length++] = 0;
    	  	    }
    	  	    return this;
    	  	  };

    	  	  // Remove leading `0` from `this`
    	  	  BN.prototype.strip = function strip () {
    	  	    while (this.length > 1 && this.words[this.length - 1] === 0) {
    	  	      this.length--;
    	  	    }
    	  	    return this._normSign();
    	  	  };

    	  	  BN.prototype._normSign = function _normSign () {
    	  	    // -0 = 0
    	  	    if (this.length === 1 && this.words[0] === 0) {
    	  	      this.negative = 0;
    	  	    }
    	  	    return this;
    	  	  };

    	  	  BN.prototype.inspect = function inspect () {
    	  	    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    	  	  };

    	  	  /*

    	  	  var zeros = [];
    	  	  var groupSizes = [];
    	  	  var groupBases = [];

    	  	  var s = '';
    	  	  var i = -1;
    	  	  while (++i < BN.wordSize) {
    	  	    zeros[i] = s;
    	  	    s += '0';
    	  	  }
    	  	  groupSizes[0] = 0;
    	  	  groupSizes[1] = 0;
    	  	  groupBases[0] = 0;
    	  	  groupBases[1] = 0;
    	  	  var base = 2 - 1;
    	  	  while (++base < 36 + 1) {
    	  	    var groupSize = 0;
    	  	    var groupBase = 1;
    	  	    while (groupBase < (1 << BN.wordSize) / base) {
    	  	      groupBase *= base;
    	  	      groupSize += 1;
    	  	    }
    	  	    groupSizes[base] = groupSize;
    	  	    groupBases[base] = groupBase;
    	  	  }

    	  	  */

    	  	  var zeros = [
    	  	    '',
    	  	    '0',
    	  	    '00',
    	  	    '000',
    	  	    '0000',
    	  	    '00000',
    	  	    '000000',
    	  	    '0000000',
    	  	    '00000000',
    	  	    '000000000',
    	  	    '0000000000',
    	  	    '00000000000',
    	  	    '000000000000',
    	  	    '0000000000000',
    	  	    '00000000000000',
    	  	    '000000000000000',
    	  	    '0000000000000000',
    	  	    '00000000000000000',
    	  	    '000000000000000000',
    	  	    '0000000000000000000',
    	  	    '00000000000000000000',
    	  	    '000000000000000000000',
    	  	    '0000000000000000000000',
    	  	    '00000000000000000000000',
    	  	    '000000000000000000000000',
    	  	    '0000000000000000000000000'
    	  	  ];

    	  	  var groupSizes = [
    	  	    0, 0,
    	  	    25, 16, 12, 11, 10, 9, 8,
    	  	    8, 7, 7, 7, 7, 6, 6,
    	  	    6, 6, 6, 6, 6, 5, 5,
    	  	    5, 5, 5, 5, 5, 5, 5,
    	  	    5, 5, 5, 5, 5, 5, 5
    	  	  ];

    	  	  var groupBases = [
    	  	    0, 0,
    	  	    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    	  	    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    	  	    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    	  	    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    	  	    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
    	  	  ];

    	  	  BN.prototype.toString = function toString (base, padding) {
    	  	    base = base || 10;
    	  	    padding = padding | 0 || 1;

    	  	    var out;
    	  	    if (base === 16 || base === 'hex') {
    	  	      out = '';
    	  	      var off = 0;
    	  	      var carry = 0;
    	  	      for (var i = 0; i < this.length; i++) {
    	  	        var w = this.words[i];
    	  	        var word = (((w << off) | carry) & 0xffffff).toString(16);
    	  	        carry = (w >>> (24 - off)) & 0xffffff;
    	  	        if (carry !== 0 || i !== this.length - 1) {
    	  	          out = zeros[6 - word.length] + word + out;
    	  	        } else {
    	  	          out = word + out;
    	  	        }
    	  	        off += 2;
    	  	        if (off >= 26) {
    	  	          off -= 26;
    	  	          i--;
    	  	        }
    	  	      }
    	  	      if (carry !== 0) {
    	  	        out = carry.toString(16) + out;
    	  	      }
    	  	      while (out.length % padding !== 0) {
    	  	        out = '0' + out;
    	  	      }
    	  	      if (this.negative !== 0) {
    	  	        out = '-' + out;
    	  	      }
    	  	      return out;
    	  	    }

    	  	    if (base === (base | 0) && base >= 2 && base <= 36) {
    	  	      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
    	  	      var groupSize = groupSizes[base];
    	  	      // var groupBase = Math.pow(base, groupSize);
    	  	      var groupBase = groupBases[base];
    	  	      out = '';
    	  	      var c = this.clone();
    	  	      c.negative = 0;
    	  	      while (!c.isZero()) {
    	  	        var r = c.modn(groupBase).toString(base);
    	  	        c = c.idivn(groupBase);

    	  	        if (!c.isZero()) {
    	  	          out = zeros[groupSize - r.length] + r + out;
    	  	        } else {
    	  	          out = r + out;
    	  	        }
    	  	      }
    	  	      if (this.isZero()) {
    	  	        out = '0' + out;
    	  	      }
    	  	      while (out.length % padding !== 0) {
    	  	        out = '0' + out;
    	  	      }
    	  	      if (this.negative !== 0) {
    	  	        out = '-' + out;
    	  	      }
    	  	      return out;
    	  	    }

    	  	    assert(false, 'Base should be between 2 and 36');
    	  	  };

    	  	  BN.prototype.toNumber = function toNumber () {
    	  	    var ret = this.words[0];
    	  	    if (this.length === 2) {
    	  	      ret += this.words[1] * 0x4000000;
    	  	    } else if (this.length === 3 && this.words[2] === 0x01) {
    	  	      // NOTE: at this stage it is known that the top bit is set
    	  	      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    	  	    } else if (this.length > 2) {
    	  	      assert(false, 'Number can only safely store up to 53 bits');
    	  	    }
    	  	    return (this.negative !== 0) ? -ret : ret;
    	  	  };

    	  	  BN.prototype.toJSON = function toJSON () {
    	  	    return this.toString(16);
    	  	  };

    	  	  BN.prototype.toBuffer = function toBuffer (endian, length) {
    	  	    assert(typeof Buffer !== 'undefined');
    	  	    return this.toArrayLike(Buffer, endian, length);
    	  	  };

    	  	  BN.prototype.toArray = function toArray (endian, length) {
    	  	    return this.toArrayLike(Array, endian, length);
    	  	  };

    	  	  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    	  	    var byteLength = this.byteLength();
    	  	    var reqLength = length || Math.max(1, byteLength);
    	  	    assert(byteLength <= reqLength, 'byte array longer than desired length');
    	  	    assert(reqLength > 0, 'Requested array length <= 0');

    	  	    this.strip();
    	  	    var littleEndian = endian === 'le';
    	  	    var res = new ArrayType(reqLength);

    	  	    var b, i;
    	  	    var q = this.clone();
    	  	    if (!littleEndian) {
    	  	      // Assume big-endian
    	  	      for (i = 0; i < reqLength - byteLength; i++) {
    	  	        res[i] = 0;
    	  	      }

    	  	      for (i = 0; !q.isZero(); i++) {
    	  	        b = q.andln(0xff);
    	  	        q.iushrn(8);

    	  	        res[reqLength - i - 1] = b;
    	  	      }
    	  	    } else {
    	  	      for (i = 0; !q.isZero(); i++) {
    	  	        b = q.andln(0xff);
    	  	        q.iushrn(8);

    	  	        res[i] = b;
    	  	      }

    	  	      for (; i < reqLength; i++) {
    	  	        res[i] = 0;
    	  	      }
    	  	    }

    	  	    return res;
    	  	  };

    	  	  if (Math.clz32) {
    	  	    BN.prototype._countBits = function _countBits (w) {
    	  	      return 32 - Math.clz32(w);
    	  	    };
    	  	  } else {
    	  	    BN.prototype._countBits = function _countBits (w) {
    	  	      var t = w;
    	  	      var r = 0;
    	  	      if (t >= 0x1000) {
    	  	        r += 13;
    	  	        t >>>= 13;
    	  	      }
    	  	      if (t >= 0x40) {
    	  	        r += 7;
    	  	        t >>>= 7;
    	  	      }
    	  	      if (t >= 0x8) {
    	  	        r += 4;
    	  	        t >>>= 4;
    	  	      }
    	  	      if (t >= 0x02) {
    	  	        r += 2;
    	  	        t >>>= 2;
    	  	      }
    	  	      return r + t;
    	  	    };
    	  	  }

    	  	  BN.prototype._zeroBits = function _zeroBits (w) {
    	  	    // Short-cut
    	  	    if (w === 0) return 26;

    	  	    var t = w;
    	  	    var r = 0;
    	  	    if ((t & 0x1fff) === 0) {
    	  	      r += 13;
    	  	      t >>>= 13;
    	  	    }
    	  	    if ((t & 0x7f) === 0) {
    	  	      r += 7;
    	  	      t >>>= 7;
    	  	    }
    	  	    if ((t & 0xf) === 0) {
    	  	      r += 4;
    	  	      t >>>= 4;
    	  	    }
    	  	    if ((t & 0x3) === 0) {
    	  	      r += 2;
    	  	      t >>>= 2;
    	  	    }
    	  	    if ((t & 0x1) === 0) {
    	  	      r++;
    	  	    }
    	  	    return r;
    	  	  };

    	  	  // Return number of used bits in a BN
    	  	  BN.prototype.bitLength = function bitLength () {
    	  	    var w = this.words[this.length - 1];
    	  	    var hi = this._countBits(w);
    	  	    return (this.length - 1) * 26 + hi;
    	  	  };

    	  	  function toBitArray (num) {
    	  	    var w = new Array(num.bitLength());

    	  	    for (var bit = 0; bit < w.length; bit++) {
    	  	      var off = (bit / 26) | 0;
    	  	      var wbit = bit % 26;

    	  	      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    	  	    }

    	  	    return w;
    	  	  }

    	  	  // Number of trailing zero bits
    	  	  BN.prototype.zeroBits = function zeroBits () {
    	  	    if (this.isZero()) return 0;

    	  	    var r = 0;
    	  	    for (var i = 0; i < this.length; i++) {
    	  	      var b = this._zeroBits(this.words[i]);
    	  	      r += b;
    	  	      if (b !== 26) break;
    	  	    }
    	  	    return r;
    	  	  };

    	  	  BN.prototype.byteLength = function byteLength () {
    	  	    return Math.ceil(this.bitLength() / 8);
    	  	  };

    	  	  BN.prototype.toTwos = function toTwos (width) {
    	  	    if (this.negative !== 0) {
    	  	      return this.abs().inotn(width).iaddn(1);
    	  	    }
    	  	    return this.clone();
    	  	  };

    	  	  BN.prototype.fromTwos = function fromTwos (width) {
    	  	    if (this.testn(width - 1)) {
    	  	      return this.notn(width).iaddn(1).ineg();
    	  	    }
    	  	    return this.clone();
    	  	  };

    	  	  BN.prototype.isNeg = function isNeg () {
    	  	    return this.negative !== 0;
    	  	  };

    	  	  // Return negative clone of `this`
    	  	  BN.prototype.neg = function neg () {
    	  	    return this.clone().ineg();
    	  	  };

    	  	  BN.prototype.ineg = function ineg () {
    	  	    if (!this.isZero()) {
    	  	      this.negative ^= 1;
    	  	    }

    	  	    return this;
    	  	  };

    	  	  // Or `num` with `this` in-place
    	  	  BN.prototype.iuor = function iuor (num) {
    	  	    while (this.length < num.length) {
    	  	      this.words[this.length++] = 0;
    	  	    }

    	  	    for (var i = 0; i < num.length; i++) {
    	  	      this.words[i] = this.words[i] | num.words[i];
    	  	    }

    	  	    return this.strip();
    	  	  };

    	  	  BN.prototype.ior = function ior (num) {
    	  	    assert((this.negative | num.negative) === 0);
    	  	    return this.iuor(num);
    	  	  };

    	  	  // Or `num` with `this`
    	  	  BN.prototype.or = function or (num) {
    	  	    if (this.length > num.length) return this.clone().ior(num);
    	  	    return num.clone().ior(this);
    	  	  };

    	  	  BN.prototype.uor = function uor (num) {
    	  	    if (this.length > num.length) return this.clone().iuor(num);
    	  	    return num.clone().iuor(this);
    	  	  };

    	  	  // And `num` with `this` in-place
    	  	  BN.prototype.iuand = function iuand (num) {
    	  	    // b = min-length(num, this)
    	  	    var b;
    	  	    if (this.length > num.length) {
    	  	      b = num;
    	  	    } else {
    	  	      b = this;
    	  	    }

    	  	    for (var i = 0; i < b.length; i++) {
    	  	      this.words[i] = this.words[i] & num.words[i];
    	  	    }

    	  	    this.length = b.length;

    	  	    return this.strip();
    	  	  };

    	  	  BN.prototype.iand = function iand (num) {
    	  	    assert((this.negative | num.negative) === 0);
    	  	    return this.iuand(num);
    	  	  };

    	  	  // And `num` with `this`
    	  	  BN.prototype.and = function and (num) {
    	  	    if (this.length > num.length) return this.clone().iand(num);
    	  	    return num.clone().iand(this);
    	  	  };

    	  	  BN.prototype.uand = function uand (num) {
    	  	    if (this.length > num.length) return this.clone().iuand(num);
    	  	    return num.clone().iuand(this);
    	  	  };

    	  	  // Xor `num` with `this` in-place
    	  	  BN.prototype.iuxor = function iuxor (num) {
    	  	    // a.length > b.length
    	  	    var a;
    	  	    var b;
    	  	    if (this.length > num.length) {
    	  	      a = this;
    	  	      b = num;
    	  	    } else {
    	  	      a = num;
    	  	      b = this;
    	  	    }

    	  	    for (var i = 0; i < b.length; i++) {
    	  	      this.words[i] = a.words[i] ^ b.words[i];
    	  	    }

    	  	    if (this !== a) {
    	  	      for (; i < a.length; i++) {
    	  	        this.words[i] = a.words[i];
    	  	      }
    	  	    }

    	  	    this.length = a.length;

    	  	    return this.strip();
    	  	  };

    	  	  BN.prototype.ixor = function ixor (num) {
    	  	    assert((this.negative | num.negative) === 0);
    	  	    return this.iuxor(num);
    	  	  };

    	  	  // Xor `num` with `this`
    	  	  BN.prototype.xor = function xor (num) {
    	  	    if (this.length > num.length) return this.clone().ixor(num);
    	  	    return num.clone().ixor(this);
    	  	  };

    	  	  BN.prototype.uxor = function uxor (num) {
    	  	    if (this.length > num.length) return this.clone().iuxor(num);
    	  	    return num.clone().iuxor(this);
    	  	  };

    	  	  // Not ``this`` with ``width`` bitwidth
    	  	  BN.prototype.inotn = function inotn (width) {
    	  	    assert(typeof width === 'number' && width >= 0);

    	  	    var bytesNeeded = Math.ceil(width / 26) | 0;
    	  	    var bitsLeft = width % 26;

    	  	    // Extend the buffer with leading zeroes
    	  	    this._expand(bytesNeeded);

    	  	    if (bitsLeft > 0) {
    	  	      bytesNeeded--;
    	  	    }

    	  	    // Handle complete words
    	  	    for (var i = 0; i < bytesNeeded; i++) {
    	  	      this.words[i] = ~this.words[i] & 0x3ffffff;
    	  	    }

    	  	    // Handle the residue
    	  	    if (bitsLeft > 0) {
    	  	      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    	  	    }

    	  	    // And remove leading zeroes
    	  	    return this.strip();
    	  	  };

    	  	  BN.prototype.notn = function notn (width) {
    	  	    return this.clone().inotn(width);
    	  	  };

    	  	  // Set `bit` of `this`
    	  	  BN.prototype.setn = function setn (bit, val) {
    	  	    assert(typeof bit === 'number' && bit >= 0);

    	  	    var off = (bit / 26) | 0;
    	  	    var wbit = bit % 26;

    	  	    this._expand(off + 1);

    	  	    if (val) {
    	  	      this.words[off] = this.words[off] | (1 << wbit);
    	  	    } else {
    	  	      this.words[off] = this.words[off] & ~(1 << wbit);
    	  	    }

    	  	    return this.strip();
    	  	  };

    	  	  // Add `num` to `this` in-place
    	  	  BN.prototype.iadd = function iadd (num) {
    	  	    var r;

    	  	    // negative + positive
    	  	    if (this.negative !== 0 && num.negative === 0) {
    	  	      this.negative = 0;
    	  	      r = this.isub(num);
    	  	      this.negative ^= 1;
    	  	      return this._normSign();

    	  	    // positive + negative
    	  	    } else if (this.negative === 0 && num.negative !== 0) {
    	  	      num.negative = 0;
    	  	      r = this.isub(num);
    	  	      num.negative = 1;
    	  	      return r._normSign();
    	  	    }

    	  	    // a.length > b.length
    	  	    var a, b;
    	  	    if (this.length > num.length) {
    	  	      a = this;
    	  	      b = num;
    	  	    } else {
    	  	      a = num;
    	  	      b = this;
    	  	    }

    	  	    var carry = 0;
    	  	    for (var i = 0; i < b.length; i++) {
    	  	      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
    	  	      this.words[i] = r & 0x3ffffff;
    	  	      carry = r >>> 26;
    	  	    }
    	  	    for (; carry !== 0 && i < a.length; i++) {
    	  	      r = (a.words[i] | 0) + carry;
    	  	      this.words[i] = r & 0x3ffffff;
    	  	      carry = r >>> 26;
    	  	    }

    	  	    this.length = a.length;
    	  	    if (carry !== 0) {
    	  	      this.words[this.length] = carry;
    	  	      this.length++;
    	  	    // Copy the rest of the words
    	  	    } else if (a !== this) {
    	  	      for (; i < a.length; i++) {
    	  	        this.words[i] = a.words[i];
    	  	      }
    	  	    }

    	  	    return this;
    	  	  };

    	  	  // Add `num` to `this`
    	  	  BN.prototype.add = function add (num) {
    	  	    var res;
    	  	    if (num.negative !== 0 && this.negative === 0) {
    	  	      num.negative = 0;
    	  	      res = this.sub(num);
    	  	      num.negative ^= 1;
    	  	      return res;
    	  	    } else if (num.negative === 0 && this.negative !== 0) {
    	  	      this.negative = 0;
    	  	      res = num.sub(this);
    	  	      this.negative = 1;
    	  	      return res;
    	  	    }

    	  	    if (this.length > num.length) return this.clone().iadd(num);

    	  	    return num.clone().iadd(this);
    	  	  };

    	  	  // Subtract `num` from `this` in-place
    	  	  BN.prototype.isub = function isub (num) {
    	  	    // this - (-num) = this + num
    	  	    if (num.negative !== 0) {
    	  	      num.negative = 0;
    	  	      var r = this.iadd(num);
    	  	      num.negative = 1;
    	  	      return r._normSign();

    	  	    // -this - num = -(this + num)
    	  	    } else if (this.negative !== 0) {
    	  	      this.negative = 0;
    	  	      this.iadd(num);
    	  	      this.negative = 1;
    	  	      return this._normSign();
    	  	    }

    	  	    // At this point both numbers are positive
    	  	    var cmp = this.cmp(num);

    	  	    // Optimization - zeroify
    	  	    if (cmp === 0) {
    	  	      this.negative = 0;
    	  	      this.length = 1;
    	  	      this.words[0] = 0;
    	  	      return this;
    	  	    }

    	  	    // a > b
    	  	    var a, b;
    	  	    if (cmp > 0) {
    	  	      a = this;
    	  	      b = num;
    	  	    } else {
    	  	      a = num;
    	  	      b = this;
    	  	    }

    	  	    var carry = 0;
    	  	    for (var i = 0; i < b.length; i++) {
    	  	      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
    	  	      carry = r >> 26;
    	  	      this.words[i] = r & 0x3ffffff;
    	  	    }
    	  	    for (; carry !== 0 && i < a.length; i++) {
    	  	      r = (a.words[i] | 0) + carry;
    	  	      carry = r >> 26;
    	  	      this.words[i] = r & 0x3ffffff;
    	  	    }

    	  	    // Copy rest of the words
    	  	    if (carry === 0 && i < a.length && a !== this) {
    	  	      for (; i < a.length; i++) {
    	  	        this.words[i] = a.words[i];
    	  	      }
    	  	    }

    	  	    this.length = Math.max(this.length, i);

    	  	    if (a !== this) {
    	  	      this.negative = 1;
    	  	    }

    	  	    return this.strip();
    	  	  };

    	  	  // Subtract `num` from `this`
    	  	  BN.prototype.sub = function sub (num) {
    	  	    return this.clone().isub(num);
    	  	  };

    	  	  function smallMulTo (self, num, out) {
    	  	    out.negative = num.negative ^ self.negative;
    	  	    var len = (self.length + num.length) | 0;
    	  	    out.length = len;
    	  	    len = (len - 1) | 0;

    	  	    // Peel one iteration (compiler can't do it, because of code complexity)
    	  	    var a = self.words[0] | 0;
    	  	    var b = num.words[0] | 0;
    	  	    var r = a * b;

    	  	    var lo = r & 0x3ffffff;
    	  	    var carry = (r / 0x4000000) | 0;
    	  	    out.words[0] = lo;

    	  	    for (var k = 1; k < len; k++) {
    	  	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
    	  	      // note that ncarry could be >= 0x3ffffff
    	  	      var ncarry = carry >>> 26;
    	  	      var rword = carry & 0x3ffffff;
    	  	      var maxJ = Math.min(k, num.length - 1);
    	  	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
    	  	        var i = (k - j) | 0;
    	  	        a = self.words[i] | 0;
    	  	        b = num.words[j] | 0;
    	  	        r = a * b + rword;
    	  	        ncarry += (r / 0x4000000) | 0;
    	  	        rword = r & 0x3ffffff;
    	  	      }
    	  	      out.words[k] = rword | 0;
    	  	      carry = ncarry | 0;
    	  	    }
    	  	    if (carry !== 0) {
    	  	      out.words[k] = carry | 0;
    	  	    } else {
    	  	      out.length--;
    	  	    }

    	  	    return out.strip();
    	  	  }

    	  	  // TODO(indutny): it may be reasonable to omit it for users who don't need
    	  	  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    	  	  // multiplication (like elliptic secp256k1).
    	  	  var comb10MulTo = function comb10MulTo (self, num, out) {
    	  	    var a = self.words;
    	  	    var b = num.words;
    	  	    var o = out.words;
    	  	    var c = 0;
    	  	    var lo;
    	  	    var mid;
    	  	    var hi;
    	  	    var a0 = a[0] | 0;
    	  	    var al0 = a0 & 0x1fff;
    	  	    var ah0 = a0 >>> 13;
    	  	    var a1 = a[1] | 0;
    	  	    var al1 = a1 & 0x1fff;
    	  	    var ah1 = a1 >>> 13;
    	  	    var a2 = a[2] | 0;
    	  	    var al2 = a2 & 0x1fff;
    	  	    var ah2 = a2 >>> 13;
    	  	    var a3 = a[3] | 0;
    	  	    var al3 = a3 & 0x1fff;
    	  	    var ah3 = a3 >>> 13;
    	  	    var a4 = a[4] | 0;
    	  	    var al4 = a4 & 0x1fff;
    	  	    var ah4 = a4 >>> 13;
    	  	    var a5 = a[5] | 0;
    	  	    var al5 = a5 & 0x1fff;
    	  	    var ah5 = a5 >>> 13;
    	  	    var a6 = a[6] | 0;
    	  	    var al6 = a6 & 0x1fff;
    	  	    var ah6 = a6 >>> 13;
    	  	    var a7 = a[7] | 0;
    	  	    var al7 = a7 & 0x1fff;
    	  	    var ah7 = a7 >>> 13;
    	  	    var a8 = a[8] | 0;
    	  	    var al8 = a8 & 0x1fff;
    	  	    var ah8 = a8 >>> 13;
    	  	    var a9 = a[9] | 0;
    	  	    var al9 = a9 & 0x1fff;
    	  	    var ah9 = a9 >>> 13;
    	  	    var b0 = b[0] | 0;
    	  	    var bl0 = b0 & 0x1fff;
    	  	    var bh0 = b0 >>> 13;
    	  	    var b1 = b[1] | 0;
    	  	    var bl1 = b1 & 0x1fff;
    	  	    var bh1 = b1 >>> 13;
    	  	    var b2 = b[2] | 0;
    	  	    var bl2 = b2 & 0x1fff;
    	  	    var bh2 = b2 >>> 13;
    	  	    var b3 = b[3] | 0;
    	  	    var bl3 = b3 & 0x1fff;
    	  	    var bh3 = b3 >>> 13;
    	  	    var b4 = b[4] | 0;
    	  	    var bl4 = b4 & 0x1fff;
    	  	    var bh4 = b4 >>> 13;
    	  	    var b5 = b[5] | 0;
    	  	    var bl5 = b5 & 0x1fff;
    	  	    var bh5 = b5 >>> 13;
    	  	    var b6 = b[6] | 0;
    	  	    var bl6 = b6 & 0x1fff;
    	  	    var bh6 = b6 >>> 13;
    	  	    var b7 = b[7] | 0;
    	  	    var bl7 = b7 & 0x1fff;
    	  	    var bh7 = b7 >>> 13;
    	  	    var b8 = b[8] | 0;
    	  	    var bl8 = b8 & 0x1fff;
    	  	    var bh8 = b8 >>> 13;
    	  	    var b9 = b[9] | 0;
    	  	    var bl9 = b9 & 0x1fff;
    	  	    var bh9 = b9 >>> 13;

    	  	    out.negative = self.negative ^ num.negative;
    	  	    out.length = 19;
    	  	    /* k = 0 */
    	  	    lo = Math.imul(al0, bl0);
    	  	    mid = Math.imul(al0, bh0);
    	  	    mid = (mid + Math.imul(ah0, bl0)) | 0;
    	  	    hi = Math.imul(ah0, bh0);
    	  	    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    	  	    w0 &= 0x3ffffff;
    	  	    /* k = 1 */
    	  	    lo = Math.imul(al1, bl0);
    	  	    mid = Math.imul(al1, bh0);
    	  	    mid = (mid + Math.imul(ah1, bl0)) | 0;
    	  	    hi = Math.imul(ah1, bh0);
    	  	    lo = (lo + Math.imul(al0, bl1)) | 0;
    	  	    mid = (mid + Math.imul(al0, bh1)) | 0;
    	  	    mid = (mid + Math.imul(ah0, bl1)) | 0;
    	  	    hi = (hi + Math.imul(ah0, bh1)) | 0;
    	  	    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    	  	    w1 &= 0x3ffffff;
    	  	    /* k = 2 */
    	  	    lo = Math.imul(al2, bl0);
    	  	    mid = Math.imul(al2, bh0);
    	  	    mid = (mid + Math.imul(ah2, bl0)) | 0;
    	  	    hi = Math.imul(ah2, bh0);
    	  	    lo = (lo + Math.imul(al1, bl1)) | 0;
    	  	    mid = (mid + Math.imul(al1, bh1)) | 0;
    	  	    mid = (mid + Math.imul(ah1, bl1)) | 0;
    	  	    hi = (hi + Math.imul(ah1, bh1)) | 0;
    	  	    lo = (lo + Math.imul(al0, bl2)) | 0;
    	  	    mid = (mid + Math.imul(al0, bh2)) | 0;
    	  	    mid = (mid + Math.imul(ah0, bl2)) | 0;
    	  	    hi = (hi + Math.imul(ah0, bh2)) | 0;
    	  	    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    	  	    w2 &= 0x3ffffff;
    	  	    /* k = 3 */
    	  	    lo = Math.imul(al3, bl0);
    	  	    mid = Math.imul(al3, bh0);
    	  	    mid = (mid + Math.imul(ah3, bl0)) | 0;
    	  	    hi = Math.imul(ah3, bh0);
    	  	    lo = (lo + Math.imul(al2, bl1)) | 0;
    	  	    mid = (mid + Math.imul(al2, bh1)) | 0;
    	  	    mid = (mid + Math.imul(ah2, bl1)) | 0;
    	  	    hi = (hi + Math.imul(ah2, bh1)) | 0;
    	  	    lo = (lo + Math.imul(al1, bl2)) | 0;
    	  	    mid = (mid + Math.imul(al1, bh2)) | 0;
    	  	    mid = (mid + Math.imul(ah1, bl2)) | 0;
    	  	    hi = (hi + Math.imul(ah1, bh2)) | 0;
    	  	    lo = (lo + Math.imul(al0, bl3)) | 0;
    	  	    mid = (mid + Math.imul(al0, bh3)) | 0;
    	  	    mid = (mid + Math.imul(ah0, bl3)) | 0;
    	  	    hi = (hi + Math.imul(ah0, bh3)) | 0;
    	  	    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    	  	    w3 &= 0x3ffffff;
    	  	    /* k = 4 */
    	  	    lo = Math.imul(al4, bl0);
    	  	    mid = Math.imul(al4, bh0);
    	  	    mid = (mid + Math.imul(ah4, bl0)) | 0;
    	  	    hi = Math.imul(ah4, bh0);
    	  	    lo = (lo + Math.imul(al3, bl1)) | 0;
    	  	    mid = (mid + Math.imul(al3, bh1)) | 0;
    	  	    mid = (mid + Math.imul(ah3, bl1)) | 0;
    	  	    hi = (hi + Math.imul(ah3, bh1)) | 0;
    	  	    lo = (lo + Math.imul(al2, bl2)) | 0;
    	  	    mid = (mid + Math.imul(al2, bh2)) | 0;
    	  	    mid = (mid + Math.imul(ah2, bl2)) | 0;
    	  	    hi = (hi + Math.imul(ah2, bh2)) | 0;
    	  	    lo = (lo + Math.imul(al1, bl3)) | 0;
    	  	    mid = (mid + Math.imul(al1, bh3)) | 0;
    	  	    mid = (mid + Math.imul(ah1, bl3)) | 0;
    	  	    hi = (hi + Math.imul(ah1, bh3)) | 0;
    	  	    lo = (lo + Math.imul(al0, bl4)) | 0;
    	  	    mid = (mid + Math.imul(al0, bh4)) | 0;
    	  	    mid = (mid + Math.imul(ah0, bl4)) | 0;
    	  	    hi = (hi + Math.imul(ah0, bh4)) | 0;
    	  	    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    	  	    w4 &= 0x3ffffff;
    	  	    /* k = 5 */
    	  	    lo = Math.imul(al5, bl0);
    	  	    mid = Math.imul(al5, bh0);
    	  	    mid = (mid + Math.imul(ah5, bl0)) | 0;
    	  	    hi = Math.imul(ah5, bh0);
    	  	    lo = (lo + Math.imul(al4, bl1)) | 0;
    	  	    mid = (mid + Math.imul(al4, bh1)) | 0;
    	  	    mid = (mid + Math.imul(ah4, bl1)) | 0;
    	  	    hi = (hi + Math.imul(ah4, bh1)) | 0;
    	  	    lo = (lo + Math.imul(al3, bl2)) | 0;
    	  	    mid = (mid + Math.imul(al3, bh2)) | 0;
    	  	    mid = (mid + Math.imul(ah3, bl2)) | 0;
    	  	    hi = (hi + Math.imul(ah3, bh2)) | 0;
    	  	    lo = (lo + Math.imul(al2, bl3)) | 0;
    	  	    mid = (mid + Math.imul(al2, bh3)) | 0;
    	  	    mid = (mid + Math.imul(ah2, bl3)) | 0;
    	  	    hi = (hi + Math.imul(ah2, bh3)) | 0;
    	  	    lo = (lo + Math.imul(al1, bl4)) | 0;
    	  	    mid = (mid + Math.imul(al1, bh4)) | 0;
    	  	    mid = (mid + Math.imul(ah1, bl4)) | 0;
    	  	    hi = (hi + Math.imul(ah1, bh4)) | 0;
    	  	    lo = (lo + Math.imul(al0, bl5)) | 0;
    	  	    mid = (mid + Math.imul(al0, bh5)) | 0;
    	  	    mid = (mid + Math.imul(ah0, bl5)) | 0;
    	  	    hi = (hi + Math.imul(ah0, bh5)) | 0;
    	  	    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    	  	    w5 &= 0x3ffffff;
    	  	    /* k = 6 */
    	  	    lo = Math.imul(al6, bl0);
    	  	    mid = Math.imul(al6, bh0);
    	  	    mid = (mid + Math.imul(ah6, bl0)) | 0;
    	  	    hi = Math.imul(ah6, bh0);
    	  	    lo = (lo + Math.imul(al5, bl1)) | 0;
    	  	    mid = (mid + Math.imul(al5, bh1)) | 0;
    	  	    mid = (mid + Math.imul(ah5, bl1)) | 0;
    	  	    hi = (hi + Math.imul(ah5, bh1)) | 0;
    	  	    lo = (lo + Math.imul(al4, bl2)) | 0;
    	  	    mid = (mid + Math.imul(al4, bh2)) | 0;
    	  	    mid = (mid + Math.imul(ah4, bl2)) | 0;
    	  	    hi = (hi + Math.imul(ah4, bh2)) | 0;
    	  	    lo = (lo + Math.imul(al3, bl3)) | 0;
    	  	    mid = (mid + Math.imul(al3, bh3)) | 0;
    	  	    mid = (mid + Math.imul(ah3, bl3)) | 0;
    	  	    hi = (hi + Math.imul(ah3, bh3)) | 0;
    	  	    lo = (lo + Math.imul(al2, bl4)) | 0;
    	  	    mid = (mid + Math.imul(al2, bh4)) | 0;
    	  	    mid = (mid + Math.imul(ah2, bl4)) | 0;
    	  	    hi = (hi + Math.imul(ah2, bh4)) | 0;
    	  	    lo = (lo + Math.imul(al1, bl5)) | 0;
    	  	    mid = (mid + Math.imul(al1, bh5)) | 0;
    	  	    mid = (mid + Math.imul(ah1, bl5)) | 0;
    	  	    hi = (hi + Math.imul(ah1, bh5)) | 0;
    	  	    lo = (lo + Math.imul(al0, bl6)) | 0;
    	  	    mid = (mid + Math.imul(al0, bh6)) | 0;
    	  	    mid = (mid + Math.imul(ah0, bl6)) | 0;
    	  	    hi = (hi + Math.imul(ah0, bh6)) | 0;
    	  	    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    	  	    w6 &= 0x3ffffff;
    	  	    /* k = 7 */
    	  	    lo = Math.imul(al7, bl0);
    	  	    mid = Math.imul(al7, bh0);
    	  	    mid = (mid + Math.imul(ah7, bl0)) | 0;
    	  	    hi = Math.imul(ah7, bh0);
    	  	    lo = (lo + Math.imul(al6, bl1)) | 0;
    	  	    mid = (mid + Math.imul(al6, bh1)) | 0;
    	  	    mid = (mid + Math.imul(ah6, bl1)) | 0;
    	  	    hi = (hi + Math.imul(ah6, bh1)) | 0;
    	  	    lo = (lo + Math.imul(al5, bl2)) | 0;
    	  	    mid = (mid + Math.imul(al5, bh2)) | 0;
    	  	    mid = (mid + Math.imul(ah5, bl2)) | 0;
    	  	    hi = (hi + Math.imul(ah5, bh2)) | 0;
    	  	    lo = (lo + Math.imul(al4, bl3)) | 0;
    	  	    mid = (mid + Math.imul(al4, bh3)) | 0;
    	  	    mid = (mid + Math.imul(ah4, bl3)) | 0;
    	  	    hi = (hi + Math.imul(ah4, bh3)) | 0;
    	  	    lo = (lo + Math.imul(al3, bl4)) | 0;
    	  	    mid = (mid + Math.imul(al3, bh4)) | 0;
    	  	    mid = (mid + Math.imul(ah3, bl4)) | 0;
    	  	    hi = (hi + Math.imul(ah3, bh4)) | 0;
    	  	    lo = (lo + Math.imul(al2, bl5)) | 0;
    	  	    mid = (mid + Math.imul(al2, bh5)) | 0;
    	  	    mid = (mid + Math.imul(ah2, bl5)) | 0;
    	  	    hi = (hi + Math.imul(ah2, bh5)) | 0;
    	  	    lo = (lo + Math.imul(al1, bl6)) | 0;
    	  	    mid = (mid + Math.imul(al1, bh6)) | 0;
    	  	    mid = (mid + Math.imul(ah1, bl6)) | 0;
    	  	    hi = (hi + Math.imul(ah1, bh6)) | 0;
    	  	    lo = (lo + Math.imul(al0, bl7)) | 0;
    	  	    mid = (mid + Math.imul(al0, bh7)) | 0;
    	  	    mid = (mid + Math.imul(ah0, bl7)) | 0;
    	  	    hi = (hi + Math.imul(ah0, bh7)) | 0;
    	  	    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    	  	    w7 &= 0x3ffffff;
    	  	    /* k = 8 */
    	  	    lo = Math.imul(al8, bl0);
    	  	    mid = Math.imul(al8, bh0);
    	  	    mid = (mid + Math.imul(ah8, bl0)) | 0;
    	  	    hi = Math.imul(ah8, bh0);
    	  	    lo = (lo + Math.imul(al7, bl1)) | 0;
    	  	    mid = (mid + Math.imul(al7, bh1)) | 0;
    	  	    mid = (mid + Math.imul(ah7, bl1)) | 0;
    	  	    hi = (hi + Math.imul(ah7, bh1)) | 0;
    	  	    lo = (lo + Math.imul(al6, bl2)) | 0;
    	  	    mid = (mid + Math.imul(al6, bh2)) | 0;
    	  	    mid = (mid + Math.imul(ah6, bl2)) | 0;
    	  	    hi = (hi + Math.imul(ah6, bh2)) | 0;
    	  	    lo = (lo + Math.imul(al5, bl3)) | 0;
    	  	    mid = (mid + Math.imul(al5, bh3)) | 0;
    	  	    mid = (mid + Math.imul(ah5, bl3)) | 0;
    	  	    hi = (hi + Math.imul(ah5, bh3)) | 0;
    	  	    lo = (lo + Math.imul(al4, bl4)) | 0;
    	  	    mid = (mid + Math.imul(al4, bh4)) | 0;
    	  	    mid = (mid + Math.imul(ah4, bl4)) | 0;
    	  	    hi = (hi + Math.imul(ah4, bh4)) | 0;
    	  	    lo = (lo + Math.imul(al3, bl5)) | 0;
    	  	    mid = (mid + Math.imul(al3, bh5)) | 0;
    	  	    mid = (mid + Math.imul(ah3, bl5)) | 0;
    	  	    hi = (hi + Math.imul(ah3, bh5)) | 0;
    	  	    lo = (lo + Math.imul(al2, bl6)) | 0;
    	  	    mid = (mid + Math.imul(al2, bh6)) | 0;
    	  	    mid = (mid + Math.imul(ah2, bl6)) | 0;
    	  	    hi = (hi + Math.imul(ah2, bh6)) | 0;
    	  	    lo = (lo + Math.imul(al1, bl7)) | 0;
    	  	    mid = (mid + Math.imul(al1, bh7)) | 0;
    	  	    mid = (mid + Math.imul(ah1, bl7)) | 0;
    	  	    hi = (hi + Math.imul(ah1, bh7)) | 0;
    	  	    lo = (lo + Math.imul(al0, bl8)) | 0;
    	  	    mid = (mid + Math.imul(al0, bh8)) | 0;
    	  	    mid = (mid + Math.imul(ah0, bl8)) | 0;
    	  	    hi = (hi + Math.imul(ah0, bh8)) | 0;
    	  	    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    	  	    w8 &= 0x3ffffff;
    	  	    /* k = 9 */
    	  	    lo = Math.imul(al9, bl0);
    	  	    mid = Math.imul(al9, bh0);
    	  	    mid = (mid + Math.imul(ah9, bl0)) | 0;
    	  	    hi = Math.imul(ah9, bh0);
    	  	    lo = (lo + Math.imul(al8, bl1)) | 0;
    	  	    mid = (mid + Math.imul(al8, bh1)) | 0;
    	  	    mid = (mid + Math.imul(ah8, bl1)) | 0;
    	  	    hi = (hi + Math.imul(ah8, bh1)) | 0;
    	  	    lo = (lo + Math.imul(al7, bl2)) | 0;
    	  	    mid = (mid + Math.imul(al7, bh2)) | 0;
    	  	    mid = (mid + Math.imul(ah7, bl2)) | 0;
    	  	    hi = (hi + Math.imul(ah7, bh2)) | 0;
    	  	    lo = (lo + Math.imul(al6, bl3)) | 0;
    	  	    mid = (mid + Math.imul(al6, bh3)) | 0;
    	  	    mid = (mid + Math.imul(ah6, bl3)) | 0;
    	  	    hi = (hi + Math.imul(ah6, bh3)) | 0;
    	  	    lo = (lo + Math.imul(al5, bl4)) | 0;
    	  	    mid = (mid + Math.imul(al5, bh4)) | 0;
    	  	    mid = (mid + Math.imul(ah5, bl4)) | 0;
    	  	    hi = (hi + Math.imul(ah5, bh4)) | 0;
    	  	    lo = (lo + Math.imul(al4, bl5)) | 0;
    	  	    mid = (mid + Math.imul(al4, bh5)) | 0;
    	  	    mid = (mid + Math.imul(ah4, bl5)) | 0;
    	  	    hi = (hi + Math.imul(ah4, bh5)) | 0;
    	  	    lo = (lo + Math.imul(al3, bl6)) | 0;
    	  	    mid = (mid + Math.imul(al3, bh6)) | 0;
    	  	    mid = (mid + Math.imul(ah3, bl6)) | 0;
    	  	    hi = (hi + Math.imul(ah3, bh6)) | 0;
    	  	    lo = (lo + Math.imul(al2, bl7)) | 0;
    	  	    mid = (mid + Math.imul(al2, bh7)) | 0;
    	  	    mid = (mid + Math.imul(ah2, bl7)) | 0;
    	  	    hi = (hi + Math.imul(ah2, bh7)) | 0;
    	  	    lo = (lo + Math.imul(al1, bl8)) | 0;
    	  	    mid = (mid + Math.imul(al1, bh8)) | 0;
    	  	    mid = (mid + Math.imul(ah1, bl8)) | 0;
    	  	    hi = (hi + Math.imul(ah1, bh8)) | 0;
    	  	    lo = (lo + Math.imul(al0, bl9)) | 0;
    	  	    mid = (mid + Math.imul(al0, bh9)) | 0;
    	  	    mid = (mid + Math.imul(ah0, bl9)) | 0;
    	  	    hi = (hi + Math.imul(ah0, bh9)) | 0;
    	  	    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    	  	    w9 &= 0x3ffffff;
    	  	    /* k = 10 */
    	  	    lo = Math.imul(al9, bl1);
    	  	    mid = Math.imul(al9, bh1);
    	  	    mid = (mid + Math.imul(ah9, bl1)) | 0;
    	  	    hi = Math.imul(ah9, bh1);
    	  	    lo = (lo + Math.imul(al8, bl2)) | 0;
    	  	    mid = (mid + Math.imul(al8, bh2)) | 0;
    	  	    mid = (mid + Math.imul(ah8, bl2)) | 0;
    	  	    hi = (hi + Math.imul(ah8, bh2)) | 0;
    	  	    lo = (lo + Math.imul(al7, bl3)) | 0;
    	  	    mid = (mid + Math.imul(al7, bh3)) | 0;
    	  	    mid = (mid + Math.imul(ah7, bl3)) | 0;
    	  	    hi = (hi + Math.imul(ah7, bh3)) | 0;
    	  	    lo = (lo + Math.imul(al6, bl4)) | 0;
    	  	    mid = (mid + Math.imul(al6, bh4)) | 0;
    	  	    mid = (mid + Math.imul(ah6, bl4)) | 0;
    	  	    hi = (hi + Math.imul(ah6, bh4)) | 0;
    	  	    lo = (lo + Math.imul(al5, bl5)) | 0;
    	  	    mid = (mid + Math.imul(al5, bh5)) | 0;
    	  	    mid = (mid + Math.imul(ah5, bl5)) | 0;
    	  	    hi = (hi + Math.imul(ah5, bh5)) | 0;
    	  	    lo = (lo + Math.imul(al4, bl6)) | 0;
    	  	    mid = (mid + Math.imul(al4, bh6)) | 0;
    	  	    mid = (mid + Math.imul(ah4, bl6)) | 0;
    	  	    hi = (hi + Math.imul(ah4, bh6)) | 0;
    	  	    lo = (lo + Math.imul(al3, bl7)) | 0;
    	  	    mid = (mid + Math.imul(al3, bh7)) | 0;
    	  	    mid = (mid + Math.imul(ah3, bl7)) | 0;
    	  	    hi = (hi + Math.imul(ah3, bh7)) | 0;
    	  	    lo = (lo + Math.imul(al2, bl8)) | 0;
    	  	    mid = (mid + Math.imul(al2, bh8)) | 0;
    	  	    mid = (mid + Math.imul(ah2, bl8)) | 0;
    	  	    hi = (hi + Math.imul(ah2, bh8)) | 0;
    	  	    lo = (lo + Math.imul(al1, bl9)) | 0;
    	  	    mid = (mid + Math.imul(al1, bh9)) | 0;
    	  	    mid = (mid + Math.imul(ah1, bl9)) | 0;
    	  	    hi = (hi + Math.imul(ah1, bh9)) | 0;
    	  	    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    	  	    w10 &= 0x3ffffff;
    	  	    /* k = 11 */
    	  	    lo = Math.imul(al9, bl2);
    	  	    mid = Math.imul(al9, bh2);
    	  	    mid = (mid + Math.imul(ah9, bl2)) | 0;
    	  	    hi = Math.imul(ah9, bh2);
    	  	    lo = (lo + Math.imul(al8, bl3)) | 0;
    	  	    mid = (mid + Math.imul(al8, bh3)) | 0;
    	  	    mid = (mid + Math.imul(ah8, bl3)) | 0;
    	  	    hi = (hi + Math.imul(ah8, bh3)) | 0;
    	  	    lo = (lo + Math.imul(al7, bl4)) | 0;
    	  	    mid = (mid + Math.imul(al7, bh4)) | 0;
    	  	    mid = (mid + Math.imul(ah7, bl4)) | 0;
    	  	    hi = (hi + Math.imul(ah7, bh4)) | 0;
    	  	    lo = (lo + Math.imul(al6, bl5)) | 0;
    	  	    mid = (mid + Math.imul(al6, bh5)) | 0;
    	  	    mid = (mid + Math.imul(ah6, bl5)) | 0;
    	  	    hi = (hi + Math.imul(ah6, bh5)) | 0;
    	  	    lo = (lo + Math.imul(al5, bl6)) | 0;
    	  	    mid = (mid + Math.imul(al5, bh6)) | 0;
    	  	    mid = (mid + Math.imul(ah5, bl6)) | 0;
    	  	    hi = (hi + Math.imul(ah5, bh6)) | 0;
    	  	    lo = (lo + Math.imul(al4, bl7)) | 0;
    	  	    mid = (mid + Math.imul(al4, bh7)) | 0;
    	  	    mid = (mid + Math.imul(ah4, bl7)) | 0;
    	  	    hi = (hi + Math.imul(ah4, bh7)) | 0;
    	  	    lo = (lo + Math.imul(al3, bl8)) | 0;
    	  	    mid = (mid + Math.imul(al3, bh8)) | 0;
    	  	    mid = (mid + Math.imul(ah3, bl8)) | 0;
    	  	    hi = (hi + Math.imul(ah3, bh8)) | 0;
    	  	    lo = (lo + Math.imul(al2, bl9)) | 0;
    	  	    mid = (mid + Math.imul(al2, bh9)) | 0;
    	  	    mid = (mid + Math.imul(ah2, bl9)) | 0;
    	  	    hi = (hi + Math.imul(ah2, bh9)) | 0;
    	  	    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    	  	    w11 &= 0x3ffffff;
    	  	    /* k = 12 */
    	  	    lo = Math.imul(al9, bl3);
    	  	    mid = Math.imul(al9, bh3);
    	  	    mid = (mid + Math.imul(ah9, bl3)) | 0;
    	  	    hi = Math.imul(ah9, bh3);
    	  	    lo = (lo + Math.imul(al8, bl4)) | 0;
    	  	    mid = (mid + Math.imul(al8, bh4)) | 0;
    	  	    mid = (mid + Math.imul(ah8, bl4)) | 0;
    	  	    hi = (hi + Math.imul(ah8, bh4)) | 0;
    	  	    lo = (lo + Math.imul(al7, bl5)) | 0;
    	  	    mid = (mid + Math.imul(al7, bh5)) | 0;
    	  	    mid = (mid + Math.imul(ah7, bl5)) | 0;
    	  	    hi = (hi + Math.imul(ah7, bh5)) | 0;
    	  	    lo = (lo + Math.imul(al6, bl6)) | 0;
    	  	    mid = (mid + Math.imul(al6, bh6)) | 0;
    	  	    mid = (mid + Math.imul(ah6, bl6)) | 0;
    	  	    hi = (hi + Math.imul(ah6, bh6)) | 0;
    	  	    lo = (lo + Math.imul(al5, bl7)) | 0;
    	  	    mid = (mid + Math.imul(al5, bh7)) | 0;
    	  	    mid = (mid + Math.imul(ah5, bl7)) | 0;
    	  	    hi = (hi + Math.imul(ah5, bh7)) | 0;
    	  	    lo = (lo + Math.imul(al4, bl8)) | 0;
    	  	    mid = (mid + Math.imul(al4, bh8)) | 0;
    	  	    mid = (mid + Math.imul(ah4, bl8)) | 0;
    	  	    hi = (hi + Math.imul(ah4, bh8)) | 0;
    	  	    lo = (lo + Math.imul(al3, bl9)) | 0;
    	  	    mid = (mid + Math.imul(al3, bh9)) | 0;
    	  	    mid = (mid + Math.imul(ah3, bl9)) | 0;
    	  	    hi = (hi + Math.imul(ah3, bh9)) | 0;
    	  	    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    	  	    w12 &= 0x3ffffff;
    	  	    /* k = 13 */
    	  	    lo = Math.imul(al9, bl4);
    	  	    mid = Math.imul(al9, bh4);
    	  	    mid = (mid + Math.imul(ah9, bl4)) | 0;
    	  	    hi = Math.imul(ah9, bh4);
    	  	    lo = (lo + Math.imul(al8, bl5)) | 0;
    	  	    mid = (mid + Math.imul(al8, bh5)) | 0;
    	  	    mid = (mid + Math.imul(ah8, bl5)) | 0;
    	  	    hi = (hi + Math.imul(ah8, bh5)) | 0;
    	  	    lo = (lo + Math.imul(al7, bl6)) | 0;
    	  	    mid = (mid + Math.imul(al7, bh6)) | 0;
    	  	    mid = (mid + Math.imul(ah7, bl6)) | 0;
    	  	    hi = (hi + Math.imul(ah7, bh6)) | 0;
    	  	    lo = (lo + Math.imul(al6, bl7)) | 0;
    	  	    mid = (mid + Math.imul(al6, bh7)) | 0;
    	  	    mid = (mid + Math.imul(ah6, bl7)) | 0;
    	  	    hi = (hi + Math.imul(ah6, bh7)) | 0;
    	  	    lo = (lo + Math.imul(al5, bl8)) | 0;
    	  	    mid = (mid + Math.imul(al5, bh8)) | 0;
    	  	    mid = (mid + Math.imul(ah5, bl8)) | 0;
    	  	    hi = (hi + Math.imul(ah5, bh8)) | 0;
    	  	    lo = (lo + Math.imul(al4, bl9)) | 0;
    	  	    mid = (mid + Math.imul(al4, bh9)) | 0;
    	  	    mid = (mid + Math.imul(ah4, bl9)) | 0;
    	  	    hi = (hi + Math.imul(ah4, bh9)) | 0;
    	  	    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    	  	    w13 &= 0x3ffffff;
    	  	    /* k = 14 */
    	  	    lo = Math.imul(al9, bl5);
    	  	    mid = Math.imul(al9, bh5);
    	  	    mid = (mid + Math.imul(ah9, bl5)) | 0;
    	  	    hi = Math.imul(ah9, bh5);
    	  	    lo = (lo + Math.imul(al8, bl6)) | 0;
    	  	    mid = (mid + Math.imul(al8, bh6)) | 0;
    	  	    mid = (mid + Math.imul(ah8, bl6)) | 0;
    	  	    hi = (hi + Math.imul(ah8, bh6)) | 0;
    	  	    lo = (lo + Math.imul(al7, bl7)) | 0;
    	  	    mid = (mid + Math.imul(al7, bh7)) | 0;
    	  	    mid = (mid + Math.imul(ah7, bl7)) | 0;
    	  	    hi = (hi + Math.imul(ah7, bh7)) | 0;
    	  	    lo = (lo + Math.imul(al6, bl8)) | 0;
    	  	    mid = (mid + Math.imul(al6, bh8)) | 0;
    	  	    mid = (mid + Math.imul(ah6, bl8)) | 0;
    	  	    hi = (hi + Math.imul(ah6, bh8)) | 0;
    	  	    lo = (lo + Math.imul(al5, bl9)) | 0;
    	  	    mid = (mid + Math.imul(al5, bh9)) | 0;
    	  	    mid = (mid + Math.imul(ah5, bl9)) | 0;
    	  	    hi = (hi + Math.imul(ah5, bh9)) | 0;
    	  	    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    	  	    w14 &= 0x3ffffff;
    	  	    /* k = 15 */
    	  	    lo = Math.imul(al9, bl6);
    	  	    mid = Math.imul(al9, bh6);
    	  	    mid = (mid + Math.imul(ah9, bl6)) | 0;
    	  	    hi = Math.imul(ah9, bh6);
    	  	    lo = (lo + Math.imul(al8, bl7)) | 0;
    	  	    mid = (mid + Math.imul(al8, bh7)) | 0;
    	  	    mid = (mid + Math.imul(ah8, bl7)) | 0;
    	  	    hi = (hi + Math.imul(ah8, bh7)) | 0;
    	  	    lo = (lo + Math.imul(al7, bl8)) | 0;
    	  	    mid = (mid + Math.imul(al7, bh8)) | 0;
    	  	    mid = (mid + Math.imul(ah7, bl8)) | 0;
    	  	    hi = (hi + Math.imul(ah7, bh8)) | 0;
    	  	    lo = (lo + Math.imul(al6, bl9)) | 0;
    	  	    mid = (mid + Math.imul(al6, bh9)) | 0;
    	  	    mid = (mid + Math.imul(ah6, bl9)) | 0;
    	  	    hi = (hi + Math.imul(ah6, bh9)) | 0;
    	  	    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    	  	    w15 &= 0x3ffffff;
    	  	    /* k = 16 */
    	  	    lo = Math.imul(al9, bl7);
    	  	    mid = Math.imul(al9, bh7);
    	  	    mid = (mid + Math.imul(ah9, bl7)) | 0;
    	  	    hi = Math.imul(ah9, bh7);
    	  	    lo = (lo + Math.imul(al8, bl8)) | 0;
    	  	    mid = (mid + Math.imul(al8, bh8)) | 0;
    	  	    mid = (mid + Math.imul(ah8, bl8)) | 0;
    	  	    hi = (hi + Math.imul(ah8, bh8)) | 0;
    	  	    lo = (lo + Math.imul(al7, bl9)) | 0;
    	  	    mid = (mid + Math.imul(al7, bh9)) | 0;
    	  	    mid = (mid + Math.imul(ah7, bl9)) | 0;
    	  	    hi = (hi + Math.imul(ah7, bh9)) | 0;
    	  	    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    	  	    w16 &= 0x3ffffff;
    	  	    /* k = 17 */
    	  	    lo = Math.imul(al9, bl8);
    	  	    mid = Math.imul(al9, bh8);
    	  	    mid = (mid + Math.imul(ah9, bl8)) | 0;
    	  	    hi = Math.imul(ah9, bh8);
    	  	    lo = (lo + Math.imul(al8, bl9)) | 0;
    	  	    mid = (mid + Math.imul(al8, bh9)) | 0;
    	  	    mid = (mid + Math.imul(ah8, bl9)) | 0;
    	  	    hi = (hi + Math.imul(ah8, bh9)) | 0;
    	  	    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    	  	    w17 &= 0x3ffffff;
    	  	    /* k = 18 */
    	  	    lo = Math.imul(al9, bl9);
    	  	    mid = Math.imul(al9, bh9);
    	  	    mid = (mid + Math.imul(ah9, bl9)) | 0;
    	  	    hi = Math.imul(ah9, bh9);
    	  	    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	  	    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    	  	    w18 &= 0x3ffffff;
    	  	    o[0] = w0;
    	  	    o[1] = w1;
    	  	    o[2] = w2;
    	  	    o[3] = w3;
    	  	    o[4] = w4;
    	  	    o[5] = w5;
    	  	    o[6] = w6;
    	  	    o[7] = w7;
    	  	    o[8] = w8;
    	  	    o[9] = w9;
    	  	    o[10] = w10;
    	  	    o[11] = w11;
    	  	    o[12] = w12;
    	  	    o[13] = w13;
    	  	    o[14] = w14;
    	  	    o[15] = w15;
    	  	    o[16] = w16;
    	  	    o[17] = w17;
    	  	    o[18] = w18;
    	  	    if (c !== 0) {
    	  	      o[19] = c;
    	  	      out.length++;
    	  	    }
    	  	    return out;
    	  	  };

    	  	  // Polyfill comb
    	  	  if (!Math.imul) {
    	  	    comb10MulTo = smallMulTo;
    	  	  }

    	  	  function bigMulTo (self, num, out) {
    	  	    out.negative = num.negative ^ self.negative;
    	  	    out.length = self.length + num.length;

    	  	    var carry = 0;
    	  	    var hncarry = 0;
    	  	    for (var k = 0; k < out.length - 1; k++) {
    	  	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
    	  	      // note that ncarry could be >= 0x3ffffff
    	  	      var ncarry = hncarry;
    	  	      hncarry = 0;
    	  	      var rword = carry & 0x3ffffff;
    	  	      var maxJ = Math.min(k, num.length - 1);
    	  	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
    	  	        var i = k - j;
    	  	        var a = self.words[i] | 0;
    	  	        var b = num.words[j] | 0;
    	  	        var r = a * b;

    	  	        var lo = r & 0x3ffffff;
    	  	        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
    	  	        lo = (lo + rword) | 0;
    	  	        rword = lo & 0x3ffffff;
    	  	        ncarry = (ncarry + (lo >>> 26)) | 0;

    	  	        hncarry += ncarry >>> 26;
    	  	        ncarry &= 0x3ffffff;
    	  	      }
    	  	      out.words[k] = rword;
    	  	      carry = ncarry;
    	  	      ncarry = hncarry;
    	  	    }
    	  	    if (carry !== 0) {
    	  	      out.words[k] = carry;
    	  	    } else {
    	  	      out.length--;
    	  	    }

    	  	    return out.strip();
    	  	  }

    	  	  function jumboMulTo (self, num, out) {
    	  	    var fftm = new FFTM();
    	  	    return fftm.mulp(self, num, out);
    	  	  }

    	  	  BN.prototype.mulTo = function mulTo (num, out) {
    	  	    var res;
    	  	    var len = this.length + num.length;
    	  	    if (this.length === 10 && num.length === 10) {
    	  	      res = comb10MulTo(this, num, out);
    	  	    } else if (len < 63) {
    	  	      res = smallMulTo(this, num, out);
    	  	    } else if (len < 1024) {
    	  	      res = bigMulTo(this, num, out);
    	  	    } else {
    	  	      res = jumboMulTo(this, num, out);
    	  	    }

    	  	    return res;
    	  	  };

    	  	  // Cooley-Tukey algorithm for FFT
    	  	  // slightly revisited to rely on looping instead of recursion

    	  	  function FFTM (x, y) {
    	  	    this.x = x;
    	  	    this.y = y;
    	  	  }

    	  	  FFTM.prototype.makeRBT = function makeRBT (N) {
    	  	    var t = new Array(N);
    	  	    var l = BN.prototype._countBits(N) - 1;
    	  	    for (var i = 0; i < N; i++) {
    	  	      t[i] = this.revBin(i, l, N);
    	  	    }

    	  	    return t;
    	  	  };

    	  	  // Returns binary-reversed representation of `x`
    	  	  FFTM.prototype.revBin = function revBin (x, l, N) {
    	  	    if (x === 0 || x === N - 1) return x;

    	  	    var rb = 0;
    	  	    for (var i = 0; i < l; i++) {
    	  	      rb |= (x & 1) << (l - i - 1);
    	  	      x >>= 1;
    	  	    }

    	  	    return rb;
    	  	  };

    	  	  // Performs "tweedling" phase, therefore 'emulating'
    	  	  // behaviour of the recursive algorithm
    	  	  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    	  	    for (var i = 0; i < N; i++) {
    	  	      rtws[i] = rws[rbt[i]];
    	  	      itws[i] = iws[rbt[i]];
    	  	    }
    	  	  };

    	  	  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    	  	    this.permute(rbt, rws, iws, rtws, itws, N);

    	  	    for (var s = 1; s < N; s <<= 1) {
    	  	      var l = s << 1;

    	  	      var rtwdf = Math.cos(2 * Math.PI / l);
    	  	      var itwdf = Math.sin(2 * Math.PI / l);

    	  	      for (var p = 0; p < N; p += l) {
    	  	        var rtwdf_ = rtwdf;
    	  	        var itwdf_ = itwdf;

    	  	        for (var j = 0; j < s; j++) {
    	  	          var re = rtws[p + j];
    	  	          var ie = itws[p + j];

    	  	          var ro = rtws[p + j + s];
    	  	          var io = itws[p + j + s];

    	  	          var rx = rtwdf_ * ro - itwdf_ * io;

    	  	          io = rtwdf_ * io + itwdf_ * ro;
    	  	          ro = rx;

    	  	          rtws[p + j] = re + ro;
    	  	          itws[p + j] = ie + io;

    	  	          rtws[p + j + s] = re - ro;
    	  	          itws[p + j + s] = ie - io;

    	  	          /* jshint maxdepth : false */
    	  	          if (j !== l) {
    	  	            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

    	  	            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
    	  	            rtwdf_ = rx;
    	  	          }
    	  	        }
    	  	      }
    	  	    }
    	  	  };

    	  	  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    	  	    var N = Math.max(m, n) | 1;
    	  	    var odd = N & 1;
    	  	    var i = 0;
    	  	    for (N = N / 2 | 0; N; N = N >>> 1) {
    	  	      i++;
    	  	    }

    	  	    return 1 << i + 1 + odd;
    	  	  };

    	  	  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    	  	    if (N <= 1) return;

    	  	    for (var i = 0; i < N / 2; i++) {
    	  	      var t = rws[i];

    	  	      rws[i] = rws[N - i - 1];
    	  	      rws[N - i - 1] = t;

    	  	      t = iws[i];

    	  	      iws[i] = -iws[N - i - 1];
    	  	      iws[N - i - 1] = -t;
    	  	    }
    	  	  };

    	  	  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    	  	    var carry = 0;
    	  	    for (var i = 0; i < N / 2; i++) {
    	  	      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
    	  	        Math.round(ws[2 * i] / N) +
    	  	        carry;

    	  	      ws[i] = w & 0x3ffffff;

    	  	      if (w < 0x4000000) {
    	  	        carry = 0;
    	  	      } else {
    	  	        carry = w / 0x4000000 | 0;
    	  	      }
    	  	    }

    	  	    return ws;
    	  	  };

    	  	  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    	  	    var carry = 0;
    	  	    for (var i = 0; i < len; i++) {
    	  	      carry = carry + (ws[i] | 0);

    	  	      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
    	  	      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    	  	    }

    	  	    // Pad with zeroes
    	  	    for (i = 2 * len; i < N; ++i) {
    	  	      rws[i] = 0;
    	  	    }

    	  	    assert(carry === 0);
    	  	    assert((carry & ~0x1fff) === 0);
    	  	  };

    	  	  FFTM.prototype.stub = function stub (N) {
    	  	    var ph = new Array(N);
    	  	    for (var i = 0; i < N; i++) {
    	  	      ph[i] = 0;
    	  	    }

    	  	    return ph;
    	  	  };

    	  	  FFTM.prototype.mulp = function mulp (x, y, out) {
    	  	    var N = 2 * this.guessLen13b(x.length, y.length);

    	  	    var rbt = this.makeRBT(N);

    	  	    var _ = this.stub(N);

    	  	    var rws = new Array(N);
    	  	    var rwst = new Array(N);
    	  	    var iwst = new Array(N);

    	  	    var nrws = new Array(N);
    	  	    var nrwst = new Array(N);
    	  	    var niwst = new Array(N);

    	  	    var rmws = out.words;
    	  	    rmws.length = N;

    	  	    this.convert13b(x.words, x.length, rws, N);
    	  	    this.convert13b(y.words, y.length, nrws, N);

    	  	    this.transform(rws, _, rwst, iwst, N, rbt);
    	  	    this.transform(nrws, _, nrwst, niwst, N, rbt);

    	  	    for (var i = 0; i < N; i++) {
    	  	      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
    	  	      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
    	  	      rwst[i] = rx;
    	  	    }

    	  	    this.conjugate(rwst, iwst, N);
    	  	    this.transform(rwst, iwst, rmws, _, N, rbt);
    	  	    this.conjugate(rmws, _, N);
    	  	    this.normalize13b(rmws, N);

    	  	    out.negative = x.negative ^ y.negative;
    	  	    out.length = x.length + y.length;
    	  	    return out.strip();
    	  	  };

    	  	  // Multiply `this` by `num`
    	  	  BN.prototype.mul = function mul (num) {
    	  	    var out = new BN(null);
    	  	    out.words = new Array(this.length + num.length);
    	  	    return this.mulTo(num, out);
    	  	  };

    	  	  // Multiply employing FFT
    	  	  BN.prototype.mulf = function mulf (num) {
    	  	    var out = new BN(null);
    	  	    out.words = new Array(this.length + num.length);
    	  	    return jumboMulTo(this, num, out);
    	  	  };

    	  	  // In-place Multiplication
    	  	  BN.prototype.imul = function imul (num) {
    	  	    return this.clone().mulTo(num, this);
    	  	  };

    	  	  BN.prototype.imuln = function imuln (num) {
    	  	    assert(typeof num === 'number');
    	  	    assert(num < 0x4000000);

    	  	    // Carry
    	  	    var carry = 0;
    	  	    for (var i = 0; i < this.length; i++) {
    	  	      var w = (this.words[i] | 0) * num;
    	  	      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
    	  	      carry >>= 26;
    	  	      carry += (w / 0x4000000) | 0;
    	  	      // NOTE: lo is 27bit maximum
    	  	      carry += lo >>> 26;
    	  	      this.words[i] = lo & 0x3ffffff;
    	  	    }

    	  	    if (carry !== 0) {
    	  	      this.words[i] = carry;
    	  	      this.length++;
    	  	    }

    	  	    return this;
    	  	  };

    	  	  BN.prototype.muln = function muln (num) {
    	  	    return this.clone().imuln(num);
    	  	  };

    	  	  // `this` * `this`
    	  	  BN.prototype.sqr = function sqr () {
    	  	    return this.mul(this);
    	  	  };

    	  	  // `this` * `this` in-place
    	  	  BN.prototype.isqr = function isqr () {
    	  	    return this.imul(this.clone());
    	  	  };

    	  	  // Math.pow(`this`, `num`)
    	  	  BN.prototype.pow = function pow (num) {
    	  	    var w = toBitArray(num);
    	  	    if (w.length === 0) return new BN(1);

    	  	    // Skip leading zeroes
    	  	    var res = this;
    	  	    for (var i = 0; i < w.length; i++, res = res.sqr()) {
    	  	      if (w[i] !== 0) break;
    	  	    }

    	  	    if (++i < w.length) {
    	  	      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
    	  	        if (w[i] === 0) continue;

    	  	        res = res.mul(q);
    	  	      }
    	  	    }

    	  	    return res;
    	  	  };

    	  	  // Shift-left in-place
    	  	  BN.prototype.iushln = function iushln (bits) {
    	  	    assert(typeof bits === 'number' && bits >= 0);
    	  	    var r = bits % 26;
    	  	    var s = (bits - r) / 26;
    	  	    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    	  	    var i;

    	  	    if (r !== 0) {
    	  	      var carry = 0;

    	  	      for (i = 0; i < this.length; i++) {
    	  	        var newCarry = this.words[i] & carryMask;
    	  	        var c = ((this.words[i] | 0) - newCarry) << r;
    	  	        this.words[i] = c | carry;
    	  	        carry = newCarry >>> (26 - r);
    	  	      }

    	  	      if (carry) {
    	  	        this.words[i] = carry;
    	  	        this.length++;
    	  	      }
    	  	    }

    	  	    if (s !== 0) {
    	  	      for (i = this.length - 1; i >= 0; i--) {
    	  	        this.words[i + s] = this.words[i];
    	  	      }

    	  	      for (i = 0; i < s; i++) {
    	  	        this.words[i] = 0;
    	  	      }

    	  	      this.length += s;
    	  	    }

    	  	    return this.strip();
    	  	  };

    	  	  BN.prototype.ishln = function ishln (bits) {
    	  	    // TODO(indutny): implement me
    	  	    assert(this.negative === 0);
    	  	    return this.iushln(bits);
    	  	  };

    	  	  // Shift-right in-place
    	  	  // NOTE: `hint` is a lowest bit before trailing zeroes
    	  	  // NOTE: if `extended` is present - it will be filled with destroyed bits
    	  	  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    	  	    assert(typeof bits === 'number' && bits >= 0);
    	  	    var h;
    	  	    if (hint) {
    	  	      h = (hint - (hint % 26)) / 26;
    	  	    } else {
    	  	      h = 0;
    	  	    }

    	  	    var r = bits % 26;
    	  	    var s = Math.min((bits - r) / 26, this.length);
    	  	    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    	  	    var maskedWords = extended;

    	  	    h -= s;
    	  	    h = Math.max(0, h);

    	  	    // Extended mode, copy masked part
    	  	    if (maskedWords) {
    	  	      for (var i = 0; i < s; i++) {
    	  	        maskedWords.words[i] = this.words[i];
    	  	      }
    	  	      maskedWords.length = s;
    	  	    }

    	  	    if (s === 0) ; else if (this.length > s) {
    	  	      this.length -= s;
    	  	      for (i = 0; i < this.length; i++) {
    	  	        this.words[i] = this.words[i + s];
    	  	      }
    	  	    } else {
    	  	      this.words[0] = 0;
    	  	      this.length = 1;
    	  	    }

    	  	    var carry = 0;
    	  	    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
    	  	      var word = this.words[i] | 0;
    	  	      this.words[i] = (carry << (26 - r)) | (word >>> r);
    	  	      carry = word & mask;
    	  	    }

    	  	    // Push carried bits as a mask
    	  	    if (maskedWords && carry !== 0) {
    	  	      maskedWords.words[maskedWords.length++] = carry;
    	  	    }

    	  	    if (this.length === 0) {
    	  	      this.words[0] = 0;
    	  	      this.length = 1;
    	  	    }

    	  	    return this.strip();
    	  	  };

    	  	  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    	  	    // TODO(indutny): implement me
    	  	    assert(this.negative === 0);
    	  	    return this.iushrn(bits, hint, extended);
    	  	  };

    	  	  // Shift-left
    	  	  BN.prototype.shln = function shln (bits) {
    	  	    return this.clone().ishln(bits);
    	  	  };

    	  	  BN.prototype.ushln = function ushln (bits) {
    	  	    return this.clone().iushln(bits);
    	  	  };

    	  	  // Shift-right
    	  	  BN.prototype.shrn = function shrn (bits) {
    	  	    return this.clone().ishrn(bits);
    	  	  };

    	  	  BN.prototype.ushrn = function ushrn (bits) {
    	  	    return this.clone().iushrn(bits);
    	  	  };

    	  	  // Test if n bit is set
    	  	  BN.prototype.testn = function testn (bit) {
    	  	    assert(typeof bit === 'number' && bit >= 0);
    	  	    var r = bit % 26;
    	  	    var s = (bit - r) / 26;
    	  	    var q = 1 << r;

    	  	    // Fast case: bit is much higher than all existing words
    	  	    if (this.length <= s) return false;

    	  	    // Check bit and return
    	  	    var w = this.words[s];

    	  	    return !!(w & q);
    	  	  };

    	  	  // Return only lowers bits of number (in-place)
    	  	  BN.prototype.imaskn = function imaskn (bits) {
    	  	    assert(typeof bits === 'number' && bits >= 0);
    	  	    var r = bits % 26;
    	  	    var s = (bits - r) / 26;

    	  	    assert(this.negative === 0, 'imaskn works only with positive numbers');

    	  	    if (this.length <= s) {
    	  	      return this;
    	  	    }

    	  	    if (r !== 0) {
    	  	      s++;
    	  	    }
    	  	    this.length = Math.min(s, this.length);

    	  	    if (r !== 0) {
    	  	      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    	  	      this.words[this.length - 1] &= mask;
    	  	    }

    	  	    return this.strip();
    	  	  };

    	  	  // Return only lowers bits of number
    	  	  BN.prototype.maskn = function maskn (bits) {
    	  	    return this.clone().imaskn(bits);
    	  	  };

    	  	  // Add plain number `num` to `this`
    	  	  BN.prototype.iaddn = function iaddn (num) {
    	  	    assert(typeof num === 'number');
    	  	    assert(num < 0x4000000);
    	  	    if (num < 0) return this.isubn(-num);

    	  	    // Possible sign change
    	  	    if (this.negative !== 0) {
    	  	      if (this.length === 1 && (this.words[0] | 0) < num) {
    	  	        this.words[0] = num - (this.words[0] | 0);
    	  	        this.negative = 0;
    	  	        return this;
    	  	      }

    	  	      this.negative = 0;
    	  	      this.isubn(num);
    	  	      this.negative = 1;
    	  	      return this;
    	  	    }

    	  	    // Add without checks
    	  	    return this._iaddn(num);
    	  	  };

    	  	  BN.prototype._iaddn = function _iaddn (num) {
    	  	    this.words[0] += num;

    	  	    // Carry
    	  	    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
    	  	      this.words[i] -= 0x4000000;
    	  	      if (i === this.length - 1) {
    	  	        this.words[i + 1] = 1;
    	  	      } else {
    	  	        this.words[i + 1]++;
    	  	      }
    	  	    }
    	  	    this.length = Math.max(this.length, i + 1);

    	  	    return this;
    	  	  };

    	  	  // Subtract plain number `num` from `this`
    	  	  BN.prototype.isubn = function isubn (num) {
    	  	    assert(typeof num === 'number');
    	  	    assert(num < 0x4000000);
    	  	    if (num < 0) return this.iaddn(-num);

    	  	    if (this.negative !== 0) {
    	  	      this.negative = 0;
    	  	      this.iaddn(num);
    	  	      this.negative = 1;
    	  	      return this;
    	  	    }

    	  	    this.words[0] -= num;

    	  	    if (this.length === 1 && this.words[0] < 0) {
    	  	      this.words[0] = -this.words[0];
    	  	      this.negative = 1;
    	  	    } else {
    	  	      // Carry
    	  	      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
    	  	        this.words[i] += 0x4000000;
    	  	        this.words[i + 1] -= 1;
    	  	      }
    	  	    }

    	  	    return this.strip();
    	  	  };

    	  	  BN.prototype.addn = function addn (num) {
    	  	    return this.clone().iaddn(num);
    	  	  };

    	  	  BN.prototype.subn = function subn (num) {
    	  	    return this.clone().isubn(num);
    	  	  };

    	  	  BN.prototype.iabs = function iabs () {
    	  	    this.negative = 0;

    	  	    return this;
    	  	  };

    	  	  BN.prototype.abs = function abs () {
    	  	    return this.clone().iabs();
    	  	  };

    	  	  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    	  	    var len = num.length + shift;
    	  	    var i;

    	  	    this._expand(len);

    	  	    var w;
    	  	    var carry = 0;
    	  	    for (i = 0; i < num.length; i++) {
    	  	      w = (this.words[i + shift] | 0) + carry;
    	  	      var right = (num.words[i] | 0) * mul;
    	  	      w -= right & 0x3ffffff;
    	  	      carry = (w >> 26) - ((right / 0x4000000) | 0);
    	  	      this.words[i + shift] = w & 0x3ffffff;
    	  	    }
    	  	    for (; i < this.length - shift; i++) {
    	  	      w = (this.words[i + shift] | 0) + carry;
    	  	      carry = w >> 26;
    	  	      this.words[i + shift] = w & 0x3ffffff;
    	  	    }

    	  	    if (carry === 0) return this.strip();

    	  	    // Subtraction overflow
    	  	    assert(carry === -1);
    	  	    carry = 0;
    	  	    for (i = 0; i < this.length; i++) {
    	  	      w = -(this.words[i] | 0) + carry;
    	  	      carry = w >> 26;
    	  	      this.words[i] = w & 0x3ffffff;
    	  	    }
    	  	    this.negative = 1;

    	  	    return this.strip();
    	  	  };

    	  	  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    	  	    var shift = this.length - num.length;

    	  	    var a = this.clone();
    	  	    var b = num;

    	  	    // Normalize
    	  	    var bhi = b.words[b.length - 1] | 0;
    	  	    var bhiBits = this._countBits(bhi);
    	  	    shift = 26 - bhiBits;
    	  	    if (shift !== 0) {
    	  	      b = b.ushln(shift);
    	  	      a.iushln(shift);
    	  	      bhi = b.words[b.length - 1] | 0;
    	  	    }

    	  	    // Initialize quotient
    	  	    var m = a.length - b.length;
    	  	    var q;

    	  	    if (mode !== 'mod') {
    	  	      q = new BN(null);
    	  	      q.length = m + 1;
    	  	      q.words = new Array(q.length);
    	  	      for (var i = 0; i < q.length; i++) {
    	  	        q.words[i] = 0;
    	  	      }
    	  	    }

    	  	    var diff = a.clone()._ishlnsubmul(b, 1, m);
    	  	    if (diff.negative === 0) {
    	  	      a = diff;
    	  	      if (q) {
    	  	        q.words[m] = 1;
    	  	      }
    	  	    }

    	  	    for (var j = m - 1; j >= 0; j--) {
    	  	      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
    	  	        (a.words[b.length + j - 1] | 0);

    	  	      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
    	  	      // (0x7ffffff)
    	  	      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

    	  	      a._ishlnsubmul(b, qj, j);
    	  	      while (a.negative !== 0) {
    	  	        qj--;
    	  	        a.negative = 0;
    	  	        a._ishlnsubmul(b, 1, j);
    	  	        if (!a.isZero()) {
    	  	          a.negative ^= 1;
    	  	        }
    	  	      }
    	  	      if (q) {
    	  	        q.words[j] = qj;
    	  	      }
    	  	    }
    	  	    if (q) {
    	  	      q.strip();
    	  	    }
    	  	    a.strip();

    	  	    // Denormalize
    	  	    if (mode !== 'div' && shift !== 0) {
    	  	      a.iushrn(shift);
    	  	    }

    	  	    return {
    	  	      div: q || null,
    	  	      mod: a
    	  	    };
    	  	  };

    	  	  // NOTE: 1) `mode` can be set to `mod` to request mod only,
    	  	  //       to `div` to request div only, or be absent to
    	  	  //       request both div & mod
    	  	  //       2) `positive` is true if unsigned mod is requested
    	  	  BN.prototype.divmod = function divmod (num, mode, positive) {
    	  	    assert(!num.isZero());

    	  	    if (this.isZero()) {
    	  	      return {
    	  	        div: new BN(0),
    	  	        mod: new BN(0)
    	  	      };
    	  	    }

    	  	    var div, mod, res;
    	  	    if (this.negative !== 0 && num.negative === 0) {
    	  	      res = this.neg().divmod(num, mode);

    	  	      if (mode !== 'mod') {
    	  	        div = res.div.neg();
    	  	      }

    	  	      if (mode !== 'div') {
    	  	        mod = res.mod.neg();
    	  	        if (positive && mod.negative !== 0) {
    	  	          mod.iadd(num);
    	  	        }
    	  	      }

    	  	      return {
    	  	        div: div,
    	  	        mod: mod
    	  	      };
    	  	    }

    	  	    if (this.negative === 0 && num.negative !== 0) {
    	  	      res = this.divmod(num.neg(), mode);

    	  	      if (mode !== 'mod') {
    	  	        div = res.div.neg();
    	  	      }

    	  	      return {
    	  	        div: div,
    	  	        mod: res.mod
    	  	      };
    	  	    }

    	  	    if ((this.negative & num.negative) !== 0) {
    	  	      res = this.neg().divmod(num.neg(), mode);

    	  	      if (mode !== 'div') {
    	  	        mod = res.mod.neg();
    	  	        if (positive && mod.negative !== 0) {
    	  	          mod.isub(num);
    	  	        }
    	  	      }

    	  	      return {
    	  	        div: res.div,
    	  	        mod: mod
    	  	      };
    	  	    }

    	  	    // Both numbers are positive at this point

    	  	    // Strip both numbers to approximate shift value
    	  	    if (num.length > this.length || this.cmp(num) < 0) {
    	  	      return {
    	  	        div: new BN(0),
    	  	        mod: this
    	  	      };
    	  	    }

    	  	    // Very short reduction
    	  	    if (num.length === 1) {
    	  	      if (mode === 'div') {
    	  	        return {
    	  	          div: this.divn(num.words[0]),
    	  	          mod: null
    	  	        };
    	  	      }

    	  	      if (mode === 'mod') {
    	  	        return {
    	  	          div: null,
    	  	          mod: new BN(this.modn(num.words[0]))
    	  	        };
    	  	      }

    	  	      return {
    	  	        div: this.divn(num.words[0]),
    	  	        mod: new BN(this.modn(num.words[0]))
    	  	      };
    	  	    }

    	  	    return this._wordDiv(num, mode);
    	  	  };

    	  	  // Find `this` / `num`
    	  	  BN.prototype.div = function div (num) {
    	  	    return this.divmod(num, 'div', false).div;
    	  	  };

    	  	  // Find `this` % `num`
    	  	  BN.prototype.mod = function mod (num) {
    	  	    return this.divmod(num, 'mod', false).mod;
    	  	  };

    	  	  BN.prototype.umod = function umod (num) {
    	  	    return this.divmod(num, 'mod', true).mod;
    	  	  };

    	  	  // Find Round(`this` / `num`)
    	  	  BN.prototype.divRound = function divRound (num) {
    	  	    var dm = this.divmod(num);

    	  	    // Fast case - exact division
    	  	    if (dm.mod.isZero()) return dm.div;

    	  	    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    	  	    var half = num.ushrn(1);
    	  	    var r2 = num.andln(1);
    	  	    var cmp = mod.cmp(half);

    	  	    // Round down
    	  	    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    	  	    // Round up
    	  	    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    	  	  };

    	  	  BN.prototype.modn = function modn (num) {
    	  	    assert(num <= 0x3ffffff);
    	  	    var p = (1 << 26) % num;

    	  	    var acc = 0;
    	  	    for (var i = this.length - 1; i >= 0; i--) {
    	  	      acc = (p * acc + (this.words[i] | 0)) % num;
    	  	    }

    	  	    return acc;
    	  	  };

    	  	  // In-place division by number
    	  	  BN.prototype.idivn = function idivn (num) {
    	  	    assert(num <= 0x3ffffff);

    	  	    var carry = 0;
    	  	    for (var i = this.length - 1; i >= 0; i--) {
    	  	      var w = (this.words[i] | 0) + carry * 0x4000000;
    	  	      this.words[i] = (w / num) | 0;
    	  	      carry = w % num;
    	  	    }

    	  	    return this.strip();
    	  	  };

    	  	  BN.prototype.divn = function divn (num) {
    	  	    return this.clone().idivn(num);
    	  	  };

    	  	  BN.prototype.egcd = function egcd (p) {
    	  	    assert(p.negative === 0);
    	  	    assert(!p.isZero());

    	  	    var x = this;
    	  	    var y = p.clone();

    	  	    if (x.negative !== 0) {
    	  	      x = x.umod(p);
    	  	    } else {
    	  	      x = x.clone();
    	  	    }

    	  	    // A * x + B * y = x
    	  	    var A = new BN(1);
    	  	    var B = new BN(0);

    	  	    // C * x + D * y = y
    	  	    var C = new BN(0);
    	  	    var D = new BN(1);

    	  	    var g = 0;

    	  	    while (x.isEven() && y.isEven()) {
    	  	      x.iushrn(1);
    	  	      y.iushrn(1);
    	  	      ++g;
    	  	    }

    	  	    var yp = y.clone();
    	  	    var xp = x.clone();

    	  	    while (!x.isZero()) {
    	  	      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
    	  	      if (i > 0) {
    	  	        x.iushrn(i);
    	  	        while (i-- > 0) {
    	  	          if (A.isOdd() || B.isOdd()) {
    	  	            A.iadd(yp);
    	  	            B.isub(xp);
    	  	          }

    	  	          A.iushrn(1);
    	  	          B.iushrn(1);
    	  	        }
    	  	      }

    	  	      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
    	  	      if (j > 0) {
    	  	        y.iushrn(j);
    	  	        while (j-- > 0) {
    	  	          if (C.isOdd() || D.isOdd()) {
    	  	            C.iadd(yp);
    	  	            D.isub(xp);
    	  	          }

    	  	          C.iushrn(1);
    	  	          D.iushrn(1);
    	  	        }
    	  	      }

    	  	      if (x.cmp(y) >= 0) {
    	  	        x.isub(y);
    	  	        A.isub(C);
    	  	        B.isub(D);
    	  	      } else {
    	  	        y.isub(x);
    	  	        C.isub(A);
    	  	        D.isub(B);
    	  	      }
    	  	    }

    	  	    return {
    	  	      a: C,
    	  	      b: D,
    	  	      gcd: y.iushln(g)
    	  	    };
    	  	  };

    	  	  // This is reduced incarnation of the binary EEA
    	  	  // above, designated to invert members of the
    	  	  // _prime_ fields F(p) at a maximal speed
    	  	  BN.prototype._invmp = function _invmp (p) {
    	  	    assert(p.negative === 0);
    	  	    assert(!p.isZero());

    	  	    var a = this;
    	  	    var b = p.clone();

    	  	    if (a.negative !== 0) {
    	  	      a = a.umod(p);
    	  	    } else {
    	  	      a = a.clone();
    	  	    }

    	  	    var x1 = new BN(1);
    	  	    var x2 = new BN(0);

    	  	    var delta = b.clone();

    	  	    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
    	  	      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
    	  	      if (i > 0) {
    	  	        a.iushrn(i);
    	  	        while (i-- > 0) {
    	  	          if (x1.isOdd()) {
    	  	            x1.iadd(delta);
    	  	          }

    	  	          x1.iushrn(1);
    	  	        }
    	  	      }

    	  	      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
    	  	      if (j > 0) {
    	  	        b.iushrn(j);
    	  	        while (j-- > 0) {
    	  	          if (x2.isOdd()) {
    	  	            x2.iadd(delta);
    	  	          }

    	  	          x2.iushrn(1);
    	  	        }
    	  	      }

    	  	      if (a.cmp(b) >= 0) {
    	  	        a.isub(b);
    	  	        x1.isub(x2);
    	  	      } else {
    	  	        b.isub(a);
    	  	        x2.isub(x1);
    	  	      }
    	  	    }

    	  	    var res;
    	  	    if (a.cmpn(1) === 0) {
    	  	      res = x1;
    	  	    } else {
    	  	      res = x2;
    	  	    }

    	  	    if (res.cmpn(0) < 0) {
    	  	      res.iadd(p);
    	  	    }

    	  	    return res;
    	  	  };

    	  	  BN.prototype.gcd = function gcd (num) {
    	  	    if (this.isZero()) return num.abs();
    	  	    if (num.isZero()) return this.abs();

    	  	    var a = this.clone();
    	  	    var b = num.clone();
    	  	    a.negative = 0;
    	  	    b.negative = 0;

    	  	    // Remove common factor of two
    	  	    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
    	  	      a.iushrn(1);
    	  	      b.iushrn(1);
    	  	    }

    	  	    do {
    	  	      while (a.isEven()) {
    	  	        a.iushrn(1);
    	  	      }
    	  	      while (b.isEven()) {
    	  	        b.iushrn(1);
    	  	      }

    	  	      var r = a.cmp(b);
    	  	      if (r < 0) {
    	  	        // Swap `a` and `b` to make `a` always bigger than `b`
    	  	        var t = a;
    	  	        a = b;
    	  	        b = t;
    	  	      } else if (r === 0 || b.cmpn(1) === 0) {
    	  	        break;
    	  	      }

    	  	      a.isub(b);
    	  	    } while (true);

    	  	    return b.iushln(shift);
    	  	  };

    	  	  // Invert number in the field F(num)
    	  	  BN.prototype.invm = function invm (num) {
    	  	    return this.egcd(num).a.umod(num);
    	  	  };

    	  	  BN.prototype.isEven = function isEven () {
    	  	    return (this.words[0] & 1) === 0;
    	  	  };

    	  	  BN.prototype.isOdd = function isOdd () {
    	  	    return (this.words[0] & 1) === 1;
    	  	  };

    	  	  // And first word and num
    	  	  BN.prototype.andln = function andln (num) {
    	  	    return this.words[0] & num;
    	  	  };

    	  	  // Increment at the bit position in-line
    	  	  BN.prototype.bincn = function bincn (bit) {
    	  	    assert(typeof bit === 'number');
    	  	    var r = bit % 26;
    	  	    var s = (bit - r) / 26;
    	  	    var q = 1 << r;

    	  	    // Fast case: bit is much higher than all existing words
    	  	    if (this.length <= s) {
    	  	      this._expand(s + 1);
    	  	      this.words[s] |= q;
    	  	      return this;
    	  	    }

    	  	    // Add bit and propagate, if needed
    	  	    var carry = q;
    	  	    for (var i = s; carry !== 0 && i < this.length; i++) {
    	  	      var w = this.words[i] | 0;
    	  	      w += carry;
    	  	      carry = w >>> 26;
    	  	      w &= 0x3ffffff;
    	  	      this.words[i] = w;
    	  	    }
    	  	    if (carry !== 0) {
    	  	      this.words[i] = carry;
    	  	      this.length++;
    	  	    }
    	  	    return this;
    	  	  };

    	  	  BN.prototype.isZero = function isZero () {
    	  	    return this.length === 1 && this.words[0] === 0;
    	  	  };

    	  	  BN.prototype.cmpn = function cmpn (num) {
    	  	    var negative = num < 0;

    	  	    if (this.negative !== 0 && !negative) return -1;
    	  	    if (this.negative === 0 && negative) return 1;

    	  	    this.strip();

    	  	    var res;
    	  	    if (this.length > 1) {
    	  	      res = 1;
    	  	    } else {
    	  	      if (negative) {
    	  	        num = -num;
    	  	      }

    	  	      assert(num <= 0x3ffffff, 'Number is too big');

    	  	      var w = this.words[0] | 0;
    	  	      res = w === num ? 0 : w < num ? -1 : 1;
    	  	    }
    	  	    if (this.negative !== 0) return -res | 0;
    	  	    return res;
    	  	  };

    	  	  // Compare two numbers and return:
    	  	  // 1 - if `this` > `num`
    	  	  // 0 - if `this` == `num`
    	  	  // -1 - if `this` < `num`
    	  	  BN.prototype.cmp = function cmp (num) {
    	  	    if (this.negative !== 0 && num.negative === 0) return -1;
    	  	    if (this.negative === 0 && num.negative !== 0) return 1;

    	  	    var res = this.ucmp(num);
    	  	    if (this.negative !== 0) return -res | 0;
    	  	    return res;
    	  	  };

    	  	  // Unsigned comparison
    	  	  BN.prototype.ucmp = function ucmp (num) {
    	  	    // At this point both numbers have the same sign
    	  	    if (this.length > num.length) return 1;
    	  	    if (this.length < num.length) return -1;

    	  	    var res = 0;
    	  	    for (var i = this.length - 1; i >= 0; i--) {
    	  	      var a = this.words[i] | 0;
    	  	      var b = num.words[i] | 0;

    	  	      if (a === b) continue;
    	  	      if (a < b) {
    	  	        res = -1;
    	  	      } else if (a > b) {
    	  	        res = 1;
    	  	      }
    	  	      break;
    	  	    }
    	  	    return res;
    	  	  };

    	  	  BN.prototype.gtn = function gtn (num) {
    	  	    return this.cmpn(num) === 1;
    	  	  };

    	  	  BN.prototype.gt = function gt (num) {
    	  	    return this.cmp(num) === 1;
    	  	  };

    	  	  BN.prototype.gten = function gten (num) {
    	  	    return this.cmpn(num) >= 0;
    	  	  };

    	  	  BN.prototype.gte = function gte (num) {
    	  	    return this.cmp(num) >= 0;
    	  	  };

    	  	  BN.prototype.ltn = function ltn (num) {
    	  	    return this.cmpn(num) === -1;
    	  	  };

    	  	  BN.prototype.lt = function lt (num) {
    	  	    return this.cmp(num) === -1;
    	  	  };

    	  	  BN.prototype.lten = function lten (num) {
    	  	    return this.cmpn(num) <= 0;
    	  	  };

    	  	  BN.prototype.lte = function lte (num) {
    	  	    return this.cmp(num) <= 0;
    	  	  };

    	  	  BN.prototype.eqn = function eqn (num) {
    	  	    return this.cmpn(num) === 0;
    	  	  };

    	  	  BN.prototype.eq = function eq (num) {
    	  	    return this.cmp(num) === 0;
    	  	  };

    	  	  //
    	  	  // A reduce context, could be using montgomery or something better, depending
    	  	  // on the `m` itself.
    	  	  //
    	  	  BN.red = function red (num) {
    	  	    return new Red(num);
    	  	  };

    	  	  BN.prototype.toRed = function toRed (ctx) {
    	  	    assert(!this.red, 'Already a number in reduction context');
    	  	    assert(this.negative === 0, 'red works only with positives');
    	  	    return ctx.convertTo(this)._forceRed(ctx);
    	  	  };

    	  	  BN.prototype.fromRed = function fromRed () {
    	  	    assert(this.red, 'fromRed works only with numbers in reduction context');
    	  	    return this.red.convertFrom(this);
    	  	  };

    	  	  BN.prototype._forceRed = function _forceRed (ctx) {
    	  	    this.red = ctx;
    	  	    return this;
    	  	  };

    	  	  BN.prototype.forceRed = function forceRed (ctx) {
    	  	    assert(!this.red, 'Already a number in reduction context');
    	  	    return this._forceRed(ctx);
    	  	  };

    	  	  BN.prototype.redAdd = function redAdd (num) {
    	  	    assert(this.red, 'redAdd works only with red numbers');
    	  	    return this.red.add(this, num);
    	  	  };

    	  	  BN.prototype.redIAdd = function redIAdd (num) {
    	  	    assert(this.red, 'redIAdd works only with red numbers');
    	  	    return this.red.iadd(this, num);
    	  	  };

    	  	  BN.prototype.redSub = function redSub (num) {
    	  	    assert(this.red, 'redSub works only with red numbers');
    	  	    return this.red.sub(this, num);
    	  	  };

    	  	  BN.prototype.redISub = function redISub (num) {
    	  	    assert(this.red, 'redISub works only with red numbers');
    	  	    return this.red.isub(this, num);
    	  	  };

    	  	  BN.prototype.redShl = function redShl (num) {
    	  	    assert(this.red, 'redShl works only with red numbers');
    	  	    return this.red.shl(this, num);
    	  	  };

    	  	  BN.prototype.redMul = function redMul (num) {
    	  	    assert(this.red, 'redMul works only with red numbers');
    	  	    this.red._verify2(this, num);
    	  	    return this.red.mul(this, num);
    	  	  };

    	  	  BN.prototype.redIMul = function redIMul (num) {
    	  	    assert(this.red, 'redMul works only with red numbers');
    	  	    this.red._verify2(this, num);
    	  	    return this.red.imul(this, num);
    	  	  };

    	  	  BN.prototype.redSqr = function redSqr () {
    	  	    assert(this.red, 'redSqr works only with red numbers');
    	  	    this.red._verify1(this);
    	  	    return this.red.sqr(this);
    	  	  };

    	  	  BN.prototype.redISqr = function redISqr () {
    	  	    assert(this.red, 'redISqr works only with red numbers');
    	  	    this.red._verify1(this);
    	  	    return this.red.isqr(this);
    	  	  };

    	  	  // Square root over p
    	  	  BN.prototype.redSqrt = function redSqrt () {
    	  	    assert(this.red, 'redSqrt works only with red numbers');
    	  	    this.red._verify1(this);
    	  	    return this.red.sqrt(this);
    	  	  };

    	  	  BN.prototype.redInvm = function redInvm () {
    	  	    assert(this.red, 'redInvm works only with red numbers');
    	  	    this.red._verify1(this);
    	  	    return this.red.invm(this);
    	  	  };

    	  	  // Return negative clone of `this` % `red modulo`
    	  	  BN.prototype.redNeg = function redNeg () {
    	  	    assert(this.red, 'redNeg works only with red numbers');
    	  	    this.red._verify1(this);
    	  	    return this.red.neg(this);
    	  	  };

    	  	  BN.prototype.redPow = function redPow (num) {
    	  	    assert(this.red && !num.red, 'redPow(normalNum)');
    	  	    this.red._verify1(this);
    	  	    return this.red.pow(this, num);
    	  	  };

    	  	  // Prime numbers with efficient reduction
    	  	  var primes = {
    	  	    k256: null,
    	  	    p224: null,
    	  	    p192: null,
    	  	    p25519: null
    	  	  };

    	  	  // Pseudo-Mersenne prime
    	  	  function MPrime (name, p) {
    	  	    // P = 2 ^ N - K
    	  	    this.name = name;
    	  	    this.p = new BN(p, 16);
    	  	    this.n = this.p.bitLength();
    	  	    this.k = new BN(1).iushln(this.n).isub(this.p);

    	  	    this.tmp = this._tmp();
    	  	  }

    	  	  MPrime.prototype._tmp = function _tmp () {
    	  	    var tmp = new BN(null);
    	  	    tmp.words = new Array(Math.ceil(this.n / 13));
    	  	    return tmp;
    	  	  };

    	  	  MPrime.prototype.ireduce = function ireduce (num) {
    	  	    // Assumes that `num` is less than `P^2`
    	  	    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    	  	    var r = num;
    	  	    var rlen;

    	  	    do {
    	  	      this.split(r, this.tmp);
    	  	      r = this.imulK(r);
    	  	      r = r.iadd(this.tmp);
    	  	      rlen = r.bitLength();
    	  	    } while (rlen > this.n);

    	  	    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    	  	    if (cmp === 0) {
    	  	      r.words[0] = 0;
    	  	      r.length = 1;
    	  	    } else if (cmp > 0) {
    	  	      r.isub(this.p);
    	  	    } else {
    	  	      if (r.strip !== undefined) {
    	  	        // r is BN v4 instance
    	  	        r.strip();
    	  	      } else {
    	  	        // r is BN v5 instance
    	  	        r._strip();
    	  	      }
    	  	    }

    	  	    return r;
    	  	  };

    	  	  MPrime.prototype.split = function split (input, out) {
    	  	    input.iushrn(this.n, 0, out);
    	  	  };

    	  	  MPrime.prototype.imulK = function imulK (num) {
    	  	    return num.imul(this.k);
    	  	  };

    	  	  function K256 () {
    	  	    MPrime.call(
    	  	      this,
    	  	      'k256',
    	  	      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    	  	  }
    	  	  inherits(K256, MPrime);

    	  	  K256.prototype.split = function split (input, output) {
    	  	    // 256 = 9 * 26 + 22
    	  	    var mask = 0x3fffff;

    	  	    var outLen = Math.min(input.length, 9);
    	  	    for (var i = 0; i < outLen; i++) {
    	  	      output.words[i] = input.words[i];
    	  	    }
    	  	    output.length = outLen;

    	  	    if (input.length <= 9) {
    	  	      input.words[0] = 0;
    	  	      input.length = 1;
    	  	      return;
    	  	    }

    	  	    // Shift by 9 limbs
    	  	    var prev = input.words[9];
    	  	    output.words[output.length++] = prev & mask;

    	  	    for (i = 10; i < input.length; i++) {
    	  	      var next = input.words[i] | 0;
    	  	      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
    	  	      prev = next;
    	  	    }
    	  	    prev >>>= 22;
    	  	    input.words[i - 10] = prev;
    	  	    if (prev === 0 && input.length > 10) {
    	  	      input.length -= 10;
    	  	    } else {
    	  	      input.length -= 9;
    	  	    }
    	  	  };

    	  	  K256.prototype.imulK = function imulK (num) {
    	  	    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    	  	    num.words[num.length] = 0;
    	  	    num.words[num.length + 1] = 0;
    	  	    num.length += 2;

    	  	    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    	  	    var lo = 0;
    	  	    for (var i = 0; i < num.length; i++) {
    	  	      var w = num.words[i] | 0;
    	  	      lo += w * 0x3d1;
    	  	      num.words[i] = lo & 0x3ffffff;
    	  	      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    	  	    }

    	  	    // Fast length reduction
    	  	    if (num.words[num.length - 1] === 0) {
    	  	      num.length--;
    	  	      if (num.words[num.length - 1] === 0) {
    	  	        num.length--;
    	  	      }
    	  	    }
    	  	    return num;
    	  	  };

    	  	  function P224 () {
    	  	    MPrime.call(
    	  	      this,
    	  	      'p224',
    	  	      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    	  	  }
    	  	  inherits(P224, MPrime);

    	  	  function P192 () {
    	  	    MPrime.call(
    	  	      this,
    	  	      'p192',
    	  	      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    	  	  }
    	  	  inherits(P192, MPrime);

    	  	  function P25519 () {
    	  	    // 2 ^ 255 - 19
    	  	    MPrime.call(
    	  	      this,
    	  	      '25519',
    	  	      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    	  	  }
    	  	  inherits(P25519, MPrime);

    	  	  P25519.prototype.imulK = function imulK (num) {
    	  	    // K = 0x13
    	  	    var carry = 0;
    	  	    for (var i = 0; i < num.length; i++) {
    	  	      var hi = (num.words[i] | 0) * 0x13 + carry;
    	  	      var lo = hi & 0x3ffffff;
    	  	      hi >>>= 26;

    	  	      num.words[i] = lo;
    	  	      carry = hi;
    	  	    }
    	  	    if (carry !== 0) {
    	  	      num.words[num.length++] = carry;
    	  	    }
    	  	    return num;
    	  	  };

    	  	  // Exported mostly for testing purposes, use plain name instead
    	  	  BN._prime = function prime (name) {
    	  	    // Cached version of prime
    	  	    if (primes[name]) return primes[name];

    	  	    var prime;
    	  	    if (name === 'k256') {
    	  	      prime = new K256();
    	  	    } else if (name === 'p224') {
    	  	      prime = new P224();
    	  	    } else if (name === 'p192') {
    	  	      prime = new P192();
    	  	    } else if (name === 'p25519') {
    	  	      prime = new P25519();
    	  	    } else {
    	  	      throw new Error('Unknown prime ' + name);
    	  	    }
    	  	    primes[name] = prime;

    	  	    return prime;
    	  	  };

    	  	  //
    	  	  // Base reduction engine
    	  	  //
    	  	  function Red (m) {
    	  	    if (typeof m === 'string') {
    	  	      var prime = BN._prime(m);
    	  	      this.m = prime.p;
    	  	      this.prime = prime;
    	  	    } else {
    	  	      assert(m.gtn(1), 'modulus must be greater than 1');
    	  	      this.m = m;
    	  	      this.prime = null;
    	  	    }
    	  	  }

    	  	  Red.prototype._verify1 = function _verify1 (a) {
    	  	    assert(a.negative === 0, 'red works only with positives');
    	  	    assert(a.red, 'red works only with red numbers');
    	  	  };

    	  	  Red.prototype._verify2 = function _verify2 (a, b) {
    	  	    assert((a.negative | b.negative) === 0, 'red works only with positives');
    	  	    assert(a.red && a.red === b.red,
    	  	      'red works only with red numbers');
    	  	  };

    	  	  Red.prototype.imod = function imod (a) {
    	  	    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    	  	    return a.umod(this.m)._forceRed(this);
    	  	  };

    	  	  Red.prototype.neg = function neg (a) {
    	  	    if (a.isZero()) {
    	  	      return a.clone();
    	  	    }

    	  	    return this.m.sub(a)._forceRed(this);
    	  	  };

    	  	  Red.prototype.add = function add (a, b) {
    	  	    this._verify2(a, b);

    	  	    var res = a.add(b);
    	  	    if (res.cmp(this.m) >= 0) {
    	  	      res.isub(this.m);
    	  	    }
    	  	    return res._forceRed(this);
    	  	  };

    	  	  Red.prototype.iadd = function iadd (a, b) {
    	  	    this._verify2(a, b);

    	  	    var res = a.iadd(b);
    	  	    if (res.cmp(this.m) >= 0) {
    	  	      res.isub(this.m);
    	  	    }
    	  	    return res;
    	  	  };

    	  	  Red.prototype.sub = function sub (a, b) {
    	  	    this._verify2(a, b);

    	  	    var res = a.sub(b);
    	  	    if (res.cmpn(0) < 0) {
    	  	      res.iadd(this.m);
    	  	    }
    	  	    return res._forceRed(this);
    	  	  };

    	  	  Red.prototype.isub = function isub (a, b) {
    	  	    this._verify2(a, b);

    	  	    var res = a.isub(b);
    	  	    if (res.cmpn(0) < 0) {
    	  	      res.iadd(this.m);
    	  	    }
    	  	    return res;
    	  	  };

    	  	  Red.prototype.shl = function shl (a, num) {
    	  	    this._verify1(a);
    	  	    return this.imod(a.ushln(num));
    	  	  };

    	  	  Red.prototype.imul = function imul (a, b) {
    	  	    this._verify2(a, b);
    	  	    return this.imod(a.imul(b));
    	  	  };

    	  	  Red.prototype.mul = function mul (a, b) {
    	  	    this._verify2(a, b);
    	  	    return this.imod(a.mul(b));
    	  	  };

    	  	  Red.prototype.isqr = function isqr (a) {
    	  	    return this.imul(a, a.clone());
    	  	  };

    	  	  Red.prototype.sqr = function sqr (a) {
    	  	    return this.mul(a, a);
    	  	  };

    	  	  Red.prototype.sqrt = function sqrt (a) {
    	  	    if (a.isZero()) return a.clone();

    	  	    var mod3 = this.m.andln(3);
    	  	    assert(mod3 % 2 === 1);

    	  	    // Fast case
    	  	    if (mod3 === 3) {
    	  	      var pow = this.m.add(new BN(1)).iushrn(2);
    	  	      return this.pow(a, pow);
    	  	    }

    	  	    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    	  	    //
    	  	    // Find Q and S, that Q * 2 ^ S = (P - 1)
    	  	    var q = this.m.subn(1);
    	  	    var s = 0;
    	  	    while (!q.isZero() && q.andln(1) === 0) {
    	  	      s++;
    	  	      q.iushrn(1);
    	  	    }
    	  	    assert(!q.isZero());

    	  	    var one = new BN(1).toRed(this);
    	  	    var nOne = one.redNeg();

    	  	    // Find quadratic non-residue
    	  	    // NOTE: Max is such because of generalized Riemann hypothesis.
    	  	    var lpow = this.m.subn(1).iushrn(1);
    	  	    var z = this.m.bitLength();
    	  	    z = new BN(2 * z * z).toRed(this);

    	  	    while (this.pow(z, lpow).cmp(nOne) !== 0) {
    	  	      z.redIAdd(nOne);
    	  	    }

    	  	    var c = this.pow(z, q);
    	  	    var r = this.pow(a, q.addn(1).iushrn(1));
    	  	    var t = this.pow(a, q);
    	  	    var m = s;
    	  	    while (t.cmp(one) !== 0) {
    	  	      var tmp = t;
    	  	      for (var i = 0; tmp.cmp(one) !== 0; i++) {
    	  	        tmp = tmp.redSqr();
    	  	      }
    	  	      assert(i < m);
    	  	      var b = this.pow(c, new BN(1).iushln(m - i - 1));

    	  	      r = r.redMul(b);
    	  	      c = b.redSqr();
    	  	      t = t.redMul(c);
    	  	      m = i;
    	  	    }

    	  	    return r;
    	  	  };

    	  	  Red.prototype.invm = function invm (a) {
    	  	    var inv = a._invmp(this.m);
    	  	    if (inv.negative !== 0) {
    	  	      inv.negative = 0;
    	  	      return this.imod(inv).redNeg();
    	  	    } else {
    	  	      return this.imod(inv);
    	  	    }
    	  	  };

    	  	  Red.prototype.pow = function pow (a, num) {
    	  	    if (num.isZero()) return new BN(1).toRed(this);
    	  	    if (num.cmpn(1) === 0) return a.clone();

    	  	    var windowSize = 4;
    	  	    var wnd = new Array(1 << windowSize);
    	  	    wnd[0] = new BN(1).toRed(this);
    	  	    wnd[1] = a;
    	  	    for (var i = 2; i < wnd.length; i++) {
    	  	      wnd[i] = this.mul(wnd[i - 1], a);
    	  	    }

    	  	    var res = wnd[0];
    	  	    var current = 0;
    	  	    var currentLen = 0;
    	  	    var start = num.bitLength() % 26;
    	  	    if (start === 0) {
    	  	      start = 26;
    	  	    }

    	  	    for (i = num.length - 1; i >= 0; i--) {
    	  	      var word = num.words[i];
    	  	      for (var j = start - 1; j >= 0; j--) {
    	  	        var bit = (word >> j) & 1;
    	  	        if (res !== wnd[0]) {
    	  	          res = this.sqr(res);
    	  	        }

    	  	        if (bit === 0 && current === 0) {
    	  	          currentLen = 0;
    	  	          continue;
    	  	        }

    	  	        current <<= 1;
    	  	        current |= bit;
    	  	        currentLen++;
    	  	        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

    	  	        res = this.mul(res, wnd[current]);
    	  	        currentLen = 0;
    	  	        current = 0;
    	  	      }
    	  	      start = 26;
    	  	    }

    	  	    return res;
    	  	  };

    	  	  Red.prototype.convertTo = function convertTo (num) {
    	  	    var r = num.umod(this.m);

    	  	    return r === num ? r.clone() : r;
    	  	  };

    	  	  Red.prototype.convertFrom = function convertFrom (num) {
    	  	    var res = num.clone();
    	  	    res.red = null;
    	  	    return res;
    	  	  };

    	  	  //
    	  	  // Montgomery method engine
    	  	  //

    	  	  BN.mont = function mont (num) {
    	  	    return new Mont(num);
    	  	  };

    	  	  function Mont (m) {
    	  	    Red.call(this, m);

    	  	    this.shift = this.m.bitLength();
    	  	    if (this.shift % 26 !== 0) {
    	  	      this.shift += 26 - (this.shift % 26);
    	  	    }

    	  	    this.r = new BN(1).iushln(this.shift);
    	  	    this.r2 = this.imod(this.r.sqr());
    	  	    this.rinv = this.r._invmp(this.m);

    	  	    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    	  	    this.minv = this.minv.umod(this.r);
    	  	    this.minv = this.r.sub(this.minv);
    	  	  }
    	  	  inherits(Mont, Red);

    	  	  Mont.prototype.convertTo = function convertTo (num) {
    	  	    return this.imod(num.ushln(this.shift));
    	  	  };

    	  	  Mont.prototype.convertFrom = function convertFrom (num) {
    	  	    var r = this.imod(num.mul(this.rinv));
    	  	    r.red = null;
    	  	    return r;
    	  	  };

    	  	  Mont.prototype.imul = function imul (a, b) {
    	  	    if (a.isZero() || b.isZero()) {
    	  	      a.words[0] = 0;
    	  	      a.length = 1;
    	  	      return a;
    	  	    }

    	  	    var t = a.imul(b);
    	  	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    	  	    var u = t.isub(c).iushrn(this.shift);
    	  	    var res = u;

    	  	    if (u.cmp(this.m) >= 0) {
    	  	      res = u.isub(this.m);
    	  	    } else if (u.cmpn(0) < 0) {
    	  	      res = u.iadd(this.m);
    	  	    }

    	  	    return res._forceRed(this);
    	  	  };

    	  	  Mont.prototype.mul = function mul (a, b) {
    	  	    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    	  	    var t = a.mul(b);
    	  	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    	  	    var u = t.isub(c).iushrn(this.shift);
    	  	    var res = u;
    	  	    if (u.cmp(this.m) >= 0) {
    	  	      res = u.isub(this.m);
    	  	    } else if (u.cmpn(0) < 0) {
    	  	      res = u.iadd(this.m);
    	  	    }

    	  	    return res._forceRed(this);
    	  	  };

    	  	  Mont.prototype.invm = function invm (a) {
    	  	    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    	  	    var res = this.imod(a._invmp(this.m).mul(this.r2));
    	  	    return res._forceRed(this);
    	  	  };
    	  	})(module, commonjsGlobal$1); 
    	  } (bn));

    	  var bnExports = bn.exports;
    	  var BN = /*@__PURE__*/getDefaultExportFromCjs(bnExports);

    	  var long = Long;

    	  /**
    	   * wasm optimizations, to do native i64 multiplication and divide
    	   */
    	  var wasm = null;

    	  try {
    	    wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
    	      0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11
    	    ])), {}).exports;
    	  } catch (e) {
    	    // no wasm support :(
    	  }

    	  /**
    	   * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
    	   *  See the from* functions below for more convenient ways of constructing Longs.
    	   * @exports Long
    	   * @class A Long class for representing a 64 bit two's-complement integer value.
    	   * @param {number} low The low (signed) 32 bits of the long
    	   * @param {number} high The high (signed) 32 bits of the long
    	   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
    	   * @constructor
    	   */
    	  function Long(low, high, unsigned) {

    	      /**
    	       * The low 32 bits as a signed value.
    	       * @type {number}
    	       */
    	      this.low = low | 0;

    	      /**
    	       * The high 32 bits as a signed value.
    	       * @type {number}
    	       */
    	      this.high = high | 0;

    	      /**
    	       * Whether unsigned or not.
    	       * @type {boolean}
    	       */
    	      this.unsigned = !!unsigned;
    	  }

    	  // The internal representation of a long is the two given signed, 32-bit values.
    	  // We use 32-bit pieces because these are the size of integers on which
    	  // Javascript performs bit-operations.  For operations like addition and
    	  // multiplication, we split each number into 16 bit pieces, which can easily be
    	  // multiplied within Javascript's floating-point representation without overflow
    	  // or change in sign.
    	  //
    	  // In the algorithms below, we frequently reduce the negative case to the
    	  // positive case by negating the input(s) and then post-processing the result.
    	  // Note that we must ALWAYS check specially whether those values are MIN_VALUE
    	  // (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
    	  // a positive number, it overflows back into a negative).  Not handling this
    	  // case would often result in infinite recursion.
    	  //
    	  // Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
    	  // methods on which they depend.

    	  /**
    	   * An indicator used to reliably determine if an object is a Long or not.
    	   * @type {boolean}
    	   * @const
    	   * @private
    	   */
    	  Long.prototype.__isLong__;

    	  Object.defineProperty(Long.prototype, "__isLong__", { value: true });

    	  /**
    	   * @function
    	   * @param {*} obj Object
    	   * @returns {boolean}
    	   * @inner
    	   */
    	  function isLong$1(obj) {
    	      return (obj && obj["__isLong__"]) === true;
    	  }

    	  /**
    	   * Tests if the specified object is a Long.
    	   * @function
    	   * @param {*} obj Object
    	   * @returns {boolean}
    	   */
    	  Long.isLong = isLong$1;

    	  /**
    	   * A cache of the Long representations of small integer values.
    	   * @type {!Object}
    	   * @inner
    	   */
    	  var INT_CACHE = {};

    	  /**
    	   * A cache of the Long representations of small unsigned integer values.
    	   * @type {!Object}
    	   * @inner
    	   */
    	  var UINT_CACHE = {};

    	  /**
    	   * @param {number} value
    	   * @param {boolean=} unsigned
    	   * @returns {!Long}
    	   * @inner
    	   */
    	  function fromInt(value, unsigned) {
    	      var obj, cachedObj, cache;
    	      if (unsigned) {
    	          value >>>= 0;
    	          if (cache = (0 <= value && value < 256)) {
    	              cachedObj = UINT_CACHE[value];
    	              if (cachedObj)
    	                  return cachedObj;
    	          }
    	          obj = fromBits(value, (value | 0) < 0 ? -1 : 0, true);
    	          if (cache)
    	              UINT_CACHE[value] = obj;
    	          return obj;
    	      } else {
    	          value |= 0;
    	          if (cache = (-128 <= value && value < 128)) {
    	              cachedObj = INT_CACHE[value];
    	              if (cachedObj)
    	                  return cachedObj;
    	          }
    	          obj = fromBits(value, value < 0 ? -1 : 0, false);
    	          if (cache)
    	              INT_CACHE[value] = obj;
    	          return obj;
    	      }
    	  }

    	  /**
    	   * Returns a Long representing the given 32 bit integer value.
    	   * @function
    	   * @param {number} value The 32 bit integer in question
    	   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
    	   * @returns {!Long} The corresponding Long value
    	   */
    	  Long.fromInt = fromInt;

    	  /**
    	   * @param {number} value
    	   * @param {boolean=} unsigned
    	   * @returns {!Long}
    	   * @inner
    	   */
    	  function fromNumber(value, unsigned) {
    	      if (isNaN(value))
    	          return unsigned ? UZERO : ZERO;
    	      if (unsigned) {
    	          if (value < 0)
    	              return UZERO;
    	          if (value >= TWO_PWR_64_DBL)
    	              return MAX_UNSIGNED_VALUE;
    	      } else {
    	          if (value <= -TWO_PWR_63_DBL)
    	              return MIN_VALUE;
    	          if (value + 1 >= TWO_PWR_63_DBL)
    	              return MAX_VALUE;
    	      }
    	      if (value < 0)
    	          return fromNumber(-value, unsigned).neg();
    	      return fromBits((value % TWO_PWR_32_DBL) | 0, (value / TWO_PWR_32_DBL) | 0, unsigned);
    	  }

    	  /**
    	   * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
    	   * @function
    	   * @param {number} value The number in question
    	   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
    	   * @returns {!Long} The corresponding Long value
    	   */
    	  Long.fromNumber = fromNumber;

    	  /**
    	   * @param {number} lowBits
    	   * @param {number} highBits
    	   * @param {boolean=} unsigned
    	   * @returns {!Long}
    	   * @inner
    	   */
    	  function fromBits(lowBits, highBits, unsigned) {
    	      return new Long(lowBits, highBits, unsigned);
    	  }

    	  /**
    	   * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
    	   *  assumed to use 32 bits.
    	   * @function
    	   * @param {number} lowBits The low 32 bits
    	   * @param {number} highBits The high 32 bits
    	   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
    	   * @returns {!Long} The corresponding Long value
    	   */
    	  Long.fromBits = fromBits;

    	  /**
    	   * @function
    	   * @param {number} base
    	   * @param {number} exponent
    	   * @returns {number}
    	   * @inner
    	   */
    	  var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)

    	  /**
    	   * @param {string} str
    	   * @param {(boolean|number)=} unsigned
    	   * @param {number=} radix
    	   * @returns {!Long}
    	   * @inner
    	   */
    	  function fromString(str, unsigned, radix) {
    	      if (str.length === 0)
    	          throw Error('empty string');
    	      if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity")
    	          return ZERO;
    	      if (typeof unsigned === 'number') {
    	          // For goog.math.long compatibility
    	          radix = unsigned,
    	          unsigned = false;
    	      } else {
    	          unsigned = !! unsigned;
    	      }
    	      radix = radix || 10;
    	      if (radix < 2 || 36 < radix)
    	          throw RangeError('radix');

    	      var p;
    	      if ((p = str.indexOf('-')) > 0)
    	          throw Error('interior hyphen');
    	      else if (p === 0) {
    	          return fromString(str.substring(1), unsigned, radix).neg();
    	      }

    	      // Do several (8) digits each time through the loop, so as to
    	      // minimize the calls to the very expensive emulated div.
    	      var radixToPower = fromNumber(pow_dbl(radix, 8));

    	      var result = ZERO;
    	      for (var i = 0; i < str.length; i += 8) {
    	          var size = Math.min(8, str.length - i),
    	              value = parseInt(str.substring(i, i + size), radix);
    	          if (size < 8) {
    	              var power = fromNumber(pow_dbl(radix, size));
    	              result = result.mul(power).add(fromNumber(value));
    	          } else {
    	              result = result.mul(radixToPower);
    	              result = result.add(fromNumber(value));
    	          }
    	      }
    	      result.unsigned = unsigned;
    	      return result;
    	  }

    	  /**
    	   * Returns a Long representation of the given string, written using the specified radix.
    	   * @function
    	   * @param {string} str The textual representation of the Long
    	   * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
    	   * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
    	   * @returns {!Long} The corresponding Long value
    	   */
    	  Long.fromString = fromString;

    	  /**
    	   * @function
    	   * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
    	   * @param {boolean=} unsigned
    	   * @returns {!Long}
    	   * @inner
    	   */
    	  function fromValue(val, unsigned) {
    	      if (typeof val === 'number')
    	          return fromNumber(val, unsigned);
    	      if (typeof val === 'string')
    	          return fromString(val, unsigned);
    	      // Throws for non-objects, converts non-instanceof Long:
    	      return fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
    	  }

    	  /**
    	   * Converts the specified value to a Long using the appropriate from* function for its type.
    	   * @function
    	   * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
    	   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
    	   * @returns {!Long}
    	   */
    	  Long.fromValue = fromValue;

    	  // NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
    	  // no runtime penalty for these.

    	  /**
    	   * @type {number}
    	   * @const
    	   * @inner
    	   */
    	  var TWO_PWR_16_DBL = 1 << 16;

    	  /**
    	   * @type {number}
    	   * @const
    	   * @inner
    	   */
    	  var TWO_PWR_24_DBL = 1 << 24;

    	  /**
    	   * @type {number}
    	   * @const
    	   * @inner
    	   */
    	  var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;

    	  /**
    	   * @type {number}
    	   * @const
    	   * @inner
    	   */
    	  var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;

    	  /**
    	   * @type {number}
    	   * @const
    	   * @inner
    	   */
    	  var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;

    	  /**
    	   * @type {!Long}
    	   * @const
    	   * @inner
    	   */
    	  var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);

    	  /**
    	   * @type {!Long}
    	   * @inner
    	   */
    	  var ZERO = fromInt(0);

    	  /**
    	   * Signed zero.
    	   * @type {!Long}
    	   */
    	  Long.ZERO = ZERO;

    	  /**
    	   * @type {!Long}
    	   * @inner
    	   */
    	  var UZERO = fromInt(0, true);

    	  /**
    	   * Unsigned zero.
    	   * @type {!Long}
    	   */
    	  Long.UZERO = UZERO;

    	  /**
    	   * @type {!Long}
    	   * @inner
    	   */
    	  var ONE = fromInt(1);

    	  /**
    	   * Signed one.
    	   * @type {!Long}
    	   */
    	  Long.ONE = ONE;

    	  /**
    	   * @type {!Long}
    	   * @inner
    	   */
    	  var UONE = fromInt(1, true);

    	  /**
    	   * Unsigned one.
    	   * @type {!Long}
    	   */
    	  Long.UONE = UONE;

    	  /**
    	   * @type {!Long}
    	   * @inner
    	   */
    	  var NEG_ONE = fromInt(-1);

    	  /**
    	   * Signed negative one.
    	   * @type {!Long}
    	   */
    	  Long.NEG_ONE = NEG_ONE;

    	  /**
    	   * @type {!Long}
    	   * @inner
    	   */
    	  var MAX_VALUE = fromBits(0xFFFFFFFF|0, 0x7FFFFFFF|0, false);

    	  /**
    	   * Maximum signed value.
    	   * @type {!Long}
    	   */
    	  Long.MAX_VALUE = MAX_VALUE;

    	  /**
    	   * @type {!Long}
    	   * @inner
    	   */
    	  var MAX_UNSIGNED_VALUE = fromBits(0xFFFFFFFF|0, 0xFFFFFFFF|0, true);

    	  /**
    	   * Maximum unsigned value.
    	   * @type {!Long}
    	   */
    	  Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;

    	  /**
    	   * @type {!Long}
    	   * @inner
    	   */
    	  var MIN_VALUE = fromBits(0, 0x80000000|0, false);

    	  /**
    	   * Minimum signed value.
    	   * @type {!Long}
    	   */
    	  Long.MIN_VALUE = MIN_VALUE;

    	  /**
    	   * @alias Long.prototype
    	   * @inner
    	   */
    	  var LongPrototype = Long.prototype;

    	  /**
    	   * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
    	   * @returns {number}
    	   */
    	  LongPrototype.toInt = function toInt() {
    	      return this.unsigned ? this.low >>> 0 : this.low;
    	  };

    	  /**
    	   * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
    	   * @returns {number}
    	   */
    	  LongPrototype.toNumber = function toNumber() {
    	      if (this.unsigned)
    	          return ((this.high >>> 0) * TWO_PWR_32_DBL) + (this.low >>> 0);
    	      return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
    	  };

    	  /**
    	   * Converts the Long to a string written in the specified radix.
    	   * @param {number=} radix Radix (2-36), defaults to 10
    	   * @returns {string}
    	   * @override
    	   * @throws {RangeError} If `radix` is out of range
    	   */
    	  LongPrototype.toString = function toString(radix) {
    	      radix = radix || 10;
    	      if (radix < 2 || 36 < radix)
    	          throw RangeError('radix');
    	      if (this.isZero())
    	          return '0';
    	      if (this.isNegative()) { // Unsigned Longs are never negative
    	          if (this.eq(MIN_VALUE)) {
    	              // We need to change the Long value before it can be negated, so we remove
    	              // the bottom-most digit in this base and then recurse to do the rest.
    	              var radixLong = fromNumber(radix),
    	                  div = this.div(radixLong),
    	                  rem1 = div.mul(radixLong).sub(this);
    	              return div.toString(radix) + rem1.toInt().toString(radix);
    	          } else
    	              return '-' + this.neg().toString(radix);
    	      }

    	      // Do several (6) digits each time through the loop, so as to
    	      // minimize the calls to the very expensive emulated div.
    	      var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned),
    	          rem = this;
    	      var result = '';
    	      while (true) {
    	          var remDiv = rem.div(radixToPower),
    	              intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0,
    	              digits = intval.toString(radix);
    	          rem = remDiv;
    	          if (rem.isZero())
    	              return digits + result;
    	          else {
    	              while (digits.length < 6)
    	                  digits = '0' + digits;
    	              result = '' + digits + result;
    	          }
    	      }
    	  };

    	  /**
    	   * Gets the high 32 bits as a signed integer.
    	   * @returns {number} Signed high bits
    	   */
    	  LongPrototype.getHighBits = function getHighBits() {
    	      return this.high;
    	  };

    	  /**
    	   * Gets the high 32 bits as an unsigned integer.
    	   * @returns {number} Unsigned high bits
    	   */
    	  LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    	      return this.high >>> 0;
    	  };

    	  /**
    	   * Gets the low 32 bits as a signed integer.
    	   * @returns {number} Signed low bits
    	   */
    	  LongPrototype.getLowBits = function getLowBits() {
    	      return this.low;
    	  };

    	  /**
    	   * Gets the low 32 bits as an unsigned integer.
    	   * @returns {number} Unsigned low bits
    	   */
    	  LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    	      return this.low >>> 0;
    	  };

    	  /**
    	   * Gets the number of bits needed to represent the absolute value of this Long.
    	   * @returns {number}
    	   */
    	  LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    	      if (this.isNegative()) // Unsigned Longs are never negative
    	          return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    	      var val = this.high != 0 ? this.high : this.low;
    	      for (var bit = 31; bit > 0; bit--)
    	          if ((val & (1 << bit)) != 0)
    	              break;
    	      return this.high != 0 ? bit + 33 : bit + 1;
    	  };

    	  /**
    	   * Tests if this Long's value equals zero.
    	   * @returns {boolean}
    	   */
    	  LongPrototype.isZero = function isZero() {
    	      return this.high === 0 && this.low === 0;
    	  };

    	  /**
    	   * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
    	   * @returns {boolean}
    	   */
    	  LongPrototype.eqz = LongPrototype.isZero;

    	  /**
    	   * Tests if this Long's value is negative.
    	   * @returns {boolean}
    	   */
    	  LongPrototype.isNegative = function isNegative() {
    	      return !this.unsigned && this.high < 0;
    	  };

    	  /**
    	   * Tests if this Long's value is positive.
    	   * @returns {boolean}
    	   */
    	  LongPrototype.isPositive = function isPositive() {
    	      return this.unsigned || this.high >= 0;
    	  };

    	  /**
    	   * Tests if this Long's value is odd.
    	   * @returns {boolean}
    	   */
    	  LongPrototype.isOdd = function isOdd() {
    	      return (this.low & 1) === 1;
    	  };

    	  /**
    	   * Tests if this Long's value is even.
    	   * @returns {boolean}
    	   */
    	  LongPrototype.isEven = function isEven() {
    	      return (this.low & 1) === 0;
    	  };

    	  /**
    	   * Tests if this Long's value equals the specified's.
    	   * @param {!Long|number|string} other Other value
    	   * @returns {boolean}
    	   */
    	  LongPrototype.equals = function equals(other) {
    	      if (!isLong$1(other))
    	          other = fromValue(other);
    	      if (this.unsigned !== other.unsigned && (this.high >>> 31) === 1 && (other.high >>> 31) === 1)
    	          return false;
    	      return this.high === other.high && this.low === other.low;
    	  };

    	  /**
    	   * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
    	   * @function
    	   * @param {!Long|number|string} other Other value
    	   * @returns {boolean}
    	   */
    	  LongPrototype.eq = LongPrototype.equals;

    	  /**
    	   * Tests if this Long's value differs from the specified's.
    	   * @param {!Long|number|string} other Other value
    	   * @returns {boolean}
    	   */
    	  LongPrototype.notEquals = function notEquals(other) {
    	      return !this.eq(/* validates */ other);
    	  };

    	  /**
    	   * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
    	   * @function
    	   * @param {!Long|number|string} other Other value
    	   * @returns {boolean}
    	   */
    	  LongPrototype.neq = LongPrototype.notEquals;

    	  /**
    	   * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
    	   * @function
    	   * @param {!Long|number|string} other Other value
    	   * @returns {boolean}
    	   */
    	  LongPrototype.ne = LongPrototype.notEquals;

    	  /**
    	   * Tests if this Long's value is less than the specified's.
    	   * @param {!Long|number|string} other Other value
    	   * @returns {boolean}
    	   */
    	  LongPrototype.lessThan = function lessThan(other) {
    	      return this.comp(/* validates */ other) < 0;
    	  };

    	  /**
    	   * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
    	   * @function
    	   * @param {!Long|number|string} other Other value
    	   * @returns {boolean}
    	   */
    	  LongPrototype.lt = LongPrototype.lessThan;

    	  /**
    	   * Tests if this Long's value is less than or equal the specified's.
    	   * @param {!Long|number|string} other Other value
    	   * @returns {boolean}
    	   */
    	  LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    	      return this.comp(/* validates */ other) <= 0;
    	  };

    	  /**
    	   * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
    	   * @function
    	   * @param {!Long|number|string} other Other value
    	   * @returns {boolean}
    	   */
    	  LongPrototype.lte = LongPrototype.lessThanOrEqual;

    	  /**
    	   * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
    	   * @function
    	   * @param {!Long|number|string} other Other value
    	   * @returns {boolean}
    	   */
    	  LongPrototype.le = LongPrototype.lessThanOrEqual;

    	  /**
    	   * Tests if this Long's value is greater than the specified's.
    	   * @param {!Long|number|string} other Other value
    	   * @returns {boolean}
    	   */
    	  LongPrototype.greaterThan = function greaterThan(other) {
    	      return this.comp(/* validates */ other) > 0;
    	  };

    	  /**
    	   * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
    	   * @function
    	   * @param {!Long|number|string} other Other value
    	   * @returns {boolean}
    	   */
    	  LongPrototype.gt = LongPrototype.greaterThan;

    	  /**
    	   * Tests if this Long's value is greater than or equal the specified's.
    	   * @param {!Long|number|string} other Other value
    	   * @returns {boolean}
    	   */
    	  LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    	      return this.comp(/* validates */ other) >= 0;
    	  };

    	  /**
    	   * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
    	   * @function
    	   * @param {!Long|number|string} other Other value
    	   * @returns {boolean}
    	   */
    	  LongPrototype.gte = LongPrototype.greaterThanOrEqual;

    	  /**
    	   * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
    	   * @function
    	   * @param {!Long|number|string} other Other value
    	   * @returns {boolean}
    	   */
    	  LongPrototype.ge = LongPrototype.greaterThanOrEqual;

    	  /**
    	   * Compares this Long's value with the specified's.
    	   * @param {!Long|number|string} other Other value
    	   * @returns {number} 0 if they are the same, 1 if the this is greater and -1
    	   *  if the given one is greater
    	   */
    	  LongPrototype.compare = function compare(other) {
    	      if (!isLong$1(other))
    	          other = fromValue(other);
    	      if (this.eq(other))
    	          return 0;
    	      var thisNeg = this.isNegative(),
    	          otherNeg = other.isNegative();
    	      if (thisNeg && !otherNeg)
    	          return -1;
    	      if (!thisNeg && otherNeg)
    	          return 1;
    	      // At this point the sign bits are the same
    	      if (!this.unsigned)
    	          return this.sub(other).isNegative() ? -1 : 1;
    	      // Both are positive if at least one is unsigned
    	      return (other.high >>> 0) > (this.high >>> 0) || (other.high === this.high && (other.low >>> 0) > (this.low >>> 0)) ? -1 : 1;
    	  };

    	  /**
    	   * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
    	   * @function
    	   * @param {!Long|number|string} other Other value
    	   * @returns {number} 0 if they are the same, 1 if the this is greater and -1
    	   *  if the given one is greater
    	   */
    	  LongPrototype.comp = LongPrototype.compare;

    	  /**
    	   * Negates this Long's value.
    	   * @returns {!Long} Negated Long
    	   */
    	  LongPrototype.negate = function negate() {
    	      if (!this.unsigned && this.eq(MIN_VALUE))
    	          return MIN_VALUE;
    	      return this.not().add(ONE);
    	  };

    	  /**
    	   * Negates this Long's value. This is an alias of {@link Long#negate}.
    	   * @function
    	   * @returns {!Long} Negated Long
    	   */
    	  LongPrototype.neg = LongPrototype.negate;

    	  /**
    	   * Returns the sum of this and the specified Long.
    	   * @param {!Long|number|string} addend Addend
    	   * @returns {!Long} Sum
    	   */
    	  LongPrototype.add = function add(addend) {
    	      if (!isLong$1(addend))
    	          addend = fromValue(addend);

    	      // Divide each number into 4 chunks of 16 bits, and then sum the chunks.

    	      var a48 = this.high >>> 16;
    	      var a32 = this.high & 0xFFFF;
    	      var a16 = this.low >>> 16;
    	      var a00 = this.low & 0xFFFF;

    	      var b48 = addend.high >>> 16;
    	      var b32 = addend.high & 0xFFFF;
    	      var b16 = addend.low >>> 16;
    	      var b00 = addend.low & 0xFFFF;

    	      var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    	      c00 += a00 + b00;
    	      c16 += c00 >>> 16;
    	      c00 &= 0xFFFF;
    	      c16 += a16 + b16;
    	      c32 += c16 >>> 16;
    	      c16 &= 0xFFFF;
    	      c32 += a32 + b32;
    	      c48 += c32 >>> 16;
    	      c32 &= 0xFFFF;
    	      c48 += a48 + b48;
    	      c48 &= 0xFFFF;
    	      return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
    	  };

    	  /**
    	   * Returns the difference of this and the specified Long.
    	   * @param {!Long|number|string} subtrahend Subtrahend
    	   * @returns {!Long} Difference
    	   */
    	  LongPrototype.subtract = function subtract(subtrahend) {
    	      if (!isLong$1(subtrahend))
    	          subtrahend = fromValue(subtrahend);
    	      return this.add(subtrahend.neg());
    	  };

    	  /**
    	   * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
    	   * @function
    	   * @param {!Long|number|string} subtrahend Subtrahend
    	   * @returns {!Long} Difference
    	   */
    	  LongPrototype.sub = LongPrototype.subtract;

    	  /**
    	   * Returns the product of this and the specified Long.
    	   * @param {!Long|number|string} multiplier Multiplier
    	   * @returns {!Long} Product
    	   */
    	  LongPrototype.multiply = function multiply(multiplier) {
    	      if (this.isZero())
    	          return ZERO;
    	      if (!isLong$1(multiplier))
    	          multiplier = fromValue(multiplier);

    	      // use wasm support if present
    	      if (wasm) {
    	          var low = wasm.mul(this.low,
    	                             this.high,
    	                             multiplier.low,
    	                             multiplier.high);
    	          return fromBits(low, wasm.get_high(), this.unsigned);
    	      }

    	      if (multiplier.isZero())
    	          return ZERO;
    	      if (this.eq(MIN_VALUE))
    	          return multiplier.isOdd() ? MIN_VALUE : ZERO;
    	      if (multiplier.eq(MIN_VALUE))
    	          return this.isOdd() ? MIN_VALUE : ZERO;

    	      if (this.isNegative()) {
    	          if (multiplier.isNegative())
    	              return this.neg().mul(multiplier.neg());
    	          else
    	              return this.neg().mul(multiplier).neg();
    	      } else if (multiplier.isNegative())
    	          return this.mul(multiplier.neg()).neg();

    	      // If both longs are small, use float multiplication
    	      if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24))
    	          return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);

    	      // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    	      // We can skip products that would overflow.

    	      var a48 = this.high >>> 16;
    	      var a32 = this.high & 0xFFFF;
    	      var a16 = this.low >>> 16;
    	      var a00 = this.low & 0xFFFF;

    	      var b48 = multiplier.high >>> 16;
    	      var b32 = multiplier.high & 0xFFFF;
    	      var b16 = multiplier.low >>> 16;
    	      var b00 = multiplier.low & 0xFFFF;

    	      var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    	      c00 += a00 * b00;
    	      c16 += c00 >>> 16;
    	      c00 &= 0xFFFF;
    	      c16 += a16 * b00;
    	      c32 += c16 >>> 16;
    	      c16 &= 0xFFFF;
    	      c16 += a00 * b16;
    	      c32 += c16 >>> 16;
    	      c16 &= 0xFFFF;
    	      c32 += a32 * b00;
    	      c48 += c32 >>> 16;
    	      c32 &= 0xFFFF;
    	      c32 += a16 * b16;
    	      c48 += c32 >>> 16;
    	      c32 &= 0xFFFF;
    	      c32 += a00 * b32;
    	      c48 += c32 >>> 16;
    	      c32 &= 0xFFFF;
    	      c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    	      c48 &= 0xFFFF;
    	      return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
    	  };

    	  /**
    	   * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
    	   * @function
    	   * @param {!Long|number|string} multiplier Multiplier
    	   * @returns {!Long} Product
    	   */
    	  LongPrototype.mul = LongPrototype.multiply;

    	  /**
    	   * Returns this Long divided by the specified. The result is signed if this Long is signed or
    	   *  unsigned if this Long is unsigned.
    	   * @param {!Long|number|string} divisor Divisor
    	   * @returns {!Long} Quotient
    	   */
    	  LongPrototype.divide = function divide(divisor) {
    	      if (!isLong$1(divisor))
    	          divisor = fromValue(divisor);
    	      if (divisor.isZero())
    	          throw Error('division by zero');

    	      // use wasm support if present
    	      if (wasm) {
    	          // guard against signed division overflow: the largest
    	          // negative number / -1 would be 1 larger than the largest
    	          // positive number, due to two's complement.
    	          if (!this.unsigned &&
    	              this.high === -0x80000000 &&
    	              divisor.low === -1 && divisor.high === -1) {
    	              // be consistent with non-wasm code path
    	              return this;
    	          }
    	          var low = (this.unsigned ? wasm.div_u : wasm.div_s)(
    	              this.low,
    	              this.high,
    	              divisor.low,
    	              divisor.high
    	          );
    	          return fromBits(low, wasm.get_high(), this.unsigned);
    	      }

    	      if (this.isZero())
    	          return this.unsigned ? UZERO : ZERO;
    	      var approx, rem, res;
    	      if (!this.unsigned) {
    	          // This section is only relevant for signed longs and is derived from the
    	          // closure library as a whole.
    	          if (this.eq(MIN_VALUE)) {
    	              if (divisor.eq(ONE) || divisor.eq(NEG_ONE))
    	                  return MIN_VALUE;  // recall that -MIN_VALUE == MIN_VALUE
    	              else if (divisor.eq(MIN_VALUE))
    	                  return ONE;
    	              else {
    	                  // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
    	                  var halfThis = this.shr(1);
    	                  approx = halfThis.div(divisor).shl(1);
    	                  if (approx.eq(ZERO)) {
    	                      return divisor.isNegative() ? ONE : NEG_ONE;
    	                  } else {
    	                      rem = this.sub(divisor.mul(approx));
    	                      res = approx.add(rem.div(divisor));
    	                      return res;
    	                  }
    	              }
    	          } else if (divisor.eq(MIN_VALUE))
    	              return this.unsigned ? UZERO : ZERO;
    	          if (this.isNegative()) {
    	              if (divisor.isNegative())
    	                  return this.neg().div(divisor.neg());
    	              return this.neg().div(divisor).neg();
    	          } else if (divisor.isNegative())
    	              return this.div(divisor.neg()).neg();
    	          res = ZERO;
    	      } else {
    	          // The algorithm below has not been made for unsigned longs. It's therefore
    	          // required to take special care of the MSB prior to running it.
    	          if (!divisor.unsigned)
    	              divisor = divisor.toUnsigned();
    	          if (divisor.gt(this))
    	              return UZERO;
    	          if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
    	              return UONE;
    	          res = UZERO;
    	      }

    	      // Repeat the following until the remainder is less than other:  find a
    	      // floating-point that approximates remainder / other *from below*, add this
    	      // into the result, and subtract it from the remainder.  It is critical that
    	      // the approximate value is less than or equal to the real value so that the
    	      // remainder never becomes negative.
    	      rem = this;
    	      while (rem.gte(divisor)) {
    	          // Approximate the result of division. This may be a little greater or
    	          // smaller than the actual value.
    	          approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));

    	          // We will tweak the approximate result by changing it in the 48-th digit or
    	          // the smallest non-fractional digit, whichever is larger.
    	          var log2 = Math.ceil(Math.log(approx) / Math.LN2),
    	              delta = (log2 <= 48) ? 1 : pow_dbl(2, log2 - 48),

    	          // Decrease the approximation until it is smaller than the remainder.  Note
    	          // that if it is too large, the product overflows and is negative.
    	              approxRes = fromNumber(approx),
    	              approxRem = approxRes.mul(divisor);
    	          while (approxRem.isNegative() || approxRem.gt(rem)) {
    	              approx -= delta;
    	              approxRes = fromNumber(approx, this.unsigned);
    	              approxRem = approxRes.mul(divisor);
    	          }

    	          // We know the answer can't be zero... and actually, zero would cause
    	          // infinite recursion since we would make no progress.
    	          if (approxRes.isZero())
    	              approxRes = ONE;

    	          res = res.add(approxRes);
    	          rem = rem.sub(approxRem);
    	      }
    	      return res;
    	  };

    	  /**
    	   * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
    	   * @function
    	   * @param {!Long|number|string} divisor Divisor
    	   * @returns {!Long} Quotient
    	   */
    	  LongPrototype.div = LongPrototype.divide;

    	  /**
    	   * Returns this Long modulo the specified.
    	   * @param {!Long|number|string} divisor Divisor
    	   * @returns {!Long} Remainder
    	   */
    	  LongPrototype.modulo = function modulo(divisor) {
    	      if (!isLong$1(divisor))
    	          divisor = fromValue(divisor);

    	      // use wasm support if present
    	      if (wasm) {
    	          var low = (this.unsigned ? wasm.rem_u : wasm.rem_s)(
    	              this.low,
    	              this.high,
    	              divisor.low,
    	              divisor.high
    	          );
    	          return fromBits(low, wasm.get_high(), this.unsigned);
    	      }

    	      return this.sub(this.div(divisor).mul(divisor));
    	  };

    	  /**
    	   * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
    	   * @function
    	   * @param {!Long|number|string} divisor Divisor
    	   * @returns {!Long} Remainder
    	   */
    	  LongPrototype.mod = LongPrototype.modulo;

    	  /**
    	   * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
    	   * @function
    	   * @param {!Long|number|string} divisor Divisor
    	   * @returns {!Long} Remainder
    	   */
    	  LongPrototype.rem = LongPrototype.modulo;

    	  /**
    	   * Returns the bitwise NOT of this Long.
    	   * @returns {!Long}
    	   */
    	  LongPrototype.not = function not() {
    	      return fromBits(~this.low, ~this.high, this.unsigned);
    	  };

    	  /**
    	   * Returns the bitwise AND of this Long and the specified.
    	   * @param {!Long|number|string} other Other Long
    	   * @returns {!Long}
    	   */
    	  LongPrototype.and = function and(other) {
    	      if (!isLong$1(other))
    	          other = fromValue(other);
    	      return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
    	  };

    	  /**
    	   * Returns the bitwise OR of this Long and the specified.
    	   * @param {!Long|number|string} other Other Long
    	   * @returns {!Long}
    	   */
    	  LongPrototype.or = function or(other) {
    	      if (!isLong$1(other))
    	          other = fromValue(other);
    	      return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
    	  };

    	  /**
    	   * Returns the bitwise XOR of this Long and the given one.
    	   * @param {!Long|number|string} other Other Long
    	   * @returns {!Long}
    	   */
    	  LongPrototype.xor = function xor(other) {
    	      if (!isLong$1(other))
    	          other = fromValue(other);
    	      return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
    	  };

    	  /**
    	   * Returns this Long with bits shifted to the left by the given amount.
    	   * @param {number|!Long} numBits Number of bits
    	   * @returns {!Long} Shifted Long
    	   */
    	  LongPrototype.shiftLeft = function shiftLeft(numBits) {
    	      if (isLong$1(numBits))
    	          numBits = numBits.toInt();
    	      if ((numBits &= 63) === 0)
    	          return this;
    	      else if (numBits < 32)
    	          return fromBits(this.low << numBits, (this.high << numBits) | (this.low >>> (32 - numBits)), this.unsigned);
    	      else
    	          return fromBits(0, this.low << (numBits - 32), this.unsigned);
    	  };

    	  /**
    	   * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
    	   * @function
    	   * @param {number|!Long} numBits Number of bits
    	   * @returns {!Long} Shifted Long
    	   */
    	  LongPrototype.shl = LongPrototype.shiftLeft;

    	  /**
    	   * Returns this Long with bits arithmetically shifted to the right by the given amount.
    	   * @param {number|!Long} numBits Number of bits
    	   * @returns {!Long} Shifted Long
    	   */
    	  LongPrototype.shiftRight = function shiftRight(numBits) {
    	      if (isLong$1(numBits))
    	          numBits = numBits.toInt();
    	      if ((numBits &= 63) === 0)
    	          return this;
    	      else if (numBits < 32)
    	          return fromBits((this.low >>> numBits) | (this.high << (32 - numBits)), this.high >> numBits, this.unsigned);
    	      else
    	          return fromBits(this.high >> (numBits - 32), this.high >= 0 ? 0 : -1, this.unsigned);
    	  };

    	  /**
    	   * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
    	   * @function
    	   * @param {number|!Long} numBits Number of bits
    	   * @returns {!Long} Shifted Long
    	   */
    	  LongPrototype.shr = LongPrototype.shiftRight;

    	  /**
    	   * Returns this Long with bits logically shifted to the right by the given amount.
    	   * @param {number|!Long} numBits Number of bits
    	   * @returns {!Long} Shifted Long
    	   */
    	  LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    	      if (isLong$1(numBits))
    	          numBits = numBits.toInt();
    	      numBits &= 63;
    	      if (numBits === 0)
    	          return this;
    	      else {
    	          var high = this.high;
    	          if (numBits < 32) {
    	              var low = this.low;
    	              return fromBits((low >>> numBits) | (high << (32 - numBits)), high >>> numBits, this.unsigned);
    	          } else if (numBits === 32)
    	              return fromBits(high, 0, this.unsigned);
    	          else
    	              return fromBits(high >>> (numBits - 32), 0, this.unsigned);
    	      }
    	  };

    	  /**
    	   * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
    	   * @function
    	   * @param {number|!Long} numBits Number of bits
    	   * @returns {!Long} Shifted Long
    	   */
    	  LongPrototype.shru = LongPrototype.shiftRightUnsigned;

    	  /**
    	   * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
    	   * @function
    	   * @param {number|!Long} numBits Number of bits
    	   * @returns {!Long} Shifted Long
    	   */
    	  LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;

    	  /**
    	   * Converts this Long to signed.
    	   * @returns {!Long} Signed long
    	   */
    	  LongPrototype.toSigned = function toSigned() {
    	      if (!this.unsigned)
    	          return this;
    	      return fromBits(this.low, this.high, false);
    	  };

    	  /**
    	   * Converts this Long to unsigned.
    	   * @returns {!Long} Unsigned long
    	   */
    	  LongPrototype.toUnsigned = function toUnsigned() {
    	      if (this.unsigned)
    	          return this;
    	      return fromBits(this.low, this.high, true);
    	  };

    	  /**
    	   * Converts this Long to its byte representation.
    	   * @param {boolean=} le Whether little or big endian, defaults to big endian
    	   * @returns {!Array.<number>} Byte representation
    	   */
    	  LongPrototype.toBytes = function toBytes(le) {
    	      return le ? this.toBytesLE() : this.toBytesBE();
    	  };

    	  /**
    	   * Converts this Long to its little endian byte representation.
    	   * @returns {!Array.<number>} Little endian byte representation
    	   */
    	  LongPrototype.toBytesLE = function toBytesLE() {
    	      var hi = this.high,
    	          lo = this.low;
    	      return [
    	          lo        & 0xff,
    	          lo >>>  8 & 0xff,
    	          lo >>> 16 & 0xff,
    	          lo >>> 24       ,
    	          hi        & 0xff,
    	          hi >>>  8 & 0xff,
    	          hi >>> 16 & 0xff,
    	          hi >>> 24
    	      ];
    	  };

    	  /**
    	   * Converts this Long to its big endian byte representation.
    	   * @returns {!Array.<number>} Big endian byte representation
    	   */
    	  LongPrototype.toBytesBE = function toBytesBE() {
    	      var hi = this.high,
    	          lo = this.low;
    	      return [
    	          hi >>> 24       ,
    	          hi >>> 16 & 0xff,
    	          hi >>>  8 & 0xff,
    	          hi        & 0xff,
    	          lo >>> 24       ,
    	          lo >>> 16 & 0xff,
    	          lo >>>  8 & 0xff,
    	          lo        & 0xff
    	      ];
    	  };

    	  /**
    	   * Creates a Long from its byte representation.
    	   * @param {!Array.<number>} bytes Byte representation
    	   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
    	   * @param {boolean=} le Whether little or big endian, defaults to big endian
    	   * @returns {Long} The corresponding Long value
    	   */
    	  Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    	      return le ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
    	  };

    	  /**
    	   * Creates a Long from its little endian byte representation.
    	   * @param {!Array.<number>} bytes Little endian byte representation
    	   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
    	   * @returns {Long} The corresponding Long value
    	   */
    	  Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    	      return new Long(
    	          bytes[0]       |
    	          bytes[1] <<  8 |
    	          bytes[2] << 16 |
    	          bytes[3] << 24,
    	          bytes[4]       |
    	          bytes[5] <<  8 |
    	          bytes[6] << 16 |
    	          bytes[7] << 24,
    	          unsigned
    	      );
    	  };

    	  /**
    	   * Creates a Long from its big endian byte representation.
    	   * @param {!Array.<number>} bytes Big endian byte representation
    	   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
    	   * @returns {Long} The corresponding Long value
    	   */
    	  Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    	      return new Long(
    	          bytes[4] << 24 |
    	          bytes[5] << 16 |
    	          bytes[6] <<  8 |
    	          bytes[7],
    	          bytes[0] << 24 |
    	          bytes[1] << 16 |
    	          bytes[2] <<  8 |
    	          bytes[3],
    	          unsigned
    	      );
    	  };

    	  var Long$1 = /*@__PURE__*/getDefaultExportFromCjs(long);

    	  //  Copyright (C) 2018 Zilliqa
    	  var isAddress = function (address) {
    	      return isByteString(address, 40);
    	  };
    	  var isBech32 = function (raw) {
    	      return !!raw.match(/^zil1[qpzry9x8gf2tvdw0s3jn54khce6mua7l]{38}$/);
    	  };
    	  var isBase58 = function (raw) {
    	      return !!raw.match(/^[1-9ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]+$/);
    	  };
    	  var isPrivateKey = function (privateKey) {
    	      return isByteString(privateKey, 64);
    	  };
    	  var isPubKey = function (pubKey) {
    	      return isByteString(pubKey, 66);
    	  };
    	  var isSignature = function (sig) {
    	      return isByteString(sig, 128);
    	  };
    	  var isByteString = function (str, len) {
    	      return !!str.replace('0x', '').match("^[0-9a-fA-F]{".concat(len, "}$"));
    	  };
    	  var isNumber = function (x) {
    	      return typeof x === 'number';
    	  };
    	  var isBN = function (x) {
    	      return BN.isBN(x);
    	  };
    	  var isLong = function (x) {
    	      return Long$1.isLong(x);
    	  };
    	  var isString = function (x) {
    	      return typeof x === 'string';
    	  };
    	  var isPlainObject = function (x) {
    	      if (typeof x === 'object' && x !== null) {
    	          var proto = Object.getPrototypeOf(x);
    	          return proto === Object.prototype || proto === null;
    	      }
    	      return false;
    	  };
    	  var PRAGMA_REQUIRED = '@@ZJS_REQUIRED@@';
    	  var required = function (fn) {
    	      if (typeof fn === 'function') {
    	          return Object.defineProperty(fn, 'required', {
    	              value: PRAGMA_REQUIRED,
    	          });
    	      }
    	      throw new Error('fn is not a function');
    	  };
    	  var matchesObject = function (x, test) {
    	      var e_1, _a;
    	      if (isPlainObject(x)) {
    	          for (var key in test) {
    	              if (test.hasOwnProperty(key)) {
    	                  try {
    	                      for (var _b = (e_1 = void 0, __values(test[key])), _c = _b.next(); !_c.done; _c = _b.next()) {
    	                          var tester = _c.value;
    	                          var value = x[key];
    	                          if (typeof value === 'undefined' && tester.required) {
    	                              throw new Error('Key not found: ' + key);
    	                          }
    	                          else {
    	                              continue;
    	                          }
    	                      }
    	                  }
    	                  catch (e_1_1) { e_1 = { error: e_1_1 }; }
    	                  finally {
    	                      try {
    	                          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    	                      }
    	                      finally { if (e_1) throw e_1.error; }
    	                  }
    	              }
    	          }
    	      }
    	      return true;
    	  };

    	  var validation = /*#__PURE__*/Object.freeze({
    	    __proto__: null,
    	    isAddress: isAddress,
    	    isBech32: isBech32,
    	    isBase58: isBase58,
    	    isPrivateKey: isPrivateKey,
    	    isPubKey: isPubKey,
    	    isSignature: isSignature,
    	    isByteString: isByteString,
    	    isNumber: isNumber,
    	    isBN: isBN,
    	    isLong: isLong,
    	    isString: isString,
    	    isPlainObject: isPlainObject,
    	    required: required,
    	    matchesObject: matchesObject
    	  });

    	  //  Copyright (C) 2018 Zilliqa
    	  var Units;
    	  (function (Units) {
    	      Units["Zil"] = "zil";
    	      Units["Li"] = "li";
    	      Units["Qa"] = "qa";
    	  })(Units || (Units = {}));
    	  var DEFAULT_OPTIONS = {
    	      pad: false,
    	  };
    	  var unitMap = new Map([
    	      [Units.Qa, '1'],
    	      [Units.Li, '1000000'],
    	      [Units.Zil, '1000000000000'], // 1e12 qa
    	  ]);
    	  var numToStr = function (input) {
    	      if (typeof input === 'string') {
    	          if (!input.match(/^-?[0-9.]+$/)) {
    	              throw new Error("while converting number to string, invalid number value '".concat(input, "', should be a number matching (^-?[0-9.]+)."));
    	          }
    	          return input;
    	      }
    	      else if (typeof input === 'number') {
    	          return String(input);
    	      }
    	      else if (BN.isBN(input)) {
    	          return input.toString(10);
    	      }
    	      throw new Error("while converting number to string, invalid number value '".concat(input, "' type ").concat(typeof input, "."));
    	  };
    	  var fromQa = function (qa, unit, options) {
    	      if (options === void 0) { options = DEFAULT_OPTIONS; }
    	      if (unit === 'qa') {
    	          return qa.toString(10);
    	      }
    	      var baseStr = unitMap.get(unit);
    	      if (!baseStr) {
    	          throw new Error("No unit of type ".concat(unit, " exists."));
    	      }
    	      var base = new BN(baseStr, 10);
    	      var baseNumDecimals = baseStr.length - 1;
    	      var fraction = qa.abs().mod(base).toString(10);
    	      // prepend 0s to the fraction half
    	      while (fraction.length < baseNumDecimals) {
    	          fraction = "0".concat(fraction);
    	      }
    	      if (!options.pad) {
    	          fraction = (fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1]);
    	      }
    	      var whole = qa.div(base).toString(10);
    	      return fraction === '0' ? "".concat(whole) : "".concat(whole, ".").concat(fraction);
    	  };
    	  var toQa = function (input, unit) {
    	      var inputStr = numToStr(input);
    	      var baseStr = unitMap.get(unit);
    	      if (!baseStr) {
    	          throw new Error("No unit of type ".concat(unit, " exists."));
    	      }
    	      var baseNumDecimals = baseStr.length - 1;
    	      var base = new BN(baseStr, 10);
    	      // Is it negative?
    	      var isNegative = inputStr.substring(0, 1) === '-';
    	      if (isNegative) {
    	          inputStr = inputStr.substring(1);
    	      }
    	      if (inputStr === '.') {
    	          throw new Error("Cannot convert ".concat(inputStr, " to Qa."));
    	      }
    	      // Split it into a whole and fractional part
    	      var comps = inputStr.split('.'); // eslint-disable-line
    	      if (comps.length > 2) {
    	          throw new Error("Cannot convert ".concat(inputStr, " to Qa."));
    	      }
    	      var _a = __read(comps, 2), whole = _a[0], fraction = _a[1];
    	      if (!whole) {
    	          whole = '0';
    	      }
    	      if (!fraction) {
    	          fraction = '0';
    	      }
    	      if (fraction.length > baseNumDecimals) {
    	          throw new Error("Cannot convert ".concat(inputStr, " to Qa."));
    	      }
    	      while (fraction.length < baseNumDecimals) {
    	          fraction += '0';
    	      }
    	      var wholeBN = new BN(whole);
    	      var fractionBN = new BN(fraction);
    	      var wei = wholeBN.mul(base).add(fractionBN); // eslint-disable-line
    	      if (isNegative) {
    	          wei = wei.neg();
    	      }
    	      return new BN(wei.toString(10), 10);
    	  };

    	  var unit = /*#__PURE__*/Object.freeze({
    	    __proto__: null,
    	    get Units () { return Units; },
    	    fromQa: fromQa,
    	    toQa: toQa
    	  });

    	  exports.BN = BN;
    	  exports.Long = Long$1;
    	  exports.bytes = bytes;
    	  exports.units = unit;
    	  exports.validation = validation;

    	  Object.defineProperty(exports, '__esModule', { value: true });

    	}));
    	
    } (bundle$1, bundle$1.exports));

    var bundleExports$1 = bundle$1.exports;

    var indexMinimal = {};

    var minimal$1 = {};

    var aspromise = asPromise;

    /**
     * Callback as used by {@link util.asPromise}.
     * @typedef asPromiseCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {...*} params Additional arguments
     * @returns {undefined}
     */

    /**
     * Returns a promise from a node-style callback function.
     * @memberof util
     * @param {asPromiseCallback} fn Function to call
     * @param {*} ctx Function context
     * @param {...*} params Function arguments
     * @returns {Promise<*>} Promisified function
     */
    function asPromise(fn, ctx/*, varargs */) {
        var params  = new Array(arguments.length - 1),
            offset  = 0,
            index   = 2,
            pending = true;
        while (index < arguments.length)
            params[offset++] = arguments[index++];
        return new Promise(function executor(resolve, reject) {
            params[offset] = function callback(err/*, varargs */) {
                if (pending) {
                    pending = false;
                    if (err)
                        reject(err);
                    else {
                        var params = new Array(arguments.length - 1),
                            offset = 0;
                        while (offset < params.length)
                            params[offset++] = arguments[offset];
                        resolve.apply(null, params);
                    }
                }
            };
            try {
                fn.apply(ctx || null, params);
            } catch (err) {
                if (pending) {
                    pending = false;
                    reject(err);
                }
            }
        });
    }

    var base64$1 = {};

    (function (exports) {

    	/**
    	 * A minimal base64 implementation for number arrays.
    	 * @memberof util
    	 * @namespace
    	 */
    	var base64 = exports;

    	/**
    	 * Calculates the byte length of a base64 encoded string.
    	 * @param {string} string Base64 encoded string
    	 * @returns {number} Byte length
    	 */
    	base64.length = function length(string) {
    	    var p = string.length;
    	    if (!p)
    	        return 0;
    	    var n = 0;
    	    while (--p % 4 > 1 && string.charAt(p) === "=")
    	        ++n;
    	    return Math.ceil(string.length * 3) / 4 - n;
    	};

    	// Base64 encoding table
    	var b64 = new Array(64);

    	// Base64 decoding table
    	var s64 = new Array(123);

    	// 65..90, 97..122, 48..57, 43, 47
    	for (var i = 0; i < 64;)
    	    s64[b64[i] = i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i - 59 | 43] = i++;

    	/**
    	 * Encodes a buffer to a base64 encoded string.
    	 * @param {Uint8Array} buffer Source buffer
    	 * @param {number} start Source start
    	 * @param {number} end Source end
    	 * @returns {string} Base64 encoded string
    	 */
    	base64.encode = function encode(buffer, start, end) {
    	    var parts = null,
    	        chunk = [];
    	    var i = 0, // output index
    	        j = 0, // goto index
    	        t;     // temporary
    	    while (start < end) {
    	        var b = buffer[start++];
    	        switch (j) {
    	            case 0:
    	                chunk[i++] = b64[b >> 2];
    	                t = (b & 3) << 4;
    	                j = 1;
    	                break;
    	            case 1:
    	                chunk[i++] = b64[t | b >> 4];
    	                t = (b & 15) << 2;
    	                j = 2;
    	                break;
    	            case 2:
    	                chunk[i++] = b64[t | b >> 6];
    	                chunk[i++] = b64[b & 63];
    	                j = 0;
    	                break;
    	        }
    	        if (i > 8191) {
    	            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
    	            i = 0;
    	        }
    	    }
    	    if (j) {
    	        chunk[i++] = b64[t];
    	        chunk[i++] = 61;
    	        if (j === 1)
    	            chunk[i++] = 61;
    	    }
    	    if (parts) {
    	        if (i)
    	            parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
    	        return parts.join("");
    	    }
    	    return String.fromCharCode.apply(String, chunk.slice(0, i));
    	};

    	var invalidEncoding = "invalid encoding";

    	/**
    	 * Decodes a base64 encoded string to a buffer.
    	 * @param {string} string Source string
    	 * @param {Uint8Array} buffer Destination buffer
    	 * @param {number} offset Destination offset
    	 * @returns {number} Number of bytes written
    	 * @throws {Error} If encoding is invalid
    	 */
    	base64.decode = function decode(string, buffer, offset) {
    	    var start = offset;
    	    var j = 0, // goto index
    	        t;     // temporary
    	    for (var i = 0; i < string.length;) {
    	        var c = string.charCodeAt(i++);
    	        if (c === 61 && j > 1)
    	            break;
    	        if ((c = s64[c]) === undefined)
    	            throw Error(invalidEncoding);
    	        switch (j) {
    	            case 0:
    	                t = c;
    	                j = 1;
    	                break;
    	            case 1:
    	                buffer[offset++] = t << 2 | (c & 48) >> 4;
    	                t = c;
    	                j = 2;
    	                break;
    	            case 2:
    	                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
    	                t = c;
    	                j = 3;
    	                break;
    	            case 3:
    	                buffer[offset++] = (t & 3) << 6 | c;
    	                j = 0;
    	                break;
    	        }
    	    }
    	    if (j === 1)
    	        throw Error(invalidEncoding);
    	    return offset - start;
    	};

    	/**
    	 * Tests if the specified string appears to be base64 encoded.
    	 * @param {string} string String to test
    	 * @returns {boolean} `true` if probably base64 encoded, otherwise false
    	 */
    	base64.test = function test(string) {
    	    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
    	}; 
    } (base64$1));

    var eventemitter = EventEmitter$1;

    /**
     * Constructs a new event emitter instance.
     * @classdesc A minimal event emitter.
     * @memberof util
     * @constructor
     */
    function EventEmitter$1() {

        /**
         * Registered listeners.
         * @type {Object.<string,*>}
         * @private
         */
        this._listeners = {};
    }

    /**
     * Registers an event listener.
     * @param {string} evt Event name
     * @param {function} fn Listener
     * @param {*} [ctx] Listener context
     * @returns {util.EventEmitter} `this`
     */
    EventEmitter$1.prototype.on = function on(evt, fn, ctx) {
        (this._listeners[evt] || (this._listeners[evt] = [])).push({
            fn  : fn,
            ctx : ctx || this
        });
        return this;
    };

    /**
     * Removes an event listener or any matching listeners if arguments are omitted.
     * @param {string} [evt] Event name. Removes all listeners if omitted.
     * @param {function} [fn] Listener to remove. Removes all listeners of `evt` if omitted.
     * @returns {util.EventEmitter} `this`
     */
    EventEmitter$1.prototype.off = function off(evt, fn) {
        if (evt === undefined)
            this._listeners = {};
        else {
            if (fn === undefined)
                this._listeners[evt] = [];
            else {
                var listeners = this._listeners[evt];
                for (var i = 0; i < listeners.length;)
                    if (listeners[i].fn === fn)
                        listeners.splice(i, 1);
                    else
                        ++i;
            }
        }
        return this;
    };

    /**
     * Emits an event by calling its listeners with the specified arguments.
     * @param {string} evt Event name
     * @param {...*} args Arguments
     * @returns {util.EventEmitter} `this`
     */
    EventEmitter$1.prototype.emit = function emit(evt) {
        var listeners = this._listeners[evt];
        if (listeners) {
            var args = [],
                i = 1;
            for (; i < arguments.length;)
                args.push(arguments[i++]);
            for (i = 0; i < listeners.length;)
                listeners[i].fn.apply(listeners[i++].ctx, args);
        }
        return this;
    };

    var float = factory(factory);

    /**
     * Reads / writes floats / doubles from / to buffers.
     * @name util.float
     * @namespace
     */

    /**
     * Writes a 32 bit float to a buffer using little endian byte order.
     * @name util.float.writeFloatLE
     * @function
     * @param {number} val Value to write
     * @param {Uint8Array} buf Target buffer
     * @param {number} pos Target buffer offset
     * @returns {undefined}
     */

    /**
     * Writes a 32 bit float to a buffer using big endian byte order.
     * @name util.float.writeFloatBE
     * @function
     * @param {number} val Value to write
     * @param {Uint8Array} buf Target buffer
     * @param {number} pos Target buffer offset
     * @returns {undefined}
     */

    /**
     * Reads a 32 bit float from a buffer using little endian byte order.
     * @name util.float.readFloatLE
     * @function
     * @param {Uint8Array} buf Source buffer
     * @param {number} pos Source buffer offset
     * @returns {number} Value read
     */

    /**
     * Reads a 32 bit float from a buffer using big endian byte order.
     * @name util.float.readFloatBE
     * @function
     * @param {Uint8Array} buf Source buffer
     * @param {number} pos Source buffer offset
     * @returns {number} Value read
     */

    /**
     * Writes a 64 bit double to a buffer using little endian byte order.
     * @name util.float.writeDoubleLE
     * @function
     * @param {number} val Value to write
     * @param {Uint8Array} buf Target buffer
     * @param {number} pos Target buffer offset
     * @returns {undefined}
     */

    /**
     * Writes a 64 bit double to a buffer using big endian byte order.
     * @name util.float.writeDoubleBE
     * @function
     * @param {number} val Value to write
     * @param {Uint8Array} buf Target buffer
     * @param {number} pos Target buffer offset
     * @returns {undefined}
     */

    /**
     * Reads a 64 bit double from a buffer using little endian byte order.
     * @name util.float.readDoubleLE
     * @function
     * @param {Uint8Array} buf Source buffer
     * @param {number} pos Source buffer offset
     * @returns {number} Value read
     */

    /**
     * Reads a 64 bit double from a buffer using big endian byte order.
     * @name util.float.readDoubleBE
     * @function
     * @param {Uint8Array} buf Source buffer
     * @param {number} pos Source buffer offset
     * @returns {number} Value read
     */

    // Factory function for the purpose of node-based testing in modified global environments
    function factory(exports) {

        // float: typed array
        if (typeof Float32Array !== "undefined") (function() {

            var f32 = new Float32Array([ -0 ]),
                f8b = new Uint8Array(f32.buffer),
                le  = f8b[3] === 128;

            function writeFloat_f32_cpy(val, buf, pos) {
                f32[0] = val;
                buf[pos    ] = f8b[0];
                buf[pos + 1] = f8b[1];
                buf[pos + 2] = f8b[2];
                buf[pos + 3] = f8b[3];
            }

            function writeFloat_f32_rev(val, buf, pos) {
                f32[0] = val;
                buf[pos    ] = f8b[3];
                buf[pos + 1] = f8b[2];
                buf[pos + 2] = f8b[1];
                buf[pos + 3] = f8b[0];
            }

            /* istanbul ignore next */
            exports.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
            /* istanbul ignore next */
            exports.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;

            function readFloat_f32_cpy(buf, pos) {
                f8b[0] = buf[pos    ];
                f8b[1] = buf[pos + 1];
                f8b[2] = buf[pos + 2];
                f8b[3] = buf[pos + 3];
                return f32[0];
            }

            function readFloat_f32_rev(buf, pos) {
                f8b[3] = buf[pos    ];
                f8b[2] = buf[pos + 1];
                f8b[1] = buf[pos + 2];
                f8b[0] = buf[pos + 3];
                return f32[0];
            }

            /* istanbul ignore next */
            exports.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
            /* istanbul ignore next */
            exports.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;

        // float: ieee754
        })(); else (function() {

            function writeFloat_ieee754(writeUint, val, buf, pos) {
                var sign = val < 0 ? 1 : 0;
                if (sign)
                    val = -val;
                if (val === 0)
                    writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos);
                else if (isNaN(val))
                    writeUint(2143289344, buf, pos);
                else if (val > 3.4028234663852886e+38) // +-Infinity
                    writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
                else if (val < 1.1754943508222875e-38) // denormal
                    writeUint((sign << 31 | Math.round(val / 1.401298464324817e-45)) >>> 0, buf, pos);
                else {
                    var exponent = Math.floor(Math.log(val) / Math.LN2),
                        mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
                    writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
                }
            }

            exports.writeFloatLE = writeFloat_ieee754.bind(null, writeUintLE);
            exports.writeFloatBE = writeFloat_ieee754.bind(null, writeUintBE);

            function readFloat_ieee754(readUint, buf, pos) {
                var uint = readUint(buf, pos),
                    sign = (uint >> 31) * 2 + 1,
                    exponent = uint >>> 23 & 255,
                    mantissa = uint & 8388607;
                return exponent === 255
                    ? mantissa
                    ? NaN
                    : sign * Infinity
                    : exponent === 0 // denormal
                    ? sign * 1.401298464324817e-45 * mantissa
                    : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
            }

            exports.readFloatLE = readFloat_ieee754.bind(null, readUintLE);
            exports.readFloatBE = readFloat_ieee754.bind(null, readUintBE);

        })();

        // double: typed array
        if (typeof Float64Array !== "undefined") (function() {

            var f64 = new Float64Array([-0]),
                f8b = new Uint8Array(f64.buffer),
                le  = f8b[7] === 128;

            function writeDouble_f64_cpy(val, buf, pos) {
                f64[0] = val;
                buf[pos    ] = f8b[0];
                buf[pos + 1] = f8b[1];
                buf[pos + 2] = f8b[2];
                buf[pos + 3] = f8b[3];
                buf[pos + 4] = f8b[4];
                buf[pos + 5] = f8b[5];
                buf[pos + 6] = f8b[6];
                buf[pos + 7] = f8b[7];
            }

            function writeDouble_f64_rev(val, buf, pos) {
                f64[0] = val;
                buf[pos    ] = f8b[7];
                buf[pos + 1] = f8b[6];
                buf[pos + 2] = f8b[5];
                buf[pos + 3] = f8b[4];
                buf[pos + 4] = f8b[3];
                buf[pos + 5] = f8b[2];
                buf[pos + 6] = f8b[1];
                buf[pos + 7] = f8b[0];
            }

            /* istanbul ignore next */
            exports.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
            /* istanbul ignore next */
            exports.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;

            function readDouble_f64_cpy(buf, pos) {
                f8b[0] = buf[pos    ];
                f8b[1] = buf[pos + 1];
                f8b[2] = buf[pos + 2];
                f8b[3] = buf[pos + 3];
                f8b[4] = buf[pos + 4];
                f8b[5] = buf[pos + 5];
                f8b[6] = buf[pos + 6];
                f8b[7] = buf[pos + 7];
                return f64[0];
            }

            function readDouble_f64_rev(buf, pos) {
                f8b[7] = buf[pos    ];
                f8b[6] = buf[pos + 1];
                f8b[5] = buf[pos + 2];
                f8b[4] = buf[pos + 3];
                f8b[3] = buf[pos + 4];
                f8b[2] = buf[pos + 5];
                f8b[1] = buf[pos + 6];
                f8b[0] = buf[pos + 7];
                return f64[0];
            }

            /* istanbul ignore next */
            exports.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
            /* istanbul ignore next */
            exports.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;

        // double: ieee754
        })(); else (function() {

            function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
                var sign = val < 0 ? 1 : 0;
                if (sign)
                    val = -val;
                if (val === 0) {
                    writeUint(0, buf, pos + off0);
                    writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos + off1);
                } else if (isNaN(val)) {
                    writeUint(0, buf, pos + off0);
                    writeUint(2146959360, buf, pos + off1);
                } else if (val > 1.7976931348623157e+308) { // +-Infinity
                    writeUint(0, buf, pos + off0);
                    writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
                } else {
                    var mantissa;
                    if (val < 2.2250738585072014e-308) { // denormal
                        mantissa = val / 5e-324;
                        writeUint(mantissa >>> 0, buf, pos + off0);
                        writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
                    } else {
                        var exponent = Math.floor(Math.log(val) / Math.LN2);
                        if (exponent === 1024)
                            exponent = 1023;
                        mantissa = val * Math.pow(2, -exponent);
                        writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
                        writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
                    }
                }
            }

            exports.writeDoubleLE = writeDouble_ieee754.bind(null, writeUintLE, 0, 4);
            exports.writeDoubleBE = writeDouble_ieee754.bind(null, writeUintBE, 4, 0);

            function readDouble_ieee754(readUint, off0, off1, buf, pos) {
                var lo = readUint(buf, pos + off0),
                    hi = readUint(buf, pos + off1);
                var sign = (hi >> 31) * 2 + 1,
                    exponent = hi >>> 20 & 2047,
                    mantissa = 4294967296 * (hi & 1048575) + lo;
                return exponent === 2047
                    ? mantissa
                    ? NaN
                    : sign * Infinity
                    : exponent === 0 // denormal
                    ? sign * 5e-324 * mantissa
                    : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
            }

            exports.readDoubleLE = readDouble_ieee754.bind(null, readUintLE, 0, 4);
            exports.readDoubleBE = readDouble_ieee754.bind(null, readUintBE, 4, 0);

        })();

        return exports;
    }

    // uint helpers

    function writeUintLE(val, buf, pos) {
        buf[pos    ] =  val        & 255;
        buf[pos + 1] =  val >>> 8  & 255;
        buf[pos + 2] =  val >>> 16 & 255;
        buf[pos + 3] =  val >>> 24;
    }

    function writeUintBE(val, buf, pos) {
        buf[pos    ] =  val >>> 24;
        buf[pos + 1] =  val >>> 16 & 255;
        buf[pos + 2] =  val >>> 8  & 255;
        buf[pos + 3] =  val        & 255;
    }

    function readUintLE(buf, pos) {
        return (buf[pos    ]
              | buf[pos + 1] << 8
              | buf[pos + 2] << 16
              | buf[pos + 3] << 24) >>> 0;
    }

    function readUintBE(buf, pos) {
        return (buf[pos    ] << 24
              | buf[pos + 1] << 16
              | buf[pos + 2] << 8
              | buf[pos + 3]) >>> 0;
    }

    var inquire_1 = inquire;

    /**
     * Requires a module only if available.
     * @memberof util
     * @param {string} moduleName Module to require
     * @returns {?Object} Required module if available and not empty, otherwise `null`
     */
    function inquire(moduleName) {
        try {
            var mod = eval("quire".replace(/^/,"re"))(moduleName); // eslint-disable-line no-eval
            if (mod && (mod.length || Object.keys(mod).length))
                return mod;
        } catch (e) {} // eslint-disable-line no-empty
        return null;
    }

    var utf8$2 = {};

    (function (exports) {

    	/**
    	 * A minimal UTF8 implementation for number arrays.
    	 * @memberof util
    	 * @namespace
    	 */
    	var utf8 = exports;

    	/**
    	 * Calculates the UTF8 byte length of a string.
    	 * @param {string} string String
    	 * @returns {number} Byte length
    	 */
    	utf8.length = function utf8_length(string) {
    	    var len = 0,
    	        c = 0;
    	    for (var i = 0; i < string.length; ++i) {
    	        c = string.charCodeAt(i);
    	        if (c < 128)
    	            len += 1;
    	        else if (c < 2048)
    	            len += 2;
    	        else if ((c & 0xFC00) === 0xD800 && (string.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
    	            ++i;
    	            len += 4;
    	        } else
    	            len += 3;
    	    }
    	    return len;
    	};

    	/**
    	 * Reads UTF8 bytes as a string.
    	 * @param {Uint8Array} buffer Source buffer
    	 * @param {number} start Source start
    	 * @param {number} end Source end
    	 * @returns {string} String read
    	 */
    	utf8.read = function utf8_read(buffer, start, end) {
    	    var len = end - start;
    	    if (len < 1)
    	        return "";
    	    var parts = null,
    	        chunk = [],
    	        i = 0, // char offset
    	        t;     // temporary
    	    while (start < end) {
    	        t = buffer[start++];
    	        if (t < 128)
    	            chunk[i++] = t;
    	        else if (t > 191 && t < 224)
    	            chunk[i++] = (t & 31) << 6 | buffer[start++] & 63;
    	        else if (t > 239 && t < 365) {
    	            t = ((t & 7) << 18 | (buffer[start++] & 63) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63) - 0x10000;
    	            chunk[i++] = 0xD800 + (t >> 10);
    	            chunk[i++] = 0xDC00 + (t & 1023);
    	        } else
    	            chunk[i++] = (t & 15) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63;
    	        if (i > 8191) {
    	            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
    	            i = 0;
    	        }
    	    }
    	    if (parts) {
    	        if (i)
    	            parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
    	        return parts.join("");
    	    }
    	    return String.fromCharCode.apply(String, chunk.slice(0, i));
    	};

    	/**
    	 * Writes a string as UTF8 bytes.
    	 * @param {string} string Source string
    	 * @param {Uint8Array} buffer Destination buffer
    	 * @param {number} offset Destination offset
    	 * @returns {number} Bytes written
    	 */
    	utf8.write = function utf8_write(string, buffer, offset) {
    	    var start = offset,
    	        c1, // character 1
    	        c2; // character 2
    	    for (var i = 0; i < string.length; ++i) {
    	        c1 = string.charCodeAt(i);
    	        if (c1 < 128) {
    	            buffer[offset++] = c1;
    	        } else if (c1 < 2048) {
    	            buffer[offset++] = c1 >> 6       | 192;
    	            buffer[offset++] = c1       & 63 | 128;
    	        } else if ((c1 & 0xFC00) === 0xD800 && ((c2 = string.charCodeAt(i + 1)) & 0xFC00) === 0xDC00) {
    	            c1 = 0x10000 + ((c1 & 0x03FF) << 10) + (c2 & 0x03FF);
    	            ++i;
    	            buffer[offset++] = c1 >> 18      | 240;
    	            buffer[offset++] = c1 >> 12 & 63 | 128;
    	            buffer[offset++] = c1 >> 6  & 63 | 128;
    	            buffer[offset++] = c1       & 63 | 128;
    	        } else {
    	            buffer[offset++] = c1 >> 12      | 224;
    	            buffer[offset++] = c1 >> 6  & 63 | 128;
    	            buffer[offset++] = c1       & 63 | 128;
    	        }
    	    }
    	    return offset - start;
    	}; 
    } (utf8$2));

    var pool_1 = pool;

    /**
     * An allocator as used by {@link util.pool}.
     * @typedef PoolAllocator
     * @type {function}
     * @param {number} size Buffer size
     * @returns {Uint8Array} Buffer
     */

    /**
     * A slicer as used by {@link util.pool}.
     * @typedef PoolSlicer
     * @type {function}
     * @param {number} start Start offset
     * @param {number} end End offset
     * @returns {Uint8Array} Buffer slice
     * @this {Uint8Array}
     */

    /**
     * A general purpose buffer pool.
     * @memberof util
     * @function
     * @param {PoolAllocator} alloc Allocator
     * @param {PoolSlicer} slice Slicer
     * @param {number} [size=8192] Slab size
     * @returns {PoolAllocator} Pooled allocator
     */
    function pool(alloc, slice, size) {
        var SIZE   = size || 8192;
        var MAX    = SIZE >>> 1;
        var slab   = null;
        var offset = SIZE;
        return function pool_alloc(size) {
            if (size < 1 || size > MAX)
                return alloc(size);
            if (offset + size > SIZE) {
                slab = alloc(SIZE);
                offset = 0;
            }
            var buf = slice.call(slab, offset, offset += size);
            if (offset & 7) // align to 32 bit
                offset = (offset | 7) + 1;
            return buf;
        };
    }

    var longbits;
    var hasRequiredLongbits;

    function requireLongbits () {
    	if (hasRequiredLongbits) return longbits;
    	hasRequiredLongbits = 1;
    	longbits = LongBits;

    	var util = requireMinimal();

    	/**
    	 * Constructs new long bits.
    	 * @classdesc Helper class for working with the low and high bits of a 64 bit value.
    	 * @memberof util
    	 * @constructor
    	 * @param {number} lo Low 32 bits, unsigned
    	 * @param {number} hi High 32 bits, unsigned
    	 */
    	function LongBits(lo, hi) {

    	    // note that the casts below are theoretically unnecessary as of today, but older statically
    	    // generated converter code might still call the ctor with signed 32bits. kept for compat.

    	    /**
    	     * Low bits.
    	     * @type {number}
    	     */
    	    this.lo = lo >>> 0;

    	    /**
    	     * High bits.
    	     * @type {number}
    	     */
    	    this.hi = hi >>> 0;
    	}

    	/**
    	 * Zero bits.
    	 * @memberof util.LongBits
    	 * @type {util.LongBits}
    	 */
    	var zero = LongBits.zero = new LongBits(0, 0);

    	zero.toNumber = function() { return 0; };
    	zero.zzEncode = zero.zzDecode = function() { return this; };
    	zero.length = function() { return 1; };

    	/**
    	 * Zero hash.
    	 * @memberof util.LongBits
    	 * @type {string}
    	 */
    	var zeroHash = LongBits.zeroHash = "\0\0\0\0\0\0\0\0";

    	/**
    	 * Constructs new long bits from the specified number.
    	 * @param {number} value Value
    	 * @returns {util.LongBits} Instance
    	 */
    	LongBits.fromNumber = function fromNumber(value) {
    	    if (value === 0)
    	        return zero;
    	    var sign = value < 0;
    	    if (sign)
    	        value = -value;
    	    var lo = value >>> 0,
    	        hi = (value - lo) / 4294967296 >>> 0;
    	    if (sign) {
    	        hi = ~hi >>> 0;
    	        lo = ~lo >>> 0;
    	        if (++lo > 4294967295) {
    	            lo = 0;
    	            if (++hi > 4294967295)
    	                hi = 0;
    	        }
    	    }
    	    return new LongBits(lo, hi);
    	};

    	/**
    	 * Constructs new long bits from a number, long or string.
    	 * @param {Long|number|string} value Value
    	 * @returns {util.LongBits} Instance
    	 */
    	LongBits.from = function from(value) {
    	    if (typeof value === "number")
    	        return LongBits.fromNumber(value);
    	    if (util.isString(value)) {
    	        /* istanbul ignore else */
    	        if (util.Long)
    	            value = util.Long.fromString(value);
    	        else
    	            return LongBits.fromNumber(parseInt(value, 10));
    	    }
    	    return value.low || value.high ? new LongBits(value.low >>> 0, value.high >>> 0) : zero;
    	};

    	/**
    	 * Converts this long bits to a possibly unsafe JavaScript number.
    	 * @param {boolean} [unsigned=false] Whether unsigned or not
    	 * @returns {number} Possibly unsafe number
    	 */
    	LongBits.prototype.toNumber = function toNumber(unsigned) {
    	    if (!unsigned && this.hi >>> 31) {
    	        var lo = ~this.lo + 1 >>> 0,
    	            hi = ~this.hi     >>> 0;
    	        if (!lo)
    	            hi = hi + 1 >>> 0;
    	        return -(lo + hi * 4294967296);
    	    }
    	    return this.lo + this.hi * 4294967296;
    	};

    	/**
    	 * Converts this long bits to a long.
    	 * @param {boolean} [unsigned=false] Whether unsigned or not
    	 * @returns {Long} Long
    	 */
    	LongBits.prototype.toLong = function toLong(unsigned) {
    	    return util.Long
    	        ? new util.Long(this.lo | 0, this.hi | 0, Boolean(unsigned))
    	        /* istanbul ignore next */
    	        : { low: this.lo | 0, high: this.hi | 0, unsigned: Boolean(unsigned) };
    	};

    	var charCodeAt = String.prototype.charCodeAt;

    	/**
    	 * Constructs new long bits from the specified 8 characters long hash.
    	 * @param {string} hash Hash
    	 * @returns {util.LongBits} Bits
    	 */
    	LongBits.fromHash = function fromHash(hash) {
    	    if (hash === zeroHash)
    	        return zero;
    	    return new LongBits(
    	        ( charCodeAt.call(hash, 0)
    	        | charCodeAt.call(hash, 1) << 8
    	        | charCodeAt.call(hash, 2) << 16
    	        | charCodeAt.call(hash, 3) << 24) >>> 0
    	    ,
    	        ( charCodeAt.call(hash, 4)
    	        | charCodeAt.call(hash, 5) << 8
    	        | charCodeAt.call(hash, 6) << 16
    	        | charCodeAt.call(hash, 7) << 24) >>> 0
    	    );
    	};

    	/**
    	 * Converts this long bits to a 8 characters long hash.
    	 * @returns {string} Hash
    	 */
    	LongBits.prototype.toHash = function toHash() {
    	    return String.fromCharCode(
    	        this.lo        & 255,
    	        this.lo >>> 8  & 255,
    	        this.lo >>> 16 & 255,
    	        this.lo >>> 24      ,
    	        this.hi        & 255,
    	        this.hi >>> 8  & 255,
    	        this.hi >>> 16 & 255,
    	        this.hi >>> 24
    	    );
    	};

    	/**
    	 * Zig-zag encodes this long bits.
    	 * @returns {util.LongBits} `this`
    	 */
    	LongBits.prototype.zzEncode = function zzEncode() {
    	    var mask =   this.hi >> 31;
    	    this.hi  = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
    	    this.lo  = ( this.lo << 1                   ^ mask) >>> 0;
    	    return this;
    	};

    	/**
    	 * Zig-zag decodes this long bits.
    	 * @returns {util.LongBits} `this`
    	 */
    	LongBits.prototype.zzDecode = function zzDecode() {
    	    var mask = -(this.lo & 1);
    	    this.lo  = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
    	    this.hi  = ( this.hi >>> 1                  ^ mask) >>> 0;
    	    return this;
    	};

    	/**
    	 * Calculates the length of this longbits when encoded as a varint.
    	 * @returns {number} Length
    	 */
    	LongBits.prototype.length = function length() {
    	    var part0 =  this.lo,
    	        part1 = (this.lo >>> 28 | this.hi << 4) >>> 0,
    	        part2 =  this.hi >>> 24;
    	    return part2 === 0
    	         ? part1 === 0
    	           ? part0 < 16384
    	             ? part0 < 128 ? 1 : 2
    	             : part0 < 2097152 ? 3 : 4
    	           : part1 < 16384
    	             ? part1 < 128 ? 5 : 6
    	             : part1 < 2097152 ? 7 : 8
    	         : part2 < 128 ? 9 : 10;
    	};
    	return longbits;
    }

    var hasRequiredMinimal;

    function requireMinimal () {
    	if (hasRequiredMinimal) return minimal$1;
    	hasRequiredMinimal = 1;
    	(function (exports) {
    		var util = exports;

    		// used to return a Promise where callback is omitted
    		util.asPromise = aspromise;

    		// converts to / from base64 encoded strings
    		util.base64 = base64$1;

    		// base class of rpc.Service
    		util.EventEmitter = eventemitter;

    		// float handling accross browsers
    		util.float = float;

    		// requires modules optionally and hides the call from bundlers
    		util.inquire = inquire_1;

    		// converts to / from utf8 encoded strings
    		util.utf8 = utf8$2;

    		// provides a node-like buffer pool in the browser
    		util.pool = pool_1;

    		// utility to work with the low and high bits of a 64 bit value
    		util.LongBits = requireLongbits();

    		/**
    		 * Whether running within node or not.
    		 * @memberof util
    		 * @type {boolean}
    		 */
    		util.isNode = Boolean(typeof commonjsGlobal !== "undefined"
    		                   && commonjsGlobal
    		                   && commonjsGlobal.process
    		                   && commonjsGlobal.process.versions
    		                   && commonjsGlobal.process.versions.node);

    		/**
    		 * Global object reference.
    		 * @memberof util
    		 * @type {Object}
    		 */
    		util.global = util.isNode && commonjsGlobal
    		           || typeof window !== "undefined" && window
    		           || typeof self   !== "undefined" && self
    		           || commonjsGlobal; // eslint-disable-line no-invalid-this

    		/**
    		 * An immuable empty array.
    		 * @memberof util
    		 * @type {Array.<*>}
    		 * @const
    		 */
    		util.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ []; // used on prototypes

    		/**
    		 * An immutable empty object.
    		 * @type {Object}
    		 * @const
    		 */
    		util.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}; // used on prototypes

    		/**
    		 * Tests if the specified value is an integer.
    		 * @function
    		 * @param {*} value Value to test
    		 * @returns {boolean} `true` if the value is an integer
    		 */
    		util.isInteger = Number.isInteger || /* istanbul ignore next */ function isInteger(value) {
    		    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
    		};

    		/**
    		 * Tests if the specified value is a string.
    		 * @param {*} value Value to test
    		 * @returns {boolean} `true` if the value is a string
    		 */
    		util.isString = function isString(value) {
    		    return typeof value === "string" || value instanceof String;
    		};

    		/**
    		 * Tests if the specified value is a non-null object.
    		 * @param {*} value Value to test
    		 * @returns {boolean} `true` if the value is a non-null object
    		 */
    		util.isObject = function isObject(value) {
    		    return value && typeof value === "object";
    		};

    		/**
    		 * Checks if a property on a message is considered to be present.
    		 * This is an alias of {@link util.isSet}.
    		 * @function
    		 * @param {Object} obj Plain object or message instance
    		 * @param {string} prop Property name
    		 * @returns {boolean} `true` if considered to be present, otherwise `false`
    		 */
    		util.isset =

    		/**
    		 * Checks if a property on a message is considered to be present.
    		 * @param {Object} obj Plain object or message instance
    		 * @param {string} prop Property name
    		 * @returns {boolean} `true` if considered to be present, otherwise `false`
    		 */
    		util.isSet = function isSet(obj, prop) {
    		    var value = obj[prop];
    		    if (value != null && obj.hasOwnProperty(prop)) // eslint-disable-line eqeqeq, no-prototype-builtins
    		        return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
    		    return false;
    		};

    		/**
    		 * Any compatible Buffer instance.
    		 * This is a minimal stand-alone definition of a Buffer instance. The actual type is that exported by node's typings.
    		 * @interface Buffer
    		 * @extends Uint8Array
    		 */

    		/**
    		 * Node's Buffer class if available.
    		 * @type {Constructor<Buffer>}
    		 */
    		util.Buffer = (function() {
    		    try {
    		        var Buffer = util.inquire("buffer").Buffer;
    		        // refuse to use non-node buffers if not explicitly assigned (perf reasons):
    		        return Buffer.prototype.utf8Write ? Buffer : /* istanbul ignore next */ null;
    		    } catch (e) {
    		        /* istanbul ignore next */
    		        return null;
    		    }
    		})();

    		// Internal alias of or polyfull for Buffer.from.
    		util._Buffer_from = null;

    		// Internal alias of or polyfill for Buffer.allocUnsafe.
    		util._Buffer_allocUnsafe = null;

    		/**
    		 * Creates a new buffer of whatever type supported by the environment.
    		 * @param {number|number[]} [sizeOrArray=0] Buffer size or number array
    		 * @returns {Uint8Array|Buffer} Buffer
    		 */
    		util.newBuffer = function newBuffer(sizeOrArray) {
    		    /* istanbul ignore next */
    		    return typeof sizeOrArray === "number"
    		        ? util.Buffer
    		            ? util._Buffer_allocUnsafe(sizeOrArray)
    		            : new util.Array(sizeOrArray)
    		        : util.Buffer
    		            ? util._Buffer_from(sizeOrArray)
    		            : typeof Uint8Array === "undefined"
    		                ? sizeOrArray
    		                : new Uint8Array(sizeOrArray);
    		};

    		/**
    		 * Array implementation used in the browser. `Uint8Array` if supported, otherwise `Array`.
    		 * @type {Constructor<Uint8Array>}
    		 */
    		util.Array = typeof Uint8Array !== "undefined" ? Uint8Array /* istanbul ignore next */ : Array;

    		/**
    		 * Any compatible Long instance.
    		 * This is a minimal stand-alone definition of a Long instance. The actual type is that exported by long.js.
    		 * @interface Long
    		 * @property {number} low Low bits
    		 * @property {number} high High bits
    		 * @property {boolean} unsigned Whether unsigned or not
    		 */

    		/**
    		 * Long.js's Long class if available.
    		 * @type {Constructor<Long>}
    		 */
    		util.Long = /* istanbul ignore next */ util.global.dcodeIO && /* istanbul ignore next */ util.global.dcodeIO.Long
    		         || /* istanbul ignore next */ util.global.Long
    		         || util.inquire("long");

    		/**
    		 * Regular expression used to verify 2 bit (`bool`) map keys.
    		 * @type {RegExp}
    		 * @const
    		 */
    		util.key2Re = /^true|false|0|1$/;

    		/**
    		 * Regular expression used to verify 32 bit (`int32` etc.) map keys.
    		 * @type {RegExp}
    		 * @const
    		 */
    		util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;

    		/**
    		 * Regular expression used to verify 64 bit (`int64` etc.) map keys.
    		 * @type {RegExp}
    		 * @const
    		 */
    		util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;

    		/**
    		 * Converts a number or long to an 8 characters long hash string.
    		 * @param {Long|number} value Value to convert
    		 * @returns {string} Hash
    		 */
    		util.longToHash = function longToHash(value) {
    		    return value
    		        ? util.LongBits.from(value).toHash()
    		        : util.LongBits.zeroHash;
    		};

    		/**
    		 * Converts an 8 characters long hash string to a long or number.
    		 * @param {string} hash Hash
    		 * @param {boolean} [unsigned=false] Whether unsigned or not
    		 * @returns {Long|number} Original value
    		 */
    		util.longFromHash = function longFromHash(hash, unsigned) {
    		    var bits = util.LongBits.fromHash(hash);
    		    if (util.Long)
    		        return util.Long.fromBits(bits.lo, bits.hi, unsigned);
    		    return bits.toNumber(Boolean(unsigned));
    		};

    		/**
    		 * Merges the properties of the source object into the destination object.
    		 * @memberof util
    		 * @param {Object.<string,*>} dst Destination object
    		 * @param {Object.<string,*>} src Source object
    		 * @param {boolean} [ifNotSet=false] Merges only if the key is not already set
    		 * @returns {Object.<string,*>} Destination object
    		 */
    		function merge(dst, src, ifNotSet) { // used by converters
    		    for (var keys = Object.keys(src), i = 0; i < keys.length; ++i)
    		        if (dst[keys[i]] === undefined || !ifNotSet)
    		            dst[keys[i]] = src[keys[i]];
    		    return dst;
    		}

    		util.merge = merge;

    		/**
    		 * Converts the first character of a string to lower case.
    		 * @param {string} str String to convert
    		 * @returns {string} Converted string
    		 */
    		util.lcFirst = function lcFirst(str) {
    		    return str.charAt(0).toLowerCase() + str.substring(1);
    		};

    		/**
    		 * Creates a custom error constructor.
    		 * @memberof util
    		 * @param {string} name Error name
    		 * @returns {Constructor<Error>} Custom error constructor
    		 */
    		function newError(name) {

    		    function CustomError(message, properties) {

    		        if (!(this instanceof CustomError))
    		            return new CustomError(message, properties);

    		        // Error.call(this, message);
    		        // ^ just returns a new error instance because the ctor can be called as a function

    		        Object.defineProperty(this, "message", { get: function() { return message; } });

    		        /* istanbul ignore next */
    		        if (Error.captureStackTrace) // node
    		            Error.captureStackTrace(this, CustomError);
    		        else
    		            Object.defineProperty(this, "stack", { value: new Error().stack || "" });

    		        if (properties)
    		            merge(this, properties);
    		    }

    		    (CustomError.prototype = Object.create(Error.prototype)).constructor = CustomError;

    		    Object.defineProperty(CustomError.prototype, "name", { get: function() { return name; } });

    		    CustomError.prototype.toString = function toString() {
    		        return this.name + ": " + this.message;
    		    };

    		    return CustomError;
    		}

    		util.newError = newError;

    		/**
    		 * Constructs a new protocol error.
    		 * @classdesc Error subclass indicating a protocol specifc error.
    		 * @memberof util
    		 * @extends Error
    		 * @template T extends Message<T>
    		 * @constructor
    		 * @param {string} message Error message
    		 * @param {Object.<string,*>} [properties] Additional properties
    		 * @example
    		 * try {
    		 *     MyMessage.decode(someBuffer); // throws if required fields are missing
    		 * } catch (e) {
    		 *     if (e instanceof ProtocolError && e.instance)
    		 *         console.log("decoded so far: " + JSON.stringify(e.instance));
    		 * }
    		 */
    		util.ProtocolError = newError("ProtocolError");

    		/**
    		 * So far decoded message instance.
    		 * @name util.ProtocolError#instance
    		 * @type {Message<T>}
    		 */

    		/**
    		 * A OneOf getter as returned by {@link util.oneOfGetter}.
    		 * @typedef OneOfGetter
    		 * @type {function}
    		 * @returns {string|undefined} Set field name, if any
    		 */

    		/**
    		 * Builds a getter for a oneof's present field name.
    		 * @param {string[]} fieldNames Field names
    		 * @returns {OneOfGetter} Unbound getter
    		 */
    		util.oneOfGetter = function getOneOf(fieldNames) {
    		    var fieldMap = {};
    		    for (var i = 0; i < fieldNames.length; ++i)
    		        fieldMap[fieldNames[i]] = 1;

    		    /**
    		     * @returns {string|undefined} Set field name, if any
    		     * @this Object
    		     * @ignore
    		     */
    		    return function() { // eslint-disable-line consistent-return
    		        for (var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)
    		            if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null)
    		                return keys[i];
    		    };
    		};

    		/**
    		 * A OneOf setter as returned by {@link util.oneOfSetter}.
    		 * @typedef OneOfSetter
    		 * @type {function}
    		 * @param {string|undefined} value Field name
    		 * @returns {undefined}
    		 */

    		/**
    		 * Builds a setter for a oneof's present field name.
    		 * @param {string[]} fieldNames Field names
    		 * @returns {OneOfSetter} Unbound setter
    		 */
    		util.oneOfSetter = function setOneOf(fieldNames) {

    		    /**
    		     * @param {string} name Field name
    		     * @returns {undefined}
    		     * @this Object
    		     * @ignore
    		     */
    		    return function(name) {
    		        for (var i = 0; i < fieldNames.length; ++i)
    		            if (fieldNames[i] !== name)
    		                delete this[fieldNames[i]];
    		    };
    		};

    		/**
    		 * Default conversion options used for {@link Message#toJSON} implementations.
    		 *
    		 * These options are close to proto3's JSON mapping with the exception that internal types like Any are handled just like messages. More precisely:
    		 *
    		 * - Longs become strings
    		 * - Enums become string keys
    		 * - Bytes become base64 encoded strings
    		 * - (Sub-)Messages become plain objects
    		 * - Maps become plain objects with all string keys
    		 * - Repeated fields become arrays
    		 * - NaN and Infinity for float and double fields become strings
    		 *
    		 * @type {IConversionOptions}
    		 * @see https://developers.google.com/protocol-buffers/docs/proto3?hl=en#json
    		 */
    		util.toJSONOptions = {
    		    longs: String,
    		    enums: String,
    		    bytes: String,
    		    json: true
    		};

    		// Sets up buffer utility according to the environment (called in index-minimal)
    		util._configure = function() {
    		    var Buffer = util.Buffer;
    		    /* istanbul ignore if */
    		    if (!Buffer) {
    		        util._Buffer_from = util._Buffer_allocUnsafe = null;
    		        return;
    		    }
    		    // because node 4.x buffers are incompatible & immutable
    		    // see: https://github.com/dcodeIO/protobuf.js/pull/665
    		    util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from ||
    		        /* istanbul ignore next */
    		        function Buffer_from(value, encoding) {
    		            return new Buffer(value, encoding);
    		        };
    		    util._Buffer_allocUnsafe = Buffer.allocUnsafe ||
    		        /* istanbul ignore next */
    		        function Buffer_allocUnsafe(size) {
    		            return new Buffer(size);
    		        };
    		}; 
    	} (minimal$1));
    	return minimal$1;
    }

    var writer = Writer$1;

    var util$5      = requireMinimal();

    var BufferWriter$1; // cyclic

    var LongBits$1  = util$5.LongBits,
        base64    = util$5.base64,
        utf8$1      = util$5.utf8;

    /**
     * Constructs a new writer operation instance.
     * @classdesc Scheduled writer operation.
     * @constructor
     * @param {function(*, Uint8Array, number)} fn Function to call
     * @param {number} len Value byte length
     * @param {*} val Value to write
     * @ignore
     */
    function Op(fn, len, val) {

        /**
         * Function to call.
         * @type {function(Uint8Array, number, *)}
         */
        this.fn = fn;

        /**
         * Value byte length.
         * @type {number}
         */
        this.len = len;

        /**
         * Next operation.
         * @type {Writer.Op|undefined}
         */
        this.next = undefined;

        /**
         * Value to write.
         * @type {*}
         */
        this.val = val; // type varies
    }

    /* istanbul ignore next */
    function noop$3() {} // eslint-disable-line no-empty-function

    /**
     * Constructs a new writer state instance.
     * @classdesc Copied writer state.
     * @memberof Writer
     * @constructor
     * @param {Writer} writer Writer to copy state from
     * @ignore
     */
    function State(writer) {

        /**
         * Current head.
         * @type {Writer.Op}
         */
        this.head = writer.head;

        /**
         * Current tail.
         * @type {Writer.Op}
         */
        this.tail = writer.tail;

        /**
         * Current buffer length.
         * @type {number}
         */
        this.len = writer.len;

        /**
         * Next state.
         * @type {State|null}
         */
        this.next = writer.states;
    }

    /**
     * Constructs a new writer instance.
     * @classdesc Wire format writer using `Uint8Array` if available, otherwise `Array`.
     * @constructor
     */
    function Writer$1() {

        /**
         * Current length.
         * @type {number}
         */
        this.len = 0;

        /**
         * Operations head.
         * @type {Object}
         */
        this.head = new Op(noop$3, 0, 0);

        /**
         * Operations tail
         * @type {Object}
         */
        this.tail = this.head;

        /**
         * Linked forked states.
         * @type {Object|null}
         */
        this.states = null;

        // When a value is written, the writer calculates its byte length and puts it into a linked
        // list of operations to perform when finish() is called. This both allows us to allocate
        // buffers of the exact required size and reduces the amount of work we have to do compared
        // to first calculating over objects and then encoding over objects. In our case, the encoding
        // part is just a linked list walk calling operations with already prepared values.
    }

    var create$1 = function create() {
        return util$5.Buffer
            ? function create_buffer_setup() {
                return (Writer$1.create = function create_buffer() {
                    return new BufferWriter$1();
                })();
            }
            /* istanbul ignore next */
            : function create_array() {
                return new Writer$1();
            };
    };

    /**
     * Creates a new writer.
     * @function
     * @returns {BufferWriter|Writer} A {@link BufferWriter} when Buffers are supported, otherwise a {@link Writer}
     */
    Writer$1.create = create$1();

    /**
     * Allocates a buffer of the specified size.
     * @param {number} size Buffer size
     * @returns {Uint8Array} Buffer
     */
    Writer$1.alloc = function alloc(size) {
        return new util$5.Array(size);
    };

    // Use Uint8Array buffer pool in the browser, just like node does with buffers
    /* istanbul ignore else */
    if (util$5.Array !== Array)
        Writer$1.alloc = util$5.pool(Writer$1.alloc, util$5.Array.prototype.subarray);

    /**
     * Pushes a new operation to the queue.
     * @param {function(Uint8Array, number, *)} fn Function to call
     * @param {number} len Value byte length
     * @param {number} val Value to write
     * @returns {Writer} `this`
     * @private
     */
    Writer$1.prototype._push = function push(fn, len, val) {
        this.tail = this.tail.next = new Op(fn, len, val);
        this.len += len;
        return this;
    };

    function writeByte(val, buf, pos) {
        buf[pos] = val & 255;
    }

    function writeVarint32(val, buf, pos) {
        while (val > 127) {
            buf[pos++] = val & 127 | 128;
            val >>>= 7;
        }
        buf[pos] = val;
    }

    /**
     * Constructs a new varint writer operation instance.
     * @classdesc Scheduled varint writer operation.
     * @extends Op
     * @constructor
     * @param {number} len Value byte length
     * @param {number} val Value to write
     * @ignore
     */
    function VarintOp(len, val) {
        this.len = len;
        this.next = undefined;
        this.val = val;
    }

    VarintOp.prototype = Object.create(Op.prototype);
    VarintOp.prototype.fn = writeVarint32;

    /**
     * Writes an unsigned 32 bit value as a varint.
     * @param {number} value Value to write
     * @returns {Writer} `this`
     */
    Writer$1.prototype.uint32 = function write_uint32(value) {
        // here, the call to this.push has been inlined and a varint specific Op subclass is used.
        // uint32 is by far the most frequently used operation and benefits significantly from this.
        this.len += (this.tail = this.tail.next = new VarintOp(
            (value = value >>> 0)
                    < 128       ? 1
            : value < 16384     ? 2
            : value < 2097152   ? 3
            : value < 268435456 ? 4
            :                     5,
        value)).len;
        return this;
    };

    /**
     * Writes a signed 32 bit value as a varint.
     * @function
     * @param {number} value Value to write
     * @returns {Writer} `this`
     */
    Writer$1.prototype.int32 = function write_int32(value) {
        return value < 0
            ? this._push(writeVarint64, 10, LongBits$1.fromNumber(value)) // 10 bytes per spec
            : this.uint32(value);
    };

    /**
     * Writes a 32 bit value as a varint, zig-zag encoded.
     * @param {number} value Value to write
     * @returns {Writer} `this`
     */
    Writer$1.prototype.sint32 = function write_sint32(value) {
        return this.uint32((value << 1 ^ value >> 31) >>> 0);
    };

    function writeVarint64(val, buf, pos) {
        while (val.hi) {
            buf[pos++] = val.lo & 127 | 128;
            val.lo = (val.lo >>> 7 | val.hi << 25) >>> 0;
            val.hi >>>= 7;
        }
        while (val.lo > 127) {
            buf[pos++] = val.lo & 127 | 128;
            val.lo = val.lo >>> 7;
        }
        buf[pos++] = val.lo;
    }

    /**
     * Writes an unsigned 64 bit value as a varint.
     * @param {Long|number|string} value Value to write
     * @returns {Writer} `this`
     * @throws {TypeError} If `value` is a string and no long library is present.
     */
    Writer$1.prototype.uint64 = function write_uint64(value) {
        var bits = LongBits$1.from(value);
        return this._push(writeVarint64, bits.length(), bits);
    };

    /**
     * Writes a signed 64 bit value as a varint.
     * @function
     * @param {Long|number|string} value Value to write
     * @returns {Writer} `this`
     * @throws {TypeError} If `value` is a string and no long library is present.
     */
    Writer$1.prototype.int64 = Writer$1.prototype.uint64;

    /**
     * Writes a signed 64 bit value as a varint, zig-zag encoded.
     * @param {Long|number|string} value Value to write
     * @returns {Writer} `this`
     * @throws {TypeError} If `value` is a string and no long library is present.
     */
    Writer$1.prototype.sint64 = function write_sint64(value) {
        var bits = LongBits$1.from(value).zzEncode();
        return this._push(writeVarint64, bits.length(), bits);
    };

    /**
     * Writes a boolish value as a varint.
     * @param {boolean} value Value to write
     * @returns {Writer} `this`
     */
    Writer$1.prototype.bool = function write_bool(value) {
        return this._push(writeByte, 1, value ? 1 : 0);
    };

    function writeFixed32(val, buf, pos) {
        buf[pos    ] =  val         & 255;
        buf[pos + 1] =  val >>> 8   & 255;
        buf[pos + 2] =  val >>> 16  & 255;
        buf[pos + 3] =  val >>> 24;
    }

    /**
     * Writes an unsigned 32 bit value as fixed 32 bits.
     * @param {number} value Value to write
     * @returns {Writer} `this`
     */
    Writer$1.prototype.fixed32 = function write_fixed32(value) {
        return this._push(writeFixed32, 4, value >>> 0);
    };

    /**
     * Writes a signed 32 bit value as fixed 32 bits.
     * @function
     * @param {number} value Value to write
     * @returns {Writer} `this`
     */
    Writer$1.prototype.sfixed32 = Writer$1.prototype.fixed32;

    /**
     * Writes an unsigned 64 bit value as fixed 64 bits.
     * @param {Long|number|string} value Value to write
     * @returns {Writer} `this`
     * @throws {TypeError} If `value` is a string and no long library is present.
     */
    Writer$1.prototype.fixed64 = function write_fixed64(value) {
        var bits = LongBits$1.from(value);
        return this._push(writeFixed32, 4, bits.lo)._push(writeFixed32, 4, bits.hi);
    };

    /**
     * Writes a signed 64 bit value as fixed 64 bits.
     * @function
     * @param {Long|number|string} value Value to write
     * @returns {Writer} `this`
     * @throws {TypeError} If `value` is a string and no long library is present.
     */
    Writer$1.prototype.sfixed64 = Writer$1.prototype.fixed64;

    /**
     * Writes a float (32 bit).
     * @function
     * @param {number} value Value to write
     * @returns {Writer} `this`
     */
    Writer$1.prototype.float = function write_float(value) {
        return this._push(util$5.float.writeFloatLE, 4, value);
    };

    /**
     * Writes a double (64 bit float).
     * @function
     * @param {number} value Value to write
     * @returns {Writer} `this`
     */
    Writer$1.prototype.double = function write_double(value) {
        return this._push(util$5.float.writeDoubleLE, 8, value);
    };

    var writeBytes = util$5.Array.prototype.set
        ? function writeBytes_set(val, buf, pos) {
            buf.set(val, pos); // also works for plain array values
        }
        /* istanbul ignore next */
        : function writeBytes_for(val, buf, pos) {
            for (var i = 0; i < val.length; ++i)
                buf[pos + i] = val[i];
        };

    /**
     * Writes a sequence of bytes.
     * @param {Uint8Array|string} value Buffer or base64 encoded string to write
     * @returns {Writer} `this`
     */
    Writer$1.prototype.bytes = function write_bytes(value) {
        var len = value.length >>> 0;
        if (!len)
            return this._push(writeByte, 1, 0);
        if (util$5.isString(value)) {
            var buf = Writer$1.alloc(len = base64.length(value));
            base64.decode(value, buf, 0);
            value = buf;
        }
        return this.uint32(len)._push(writeBytes, len, value);
    };

    /**
     * Writes a string.
     * @param {string} value Value to write
     * @returns {Writer} `this`
     */
    Writer$1.prototype.string = function write_string(value) {
        var len = utf8$1.length(value);
        return len
            ? this.uint32(len)._push(utf8$1.write, len, value)
            : this._push(writeByte, 1, 0);
    };

    /**
     * Forks this writer's state by pushing it to a stack.
     * Calling {@link Writer#reset|reset} or {@link Writer#ldelim|ldelim} resets the writer to the previous state.
     * @returns {Writer} `this`
     */
    Writer$1.prototype.fork = function fork() {
        this.states = new State(this);
        this.head = this.tail = new Op(noop$3, 0, 0);
        this.len = 0;
        return this;
    };

    /**
     * Resets this instance to the last state.
     * @returns {Writer} `this`
     */
    Writer$1.prototype.reset = function reset() {
        if (this.states) {
            this.head   = this.states.head;
            this.tail   = this.states.tail;
            this.len    = this.states.len;
            this.states = this.states.next;
        } else {
            this.head = this.tail = new Op(noop$3, 0, 0);
            this.len  = 0;
        }
        return this;
    };

    /**
     * Resets to the last state and appends the fork state's current write length as a varint followed by its operations.
     * @returns {Writer} `this`
     */
    Writer$1.prototype.ldelim = function ldelim() {
        var head = this.head,
            tail = this.tail,
            len  = this.len;
        this.reset().uint32(len);
        if (len) {
            this.tail.next = head.next; // skip noop
            this.tail = tail;
            this.len += len;
        }
        return this;
    };

    /**
     * Finishes the write operation.
     * @returns {Uint8Array} Finished buffer
     */
    Writer$1.prototype.finish = function finish() {
        var head = this.head.next, // skip noop
            buf  = this.constructor.alloc(this.len),
            pos  = 0;
        while (head) {
            head.fn(head.val, buf, pos);
            pos += head.len;
            head = head.next;
        }
        // this.head = this.tail = null;
        return buf;
    };

    Writer$1._configure = function(BufferWriter_) {
        BufferWriter$1 = BufferWriter_;
        Writer$1.create = create$1();
        BufferWriter$1._configure();
    };

    var writer_buffer = BufferWriter;

    // extends Writer
    var Writer = writer;
    (BufferWriter.prototype = Object.create(Writer.prototype)).constructor = BufferWriter;

    var util$4 = requireMinimal();

    /**
     * Constructs a new buffer writer instance.
     * @classdesc Wire format writer using node buffers.
     * @extends Writer
     * @constructor
     */
    function BufferWriter() {
        Writer.call(this);
    }

    BufferWriter._configure = function () {
        /**
         * Allocates a buffer of the specified size.
         * @function
         * @param {number} size Buffer size
         * @returns {Buffer} Buffer
         */
        BufferWriter.alloc = util$4._Buffer_allocUnsafe;

        BufferWriter.writeBytesBuffer = util$4.Buffer && util$4.Buffer.prototype instanceof Uint8Array && util$4.Buffer.prototype.set.name === "set"
            ? function writeBytesBuffer_set(val, buf, pos) {
              buf.set(val, pos); // faster than copy (requires node >= 4 where Buffers extend Uint8Array and set is properly inherited)
              // also works for plain array values
            }
            /* istanbul ignore next */
            : function writeBytesBuffer_copy(val, buf, pos) {
              if (val.copy) // Buffer values
                val.copy(buf, pos, 0, val.length);
              else for (var i = 0; i < val.length;) // plain array values
                buf[pos++] = val[i++];
            };
    };


    /**
     * @override
     */
    BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
        if (util$4.isString(value))
            value = util$4._Buffer_from(value, "base64");
        var len = value.length >>> 0;
        this.uint32(len);
        if (len)
            this._push(BufferWriter.writeBytesBuffer, len, value);
        return this;
    };

    function writeStringBuffer(val, buf, pos) {
        if (val.length < 40) // plain js is faster for short strings (probably due to redundant assertions)
            util$4.utf8.write(val, buf, pos);
        else if (buf.utf8Write)
            buf.utf8Write(val, pos);
        else
            buf.write(val, pos);
    }

    /**
     * @override
     */
    BufferWriter.prototype.string = function write_string_buffer(value) {
        var len = util$4.Buffer.byteLength(value);
        this.uint32(len);
        if (len)
            this._push(writeStringBuffer, len, value);
        return this;
    };


    /**
     * Finishes the write operation.
     * @name BufferWriter#finish
     * @function
     * @returns {Buffer} Finished buffer
     */

    BufferWriter._configure();

    var reader = Reader$1;

    var util$3      = requireMinimal();

    var BufferReader$1; // cyclic

    var LongBits  = util$3.LongBits,
        utf8      = util$3.utf8;

    /* istanbul ignore next */
    function indexOutOfRange(reader, writeLength) {
        return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
    }

    /**
     * Constructs a new reader instance using the specified buffer.
     * @classdesc Wire format reader using `Uint8Array` if available, otherwise `Array`.
     * @constructor
     * @param {Uint8Array} buffer Buffer to read from
     */
    function Reader$1(buffer) {

        /**
         * Read buffer.
         * @type {Uint8Array}
         */
        this.buf = buffer;

        /**
         * Read buffer position.
         * @type {number}
         */
        this.pos = 0;

        /**
         * Read buffer length.
         * @type {number}
         */
        this.len = buffer.length;
    }

    var create_array = typeof Uint8Array !== "undefined"
        ? function create_typed_array(buffer) {
            if (buffer instanceof Uint8Array || Array.isArray(buffer))
                return new Reader$1(buffer);
            throw Error("illegal buffer");
        }
        /* istanbul ignore next */
        : function create_array(buffer) {
            if (Array.isArray(buffer))
                return new Reader$1(buffer);
            throw Error("illegal buffer");
        };

    var create = function create() {
        return util$3.Buffer
            ? function create_buffer_setup(buffer) {
                return (Reader$1.create = function create_buffer(buffer) {
                    return util$3.Buffer.isBuffer(buffer)
                        ? new BufferReader$1(buffer)
                        /* istanbul ignore next */
                        : create_array(buffer);
                })(buffer);
            }
            /* istanbul ignore next */
            : create_array;
    };

    /**
     * Creates a new reader using the specified buffer.
     * @function
     * @param {Uint8Array|Buffer} buffer Buffer to read from
     * @returns {Reader|BufferReader} A {@link BufferReader} if `buffer` is a Buffer, otherwise a {@link Reader}
     * @throws {Error} If `buffer` is not a valid buffer
     */
    Reader$1.create = create();

    Reader$1.prototype._slice = util$3.Array.prototype.subarray || /* istanbul ignore next */ util$3.Array.prototype.slice;

    /**
     * Reads a varint as an unsigned 32 bit value.
     * @function
     * @returns {number} Value read
     */
    Reader$1.prototype.uint32 = (function read_uint32_setup() {
        var value = 4294967295; // optimizer type-hint, tends to deopt otherwise (?!)
        return function read_uint32() {
            value = (         this.buf[this.pos] & 127       ) >>> 0; if (this.buf[this.pos++] < 128) return value;
            value = (value | (this.buf[this.pos] & 127) <<  7) >>> 0; if (this.buf[this.pos++] < 128) return value;
            value = (value | (this.buf[this.pos] & 127) << 14) >>> 0; if (this.buf[this.pos++] < 128) return value;
            value = (value | (this.buf[this.pos] & 127) << 21) >>> 0; if (this.buf[this.pos++] < 128) return value;
            value = (value | (this.buf[this.pos] &  15) << 28) >>> 0; if (this.buf[this.pos++] < 128) return value;

            /* istanbul ignore if */
            if ((this.pos += 5) > this.len) {
                this.pos = this.len;
                throw indexOutOfRange(this, 10);
            }
            return value;
        };
    })();

    /**
     * Reads a varint as a signed 32 bit value.
     * @returns {number} Value read
     */
    Reader$1.prototype.int32 = function read_int32() {
        return this.uint32() | 0;
    };

    /**
     * Reads a zig-zag encoded varint as a signed 32 bit value.
     * @returns {number} Value read
     */
    Reader$1.prototype.sint32 = function read_sint32() {
        var value = this.uint32();
        return value >>> 1 ^ -(value & 1) | 0;
    };

    /* eslint-disable no-invalid-this */

    function readLongVarint() {
        // tends to deopt with local vars for octet etc.
        var bits = new LongBits(0, 0);
        var i = 0;
        if (this.len - this.pos > 4) { // fast route (lo)
            for (; i < 4; ++i) {
                // 1st..4th
                bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
                if (this.buf[this.pos++] < 128)
                    return bits;
            }
            // 5th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
            bits.hi = (bits.hi | (this.buf[this.pos] & 127) >>  4) >>> 0;
            if (this.buf[this.pos++] < 128)
                return bits;
            i = 0;
        } else {
            for (; i < 3; ++i) {
                /* istanbul ignore if */
                if (this.pos >= this.len)
                    throw indexOutOfRange(this);
                // 1st..3th
                bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
                if (this.buf[this.pos++] < 128)
                    return bits;
            }
            // 4th
            bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
            return bits;
        }
        if (this.len - this.pos > 4) { // fast route (hi)
            for (; i < 5; ++i) {
                // 6th..10th
                bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
                if (this.buf[this.pos++] < 128)
                    return bits;
            }
        } else {
            for (; i < 5; ++i) {
                /* istanbul ignore if */
                if (this.pos >= this.len)
                    throw indexOutOfRange(this);
                // 6th..10th
                bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
                if (this.buf[this.pos++] < 128)
                    return bits;
            }
        }
        /* istanbul ignore next */
        throw Error("invalid varint encoding");
    }

    /* eslint-enable no-invalid-this */

    /**
     * Reads a varint as a signed 64 bit value.
     * @name Reader#int64
     * @function
     * @returns {Long} Value read
     */

    /**
     * Reads a varint as an unsigned 64 bit value.
     * @name Reader#uint64
     * @function
     * @returns {Long} Value read
     */

    /**
     * Reads a zig-zag encoded varint as a signed 64 bit value.
     * @name Reader#sint64
     * @function
     * @returns {Long} Value read
     */

    /**
     * Reads a varint as a boolean.
     * @returns {boolean} Value read
     */
    Reader$1.prototype.bool = function read_bool() {
        return this.uint32() !== 0;
    };

    function readFixed32_end(buf, end) { // note that this uses `end`, not `pos`
        return (buf[end - 4]
              | buf[end - 3] << 8
              | buf[end - 2] << 16
              | buf[end - 1] << 24) >>> 0;
    }

    /**
     * Reads fixed 32 bits as an unsigned 32 bit integer.
     * @returns {number} Value read
     */
    Reader$1.prototype.fixed32 = function read_fixed32() {

        /* istanbul ignore if */
        if (this.pos + 4 > this.len)
            throw indexOutOfRange(this, 4);

        return readFixed32_end(this.buf, this.pos += 4);
    };

    /**
     * Reads fixed 32 bits as a signed 32 bit integer.
     * @returns {number} Value read
     */
    Reader$1.prototype.sfixed32 = function read_sfixed32() {

        /* istanbul ignore if */
        if (this.pos + 4 > this.len)
            throw indexOutOfRange(this, 4);

        return readFixed32_end(this.buf, this.pos += 4) | 0;
    };

    /* eslint-disable no-invalid-this */

    function readFixed64(/* this: Reader */) {

        /* istanbul ignore if */
        if (this.pos + 8 > this.len)
            throw indexOutOfRange(this, 8);

        return new LongBits(readFixed32_end(this.buf, this.pos += 4), readFixed32_end(this.buf, this.pos += 4));
    }

    /* eslint-enable no-invalid-this */

    /**
     * Reads fixed 64 bits.
     * @name Reader#fixed64
     * @function
     * @returns {Long} Value read
     */

    /**
     * Reads zig-zag encoded fixed 64 bits.
     * @name Reader#sfixed64
     * @function
     * @returns {Long} Value read
     */

    /**
     * Reads a float (32 bit) as a number.
     * @function
     * @returns {number} Value read
     */
    Reader$1.prototype.float = function read_float() {

        /* istanbul ignore if */
        if (this.pos + 4 > this.len)
            throw indexOutOfRange(this, 4);

        var value = util$3.float.readFloatLE(this.buf, this.pos);
        this.pos += 4;
        return value;
    };

    /**
     * Reads a double (64 bit float) as a number.
     * @function
     * @returns {number} Value read
     */
    Reader$1.prototype.double = function read_double() {

        /* istanbul ignore if */
        if (this.pos + 8 > this.len)
            throw indexOutOfRange(this, 4);

        var value = util$3.float.readDoubleLE(this.buf, this.pos);
        this.pos += 8;
        return value;
    };

    /**
     * Reads a sequence of bytes preceeded by its length as a varint.
     * @returns {Uint8Array} Value read
     */
    Reader$1.prototype.bytes = function read_bytes() {
        var length = this.uint32(),
            start  = this.pos,
            end    = this.pos + length;

        /* istanbul ignore if */
        if (end > this.len)
            throw indexOutOfRange(this, length);

        this.pos += length;
        if (Array.isArray(this.buf)) // plain array
            return this.buf.slice(start, end);
        return start === end // fix for IE 10/Win8 and others' subarray returning array of size 1
            ? new this.buf.constructor(0)
            : this._slice.call(this.buf, start, end);
    };

    /**
     * Reads a string preceeded by its byte length as a varint.
     * @returns {string} Value read
     */
    Reader$1.prototype.string = function read_string() {
        var bytes = this.bytes();
        return utf8.read(bytes, 0, bytes.length);
    };

    /**
     * Skips the specified number of bytes if specified, otherwise skips a varint.
     * @param {number} [length] Length if known, otherwise a varint is assumed
     * @returns {Reader} `this`
     */
    Reader$1.prototype.skip = function skip(length) {
        if (typeof length === "number") {
            /* istanbul ignore if */
            if (this.pos + length > this.len)
                throw indexOutOfRange(this, length);
            this.pos += length;
        } else {
            do {
                /* istanbul ignore if */
                if (this.pos >= this.len)
                    throw indexOutOfRange(this);
            } while (this.buf[this.pos++] & 128);
        }
        return this;
    };

    /**
     * Skips the next element of the specified wire type.
     * @param {number} wireType Wire type received
     * @returns {Reader} `this`
     */
    Reader$1.prototype.skipType = function(wireType) {
        switch (wireType) {
            case 0:
                this.skip();
                break;
            case 1:
                this.skip(8);
                break;
            case 2:
                this.skip(this.uint32());
                break;
            case 3:
                while ((wireType = this.uint32() & 7) !== 4) {
                    this.skipType(wireType);
                }
                break;
            case 5:
                this.skip(4);
                break;

            /* istanbul ignore next */
            default:
                throw Error("invalid wire type " + wireType + " at offset " + this.pos);
        }
        return this;
    };

    Reader$1._configure = function(BufferReader_) {
        BufferReader$1 = BufferReader_;
        Reader$1.create = create();
        BufferReader$1._configure();

        var fn = util$3.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
        util$3.merge(Reader$1.prototype, {

            int64: function read_int64() {
                return readLongVarint.call(this)[fn](false);
            },

            uint64: function read_uint64() {
                return readLongVarint.call(this)[fn](true);
            },

            sint64: function read_sint64() {
                return readLongVarint.call(this).zzDecode()[fn](false);
            },

            fixed64: function read_fixed64() {
                return readFixed64.call(this)[fn](true);
            },

            sfixed64: function read_sfixed64() {
                return readFixed64.call(this)[fn](false);
            }

        });
    };

    var reader_buffer = BufferReader;

    // extends Reader
    var Reader = reader;
    (BufferReader.prototype = Object.create(Reader.prototype)).constructor = BufferReader;

    var util$2 = requireMinimal();

    /**
     * Constructs a new buffer reader instance.
     * @classdesc Wire format reader using node buffers.
     * @extends Reader
     * @constructor
     * @param {Buffer} buffer Buffer to read from
     */
    function BufferReader(buffer) {
        Reader.call(this, buffer);

        /**
         * Read buffer.
         * @name BufferReader#buf
         * @type {Buffer}
         */
    }

    BufferReader._configure = function () {
        /* istanbul ignore else */
        if (util$2.Buffer)
            BufferReader.prototype._slice = util$2.Buffer.prototype.slice;
    };


    /**
     * @override
     */
    BufferReader.prototype.string = function read_string_buffer() {
        var len = this.uint32(); // modifies pos
        return this.buf.utf8Slice
            ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len))
            : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
    };

    /**
     * Reads a sequence of bytes preceeded by its length as a varint.
     * @name BufferReader#bytes
     * @function
     * @returns {Buffer} Value read
     */

    BufferReader._configure();

    var rpc = {};

    var service = Service;

    var util$1 = requireMinimal();

    // Extends EventEmitter
    (Service.prototype = Object.create(util$1.EventEmitter.prototype)).constructor = Service;

    /**
     * A service method callback as used by {@link rpc.ServiceMethod|ServiceMethod}.
     *
     * Differs from {@link RPCImplCallback} in that it is an actual callback of a service method which may not return `response = null`.
     * @typedef rpc.ServiceMethodCallback
     * @template TRes extends Message<TRes>
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {TRes} [response] Response message
     * @returns {undefined}
     */

    /**
     * A service method part of a {@link rpc.Service} as created by {@link Service.create}.
     * @typedef rpc.ServiceMethod
     * @template TReq extends Message<TReq>
     * @template TRes extends Message<TRes>
     * @type {function}
     * @param {TReq|Properties<TReq>} request Request message or plain object
     * @param {rpc.ServiceMethodCallback<TRes>} [callback] Node-style callback called with the error, if any, and the response message
     * @returns {Promise<Message<TRes>>} Promise if `callback` has been omitted, otherwise `undefined`
     */

    /**
     * Constructs a new RPC service instance.
     * @classdesc An RPC service as returned by {@link Service#create}.
     * @exports rpc.Service
     * @extends util.EventEmitter
     * @constructor
     * @param {RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     */
    function Service(rpcImpl, requestDelimited, responseDelimited) {

        if (typeof rpcImpl !== "function")
            throw TypeError("rpcImpl must be a function");

        util$1.EventEmitter.call(this);

        /**
         * RPC implementation. Becomes `null` once the service is ended.
         * @type {RPCImpl|null}
         */
        this.rpcImpl = rpcImpl;

        /**
         * Whether requests are length-delimited.
         * @type {boolean}
         */
        this.requestDelimited = Boolean(requestDelimited);

        /**
         * Whether responses are length-delimited.
         * @type {boolean}
         */
        this.responseDelimited = Boolean(responseDelimited);
    }

    /**
     * Calls a service method through {@link rpc.Service#rpcImpl|rpcImpl}.
     * @param {Method|rpc.ServiceMethod<TReq,TRes>} method Reflected or static method
     * @param {Constructor<TReq>} requestCtor Request constructor
     * @param {Constructor<TRes>} responseCtor Response constructor
     * @param {TReq|Properties<TReq>} request Request message or plain object
     * @param {rpc.ServiceMethodCallback<TRes>} callback Service callback
     * @returns {undefined}
     * @template TReq extends Message<TReq>
     * @template TRes extends Message<TRes>
     */
    Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {

        if (!request)
            throw TypeError("request must be specified");

        var self = this;
        if (!callback)
            return util$1.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);

        if (!self.rpcImpl) {
            setTimeout(function() { callback(Error("already ended")); }, 0);
            return undefined;
        }

        try {
            return self.rpcImpl(
                method,
                requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(),
                function rpcCallback(err, response) {

                    if (err) {
                        self.emit("error", err, method);
                        return callback(err);
                    }

                    if (response === null) {
                        self.end(/* endedByRPC */ true);
                        return undefined;
                    }

                    if (!(response instanceof responseCtor)) {
                        try {
                            response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
                        } catch (err) {
                            self.emit("error", err, method);
                            return callback(err);
                        }
                    }

                    self.emit("data", response, method);
                    return callback(null, response);
                }
            );
        } catch (err) {
            self.emit("error", err, method);
            setTimeout(function() { callback(err); }, 0);
            return undefined;
        }
    };

    /**
     * Ends this service and emits the `end` event.
     * @param {boolean} [endedByRPC=false] Whether the service has been ended by the RPC implementation.
     * @returns {rpc.Service} `this`
     */
    Service.prototype.end = function end(endedByRPC) {
        if (this.rpcImpl) {
            if (!endedByRPC) // signal end to rpcImpl
                this.rpcImpl(null, null, null);
            this.rpcImpl = null;
            this.emit("end").off();
        }
        return this;
    };

    (function (exports) {

    	/**
    	 * Streaming RPC helpers.
    	 * @namespace
    	 */
    	var rpc = exports;

    	/**
    	 * RPC implementation passed to {@link Service#create} performing a service request on network level, i.e. by utilizing http requests or websockets.
    	 * @typedef RPCImpl
    	 * @type {function}
    	 * @param {Method|rpc.ServiceMethod<Message<{}>,Message<{}>>} method Reflected or static method being called
    	 * @param {Uint8Array} requestData Request data
    	 * @param {RPCImplCallback} callback Callback function
    	 * @returns {undefined}
    	 * @example
    	 * function rpcImpl(method, requestData, callback) {
    	 *     if (protobuf.util.lcFirst(method.name) !== "myMethod") // compatible with static code
    	 *         throw Error("no such method");
    	 *     asynchronouslyObtainAResponse(requestData, function(err, responseData) {
    	 *         callback(err, responseData);
    	 *     });
    	 * }
    	 */

    	/**
    	 * Node-style callback as used by {@link RPCImpl}.
    	 * @typedef RPCImplCallback
    	 * @type {function}
    	 * @param {Error|null} error Error, if any, otherwise `null`
    	 * @param {Uint8Array|null} [response] Response data or `null` to signal end of stream, if there hasn't been an error
    	 * @returns {undefined}
    	 */

    	rpc.Service = service; 
    } (rpc));

    var roots = {};

    (function (exports) {
    	var protobuf = exports;

    	/**
    	 * Build type, one of `"full"`, `"light"` or `"minimal"`.
    	 * @name build
    	 * @type {string}
    	 * @const
    	 */
    	protobuf.build = "minimal";

    	// Serialization
    	protobuf.Writer       = writer;
    	protobuf.BufferWriter = writer_buffer;
    	protobuf.Reader       = reader;
    	protobuf.BufferReader = reader_buffer;

    	// Utility
    	protobuf.util         = requireMinimal();
    	protobuf.rpc          = rpc;
    	protobuf.roots        = roots;
    	protobuf.configure    = configure;

    	/* istanbul ignore next */
    	/**
    	 * Reconfigures the library according to the environment.
    	 * @returns {undefined}
    	 */
    	function configure() {
    	    protobuf.util._configure();
    	    protobuf.Writer._configure(protobuf.BufferWriter);
    	    protobuf.Reader._configure(protobuf.BufferReader);
    	}

    	// Set up buffer utility according to the environment
    	configure(); 
    } (indexMinimal));

    var minimal = indexMinimal;

    /*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/

    var $protobuf = minimal;

    // Common aliases
    var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

    // Exported root namespace
    var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

    $root.ZilliqaMessage = (function() {

        /**
         * Namespace ZilliqaMessage.
         * @exports ZilliqaMessage
         * @namespace
         */
        var ZilliqaMessage = {};

        ZilliqaMessage.ByteArray = (function() {

            /**
             * Properties of a ByteArray.
             * @memberof ZilliqaMessage
             * @interface IByteArray
             * @property {Uint8Array} data ByteArray data
             */

            /**
             * Constructs a new ByteArray.
             * @memberof ZilliqaMessage
             * @classdesc Represents a ByteArray.
             * @implements IByteArray
             * @constructor
             * @param {ZilliqaMessage.IByteArray=} [properties] Properties to set
             */
            function ByteArray(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ByteArray data.
             * @member {Uint8Array} data
             * @memberof ZilliqaMessage.ByteArray
             * @instance
             */
            ByteArray.prototype.data = $util.newBuffer([]);

            /**
             * Creates a new ByteArray instance using the specified properties.
             * @function create
             * @memberof ZilliqaMessage.ByteArray
             * @static
             * @param {ZilliqaMessage.IByteArray=} [properties] Properties to set
             * @returns {ZilliqaMessage.ByteArray} ByteArray instance
             */
            ByteArray.create = function create(properties) {
                return new ByteArray(properties);
            };

            /**
             * Encodes the specified ByteArray message. Does not implicitly {@link ZilliqaMessage.ByteArray.verify|verify} messages.
             * @function encode
             * @memberof ZilliqaMessage.ByteArray
             * @static
             * @param {ZilliqaMessage.IByteArray} message ByteArray message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ByteArray.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.data);
                return writer;
            };

            /**
             * Encodes the specified ByteArray message, length delimited. Does not implicitly {@link ZilliqaMessage.ByteArray.verify|verify} messages.
             * @function encodeDelimited
             * @memberof ZilliqaMessage.ByteArray
             * @static
             * @param {ZilliqaMessage.IByteArray} message ByteArray message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ByteArray.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ByteArray message from the specified reader or buffer.
             * @function decode
             * @memberof ZilliqaMessage.ByteArray
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {ZilliqaMessage.ByteArray} ByteArray
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ByteArray.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ZilliqaMessage.ByteArray();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.data = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("data"))
                    throw $util.ProtocolError("missing required 'data'", { instance: message });
                return message;
            };

            /**
             * Decodes a ByteArray message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof ZilliqaMessage.ByteArray
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {ZilliqaMessage.ByteArray} ByteArray
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ByteArray.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ByteArray message.
             * @function verify
             * @memberof ZilliqaMessage.ByteArray
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ByteArray.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
                return null;
            };

            /**
             * Creates a ByteArray message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof ZilliqaMessage.ByteArray
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {ZilliqaMessage.ByteArray} ByteArray
             */
            ByteArray.fromObject = function fromObject(object) {
                if (object instanceof $root.ZilliqaMessage.ByteArray)
                    return object;
                var message = new $root.ZilliqaMessage.ByteArray();
                if (object.data != null)
                    if (typeof object.data === "string")
                        $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                    else if (object.data.length)
                        message.data = object.data;
                return message;
            };

            /**
             * Creates a plain object from a ByteArray message. Also converts values to other types if specified.
             * @function toObject
             * @memberof ZilliqaMessage.ByteArray
             * @static
             * @param {ZilliqaMessage.ByteArray} message ByteArray
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ByteArray.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    if (options.bytes === String)
                        object.data = "";
                    else {
                        object.data = [];
                        if (options.bytes !== Array)
                            object.data = $util.newBuffer(object.data);
                    }
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
                return object;
            };

            /**
             * Converts this ByteArray to JSON.
             * @function toJSON
             * @memberof ZilliqaMessage.ByteArray
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ByteArray.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ByteArray;
        })();

        ZilliqaMessage.ProtoTransactionCoreInfo = (function() {

            /**
             * Properties of a ProtoTransactionCoreInfo.
             * @memberof ZilliqaMessage
             * @interface IProtoTransactionCoreInfo
             * @property {number|null} [version] ProtoTransactionCoreInfo version
             * @property {number|Long|null} [nonce] ProtoTransactionCoreInfo nonce
             * @property {Uint8Array|null} [toaddr] ProtoTransactionCoreInfo toaddr
             * @property {ZilliqaMessage.IByteArray|null} [senderpubkey] ProtoTransactionCoreInfo senderpubkey
             * @property {ZilliqaMessage.IByteArray|null} [amount] ProtoTransactionCoreInfo amount
             * @property {ZilliqaMessage.IByteArray|null} [gasprice] ProtoTransactionCoreInfo gasprice
             * @property {number|Long|null} [gaslimit] ProtoTransactionCoreInfo gaslimit
             * @property {Uint8Array|null} [code] ProtoTransactionCoreInfo code
             * @property {Uint8Array|null} [data] ProtoTransactionCoreInfo data
             */

            /**
             * Constructs a new ProtoTransactionCoreInfo.
             * @memberof ZilliqaMessage
             * @classdesc Represents a ProtoTransactionCoreInfo.
             * @implements IProtoTransactionCoreInfo
             * @constructor
             * @param {ZilliqaMessage.IProtoTransactionCoreInfo=} [properties] Properties to set
             */
            function ProtoTransactionCoreInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ProtoTransactionCoreInfo version.
             * @member {number} version
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @instance
             */
            ProtoTransactionCoreInfo.prototype.version = 0;

            /**
             * ProtoTransactionCoreInfo nonce.
             * @member {number|Long} nonce
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @instance
             */
            ProtoTransactionCoreInfo.prototype.nonce = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * ProtoTransactionCoreInfo toaddr.
             * @member {Uint8Array} toaddr
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @instance
             */
            ProtoTransactionCoreInfo.prototype.toaddr = $util.newBuffer([]);

            /**
             * ProtoTransactionCoreInfo senderpubkey.
             * @member {ZilliqaMessage.IByteArray|null|undefined} senderpubkey
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @instance
             */
            ProtoTransactionCoreInfo.prototype.senderpubkey = null;

            /**
             * ProtoTransactionCoreInfo amount.
             * @member {ZilliqaMessage.IByteArray|null|undefined} amount
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @instance
             */
            ProtoTransactionCoreInfo.prototype.amount = null;

            /**
             * ProtoTransactionCoreInfo gasprice.
             * @member {ZilliqaMessage.IByteArray|null|undefined} gasprice
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @instance
             */
            ProtoTransactionCoreInfo.prototype.gasprice = null;

            /**
             * ProtoTransactionCoreInfo gaslimit.
             * @member {number|Long} gaslimit
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @instance
             */
            ProtoTransactionCoreInfo.prototype.gaslimit = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * ProtoTransactionCoreInfo code.
             * @member {Uint8Array} code
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @instance
             */
            ProtoTransactionCoreInfo.prototype.code = $util.newBuffer([]);

            /**
             * ProtoTransactionCoreInfo data.
             * @member {Uint8Array} data
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @instance
             */
            ProtoTransactionCoreInfo.prototype.data = $util.newBuffer([]);

            /**
             * Creates a new ProtoTransactionCoreInfo instance using the specified properties.
             * @function create
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @static
             * @param {ZilliqaMessage.IProtoTransactionCoreInfo=} [properties] Properties to set
             * @returns {ZilliqaMessage.ProtoTransactionCoreInfo} ProtoTransactionCoreInfo instance
             */
            ProtoTransactionCoreInfo.create = function create(properties) {
                return new ProtoTransactionCoreInfo(properties);
            };

            /**
             * Encodes the specified ProtoTransactionCoreInfo message. Does not implicitly {@link ZilliqaMessage.ProtoTransactionCoreInfo.verify|verify} messages.
             * @function encode
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @static
             * @param {ZilliqaMessage.IProtoTransactionCoreInfo} message ProtoTransactionCoreInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ProtoTransactionCoreInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.version);
                if (message.nonce != null && Object.hasOwnProperty.call(message, "nonce"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.nonce);
                if (message.toaddr != null && Object.hasOwnProperty.call(message, "toaddr"))
                    writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.toaddr);
                if (message.senderpubkey != null && Object.hasOwnProperty.call(message, "senderpubkey"))
                    $root.ZilliqaMessage.ByteArray.encode(message.senderpubkey, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    $root.ZilliqaMessage.ByteArray.encode(message.amount, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.gasprice != null && Object.hasOwnProperty.call(message, "gasprice"))
                    $root.ZilliqaMessage.ByteArray.encode(message.gasprice, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.gaslimit != null && Object.hasOwnProperty.call(message, "gaslimit"))
                    writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.gaslimit);
                if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                    writer.uint32(/* id 8, wireType 2 =*/66).bytes(message.code);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    writer.uint32(/* id 9, wireType 2 =*/74).bytes(message.data);
                return writer;
            };

            /**
             * Encodes the specified ProtoTransactionCoreInfo message, length delimited. Does not implicitly {@link ZilliqaMessage.ProtoTransactionCoreInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @static
             * @param {ZilliqaMessage.IProtoTransactionCoreInfo} message ProtoTransactionCoreInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ProtoTransactionCoreInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ProtoTransactionCoreInfo message from the specified reader or buffer.
             * @function decode
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {ZilliqaMessage.ProtoTransactionCoreInfo} ProtoTransactionCoreInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ProtoTransactionCoreInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ZilliqaMessage.ProtoTransactionCoreInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.version = reader.uint32();
                        break;
                    case 2:
                        message.nonce = reader.uint64();
                        break;
                    case 3:
                        message.toaddr = reader.bytes();
                        break;
                    case 4:
                        message.senderpubkey = $root.ZilliqaMessage.ByteArray.decode(reader, reader.uint32());
                        break;
                    case 5:
                        message.amount = $root.ZilliqaMessage.ByteArray.decode(reader, reader.uint32());
                        break;
                    case 6:
                        message.gasprice = $root.ZilliqaMessage.ByteArray.decode(reader, reader.uint32());
                        break;
                    case 7:
                        message.gaslimit = reader.uint64();
                        break;
                    case 8:
                        message.code = reader.bytes();
                        break;
                    case 9:
                        message.data = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ProtoTransactionCoreInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {ZilliqaMessage.ProtoTransactionCoreInfo} ProtoTransactionCoreInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ProtoTransactionCoreInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ProtoTransactionCoreInfo message.
             * @function verify
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ProtoTransactionCoreInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.version != null && message.hasOwnProperty("version"))
                    if (!$util.isInteger(message.version))
                        return "version: integer expected";
                if (message.nonce != null && message.hasOwnProperty("nonce"))
                    if (!$util.isInteger(message.nonce) && !(message.nonce && $util.isInteger(message.nonce.low) && $util.isInteger(message.nonce.high)))
                        return "nonce: integer|Long expected";
                if (message.toaddr != null && message.hasOwnProperty("toaddr"))
                    if (!(message.toaddr && typeof message.toaddr.length === "number" || $util.isString(message.toaddr)))
                        return "toaddr: buffer expected";
                if (message.senderpubkey != null && message.hasOwnProperty("senderpubkey")) {
                    var error = $root.ZilliqaMessage.ByteArray.verify(message.senderpubkey);
                    if (error)
                        return "senderpubkey." + error;
                }
                if (message.amount != null && message.hasOwnProperty("amount")) {
                    var error = $root.ZilliqaMessage.ByteArray.verify(message.amount);
                    if (error)
                        return "amount." + error;
                }
                if (message.gasprice != null && message.hasOwnProperty("gasprice")) {
                    var error = $root.ZilliqaMessage.ByteArray.verify(message.gasprice);
                    if (error)
                        return "gasprice." + error;
                }
                if (message.gaslimit != null && message.hasOwnProperty("gaslimit"))
                    if (!$util.isInteger(message.gaslimit) && !(message.gaslimit && $util.isInteger(message.gaslimit.low) && $util.isInteger(message.gaslimit.high)))
                        return "gaslimit: integer|Long expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!(message.code && typeof message.code.length === "number" || $util.isString(message.code)))
                        return "code: buffer expected";
                if (message.data != null && message.hasOwnProperty("data"))
                    if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                        return "data: buffer expected";
                return null;
            };

            /**
             * Creates a ProtoTransactionCoreInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {ZilliqaMessage.ProtoTransactionCoreInfo} ProtoTransactionCoreInfo
             */
            ProtoTransactionCoreInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.ZilliqaMessage.ProtoTransactionCoreInfo)
                    return object;
                var message = new $root.ZilliqaMessage.ProtoTransactionCoreInfo();
                if (object.version != null)
                    message.version = object.version >>> 0;
                if (object.nonce != null)
                    if ($util.Long)
                        (message.nonce = $util.Long.fromValue(object.nonce)).unsigned = true;
                    else if (typeof object.nonce === "string")
                        message.nonce = parseInt(object.nonce, 10);
                    else if (typeof object.nonce === "number")
                        message.nonce = object.nonce;
                    else if (typeof object.nonce === "object")
                        message.nonce = new $util.LongBits(object.nonce.low >>> 0, object.nonce.high >>> 0).toNumber(true);
                if (object.toaddr != null)
                    if (typeof object.toaddr === "string")
                        $util.base64.decode(object.toaddr, message.toaddr = $util.newBuffer($util.base64.length(object.toaddr)), 0);
                    else if (object.toaddr.length)
                        message.toaddr = object.toaddr;
                if (object.senderpubkey != null) {
                    if (typeof object.senderpubkey !== "object")
                        throw TypeError(".ZilliqaMessage.ProtoTransactionCoreInfo.senderpubkey: object expected");
                    message.senderpubkey = $root.ZilliqaMessage.ByteArray.fromObject(object.senderpubkey);
                }
                if (object.amount != null) {
                    if (typeof object.amount !== "object")
                        throw TypeError(".ZilliqaMessage.ProtoTransactionCoreInfo.amount: object expected");
                    message.amount = $root.ZilliqaMessage.ByteArray.fromObject(object.amount);
                }
                if (object.gasprice != null) {
                    if (typeof object.gasprice !== "object")
                        throw TypeError(".ZilliqaMessage.ProtoTransactionCoreInfo.gasprice: object expected");
                    message.gasprice = $root.ZilliqaMessage.ByteArray.fromObject(object.gasprice);
                }
                if (object.gaslimit != null)
                    if ($util.Long)
                        (message.gaslimit = $util.Long.fromValue(object.gaslimit)).unsigned = true;
                    else if (typeof object.gaslimit === "string")
                        message.gaslimit = parseInt(object.gaslimit, 10);
                    else if (typeof object.gaslimit === "number")
                        message.gaslimit = object.gaslimit;
                    else if (typeof object.gaslimit === "object")
                        message.gaslimit = new $util.LongBits(object.gaslimit.low >>> 0, object.gaslimit.high >>> 0).toNumber(true);
                if (object.code != null)
                    if (typeof object.code === "string")
                        $util.base64.decode(object.code, message.code = $util.newBuffer($util.base64.length(object.code)), 0);
                    else if (object.code.length)
                        message.code = object.code;
                if (object.data != null)
                    if (typeof object.data === "string")
                        $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                    else if (object.data.length)
                        message.data = object.data;
                return message;
            };

            /**
             * Creates a plain object from a ProtoTransactionCoreInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @static
             * @param {ZilliqaMessage.ProtoTransactionCoreInfo} message ProtoTransactionCoreInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ProtoTransactionCoreInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.version = 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.nonce = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.nonce = options.longs === String ? "0" : 0;
                    if (options.bytes === String)
                        object.toaddr = "";
                    else {
                        object.toaddr = [];
                        if (options.bytes !== Array)
                            object.toaddr = $util.newBuffer(object.toaddr);
                    }
                    object.senderpubkey = null;
                    object.amount = null;
                    object.gasprice = null;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.gaslimit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.gaslimit = options.longs === String ? "0" : 0;
                    if (options.bytes === String)
                        object.code = "";
                    else {
                        object.code = [];
                        if (options.bytes !== Array)
                            object.code = $util.newBuffer(object.code);
                    }
                    if (options.bytes === String)
                        object.data = "";
                    else {
                        object.data = [];
                        if (options.bytes !== Array)
                            object.data = $util.newBuffer(object.data);
                    }
                }
                if (message.version != null && message.hasOwnProperty("version"))
                    object.version = message.version;
                if (message.nonce != null && message.hasOwnProperty("nonce"))
                    if (typeof message.nonce === "number")
                        object.nonce = options.longs === String ? String(message.nonce) : message.nonce;
                    else
                        object.nonce = options.longs === String ? $util.Long.prototype.toString.call(message.nonce) : options.longs === Number ? new $util.LongBits(message.nonce.low >>> 0, message.nonce.high >>> 0).toNumber(true) : message.nonce;
                if (message.toaddr != null && message.hasOwnProperty("toaddr"))
                    object.toaddr = options.bytes === String ? $util.base64.encode(message.toaddr, 0, message.toaddr.length) : options.bytes === Array ? Array.prototype.slice.call(message.toaddr) : message.toaddr;
                if (message.senderpubkey != null && message.hasOwnProperty("senderpubkey"))
                    object.senderpubkey = $root.ZilliqaMessage.ByteArray.toObject(message.senderpubkey, options);
                if (message.amount != null && message.hasOwnProperty("amount"))
                    object.amount = $root.ZilliqaMessage.ByteArray.toObject(message.amount, options);
                if (message.gasprice != null && message.hasOwnProperty("gasprice"))
                    object.gasprice = $root.ZilliqaMessage.ByteArray.toObject(message.gasprice, options);
                if (message.gaslimit != null && message.hasOwnProperty("gaslimit"))
                    if (typeof message.gaslimit === "number")
                        object.gaslimit = options.longs === String ? String(message.gaslimit) : message.gaslimit;
                    else
                        object.gaslimit = options.longs === String ? $util.Long.prototype.toString.call(message.gaslimit) : options.longs === Number ? new $util.LongBits(message.gaslimit.low >>> 0, message.gaslimit.high >>> 0).toNumber(true) : message.gaslimit;
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = options.bytes === String ? $util.base64.encode(message.code, 0, message.code.length) : options.bytes === Array ? Array.prototype.slice.call(message.code) : message.code;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
                return object;
            };

            /**
             * Converts this ProtoTransactionCoreInfo to JSON.
             * @function toJSON
             * @memberof ZilliqaMessage.ProtoTransactionCoreInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ProtoTransactionCoreInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ProtoTransactionCoreInfo;
        })();

        ZilliqaMessage.ProtoTransaction = (function() {

            /**
             * Properties of a ProtoTransaction.
             * @memberof ZilliqaMessage
             * @interface IProtoTransaction
             * @property {Uint8Array|null} [tranid] ProtoTransaction tranid
             * @property {ZilliqaMessage.IProtoTransactionCoreInfo|null} [info] ProtoTransaction info
             * @property {ZilliqaMessage.IByteArray|null} [signature] ProtoTransaction signature
             */

            /**
             * Constructs a new ProtoTransaction.
             * @memberof ZilliqaMessage
             * @classdesc Represents a ProtoTransaction.
             * @implements IProtoTransaction
             * @constructor
             * @param {ZilliqaMessage.IProtoTransaction=} [properties] Properties to set
             */
            function ProtoTransaction(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ProtoTransaction tranid.
             * @member {Uint8Array} tranid
             * @memberof ZilliqaMessage.ProtoTransaction
             * @instance
             */
            ProtoTransaction.prototype.tranid = $util.newBuffer([]);

            /**
             * ProtoTransaction info.
             * @member {ZilliqaMessage.IProtoTransactionCoreInfo|null|undefined} info
             * @memberof ZilliqaMessage.ProtoTransaction
             * @instance
             */
            ProtoTransaction.prototype.info = null;

            /**
             * ProtoTransaction signature.
             * @member {ZilliqaMessage.IByteArray|null|undefined} signature
             * @memberof ZilliqaMessage.ProtoTransaction
             * @instance
             */
            ProtoTransaction.prototype.signature = null;

            /**
             * Creates a new ProtoTransaction instance using the specified properties.
             * @function create
             * @memberof ZilliqaMessage.ProtoTransaction
             * @static
             * @param {ZilliqaMessage.IProtoTransaction=} [properties] Properties to set
             * @returns {ZilliqaMessage.ProtoTransaction} ProtoTransaction instance
             */
            ProtoTransaction.create = function create(properties) {
                return new ProtoTransaction(properties);
            };

            /**
             * Encodes the specified ProtoTransaction message. Does not implicitly {@link ZilliqaMessage.ProtoTransaction.verify|verify} messages.
             * @function encode
             * @memberof ZilliqaMessage.ProtoTransaction
             * @static
             * @param {ZilliqaMessage.IProtoTransaction} message ProtoTransaction message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ProtoTransaction.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.tranid != null && Object.hasOwnProperty.call(message, "tranid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.tranid);
                if (message.info != null && Object.hasOwnProperty.call(message, "info"))
                    $root.ZilliqaMessage.ProtoTransactionCoreInfo.encode(message.info, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.signature != null && Object.hasOwnProperty.call(message, "signature"))
                    $root.ZilliqaMessage.ByteArray.encode(message.signature, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ProtoTransaction message, length delimited. Does not implicitly {@link ZilliqaMessage.ProtoTransaction.verify|verify} messages.
             * @function encodeDelimited
             * @memberof ZilliqaMessage.ProtoTransaction
             * @static
             * @param {ZilliqaMessage.IProtoTransaction} message ProtoTransaction message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ProtoTransaction.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ProtoTransaction message from the specified reader or buffer.
             * @function decode
             * @memberof ZilliqaMessage.ProtoTransaction
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {ZilliqaMessage.ProtoTransaction} ProtoTransaction
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ProtoTransaction.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ZilliqaMessage.ProtoTransaction();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.tranid = reader.bytes();
                        break;
                    case 2:
                        message.info = $root.ZilliqaMessage.ProtoTransactionCoreInfo.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.signature = $root.ZilliqaMessage.ByteArray.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ProtoTransaction message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof ZilliqaMessage.ProtoTransaction
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {ZilliqaMessage.ProtoTransaction} ProtoTransaction
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ProtoTransaction.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ProtoTransaction message.
             * @function verify
             * @memberof ZilliqaMessage.ProtoTransaction
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ProtoTransaction.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.tranid != null && message.hasOwnProperty("tranid"))
                    if (!(message.tranid && typeof message.tranid.length === "number" || $util.isString(message.tranid)))
                        return "tranid: buffer expected";
                if (message.info != null && message.hasOwnProperty("info")) {
                    var error = $root.ZilliqaMessage.ProtoTransactionCoreInfo.verify(message.info);
                    if (error)
                        return "info." + error;
                }
                if (message.signature != null && message.hasOwnProperty("signature")) {
                    var error = $root.ZilliqaMessage.ByteArray.verify(message.signature);
                    if (error)
                        return "signature." + error;
                }
                return null;
            };

            /**
             * Creates a ProtoTransaction message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof ZilliqaMessage.ProtoTransaction
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {ZilliqaMessage.ProtoTransaction} ProtoTransaction
             */
            ProtoTransaction.fromObject = function fromObject(object) {
                if (object instanceof $root.ZilliqaMessage.ProtoTransaction)
                    return object;
                var message = new $root.ZilliqaMessage.ProtoTransaction();
                if (object.tranid != null)
                    if (typeof object.tranid === "string")
                        $util.base64.decode(object.tranid, message.tranid = $util.newBuffer($util.base64.length(object.tranid)), 0);
                    else if (object.tranid.length)
                        message.tranid = object.tranid;
                if (object.info != null) {
                    if (typeof object.info !== "object")
                        throw TypeError(".ZilliqaMessage.ProtoTransaction.info: object expected");
                    message.info = $root.ZilliqaMessage.ProtoTransactionCoreInfo.fromObject(object.info);
                }
                if (object.signature != null) {
                    if (typeof object.signature !== "object")
                        throw TypeError(".ZilliqaMessage.ProtoTransaction.signature: object expected");
                    message.signature = $root.ZilliqaMessage.ByteArray.fromObject(object.signature);
                }
                return message;
            };

            /**
             * Creates a plain object from a ProtoTransaction message. Also converts values to other types if specified.
             * @function toObject
             * @memberof ZilliqaMessage.ProtoTransaction
             * @static
             * @param {ZilliqaMessage.ProtoTransaction} message ProtoTransaction
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ProtoTransaction.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if (options.bytes === String)
                        object.tranid = "";
                    else {
                        object.tranid = [];
                        if (options.bytes !== Array)
                            object.tranid = $util.newBuffer(object.tranid);
                    }
                    object.info = null;
                    object.signature = null;
                }
                if (message.tranid != null && message.hasOwnProperty("tranid"))
                    object.tranid = options.bytes === String ? $util.base64.encode(message.tranid, 0, message.tranid.length) : options.bytes === Array ? Array.prototype.slice.call(message.tranid) : message.tranid;
                if (message.info != null && message.hasOwnProperty("info"))
                    object.info = $root.ZilliqaMessage.ProtoTransactionCoreInfo.toObject(message.info, options);
                if (message.signature != null && message.hasOwnProperty("signature"))
                    object.signature = $root.ZilliqaMessage.ByteArray.toObject(message.signature, options);
                return object;
            };

            /**
             * Converts this ProtoTransaction to JSON.
             * @function toJSON
             * @memberof ZilliqaMessage.ProtoTransaction
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ProtoTransaction.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ProtoTransaction;
        })();

        ZilliqaMessage.ProtoTransactionReceipt = (function() {

            /**
             * Properties of a ProtoTransactionReceipt.
             * @memberof ZilliqaMessage
             * @interface IProtoTransactionReceipt
             * @property {Uint8Array|null} [receipt] ProtoTransactionReceipt receipt
             * @property {number|Long|null} [cumgas] ProtoTransactionReceipt cumgas
             */

            /**
             * Constructs a new ProtoTransactionReceipt.
             * @memberof ZilliqaMessage
             * @classdesc Represents a ProtoTransactionReceipt.
             * @implements IProtoTransactionReceipt
             * @constructor
             * @param {ZilliqaMessage.IProtoTransactionReceipt=} [properties] Properties to set
             */
            function ProtoTransactionReceipt(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ProtoTransactionReceipt receipt.
             * @member {Uint8Array} receipt
             * @memberof ZilliqaMessage.ProtoTransactionReceipt
             * @instance
             */
            ProtoTransactionReceipt.prototype.receipt = $util.newBuffer([]);

            /**
             * ProtoTransactionReceipt cumgas.
             * @member {number|Long} cumgas
             * @memberof ZilliqaMessage.ProtoTransactionReceipt
             * @instance
             */
            ProtoTransactionReceipt.prototype.cumgas = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new ProtoTransactionReceipt instance using the specified properties.
             * @function create
             * @memberof ZilliqaMessage.ProtoTransactionReceipt
             * @static
             * @param {ZilliqaMessage.IProtoTransactionReceipt=} [properties] Properties to set
             * @returns {ZilliqaMessage.ProtoTransactionReceipt} ProtoTransactionReceipt instance
             */
            ProtoTransactionReceipt.create = function create(properties) {
                return new ProtoTransactionReceipt(properties);
            };

            /**
             * Encodes the specified ProtoTransactionReceipt message. Does not implicitly {@link ZilliqaMessage.ProtoTransactionReceipt.verify|verify} messages.
             * @function encode
             * @memberof ZilliqaMessage.ProtoTransactionReceipt
             * @static
             * @param {ZilliqaMessage.IProtoTransactionReceipt} message ProtoTransactionReceipt message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ProtoTransactionReceipt.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.receipt != null && Object.hasOwnProperty.call(message, "receipt"))
                    writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.receipt);
                if (message.cumgas != null && Object.hasOwnProperty.call(message, "cumgas"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.cumgas);
                return writer;
            };

            /**
             * Encodes the specified ProtoTransactionReceipt message, length delimited. Does not implicitly {@link ZilliqaMessage.ProtoTransactionReceipt.verify|verify} messages.
             * @function encodeDelimited
             * @memberof ZilliqaMessage.ProtoTransactionReceipt
             * @static
             * @param {ZilliqaMessage.IProtoTransactionReceipt} message ProtoTransactionReceipt message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ProtoTransactionReceipt.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ProtoTransactionReceipt message from the specified reader or buffer.
             * @function decode
             * @memberof ZilliqaMessage.ProtoTransactionReceipt
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {ZilliqaMessage.ProtoTransactionReceipt} ProtoTransactionReceipt
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ProtoTransactionReceipt.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ZilliqaMessage.ProtoTransactionReceipt();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.receipt = reader.bytes();
                        break;
                    case 2:
                        message.cumgas = reader.uint64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ProtoTransactionReceipt message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof ZilliqaMessage.ProtoTransactionReceipt
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {ZilliqaMessage.ProtoTransactionReceipt} ProtoTransactionReceipt
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ProtoTransactionReceipt.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ProtoTransactionReceipt message.
             * @function verify
             * @memberof ZilliqaMessage.ProtoTransactionReceipt
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ProtoTransactionReceipt.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.receipt != null && message.hasOwnProperty("receipt"))
                    if (!(message.receipt && typeof message.receipt.length === "number" || $util.isString(message.receipt)))
                        return "receipt: buffer expected";
                if (message.cumgas != null && message.hasOwnProperty("cumgas"))
                    if (!$util.isInteger(message.cumgas) && !(message.cumgas && $util.isInteger(message.cumgas.low) && $util.isInteger(message.cumgas.high)))
                        return "cumgas: integer|Long expected";
                return null;
            };

            /**
             * Creates a ProtoTransactionReceipt message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof ZilliqaMessage.ProtoTransactionReceipt
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {ZilliqaMessage.ProtoTransactionReceipt} ProtoTransactionReceipt
             */
            ProtoTransactionReceipt.fromObject = function fromObject(object) {
                if (object instanceof $root.ZilliqaMessage.ProtoTransactionReceipt)
                    return object;
                var message = new $root.ZilliqaMessage.ProtoTransactionReceipt();
                if (object.receipt != null)
                    if (typeof object.receipt === "string")
                        $util.base64.decode(object.receipt, message.receipt = $util.newBuffer($util.base64.length(object.receipt)), 0);
                    else if (object.receipt.length)
                        message.receipt = object.receipt;
                if (object.cumgas != null)
                    if ($util.Long)
                        (message.cumgas = $util.Long.fromValue(object.cumgas)).unsigned = true;
                    else if (typeof object.cumgas === "string")
                        message.cumgas = parseInt(object.cumgas, 10);
                    else if (typeof object.cumgas === "number")
                        message.cumgas = object.cumgas;
                    else if (typeof object.cumgas === "object")
                        message.cumgas = new $util.LongBits(object.cumgas.low >>> 0, object.cumgas.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from a ProtoTransactionReceipt message. Also converts values to other types if specified.
             * @function toObject
             * @memberof ZilliqaMessage.ProtoTransactionReceipt
             * @static
             * @param {ZilliqaMessage.ProtoTransactionReceipt} message ProtoTransactionReceipt
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ProtoTransactionReceipt.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if (options.bytes === String)
                        object.receipt = "";
                    else {
                        object.receipt = [];
                        if (options.bytes !== Array)
                            object.receipt = $util.newBuffer(object.receipt);
                    }
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.cumgas = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.cumgas = options.longs === String ? "0" : 0;
                }
                if (message.receipt != null && message.hasOwnProperty("receipt"))
                    object.receipt = options.bytes === String ? $util.base64.encode(message.receipt, 0, message.receipt.length) : options.bytes === Array ? Array.prototype.slice.call(message.receipt) : message.receipt;
                if (message.cumgas != null && message.hasOwnProperty("cumgas"))
                    if (typeof message.cumgas === "number")
                        object.cumgas = options.longs === String ? String(message.cumgas) : message.cumgas;
                    else
                        object.cumgas = options.longs === String ? $util.Long.prototype.toString.call(message.cumgas) : options.longs === Number ? new $util.LongBits(message.cumgas.low >>> 0, message.cumgas.high >>> 0).toNumber(true) : message.cumgas;
                return object;
            };

            /**
             * Converts this ProtoTransactionReceipt to JSON.
             * @function toJSON
             * @memberof ZilliqaMessage.ProtoTransactionReceipt
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ProtoTransactionReceipt.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ProtoTransactionReceipt;
        })();

        ZilliqaMessage.ProtoTransactionWithReceipt = (function() {

            /**
             * Properties of a ProtoTransactionWithReceipt.
             * @memberof ZilliqaMessage
             * @interface IProtoTransactionWithReceipt
             * @property {ZilliqaMessage.IProtoTransaction|null} [transaction] ProtoTransactionWithReceipt transaction
             * @property {ZilliqaMessage.IProtoTransactionReceipt|null} [receipt] ProtoTransactionWithReceipt receipt
             */

            /**
             * Constructs a new ProtoTransactionWithReceipt.
             * @memberof ZilliqaMessage
             * @classdesc Represents a ProtoTransactionWithReceipt.
             * @implements IProtoTransactionWithReceipt
             * @constructor
             * @param {ZilliqaMessage.IProtoTransactionWithReceipt=} [properties] Properties to set
             */
            function ProtoTransactionWithReceipt(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ProtoTransactionWithReceipt transaction.
             * @member {ZilliqaMessage.IProtoTransaction|null|undefined} transaction
             * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
             * @instance
             */
            ProtoTransactionWithReceipt.prototype.transaction = null;

            /**
             * ProtoTransactionWithReceipt receipt.
             * @member {ZilliqaMessage.IProtoTransactionReceipt|null|undefined} receipt
             * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
             * @instance
             */
            ProtoTransactionWithReceipt.prototype.receipt = null;

            /**
             * Creates a new ProtoTransactionWithReceipt instance using the specified properties.
             * @function create
             * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
             * @static
             * @param {ZilliqaMessage.IProtoTransactionWithReceipt=} [properties] Properties to set
             * @returns {ZilliqaMessage.ProtoTransactionWithReceipt} ProtoTransactionWithReceipt instance
             */
            ProtoTransactionWithReceipt.create = function create(properties) {
                return new ProtoTransactionWithReceipt(properties);
            };

            /**
             * Encodes the specified ProtoTransactionWithReceipt message. Does not implicitly {@link ZilliqaMessage.ProtoTransactionWithReceipt.verify|verify} messages.
             * @function encode
             * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
             * @static
             * @param {ZilliqaMessage.IProtoTransactionWithReceipt} message ProtoTransactionWithReceipt message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ProtoTransactionWithReceipt.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.transaction != null && Object.hasOwnProperty.call(message, "transaction"))
                    $root.ZilliqaMessage.ProtoTransaction.encode(message.transaction, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.receipt != null && Object.hasOwnProperty.call(message, "receipt"))
                    $root.ZilliqaMessage.ProtoTransactionReceipt.encode(message.receipt, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ProtoTransactionWithReceipt message, length delimited. Does not implicitly {@link ZilliqaMessage.ProtoTransactionWithReceipt.verify|verify} messages.
             * @function encodeDelimited
             * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
             * @static
             * @param {ZilliqaMessage.IProtoTransactionWithReceipt} message ProtoTransactionWithReceipt message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ProtoTransactionWithReceipt.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ProtoTransactionWithReceipt message from the specified reader or buffer.
             * @function decode
             * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {ZilliqaMessage.ProtoTransactionWithReceipt} ProtoTransactionWithReceipt
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ProtoTransactionWithReceipt.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ZilliqaMessage.ProtoTransactionWithReceipt();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.transaction = $root.ZilliqaMessage.ProtoTransaction.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.receipt = $root.ZilliqaMessage.ProtoTransactionReceipt.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ProtoTransactionWithReceipt message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {ZilliqaMessage.ProtoTransactionWithReceipt} ProtoTransactionWithReceipt
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ProtoTransactionWithReceipt.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ProtoTransactionWithReceipt message.
             * @function verify
             * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ProtoTransactionWithReceipt.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.transaction != null && message.hasOwnProperty("transaction")) {
                    var error = $root.ZilliqaMessage.ProtoTransaction.verify(message.transaction);
                    if (error)
                        return "transaction." + error;
                }
                if (message.receipt != null && message.hasOwnProperty("receipt")) {
                    var error = $root.ZilliqaMessage.ProtoTransactionReceipt.verify(message.receipt);
                    if (error)
                        return "receipt." + error;
                }
                return null;
            };

            /**
             * Creates a ProtoTransactionWithReceipt message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {ZilliqaMessage.ProtoTransactionWithReceipt} ProtoTransactionWithReceipt
             */
            ProtoTransactionWithReceipt.fromObject = function fromObject(object) {
                if (object instanceof $root.ZilliqaMessage.ProtoTransactionWithReceipt)
                    return object;
                var message = new $root.ZilliqaMessage.ProtoTransactionWithReceipt();
                if (object.transaction != null) {
                    if (typeof object.transaction !== "object")
                        throw TypeError(".ZilliqaMessage.ProtoTransactionWithReceipt.transaction: object expected");
                    message.transaction = $root.ZilliqaMessage.ProtoTransaction.fromObject(object.transaction);
                }
                if (object.receipt != null) {
                    if (typeof object.receipt !== "object")
                        throw TypeError(".ZilliqaMessage.ProtoTransactionWithReceipt.receipt: object expected");
                    message.receipt = $root.ZilliqaMessage.ProtoTransactionReceipt.fromObject(object.receipt);
                }
                return message;
            };

            /**
             * Creates a plain object from a ProtoTransactionWithReceipt message. Also converts values to other types if specified.
             * @function toObject
             * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
             * @static
             * @param {ZilliqaMessage.ProtoTransactionWithReceipt} message ProtoTransactionWithReceipt
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ProtoTransactionWithReceipt.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.transaction = null;
                    object.receipt = null;
                }
                if (message.transaction != null && message.hasOwnProperty("transaction"))
                    object.transaction = $root.ZilliqaMessage.ProtoTransaction.toObject(message.transaction, options);
                if (message.receipt != null && message.hasOwnProperty("receipt"))
                    object.receipt = $root.ZilliqaMessage.ProtoTransactionReceipt.toObject(message.receipt, options);
                return object;
            };

            /**
             * Converts this ProtoTransactionWithReceipt to JSON.
             * @function toJSON
             * @memberof ZilliqaMessage.ProtoTransactionWithReceipt
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ProtoTransactionWithReceipt.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ProtoTransactionWithReceipt;
        })();

        return ZilliqaMessage;
    })();

    var dist = $root;

    var global$1 = (typeof global !== "undefined" ? global :
      typeof self !== "undefined" ? self :
      typeof window !== "undefined" ? window : {});

    var lookup = [];
    var revLookup = [];
    var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
    var inited = false;
    function init () {
      inited = true;
      var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
      for (var i = 0, len = code.length; i < len; ++i) {
        lookup[i] = code[i];
        revLookup[code.charCodeAt(i)] = i;
      }

      revLookup['-'.charCodeAt(0)] = 62;
      revLookup['_'.charCodeAt(0)] = 63;
    }

    function toByteArray (b64) {
      if (!inited) {
        init();
      }
      var i, j, l, tmp, placeHolders, arr;
      var len = b64.length;

      if (len % 4 > 0) {
        throw new Error('Invalid string. Length must be a multiple of 4')
      }

      // the number of equal signs (place holders)
      // if there are two placeholders, than the two characters before it
      // represent one byte
      // if there is only one, then the three characters before it represent 2 bytes
      // this is just a cheap hack to not do indexOf twice
      placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;

      // base64 is 4/3 + up to two characters of the original data
      arr = new Arr(len * 3 / 4 - placeHolders);

      // if there are placeholders, only get up to the last complete 4 chars
      l = placeHolders > 0 ? len - 4 : len;

      var L = 0;

      for (i = 0, j = 0; i < l; i += 4, j += 3) {
        tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)];
        arr[L++] = (tmp >> 16) & 0xFF;
        arr[L++] = (tmp >> 8) & 0xFF;
        arr[L++] = tmp & 0xFF;
      }

      if (placeHolders === 2) {
        tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4);
        arr[L++] = tmp & 0xFF;
      } else if (placeHolders === 1) {
        tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2);
        arr[L++] = (tmp >> 8) & 0xFF;
        arr[L++] = tmp & 0xFF;
      }

      return arr
    }

    function tripletToBase64 (num) {
      return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
    }

    function encodeChunk (uint8, start, end) {
      var tmp;
      var output = [];
      for (var i = start; i < end; i += 3) {
        tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2]);
        output.push(tripletToBase64(tmp));
      }
      return output.join('')
    }

    function fromByteArray (uint8) {
      if (!inited) {
        init();
      }
      var tmp;
      var len = uint8.length;
      var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
      var output = '';
      var parts = [];
      var maxChunkLength = 16383; // must be multiple of 3

      // go through the array every three bytes, we'll deal with trailing stuff later
      for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
        parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
      }

      // pad the end with zeros, but make sure to not forget the extra bytes
      if (extraBytes === 1) {
        tmp = uint8[len - 1];
        output += lookup[tmp >> 2];
        output += lookup[(tmp << 4) & 0x3F];
        output += '==';
      } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + (uint8[len - 1]);
        output += lookup[tmp >> 10];
        output += lookup[(tmp >> 4) & 0x3F];
        output += lookup[(tmp << 2) & 0x3F];
        output += '=';
      }

      parts.push(output);

      return parts.join('')
    }

    function read (buffer, offset, isLE, mLen, nBytes) {
      var e, m;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var nBits = -7;
      var i = isLE ? (nBytes - 1) : 0;
      var d = isLE ? -1 : 1;
      var s = buffer[offset + i];

      i += d;

      e = s & ((1 << (-nBits)) - 1);
      s >>= (-nBits);
      nBits += eLen;
      for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

      m = e & ((1 << (-nBits)) - 1);
      e >>= (-nBits);
      nBits += mLen;
      for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

      if (e === 0) {
        e = 1 - eBias;
      } else if (e === eMax) {
        return m ? NaN : ((s ? -1 : 1) * Infinity)
      } else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
      }
      return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
    }

    function write (buffer, value, offset, isLE, mLen, nBytes) {
      var e, m, c;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
      var i = isLE ? 0 : (nBytes - 1);
      var d = isLE ? 1 : -1;
      var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

      value = Math.abs(value);

      if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
      } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
          e--;
          c *= 2;
        }
        if (e + eBias >= 1) {
          value += rt / c;
        } else {
          value += rt * Math.pow(2, 1 - eBias);
        }
        if (value * c >= 2) {
          e++;
          c /= 2;
        }

        if (e + eBias >= eMax) {
          m = 0;
          e = eMax;
        } else if (e + eBias >= 1) {
          m = (value * c - 1) * Math.pow(2, mLen);
          e = e + eBias;
        } else {
          m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
          e = 0;
        }
      }

      for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

      e = (e << mLen) | m;
      eLen += mLen;
      for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

      buffer[offset + i - d] |= s * 128;
    }

    var toString$1 = {}.toString;

    var isArray$1 = Array.isArray || function (arr) {
      return toString$1.call(arr) == '[object Array]';
    };

    /*!
     * The buffer module from node.js, for the browser.
     *
     * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
     * @license  MIT
     */

    var INSPECT_MAX_BYTES = 50;

    /**
     * If `Buffer.TYPED_ARRAY_SUPPORT`:
     *   === true    Use Uint8Array implementation (fastest)
     *   === false   Use Object implementation (most compatible, even IE6)
     *
     * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
     * Opera 11.6+, iOS 4.2+.
     *
     * Due to various browser bugs, sometimes the Object implementation will be used even
     * when the browser supports typed arrays.
     *
     * Note:
     *
     *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
     *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
     *
     *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
     *
     *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
     *     incorrect length in some situations.

     * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
     * get the Object implementation, which is slower but behaves correctly.
     */
    Buffer$l.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined
      ? global$1.TYPED_ARRAY_SUPPORT
      : true;

    /*
     * Export kMaxLength after typed array support is determined.
     */
    var _kMaxLength = kMaxLength();

    function kMaxLength () {
      return Buffer$l.TYPED_ARRAY_SUPPORT
        ? 0x7fffffff
        : 0x3fffffff
    }

    function createBuffer (that, length) {
      if (kMaxLength() < length) {
        throw new RangeError('Invalid typed array length')
      }
      if (Buffer$l.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer$l.prototype;
      } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) {
          that = new Buffer$l(length);
        }
        that.length = length;
      }

      return that
    }

    /**
     * The Buffer constructor returns instances of `Uint8Array` that have their
     * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
     * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
     * and the `Uint8Array` methods. Square bracket notation works as expected -- it
     * returns a single octet.
     *
     * The `Uint8Array` prototype remains unmodified.
     */

    function Buffer$l (arg, encodingOrOffset, length) {
      if (!Buffer$l.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer$l)) {
        return new Buffer$l(arg, encodingOrOffset, length)
      }

      // Common case.
      if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') {
          throw new Error(
            'If encoding is specified then the first argument must be a string'
          )
        }
        return allocUnsafe(this, arg)
      }
      return from(this, arg, encodingOrOffset, length)
    }

    Buffer$l.poolSize = 8192; // not used by this implementation

    // TODO: Legacy, not needed anymore. Remove in next major version.
    Buffer$l._augment = function (arr) {
      arr.__proto__ = Buffer$l.prototype;
      return arr
    };

    function from (that, value, encodingOrOffset, length) {
      if (typeof value === 'number') {
        throw new TypeError('"value" argument must not be a number')
      }

      if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
        return fromArrayBuffer(that, value, encodingOrOffset, length)
      }

      if (typeof value === 'string') {
        return fromString(that, value, encodingOrOffset)
      }

      return fromObject(that, value)
    }

    /**
     * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
     * if value is a number.
     * Buffer.from(str[, encoding])
     * Buffer.from(array)
     * Buffer.from(buffer)
     * Buffer.from(arrayBuffer[, byteOffset[, length]])
     **/
    Buffer$l.from = function (value, encodingOrOffset, length) {
      return from(null, value, encodingOrOffset, length)
    };

    if (Buffer$l.TYPED_ARRAY_SUPPORT) {
      Buffer$l.prototype.__proto__ = Uint8Array.prototype;
      Buffer$l.__proto__ = Uint8Array;
      if (typeof Symbol !== 'undefined' && Symbol.species &&
          Buffer$l[Symbol.species] === Buffer$l) ;
    }

    function assertSize (size) {
      if (typeof size !== 'number') {
        throw new TypeError('"size" argument must be a number')
      } else if (size < 0) {
        throw new RangeError('"size" argument must not be negative')
      }
    }

    function alloc (that, size, fill, encoding) {
      assertSize(size);
      if (size <= 0) {
        return createBuffer(that, size)
      }
      if (fill !== undefined) {
        // Only pay attention to encoding if it's a string. This
        // prevents accidentally sending in a number that would
        // be interpretted as a start offset.
        return typeof encoding === 'string'
          ? createBuffer(that, size).fill(fill, encoding)
          : createBuffer(that, size).fill(fill)
      }
      return createBuffer(that, size)
    }

    /**
     * Creates a new filled Buffer instance.
     * alloc(size[, fill[, encoding]])
     **/
    Buffer$l.alloc = function (size, fill, encoding) {
      return alloc(null, size, fill, encoding)
    };

    function allocUnsafe (that, size) {
      assertSize(size);
      that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
      if (!Buffer$l.TYPED_ARRAY_SUPPORT) {
        for (var i = 0; i < size; ++i) {
          that[i] = 0;
        }
      }
      return that
    }

    /**
     * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
     * */
    Buffer$l.allocUnsafe = function (size) {
      return allocUnsafe(null, size)
    };
    /**
     * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
     */
    Buffer$l.allocUnsafeSlow = function (size) {
      return allocUnsafe(null, size)
    };

    function fromString (that, string, encoding) {
      if (typeof encoding !== 'string' || encoding === '') {
        encoding = 'utf8';
      }

      if (!Buffer$l.isEncoding(encoding)) {
        throw new TypeError('"encoding" must be a valid string encoding')
      }

      var length = byteLength(string, encoding) | 0;
      that = createBuffer(that, length);

      var actual = that.write(string, encoding);

      if (actual !== length) {
        // Writing a hex string, for example, that contains invalid characters will
        // cause everything after the first invalid character to be ignored. (e.g.
        // 'abxxcd' will be treated as 'ab')
        that = that.slice(0, actual);
      }

      return that
    }

    function fromArrayLike (that, array) {
      var length = array.length < 0 ? 0 : checked(array.length) | 0;
      that = createBuffer(that, length);
      for (var i = 0; i < length; i += 1) {
        that[i] = array[i] & 255;
      }
      return that
    }

    function fromArrayBuffer (that, array, byteOffset, length) {
      array.byteLength; // this throws if `array` is not a valid ArrayBuffer

      if (byteOffset < 0 || array.byteLength < byteOffset) {
        throw new RangeError('\'offset\' is out of bounds')
      }

      if (array.byteLength < byteOffset + (length || 0)) {
        throw new RangeError('\'length\' is out of bounds')
      }

      if (byteOffset === undefined && length === undefined) {
        array = new Uint8Array(array);
      } else if (length === undefined) {
        array = new Uint8Array(array, byteOffset);
      } else {
        array = new Uint8Array(array, byteOffset, length);
      }

      if (Buffer$l.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer$l.prototype;
      } else {
        // Fallback: Return an object instance of the Buffer class
        that = fromArrayLike(that, array);
      }
      return that
    }

    function fromObject (that, obj) {
      if (internalIsBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);

        if (that.length === 0) {
          return that
        }

        obj.copy(that, 0, 0, len);
        return that
      }

      if (obj) {
        if ((typeof ArrayBuffer !== 'undefined' &&
            obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
          if (typeof obj.length !== 'number' || isnan(obj.length)) {
            return createBuffer(that, 0)
          }
          return fromArrayLike(that, obj)
        }

        if (obj.type === 'Buffer' && isArray$1(obj.data)) {
          return fromArrayLike(that, obj.data)
        }
      }

      throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
    }

    function checked (length) {
      // Note: cannot use `length < kMaxLength()` here because that fails when
      // length is NaN (which is otherwise coerced to zero.)
      if (length >= kMaxLength()) {
        throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                             'size: 0x' + kMaxLength().toString(16) + ' bytes')
      }
      return length | 0
    }

    function SlowBuffer (length) {
      if (+length != length) { // eslint-disable-line eqeqeq
        length = 0;
      }
      return Buffer$l.alloc(+length)
    }
    Buffer$l.isBuffer = isBuffer$1;
    function internalIsBuffer (b) {
      return !!(b != null && b._isBuffer)
    }

    Buffer$l.compare = function compare (a, b) {
      if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
        throw new TypeError('Arguments must be Buffers')
      }

      if (a === b) return 0

      var x = a.length;
      var y = b.length;

      for (var i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
          x = a[i];
          y = b[i];
          break
        }
      }

      if (x < y) return -1
      if (y < x) return 1
      return 0
    };

    Buffer$l.isEncoding = function isEncoding (encoding) {
      switch (String(encoding).toLowerCase()) {
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return true
        default:
          return false
      }
    };

    Buffer$l.concat = function concat (list, length) {
      if (!isArray$1(list)) {
        throw new TypeError('"list" argument must be an Array of Buffers')
      }

      if (list.length === 0) {
        return Buffer$l.alloc(0)
      }

      var i;
      if (length === undefined) {
        length = 0;
        for (i = 0; i < list.length; ++i) {
          length += list[i].length;
        }
      }

      var buffer = Buffer$l.allocUnsafe(length);
      var pos = 0;
      for (i = 0; i < list.length; ++i) {
        var buf = list[i];
        if (!internalIsBuffer(buf)) {
          throw new TypeError('"list" argument must be an Array of Buffers')
        }
        buf.copy(buffer, pos);
        pos += buf.length;
      }
      return buffer
    };

    function byteLength (string, encoding) {
      if (internalIsBuffer(string)) {
        return string.length
      }
      if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
          (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
        return string.byteLength
      }
      if (typeof string !== 'string') {
        string = '' + string;
      }

      var len = string.length;
      if (len === 0) return 0

      // Use a for loop to avoid recursion
      var loweredCase = false;
      for (;;) {
        switch (encoding) {
          case 'ascii':
          case 'latin1':
          case 'binary':
            return len
          case 'utf8':
          case 'utf-8':
          case undefined:
            return utf8ToBytes(string).length
          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return len * 2
          case 'hex':
            return len >>> 1
          case 'base64':
            return base64ToBytes(string).length
          default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer$l.byteLength = byteLength;

    function slowToString (encoding, start, end) {
      var loweredCase = false;

      // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
      // property of a typed array.

      // This behaves neither like String nor Uint8Array in that we set start/end
      // to their upper/lower bounds if the value passed is out of range.
      // undefined is handled specially as per ECMA-262 6th Edition,
      // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
      if (start === undefined || start < 0) {
        start = 0;
      }
      // Return early if start > this.length. Done here to prevent potential uint32
      // coercion fail below.
      if (start > this.length) {
        return ''
      }

      if (end === undefined || end > this.length) {
        end = this.length;
      }

      if (end <= 0) {
        return ''
      }

      // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
      end >>>= 0;
      start >>>= 0;

      if (end <= start) {
        return ''
      }

      if (!encoding) encoding = 'utf8';

      while (true) {
        switch (encoding) {
          case 'hex':
            return hexSlice(this, start, end)

          case 'utf8':
          case 'utf-8':
            return utf8Slice(this, start, end)

          case 'ascii':
            return asciiSlice(this, start, end)

          case 'latin1':
          case 'binary':
            return latin1Slice(this, start, end)

          case 'base64':
            return base64Slice(this, start, end)

          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return utf16leSlice(this, start, end)

          default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
        }
      }
    }

    // The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
    // Buffer instances.
    Buffer$l.prototype._isBuffer = true;

    function swap (b, n, m) {
      var i = b[n];
      b[n] = b[m];
      b[m] = i;
    }

    Buffer$l.prototype.swap16 = function swap16 () {
      var len = this.length;
      if (len % 2 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 16-bits')
      }
      for (var i = 0; i < len; i += 2) {
        swap(this, i, i + 1);
      }
      return this
    };

    Buffer$l.prototype.swap32 = function swap32 () {
      var len = this.length;
      if (len % 4 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 32-bits')
      }
      for (var i = 0; i < len; i += 4) {
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
      }
      return this
    };

    Buffer$l.prototype.swap64 = function swap64 () {
      var len = this.length;
      if (len % 8 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 64-bits')
      }
      for (var i = 0; i < len; i += 8) {
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
      }
      return this
    };

    Buffer$l.prototype.toString = function toString () {
      var length = this.length | 0;
      if (length === 0) return ''
      if (arguments.length === 0) return utf8Slice(this, 0, length)
      return slowToString.apply(this, arguments)
    };

    Buffer$l.prototype.equals = function equals (b) {
      if (!internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer')
      if (this === b) return true
      return Buffer$l.compare(this, b) === 0
    };

    Buffer$l.prototype.inspect = function inspect () {
      var str = '';
      var max = INSPECT_MAX_BYTES;
      if (this.length > 0) {
        str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
        if (this.length > max) str += ' ... ';
      }
      return '<Buffer ' + str + '>'
    };

    Buffer$l.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
      if (!internalIsBuffer(target)) {
        throw new TypeError('Argument must be a Buffer')
      }

      if (start === undefined) {
        start = 0;
      }
      if (end === undefined) {
        end = target ? target.length : 0;
      }
      if (thisStart === undefined) {
        thisStart = 0;
      }
      if (thisEnd === undefined) {
        thisEnd = this.length;
      }

      if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
        throw new RangeError('out of range index')
      }

      if (thisStart >= thisEnd && start >= end) {
        return 0
      }
      if (thisStart >= thisEnd) {
        return -1
      }
      if (start >= end) {
        return 1
      }

      start >>>= 0;
      end >>>= 0;
      thisStart >>>= 0;
      thisEnd >>>= 0;

      if (this === target) return 0

      var x = thisEnd - thisStart;
      var y = end - start;
      var len = Math.min(x, y);

      var thisCopy = this.slice(thisStart, thisEnd);
      var targetCopy = target.slice(start, end);

      for (var i = 0; i < len; ++i) {
        if (thisCopy[i] !== targetCopy[i]) {
          x = thisCopy[i];
          y = targetCopy[i];
          break
        }
      }

      if (x < y) return -1
      if (y < x) return 1
      return 0
    };

    // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    //
    // Arguments:
    // - buffer - a Buffer to search
    // - val - a string, Buffer, or number
    // - byteOffset - an index into `buffer`; will be clamped to an int32
    // - encoding - an optional encoding, relevant is val is a string
    // - dir - true for indexOf, false for lastIndexOf
    function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
      // Empty buffer means no match
      if (buffer.length === 0) return -1

      // Normalize byteOffset
      if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
      } else if (byteOffset > 0x7fffffff) {
        byteOffset = 0x7fffffff;
      } else if (byteOffset < -0x80000000) {
        byteOffset = -0x80000000;
      }
      byteOffset = +byteOffset;  // Coerce to Number.
      if (isNaN(byteOffset)) {
        // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
        byteOffset = dir ? 0 : (buffer.length - 1);
      }

      // Normalize byteOffset: negative offsets start from the end of the buffer
      if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
      if (byteOffset >= buffer.length) {
        if (dir) return -1
        else byteOffset = buffer.length - 1;
      } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1
      }

      // Normalize val
      if (typeof val === 'string') {
        val = Buffer$l.from(val, encoding);
      }

      // Finally, search either indexOf (if dir is true) or lastIndexOf
      if (internalIsBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) {
          return -1
        }
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
      } else if (typeof val === 'number') {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (Buffer$l.TYPED_ARRAY_SUPPORT &&
            typeof Uint8Array.prototype.indexOf === 'function') {
          if (dir) {
            return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
          } else {
            return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
          }
        }
        return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
      }

      throw new TypeError('val must be string, number or Buffer')
    }

    function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
      var indexSize = 1;
      var arrLength = arr.length;
      var valLength = val.length;

      if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' ||
            encoding === 'utf16le' || encoding === 'utf-16le') {
          if (arr.length < 2 || val.length < 2) {
            return -1
          }
          indexSize = 2;
          arrLength /= 2;
          valLength /= 2;
          byteOffset /= 2;
        }
      }

      function read (buf, i) {
        if (indexSize === 1) {
          return buf[i]
        } else {
          return buf.readUInt16BE(i * indexSize)
        }
      }

      var i;
      if (dir) {
        var foundIndex = -1;
        for (i = byteOffset; i < arrLength; i++) {
          if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
          } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
          }
        }
      } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for (i = byteOffset; i >= 0; i--) {
          var found = true;
          for (var j = 0; j < valLength; j++) {
            if (read(arr, i + j) !== read(val, j)) {
              found = false;
              break
            }
          }
          if (found) return i
        }
      }

      return -1
    }

    Buffer$l.prototype.includes = function includes (val, byteOffset, encoding) {
      return this.indexOf(val, byteOffset, encoding) !== -1
    };

    Buffer$l.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
    };

    Buffer$l.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
    };

    function hexWrite (buf, string, offset, length) {
      offset = Number(offset) || 0;
      var remaining = buf.length - offset;
      if (!length) {
        length = remaining;
      } else {
        length = Number(length);
        if (length > remaining) {
          length = remaining;
        }
      }

      // must be an even number of digits
      var strLen = string.length;
      if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

      if (length > strLen / 2) {
        length = strLen / 2;
      }
      for (var i = 0; i < length; ++i) {
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i
        buf[offset + i] = parsed;
      }
      return i
    }

    function utf8Write (buf, string, offset, length) {
      return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
    }

    function asciiWrite (buf, string, offset, length) {
      return blitBuffer(asciiToBytes(string), buf, offset, length)
    }

    function latin1Write (buf, string, offset, length) {
      return asciiWrite(buf, string, offset, length)
    }

    function base64Write (buf, string, offset, length) {
      return blitBuffer(base64ToBytes(string), buf, offset, length)
    }

    function ucs2Write (buf, string, offset, length) {
      return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
    }

    Buffer$l.prototype.write = function write (string, offset, length, encoding) {
      // Buffer#write(string)
      if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
      // Buffer#write(string, encoding)
      } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
      // Buffer#write(string, offset[, length][, encoding])
      } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
          length = length | 0;
          if (encoding === undefined) encoding = 'utf8';
        } else {
          encoding = length;
          length = undefined;
        }
      // legacy write(string, encoding, offset, length) - remove in v0.13
      } else {
        throw new Error(
          'Buffer.write(string, encoding, offset[, length]) is no longer supported'
        )
      }

      var remaining = this.length - offset;
      if (length === undefined || length > remaining) length = remaining;

      if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
        throw new RangeError('Attempt to write outside buffer bounds')
      }

      if (!encoding) encoding = 'utf8';

      var loweredCase = false;
      for (;;) {
        switch (encoding) {
          case 'hex':
            return hexWrite(this, string, offset, length)

          case 'utf8':
          case 'utf-8':
            return utf8Write(this, string, offset, length)

          case 'ascii':
            return asciiWrite(this, string, offset, length)

          case 'latin1':
          case 'binary':
            return latin1Write(this, string, offset, length)

          case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length)

          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return ucs2Write(this, string, offset, length)

          default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    };

    Buffer$l.prototype.toJSON = function toJSON () {
      return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
      }
    };

    function base64Slice (buf, start, end) {
      if (start === 0 && end === buf.length) {
        return fromByteArray(buf)
      } else {
        return fromByteArray(buf.slice(start, end))
      }
    }

    function utf8Slice (buf, start, end) {
      end = Math.min(buf.length, end);
      var res = [];

      var i = start;
      while (i < end) {
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = (firstByte > 0xEF) ? 4
          : (firstByte > 0xDF) ? 3
          : (firstByte > 0xBF) ? 2
          : 1;

        if (i + bytesPerSequence <= end) {
          var secondByte, thirdByte, fourthByte, tempCodePoint;

          switch (bytesPerSequence) {
            case 1:
              if (firstByte < 0x80) {
                codePoint = firstByte;
              }
              break
            case 2:
              secondByte = buf[i + 1];
              if ((secondByte & 0xC0) === 0x80) {
                tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
                if (tempCodePoint > 0x7F) {
                  codePoint = tempCodePoint;
                }
              }
              break
            case 3:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
                if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                  codePoint = tempCodePoint;
                }
              }
              break
            case 4:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              fourthByte = buf[i + 3];
              if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
                if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                  codePoint = tempCodePoint;
                }
              }
          }
        }

        if (codePoint === null) {
          // we did not generate a valid codePoint so insert a
          // replacement char (U+FFFD) and advance only 1 byte
          codePoint = 0xFFFD;
          bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
          // encode to utf16 (surrogate pair dance)
          codePoint -= 0x10000;
          res.push(codePoint >>> 10 & 0x3FF | 0xD800);
          codePoint = 0xDC00 | codePoint & 0x3FF;
        }

        res.push(codePoint);
        i += bytesPerSequence;
      }

      return decodeCodePointsArray(res)
    }

    // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    // the lowest limit is Chrome, with 0x10000 args.
    // We go 1 magnitude less, for safety
    var MAX_ARGUMENTS_LENGTH = 0x1000;

    function decodeCodePointsArray (codePoints) {
      var len = codePoints.length;
      if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
      }

      // Decode in chunks to avoid "call stack size exceeded".
      var res = '';
      var i = 0;
      while (i < len) {
        res += String.fromCharCode.apply(
          String,
          codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
        );
      }
      return res
    }

    function asciiSlice (buf, start, end) {
      var ret = '';
      end = Math.min(buf.length, end);

      for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i] & 0x7F);
      }
      return ret
    }

    function latin1Slice (buf, start, end) {
      var ret = '';
      end = Math.min(buf.length, end);

      for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i]);
      }
      return ret
    }

    function hexSlice (buf, start, end) {
      var len = buf.length;

      if (!start || start < 0) start = 0;
      if (!end || end < 0 || end > len) end = len;

      var out = '';
      for (var i = start; i < end; ++i) {
        out += toHex$1(buf[i]);
      }
      return out
    }

    function utf16leSlice (buf, start, end) {
      var bytes = buf.slice(start, end);
      var res = '';
      for (var i = 0; i < bytes.length; i += 2) {
        res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
      }
      return res
    }

    Buffer$l.prototype.slice = function slice (start, end) {
      var len = this.length;
      start = ~~start;
      end = end === undefined ? len : ~~end;

      if (start < 0) {
        start += len;
        if (start < 0) start = 0;
      } else if (start > len) {
        start = len;
      }

      if (end < 0) {
        end += len;
        if (end < 0) end = 0;
      } else if (end > len) {
        end = len;
      }

      if (end < start) end = start;

      var newBuf;
      if (Buffer$l.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer$l.prototype;
      } else {
        var sliceLen = end - start;
        newBuf = new Buffer$l(sliceLen, undefined);
        for (var i = 0; i < sliceLen; ++i) {
          newBuf[i] = this[i + start];
        }
      }

      return newBuf
    };

    /*
     * Need to make sure that buffer isn't trying to write out of bounds.
     */
    function checkOffset (offset, ext, length) {
      if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
      if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
    }

    Buffer$l.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) checkOffset(offset, byteLength, this.length);

      var val = this[offset];
      var mul = 1;
      var i = 0;
      while (++i < byteLength && (mul *= 0x100)) {
        val += this[offset + i] * mul;
      }

      return val
    };

    Buffer$l.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) {
        checkOffset(offset, byteLength, this.length);
      }

      var val = this[offset + --byteLength];
      var mul = 1;
      while (byteLength > 0 && (mul *= 0x100)) {
        val += this[offset + --byteLength] * mul;
      }

      return val
    };

    Buffer$l.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 1, this.length);
      return this[offset]
    };

    Buffer$l.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 2, this.length);
      return this[offset] | (this[offset + 1] << 8)
    };

    Buffer$l.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 2, this.length);
      return (this[offset] << 8) | this[offset + 1]
    };

    Buffer$l.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);

      return ((this[offset]) |
          (this[offset + 1] << 8) |
          (this[offset + 2] << 16)) +
          (this[offset + 3] * 0x1000000)
    };

    Buffer$l.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);

      return (this[offset] * 0x1000000) +
        ((this[offset + 1] << 16) |
        (this[offset + 2] << 8) |
        this[offset + 3])
    };

    Buffer$l.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) checkOffset(offset, byteLength, this.length);

      var val = this[offset];
      var mul = 1;
      var i = 0;
      while (++i < byteLength && (mul *= 0x100)) {
        val += this[offset + i] * mul;
      }
      mul *= 0x80;

      if (val >= mul) val -= Math.pow(2, 8 * byteLength);

      return val
    };

    Buffer$l.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) checkOffset(offset, byteLength, this.length);

      var i = byteLength;
      var mul = 1;
      var val = this[offset + --i];
      while (i > 0 && (mul *= 0x100)) {
        val += this[offset + --i] * mul;
      }
      mul *= 0x80;

      if (val >= mul) val -= Math.pow(2, 8 * byteLength);

      return val
    };

    Buffer$l.prototype.readInt8 = function readInt8 (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 1, this.length);
      if (!(this[offset] & 0x80)) return (this[offset])
      return ((0xff - this[offset] + 1) * -1)
    };

    Buffer$l.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 2, this.length);
      var val = this[offset] | (this[offset + 1] << 8);
      return (val & 0x8000) ? val | 0xFFFF0000 : val
    };

    Buffer$l.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 2, this.length);
      var val = this[offset + 1] | (this[offset] << 8);
      return (val & 0x8000) ? val | 0xFFFF0000 : val
    };

    Buffer$l.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);

      return (this[offset]) |
        (this[offset + 1] << 8) |
        (this[offset + 2] << 16) |
        (this[offset + 3] << 24)
    };

    Buffer$l.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);

      return (this[offset] << 24) |
        (this[offset + 1] << 16) |
        (this[offset + 2] << 8) |
        (this[offset + 3])
    };

    Buffer$l.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);
      return read(this, offset, true, 23, 4)
    };

    Buffer$l.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);
      return read(this, offset, false, 23, 4)
    };

    Buffer$l.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 8, this.length);
      return read(this, offset, true, 52, 8)
    };

    Buffer$l.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 8, this.length);
      return read(this, offset, false, 52, 8)
    };

    function checkInt (buf, value, offset, ext, max, min) {
      if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
      if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
      if (offset + ext > buf.length) throw new RangeError('Index out of range')
    }

    Buffer$l.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
      value = +value;
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
      }

      var mul = 1;
      var i = 0;
      this[offset] = value & 0xFF;
      while (++i < byteLength && (mul *= 0x100)) {
        this[offset + i] = (value / mul) & 0xFF;
      }

      return offset + byteLength
    };

    Buffer$l.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
      value = +value;
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
      }

      var i = byteLength - 1;
      var mul = 1;
      this[offset + i] = value & 0xFF;
      while (--i >= 0 && (mul *= 0x100)) {
        this[offset + i] = (value / mul) & 0xFF;
      }

      return offset + byteLength
    };

    Buffer$l.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
      if (!Buffer$l.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
      this[offset] = (value & 0xff);
      return offset + 1
    };

    function objectWriteUInt16 (buf, value, offset, littleEndian) {
      if (value < 0) value = 0xffff + value + 1;
      for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
        buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
          (littleEndian ? i : 1 - i) * 8;
      }
    }

    Buffer$l.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
      if (Buffer$l.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value & 0xff);
        this[offset + 1] = (value >>> 8);
      } else {
        objectWriteUInt16(this, value, offset, true);
      }
      return offset + 2
    };

    Buffer$l.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
      if (Buffer$l.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value >>> 8);
        this[offset + 1] = (value & 0xff);
      } else {
        objectWriteUInt16(this, value, offset, false);
      }
      return offset + 2
    };

    function objectWriteUInt32 (buf, value, offset, littleEndian) {
      if (value < 0) value = 0xffffffff + value + 1;
      for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
        buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff;
      }
    }

    Buffer$l.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
      if (Buffer$l.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = (value >>> 24);
        this[offset + 2] = (value >>> 16);
        this[offset + 1] = (value >>> 8);
        this[offset] = (value & 0xff);
      } else {
        objectWriteUInt32(this, value, offset, true);
      }
      return offset + 4
    };

    Buffer$l.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
      if (Buffer$l.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value >>> 24);
        this[offset + 1] = (value >>> 16);
        this[offset + 2] = (value >>> 8);
        this[offset + 3] = (value & 0xff);
      } else {
        objectWriteUInt32(this, value, offset, false);
      }
      return offset + 4
    };

    Buffer$l.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);

        checkInt(this, value, offset, byteLength, limit - 1, -limit);
      }

      var i = 0;
      var mul = 1;
      var sub = 0;
      this[offset] = value & 0xFF;
      while (++i < byteLength && (mul *= 0x100)) {
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
          sub = 1;
        }
        this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
      }

      return offset + byteLength
    };

    Buffer$l.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);

        checkInt(this, value, offset, byteLength, limit - 1, -limit);
      }

      var i = byteLength - 1;
      var mul = 1;
      var sub = 0;
      this[offset + i] = value & 0xFF;
      while (--i >= 0 && (mul *= 0x100)) {
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
          sub = 1;
        }
        this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
      }

      return offset + byteLength
    };

    Buffer$l.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
      if (!Buffer$l.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
      if (value < 0) value = 0xff + value + 1;
      this[offset] = (value & 0xff);
      return offset + 1
    };

    Buffer$l.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
      if (Buffer$l.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value & 0xff);
        this[offset + 1] = (value >>> 8);
      } else {
        objectWriteUInt16(this, value, offset, true);
      }
      return offset + 2
    };

    Buffer$l.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
      if (Buffer$l.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value >>> 8);
        this[offset + 1] = (value & 0xff);
      } else {
        objectWriteUInt16(this, value, offset, false);
      }
      return offset + 2
    };

    Buffer$l.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
      if (Buffer$l.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value & 0xff);
        this[offset + 1] = (value >>> 8);
        this[offset + 2] = (value >>> 16);
        this[offset + 3] = (value >>> 24);
      } else {
        objectWriteUInt32(this, value, offset, true);
      }
      return offset + 4
    };

    Buffer$l.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
      if (value < 0) value = 0xffffffff + value + 1;
      if (Buffer$l.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value >>> 24);
        this[offset + 1] = (value >>> 16);
        this[offset + 2] = (value >>> 8);
        this[offset + 3] = (value & 0xff);
      } else {
        objectWriteUInt32(this, value, offset, false);
      }
      return offset + 4
    };

    function checkIEEE754 (buf, value, offset, ext, max, min) {
      if (offset + ext > buf.length) throw new RangeError('Index out of range')
      if (offset < 0) throw new RangeError('Index out of range')
    }

    function writeFloat (buf, value, offset, littleEndian, noAssert) {
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 4);
      }
      write(buf, value, offset, littleEndian, 23, 4);
      return offset + 4
    }

    Buffer$l.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
      return writeFloat(this, value, offset, true, noAssert)
    };

    Buffer$l.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
      return writeFloat(this, value, offset, false, noAssert)
    };

    function writeDouble (buf, value, offset, littleEndian, noAssert) {
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 8);
      }
      write(buf, value, offset, littleEndian, 52, 8);
      return offset + 8
    }

    Buffer$l.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
      return writeDouble(this, value, offset, true, noAssert)
    };

    Buffer$l.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
      return writeDouble(this, value, offset, false, noAssert)
    };

    // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    Buffer$l.prototype.copy = function copy (target, targetStart, start, end) {
      if (!start) start = 0;
      if (!end && end !== 0) end = this.length;
      if (targetStart >= target.length) targetStart = target.length;
      if (!targetStart) targetStart = 0;
      if (end > 0 && end < start) end = start;

      // Copy 0 bytes; we're done
      if (end === start) return 0
      if (target.length === 0 || this.length === 0) return 0

      // Fatal error conditions
      if (targetStart < 0) {
        throw new RangeError('targetStart out of bounds')
      }
      if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
      if (end < 0) throw new RangeError('sourceEnd out of bounds')

      // Are we oob?
      if (end > this.length) end = this.length;
      if (target.length - targetStart < end - start) {
        end = target.length - targetStart + start;
      }

      var len = end - start;
      var i;

      if (this === target && start < targetStart && targetStart < end) {
        // descending copy from end
        for (i = len - 1; i >= 0; --i) {
          target[i + targetStart] = this[i + start];
        }
      } else if (len < 1000 || !Buffer$l.TYPED_ARRAY_SUPPORT) {
        // ascending copy from start
        for (i = 0; i < len; ++i) {
          target[i + targetStart] = this[i + start];
        }
      } else {
        Uint8Array.prototype.set.call(
          target,
          this.subarray(start, start + len),
          targetStart
        );
      }

      return len
    };

    // Usage:
    //    buffer.fill(number[, offset[, end]])
    //    buffer.fill(buffer[, offset[, end]])
    //    buffer.fill(string[, offset[, end]][, encoding])
    Buffer$l.prototype.fill = function fill (val, start, end, encoding) {
      // Handle string cases:
      if (typeof val === 'string') {
        if (typeof start === 'string') {
          encoding = start;
          start = 0;
          end = this.length;
        } else if (typeof end === 'string') {
          encoding = end;
          end = this.length;
        }
        if (val.length === 1) {
          var code = val.charCodeAt(0);
          if (code < 256) {
            val = code;
          }
        }
        if (encoding !== undefined && typeof encoding !== 'string') {
          throw new TypeError('encoding must be a string')
        }
        if (typeof encoding === 'string' && !Buffer$l.isEncoding(encoding)) {
          throw new TypeError('Unknown encoding: ' + encoding)
        }
      } else if (typeof val === 'number') {
        val = val & 255;
      }

      // Invalid ranges are not set to a default, so can range check early.
      if (start < 0 || this.length < start || this.length < end) {
        throw new RangeError('Out of range index')
      }

      if (end <= start) {
        return this
      }

      start = start >>> 0;
      end = end === undefined ? this.length : end >>> 0;

      if (!val) val = 0;

      var i;
      if (typeof val === 'number') {
        for (i = start; i < end; ++i) {
          this[i] = val;
        }
      } else {
        var bytes = internalIsBuffer(val)
          ? val
          : utf8ToBytes(new Buffer$l(val, encoding).toString());
        var len = bytes.length;
        for (i = 0; i < end - start; ++i) {
          this[i + start] = bytes[i % len];
        }
      }

      return this
    };

    // HELPER FUNCTIONS
    // ================

    var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

    function base64clean (str) {
      // Node strips out invalid characters like \n and \t from the string, base64-js does not
      str = stringtrim(str).replace(INVALID_BASE64_RE, '');
      // Node converts strings with length < 2 to ''
      if (str.length < 2) return ''
      // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
      while (str.length % 4 !== 0) {
        str = str + '=';
      }
      return str
    }

    function stringtrim (str) {
      if (str.trim) return str.trim()
      return str.replace(/^\s+|\s+$/g, '')
    }

    function toHex$1 (n) {
      if (n < 16) return '0' + n.toString(16)
      return n.toString(16)
    }

    function utf8ToBytes (string, units) {
      units = units || Infinity;
      var codePoint;
      var length = string.length;
      var leadSurrogate = null;
      var bytes = [];

      for (var i = 0; i < length; ++i) {
        codePoint = string.charCodeAt(i);

        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
          // last char was a lead
          if (!leadSurrogate) {
            // no lead yet
            if (codePoint > 0xDBFF) {
              // unexpected trail
              if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
              continue
            } else if (i + 1 === length) {
              // unpaired lead
              if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
              continue
            }

            // valid lead
            leadSurrogate = codePoint;

            continue
          }

          // 2 leads in a row
          if (codePoint < 0xDC00) {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            leadSurrogate = codePoint;
            continue
          }

          // valid surrogate pair
          codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) {
          // valid bmp char, but last char was a lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }

        leadSurrogate = null;

        // encode utf8
        if (codePoint < 0x80) {
          if ((units -= 1) < 0) break
          bytes.push(codePoint);
        } else if (codePoint < 0x800) {
          if ((units -= 2) < 0) break
          bytes.push(
            codePoint >> 0x6 | 0xC0,
            codePoint & 0x3F | 0x80
          );
        } else if (codePoint < 0x10000) {
          if ((units -= 3) < 0) break
          bytes.push(
            codePoint >> 0xC | 0xE0,
            codePoint >> 0x6 & 0x3F | 0x80,
            codePoint & 0x3F | 0x80
          );
        } else if (codePoint < 0x110000) {
          if ((units -= 4) < 0) break
          bytes.push(
            codePoint >> 0x12 | 0xF0,
            codePoint >> 0xC & 0x3F | 0x80,
            codePoint >> 0x6 & 0x3F | 0x80,
            codePoint & 0x3F | 0x80
          );
        } else {
          throw new Error('Invalid code point')
        }
      }

      return bytes
    }

    function asciiToBytes (str) {
      var byteArray = [];
      for (var i = 0; i < str.length; ++i) {
        // Node's code seems to be doing this and not & 0x7F..
        byteArray.push(str.charCodeAt(i) & 0xFF);
      }
      return byteArray
    }

    function utf16leToBytes (str, units) {
      var c, hi, lo;
      var byteArray = [];
      for (var i = 0; i < str.length; ++i) {
        if ((units -= 2) < 0) break

        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
      }

      return byteArray
    }


    function base64ToBytes (str) {
      return toByteArray(base64clean(str))
    }

    function blitBuffer (src, dst, offset, length) {
      for (var i = 0; i < length; ++i) {
        if ((i + offset >= dst.length) || (i >= src.length)) break
        dst[i + offset] = src[i];
      }
      return i
    }

    function isnan (val) {
      return val !== val // eslint-disable-line no-self-compare
    }


    // the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
    // The _isBuffer check is for Safari 5-7 support, because it's missing
    // Object.prototype.constructor. Remove this eventually
    function isBuffer$1(obj) {
      return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj))
    }

    function isFastBuffer (obj) {
      return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
    }

    // For Node v0.10 support. Remove this eventually.
    function isSlowBuffer (obj) {
      return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0))
    }

    var _polyfillNode_buffer = /*#__PURE__*/Object.freeze({
        __proto__: null,
        Buffer: Buffer$l,
        INSPECT_MAX_BYTES: INSPECT_MAX_BYTES,
        SlowBuffer: SlowBuffer,
        isBuffer: isBuffer$1,
        kMaxLength: _kMaxLength
    });

    //  Copyright (C) 2018 Zilliqa
    var ZilliqaMessage = dist.ZilliqaMessage;
    var encodeTransactionProto = function (tx) {
        var msg = {
            version: tx.version,
            nonce: new bundleExports$1.Long(tx.nonce || 0, 0),
            // core protocol Schnorr expects lowercase, non-prefixed address.
            toaddr: bundleExports$1.bytes.hexToByteArray(tx.toAddr.replace("0x", "").toLowerCase()),
            senderpubkey: ZilliqaMessage.ByteArray.create({
                data: bundleExports$1.bytes.hexToByteArray(tx.pubKey || "00"),
            }),
            amount: ZilliqaMessage.ByteArray.create({
                data: Uint8Array.from(tx.amount.toArrayLike(Buffer$l, undefined, 16)),
            }),
            gasprice: ZilliqaMessage.ByteArray.create({
                data: Uint8Array.from(tx.gasPrice.toArrayLike(Buffer$l, undefined, 16)),
            }),
            gaslimit: tx.gasLimit,
            code: tx.code && tx.code.length
                ? Uint8Array.from(__spreadArray([], __read(tx.code), false).map(function (c) { return c.charCodeAt(0); }))
                : null,
            data: tx.data && tx.data.length
                ? Uint8Array.from(__spreadArray([], __read(tx.data), false).map(function (c) { return c.charCodeAt(0); }))
                : null,
        };
        var serialised = ZilliqaMessage.ProtoTransactionCoreInfo.create(msg);
        return Buffer$l.from(ZilliqaMessage.ProtoTransactionCoreInfo.encode(serialised).finish());
    };
    var isTxReceipt = function (x) {
        return bundleExports$1.validation.isPlainObject(x) && bundleExports$1.validation.matchesObject(x, {});
    };
    var isTxParams = function (obj) {
        var validator = {
            version: [bundleExports$1.validation.required(bundleExports$1.validation.isNumber)],
            toAddr: [bundleExports$1.validation.required(bundleExports$1.validation.isAddress)],
            amount: [bundleExports$1.validation.required(bundleExports$1.validation.isBN)],
            gasPrice: [bundleExports$1.validation.required(bundleExports$1.validation.isBN)],
            gasLimit: [bundleExports$1.validation.required(bundleExports$1.validation.isLong)],
            code: [bundleExports$1.validation.isString],
            data: [bundleExports$1.validation.isString],
            receipt: [isTxReceipt],
            nonce: [bundleExports$1.validation.required(bundleExports$1.validation.isNumber)],
            signature: [bundleExports$1.validation.required(bundleExports$1.validation.isSignature)],
        };
        return bundleExports$1.validation.matchesObject(obj, validator);
    };
    var formatOutgoingTx = function (req) {
        var e_1, _a;
        // if batch create transaction, payload is array
        if (Array.isArray(req.payload) &&
            req.payload[0].method === bundleExports$2.RPCMethod.CreateTransaction &&
            isTxParams(req.payload[0].params[0])) {
            // loop thru batch payloads and format the params
            var payloads = [];
            try {
                for (var _b = __values(req.payload), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var txPayload = _c.value;
                    var txConfig = txPayload.params[0];
                    payloads.push(__assign(__assign({}, txPayload), { params: [
                            __assign(__assign({}, txConfig), { amount: txConfig.amount.toString(), gasLimit: txConfig.gasLimit.toString(), gasPrice: txConfig.gasPrice.toString() }),
                        ] }));
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            var ret = __assign(__assign({}, req), { payload: payloads });
            return ret;
        }
        // non-batch create transactions
        if (!Array.isArray(req.payload) &&
            req.payload.method === bundleExports$2.RPCMethod.CreateTransaction &&
            isTxParams(req.payload.params[0])) {
            var txConfig = req.payload.params[0];
            var ret = __assign(__assign({}, req), { payload: __assign(__assign({}, req.payload), { params: [
                        __assign(__assign({}, txConfig), { amount: txConfig.amount.toString(), gasLimit: txConfig.gasLimit.toString(), gasPrice: txConfig.gasPrice.toString() }),
                    ] }) });
            return ret;
        }
        return req;
    };
    function sleep(ms) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        setTimeout(function () { return resolve(undefined); }, ms);
                    })];
            });
        });
    }

    var util = /*#__PURE__*/Object.freeze({
        __proto__: null,
        encodeTransactionProto: encodeTransactionProto,
        isTxReceipt: isTxReceipt,
        isTxParams: isTxParams,
        formatOutgoingTx: formatOutgoingTx,
        sleep: sleep
    });

    var bundle = {exports: {}};

    bundle.exports;

    (function (module, exports) {
    	(function (global, factory) {
    		factory(exports) ;
    	})(commonjsGlobal, (function (exports) {
    		var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : {};

    		function getDefaultExportFromCjs (x) {
    			return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    		}

    		function getAugmentedNamespace(n) {
    		  if (n.__esModule) return n;
    		  var f = n.default;
    			if (typeof f == "function") {
    				var a = function a () {
    					if (this instanceof a) {
    						var args = [null];
    						args.push.apply(args, arguments);
    						var Ctor = Function.bind.apply(f, args);
    						return new Ctor();
    					}
    					return f.apply(this, arguments);
    				};
    				a.prototype = f.prototype;
    		  } else a = {};
    		  Object.defineProperty(a, '__esModule', {value: true});
    			Object.keys(n).forEach(function (k) {
    				var d = Object.getOwnPropertyDescriptor(n, k);
    				Object.defineProperty(a, k, d.get ? d : {
    					enumerable: true,
    					get: function () {
    						return n[k];
    					}
    				});
    			});
    			return a;
    		}

    		var elliptic$1 = {};

    		var name = "elliptic";
    		var version$1 = "6.5.4";
    		var description = "EC cryptography";
    		var main = "lib/elliptic.js";
    		var files = [
    			"lib"
    		];
    		var scripts = {
    			lint: "eslint lib test",
    			"lint:fix": "npm run lint -- --fix",
    			unit: "istanbul test _mocha --reporter=spec test/index.js",
    			test: "npm run lint && npm run unit",
    			version: "grunt dist && git add dist/"
    		};
    		var repository = {
    			type: "git",
    			url: "git@github.com:indutny/elliptic"
    		};
    		var keywords = [
    			"EC",
    			"Elliptic",
    			"curve",
    			"Cryptography"
    		];
    		var author = "Fedor Indutny <fedor@indutny.com>";
    		var license = "MIT";
    		var bugs = {
    			url: "https://github.com/indutny/elliptic/issues"
    		};
    		var homepage = "https://github.com/indutny/elliptic";
    		var devDependencies = {
    			brfs: "^2.0.2",
    			coveralls: "^3.1.0",
    			eslint: "^7.6.0",
    			grunt: "^1.2.1",
    			"grunt-browserify": "^5.3.0",
    			"grunt-cli": "^1.3.2",
    			"grunt-contrib-connect": "^3.0.0",
    			"grunt-contrib-copy": "^1.0.0",
    			"grunt-contrib-uglify": "^5.0.0",
    			"grunt-mocha-istanbul": "^5.0.2",
    			"grunt-saucelabs": "^9.0.1",
    			istanbul: "^0.4.5",
    			mocha: "^8.0.1"
    		};
    		var dependencies = {
    			"bn.js": "^4.11.9",
    			brorand: "^1.1.0",
    			"hash.js": "^1.0.0",
    			"hmac-drbg": "^1.0.1",
    			inherits: "^2.0.4",
    			"minimalistic-assert": "^1.0.1",
    			"minimalistic-crypto-utils": "^1.0.1"
    		};
    		var require$$0$4 = {
    			name: name,
    			version: version$1,
    			description: description,
    			main: main,
    			files: files,
    			scripts: scripts,
    			repository: repository,
    			keywords: keywords,
    			author: author,
    			license: license,
    			bugs: bugs,
    			homepage: homepage,
    			devDependencies: devDependencies,
    			dependencies: dependencies
    		};

    		var utils$m = {};

    		var bn = {exports: {}};

    		var global$1 = (typeof commonjsGlobal !== "undefined" ? commonjsGlobal :
    		  typeof self !== "undefined" ? self :
    		  typeof window !== "undefined" ? window : {});

    		var lookup = [];
    		var revLookup = [];
    		var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
    		var inited = false;
    		function init () {
    		  inited = true;
    		  var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    		  for (var i = 0, len = code.length; i < len; ++i) {
    		    lookup[i] = code[i];
    		    revLookup[code.charCodeAt(i)] = i;
    		  }

    		  revLookup['-'.charCodeAt(0)] = 62;
    		  revLookup['_'.charCodeAt(0)] = 63;
    		}

    		function toByteArray (b64) {
    		  if (!inited) {
    		    init();
    		  }
    		  var i, j, l, tmp, placeHolders, arr;
    		  var len = b64.length;

    		  if (len % 4 > 0) {
    		    throw new Error('Invalid string. Length must be a multiple of 4')
    		  }

    		  // the number of equal signs (place holders)
    		  // if there are two placeholders, than the two characters before it
    		  // represent one byte
    		  // if there is only one, then the three characters before it represent 2 bytes
    		  // this is just a cheap hack to not do indexOf twice
    		  placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;

    		  // base64 is 4/3 + up to two characters of the original data
    		  arr = new Arr(len * 3 / 4 - placeHolders);

    		  // if there are placeholders, only get up to the last complete 4 chars
    		  l = placeHolders > 0 ? len - 4 : len;

    		  var L = 0;

    		  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    		    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)];
    		    arr[L++] = (tmp >> 16) & 0xFF;
    		    arr[L++] = (tmp >> 8) & 0xFF;
    		    arr[L++] = tmp & 0xFF;
    		  }

    		  if (placeHolders === 2) {
    		    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4);
    		    arr[L++] = tmp & 0xFF;
    		  } else if (placeHolders === 1) {
    		    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2);
    		    arr[L++] = (tmp >> 8) & 0xFF;
    		    arr[L++] = tmp & 0xFF;
    		  }

    		  return arr
    		}

    		function tripletToBase64 (num) {
    		  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
    		}

    		function encodeChunk (uint8, start, end) {
    		  var tmp;
    		  var output = [];
    		  for (var i = start; i < end; i += 3) {
    		    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2]);
    		    output.push(tripletToBase64(tmp));
    		  }
    		  return output.join('')
    		}

    		function fromByteArray (uint8) {
    		  if (!inited) {
    		    init();
    		  }
    		  var tmp;
    		  var len = uint8.length;
    		  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    		  var output = '';
    		  var parts = [];
    		  var maxChunkLength = 16383; // must be multiple of 3

    		  // go through the array every three bytes, we'll deal with trailing stuff later
    		  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    		    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
    		  }

    		  // pad the end with zeros, but make sure to not forget the extra bytes
    		  if (extraBytes === 1) {
    		    tmp = uint8[len - 1];
    		    output += lookup[tmp >> 2];
    		    output += lookup[(tmp << 4) & 0x3F];
    		    output += '==';
    		  } else if (extraBytes === 2) {
    		    tmp = (uint8[len - 2] << 8) + (uint8[len - 1]);
    		    output += lookup[tmp >> 10];
    		    output += lookup[(tmp >> 4) & 0x3F];
    		    output += lookup[(tmp << 2) & 0x3F];
    		    output += '=';
    		  }

    		  parts.push(output);

    		  return parts.join('')
    		}

    		function read (buffer, offset, isLE, mLen, nBytes) {
    		  var e, m;
    		  var eLen = nBytes * 8 - mLen - 1;
    		  var eMax = (1 << eLen) - 1;
    		  var eBias = eMax >> 1;
    		  var nBits = -7;
    		  var i = isLE ? (nBytes - 1) : 0;
    		  var d = isLE ? -1 : 1;
    		  var s = buffer[offset + i];

    		  i += d;

    		  e = s & ((1 << (-nBits)) - 1);
    		  s >>= (-nBits);
    		  nBits += eLen;
    		  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    		  m = e & ((1 << (-nBits)) - 1);
    		  e >>= (-nBits);
    		  nBits += mLen;
    		  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    		  if (e === 0) {
    		    e = 1 - eBias;
    		  } else if (e === eMax) {
    		    return m ? NaN : ((s ? -1 : 1) * Infinity)
    		  } else {
    		    m = m + Math.pow(2, mLen);
    		    e = e - eBias;
    		  }
    		  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
    		}

    		function write (buffer, value, offset, isLE, mLen, nBytes) {
    		  var e, m, c;
    		  var eLen = nBytes * 8 - mLen - 1;
    		  var eMax = (1 << eLen) - 1;
    		  var eBias = eMax >> 1;
    		  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
    		  var i = isLE ? 0 : (nBytes - 1);
    		  var d = isLE ? 1 : -1;
    		  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

    		  value = Math.abs(value);

    		  if (isNaN(value) || value === Infinity) {
    		    m = isNaN(value) ? 1 : 0;
    		    e = eMax;
    		  } else {
    		    e = Math.floor(Math.log(value) / Math.LN2);
    		    if (value * (c = Math.pow(2, -e)) < 1) {
    		      e--;
    		      c *= 2;
    		    }
    		    if (e + eBias >= 1) {
    		      value += rt / c;
    		    } else {
    		      value += rt * Math.pow(2, 1 - eBias);
    		    }
    		    if (value * c >= 2) {
    		      e++;
    		      c /= 2;
    		    }

    		    if (e + eBias >= eMax) {
    		      m = 0;
    		      e = eMax;
    		    } else if (e + eBias >= 1) {
    		      m = (value * c - 1) * Math.pow(2, mLen);
    		      e = e + eBias;
    		    } else {
    		      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
    		      e = 0;
    		    }
    		  }

    		  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

    		  e = (e << mLen) | m;
    		  eLen += mLen;
    		  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

    		  buffer[offset + i - d] |= s * 128;
    		}

    		var toString = {}.toString;

    		var isArray$1 = Array.isArray || function (arr) {
    		  return toString.call(arr) == '[object Array]';
    		};

    		/*!
    		 * The buffer module from node.js, for the browser.
    		 *
    		 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
    		 * @license  MIT
    		 */

    		var INSPECT_MAX_BYTES = 50;

    		/**
    		 * If `Buffer.TYPED_ARRAY_SUPPORT`:
    		 *   === true    Use Uint8Array implementation (fastest)
    		 *   === false   Use Object implementation (most compatible, even IE6)
    		 *
    		 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
    		 * Opera 11.6+, iOS 4.2+.
    		 *
    		 * Due to various browser bugs, sometimes the Object implementation will be used even
    		 * when the browser supports typed arrays.
    		 *
    		 * Note:
    		 *
    		 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
    		 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
    		 *
    		 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
    		 *
    		 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
    		 *     incorrect length in some situations.

    		 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
    		 * get the Object implementation, which is slower but behaves correctly.
    		 */
    		Buffer$c.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined
    		  ? global$1.TYPED_ARRAY_SUPPORT
    		  : true;

    		/*
    		 * Export kMaxLength after typed array support is determined.
    		 */
    		var _kMaxLength = kMaxLength();

    		function kMaxLength () {
    		  return Buffer$c.TYPED_ARRAY_SUPPORT
    		    ? 0x7fffffff
    		    : 0x3fffffff
    		}

    		function createBuffer (that, length) {
    		  if (kMaxLength() < length) {
    		    throw new RangeError('Invalid typed array length')
    		  }
    		  if (Buffer$c.TYPED_ARRAY_SUPPORT) {
    		    // Return an augmented `Uint8Array` instance, for best performance
    		    that = new Uint8Array(length);
    		    that.__proto__ = Buffer$c.prototype;
    		  } else {
    		    // Fallback: Return an object instance of the Buffer class
    		    if (that === null) {
    		      that = new Buffer$c(length);
    		    }
    		    that.length = length;
    		  }

    		  return that
    		}

    		/**
    		 * The Buffer constructor returns instances of `Uint8Array` that have their
    		 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
    		 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
    		 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
    		 * returns a single octet.
    		 *
    		 * The `Uint8Array` prototype remains unmodified.
    		 */

    		function Buffer$c (arg, encodingOrOffset, length) {
    		  if (!Buffer$c.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer$c)) {
    		    return new Buffer$c(arg, encodingOrOffset, length)
    		  }

    		  // Common case.
    		  if (typeof arg === 'number') {
    		    if (typeof encodingOrOffset === 'string') {
    		      throw new Error(
    		        'If encoding is specified then the first argument must be a string'
    		      )
    		    }
    		    return allocUnsafe(this, arg)
    		  }
    		  return from(this, arg, encodingOrOffset, length)
    		}

    		Buffer$c.poolSize = 8192; // not used by this implementation

    		// TODO: Legacy, not needed anymore. Remove in next major version.
    		Buffer$c._augment = function (arr) {
    		  arr.__proto__ = Buffer$c.prototype;
    		  return arr
    		};

    		function from (that, value, encodingOrOffset, length) {
    		  if (typeof value === 'number') {
    		    throw new TypeError('"value" argument must not be a number')
    		  }

    		  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    		    return fromArrayBuffer(that, value, encodingOrOffset, length)
    		  }

    		  if (typeof value === 'string') {
    		    return fromString(that, value, encodingOrOffset)
    		  }

    		  return fromObject(that, value)
    		}

    		/**
    		 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
    		 * if value is a number.
    		 * Buffer.from(str[, encoding])
    		 * Buffer.from(array)
    		 * Buffer.from(buffer)
    		 * Buffer.from(arrayBuffer[, byteOffset[, length]])
    		 **/
    		Buffer$c.from = function (value, encodingOrOffset, length) {
    		  return from(null, value, encodingOrOffset, length)
    		};

    		if (Buffer$c.TYPED_ARRAY_SUPPORT) {
    		  Buffer$c.prototype.__proto__ = Uint8Array.prototype;
    		  Buffer$c.__proto__ = Uint8Array;
    		  if (typeof Symbol !== 'undefined' && Symbol.species &&
    		      Buffer$c[Symbol.species] === Buffer$c) ;
    		}

    		function assertSize (size) {
    		  if (typeof size !== 'number') {
    		    throw new TypeError('"size" argument must be a number')
    		  } else if (size < 0) {
    		    throw new RangeError('"size" argument must not be negative')
    		  }
    		}

    		function alloc (that, size, fill, encoding) {
    		  assertSize(size);
    		  if (size <= 0) {
    		    return createBuffer(that, size)
    		  }
    		  if (fill !== undefined) {
    		    // Only pay attention to encoding if it's a string. This
    		    // prevents accidentally sending in a number that would
    		    // be interpretted as a start offset.
    		    return typeof encoding === 'string'
    		      ? createBuffer(that, size).fill(fill, encoding)
    		      : createBuffer(that, size).fill(fill)
    		  }
    		  return createBuffer(that, size)
    		}

    		/**
    		 * Creates a new filled Buffer instance.
    		 * alloc(size[, fill[, encoding]])
    		 **/
    		Buffer$c.alloc = function (size, fill, encoding) {
    		  return alloc(null, size, fill, encoding)
    		};

    		function allocUnsafe (that, size) {
    		  assertSize(size);
    		  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    		  if (!Buffer$c.TYPED_ARRAY_SUPPORT) {
    		    for (var i = 0; i < size; ++i) {
    		      that[i] = 0;
    		    }
    		  }
    		  return that
    		}

    		/**
    		 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
    		 * */
    		Buffer$c.allocUnsafe = function (size) {
    		  return allocUnsafe(null, size)
    		};
    		/**
    		 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
    		 */
    		Buffer$c.allocUnsafeSlow = function (size) {
    		  return allocUnsafe(null, size)
    		};

    		function fromString (that, string, encoding) {
    		  if (typeof encoding !== 'string' || encoding === '') {
    		    encoding = 'utf8';
    		  }

    		  if (!Buffer$c.isEncoding(encoding)) {
    		    throw new TypeError('"encoding" must be a valid string encoding')
    		  }

    		  var length = byteLength(string, encoding) | 0;
    		  that = createBuffer(that, length);

    		  var actual = that.write(string, encoding);

    		  if (actual !== length) {
    		    // Writing a hex string, for example, that contains invalid characters will
    		    // cause everything after the first invalid character to be ignored. (e.g.
    		    // 'abxxcd' will be treated as 'ab')
    		    that = that.slice(0, actual);
    		  }

    		  return that
    		}

    		function fromArrayLike (that, array) {
    		  var length = array.length < 0 ? 0 : checked(array.length) | 0;
    		  that = createBuffer(that, length);
    		  for (var i = 0; i < length; i += 1) {
    		    that[i] = array[i] & 255;
    		  }
    		  return that
    		}

    		function fromArrayBuffer (that, array, byteOffset, length) {
    		  array.byteLength; // this throws if `array` is not a valid ArrayBuffer

    		  if (byteOffset < 0 || array.byteLength < byteOffset) {
    		    throw new RangeError('\'offset\' is out of bounds')
    		  }

    		  if (array.byteLength < byteOffset + (length || 0)) {
    		    throw new RangeError('\'length\' is out of bounds')
    		  }

    		  if (byteOffset === undefined && length === undefined) {
    		    array = new Uint8Array(array);
    		  } else if (length === undefined) {
    		    array = new Uint8Array(array, byteOffset);
    		  } else {
    		    array = new Uint8Array(array, byteOffset, length);
    		  }

    		  if (Buffer$c.TYPED_ARRAY_SUPPORT) {
    		    // Return an augmented `Uint8Array` instance, for best performance
    		    that = array;
    		    that.__proto__ = Buffer$c.prototype;
    		  } else {
    		    // Fallback: Return an object instance of the Buffer class
    		    that = fromArrayLike(that, array);
    		  }
    		  return that
    		}

    		function fromObject (that, obj) {
    		  if (internalIsBuffer(obj)) {
    		    var len = checked(obj.length) | 0;
    		    that = createBuffer(that, len);

    		    if (that.length === 0) {
    		      return that
    		    }

    		    obj.copy(that, 0, 0, len);
    		    return that
    		  }

    		  if (obj) {
    		    if ((typeof ArrayBuffer !== 'undefined' &&
    		        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
    		      if (typeof obj.length !== 'number' || isnan(obj.length)) {
    		        return createBuffer(that, 0)
    		      }
    		      return fromArrayLike(that, obj)
    		    }

    		    if (obj.type === 'Buffer' && isArray$1(obj.data)) {
    		      return fromArrayLike(that, obj.data)
    		    }
    		  }

    		  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
    		}

    		function checked (length) {
    		  // Note: cannot use `length < kMaxLength()` here because that fails when
    		  // length is NaN (which is otherwise coerced to zero.)
    		  if (length >= kMaxLength()) {
    		    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
    		                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
    		  }
    		  return length | 0
    		}

    		function SlowBuffer (length) {
    		  if (+length != length) { // eslint-disable-line eqeqeq
    		    length = 0;
    		  }
    		  return Buffer$c.alloc(+length)
    		}
    		Buffer$c.isBuffer = isBuffer$1;
    		function internalIsBuffer (b) {
    		  return !!(b != null && b._isBuffer)
    		}

    		Buffer$c.compare = function compare (a, b) {
    		  if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
    		    throw new TypeError('Arguments must be Buffers')
    		  }

    		  if (a === b) return 0

    		  var x = a.length;
    		  var y = b.length;

    		  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    		    if (a[i] !== b[i]) {
    		      x = a[i];
    		      y = b[i];
    		      break
    		    }
    		  }

    		  if (x < y) return -1
    		  if (y < x) return 1
    		  return 0
    		};

    		Buffer$c.isEncoding = function isEncoding (encoding) {
    		  switch (String(encoding).toLowerCase()) {
    		    case 'hex':
    		    case 'utf8':
    		    case 'utf-8':
    		    case 'ascii':
    		    case 'latin1':
    		    case 'binary':
    		    case 'base64':
    		    case 'ucs2':
    		    case 'ucs-2':
    		    case 'utf16le':
    		    case 'utf-16le':
    		      return true
    		    default:
    		      return false
    		  }
    		};

    		Buffer$c.concat = function concat (list, length) {
    		  if (!isArray$1(list)) {
    		    throw new TypeError('"list" argument must be an Array of Buffers')
    		  }

    		  if (list.length === 0) {
    		    return Buffer$c.alloc(0)
    		  }

    		  var i;
    		  if (length === undefined) {
    		    length = 0;
    		    for (i = 0; i < list.length; ++i) {
    		      length += list[i].length;
    		    }
    		  }

    		  var buffer = Buffer$c.allocUnsafe(length);
    		  var pos = 0;
    		  for (i = 0; i < list.length; ++i) {
    		    var buf = list[i];
    		    if (!internalIsBuffer(buf)) {
    		      throw new TypeError('"list" argument must be an Array of Buffers')
    		    }
    		    buf.copy(buffer, pos);
    		    pos += buf.length;
    		  }
    		  return buffer
    		};

    		function byteLength (string, encoding) {
    		  if (internalIsBuffer(string)) {
    		    return string.length
    		  }
    		  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
    		      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    		    return string.byteLength
    		  }
    		  if (typeof string !== 'string') {
    		    string = '' + string;
    		  }

    		  var len = string.length;
    		  if (len === 0) return 0

    		  // Use a for loop to avoid recursion
    		  var loweredCase = false;
    		  for (;;) {
    		    switch (encoding) {
    		      case 'ascii':
    		      case 'latin1':
    		      case 'binary':
    		        return len
    		      case 'utf8':
    		      case 'utf-8':
    		      case undefined:
    		        return utf8ToBytes(string).length
    		      case 'ucs2':
    		      case 'ucs-2':
    		      case 'utf16le':
    		      case 'utf-16le':
    		        return len * 2
    		      case 'hex':
    		        return len >>> 1
    		      case 'base64':
    		        return base64ToBytes(string).length
    		      default:
    		        if (loweredCase) return utf8ToBytes(string).length // assume utf8
    		        encoding = ('' + encoding).toLowerCase();
    		        loweredCase = true;
    		    }
    		  }
    		}
    		Buffer$c.byteLength = byteLength;

    		function slowToString (encoding, start, end) {
    		  var loweredCase = false;

    		  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    		  // property of a typed array.

    		  // This behaves neither like String nor Uint8Array in that we set start/end
    		  // to their upper/lower bounds if the value passed is out of range.
    		  // undefined is handled specially as per ECMA-262 6th Edition,
    		  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    		  if (start === undefined || start < 0) {
    		    start = 0;
    		  }
    		  // Return early if start > this.length. Done here to prevent potential uint32
    		  // coercion fail below.
    		  if (start > this.length) {
    		    return ''
    		  }

    		  if (end === undefined || end > this.length) {
    		    end = this.length;
    		  }

    		  if (end <= 0) {
    		    return ''
    		  }

    		  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    		  end >>>= 0;
    		  start >>>= 0;

    		  if (end <= start) {
    		    return ''
    		  }

    		  if (!encoding) encoding = 'utf8';

    		  while (true) {
    		    switch (encoding) {
    		      case 'hex':
    		        return hexSlice(this, start, end)

    		      case 'utf8':
    		      case 'utf-8':
    		        return utf8Slice(this, start, end)

    		      case 'ascii':
    		        return asciiSlice(this, start, end)

    		      case 'latin1':
    		      case 'binary':
    		        return latin1Slice(this, start, end)

    		      case 'base64':
    		        return base64Slice(this, start, end)

    		      case 'ucs2':
    		      case 'ucs-2':
    		      case 'utf16le':
    		      case 'utf-16le':
    		        return utf16leSlice(this, start, end)

    		      default:
    		        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
    		        encoding = (encoding + '').toLowerCase();
    		        loweredCase = true;
    		    }
    		  }
    		}

    		// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
    		// Buffer instances.
    		Buffer$c.prototype._isBuffer = true;

    		function swap (b, n, m) {
    		  var i = b[n];
    		  b[n] = b[m];
    		  b[m] = i;
    		}

    		Buffer$c.prototype.swap16 = function swap16 () {
    		  var len = this.length;
    		  if (len % 2 !== 0) {
    		    throw new RangeError('Buffer size must be a multiple of 16-bits')
    		  }
    		  for (var i = 0; i < len; i += 2) {
    		    swap(this, i, i + 1);
    		  }
    		  return this
    		};

    		Buffer$c.prototype.swap32 = function swap32 () {
    		  var len = this.length;
    		  if (len % 4 !== 0) {
    		    throw new RangeError('Buffer size must be a multiple of 32-bits')
    		  }
    		  for (var i = 0; i < len; i += 4) {
    		    swap(this, i, i + 3);
    		    swap(this, i + 1, i + 2);
    		  }
    		  return this
    		};

    		Buffer$c.prototype.swap64 = function swap64 () {
    		  var len = this.length;
    		  if (len % 8 !== 0) {
    		    throw new RangeError('Buffer size must be a multiple of 64-bits')
    		  }
    		  for (var i = 0; i < len; i += 8) {
    		    swap(this, i, i + 7);
    		    swap(this, i + 1, i + 6);
    		    swap(this, i + 2, i + 5);
    		    swap(this, i + 3, i + 4);
    		  }
    		  return this
    		};

    		Buffer$c.prototype.toString = function toString () {
    		  var length = this.length | 0;
    		  if (length === 0) return ''
    		  if (arguments.length === 0) return utf8Slice(this, 0, length)
    		  return slowToString.apply(this, arguments)
    		};

    		Buffer$c.prototype.equals = function equals (b) {
    		  if (!internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer')
    		  if (this === b) return true
    		  return Buffer$c.compare(this, b) === 0
    		};

    		Buffer$c.prototype.inspect = function inspect () {
    		  var str = '';
    		  var max = INSPECT_MAX_BYTES;
    		  if (this.length > 0) {
    		    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
    		    if (this.length > max) str += ' ... ';
    		  }
    		  return '<Buffer ' + str + '>'
    		};

    		Buffer$c.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
    		  if (!internalIsBuffer(target)) {
    		    throw new TypeError('Argument must be a Buffer')
    		  }

    		  if (start === undefined) {
    		    start = 0;
    		  }
    		  if (end === undefined) {
    		    end = target ? target.length : 0;
    		  }
    		  if (thisStart === undefined) {
    		    thisStart = 0;
    		  }
    		  if (thisEnd === undefined) {
    		    thisEnd = this.length;
    		  }

    		  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    		    throw new RangeError('out of range index')
    		  }

    		  if (thisStart >= thisEnd && start >= end) {
    		    return 0
    		  }
    		  if (thisStart >= thisEnd) {
    		    return -1
    		  }
    		  if (start >= end) {
    		    return 1
    		  }

    		  start >>>= 0;
    		  end >>>= 0;
    		  thisStart >>>= 0;
    		  thisEnd >>>= 0;

    		  if (this === target) return 0

    		  var x = thisEnd - thisStart;
    		  var y = end - start;
    		  var len = Math.min(x, y);

    		  var thisCopy = this.slice(thisStart, thisEnd);
    		  var targetCopy = target.slice(start, end);

    		  for (var i = 0; i < len; ++i) {
    		    if (thisCopy[i] !== targetCopy[i]) {
    		      x = thisCopy[i];
    		      y = targetCopy[i];
    		      break
    		    }
    		  }

    		  if (x < y) return -1
    		  if (y < x) return 1
    		  return 0
    		};

    		// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    		// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    		//
    		// Arguments:
    		// - buffer - a Buffer to search
    		// - val - a string, Buffer, or number
    		// - byteOffset - an index into `buffer`; will be clamped to an int32
    		// - encoding - an optional encoding, relevant is val is a string
    		// - dir - true for indexOf, false for lastIndexOf
    		function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
    		  // Empty buffer means no match
    		  if (buffer.length === 0) return -1

    		  // Normalize byteOffset
    		  if (typeof byteOffset === 'string') {
    		    encoding = byteOffset;
    		    byteOffset = 0;
    		  } else if (byteOffset > 0x7fffffff) {
    		    byteOffset = 0x7fffffff;
    		  } else if (byteOffset < -0x80000000) {
    		    byteOffset = -0x80000000;
    		  }
    		  byteOffset = +byteOffset;  // Coerce to Number.
    		  if (isNaN(byteOffset)) {
    		    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    		    byteOffset = dir ? 0 : (buffer.length - 1);
    		  }

    		  // Normalize byteOffset: negative offsets start from the end of the buffer
    		  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    		  if (byteOffset >= buffer.length) {
    		    if (dir) return -1
    		    else byteOffset = buffer.length - 1;
    		  } else if (byteOffset < 0) {
    		    if (dir) byteOffset = 0;
    		    else return -1
    		  }

    		  // Normalize val
    		  if (typeof val === 'string') {
    		    val = Buffer$c.from(val, encoding);
    		  }

    		  // Finally, search either indexOf (if dir is true) or lastIndexOf
    		  if (internalIsBuffer(val)) {
    		    // Special case: looking for empty string/buffer always fails
    		    if (val.length === 0) {
    		      return -1
    		    }
    		    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
    		  } else if (typeof val === 'number') {
    		    val = val & 0xFF; // Search for a byte value [0-255]
    		    if (Buffer$c.TYPED_ARRAY_SUPPORT &&
    		        typeof Uint8Array.prototype.indexOf === 'function') {
    		      if (dir) {
    		        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
    		      } else {
    		        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
    		      }
    		    }
    		    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
    		  }

    		  throw new TypeError('val must be string, number or Buffer')
    		}

    		function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
    		  var indexSize = 1;
    		  var arrLength = arr.length;
    		  var valLength = val.length;

    		  if (encoding !== undefined) {
    		    encoding = String(encoding).toLowerCase();
    		    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
    		        encoding === 'utf16le' || encoding === 'utf-16le') {
    		      if (arr.length < 2 || val.length < 2) {
    		        return -1
    		      }
    		      indexSize = 2;
    		      arrLength /= 2;
    		      valLength /= 2;
    		      byteOffset /= 2;
    		    }
    		  }

    		  function read (buf, i) {
    		    if (indexSize === 1) {
    		      return buf[i]
    		    } else {
    		      return buf.readUInt16BE(i * indexSize)
    		    }
    		  }

    		  var i;
    		  if (dir) {
    		    var foundIndex = -1;
    		    for (i = byteOffset; i < arrLength; i++) {
    		      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
    		        if (foundIndex === -1) foundIndex = i;
    		        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
    		      } else {
    		        if (foundIndex !== -1) i -= i - foundIndex;
    		        foundIndex = -1;
    		      }
    		    }
    		  } else {
    		    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    		    for (i = byteOffset; i >= 0; i--) {
    		      var found = true;
    		      for (var j = 0; j < valLength; j++) {
    		        if (read(arr, i + j) !== read(val, j)) {
    		          found = false;
    		          break
    		        }
    		      }
    		      if (found) return i
    		    }
    		  }

    		  return -1
    		}

    		Buffer$c.prototype.includes = function includes (val, byteOffset, encoding) {
    		  return this.indexOf(val, byteOffset, encoding) !== -1
    		};

    		Buffer$c.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
    		  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
    		};

    		Buffer$c.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
    		  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
    		};

    		function hexWrite (buf, string, offset, length) {
    		  offset = Number(offset) || 0;
    		  var remaining = buf.length - offset;
    		  if (!length) {
    		    length = remaining;
    		  } else {
    		    length = Number(length);
    		    if (length > remaining) {
    		      length = remaining;
    		    }
    		  }

    		  // must be an even number of digits
    		  var strLen = string.length;
    		  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

    		  if (length > strLen / 2) {
    		    length = strLen / 2;
    		  }
    		  for (var i = 0; i < length; ++i) {
    		    var parsed = parseInt(string.substr(i * 2, 2), 16);
    		    if (isNaN(parsed)) return i
    		    buf[offset + i] = parsed;
    		  }
    		  return i
    		}

    		function utf8Write (buf, string, offset, length) {
    		  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
    		}

    		function asciiWrite (buf, string, offset, length) {
    		  return blitBuffer(asciiToBytes(string), buf, offset, length)
    		}

    		function latin1Write (buf, string, offset, length) {
    		  return asciiWrite(buf, string, offset, length)
    		}

    		function base64Write (buf, string, offset, length) {
    		  return blitBuffer(base64ToBytes(string), buf, offset, length)
    		}

    		function ucs2Write (buf, string, offset, length) {
    		  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
    		}

    		Buffer$c.prototype.write = function write (string, offset, length, encoding) {
    		  // Buffer#write(string)
    		  if (offset === undefined) {
    		    encoding = 'utf8';
    		    length = this.length;
    		    offset = 0;
    		  // Buffer#write(string, encoding)
    		  } else if (length === undefined && typeof offset === 'string') {
    		    encoding = offset;
    		    length = this.length;
    		    offset = 0;
    		  // Buffer#write(string, offset[, length][, encoding])
    		  } else if (isFinite(offset)) {
    		    offset = offset | 0;
    		    if (isFinite(length)) {
    		      length = length | 0;
    		      if (encoding === undefined) encoding = 'utf8';
    		    } else {
    		      encoding = length;
    		      length = undefined;
    		    }
    		  // legacy write(string, encoding, offset, length) - remove in v0.13
    		  } else {
    		    throw new Error(
    		      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    		    )
    		  }

    		  var remaining = this.length - offset;
    		  if (length === undefined || length > remaining) length = remaining;

    		  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    		    throw new RangeError('Attempt to write outside buffer bounds')
    		  }

    		  if (!encoding) encoding = 'utf8';

    		  var loweredCase = false;
    		  for (;;) {
    		    switch (encoding) {
    		      case 'hex':
    		        return hexWrite(this, string, offset, length)

    		      case 'utf8':
    		      case 'utf-8':
    		        return utf8Write(this, string, offset, length)

    		      case 'ascii':
    		        return asciiWrite(this, string, offset, length)

    		      case 'latin1':
    		      case 'binary':
    		        return latin1Write(this, string, offset, length)

    		      case 'base64':
    		        // Warning: maxLength not taken into account in base64Write
    		        return base64Write(this, string, offset, length)

    		      case 'ucs2':
    		      case 'ucs-2':
    		      case 'utf16le':
    		      case 'utf-16le':
    		        return ucs2Write(this, string, offset, length)

    		      default:
    		        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
    		        encoding = ('' + encoding).toLowerCase();
    		        loweredCase = true;
    		    }
    		  }
    		};

    		Buffer$c.prototype.toJSON = function toJSON () {
    		  return {
    		    type: 'Buffer',
    		    data: Array.prototype.slice.call(this._arr || this, 0)
    		  }
    		};

    		function base64Slice (buf, start, end) {
    		  if (start === 0 && end === buf.length) {
    		    return fromByteArray(buf)
    		  } else {
    		    return fromByteArray(buf.slice(start, end))
    		  }
    		}

    		function utf8Slice (buf, start, end) {
    		  end = Math.min(buf.length, end);
    		  var res = [];

    		  var i = start;
    		  while (i < end) {
    		    var firstByte = buf[i];
    		    var codePoint = null;
    		    var bytesPerSequence = (firstByte > 0xEF) ? 4
    		      : (firstByte > 0xDF) ? 3
    		      : (firstByte > 0xBF) ? 2
    		      : 1;

    		    if (i + bytesPerSequence <= end) {
    		      var secondByte, thirdByte, fourthByte, tempCodePoint;

    		      switch (bytesPerSequence) {
    		        case 1:
    		          if (firstByte < 0x80) {
    		            codePoint = firstByte;
    		          }
    		          break
    		        case 2:
    		          secondByte = buf[i + 1];
    		          if ((secondByte & 0xC0) === 0x80) {
    		            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
    		            if (tempCodePoint > 0x7F) {
    		              codePoint = tempCodePoint;
    		            }
    		          }
    		          break
    		        case 3:
    		          secondByte = buf[i + 1];
    		          thirdByte = buf[i + 2];
    		          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
    		            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
    		            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
    		              codePoint = tempCodePoint;
    		            }
    		          }
    		          break
    		        case 4:
    		          secondByte = buf[i + 1];
    		          thirdByte = buf[i + 2];
    		          fourthByte = buf[i + 3];
    		          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
    		            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
    		            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
    		              codePoint = tempCodePoint;
    		            }
    		          }
    		      }
    		    }

    		    if (codePoint === null) {
    		      // we did not generate a valid codePoint so insert a
    		      // replacement char (U+FFFD) and advance only 1 byte
    		      codePoint = 0xFFFD;
    		      bytesPerSequence = 1;
    		    } else if (codePoint > 0xFFFF) {
    		      // encode to utf16 (surrogate pair dance)
    		      codePoint -= 0x10000;
    		      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
    		      codePoint = 0xDC00 | codePoint & 0x3FF;
    		    }

    		    res.push(codePoint);
    		    i += bytesPerSequence;
    		  }

    		  return decodeCodePointsArray(res)
    		}

    		// Based on http://stackoverflow.com/a/22747272/680742, the browser with
    		// the lowest limit is Chrome, with 0x10000 args.
    		// We go 1 magnitude less, for safety
    		var MAX_ARGUMENTS_LENGTH = 0x1000;

    		function decodeCodePointsArray (codePoints) {
    		  var len = codePoints.length;
    		  if (len <= MAX_ARGUMENTS_LENGTH) {
    		    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    		  }

    		  // Decode in chunks to avoid "call stack size exceeded".
    		  var res = '';
    		  var i = 0;
    		  while (i < len) {
    		    res += String.fromCharCode.apply(
    		      String,
    		      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    		    );
    		  }
    		  return res
    		}

    		function asciiSlice (buf, start, end) {
    		  var ret = '';
    		  end = Math.min(buf.length, end);

    		  for (var i = start; i < end; ++i) {
    		    ret += String.fromCharCode(buf[i] & 0x7F);
    		  }
    		  return ret
    		}

    		function latin1Slice (buf, start, end) {
    		  var ret = '';
    		  end = Math.min(buf.length, end);

    		  for (var i = start; i < end; ++i) {
    		    ret += String.fromCharCode(buf[i]);
    		  }
    		  return ret
    		}

    		function hexSlice (buf, start, end) {
    		  var len = buf.length;

    		  if (!start || start < 0) start = 0;
    		  if (!end || end < 0 || end > len) end = len;

    		  var out = '';
    		  for (var i = start; i < end; ++i) {
    		    out += toHex$1(buf[i]);
    		  }
    		  return out
    		}

    		function utf16leSlice (buf, start, end) {
    		  var bytes = buf.slice(start, end);
    		  var res = '';
    		  for (var i = 0; i < bytes.length; i += 2) {
    		    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    		  }
    		  return res
    		}

    		Buffer$c.prototype.slice = function slice (start, end) {
    		  var len = this.length;
    		  start = ~~start;
    		  end = end === undefined ? len : ~~end;

    		  if (start < 0) {
    		    start += len;
    		    if (start < 0) start = 0;
    		  } else if (start > len) {
    		    start = len;
    		  }

    		  if (end < 0) {
    		    end += len;
    		    if (end < 0) end = 0;
    		  } else if (end > len) {
    		    end = len;
    		  }

    		  if (end < start) end = start;

    		  var newBuf;
    		  if (Buffer$c.TYPED_ARRAY_SUPPORT) {
    		    newBuf = this.subarray(start, end);
    		    newBuf.__proto__ = Buffer$c.prototype;
    		  } else {
    		    var sliceLen = end - start;
    		    newBuf = new Buffer$c(sliceLen, undefined);
    		    for (var i = 0; i < sliceLen; ++i) {
    		      newBuf[i] = this[i + start];
    		    }
    		  }

    		  return newBuf
    		};

    		/*
    		 * Need to make sure that buffer isn't trying to write out of bounds.
    		 */
    		function checkOffset (offset, ext, length) {
    		  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
    		  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
    		}

    		Buffer$c.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
    		  offset = offset | 0;
    		  byteLength = byteLength | 0;
    		  if (!noAssert) checkOffset(offset, byteLength, this.length);

    		  var val = this[offset];
    		  var mul = 1;
    		  var i = 0;
    		  while (++i < byteLength && (mul *= 0x100)) {
    		    val += this[offset + i] * mul;
    		  }

    		  return val
    		};

    		Buffer$c.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
    		  offset = offset | 0;
    		  byteLength = byteLength | 0;
    		  if (!noAssert) {
    		    checkOffset(offset, byteLength, this.length);
    		  }

    		  var val = this[offset + --byteLength];
    		  var mul = 1;
    		  while (byteLength > 0 && (mul *= 0x100)) {
    		    val += this[offset + --byteLength] * mul;
    		  }

    		  return val
    		};

    		Buffer$c.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
    		  if (!noAssert) checkOffset(offset, 1, this.length);
    		  return this[offset]
    		};

    		Buffer$c.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
    		  if (!noAssert) checkOffset(offset, 2, this.length);
    		  return this[offset] | (this[offset + 1] << 8)
    		};

    		Buffer$c.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
    		  if (!noAssert) checkOffset(offset, 2, this.length);
    		  return (this[offset] << 8) | this[offset + 1]
    		};

    		Buffer$c.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
    		  if (!noAssert) checkOffset(offset, 4, this.length);

    		  return ((this[offset]) |
    		      (this[offset + 1] << 8) |
    		      (this[offset + 2] << 16)) +
    		      (this[offset + 3] * 0x1000000)
    		};

    		Buffer$c.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
    		  if (!noAssert) checkOffset(offset, 4, this.length);

    		  return (this[offset] * 0x1000000) +
    		    ((this[offset + 1] << 16) |
    		    (this[offset + 2] << 8) |
    		    this[offset + 3])
    		};

    		Buffer$c.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
    		  offset = offset | 0;
    		  byteLength = byteLength | 0;
    		  if (!noAssert) checkOffset(offset, byteLength, this.length);

    		  var val = this[offset];
    		  var mul = 1;
    		  var i = 0;
    		  while (++i < byteLength && (mul *= 0x100)) {
    		    val += this[offset + i] * mul;
    		  }
    		  mul *= 0x80;

    		  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

    		  return val
    		};

    		Buffer$c.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
    		  offset = offset | 0;
    		  byteLength = byteLength | 0;
    		  if (!noAssert) checkOffset(offset, byteLength, this.length);

    		  var i = byteLength;
    		  var mul = 1;
    		  var val = this[offset + --i];
    		  while (i > 0 && (mul *= 0x100)) {
    		    val += this[offset + --i] * mul;
    		  }
    		  mul *= 0x80;

    		  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

    		  return val
    		};

    		Buffer$c.prototype.readInt8 = function readInt8 (offset, noAssert) {
    		  if (!noAssert) checkOffset(offset, 1, this.length);
    		  if (!(this[offset] & 0x80)) return (this[offset])
    		  return ((0xff - this[offset] + 1) * -1)
    		};

    		Buffer$c.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
    		  if (!noAssert) checkOffset(offset, 2, this.length);
    		  var val = this[offset] | (this[offset + 1] << 8);
    		  return (val & 0x8000) ? val | 0xFFFF0000 : val
    		};

    		Buffer$c.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
    		  if (!noAssert) checkOffset(offset, 2, this.length);
    		  var val = this[offset + 1] | (this[offset] << 8);
    		  return (val & 0x8000) ? val | 0xFFFF0000 : val
    		};

    		Buffer$c.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
    		  if (!noAssert) checkOffset(offset, 4, this.length);

    		  return (this[offset]) |
    		    (this[offset + 1] << 8) |
    		    (this[offset + 2] << 16) |
    		    (this[offset + 3] << 24)
    		};

    		Buffer$c.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
    		  if (!noAssert) checkOffset(offset, 4, this.length);

    		  return (this[offset] << 24) |
    		    (this[offset + 1] << 16) |
    		    (this[offset + 2] << 8) |
    		    (this[offset + 3])
    		};

    		Buffer$c.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
    		  if (!noAssert) checkOffset(offset, 4, this.length);
    		  return read(this, offset, true, 23, 4)
    		};

    		Buffer$c.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
    		  if (!noAssert) checkOffset(offset, 4, this.length);
    		  return read(this, offset, false, 23, 4)
    		};

    		Buffer$c.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
    		  if (!noAssert) checkOffset(offset, 8, this.length);
    		  return read(this, offset, true, 52, 8)
    		};

    		Buffer$c.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
    		  if (!noAssert) checkOffset(offset, 8, this.length);
    		  return read(this, offset, false, 52, 8)
    		};

    		function checkInt (buf, value, offset, ext, max, min) {
    		  if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
    		  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
    		  if (offset + ext > buf.length) throw new RangeError('Index out of range')
    		}

    		Buffer$c.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
    		  value = +value;
    		  offset = offset | 0;
    		  byteLength = byteLength | 0;
    		  if (!noAssert) {
    		    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    		    checkInt(this, value, offset, byteLength, maxBytes, 0);
    		  }

    		  var mul = 1;
    		  var i = 0;
    		  this[offset] = value & 0xFF;
    		  while (++i < byteLength && (mul *= 0x100)) {
    		    this[offset + i] = (value / mul) & 0xFF;
    		  }

    		  return offset + byteLength
    		};

    		Buffer$c.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
    		  value = +value;
    		  offset = offset | 0;
    		  byteLength = byteLength | 0;
    		  if (!noAssert) {
    		    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    		    checkInt(this, value, offset, byteLength, maxBytes, 0);
    		  }

    		  var i = byteLength - 1;
    		  var mul = 1;
    		  this[offset + i] = value & 0xFF;
    		  while (--i >= 0 && (mul *= 0x100)) {
    		    this[offset + i] = (value / mul) & 0xFF;
    		  }

    		  return offset + byteLength
    		};

    		Buffer$c.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
    		  value = +value;
    		  offset = offset | 0;
    		  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    		  if (!Buffer$c.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    		  this[offset] = (value & 0xff);
    		  return offset + 1
    		};

    		function objectWriteUInt16 (buf, value, offset, littleEndian) {
    		  if (value < 0) value = 0xffff + value + 1;
    		  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    		    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
    		      (littleEndian ? i : 1 - i) * 8;
    		  }
    		}

    		Buffer$c.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
    		  value = +value;
    		  offset = offset | 0;
    		  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    		  if (Buffer$c.TYPED_ARRAY_SUPPORT) {
    		    this[offset] = (value & 0xff);
    		    this[offset + 1] = (value >>> 8);
    		  } else {
    		    objectWriteUInt16(this, value, offset, true);
    		  }
    		  return offset + 2
    		};

    		Buffer$c.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
    		  value = +value;
    		  offset = offset | 0;
    		  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    		  if (Buffer$c.TYPED_ARRAY_SUPPORT) {
    		    this[offset] = (value >>> 8);
    		    this[offset + 1] = (value & 0xff);
    		  } else {
    		    objectWriteUInt16(this, value, offset, false);
    		  }
    		  return offset + 2
    		};

    		function objectWriteUInt32 (buf, value, offset, littleEndian) {
    		  if (value < 0) value = 0xffffffff + value + 1;
    		  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    		    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff;
    		  }
    		}

    		Buffer$c.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
    		  value = +value;
    		  offset = offset | 0;
    		  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    		  if (Buffer$c.TYPED_ARRAY_SUPPORT) {
    		    this[offset + 3] = (value >>> 24);
    		    this[offset + 2] = (value >>> 16);
    		    this[offset + 1] = (value >>> 8);
    		    this[offset] = (value & 0xff);
    		  } else {
    		    objectWriteUInt32(this, value, offset, true);
    		  }
    		  return offset + 4
    		};

    		Buffer$c.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
    		  value = +value;
    		  offset = offset | 0;
    		  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    		  if (Buffer$c.TYPED_ARRAY_SUPPORT) {
    		    this[offset] = (value >>> 24);
    		    this[offset + 1] = (value >>> 16);
    		    this[offset + 2] = (value >>> 8);
    		    this[offset + 3] = (value & 0xff);
    		  } else {
    		    objectWriteUInt32(this, value, offset, false);
    		  }
    		  return offset + 4
    		};

    		Buffer$c.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
    		  value = +value;
    		  offset = offset | 0;
    		  if (!noAssert) {
    		    var limit = Math.pow(2, 8 * byteLength - 1);

    		    checkInt(this, value, offset, byteLength, limit - 1, -limit);
    		  }

    		  var i = 0;
    		  var mul = 1;
    		  var sub = 0;
    		  this[offset] = value & 0xFF;
    		  while (++i < byteLength && (mul *= 0x100)) {
    		    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
    		      sub = 1;
    		    }
    		    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
    		  }

    		  return offset + byteLength
    		};

    		Buffer$c.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
    		  value = +value;
    		  offset = offset | 0;
    		  if (!noAssert) {
    		    var limit = Math.pow(2, 8 * byteLength - 1);

    		    checkInt(this, value, offset, byteLength, limit - 1, -limit);
    		  }

    		  var i = byteLength - 1;
    		  var mul = 1;
    		  var sub = 0;
    		  this[offset + i] = value & 0xFF;
    		  while (--i >= 0 && (mul *= 0x100)) {
    		    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
    		      sub = 1;
    		    }
    		    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
    		  }

    		  return offset + byteLength
    		};

    		Buffer$c.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
    		  value = +value;
    		  offset = offset | 0;
    		  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
    		  if (!Buffer$c.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    		  if (value < 0) value = 0xff + value + 1;
    		  this[offset] = (value & 0xff);
    		  return offset + 1
    		};

    		Buffer$c.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
    		  value = +value;
    		  offset = offset | 0;
    		  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    		  if (Buffer$c.TYPED_ARRAY_SUPPORT) {
    		    this[offset] = (value & 0xff);
    		    this[offset + 1] = (value >>> 8);
    		  } else {
    		    objectWriteUInt16(this, value, offset, true);
    		  }
    		  return offset + 2
    		};

    		Buffer$c.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
    		  value = +value;
    		  offset = offset | 0;
    		  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    		  if (Buffer$c.TYPED_ARRAY_SUPPORT) {
    		    this[offset] = (value >>> 8);
    		    this[offset + 1] = (value & 0xff);
    		  } else {
    		    objectWriteUInt16(this, value, offset, false);
    		  }
    		  return offset + 2
    		};

    		Buffer$c.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
    		  value = +value;
    		  offset = offset | 0;
    		  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    		  if (Buffer$c.TYPED_ARRAY_SUPPORT) {
    		    this[offset] = (value & 0xff);
    		    this[offset + 1] = (value >>> 8);
    		    this[offset + 2] = (value >>> 16);
    		    this[offset + 3] = (value >>> 24);
    		  } else {
    		    objectWriteUInt32(this, value, offset, true);
    		  }
    		  return offset + 4
    		};

    		Buffer$c.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
    		  value = +value;
    		  offset = offset | 0;
    		  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    		  if (value < 0) value = 0xffffffff + value + 1;
    		  if (Buffer$c.TYPED_ARRAY_SUPPORT) {
    		    this[offset] = (value >>> 24);
    		    this[offset + 1] = (value >>> 16);
    		    this[offset + 2] = (value >>> 8);
    		    this[offset + 3] = (value & 0xff);
    		  } else {
    		    objectWriteUInt32(this, value, offset, false);
    		  }
    		  return offset + 4
    		};

    		function checkIEEE754 (buf, value, offset, ext, max, min) {
    		  if (offset + ext > buf.length) throw new RangeError('Index out of range')
    		  if (offset < 0) throw new RangeError('Index out of range')
    		}

    		function writeFloat (buf, value, offset, littleEndian, noAssert) {
    		  if (!noAssert) {
    		    checkIEEE754(buf, value, offset, 4);
    		  }
    		  write(buf, value, offset, littleEndian, 23, 4);
    		  return offset + 4
    		}

    		Buffer$c.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
    		  return writeFloat(this, value, offset, true, noAssert)
    		};

    		Buffer$c.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
    		  return writeFloat(this, value, offset, false, noAssert)
    		};

    		function writeDouble (buf, value, offset, littleEndian, noAssert) {
    		  if (!noAssert) {
    		    checkIEEE754(buf, value, offset, 8);
    		  }
    		  write(buf, value, offset, littleEndian, 52, 8);
    		  return offset + 8
    		}

    		Buffer$c.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
    		  return writeDouble(this, value, offset, true, noAssert)
    		};

    		Buffer$c.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
    		  return writeDouble(this, value, offset, false, noAssert)
    		};

    		// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    		Buffer$c.prototype.copy = function copy (target, targetStart, start, end) {
    		  if (!start) start = 0;
    		  if (!end && end !== 0) end = this.length;
    		  if (targetStart >= target.length) targetStart = target.length;
    		  if (!targetStart) targetStart = 0;
    		  if (end > 0 && end < start) end = start;

    		  // Copy 0 bytes; we're done
    		  if (end === start) return 0
    		  if (target.length === 0 || this.length === 0) return 0

    		  // Fatal error conditions
    		  if (targetStart < 0) {
    		    throw new RangeError('targetStart out of bounds')
    		  }
    		  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
    		  if (end < 0) throw new RangeError('sourceEnd out of bounds')

    		  // Are we oob?
    		  if (end > this.length) end = this.length;
    		  if (target.length - targetStart < end - start) {
    		    end = target.length - targetStart + start;
    		  }

    		  var len = end - start;
    		  var i;

    		  if (this === target && start < targetStart && targetStart < end) {
    		    // descending copy from end
    		    for (i = len - 1; i >= 0; --i) {
    		      target[i + targetStart] = this[i + start];
    		    }
    		  } else if (len < 1000 || !Buffer$c.TYPED_ARRAY_SUPPORT) {
    		    // ascending copy from start
    		    for (i = 0; i < len; ++i) {
    		      target[i + targetStart] = this[i + start];
    		    }
    		  } else {
    		    Uint8Array.prototype.set.call(
    		      target,
    		      this.subarray(start, start + len),
    		      targetStart
    		    );
    		  }

    		  return len
    		};

    		// Usage:
    		//    buffer.fill(number[, offset[, end]])
    		//    buffer.fill(buffer[, offset[, end]])
    		//    buffer.fill(string[, offset[, end]][, encoding])
    		Buffer$c.prototype.fill = function fill (val, start, end, encoding) {
    		  // Handle string cases:
    		  if (typeof val === 'string') {
    		    if (typeof start === 'string') {
    		      encoding = start;
    		      start = 0;
    		      end = this.length;
    		    } else if (typeof end === 'string') {
    		      encoding = end;
    		      end = this.length;
    		    }
    		    if (val.length === 1) {
    		      var code = val.charCodeAt(0);
    		      if (code < 256) {
    		        val = code;
    		      }
    		    }
    		    if (encoding !== undefined && typeof encoding !== 'string') {
    		      throw new TypeError('encoding must be a string')
    		    }
    		    if (typeof encoding === 'string' && !Buffer$c.isEncoding(encoding)) {
    		      throw new TypeError('Unknown encoding: ' + encoding)
    		    }
    		  } else if (typeof val === 'number') {
    		    val = val & 255;
    		  }

    		  // Invalid ranges are not set to a default, so can range check early.
    		  if (start < 0 || this.length < start || this.length < end) {
    		    throw new RangeError('Out of range index')
    		  }

    		  if (end <= start) {
    		    return this
    		  }

    		  start = start >>> 0;
    		  end = end === undefined ? this.length : end >>> 0;

    		  if (!val) val = 0;

    		  var i;
    		  if (typeof val === 'number') {
    		    for (i = start; i < end; ++i) {
    		      this[i] = val;
    		    }
    		  } else {
    		    var bytes = internalIsBuffer(val)
    		      ? val
    		      : utf8ToBytes(new Buffer$c(val, encoding).toString());
    		    var len = bytes.length;
    		    for (i = 0; i < end - start; ++i) {
    		      this[i + start] = bytes[i % len];
    		    }
    		  }

    		  return this
    		};

    		// HELPER FUNCTIONS
    		// ================

    		var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

    		function base64clean (str) {
    		  // Node strips out invalid characters like \n and \t from the string, base64-js does not
    		  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
    		  // Node converts strings with length < 2 to ''
    		  if (str.length < 2) return ''
    		  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    		  while (str.length % 4 !== 0) {
    		    str = str + '=';
    		  }
    		  return str
    		}

    		function stringtrim (str) {
    		  if (str.trim) return str.trim()
    		  return str.replace(/^\s+|\s+$/g, '')
    		}

    		function toHex$1 (n) {
    		  if (n < 16) return '0' + n.toString(16)
    		  return n.toString(16)
    		}

    		function utf8ToBytes (string, units) {
    		  units = units || Infinity;
    		  var codePoint;
    		  var length = string.length;
    		  var leadSurrogate = null;
    		  var bytes = [];

    		  for (var i = 0; i < length; ++i) {
    		    codePoint = string.charCodeAt(i);

    		    // is surrogate component
    		    if (codePoint > 0xD7FF && codePoint < 0xE000) {
    		      // last char was a lead
    		      if (!leadSurrogate) {
    		        // no lead yet
    		        if (codePoint > 0xDBFF) {
    		          // unexpected trail
    		          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    		          continue
    		        } else if (i + 1 === length) {
    		          // unpaired lead
    		          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    		          continue
    		        }

    		        // valid lead
    		        leadSurrogate = codePoint;

    		        continue
    		      }

    		      // 2 leads in a row
    		      if (codePoint < 0xDC00) {
    		        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    		        leadSurrogate = codePoint;
    		        continue
    		      }

    		      // valid surrogate pair
    		      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    		    } else if (leadSurrogate) {
    		      // valid bmp char, but last char was a lead
    		      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    		    }

    		    leadSurrogate = null;

    		    // encode utf8
    		    if (codePoint < 0x80) {
    		      if ((units -= 1) < 0) break
    		      bytes.push(codePoint);
    		    } else if (codePoint < 0x800) {
    		      if ((units -= 2) < 0) break
    		      bytes.push(
    		        codePoint >> 0x6 | 0xC0,
    		        codePoint & 0x3F | 0x80
    		      );
    		    } else if (codePoint < 0x10000) {
    		      if ((units -= 3) < 0) break
    		      bytes.push(
    		        codePoint >> 0xC | 0xE0,
    		        codePoint >> 0x6 & 0x3F | 0x80,
    		        codePoint & 0x3F | 0x80
    		      );
    		    } else if (codePoint < 0x110000) {
    		      if ((units -= 4) < 0) break
    		      bytes.push(
    		        codePoint >> 0x12 | 0xF0,
    		        codePoint >> 0xC & 0x3F | 0x80,
    		        codePoint >> 0x6 & 0x3F | 0x80,
    		        codePoint & 0x3F | 0x80
    		      );
    		    } else {
    		      throw new Error('Invalid code point')
    		    }
    		  }

    		  return bytes
    		}

    		function asciiToBytes (str) {
    		  var byteArray = [];
    		  for (var i = 0; i < str.length; ++i) {
    		    // Node's code seems to be doing this and not & 0x7F..
    		    byteArray.push(str.charCodeAt(i) & 0xFF);
    		  }
    		  return byteArray
    		}

    		function utf16leToBytes (str, units) {
    		  var c, hi, lo;
    		  var byteArray = [];
    		  for (var i = 0; i < str.length; ++i) {
    		    if ((units -= 2) < 0) break

    		    c = str.charCodeAt(i);
    		    hi = c >> 8;
    		    lo = c % 256;
    		    byteArray.push(lo);
    		    byteArray.push(hi);
    		  }

    		  return byteArray
    		}


    		function base64ToBytes (str) {
    		  return toByteArray(base64clean(str))
    		}

    		function blitBuffer (src, dst, offset, length) {
    		  for (var i = 0; i < length; ++i) {
    		    if ((i + offset >= dst.length) || (i >= src.length)) break
    		    dst[i + offset] = src[i];
    		  }
    		  return i
    		}

    		function isnan (val) {
    		  return val !== val // eslint-disable-line no-self-compare
    		}


    		// the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
    		// The _isBuffer check is for Safari 5-7 support, because it's missing
    		// Object.prototype.constructor. Remove this eventually
    		function isBuffer$1(obj) {
    		  return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj))
    		}

    		function isFastBuffer (obj) {
    		  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
    		}

    		// For Node v0.10 support. Remove this eventually.
    		function isSlowBuffer (obj) {
    		  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0))
    		}

    		var _polyfillNode_buffer = /*#__PURE__*/Object.freeze({
    			__proto__: null,
    			Buffer: Buffer$c,
    			INSPECT_MAX_BYTES: INSPECT_MAX_BYTES,
    			SlowBuffer: SlowBuffer,
    			isBuffer: isBuffer$1,
    			kMaxLength: _kMaxLength
    		});

    		var require$$0$3 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_buffer);

    		bn.exports;

    		(function (module) {
    			(function (module, exports) {

    			  // Utils
    			  function assert (val, msg) {
    			    if (!val) throw new Error(msg || 'Assertion failed');
    			  }

    			  // Could use `inherits` module, but don't want to move from single file
    			  // architecture yet.
    			  function inherits (ctor, superCtor) {
    			    ctor.super_ = superCtor;
    			    var TempCtor = function () {};
    			    TempCtor.prototype = superCtor.prototype;
    			    ctor.prototype = new TempCtor();
    			    ctor.prototype.constructor = ctor;
    			  }

    			  // BN

    			  function BN (number, base, endian) {
    			    if (BN.isBN(number)) {
    			      return number;
    			    }

    			    this.negative = 0;
    			    this.words = null;
    			    this.length = 0;

    			    // Reduction context
    			    this.red = null;

    			    if (number !== null) {
    			      if (base === 'le' || base === 'be') {
    			        endian = base;
    			        base = 10;
    			      }

    			      this._init(number || 0, base || 10, endian || 'be');
    			    }
    			  }
    			  if (typeof module === 'object') {
    			    module.exports = BN;
    			  } else {
    			    exports.BN = BN;
    			  }

    			  BN.BN = BN;
    			  BN.wordSize = 26;

    			  var Buffer;
    			  try {
    			    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
    			      Buffer = window.Buffer;
    			    } else {
    			      Buffer = require$$0$3.Buffer;
    			    }
    			  } catch (e) {
    			  }

    			  BN.isBN = function isBN (num) {
    			    if (num instanceof BN) {
    			      return true;
    			    }

    			    return num !== null && typeof num === 'object' &&
    			      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    			  };

    			  BN.max = function max (left, right) {
    			    if (left.cmp(right) > 0) return left;
    			    return right;
    			  };

    			  BN.min = function min (left, right) {
    			    if (left.cmp(right) < 0) return left;
    			    return right;
    			  };

    			  BN.prototype._init = function init (number, base, endian) {
    			    if (typeof number === 'number') {
    			      return this._initNumber(number, base, endian);
    			    }

    			    if (typeof number === 'object') {
    			      return this._initArray(number, base, endian);
    			    }

    			    if (base === 'hex') {
    			      base = 16;
    			    }
    			    assert(base === (base | 0) && base >= 2 && base <= 36);

    			    number = number.toString().replace(/\s+/g, '');
    			    var start = 0;
    			    if (number[0] === '-') {
    			      start++;
    			      this.negative = 1;
    			    }

    			    if (start < number.length) {
    			      if (base === 16) {
    			        this._parseHex(number, start, endian);
    			      } else {
    			        this._parseBase(number, base, start);
    			        if (endian === 'le') {
    			          this._initArray(this.toArray(), base, endian);
    			        }
    			      }
    			    }
    			  };

    			  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    			    if (number < 0) {
    			      this.negative = 1;
    			      number = -number;
    			    }
    			    if (number < 0x4000000) {
    			      this.words = [ number & 0x3ffffff ];
    			      this.length = 1;
    			    } else if (number < 0x10000000000000) {
    			      this.words = [
    			        number & 0x3ffffff,
    			        (number / 0x4000000) & 0x3ffffff
    			      ];
    			      this.length = 2;
    			    } else {
    			      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
    			      this.words = [
    			        number & 0x3ffffff,
    			        (number / 0x4000000) & 0x3ffffff,
    			        1
    			      ];
    			      this.length = 3;
    			    }

    			    if (endian !== 'le') return;

    			    // Reverse the bytes
    			    this._initArray(this.toArray(), base, endian);
    			  };

    			  BN.prototype._initArray = function _initArray (number, base, endian) {
    			    // Perhaps a Uint8Array
    			    assert(typeof number.length === 'number');
    			    if (number.length <= 0) {
    			      this.words = [ 0 ];
    			      this.length = 1;
    			      return this;
    			    }

    			    this.length = Math.ceil(number.length / 3);
    			    this.words = new Array(this.length);
    			    for (var i = 0; i < this.length; i++) {
    			      this.words[i] = 0;
    			    }

    			    var j, w;
    			    var off = 0;
    			    if (endian === 'be') {
    			      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
    			        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
    			        this.words[j] |= (w << off) & 0x3ffffff;
    			        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
    			        off += 24;
    			        if (off >= 26) {
    			          off -= 26;
    			          j++;
    			        }
    			      }
    			    } else if (endian === 'le') {
    			      for (i = 0, j = 0; i < number.length; i += 3) {
    			        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
    			        this.words[j] |= (w << off) & 0x3ffffff;
    			        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
    			        off += 24;
    			        if (off >= 26) {
    			          off -= 26;
    			          j++;
    			        }
    			      }
    			    }
    			    return this.strip();
    			  };

    			  function parseHex4Bits (string, index) {
    			    var c = string.charCodeAt(index);
    			    // 'A' - 'F'
    			    if (c >= 65 && c <= 70) {
    			      return c - 55;
    			    // 'a' - 'f'
    			    } else if (c >= 97 && c <= 102) {
    			      return c - 87;
    			    // '0' - '9'
    			    } else {
    			      return (c - 48) & 0xf;
    			    }
    			  }

    			  function parseHexByte (string, lowerBound, index) {
    			    var r = parseHex4Bits(string, index);
    			    if (index - 1 >= lowerBound) {
    			      r |= parseHex4Bits(string, index - 1) << 4;
    			    }
    			    return r;
    			  }

    			  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    			    // Create possibly bigger array to ensure that it fits the number
    			    this.length = Math.ceil((number.length - start) / 6);
    			    this.words = new Array(this.length);
    			    for (var i = 0; i < this.length; i++) {
    			      this.words[i] = 0;
    			    }

    			    // 24-bits chunks
    			    var off = 0;
    			    var j = 0;

    			    var w;
    			    if (endian === 'be') {
    			      for (i = number.length - 1; i >= start; i -= 2) {
    			        w = parseHexByte(number, start, i) << off;
    			        this.words[j] |= w & 0x3ffffff;
    			        if (off >= 18) {
    			          off -= 18;
    			          j += 1;
    			          this.words[j] |= w >>> 26;
    			        } else {
    			          off += 8;
    			        }
    			      }
    			    } else {
    			      var parseLength = number.length - start;
    			      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
    			        w = parseHexByte(number, start, i) << off;
    			        this.words[j] |= w & 0x3ffffff;
    			        if (off >= 18) {
    			          off -= 18;
    			          j += 1;
    			          this.words[j] |= w >>> 26;
    			        } else {
    			          off += 8;
    			        }
    			      }
    			    }

    			    this.strip();
    			  };

    			  function parseBase (str, start, end, mul) {
    			    var r = 0;
    			    var len = Math.min(str.length, end);
    			    for (var i = start; i < len; i++) {
    			      var c = str.charCodeAt(i) - 48;

    			      r *= mul;

    			      // 'a'
    			      if (c >= 49) {
    			        r += c - 49 + 0xa;

    			      // 'A'
    			      } else if (c >= 17) {
    			        r += c - 17 + 0xa;

    			      // '0' - '9'
    			      } else {
    			        r += c;
    			      }
    			    }
    			    return r;
    			  }

    			  BN.prototype._parseBase = function _parseBase (number, base, start) {
    			    // Initialize as zero
    			    this.words = [ 0 ];
    			    this.length = 1;

    			    // Find length of limb in base
    			    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
    			      limbLen++;
    			    }
    			    limbLen--;
    			    limbPow = (limbPow / base) | 0;

    			    var total = number.length - start;
    			    var mod = total % limbLen;
    			    var end = Math.min(total, total - mod) + start;

    			    var word = 0;
    			    for (var i = start; i < end; i += limbLen) {
    			      word = parseBase(number, i, i + limbLen, base);

    			      this.imuln(limbPow);
    			      if (this.words[0] + word < 0x4000000) {
    			        this.words[0] += word;
    			      } else {
    			        this._iaddn(word);
    			      }
    			    }

    			    if (mod !== 0) {
    			      var pow = 1;
    			      word = parseBase(number, i, number.length, base);

    			      for (i = 0; i < mod; i++) {
    			        pow *= base;
    			      }

    			      this.imuln(pow);
    			      if (this.words[0] + word < 0x4000000) {
    			        this.words[0] += word;
    			      } else {
    			        this._iaddn(word);
    			      }
    			    }

    			    this.strip();
    			  };

    			  BN.prototype.copy = function copy (dest) {
    			    dest.words = new Array(this.length);
    			    for (var i = 0; i < this.length; i++) {
    			      dest.words[i] = this.words[i];
    			    }
    			    dest.length = this.length;
    			    dest.negative = this.negative;
    			    dest.red = this.red;
    			  };

    			  BN.prototype.clone = function clone () {
    			    var r = new BN(null);
    			    this.copy(r);
    			    return r;
    			  };

    			  BN.prototype._expand = function _expand (size) {
    			    while (this.length < size) {
    			      this.words[this.length++] = 0;
    			    }
    			    return this;
    			  };

    			  // Remove leading `0` from `this`
    			  BN.prototype.strip = function strip () {
    			    while (this.length > 1 && this.words[this.length - 1] === 0) {
    			      this.length--;
    			    }
    			    return this._normSign();
    			  };

    			  BN.prototype._normSign = function _normSign () {
    			    // -0 = 0
    			    if (this.length === 1 && this.words[0] === 0) {
    			      this.negative = 0;
    			    }
    			    return this;
    			  };

    			  BN.prototype.inspect = function inspect () {
    			    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    			  };

    			  /*

    			  var zeros = [];
    			  var groupSizes = [];
    			  var groupBases = [];

    			  var s = '';
    			  var i = -1;
    			  while (++i < BN.wordSize) {
    			    zeros[i] = s;
    			    s += '0';
    			  }
    			  groupSizes[0] = 0;
    			  groupSizes[1] = 0;
    			  groupBases[0] = 0;
    			  groupBases[1] = 0;
    			  var base = 2 - 1;
    			  while (++base < 36 + 1) {
    			    var groupSize = 0;
    			    var groupBase = 1;
    			    while (groupBase < (1 << BN.wordSize) / base) {
    			      groupBase *= base;
    			      groupSize += 1;
    			    }
    			    groupSizes[base] = groupSize;
    			    groupBases[base] = groupBase;
    			  }

    			  */

    			  var zeros = [
    			    '',
    			    '0',
    			    '00',
    			    '000',
    			    '0000',
    			    '00000',
    			    '000000',
    			    '0000000',
    			    '00000000',
    			    '000000000',
    			    '0000000000',
    			    '00000000000',
    			    '000000000000',
    			    '0000000000000',
    			    '00000000000000',
    			    '000000000000000',
    			    '0000000000000000',
    			    '00000000000000000',
    			    '000000000000000000',
    			    '0000000000000000000',
    			    '00000000000000000000',
    			    '000000000000000000000',
    			    '0000000000000000000000',
    			    '00000000000000000000000',
    			    '000000000000000000000000',
    			    '0000000000000000000000000'
    			  ];

    			  var groupSizes = [
    			    0, 0,
    			    25, 16, 12, 11, 10, 9, 8,
    			    8, 7, 7, 7, 7, 6, 6,
    			    6, 6, 6, 6, 6, 5, 5,
    			    5, 5, 5, 5, 5, 5, 5,
    			    5, 5, 5, 5, 5, 5, 5
    			  ];

    			  var groupBases = [
    			    0, 0,
    			    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    			    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    			    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    			    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    			    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
    			  ];

    			  BN.prototype.toString = function toString (base, padding) {
    			    base = base || 10;
    			    padding = padding | 0 || 1;

    			    var out;
    			    if (base === 16 || base === 'hex') {
    			      out = '';
    			      var off = 0;
    			      var carry = 0;
    			      for (var i = 0; i < this.length; i++) {
    			        var w = this.words[i];
    			        var word = (((w << off) | carry) & 0xffffff).toString(16);
    			        carry = (w >>> (24 - off)) & 0xffffff;
    			        if (carry !== 0 || i !== this.length - 1) {
    			          out = zeros[6 - word.length] + word + out;
    			        } else {
    			          out = word + out;
    			        }
    			        off += 2;
    			        if (off >= 26) {
    			          off -= 26;
    			          i--;
    			        }
    			      }
    			      if (carry !== 0) {
    			        out = carry.toString(16) + out;
    			      }
    			      while (out.length % padding !== 0) {
    			        out = '0' + out;
    			      }
    			      if (this.negative !== 0) {
    			        out = '-' + out;
    			      }
    			      return out;
    			    }

    			    if (base === (base | 0) && base >= 2 && base <= 36) {
    			      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
    			      var groupSize = groupSizes[base];
    			      // var groupBase = Math.pow(base, groupSize);
    			      var groupBase = groupBases[base];
    			      out = '';
    			      var c = this.clone();
    			      c.negative = 0;
    			      while (!c.isZero()) {
    			        var r = c.modn(groupBase).toString(base);
    			        c = c.idivn(groupBase);

    			        if (!c.isZero()) {
    			          out = zeros[groupSize - r.length] + r + out;
    			        } else {
    			          out = r + out;
    			        }
    			      }
    			      if (this.isZero()) {
    			        out = '0' + out;
    			      }
    			      while (out.length % padding !== 0) {
    			        out = '0' + out;
    			      }
    			      if (this.negative !== 0) {
    			        out = '-' + out;
    			      }
    			      return out;
    			    }

    			    assert(false, 'Base should be between 2 and 36');
    			  };

    			  BN.prototype.toNumber = function toNumber () {
    			    var ret = this.words[0];
    			    if (this.length === 2) {
    			      ret += this.words[1] * 0x4000000;
    			    } else if (this.length === 3 && this.words[2] === 0x01) {
    			      // NOTE: at this stage it is known that the top bit is set
    			      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    			    } else if (this.length > 2) {
    			      assert(false, 'Number can only safely store up to 53 bits');
    			    }
    			    return (this.negative !== 0) ? -ret : ret;
    			  };

    			  BN.prototype.toJSON = function toJSON () {
    			    return this.toString(16);
    			  };

    			  BN.prototype.toBuffer = function toBuffer (endian, length) {
    			    assert(typeof Buffer !== 'undefined');
    			    return this.toArrayLike(Buffer, endian, length);
    			  };

    			  BN.prototype.toArray = function toArray (endian, length) {
    			    return this.toArrayLike(Array, endian, length);
    			  };

    			  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    			    var byteLength = this.byteLength();
    			    var reqLength = length || Math.max(1, byteLength);
    			    assert(byteLength <= reqLength, 'byte array longer than desired length');
    			    assert(reqLength > 0, 'Requested array length <= 0');

    			    this.strip();
    			    var littleEndian = endian === 'le';
    			    var res = new ArrayType(reqLength);

    			    var b, i;
    			    var q = this.clone();
    			    if (!littleEndian) {
    			      // Assume big-endian
    			      for (i = 0; i < reqLength - byteLength; i++) {
    			        res[i] = 0;
    			      }

    			      for (i = 0; !q.isZero(); i++) {
    			        b = q.andln(0xff);
    			        q.iushrn(8);

    			        res[reqLength - i - 1] = b;
    			      }
    			    } else {
    			      for (i = 0; !q.isZero(); i++) {
    			        b = q.andln(0xff);
    			        q.iushrn(8);

    			        res[i] = b;
    			      }

    			      for (; i < reqLength; i++) {
    			        res[i] = 0;
    			      }
    			    }

    			    return res;
    			  };

    			  if (Math.clz32) {
    			    BN.prototype._countBits = function _countBits (w) {
    			      return 32 - Math.clz32(w);
    			    };
    			  } else {
    			    BN.prototype._countBits = function _countBits (w) {
    			      var t = w;
    			      var r = 0;
    			      if (t >= 0x1000) {
    			        r += 13;
    			        t >>>= 13;
    			      }
    			      if (t >= 0x40) {
    			        r += 7;
    			        t >>>= 7;
    			      }
    			      if (t >= 0x8) {
    			        r += 4;
    			        t >>>= 4;
    			      }
    			      if (t >= 0x02) {
    			        r += 2;
    			        t >>>= 2;
    			      }
    			      return r + t;
    			    };
    			  }

    			  BN.prototype._zeroBits = function _zeroBits (w) {
    			    // Short-cut
    			    if (w === 0) return 26;

    			    var t = w;
    			    var r = 0;
    			    if ((t & 0x1fff) === 0) {
    			      r += 13;
    			      t >>>= 13;
    			    }
    			    if ((t & 0x7f) === 0) {
    			      r += 7;
    			      t >>>= 7;
    			    }
    			    if ((t & 0xf) === 0) {
    			      r += 4;
    			      t >>>= 4;
    			    }
    			    if ((t & 0x3) === 0) {
    			      r += 2;
    			      t >>>= 2;
    			    }
    			    if ((t & 0x1) === 0) {
    			      r++;
    			    }
    			    return r;
    			  };

    			  // Return number of used bits in a BN
    			  BN.prototype.bitLength = function bitLength () {
    			    var w = this.words[this.length - 1];
    			    var hi = this._countBits(w);
    			    return (this.length - 1) * 26 + hi;
    			  };

    			  function toBitArray (num) {
    			    var w = new Array(num.bitLength());

    			    for (var bit = 0; bit < w.length; bit++) {
    			      var off = (bit / 26) | 0;
    			      var wbit = bit % 26;

    			      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    			    }

    			    return w;
    			  }

    			  // Number of trailing zero bits
    			  BN.prototype.zeroBits = function zeroBits () {
    			    if (this.isZero()) return 0;

    			    var r = 0;
    			    for (var i = 0; i < this.length; i++) {
    			      var b = this._zeroBits(this.words[i]);
    			      r += b;
    			      if (b !== 26) break;
    			    }
    			    return r;
    			  };

    			  BN.prototype.byteLength = function byteLength () {
    			    return Math.ceil(this.bitLength() / 8);
    			  };

    			  BN.prototype.toTwos = function toTwos (width) {
    			    if (this.negative !== 0) {
    			      return this.abs().inotn(width).iaddn(1);
    			    }
    			    return this.clone();
    			  };

    			  BN.prototype.fromTwos = function fromTwos (width) {
    			    if (this.testn(width - 1)) {
    			      return this.notn(width).iaddn(1).ineg();
    			    }
    			    return this.clone();
    			  };

    			  BN.prototype.isNeg = function isNeg () {
    			    return this.negative !== 0;
    			  };

    			  // Return negative clone of `this`
    			  BN.prototype.neg = function neg () {
    			    return this.clone().ineg();
    			  };

    			  BN.prototype.ineg = function ineg () {
    			    if (!this.isZero()) {
    			      this.negative ^= 1;
    			    }

    			    return this;
    			  };

    			  // Or `num` with `this` in-place
    			  BN.prototype.iuor = function iuor (num) {
    			    while (this.length < num.length) {
    			      this.words[this.length++] = 0;
    			    }

    			    for (var i = 0; i < num.length; i++) {
    			      this.words[i] = this.words[i] | num.words[i];
    			    }

    			    return this.strip();
    			  };

    			  BN.prototype.ior = function ior (num) {
    			    assert((this.negative | num.negative) === 0);
    			    return this.iuor(num);
    			  };

    			  // Or `num` with `this`
    			  BN.prototype.or = function or (num) {
    			    if (this.length > num.length) return this.clone().ior(num);
    			    return num.clone().ior(this);
    			  };

    			  BN.prototype.uor = function uor (num) {
    			    if (this.length > num.length) return this.clone().iuor(num);
    			    return num.clone().iuor(this);
    			  };

    			  // And `num` with `this` in-place
    			  BN.prototype.iuand = function iuand (num) {
    			    // b = min-length(num, this)
    			    var b;
    			    if (this.length > num.length) {
    			      b = num;
    			    } else {
    			      b = this;
    			    }

    			    for (var i = 0; i < b.length; i++) {
    			      this.words[i] = this.words[i] & num.words[i];
    			    }

    			    this.length = b.length;

    			    return this.strip();
    			  };

    			  BN.prototype.iand = function iand (num) {
    			    assert((this.negative | num.negative) === 0);
    			    return this.iuand(num);
    			  };

    			  // And `num` with `this`
    			  BN.prototype.and = function and (num) {
    			    if (this.length > num.length) return this.clone().iand(num);
    			    return num.clone().iand(this);
    			  };

    			  BN.prototype.uand = function uand (num) {
    			    if (this.length > num.length) return this.clone().iuand(num);
    			    return num.clone().iuand(this);
    			  };

    			  // Xor `num` with `this` in-place
    			  BN.prototype.iuxor = function iuxor (num) {
    			    // a.length > b.length
    			    var a;
    			    var b;
    			    if (this.length > num.length) {
    			      a = this;
    			      b = num;
    			    } else {
    			      a = num;
    			      b = this;
    			    }

    			    for (var i = 0; i < b.length; i++) {
    			      this.words[i] = a.words[i] ^ b.words[i];
    			    }

    			    if (this !== a) {
    			      for (; i < a.length; i++) {
    			        this.words[i] = a.words[i];
    			      }
    			    }

    			    this.length = a.length;

    			    return this.strip();
    			  };

    			  BN.prototype.ixor = function ixor (num) {
    			    assert((this.negative | num.negative) === 0);
    			    return this.iuxor(num);
    			  };

    			  // Xor `num` with `this`
    			  BN.prototype.xor = function xor (num) {
    			    if (this.length > num.length) return this.clone().ixor(num);
    			    return num.clone().ixor(this);
    			  };

    			  BN.prototype.uxor = function uxor (num) {
    			    if (this.length > num.length) return this.clone().iuxor(num);
    			    return num.clone().iuxor(this);
    			  };

    			  // Not ``this`` with ``width`` bitwidth
    			  BN.prototype.inotn = function inotn (width) {
    			    assert(typeof width === 'number' && width >= 0);

    			    var bytesNeeded = Math.ceil(width / 26) | 0;
    			    var bitsLeft = width % 26;

    			    // Extend the buffer with leading zeroes
    			    this._expand(bytesNeeded);

    			    if (bitsLeft > 0) {
    			      bytesNeeded--;
    			    }

    			    // Handle complete words
    			    for (var i = 0; i < bytesNeeded; i++) {
    			      this.words[i] = ~this.words[i] & 0x3ffffff;
    			    }

    			    // Handle the residue
    			    if (bitsLeft > 0) {
    			      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    			    }

    			    // And remove leading zeroes
    			    return this.strip();
    			  };

    			  BN.prototype.notn = function notn (width) {
    			    return this.clone().inotn(width);
    			  };

    			  // Set `bit` of `this`
    			  BN.prototype.setn = function setn (bit, val) {
    			    assert(typeof bit === 'number' && bit >= 0);

    			    var off = (bit / 26) | 0;
    			    var wbit = bit % 26;

    			    this._expand(off + 1);

    			    if (val) {
    			      this.words[off] = this.words[off] | (1 << wbit);
    			    } else {
    			      this.words[off] = this.words[off] & ~(1 << wbit);
    			    }

    			    return this.strip();
    			  };

    			  // Add `num` to `this` in-place
    			  BN.prototype.iadd = function iadd (num) {
    			    var r;

    			    // negative + positive
    			    if (this.negative !== 0 && num.negative === 0) {
    			      this.negative = 0;
    			      r = this.isub(num);
    			      this.negative ^= 1;
    			      return this._normSign();

    			    // positive + negative
    			    } else if (this.negative === 0 && num.negative !== 0) {
    			      num.negative = 0;
    			      r = this.isub(num);
    			      num.negative = 1;
    			      return r._normSign();
    			    }

    			    // a.length > b.length
    			    var a, b;
    			    if (this.length > num.length) {
    			      a = this;
    			      b = num;
    			    } else {
    			      a = num;
    			      b = this;
    			    }

    			    var carry = 0;
    			    for (var i = 0; i < b.length; i++) {
    			      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
    			      this.words[i] = r & 0x3ffffff;
    			      carry = r >>> 26;
    			    }
    			    for (; carry !== 0 && i < a.length; i++) {
    			      r = (a.words[i] | 0) + carry;
    			      this.words[i] = r & 0x3ffffff;
    			      carry = r >>> 26;
    			    }

    			    this.length = a.length;
    			    if (carry !== 0) {
    			      this.words[this.length] = carry;
    			      this.length++;
    			    // Copy the rest of the words
    			    } else if (a !== this) {
    			      for (; i < a.length; i++) {
    			        this.words[i] = a.words[i];
    			      }
    			    }

    			    return this;
    			  };

    			  // Add `num` to `this`
    			  BN.prototype.add = function add (num) {
    			    var res;
    			    if (num.negative !== 0 && this.negative === 0) {
    			      num.negative = 0;
    			      res = this.sub(num);
    			      num.negative ^= 1;
    			      return res;
    			    } else if (num.negative === 0 && this.negative !== 0) {
    			      this.negative = 0;
    			      res = num.sub(this);
    			      this.negative = 1;
    			      return res;
    			    }

    			    if (this.length > num.length) return this.clone().iadd(num);

    			    return num.clone().iadd(this);
    			  };

    			  // Subtract `num` from `this` in-place
    			  BN.prototype.isub = function isub (num) {
    			    // this - (-num) = this + num
    			    if (num.negative !== 0) {
    			      num.negative = 0;
    			      var r = this.iadd(num);
    			      num.negative = 1;
    			      return r._normSign();

    			    // -this - num = -(this + num)
    			    } else if (this.negative !== 0) {
    			      this.negative = 0;
    			      this.iadd(num);
    			      this.negative = 1;
    			      return this._normSign();
    			    }

    			    // At this point both numbers are positive
    			    var cmp = this.cmp(num);

    			    // Optimization - zeroify
    			    if (cmp === 0) {
    			      this.negative = 0;
    			      this.length = 1;
    			      this.words[0] = 0;
    			      return this;
    			    }

    			    // a > b
    			    var a, b;
    			    if (cmp > 0) {
    			      a = this;
    			      b = num;
    			    } else {
    			      a = num;
    			      b = this;
    			    }

    			    var carry = 0;
    			    for (var i = 0; i < b.length; i++) {
    			      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
    			      carry = r >> 26;
    			      this.words[i] = r & 0x3ffffff;
    			    }
    			    for (; carry !== 0 && i < a.length; i++) {
    			      r = (a.words[i] | 0) + carry;
    			      carry = r >> 26;
    			      this.words[i] = r & 0x3ffffff;
    			    }

    			    // Copy rest of the words
    			    if (carry === 0 && i < a.length && a !== this) {
    			      for (; i < a.length; i++) {
    			        this.words[i] = a.words[i];
    			      }
    			    }

    			    this.length = Math.max(this.length, i);

    			    if (a !== this) {
    			      this.negative = 1;
    			    }

    			    return this.strip();
    			  };

    			  // Subtract `num` from `this`
    			  BN.prototype.sub = function sub (num) {
    			    return this.clone().isub(num);
    			  };

    			  function smallMulTo (self, num, out) {
    			    out.negative = num.negative ^ self.negative;
    			    var len = (self.length + num.length) | 0;
    			    out.length = len;
    			    len = (len - 1) | 0;

    			    // Peel one iteration (compiler can't do it, because of code complexity)
    			    var a = self.words[0] | 0;
    			    var b = num.words[0] | 0;
    			    var r = a * b;

    			    var lo = r & 0x3ffffff;
    			    var carry = (r / 0x4000000) | 0;
    			    out.words[0] = lo;

    			    for (var k = 1; k < len; k++) {
    			      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
    			      // note that ncarry could be >= 0x3ffffff
    			      var ncarry = carry >>> 26;
    			      var rword = carry & 0x3ffffff;
    			      var maxJ = Math.min(k, num.length - 1);
    			      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
    			        var i = (k - j) | 0;
    			        a = self.words[i] | 0;
    			        b = num.words[j] | 0;
    			        r = a * b + rword;
    			        ncarry += (r / 0x4000000) | 0;
    			        rword = r & 0x3ffffff;
    			      }
    			      out.words[k] = rword | 0;
    			      carry = ncarry | 0;
    			    }
    			    if (carry !== 0) {
    			      out.words[k] = carry | 0;
    			    } else {
    			      out.length--;
    			    }

    			    return out.strip();
    			  }

    			  // TODO(indutny): it may be reasonable to omit it for users who don't need
    			  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    			  // multiplication (like elliptic secp256k1).
    			  var comb10MulTo = function comb10MulTo (self, num, out) {
    			    var a = self.words;
    			    var b = num.words;
    			    var o = out.words;
    			    var c = 0;
    			    var lo;
    			    var mid;
    			    var hi;
    			    var a0 = a[0] | 0;
    			    var al0 = a0 & 0x1fff;
    			    var ah0 = a0 >>> 13;
    			    var a1 = a[1] | 0;
    			    var al1 = a1 & 0x1fff;
    			    var ah1 = a1 >>> 13;
    			    var a2 = a[2] | 0;
    			    var al2 = a2 & 0x1fff;
    			    var ah2 = a2 >>> 13;
    			    var a3 = a[3] | 0;
    			    var al3 = a3 & 0x1fff;
    			    var ah3 = a3 >>> 13;
    			    var a4 = a[4] | 0;
    			    var al4 = a4 & 0x1fff;
    			    var ah4 = a4 >>> 13;
    			    var a5 = a[5] | 0;
    			    var al5 = a5 & 0x1fff;
    			    var ah5 = a5 >>> 13;
    			    var a6 = a[6] | 0;
    			    var al6 = a6 & 0x1fff;
    			    var ah6 = a6 >>> 13;
    			    var a7 = a[7] | 0;
    			    var al7 = a7 & 0x1fff;
    			    var ah7 = a7 >>> 13;
    			    var a8 = a[8] | 0;
    			    var al8 = a8 & 0x1fff;
    			    var ah8 = a8 >>> 13;
    			    var a9 = a[9] | 0;
    			    var al9 = a9 & 0x1fff;
    			    var ah9 = a9 >>> 13;
    			    var b0 = b[0] | 0;
    			    var bl0 = b0 & 0x1fff;
    			    var bh0 = b0 >>> 13;
    			    var b1 = b[1] | 0;
    			    var bl1 = b1 & 0x1fff;
    			    var bh1 = b1 >>> 13;
    			    var b2 = b[2] | 0;
    			    var bl2 = b2 & 0x1fff;
    			    var bh2 = b2 >>> 13;
    			    var b3 = b[3] | 0;
    			    var bl3 = b3 & 0x1fff;
    			    var bh3 = b3 >>> 13;
    			    var b4 = b[4] | 0;
    			    var bl4 = b4 & 0x1fff;
    			    var bh4 = b4 >>> 13;
    			    var b5 = b[5] | 0;
    			    var bl5 = b5 & 0x1fff;
    			    var bh5 = b5 >>> 13;
    			    var b6 = b[6] | 0;
    			    var bl6 = b6 & 0x1fff;
    			    var bh6 = b6 >>> 13;
    			    var b7 = b[7] | 0;
    			    var bl7 = b7 & 0x1fff;
    			    var bh7 = b7 >>> 13;
    			    var b8 = b[8] | 0;
    			    var bl8 = b8 & 0x1fff;
    			    var bh8 = b8 >>> 13;
    			    var b9 = b[9] | 0;
    			    var bl9 = b9 & 0x1fff;
    			    var bh9 = b9 >>> 13;

    			    out.negative = self.negative ^ num.negative;
    			    out.length = 19;
    			    /* k = 0 */
    			    lo = Math.imul(al0, bl0);
    			    mid = Math.imul(al0, bh0);
    			    mid = (mid + Math.imul(ah0, bl0)) | 0;
    			    hi = Math.imul(ah0, bh0);
    			    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    			    w0 &= 0x3ffffff;
    			    /* k = 1 */
    			    lo = Math.imul(al1, bl0);
    			    mid = Math.imul(al1, bh0);
    			    mid = (mid + Math.imul(ah1, bl0)) | 0;
    			    hi = Math.imul(ah1, bh0);
    			    lo = (lo + Math.imul(al0, bl1)) | 0;
    			    mid = (mid + Math.imul(al0, bh1)) | 0;
    			    mid = (mid + Math.imul(ah0, bl1)) | 0;
    			    hi = (hi + Math.imul(ah0, bh1)) | 0;
    			    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    			    w1 &= 0x3ffffff;
    			    /* k = 2 */
    			    lo = Math.imul(al2, bl0);
    			    mid = Math.imul(al2, bh0);
    			    mid = (mid + Math.imul(ah2, bl0)) | 0;
    			    hi = Math.imul(ah2, bh0);
    			    lo = (lo + Math.imul(al1, bl1)) | 0;
    			    mid = (mid + Math.imul(al1, bh1)) | 0;
    			    mid = (mid + Math.imul(ah1, bl1)) | 0;
    			    hi = (hi + Math.imul(ah1, bh1)) | 0;
    			    lo = (lo + Math.imul(al0, bl2)) | 0;
    			    mid = (mid + Math.imul(al0, bh2)) | 0;
    			    mid = (mid + Math.imul(ah0, bl2)) | 0;
    			    hi = (hi + Math.imul(ah0, bh2)) | 0;
    			    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    			    w2 &= 0x3ffffff;
    			    /* k = 3 */
    			    lo = Math.imul(al3, bl0);
    			    mid = Math.imul(al3, bh0);
    			    mid = (mid + Math.imul(ah3, bl0)) | 0;
    			    hi = Math.imul(ah3, bh0);
    			    lo = (lo + Math.imul(al2, bl1)) | 0;
    			    mid = (mid + Math.imul(al2, bh1)) | 0;
    			    mid = (mid + Math.imul(ah2, bl1)) | 0;
    			    hi = (hi + Math.imul(ah2, bh1)) | 0;
    			    lo = (lo + Math.imul(al1, bl2)) | 0;
    			    mid = (mid + Math.imul(al1, bh2)) | 0;
    			    mid = (mid + Math.imul(ah1, bl2)) | 0;
    			    hi = (hi + Math.imul(ah1, bh2)) | 0;
    			    lo = (lo + Math.imul(al0, bl3)) | 0;
    			    mid = (mid + Math.imul(al0, bh3)) | 0;
    			    mid = (mid + Math.imul(ah0, bl3)) | 0;
    			    hi = (hi + Math.imul(ah0, bh3)) | 0;
    			    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    			    w3 &= 0x3ffffff;
    			    /* k = 4 */
    			    lo = Math.imul(al4, bl0);
    			    mid = Math.imul(al4, bh0);
    			    mid = (mid + Math.imul(ah4, bl0)) | 0;
    			    hi = Math.imul(ah4, bh0);
    			    lo = (lo + Math.imul(al3, bl1)) | 0;
    			    mid = (mid + Math.imul(al3, bh1)) | 0;
    			    mid = (mid + Math.imul(ah3, bl1)) | 0;
    			    hi = (hi + Math.imul(ah3, bh1)) | 0;
    			    lo = (lo + Math.imul(al2, bl2)) | 0;
    			    mid = (mid + Math.imul(al2, bh2)) | 0;
    			    mid = (mid + Math.imul(ah2, bl2)) | 0;
    			    hi = (hi + Math.imul(ah2, bh2)) | 0;
    			    lo = (lo + Math.imul(al1, bl3)) | 0;
    			    mid = (mid + Math.imul(al1, bh3)) | 0;
    			    mid = (mid + Math.imul(ah1, bl3)) | 0;
    			    hi = (hi + Math.imul(ah1, bh3)) | 0;
    			    lo = (lo + Math.imul(al0, bl4)) | 0;
    			    mid = (mid + Math.imul(al0, bh4)) | 0;
    			    mid = (mid + Math.imul(ah0, bl4)) | 0;
    			    hi = (hi + Math.imul(ah0, bh4)) | 0;
    			    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    			    w4 &= 0x3ffffff;
    			    /* k = 5 */
    			    lo = Math.imul(al5, bl0);
    			    mid = Math.imul(al5, bh0);
    			    mid = (mid + Math.imul(ah5, bl0)) | 0;
    			    hi = Math.imul(ah5, bh0);
    			    lo = (lo + Math.imul(al4, bl1)) | 0;
    			    mid = (mid + Math.imul(al4, bh1)) | 0;
    			    mid = (mid + Math.imul(ah4, bl1)) | 0;
    			    hi = (hi + Math.imul(ah4, bh1)) | 0;
    			    lo = (lo + Math.imul(al3, bl2)) | 0;
    			    mid = (mid + Math.imul(al3, bh2)) | 0;
    			    mid = (mid + Math.imul(ah3, bl2)) | 0;
    			    hi = (hi + Math.imul(ah3, bh2)) | 0;
    			    lo = (lo + Math.imul(al2, bl3)) | 0;
    			    mid = (mid + Math.imul(al2, bh3)) | 0;
    			    mid = (mid + Math.imul(ah2, bl3)) | 0;
    			    hi = (hi + Math.imul(ah2, bh3)) | 0;
    			    lo = (lo + Math.imul(al1, bl4)) | 0;
    			    mid = (mid + Math.imul(al1, bh4)) | 0;
    			    mid = (mid + Math.imul(ah1, bl4)) | 0;
    			    hi = (hi + Math.imul(ah1, bh4)) | 0;
    			    lo = (lo + Math.imul(al0, bl5)) | 0;
    			    mid = (mid + Math.imul(al0, bh5)) | 0;
    			    mid = (mid + Math.imul(ah0, bl5)) | 0;
    			    hi = (hi + Math.imul(ah0, bh5)) | 0;
    			    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    			    w5 &= 0x3ffffff;
    			    /* k = 6 */
    			    lo = Math.imul(al6, bl0);
    			    mid = Math.imul(al6, bh0);
    			    mid = (mid + Math.imul(ah6, bl0)) | 0;
    			    hi = Math.imul(ah6, bh0);
    			    lo = (lo + Math.imul(al5, bl1)) | 0;
    			    mid = (mid + Math.imul(al5, bh1)) | 0;
    			    mid = (mid + Math.imul(ah5, bl1)) | 0;
    			    hi = (hi + Math.imul(ah5, bh1)) | 0;
    			    lo = (lo + Math.imul(al4, bl2)) | 0;
    			    mid = (mid + Math.imul(al4, bh2)) | 0;
    			    mid = (mid + Math.imul(ah4, bl2)) | 0;
    			    hi = (hi + Math.imul(ah4, bh2)) | 0;
    			    lo = (lo + Math.imul(al3, bl3)) | 0;
    			    mid = (mid + Math.imul(al3, bh3)) | 0;
    			    mid = (mid + Math.imul(ah3, bl3)) | 0;
    			    hi = (hi + Math.imul(ah3, bh3)) | 0;
    			    lo = (lo + Math.imul(al2, bl4)) | 0;
    			    mid = (mid + Math.imul(al2, bh4)) | 0;
    			    mid = (mid + Math.imul(ah2, bl4)) | 0;
    			    hi = (hi + Math.imul(ah2, bh4)) | 0;
    			    lo = (lo + Math.imul(al1, bl5)) | 0;
    			    mid = (mid + Math.imul(al1, bh5)) | 0;
    			    mid = (mid + Math.imul(ah1, bl5)) | 0;
    			    hi = (hi + Math.imul(ah1, bh5)) | 0;
    			    lo = (lo + Math.imul(al0, bl6)) | 0;
    			    mid = (mid + Math.imul(al0, bh6)) | 0;
    			    mid = (mid + Math.imul(ah0, bl6)) | 0;
    			    hi = (hi + Math.imul(ah0, bh6)) | 0;
    			    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    			    w6 &= 0x3ffffff;
    			    /* k = 7 */
    			    lo = Math.imul(al7, bl0);
    			    mid = Math.imul(al7, bh0);
    			    mid = (mid + Math.imul(ah7, bl0)) | 0;
    			    hi = Math.imul(ah7, bh0);
    			    lo = (lo + Math.imul(al6, bl1)) | 0;
    			    mid = (mid + Math.imul(al6, bh1)) | 0;
    			    mid = (mid + Math.imul(ah6, bl1)) | 0;
    			    hi = (hi + Math.imul(ah6, bh1)) | 0;
    			    lo = (lo + Math.imul(al5, bl2)) | 0;
    			    mid = (mid + Math.imul(al5, bh2)) | 0;
    			    mid = (mid + Math.imul(ah5, bl2)) | 0;
    			    hi = (hi + Math.imul(ah5, bh2)) | 0;
    			    lo = (lo + Math.imul(al4, bl3)) | 0;
    			    mid = (mid + Math.imul(al4, bh3)) | 0;
    			    mid = (mid + Math.imul(ah4, bl3)) | 0;
    			    hi = (hi + Math.imul(ah4, bh3)) | 0;
    			    lo = (lo + Math.imul(al3, bl4)) | 0;
    			    mid = (mid + Math.imul(al3, bh4)) | 0;
    			    mid = (mid + Math.imul(ah3, bl4)) | 0;
    			    hi = (hi + Math.imul(ah3, bh4)) | 0;
    			    lo = (lo + Math.imul(al2, bl5)) | 0;
    			    mid = (mid + Math.imul(al2, bh5)) | 0;
    			    mid = (mid + Math.imul(ah2, bl5)) | 0;
    			    hi = (hi + Math.imul(ah2, bh5)) | 0;
    			    lo = (lo + Math.imul(al1, bl6)) | 0;
    			    mid = (mid + Math.imul(al1, bh6)) | 0;
    			    mid = (mid + Math.imul(ah1, bl6)) | 0;
    			    hi = (hi + Math.imul(ah1, bh6)) | 0;
    			    lo = (lo + Math.imul(al0, bl7)) | 0;
    			    mid = (mid + Math.imul(al0, bh7)) | 0;
    			    mid = (mid + Math.imul(ah0, bl7)) | 0;
    			    hi = (hi + Math.imul(ah0, bh7)) | 0;
    			    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    			    w7 &= 0x3ffffff;
    			    /* k = 8 */
    			    lo = Math.imul(al8, bl0);
    			    mid = Math.imul(al8, bh0);
    			    mid = (mid + Math.imul(ah8, bl0)) | 0;
    			    hi = Math.imul(ah8, bh0);
    			    lo = (lo + Math.imul(al7, bl1)) | 0;
    			    mid = (mid + Math.imul(al7, bh1)) | 0;
    			    mid = (mid + Math.imul(ah7, bl1)) | 0;
    			    hi = (hi + Math.imul(ah7, bh1)) | 0;
    			    lo = (lo + Math.imul(al6, bl2)) | 0;
    			    mid = (mid + Math.imul(al6, bh2)) | 0;
    			    mid = (mid + Math.imul(ah6, bl2)) | 0;
    			    hi = (hi + Math.imul(ah6, bh2)) | 0;
    			    lo = (lo + Math.imul(al5, bl3)) | 0;
    			    mid = (mid + Math.imul(al5, bh3)) | 0;
    			    mid = (mid + Math.imul(ah5, bl3)) | 0;
    			    hi = (hi + Math.imul(ah5, bh3)) | 0;
    			    lo = (lo + Math.imul(al4, bl4)) | 0;
    			    mid = (mid + Math.imul(al4, bh4)) | 0;
    			    mid = (mid + Math.imul(ah4, bl4)) | 0;
    			    hi = (hi + Math.imul(ah4, bh4)) | 0;
    			    lo = (lo + Math.imul(al3, bl5)) | 0;
    			    mid = (mid + Math.imul(al3, bh5)) | 0;
    			    mid = (mid + Math.imul(ah3, bl5)) | 0;
    			    hi = (hi + Math.imul(ah3, bh5)) | 0;
    			    lo = (lo + Math.imul(al2, bl6)) | 0;
    			    mid = (mid + Math.imul(al2, bh6)) | 0;
    			    mid = (mid + Math.imul(ah2, bl6)) | 0;
    			    hi = (hi + Math.imul(ah2, bh6)) | 0;
    			    lo = (lo + Math.imul(al1, bl7)) | 0;
    			    mid = (mid + Math.imul(al1, bh7)) | 0;
    			    mid = (mid + Math.imul(ah1, bl7)) | 0;
    			    hi = (hi + Math.imul(ah1, bh7)) | 0;
    			    lo = (lo + Math.imul(al0, bl8)) | 0;
    			    mid = (mid + Math.imul(al0, bh8)) | 0;
    			    mid = (mid + Math.imul(ah0, bl8)) | 0;
    			    hi = (hi + Math.imul(ah0, bh8)) | 0;
    			    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    			    w8 &= 0x3ffffff;
    			    /* k = 9 */
    			    lo = Math.imul(al9, bl0);
    			    mid = Math.imul(al9, bh0);
    			    mid = (mid + Math.imul(ah9, bl0)) | 0;
    			    hi = Math.imul(ah9, bh0);
    			    lo = (lo + Math.imul(al8, bl1)) | 0;
    			    mid = (mid + Math.imul(al8, bh1)) | 0;
    			    mid = (mid + Math.imul(ah8, bl1)) | 0;
    			    hi = (hi + Math.imul(ah8, bh1)) | 0;
    			    lo = (lo + Math.imul(al7, bl2)) | 0;
    			    mid = (mid + Math.imul(al7, bh2)) | 0;
    			    mid = (mid + Math.imul(ah7, bl2)) | 0;
    			    hi = (hi + Math.imul(ah7, bh2)) | 0;
    			    lo = (lo + Math.imul(al6, bl3)) | 0;
    			    mid = (mid + Math.imul(al6, bh3)) | 0;
    			    mid = (mid + Math.imul(ah6, bl3)) | 0;
    			    hi = (hi + Math.imul(ah6, bh3)) | 0;
    			    lo = (lo + Math.imul(al5, bl4)) | 0;
    			    mid = (mid + Math.imul(al5, bh4)) | 0;
    			    mid = (mid + Math.imul(ah5, bl4)) | 0;
    			    hi = (hi + Math.imul(ah5, bh4)) | 0;
    			    lo = (lo + Math.imul(al4, bl5)) | 0;
    			    mid = (mid + Math.imul(al4, bh5)) | 0;
    			    mid = (mid + Math.imul(ah4, bl5)) | 0;
    			    hi = (hi + Math.imul(ah4, bh5)) | 0;
    			    lo = (lo + Math.imul(al3, bl6)) | 0;
    			    mid = (mid + Math.imul(al3, bh6)) | 0;
    			    mid = (mid + Math.imul(ah3, bl6)) | 0;
    			    hi = (hi + Math.imul(ah3, bh6)) | 0;
    			    lo = (lo + Math.imul(al2, bl7)) | 0;
    			    mid = (mid + Math.imul(al2, bh7)) | 0;
    			    mid = (mid + Math.imul(ah2, bl7)) | 0;
    			    hi = (hi + Math.imul(ah2, bh7)) | 0;
    			    lo = (lo + Math.imul(al1, bl8)) | 0;
    			    mid = (mid + Math.imul(al1, bh8)) | 0;
    			    mid = (mid + Math.imul(ah1, bl8)) | 0;
    			    hi = (hi + Math.imul(ah1, bh8)) | 0;
    			    lo = (lo + Math.imul(al0, bl9)) | 0;
    			    mid = (mid + Math.imul(al0, bh9)) | 0;
    			    mid = (mid + Math.imul(ah0, bl9)) | 0;
    			    hi = (hi + Math.imul(ah0, bh9)) | 0;
    			    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    			    w9 &= 0x3ffffff;
    			    /* k = 10 */
    			    lo = Math.imul(al9, bl1);
    			    mid = Math.imul(al9, bh1);
    			    mid = (mid + Math.imul(ah9, bl1)) | 0;
    			    hi = Math.imul(ah9, bh1);
    			    lo = (lo + Math.imul(al8, bl2)) | 0;
    			    mid = (mid + Math.imul(al8, bh2)) | 0;
    			    mid = (mid + Math.imul(ah8, bl2)) | 0;
    			    hi = (hi + Math.imul(ah8, bh2)) | 0;
    			    lo = (lo + Math.imul(al7, bl3)) | 0;
    			    mid = (mid + Math.imul(al7, bh3)) | 0;
    			    mid = (mid + Math.imul(ah7, bl3)) | 0;
    			    hi = (hi + Math.imul(ah7, bh3)) | 0;
    			    lo = (lo + Math.imul(al6, bl4)) | 0;
    			    mid = (mid + Math.imul(al6, bh4)) | 0;
    			    mid = (mid + Math.imul(ah6, bl4)) | 0;
    			    hi = (hi + Math.imul(ah6, bh4)) | 0;
    			    lo = (lo + Math.imul(al5, bl5)) | 0;
    			    mid = (mid + Math.imul(al5, bh5)) | 0;
    			    mid = (mid + Math.imul(ah5, bl5)) | 0;
    			    hi = (hi + Math.imul(ah5, bh5)) | 0;
    			    lo = (lo + Math.imul(al4, bl6)) | 0;
    			    mid = (mid + Math.imul(al4, bh6)) | 0;
    			    mid = (mid + Math.imul(ah4, bl6)) | 0;
    			    hi = (hi + Math.imul(ah4, bh6)) | 0;
    			    lo = (lo + Math.imul(al3, bl7)) | 0;
    			    mid = (mid + Math.imul(al3, bh7)) | 0;
    			    mid = (mid + Math.imul(ah3, bl7)) | 0;
    			    hi = (hi + Math.imul(ah3, bh7)) | 0;
    			    lo = (lo + Math.imul(al2, bl8)) | 0;
    			    mid = (mid + Math.imul(al2, bh8)) | 0;
    			    mid = (mid + Math.imul(ah2, bl8)) | 0;
    			    hi = (hi + Math.imul(ah2, bh8)) | 0;
    			    lo = (lo + Math.imul(al1, bl9)) | 0;
    			    mid = (mid + Math.imul(al1, bh9)) | 0;
    			    mid = (mid + Math.imul(ah1, bl9)) | 0;
    			    hi = (hi + Math.imul(ah1, bh9)) | 0;
    			    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    			    w10 &= 0x3ffffff;
    			    /* k = 11 */
    			    lo = Math.imul(al9, bl2);
    			    mid = Math.imul(al9, bh2);
    			    mid = (mid + Math.imul(ah9, bl2)) | 0;
    			    hi = Math.imul(ah9, bh2);
    			    lo = (lo + Math.imul(al8, bl3)) | 0;
    			    mid = (mid + Math.imul(al8, bh3)) | 0;
    			    mid = (mid + Math.imul(ah8, bl3)) | 0;
    			    hi = (hi + Math.imul(ah8, bh3)) | 0;
    			    lo = (lo + Math.imul(al7, bl4)) | 0;
    			    mid = (mid + Math.imul(al7, bh4)) | 0;
    			    mid = (mid + Math.imul(ah7, bl4)) | 0;
    			    hi = (hi + Math.imul(ah7, bh4)) | 0;
    			    lo = (lo + Math.imul(al6, bl5)) | 0;
    			    mid = (mid + Math.imul(al6, bh5)) | 0;
    			    mid = (mid + Math.imul(ah6, bl5)) | 0;
    			    hi = (hi + Math.imul(ah6, bh5)) | 0;
    			    lo = (lo + Math.imul(al5, bl6)) | 0;
    			    mid = (mid + Math.imul(al5, bh6)) | 0;
    			    mid = (mid + Math.imul(ah5, bl6)) | 0;
    			    hi = (hi + Math.imul(ah5, bh6)) | 0;
    			    lo = (lo + Math.imul(al4, bl7)) | 0;
    			    mid = (mid + Math.imul(al4, bh7)) | 0;
    			    mid = (mid + Math.imul(ah4, bl7)) | 0;
    			    hi = (hi + Math.imul(ah4, bh7)) | 0;
    			    lo = (lo + Math.imul(al3, bl8)) | 0;
    			    mid = (mid + Math.imul(al3, bh8)) | 0;
    			    mid = (mid + Math.imul(ah3, bl8)) | 0;
    			    hi = (hi + Math.imul(ah3, bh8)) | 0;
    			    lo = (lo + Math.imul(al2, bl9)) | 0;
    			    mid = (mid + Math.imul(al2, bh9)) | 0;
    			    mid = (mid + Math.imul(ah2, bl9)) | 0;
    			    hi = (hi + Math.imul(ah2, bh9)) | 0;
    			    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    			    w11 &= 0x3ffffff;
    			    /* k = 12 */
    			    lo = Math.imul(al9, bl3);
    			    mid = Math.imul(al9, bh3);
    			    mid = (mid + Math.imul(ah9, bl3)) | 0;
    			    hi = Math.imul(ah9, bh3);
    			    lo = (lo + Math.imul(al8, bl4)) | 0;
    			    mid = (mid + Math.imul(al8, bh4)) | 0;
    			    mid = (mid + Math.imul(ah8, bl4)) | 0;
    			    hi = (hi + Math.imul(ah8, bh4)) | 0;
    			    lo = (lo + Math.imul(al7, bl5)) | 0;
    			    mid = (mid + Math.imul(al7, bh5)) | 0;
    			    mid = (mid + Math.imul(ah7, bl5)) | 0;
    			    hi = (hi + Math.imul(ah7, bh5)) | 0;
    			    lo = (lo + Math.imul(al6, bl6)) | 0;
    			    mid = (mid + Math.imul(al6, bh6)) | 0;
    			    mid = (mid + Math.imul(ah6, bl6)) | 0;
    			    hi = (hi + Math.imul(ah6, bh6)) | 0;
    			    lo = (lo + Math.imul(al5, bl7)) | 0;
    			    mid = (mid + Math.imul(al5, bh7)) | 0;
    			    mid = (mid + Math.imul(ah5, bl7)) | 0;
    			    hi = (hi + Math.imul(ah5, bh7)) | 0;
    			    lo = (lo + Math.imul(al4, bl8)) | 0;
    			    mid = (mid + Math.imul(al4, bh8)) | 0;
    			    mid = (mid + Math.imul(ah4, bl8)) | 0;
    			    hi = (hi + Math.imul(ah4, bh8)) | 0;
    			    lo = (lo + Math.imul(al3, bl9)) | 0;
    			    mid = (mid + Math.imul(al3, bh9)) | 0;
    			    mid = (mid + Math.imul(ah3, bl9)) | 0;
    			    hi = (hi + Math.imul(ah3, bh9)) | 0;
    			    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    			    w12 &= 0x3ffffff;
    			    /* k = 13 */
    			    lo = Math.imul(al9, bl4);
    			    mid = Math.imul(al9, bh4);
    			    mid = (mid + Math.imul(ah9, bl4)) | 0;
    			    hi = Math.imul(ah9, bh4);
    			    lo = (lo + Math.imul(al8, bl5)) | 0;
    			    mid = (mid + Math.imul(al8, bh5)) | 0;
    			    mid = (mid + Math.imul(ah8, bl5)) | 0;
    			    hi = (hi + Math.imul(ah8, bh5)) | 0;
    			    lo = (lo + Math.imul(al7, bl6)) | 0;
    			    mid = (mid + Math.imul(al7, bh6)) | 0;
    			    mid = (mid + Math.imul(ah7, bl6)) | 0;
    			    hi = (hi + Math.imul(ah7, bh6)) | 0;
    			    lo = (lo + Math.imul(al6, bl7)) | 0;
    			    mid = (mid + Math.imul(al6, bh7)) | 0;
    			    mid = (mid + Math.imul(ah6, bl7)) | 0;
    			    hi = (hi + Math.imul(ah6, bh7)) | 0;
    			    lo = (lo + Math.imul(al5, bl8)) | 0;
    			    mid = (mid + Math.imul(al5, bh8)) | 0;
    			    mid = (mid + Math.imul(ah5, bl8)) | 0;
    			    hi = (hi + Math.imul(ah5, bh8)) | 0;
    			    lo = (lo + Math.imul(al4, bl9)) | 0;
    			    mid = (mid + Math.imul(al4, bh9)) | 0;
    			    mid = (mid + Math.imul(ah4, bl9)) | 0;
    			    hi = (hi + Math.imul(ah4, bh9)) | 0;
    			    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    			    w13 &= 0x3ffffff;
    			    /* k = 14 */
    			    lo = Math.imul(al9, bl5);
    			    mid = Math.imul(al9, bh5);
    			    mid = (mid + Math.imul(ah9, bl5)) | 0;
    			    hi = Math.imul(ah9, bh5);
    			    lo = (lo + Math.imul(al8, bl6)) | 0;
    			    mid = (mid + Math.imul(al8, bh6)) | 0;
    			    mid = (mid + Math.imul(ah8, bl6)) | 0;
    			    hi = (hi + Math.imul(ah8, bh6)) | 0;
    			    lo = (lo + Math.imul(al7, bl7)) | 0;
    			    mid = (mid + Math.imul(al7, bh7)) | 0;
    			    mid = (mid + Math.imul(ah7, bl7)) | 0;
    			    hi = (hi + Math.imul(ah7, bh7)) | 0;
    			    lo = (lo + Math.imul(al6, bl8)) | 0;
    			    mid = (mid + Math.imul(al6, bh8)) | 0;
    			    mid = (mid + Math.imul(ah6, bl8)) | 0;
    			    hi = (hi + Math.imul(ah6, bh8)) | 0;
    			    lo = (lo + Math.imul(al5, bl9)) | 0;
    			    mid = (mid + Math.imul(al5, bh9)) | 0;
    			    mid = (mid + Math.imul(ah5, bl9)) | 0;
    			    hi = (hi + Math.imul(ah5, bh9)) | 0;
    			    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    			    w14 &= 0x3ffffff;
    			    /* k = 15 */
    			    lo = Math.imul(al9, bl6);
    			    mid = Math.imul(al9, bh6);
    			    mid = (mid + Math.imul(ah9, bl6)) | 0;
    			    hi = Math.imul(ah9, bh6);
    			    lo = (lo + Math.imul(al8, bl7)) | 0;
    			    mid = (mid + Math.imul(al8, bh7)) | 0;
    			    mid = (mid + Math.imul(ah8, bl7)) | 0;
    			    hi = (hi + Math.imul(ah8, bh7)) | 0;
    			    lo = (lo + Math.imul(al7, bl8)) | 0;
    			    mid = (mid + Math.imul(al7, bh8)) | 0;
    			    mid = (mid + Math.imul(ah7, bl8)) | 0;
    			    hi = (hi + Math.imul(ah7, bh8)) | 0;
    			    lo = (lo + Math.imul(al6, bl9)) | 0;
    			    mid = (mid + Math.imul(al6, bh9)) | 0;
    			    mid = (mid + Math.imul(ah6, bl9)) | 0;
    			    hi = (hi + Math.imul(ah6, bh9)) | 0;
    			    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    			    w15 &= 0x3ffffff;
    			    /* k = 16 */
    			    lo = Math.imul(al9, bl7);
    			    mid = Math.imul(al9, bh7);
    			    mid = (mid + Math.imul(ah9, bl7)) | 0;
    			    hi = Math.imul(ah9, bh7);
    			    lo = (lo + Math.imul(al8, bl8)) | 0;
    			    mid = (mid + Math.imul(al8, bh8)) | 0;
    			    mid = (mid + Math.imul(ah8, bl8)) | 0;
    			    hi = (hi + Math.imul(ah8, bh8)) | 0;
    			    lo = (lo + Math.imul(al7, bl9)) | 0;
    			    mid = (mid + Math.imul(al7, bh9)) | 0;
    			    mid = (mid + Math.imul(ah7, bl9)) | 0;
    			    hi = (hi + Math.imul(ah7, bh9)) | 0;
    			    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    			    w16 &= 0x3ffffff;
    			    /* k = 17 */
    			    lo = Math.imul(al9, bl8);
    			    mid = Math.imul(al9, bh8);
    			    mid = (mid + Math.imul(ah9, bl8)) | 0;
    			    hi = Math.imul(ah9, bh8);
    			    lo = (lo + Math.imul(al8, bl9)) | 0;
    			    mid = (mid + Math.imul(al8, bh9)) | 0;
    			    mid = (mid + Math.imul(ah8, bl9)) | 0;
    			    hi = (hi + Math.imul(ah8, bh9)) | 0;
    			    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    			    w17 &= 0x3ffffff;
    			    /* k = 18 */
    			    lo = Math.imul(al9, bl9);
    			    mid = Math.imul(al9, bh9);
    			    mid = (mid + Math.imul(ah9, bl9)) | 0;
    			    hi = Math.imul(ah9, bh9);
    			    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    			    w18 &= 0x3ffffff;
    			    o[0] = w0;
    			    o[1] = w1;
    			    o[2] = w2;
    			    o[3] = w3;
    			    o[4] = w4;
    			    o[5] = w5;
    			    o[6] = w6;
    			    o[7] = w7;
    			    o[8] = w8;
    			    o[9] = w9;
    			    o[10] = w10;
    			    o[11] = w11;
    			    o[12] = w12;
    			    o[13] = w13;
    			    o[14] = w14;
    			    o[15] = w15;
    			    o[16] = w16;
    			    o[17] = w17;
    			    o[18] = w18;
    			    if (c !== 0) {
    			      o[19] = c;
    			      out.length++;
    			    }
    			    return out;
    			  };

    			  // Polyfill comb
    			  if (!Math.imul) {
    			    comb10MulTo = smallMulTo;
    			  }

    			  function bigMulTo (self, num, out) {
    			    out.negative = num.negative ^ self.negative;
    			    out.length = self.length + num.length;

    			    var carry = 0;
    			    var hncarry = 0;
    			    for (var k = 0; k < out.length - 1; k++) {
    			      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
    			      // note that ncarry could be >= 0x3ffffff
    			      var ncarry = hncarry;
    			      hncarry = 0;
    			      var rword = carry & 0x3ffffff;
    			      var maxJ = Math.min(k, num.length - 1);
    			      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
    			        var i = k - j;
    			        var a = self.words[i] | 0;
    			        var b = num.words[j] | 0;
    			        var r = a * b;

    			        var lo = r & 0x3ffffff;
    			        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
    			        lo = (lo + rword) | 0;
    			        rword = lo & 0x3ffffff;
    			        ncarry = (ncarry + (lo >>> 26)) | 0;

    			        hncarry += ncarry >>> 26;
    			        ncarry &= 0x3ffffff;
    			      }
    			      out.words[k] = rword;
    			      carry = ncarry;
    			      ncarry = hncarry;
    			    }
    			    if (carry !== 0) {
    			      out.words[k] = carry;
    			    } else {
    			      out.length--;
    			    }

    			    return out.strip();
    			  }

    			  function jumboMulTo (self, num, out) {
    			    var fftm = new FFTM();
    			    return fftm.mulp(self, num, out);
    			  }

    			  BN.prototype.mulTo = function mulTo (num, out) {
    			    var res;
    			    var len = this.length + num.length;
    			    if (this.length === 10 && num.length === 10) {
    			      res = comb10MulTo(this, num, out);
    			    } else if (len < 63) {
    			      res = smallMulTo(this, num, out);
    			    } else if (len < 1024) {
    			      res = bigMulTo(this, num, out);
    			    } else {
    			      res = jumboMulTo(this, num, out);
    			    }

    			    return res;
    			  };

    			  // Cooley-Tukey algorithm for FFT
    			  // slightly revisited to rely on looping instead of recursion

    			  function FFTM (x, y) {
    			    this.x = x;
    			    this.y = y;
    			  }

    			  FFTM.prototype.makeRBT = function makeRBT (N) {
    			    var t = new Array(N);
    			    var l = BN.prototype._countBits(N) - 1;
    			    for (var i = 0; i < N; i++) {
    			      t[i] = this.revBin(i, l, N);
    			    }

    			    return t;
    			  };

    			  // Returns binary-reversed representation of `x`
    			  FFTM.prototype.revBin = function revBin (x, l, N) {
    			    if (x === 0 || x === N - 1) return x;

    			    var rb = 0;
    			    for (var i = 0; i < l; i++) {
    			      rb |= (x & 1) << (l - i - 1);
    			      x >>= 1;
    			    }

    			    return rb;
    			  };

    			  // Performs "tweedling" phase, therefore 'emulating'
    			  // behaviour of the recursive algorithm
    			  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    			    for (var i = 0; i < N; i++) {
    			      rtws[i] = rws[rbt[i]];
    			      itws[i] = iws[rbt[i]];
    			    }
    			  };

    			  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    			    this.permute(rbt, rws, iws, rtws, itws, N);

    			    for (var s = 1; s < N; s <<= 1) {
    			      var l = s << 1;

    			      var rtwdf = Math.cos(2 * Math.PI / l);
    			      var itwdf = Math.sin(2 * Math.PI / l);

    			      for (var p = 0; p < N; p += l) {
    			        var rtwdf_ = rtwdf;
    			        var itwdf_ = itwdf;

    			        for (var j = 0; j < s; j++) {
    			          var re = rtws[p + j];
    			          var ie = itws[p + j];

    			          var ro = rtws[p + j + s];
    			          var io = itws[p + j + s];

    			          var rx = rtwdf_ * ro - itwdf_ * io;

    			          io = rtwdf_ * io + itwdf_ * ro;
    			          ro = rx;

    			          rtws[p + j] = re + ro;
    			          itws[p + j] = ie + io;

    			          rtws[p + j + s] = re - ro;
    			          itws[p + j + s] = ie - io;

    			          /* jshint maxdepth : false */
    			          if (j !== l) {
    			            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

    			            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
    			            rtwdf_ = rx;
    			          }
    			        }
    			      }
    			    }
    			  };

    			  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    			    var N = Math.max(m, n) | 1;
    			    var odd = N & 1;
    			    var i = 0;
    			    for (N = N / 2 | 0; N; N = N >>> 1) {
    			      i++;
    			    }

    			    return 1 << i + 1 + odd;
    			  };

    			  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    			    if (N <= 1) return;

    			    for (var i = 0; i < N / 2; i++) {
    			      var t = rws[i];

    			      rws[i] = rws[N - i - 1];
    			      rws[N - i - 1] = t;

    			      t = iws[i];

    			      iws[i] = -iws[N - i - 1];
    			      iws[N - i - 1] = -t;
    			    }
    			  };

    			  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    			    var carry = 0;
    			    for (var i = 0; i < N / 2; i++) {
    			      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
    			        Math.round(ws[2 * i] / N) +
    			        carry;

    			      ws[i] = w & 0x3ffffff;

    			      if (w < 0x4000000) {
    			        carry = 0;
    			      } else {
    			        carry = w / 0x4000000 | 0;
    			      }
    			    }

    			    return ws;
    			  };

    			  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    			    var carry = 0;
    			    for (var i = 0; i < len; i++) {
    			      carry = carry + (ws[i] | 0);

    			      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
    			      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    			    }

    			    // Pad with zeroes
    			    for (i = 2 * len; i < N; ++i) {
    			      rws[i] = 0;
    			    }

    			    assert(carry === 0);
    			    assert((carry & ~0x1fff) === 0);
    			  };

    			  FFTM.prototype.stub = function stub (N) {
    			    var ph = new Array(N);
    			    for (var i = 0; i < N; i++) {
    			      ph[i] = 0;
    			    }

    			    return ph;
    			  };

    			  FFTM.prototype.mulp = function mulp (x, y, out) {
    			    var N = 2 * this.guessLen13b(x.length, y.length);

    			    var rbt = this.makeRBT(N);

    			    var _ = this.stub(N);

    			    var rws = new Array(N);
    			    var rwst = new Array(N);
    			    var iwst = new Array(N);

    			    var nrws = new Array(N);
    			    var nrwst = new Array(N);
    			    var niwst = new Array(N);

    			    var rmws = out.words;
    			    rmws.length = N;

    			    this.convert13b(x.words, x.length, rws, N);
    			    this.convert13b(y.words, y.length, nrws, N);

    			    this.transform(rws, _, rwst, iwst, N, rbt);
    			    this.transform(nrws, _, nrwst, niwst, N, rbt);

    			    for (var i = 0; i < N; i++) {
    			      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
    			      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
    			      rwst[i] = rx;
    			    }

    			    this.conjugate(rwst, iwst, N);
    			    this.transform(rwst, iwst, rmws, _, N, rbt);
    			    this.conjugate(rmws, _, N);
    			    this.normalize13b(rmws, N);

    			    out.negative = x.negative ^ y.negative;
    			    out.length = x.length + y.length;
    			    return out.strip();
    			  };

    			  // Multiply `this` by `num`
    			  BN.prototype.mul = function mul (num) {
    			    var out = new BN(null);
    			    out.words = new Array(this.length + num.length);
    			    return this.mulTo(num, out);
    			  };

    			  // Multiply employing FFT
    			  BN.prototype.mulf = function mulf (num) {
    			    var out = new BN(null);
    			    out.words = new Array(this.length + num.length);
    			    return jumboMulTo(this, num, out);
    			  };

    			  // In-place Multiplication
    			  BN.prototype.imul = function imul (num) {
    			    return this.clone().mulTo(num, this);
    			  };

    			  BN.prototype.imuln = function imuln (num) {
    			    assert(typeof num === 'number');
    			    assert(num < 0x4000000);

    			    // Carry
    			    var carry = 0;
    			    for (var i = 0; i < this.length; i++) {
    			      var w = (this.words[i] | 0) * num;
    			      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
    			      carry >>= 26;
    			      carry += (w / 0x4000000) | 0;
    			      // NOTE: lo is 27bit maximum
    			      carry += lo >>> 26;
    			      this.words[i] = lo & 0x3ffffff;
    			    }

    			    if (carry !== 0) {
    			      this.words[i] = carry;
    			      this.length++;
    			    }

    			    return this;
    			  };

    			  BN.prototype.muln = function muln (num) {
    			    return this.clone().imuln(num);
    			  };

    			  // `this` * `this`
    			  BN.prototype.sqr = function sqr () {
    			    return this.mul(this);
    			  };

    			  // `this` * `this` in-place
    			  BN.prototype.isqr = function isqr () {
    			    return this.imul(this.clone());
    			  };

    			  // Math.pow(`this`, `num`)
    			  BN.prototype.pow = function pow (num) {
    			    var w = toBitArray(num);
    			    if (w.length === 0) return new BN(1);

    			    // Skip leading zeroes
    			    var res = this;
    			    for (var i = 0; i < w.length; i++, res = res.sqr()) {
    			      if (w[i] !== 0) break;
    			    }

    			    if (++i < w.length) {
    			      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
    			        if (w[i] === 0) continue;

    			        res = res.mul(q);
    			      }
    			    }

    			    return res;
    			  };

    			  // Shift-left in-place
    			  BN.prototype.iushln = function iushln (bits) {
    			    assert(typeof bits === 'number' && bits >= 0);
    			    var r = bits % 26;
    			    var s = (bits - r) / 26;
    			    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    			    var i;

    			    if (r !== 0) {
    			      var carry = 0;

    			      for (i = 0; i < this.length; i++) {
    			        var newCarry = this.words[i] & carryMask;
    			        var c = ((this.words[i] | 0) - newCarry) << r;
    			        this.words[i] = c | carry;
    			        carry = newCarry >>> (26 - r);
    			      }

    			      if (carry) {
    			        this.words[i] = carry;
    			        this.length++;
    			      }
    			    }

    			    if (s !== 0) {
    			      for (i = this.length - 1; i >= 0; i--) {
    			        this.words[i + s] = this.words[i];
    			      }

    			      for (i = 0; i < s; i++) {
    			        this.words[i] = 0;
    			      }

    			      this.length += s;
    			    }

    			    return this.strip();
    			  };

    			  BN.prototype.ishln = function ishln (bits) {
    			    // TODO(indutny): implement me
    			    assert(this.negative === 0);
    			    return this.iushln(bits);
    			  };

    			  // Shift-right in-place
    			  // NOTE: `hint` is a lowest bit before trailing zeroes
    			  // NOTE: if `extended` is present - it will be filled with destroyed bits
    			  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    			    assert(typeof bits === 'number' && bits >= 0);
    			    var h;
    			    if (hint) {
    			      h = (hint - (hint % 26)) / 26;
    			    } else {
    			      h = 0;
    			    }

    			    var r = bits % 26;
    			    var s = Math.min((bits - r) / 26, this.length);
    			    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    			    var maskedWords = extended;

    			    h -= s;
    			    h = Math.max(0, h);

    			    // Extended mode, copy masked part
    			    if (maskedWords) {
    			      for (var i = 0; i < s; i++) {
    			        maskedWords.words[i] = this.words[i];
    			      }
    			      maskedWords.length = s;
    			    }

    			    if (s === 0) ; else if (this.length > s) {
    			      this.length -= s;
    			      for (i = 0; i < this.length; i++) {
    			        this.words[i] = this.words[i + s];
    			      }
    			    } else {
    			      this.words[0] = 0;
    			      this.length = 1;
    			    }

    			    var carry = 0;
    			    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
    			      var word = this.words[i] | 0;
    			      this.words[i] = (carry << (26 - r)) | (word >>> r);
    			      carry = word & mask;
    			    }

    			    // Push carried bits as a mask
    			    if (maskedWords && carry !== 0) {
    			      maskedWords.words[maskedWords.length++] = carry;
    			    }

    			    if (this.length === 0) {
    			      this.words[0] = 0;
    			      this.length = 1;
    			    }

    			    return this.strip();
    			  };

    			  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    			    // TODO(indutny): implement me
    			    assert(this.negative === 0);
    			    return this.iushrn(bits, hint, extended);
    			  };

    			  // Shift-left
    			  BN.prototype.shln = function shln (bits) {
    			    return this.clone().ishln(bits);
    			  };

    			  BN.prototype.ushln = function ushln (bits) {
    			    return this.clone().iushln(bits);
    			  };

    			  // Shift-right
    			  BN.prototype.shrn = function shrn (bits) {
    			    return this.clone().ishrn(bits);
    			  };

    			  BN.prototype.ushrn = function ushrn (bits) {
    			    return this.clone().iushrn(bits);
    			  };

    			  // Test if n bit is set
    			  BN.prototype.testn = function testn (bit) {
    			    assert(typeof bit === 'number' && bit >= 0);
    			    var r = bit % 26;
    			    var s = (bit - r) / 26;
    			    var q = 1 << r;

    			    // Fast case: bit is much higher than all existing words
    			    if (this.length <= s) return false;

    			    // Check bit and return
    			    var w = this.words[s];

    			    return !!(w & q);
    			  };

    			  // Return only lowers bits of number (in-place)
    			  BN.prototype.imaskn = function imaskn (bits) {
    			    assert(typeof bits === 'number' && bits >= 0);
    			    var r = bits % 26;
    			    var s = (bits - r) / 26;

    			    assert(this.negative === 0, 'imaskn works only with positive numbers');

    			    if (this.length <= s) {
    			      return this;
    			    }

    			    if (r !== 0) {
    			      s++;
    			    }
    			    this.length = Math.min(s, this.length);

    			    if (r !== 0) {
    			      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    			      this.words[this.length - 1] &= mask;
    			    }

    			    return this.strip();
    			  };

    			  // Return only lowers bits of number
    			  BN.prototype.maskn = function maskn (bits) {
    			    return this.clone().imaskn(bits);
    			  };

    			  // Add plain number `num` to `this`
    			  BN.prototype.iaddn = function iaddn (num) {
    			    assert(typeof num === 'number');
    			    assert(num < 0x4000000);
    			    if (num < 0) return this.isubn(-num);

    			    // Possible sign change
    			    if (this.negative !== 0) {
    			      if (this.length === 1 && (this.words[0] | 0) < num) {
    			        this.words[0] = num - (this.words[0] | 0);
    			        this.negative = 0;
    			        return this;
    			      }

    			      this.negative = 0;
    			      this.isubn(num);
    			      this.negative = 1;
    			      return this;
    			    }

    			    // Add without checks
    			    return this._iaddn(num);
    			  };

    			  BN.prototype._iaddn = function _iaddn (num) {
    			    this.words[0] += num;

    			    // Carry
    			    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
    			      this.words[i] -= 0x4000000;
    			      if (i === this.length - 1) {
    			        this.words[i + 1] = 1;
    			      } else {
    			        this.words[i + 1]++;
    			      }
    			    }
    			    this.length = Math.max(this.length, i + 1);

    			    return this;
    			  };

    			  // Subtract plain number `num` from `this`
    			  BN.prototype.isubn = function isubn (num) {
    			    assert(typeof num === 'number');
    			    assert(num < 0x4000000);
    			    if (num < 0) return this.iaddn(-num);

    			    if (this.negative !== 0) {
    			      this.negative = 0;
    			      this.iaddn(num);
    			      this.negative = 1;
    			      return this;
    			    }

    			    this.words[0] -= num;

    			    if (this.length === 1 && this.words[0] < 0) {
    			      this.words[0] = -this.words[0];
    			      this.negative = 1;
    			    } else {
    			      // Carry
    			      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
    			        this.words[i] += 0x4000000;
    			        this.words[i + 1] -= 1;
    			      }
    			    }

    			    return this.strip();
    			  };

    			  BN.prototype.addn = function addn (num) {
    			    return this.clone().iaddn(num);
    			  };

    			  BN.prototype.subn = function subn (num) {
    			    return this.clone().isubn(num);
    			  };

    			  BN.prototype.iabs = function iabs () {
    			    this.negative = 0;

    			    return this;
    			  };

    			  BN.prototype.abs = function abs () {
    			    return this.clone().iabs();
    			  };

    			  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    			    var len = num.length + shift;
    			    var i;

    			    this._expand(len);

    			    var w;
    			    var carry = 0;
    			    for (i = 0; i < num.length; i++) {
    			      w = (this.words[i + shift] | 0) + carry;
    			      var right = (num.words[i] | 0) * mul;
    			      w -= right & 0x3ffffff;
    			      carry = (w >> 26) - ((right / 0x4000000) | 0);
    			      this.words[i + shift] = w & 0x3ffffff;
    			    }
    			    for (; i < this.length - shift; i++) {
    			      w = (this.words[i + shift] | 0) + carry;
    			      carry = w >> 26;
    			      this.words[i + shift] = w & 0x3ffffff;
    			    }

    			    if (carry === 0) return this.strip();

    			    // Subtraction overflow
    			    assert(carry === -1);
    			    carry = 0;
    			    for (i = 0; i < this.length; i++) {
    			      w = -(this.words[i] | 0) + carry;
    			      carry = w >> 26;
    			      this.words[i] = w & 0x3ffffff;
    			    }
    			    this.negative = 1;

    			    return this.strip();
    			  };

    			  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    			    var shift = this.length - num.length;

    			    var a = this.clone();
    			    var b = num;

    			    // Normalize
    			    var bhi = b.words[b.length - 1] | 0;
    			    var bhiBits = this._countBits(bhi);
    			    shift = 26 - bhiBits;
    			    if (shift !== 0) {
    			      b = b.ushln(shift);
    			      a.iushln(shift);
    			      bhi = b.words[b.length - 1] | 0;
    			    }

    			    // Initialize quotient
    			    var m = a.length - b.length;
    			    var q;

    			    if (mode !== 'mod') {
    			      q = new BN(null);
    			      q.length = m + 1;
    			      q.words = new Array(q.length);
    			      for (var i = 0; i < q.length; i++) {
    			        q.words[i] = 0;
    			      }
    			    }

    			    var diff = a.clone()._ishlnsubmul(b, 1, m);
    			    if (diff.negative === 0) {
    			      a = diff;
    			      if (q) {
    			        q.words[m] = 1;
    			      }
    			    }

    			    for (var j = m - 1; j >= 0; j--) {
    			      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
    			        (a.words[b.length + j - 1] | 0);

    			      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
    			      // (0x7ffffff)
    			      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

    			      a._ishlnsubmul(b, qj, j);
    			      while (a.negative !== 0) {
    			        qj--;
    			        a.negative = 0;
    			        a._ishlnsubmul(b, 1, j);
    			        if (!a.isZero()) {
    			          a.negative ^= 1;
    			        }
    			      }
    			      if (q) {
    			        q.words[j] = qj;
    			      }
    			    }
    			    if (q) {
    			      q.strip();
    			    }
    			    a.strip();

    			    // Denormalize
    			    if (mode !== 'div' && shift !== 0) {
    			      a.iushrn(shift);
    			    }

    			    return {
    			      div: q || null,
    			      mod: a
    			    };
    			  };

    			  // NOTE: 1) `mode` can be set to `mod` to request mod only,
    			  //       to `div` to request div only, or be absent to
    			  //       request both div & mod
    			  //       2) `positive` is true if unsigned mod is requested
    			  BN.prototype.divmod = function divmod (num, mode, positive) {
    			    assert(!num.isZero());

    			    if (this.isZero()) {
    			      return {
    			        div: new BN(0),
    			        mod: new BN(0)
    			      };
    			    }

    			    var div, mod, res;
    			    if (this.negative !== 0 && num.negative === 0) {
    			      res = this.neg().divmod(num, mode);

    			      if (mode !== 'mod') {
    			        div = res.div.neg();
    			      }

    			      if (mode !== 'div') {
    			        mod = res.mod.neg();
    			        if (positive && mod.negative !== 0) {
    			          mod.iadd(num);
    			        }
    			      }

    			      return {
    			        div: div,
    			        mod: mod
    			      };
    			    }

    			    if (this.negative === 0 && num.negative !== 0) {
    			      res = this.divmod(num.neg(), mode);

    			      if (mode !== 'mod') {
    			        div = res.div.neg();
    			      }

    			      return {
    			        div: div,
    			        mod: res.mod
    			      };
    			    }

    			    if ((this.negative & num.negative) !== 0) {
    			      res = this.neg().divmod(num.neg(), mode);

    			      if (mode !== 'div') {
    			        mod = res.mod.neg();
    			        if (positive && mod.negative !== 0) {
    			          mod.isub(num);
    			        }
    			      }

    			      return {
    			        div: res.div,
    			        mod: mod
    			      };
    			    }

    			    // Both numbers are positive at this point

    			    // Strip both numbers to approximate shift value
    			    if (num.length > this.length || this.cmp(num) < 0) {
    			      return {
    			        div: new BN(0),
    			        mod: this
    			      };
    			    }

    			    // Very short reduction
    			    if (num.length === 1) {
    			      if (mode === 'div') {
    			        return {
    			          div: this.divn(num.words[0]),
    			          mod: null
    			        };
    			      }

    			      if (mode === 'mod') {
    			        return {
    			          div: null,
    			          mod: new BN(this.modn(num.words[0]))
    			        };
    			      }

    			      return {
    			        div: this.divn(num.words[0]),
    			        mod: new BN(this.modn(num.words[0]))
    			      };
    			    }

    			    return this._wordDiv(num, mode);
    			  };

    			  // Find `this` / `num`
    			  BN.prototype.div = function div (num) {
    			    return this.divmod(num, 'div', false).div;
    			  };

    			  // Find `this` % `num`
    			  BN.prototype.mod = function mod (num) {
    			    return this.divmod(num, 'mod', false).mod;
    			  };

    			  BN.prototype.umod = function umod (num) {
    			    return this.divmod(num, 'mod', true).mod;
    			  };

    			  // Find Round(`this` / `num`)
    			  BN.prototype.divRound = function divRound (num) {
    			    var dm = this.divmod(num);

    			    // Fast case - exact division
    			    if (dm.mod.isZero()) return dm.div;

    			    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    			    var half = num.ushrn(1);
    			    var r2 = num.andln(1);
    			    var cmp = mod.cmp(half);

    			    // Round down
    			    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    			    // Round up
    			    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    			  };

    			  BN.prototype.modn = function modn (num) {
    			    assert(num <= 0x3ffffff);
    			    var p = (1 << 26) % num;

    			    var acc = 0;
    			    for (var i = this.length - 1; i >= 0; i--) {
    			      acc = (p * acc + (this.words[i] | 0)) % num;
    			    }

    			    return acc;
    			  };

    			  // In-place division by number
    			  BN.prototype.idivn = function idivn (num) {
    			    assert(num <= 0x3ffffff);

    			    var carry = 0;
    			    for (var i = this.length - 1; i >= 0; i--) {
    			      var w = (this.words[i] | 0) + carry * 0x4000000;
    			      this.words[i] = (w / num) | 0;
    			      carry = w % num;
    			    }

    			    return this.strip();
    			  };

    			  BN.prototype.divn = function divn (num) {
    			    return this.clone().idivn(num);
    			  };

    			  BN.prototype.egcd = function egcd (p) {
    			    assert(p.negative === 0);
    			    assert(!p.isZero());

    			    var x = this;
    			    var y = p.clone();

    			    if (x.negative !== 0) {
    			      x = x.umod(p);
    			    } else {
    			      x = x.clone();
    			    }

    			    // A * x + B * y = x
    			    var A = new BN(1);
    			    var B = new BN(0);

    			    // C * x + D * y = y
    			    var C = new BN(0);
    			    var D = new BN(1);

    			    var g = 0;

    			    while (x.isEven() && y.isEven()) {
    			      x.iushrn(1);
    			      y.iushrn(1);
    			      ++g;
    			    }

    			    var yp = y.clone();
    			    var xp = x.clone();

    			    while (!x.isZero()) {
    			      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
    			      if (i > 0) {
    			        x.iushrn(i);
    			        while (i-- > 0) {
    			          if (A.isOdd() || B.isOdd()) {
    			            A.iadd(yp);
    			            B.isub(xp);
    			          }

    			          A.iushrn(1);
    			          B.iushrn(1);
    			        }
    			      }

    			      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
    			      if (j > 0) {
    			        y.iushrn(j);
    			        while (j-- > 0) {
    			          if (C.isOdd() || D.isOdd()) {
    			            C.iadd(yp);
    			            D.isub(xp);
    			          }

    			          C.iushrn(1);
    			          D.iushrn(1);
    			        }
    			      }

    			      if (x.cmp(y) >= 0) {
    			        x.isub(y);
    			        A.isub(C);
    			        B.isub(D);
    			      } else {
    			        y.isub(x);
    			        C.isub(A);
    			        D.isub(B);
    			      }
    			    }

    			    return {
    			      a: C,
    			      b: D,
    			      gcd: y.iushln(g)
    			    };
    			  };

    			  // This is reduced incarnation of the binary EEA
    			  // above, designated to invert members of the
    			  // _prime_ fields F(p) at a maximal speed
    			  BN.prototype._invmp = function _invmp (p) {
    			    assert(p.negative === 0);
    			    assert(!p.isZero());

    			    var a = this;
    			    var b = p.clone();

    			    if (a.negative !== 0) {
    			      a = a.umod(p);
    			    } else {
    			      a = a.clone();
    			    }

    			    var x1 = new BN(1);
    			    var x2 = new BN(0);

    			    var delta = b.clone();

    			    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
    			      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
    			      if (i > 0) {
    			        a.iushrn(i);
    			        while (i-- > 0) {
    			          if (x1.isOdd()) {
    			            x1.iadd(delta);
    			          }

    			          x1.iushrn(1);
    			        }
    			      }

    			      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
    			      if (j > 0) {
    			        b.iushrn(j);
    			        while (j-- > 0) {
    			          if (x2.isOdd()) {
    			            x2.iadd(delta);
    			          }

    			          x2.iushrn(1);
    			        }
    			      }

    			      if (a.cmp(b) >= 0) {
    			        a.isub(b);
    			        x1.isub(x2);
    			      } else {
    			        b.isub(a);
    			        x2.isub(x1);
    			      }
    			    }

    			    var res;
    			    if (a.cmpn(1) === 0) {
    			      res = x1;
    			    } else {
    			      res = x2;
    			    }

    			    if (res.cmpn(0) < 0) {
    			      res.iadd(p);
    			    }

    			    return res;
    			  };

    			  BN.prototype.gcd = function gcd (num) {
    			    if (this.isZero()) return num.abs();
    			    if (num.isZero()) return this.abs();

    			    var a = this.clone();
    			    var b = num.clone();
    			    a.negative = 0;
    			    b.negative = 0;

    			    // Remove common factor of two
    			    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
    			      a.iushrn(1);
    			      b.iushrn(1);
    			    }

    			    do {
    			      while (a.isEven()) {
    			        a.iushrn(1);
    			      }
    			      while (b.isEven()) {
    			        b.iushrn(1);
    			      }

    			      var r = a.cmp(b);
    			      if (r < 0) {
    			        // Swap `a` and `b` to make `a` always bigger than `b`
    			        var t = a;
    			        a = b;
    			        b = t;
    			      } else if (r === 0 || b.cmpn(1) === 0) {
    			        break;
    			      }

    			      a.isub(b);
    			    } while (true);

    			    return b.iushln(shift);
    			  };

    			  // Invert number in the field F(num)
    			  BN.prototype.invm = function invm (num) {
    			    return this.egcd(num).a.umod(num);
    			  };

    			  BN.prototype.isEven = function isEven () {
    			    return (this.words[0] & 1) === 0;
    			  };

    			  BN.prototype.isOdd = function isOdd () {
    			    return (this.words[0] & 1) === 1;
    			  };

    			  // And first word and num
    			  BN.prototype.andln = function andln (num) {
    			    return this.words[0] & num;
    			  };

    			  // Increment at the bit position in-line
    			  BN.prototype.bincn = function bincn (bit) {
    			    assert(typeof bit === 'number');
    			    var r = bit % 26;
    			    var s = (bit - r) / 26;
    			    var q = 1 << r;

    			    // Fast case: bit is much higher than all existing words
    			    if (this.length <= s) {
    			      this._expand(s + 1);
    			      this.words[s] |= q;
    			      return this;
    			    }

    			    // Add bit and propagate, if needed
    			    var carry = q;
    			    for (var i = s; carry !== 0 && i < this.length; i++) {
    			      var w = this.words[i] | 0;
    			      w += carry;
    			      carry = w >>> 26;
    			      w &= 0x3ffffff;
    			      this.words[i] = w;
    			    }
    			    if (carry !== 0) {
    			      this.words[i] = carry;
    			      this.length++;
    			    }
    			    return this;
    			  };

    			  BN.prototype.isZero = function isZero () {
    			    return this.length === 1 && this.words[0] === 0;
    			  };

    			  BN.prototype.cmpn = function cmpn (num) {
    			    var negative = num < 0;

    			    if (this.negative !== 0 && !negative) return -1;
    			    if (this.negative === 0 && negative) return 1;

    			    this.strip();

    			    var res;
    			    if (this.length > 1) {
    			      res = 1;
    			    } else {
    			      if (negative) {
    			        num = -num;
    			      }

    			      assert(num <= 0x3ffffff, 'Number is too big');

    			      var w = this.words[0] | 0;
    			      res = w === num ? 0 : w < num ? -1 : 1;
    			    }
    			    if (this.negative !== 0) return -res | 0;
    			    return res;
    			  };

    			  // Compare two numbers and return:
    			  // 1 - if `this` > `num`
    			  // 0 - if `this` == `num`
    			  // -1 - if `this` < `num`
    			  BN.prototype.cmp = function cmp (num) {
    			    if (this.negative !== 0 && num.negative === 0) return -1;
    			    if (this.negative === 0 && num.negative !== 0) return 1;

    			    var res = this.ucmp(num);
    			    if (this.negative !== 0) return -res | 0;
    			    return res;
    			  };

    			  // Unsigned comparison
    			  BN.prototype.ucmp = function ucmp (num) {
    			    // At this point both numbers have the same sign
    			    if (this.length > num.length) return 1;
    			    if (this.length < num.length) return -1;

    			    var res = 0;
    			    for (var i = this.length - 1; i >= 0; i--) {
    			      var a = this.words[i] | 0;
    			      var b = num.words[i] | 0;

    			      if (a === b) continue;
    			      if (a < b) {
    			        res = -1;
    			      } else if (a > b) {
    			        res = 1;
    			      }
    			      break;
    			    }
    			    return res;
    			  };

    			  BN.prototype.gtn = function gtn (num) {
    			    return this.cmpn(num) === 1;
    			  };

    			  BN.prototype.gt = function gt (num) {
    			    return this.cmp(num) === 1;
    			  };

    			  BN.prototype.gten = function gten (num) {
    			    return this.cmpn(num) >= 0;
    			  };

    			  BN.prototype.gte = function gte (num) {
    			    return this.cmp(num) >= 0;
    			  };

    			  BN.prototype.ltn = function ltn (num) {
    			    return this.cmpn(num) === -1;
    			  };

    			  BN.prototype.lt = function lt (num) {
    			    return this.cmp(num) === -1;
    			  };

    			  BN.prototype.lten = function lten (num) {
    			    return this.cmpn(num) <= 0;
    			  };

    			  BN.prototype.lte = function lte (num) {
    			    return this.cmp(num) <= 0;
    			  };

    			  BN.prototype.eqn = function eqn (num) {
    			    return this.cmpn(num) === 0;
    			  };

    			  BN.prototype.eq = function eq (num) {
    			    return this.cmp(num) === 0;
    			  };

    			  //
    			  // A reduce context, could be using montgomery or something better, depending
    			  // on the `m` itself.
    			  //
    			  BN.red = function red (num) {
    			    return new Red(num);
    			  };

    			  BN.prototype.toRed = function toRed (ctx) {
    			    assert(!this.red, 'Already a number in reduction context');
    			    assert(this.negative === 0, 'red works only with positives');
    			    return ctx.convertTo(this)._forceRed(ctx);
    			  };

    			  BN.prototype.fromRed = function fromRed () {
    			    assert(this.red, 'fromRed works only with numbers in reduction context');
    			    return this.red.convertFrom(this);
    			  };

    			  BN.prototype._forceRed = function _forceRed (ctx) {
    			    this.red = ctx;
    			    return this;
    			  };

    			  BN.prototype.forceRed = function forceRed (ctx) {
    			    assert(!this.red, 'Already a number in reduction context');
    			    return this._forceRed(ctx);
    			  };

    			  BN.prototype.redAdd = function redAdd (num) {
    			    assert(this.red, 'redAdd works only with red numbers');
    			    return this.red.add(this, num);
    			  };

    			  BN.prototype.redIAdd = function redIAdd (num) {
    			    assert(this.red, 'redIAdd works only with red numbers');
    			    return this.red.iadd(this, num);
    			  };

    			  BN.prototype.redSub = function redSub (num) {
    			    assert(this.red, 'redSub works only with red numbers');
    			    return this.red.sub(this, num);
    			  };

    			  BN.prototype.redISub = function redISub (num) {
    			    assert(this.red, 'redISub works only with red numbers');
    			    return this.red.isub(this, num);
    			  };

    			  BN.prototype.redShl = function redShl (num) {
    			    assert(this.red, 'redShl works only with red numbers');
    			    return this.red.shl(this, num);
    			  };

    			  BN.prototype.redMul = function redMul (num) {
    			    assert(this.red, 'redMul works only with red numbers');
    			    this.red._verify2(this, num);
    			    return this.red.mul(this, num);
    			  };

    			  BN.prototype.redIMul = function redIMul (num) {
    			    assert(this.red, 'redMul works only with red numbers');
    			    this.red._verify2(this, num);
    			    return this.red.imul(this, num);
    			  };

    			  BN.prototype.redSqr = function redSqr () {
    			    assert(this.red, 'redSqr works only with red numbers');
    			    this.red._verify1(this);
    			    return this.red.sqr(this);
    			  };

    			  BN.prototype.redISqr = function redISqr () {
    			    assert(this.red, 'redISqr works only with red numbers');
    			    this.red._verify1(this);
    			    return this.red.isqr(this);
    			  };

    			  // Square root over p
    			  BN.prototype.redSqrt = function redSqrt () {
    			    assert(this.red, 'redSqrt works only with red numbers');
    			    this.red._verify1(this);
    			    return this.red.sqrt(this);
    			  };

    			  BN.prototype.redInvm = function redInvm () {
    			    assert(this.red, 'redInvm works only with red numbers');
    			    this.red._verify1(this);
    			    return this.red.invm(this);
    			  };

    			  // Return negative clone of `this` % `red modulo`
    			  BN.prototype.redNeg = function redNeg () {
    			    assert(this.red, 'redNeg works only with red numbers');
    			    this.red._verify1(this);
    			    return this.red.neg(this);
    			  };

    			  BN.prototype.redPow = function redPow (num) {
    			    assert(this.red && !num.red, 'redPow(normalNum)');
    			    this.red._verify1(this);
    			    return this.red.pow(this, num);
    			  };

    			  // Prime numbers with efficient reduction
    			  var primes = {
    			    k256: null,
    			    p224: null,
    			    p192: null,
    			    p25519: null
    			  };

    			  // Pseudo-Mersenne prime
    			  function MPrime (name, p) {
    			    // P = 2 ^ N - K
    			    this.name = name;
    			    this.p = new BN(p, 16);
    			    this.n = this.p.bitLength();
    			    this.k = new BN(1).iushln(this.n).isub(this.p);

    			    this.tmp = this._tmp();
    			  }

    			  MPrime.prototype._tmp = function _tmp () {
    			    var tmp = new BN(null);
    			    tmp.words = new Array(Math.ceil(this.n / 13));
    			    return tmp;
    			  };

    			  MPrime.prototype.ireduce = function ireduce (num) {
    			    // Assumes that `num` is less than `P^2`
    			    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    			    var r = num;
    			    var rlen;

    			    do {
    			      this.split(r, this.tmp);
    			      r = this.imulK(r);
    			      r = r.iadd(this.tmp);
    			      rlen = r.bitLength();
    			    } while (rlen > this.n);

    			    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    			    if (cmp === 0) {
    			      r.words[0] = 0;
    			      r.length = 1;
    			    } else if (cmp > 0) {
    			      r.isub(this.p);
    			    } else {
    			      if (r.strip !== undefined) {
    			        // r is BN v4 instance
    			        r.strip();
    			      } else {
    			        // r is BN v5 instance
    			        r._strip();
    			      }
    			    }

    			    return r;
    			  };

    			  MPrime.prototype.split = function split (input, out) {
    			    input.iushrn(this.n, 0, out);
    			  };

    			  MPrime.prototype.imulK = function imulK (num) {
    			    return num.imul(this.k);
    			  };

    			  function K256 () {
    			    MPrime.call(
    			      this,
    			      'k256',
    			      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    			  }
    			  inherits(K256, MPrime);

    			  K256.prototype.split = function split (input, output) {
    			    // 256 = 9 * 26 + 22
    			    var mask = 0x3fffff;

    			    var outLen = Math.min(input.length, 9);
    			    for (var i = 0; i < outLen; i++) {
    			      output.words[i] = input.words[i];
    			    }
    			    output.length = outLen;

    			    if (input.length <= 9) {
    			      input.words[0] = 0;
    			      input.length = 1;
    			      return;
    			    }

    			    // Shift by 9 limbs
    			    var prev = input.words[9];
    			    output.words[output.length++] = prev & mask;

    			    for (i = 10; i < input.length; i++) {
    			      var next = input.words[i] | 0;
    			      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
    			      prev = next;
    			    }
    			    prev >>>= 22;
    			    input.words[i - 10] = prev;
    			    if (prev === 0 && input.length > 10) {
    			      input.length -= 10;
    			    } else {
    			      input.length -= 9;
    			    }
    			  };

    			  K256.prototype.imulK = function imulK (num) {
    			    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    			    num.words[num.length] = 0;
    			    num.words[num.length + 1] = 0;
    			    num.length += 2;

    			    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    			    var lo = 0;
    			    for (var i = 0; i < num.length; i++) {
    			      var w = num.words[i] | 0;
    			      lo += w * 0x3d1;
    			      num.words[i] = lo & 0x3ffffff;
    			      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    			    }

    			    // Fast length reduction
    			    if (num.words[num.length - 1] === 0) {
    			      num.length--;
    			      if (num.words[num.length - 1] === 0) {
    			        num.length--;
    			      }
    			    }
    			    return num;
    			  };

    			  function P224 () {
    			    MPrime.call(
    			      this,
    			      'p224',
    			      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    			  }
    			  inherits(P224, MPrime);

    			  function P192 () {
    			    MPrime.call(
    			      this,
    			      'p192',
    			      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    			  }
    			  inherits(P192, MPrime);

    			  function P25519 () {
    			    // 2 ^ 255 - 19
    			    MPrime.call(
    			      this,
    			      '25519',
    			      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    			  }
    			  inherits(P25519, MPrime);

    			  P25519.prototype.imulK = function imulK (num) {
    			    // K = 0x13
    			    var carry = 0;
    			    for (var i = 0; i < num.length; i++) {
    			      var hi = (num.words[i] | 0) * 0x13 + carry;
    			      var lo = hi & 0x3ffffff;
    			      hi >>>= 26;

    			      num.words[i] = lo;
    			      carry = hi;
    			    }
    			    if (carry !== 0) {
    			      num.words[num.length++] = carry;
    			    }
    			    return num;
    			  };

    			  // Exported mostly for testing purposes, use plain name instead
    			  BN._prime = function prime (name) {
    			    // Cached version of prime
    			    if (primes[name]) return primes[name];

    			    var prime;
    			    if (name === 'k256') {
    			      prime = new K256();
    			    } else if (name === 'p224') {
    			      prime = new P224();
    			    } else if (name === 'p192') {
    			      prime = new P192();
    			    } else if (name === 'p25519') {
    			      prime = new P25519();
    			    } else {
    			      throw new Error('Unknown prime ' + name);
    			    }
    			    primes[name] = prime;

    			    return prime;
    			  };

    			  //
    			  // Base reduction engine
    			  //
    			  function Red (m) {
    			    if (typeof m === 'string') {
    			      var prime = BN._prime(m);
    			      this.m = prime.p;
    			      this.prime = prime;
    			    } else {
    			      assert(m.gtn(1), 'modulus must be greater than 1');
    			      this.m = m;
    			      this.prime = null;
    			    }
    			  }

    			  Red.prototype._verify1 = function _verify1 (a) {
    			    assert(a.negative === 0, 'red works only with positives');
    			    assert(a.red, 'red works only with red numbers');
    			  };

    			  Red.prototype._verify2 = function _verify2 (a, b) {
    			    assert((a.negative | b.negative) === 0, 'red works only with positives');
    			    assert(a.red && a.red === b.red,
    			      'red works only with red numbers');
    			  };

    			  Red.prototype.imod = function imod (a) {
    			    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    			    return a.umod(this.m)._forceRed(this);
    			  };

    			  Red.prototype.neg = function neg (a) {
    			    if (a.isZero()) {
    			      return a.clone();
    			    }

    			    return this.m.sub(a)._forceRed(this);
    			  };

    			  Red.prototype.add = function add (a, b) {
    			    this._verify2(a, b);

    			    var res = a.add(b);
    			    if (res.cmp(this.m) >= 0) {
    			      res.isub(this.m);
    			    }
    			    return res._forceRed(this);
    			  };

    			  Red.prototype.iadd = function iadd (a, b) {
    			    this._verify2(a, b);

    			    var res = a.iadd(b);
    			    if (res.cmp(this.m) >= 0) {
    			      res.isub(this.m);
    			    }
    			    return res;
    			  };

    			  Red.prototype.sub = function sub (a, b) {
    			    this._verify2(a, b);

    			    var res = a.sub(b);
    			    if (res.cmpn(0) < 0) {
    			      res.iadd(this.m);
    			    }
    			    return res._forceRed(this);
    			  };

    			  Red.prototype.isub = function isub (a, b) {
    			    this._verify2(a, b);

    			    var res = a.isub(b);
    			    if (res.cmpn(0) < 0) {
    			      res.iadd(this.m);
    			    }
    			    return res;
    			  };

    			  Red.prototype.shl = function shl (a, num) {
    			    this._verify1(a);
    			    return this.imod(a.ushln(num));
    			  };

    			  Red.prototype.imul = function imul (a, b) {
    			    this._verify2(a, b);
    			    return this.imod(a.imul(b));
    			  };

    			  Red.prototype.mul = function mul (a, b) {
    			    this._verify2(a, b);
    			    return this.imod(a.mul(b));
    			  };

    			  Red.prototype.isqr = function isqr (a) {
    			    return this.imul(a, a.clone());
    			  };

    			  Red.prototype.sqr = function sqr (a) {
    			    return this.mul(a, a);
    			  };

    			  Red.prototype.sqrt = function sqrt (a) {
    			    if (a.isZero()) return a.clone();

    			    var mod3 = this.m.andln(3);
    			    assert(mod3 % 2 === 1);

    			    // Fast case
    			    if (mod3 === 3) {
    			      var pow = this.m.add(new BN(1)).iushrn(2);
    			      return this.pow(a, pow);
    			    }

    			    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    			    //
    			    // Find Q and S, that Q * 2 ^ S = (P - 1)
    			    var q = this.m.subn(1);
    			    var s = 0;
    			    while (!q.isZero() && q.andln(1) === 0) {
    			      s++;
    			      q.iushrn(1);
    			    }
    			    assert(!q.isZero());

    			    var one = new BN(1).toRed(this);
    			    var nOne = one.redNeg();

    			    // Find quadratic non-residue
    			    // NOTE: Max is such because of generalized Riemann hypothesis.
    			    var lpow = this.m.subn(1).iushrn(1);
    			    var z = this.m.bitLength();
    			    z = new BN(2 * z * z).toRed(this);

    			    while (this.pow(z, lpow).cmp(nOne) !== 0) {
    			      z.redIAdd(nOne);
    			    }

    			    var c = this.pow(z, q);
    			    var r = this.pow(a, q.addn(1).iushrn(1));
    			    var t = this.pow(a, q);
    			    var m = s;
    			    while (t.cmp(one) !== 0) {
    			      var tmp = t;
    			      for (var i = 0; tmp.cmp(one) !== 0; i++) {
    			        tmp = tmp.redSqr();
    			      }
    			      assert(i < m);
    			      var b = this.pow(c, new BN(1).iushln(m - i - 1));

    			      r = r.redMul(b);
    			      c = b.redSqr();
    			      t = t.redMul(c);
    			      m = i;
    			    }

    			    return r;
    			  };

    			  Red.prototype.invm = function invm (a) {
    			    var inv = a._invmp(this.m);
    			    if (inv.negative !== 0) {
    			      inv.negative = 0;
    			      return this.imod(inv).redNeg();
    			    } else {
    			      return this.imod(inv);
    			    }
    			  };

    			  Red.prototype.pow = function pow (a, num) {
    			    if (num.isZero()) return new BN(1).toRed(this);
    			    if (num.cmpn(1) === 0) return a.clone();

    			    var windowSize = 4;
    			    var wnd = new Array(1 << windowSize);
    			    wnd[0] = new BN(1).toRed(this);
    			    wnd[1] = a;
    			    for (var i = 2; i < wnd.length; i++) {
    			      wnd[i] = this.mul(wnd[i - 1], a);
    			    }

    			    var res = wnd[0];
    			    var current = 0;
    			    var currentLen = 0;
    			    var start = num.bitLength() % 26;
    			    if (start === 0) {
    			      start = 26;
    			    }

    			    for (i = num.length - 1; i >= 0; i--) {
    			      var word = num.words[i];
    			      for (var j = start - 1; j >= 0; j--) {
    			        var bit = (word >> j) & 1;
    			        if (res !== wnd[0]) {
    			          res = this.sqr(res);
    			        }

    			        if (bit === 0 && current === 0) {
    			          currentLen = 0;
    			          continue;
    			        }

    			        current <<= 1;
    			        current |= bit;
    			        currentLen++;
    			        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

    			        res = this.mul(res, wnd[current]);
    			        currentLen = 0;
    			        current = 0;
    			      }
    			      start = 26;
    			    }

    			    return res;
    			  };

    			  Red.prototype.convertTo = function convertTo (num) {
    			    var r = num.umod(this.m);

    			    return r === num ? r.clone() : r;
    			  };

    			  Red.prototype.convertFrom = function convertFrom (num) {
    			    var res = num.clone();
    			    res.red = null;
    			    return res;
    			  };

    			  //
    			  // Montgomery method engine
    			  //

    			  BN.mont = function mont (num) {
    			    return new Mont(num);
    			  };

    			  function Mont (m) {
    			    Red.call(this, m);

    			    this.shift = this.m.bitLength();
    			    if (this.shift % 26 !== 0) {
    			      this.shift += 26 - (this.shift % 26);
    			    }

    			    this.r = new BN(1).iushln(this.shift);
    			    this.r2 = this.imod(this.r.sqr());
    			    this.rinv = this.r._invmp(this.m);

    			    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    			    this.minv = this.minv.umod(this.r);
    			    this.minv = this.r.sub(this.minv);
    			  }
    			  inherits(Mont, Red);

    			  Mont.prototype.convertTo = function convertTo (num) {
    			    return this.imod(num.ushln(this.shift));
    			  };

    			  Mont.prototype.convertFrom = function convertFrom (num) {
    			    var r = this.imod(num.mul(this.rinv));
    			    r.red = null;
    			    return r;
    			  };

    			  Mont.prototype.imul = function imul (a, b) {
    			    if (a.isZero() || b.isZero()) {
    			      a.words[0] = 0;
    			      a.length = 1;
    			      return a;
    			    }

    			    var t = a.imul(b);
    			    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    			    var u = t.isub(c).iushrn(this.shift);
    			    var res = u;

    			    if (u.cmp(this.m) >= 0) {
    			      res = u.isub(this.m);
    			    } else if (u.cmpn(0) < 0) {
    			      res = u.iadd(this.m);
    			    }

    			    return res._forceRed(this);
    			  };

    			  Mont.prototype.mul = function mul (a, b) {
    			    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    			    var t = a.mul(b);
    			    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    			    var u = t.isub(c).iushrn(this.shift);
    			    var res = u;
    			    if (u.cmp(this.m) >= 0) {
    			      res = u.isub(this.m);
    			    } else if (u.cmpn(0) < 0) {
    			      res = u.iadd(this.m);
    			    }

    			    return res._forceRed(this);
    			  };

    			  Mont.prototype.invm = function invm (a) {
    			    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    			    var res = this.imod(a._invmp(this.m).mul(this.r2));
    			    return res._forceRed(this);
    			  };
    			})(module, commonjsGlobal$1); 
    		} (bn));

    		var bnExports = bn.exports;

    		var minimalisticAssert = assert$f;

    		function assert$f(val, msg) {
    		  if (!val)
    		    throw new Error(msg || 'Assertion failed');
    		}

    		assert$f.equal = function assertEqual(l, r, msg) {
    		  if (l != r)
    		    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
    		};

    		var utils$l = {};

    		(function (exports) {

    			var utils = exports;

    			function toArray(msg, enc) {
    			  if (Array.isArray(msg))
    			    return msg.slice();
    			  if (!msg)
    			    return [];
    			  var res = [];
    			  if (typeof msg !== 'string') {
    			    for (var i = 0; i < msg.length; i++)
    			      res[i] = msg[i] | 0;
    			    return res;
    			  }
    			  if (enc === 'hex') {
    			    msg = msg.replace(/[^a-z0-9]+/ig, '');
    			    if (msg.length % 2 !== 0)
    			      msg = '0' + msg;
    			    for (var i = 0; i < msg.length; i += 2)
    			      res.push(parseInt(msg[i] + msg[i + 1], 16));
    			  } else {
    			    for (var i = 0; i < msg.length; i++) {
    			      var c = msg.charCodeAt(i);
    			      var hi = c >> 8;
    			      var lo = c & 0xff;
    			      if (hi)
    			        res.push(hi, lo);
    			      else
    			        res.push(lo);
    			    }
    			  }
    			  return res;
    			}
    			utils.toArray = toArray;

    			function zero2(word) {
    			  if (word.length === 1)
    			    return '0' + word;
    			  else
    			    return word;
    			}
    			utils.zero2 = zero2;

    			function toHex(msg) {
    			  var res = '';
    			  for (var i = 0; i < msg.length; i++)
    			    res += zero2(msg[i].toString(16));
    			  return res;
    			}
    			utils.toHex = toHex;

    			utils.encode = function encode(arr, enc) {
    			  if (enc === 'hex')
    			    return toHex(arr);
    			  else
    			    return arr;
    			}; 
    		} (utils$l));

    		(function (exports) {

    			var utils = exports;
    			var BN = bnExports;
    			var minAssert = minimalisticAssert;
    			var minUtils = utils$l;

    			utils.assert = minAssert;
    			utils.toArray = minUtils.toArray;
    			utils.zero2 = minUtils.zero2;
    			utils.toHex = minUtils.toHex;
    			utils.encode = minUtils.encode;

    			// Represent num in a w-NAF form
    			function getNAF(num, w, bits) {
    			  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    			  naf.fill(0);

    			  var ws = 1 << (w + 1);
    			  var k = num.clone();

    			  for (var i = 0; i < naf.length; i++) {
    			    var z;
    			    var mod = k.andln(ws - 1);
    			    if (k.isOdd()) {
    			      if (mod > (ws >> 1) - 1)
    			        z = (ws >> 1) - mod;
    			      else
    			        z = mod;
    			      k.isubn(z);
    			    } else {
    			      z = 0;
    			    }

    			    naf[i] = z;
    			    k.iushrn(1);
    			  }

    			  return naf;
    			}
    			utils.getNAF = getNAF;

    			// Represent k1, k2 in a Joint Sparse Form
    			function getJSF(k1, k2) {
    			  var jsf = [
    			    [],
    			    [],
    			  ];

    			  k1 = k1.clone();
    			  k2 = k2.clone();
    			  var d1 = 0;
    			  var d2 = 0;
    			  var m8;
    			  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
    			    // First phase
    			    var m14 = (k1.andln(3) + d1) & 3;
    			    var m24 = (k2.andln(3) + d2) & 3;
    			    if (m14 === 3)
    			      m14 = -1;
    			    if (m24 === 3)
    			      m24 = -1;
    			    var u1;
    			    if ((m14 & 1) === 0) {
    			      u1 = 0;
    			    } else {
    			      m8 = (k1.andln(7) + d1) & 7;
    			      if ((m8 === 3 || m8 === 5) && m24 === 2)
    			        u1 = -m14;
    			      else
    			        u1 = m14;
    			    }
    			    jsf[0].push(u1);

    			    var u2;
    			    if ((m24 & 1) === 0) {
    			      u2 = 0;
    			    } else {
    			      m8 = (k2.andln(7) + d2) & 7;
    			      if ((m8 === 3 || m8 === 5) && m14 === 2)
    			        u2 = -m24;
    			      else
    			        u2 = m24;
    			    }
    			    jsf[1].push(u2);

    			    // Second phase
    			    if (2 * d1 === u1 + 1)
    			      d1 = 1 - d1;
    			    if (2 * d2 === u2 + 1)
    			      d2 = 1 - d2;
    			    k1.iushrn(1);
    			    k2.iushrn(1);
    			  }

    			  return jsf;
    			}
    			utils.getJSF = getJSF;

    			function cachedProperty(obj, name, computer) {
    			  var key = '_' + name;
    			  obj.prototype[name] = function cachedProperty() {
    			    return this[key] !== undefined ? this[key] :
    			      this[key] = computer.call(this);
    			  };
    			}
    			utils.cachedProperty = cachedProperty;

    			function parseBytes(bytes) {
    			  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
    			    bytes;
    			}
    			utils.parseBytes = parseBytes;

    			function intFromLE(bytes) {
    			  return new BN(bytes, 'hex', 'le');
    			}
    			utils.intFromLE = intFromLE; 
    		} (utils$m));

    		var brorand = {exports: {}};

    		var _polyfillNode_crypto = {};

    		var _polyfillNode_crypto$1 = /*#__PURE__*/Object.freeze({
    			__proto__: null,
    			'default': _polyfillNode_crypto
    		});

    		var require$$0$2 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_crypto$1);

    		var r$1;

    		brorand.exports = function rand(len) {
    		  if (!r$1)
    		    r$1 = new Rand(null);

    		  return r$1.generate(len);
    		};

    		function Rand(rand) {
    		  this.rand = rand;
    		}
    		brorand.exports.Rand = Rand;

    		Rand.prototype.generate = function generate(len) {
    		  return this._rand(len);
    		};

    		// Emulate crypto API using randy
    		Rand.prototype._rand = function _rand(n) {
    		  if (this.rand.getBytes)
    		    return this.rand.getBytes(n);

    		  var res = new Uint8Array(n);
    		  for (var i = 0; i < res.length; i++)
    		    res[i] = this.rand.getByte();
    		  return res;
    		};

    		if (typeof self === 'object') {
    		  if (self.crypto && self.crypto.getRandomValues) {
    		    // Modern browsers
    		    Rand.prototype._rand = function _rand(n) {
    		      var arr = new Uint8Array(n);
    		      self.crypto.getRandomValues(arr);
    		      return arr;
    		    };
    		  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    		    // IE
    		    Rand.prototype._rand = function _rand(n) {
    		      var arr = new Uint8Array(n);
    		      self.msCrypto.getRandomValues(arr);
    		      return arr;
    		    };

    		  // Safari's WebWorkers do not have `crypto`
    		  } else if (typeof window === 'object') {
    		    // Old junk
    		    Rand.prototype._rand = function() {
    		      throw new Error('Not implemented yet');
    		    };
    		  }
    		} else {
    		  // Node.js or Web worker with no crypto support
    		  try {
    		    var crypto$1 = require$$0$2;
    		    if (typeof crypto$1.randomBytes !== 'function')
    		      throw new Error('Not supported');

    		    Rand.prototype._rand = function _rand(n) {
    		      return crypto$1.randomBytes(n);
    		    };
    		  } catch (e) {
    		  }
    		}

    		var brorandExports = brorand.exports;

    		var curve$1 = {};

    		var BN$7 = bnExports;
    		var utils$k = utils$m;
    		var getNAF = utils$k.getNAF;
    		var getJSF = utils$k.getJSF;
    		var assert$e = utils$k.assert;

    		function BaseCurve(type, conf) {
    		  this.type = type;
    		  this.p = new BN$7(conf.p, 16);

    		  // Use Montgomery, when there is no fast reduction for the prime
    		  this.red = conf.prime ? BN$7.red(conf.prime) : BN$7.mont(this.p);

    		  // Useful for many curves
    		  this.zero = new BN$7(0).toRed(this.red);
    		  this.one = new BN$7(1).toRed(this.red);
    		  this.two = new BN$7(2).toRed(this.red);

    		  // Curve configuration, optional
    		  this.n = conf.n && new BN$7(conf.n, 16);
    		  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

    		  // Temporary arrays
    		  this._wnafT1 = new Array(4);
    		  this._wnafT2 = new Array(4);
    		  this._wnafT3 = new Array(4);
    		  this._wnafT4 = new Array(4);

    		  this._bitLength = this.n ? this.n.bitLength() : 0;

    		  // Generalized Greg Maxwell's trick
    		  var adjustCount = this.n && this.p.div(this.n);
    		  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    		    this.redN = null;
    		  } else {
    		    this._maxwellTrick = true;
    		    this.redN = this.n.toRed(this.red);
    		  }
    		}
    		var base = BaseCurve;

    		BaseCurve.prototype.point = function point() {
    		  throw new Error('Not implemented');
    		};

    		BaseCurve.prototype.validate = function validate() {
    		  throw new Error('Not implemented');
    		};

    		BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    		  assert$e(p.precomputed);
    		  var doubles = p._getDoubles();

    		  var naf = getNAF(k, 1, this._bitLength);
    		  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
    		  I /= 3;

    		  // Translate into more windowed form
    		  var repr = [];
    		  var j;
    		  var nafW;
    		  for (j = 0; j < naf.length; j += doubles.step) {
    		    nafW = 0;
    		    for (var l = j + doubles.step - 1; l >= j; l--)
    		      nafW = (nafW << 1) + naf[l];
    		    repr.push(nafW);
    		  }

    		  var a = this.jpoint(null, null, null);
    		  var b = this.jpoint(null, null, null);
    		  for (var i = I; i > 0; i--) {
    		    for (j = 0; j < repr.length; j++) {
    		      nafW = repr[j];
    		      if (nafW === i)
    		        b = b.mixedAdd(doubles.points[j]);
    		      else if (nafW === -i)
    		        b = b.mixedAdd(doubles.points[j].neg());
    		    }
    		    a = a.add(b);
    		  }
    		  return a.toP();
    		};

    		BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    		  var w = 4;

    		  // Precompute window
    		  var nafPoints = p._getNAFPoints(w);
    		  w = nafPoints.wnd;
    		  var wnd = nafPoints.points;

    		  // Get NAF form
    		  var naf = getNAF(k, w, this._bitLength);

    		  // Add `this`*(N+1) for every w-NAF index
    		  var acc = this.jpoint(null, null, null);
    		  for (var i = naf.length - 1; i >= 0; i--) {
    		    // Count zeroes
    		    for (var l = 0; i >= 0 && naf[i] === 0; i--)
    		      l++;
    		    if (i >= 0)
    		      l++;
    		    acc = acc.dblp(l);

    		    if (i < 0)
    		      break;
    		    var z = naf[i];
    		    assert$e(z !== 0);
    		    if (p.type === 'affine') {
    		      // J +- P
    		      if (z > 0)
    		        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
    		      else
    		        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    		    } else {
    		      // J +- J
    		      if (z > 0)
    		        acc = acc.add(wnd[(z - 1) >> 1]);
    		      else
    		        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    		    }
    		  }
    		  return p.type === 'affine' ? acc.toP() : acc;
    		};

    		BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
    		  points,
    		  coeffs,
    		  len,
    		  jacobianResult) {
    		  var wndWidth = this._wnafT1;
    		  var wnd = this._wnafT2;
    		  var naf = this._wnafT3;

    		  // Fill all arrays
    		  var max = 0;
    		  var i;
    		  var j;
    		  var p;
    		  for (i = 0; i < len; i++) {
    		    p = points[i];
    		    var nafPoints = p._getNAFPoints(defW);
    		    wndWidth[i] = nafPoints.wnd;
    		    wnd[i] = nafPoints.points;
    		  }

    		  // Comb small window NAFs
    		  for (i = len - 1; i >= 1; i -= 2) {
    		    var a = i - 1;
    		    var b = i;
    		    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
    		      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
    		      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
    		      max = Math.max(naf[a].length, max);
    		      max = Math.max(naf[b].length, max);
    		      continue;
    		    }

    		    var comb = [
    		      points[a], /* 1 */
    		      null, /* 3 */
    		      null, /* 5 */
    		      points[b], /* 7 */
    		    ];

    		    // Try to avoid Projective points, if possible
    		    if (points[a].y.cmp(points[b].y) === 0) {
    		      comb[1] = points[a].add(points[b]);
    		      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    		    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
    		      comb[1] = points[a].toJ().mixedAdd(points[b]);
    		      comb[2] = points[a].add(points[b].neg());
    		    } else {
    		      comb[1] = points[a].toJ().mixedAdd(points[b]);
    		      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    		    }

    		    var index = [
    		      -3, /* -1 -1 */
    		      -1, /* -1 0 */
    		      -5, /* -1 1 */
    		      -7, /* 0 -1 */
    		      0, /* 0 0 */
    		      7, /* 0 1 */
    		      5, /* 1 -1 */
    		      1, /* 1 0 */
    		      3,  /* 1 1 */
    		    ];

    		    var jsf = getJSF(coeffs[a], coeffs[b]);
    		    max = Math.max(jsf[0].length, max);
    		    naf[a] = new Array(max);
    		    naf[b] = new Array(max);
    		    for (j = 0; j < max; j++) {
    		      var ja = jsf[0][j] | 0;
    		      var jb = jsf[1][j] | 0;

    		      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
    		      naf[b][j] = 0;
    		      wnd[a] = comb;
    		    }
    		  }

    		  var acc = this.jpoint(null, null, null);
    		  var tmp = this._wnafT4;
    		  for (i = max; i >= 0; i--) {
    		    var k = 0;

    		    while (i >= 0) {
    		      var zero = true;
    		      for (j = 0; j < len; j++) {
    		        tmp[j] = naf[j][i] | 0;
    		        if (tmp[j] !== 0)
    		          zero = false;
    		      }
    		      if (!zero)
    		        break;
    		      k++;
    		      i--;
    		    }
    		    if (i >= 0)
    		      k++;
    		    acc = acc.dblp(k);
    		    if (i < 0)
    		      break;

    		    for (j = 0; j < len; j++) {
    		      var z = tmp[j];
    		      if (z === 0)
    		        continue;
    		      else if (z > 0)
    		        p = wnd[j][(z - 1) >> 1];
    		      else if (z < 0)
    		        p = wnd[j][(-z - 1) >> 1].neg();

    		      if (p.type === 'affine')
    		        acc = acc.mixedAdd(p);
    		      else
    		        acc = acc.add(p);
    		    }
    		  }
    		  // Zeroify references
    		  for (i = 0; i < len; i++)
    		    wnd[i] = null;

    		  if (jacobianResult)
    		    return acc;
    		  else
    		    return acc.toP();
    		};

    		function BasePoint(curve, type) {
    		  this.curve = curve;
    		  this.type = type;
    		  this.precomputed = null;
    		}
    		BaseCurve.BasePoint = BasePoint;

    		BasePoint.prototype.eq = function eq(/*other*/) {
    		  throw new Error('Not implemented');
    		};

    		BasePoint.prototype.validate = function validate() {
    		  return this.curve.validate(this);
    		};

    		BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    		  bytes = utils$k.toArray(bytes, enc);

    		  var len = this.p.byteLength();

    		  // uncompressed, hybrid-odd, hybrid-even
    		  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
    		      bytes.length - 1 === 2 * len) {
    		    if (bytes[0] === 0x06)
    		      assert$e(bytes[bytes.length - 1] % 2 === 0);
    		    else if (bytes[0] === 0x07)
    		      assert$e(bytes[bytes.length - 1] % 2 === 1);

    		    var res =  this.point(bytes.slice(1, 1 + len),
    		      bytes.slice(1 + len, 1 + 2 * len));

    		    return res;
    		  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
    		              bytes.length - 1 === len) {
    		    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    		  }
    		  throw new Error('Unknown point format');
    		};

    		BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    		  return this.encode(enc, true);
    		};

    		BasePoint.prototype._encode = function _encode(compact) {
    		  var len = this.curve.p.byteLength();
    		  var x = this.getX().toArray('be', len);

    		  if (compact)
    		    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

    		  return [ 0x04 ].concat(x, this.getY().toArray('be', len));
    		};

    		BasePoint.prototype.encode = function encode(enc, compact) {
    		  return utils$k.encode(this._encode(compact), enc);
    		};

    		BasePoint.prototype.precompute = function precompute(power) {
    		  if (this.precomputed)
    		    return this;

    		  var precomputed = {
    		    doubles: null,
    		    naf: null,
    		    beta: null,
    		  };
    		  precomputed.naf = this._getNAFPoints(8);
    		  precomputed.doubles = this._getDoubles(4, power);
    		  precomputed.beta = this._getBeta();
    		  this.precomputed = precomputed;

    		  return this;
    		};

    		BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    		  if (!this.precomputed)
    		    return false;

    		  var doubles = this.precomputed.doubles;
    		  if (!doubles)
    		    return false;

    		  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
    		};

    		BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    		  if (this.precomputed && this.precomputed.doubles)
    		    return this.precomputed.doubles;

    		  var doubles = [ this ];
    		  var acc = this;
    		  for (var i = 0; i < power; i += step) {
    		    for (var j = 0; j < step; j++)
    		      acc = acc.dbl();
    		    doubles.push(acc);
    		  }
    		  return {
    		    step: step,
    		    points: doubles,
    		  };
    		};

    		BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    		  if (this.precomputed && this.precomputed.naf)
    		    return this.precomputed.naf;

    		  var res = [ this ];
    		  var max = (1 << wnd) - 1;
    		  var dbl = max === 1 ? null : this.dbl();
    		  for (var i = 1; i < max; i++)
    		    res[i] = res[i - 1].add(dbl);
    		  return {
    		    wnd: wnd,
    		    points: res,
    		  };
    		};

    		BasePoint.prototype._getBeta = function _getBeta() {
    		  return null;
    		};

    		BasePoint.prototype.dblp = function dblp(k) {
    		  var r = this;
    		  for (var i = 0; i < k; i++)
    		    r = r.dbl();
    		  return r;
    		};

    		var inherits$f;
    		if (typeof Object.create === 'function'){
    		  inherits$f = function inherits(ctor, superCtor) {
    		    // implementation from standard node.js 'util' module
    		    ctor.super_ = superCtor;
    		    ctor.prototype = Object.create(superCtor.prototype, {
    		      constructor: {
    		        value: ctor,
    		        enumerable: false,
    		        writable: true,
    		        configurable: true
    		      }
    		    });
    		  };
    		} else {
    		  inherits$f = function inherits(ctor, superCtor) {
    		    ctor.super_ = superCtor;
    		    var TempCtor = function () {};
    		    TempCtor.prototype = superCtor.prototype;
    		    ctor.prototype = new TempCtor();
    		    ctor.prototype.constructor = ctor;
    		  };
    		}
    		var inherits$g = inherits$f;

    		var _polyfillNode_inherits = /*#__PURE__*/Object.freeze({
    			__proto__: null,
    			'default': inherits$g
    		});

    		var require$$0$1 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_inherits);

    		var utils$j = utils$m;
    		var BN$6 = bnExports;
    		var inherits$e = require$$0$1;
    		var Base$2 = base;

    		var assert$d = utils$j.assert;

    		function ShortCurve(conf) {
    		  Base$2.call(this, 'short', conf);

    		  this.a = new BN$6(conf.a, 16).toRed(this.red);
    		  this.b = new BN$6(conf.b, 16).toRed(this.red);
    		  this.tinv = this.two.redInvm();

    		  this.zeroA = this.a.fromRed().cmpn(0) === 0;
    		  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

    		  // If the curve is endomorphic, precalculate beta and lambda
    		  this.endo = this._getEndomorphism(conf);
    		  this._endoWnafT1 = new Array(4);
    		  this._endoWnafT2 = new Array(4);
    		}
    		inherits$e(ShortCurve, Base$2);
    		var short = ShortCurve;

    		ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    		  // No efficient endomorphism
    		  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    		    return;

    		  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    		  var beta;
    		  var lambda;
    		  if (conf.beta) {
    		    beta = new BN$6(conf.beta, 16).toRed(this.red);
    		  } else {
    		    var betas = this._getEndoRoots(this.p);
    		    // Choose the smallest beta
    		    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    		    beta = beta.toRed(this.red);
    		  }
    		  if (conf.lambda) {
    		    lambda = new BN$6(conf.lambda, 16);
    		  } else {
    		    // Choose the lambda that is matching selected beta
    		    var lambdas = this._getEndoRoots(this.n);
    		    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
    		      lambda = lambdas[0];
    		    } else {
    		      lambda = lambdas[1];
    		      assert$d(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    		    }
    		  }

    		  // Get basis vectors, used for balanced length-two representation
    		  var basis;
    		  if (conf.basis) {
    		    basis = conf.basis.map(function(vec) {
    		      return {
    		        a: new BN$6(vec.a, 16),
    		        b: new BN$6(vec.b, 16),
    		      };
    		    });
    		  } else {
    		    basis = this._getEndoBasis(lambda);
    		  }

    		  return {
    		    beta: beta,
    		    lambda: lambda,
    		    basis: basis,
    		  };
    		};

    		ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    		  // Find roots of for x^2 + x + 1 in F
    		  // Root = (-1 +- Sqrt(-3)) / 2
    		  //
    		  var red = num === this.p ? this.red : BN$6.mont(num);
    		  var tinv = new BN$6(2).toRed(red).redInvm();
    		  var ntinv = tinv.redNeg();

    		  var s = new BN$6(3).toRed(red).redNeg().redSqrt().redMul(tinv);

    		  var l1 = ntinv.redAdd(s).fromRed();
    		  var l2 = ntinv.redSub(s).fromRed();
    		  return [ l1, l2 ];
    		};

    		ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    		  // aprxSqrt >= sqrt(this.n)
    		  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

    		  // 3.74
    		  // Run EGCD, until r(L + 1) < aprxSqrt
    		  var u = lambda;
    		  var v = this.n.clone();
    		  var x1 = new BN$6(1);
    		  var y1 = new BN$6(0);
    		  var x2 = new BN$6(0);
    		  var y2 = new BN$6(1);

    		  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    		  var a0;
    		  var b0;
    		  // First vector
    		  var a1;
    		  var b1;
    		  // Second vector
    		  var a2;
    		  var b2;

    		  var prevR;
    		  var i = 0;
    		  var r;
    		  var x;
    		  while (u.cmpn(0) !== 0) {
    		    var q = v.div(u);
    		    r = v.sub(q.mul(u));
    		    x = x2.sub(q.mul(x1));
    		    var y = y2.sub(q.mul(y1));

    		    if (!a1 && r.cmp(aprxSqrt) < 0) {
    		      a0 = prevR.neg();
    		      b0 = x1;
    		      a1 = r.neg();
    		      b1 = x;
    		    } else if (a1 && ++i === 2) {
    		      break;
    		    }
    		    prevR = r;

    		    v = u;
    		    u = r;
    		    x2 = x1;
    		    x1 = x;
    		    y2 = y1;
    		    y1 = y;
    		  }
    		  a2 = r.neg();
    		  b2 = x;

    		  var len1 = a1.sqr().add(b1.sqr());
    		  var len2 = a2.sqr().add(b2.sqr());
    		  if (len2.cmp(len1) >= 0) {
    		    a2 = a0;
    		    b2 = b0;
    		  }

    		  // Normalize signs
    		  if (a1.negative) {
    		    a1 = a1.neg();
    		    b1 = b1.neg();
    		  }
    		  if (a2.negative) {
    		    a2 = a2.neg();
    		    b2 = b2.neg();
    		  }

    		  return [
    		    { a: a1, b: b1 },
    		    { a: a2, b: b2 },
    		  ];
    		};

    		ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    		  var basis = this.endo.basis;
    		  var v1 = basis[0];
    		  var v2 = basis[1];

    		  var c1 = v2.b.mul(k).divRound(this.n);
    		  var c2 = v1.b.neg().mul(k).divRound(this.n);

    		  var p1 = c1.mul(v1.a);
    		  var p2 = c2.mul(v2.a);
    		  var q1 = c1.mul(v1.b);
    		  var q2 = c2.mul(v2.b);

    		  // Calculate answer
    		  var k1 = k.sub(p1).sub(p2);
    		  var k2 = q1.add(q2).neg();
    		  return { k1: k1, k2: k2 };
    		};

    		ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    		  x = new BN$6(x, 16);
    		  if (!x.red)
    		    x = x.toRed(this.red);

    		  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    		  var y = y2.redSqrt();
    		  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    		    throw new Error('invalid point');

    		  // XXX Is there any way to tell if the number is odd without converting it
    		  // to non-red form?
    		  var isOdd = y.fromRed().isOdd();
    		  if (odd && !isOdd || !odd && isOdd)
    		    y = y.redNeg();

    		  return this.point(x, y);
    		};

    		ShortCurve.prototype.validate = function validate(point) {
    		  if (point.inf)
    		    return true;

    		  var x = point.x;
    		  var y = point.y;

    		  var ax = this.a.redMul(x);
    		  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    		  return y.redSqr().redISub(rhs).cmpn(0) === 0;
    		};

    		ShortCurve.prototype._endoWnafMulAdd =
    		    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    		      var npoints = this._endoWnafT1;
    		      var ncoeffs = this._endoWnafT2;
    		      for (var i = 0; i < points.length; i++) {
    		        var split = this._endoSplit(coeffs[i]);
    		        var p = points[i];
    		        var beta = p._getBeta();

    		        if (split.k1.negative) {
    		          split.k1.ineg();
    		          p = p.neg(true);
    		        }
    		        if (split.k2.negative) {
    		          split.k2.ineg();
    		          beta = beta.neg(true);
    		        }

    		        npoints[i * 2] = p;
    		        npoints[i * 2 + 1] = beta;
    		        ncoeffs[i * 2] = split.k1;
    		        ncoeffs[i * 2 + 1] = split.k2;
    		      }
    		      var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

    		      // Clean-up references to points and coefficients
    		      for (var j = 0; j < i * 2; j++) {
    		        npoints[j] = null;
    		        ncoeffs[j] = null;
    		      }
    		      return res;
    		    };

    		function Point$2(curve, x, y, isRed) {
    		  Base$2.BasePoint.call(this, curve, 'affine');
    		  if (x === null && y === null) {
    		    this.x = null;
    		    this.y = null;
    		    this.inf = true;
    		  } else {
    		    this.x = new BN$6(x, 16);
    		    this.y = new BN$6(y, 16);
    		    // Force redgomery representation when loading from JSON
    		    if (isRed) {
    		      this.x.forceRed(this.curve.red);
    		      this.y.forceRed(this.curve.red);
    		    }
    		    if (!this.x.red)
    		      this.x = this.x.toRed(this.curve.red);
    		    if (!this.y.red)
    		      this.y = this.y.toRed(this.curve.red);
    		    this.inf = false;
    		  }
    		}
    		inherits$e(Point$2, Base$2.BasePoint);

    		ShortCurve.prototype.point = function point(x, y, isRed) {
    		  return new Point$2(this, x, y, isRed);
    		};

    		ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    		  return Point$2.fromJSON(this, obj, red);
    		};

    		Point$2.prototype._getBeta = function _getBeta() {
    		  if (!this.curve.endo)
    		    return;

    		  var pre = this.precomputed;
    		  if (pre && pre.beta)
    		    return pre.beta;

    		  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    		  if (pre) {
    		    var curve = this.curve;
    		    var endoMul = function(p) {
    		      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    		    };
    		    pre.beta = beta;
    		    beta.precomputed = {
    		      beta: null,
    		      naf: pre.naf && {
    		        wnd: pre.naf.wnd,
    		        points: pre.naf.points.map(endoMul),
    		      },
    		      doubles: pre.doubles && {
    		        step: pre.doubles.step,
    		        points: pre.doubles.points.map(endoMul),
    		      },
    		    };
    		  }
    		  return beta;
    		};

    		Point$2.prototype.toJSON = function toJSON() {
    		  if (!this.precomputed)
    		    return [ this.x, this.y ];

    		  return [ this.x, this.y, this.precomputed && {
    		    doubles: this.precomputed.doubles && {
    		      step: this.precomputed.doubles.step,
    		      points: this.precomputed.doubles.points.slice(1),
    		    },
    		    naf: this.precomputed.naf && {
    		      wnd: this.precomputed.naf.wnd,
    		      points: this.precomputed.naf.points.slice(1),
    		    },
    		  } ];
    		};

    		Point$2.fromJSON = function fromJSON(curve, obj, red) {
    		  if (typeof obj === 'string')
    		    obj = JSON.parse(obj);
    		  var res = curve.point(obj[0], obj[1], red);
    		  if (!obj[2])
    		    return res;

    		  function obj2point(obj) {
    		    return curve.point(obj[0], obj[1], red);
    		  }

    		  var pre = obj[2];
    		  res.precomputed = {
    		    beta: null,
    		    doubles: pre.doubles && {
    		      step: pre.doubles.step,
    		      points: [ res ].concat(pre.doubles.points.map(obj2point)),
    		    },
    		    naf: pre.naf && {
    		      wnd: pre.naf.wnd,
    		      points: [ res ].concat(pre.naf.points.map(obj2point)),
    		    },
    		  };
    		  return res;
    		};

    		Point$2.prototype.inspect = function inspect() {
    		  if (this.isInfinity())
    		    return '<EC Point Infinity>';
    		  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
    		      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
    		};

    		Point$2.prototype.isInfinity = function isInfinity() {
    		  return this.inf;
    		};

    		Point$2.prototype.add = function add(p) {
    		  // O + P = P
    		  if (this.inf)
    		    return p;

    		  // P + O = P
    		  if (p.inf)
    		    return this;

    		  // P + P = 2P
    		  if (this.eq(p))
    		    return this.dbl();

    		  // P + (-P) = O
    		  if (this.neg().eq(p))
    		    return this.curve.point(null, null);

    		  // P + Q = O
    		  if (this.x.cmp(p.x) === 0)
    		    return this.curve.point(null, null);

    		  var c = this.y.redSub(p.y);
    		  if (c.cmpn(0) !== 0)
    		    c = c.redMul(this.x.redSub(p.x).redInvm());
    		  var nx = c.redSqr().redISub(this.x).redISub(p.x);
    		  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    		  return this.curve.point(nx, ny);
    		};

    		Point$2.prototype.dbl = function dbl() {
    		  if (this.inf)
    		    return this;

    		  // 2P = O
    		  var ys1 = this.y.redAdd(this.y);
    		  if (ys1.cmpn(0) === 0)
    		    return this.curve.point(null, null);

    		  var a = this.curve.a;

    		  var x2 = this.x.redSqr();
    		  var dyinv = ys1.redInvm();
    		  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

    		  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    		  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    		  return this.curve.point(nx, ny);
    		};

    		Point$2.prototype.getX = function getX() {
    		  return this.x.fromRed();
    		};

    		Point$2.prototype.getY = function getY() {
    		  return this.y.fromRed();
    		};

    		Point$2.prototype.mul = function mul(k) {
    		  k = new BN$6(k, 16);
    		  if (this.isInfinity())
    		    return this;
    		  else if (this._hasDoubles(k))
    		    return this.curve._fixedNafMul(this, k);
    		  else if (this.curve.endo)
    		    return this.curve._endoWnafMulAdd([ this ], [ k ]);
    		  else
    		    return this.curve._wnafMul(this, k);
    		};

    		Point$2.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    		  var points = [ this, p2 ];
    		  var coeffs = [ k1, k2 ];
    		  if (this.curve.endo)
    		    return this.curve._endoWnafMulAdd(points, coeffs);
    		  else
    		    return this.curve._wnafMulAdd(1, points, coeffs, 2);
    		};

    		Point$2.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    		  var points = [ this, p2 ];
    		  var coeffs = [ k1, k2 ];
    		  if (this.curve.endo)
    		    return this.curve._endoWnafMulAdd(points, coeffs, true);
    		  else
    		    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
    		};

    		Point$2.prototype.eq = function eq(p) {
    		  return this === p ||
    		         this.inf === p.inf &&
    		             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
    		};

    		Point$2.prototype.neg = function neg(_precompute) {
    		  if (this.inf)
    		    return this;

    		  var res = this.curve.point(this.x, this.y.redNeg());
    		  if (_precompute && this.precomputed) {
    		    var pre = this.precomputed;
    		    var negate = function(p) {
    		      return p.neg();
    		    };
    		    res.precomputed = {
    		      naf: pre.naf && {
    		        wnd: pre.naf.wnd,
    		        points: pre.naf.points.map(negate),
    		      },
    		      doubles: pre.doubles && {
    		        step: pre.doubles.step,
    		        points: pre.doubles.points.map(negate),
    		      },
    		    };
    		  }
    		  return res;
    		};

    		Point$2.prototype.toJ = function toJ() {
    		  if (this.inf)
    		    return this.curve.jpoint(null, null, null);

    		  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    		  return res;
    		};

    		function JPoint(curve, x, y, z) {
    		  Base$2.BasePoint.call(this, curve, 'jacobian');
    		  if (x === null && y === null && z === null) {
    		    this.x = this.curve.one;
    		    this.y = this.curve.one;
    		    this.z = new BN$6(0);
    		  } else {
    		    this.x = new BN$6(x, 16);
    		    this.y = new BN$6(y, 16);
    		    this.z = new BN$6(z, 16);
    		  }
    		  if (!this.x.red)
    		    this.x = this.x.toRed(this.curve.red);
    		  if (!this.y.red)
    		    this.y = this.y.toRed(this.curve.red);
    		  if (!this.z.red)
    		    this.z = this.z.toRed(this.curve.red);

    		  this.zOne = this.z === this.curve.one;
    		}
    		inherits$e(JPoint, Base$2.BasePoint);

    		ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    		  return new JPoint(this, x, y, z);
    		};

    		JPoint.prototype.toP = function toP() {
    		  if (this.isInfinity())
    		    return this.curve.point(null, null);

    		  var zinv = this.z.redInvm();
    		  var zinv2 = zinv.redSqr();
    		  var ax = this.x.redMul(zinv2);
    		  var ay = this.y.redMul(zinv2).redMul(zinv);

    		  return this.curve.point(ax, ay);
    		};

    		JPoint.prototype.neg = function neg() {
    		  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
    		};

    		JPoint.prototype.add = function add(p) {
    		  // O + P = P
    		  if (this.isInfinity())
    		    return p;

    		  // P + O = P
    		  if (p.isInfinity())
    		    return this;

    		  // 12M + 4S + 7A
    		  var pz2 = p.z.redSqr();
    		  var z2 = this.z.redSqr();
    		  var u1 = this.x.redMul(pz2);
    		  var u2 = p.x.redMul(z2);
    		  var s1 = this.y.redMul(pz2.redMul(p.z));
    		  var s2 = p.y.redMul(z2.redMul(this.z));

    		  var h = u1.redSub(u2);
    		  var r = s1.redSub(s2);
    		  if (h.cmpn(0) === 0) {
    		    if (r.cmpn(0) !== 0)
    		      return this.curve.jpoint(null, null, null);
    		    else
    		      return this.dbl();
    		  }

    		  var h2 = h.redSqr();
    		  var h3 = h2.redMul(h);
    		  var v = u1.redMul(h2);

    		  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    		  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    		  var nz = this.z.redMul(p.z).redMul(h);

    		  return this.curve.jpoint(nx, ny, nz);
    		};

    		JPoint.prototype.mixedAdd = function mixedAdd(p) {
    		  // O + P = P
    		  if (this.isInfinity())
    		    return p.toJ();

    		  // P + O = P
    		  if (p.isInfinity())
    		    return this;

    		  // 8M + 3S + 7A
    		  var z2 = this.z.redSqr();
    		  var u1 = this.x;
    		  var u2 = p.x.redMul(z2);
    		  var s1 = this.y;
    		  var s2 = p.y.redMul(z2).redMul(this.z);

    		  var h = u1.redSub(u2);
    		  var r = s1.redSub(s2);
    		  if (h.cmpn(0) === 0) {
    		    if (r.cmpn(0) !== 0)
    		      return this.curve.jpoint(null, null, null);
    		    else
    		      return this.dbl();
    		  }

    		  var h2 = h.redSqr();
    		  var h3 = h2.redMul(h);
    		  var v = u1.redMul(h2);

    		  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    		  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    		  var nz = this.z.redMul(h);

    		  return this.curve.jpoint(nx, ny, nz);
    		};

    		JPoint.prototype.dblp = function dblp(pow) {
    		  if (pow === 0)
    		    return this;
    		  if (this.isInfinity())
    		    return this;
    		  if (!pow)
    		    return this.dbl();

    		  var i;
    		  if (this.curve.zeroA || this.curve.threeA) {
    		    var r = this;
    		    for (i = 0; i < pow; i++)
    		      r = r.dbl();
    		    return r;
    		  }

    		  // 1M + 2S + 1A + N * (4S + 5M + 8A)
    		  // N = 1 => 6M + 6S + 9A
    		  var a = this.curve.a;
    		  var tinv = this.curve.tinv;

    		  var jx = this.x;
    		  var jy = this.y;
    		  var jz = this.z;
    		  var jz4 = jz.redSqr().redSqr();

    		  // Reuse results
    		  var jyd = jy.redAdd(jy);
    		  for (i = 0; i < pow; i++) {
    		    var jx2 = jx.redSqr();
    		    var jyd2 = jyd.redSqr();
    		    var jyd4 = jyd2.redSqr();
    		    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    		    var t1 = jx.redMul(jyd2);
    		    var nx = c.redSqr().redISub(t1.redAdd(t1));
    		    var t2 = t1.redISub(nx);
    		    var dny = c.redMul(t2);
    		    dny = dny.redIAdd(dny).redISub(jyd4);
    		    var nz = jyd.redMul(jz);
    		    if (i + 1 < pow)
    		      jz4 = jz4.redMul(jyd4);

    		    jx = nx;
    		    jz = nz;
    		    jyd = dny;
    		  }

    		  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
    		};

    		JPoint.prototype.dbl = function dbl() {
    		  if (this.isInfinity())
    		    return this;

    		  if (this.curve.zeroA)
    		    return this._zeroDbl();
    		  else if (this.curve.threeA)
    		    return this._threeDbl();
    		  else
    		    return this._dbl();
    		};

    		JPoint.prototype._zeroDbl = function _zeroDbl() {
    		  var nx;
    		  var ny;
    		  var nz;
    		  // Z = 1
    		  if (this.zOne) {
    		    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    		    //     #doubling-mdbl-2007-bl
    		    // 1M + 5S + 14A

    		    // XX = X1^2
    		    var xx = this.x.redSqr();
    		    // YY = Y1^2
    		    var yy = this.y.redSqr();
    		    // YYYY = YY^2
    		    var yyyy = yy.redSqr();
    		    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    		    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    		    s = s.redIAdd(s);
    		    // M = 3 * XX + a; a = 0
    		    var m = xx.redAdd(xx).redIAdd(xx);
    		    // T = M ^ 2 - 2*S
    		    var t = m.redSqr().redISub(s).redISub(s);

    		    // 8 * YYYY
    		    var yyyy8 = yyyy.redIAdd(yyyy);
    		    yyyy8 = yyyy8.redIAdd(yyyy8);
    		    yyyy8 = yyyy8.redIAdd(yyyy8);

    		    // X3 = T
    		    nx = t;
    		    // Y3 = M * (S - T) - 8 * YYYY
    		    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    		    // Z3 = 2*Y1
    		    nz = this.y.redAdd(this.y);
    		  } else {
    		    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    		    //     #doubling-dbl-2009-l
    		    // 2M + 5S + 13A

    		    // A = X1^2
    		    var a = this.x.redSqr();
    		    // B = Y1^2
    		    var b = this.y.redSqr();
    		    // C = B^2
    		    var c = b.redSqr();
    		    // D = 2 * ((X1 + B)^2 - A - C)
    		    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    		    d = d.redIAdd(d);
    		    // E = 3 * A
    		    var e = a.redAdd(a).redIAdd(a);
    		    // F = E^2
    		    var f = e.redSqr();

    		    // 8 * C
    		    var c8 = c.redIAdd(c);
    		    c8 = c8.redIAdd(c8);
    		    c8 = c8.redIAdd(c8);

    		    // X3 = F - 2 * D
    		    nx = f.redISub(d).redISub(d);
    		    // Y3 = E * (D - X3) - 8 * C
    		    ny = e.redMul(d.redISub(nx)).redISub(c8);
    		    // Z3 = 2 * Y1 * Z1
    		    nz = this.y.redMul(this.z);
    		    nz = nz.redIAdd(nz);
    		  }

    		  return this.curve.jpoint(nx, ny, nz);
    		};

    		JPoint.prototype._threeDbl = function _threeDbl() {
    		  var nx;
    		  var ny;
    		  var nz;
    		  // Z = 1
    		  if (this.zOne) {
    		    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    		    //     #doubling-mdbl-2007-bl
    		    // 1M + 5S + 15A

    		    // XX = X1^2
    		    var xx = this.x.redSqr();
    		    // YY = Y1^2
    		    var yy = this.y.redSqr();
    		    // YYYY = YY^2
    		    var yyyy = yy.redSqr();
    		    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    		    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    		    s = s.redIAdd(s);
    		    // M = 3 * XX + a
    		    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    		    // T = M^2 - 2 * S
    		    var t = m.redSqr().redISub(s).redISub(s);
    		    // X3 = T
    		    nx = t;
    		    // Y3 = M * (S - T) - 8 * YYYY
    		    var yyyy8 = yyyy.redIAdd(yyyy);
    		    yyyy8 = yyyy8.redIAdd(yyyy8);
    		    yyyy8 = yyyy8.redIAdd(yyyy8);
    		    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    		    // Z3 = 2 * Y1
    		    nz = this.y.redAdd(this.y);
    		  } else {
    		    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    		    // 3M + 5S

    		    // delta = Z1^2
    		    var delta = this.z.redSqr();
    		    // gamma = Y1^2
    		    var gamma = this.y.redSqr();
    		    // beta = X1 * gamma
    		    var beta = this.x.redMul(gamma);
    		    // alpha = 3 * (X1 - delta) * (X1 + delta)
    		    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    		    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    		    // X3 = alpha^2 - 8 * beta
    		    var beta4 = beta.redIAdd(beta);
    		    beta4 = beta4.redIAdd(beta4);
    		    var beta8 = beta4.redAdd(beta4);
    		    nx = alpha.redSqr().redISub(beta8);
    		    // Z3 = (Y1 + Z1)^2 - gamma - delta
    		    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    		    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    		    var ggamma8 = gamma.redSqr();
    		    ggamma8 = ggamma8.redIAdd(ggamma8);
    		    ggamma8 = ggamma8.redIAdd(ggamma8);
    		    ggamma8 = ggamma8.redIAdd(ggamma8);
    		    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    		  }

    		  return this.curve.jpoint(nx, ny, nz);
    		};

    		JPoint.prototype._dbl = function _dbl() {
    		  var a = this.curve.a;

    		  // 4M + 6S + 10A
    		  var jx = this.x;
    		  var jy = this.y;
    		  var jz = this.z;
    		  var jz4 = jz.redSqr().redSqr();

    		  var jx2 = jx.redSqr();
    		  var jy2 = jy.redSqr();

    		  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    		  var jxd4 = jx.redAdd(jx);
    		  jxd4 = jxd4.redIAdd(jxd4);
    		  var t1 = jxd4.redMul(jy2);
    		  var nx = c.redSqr().redISub(t1.redAdd(t1));
    		  var t2 = t1.redISub(nx);

    		  var jyd8 = jy2.redSqr();
    		  jyd8 = jyd8.redIAdd(jyd8);
    		  jyd8 = jyd8.redIAdd(jyd8);
    		  jyd8 = jyd8.redIAdd(jyd8);
    		  var ny = c.redMul(t2).redISub(jyd8);
    		  var nz = jy.redAdd(jy).redMul(jz);

    		  return this.curve.jpoint(nx, ny, nz);
    		};

    		JPoint.prototype.trpl = function trpl() {
    		  if (!this.curve.zeroA)
    		    return this.dbl().add(this);

    		  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    		  // 5M + 10S + ...

    		  // XX = X1^2
    		  var xx = this.x.redSqr();
    		  // YY = Y1^2
    		  var yy = this.y.redSqr();
    		  // ZZ = Z1^2
    		  var zz = this.z.redSqr();
    		  // YYYY = YY^2
    		  var yyyy = yy.redSqr();
    		  // M = 3 * XX + a * ZZ2; a = 0
    		  var m = xx.redAdd(xx).redIAdd(xx);
    		  // MM = M^2
    		  var mm = m.redSqr();
    		  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    		  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    		  e = e.redIAdd(e);
    		  e = e.redAdd(e).redIAdd(e);
    		  e = e.redISub(mm);
    		  // EE = E^2
    		  var ee = e.redSqr();
    		  // T = 16*YYYY
    		  var t = yyyy.redIAdd(yyyy);
    		  t = t.redIAdd(t);
    		  t = t.redIAdd(t);
    		  t = t.redIAdd(t);
    		  // U = (M + E)^2 - MM - EE - T
    		  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    		  // X3 = 4 * (X1 * EE - 4 * YY * U)
    		  var yyu4 = yy.redMul(u);
    		  yyu4 = yyu4.redIAdd(yyu4);
    		  yyu4 = yyu4.redIAdd(yyu4);
    		  var nx = this.x.redMul(ee).redISub(yyu4);
    		  nx = nx.redIAdd(nx);
    		  nx = nx.redIAdd(nx);
    		  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    		  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    		  ny = ny.redIAdd(ny);
    		  ny = ny.redIAdd(ny);
    		  ny = ny.redIAdd(ny);
    		  // Z3 = (Z1 + E)^2 - ZZ - EE
    		  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

    		  return this.curve.jpoint(nx, ny, nz);
    		};

    		JPoint.prototype.mul = function mul(k, kbase) {
    		  k = new BN$6(k, kbase);

    		  return this.curve._wnafMul(this, k);
    		};

    		JPoint.prototype.eq = function eq(p) {
    		  if (p.type === 'affine')
    		    return this.eq(p.toJ());

    		  if (this === p)
    		    return true;

    		  // x1 * z2^2 == x2 * z1^2
    		  var z2 = this.z.redSqr();
    		  var pz2 = p.z.redSqr();
    		  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    		    return false;

    		  // y1 * z2^3 == y2 * z1^3
    		  var z3 = z2.redMul(this.z);
    		  var pz3 = pz2.redMul(p.z);
    		  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
    		};

    		JPoint.prototype.eqXToP = function eqXToP(x) {
    		  var zs = this.z.redSqr();
    		  var rx = x.toRed(this.curve.red).redMul(zs);
    		  if (this.x.cmp(rx) === 0)
    		    return true;

    		  var xc = x.clone();
    		  var t = this.curve.redN.redMul(zs);
    		  for (;;) {
    		    xc.iadd(this.curve.n);
    		    if (xc.cmp(this.curve.p) >= 0)
    		      return false;

    		    rx.redIAdd(t);
    		    if (this.x.cmp(rx) === 0)
    		      return true;
    		  }
    		};

    		JPoint.prototype.inspect = function inspect() {
    		  if (this.isInfinity())
    		    return '<EC JPoint Infinity>';
    		  return '<EC JPoint x: ' + this.x.toString(16, 2) +
    		      ' y: ' + this.y.toString(16, 2) +
    		      ' z: ' + this.z.toString(16, 2) + '>';
    		};

    		JPoint.prototype.isInfinity = function isInfinity() {
    		  // XXX This code assumes that zero is always zero in red
    		  return this.z.cmpn(0) === 0;
    		};

    		var BN$5 = bnExports;
    		var inherits$d = require$$0$1;
    		var Base$1 = base;

    		var utils$i = utils$m;

    		function MontCurve(conf) {
    		  Base$1.call(this, 'mont', conf);

    		  this.a = new BN$5(conf.a, 16).toRed(this.red);
    		  this.b = new BN$5(conf.b, 16).toRed(this.red);
    		  this.i4 = new BN$5(4).toRed(this.red).redInvm();
    		  this.two = new BN$5(2).toRed(this.red);
    		  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
    		}
    		inherits$d(MontCurve, Base$1);
    		var mont = MontCurve;

    		MontCurve.prototype.validate = function validate(point) {
    		  var x = point.normalize().x;
    		  var x2 = x.redSqr();
    		  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    		  var y = rhs.redSqrt();

    		  return y.redSqr().cmp(rhs) === 0;
    		};

    		function Point$1(curve, x, z) {
    		  Base$1.BasePoint.call(this, curve, 'projective');
    		  if (x === null && z === null) {
    		    this.x = this.curve.one;
    		    this.z = this.curve.zero;
    		  } else {
    		    this.x = new BN$5(x, 16);
    		    this.z = new BN$5(z, 16);
    		    if (!this.x.red)
    		      this.x = this.x.toRed(this.curve.red);
    		    if (!this.z.red)
    		      this.z = this.z.toRed(this.curve.red);
    		  }
    		}
    		inherits$d(Point$1, Base$1.BasePoint);

    		MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    		  return this.point(utils$i.toArray(bytes, enc), 1);
    		};

    		MontCurve.prototype.point = function point(x, z) {
    		  return new Point$1(this, x, z);
    		};

    		MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    		  return Point$1.fromJSON(this, obj);
    		};

    		Point$1.prototype.precompute = function precompute() {
    		  // No-op
    		};

    		Point$1.prototype._encode = function _encode() {
    		  return this.getX().toArray('be', this.curve.p.byteLength());
    		};

    		Point$1.fromJSON = function fromJSON(curve, obj) {
    		  return new Point$1(curve, obj[0], obj[1] || curve.one);
    		};

    		Point$1.prototype.inspect = function inspect() {
    		  if (this.isInfinity())
    		    return '<EC Point Infinity>';
    		  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
    		      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
    		};

    		Point$1.prototype.isInfinity = function isInfinity() {
    		  // XXX This code assumes that zero is always zero in red
    		  return this.z.cmpn(0) === 0;
    		};

    		Point$1.prototype.dbl = function dbl() {
    		  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    		  // 2M + 2S + 4A

    		  // A = X1 + Z1
    		  var a = this.x.redAdd(this.z);
    		  // AA = A^2
    		  var aa = a.redSqr();
    		  // B = X1 - Z1
    		  var b = this.x.redSub(this.z);
    		  // BB = B^2
    		  var bb = b.redSqr();
    		  // C = AA - BB
    		  var c = aa.redSub(bb);
    		  // X3 = AA * BB
    		  var nx = aa.redMul(bb);
    		  // Z3 = C * (BB + A24 * C)
    		  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    		  return this.curve.point(nx, nz);
    		};

    		Point$1.prototype.add = function add() {
    		  throw new Error('Not supported on Montgomery curve');
    		};

    		Point$1.prototype.diffAdd = function diffAdd(p, diff) {
    		  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    		  // 4M + 2S + 6A

    		  // A = X2 + Z2
    		  var a = this.x.redAdd(this.z);
    		  // B = X2 - Z2
    		  var b = this.x.redSub(this.z);
    		  // C = X3 + Z3
    		  var c = p.x.redAdd(p.z);
    		  // D = X3 - Z3
    		  var d = p.x.redSub(p.z);
    		  // DA = D * A
    		  var da = d.redMul(a);
    		  // CB = C * B
    		  var cb = c.redMul(b);
    		  // X5 = Z1 * (DA + CB)^2
    		  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    		  // Z5 = X1 * (DA - CB)^2
    		  var nz = diff.x.redMul(da.redISub(cb).redSqr());
    		  return this.curve.point(nx, nz);
    		};

    		Point$1.prototype.mul = function mul(k) {
    		  var t = k.clone();
    		  var a = this; // (N / 2) * Q + Q
    		  var b = this.curve.point(null, null); // (N / 2) * Q
    		  var c = this; // Q

    		  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    		    bits.push(t.andln(1));

    		  for (var i = bits.length - 1; i >= 0; i--) {
    		    if (bits[i] === 0) {
    		      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
    		      a = a.diffAdd(b, c);
    		      // N * Q = 2 * ((N / 2) * Q + Q))
    		      b = b.dbl();
    		    } else {
    		      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
    		      b = a.diffAdd(b, c);
    		      // N * Q + Q = 2 * ((N / 2) * Q + Q)
    		      a = a.dbl();
    		    }
    		  }
    		  return b;
    		};

    		Point$1.prototype.mulAdd = function mulAdd() {
    		  throw new Error('Not supported on Montgomery curve');
    		};

    		Point$1.prototype.jumlAdd = function jumlAdd() {
    		  throw new Error('Not supported on Montgomery curve');
    		};

    		Point$1.prototype.eq = function eq(other) {
    		  return this.getX().cmp(other.getX()) === 0;
    		};

    		Point$1.prototype.normalize = function normalize() {
    		  this.x = this.x.redMul(this.z.redInvm());
    		  this.z = this.curve.one;
    		  return this;
    		};

    		Point$1.prototype.getX = function getX() {
    		  // Normalize coordinates
    		  this.normalize();

    		  return this.x.fromRed();
    		};

    		var utils$h = utils$m;
    		var BN$4 = bnExports;
    		var inherits$c = require$$0$1;
    		var Base = base;

    		var assert$c = utils$h.assert;

    		function EdwardsCurve(conf) {
    		  // NOTE: Important as we are creating point in Base.call()
    		  this.twisted = (conf.a | 0) !== 1;
    		  this.mOneA = this.twisted && (conf.a | 0) === -1;
    		  this.extended = this.mOneA;

    		  Base.call(this, 'edwards', conf);

    		  this.a = new BN$4(conf.a, 16).umod(this.red.m);
    		  this.a = this.a.toRed(this.red);
    		  this.c = new BN$4(conf.c, 16).toRed(this.red);
    		  this.c2 = this.c.redSqr();
    		  this.d = new BN$4(conf.d, 16).toRed(this.red);
    		  this.dd = this.d.redAdd(this.d);

    		  assert$c(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    		  this.oneC = (conf.c | 0) === 1;
    		}
    		inherits$c(EdwardsCurve, Base);
    		var edwards = EdwardsCurve;

    		EdwardsCurve.prototype._mulA = function _mulA(num) {
    		  if (this.mOneA)
    		    return num.redNeg();
    		  else
    		    return this.a.redMul(num);
    		};

    		EdwardsCurve.prototype._mulC = function _mulC(num) {
    		  if (this.oneC)
    		    return num;
    		  else
    		    return this.c.redMul(num);
    		};

    		// Just for compatibility with Short curve
    		EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    		  return this.point(x, y, z, t);
    		};

    		EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    		  x = new BN$4(x, 16);
    		  if (!x.red)
    		    x = x.toRed(this.red);

    		  var x2 = x.redSqr();
    		  var rhs = this.c2.redSub(this.a.redMul(x2));
    		  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

    		  var y2 = rhs.redMul(lhs.redInvm());
    		  var y = y2.redSqrt();
    		  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    		    throw new Error('invalid point');

    		  var isOdd = y.fromRed().isOdd();
    		  if (odd && !isOdd || !odd && isOdd)
    		    y = y.redNeg();

    		  return this.point(x, y);
    		};

    		EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    		  y = new BN$4(y, 16);
    		  if (!y.red)
    		    y = y.toRed(this.red);

    		  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    		  var y2 = y.redSqr();
    		  var lhs = y2.redSub(this.c2);
    		  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    		  var x2 = lhs.redMul(rhs.redInvm());

    		  if (x2.cmp(this.zero) === 0) {
    		    if (odd)
    		      throw new Error('invalid point');
    		    else
    		      return this.point(this.zero, y);
    		  }

    		  var x = x2.redSqrt();
    		  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    		    throw new Error('invalid point');

    		  if (x.fromRed().isOdd() !== odd)
    		    x = x.redNeg();

    		  return this.point(x, y);
    		};

    		EdwardsCurve.prototype.validate = function validate(point) {
    		  if (point.isInfinity())
    		    return true;

    		  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    		  point.normalize();

    		  var x2 = point.x.redSqr();
    		  var y2 = point.y.redSqr();
    		  var lhs = x2.redMul(this.a).redAdd(y2);
    		  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

    		  return lhs.cmp(rhs) === 0;
    		};

    		function Point(curve, x, y, z, t) {
    		  Base.BasePoint.call(this, curve, 'projective');
    		  if (x === null && y === null && z === null) {
    		    this.x = this.curve.zero;
    		    this.y = this.curve.one;
    		    this.z = this.curve.one;
    		    this.t = this.curve.zero;
    		    this.zOne = true;
    		  } else {
    		    this.x = new BN$4(x, 16);
    		    this.y = new BN$4(y, 16);
    		    this.z = z ? new BN$4(z, 16) : this.curve.one;
    		    this.t = t && new BN$4(t, 16);
    		    if (!this.x.red)
    		      this.x = this.x.toRed(this.curve.red);
    		    if (!this.y.red)
    		      this.y = this.y.toRed(this.curve.red);
    		    if (!this.z.red)
    		      this.z = this.z.toRed(this.curve.red);
    		    if (this.t && !this.t.red)
    		      this.t = this.t.toRed(this.curve.red);
    		    this.zOne = this.z === this.curve.one;

    		    // Use extended coordinates
    		    if (this.curve.extended && !this.t) {
    		      this.t = this.x.redMul(this.y);
    		      if (!this.zOne)
    		        this.t = this.t.redMul(this.z.redInvm());
    		    }
    		  }
    		}
    		inherits$c(Point, Base.BasePoint);

    		EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    		  return Point.fromJSON(this, obj);
    		};

    		EdwardsCurve.prototype.point = function point(x, y, z, t) {
    		  return new Point(this, x, y, z, t);
    		};

    		Point.fromJSON = function fromJSON(curve, obj) {
    		  return new Point(curve, obj[0], obj[1], obj[2]);
    		};

    		Point.prototype.inspect = function inspect() {
    		  if (this.isInfinity())
    		    return '<EC Point Infinity>';
    		  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
    		      ' y: ' + this.y.fromRed().toString(16, 2) +
    		      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
    		};

    		Point.prototype.isInfinity = function isInfinity() {
    		  // XXX This code assumes that zero is always zero in red
    		  return this.x.cmpn(0) === 0 &&
    		    (this.y.cmp(this.z) === 0 ||
    		    (this.zOne && this.y.cmp(this.curve.c) === 0));
    		};

    		Point.prototype._extDbl = function _extDbl() {
    		  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    		  //     #doubling-dbl-2008-hwcd
    		  // 4M + 4S

    		  // A = X1^2
    		  var a = this.x.redSqr();
    		  // B = Y1^2
    		  var b = this.y.redSqr();
    		  // C = 2 * Z1^2
    		  var c = this.z.redSqr();
    		  c = c.redIAdd(c);
    		  // D = a * A
    		  var d = this.curve._mulA(a);
    		  // E = (X1 + Y1)^2 - A - B
    		  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    		  // G = D + B
    		  var g = d.redAdd(b);
    		  // F = G - C
    		  var f = g.redSub(c);
    		  // H = D - B
    		  var h = d.redSub(b);
    		  // X3 = E * F
    		  var nx = e.redMul(f);
    		  // Y3 = G * H
    		  var ny = g.redMul(h);
    		  // T3 = E * H
    		  var nt = e.redMul(h);
    		  // Z3 = F * G
    		  var nz = f.redMul(g);
    		  return this.curve.point(nx, ny, nz, nt);
    		};

    		Point.prototype._projDbl = function _projDbl() {
    		  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    		  //     #doubling-dbl-2008-bbjlp
    		  //     #doubling-dbl-2007-bl
    		  // and others
    		  // Generally 3M + 4S or 2M + 4S

    		  // B = (X1 + Y1)^2
    		  var b = this.x.redAdd(this.y).redSqr();
    		  // C = X1^2
    		  var c = this.x.redSqr();
    		  // D = Y1^2
    		  var d = this.y.redSqr();

    		  var nx;
    		  var ny;
    		  var nz;
    		  var e;
    		  var h;
    		  var j;
    		  if (this.curve.twisted) {
    		    // E = a * C
    		    e = this.curve._mulA(c);
    		    // F = E + D
    		    var f = e.redAdd(d);
    		    if (this.zOne) {
    		      // X3 = (B - C - D) * (F - 2)
    		      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
    		      // Y3 = F * (E - D)
    		      ny = f.redMul(e.redSub(d));
    		      // Z3 = F^2 - 2 * F
    		      nz = f.redSqr().redSub(f).redSub(f);
    		    } else {
    		      // H = Z1^2
    		      h = this.z.redSqr();
    		      // J = F - 2 * H
    		      j = f.redSub(h).redISub(h);
    		      // X3 = (B-C-D)*J
    		      nx = b.redSub(c).redISub(d).redMul(j);
    		      // Y3 = F * (E - D)
    		      ny = f.redMul(e.redSub(d));
    		      // Z3 = F * J
    		      nz = f.redMul(j);
    		    }
    		  } else {
    		    // E = C + D
    		    e = c.redAdd(d);
    		    // H = (c * Z1)^2
    		    h = this.curve._mulC(this.z).redSqr();
    		    // J = E - 2 * H
    		    j = e.redSub(h).redSub(h);
    		    // X3 = c * (B - E) * J
    		    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    		    // Y3 = c * E * (C - D)
    		    ny = this.curve._mulC(e).redMul(c.redISub(d));
    		    // Z3 = E * J
    		    nz = e.redMul(j);
    		  }
    		  return this.curve.point(nx, ny, nz);
    		};

    		Point.prototype.dbl = function dbl() {
    		  if (this.isInfinity())
    		    return this;

    		  // Double in extended coordinates
    		  if (this.curve.extended)
    		    return this._extDbl();
    		  else
    		    return this._projDbl();
    		};

    		Point.prototype._extAdd = function _extAdd(p) {
    		  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    		  //     #addition-add-2008-hwcd-3
    		  // 8M

    		  // A = (Y1 - X1) * (Y2 - X2)
    		  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    		  // B = (Y1 + X1) * (Y2 + X2)
    		  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    		  // C = T1 * k * T2
    		  var c = this.t.redMul(this.curve.dd).redMul(p.t);
    		  // D = Z1 * 2 * Z2
    		  var d = this.z.redMul(p.z.redAdd(p.z));
    		  // E = B - A
    		  var e = b.redSub(a);
    		  // F = D - C
    		  var f = d.redSub(c);
    		  // G = D + C
    		  var g = d.redAdd(c);
    		  // H = B + A
    		  var h = b.redAdd(a);
    		  // X3 = E * F
    		  var nx = e.redMul(f);
    		  // Y3 = G * H
    		  var ny = g.redMul(h);
    		  // T3 = E * H
    		  var nt = e.redMul(h);
    		  // Z3 = F * G
    		  var nz = f.redMul(g);
    		  return this.curve.point(nx, ny, nz, nt);
    		};

    		Point.prototype._projAdd = function _projAdd(p) {
    		  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    		  //     #addition-add-2008-bbjlp
    		  //     #addition-add-2007-bl
    		  // 10M + 1S

    		  // A = Z1 * Z2
    		  var a = this.z.redMul(p.z);
    		  // B = A^2
    		  var b = a.redSqr();
    		  // C = X1 * X2
    		  var c = this.x.redMul(p.x);
    		  // D = Y1 * Y2
    		  var d = this.y.redMul(p.y);
    		  // E = d * C * D
    		  var e = this.curve.d.redMul(c).redMul(d);
    		  // F = B - E
    		  var f = b.redSub(e);
    		  // G = B + E
    		  var g = b.redAdd(e);
    		  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    		  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    		  var nx = a.redMul(f).redMul(tmp);
    		  var ny;
    		  var nz;
    		  if (this.curve.twisted) {
    		    // Y3 = A * G * (D - a * C)
    		    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    		    // Z3 = F * G
    		    nz = f.redMul(g);
    		  } else {
    		    // Y3 = A * G * (D - C)
    		    ny = a.redMul(g).redMul(d.redSub(c));
    		    // Z3 = c * F * G
    		    nz = this.curve._mulC(f).redMul(g);
    		  }
    		  return this.curve.point(nx, ny, nz);
    		};

    		Point.prototype.add = function add(p) {
    		  if (this.isInfinity())
    		    return p;
    		  if (p.isInfinity())
    		    return this;

    		  if (this.curve.extended)
    		    return this._extAdd(p);
    		  else
    		    return this._projAdd(p);
    		};

    		Point.prototype.mul = function mul(k) {
    		  if (this._hasDoubles(k))
    		    return this.curve._fixedNafMul(this, k);
    		  else
    		    return this.curve._wnafMul(this, k);
    		};

    		Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    		  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
    		};

    		Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    		  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
    		};

    		Point.prototype.normalize = function normalize() {
    		  if (this.zOne)
    		    return this;

    		  // Normalize coordinates
    		  var zi = this.z.redInvm();
    		  this.x = this.x.redMul(zi);
    		  this.y = this.y.redMul(zi);
    		  if (this.t)
    		    this.t = this.t.redMul(zi);
    		  this.z = this.curve.one;
    		  this.zOne = true;
    		  return this;
    		};

    		Point.prototype.neg = function neg() {
    		  return this.curve.point(this.x.redNeg(),
    		    this.y,
    		    this.z,
    		    this.t && this.t.redNeg());
    		};

    		Point.prototype.getX = function getX() {
    		  this.normalize();
    		  return this.x.fromRed();
    		};

    		Point.prototype.getY = function getY() {
    		  this.normalize();
    		  return this.y.fromRed();
    		};

    		Point.prototype.eq = function eq(other) {
    		  return this === other ||
    		         this.getX().cmp(other.getX()) === 0 &&
    		         this.getY().cmp(other.getY()) === 0;
    		};

    		Point.prototype.eqXToP = function eqXToP(x) {
    		  var rx = x.toRed(this.curve.red).redMul(this.z);
    		  if (this.x.cmp(rx) === 0)
    		    return true;

    		  var xc = x.clone();
    		  var t = this.curve.redN.redMul(this.z);
    		  for (;;) {
    		    xc.iadd(this.curve.n);
    		    if (xc.cmp(this.curve.p) >= 0)
    		      return false;

    		    rx.redIAdd(t);
    		    if (this.x.cmp(rx) === 0)
    		      return true;
    		  }
    		};

    		// Compatibility with BaseCurve
    		Point.prototype.toP = Point.prototype.normalize;
    		Point.prototype.mixedAdd = Point.prototype.add;

    		(function (exports) {

    			var curve = exports;

    			curve.base = base;
    			curve.short = short;
    			curve.mont = mont;
    			curve.edwards = edwards; 
    		} (curve$1));

    		var curves$2 = {};

    		var hash$4 = {};

    		var utils$g = {};

    		var assert$b = minimalisticAssert;
    		var inherits$b = require$$0$1;

    		utils$g.inherits = inherits$b;

    		function isSurrogatePair(msg, i) {
    		  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    		    return false;
    		  }
    		  if (i < 0 || i + 1 >= msg.length) {
    		    return false;
    		  }
    		  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
    		}

    		function toArray(msg, enc) {
    		  if (Array.isArray(msg))
    		    return msg.slice();
    		  if (!msg)
    		    return [];
    		  var res = [];
    		  if (typeof msg === 'string') {
    		    if (!enc) {
    		      // Inspired by stringToUtf8ByteArray() in closure-library by Google
    		      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
    		      // Apache License 2.0
    		      // https://github.com/google/closure-library/blob/master/LICENSE
    		      var p = 0;
    		      for (var i = 0; i < msg.length; i++) {
    		        var c = msg.charCodeAt(i);
    		        if (c < 128) {
    		          res[p++] = c;
    		        } else if (c < 2048) {
    		          res[p++] = (c >> 6) | 192;
    		          res[p++] = (c & 63) | 128;
    		        } else if (isSurrogatePair(msg, i)) {
    		          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
    		          res[p++] = (c >> 18) | 240;
    		          res[p++] = ((c >> 12) & 63) | 128;
    		          res[p++] = ((c >> 6) & 63) | 128;
    		          res[p++] = (c & 63) | 128;
    		        } else {
    		          res[p++] = (c >> 12) | 224;
    		          res[p++] = ((c >> 6) & 63) | 128;
    		          res[p++] = (c & 63) | 128;
    		        }
    		      }
    		    } else if (enc === 'hex') {
    		      msg = msg.replace(/[^a-z0-9]+/ig, '');
    		      if (msg.length % 2 !== 0)
    		        msg = '0' + msg;
    		      for (i = 0; i < msg.length; i += 2)
    		        res.push(parseInt(msg[i] + msg[i + 1], 16));
    		    }
    		  } else {
    		    for (i = 0; i < msg.length; i++)
    		      res[i] = msg[i] | 0;
    		  }
    		  return res;
    		}
    		utils$g.toArray = toArray;

    		function toHex(msg) {
    		  var res = '';
    		  for (var i = 0; i < msg.length; i++)
    		    res += zero2(msg[i].toString(16));
    		  return res;
    		}
    		utils$g.toHex = toHex;

    		function htonl(w) {
    		  var res = (w >>> 24) |
    		            ((w >>> 8) & 0xff00) |
    		            ((w << 8) & 0xff0000) |
    		            ((w & 0xff) << 24);
    		  return res >>> 0;
    		}
    		utils$g.htonl = htonl;

    		function toHex32(msg, endian) {
    		  var res = '';
    		  for (var i = 0; i < msg.length; i++) {
    		    var w = msg[i];
    		    if (endian === 'little')
    		      w = htonl(w);
    		    res += zero8(w.toString(16));
    		  }
    		  return res;
    		}
    		utils$g.toHex32 = toHex32;

    		function zero2(word) {
    		  if (word.length === 1)
    		    return '0' + word;
    		  else
    		    return word;
    		}
    		utils$g.zero2 = zero2;

    		function zero8(word) {
    		  if (word.length === 7)
    		    return '0' + word;
    		  else if (word.length === 6)
    		    return '00' + word;
    		  else if (word.length === 5)
    		    return '000' + word;
    		  else if (word.length === 4)
    		    return '0000' + word;
    		  else if (word.length === 3)
    		    return '00000' + word;
    		  else if (word.length === 2)
    		    return '000000' + word;
    		  else if (word.length === 1)
    		    return '0000000' + word;
    		  else
    		    return word;
    		}
    		utils$g.zero8 = zero8;

    		function join32(msg, start, end, endian) {
    		  var len = end - start;
    		  assert$b(len % 4 === 0);
    		  var res = new Array(len / 4);
    		  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    		    var w;
    		    if (endian === 'big')
    		      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    		    else
    		      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    		    res[i] = w >>> 0;
    		  }
    		  return res;
    		}
    		utils$g.join32 = join32;

    		function split32(msg, endian) {
    		  var res = new Array(msg.length * 4);
    		  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    		    var m = msg[i];
    		    if (endian === 'big') {
    		      res[k] = m >>> 24;
    		      res[k + 1] = (m >>> 16) & 0xff;
    		      res[k + 2] = (m >>> 8) & 0xff;
    		      res[k + 3] = m & 0xff;
    		    } else {
    		      res[k + 3] = m >>> 24;
    		      res[k + 2] = (m >>> 16) & 0xff;
    		      res[k + 1] = (m >>> 8) & 0xff;
    		      res[k] = m & 0xff;
    		    }
    		  }
    		  return res;
    		}
    		utils$g.split32 = split32;

    		function rotr32$1(w, b) {
    		  return (w >>> b) | (w << (32 - b));
    		}
    		utils$g.rotr32 = rotr32$1;

    		function rotl32$2(w, b) {
    		  return (w << b) | (w >>> (32 - b));
    		}
    		utils$g.rotl32 = rotl32$2;

    		function sum32$3(a, b) {
    		  return (a + b) >>> 0;
    		}
    		utils$g.sum32 = sum32$3;

    		function sum32_3$1(a, b, c) {
    		  return (a + b + c) >>> 0;
    		}
    		utils$g.sum32_3 = sum32_3$1;

    		function sum32_4$2(a, b, c, d) {
    		  return (a + b + c + d) >>> 0;
    		}
    		utils$g.sum32_4 = sum32_4$2;

    		function sum32_5$2(a, b, c, d, e) {
    		  return (a + b + c + d + e) >>> 0;
    		}
    		utils$g.sum32_5 = sum32_5$2;

    		function sum64$1(buf, pos, ah, al) {
    		  var bh = buf[pos];
    		  var bl = buf[pos + 1];

    		  var lo = (al + bl) >>> 0;
    		  var hi = (lo < al ? 1 : 0) + ah + bh;
    		  buf[pos] = hi >>> 0;
    		  buf[pos + 1] = lo;
    		}
    		utils$g.sum64 = sum64$1;

    		function sum64_hi$1(ah, al, bh, bl) {
    		  var lo = (al + bl) >>> 0;
    		  var hi = (lo < al ? 1 : 0) + ah + bh;
    		  return hi >>> 0;
    		}
    		utils$g.sum64_hi = sum64_hi$1;

    		function sum64_lo$1(ah, al, bh, bl) {
    		  var lo = al + bl;
    		  return lo >>> 0;
    		}
    		utils$g.sum64_lo = sum64_lo$1;

    		function sum64_4_hi$1(ah, al, bh, bl, ch, cl, dh, dl) {
    		  var carry = 0;
    		  var lo = al;
    		  lo = (lo + bl) >>> 0;
    		  carry += lo < al ? 1 : 0;
    		  lo = (lo + cl) >>> 0;
    		  carry += lo < cl ? 1 : 0;
    		  lo = (lo + dl) >>> 0;
    		  carry += lo < dl ? 1 : 0;

    		  var hi = ah + bh + ch + dh + carry;
    		  return hi >>> 0;
    		}
    		utils$g.sum64_4_hi = sum64_4_hi$1;

    		function sum64_4_lo$1(ah, al, bh, bl, ch, cl, dh, dl) {
    		  var lo = al + bl + cl + dl;
    		  return lo >>> 0;
    		}
    		utils$g.sum64_4_lo = sum64_4_lo$1;

    		function sum64_5_hi$1(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    		  var carry = 0;
    		  var lo = al;
    		  lo = (lo + bl) >>> 0;
    		  carry += lo < al ? 1 : 0;
    		  lo = (lo + cl) >>> 0;
    		  carry += lo < cl ? 1 : 0;
    		  lo = (lo + dl) >>> 0;
    		  carry += lo < dl ? 1 : 0;
    		  lo = (lo + el) >>> 0;
    		  carry += lo < el ? 1 : 0;

    		  var hi = ah + bh + ch + dh + eh + carry;
    		  return hi >>> 0;
    		}
    		utils$g.sum64_5_hi = sum64_5_hi$1;

    		function sum64_5_lo$1(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    		  var lo = al + bl + cl + dl + el;

    		  return lo >>> 0;
    		}
    		utils$g.sum64_5_lo = sum64_5_lo$1;

    		function rotr64_hi$1(ah, al, num) {
    		  var r = (al << (32 - num)) | (ah >>> num);
    		  return r >>> 0;
    		}
    		utils$g.rotr64_hi = rotr64_hi$1;

    		function rotr64_lo$1(ah, al, num) {
    		  var r = (ah << (32 - num)) | (al >>> num);
    		  return r >>> 0;
    		}
    		utils$g.rotr64_lo = rotr64_lo$1;

    		function shr64_hi$1(ah, al, num) {
    		  return ah >>> num;
    		}
    		utils$g.shr64_hi = shr64_hi$1;

    		function shr64_lo$1(ah, al, num) {
    		  var r = (ah << (32 - num)) | (al >>> num);
    		  return r >>> 0;
    		}
    		utils$g.shr64_lo = shr64_lo$1;

    		var common$5 = {};

    		var utils$f = utils$g;
    		var assert$a = minimalisticAssert;

    		function BlockHash$4() {
    		  this.pending = null;
    		  this.pendingTotal = 0;
    		  this.blockSize = this.constructor.blockSize;
    		  this.outSize = this.constructor.outSize;
    		  this.hmacStrength = this.constructor.hmacStrength;
    		  this.padLength = this.constructor.padLength / 8;
    		  this.endian = 'big';

    		  this._delta8 = this.blockSize / 8;
    		  this._delta32 = this.blockSize / 32;
    		}
    		common$5.BlockHash = BlockHash$4;

    		BlockHash$4.prototype.update = function update(msg, enc) {
    		  // Convert message to array, pad it, and join into 32bit blocks
    		  msg = utils$f.toArray(msg, enc);
    		  if (!this.pending)
    		    this.pending = msg;
    		  else
    		    this.pending = this.pending.concat(msg);
    		  this.pendingTotal += msg.length;

    		  // Enough data, try updating
    		  if (this.pending.length >= this._delta8) {
    		    msg = this.pending;

    		    // Process pending data in blocks
    		    var r = msg.length % this._delta8;
    		    this.pending = msg.slice(msg.length - r, msg.length);
    		    if (this.pending.length === 0)
    		      this.pending = null;

    		    msg = utils$f.join32(msg, 0, msg.length - r, this.endian);
    		    for (var i = 0; i < msg.length; i += this._delta32)
    		      this._update(msg, i, i + this._delta32);
    		  }

    		  return this;
    		};

    		BlockHash$4.prototype.digest = function digest(enc) {
    		  this.update(this._pad());
    		  assert$a(this.pending === null);

    		  return this._digest(enc);
    		};

    		BlockHash$4.prototype._pad = function pad() {
    		  var len = this.pendingTotal;
    		  var bytes = this._delta8;
    		  var k = bytes - ((len + this.padLength) % bytes);
    		  var res = new Array(k + this.padLength);
    		  res[0] = 0x80;
    		  for (var i = 1; i < k; i++)
    		    res[i] = 0;

    		  // Append length
    		  len <<= 3;
    		  if (this.endian === 'big') {
    		    for (var t = 8; t < this.padLength; t++)
    		      res[i++] = 0;

    		    res[i++] = 0;
    		    res[i++] = 0;
    		    res[i++] = 0;
    		    res[i++] = 0;
    		    res[i++] = (len >>> 24) & 0xff;
    		    res[i++] = (len >>> 16) & 0xff;
    		    res[i++] = (len >>> 8) & 0xff;
    		    res[i++] = len & 0xff;
    		  } else {
    		    res[i++] = len & 0xff;
    		    res[i++] = (len >>> 8) & 0xff;
    		    res[i++] = (len >>> 16) & 0xff;
    		    res[i++] = (len >>> 24) & 0xff;
    		    res[i++] = 0;
    		    res[i++] = 0;
    		    res[i++] = 0;
    		    res[i++] = 0;

    		    for (t = 8; t < this.padLength; t++)
    		      res[i++] = 0;
    		  }

    		  return res;
    		};

    		var sha$2 = {};

    		var common$4 = {};

    		var utils$e = utils$g;
    		var rotr32 = utils$e.rotr32;

    		function ft_1$1(s, x, y, z) {
    		  if (s === 0)
    		    return ch32$1(x, y, z);
    		  if (s === 1 || s === 3)
    		    return p32(x, y, z);
    		  if (s === 2)
    		    return maj32$1(x, y, z);
    		}
    		common$4.ft_1 = ft_1$1;

    		function ch32$1(x, y, z) {
    		  return (x & y) ^ ((~x) & z);
    		}
    		common$4.ch32 = ch32$1;

    		function maj32$1(x, y, z) {
    		  return (x & y) ^ (x & z) ^ (y & z);
    		}
    		common$4.maj32 = maj32$1;

    		function p32(x, y, z) {
    		  return x ^ y ^ z;
    		}
    		common$4.p32 = p32;

    		function s0_256$1(x) {
    		  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
    		}
    		common$4.s0_256 = s0_256$1;

    		function s1_256$1(x) {
    		  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
    		}
    		common$4.s1_256 = s1_256$1;

    		function g0_256$1(x) {
    		  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
    		}
    		common$4.g0_256 = g0_256$1;

    		function g1_256$1(x) {
    		  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
    		}
    		common$4.g1_256 = g1_256$1;

    		var utils$d = utils$g;
    		var common$3 = common$5;
    		var shaCommon$1 = common$4;

    		var rotl32$1 = utils$d.rotl32;
    		var sum32$2 = utils$d.sum32;
    		var sum32_5$1 = utils$d.sum32_5;
    		var ft_1 = shaCommon$1.ft_1;
    		var BlockHash$3 = common$3.BlockHash;

    		var sha1_K = [
    		  0x5A827999, 0x6ED9EBA1,
    		  0x8F1BBCDC, 0xCA62C1D6
    		];

    		function SHA1() {
    		  if (!(this instanceof SHA1))
    		    return new SHA1();

    		  BlockHash$3.call(this);
    		  this.h = [
    		    0x67452301, 0xefcdab89, 0x98badcfe,
    		    0x10325476, 0xc3d2e1f0 ];
    		  this.W = new Array(80);
    		}

    		utils$d.inherits(SHA1, BlockHash$3);
    		var _1 = SHA1;

    		SHA1.blockSize = 512;
    		SHA1.outSize = 160;
    		SHA1.hmacStrength = 80;
    		SHA1.padLength = 64;

    		SHA1.prototype._update = function _update(msg, start) {
    		  var W = this.W;

    		  for (var i = 0; i < 16; i++)
    		    W[i] = msg[start + i];

    		  for(; i < W.length; i++)
    		    W[i] = rotl32$1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

    		  var a = this.h[0];
    		  var b = this.h[1];
    		  var c = this.h[2];
    		  var d = this.h[3];
    		  var e = this.h[4];

    		  for (i = 0; i < W.length; i++) {
    		    var s = ~~(i / 20);
    		    var t = sum32_5$1(rotl32$1(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    		    e = d;
    		    d = c;
    		    c = rotl32$1(b, 30);
    		    b = a;
    		    a = t;
    		  }

    		  this.h[0] = sum32$2(this.h[0], a);
    		  this.h[1] = sum32$2(this.h[1], b);
    		  this.h[2] = sum32$2(this.h[2], c);
    		  this.h[3] = sum32$2(this.h[3], d);
    		  this.h[4] = sum32$2(this.h[4], e);
    		};

    		SHA1.prototype._digest = function digest(enc) {
    		  if (enc === 'hex')
    		    return utils$d.toHex32(this.h, 'big');
    		  else
    		    return utils$d.split32(this.h, 'big');
    		};

    		var utils$c = utils$g;
    		var common$2 = common$5;
    		var shaCommon = common$4;
    		var assert$9 = minimalisticAssert;

    		var sum32$1 = utils$c.sum32;
    		var sum32_4$1 = utils$c.sum32_4;
    		var sum32_5 = utils$c.sum32_5;
    		var ch32 = shaCommon.ch32;
    		var maj32 = shaCommon.maj32;
    		var s0_256 = shaCommon.s0_256;
    		var s1_256 = shaCommon.s1_256;
    		var g0_256 = shaCommon.g0_256;
    		var g1_256 = shaCommon.g1_256;

    		var BlockHash$2 = common$2.BlockHash;

    		var sha256_K = [
    		  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
    		  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    		  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
    		  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    		  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
    		  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    		  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
    		  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    		  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
    		  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    		  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
    		  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    		  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
    		  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    		  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
    		  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
    		];

    		function SHA256$1() {
    		  if (!(this instanceof SHA256$1))
    		    return new SHA256$1();

    		  BlockHash$2.call(this);
    		  this.h = [
    		    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    		    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
    		  ];
    		  this.k = sha256_K;
    		  this.W = new Array(64);
    		}
    		utils$c.inherits(SHA256$1, BlockHash$2);
    		var _256 = SHA256$1;

    		SHA256$1.blockSize = 512;
    		SHA256$1.outSize = 256;
    		SHA256$1.hmacStrength = 192;
    		SHA256$1.padLength = 64;

    		SHA256$1.prototype._update = function _update(msg, start) {
    		  var W = this.W;

    		  for (var i = 0; i < 16; i++)
    		    W[i] = msg[start + i];
    		  for (; i < W.length; i++)
    		    W[i] = sum32_4$1(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

    		  var a = this.h[0];
    		  var b = this.h[1];
    		  var c = this.h[2];
    		  var d = this.h[3];
    		  var e = this.h[4];
    		  var f = this.h[5];
    		  var g = this.h[6];
    		  var h = this.h[7];

    		  assert$9(this.k.length === W.length);
    		  for (i = 0; i < W.length; i++) {
    		    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    		    var T2 = sum32$1(s0_256(a), maj32(a, b, c));
    		    h = g;
    		    g = f;
    		    f = e;
    		    e = sum32$1(d, T1);
    		    d = c;
    		    c = b;
    		    b = a;
    		    a = sum32$1(T1, T2);
    		  }

    		  this.h[0] = sum32$1(this.h[0], a);
    		  this.h[1] = sum32$1(this.h[1], b);
    		  this.h[2] = sum32$1(this.h[2], c);
    		  this.h[3] = sum32$1(this.h[3], d);
    		  this.h[4] = sum32$1(this.h[4], e);
    		  this.h[5] = sum32$1(this.h[5], f);
    		  this.h[6] = sum32$1(this.h[6], g);
    		  this.h[7] = sum32$1(this.h[7], h);
    		};

    		SHA256$1.prototype._digest = function digest(enc) {
    		  if (enc === 'hex')
    		    return utils$c.toHex32(this.h, 'big');
    		  else
    		    return utils$c.split32(this.h, 'big');
    		};

    		var utils$b = utils$g;
    		var SHA256 = _256;

    		function SHA224() {
    		  if (!(this instanceof SHA224))
    		    return new SHA224();

    		  SHA256.call(this);
    		  this.h = [
    		    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    		    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
    		}
    		utils$b.inherits(SHA224, SHA256);
    		var _224 = SHA224;

    		SHA224.blockSize = 512;
    		SHA224.outSize = 224;
    		SHA224.hmacStrength = 192;
    		SHA224.padLength = 64;

    		SHA224.prototype._digest = function digest(enc) {
    		  // Just truncate output
    		  if (enc === 'hex')
    		    return utils$b.toHex32(this.h.slice(0, 7), 'big');
    		  else
    		    return utils$b.split32(this.h.slice(0, 7), 'big');
    		};

    		var utils$a = utils$g;
    		var common$1 = common$5;
    		var assert$8 = minimalisticAssert;

    		var rotr64_hi = utils$a.rotr64_hi;
    		var rotr64_lo = utils$a.rotr64_lo;
    		var shr64_hi = utils$a.shr64_hi;
    		var shr64_lo = utils$a.shr64_lo;
    		var sum64 = utils$a.sum64;
    		var sum64_hi = utils$a.sum64_hi;
    		var sum64_lo = utils$a.sum64_lo;
    		var sum64_4_hi = utils$a.sum64_4_hi;
    		var sum64_4_lo = utils$a.sum64_4_lo;
    		var sum64_5_hi = utils$a.sum64_5_hi;
    		var sum64_5_lo = utils$a.sum64_5_lo;

    		var BlockHash$1 = common$1.BlockHash;

    		var sha512_K = [
    		  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
    		  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
    		  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
    		  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
    		  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
    		  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
    		  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
    		  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
    		  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
    		  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
    		  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
    		  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
    		  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
    		  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
    		  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
    		  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
    		  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
    		  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
    		  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
    		  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
    		  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
    		  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
    		  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
    		  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
    		  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
    		  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
    		  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
    		  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
    		  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
    		  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
    		  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
    		  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
    		  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
    		  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
    		  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
    		  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
    		  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
    		  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
    		  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
    		  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
    		];

    		function SHA512$2() {
    		  if (!(this instanceof SHA512$2))
    		    return new SHA512$2();

    		  BlockHash$1.call(this);
    		  this.h = [
    		    0x6a09e667, 0xf3bcc908,
    		    0xbb67ae85, 0x84caa73b,
    		    0x3c6ef372, 0xfe94f82b,
    		    0xa54ff53a, 0x5f1d36f1,
    		    0x510e527f, 0xade682d1,
    		    0x9b05688c, 0x2b3e6c1f,
    		    0x1f83d9ab, 0xfb41bd6b,
    		    0x5be0cd19, 0x137e2179 ];
    		  this.k = sha512_K;
    		  this.W = new Array(160);
    		}
    		utils$a.inherits(SHA512$2, BlockHash$1);
    		var _512 = SHA512$2;

    		SHA512$2.blockSize = 1024;
    		SHA512$2.outSize = 512;
    		SHA512$2.hmacStrength = 192;
    		SHA512$2.padLength = 128;

    		SHA512$2.prototype._prepareBlock = function _prepareBlock(msg, start) {
    		  var W = this.W;

    		  // 32 x 32bit words
    		  for (var i = 0; i < 32; i++)
    		    W[i] = msg[start + i];
    		  for (; i < W.length; i += 2) {
    		    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    		    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    		    var c1_hi = W[i - 14];  // i - 7
    		    var c1_lo = W[i - 13];
    		    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    		    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    		    var c3_hi = W[i - 32];  // i - 16
    		    var c3_lo = W[i - 31];

    		    W[i] = sum64_4_hi(
    		      c0_hi, c0_lo,
    		      c1_hi, c1_lo,
    		      c2_hi, c2_lo,
    		      c3_hi, c3_lo);
    		    W[i + 1] = sum64_4_lo(
    		      c0_hi, c0_lo,
    		      c1_hi, c1_lo,
    		      c2_hi, c2_lo,
    		      c3_hi, c3_lo);
    		  }
    		};

    		SHA512$2.prototype._update = function _update(msg, start) {
    		  this._prepareBlock(msg, start);

    		  var W = this.W;

    		  var ah = this.h[0];
    		  var al = this.h[1];
    		  var bh = this.h[2];
    		  var bl = this.h[3];
    		  var ch = this.h[4];
    		  var cl = this.h[5];
    		  var dh = this.h[6];
    		  var dl = this.h[7];
    		  var eh = this.h[8];
    		  var el = this.h[9];
    		  var fh = this.h[10];
    		  var fl = this.h[11];
    		  var gh = this.h[12];
    		  var gl = this.h[13];
    		  var hh = this.h[14];
    		  var hl = this.h[15];

    		  assert$8(this.k.length === W.length);
    		  for (var i = 0; i < W.length; i += 2) {
    		    var c0_hi = hh;
    		    var c0_lo = hl;
    		    var c1_hi = s1_512_hi(eh, el);
    		    var c1_lo = s1_512_lo(eh, el);
    		    var c2_hi = ch64_hi(eh, el, fh, fl, gh);
    		    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    		    var c3_hi = this.k[i];
    		    var c3_lo = this.k[i + 1];
    		    var c4_hi = W[i];
    		    var c4_lo = W[i + 1];

    		    var T1_hi = sum64_5_hi(
    		      c0_hi, c0_lo,
    		      c1_hi, c1_lo,
    		      c2_hi, c2_lo,
    		      c3_hi, c3_lo,
    		      c4_hi, c4_lo);
    		    var T1_lo = sum64_5_lo(
    		      c0_hi, c0_lo,
    		      c1_hi, c1_lo,
    		      c2_hi, c2_lo,
    		      c3_hi, c3_lo,
    		      c4_hi, c4_lo);

    		    c0_hi = s0_512_hi(ah, al);
    		    c0_lo = s0_512_lo(ah, al);
    		    c1_hi = maj64_hi(ah, al, bh, bl, ch);
    		    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    		    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    		    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    		    hh = gh;
    		    hl = gl;

    		    gh = fh;
    		    gl = fl;

    		    fh = eh;
    		    fl = el;

    		    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    		    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    		    dh = ch;
    		    dl = cl;

    		    ch = bh;
    		    cl = bl;

    		    bh = ah;
    		    bl = al;

    		    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    		    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    		  }

    		  sum64(this.h, 0, ah, al);
    		  sum64(this.h, 2, bh, bl);
    		  sum64(this.h, 4, ch, cl);
    		  sum64(this.h, 6, dh, dl);
    		  sum64(this.h, 8, eh, el);
    		  sum64(this.h, 10, fh, fl);
    		  sum64(this.h, 12, gh, gl);
    		  sum64(this.h, 14, hh, hl);
    		};

    		SHA512$2.prototype._digest = function digest(enc) {
    		  if (enc === 'hex')
    		    return utils$a.toHex32(this.h, 'big');
    		  else
    		    return utils$a.split32(this.h, 'big');
    		};

    		function ch64_hi(xh, xl, yh, yl, zh) {
    		  var r = (xh & yh) ^ ((~xh) & zh);
    		  if (r < 0)
    		    r += 0x100000000;
    		  return r;
    		}

    		function ch64_lo(xh, xl, yh, yl, zh, zl) {
    		  var r = (xl & yl) ^ ((~xl) & zl);
    		  if (r < 0)
    		    r += 0x100000000;
    		  return r;
    		}

    		function maj64_hi(xh, xl, yh, yl, zh) {
    		  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
    		  if (r < 0)
    		    r += 0x100000000;
    		  return r;
    		}

    		function maj64_lo(xh, xl, yh, yl, zh, zl) {
    		  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
    		  if (r < 0)
    		    r += 0x100000000;
    		  return r;
    		}

    		function s0_512_hi(xh, xl) {
    		  var c0_hi = rotr64_hi(xh, xl, 28);
    		  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
    		  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

    		  var r = c0_hi ^ c1_hi ^ c2_hi;
    		  if (r < 0)
    		    r += 0x100000000;
    		  return r;
    		}

    		function s0_512_lo(xh, xl) {
    		  var c0_lo = rotr64_lo(xh, xl, 28);
    		  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
    		  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

    		  var r = c0_lo ^ c1_lo ^ c2_lo;
    		  if (r < 0)
    		    r += 0x100000000;
    		  return r;
    		}

    		function s1_512_hi(xh, xl) {
    		  var c0_hi = rotr64_hi(xh, xl, 14);
    		  var c1_hi = rotr64_hi(xh, xl, 18);
    		  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

    		  var r = c0_hi ^ c1_hi ^ c2_hi;
    		  if (r < 0)
    		    r += 0x100000000;
    		  return r;
    		}

    		function s1_512_lo(xh, xl) {
    		  var c0_lo = rotr64_lo(xh, xl, 14);
    		  var c1_lo = rotr64_lo(xh, xl, 18);
    		  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

    		  var r = c0_lo ^ c1_lo ^ c2_lo;
    		  if (r < 0)
    		    r += 0x100000000;
    		  return r;
    		}

    		function g0_512_hi(xh, xl) {
    		  var c0_hi = rotr64_hi(xh, xl, 1);
    		  var c1_hi = rotr64_hi(xh, xl, 8);
    		  var c2_hi = shr64_hi(xh, xl, 7);

    		  var r = c0_hi ^ c1_hi ^ c2_hi;
    		  if (r < 0)
    		    r += 0x100000000;
    		  return r;
    		}

    		function g0_512_lo(xh, xl) {
    		  var c0_lo = rotr64_lo(xh, xl, 1);
    		  var c1_lo = rotr64_lo(xh, xl, 8);
    		  var c2_lo = shr64_lo(xh, xl, 7);

    		  var r = c0_lo ^ c1_lo ^ c2_lo;
    		  if (r < 0)
    		    r += 0x100000000;
    		  return r;
    		}

    		function g1_512_hi(xh, xl) {
    		  var c0_hi = rotr64_hi(xh, xl, 19);
    		  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
    		  var c2_hi = shr64_hi(xh, xl, 6);

    		  var r = c0_hi ^ c1_hi ^ c2_hi;
    		  if (r < 0)
    		    r += 0x100000000;
    		  return r;
    		}

    		function g1_512_lo(xh, xl) {
    		  var c0_lo = rotr64_lo(xh, xl, 19);
    		  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
    		  var c2_lo = shr64_lo(xh, xl, 6);

    		  var r = c0_lo ^ c1_lo ^ c2_lo;
    		  if (r < 0)
    		    r += 0x100000000;
    		  return r;
    		}

    		var utils$9 = utils$g;

    		var SHA512$1 = _512;

    		function SHA384() {
    		  if (!(this instanceof SHA384))
    		    return new SHA384();

    		  SHA512$1.call(this);
    		  this.h = [
    		    0xcbbb9d5d, 0xc1059ed8,
    		    0x629a292a, 0x367cd507,
    		    0x9159015a, 0x3070dd17,
    		    0x152fecd8, 0xf70e5939,
    		    0x67332667, 0xffc00b31,
    		    0x8eb44a87, 0x68581511,
    		    0xdb0c2e0d, 0x64f98fa7,
    		    0x47b5481d, 0xbefa4fa4 ];
    		}
    		utils$9.inherits(SHA384, SHA512$1);
    		var _384 = SHA384;

    		SHA384.blockSize = 1024;
    		SHA384.outSize = 384;
    		SHA384.hmacStrength = 192;
    		SHA384.padLength = 128;

    		SHA384.prototype._digest = function digest(enc) {
    		  if (enc === 'hex')
    		    return utils$9.toHex32(this.h.slice(0, 12), 'big');
    		  else
    		    return utils$9.split32(this.h.slice(0, 12), 'big');
    		};

    		sha$2.sha1 = _1;
    		sha$2.sha224 = _224;
    		sha$2.sha256 = _256;
    		sha$2.sha384 = _384;
    		sha$2.sha512 = _512;

    		var ripemd = {};

    		var utils$8 = utils$g;
    		var common = common$5;

    		var rotl32 = utils$8.rotl32;
    		var sum32 = utils$8.sum32;
    		var sum32_3 = utils$8.sum32_3;
    		var sum32_4 = utils$8.sum32_4;
    		var BlockHash = common.BlockHash;

    		function RIPEMD160$2() {
    		  if (!(this instanceof RIPEMD160$2))
    		    return new RIPEMD160$2();

    		  BlockHash.call(this);

    		  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
    		  this.endian = 'little';
    		}
    		utils$8.inherits(RIPEMD160$2, BlockHash);
    		ripemd.ripemd160 = RIPEMD160$2;

    		RIPEMD160$2.blockSize = 512;
    		RIPEMD160$2.outSize = 160;
    		RIPEMD160$2.hmacStrength = 192;
    		RIPEMD160$2.padLength = 64;

    		RIPEMD160$2.prototype._update = function update(msg, start) {
    		  var A = this.h[0];
    		  var B = this.h[1];
    		  var C = this.h[2];
    		  var D = this.h[3];
    		  var E = this.h[4];
    		  var Ah = A;
    		  var Bh = B;
    		  var Ch = C;
    		  var Dh = D;
    		  var Eh = E;
    		  for (var j = 0; j < 80; j++) {
    		    var T = sum32(
    		      rotl32(
    		        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K$4(j)),
    		        s[j]),
    		      E);
    		    A = E;
    		    E = D;
    		    D = rotl32(C, 10);
    		    C = B;
    		    B = T;
    		    T = sum32(
    		      rotl32(
    		        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
    		        sh[j]),
    		      Eh);
    		    Ah = Eh;
    		    Eh = Dh;
    		    Dh = rotl32(Ch, 10);
    		    Ch = Bh;
    		    Bh = T;
    		  }
    		  T = sum32_3(this.h[1], C, Dh);
    		  this.h[1] = sum32_3(this.h[2], D, Eh);
    		  this.h[2] = sum32_3(this.h[3], E, Ah);
    		  this.h[3] = sum32_3(this.h[4], A, Bh);
    		  this.h[4] = sum32_3(this.h[0], B, Ch);
    		  this.h[0] = T;
    		};

    		RIPEMD160$2.prototype._digest = function digest(enc) {
    		  if (enc === 'hex')
    		    return utils$8.toHex32(this.h, 'little');
    		  else
    		    return utils$8.split32(this.h, 'little');
    		};

    		function f(j, x, y, z) {
    		  if (j <= 15)
    		    return x ^ y ^ z;
    		  else if (j <= 31)
    		    return (x & y) | ((~x) & z);
    		  else if (j <= 47)
    		    return (x | (~y)) ^ z;
    		  else if (j <= 63)
    		    return (x & z) | (y & (~z));
    		  else
    		    return x ^ (y | (~z));
    		}

    		function K$4(j) {
    		  if (j <= 15)
    		    return 0x00000000;
    		  else if (j <= 31)
    		    return 0x5a827999;
    		  else if (j <= 47)
    		    return 0x6ed9eba1;
    		  else if (j <= 63)
    		    return 0x8f1bbcdc;
    		  else
    		    return 0xa953fd4e;
    		}

    		function Kh(j) {
    		  if (j <= 15)
    		    return 0x50a28be6;
    		  else if (j <= 31)
    		    return 0x5c4dd124;
    		  else if (j <= 47)
    		    return 0x6d703ef3;
    		  else if (j <= 63)
    		    return 0x7a6d76e9;
    		  else
    		    return 0x00000000;
    		}

    		var r = [
    		  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    		  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
    		  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
    		  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
    		  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
    		];

    		var rh = [
    		  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
    		  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
    		  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
    		  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
    		  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
    		];

    		var s = [
    		  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
    		  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
    		  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
    		  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
    		  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
    		];

    		var sh = [
    		  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
    		  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
    		  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
    		  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
    		  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
    		];

    		var utils$7 = utils$g;
    		var assert$7 = minimalisticAssert;

    		function Hmac$1(hash, key, enc) {
    		  if (!(this instanceof Hmac$1))
    		    return new Hmac$1(hash, key, enc);
    		  this.Hash = hash;
    		  this.blockSize = hash.blockSize / 8;
    		  this.outSize = hash.outSize / 8;
    		  this.inner = null;
    		  this.outer = null;

    		  this._init(utils$7.toArray(key, enc));
    		}
    		var hmac$1 = Hmac$1;

    		Hmac$1.prototype._init = function init(key) {
    		  // Shorten key, if needed
    		  if (key.length > this.blockSize)
    		    key = new this.Hash().update(key).digest();
    		  assert$7(key.length <= this.blockSize);

    		  // Add padding to key
    		  for (var i = key.length; i < this.blockSize; i++)
    		    key.push(0);

    		  for (i = 0; i < key.length; i++)
    		    key[i] ^= 0x36;
    		  this.inner = new this.Hash().update(key);

    		  // 0x36 ^ 0x5c = 0x6a
    		  for (i = 0; i < key.length; i++)
    		    key[i] ^= 0x6a;
    		  this.outer = new this.Hash().update(key);
    		};

    		Hmac$1.prototype.update = function update(msg, enc) {
    		  this.inner.update(msg, enc);
    		  return this;
    		};

    		Hmac$1.prototype.digest = function digest(enc) {
    		  this.outer.update(this.inner.digest());
    		  return this.outer.digest(enc);
    		};

    		(function (exports) {
    			var hash = exports;

    			hash.utils = utils$g;
    			hash.common = common$5;
    			hash.sha = sha$2;
    			hash.ripemd = ripemd;
    			hash.hmac = hmac$1;

    			// Proxy hash functions to the main object
    			hash.sha1 = hash.sha.sha1;
    			hash.sha256 = hash.sha.sha256;
    			hash.sha224 = hash.sha.sha224;
    			hash.sha384 = hash.sha.sha384;
    			hash.sha512 = hash.sha.sha512;
    			hash.ripemd160 = hash.ripemd.ripemd160; 
    		} (hash$4));

    		var hashjs = /*@__PURE__*/getDefaultExportFromCjs(hash$4);

    		var secp256k1$2;
    		var hasRequiredSecp256k1;

    		function requireSecp256k1 () {
    			if (hasRequiredSecp256k1) return secp256k1$2;
    			hasRequiredSecp256k1 = 1;
    			secp256k1$2 = {
    			  doubles: {
    			    step: 4,
    			    points: [
    			      [
    			        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
    			        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821',
    			      ],
    			      [
    			        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
    			        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf',
    			      ],
    			      [
    			        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
    			        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695',
    			      ],
    			      [
    			        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
    			        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9',
    			      ],
    			      [
    			        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
    			        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36',
    			      ],
    			      [
    			        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
    			        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f',
    			      ],
    			      [
    			        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
    			        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999',
    			      ],
    			      [
    			        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
    			        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09',
    			      ],
    			      [
    			        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
    			        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d',
    			      ],
    			      [
    			        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
    			        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088',
    			      ],
    			      [
    			        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
    			        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d',
    			      ],
    			      [
    			        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
    			        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8',
    			      ],
    			      [
    			        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
    			        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a',
    			      ],
    			      [
    			        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
    			        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453',
    			      ],
    			      [
    			        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
    			        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160',
    			      ],
    			      [
    			        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
    			        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0',
    			      ],
    			      [
    			        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
    			        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6',
    			      ],
    			      [
    			        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
    			        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589',
    			      ],
    			      [
    			        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
    			        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17',
    			      ],
    			      [
    			        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
    			        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda',
    			      ],
    			      [
    			        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
    			        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd',
    			      ],
    			      [
    			        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
    			        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2',
    			      ],
    			      [
    			        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
    			        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6',
    			      ],
    			      [
    			        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
    			        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f',
    			      ],
    			      [
    			        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
    			        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01',
    			      ],
    			      [
    			        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
    			        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3',
    			      ],
    			      [
    			        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
    			        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f',
    			      ],
    			      [
    			        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
    			        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7',
    			      ],
    			      [
    			        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
    			        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78',
    			      ],
    			      [
    			        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
    			        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1',
    			      ],
    			      [
    			        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
    			        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150',
    			      ],
    			      [
    			        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
    			        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82',
    			      ],
    			      [
    			        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
    			        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc',
    			      ],
    			      [
    			        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
    			        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b',
    			      ],
    			      [
    			        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
    			        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51',
    			      ],
    			      [
    			        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
    			        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45',
    			      ],
    			      [
    			        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
    			        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120',
    			      ],
    			      [
    			        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
    			        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84',
    			      ],
    			      [
    			        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
    			        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d',
    			      ],
    			      [
    			        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
    			        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d',
    			      ],
    			      [
    			        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
    			        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8',
    			      ],
    			      [
    			        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
    			        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8',
    			      ],
    			      [
    			        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
    			        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac',
    			      ],
    			      [
    			        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
    			        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f',
    			      ],
    			      [
    			        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
    			        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962',
    			      ],
    			      [
    			        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
    			        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907',
    			      ],
    			      [
    			        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
    			        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec',
    			      ],
    			      [
    			        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
    			        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d',
    			      ],
    			      [
    			        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
    			        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414',
    			      ],
    			      [
    			        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
    			        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd',
    			      ],
    			      [
    			        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
    			        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0',
    			      ],
    			      [
    			        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
    			        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811',
    			      ],
    			      [
    			        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
    			        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1',
    			      ],
    			      [
    			        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
    			        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c',
    			      ],
    			      [
    			        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
    			        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73',
    			      ],
    			      [
    			        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
    			        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd',
    			      ],
    			      [
    			        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
    			        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405',
    			      ],
    			      [
    			        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
    			        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589',
    			      ],
    			      [
    			        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
    			        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e',
    			      ],
    			      [
    			        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
    			        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27',
    			      ],
    			      [
    			        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
    			        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1',
    			      ],
    			      [
    			        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
    			        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482',
    			      ],
    			      [
    			        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
    			        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945',
    			      ],
    			      [
    			        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
    			        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573',
    			      ],
    			      [
    			        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
    			        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82',
    			      ],
    			    ],
    			  },
    			  naf: {
    			    wnd: 7,
    			    points: [
    			      [
    			        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
    			        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672',
    			      ],
    			      [
    			        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
    			        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6',
    			      ],
    			      [
    			        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
    			        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da',
    			      ],
    			      [
    			        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
    			        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37',
    			      ],
    			      [
    			        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
    			        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b',
    			      ],
    			      [
    			        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
    			        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81',
    			      ],
    			      [
    			        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
    			        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58',
    			      ],
    			      [
    			        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
    			        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77',
    			      ],
    			      [
    			        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
    			        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a',
    			      ],
    			      [
    			        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
    			        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c',
    			      ],
    			      [
    			        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
    			        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67',
    			      ],
    			      [
    			        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
    			        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402',
    			      ],
    			      [
    			        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
    			        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55',
    			      ],
    			      [
    			        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
    			        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482',
    			      ],
    			      [
    			        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
    			        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82',
    			      ],
    			      [
    			        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
    			        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396',
    			      ],
    			      [
    			        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
    			        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49',
    			      ],
    			      [
    			        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
    			        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf',
    			      ],
    			      [
    			        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
    			        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a',
    			      ],
    			      [
    			        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
    			        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7',
    			      ],
    			      [
    			        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
    			        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933',
    			      ],
    			      [
    			        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
    			        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a',
    			      ],
    			      [
    			        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
    			        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6',
    			      ],
    			      [
    			        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
    			        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37',
    			      ],
    			      [
    			        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
    			        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e',
    			      ],
    			      [
    			        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
    			        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6',
    			      ],
    			      [
    			        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
    			        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476',
    			      ],
    			      [
    			        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
    			        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40',
    			      ],
    			      [
    			        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
    			        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61',
    			      ],
    			      [
    			        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
    			        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683',
    			      ],
    			      [
    			        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
    			        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5',
    			      ],
    			      [
    			        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
    			        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b',
    			      ],
    			      [
    			        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
    			        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417',
    			      ],
    			      [
    			        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
    			        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868',
    			      ],
    			      [
    			        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
    			        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a',
    			      ],
    			      [
    			        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
    			        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6',
    			      ],
    			      [
    			        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
    			        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996',
    			      ],
    			      [
    			        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
    			        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e',
    			      ],
    			      [
    			        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
    			        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d',
    			      ],
    			      [
    			        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
    			        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2',
    			      ],
    			      [
    			        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
    			        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e',
    			      ],
    			      [
    			        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
    			        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437',
    			      ],
    			      [
    			        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
    			        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311',
    			      ],
    			      [
    			        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
    			        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4',
    			      ],
    			      [
    			        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
    			        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575',
    			      ],
    			      [
    			        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
    			        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d',
    			      ],
    			      [
    			        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
    			        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d',
    			      ],
    			      [
    			        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
    			        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629',
    			      ],
    			      [
    			        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
    			        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06',
    			      ],
    			      [
    			        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
    			        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374',
    			      ],
    			      [
    			        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
    			        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee',
    			      ],
    			      [
    			        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
    			        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1',
    			      ],
    			      [
    			        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
    			        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b',
    			      ],
    			      [
    			        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
    			        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661',
    			      ],
    			      [
    			        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
    			        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6',
    			      ],
    			      [
    			        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
    			        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e',
    			      ],
    			      [
    			        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
    			        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d',
    			      ],
    			      [
    			        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
    			        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc',
    			      ],
    			      [
    			        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
    			        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4',
    			      ],
    			      [
    			        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
    			        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c',
    			      ],
    			      [
    			        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
    			        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b',
    			      ],
    			      [
    			        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
    			        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913',
    			      ],
    			      [
    			        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
    			        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154',
    			      ],
    			      [
    			        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
    			        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865',
    			      ],
    			      [
    			        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
    			        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc',
    			      ],
    			      [
    			        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
    			        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224',
    			      ],
    			      [
    			        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
    			        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e',
    			      ],
    			      [
    			        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
    			        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6',
    			      ],
    			      [
    			        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
    			        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511',
    			      ],
    			      [
    			        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
    			        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b',
    			      ],
    			      [
    			        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
    			        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2',
    			      ],
    			      [
    			        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
    			        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c',
    			      ],
    			      [
    			        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
    			        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3',
    			      ],
    			      [
    			        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
    			        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d',
    			      ],
    			      [
    			        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
    			        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700',
    			      ],
    			      [
    			        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
    			        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4',
    			      ],
    			      [
    			        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
    			        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196',
    			      ],
    			      [
    			        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
    			        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4',
    			      ],
    			      [
    			        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
    			        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257',
    			      ],
    			      [
    			        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
    			        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13',
    			      ],
    			      [
    			        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
    			        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096',
    			      ],
    			      [
    			        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
    			        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38',
    			      ],
    			      [
    			        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
    			        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f',
    			      ],
    			      [
    			        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
    			        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448',
    			      ],
    			      [
    			        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
    			        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a',
    			      ],
    			      [
    			        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
    			        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4',
    			      ],
    			      [
    			        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
    			        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437',
    			      ],
    			      [
    			        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
    			        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7',
    			      ],
    			      [
    			        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
    			        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d',
    			      ],
    			      [
    			        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
    			        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a',
    			      ],
    			      [
    			        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
    			        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54',
    			      ],
    			      [
    			        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
    			        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77',
    			      ],
    			      [
    			        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
    			        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517',
    			      ],
    			      [
    			        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
    			        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10',
    			      ],
    			      [
    			        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
    			        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125',
    			      ],
    			      [
    			        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
    			        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e',
    			      ],
    			      [
    			        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
    			        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1',
    			      ],
    			      [
    			        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
    			        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2',
    			      ],
    			      [
    			        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
    			        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423',
    			      ],
    			      [
    			        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
    			        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8',
    			      ],
    			      [
    			        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
    			        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758',
    			      ],
    			      [
    			        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
    			        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375',
    			      ],
    			      [
    			        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
    			        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d',
    			      ],
    			      [
    			        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
    			        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec',
    			      ],
    			      [
    			        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
    			        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0',
    			      ],
    			      [
    			        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
    			        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c',
    			      ],
    			      [
    			        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
    			        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4',
    			      ],
    			      [
    			        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
    			        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f',
    			      ],
    			      [
    			        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
    			        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649',
    			      ],
    			      [
    			        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
    			        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826',
    			      ],
    			      [
    			        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
    			        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5',
    			      ],
    			      [
    			        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
    			        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87',
    			      ],
    			      [
    			        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
    			        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b',
    			      ],
    			      [
    			        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
    			        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc',
    			      ],
    			      [
    			        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
    			        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c',
    			      ],
    			      [
    			        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
    			        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f',
    			      ],
    			      [
    			        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
    			        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a',
    			      ],
    			      [
    			        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
    			        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46',
    			      ],
    			      [
    			        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
    			        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f',
    			      ],
    			      [
    			        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
    			        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03',
    			      ],
    			      [
    			        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
    			        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08',
    			      ],
    			      [
    			        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
    			        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8',
    			      ],
    			      [
    			        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
    			        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373',
    			      ],
    			      [
    			        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
    			        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3',
    			      ],
    			      [
    			        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
    			        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8',
    			      ],
    			      [
    			        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
    			        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1',
    			      ],
    			      [
    			        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
    			        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9',
    			      ],
    			    ],
    			  },
    			};
    			return secp256k1$2;
    		}

    		(function (exports) {

    			var curves = exports;

    			var hash = hash$4;
    			var curve = curve$1;
    			var utils = utils$m;

    			var assert = utils.assert;

    			function PresetCurve(options) {
    			  if (options.type === 'short')
    			    this.curve = new curve.short(options);
    			  else if (options.type === 'edwards')
    			    this.curve = new curve.edwards(options);
    			  else
    			    this.curve = new curve.mont(options);
    			  this.g = this.curve.g;
    			  this.n = this.curve.n;
    			  this.hash = options.hash;

    			  assert(this.g.validate(), 'Invalid curve');
    			  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
    			}
    			curves.PresetCurve = PresetCurve;

    			function defineCurve(name, options) {
    			  Object.defineProperty(curves, name, {
    			    configurable: true,
    			    enumerable: true,
    			    get: function() {
    			      var curve = new PresetCurve(options);
    			      Object.defineProperty(curves, name, {
    			        configurable: true,
    			        enumerable: true,
    			        value: curve,
    			      });
    			      return curve;
    			    },
    			  });
    			}

    			defineCurve('p192', {
    			  type: 'short',
    			  prime: 'p192',
    			  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    			  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    			  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    			  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    			  hash: hash.sha256,
    			  gRed: false,
    			  g: [
    			    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    			    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
    			  ],
    			});

    			defineCurve('p224', {
    			  type: 'short',
    			  prime: 'p224',
    			  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    			  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    			  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    			  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    			  hash: hash.sha256,
    			  gRed: false,
    			  g: [
    			    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    			    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
    			  ],
    			});

    			defineCurve('p256', {
    			  type: 'short',
    			  prime: null,
    			  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    			  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    			  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    			  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    			  hash: hash.sha256,
    			  gRed: false,
    			  g: [
    			    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    			    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
    			  ],
    			});

    			defineCurve('p384', {
    			  type: 'short',
    			  prime: null,
    			  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
    			     'fffffffe ffffffff 00000000 00000000 ffffffff',
    			  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
    			     'fffffffe ffffffff 00000000 00000000 fffffffc',
    			  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
    			     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
    			  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
    			     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
    			  hash: hash.sha384,
    			  gRed: false,
    			  g: [
    			    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    			    '5502f25d bf55296c 3a545e38 72760ab7',
    			    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    			    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
    			  ],
    			});

    			defineCurve('p521', {
    			  type: 'short',
    			  prime: null,
    			  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
    			     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
    			     'ffffffff ffffffff ffffffff ffffffff ffffffff',
    			  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
    			     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
    			     'ffffffff ffffffff ffffffff ffffffff fffffffc',
    			  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
    			     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
    			     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
    			  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
    			     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
    			     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
    			  hash: hash.sha512,
    			  gRed: false,
    			  g: [
    			    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    			    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    			    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    			    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    			    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    			    '3fad0761 353c7086 a272c240 88be9476 9fd16650',
    			  ],
    			});

    			defineCurve('curve25519', {
    			  type: 'mont',
    			  prime: 'p25519',
    			  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    			  a: '76d06',
    			  b: '1',
    			  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    			  hash: hash.sha256,
    			  gRed: false,
    			  g: [
    			    '9',
    			  ],
    			});

    			defineCurve('ed25519', {
    			  type: 'edwards',
    			  prime: 'p25519',
    			  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    			  a: '-1',
    			  c: '1',
    			  // -121665 * (121666^(-1)) (mod P)
    			  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    			  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    			  hash: hash.sha256,
    			  gRed: false,
    			  g: [
    			    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    			    // 4/5
    			    '6666666666666666666666666666666666666666666666666666666666666658',
    			  ],
    			});

    			var pre;
    			try {
    			  pre = requireSecp256k1();
    			} catch (e) {
    			  pre = undefined;
    			}

    			defineCurve('secp256k1', {
    			  type: 'short',
    			  prime: 'k256',
    			  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    			  a: '0',
    			  b: '7',
    			  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    			  h: '1',
    			  hash: hash.sha256,

    			  // Precomputed endomorphism
    			  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    			  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    			  basis: [
    			    {
    			      a: '3086d221a7d46bcde86c90e49284eb15',
    			      b: '-e4437ed6010e88286f547fa90abfe4c3',
    			    },
    			    {
    			      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
    			      b: '3086d221a7d46bcde86c90e49284eb15',
    			    },
    			  ],

    			  gRed: false,
    			  g: [
    			    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    			    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    			    pre,
    			  ],
    			}); 
    		} (curves$2));

    		var hash$3 = hash$4;
    		var utils$6 = utils$l;
    		var assert$6 = minimalisticAssert;

    		function HmacDRBG$1(options) {
    		  if (!(this instanceof HmacDRBG$1))
    		    return new HmacDRBG$1(options);
    		  this.hash = options.hash;
    		  this.predResist = !!options.predResist;

    		  this.outLen = this.hash.outSize;
    		  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

    		  this._reseed = null;
    		  this.reseedInterval = null;
    		  this.K = null;
    		  this.V = null;

    		  var entropy = utils$6.toArray(options.entropy, options.entropyEnc || 'hex');
    		  var nonce = utils$6.toArray(options.nonce, options.nonceEnc || 'hex');
    		  var pers = utils$6.toArray(options.pers, options.persEnc || 'hex');
    		  assert$6(entropy.length >= (this.minEntropy / 8),
    		         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    		  this._init(entropy, nonce, pers);
    		}
    		var hmacDrbg = HmacDRBG$1;

    		HmacDRBG$1.prototype._init = function init(entropy, nonce, pers) {
    		  var seed = entropy.concat(nonce).concat(pers);

    		  this.K = new Array(this.outLen / 8);
    		  this.V = new Array(this.outLen / 8);
    		  for (var i = 0; i < this.V.length; i++) {
    		    this.K[i] = 0x00;
    		    this.V[i] = 0x01;
    		  }

    		  this._update(seed);
    		  this._reseed = 1;
    		  this.reseedInterval = 0x1000000000000;  // 2^48
    		};

    		HmacDRBG$1.prototype._hmac = function hmac() {
    		  return new hash$3.hmac(this.hash, this.K);
    		};

    		HmacDRBG$1.prototype._update = function update(seed) {
    		  var kmac = this._hmac()
    		                 .update(this.V)
    		                 .update([ 0x00 ]);
    		  if (seed)
    		    kmac = kmac.update(seed);
    		  this.K = kmac.digest();
    		  this.V = this._hmac().update(this.V).digest();
    		  if (!seed)
    		    return;

    		  this.K = this._hmac()
    		               .update(this.V)
    		               .update([ 0x01 ])
    		               .update(seed)
    		               .digest();
    		  this.V = this._hmac().update(this.V).digest();
    		};

    		HmacDRBG$1.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    		  // Optional entropy enc
    		  if (typeof entropyEnc !== 'string') {
    		    addEnc = add;
    		    add = entropyEnc;
    		    entropyEnc = null;
    		  }

    		  entropy = utils$6.toArray(entropy, entropyEnc);
    		  add = utils$6.toArray(add, addEnc);

    		  assert$6(entropy.length >= (this.minEntropy / 8),
    		         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

    		  this._update(entropy.concat(add || []));
    		  this._reseed = 1;
    		};

    		HmacDRBG$1.prototype.generate = function generate(len, enc, add, addEnc) {
    		  if (this._reseed > this.reseedInterval)
    		    throw new Error('Reseed is required');

    		  // Optional encoding
    		  if (typeof enc !== 'string') {
    		    addEnc = add;
    		    add = enc;
    		    enc = null;
    		  }

    		  // Optional additional data
    		  if (add) {
    		    add = utils$6.toArray(add, addEnc || 'hex');
    		    this._update(add);
    		  }

    		  var temp = [];
    		  while (temp.length < len) {
    		    this.V = this._hmac().update(this.V).digest();
    		    temp = temp.concat(this.V);
    		  }

    		  var res = temp.slice(0, len);
    		  this._update(add);
    		  this._reseed++;
    		  return utils$6.encode(res, enc);
    		};

    		var DRBG = /*@__PURE__*/getDefaultExportFromCjs(hmacDrbg);

    		var BN$3 = bnExports;
    		var utils$5 = utils$m;
    		var assert$5 = utils$5.assert;

    		function KeyPair$3(ec, options) {
    		  this.ec = ec;
    		  this.priv = null;
    		  this.pub = null;

    		  // KeyPair(ec, { priv: ..., pub: ... })
    		  if (options.priv)
    		    this._importPrivate(options.priv, options.privEnc);
    		  if (options.pub)
    		    this._importPublic(options.pub, options.pubEnc);
    		}
    		var key$1 = KeyPair$3;

    		KeyPair$3.fromPublic = function fromPublic(ec, pub, enc) {
    		  if (pub instanceof KeyPair$3)
    		    return pub;

    		  return new KeyPair$3(ec, {
    		    pub: pub,
    		    pubEnc: enc,
    		  });
    		};

    		KeyPair$3.fromPrivate = function fromPrivate(ec, priv, enc) {
    		  if (priv instanceof KeyPair$3)
    		    return priv;

    		  return new KeyPair$3(ec, {
    		    priv: priv,
    		    privEnc: enc,
    		  });
    		};

    		KeyPair$3.prototype.validate = function validate() {
    		  var pub = this.getPublic();

    		  if (pub.isInfinity())
    		    return { result: false, reason: 'Invalid public key' };
    		  if (!pub.validate())
    		    return { result: false, reason: 'Public key is not a point' };
    		  if (!pub.mul(this.ec.curve.n).isInfinity())
    		    return { result: false, reason: 'Public key * N != O' };

    		  return { result: true, reason: null };
    		};

    		KeyPair$3.prototype.getPublic = function getPublic(compact, enc) {
    		  // compact is optional argument
    		  if (typeof compact === 'string') {
    		    enc = compact;
    		    compact = null;
    		  }

    		  if (!this.pub)
    		    this.pub = this.ec.g.mul(this.priv);

    		  if (!enc)
    		    return this.pub;

    		  return this.pub.encode(enc, compact);
    		};

    		KeyPair$3.prototype.getPrivate = function getPrivate(enc) {
    		  if (enc === 'hex')
    		    return this.priv.toString(16, 2);
    		  else
    		    return this.priv;
    		};

    		KeyPair$3.prototype._importPrivate = function _importPrivate(key, enc) {
    		  this.priv = new BN$3(key, enc || 16);

    		  // Ensure that the priv won't be bigger than n, otherwise we may fail
    		  // in fixed multiplication method
    		  this.priv = this.priv.umod(this.ec.curve.n);
    		};

    		KeyPair$3.prototype._importPublic = function _importPublic(key, enc) {
    		  if (key.x || key.y) {
    		    // Montgomery points only have an `x` coordinate.
    		    // Weierstrass/Edwards points on the other hand have both `x` and
    		    // `y` coordinates.
    		    if (this.ec.curve.type === 'mont') {
    		      assert$5(key.x, 'Need x coordinate');
    		    } else if (this.ec.curve.type === 'short' ||
    		               this.ec.curve.type === 'edwards') {
    		      assert$5(key.x && key.y, 'Need both x and y coordinate');
    		    }
    		    this.pub = this.ec.curve.point(key.x, key.y);
    		    return;
    		  }
    		  this.pub = this.ec.curve.decodePoint(key, enc);
    		};

    		// ECDH
    		KeyPair$3.prototype.derive = function derive(pub) {
    		  if(!pub.validate()) {
    		    assert$5(pub.validate(), 'public point not validated');
    		  }
    		  return pub.mul(this.priv).getX();
    		};

    		// ECDSA
    		KeyPair$3.prototype.sign = function sign(msg, enc, options) {
    		  return this.ec.sign(msg, this, enc, options);
    		};

    		KeyPair$3.prototype.verify = function verify(msg, signature) {
    		  return this.ec.verify(msg, signature, this);
    		};

    		KeyPair$3.prototype.inspect = function inspect() {
    		  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
    		         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
    		};

    		var BN$2 = bnExports;

    		var utils$4 = utils$m;
    		var assert$4 = utils$4.assert;

    		function Signature$4(options, enc) {
    		  if (options instanceof Signature$4)
    		    return options;

    		  if (this._importDER(options, enc))
    		    return;

    		  assert$4(options.r && options.s, 'Signature without r or s');
    		  this.r = new BN$2(options.r, 16);
    		  this.s = new BN$2(options.s, 16);
    		  if (options.recoveryParam === undefined)
    		    this.recoveryParam = null;
    		  else
    		    this.recoveryParam = options.recoveryParam;
    		}
    		var signature$1 = Signature$4;

    		function Position() {
    		  this.place = 0;
    		}

    		function getLength(buf, p) {
    		  var initial = buf[p.place++];
    		  if (!(initial & 0x80)) {
    		    return initial;
    		  }
    		  var octetLen = initial & 0xf;

    		  // Indefinite length or overflow
    		  if (octetLen === 0 || octetLen > 4) {
    		    return false;
    		  }

    		  var val = 0;
    		  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    		    val <<= 8;
    		    val |= buf[off];
    		    val >>>= 0;
    		  }

    		  // Leading zeroes
    		  if (val <= 0x7f) {
    		    return false;
    		  }

    		  p.place = off;
    		  return val;
    		}

    		function rmPadding(buf) {
    		  var i = 0;
    		  var len = buf.length - 1;
    		  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    		    i++;
    		  }
    		  if (i === 0) {
    		    return buf;
    		  }
    		  return buf.slice(i);
    		}

    		Signature$4.prototype._importDER = function _importDER(data, enc) {
    		  data = utils$4.toArray(data, enc);
    		  var p = new Position();
    		  if (data[p.place++] !== 0x30) {
    		    return false;
    		  }
    		  var len = getLength(data, p);
    		  if (len === false) {
    		    return false;
    		  }
    		  if ((len + p.place) !== data.length) {
    		    return false;
    		  }
    		  if (data[p.place++] !== 0x02) {
    		    return false;
    		  }
    		  var rlen = getLength(data, p);
    		  if (rlen === false) {
    		    return false;
    		  }
    		  var r = data.slice(p.place, rlen + p.place);
    		  p.place += rlen;
    		  if (data[p.place++] !== 0x02) {
    		    return false;
    		  }
    		  var slen = getLength(data, p);
    		  if (slen === false) {
    		    return false;
    		  }
    		  if (data.length !== slen + p.place) {
    		    return false;
    		  }
    		  var s = data.slice(p.place, slen + p.place);
    		  if (r[0] === 0) {
    		    if (r[1] & 0x80) {
    		      r = r.slice(1);
    		    } else {
    		      // Leading zeroes
    		      return false;
    		    }
    		  }
    		  if (s[0] === 0) {
    		    if (s[1] & 0x80) {
    		      s = s.slice(1);
    		    } else {
    		      // Leading zeroes
    		      return false;
    		    }
    		  }

    		  this.r = new BN$2(r);
    		  this.s = new BN$2(s);
    		  this.recoveryParam = null;

    		  return true;
    		};

    		function constructLength(arr, len) {
    		  if (len < 0x80) {
    		    arr.push(len);
    		    return;
    		  }
    		  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    		  arr.push(octets | 0x80);
    		  while (--octets) {
    		    arr.push((len >>> (octets << 3)) & 0xff);
    		  }
    		  arr.push(len);
    		}

    		Signature$4.prototype.toDER = function toDER(enc) {
    		  var r = this.r.toArray();
    		  var s = this.s.toArray();

    		  // Pad values
    		  if (r[0] & 0x80)
    		    r = [ 0 ].concat(r);
    		  // Pad values
    		  if (s[0] & 0x80)
    		    s = [ 0 ].concat(s);

    		  r = rmPadding(r);
    		  s = rmPadding(s);

    		  while (!s[0] && !(s[1] & 0x80)) {
    		    s = s.slice(1);
    		  }
    		  var arr = [ 0x02 ];
    		  constructLength(arr, r.length);
    		  arr = arr.concat(r);
    		  arr.push(0x02);
    		  constructLength(arr, s.length);
    		  var backHalf = arr.concat(s);
    		  var res = [ 0x30 ];
    		  constructLength(res, backHalf.length);
    		  res = res.concat(backHalf);
    		  return utils$4.encode(res, enc);
    		};

    		var BN$1 = bnExports;
    		var HmacDRBG = hmacDrbg;
    		var utils$3 = utils$m;
    		var curves$1 = curves$2;
    		var rand = brorandExports;
    		var assert$3 = utils$3.assert;

    		var KeyPair$2 = key$1;
    		var Signature$3 = signature$1;

    		function EC(options) {
    		  if (!(this instanceof EC))
    		    return new EC(options);

    		  // Shortcut `elliptic.ec(curve-name)`
    		  if (typeof options === 'string') {
    		    assert$3(Object.prototype.hasOwnProperty.call(curves$1, options),
    		      'Unknown curve ' + options);

    		    options = curves$1[options];
    		  }

    		  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    		  if (options instanceof curves$1.PresetCurve)
    		    options = { curve: options };

    		  this.curve = options.curve.curve;
    		  this.n = this.curve.n;
    		  this.nh = this.n.ushrn(1);
    		  this.g = this.curve.g;

    		  // Point on curve
    		  this.g = options.curve.g;
    		  this.g.precompute(options.curve.n.bitLength() + 1);

    		  // Hash for function for DRBG
    		  this.hash = options.hash || options.curve.hash;
    		}
    		var ec$1 = EC;

    		EC.prototype.keyPair = function keyPair(options) {
    		  return new KeyPair$2(this, options);
    		};

    		EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    		  return KeyPair$2.fromPrivate(this, priv, enc);
    		};

    		EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    		  return KeyPair$2.fromPublic(this, pub, enc);
    		};

    		EC.prototype.genKeyPair = function genKeyPair(options) {
    		  if (!options)
    		    options = {};

    		  // Instantiate Hmac_DRBG
    		  var drbg = new HmacDRBG({
    		    hash: this.hash,
    		    pers: options.pers,
    		    persEnc: options.persEnc || 'utf8',
    		    entropy: options.entropy || rand(this.hash.hmacStrength),
    		    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    		    nonce: this.n.toArray(),
    		  });

    		  var bytes = this.n.byteLength();
    		  var ns2 = this.n.sub(new BN$1(2));
    		  for (;;) {
    		    var priv = new BN$1(drbg.generate(bytes));
    		    if (priv.cmp(ns2) > 0)
    		      continue;

    		    priv.iaddn(1);
    		    return this.keyFromPrivate(priv);
    		  }
    		};

    		EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    		  var delta = msg.byteLength() * 8 - this.n.bitLength();
    		  if (delta > 0)
    		    msg = msg.ushrn(delta);
    		  if (!truncOnly && msg.cmp(this.n) >= 0)
    		    return msg.sub(this.n);
    		  else
    		    return msg;
    		};

    		EC.prototype.sign = function sign(msg, key, enc, options) {
    		  if (typeof enc === 'object') {
    		    options = enc;
    		    enc = null;
    		  }
    		  if (!options)
    		    options = {};

    		  key = this.keyFromPrivate(key, enc);
    		  msg = this._truncateToN(new BN$1(msg, 16));

    		  // Zero-extend key to provide enough entropy
    		  var bytes = this.n.byteLength();
    		  var bkey = key.getPrivate().toArray('be', bytes);

    		  // Zero-extend nonce to have the same byte size as N
    		  var nonce = msg.toArray('be', bytes);

    		  // Instantiate Hmac_DRBG
    		  var drbg = new HmacDRBG({
    		    hash: this.hash,
    		    entropy: bkey,
    		    nonce: nonce,
    		    pers: options.pers,
    		    persEnc: options.persEnc || 'utf8',
    		  });

    		  // Number of bytes to generate
    		  var ns1 = this.n.sub(new BN$1(1));

    		  for (var iter = 0; ; iter++) {
    		    var k = options.k ?
    		      options.k(iter) :
    		      new BN$1(drbg.generate(this.n.byteLength()));
    		    k = this._truncateToN(k, true);
    		    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
    		      continue;

    		    var kp = this.g.mul(k);
    		    if (kp.isInfinity())
    		      continue;

    		    var kpX = kp.getX();
    		    var r = kpX.umod(this.n);
    		    if (r.cmpn(0) === 0)
    		      continue;

    		    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    		    s = s.umod(this.n);
    		    if (s.cmpn(0) === 0)
    		      continue;

    		    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
    		                        (kpX.cmp(r) !== 0 ? 2 : 0);

    		    // Use complement of `s`, if it is > `n / 2`
    		    if (options.canonical && s.cmp(this.nh) > 0) {
    		      s = this.n.sub(s);
    		      recoveryParam ^= 1;
    		    }

    		    return new Signature$3({ r: r, s: s, recoveryParam: recoveryParam });
    		  }
    		};

    		EC.prototype.verify = function verify(msg, signature, key, enc) {
    		  msg = this._truncateToN(new BN$1(msg, 16));
    		  key = this.keyFromPublic(key, enc);
    		  signature = new Signature$3(signature, 'hex');

    		  // Perform primitive values validation
    		  var r = signature.r;
    		  var s = signature.s;
    		  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    		    return false;
    		  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    		    return false;

    		  // Validate signature
    		  var sinv = s.invm(this.n);
    		  var u1 = sinv.mul(msg).umod(this.n);
    		  var u2 = sinv.mul(r).umod(this.n);
    		  var p;

    		  if (!this.curve._maxwellTrick) {
    		    p = this.g.mulAdd(u1, key.getPublic(), u2);
    		    if (p.isInfinity())
    		      return false;

    		    return p.getX().umod(this.n).cmp(r) === 0;
    		  }

    		  // NOTE: Greg Maxwell's trick, inspired by:
    		  // https://git.io/vad3K

    		  p = this.g.jmulAdd(u1, key.getPublic(), u2);
    		  if (p.isInfinity())
    		    return false;

    		  // Compare `p.x` of Jacobian point with `r`,
    		  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    		  // inverse of `p.z^2`
    		  return p.eqXToP(r);
    		};

    		EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    		  assert$3((3 & j) === j, 'The recovery param is more than two bits');
    		  signature = new Signature$3(signature, enc);

    		  var n = this.n;
    		  var e = new BN$1(msg);
    		  var r = signature.r;
    		  var s = signature.s;

    		  // A set LSB signifies that the y-coordinate is odd
    		  var isYOdd = j & 1;
    		  var isSecondKey = j >> 1;
    		  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    		    throw new Error('Unable to find sencond key candinate');

    		  // 1.1. Let x = r + jn.
    		  if (isSecondKey)
    		    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    		  else
    		    r = this.curve.pointFromX(r, isYOdd);

    		  var rInv = signature.r.invm(n);
    		  var s1 = n.sub(e).mul(rInv).umod(n);
    		  var s2 = s.mul(rInv).umod(n);

    		  // 1.6.1 Compute Q = r^-1 (sR -  eG)
    		  //               Q = r^-1 (sR + -eG)
    		  return this.g.mulAdd(s1, r, s2);
    		};

    		EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    		  signature = new Signature$3(signature, enc);
    		  if (signature.recoveryParam !== null)
    		    return signature.recoveryParam;

    		  for (var i = 0; i < 4; i++) {
    		    var Qprime;
    		    try {
    		      Qprime = this.recoverPubKey(e, signature, i);
    		    } catch (e) {
    		      continue;
    		    }

    		    if (Qprime.eq(Q))
    		      return i;
    		  }
    		  throw new Error('Unable to find valid recovery factor');
    		};

    		var utils$2 = utils$m;
    		var assert$2 = utils$2.assert;
    		var parseBytes$2 = utils$2.parseBytes;
    		var cachedProperty$1 = utils$2.cachedProperty;

    		/**
    		* @param {EDDSA} eddsa - instance
    		* @param {Object} params - public/private key parameters
    		*
    		* @param {Array<Byte>} [params.secret] - secret seed bytes
    		* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
    		* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
    		*
    		*/
    		function KeyPair$1(eddsa, params) {
    		  this.eddsa = eddsa;
    		  this._secret = parseBytes$2(params.secret);
    		  if (eddsa.isPoint(params.pub))
    		    this._pub = params.pub;
    		  else
    		    this._pubBytes = parseBytes$2(params.pub);
    		}

    		KeyPair$1.fromPublic = function fromPublic(eddsa, pub) {
    		  if (pub instanceof KeyPair$1)
    		    return pub;
    		  return new KeyPair$1(eddsa, { pub: pub });
    		};

    		KeyPair$1.fromSecret = function fromSecret(eddsa, secret) {
    		  if (secret instanceof KeyPair$1)
    		    return secret;
    		  return new KeyPair$1(eddsa, { secret: secret });
    		};

    		KeyPair$1.prototype.secret = function secret() {
    		  return this._secret;
    		};

    		cachedProperty$1(KeyPair$1, 'pubBytes', function pubBytes() {
    		  return this.eddsa.encodePoint(this.pub());
    		});

    		cachedProperty$1(KeyPair$1, 'pub', function pub() {
    		  if (this._pubBytes)
    		    return this.eddsa.decodePoint(this._pubBytes);
    		  return this.eddsa.g.mul(this.priv());
    		});

    		cachedProperty$1(KeyPair$1, 'privBytes', function privBytes() {
    		  var eddsa = this.eddsa;
    		  var hash = this.hash();
    		  var lastIx = eddsa.encodingLength - 1;

    		  var a = hash.slice(0, eddsa.encodingLength);
    		  a[0] &= 248;
    		  a[lastIx] &= 127;
    		  a[lastIx] |= 64;

    		  return a;
    		});

    		cachedProperty$1(KeyPair$1, 'priv', function priv() {
    		  return this.eddsa.decodeInt(this.privBytes());
    		});

    		cachedProperty$1(KeyPair$1, 'hash', function hash() {
    		  return this.eddsa.hash().update(this.secret()).digest();
    		});

    		cachedProperty$1(KeyPair$1, 'messagePrefix', function messagePrefix() {
    		  return this.hash().slice(this.eddsa.encodingLength);
    		});

    		KeyPair$1.prototype.sign = function sign(message) {
    		  assert$2(this._secret, 'KeyPair can only verify');
    		  return this.eddsa.sign(message, this);
    		};

    		KeyPair$1.prototype.verify = function verify(message, sig) {
    		  return this.eddsa.verify(message, sig, this);
    		};

    		KeyPair$1.prototype.getSecret = function getSecret(enc) {
    		  assert$2(this._secret, 'KeyPair is public only');
    		  return utils$2.encode(this.secret(), enc);
    		};

    		KeyPair$1.prototype.getPublic = function getPublic(enc) {
    		  return utils$2.encode(this.pubBytes(), enc);
    		};

    		var key = KeyPair$1;

    		var BN = bnExports;
    		var utils$1 = utils$m;
    		var assert$1 = utils$1.assert;
    		var cachedProperty = utils$1.cachedProperty;
    		var parseBytes$1 = utils$1.parseBytes;

    		/**
    		* @param {EDDSA} eddsa - eddsa instance
    		* @param {Array<Bytes>|Object} sig -
    		* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
    		* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
    		* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
    		* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
    		*/
    		function Signature$2(eddsa, sig) {
    		  this.eddsa = eddsa;

    		  if (typeof sig !== 'object')
    		    sig = parseBytes$1(sig);

    		  if (Array.isArray(sig)) {
    		    sig = {
    		      R: sig.slice(0, eddsa.encodingLength),
    		      S: sig.slice(eddsa.encodingLength),
    		    };
    		  }

    		  assert$1(sig.R && sig.S, 'Signature without R or S');

    		  if (eddsa.isPoint(sig.R))
    		    this._R = sig.R;
    		  if (sig.S instanceof BN)
    		    this._S = sig.S;

    		  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    		  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
    		}

    		cachedProperty(Signature$2, 'S', function S() {
    		  return this.eddsa.decodeInt(this.Sencoded());
    		});

    		cachedProperty(Signature$2, 'R', function R() {
    		  return this.eddsa.decodePoint(this.Rencoded());
    		});

    		cachedProperty(Signature$2, 'Rencoded', function Rencoded() {
    		  return this.eddsa.encodePoint(this.R());
    		});

    		cachedProperty(Signature$2, 'Sencoded', function Sencoded() {
    		  return this.eddsa.encodeInt(this.S());
    		});

    		Signature$2.prototype.toBytes = function toBytes() {
    		  return this.Rencoded().concat(this.Sencoded());
    		};

    		Signature$2.prototype.toHex = function toHex() {
    		  return utils$1.encode(this.toBytes(), 'hex').toUpperCase();
    		};

    		var signature = Signature$2;

    		var hash$2 = hash$4;
    		var curves = curves$2;
    		var utils = utils$m;
    		var assert = utils.assert;
    		var parseBytes = utils.parseBytes;
    		var KeyPair = key;
    		var Signature$1 = signature;

    		function EDDSA(curve) {
    		  assert(curve === 'ed25519', 'only tested with ed25519 so far');

    		  if (!(this instanceof EDDSA))
    		    return new EDDSA(curve);

    		  curve = curves[curve].curve;
    		  this.curve = curve;
    		  this.g = curve.g;
    		  this.g.precompute(curve.n.bitLength() + 1);

    		  this.pointClass = curve.point().constructor;
    		  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    		  this.hash = hash$2.sha512;
    		}

    		var eddsa = EDDSA;

    		/**
    		* @param {Array|String} message - message bytes
    		* @param {Array|String|KeyPair} secret - secret bytes or a keypair
    		* @returns {Signature} - signature
    		*/
    		EDDSA.prototype.sign = function sign(message, secret) {
    		  message = parseBytes(message);
    		  var key = this.keyFromSecret(secret);
    		  var r = this.hashInt(key.messagePrefix(), message);
    		  var R = this.g.mul(r);
    		  var Rencoded = this.encodePoint(R);
    		  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
    		    .mul(key.priv());
    		  var S = r.add(s_).umod(this.curve.n);
    		  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
    		};

    		/**
    		* @param {Array} message - message bytes
    		* @param {Array|String|Signature} sig - sig bytes
    		* @param {Array|String|Point|KeyPair} pub - public key
    		* @returns {Boolean} - true if public key matches sig of message
    		*/
    		EDDSA.prototype.verify = function verify(message, sig, pub) {
    		  message = parseBytes(message);
    		  sig = this.makeSignature(sig);
    		  var key = this.keyFromPublic(pub);
    		  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    		  var SG = this.g.mul(sig.S());
    		  var RplusAh = sig.R().add(key.pub().mul(h));
    		  return RplusAh.eq(SG);
    		};

    		EDDSA.prototype.hashInt = function hashInt() {
    		  var hash = this.hash();
    		  for (var i = 0; i < arguments.length; i++)
    		    hash.update(arguments[i]);
    		  return utils.intFromLE(hash.digest()).umod(this.curve.n);
    		};

    		EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    		  return KeyPair.fromPublic(this, pub);
    		};

    		EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    		  return KeyPair.fromSecret(this, secret);
    		};

    		EDDSA.prototype.makeSignature = function makeSignature(sig) {
    		  if (sig instanceof Signature$1)
    		    return sig;
    		  return new Signature$1(this, sig);
    		};

    		/**
    		* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
    		*
    		* EDDSA defines methods for encoding and decoding points and integers. These are
    		* helper convenience methods, that pass along to utility functions implied
    		* parameters.
    		*
    		*/
    		EDDSA.prototype.encodePoint = function encodePoint(point) {
    		  var enc = point.getY().toArray('le', this.encodingLength);
    		  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    		  return enc;
    		};

    		EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    		  bytes = utils.parseBytes(bytes);

    		  var lastIx = bytes.length - 1;
    		  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
    		  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

    		  var y = utils.intFromLE(normed);
    		  return this.curve.pointFromY(y, xIsOdd);
    		};

    		EDDSA.prototype.encodeInt = function encodeInt(num) {
    		  return num.toArray('le', this.encodingLength);
    		};

    		EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    		  return utils.intFromLE(bytes);
    		};

    		EDDSA.prototype.isPoint = function isPoint(val) {
    		  return val instanceof this.pointClass;
    		};

    		(function (exports) {

    			var elliptic = exports;

    			elliptic.version = require$$0$4.version;
    			elliptic.utils = utils$m;
    			elliptic.rand = brorandExports;
    			elliptic.curve = curve$1;
    			elliptic.curves = curves$2;

    			// Protocols
    			elliptic.ec = ec$1;
    			elliptic.eddsa = eddsa; 
    		} (elliptic$1));

    		var elliptic = /*@__PURE__*/getDefaultExportFromCjs(elliptic$1);

    		var bundle = {exports: {}};

    		bundle.exports;

    		(function (module, exports) {
    			(function (global, factory) {
    			  factory(exports) ;
    			})(commonjsGlobal$1, (function (exports) {
    			  //  Copyright (C) 2018 Zilliqa
    			  //
    			  //  This file is part of zilliqa-js
    			  //
    			  //  This program is free software: you can redistribute it and/or modify
    			  //  it under the terms of the GNU General Public License as published by
    			  //  the Free Software Foundation, either version 3 of the License, or
    			  //  (at your option) any later version.
    			  //
    			  //  This program is distributed in the hope that it will be useful,
    			  //  but WITHOUT ANY WARRANTY; without even the implied warranty of
    			  //  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    			  //  GNU General Public License for more details.
    			  //
    			  //  You should have received a copy of the GNU General Public License
    			  //  along with this program.  If not, see <https://www.gnu.org/licenses/>.
    			  /**
    			   * intToHexArray
    			   *
    			   * @param {number} int - the number to be converted to hex
    			   * @param {number)} size - the desired width of the hex value. will pad.
    			   *
    			   * @returns {string[]}
    			   */
    			  var intToHexArray = function (int, size) {
    			      var hex = [];
    			      var hexRep = [];
    			      var hexVal = int.toString(16);
    			      // TODO: this really needs to be refactored.
    			      for (var i = 0; i < hexVal.length; i++) {
    			          hexRep[i] = hexVal[i].toString();
    			      }
    			      for (var i = 0; i < size - hexVal.length; i++) {
    			          hex.push('0');
    			      }
    			      for (var i = 0; i < hexVal.length; i++) {
    			          hex.push(hexRep[i]);
    			      }
    			      return hex;
    			  };
    			  /**
    			   * intToByteArray
    			   *
    			   * Converts a number to Uint8Array
    			   *
    			   * @param {number} num
    			   * @param {number} size
    			   *
    			   * @returns {Uint8Array}
    			   */
    			  var intToByteArray = function (num, size) {
    			      var x = num;
    			      var res = [];
    			      while (x > 0) {
    			          res.push(x & 255);
    			          x = x >> 8;
    			      }
    			      var pad = size - res.length;
    			      for (var i = 0; i < pad; i++) {
    			          res.unshift(0);
    			      }
    			      return Uint8Array.from(res);
    			  };
    			  /**
    			   * hexToByteArray
    			   *
    			   * Convers a hex string to a Uint8Array
    			   *
    			   * @param {string} hex
    			   * @returns {Uint8Array}
    			   */
    			  var hexToByteArray = function (hex) {
    			      var res = new Uint8Array(hex.length / 2);
    			      for (var i = 0; i < hex.length; i += 2) {
    			          res[i / 2] = parseInt(hex.substring(i, i + 2), 16);
    			      }
    			      return res;
    			  };
    			  /**
    			   * hexToIntArray
    			   *
    			   * @param {string} hex
    			   * @returns {number[]}
    			   */
    			  var hexToIntArray = function (hex) {
    			      if (!hex || !isHex(hex)) {
    			          return [];
    			      }
    			      var res = [];
    			      for (var i = 0; i < hex.length; i++) {
    			          var c = hex.charCodeAt(i);
    			          var hi = c >> 8;
    			          var lo = c & 0xff;
    			          hi ? res.push(hi, lo) : res.push(lo);
    			      }
    			      return res;
    			  };
    			  /**
    			   * pack
    			   *
    			   * Takes two 16-bit integers and combines them. Used to compute version.
    			   *
    			   * @param {number} a
    			   * @param {number} b
    			   *
    			   * @returns {number} - a 32-bit number
    			   */
    			  var pack = function (a, b) {
    			      if (a >> 16 > 0 || b >> 16 > 0) {
    			          throw new Error('Both a and b must be 16 bits or less');
    			      }
    			      return (a << 16) + b;
    			  };
    			  /**
    			   * compareBytes
    			   *
    			   * A constant time HMAC comparison function.
    			   *
    			   * @param {string} a
    			   * @param {string} b
    			   * @returns {boolean}
    			   */
    			  var isEqual = function (a, b) {
    			      var bzA = hexToIntArray(a);
    			      var bzB = hexToIntArray(b);
    			      if (bzA.length !== bzB.length) {
    			          return false;
    			      }
    			      var result = 0;
    			      for (var i = 0; i < bzA.length; i++) {
    			          result |= bzA[i] ^ bzB[i];
    			      }
    			      return result === 0;
    			  };
    			  /**
    			   * isHex
    			   *
    			   * @param {string} str - string to be tested
    			   * @returns {boolean}
    			   */
    			  var isHex = function (str) {
    			      var plain = str.replace('0x', '');
    			      return /[0-9a-f]*$/i.test(plain);
    			  };

    			  var bytes = /*#__PURE__*/Object.freeze({
    			    __proto__: null,
    			    intToHexArray: intToHexArray,
    			    intToByteArray: intToByteArray,
    			    hexToByteArray: hexToByteArray,
    			    hexToIntArray: hexToIntArray,
    			    pack: pack,
    			    isEqual: isEqual,
    			    isHex: isHex
    			  });

    			  /******************************************************************************
    			  Copyright (c) Microsoft Corporation.

    			  Permission to use, copy, modify, and/or distribute this software for any
    			  purpose with or without fee is hereby granted.

    			  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    			  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    			  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    			  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    			  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    			  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    			  PERFORMANCE OF THIS SOFTWARE.
    			  ***************************************************************************** */

    			  function __values(o) {
    			      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    			      if (m) return m.call(o);
    			      if (o && typeof o.length === "number") return {
    			          next: function () {
    			              if (o && i >= o.length) o = void 0;
    			              return { value: o && o[i++], done: !o };
    			          }
    			      };
    			      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    			  }

    			  function __read(o, n) {
    			      var m = typeof Symbol === "function" && o[Symbol.iterator];
    			      if (!m) return o;
    			      var i = m.call(o), r, ar = [], e;
    			      try {
    			          while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    			      }
    			      catch (error) { e = { error: error }; }
    			      finally {
    			          try {
    			              if (r && !r.done && (m = i["return"])) m.call(i);
    			          }
    			          finally { if (e) throw e.error; }
    			      }
    			      return ar;
    			  }

    			  var commonjsGlobal$1$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal$1 !== 'undefined' ? commonjsGlobal$1 : typeof self !== 'undefined' ? self : {};

    			  function getDefaultExportFromCjs (x) {
    			  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    			  }

    			  function getAugmentedNamespace(n) {
    			    if (n.__esModule) return n;
    			    var f = n.default;
    			  	if (typeof f == "function") {
    			  		var a = function a () {
    			  			if (this instanceof a) {
    			  				var args = [null];
    			  				args.push.apply(args, arguments);
    			  				var Ctor = Function.bind.apply(f, args);
    			  				return new Ctor();
    			  			}
    			  			return f.apply(this, arguments);
    			  		};
    			  		a.prototype = f.prototype;
    			    } else a = {};
    			    Object.defineProperty(a, '__esModule', {value: true});
    			  	Object.keys(n).forEach(function (k) {
    			  		var d = Object.getOwnPropertyDescriptor(n, k);
    			  		Object.defineProperty(a, k, d.get ? d : {
    			  			enumerable: true,
    			  			get: function () {
    			  				return n[k];
    			  			}
    			  		});
    			  	});
    			  	return a;
    			  }

    			  var bn = {exports: {}};

    			  var global$1 = (typeof commonjsGlobal$1 !== "undefined" ? commonjsGlobal$1 :
    			    typeof self !== "undefined" ? self :
    			    typeof window !== "undefined" ? window : {});

    			  var lookup = [];
    			  var revLookup = [];
    			  var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
    			  var inited = false;
    			  function init () {
    			    inited = true;
    			    var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    			    for (var i = 0, len = code.length; i < len; ++i) {
    			      lookup[i] = code[i];
    			      revLookup[code.charCodeAt(i)] = i;
    			    }

    			    revLookup['-'.charCodeAt(0)] = 62;
    			    revLookup['_'.charCodeAt(0)] = 63;
    			  }

    			  function toByteArray (b64) {
    			    if (!inited) {
    			      init();
    			    }
    			    var i, j, l, tmp, placeHolders, arr;
    			    var len = b64.length;

    			    if (len % 4 > 0) {
    			      throw new Error('Invalid string. Length must be a multiple of 4')
    			    }

    			    // the number of equal signs (place holders)
    			    // if there are two placeholders, than the two characters before it
    			    // represent one byte
    			    // if there is only one, then the three characters before it represent 2 bytes
    			    // this is just a cheap hack to not do indexOf twice
    			    placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;

    			    // base64 is 4/3 + up to two characters of the original data
    			    arr = new Arr(len * 3 / 4 - placeHolders);

    			    // if there are placeholders, only get up to the last complete 4 chars
    			    l = placeHolders > 0 ? len - 4 : len;

    			    var L = 0;

    			    for (i = 0, j = 0; i < l; i += 4, j += 3) {
    			      tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)];
    			      arr[L++] = (tmp >> 16) & 0xFF;
    			      arr[L++] = (tmp >> 8) & 0xFF;
    			      arr[L++] = tmp & 0xFF;
    			    }

    			    if (placeHolders === 2) {
    			      tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4);
    			      arr[L++] = tmp & 0xFF;
    			    } else if (placeHolders === 1) {
    			      tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2);
    			      arr[L++] = (tmp >> 8) & 0xFF;
    			      arr[L++] = tmp & 0xFF;
    			    }

    			    return arr
    			  }

    			  function tripletToBase64 (num) {
    			    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
    			  }

    			  function encodeChunk (uint8, start, end) {
    			    var tmp;
    			    var output = [];
    			    for (var i = start; i < end; i += 3) {
    			      tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2]);
    			      output.push(tripletToBase64(tmp));
    			    }
    			    return output.join('')
    			  }

    			  function fromByteArray (uint8) {
    			    if (!inited) {
    			      init();
    			    }
    			    var tmp;
    			    var len = uint8.length;
    			    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    			    var output = '';
    			    var parts = [];
    			    var maxChunkLength = 16383; // must be multiple of 3

    			    // go through the array every three bytes, we'll deal with trailing stuff later
    			    for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    			      parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
    			    }

    			    // pad the end with zeros, but make sure to not forget the extra bytes
    			    if (extraBytes === 1) {
    			      tmp = uint8[len - 1];
    			      output += lookup[tmp >> 2];
    			      output += lookup[(tmp << 4) & 0x3F];
    			      output += '==';
    			    } else if (extraBytes === 2) {
    			      tmp = (uint8[len - 2] << 8) + (uint8[len - 1]);
    			      output += lookup[tmp >> 10];
    			      output += lookup[(tmp >> 4) & 0x3F];
    			      output += lookup[(tmp << 2) & 0x3F];
    			      output += '=';
    			    }

    			    parts.push(output);

    			    return parts.join('')
    			  }

    			  function read (buffer, offset, isLE, mLen, nBytes) {
    			    var e, m;
    			    var eLen = nBytes * 8 - mLen - 1;
    			    var eMax = (1 << eLen) - 1;
    			    var eBias = eMax >> 1;
    			    var nBits = -7;
    			    var i = isLE ? (nBytes - 1) : 0;
    			    var d = isLE ? -1 : 1;
    			    var s = buffer[offset + i];

    			    i += d;

    			    e = s & ((1 << (-nBits)) - 1);
    			    s >>= (-nBits);
    			    nBits += eLen;
    			    for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    			    m = e & ((1 << (-nBits)) - 1);
    			    e >>= (-nBits);
    			    nBits += mLen;
    			    for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    			    if (e === 0) {
    			      e = 1 - eBias;
    			    } else if (e === eMax) {
    			      return m ? NaN : ((s ? -1 : 1) * Infinity)
    			    } else {
    			      m = m + Math.pow(2, mLen);
    			      e = e - eBias;
    			    }
    			    return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
    			  }

    			  function write (buffer, value, offset, isLE, mLen, nBytes) {
    			    var e, m, c;
    			    var eLen = nBytes * 8 - mLen - 1;
    			    var eMax = (1 << eLen) - 1;
    			    var eBias = eMax >> 1;
    			    var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
    			    var i = isLE ? 0 : (nBytes - 1);
    			    var d = isLE ? 1 : -1;
    			    var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

    			    value = Math.abs(value);

    			    if (isNaN(value) || value === Infinity) {
    			      m = isNaN(value) ? 1 : 0;
    			      e = eMax;
    			    } else {
    			      e = Math.floor(Math.log(value) / Math.LN2);
    			      if (value * (c = Math.pow(2, -e)) < 1) {
    			        e--;
    			        c *= 2;
    			      }
    			      if (e + eBias >= 1) {
    			        value += rt / c;
    			      } else {
    			        value += rt * Math.pow(2, 1 - eBias);
    			      }
    			      if (value * c >= 2) {
    			        e++;
    			        c /= 2;
    			      }

    			      if (e + eBias >= eMax) {
    			        m = 0;
    			        e = eMax;
    			      } else if (e + eBias >= 1) {
    			        m = (value * c - 1) * Math.pow(2, mLen);
    			        e = e + eBias;
    			      } else {
    			        m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
    			        e = 0;
    			      }
    			    }

    			    for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

    			    e = (e << mLen) | m;
    			    eLen += mLen;
    			    for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

    			    buffer[offset + i - d] |= s * 128;
    			  }

    			  var toString = {}.toString;

    			  var isArray = Array.isArray || function (arr) {
    			    return toString.call(arr) == '[object Array]';
    			  };

    			  /*!
    			   * The buffer module from node.js, for the browser.
    			   *
    			   * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
    			   * @license  MIT
    			   */

    			  var INSPECT_MAX_BYTES = 50;

    			  /**
    			   * If `Buffer.TYPED_ARRAY_SUPPORT`:
    			   *   === true    Use Uint8Array implementation (fastest)
    			   *   === false   Use Object implementation (most compatible, even IE6)
    			   *
    			   * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
    			   * Opera 11.6+, iOS 4.2+.
    			   *
    			   * Due to various browser bugs, sometimes the Object implementation will be used even
    			   * when the browser supports typed arrays.
    			   *
    			   * Note:
    			   *
    			   *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
    			   *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
    			   *
    			   *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
    			   *
    			   *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
    			   *     incorrect length in some situations.

    			   * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
    			   * get the Object implementation, which is slower but behaves correctly.
    			   */
    			  Buffer.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined
    			    ? global$1.TYPED_ARRAY_SUPPORT
    			    : true;

    			  /*
    			   * Export kMaxLength after typed array support is determined.
    			   */
    			  var _kMaxLength = kMaxLength();

    			  function kMaxLength () {
    			    return Buffer.TYPED_ARRAY_SUPPORT
    			      ? 0x7fffffff
    			      : 0x3fffffff
    			  }

    			  function createBuffer (that, length) {
    			    if (kMaxLength() < length) {
    			      throw new RangeError('Invalid typed array length')
    			    }
    			    if (Buffer.TYPED_ARRAY_SUPPORT) {
    			      // Return an augmented `Uint8Array` instance, for best performance
    			      that = new Uint8Array(length);
    			      that.__proto__ = Buffer.prototype;
    			    } else {
    			      // Fallback: Return an object instance of the Buffer class
    			      if (that === null) {
    			        that = new Buffer(length);
    			      }
    			      that.length = length;
    			    }

    			    return that
    			  }

    			  /**
    			   * The Buffer constructor returns instances of `Uint8Array` that have their
    			   * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
    			   * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
    			   * and the `Uint8Array` methods. Square bracket notation works as expected -- it
    			   * returns a single octet.
    			   *
    			   * The `Uint8Array` prototype remains unmodified.
    			   */

    			  function Buffer (arg, encodingOrOffset, length) {
    			    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    			      return new Buffer(arg, encodingOrOffset, length)
    			    }

    			    // Common case.
    			    if (typeof arg === 'number') {
    			      if (typeof encodingOrOffset === 'string') {
    			        throw new Error(
    			          'If encoding is specified then the first argument must be a string'
    			        )
    			      }
    			      return allocUnsafe(this, arg)
    			    }
    			    return from(this, arg, encodingOrOffset, length)
    			  }

    			  Buffer.poolSize = 8192; // not used by this implementation

    			  // TODO: Legacy, not needed anymore. Remove in next major version.
    			  Buffer._augment = function (arr) {
    			    arr.__proto__ = Buffer.prototype;
    			    return arr
    			  };

    			  function from (that, value, encodingOrOffset, length) {
    			    if (typeof value === 'number') {
    			      throw new TypeError('"value" argument must not be a number')
    			    }

    			    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    			      return fromArrayBuffer(that, value, encodingOrOffset, length)
    			    }

    			    if (typeof value === 'string') {
    			      return fromString$1(that, value, encodingOrOffset)
    			    }

    			    return fromObject(that, value)
    			  }

    			  /**
    			   * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
    			   * if value is a number.
    			   * Buffer.from(str[, encoding])
    			   * Buffer.from(array)
    			   * Buffer.from(buffer)
    			   * Buffer.from(arrayBuffer[, byteOffset[, length]])
    			   **/
    			  Buffer.from = function (value, encodingOrOffset, length) {
    			    return from(null, value, encodingOrOffset, length)
    			  };

    			  if (Buffer.TYPED_ARRAY_SUPPORT) {
    			    Buffer.prototype.__proto__ = Uint8Array.prototype;
    			    Buffer.__proto__ = Uint8Array;
    			    if (typeof Symbol !== 'undefined' && Symbol.species &&
    			        Buffer[Symbol.species] === Buffer) ;
    			  }

    			  function assertSize (size) {
    			    if (typeof size !== 'number') {
    			      throw new TypeError('"size" argument must be a number')
    			    } else if (size < 0) {
    			      throw new RangeError('"size" argument must not be negative')
    			    }
    			  }

    			  function alloc (that, size, fill, encoding) {
    			    assertSize(size);
    			    if (size <= 0) {
    			      return createBuffer(that, size)
    			    }
    			    if (fill !== undefined) {
    			      // Only pay attention to encoding if it's a string. This
    			      // prevents accidentally sending in a number that would
    			      // be interpretted as a start offset.
    			      return typeof encoding === 'string'
    			        ? createBuffer(that, size).fill(fill, encoding)
    			        : createBuffer(that, size).fill(fill)
    			    }
    			    return createBuffer(that, size)
    			  }

    			  /**
    			   * Creates a new filled Buffer instance.
    			   * alloc(size[, fill[, encoding]])
    			   **/
    			  Buffer.alloc = function (size, fill, encoding) {
    			    return alloc(null, size, fill, encoding)
    			  };

    			  function allocUnsafe (that, size) {
    			    assertSize(size);
    			    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    			    if (!Buffer.TYPED_ARRAY_SUPPORT) {
    			      for (var i = 0; i < size; ++i) {
    			        that[i] = 0;
    			      }
    			    }
    			    return that
    			  }

    			  /**
    			   * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
    			   * */
    			  Buffer.allocUnsafe = function (size) {
    			    return allocUnsafe(null, size)
    			  };
    			  /**
    			   * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
    			   */
    			  Buffer.allocUnsafeSlow = function (size) {
    			    return allocUnsafe(null, size)
    			  };

    			  function fromString$1 (that, string, encoding) {
    			    if (typeof encoding !== 'string' || encoding === '') {
    			      encoding = 'utf8';
    			    }

    			    if (!Buffer.isEncoding(encoding)) {
    			      throw new TypeError('"encoding" must be a valid string encoding')
    			    }

    			    var length = byteLength(string, encoding) | 0;
    			    that = createBuffer(that, length);

    			    var actual = that.write(string, encoding);

    			    if (actual !== length) {
    			      // Writing a hex string, for example, that contains invalid characters will
    			      // cause everything after the first invalid character to be ignored. (e.g.
    			      // 'abxxcd' will be treated as 'ab')
    			      that = that.slice(0, actual);
    			    }

    			    return that
    			  }

    			  function fromArrayLike (that, array) {
    			    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    			    that = createBuffer(that, length);
    			    for (var i = 0; i < length; i += 1) {
    			      that[i] = array[i] & 255;
    			    }
    			    return that
    			  }

    			  function fromArrayBuffer (that, array, byteOffset, length) {
    			    array.byteLength; // this throws if `array` is not a valid ArrayBuffer

    			    if (byteOffset < 0 || array.byteLength < byteOffset) {
    			      throw new RangeError('\'offset\' is out of bounds')
    			    }

    			    if (array.byteLength < byteOffset + (length || 0)) {
    			      throw new RangeError('\'length\' is out of bounds')
    			    }

    			    if (byteOffset === undefined && length === undefined) {
    			      array = new Uint8Array(array);
    			    } else if (length === undefined) {
    			      array = new Uint8Array(array, byteOffset);
    			    } else {
    			      array = new Uint8Array(array, byteOffset, length);
    			    }

    			    if (Buffer.TYPED_ARRAY_SUPPORT) {
    			      // Return an augmented `Uint8Array` instance, for best performance
    			      that = array;
    			      that.__proto__ = Buffer.prototype;
    			    } else {
    			      // Fallback: Return an object instance of the Buffer class
    			      that = fromArrayLike(that, array);
    			    }
    			    return that
    			  }

    			  function fromObject (that, obj) {
    			    if (internalIsBuffer(obj)) {
    			      var len = checked(obj.length) | 0;
    			      that = createBuffer(that, len);

    			      if (that.length === 0) {
    			        return that
    			      }

    			      obj.copy(that, 0, 0, len);
    			      return that
    			    }

    			    if (obj) {
    			      if ((typeof ArrayBuffer !== 'undefined' &&
    			          obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
    			        if (typeof obj.length !== 'number' || isnan(obj.length)) {
    			          return createBuffer(that, 0)
    			        }
    			        return fromArrayLike(that, obj)
    			      }

    			      if (obj.type === 'Buffer' && isArray(obj.data)) {
    			        return fromArrayLike(that, obj.data)
    			      }
    			    }

    			    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
    			  }

    			  function checked (length) {
    			    // Note: cannot use `length < kMaxLength()` here because that fails when
    			    // length is NaN (which is otherwise coerced to zero.)
    			    if (length >= kMaxLength()) {
    			      throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
    			                           'size: 0x' + kMaxLength().toString(16) + ' bytes')
    			    }
    			    return length | 0
    			  }

    			  function SlowBuffer (length) {
    			    if (+length != length) { // eslint-disable-line eqeqeq
    			      length = 0;
    			    }
    			    return Buffer.alloc(+length)
    			  }
    			  Buffer.isBuffer = isBuffer;
    			  function internalIsBuffer (b) {
    			    return !!(b != null && b._isBuffer)
    			  }

    			  Buffer.compare = function compare (a, b) {
    			    if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
    			      throw new TypeError('Arguments must be Buffers')
    			    }

    			    if (a === b) return 0

    			    var x = a.length;
    			    var y = b.length;

    			    for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    			      if (a[i] !== b[i]) {
    			        x = a[i];
    			        y = b[i];
    			        break
    			      }
    			    }

    			    if (x < y) return -1
    			    if (y < x) return 1
    			    return 0
    			  };

    			  Buffer.isEncoding = function isEncoding (encoding) {
    			    switch (String(encoding).toLowerCase()) {
    			      case 'hex':
    			      case 'utf8':
    			      case 'utf-8':
    			      case 'ascii':
    			      case 'latin1':
    			      case 'binary':
    			      case 'base64':
    			      case 'ucs2':
    			      case 'ucs-2':
    			      case 'utf16le':
    			      case 'utf-16le':
    			        return true
    			      default:
    			        return false
    			    }
    			  };

    			  Buffer.concat = function concat (list, length) {
    			    if (!isArray(list)) {
    			      throw new TypeError('"list" argument must be an Array of Buffers')
    			    }

    			    if (list.length === 0) {
    			      return Buffer.alloc(0)
    			    }

    			    var i;
    			    if (length === undefined) {
    			      length = 0;
    			      for (i = 0; i < list.length; ++i) {
    			        length += list[i].length;
    			      }
    			    }

    			    var buffer = Buffer.allocUnsafe(length);
    			    var pos = 0;
    			    for (i = 0; i < list.length; ++i) {
    			      var buf = list[i];
    			      if (!internalIsBuffer(buf)) {
    			        throw new TypeError('"list" argument must be an Array of Buffers')
    			      }
    			      buf.copy(buffer, pos);
    			      pos += buf.length;
    			    }
    			    return buffer
    			  };

    			  function byteLength (string, encoding) {
    			    if (internalIsBuffer(string)) {
    			      return string.length
    			    }
    			    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
    			        (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    			      return string.byteLength
    			    }
    			    if (typeof string !== 'string') {
    			      string = '' + string;
    			    }

    			    var len = string.length;
    			    if (len === 0) return 0

    			    // Use a for loop to avoid recursion
    			    var loweredCase = false;
    			    for (;;) {
    			      switch (encoding) {
    			        case 'ascii':
    			        case 'latin1':
    			        case 'binary':
    			          return len
    			        case 'utf8':
    			        case 'utf-8':
    			        case undefined:
    			          return utf8ToBytes(string).length
    			        case 'ucs2':
    			        case 'ucs-2':
    			        case 'utf16le':
    			        case 'utf-16le':
    			          return len * 2
    			        case 'hex':
    			          return len >>> 1
    			        case 'base64':
    			          return base64ToBytes(string).length
    			        default:
    			          if (loweredCase) return utf8ToBytes(string).length // assume utf8
    			          encoding = ('' + encoding).toLowerCase();
    			          loweredCase = true;
    			      }
    			    }
    			  }
    			  Buffer.byteLength = byteLength;

    			  function slowToString (encoding, start, end) {
    			    var loweredCase = false;

    			    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    			    // property of a typed array.

    			    // This behaves neither like String nor Uint8Array in that we set start/end
    			    // to their upper/lower bounds if the value passed is out of range.
    			    // undefined is handled specially as per ECMA-262 6th Edition,
    			    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    			    if (start === undefined || start < 0) {
    			      start = 0;
    			    }
    			    // Return early if start > this.length. Done here to prevent potential uint32
    			    // coercion fail below.
    			    if (start > this.length) {
    			      return ''
    			    }

    			    if (end === undefined || end > this.length) {
    			      end = this.length;
    			    }

    			    if (end <= 0) {
    			      return ''
    			    }

    			    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    			    end >>>= 0;
    			    start >>>= 0;

    			    if (end <= start) {
    			      return ''
    			    }

    			    if (!encoding) encoding = 'utf8';

    			    while (true) {
    			      switch (encoding) {
    			        case 'hex':
    			          return hexSlice(this, start, end)

    			        case 'utf8':
    			        case 'utf-8':
    			          return utf8Slice(this, start, end)

    			        case 'ascii':
    			          return asciiSlice(this, start, end)

    			        case 'latin1':
    			        case 'binary':
    			          return latin1Slice(this, start, end)

    			        case 'base64':
    			          return base64Slice(this, start, end)

    			        case 'ucs2':
    			        case 'ucs-2':
    			        case 'utf16le':
    			        case 'utf-16le':
    			          return utf16leSlice(this, start, end)

    			        default:
    			          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
    			          encoding = (encoding + '').toLowerCase();
    			          loweredCase = true;
    			      }
    			    }
    			  }

    			  // The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
    			  // Buffer instances.
    			  Buffer.prototype._isBuffer = true;

    			  function swap (b, n, m) {
    			    var i = b[n];
    			    b[n] = b[m];
    			    b[m] = i;
    			  }

    			  Buffer.prototype.swap16 = function swap16 () {
    			    var len = this.length;
    			    if (len % 2 !== 0) {
    			      throw new RangeError('Buffer size must be a multiple of 16-bits')
    			    }
    			    for (var i = 0; i < len; i += 2) {
    			      swap(this, i, i + 1);
    			    }
    			    return this
    			  };

    			  Buffer.prototype.swap32 = function swap32 () {
    			    var len = this.length;
    			    if (len % 4 !== 0) {
    			      throw new RangeError('Buffer size must be a multiple of 32-bits')
    			    }
    			    for (var i = 0; i < len; i += 4) {
    			      swap(this, i, i + 3);
    			      swap(this, i + 1, i + 2);
    			    }
    			    return this
    			  };

    			  Buffer.prototype.swap64 = function swap64 () {
    			    var len = this.length;
    			    if (len % 8 !== 0) {
    			      throw new RangeError('Buffer size must be a multiple of 64-bits')
    			    }
    			    for (var i = 0; i < len; i += 8) {
    			      swap(this, i, i + 7);
    			      swap(this, i + 1, i + 6);
    			      swap(this, i + 2, i + 5);
    			      swap(this, i + 3, i + 4);
    			    }
    			    return this
    			  };

    			  Buffer.prototype.toString = function toString () {
    			    var length = this.length | 0;
    			    if (length === 0) return ''
    			    if (arguments.length === 0) return utf8Slice(this, 0, length)
    			    return slowToString.apply(this, arguments)
    			  };

    			  Buffer.prototype.equals = function equals (b) {
    			    if (!internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer')
    			    if (this === b) return true
    			    return Buffer.compare(this, b) === 0
    			  };

    			  Buffer.prototype.inspect = function inspect () {
    			    var str = '';
    			    var max = INSPECT_MAX_BYTES;
    			    if (this.length > 0) {
    			      str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
    			      if (this.length > max) str += ' ... ';
    			    }
    			    return '<Buffer ' + str + '>'
    			  };

    			  Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
    			    if (!internalIsBuffer(target)) {
    			      throw new TypeError('Argument must be a Buffer')
    			    }

    			    if (start === undefined) {
    			      start = 0;
    			    }
    			    if (end === undefined) {
    			      end = target ? target.length : 0;
    			    }
    			    if (thisStart === undefined) {
    			      thisStart = 0;
    			    }
    			    if (thisEnd === undefined) {
    			      thisEnd = this.length;
    			    }

    			    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    			      throw new RangeError('out of range index')
    			    }

    			    if (thisStart >= thisEnd && start >= end) {
    			      return 0
    			    }
    			    if (thisStart >= thisEnd) {
    			      return -1
    			    }
    			    if (start >= end) {
    			      return 1
    			    }

    			    start >>>= 0;
    			    end >>>= 0;
    			    thisStart >>>= 0;
    			    thisEnd >>>= 0;

    			    if (this === target) return 0

    			    var x = thisEnd - thisStart;
    			    var y = end - start;
    			    var len = Math.min(x, y);

    			    var thisCopy = this.slice(thisStart, thisEnd);
    			    var targetCopy = target.slice(start, end);

    			    for (var i = 0; i < len; ++i) {
    			      if (thisCopy[i] !== targetCopy[i]) {
    			        x = thisCopy[i];
    			        y = targetCopy[i];
    			        break
    			      }
    			    }

    			    if (x < y) return -1
    			    if (y < x) return 1
    			    return 0
    			  };

    			  // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    			  // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    			  //
    			  // Arguments:
    			  // - buffer - a Buffer to search
    			  // - val - a string, Buffer, or number
    			  // - byteOffset - an index into `buffer`; will be clamped to an int32
    			  // - encoding - an optional encoding, relevant is val is a string
    			  // - dir - true for indexOf, false for lastIndexOf
    			  function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
    			    // Empty buffer means no match
    			    if (buffer.length === 0) return -1

    			    // Normalize byteOffset
    			    if (typeof byteOffset === 'string') {
    			      encoding = byteOffset;
    			      byteOffset = 0;
    			    } else if (byteOffset > 0x7fffffff) {
    			      byteOffset = 0x7fffffff;
    			    } else if (byteOffset < -0x80000000) {
    			      byteOffset = -0x80000000;
    			    }
    			    byteOffset = +byteOffset;  // Coerce to Number.
    			    if (isNaN(byteOffset)) {
    			      // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    			      byteOffset = dir ? 0 : (buffer.length - 1);
    			    }

    			    // Normalize byteOffset: negative offsets start from the end of the buffer
    			    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    			    if (byteOffset >= buffer.length) {
    			      if (dir) return -1
    			      else byteOffset = buffer.length - 1;
    			    } else if (byteOffset < 0) {
    			      if (dir) byteOffset = 0;
    			      else return -1
    			    }

    			    // Normalize val
    			    if (typeof val === 'string') {
    			      val = Buffer.from(val, encoding);
    			    }

    			    // Finally, search either indexOf (if dir is true) or lastIndexOf
    			    if (internalIsBuffer(val)) {
    			      // Special case: looking for empty string/buffer always fails
    			      if (val.length === 0) {
    			        return -1
    			      }
    			      return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
    			    } else if (typeof val === 'number') {
    			      val = val & 0xFF; // Search for a byte value [0-255]
    			      if (Buffer.TYPED_ARRAY_SUPPORT &&
    			          typeof Uint8Array.prototype.indexOf === 'function') {
    			        if (dir) {
    			          return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
    			        } else {
    			          return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
    			        }
    			      }
    			      return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
    			    }

    			    throw new TypeError('val must be string, number or Buffer')
    			  }

    			  function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
    			    var indexSize = 1;
    			    var arrLength = arr.length;
    			    var valLength = val.length;

    			    if (encoding !== undefined) {
    			      encoding = String(encoding).toLowerCase();
    			      if (encoding === 'ucs2' || encoding === 'ucs-2' ||
    			          encoding === 'utf16le' || encoding === 'utf-16le') {
    			        if (arr.length < 2 || val.length < 2) {
    			          return -1
    			        }
    			        indexSize = 2;
    			        arrLength /= 2;
    			        valLength /= 2;
    			        byteOffset /= 2;
    			      }
    			    }

    			    function read (buf, i) {
    			      if (indexSize === 1) {
    			        return buf[i]
    			      } else {
    			        return buf.readUInt16BE(i * indexSize)
    			      }
    			    }

    			    var i;
    			    if (dir) {
    			      var foundIndex = -1;
    			      for (i = byteOffset; i < arrLength; i++) {
    			        if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
    			          if (foundIndex === -1) foundIndex = i;
    			          if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
    			        } else {
    			          if (foundIndex !== -1) i -= i - foundIndex;
    			          foundIndex = -1;
    			        }
    			      }
    			    } else {
    			      if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    			      for (i = byteOffset; i >= 0; i--) {
    			        var found = true;
    			        for (var j = 0; j < valLength; j++) {
    			          if (read(arr, i + j) !== read(val, j)) {
    			            found = false;
    			            break
    			          }
    			        }
    			        if (found) return i
    			      }
    			    }

    			    return -1
    			  }

    			  Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
    			    return this.indexOf(val, byteOffset, encoding) !== -1
    			  };

    			  Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
    			    return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
    			  };

    			  Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
    			    return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
    			  };

    			  function hexWrite (buf, string, offset, length) {
    			    offset = Number(offset) || 0;
    			    var remaining = buf.length - offset;
    			    if (!length) {
    			      length = remaining;
    			    } else {
    			      length = Number(length);
    			      if (length > remaining) {
    			        length = remaining;
    			      }
    			    }

    			    // must be an even number of digits
    			    var strLen = string.length;
    			    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

    			    if (length > strLen / 2) {
    			      length = strLen / 2;
    			    }
    			    for (var i = 0; i < length; ++i) {
    			      var parsed = parseInt(string.substr(i * 2, 2), 16);
    			      if (isNaN(parsed)) return i
    			      buf[offset + i] = parsed;
    			    }
    			    return i
    			  }

    			  function utf8Write (buf, string, offset, length) {
    			    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
    			  }

    			  function asciiWrite (buf, string, offset, length) {
    			    return blitBuffer(asciiToBytes(string), buf, offset, length)
    			  }

    			  function latin1Write (buf, string, offset, length) {
    			    return asciiWrite(buf, string, offset, length)
    			  }

    			  function base64Write (buf, string, offset, length) {
    			    return blitBuffer(base64ToBytes(string), buf, offset, length)
    			  }

    			  function ucs2Write (buf, string, offset, length) {
    			    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
    			  }

    			  Buffer.prototype.write = function write (string, offset, length, encoding) {
    			    // Buffer#write(string)
    			    if (offset === undefined) {
    			      encoding = 'utf8';
    			      length = this.length;
    			      offset = 0;
    			    // Buffer#write(string, encoding)
    			    } else if (length === undefined && typeof offset === 'string') {
    			      encoding = offset;
    			      length = this.length;
    			      offset = 0;
    			    // Buffer#write(string, offset[, length][, encoding])
    			    } else if (isFinite(offset)) {
    			      offset = offset | 0;
    			      if (isFinite(length)) {
    			        length = length | 0;
    			        if (encoding === undefined) encoding = 'utf8';
    			      } else {
    			        encoding = length;
    			        length = undefined;
    			      }
    			    // legacy write(string, encoding, offset, length) - remove in v0.13
    			    } else {
    			      throw new Error(
    			        'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    			      )
    			    }

    			    var remaining = this.length - offset;
    			    if (length === undefined || length > remaining) length = remaining;

    			    if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    			      throw new RangeError('Attempt to write outside buffer bounds')
    			    }

    			    if (!encoding) encoding = 'utf8';

    			    var loweredCase = false;
    			    for (;;) {
    			      switch (encoding) {
    			        case 'hex':
    			          return hexWrite(this, string, offset, length)

    			        case 'utf8':
    			        case 'utf-8':
    			          return utf8Write(this, string, offset, length)

    			        case 'ascii':
    			          return asciiWrite(this, string, offset, length)

    			        case 'latin1':
    			        case 'binary':
    			          return latin1Write(this, string, offset, length)

    			        case 'base64':
    			          // Warning: maxLength not taken into account in base64Write
    			          return base64Write(this, string, offset, length)

    			        case 'ucs2':
    			        case 'ucs-2':
    			        case 'utf16le':
    			        case 'utf-16le':
    			          return ucs2Write(this, string, offset, length)

    			        default:
    			          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
    			          encoding = ('' + encoding).toLowerCase();
    			          loweredCase = true;
    			      }
    			    }
    			  };

    			  Buffer.prototype.toJSON = function toJSON () {
    			    return {
    			      type: 'Buffer',
    			      data: Array.prototype.slice.call(this._arr || this, 0)
    			    }
    			  };

    			  function base64Slice (buf, start, end) {
    			    if (start === 0 && end === buf.length) {
    			      return fromByteArray(buf)
    			    } else {
    			      return fromByteArray(buf.slice(start, end))
    			    }
    			  }

    			  function utf8Slice (buf, start, end) {
    			    end = Math.min(buf.length, end);
    			    var res = [];

    			    var i = start;
    			    while (i < end) {
    			      var firstByte = buf[i];
    			      var codePoint = null;
    			      var bytesPerSequence = (firstByte > 0xEF) ? 4
    			        : (firstByte > 0xDF) ? 3
    			        : (firstByte > 0xBF) ? 2
    			        : 1;

    			      if (i + bytesPerSequence <= end) {
    			        var secondByte, thirdByte, fourthByte, tempCodePoint;

    			        switch (bytesPerSequence) {
    			          case 1:
    			            if (firstByte < 0x80) {
    			              codePoint = firstByte;
    			            }
    			            break
    			          case 2:
    			            secondByte = buf[i + 1];
    			            if ((secondByte & 0xC0) === 0x80) {
    			              tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
    			              if (tempCodePoint > 0x7F) {
    			                codePoint = tempCodePoint;
    			              }
    			            }
    			            break
    			          case 3:
    			            secondByte = buf[i + 1];
    			            thirdByte = buf[i + 2];
    			            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
    			              tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
    			              if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
    			                codePoint = tempCodePoint;
    			              }
    			            }
    			            break
    			          case 4:
    			            secondByte = buf[i + 1];
    			            thirdByte = buf[i + 2];
    			            fourthByte = buf[i + 3];
    			            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
    			              tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
    			              if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
    			                codePoint = tempCodePoint;
    			              }
    			            }
    			        }
    			      }

    			      if (codePoint === null) {
    			        // we did not generate a valid codePoint so insert a
    			        // replacement char (U+FFFD) and advance only 1 byte
    			        codePoint = 0xFFFD;
    			        bytesPerSequence = 1;
    			      } else if (codePoint > 0xFFFF) {
    			        // encode to utf16 (surrogate pair dance)
    			        codePoint -= 0x10000;
    			        res.push(codePoint >>> 10 & 0x3FF | 0xD800);
    			        codePoint = 0xDC00 | codePoint & 0x3FF;
    			      }

    			      res.push(codePoint);
    			      i += bytesPerSequence;
    			    }

    			    return decodeCodePointsArray(res)
    			  }

    			  // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    			  // the lowest limit is Chrome, with 0x10000 args.
    			  // We go 1 magnitude less, for safety
    			  var MAX_ARGUMENTS_LENGTH = 0x1000;

    			  function decodeCodePointsArray (codePoints) {
    			    var len = codePoints.length;
    			    if (len <= MAX_ARGUMENTS_LENGTH) {
    			      return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    			    }

    			    // Decode in chunks to avoid "call stack size exceeded".
    			    var res = '';
    			    var i = 0;
    			    while (i < len) {
    			      res += String.fromCharCode.apply(
    			        String,
    			        codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    			      );
    			    }
    			    return res
    			  }

    			  function asciiSlice (buf, start, end) {
    			    var ret = '';
    			    end = Math.min(buf.length, end);

    			    for (var i = start; i < end; ++i) {
    			      ret += String.fromCharCode(buf[i] & 0x7F);
    			    }
    			    return ret
    			  }

    			  function latin1Slice (buf, start, end) {
    			    var ret = '';
    			    end = Math.min(buf.length, end);

    			    for (var i = start; i < end; ++i) {
    			      ret += String.fromCharCode(buf[i]);
    			    }
    			    return ret
    			  }

    			  function hexSlice (buf, start, end) {
    			    var len = buf.length;

    			    if (!start || start < 0) start = 0;
    			    if (!end || end < 0 || end > len) end = len;

    			    var out = '';
    			    for (var i = start; i < end; ++i) {
    			      out += toHex(buf[i]);
    			    }
    			    return out
    			  }

    			  function utf16leSlice (buf, start, end) {
    			    var bytes = buf.slice(start, end);
    			    var res = '';
    			    for (var i = 0; i < bytes.length; i += 2) {
    			      res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    			    }
    			    return res
    			  }

    			  Buffer.prototype.slice = function slice (start, end) {
    			    var len = this.length;
    			    start = ~~start;
    			    end = end === undefined ? len : ~~end;

    			    if (start < 0) {
    			      start += len;
    			      if (start < 0) start = 0;
    			    } else if (start > len) {
    			      start = len;
    			    }

    			    if (end < 0) {
    			      end += len;
    			      if (end < 0) end = 0;
    			    } else if (end > len) {
    			      end = len;
    			    }

    			    if (end < start) end = start;

    			    var newBuf;
    			    if (Buffer.TYPED_ARRAY_SUPPORT) {
    			      newBuf = this.subarray(start, end);
    			      newBuf.__proto__ = Buffer.prototype;
    			    } else {
    			      var sliceLen = end - start;
    			      newBuf = new Buffer(sliceLen, undefined);
    			      for (var i = 0; i < sliceLen; ++i) {
    			        newBuf[i] = this[i + start];
    			      }
    			    }

    			    return newBuf
    			  };

    			  /*
    			   * Need to make sure that buffer isn't trying to write out of bounds.
    			   */
    			  function checkOffset (offset, ext, length) {
    			    if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
    			    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
    			  }

    			  Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
    			    offset = offset | 0;
    			    byteLength = byteLength | 0;
    			    if (!noAssert) checkOffset(offset, byteLength, this.length);

    			    var val = this[offset];
    			    var mul = 1;
    			    var i = 0;
    			    while (++i < byteLength && (mul *= 0x100)) {
    			      val += this[offset + i] * mul;
    			    }

    			    return val
    			  };

    			  Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
    			    offset = offset | 0;
    			    byteLength = byteLength | 0;
    			    if (!noAssert) {
    			      checkOffset(offset, byteLength, this.length);
    			    }

    			    var val = this[offset + --byteLength];
    			    var mul = 1;
    			    while (byteLength > 0 && (mul *= 0x100)) {
    			      val += this[offset + --byteLength] * mul;
    			    }

    			    return val
    			  };

    			  Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
    			    if (!noAssert) checkOffset(offset, 1, this.length);
    			    return this[offset]
    			  };

    			  Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
    			    if (!noAssert) checkOffset(offset, 2, this.length);
    			    return this[offset] | (this[offset + 1] << 8)
    			  };

    			  Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
    			    if (!noAssert) checkOffset(offset, 2, this.length);
    			    return (this[offset] << 8) | this[offset + 1]
    			  };

    			  Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
    			    if (!noAssert) checkOffset(offset, 4, this.length);

    			    return ((this[offset]) |
    			        (this[offset + 1] << 8) |
    			        (this[offset + 2] << 16)) +
    			        (this[offset + 3] * 0x1000000)
    			  };

    			  Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
    			    if (!noAssert) checkOffset(offset, 4, this.length);

    			    return (this[offset] * 0x1000000) +
    			      ((this[offset + 1] << 16) |
    			      (this[offset + 2] << 8) |
    			      this[offset + 3])
    			  };

    			  Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
    			    offset = offset | 0;
    			    byteLength = byteLength | 0;
    			    if (!noAssert) checkOffset(offset, byteLength, this.length);

    			    var val = this[offset];
    			    var mul = 1;
    			    var i = 0;
    			    while (++i < byteLength && (mul *= 0x100)) {
    			      val += this[offset + i] * mul;
    			    }
    			    mul *= 0x80;

    			    if (val >= mul) val -= Math.pow(2, 8 * byteLength);

    			    return val
    			  };

    			  Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
    			    offset = offset | 0;
    			    byteLength = byteLength | 0;
    			    if (!noAssert) checkOffset(offset, byteLength, this.length);

    			    var i = byteLength;
    			    var mul = 1;
    			    var val = this[offset + --i];
    			    while (i > 0 && (mul *= 0x100)) {
    			      val += this[offset + --i] * mul;
    			    }
    			    mul *= 0x80;

    			    if (val >= mul) val -= Math.pow(2, 8 * byteLength);

    			    return val
    			  };

    			  Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
    			    if (!noAssert) checkOffset(offset, 1, this.length);
    			    if (!(this[offset] & 0x80)) return (this[offset])
    			    return ((0xff - this[offset] + 1) * -1)
    			  };

    			  Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
    			    if (!noAssert) checkOffset(offset, 2, this.length);
    			    var val = this[offset] | (this[offset + 1] << 8);
    			    return (val & 0x8000) ? val | 0xFFFF0000 : val
    			  };

    			  Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
    			    if (!noAssert) checkOffset(offset, 2, this.length);
    			    var val = this[offset + 1] | (this[offset] << 8);
    			    return (val & 0x8000) ? val | 0xFFFF0000 : val
    			  };

    			  Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
    			    if (!noAssert) checkOffset(offset, 4, this.length);

    			    return (this[offset]) |
    			      (this[offset + 1] << 8) |
    			      (this[offset + 2] << 16) |
    			      (this[offset + 3] << 24)
    			  };

    			  Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
    			    if (!noAssert) checkOffset(offset, 4, this.length);

    			    return (this[offset] << 24) |
    			      (this[offset + 1] << 16) |
    			      (this[offset + 2] << 8) |
    			      (this[offset + 3])
    			  };

    			  Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
    			    if (!noAssert) checkOffset(offset, 4, this.length);
    			    return read(this, offset, true, 23, 4)
    			  };

    			  Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
    			    if (!noAssert) checkOffset(offset, 4, this.length);
    			    return read(this, offset, false, 23, 4)
    			  };

    			  Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
    			    if (!noAssert) checkOffset(offset, 8, this.length);
    			    return read(this, offset, true, 52, 8)
    			  };

    			  Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
    			    if (!noAssert) checkOffset(offset, 8, this.length);
    			    return read(this, offset, false, 52, 8)
    			  };

    			  function checkInt (buf, value, offset, ext, max, min) {
    			    if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
    			    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
    			    if (offset + ext > buf.length) throw new RangeError('Index out of range')
    			  }

    			  Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
    			    value = +value;
    			    offset = offset | 0;
    			    byteLength = byteLength | 0;
    			    if (!noAssert) {
    			      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    			      checkInt(this, value, offset, byteLength, maxBytes, 0);
    			    }

    			    var mul = 1;
    			    var i = 0;
    			    this[offset] = value & 0xFF;
    			    while (++i < byteLength && (mul *= 0x100)) {
    			      this[offset + i] = (value / mul) & 0xFF;
    			    }

    			    return offset + byteLength
    			  };

    			  Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
    			    value = +value;
    			    offset = offset | 0;
    			    byteLength = byteLength | 0;
    			    if (!noAssert) {
    			      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    			      checkInt(this, value, offset, byteLength, maxBytes, 0);
    			    }

    			    var i = byteLength - 1;
    			    var mul = 1;
    			    this[offset + i] = value & 0xFF;
    			    while (--i >= 0 && (mul *= 0x100)) {
    			      this[offset + i] = (value / mul) & 0xFF;
    			    }

    			    return offset + byteLength
    			  };

    			  Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
    			    value = +value;
    			    offset = offset | 0;
    			    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    			    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    			    this[offset] = (value & 0xff);
    			    return offset + 1
    			  };

    			  function objectWriteUInt16 (buf, value, offset, littleEndian) {
    			    if (value < 0) value = 0xffff + value + 1;
    			    for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    			      buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
    			        (littleEndian ? i : 1 - i) * 8;
    			    }
    			  }

    			  Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
    			    value = +value;
    			    offset = offset | 0;
    			    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    			    if (Buffer.TYPED_ARRAY_SUPPORT) {
    			      this[offset] = (value & 0xff);
    			      this[offset + 1] = (value >>> 8);
    			    } else {
    			      objectWriteUInt16(this, value, offset, true);
    			    }
    			    return offset + 2
    			  };

    			  Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
    			    value = +value;
    			    offset = offset | 0;
    			    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    			    if (Buffer.TYPED_ARRAY_SUPPORT) {
    			      this[offset] = (value >>> 8);
    			      this[offset + 1] = (value & 0xff);
    			    } else {
    			      objectWriteUInt16(this, value, offset, false);
    			    }
    			    return offset + 2
    			  };

    			  function objectWriteUInt32 (buf, value, offset, littleEndian) {
    			    if (value < 0) value = 0xffffffff + value + 1;
    			    for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    			      buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff;
    			    }
    			  }

    			  Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
    			    value = +value;
    			    offset = offset | 0;
    			    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    			    if (Buffer.TYPED_ARRAY_SUPPORT) {
    			      this[offset + 3] = (value >>> 24);
    			      this[offset + 2] = (value >>> 16);
    			      this[offset + 1] = (value >>> 8);
    			      this[offset] = (value & 0xff);
    			    } else {
    			      objectWriteUInt32(this, value, offset, true);
    			    }
    			    return offset + 4
    			  };

    			  Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
    			    value = +value;
    			    offset = offset | 0;
    			    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    			    if (Buffer.TYPED_ARRAY_SUPPORT) {
    			      this[offset] = (value >>> 24);
    			      this[offset + 1] = (value >>> 16);
    			      this[offset + 2] = (value >>> 8);
    			      this[offset + 3] = (value & 0xff);
    			    } else {
    			      objectWriteUInt32(this, value, offset, false);
    			    }
    			    return offset + 4
    			  };

    			  Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
    			    value = +value;
    			    offset = offset | 0;
    			    if (!noAssert) {
    			      var limit = Math.pow(2, 8 * byteLength - 1);

    			      checkInt(this, value, offset, byteLength, limit - 1, -limit);
    			    }

    			    var i = 0;
    			    var mul = 1;
    			    var sub = 0;
    			    this[offset] = value & 0xFF;
    			    while (++i < byteLength && (mul *= 0x100)) {
    			      if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
    			        sub = 1;
    			      }
    			      this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
    			    }

    			    return offset + byteLength
    			  };

    			  Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
    			    value = +value;
    			    offset = offset | 0;
    			    if (!noAssert) {
    			      var limit = Math.pow(2, 8 * byteLength - 1);

    			      checkInt(this, value, offset, byteLength, limit - 1, -limit);
    			    }

    			    var i = byteLength - 1;
    			    var mul = 1;
    			    var sub = 0;
    			    this[offset + i] = value & 0xFF;
    			    while (--i >= 0 && (mul *= 0x100)) {
    			      if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
    			        sub = 1;
    			      }
    			      this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
    			    }

    			    return offset + byteLength
    			  };

    			  Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
    			    value = +value;
    			    offset = offset | 0;
    			    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
    			    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    			    if (value < 0) value = 0xff + value + 1;
    			    this[offset] = (value & 0xff);
    			    return offset + 1
    			  };

    			  Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
    			    value = +value;
    			    offset = offset | 0;
    			    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    			    if (Buffer.TYPED_ARRAY_SUPPORT) {
    			      this[offset] = (value & 0xff);
    			      this[offset + 1] = (value >>> 8);
    			    } else {
    			      objectWriteUInt16(this, value, offset, true);
    			    }
    			    return offset + 2
    			  };

    			  Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
    			    value = +value;
    			    offset = offset | 0;
    			    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    			    if (Buffer.TYPED_ARRAY_SUPPORT) {
    			      this[offset] = (value >>> 8);
    			      this[offset + 1] = (value & 0xff);
    			    } else {
    			      objectWriteUInt16(this, value, offset, false);
    			    }
    			    return offset + 2
    			  };

    			  Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
    			    value = +value;
    			    offset = offset | 0;
    			    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    			    if (Buffer.TYPED_ARRAY_SUPPORT) {
    			      this[offset] = (value & 0xff);
    			      this[offset + 1] = (value >>> 8);
    			      this[offset + 2] = (value >>> 16);
    			      this[offset + 3] = (value >>> 24);
    			    } else {
    			      objectWriteUInt32(this, value, offset, true);
    			    }
    			    return offset + 4
    			  };

    			  Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
    			    value = +value;
    			    offset = offset | 0;
    			    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    			    if (value < 0) value = 0xffffffff + value + 1;
    			    if (Buffer.TYPED_ARRAY_SUPPORT) {
    			      this[offset] = (value >>> 24);
    			      this[offset + 1] = (value >>> 16);
    			      this[offset + 2] = (value >>> 8);
    			      this[offset + 3] = (value & 0xff);
    			    } else {
    			      objectWriteUInt32(this, value, offset, false);
    			    }
    			    return offset + 4
    			  };

    			  function checkIEEE754 (buf, value, offset, ext, max, min) {
    			    if (offset + ext > buf.length) throw new RangeError('Index out of range')
    			    if (offset < 0) throw new RangeError('Index out of range')
    			  }

    			  function writeFloat (buf, value, offset, littleEndian, noAssert) {
    			    if (!noAssert) {
    			      checkIEEE754(buf, value, offset, 4);
    			    }
    			    write(buf, value, offset, littleEndian, 23, 4);
    			    return offset + 4
    			  }

    			  Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
    			    return writeFloat(this, value, offset, true, noAssert)
    			  };

    			  Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
    			    return writeFloat(this, value, offset, false, noAssert)
    			  };

    			  function writeDouble (buf, value, offset, littleEndian, noAssert) {
    			    if (!noAssert) {
    			      checkIEEE754(buf, value, offset, 8);
    			    }
    			    write(buf, value, offset, littleEndian, 52, 8);
    			    return offset + 8
    			  }

    			  Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
    			    return writeDouble(this, value, offset, true, noAssert)
    			  };

    			  Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
    			    return writeDouble(this, value, offset, false, noAssert)
    			  };

    			  // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    			  Buffer.prototype.copy = function copy (target, targetStart, start, end) {
    			    if (!start) start = 0;
    			    if (!end && end !== 0) end = this.length;
    			    if (targetStart >= target.length) targetStart = target.length;
    			    if (!targetStart) targetStart = 0;
    			    if (end > 0 && end < start) end = start;

    			    // Copy 0 bytes; we're done
    			    if (end === start) return 0
    			    if (target.length === 0 || this.length === 0) return 0

    			    // Fatal error conditions
    			    if (targetStart < 0) {
    			      throw new RangeError('targetStart out of bounds')
    			    }
    			    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
    			    if (end < 0) throw new RangeError('sourceEnd out of bounds')

    			    // Are we oob?
    			    if (end > this.length) end = this.length;
    			    if (target.length - targetStart < end - start) {
    			      end = target.length - targetStart + start;
    			    }

    			    var len = end - start;
    			    var i;

    			    if (this === target && start < targetStart && targetStart < end) {
    			      // descending copy from end
    			      for (i = len - 1; i >= 0; --i) {
    			        target[i + targetStart] = this[i + start];
    			      }
    			    } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    			      // ascending copy from start
    			      for (i = 0; i < len; ++i) {
    			        target[i + targetStart] = this[i + start];
    			      }
    			    } else {
    			      Uint8Array.prototype.set.call(
    			        target,
    			        this.subarray(start, start + len),
    			        targetStart
    			      );
    			    }

    			    return len
    			  };

    			  // Usage:
    			  //    buffer.fill(number[, offset[, end]])
    			  //    buffer.fill(buffer[, offset[, end]])
    			  //    buffer.fill(string[, offset[, end]][, encoding])
    			  Buffer.prototype.fill = function fill (val, start, end, encoding) {
    			    // Handle string cases:
    			    if (typeof val === 'string') {
    			      if (typeof start === 'string') {
    			        encoding = start;
    			        start = 0;
    			        end = this.length;
    			      } else if (typeof end === 'string') {
    			        encoding = end;
    			        end = this.length;
    			      }
    			      if (val.length === 1) {
    			        var code = val.charCodeAt(0);
    			        if (code < 256) {
    			          val = code;
    			        }
    			      }
    			      if (encoding !== undefined && typeof encoding !== 'string') {
    			        throw new TypeError('encoding must be a string')
    			      }
    			      if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
    			        throw new TypeError('Unknown encoding: ' + encoding)
    			      }
    			    } else if (typeof val === 'number') {
    			      val = val & 255;
    			    }

    			    // Invalid ranges are not set to a default, so can range check early.
    			    if (start < 0 || this.length < start || this.length < end) {
    			      throw new RangeError('Out of range index')
    			    }

    			    if (end <= start) {
    			      return this
    			    }

    			    start = start >>> 0;
    			    end = end === undefined ? this.length : end >>> 0;

    			    if (!val) val = 0;

    			    var i;
    			    if (typeof val === 'number') {
    			      for (i = start; i < end; ++i) {
    			        this[i] = val;
    			      }
    			    } else {
    			      var bytes = internalIsBuffer(val)
    			        ? val
    			        : utf8ToBytes(new Buffer(val, encoding).toString());
    			      var len = bytes.length;
    			      for (i = 0; i < end - start; ++i) {
    			        this[i + start] = bytes[i % len];
    			      }
    			    }

    			    return this
    			  };

    			  // HELPER FUNCTIONS
    			  // ================

    			  var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

    			  function base64clean (str) {
    			    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    			    str = stringtrim(str).replace(INVALID_BASE64_RE, '');
    			    // Node converts strings with length < 2 to ''
    			    if (str.length < 2) return ''
    			    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    			    while (str.length % 4 !== 0) {
    			      str = str + '=';
    			    }
    			    return str
    			  }

    			  function stringtrim (str) {
    			    if (str.trim) return str.trim()
    			    return str.replace(/^\s+|\s+$/g, '')
    			  }

    			  function toHex (n) {
    			    if (n < 16) return '0' + n.toString(16)
    			    return n.toString(16)
    			  }

    			  function utf8ToBytes (string, units) {
    			    units = units || Infinity;
    			    var codePoint;
    			    var length = string.length;
    			    var leadSurrogate = null;
    			    var bytes = [];

    			    for (var i = 0; i < length; ++i) {
    			      codePoint = string.charCodeAt(i);

    			      // is surrogate component
    			      if (codePoint > 0xD7FF && codePoint < 0xE000) {
    			        // last char was a lead
    			        if (!leadSurrogate) {
    			          // no lead yet
    			          if (codePoint > 0xDBFF) {
    			            // unexpected trail
    			            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    			            continue
    			          } else if (i + 1 === length) {
    			            // unpaired lead
    			            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    			            continue
    			          }

    			          // valid lead
    			          leadSurrogate = codePoint;

    			          continue
    			        }

    			        // 2 leads in a row
    			        if (codePoint < 0xDC00) {
    			          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    			          leadSurrogate = codePoint;
    			          continue
    			        }

    			        // valid surrogate pair
    			        codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    			      } else if (leadSurrogate) {
    			        // valid bmp char, but last char was a lead
    			        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    			      }

    			      leadSurrogate = null;

    			      // encode utf8
    			      if (codePoint < 0x80) {
    			        if ((units -= 1) < 0) break
    			        bytes.push(codePoint);
    			      } else if (codePoint < 0x800) {
    			        if ((units -= 2) < 0) break
    			        bytes.push(
    			          codePoint >> 0x6 | 0xC0,
    			          codePoint & 0x3F | 0x80
    			        );
    			      } else if (codePoint < 0x10000) {
    			        if ((units -= 3) < 0) break
    			        bytes.push(
    			          codePoint >> 0xC | 0xE0,
    			          codePoint >> 0x6 & 0x3F | 0x80,
    			          codePoint & 0x3F | 0x80
    			        );
    			      } else if (codePoint < 0x110000) {
    			        if ((units -= 4) < 0) break
    			        bytes.push(
    			          codePoint >> 0x12 | 0xF0,
    			          codePoint >> 0xC & 0x3F | 0x80,
    			          codePoint >> 0x6 & 0x3F | 0x80,
    			          codePoint & 0x3F | 0x80
    			        );
    			      } else {
    			        throw new Error('Invalid code point')
    			      }
    			    }

    			    return bytes
    			  }

    			  function asciiToBytes (str) {
    			    var byteArray = [];
    			    for (var i = 0; i < str.length; ++i) {
    			      // Node's code seems to be doing this and not & 0x7F..
    			      byteArray.push(str.charCodeAt(i) & 0xFF);
    			    }
    			    return byteArray
    			  }

    			  function utf16leToBytes (str, units) {
    			    var c, hi, lo;
    			    var byteArray = [];
    			    for (var i = 0; i < str.length; ++i) {
    			      if ((units -= 2) < 0) break

    			      c = str.charCodeAt(i);
    			      hi = c >> 8;
    			      lo = c % 256;
    			      byteArray.push(lo);
    			      byteArray.push(hi);
    			    }

    			    return byteArray
    			  }


    			  function base64ToBytes (str) {
    			    return toByteArray(base64clean(str))
    			  }

    			  function blitBuffer (src, dst, offset, length) {
    			    for (var i = 0; i < length; ++i) {
    			      if ((i + offset >= dst.length) || (i >= src.length)) break
    			      dst[i + offset] = src[i];
    			    }
    			    return i
    			  }

    			  function isnan (val) {
    			    return val !== val // eslint-disable-line no-self-compare
    			  }


    			  // the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
    			  // The _isBuffer check is for Safari 5-7 support, because it's missing
    			  // Object.prototype.constructor. Remove this eventually
    			  function isBuffer(obj) {
    			    return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj))
    			  }

    			  function isFastBuffer (obj) {
    			    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
    			  }

    			  // For Node v0.10 support. Remove this eventually.
    			  function isSlowBuffer (obj) {
    			    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0))
    			  }

    			  var _polyfillNode_buffer = /*#__PURE__*/Object.freeze({
    			    __proto__: null,
    			    Buffer: Buffer,
    			    INSPECT_MAX_BYTES: INSPECT_MAX_BYTES,
    			    SlowBuffer: SlowBuffer,
    			    isBuffer: isBuffer,
    			    kMaxLength: _kMaxLength
    			  });

    			  var require$$0 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_buffer);

    			  bn.exports;

    			  (function (module) {
    			  	(function (module, exports) {

    			  	  // Utils
    			  	  function assert (val, msg) {
    			  	    if (!val) throw new Error(msg || 'Assertion failed');
    			  	  }

    			  	  // Could use `inherits` module, but don't want to move from single file
    			  	  // architecture yet.
    			  	  function inherits (ctor, superCtor) {
    			  	    ctor.super_ = superCtor;
    			  	    var TempCtor = function () {};
    			  	    TempCtor.prototype = superCtor.prototype;
    			  	    ctor.prototype = new TempCtor();
    			  	    ctor.prototype.constructor = ctor;
    			  	  }

    			  	  // BN

    			  	  function BN (number, base, endian) {
    			  	    if (BN.isBN(number)) {
    			  	      return number;
    			  	    }

    			  	    this.negative = 0;
    			  	    this.words = null;
    			  	    this.length = 0;

    			  	    // Reduction context
    			  	    this.red = null;

    			  	    if (number !== null) {
    			  	      if (base === 'le' || base === 'be') {
    			  	        endian = base;
    			  	        base = 10;
    			  	      }

    			  	      this._init(number || 0, base || 10, endian || 'be');
    			  	    }
    			  	  }
    			  	  if (typeof module === 'object') {
    			  	    module.exports = BN;
    			  	  } else {
    			  	    exports.BN = BN;
    			  	  }

    			  	  BN.BN = BN;
    			  	  BN.wordSize = 26;

    			  	  var Buffer;
    			  	  try {
    			  	    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
    			  	      Buffer = window.Buffer;
    			  	    } else {
    			  	      Buffer = require$$0.Buffer;
    			  	    }
    			  	  } catch (e) {
    			  	  }

    			  	  BN.isBN = function isBN (num) {
    			  	    if (num instanceof BN) {
    			  	      return true;
    			  	    }

    			  	    return num !== null && typeof num === 'object' &&
    			  	      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    			  	  };

    			  	  BN.max = function max (left, right) {
    			  	    if (left.cmp(right) > 0) return left;
    			  	    return right;
    			  	  };

    			  	  BN.min = function min (left, right) {
    			  	    if (left.cmp(right) < 0) return left;
    			  	    return right;
    			  	  };

    			  	  BN.prototype._init = function init (number, base, endian) {
    			  	    if (typeof number === 'number') {
    			  	      return this._initNumber(number, base, endian);
    			  	    }

    			  	    if (typeof number === 'object') {
    			  	      return this._initArray(number, base, endian);
    			  	    }

    			  	    if (base === 'hex') {
    			  	      base = 16;
    			  	    }
    			  	    assert(base === (base | 0) && base >= 2 && base <= 36);

    			  	    number = number.toString().replace(/\s+/g, '');
    			  	    var start = 0;
    			  	    if (number[0] === '-') {
    			  	      start++;
    			  	      this.negative = 1;
    			  	    }

    			  	    if (start < number.length) {
    			  	      if (base === 16) {
    			  	        this._parseHex(number, start, endian);
    			  	      } else {
    			  	        this._parseBase(number, base, start);
    			  	        if (endian === 'le') {
    			  	          this._initArray(this.toArray(), base, endian);
    			  	        }
    			  	      }
    			  	    }
    			  	  };

    			  	  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    			  	    if (number < 0) {
    			  	      this.negative = 1;
    			  	      number = -number;
    			  	    }
    			  	    if (number < 0x4000000) {
    			  	      this.words = [ number & 0x3ffffff ];
    			  	      this.length = 1;
    			  	    } else if (number < 0x10000000000000) {
    			  	      this.words = [
    			  	        number & 0x3ffffff,
    			  	        (number / 0x4000000) & 0x3ffffff
    			  	      ];
    			  	      this.length = 2;
    			  	    } else {
    			  	      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
    			  	      this.words = [
    			  	        number & 0x3ffffff,
    			  	        (number / 0x4000000) & 0x3ffffff,
    			  	        1
    			  	      ];
    			  	      this.length = 3;
    			  	    }

    			  	    if (endian !== 'le') return;

    			  	    // Reverse the bytes
    			  	    this._initArray(this.toArray(), base, endian);
    			  	  };

    			  	  BN.prototype._initArray = function _initArray (number, base, endian) {
    			  	    // Perhaps a Uint8Array
    			  	    assert(typeof number.length === 'number');
    			  	    if (number.length <= 0) {
    			  	      this.words = [ 0 ];
    			  	      this.length = 1;
    			  	      return this;
    			  	    }

    			  	    this.length = Math.ceil(number.length / 3);
    			  	    this.words = new Array(this.length);
    			  	    for (var i = 0; i < this.length; i++) {
    			  	      this.words[i] = 0;
    			  	    }

    			  	    var j, w;
    			  	    var off = 0;
    			  	    if (endian === 'be') {
    			  	      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
    			  	        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
    			  	        this.words[j] |= (w << off) & 0x3ffffff;
    			  	        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
    			  	        off += 24;
    			  	        if (off >= 26) {
    			  	          off -= 26;
    			  	          j++;
    			  	        }
    			  	      }
    			  	    } else if (endian === 'le') {
    			  	      for (i = 0, j = 0; i < number.length; i += 3) {
    			  	        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
    			  	        this.words[j] |= (w << off) & 0x3ffffff;
    			  	        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
    			  	        off += 24;
    			  	        if (off >= 26) {
    			  	          off -= 26;
    			  	          j++;
    			  	        }
    			  	      }
    			  	    }
    			  	    return this.strip();
    			  	  };

    			  	  function parseHex4Bits (string, index) {
    			  	    var c = string.charCodeAt(index);
    			  	    // 'A' - 'F'
    			  	    if (c >= 65 && c <= 70) {
    			  	      return c - 55;
    			  	    // 'a' - 'f'
    			  	    } else if (c >= 97 && c <= 102) {
    			  	      return c - 87;
    			  	    // '0' - '9'
    			  	    } else {
    			  	      return (c - 48) & 0xf;
    			  	    }
    			  	  }

    			  	  function parseHexByte (string, lowerBound, index) {
    			  	    var r = parseHex4Bits(string, index);
    			  	    if (index - 1 >= lowerBound) {
    			  	      r |= parseHex4Bits(string, index - 1) << 4;
    			  	    }
    			  	    return r;
    			  	  }

    			  	  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    			  	    // Create possibly bigger array to ensure that it fits the number
    			  	    this.length = Math.ceil((number.length - start) / 6);
    			  	    this.words = new Array(this.length);
    			  	    for (var i = 0; i < this.length; i++) {
    			  	      this.words[i] = 0;
    			  	    }

    			  	    // 24-bits chunks
    			  	    var off = 0;
    			  	    var j = 0;

    			  	    var w;
    			  	    if (endian === 'be') {
    			  	      for (i = number.length - 1; i >= start; i -= 2) {
    			  	        w = parseHexByte(number, start, i) << off;
    			  	        this.words[j] |= w & 0x3ffffff;
    			  	        if (off >= 18) {
    			  	          off -= 18;
    			  	          j += 1;
    			  	          this.words[j] |= w >>> 26;
    			  	        } else {
    			  	          off += 8;
    			  	        }
    			  	      }
    			  	    } else {
    			  	      var parseLength = number.length - start;
    			  	      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
    			  	        w = parseHexByte(number, start, i) << off;
    			  	        this.words[j] |= w & 0x3ffffff;
    			  	        if (off >= 18) {
    			  	          off -= 18;
    			  	          j += 1;
    			  	          this.words[j] |= w >>> 26;
    			  	        } else {
    			  	          off += 8;
    			  	        }
    			  	      }
    			  	    }

    			  	    this.strip();
    			  	  };

    			  	  function parseBase (str, start, end, mul) {
    			  	    var r = 0;
    			  	    var len = Math.min(str.length, end);
    			  	    for (var i = start; i < len; i++) {
    			  	      var c = str.charCodeAt(i) - 48;

    			  	      r *= mul;

    			  	      // 'a'
    			  	      if (c >= 49) {
    			  	        r += c - 49 + 0xa;

    			  	      // 'A'
    			  	      } else if (c >= 17) {
    			  	        r += c - 17 + 0xa;

    			  	      // '0' - '9'
    			  	      } else {
    			  	        r += c;
    			  	      }
    			  	    }
    			  	    return r;
    			  	  }

    			  	  BN.prototype._parseBase = function _parseBase (number, base, start) {
    			  	    // Initialize as zero
    			  	    this.words = [ 0 ];
    			  	    this.length = 1;

    			  	    // Find length of limb in base
    			  	    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
    			  	      limbLen++;
    			  	    }
    			  	    limbLen--;
    			  	    limbPow = (limbPow / base) | 0;

    			  	    var total = number.length - start;
    			  	    var mod = total % limbLen;
    			  	    var end = Math.min(total, total - mod) + start;

    			  	    var word = 0;
    			  	    for (var i = start; i < end; i += limbLen) {
    			  	      word = parseBase(number, i, i + limbLen, base);

    			  	      this.imuln(limbPow);
    			  	      if (this.words[0] + word < 0x4000000) {
    			  	        this.words[0] += word;
    			  	      } else {
    			  	        this._iaddn(word);
    			  	      }
    			  	    }

    			  	    if (mod !== 0) {
    			  	      var pow = 1;
    			  	      word = parseBase(number, i, number.length, base);

    			  	      for (i = 0; i < mod; i++) {
    			  	        pow *= base;
    			  	      }

    			  	      this.imuln(pow);
    			  	      if (this.words[0] + word < 0x4000000) {
    			  	        this.words[0] += word;
    			  	      } else {
    			  	        this._iaddn(word);
    			  	      }
    			  	    }

    			  	    this.strip();
    			  	  };

    			  	  BN.prototype.copy = function copy (dest) {
    			  	    dest.words = new Array(this.length);
    			  	    for (var i = 0; i < this.length; i++) {
    			  	      dest.words[i] = this.words[i];
    			  	    }
    			  	    dest.length = this.length;
    			  	    dest.negative = this.negative;
    			  	    dest.red = this.red;
    			  	  };

    			  	  BN.prototype.clone = function clone () {
    			  	    var r = new BN(null);
    			  	    this.copy(r);
    			  	    return r;
    			  	  };

    			  	  BN.prototype._expand = function _expand (size) {
    			  	    while (this.length < size) {
    			  	      this.words[this.length++] = 0;
    			  	    }
    			  	    return this;
    			  	  };

    			  	  // Remove leading `0` from `this`
    			  	  BN.prototype.strip = function strip () {
    			  	    while (this.length > 1 && this.words[this.length - 1] === 0) {
    			  	      this.length--;
    			  	    }
    			  	    return this._normSign();
    			  	  };

    			  	  BN.prototype._normSign = function _normSign () {
    			  	    // -0 = 0
    			  	    if (this.length === 1 && this.words[0] === 0) {
    			  	      this.negative = 0;
    			  	    }
    			  	    return this;
    			  	  };

    			  	  BN.prototype.inspect = function inspect () {
    			  	    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    			  	  };

    			  	  /*

    			  	  var zeros = [];
    			  	  var groupSizes = [];
    			  	  var groupBases = [];

    			  	  var s = '';
    			  	  var i = -1;
    			  	  while (++i < BN.wordSize) {
    			  	    zeros[i] = s;
    			  	    s += '0';
    			  	  }
    			  	  groupSizes[0] = 0;
    			  	  groupSizes[1] = 0;
    			  	  groupBases[0] = 0;
    			  	  groupBases[1] = 0;
    			  	  var base = 2 - 1;
    			  	  while (++base < 36 + 1) {
    			  	    var groupSize = 0;
    			  	    var groupBase = 1;
    			  	    while (groupBase < (1 << BN.wordSize) / base) {
    			  	      groupBase *= base;
    			  	      groupSize += 1;
    			  	    }
    			  	    groupSizes[base] = groupSize;
    			  	    groupBases[base] = groupBase;
    			  	  }

    			  	  */

    			  	  var zeros = [
    			  	    '',
    			  	    '0',
    			  	    '00',
    			  	    '000',
    			  	    '0000',
    			  	    '00000',
    			  	    '000000',
    			  	    '0000000',
    			  	    '00000000',
    			  	    '000000000',
    			  	    '0000000000',
    			  	    '00000000000',
    			  	    '000000000000',
    			  	    '0000000000000',
    			  	    '00000000000000',
    			  	    '000000000000000',
    			  	    '0000000000000000',
    			  	    '00000000000000000',
    			  	    '000000000000000000',
    			  	    '0000000000000000000',
    			  	    '00000000000000000000',
    			  	    '000000000000000000000',
    			  	    '0000000000000000000000',
    			  	    '00000000000000000000000',
    			  	    '000000000000000000000000',
    			  	    '0000000000000000000000000'
    			  	  ];

    			  	  var groupSizes = [
    			  	    0, 0,
    			  	    25, 16, 12, 11, 10, 9, 8,
    			  	    8, 7, 7, 7, 7, 6, 6,
    			  	    6, 6, 6, 6, 6, 5, 5,
    			  	    5, 5, 5, 5, 5, 5, 5,
    			  	    5, 5, 5, 5, 5, 5, 5
    			  	  ];

    			  	  var groupBases = [
    			  	    0, 0,
    			  	    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    			  	    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    			  	    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    			  	    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    			  	    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
    			  	  ];

    			  	  BN.prototype.toString = function toString (base, padding) {
    			  	    base = base || 10;
    			  	    padding = padding | 0 || 1;

    			  	    var out;
    			  	    if (base === 16 || base === 'hex') {
    			  	      out = '';
    			  	      var off = 0;
    			  	      var carry = 0;
    			  	      for (var i = 0; i < this.length; i++) {
    			  	        var w = this.words[i];
    			  	        var word = (((w << off) | carry) & 0xffffff).toString(16);
    			  	        carry = (w >>> (24 - off)) & 0xffffff;
    			  	        if (carry !== 0 || i !== this.length - 1) {
    			  	          out = zeros[6 - word.length] + word + out;
    			  	        } else {
    			  	          out = word + out;
    			  	        }
    			  	        off += 2;
    			  	        if (off >= 26) {
    			  	          off -= 26;
    			  	          i--;
    			  	        }
    			  	      }
    			  	      if (carry !== 0) {
    			  	        out = carry.toString(16) + out;
    			  	      }
    			  	      while (out.length % padding !== 0) {
    			  	        out = '0' + out;
    			  	      }
    			  	      if (this.negative !== 0) {
    			  	        out = '-' + out;
    			  	      }
    			  	      return out;
    			  	    }

    			  	    if (base === (base | 0) && base >= 2 && base <= 36) {
    			  	      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
    			  	      var groupSize = groupSizes[base];
    			  	      // var groupBase = Math.pow(base, groupSize);
    			  	      var groupBase = groupBases[base];
    			  	      out = '';
    			  	      var c = this.clone();
    			  	      c.negative = 0;
    			  	      while (!c.isZero()) {
    			  	        var r = c.modn(groupBase).toString(base);
    			  	        c = c.idivn(groupBase);

    			  	        if (!c.isZero()) {
    			  	          out = zeros[groupSize - r.length] + r + out;
    			  	        } else {
    			  	          out = r + out;
    			  	        }
    			  	      }
    			  	      if (this.isZero()) {
    			  	        out = '0' + out;
    			  	      }
    			  	      while (out.length % padding !== 0) {
    			  	        out = '0' + out;
    			  	      }
    			  	      if (this.negative !== 0) {
    			  	        out = '-' + out;
    			  	      }
    			  	      return out;
    			  	    }

    			  	    assert(false, 'Base should be between 2 and 36');
    			  	  };

    			  	  BN.prototype.toNumber = function toNumber () {
    			  	    var ret = this.words[0];
    			  	    if (this.length === 2) {
    			  	      ret += this.words[1] * 0x4000000;
    			  	    } else if (this.length === 3 && this.words[2] === 0x01) {
    			  	      // NOTE: at this stage it is known that the top bit is set
    			  	      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    			  	    } else if (this.length > 2) {
    			  	      assert(false, 'Number can only safely store up to 53 bits');
    			  	    }
    			  	    return (this.negative !== 0) ? -ret : ret;
    			  	  };

    			  	  BN.prototype.toJSON = function toJSON () {
    			  	    return this.toString(16);
    			  	  };

    			  	  BN.prototype.toBuffer = function toBuffer (endian, length) {
    			  	    assert(typeof Buffer !== 'undefined');
    			  	    return this.toArrayLike(Buffer, endian, length);
    			  	  };

    			  	  BN.prototype.toArray = function toArray (endian, length) {
    			  	    return this.toArrayLike(Array, endian, length);
    			  	  };

    			  	  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    			  	    var byteLength = this.byteLength();
    			  	    var reqLength = length || Math.max(1, byteLength);
    			  	    assert(byteLength <= reqLength, 'byte array longer than desired length');
    			  	    assert(reqLength > 0, 'Requested array length <= 0');

    			  	    this.strip();
    			  	    var littleEndian = endian === 'le';
    			  	    var res = new ArrayType(reqLength);

    			  	    var b, i;
    			  	    var q = this.clone();
    			  	    if (!littleEndian) {
    			  	      // Assume big-endian
    			  	      for (i = 0; i < reqLength - byteLength; i++) {
    			  	        res[i] = 0;
    			  	      }

    			  	      for (i = 0; !q.isZero(); i++) {
    			  	        b = q.andln(0xff);
    			  	        q.iushrn(8);

    			  	        res[reqLength - i - 1] = b;
    			  	      }
    			  	    } else {
    			  	      for (i = 0; !q.isZero(); i++) {
    			  	        b = q.andln(0xff);
    			  	        q.iushrn(8);

    			  	        res[i] = b;
    			  	      }

    			  	      for (; i < reqLength; i++) {
    			  	        res[i] = 0;
    			  	      }
    			  	    }

    			  	    return res;
    			  	  };

    			  	  if (Math.clz32) {
    			  	    BN.prototype._countBits = function _countBits (w) {
    			  	      return 32 - Math.clz32(w);
    			  	    };
    			  	  } else {
    			  	    BN.prototype._countBits = function _countBits (w) {
    			  	      var t = w;
    			  	      var r = 0;
    			  	      if (t >= 0x1000) {
    			  	        r += 13;
    			  	        t >>>= 13;
    			  	      }
    			  	      if (t >= 0x40) {
    			  	        r += 7;
    			  	        t >>>= 7;
    			  	      }
    			  	      if (t >= 0x8) {
    			  	        r += 4;
    			  	        t >>>= 4;
    			  	      }
    			  	      if (t >= 0x02) {
    			  	        r += 2;
    			  	        t >>>= 2;
    			  	      }
    			  	      return r + t;
    			  	    };
    			  	  }

    			  	  BN.prototype._zeroBits = function _zeroBits (w) {
    			  	    // Short-cut
    			  	    if (w === 0) return 26;

    			  	    var t = w;
    			  	    var r = 0;
    			  	    if ((t & 0x1fff) === 0) {
    			  	      r += 13;
    			  	      t >>>= 13;
    			  	    }
    			  	    if ((t & 0x7f) === 0) {
    			  	      r += 7;
    			  	      t >>>= 7;
    			  	    }
    			  	    if ((t & 0xf) === 0) {
    			  	      r += 4;
    			  	      t >>>= 4;
    			  	    }
    			  	    if ((t & 0x3) === 0) {
    			  	      r += 2;
    			  	      t >>>= 2;
    			  	    }
    			  	    if ((t & 0x1) === 0) {
    			  	      r++;
    			  	    }
    			  	    return r;
    			  	  };

    			  	  // Return number of used bits in a BN
    			  	  BN.prototype.bitLength = function bitLength () {
    			  	    var w = this.words[this.length - 1];
    			  	    var hi = this._countBits(w);
    			  	    return (this.length - 1) * 26 + hi;
    			  	  };

    			  	  function toBitArray (num) {
    			  	    var w = new Array(num.bitLength());

    			  	    for (var bit = 0; bit < w.length; bit++) {
    			  	      var off = (bit / 26) | 0;
    			  	      var wbit = bit % 26;

    			  	      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    			  	    }

    			  	    return w;
    			  	  }

    			  	  // Number of trailing zero bits
    			  	  BN.prototype.zeroBits = function zeroBits () {
    			  	    if (this.isZero()) return 0;

    			  	    var r = 0;
    			  	    for (var i = 0; i < this.length; i++) {
    			  	      var b = this._zeroBits(this.words[i]);
    			  	      r += b;
    			  	      if (b !== 26) break;
    			  	    }
    			  	    return r;
    			  	  };

    			  	  BN.prototype.byteLength = function byteLength () {
    			  	    return Math.ceil(this.bitLength() / 8);
    			  	  };

    			  	  BN.prototype.toTwos = function toTwos (width) {
    			  	    if (this.negative !== 0) {
    			  	      return this.abs().inotn(width).iaddn(1);
    			  	    }
    			  	    return this.clone();
    			  	  };

    			  	  BN.prototype.fromTwos = function fromTwos (width) {
    			  	    if (this.testn(width - 1)) {
    			  	      return this.notn(width).iaddn(1).ineg();
    			  	    }
    			  	    return this.clone();
    			  	  };

    			  	  BN.prototype.isNeg = function isNeg () {
    			  	    return this.negative !== 0;
    			  	  };

    			  	  // Return negative clone of `this`
    			  	  BN.prototype.neg = function neg () {
    			  	    return this.clone().ineg();
    			  	  };

    			  	  BN.prototype.ineg = function ineg () {
    			  	    if (!this.isZero()) {
    			  	      this.negative ^= 1;
    			  	    }

    			  	    return this;
    			  	  };

    			  	  // Or `num` with `this` in-place
    			  	  BN.prototype.iuor = function iuor (num) {
    			  	    while (this.length < num.length) {
    			  	      this.words[this.length++] = 0;
    			  	    }

    			  	    for (var i = 0; i < num.length; i++) {
    			  	      this.words[i] = this.words[i] | num.words[i];
    			  	    }

    			  	    return this.strip();
    			  	  };

    			  	  BN.prototype.ior = function ior (num) {
    			  	    assert((this.negative | num.negative) === 0);
    			  	    return this.iuor(num);
    			  	  };

    			  	  // Or `num` with `this`
    			  	  BN.prototype.or = function or (num) {
    			  	    if (this.length > num.length) return this.clone().ior(num);
    			  	    return num.clone().ior(this);
    			  	  };

    			  	  BN.prototype.uor = function uor (num) {
    			  	    if (this.length > num.length) return this.clone().iuor(num);
    			  	    return num.clone().iuor(this);
    			  	  };

    			  	  // And `num` with `this` in-place
    			  	  BN.prototype.iuand = function iuand (num) {
    			  	    // b = min-length(num, this)
    			  	    var b;
    			  	    if (this.length > num.length) {
    			  	      b = num;
    			  	    } else {
    			  	      b = this;
    			  	    }

    			  	    for (var i = 0; i < b.length; i++) {
    			  	      this.words[i] = this.words[i] & num.words[i];
    			  	    }

    			  	    this.length = b.length;

    			  	    return this.strip();
    			  	  };

    			  	  BN.prototype.iand = function iand (num) {
    			  	    assert((this.negative | num.negative) === 0);
    			  	    return this.iuand(num);
    			  	  };

    			  	  // And `num` with `this`
    			  	  BN.prototype.and = function and (num) {
    			  	    if (this.length > num.length) return this.clone().iand(num);
    			  	    return num.clone().iand(this);
    			  	  };

    			  	  BN.prototype.uand = function uand (num) {
    			  	    if (this.length > num.length) return this.clone().iuand(num);
    			  	    return num.clone().iuand(this);
    			  	  };

    			  	  // Xor `num` with `this` in-place
    			  	  BN.prototype.iuxor = function iuxor (num) {
    			  	    // a.length > b.length
    			  	    var a;
    			  	    var b;
    			  	    if (this.length > num.length) {
    			  	      a = this;
    			  	      b = num;
    			  	    } else {
    			  	      a = num;
    			  	      b = this;
    			  	    }

    			  	    for (var i = 0; i < b.length; i++) {
    			  	      this.words[i] = a.words[i] ^ b.words[i];
    			  	    }

    			  	    if (this !== a) {
    			  	      for (; i < a.length; i++) {
    			  	        this.words[i] = a.words[i];
    			  	      }
    			  	    }

    			  	    this.length = a.length;

    			  	    return this.strip();
    			  	  };

    			  	  BN.prototype.ixor = function ixor (num) {
    			  	    assert((this.negative | num.negative) === 0);
    			  	    return this.iuxor(num);
    			  	  };

    			  	  // Xor `num` with `this`
    			  	  BN.prototype.xor = function xor (num) {
    			  	    if (this.length > num.length) return this.clone().ixor(num);
    			  	    return num.clone().ixor(this);
    			  	  };

    			  	  BN.prototype.uxor = function uxor (num) {
    			  	    if (this.length > num.length) return this.clone().iuxor(num);
    			  	    return num.clone().iuxor(this);
    			  	  };

    			  	  // Not ``this`` with ``width`` bitwidth
    			  	  BN.prototype.inotn = function inotn (width) {
    			  	    assert(typeof width === 'number' && width >= 0);

    			  	    var bytesNeeded = Math.ceil(width / 26) | 0;
    			  	    var bitsLeft = width % 26;

    			  	    // Extend the buffer with leading zeroes
    			  	    this._expand(bytesNeeded);

    			  	    if (bitsLeft > 0) {
    			  	      bytesNeeded--;
    			  	    }

    			  	    // Handle complete words
    			  	    for (var i = 0; i < bytesNeeded; i++) {
    			  	      this.words[i] = ~this.words[i] & 0x3ffffff;
    			  	    }

    			  	    // Handle the residue
    			  	    if (bitsLeft > 0) {
    			  	      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    			  	    }

    			  	    // And remove leading zeroes
    			  	    return this.strip();
    			  	  };

    			  	  BN.prototype.notn = function notn (width) {
    			  	    return this.clone().inotn(width);
    			  	  };

    			  	  // Set `bit` of `this`
    			  	  BN.prototype.setn = function setn (bit, val) {
    			  	    assert(typeof bit === 'number' && bit >= 0);

    			  	    var off = (bit / 26) | 0;
    			  	    var wbit = bit % 26;

    			  	    this._expand(off + 1);

    			  	    if (val) {
    			  	      this.words[off] = this.words[off] | (1 << wbit);
    			  	    } else {
    			  	      this.words[off] = this.words[off] & ~(1 << wbit);
    			  	    }

    			  	    return this.strip();
    			  	  };

    			  	  // Add `num` to `this` in-place
    			  	  BN.prototype.iadd = function iadd (num) {
    			  	    var r;

    			  	    // negative + positive
    			  	    if (this.negative !== 0 && num.negative === 0) {
    			  	      this.negative = 0;
    			  	      r = this.isub(num);
    			  	      this.negative ^= 1;
    			  	      return this._normSign();

    			  	    // positive + negative
    			  	    } else if (this.negative === 0 && num.negative !== 0) {
    			  	      num.negative = 0;
    			  	      r = this.isub(num);
    			  	      num.negative = 1;
    			  	      return r._normSign();
    			  	    }

    			  	    // a.length > b.length
    			  	    var a, b;
    			  	    if (this.length > num.length) {
    			  	      a = this;
    			  	      b = num;
    			  	    } else {
    			  	      a = num;
    			  	      b = this;
    			  	    }

    			  	    var carry = 0;
    			  	    for (var i = 0; i < b.length; i++) {
    			  	      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
    			  	      this.words[i] = r & 0x3ffffff;
    			  	      carry = r >>> 26;
    			  	    }
    			  	    for (; carry !== 0 && i < a.length; i++) {
    			  	      r = (a.words[i] | 0) + carry;
    			  	      this.words[i] = r & 0x3ffffff;
    			  	      carry = r >>> 26;
    			  	    }

    			  	    this.length = a.length;
    			  	    if (carry !== 0) {
    			  	      this.words[this.length] = carry;
    			  	      this.length++;
    			  	    // Copy the rest of the words
    			  	    } else if (a !== this) {
    			  	      for (; i < a.length; i++) {
    			  	        this.words[i] = a.words[i];
    			  	      }
    			  	    }

    			  	    return this;
    			  	  };

    			  	  // Add `num` to `this`
    			  	  BN.prototype.add = function add (num) {
    			  	    var res;
    			  	    if (num.negative !== 0 && this.negative === 0) {
    			  	      num.negative = 0;
    			  	      res = this.sub(num);
    			  	      num.negative ^= 1;
    			  	      return res;
    			  	    } else if (num.negative === 0 && this.negative !== 0) {
    			  	      this.negative = 0;
    			  	      res = num.sub(this);
    			  	      this.negative = 1;
    			  	      return res;
    			  	    }

    			  	    if (this.length > num.length) return this.clone().iadd(num);

    			  	    return num.clone().iadd(this);
    			  	  };

    			  	  // Subtract `num` from `this` in-place
    			  	  BN.prototype.isub = function isub (num) {
    			  	    // this - (-num) = this + num
    			  	    if (num.negative !== 0) {
    			  	      num.negative = 0;
    			  	      var r = this.iadd(num);
    			  	      num.negative = 1;
    			  	      return r._normSign();

    			  	    // -this - num = -(this + num)
    			  	    } else if (this.negative !== 0) {
    			  	      this.negative = 0;
    			  	      this.iadd(num);
    			  	      this.negative = 1;
    			  	      return this._normSign();
    			  	    }

    			  	    // At this point both numbers are positive
    			  	    var cmp = this.cmp(num);

    			  	    // Optimization - zeroify
    			  	    if (cmp === 0) {
    			  	      this.negative = 0;
    			  	      this.length = 1;
    			  	      this.words[0] = 0;
    			  	      return this;
    			  	    }

    			  	    // a > b
    			  	    var a, b;
    			  	    if (cmp > 0) {
    			  	      a = this;
    			  	      b = num;
    			  	    } else {
    			  	      a = num;
    			  	      b = this;
    			  	    }

    			  	    var carry = 0;
    			  	    for (var i = 0; i < b.length; i++) {
    			  	      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
    			  	      carry = r >> 26;
    			  	      this.words[i] = r & 0x3ffffff;
    			  	    }
    			  	    for (; carry !== 0 && i < a.length; i++) {
    			  	      r = (a.words[i] | 0) + carry;
    			  	      carry = r >> 26;
    			  	      this.words[i] = r & 0x3ffffff;
    			  	    }

    			  	    // Copy rest of the words
    			  	    if (carry === 0 && i < a.length && a !== this) {
    			  	      for (; i < a.length; i++) {
    			  	        this.words[i] = a.words[i];
    			  	      }
    			  	    }

    			  	    this.length = Math.max(this.length, i);

    			  	    if (a !== this) {
    			  	      this.negative = 1;
    			  	    }

    			  	    return this.strip();
    			  	  };

    			  	  // Subtract `num` from `this`
    			  	  BN.prototype.sub = function sub (num) {
    			  	    return this.clone().isub(num);
    			  	  };

    			  	  function smallMulTo (self, num, out) {
    			  	    out.negative = num.negative ^ self.negative;
    			  	    var len = (self.length + num.length) | 0;
    			  	    out.length = len;
    			  	    len = (len - 1) | 0;

    			  	    // Peel one iteration (compiler can't do it, because of code complexity)
    			  	    var a = self.words[0] | 0;
    			  	    var b = num.words[0] | 0;
    			  	    var r = a * b;

    			  	    var lo = r & 0x3ffffff;
    			  	    var carry = (r / 0x4000000) | 0;
    			  	    out.words[0] = lo;

    			  	    for (var k = 1; k < len; k++) {
    			  	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
    			  	      // note that ncarry could be >= 0x3ffffff
    			  	      var ncarry = carry >>> 26;
    			  	      var rword = carry & 0x3ffffff;
    			  	      var maxJ = Math.min(k, num.length - 1);
    			  	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
    			  	        var i = (k - j) | 0;
    			  	        a = self.words[i] | 0;
    			  	        b = num.words[j] | 0;
    			  	        r = a * b + rword;
    			  	        ncarry += (r / 0x4000000) | 0;
    			  	        rword = r & 0x3ffffff;
    			  	      }
    			  	      out.words[k] = rword | 0;
    			  	      carry = ncarry | 0;
    			  	    }
    			  	    if (carry !== 0) {
    			  	      out.words[k] = carry | 0;
    			  	    } else {
    			  	      out.length--;
    			  	    }

    			  	    return out.strip();
    			  	  }

    			  	  // TODO(indutny): it may be reasonable to omit it for users who don't need
    			  	  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    			  	  // multiplication (like elliptic secp256k1).
    			  	  var comb10MulTo = function comb10MulTo (self, num, out) {
    			  	    var a = self.words;
    			  	    var b = num.words;
    			  	    var o = out.words;
    			  	    var c = 0;
    			  	    var lo;
    			  	    var mid;
    			  	    var hi;
    			  	    var a0 = a[0] | 0;
    			  	    var al0 = a0 & 0x1fff;
    			  	    var ah0 = a0 >>> 13;
    			  	    var a1 = a[1] | 0;
    			  	    var al1 = a1 & 0x1fff;
    			  	    var ah1 = a1 >>> 13;
    			  	    var a2 = a[2] | 0;
    			  	    var al2 = a2 & 0x1fff;
    			  	    var ah2 = a2 >>> 13;
    			  	    var a3 = a[3] | 0;
    			  	    var al3 = a3 & 0x1fff;
    			  	    var ah3 = a3 >>> 13;
    			  	    var a4 = a[4] | 0;
    			  	    var al4 = a4 & 0x1fff;
    			  	    var ah4 = a4 >>> 13;
    			  	    var a5 = a[5] | 0;
    			  	    var al5 = a5 & 0x1fff;
    			  	    var ah5 = a5 >>> 13;
    			  	    var a6 = a[6] | 0;
    			  	    var al6 = a6 & 0x1fff;
    			  	    var ah6 = a6 >>> 13;
    			  	    var a7 = a[7] | 0;
    			  	    var al7 = a7 & 0x1fff;
    			  	    var ah7 = a7 >>> 13;
    			  	    var a8 = a[8] | 0;
    			  	    var al8 = a8 & 0x1fff;
    			  	    var ah8 = a8 >>> 13;
    			  	    var a9 = a[9] | 0;
    			  	    var al9 = a9 & 0x1fff;
    			  	    var ah9 = a9 >>> 13;
    			  	    var b0 = b[0] | 0;
    			  	    var bl0 = b0 & 0x1fff;
    			  	    var bh0 = b0 >>> 13;
    			  	    var b1 = b[1] | 0;
    			  	    var bl1 = b1 & 0x1fff;
    			  	    var bh1 = b1 >>> 13;
    			  	    var b2 = b[2] | 0;
    			  	    var bl2 = b2 & 0x1fff;
    			  	    var bh2 = b2 >>> 13;
    			  	    var b3 = b[3] | 0;
    			  	    var bl3 = b3 & 0x1fff;
    			  	    var bh3 = b3 >>> 13;
    			  	    var b4 = b[4] | 0;
    			  	    var bl4 = b4 & 0x1fff;
    			  	    var bh4 = b4 >>> 13;
    			  	    var b5 = b[5] | 0;
    			  	    var bl5 = b5 & 0x1fff;
    			  	    var bh5 = b5 >>> 13;
    			  	    var b6 = b[6] | 0;
    			  	    var bl6 = b6 & 0x1fff;
    			  	    var bh6 = b6 >>> 13;
    			  	    var b7 = b[7] | 0;
    			  	    var bl7 = b7 & 0x1fff;
    			  	    var bh7 = b7 >>> 13;
    			  	    var b8 = b[8] | 0;
    			  	    var bl8 = b8 & 0x1fff;
    			  	    var bh8 = b8 >>> 13;
    			  	    var b9 = b[9] | 0;
    			  	    var bl9 = b9 & 0x1fff;
    			  	    var bh9 = b9 >>> 13;

    			  	    out.negative = self.negative ^ num.negative;
    			  	    out.length = 19;
    			  	    /* k = 0 */
    			  	    lo = Math.imul(al0, bl0);
    			  	    mid = Math.imul(al0, bh0);
    			  	    mid = (mid + Math.imul(ah0, bl0)) | 0;
    			  	    hi = Math.imul(ah0, bh0);
    			  	    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    			  	    w0 &= 0x3ffffff;
    			  	    /* k = 1 */
    			  	    lo = Math.imul(al1, bl0);
    			  	    mid = Math.imul(al1, bh0);
    			  	    mid = (mid + Math.imul(ah1, bl0)) | 0;
    			  	    hi = Math.imul(ah1, bh0);
    			  	    lo = (lo + Math.imul(al0, bl1)) | 0;
    			  	    mid = (mid + Math.imul(al0, bh1)) | 0;
    			  	    mid = (mid + Math.imul(ah0, bl1)) | 0;
    			  	    hi = (hi + Math.imul(ah0, bh1)) | 0;
    			  	    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    			  	    w1 &= 0x3ffffff;
    			  	    /* k = 2 */
    			  	    lo = Math.imul(al2, bl0);
    			  	    mid = Math.imul(al2, bh0);
    			  	    mid = (mid + Math.imul(ah2, bl0)) | 0;
    			  	    hi = Math.imul(ah2, bh0);
    			  	    lo = (lo + Math.imul(al1, bl1)) | 0;
    			  	    mid = (mid + Math.imul(al1, bh1)) | 0;
    			  	    mid = (mid + Math.imul(ah1, bl1)) | 0;
    			  	    hi = (hi + Math.imul(ah1, bh1)) | 0;
    			  	    lo = (lo + Math.imul(al0, bl2)) | 0;
    			  	    mid = (mid + Math.imul(al0, bh2)) | 0;
    			  	    mid = (mid + Math.imul(ah0, bl2)) | 0;
    			  	    hi = (hi + Math.imul(ah0, bh2)) | 0;
    			  	    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    			  	    w2 &= 0x3ffffff;
    			  	    /* k = 3 */
    			  	    lo = Math.imul(al3, bl0);
    			  	    mid = Math.imul(al3, bh0);
    			  	    mid = (mid + Math.imul(ah3, bl0)) | 0;
    			  	    hi = Math.imul(ah3, bh0);
    			  	    lo = (lo + Math.imul(al2, bl1)) | 0;
    			  	    mid = (mid + Math.imul(al2, bh1)) | 0;
    			  	    mid = (mid + Math.imul(ah2, bl1)) | 0;
    			  	    hi = (hi + Math.imul(ah2, bh1)) | 0;
    			  	    lo = (lo + Math.imul(al1, bl2)) | 0;
    			  	    mid = (mid + Math.imul(al1, bh2)) | 0;
    			  	    mid = (mid + Math.imul(ah1, bl2)) | 0;
    			  	    hi = (hi + Math.imul(ah1, bh2)) | 0;
    			  	    lo = (lo + Math.imul(al0, bl3)) | 0;
    			  	    mid = (mid + Math.imul(al0, bh3)) | 0;
    			  	    mid = (mid + Math.imul(ah0, bl3)) | 0;
    			  	    hi = (hi + Math.imul(ah0, bh3)) | 0;
    			  	    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    			  	    w3 &= 0x3ffffff;
    			  	    /* k = 4 */
    			  	    lo = Math.imul(al4, bl0);
    			  	    mid = Math.imul(al4, bh0);
    			  	    mid = (mid + Math.imul(ah4, bl0)) | 0;
    			  	    hi = Math.imul(ah4, bh0);
    			  	    lo = (lo + Math.imul(al3, bl1)) | 0;
    			  	    mid = (mid + Math.imul(al3, bh1)) | 0;
    			  	    mid = (mid + Math.imul(ah3, bl1)) | 0;
    			  	    hi = (hi + Math.imul(ah3, bh1)) | 0;
    			  	    lo = (lo + Math.imul(al2, bl2)) | 0;
    			  	    mid = (mid + Math.imul(al2, bh2)) | 0;
    			  	    mid = (mid + Math.imul(ah2, bl2)) | 0;
    			  	    hi = (hi + Math.imul(ah2, bh2)) | 0;
    			  	    lo = (lo + Math.imul(al1, bl3)) | 0;
    			  	    mid = (mid + Math.imul(al1, bh3)) | 0;
    			  	    mid = (mid + Math.imul(ah1, bl3)) | 0;
    			  	    hi = (hi + Math.imul(ah1, bh3)) | 0;
    			  	    lo = (lo + Math.imul(al0, bl4)) | 0;
    			  	    mid = (mid + Math.imul(al0, bh4)) | 0;
    			  	    mid = (mid + Math.imul(ah0, bl4)) | 0;
    			  	    hi = (hi + Math.imul(ah0, bh4)) | 0;
    			  	    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    			  	    w4 &= 0x3ffffff;
    			  	    /* k = 5 */
    			  	    lo = Math.imul(al5, bl0);
    			  	    mid = Math.imul(al5, bh0);
    			  	    mid = (mid + Math.imul(ah5, bl0)) | 0;
    			  	    hi = Math.imul(ah5, bh0);
    			  	    lo = (lo + Math.imul(al4, bl1)) | 0;
    			  	    mid = (mid + Math.imul(al4, bh1)) | 0;
    			  	    mid = (mid + Math.imul(ah4, bl1)) | 0;
    			  	    hi = (hi + Math.imul(ah4, bh1)) | 0;
    			  	    lo = (lo + Math.imul(al3, bl2)) | 0;
    			  	    mid = (mid + Math.imul(al3, bh2)) | 0;
    			  	    mid = (mid + Math.imul(ah3, bl2)) | 0;
    			  	    hi = (hi + Math.imul(ah3, bh2)) | 0;
    			  	    lo = (lo + Math.imul(al2, bl3)) | 0;
    			  	    mid = (mid + Math.imul(al2, bh3)) | 0;
    			  	    mid = (mid + Math.imul(ah2, bl3)) | 0;
    			  	    hi = (hi + Math.imul(ah2, bh3)) | 0;
    			  	    lo = (lo + Math.imul(al1, bl4)) | 0;
    			  	    mid = (mid + Math.imul(al1, bh4)) | 0;
    			  	    mid = (mid + Math.imul(ah1, bl4)) | 0;
    			  	    hi = (hi + Math.imul(ah1, bh4)) | 0;
    			  	    lo = (lo + Math.imul(al0, bl5)) | 0;
    			  	    mid = (mid + Math.imul(al0, bh5)) | 0;
    			  	    mid = (mid + Math.imul(ah0, bl5)) | 0;
    			  	    hi = (hi + Math.imul(ah0, bh5)) | 0;
    			  	    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    			  	    w5 &= 0x3ffffff;
    			  	    /* k = 6 */
    			  	    lo = Math.imul(al6, bl0);
    			  	    mid = Math.imul(al6, bh0);
    			  	    mid = (mid + Math.imul(ah6, bl0)) | 0;
    			  	    hi = Math.imul(ah6, bh0);
    			  	    lo = (lo + Math.imul(al5, bl1)) | 0;
    			  	    mid = (mid + Math.imul(al5, bh1)) | 0;
    			  	    mid = (mid + Math.imul(ah5, bl1)) | 0;
    			  	    hi = (hi + Math.imul(ah5, bh1)) | 0;
    			  	    lo = (lo + Math.imul(al4, bl2)) | 0;
    			  	    mid = (mid + Math.imul(al4, bh2)) | 0;
    			  	    mid = (mid + Math.imul(ah4, bl2)) | 0;
    			  	    hi = (hi + Math.imul(ah4, bh2)) | 0;
    			  	    lo = (lo + Math.imul(al3, bl3)) | 0;
    			  	    mid = (mid + Math.imul(al3, bh3)) | 0;
    			  	    mid = (mid + Math.imul(ah3, bl3)) | 0;
    			  	    hi = (hi + Math.imul(ah3, bh3)) | 0;
    			  	    lo = (lo + Math.imul(al2, bl4)) | 0;
    			  	    mid = (mid + Math.imul(al2, bh4)) | 0;
    			  	    mid = (mid + Math.imul(ah2, bl4)) | 0;
    			  	    hi = (hi + Math.imul(ah2, bh4)) | 0;
    			  	    lo = (lo + Math.imul(al1, bl5)) | 0;
    			  	    mid = (mid + Math.imul(al1, bh5)) | 0;
    			  	    mid = (mid + Math.imul(ah1, bl5)) | 0;
    			  	    hi = (hi + Math.imul(ah1, bh5)) | 0;
    			  	    lo = (lo + Math.imul(al0, bl6)) | 0;
    			  	    mid = (mid + Math.imul(al0, bh6)) | 0;
    			  	    mid = (mid + Math.imul(ah0, bl6)) | 0;
    			  	    hi = (hi + Math.imul(ah0, bh6)) | 0;
    			  	    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    			  	    w6 &= 0x3ffffff;
    			  	    /* k = 7 */
    			  	    lo = Math.imul(al7, bl0);
    			  	    mid = Math.imul(al7, bh0);
    			  	    mid = (mid + Math.imul(ah7, bl0)) | 0;
    			  	    hi = Math.imul(ah7, bh0);
    			  	    lo = (lo + Math.imul(al6, bl1)) | 0;
    			  	    mid = (mid + Math.imul(al6, bh1)) | 0;
    			  	    mid = (mid + Math.imul(ah6, bl1)) | 0;
    			  	    hi = (hi + Math.imul(ah6, bh1)) | 0;
    			  	    lo = (lo + Math.imul(al5, bl2)) | 0;
    			  	    mid = (mid + Math.imul(al5, bh2)) | 0;
    			  	    mid = (mid + Math.imul(ah5, bl2)) | 0;
    			  	    hi = (hi + Math.imul(ah5, bh2)) | 0;
    			  	    lo = (lo + Math.imul(al4, bl3)) | 0;
    			  	    mid = (mid + Math.imul(al4, bh3)) | 0;
    			  	    mid = (mid + Math.imul(ah4, bl3)) | 0;
    			  	    hi = (hi + Math.imul(ah4, bh3)) | 0;
    			  	    lo = (lo + Math.imul(al3, bl4)) | 0;
    			  	    mid = (mid + Math.imul(al3, bh4)) | 0;
    			  	    mid = (mid + Math.imul(ah3, bl4)) | 0;
    			  	    hi = (hi + Math.imul(ah3, bh4)) | 0;
    			  	    lo = (lo + Math.imul(al2, bl5)) | 0;
    			  	    mid = (mid + Math.imul(al2, bh5)) | 0;
    			  	    mid = (mid + Math.imul(ah2, bl5)) | 0;
    			  	    hi = (hi + Math.imul(ah2, bh5)) | 0;
    			  	    lo = (lo + Math.imul(al1, bl6)) | 0;
    			  	    mid = (mid + Math.imul(al1, bh6)) | 0;
    			  	    mid = (mid + Math.imul(ah1, bl6)) | 0;
    			  	    hi = (hi + Math.imul(ah1, bh6)) | 0;
    			  	    lo = (lo + Math.imul(al0, bl7)) | 0;
    			  	    mid = (mid + Math.imul(al0, bh7)) | 0;
    			  	    mid = (mid + Math.imul(ah0, bl7)) | 0;
    			  	    hi = (hi + Math.imul(ah0, bh7)) | 0;
    			  	    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    			  	    w7 &= 0x3ffffff;
    			  	    /* k = 8 */
    			  	    lo = Math.imul(al8, bl0);
    			  	    mid = Math.imul(al8, bh0);
    			  	    mid = (mid + Math.imul(ah8, bl0)) | 0;
    			  	    hi = Math.imul(ah8, bh0);
    			  	    lo = (lo + Math.imul(al7, bl1)) | 0;
    			  	    mid = (mid + Math.imul(al7, bh1)) | 0;
    			  	    mid = (mid + Math.imul(ah7, bl1)) | 0;
    			  	    hi = (hi + Math.imul(ah7, bh1)) | 0;
    			  	    lo = (lo + Math.imul(al6, bl2)) | 0;
    			  	    mid = (mid + Math.imul(al6, bh2)) | 0;
    			  	    mid = (mid + Math.imul(ah6, bl2)) | 0;
    			  	    hi = (hi + Math.imul(ah6, bh2)) | 0;
    			  	    lo = (lo + Math.imul(al5, bl3)) | 0;
    			  	    mid = (mid + Math.imul(al5, bh3)) | 0;
    			  	    mid = (mid + Math.imul(ah5, bl3)) | 0;
    			  	    hi = (hi + Math.imul(ah5, bh3)) | 0;
    			  	    lo = (lo + Math.imul(al4, bl4)) | 0;
    			  	    mid = (mid + Math.imul(al4, bh4)) | 0;
    			  	    mid = (mid + Math.imul(ah4, bl4)) | 0;
    			  	    hi = (hi + Math.imul(ah4, bh4)) | 0;
    			  	    lo = (lo + Math.imul(al3, bl5)) | 0;
    			  	    mid = (mid + Math.imul(al3, bh5)) | 0;
    			  	    mid = (mid + Math.imul(ah3, bl5)) | 0;
    			  	    hi = (hi + Math.imul(ah3, bh5)) | 0;
    			  	    lo = (lo + Math.imul(al2, bl6)) | 0;
    			  	    mid = (mid + Math.imul(al2, bh6)) | 0;
    			  	    mid = (mid + Math.imul(ah2, bl6)) | 0;
    			  	    hi = (hi + Math.imul(ah2, bh6)) | 0;
    			  	    lo = (lo + Math.imul(al1, bl7)) | 0;
    			  	    mid = (mid + Math.imul(al1, bh7)) | 0;
    			  	    mid = (mid + Math.imul(ah1, bl7)) | 0;
    			  	    hi = (hi + Math.imul(ah1, bh7)) | 0;
    			  	    lo = (lo + Math.imul(al0, bl8)) | 0;
    			  	    mid = (mid + Math.imul(al0, bh8)) | 0;
    			  	    mid = (mid + Math.imul(ah0, bl8)) | 0;
    			  	    hi = (hi + Math.imul(ah0, bh8)) | 0;
    			  	    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    			  	    w8 &= 0x3ffffff;
    			  	    /* k = 9 */
    			  	    lo = Math.imul(al9, bl0);
    			  	    mid = Math.imul(al9, bh0);
    			  	    mid = (mid + Math.imul(ah9, bl0)) | 0;
    			  	    hi = Math.imul(ah9, bh0);
    			  	    lo = (lo + Math.imul(al8, bl1)) | 0;
    			  	    mid = (mid + Math.imul(al8, bh1)) | 0;
    			  	    mid = (mid + Math.imul(ah8, bl1)) | 0;
    			  	    hi = (hi + Math.imul(ah8, bh1)) | 0;
    			  	    lo = (lo + Math.imul(al7, bl2)) | 0;
    			  	    mid = (mid + Math.imul(al7, bh2)) | 0;
    			  	    mid = (mid + Math.imul(ah7, bl2)) | 0;
    			  	    hi = (hi + Math.imul(ah7, bh2)) | 0;
    			  	    lo = (lo + Math.imul(al6, bl3)) | 0;
    			  	    mid = (mid + Math.imul(al6, bh3)) | 0;
    			  	    mid = (mid + Math.imul(ah6, bl3)) | 0;
    			  	    hi = (hi + Math.imul(ah6, bh3)) | 0;
    			  	    lo = (lo + Math.imul(al5, bl4)) | 0;
    			  	    mid = (mid + Math.imul(al5, bh4)) | 0;
    			  	    mid = (mid + Math.imul(ah5, bl4)) | 0;
    			  	    hi = (hi + Math.imul(ah5, bh4)) | 0;
    			  	    lo = (lo + Math.imul(al4, bl5)) | 0;
    			  	    mid = (mid + Math.imul(al4, bh5)) | 0;
    			  	    mid = (mid + Math.imul(ah4, bl5)) | 0;
    			  	    hi = (hi + Math.imul(ah4, bh5)) | 0;
    			  	    lo = (lo + Math.imul(al3, bl6)) | 0;
    			  	    mid = (mid + Math.imul(al3, bh6)) | 0;
    			  	    mid = (mid + Math.imul(ah3, bl6)) | 0;
    			  	    hi = (hi + Math.imul(ah3, bh6)) | 0;
    			  	    lo = (lo + Math.imul(al2, bl7)) | 0;
    			  	    mid = (mid + Math.imul(al2, bh7)) | 0;
    			  	    mid = (mid + Math.imul(ah2, bl7)) | 0;
    			  	    hi = (hi + Math.imul(ah2, bh7)) | 0;
    			  	    lo = (lo + Math.imul(al1, bl8)) | 0;
    			  	    mid = (mid + Math.imul(al1, bh8)) | 0;
    			  	    mid = (mid + Math.imul(ah1, bl8)) | 0;
    			  	    hi = (hi + Math.imul(ah1, bh8)) | 0;
    			  	    lo = (lo + Math.imul(al0, bl9)) | 0;
    			  	    mid = (mid + Math.imul(al0, bh9)) | 0;
    			  	    mid = (mid + Math.imul(ah0, bl9)) | 0;
    			  	    hi = (hi + Math.imul(ah0, bh9)) | 0;
    			  	    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    			  	    w9 &= 0x3ffffff;
    			  	    /* k = 10 */
    			  	    lo = Math.imul(al9, bl1);
    			  	    mid = Math.imul(al9, bh1);
    			  	    mid = (mid + Math.imul(ah9, bl1)) | 0;
    			  	    hi = Math.imul(ah9, bh1);
    			  	    lo = (lo + Math.imul(al8, bl2)) | 0;
    			  	    mid = (mid + Math.imul(al8, bh2)) | 0;
    			  	    mid = (mid + Math.imul(ah8, bl2)) | 0;
    			  	    hi = (hi + Math.imul(ah8, bh2)) | 0;
    			  	    lo = (lo + Math.imul(al7, bl3)) | 0;
    			  	    mid = (mid + Math.imul(al7, bh3)) | 0;
    			  	    mid = (mid + Math.imul(ah7, bl3)) | 0;
    			  	    hi = (hi + Math.imul(ah7, bh3)) | 0;
    			  	    lo = (lo + Math.imul(al6, bl4)) | 0;
    			  	    mid = (mid + Math.imul(al6, bh4)) | 0;
    			  	    mid = (mid + Math.imul(ah6, bl4)) | 0;
    			  	    hi = (hi + Math.imul(ah6, bh4)) | 0;
    			  	    lo = (lo + Math.imul(al5, bl5)) | 0;
    			  	    mid = (mid + Math.imul(al5, bh5)) | 0;
    			  	    mid = (mid + Math.imul(ah5, bl5)) | 0;
    			  	    hi = (hi + Math.imul(ah5, bh5)) | 0;
    			  	    lo = (lo + Math.imul(al4, bl6)) | 0;
    			  	    mid = (mid + Math.imul(al4, bh6)) | 0;
    			  	    mid = (mid + Math.imul(ah4, bl6)) | 0;
    			  	    hi = (hi + Math.imul(ah4, bh6)) | 0;
    			  	    lo = (lo + Math.imul(al3, bl7)) | 0;
    			  	    mid = (mid + Math.imul(al3, bh7)) | 0;
    			  	    mid = (mid + Math.imul(ah3, bl7)) | 0;
    			  	    hi = (hi + Math.imul(ah3, bh7)) | 0;
    			  	    lo = (lo + Math.imul(al2, bl8)) | 0;
    			  	    mid = (mid + Math.imul(al2, bh8)) | 0;
    			  	    mid = (mid + Math.imul(ah2, bl8)) | 0;
    			  	    hi = (hi + Math.imul(ah2, bh8)) | 0;
    			  	    lo = (lo + Math.imul(al1, bl9)) | 0;
    			  	    mid = (mid + Math.imul(al1, bh9)) | 0;
    			  	    mid = (mid + Math.imul(ah1, bl9)) | 0;
    			  	    hi = (hi + Math.imul(ah1, bh9)) | 0;
    			  	    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    			  	    w10 &= 0x3ffffff;
    			  	    /* k = 11 */
    			  	    lo = Math.imul(al9, bl2);
    			  	    mid = Math.imul(al9, bh2);
    			  	    mid = (mid + Math.imul(ah9, bl2)) | 0;
    			  	    hi = Math.imul(ah9, bh2);
    			  	    lo = (lo + Math.imul(al8, bl3)) | 0;
    			  	    mid = (mid + Math.imul(al8, bh3)) | 0;
    			  	    mid = (mid + Math.imul(ah8, bl3)) | 0;
    			  	    hi = (hi + Math.imul(ah8, bh3)) | 0;
    			  	    lo = (lo + Math.imul(al7, bl4)) | 0;
    			  	    mid = (mid + Math.imul(al7, bh4)) | 0;
    			  	    mid = (mid + Math.imul(ah7, bl4)) | 0;
    			  	    hi = (hi + Math.imul(ah7, bh4)) | 0;
    			  	    lo = (lo + Math.imul(al6, bl5)) | 0;
    			  	    mid = (mid + Math.imul(al6, bh5)) | 0;
    			  	    mid = (mid + Math.imul(ah6, bl5)) | 0;
    			  	    hi = (hi + Math.imul(ah6, bh5)) | 0;
    			  	    lo = (lo + Math.imul(al5, bl6)) | 0;
    			  	    mid = (mid + Math.imul(al5, bh6)) | 0;
    			  	    mid = (mid + Math.imul(ah5, bl6)) | 0;
    			  	    hi = (hi + Math.imul(ah5, bh6)) | 0;
    			  	    lo = (lo + Math.imul(al4, bl7)) | 0;
    			  	    mid = (mid + Math.imul(al4, bh7)) | 0;
    			  	    mid = (mid + Math.imul(ah4, bl7)) | 0;
    			  	    hi = (hi + Math.imul(ah4, bh7)) | 0;
    			  	    lo = (lo + Math.imul(al3, bl8)) | 0;
    			  	    mid = (mid + Math.imul(al3, bh8)) | 0;
    			  	    mid = (mid + Math.imul(ah3, bl8)) | 0;
    			  	    hi = (hi + Math.imul(ah3, bh8)) | 0;
    			  	    lo = (lo + Math.imul(al2, bl9)) | 0;
    			  	    mid = (mid + Math.imul(al2, bh9)) | 0;
    			  	    mid = (mid + Math.imul(ah2, bl9)) | 0;
    			  	    hi = (hi + Math.imul(ah2, bh9)) | 0;
    			  	    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    			  	    w11 &= 0x3ffffff;
    			  	    /* k = 12 */
    			  	    lo = Math.imul(al9, bl3);
    			  	    mid = Math.imul(al9, bh3);
    			  	    mid = (mid + Math.imul(ah9, bl3)) | 0;
    			  	    hi = Math.imul(ah9, bh3);
    			  	    lo = (lo + Math.imul(al8, bl4)) | 0;
    			  	    mid = (mid + Math.imul(al8, bh4)) | 0;
    			  	    mid = (mid + Math.imul(ah8, bl4)) | 0;
    			  	    hi = (hi + Math.imul(ah8, bh4)) | 0;
    			  	    lo = (lo + Math.imul(al7, bl5)) | 0;
    			  	    mid = (mid + Math.imul(al7, bh5)) | 0;
    			  	    mid = (mid + Math.imul(ah7, bl5)) | 0;
    			  	    hi = (hi + Math.imul(ah7, bh5)) | 0;
    			  	    lo = (lo + Math.imul(al6, bl6)) | 0;
    			  	    mid = (mid + Math.imul(al6, bh6)) | 0;
    			  	    mid = (mid + Math.imul(ah6, bl6)) | 0;
    			  	    hi = (hi + Math.imul(ah6, bh6)) | 0;
    			  	    lo = (lo + Math.imul(al5, bl7)) | 0;
    			  	    mid = (mid + Math.imul(al5, bh7)) | 0;
    			  	    mid = (mid + Math.imul(ah5, bl7)) | 0;
    			  	    hi = (hi + Math.imul(ah5, bh7)) | 0;
    			  	    lo = (lo + Math.imul(al4, bl8)) | 0;
    			  	    mid = (mid + Math.imul(al4, bh8)) | 0;
    			  	    mid = (mid + Math.imul(ah4, bl8)) | 0;
    			  	    hi = (hi + Math.imul(ah4, bh8)) | 0;
    			  	    lo = (lo + Math.imul(al3, bl9)) | 0;
    			  	    mid = (mid + Math.imul(al3, bh9)) | 0;
    			  	    mid = (mid + Math.imul(ah3, bl9)) | 0;
    			  	    hi = (hi + Math.imul(ah3, bh9)) | 0;
    			  	    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    			  	    w12 &= 0x3ffffff;
    			  	    /* k = 13 */
    			  	    lo = Math.imul(al9, bl4);
    			  	    mid = Math.imul(al9, bh4);
    			  	    mid = (mid + Math.imul(ah9, bl4)) | 0;
    			  	    hi = Math.imul(ah9, bh4);
    			  	    lo = (lo + Math.imul(al8, bl5)) | 0;
    			  	    mid = (mid + Math.imul(al8, bh5)) | 0;
    			  	    mid = (mid + Math.imul(ah8, bl5)) | 0;
    			  	    hi = (hi + Math.imul(ah8, bh5)) | 0;
    			  	    lo = (lo + Math.imul(al7, bl6)) | 0;
    			  	    mid = (mid + Math.imul(al7, bh6)) | 0;
    			  	    mid = (mid + Math.imul(ah7, bl6)) | 0;
    			  	    hi = (hi + Math.imul(ah7, bh6)) | 0;
    			  	    lo = (lo + Math.imul(al6, bl7)) | 0;
    			  	    mid = (mid + Math.imul(al6, bh7)) | 0;
    			  	    mid = (mid + Math.imul(ah6, bl7)) | 0;
    			  	    hi = (hi + Math.imul(ah6, bh7)) | 0;
    			  	    lo = (lo + Math.imul(al5, bl8)) | 0;
    			  	    mid = (mid + Math.imul(al5, bh8)) | 0;
    			  	    mid = (mid + Math.imul(ah5, bl8)) | 0;
    			  	    hi = (hi + Math.imul(ah5, bh8)) | 0;
    			  	    lo = (lo + Math.imul(al4, bl9)) | 0;
    			  	    mid = (mid + Math.imul(al4, bh9)) | 0;
    			  	    mid = (mid + Math.imul(ah4, bl9)) | 0;
    			  	    hi = (hi + Math.imul(ah4, bh9)) | 0;
    			  	    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    			  	    w13 &= 0x3ffffff;
    			  	    /* k = 14 */
    			  	    lo = Math.imul(al9, bl5);
    			  	    mid = Math.imul(al9, bh5);
    			  	    mid = (mid + Math.imul(ah9, bl5)) | 0;
    			  	    hi = Math.imul(ah9, bh5);
    			  	    lo = (lo + Math.imul(al8, bl6)) | 0;
    			  	    mid = (mid + Math.imul(al8, bh6)) | 0;
    			  	    mid = (mid + Math.imul(ah8, bl6)) | 0;
    			  	    hi = (hi + Math.imul(ah8, bh6)) | 0;
    			  	    lo = (lo + Math.imul(al7, bl7)) | 0;
    			  	    mid = (mid + Math.imul(al7, bh7)) | 0;
    			  	    mid = (mid + Math.imul(ah7, bl7)) | 0;
    			  	    hi = (hi + Math.imul(ah7, bh7)) | 0;
    			  	    lo = (lo + Math.imul(al6, bl8)) | 0;
    			  	    mid = (mid + Math.imul(al6, bh8)) | 0;
    			  	    mid = (mid + Math.imul(ah6, bl8)) | 0;
    			  	    hi = (hi + Math.imul(ah6, bh8)) | 0;
    			  	    lo = (lo + Math.imul(al5, bl9)) | 0;
    			  	    mid = (mid + Math.imul(al5, bh9)) | 0;
    			  	    mid = (mid + Math.imul(ah5, bl9)) | 0;
    			  	    hi = (hi + Math.imul(ah5, bh9)) | 0;
    			  	    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    			  	    w14 &= 0x3ffffff;
    			  	    /* k = 15 */
    			  	    lo = Math.imul(al9, bl6);
    			  	    mid = Math.imul(al9, bh6);
    			  	    mid = (mid + Math.imul(ah9, bl6)) | 0;
    			  	    hi = Math.imul(ah9, bh6);
    			  	    lo = (lo + Math.imul(al8, bl7)) | 0;
    			  	    mid = (mid + Math.imul(al8, bh7)) | 0;
    			  	    mid = (mid + Math.imul(ah8, bl7)) | 0;
    			  	    hi = (hi + Math.imul(ah8, bh7)) | 0;
    			  	    lo = (lo + Math.imul(al7, bl8)) | 0;
    			  	    mid = (mid + Math.imul(al7, bh8)) | 0;
    			  	    mid = (mid + Math.imul(ah7, bl8)) | 0;
    			  	    hi = (hi + Math.imul(ah7, bh8)) | 0;
    			  	    lo = (lo + Math.imul(al6, bl9)) | 0;
    			  	    mid = (mid + Math.imul(al6, bh9)) | 0;
    			  	    mid = (mid + Math.imul(ah6, bl9)) | 0;
    			  	    hi = (hi + Math.imul(ah6, bh9)) | 0;
    			  	    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    			  	    w15 &= 0x3ffffff;
    			  	    /* k = 16 */
    			  	    lo = Math.imul(al9, bl7);
    			  	    mid = Math.imul(al9, bh7);
    			  	    mid = (mid + Math.imul(ah9, bl7)) | 0;
    			  	    hi = Math.imul(ah9, bh7);
    			  	    lo = (lo + Math.imul(al8, bl8)) | 0;
    			  	    mid = (mid + Math.imul(al8, bh8)) | 0;
    			  	    mid = (mid + Math.imul(ah8, bl8)) | 0;
    			  	    hi = (hi + Math.imul(ah8, bh8)) | 0;
    			  	    lo = (lo + Math.imul(al7, bl9)) | 0;
    			  	    mid = (mid + Math.imul(al7, bh9)) | 0;
    			  	    mid = (mid + Math.imul(ah7, bl9)) | 0;
    			  	    hi = (hi + Math.imul(ah7, bh9)) | 0;
    			  	    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    			  	    w16 &= 0x3ffffff;
    			  	    /* k = 17 */
    			  	    lo = Math.imul(al9, bl8);
    			  	    mid = Math.imul(al9, bh8);
    			  	    mid = (mid + Math.imul(ah9, bl8)) | 0;
    			  	    hi = Math.imul(ah9, bh8);
    			  	    lo = (lo + Math.imul(al8, bl9)) | 0;
    			  	    mid = (mid + Math.imul(al8, bh9)) | 0;
    			  	    mid = (mid + Math.imul(ah8, bl9)) | 0;
    			  	    hi = (hi + Math.imul(ah8, bh9)) | 0;
    			  	    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    			  	    w17 &= 0x3ffffff;
    			  	    /* k = 18 */
    			  	    lo = Math.imul(al9, bl9);
    			  	    mid = Math.imul(al9, bh9);
    			  	    mid = (mid + Math.imul(ah9, bl9)) | 0;
    			  	    hi = Math.imul(ah9, bh9);
    			  	    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    			  	    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    			  	    w18 &= 0x3ffffff;
    			  	    o[0] = w0;
    			  	    o[1] = w1;
    			  	    o[2] = w2;
    			  	    o[3] = w3;
    			  	    o[4] = w4;
    			  	    o[5] = w5;
    			  	    o[6] = w6;
    			  	    o[7] = w7;
    			  	    o[8] = w8;
    			  	    o[9] = w9;
    			  	    o[10] = w10;
    			  	    o[11] = w11;
    			  	    o[12] = w12;
    			  	    o[13] = w13;
    			  	    o[14] = w14;
    			  	    o[15] = w15;
    			  	    o[16] = w16;
    			  	    o[17] = w17;
    			  	    o[18] = w18;
    			  	    if (c !== 0) {
    			  	      o[19] = c;
    			  	      out.length++;
    			  	    }
    			  	    return out;
    			  	  };

    			  	  // Polyfill comb
    			  	  if (!Math.imul) {
    			  	    comb10MulTo = smallMulTo;
    			  	  }

    			  	  function bigMulTo (self, num, out) {
    			  	    out.negative = num.negative ^ self.negative;
    			  	    out.length = self.length + num.length;

    			  	    var carry = 0;
    			  	    var hncarry = 0;
    			  	    for (var k = 0; k < out.length - 1; k++) {
    			  	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
    			  	      // note that ncarry could be >= 0x3ffffff
    			  	      var ncarry = hncarry;
    			  	      hncarry = 0;
    			  	      var rword = carry & 0x3ffffff;
    			  	      var maxJ = Math.min(k, num.length - 1);
    			  	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
    			  	        var i = k - j;
    			  	        var a = self.words[i] | 0;
    			  	        var b = num.words[j] | 0;
    			  	        var r = a * b;

    			  	        var lo = r & 0x3ffffff;
    			  	        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
    			  	        lo = (lo + rword) | 0;
    			  	        rword = lo & 0x3ffffff;
    			  	        ncarry = (ncarry + (lo >>> 26)) | 0;

    			  	        hncarry += ncarry >>> 26;
    			  	        ncarry &= 0x3ffffff;
    			  	      }
    			  	      out.words[k] = rword;
    			  	      carry = ncarry;
    			  	      ncarry = hncarry;
    			  	    }
    			  	    if (carry !== 0) {
    			  	      out.words[k] = carry;
    			  	    } else {
    			  	      out.length--;
    			  	    }

    			  	    return out.strip();
    			  	  }

    			  	  function jumboMulTo (self, num, out) {
    			  	    var fftm = new FFTM();
    			  	    return fftm.mulp(self, num, out);
    			  	  }

    			  	  BN.prototype.mulTo = function mulTo (num, out) {
    			  	    var res;
    			  	    var len = this.length + num.length;
    			  	    if (this.length === 10 && num.length === 10) {
    			  	      res = comb10MulTo(this, num, out);
    			  	    } else if (len < 63) {
    			  	      res = smallMulTo(this, num, out);
    			  	    } else if (len < 1024) {
    			  	      res = bigMulTo(this, num, out);
    			  	    } else {
    			  	      res = jumboMulTo(this, num, out);
    			  	    }

    			  	    return res;
    			  	  };

    			  	  // Cooley-Tukey algorithm for FFT
    			  	  // slightly revisited to rely on looping instead of recursion

    			  	  function FFTM (x, y) {
    			  	    this.x = x;
    			  	    this.y = y;
    			  	  }

    			  	  FFTM.prototype.makeRBT = function makeRBT (N) {
    			  	    var t = new Array(N);
    			  	    var l = BN.prototype._countBits(N) - 1;
    			  	    for (var i = 0; i < N; i++) {
    			  	      t[i] = this.revBin(i, l, N);
    			  	    }

    			  	    return t;
    			  	  };

    			  	  // Returns binary-reversed representation of `x`
    			  	  FFTM.prototype.revBin = function revBin (x, l, N) {
    			  	    if (x === 0 || x === N - 1) return x;

    			  	    var rb = 0;
    			  	    for (var i = 0; i < l; i++) {
    			  	      rb |= (x & 1) << (l - i - 1);
    			  	      x >>= 1;
    			  	    }

    			  	    return rb;
    			  	  };

    			  	  // Performs "tweedling" phase, therefore 'emulating'
    			  	  // behaviour of the recursive algorithm
    			  	  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    			  	    for (var i = 0; i < N; i++) {
    			  	      rtws[i] = rws[rbt[i]];
    			  	      itws[i] = iws[rbt[i]];
    			  	    }
    			  	  };

    			  	  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    			  	    this.permute(rbt, rws, iws, rtws, itws, N);

    			  	    for (var s = 1; s < N; s <<= 1) {
    			  	      var l = s << 1;

    			  	      var rtwdf = Math.cos(2 * Math.PI / l);
    			  	      var itwdf = Math.sin(2 * Math.PI / l);

    			  	      for (var p = 0; p < N; p += l) {
    			  	        var rtwdf_ = rtwdf;
    			  	        var itwdf_ = itwdf;

    			  	        for (var j = 0; j < s; j++) {
    			  	          var re = rtws[p + j];
    			  	          var ie = itws[p + j];

    			  	          var ro = rtws[p + j + s];
    			  	          var io = itws[p + j + s];

    			  	          var rx = rtwdf_ * ro - itwdf_ * io;

    			  	          io = rtwdf_ * io + itwdf_ * ro;
    			  	          ro = rx;

    			  	          rtws[p + j] = re + ro;
    			  	          itws[p + j] = ie + io;

    			  	          rtws[p + j + s] = re - ro;
    			  	          itws[p + j + s] = ie - io;

    			  	          /* jshint maxdepth : false */
    			  	          if (j !== l) {
    			  	            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

    			  	            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
    			  	            rtwdf_ = rx;
    			  	          }
    			  	        }
    			  	      }
    			  	    }
    			  	  };

    			  	  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    			  	    var N = Math.max(m, n) | 1;
    			  	    var odd = N & 1;
    			  	    var i = 0;
    			  	    for (N = N / 2 | 0; N; N = N >>> 1) {
    			  	      i++;
    			  	    }

    			  	    return 1 << i + 1 + odd;
    			  	  };

    			  	  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    			  	    if (N <= 1) return;

    			  	    for (var i = 0; i < N / 2; i++) {
    			  	      var t = rws[i];

    			  	      rws[i] = rws[N - i - 1];
    			  	      rws[N - i - 1] = t;

    			  	      t = iws[i];

    			  	      iws[i] = -iws[N - i - 1];
    			  	      iws[N - i - 1] = -t;
    			  	    }
    			  	  };

    			  	  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    			  	    var carry = 0;
    			  	    for (var i = 0; i < N / 2; i++) {
    			  	      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
    			  	        Math.round(ws[2 * i] / N) +
    			  	        carry;

    			  	      ws[i] = w & 0x3ffffff;

    			  	      if (w < 0x4000000) {
    			  	        carry = 0;
    			  	      } else {
    			  	        carry = w / 0x4000000 | 0;
    			  	      }
    			  	    }

    			  	    return ws;
    			  	  };

    			  	  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    			  	    var carry = 0;
    			  	    for (var i = 0; i < len; i++) {
    			  	      carry = carry + (ws[i] | 0);

    			  	      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
    			  	      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    			  	    }

    			  	    // Pad with zeroes
    			  	    for (i = 2 * len; i < N; ++i) {
    			  	      rws[i] = 0;
    			  	    }

    			  	    assert(carry === 0);
    			  	    assert((carry & ~0x1fff) === 0);
    			  	  };

    			  	  FFTM.prototype.stub = function stub (N) {
    			  	    var ph = new Array(N);
    			  	    for (var i = 0; i < N; i++) {
    			  	      ph[i] = 0;
    			  	    }

    			  	    return ph;
    			  	  };

    			  	  FFTM.prototype.mulp = function mulp (x, y, out) {
    			  	    var N = 2 * this.guessLen13b(x.length, y.length);

    			  	    var rbt = this.makeRBT(N);

    			  	    var _ = this.stub(N);

    			  	    var rws = new Array(N);
    			  	    var rwst = new Array(N);
    			  	    var iwst = new Array(N);

    			  	    var nrws = new Array(N);
    			  	    var nrwst = new Array(N);
    			  	    var niwst = new Array(N);

    			  	    var rmws = out.words;
    			  	    rmws.length = N;

    			  	    this.convert13b(x.words, x.length, rws, N);
    			  	    this.convert13b(y.words, y.length, nrws, N);

    			  	    this.transform(rws, _, rwst, iwst, N, rbt);
    			  	    this.transform(nrws, _, nrwst, niwst, N, rbt);

    			  	    for (var i = 0; i < N; i++) {
    			  	      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
    			  	      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
    			  	      rwst[i] = rx;
    			  	    }

    			  	    this.conjugate(rwst, iwst, N);
    			  	    this.transform(rwst, iwst, rmws, _, N, rbt);
    			  	    this.conjugate(rmws, _, N);
    			  	    this.normalize13b(rmws, N);

    			  	    out.negative = x.negative ^ y.negative;
    			  	    out.length = x.length + y.length;
    			  	    return out.strip();
    			  	  };

    			  	  // Multiply `this` by `num`
    			  	  BN.prototype.mul = function mul (num) {
    			  	    var out = new BN(null);
    			  	    out.words = new Array(this.length + num.length);
    			  	    return this.mulTo(num, out);
    			  	  };

    			  	  // Multiply employing FFT
    			  	  BN.prototype.mulf = function mulf (num) {
    			  	    var out = new BN(null);
    			  	    out.words = new Array(this.length + num.length);
    			  	    return jumboMulTo(this, num, out);
    			  	  };

    			  	  // In-place Multiplication
    			  	  BN.prototype.imul = function imul (num) {
    			  	    return this.clone().mulTo(num, this);
    			  	  };

    			  	  BN.prototype.imuln = function imuln (num) {
    			  	    assert(typeof num === 'number');
    			  	    assert(num < 0x4000000);

    			  	    // Carry
    			  	    var carry = 0;
    			  	    for (var i = 0; i < this.length; i++) {
    			  	      var w = (this.words[i] | 0) * num;
    			  	      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
    			  	      carry >>= 26;
    			  	      carry += (w / 0x4000000) | 0;
    			  	      // NOTE: lo is 27bit maximum
    			  	      carry += lo >>> 26;
    			  	      this.words[i] = lo & 0x3ffffff;
    			  	    }

    			  	    if (carry !== 0) {
    			  	      this.words[i] = carry;
    			  	      this.length++;
    			  	    }

    			  	    return this;
    			  	  };

    			  	  BN.prototype.muln = function muln (num) {
    			  	    return this.clone().imuln(num);
    			  	  };

    			  	  // `this` * `this`
    			  	  BN.prototype.sqr = function sqr () {
    			  	    return this.mul(this);
    			  	  };

    			  	  // `this` * `this` in-place
    			  	  BN.prototype.isqr = function isqr () {
    			  	    return this.imul(this.clone());
    			  	  };

    			  	  // Math.pow(`this`, `num`)
    			  	  BN.prototype.pow = function pow (num) {
    			  	    var w = toBitArray(num);
    			  	    if (w.length === 0) return new BN(1);

    			  	    // Skip leading zeroes
    			  	    var res = this;
    			  	    for (var i = 0; i < w.length; i++, res = res.sqr()) {
    			  	      if (w[i] !== 0) break;
    			  	    }

    			  	    if (++i < w.length) {
    			  	      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
    			  	        if (w[i] === 0) continue;

    			  	        res = res.mul(q);
    			  	      }
    			  	    }

    			  	    return res;
    			  	  };

    			  	  // Shift-left in-place
    			  	  BN.prototype.iushln = function iushln (bits) {
    			  	    assert(typeof bits === 'number' && bits >= 0);
    			  	    var r = bits % 26;
    			  	    var s = (bits - r) / 26;
    			  	    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    			  	    var i;

    			  	    if (r !== 0) {
    			  	      var carry = 0;

    			  	      for (i = 0; i < this.length; i++) {
    			  	        var newCarry = this.words[i] & carryMask;
    			  	        var c = ((this.words[i] | 0) - newCarry) << r;
    			  	        this.words[i] = c | carry;
    			  	        carry = newCarry >>> (26 - r);
    			  	      }

    			  	      if (carry) {
    			  	        this.words[i] = carry;
    			  	        this.length++;
    			  	      }
    			  	    }

    			  	    if (s !== 0) {
    			  	      for (i = this.length - 1; i >= 0; i--) {
    			  	        this.words[i + s] = this.words[i];
    			  	      }

    			  	      for (i = 0; i < s; i++) {
    			  	        this.words[i] = 0;
    			  	      }

    			  	      this.length += s;
    			  	    }

    			  	    return this.strip();
    			  	  };

    			  	  BN.prototype.ishln = function ishln (bits) {
    			  	    // TODO(indutny): implement me
    			  	    assert(this.negative === 0);
    			  	    return this.iushln(bits);
    			  	  };

    			  	  // Shift-right in-place
    			  	  // NOTE: `hint` is a lowest bit before trailing zeroes
    			  	  // NOTE: if `extended` is present - it will be filled with destroyed bits
    			  	  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    			  	    assert(typeof bits === 'number' && bits >= 0);
    			  	    var h;
    			  	    if (hint) {
    			  	      h = (hint - (hint % 26)) / 26;
    			  	    } else {
    			  	      h = 0;
    			  	    }

    			  	    var r = bits % 26;
    			  	    var s = Math.min((bits - r) / 26, this.length);
    			  	    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    			  	    var maskedWords = extended;

    			  	    h -= s;
    			  	    h = Math.max(0, h);

    			  	    // Extended mode, copy masked part
    			  	    if (maskedWords) {
    			  	      for (var i = 0; i < s; i++) {
    			  	        maskedWords.words[i] = this.words[i];
    			  	      }
    			  	      maskedWords.length = s;
    			  	    }

    			  	    if (s === 0) ; else if (this.length > s) {
    			  	      this.length -= s;
    			  	      for (i = 0; i < this.length; i++) {
    			  	        this.words[i] = this.words[i + s];
    			  	      }
    			  	    } else {
    			  	      this.words[0] = 0;
    			  	      this.length = 1;
    			  	    }

    			  	    var carry = 0;
    			  	    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
    			  	      var word = this.words[i] | 0;
    			  	      this.words[i] = (carry << (26 - r)) | (word >>> r);
    			  	      carry = word & mask;
    			  	    }

    			  	    // Push carried bits as a mask
    			  	    if (maskedWords && carry !== 0) {
    			  	      maskedWords.words[maskedWords.length++] = carry;
    			  	    }

    			  	    if (this.length === 0) {
    			  	      this.words[0] = 0;
    			  	      this.length = 1;
    			  	    }

    			  	    return this.strip();
    			  	  };

    			  	  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    			  	    // TODO(indutny): implement me
    			  	    assert(this.negative === 0);
    			  	    return this.iushrn(bits, hint, extended);
    			  	  };

    			  	  // Shift-left
    			  	  BN.prototype.shln = function shln (bits) {
    			  	    return this.clone().ishln(bits);
    			  	  };

    			  	  BN.prototype.ushln = function ushln (bits) {
    			  	    return this.clone().iushln(bits);
    			  	  };

    			  	  // Shift-right
    			  	  BN.prototype.shrn = function shrn (bits) {
    			  	    return this.clone().ishrn(bits);
    			  	  };

    			  	  BN.prototype.ushrn = function ushrn (bits) {
    			  	    return this.clone().iushrn(bits);
    			  	  };

    			  	  // Test if n bit is set
    			  	  BN.prototype.testn = function testn (bit) {
    			  	    assert(typeof bit === 'number' && bit >= 0);
    			  	    var r = bit % 26;
    			  	    var s = (bit - r) / 26;
    			  	    var q = 1 << r;

    			  	    // Fast case: bit is much higher than all existing words
    			  	    if (this.length <= s) return false;

    			  	    // Check bit and return
    			  	    var w = this.words[s];

    			  	    return !!(w & q);
    			  	  };

    			  	  // Return only lowers bits of number (in-place)
    			  	  BN.prototype.imaskn = function imaskn (bits) {
    			  	    assert(typeof bits === 'number' && bits >= 0);
    			  	    var r = bits % 26;
    			  	    var s = (bits - r) / 26;

    			  	    assert(this.negative === 0, 'imaskn works only with positive numbers');

    			  	    if (this.length <= s) {
    			  	      return this;
    			  	    }

    			  	    if (r !== 0) {
    			  	      s++;
    			  	    }
    			  	    this.length = Math.min(s, this.length);

    			  	    if (r !== 0) {
    			  	      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    			  	      this.words[this.length - 1] &= mask;
    			  	    }

    			  	    return this.strip();
    			  	  };

    			  	  // Return only lowers bits of number
    			  	  BN.prototype.maskn = function maskn (bits) {
    			  	    return this.clone().imaskn(bits);
    			  	  };

    			  	  // Add plain number `num` to `this`
    			  	  BN.prototype.iaddn = function iaddn (num) {
    			  	    assert(typeof num === 'number');
    			  	    assert(num < 0x4000000);
    			  	    if (num < 0) return this.isubn(-num);

    			  	    // Possible sign change
    			  	    if (this.negative !== 0) {
    			  	      if (this.length === 1 && (this.words[0] | 0) < num) {
    			  	        this.words[0] = num - (this.words[0] | 0);
    			  	        this.negative = 0;
    			  	        return this;
    			  	      }

    			  	      this.negative = 0;
    			  	      this.isubn(num);
    			  	      this.negative = 1;
    			  	      return this;
    			  	    }

    			  	    // Add without checks
    			  	    return this._iaddn(num);
    			  	  };

    			  	  BN.prototype._iaddn = function _iaddn (num) {
    			  	    this.words[0] += num;

    			  	    // Carry
    			  	    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
    			  	      this.words[i] -= 0x4000000;
    			  	      if (i === this.length - 1) {
    			  	        this.words[i + 1] = 1;
    			  	      } else {
    			  	        this.words[i + 1]++;
    			  	      }
    			  	    }
    			  	    this.length = Math.max(this.length, i + 1);

    			  	    return this;
    			  	  };

    			  	  // Subtract plain number `num` from `this`
    			  	  BN.prototype.isubn = function isubn (num) {
    			  	    assert(typeof num === 'number');
    			  	    assert(num < 0x4000000);
    			  	    if (num < 0) return this.iaddn(-num);

    			  	    if (this.negative !== 0) {
    			  	      this.negative = 0;
    			  	      this.iaddn(num);
    			  	      this.negative = 1;
    			  	      return this;
    			  	    }

    			  	    this.words[0] -= num;

    			  	    if (this.length === 1 && this.words[0] < 0) {
    			  	      this.words[0] = -this.words[0];
    			  	      this.negative = 1;
    			  	    } else {
    			  	      // Carry
    			  	      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
    			  	        this.words[i] += 0x4000000;
    			  	        this.words[i + 1] -= 1;
    			  	      }
    			  	    }

    			  	    return this.strip();
    			  	  };

    			  	  BN.prototype.addn = function addn (num) {
    			  	    return this.clone().iaddn(num);
    			  	  };

    			  	  BN.prototype.subn = function subn (num) {
    			  	    return this.clone().isubn(num);
    			  	  };

    			  	  BN.prototype.iabs = function iabs () {
    			  	    this.negative = 0;

    			  	    return this;
    			  	  };

    			  	  BN.prototype.abs = function abs () {
    			  	    return this.clone().iabs();
    			  	  };

    			  	  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    			  	    var len = num.length + shift;
    			  	    var i;

    			  	    this._expand(len);

    			  	    var w;
    			  	    var carry = 0;
    			  	    for (i = 0; i < num.length; i++) {
    			  	      w = (this.words[i + shift] | 0) + carry;
    			  	      var right = (num.words[i] | 0) * mul;
    			  	      w -= right & 0x3ffffff;
    			  	      carry = (w >> 26) - ((right / 0x4000000) | 0);
    			  	      this.words[i + shift] = w & 0x3ffffff;
    			  	    }
    			  	    for (; i < this.length - shift; i++) {
    			  	      w = (this.words[i + shift] | 0) + carry;
    			  	      carry = w >> 26;
    			  	      this.words[i + shift] = w & 0x3ffffff;
    			  	    }

    			  	    if (carry === 0) return this.strip();

    			  	    // Subtraction overflow
    			  	    assert(carry === -1);
    			  	    carry = 0;
    			  	    for (i = 0; i < this.length; i++) {
    			  	      w = -(this.words[i] | 0) + carry;
    			  	      carry = w >> 26;
    			  	      this.words[i] = w & 0x3ffffff;
    			  	    }
    			  	    this.negative = 1;

    			  	    return this.strip();
    			  	  };

    			  	  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    			  	    var shift = this.length - num.length;

    			  	    var a = this.clone();
    			  	    var b = num;

    			  	    // Normalize
    			  	    var bhi = b.words[b.length - 1] | 0;
    			  	    var bhiBits = this._countBits(bhi);
    			  	    shift = 26 - bhiBits;
    			  	    if (shift !== 0) {
    			  	      b = b.ushln(shift);
    			  	      a.iushln(shift);
    			  	      bhi = b.words[b.length - 1] | 0;
    			  	    }

    			  	    // Initialize quotient
    			  	    var m = a.length - b.length;
    			  	    var q;

    			  	    if (mode !== 'mod') {
    			  	      q = new BN(null);
    			  	      q.length = m + 1;
    			  	      q.words = new Array(q.length);
    			  	      for (var i = 0; i < q.length; i++) {
    			  	        q.words[i] = 0;
    			  	      }
    			  	    }

    			  	    var diff = a.clone()._ishlnsubmul(b, 1, m);
    			  	    if (diff.negative === 0) {
    			  	      a = diff;
    			  	      if (q) {
    			  	        q.words[m] = 1;
    			  	      }
    			  	    }

    			  	    for (var j = m - 1; j >= 0; j--) {
    			  	      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
    			  	        (a.words[b.length + j - 1] | 0);

    			  	      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
    			  	      // (0x7ffffff)
    			  	      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

    			  	      a._ishlnsubmul(b, qj, j);
    			  	      while (a.negative !== 0) {
    			  	        qj--;
    			  	        a.negative = 0;
    			  	        a._ishlnsubmul(b, 1, j);
    			  	        if (!a.isZero()) {
    			  	          a.negative ^= 1;
    			  	        }
    			  	      }
    			  	      if (q) {
    			  	        q.words[j] = qj;
    			  	      }
    			  	    }
    			  	    if (q) {
    			  	      q.strip();
    			  	    }
    			  	    a.strip();

    			  	    // Denormalize
    			  	    if (mode !== 'div' && shift !== 0) {
    			  	      a.iushrn(shift);
    			  	    }

    			  	    return {
    			  	      div: q || null,
    			  	      mod: a
    			  	    };
    			  	  };

    			  	  // NOTE: 1) `mode` can be set to `mod` to request mod only,
    			  	  //       to `div` to request div only, or be absent to
    			  	  //       request both div & mod
    			  	  //       2) `positive` is true if unsigned mod is requested
    			  	  BN.prototype.divmod = function divmod (num, mode, positive) {
    			  	    assert(!num.isZero());

    			  	    if (this.isZero()) {
    			  	      return {
    			  	        div: new BN(0),
    			  	        mod: new BN(0)
    			  	      };
    			  	    }

    			  	    var div, mod, res;
    			  	    if (this.negative !== 0 && num.negative === 0) {
    			  	      res = this.neg().divmod(num, mode);

    			  	      if (mode !== 'mod') {
    			  	        div = res.div.neg();
    			  	      }

    			  	      if (mode !== 'div') {
    			  	        mod = res.mod.neg();
    			  	        if (positive && mod.negative !== 0) {
    			  	          mod.iadd(num);
    			  	        }
    			  	      }

    			  	      return {
    			  	        div: div,
    			  	        mod: mod
    			  	      };
    			  	    }

    			  	    if (this.negative === 0 && num.negative !== 0) {
    			  	      res = this.divmod(num.neg(), mode);

    			  	      if (mode !== 'mod') {
    			  	        div = res.div.neg();
    			  	      }

    			  	      return {
    			  	        div: div,
    			  	        mod: res.mod
    			  	      };
    			  	    }

    			  	    if ((this.negative & num.negative) !== 0) {
    			  	      res = this.neg().divmod(num.neg(), mode);

    			  	      if (mode !== 'div') {
    			  	        mod = res.mod.neg();
    			  	        if (positive && mod.negative !== 0) {
    			  	          mod.isub(num);
    			  	        }
    			  	      }

    			  	      return {
    			  	        div: res.div,
    			  	        mod: mod
    			  	      };
    			  	    }

    			  	    // Both numbers are positive at this point

    			  	    // Strip both numbers to approximate shift value
    			  	    if (num.length > this.length || this.cmp(num) < 0) {
    			  	      return {
    			  	        div: new BN(0),
    			  	        mod: this
    			  	      };
    			  	    }

    			  	    // Very short reduction
    			  	    if (num.length === 1) {
    			  	      if (mode === 'div') {
    			  	        return {
    			  	          div: this.divn(num.words[0]),
    			  	          mod: null
    			  	        };
    			  	      }

    			  	      if (mode === 'mod') {
    			  	        return {
    			  	          div: null,
    			  	          mod: new BN(this.modn(num.words[0]))
    			  	        };
    			  	      }

    			  	      return {
    			  	        div: this.divn(num.words[0]),
    			  	        mod: new BN(this.modn(num.words[0]))
    			  	      };
    			  	    }

    			  	    return this._wordDiv(num, mode);
    			  	  };

    			  	  // Find `this` / `num`
    			  	  BN.prototype.div = function div (num) {
    			  	    return this.divmod(num, 'div', false).div;
    			  	  };

    			  	  // Find `this` % `num`
    			  	  BN.prototype.mod = function mod (num) {
    			  	    return this.divmod(num, 'mod', false).mod;
    			  	  };

    			  	  BN.prototype.umod = function umod (num) {
    			  	    return this.divmod(num, 'mod', true).mod;
    			  	  };

    			  	  // Find Round(`this` / `num`)
    			  	  BN.prototype.divRound = function divRound (num) {
    			  	    var dm = this.divmod(num);

    			  	    // Fast case - exact division
    			  	    if (dm.mod.isZero()) return dm.div;

    			  	    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    			  	    var half = num.ushrn(1);
    			  	    var r2 = num.andln(1);
    			  	    var cmp = mod.cmp(half);

    			  	    // Round down
    			  	    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    			  	    // Round up
    			  	    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    			  	  };

    			  	  BN.prototype.modn = function modn (num) {
    			  	    assert(num <= 0x3ffffff);
    			  	    var p = (1 << 26) % num;

    			  	    var acc = 0;
    			  	    for (var i = this.length - 1; i >= 0; i--) {
    			  	      acc = (p * acc + (this.words[i] | 0)) % num;
    			  	    }

    			  	    return acc;
    			  	  };

    			  	  // In-place division by number
    			  	  BN.prototype.idivn = function idivn (num) {
    			  	    assert(num <= 0x3ffffff);

    			  	    var carry = 0;
    			  	    for (var i = this.length - 1; i >= 0; i--) {
    			  	      var w = (this.words[i] | 0) + carry * 0x4000000;
    			  	      this.words[i] = (w / num) | 0;
    			  	      carry = w % num;
    			  	    }

    			  	    return this.strip();
    			  	  };

    			  	  BN.prototype.divn = function divn (num) {
    			  	    return this.clone().idivn(num);
    			  	  };

    			  	  BN.prototype.egcd = function egcd (p) {
    			  	    assert(p.negative === 0);
    			  	    assert(!p.isZero());

    			  	    var x = this;
    			  	    var y = p.clone();

    			  	    if (x.negative !== 0) {
    			  	      x = x.umod(p);
    			  	    } else {
    			  	      x = x.clone();
    			  	    }

    			  	    // A * x + B * y = x
    			  	    var A = new BN(1);
    			  	    var B = new BN(0);

    			  	    // C * x + D * y = y
    			  	    var C = new BN(0);
    			  	    var D = new BN(1);

    			  	    var g = 0;

    			  	    while (x.isEven() && y.isEven()) {
    			  	      x.iushrn(1);
    			  	      y.iushrn(1);
    			  	      ++g;
    			  	    }

    			  	    var yp = y.clone();
    			  	    var xp = x.clone();

    			  	    while (!x.isZero()) {
    			  	      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
    			  	      if (i > 0) {
    			  	        x.iushrn(i);
    			  	        while (i-- > 0) {
    			  	          if (A.isOdd() || B.isOdd()) {
    			  	            A.iadd(yp);
    			  	            B.isub(xp);
    			  	          }

    			  	          A.iushrn(1);
    			  	          B.iushrn(1);
    			  	        }
    			  	      }

    			  	      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
    			  	      if (j > 0) {
    			  	        y.iushrn(j);
    			  	        while (j-- > 0) {
    			  	          if (C.isOdd() || D.isOdd()) {
    			  	            C.iadd(yp);
    			  	            D.isub(xp);
    			  	          }

    			  	          C.iushrn(1);
    			  	          D.iushrn(1);
    			  	        }
    			  	      }

    			  	      if (x.cmp(y) >= 0) {
    			  	        x.isub(y);
    			  	        A.isub(C);
    			  	        B.isub(D);
    			  	      } else {
    			  	        y.isub(x);
    			  	        C.isub(A);
    			  	        D.isub(B);
    			  	      }
    			  	    }

    			  	    return {
    			  	      a: C,
    			  	      b: D,
    			  	      gcd: y.iushln(g)
    			  	    };
    			  	  };

    			  	  // This is reduced incarnation of the binary EEA
    			  	  // above, designated to invert members of the
    			  	  // _prime_ fields F(p) at a maximal speed
    			  	  BN.prototype._invmp = function _invmp (p) {
    			  	    assert(p.negative === 0);
    			  	    assert(!p.isZero());

    			  	    var a = this;
    			  	    var b = p.clone();

    			  	    if (a.negative !== 0) {
    			  	      a = a.umod(p);
    			  	    } else {
    			  	      a = a.clone();
    			  	    }

    			  	    var x1 = new BN(1);
    			  	    var x2 = new BN(0);

    			  	    var delta = b.clone();

    			  	    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
    			  	      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
    			  	      if (i > 0) {
    			  	        a.iushrn(i);
    			  	        while (i-- > 0) {
    			  	          if (x1.isOdd()) {
    			  	            x1.iadd(delta);
    			  	          }

    			  	          x1.iushrn(1);
    			  	        }
    			  	      }

    			  	      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
    			  	      if (j > 0) {
    			  	        b.iushrn(j);
    			  	        while (j-- > 0) {
    			  	          if (x2.isOdd()) {
    			  	            x2.iadd(delta);
    			  	          }

    			  	          x2.iushrn(1);
    			  	        }
    			  	      }

    			  	      if (a.cmp(b) >= 0) {
    			  	        a.isub(b);
    			  	        x1.isub(x2);
    			  	      } else {
    			  	        b.isub(a);
    			  	        x2.isub(x1);
    			  	      }
    			  	    }

    			  	    var res;
    			  	    if (a.cmpn(1) === 0) {
    			  	      res = x1;
    			  	    } else {
    			  	      res = x2;
    			  	    }

    			  	    if (res.cmpn(0) < 0) {
    			  	      res.iadd(p);
    			  	    }

    			  	    return res;
    			  	  };

    			  	  BN.prototype.gcd = function gcd (num) {
    			  	    if (this.isZero()) return num.abs();
    			  	    if (num.isZero()) return this.abs();

    			  	    var a = this.clone();
    			  	    var b = num.clone();
    			  	    a.negative = 0;
    			  	    b.negative = 0;

    			  	    // Remove common factor of two
    			  	    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
    			  	      a.iushrn(1);
    			  	      b.iushrn(1);
    			  	    }

    			  	    do {
    			  	      while (a.isEven()) {
    			  	        a.iushrn(1);
    			  	      }
    			  	      while (b.isEven()) {
    			  	        b.iushrn(1);
    			  	      }

    			  	      var r = a.cmp(b);
    			  	      if (r < 0) {
    			  	        // Swap `a` and `b` to make `a` always bigger than `b`
    			  	        var t = a;
    			  	        a = b;
    			  	        b = t;
    			  	      } else if (r === 0 || b.cmpn(1) === 0) {
    			  	        break;
    			  	      }

    			  	      a.isub(b);
    			  	    } while (true);

    			  	    return b.iushln(shift);
    			  	  };

    			  	  // Invert number in the field F(num)
    			  	  BN.prototype.invm = function invm (num) {
    			  	    return this.egcd(num).a.umod(num);
    			  	  };

    			  	  BN.prototype.isEven = function isEven () {
    			  	    return (this.words[0] & 1) === 0;
    			  	  };

    			  	  BN.prototype.isOdd = function isOdd () {
    			  	    return (this.words[0] & 1) === 1;
    			  	  };

    			  	  // And first word and num
    			  	  BN.prototype.andln = function andln (num) {
    			  	    return this.words[0] & num;
    			  	  };

    			  	  // Increment at the bit position in-line
    			  	  BN.prototype.bincn = function bincn (bit) {
    			  	    assert(typeof bit === 'number');
    			  	    var r = bit % 26;
    			  	    var s = (bit - r) / 26;
    			  	    var q = 1 << r;

    			  	    // Fast case: bit is much higher than all existing words
    			  	    if (this.length <= s) {
    			  	      this._expand(s + 1);
    			  	      this.words[s] |= q;
    			  	      return this;
    			  	    }

    			  	    // Add bit and propagate, if needed
    			  	    var carry = q;
    			  	    for (var i = s; carry !== 0 && i < this.length; i++) {
    			  	      var w = this.words[i] | 0;
    			  	      w += carry;
    			  	      carry = w >>> 26;
    			  	      w &= 0x3ffffff;
    			  	      this.words[i] = w;
    			  	    }
    			  	    if (carry !== 0) {
    			  	      this.words[i] = carry;
    			  	      this.length++;
    			  	    }
    			  	    return this;
    			  	  };

    			  	  BN.prototype.isZero = function isZero () {
    			  	    return this.length === 1 && this.words[0] === 0;
    			  	  };

    			  	  BN.prototype.cmpn = function cmpn (num) {
    			  	    var negative = num < 0;

    			  	    if (this.negative !== 0 && !negative) return -1;
    			  	    if (this.negative === 0 && negative) return 1;

    			  	    this.strip();

    			  	    var res;
    			  	    if (this.length > 1) {
    			  	      res = 1;
    			  	    } else {
    			  	      if (negative) {
    			  	        num = -num;
    			  	      }

    			  	      assert(num <= 0x3ffffff, 'Number is too big');

    			  	      var w = this.words[0] | 0;
    			  	      res = w === num ? 0 : w < num ? -1 : 1;
    			  	    }
    			  	    if (this.negative !== 0) return -res | 0;
    			  	    return res;
    			  	  };

    			  	  // Compare two numbers and return:
    			  	  // 1 - if `this` > `num`
    			  	  // 0 - if `this` == `num`
    			  	  // -1 - if `this` < `num`
    			  	  BN.prototype.cmp = function cmp (num) {
    			  	    if (this.negative !== 0 && num.negative === 0) return -1;
    			  	    if (this.negative === 0 && num.negative !== 0) return 1;

    			  	    var res = this.ucmp(num);
    			  	    if (this.negative !== 0) return -res | 0;
    			  	    return res;
    			  	  };

    			  	  // Unsigned comparison
    			  	  BN.prototype.ucmp = function ucmp (num) {
    			  	    // At this point both numbers have the same sign
    			  	    if (this.length > num.length) return 1;
    			  	    if (this.length < num.length) return -1;

    			  	    var res = 0;
    			  	    for (var i = this.length - 1; i >= 0; i--) {
    			  	      var a = this.words[i] | 0;
    			  	      var b = num.words[i] | 0;

    			  	      if (a === b) continue;
    			  	      if (a < b) {
    			  	        res = -1;
    			  	      } else if (a > b) {
    			  	        res = 1;
    			  	      }
    			  	      break;
    			  	    }
    			  	    return res;
    			  	  };

    			  	  BN.prototype.gtn = function gtn (num) {
    			  	    return this.cmpn(num) === 1;
    			  	  };

    			  	  BN.prototype.gt = function gt (num) {
    			  	    return this.cmp(num) === 1;
    			  	  };

    			  	  BN.prototype.gten = function gten (num) {
    			  	    return this.cmpn(num) >= 0;
    			  	  };

    			  	  BN.prototype.gte = function gte (num) {
    			  	    return this.cmp(num) >= 0;
    			  	  };

    			  	  BN.prototype.ltn = function ltn (num) {
    			  	    return this.cmpn(num) === -1;
    			  	  };

    			  	  BN.prototype.lt = function lt (num) {
    			  	    return this.cmp(num) === -1;
    			  	  };

    			  	  BN.prototype.lten = function lten (num) {
    			  	    return this.cmpn(num) <= 0;
    			  	  };

    			  	  BN.prototype.lte = function lte (num) {
    			  	    return this.cmp(num) <= 0;
    			  	  };

    			  	  BN.prototype.eqn = function eqn (num) {
    			  	    return this.cmpn(num) === 0;
    			  	  };

    			  	  BN.prototype.eq = function eq (num) {
    			  	    return this.cmp(num) === 0;
    			  	  };

    			  	  //
    			  	  // A reduce context, could be using montgomery or something better, depending
    			  	  // on the `m` itself.
    			  	  //
    			  	  BN.red = function red (num) {
    			  	    return new Red(num);
    			  	  };

    			  	  BN.prototype.toRed = function toRed (ctx) {
    			  	    assert(!this.red, 'Already a number in reduction context');
    			  	    assert(this.negative === 0, 'red works only with positives');
    			  	    return ctx.convertTo(this)._forceRed(ctx);
    			  	  };

    			  	  BN.prototype.fromRed = function fromRed () {
    			  	    assert(this.red, 'fromRed works only with numbers in reduction context');
    			  	    return this.red.convertFrom(this);
    			  	  };

    			  	  BN.prototype._forceRed = function _forceRed (ctx) {
    			  	    this.red = ctx;
    			  	    return this;
    			  	  };

    			  	  BN.prototype.forceRed = function forceRed (ctx) {
    			  	    assert(!this.red, 'Already a number in reduction context');
    			  	    return this._forceRed(ctx);
    			  	  };

    			  	  BN.prototype.redAdd = function redAdd (num) {
    			  	    assert(this.red, 'redAdd works only with red numbers');
    			  	    return this.red.add(this, num);
    			  	  };

    			  	  BN.prototype.redIAdd = function redIAdd (num) {
    			  	    assert(this.red, 'redIAdd works only with red numbers');
    			  	    return this.red.iadd(this, num);
    			  	  };

    			  	  BN.prototype.redSub = function redSub (num) {
    			  	    assert(this.red, 'redSub works only with red numbers');
    			  	    return this.red.sub(this, num);
    			  	  };

    			  	  BN.prototype.redISub = function redISub (num) {
    			  	    assert(this.red, 'redISub works only with red numbers');
    			  	    return this.red.isub(this, num);
    			  	  };

    			  	  BN.prototype.redShl = function redShl (num) {
    			  	    assert(this.red, 'redShl works only with red numbers');
    			  	    return this.red.shl(this, num);
    			  	  };

    			  	  BN.prototype.redMul = function redMul (num) {
    			  	    assert(this.red, 'redMul works only with red numbers');
    			  	    this.red._verify2(this, num);
    			  	    return this.red.mul(this, num);
    			  	  };

    			  	  BN.prototype.redIMul = function redIMul (num) {
    			  	    assert(this.red, 'redMul works only with red numbers');
    			  	    this.red._verify2(this, num);
    			  	    return this.red.imul(this, num);
    			  	  };

    			  	  BN.prototype.redSqr = function redSqr () {
    			  	    assert(this.red, 'redSqr works only with red numbers');
    			  	    this.red._verify1(this);
    			  	    return this.red.sqr(this);
    			  	  };

    			  	  BN.prototype.redISqr = function redISqr () {
    			  	    assert(this.red, 'redISqr works only with red numbers');
    			  	    this.red._verify1(this);
    			  	    return this.red.isqr(this);
    			  	  };

    			  	  // Square root over p
    			  	  BN.prototype.redSqrt = function redSqrt () {
    			  	    assert(this.red, 'redSqrt works only with red numbers');
    			  	    this.red._verify1(this);
    			  	    return this.red.sqrt(this);
    			  	  };

    			  	  BN.prototype.redInvm = function redInvm () {
    			  	    assert(this.red, 'redInvm works only with red numbers');
    			  	    this.red._verify1(this);
    			  	    return this.red.invm(this);
    			  	  };

    			  	  // Return negative clone of `this` % `red modulo`
    			  	  BN.prototype.redNeg = function redNeg () {
    			  	    assert(this.red, 'redNeg works only with red numbers');
    			  	    this.red._verify1(this);
    			  	    return this.red.neg(this);
    			  	  };

    			  	  BN.prototype.redPow = function redPow (num) {
    			  	    assert(this.red && !num.red, 'redPow(normalNum)');
    			  	    this.red._verify1(this);
    			  	    return this.red.pow(this, num);
    			  	  };

    			  	  // Prime numbers with efficient reduction
    			  	  var primes = {
    			  	    k256: null,
    			  	    p224: null,
    			  	    p192: null,
    			  	    p25519: null
    			  	  };

    			  	  // Pseudo-Mersenne prime
    			  	  function MPrime (name, p) {
    			  	    // P = 2 ^ N - K
    			  	    this.name = name;
    			  	    this.p = new BN(p, 16);
    			  	    this.n = this.p.bitLength();
    			  	    this.k = new BN(1).iushln(this.n).isub(this.p);

    			  	    this.tmp = this._tmp();
    			  	  }

    			  	  MPrime.prototype._tmp = function _tmp () {
    			  	    var tmp = new BN(null);
    			  	    tmp.words = new Array(Math.ceil(this.n / 13));
    			  	    return tmp;
    			  	  };

    			  	  MPrime.prototype.ireduce = function ireduce (num) {
    			  	    // Assumes that `num` is less than `P^2`
    			  	    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    			  	    var r = num;
    			  	    var rlen;

    			  	    do {
    			  	      this.split(r, this.tmp);
    			  	      r = this.imulK(r);
    			  	      r = r.iadd(this.tmp);
    			  	      rlen = r.bitLength();
    			  	    } while (rlen > this.n);

    			  	    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    			  	    if (cmp === 0) {
    			  	      r.words[0] = 0;
    			  	      r.length = 1;
    			  	    } else if (cmp > 0) {
    			  	      r.isub(this.p);
    			  	    } else {
    			  	      if (r.strip !== undefined) {
    			  	        // r is BN v4 instance
    			  	        r.strip();
    			  	      } else {
    			  	        // r is BN v5 instance
    			  	        r._strip();
    			  	      }
    			  	    }

    			  	    return r;
    			  	  };

    			  	  MPrime.prototype.split = function split (input, out) {
    			  	    input.iushrn(this.n, 0, out);
    			  	  };

    			  	  MPrime.prototype.imulK = function imulK (num) {
    			  	    return num.imul(this.k);
    			  	  };

    			  	  function K256 () {
    			  	    MPrime.call(
    			  	      this,
    			  	      'k256',
    			  	      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    			  	  }
    			  	  inherits(K256, MPrime);

    			  	  K256.prototype.split = function split (input, output) {
    			  	    // 256 = 9 * 26 + 22
    			  	    var mask = 0x3fffff;

    			  	    var outLen = Math.min(input.length, 9);
    			  	    for (var i = 0; i < outLen; i++) {
    			  	      output.words[i] = input.words[i];
    			  	    }
    			  	    output.length = outLen;

    			  	    if (input.length <= 9) {
    			  	      input.words[0] = 0;
    			  	      input.length = 1;
    			  	      return;
    			  	    }

    			  	    // Shift by 9 limbs
    			  	    var prev = input.words[9];
    			  	    output.words[output.length++] = prev & mask;

    			  	    for (i = 10; i < input.length; i++) {
    			  	      var next = input.words[i] | 0;
    			  	      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
    			  	      prev = next;
    			  	    }
    			  	    prev >>>= 22;
    			  	    input.words[i - 10] = prev;
    			  	    if (prev === 0 && input.length > 10) {
    			  	      input.length -= 10;
    			  	    } else {
    			  	      input.length -= 9;
    			  	    }
    			  	  };

    			  	  K256.prototype.imulK = function imulK (num) {
    			  	    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    			  	    num.words[num.length] = 0;
    			  	    num.words[num.length + 1] = 0;
    			  	    num.length += 2;

    			  	    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    			  	    var lo = 0;
    			  	    for (var i = 0; i < num.length; i++) {
    			  	      var w = num.words[i] | 0;
    			  	      lo += w * 0x3d1;
    			  	      num.words[i] = lo & 0x3ffffff;
    			  	      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    			  	    }

    			  	    // Fast length reduction
    			  	    if (num.words[num.length - 1] === 0) {
    			  	      num.length--;
    			  	      if (num.words[num.length - 1] === 0) {
    			  	        num.length--;
    			  	      }
    			  	    }
    			  	    return num;
    			  	  };

    			  	  function P224 () {
    			  	    MPrime.call(
    			  	      this,
    			  	      'p224',
    			  	      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    			  	  }
    			  	  inherits(P224, MPrime);

    			  	  function P192 () {
    			  	    MPrime.call(
    			  	      this,
    			  	      'p192',
    			  	      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    			  	  }
    			  	  inherits(P192, MPrime);

    			  	  function P25519 () {
    			  	    // 2 ^ 255 - 19
    			  	    MPrime.call(
    			  	      this,
    			  	      '25519',
    			  	      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    			  	  }
    			  	  inherits(P25519, MPrime);

    			  	  P25519.prototype.imulK = function imulK (num) {
    			  	    // K = 0x13
    			  	    var carry = 0;
    			  	    for (var i = 0; i < num.length; i++) {
    			  	      var hi = (num.words[i] | 0) * 0x13 + carry;
    			  	      var lo = hi & 0x3ffffff;
    			  	      hi >>>= 26;

    			  	      num.words[i] = lo;
    			  	      carry = hi;
    			  	    }
    			  	    if (carry !== 0) {
    			  	      num.words[num.length++] = carry;
    			  	    }
    			  	    return num;
    			  	  };

    			  	  // Exported mostly for testing purposes, use plain name instead
    			  	  BN._prime = function prime (name) {
    			  	    // Cached version of prime
    			  	    if (primes[name]) return primes[name];

    			  	    var prime;
    			  	    if (name === 'k256') {
    			  	      prime = new K256();
    			  	    } else if (name === 'p224') {
    			  	      prime = new P224();
    			  	    } else if (name === 'p192') {
    			  	      prime = new P192();
    			  	    } else if (name === 'p25519') {
    			  	      prime = new P25519();
    			  	    } else {
    			  	      throw new Error('Unknown prime ' + name);
    			  	    }
    			  	    primes[name] = prime;

    			  	    return prime;
    			  	  };

    			  	  //
    			  	  // Base reduction engine
    			  	  //
    			  	  function Red (m) {
    			  	    if (typeof m === 'string') {
    			  	      var prime = BN._prime(m);
    			  	      this.m = prime.p;
    			  	      this.prime = prime;
    			  	    } else {
    			  	      assert(m.gtn(1), 'modulus must be greater than 1');
    			  	      this.m = m;
    			  	      this.prime = null;
    			  	    }
    			  	  }

    			  	  Red.prototype._verify1 = function _verify1 (a) {
    			  	    assert(a.negative === 0, 'red works only with positives');
    			  	    assert(a.red, 'red works only with red numbers');
    			  	  };

    			  	  Red.prototype._verify2 = function _verify2 (a, b) {
    			  	    assert((a.negative | b.negative) === 0, 'red works only with positives');
    			  	    assert(a.red && a.red === b.red,
    			  	      'red works only with red numbers');
    			  	  };

    			  	  Red.prototype.imod = function imod (a) {
    			  	    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    			  	    return a.umod(this.m)._forceRed(this);
    			  	  };

    			  	  Red.prototype.neg = function neg (a) {
    			  	    if (a.isZero()) {
    			  	      return a.clone();
    			  	    }

    			  	    return this.m.sub(a)._forceRed(this);
    			  	  };

    			  	  Red.prototype.add = function add (a, b) {
    			  	    this._verify2(a, b);

    			  	    var res = a.add(b);
    			  	    if (res.cmp(this.m) >= 0) {
    			  	      res.isub(this.m);
    			  	    }
    			  	    return res._forceRed(this);
    			  	  };

    			  	  Red.prototype.iadd = function iadd (a, b) {
    			  	    this._verify2(a, b);

    			  	    var res = a.iadd(b);
    			  	    if (res.cmp(this.m) >= 0) {
    			  	      res.isub(this.m);
    			  	    }
    			  	    return res;
    			  	  };

    			  	  Red.prototype.sub = function sub (a, b) {
    			  	    this._verify2(a, b);

    			  	    var res = a.sub(b);
    			  	    if (res.cmpn(0) < 0) {
    			  	      res.iadd(this.m);
    			  	    }
    			  	    return res._forceRed(this);
    			  	  };

    			  	  Red.prototype.isub = function isub (a, b) {
    			  	    this._verify2(a, b);

    			  	    var res = a.isub(b);
    			  	    if (res.cmpn(0) < 0) {
    			  	      res.iadd(this.m);
    			  	    }
    			  	    return res;
    			  	  };

    			  	  Red.prototype.shl = function shl (a, num) {
    			  	    this._verify1(a);
    			  	    return this.imod(a.ushln(num));
    			  	  };

    			  	  Red.prototype.imul = function imul (a, b) {
    			  	    this._verify2(a, b);
    			  	    return this.imod(a.imul(b));
    			  	  };

    			  	  Red.prototype.mul = function mul (a, b) {
    			  	    this._verify2(a, b);
    			  	    return this.imod(a.mul(b));
    			  	  };

    			  	  Red.prototype.isqr = function isqr (a) {
    			  	    return this.imul(a, a.clone());
    			  	  };

    			  	  Red.prototype.sqr = function sqr (a) {
    			  	    return this.mul(a, a);
    			  	  };

    			  	  Red.prototype.sqrt = function sqrt (a) {
    			  	    if (a.isZero()) return a.clone();

    			  	    var mod3 = this.m.andln(3);
    			  	    assert(mod3 % 2 === 1);

    			  	    // Fast case
    			  	    if (mod3 === 3) {
    			  	      var pow = this.m.add(new BN(1)).iushrn(2);
    			  	      return this.pow(a, pow);
    			  	    }

    			  	    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    			  	    //
    			  	    // Find Q and S, that Q * 2 ^ S = (P - 1)
    			  	    var q = this.m.subn(1);
    			  	    var s = 0;
    			  	    while (!q.isZero() && q.andln(1) === 0) {
    			  	      s++;
    			  	      q.iushrn(1);
    			  	    }
    			  	    assert(!q.isZero());

    			  	    var one = new BN(1).toRed(this);
    			  	    var nOne = one.redNeg();

    			  	    // Find quadratic non-residue
    			  	    // NOTE: Max is such because of generalized Riemann hypothesis.
    			  	    var lpow = this.m.subn(1).iushrn(1);
    			  	    var z = this.m.bitLength();
    			  	    z = new BN(2 * z * z).toRed(this);

    			  	    while (this.pow(z, lpow).cmp(nOne) !== 0) {
    			  	      z.redIAdd(nOne);
    			  	    }

    			  	    var c = this.pow(z, q);
    			  	    var r = this.pow(a, q.addn(1).iushrn(1));
    			  	    var t = this.pow(a, q);
    			  	    var m = s;
    			  	    while (t.cmp(one) !== 0) {
    			  	      var tmp = t;
    			  	      for (var i = 0; tmp.cmp(one) !== 0; i++) {
    			  	        tmp = tmp.redSqr();
    			  	      }
    			  	      assert(i < m);
    			  	      var b = this.pow(c, new BN(1).iushln(m - i - 1));

    			  	      r = r.redMul(b);
    			  	      c = b.redSqr();
    			  	      t = t.redMul(c);
    			  	      m = i;
    			  	    }

    			  	    return r;
    			  	  };

    			  	  Red.prototype.invm = function invm (a) {
    			  	    var inv = a._invmp(this.m);
    			  	    if (inv.negative !== 0) {
    			  	      inv.negative = 0;
    			  	      return this.imod(inv).redNeg();
    			  	    } else {
    			  	      return this.imod(inv);
    			  	    }
    			  	  };

    			  	  Red.prototype.pow = function pow (a, num) {
    			  	    if (num.isZero()) return new BN(1).toRed(this);
    			  	    if (num.cmpn(1) === 0) return a.clone();

    			  	    var windowSize = 4;
    			  	    var wnd = new Array(1 << windowSize);
    			  	    wnd[0] = new BN(1).toRed(this);
    			  	    wnd[1] = a;
    			  	    for (var i = 2; i < wnd.length; i++) {
    			  	      wnd[i] = this.mul(wnd[i - 1], a);
    			  	    }

    			  	    var res = wnd[0];
    			  	    var current = 0;
    			  	    var currentLen = 0;
    			  	    var start = num.bitLength() % 26;
    			  	    if (start === 0) {
    			  	      start = 26;
    			  	    }

    			  	    for (i = num.length - 1; i >= 0; i--) {
    			  	      var word = num.words[i];
    			  	      for (var j = start - 1; j >= 0; j--) {
    			  	        var bit = (word >> j) & 1;
    			  	        if (res !== wnd[0]) {
    			  	          res = this.sqr(res);
    			  	        }

    			  	        if (bit === 0 && current === 0) {
    			  	          currentLen = 0;
    			  	          continue;
    			  	        }

    			  	        current <<= 1;
    			  	        current |= bit;
    			  	        currentLen++;
    			  	        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

    			  	        res = this.mul(res, wnd[current]);
    			  	        currentLen = 0;
    			  	        current = 0;
    			  	      }
    			  	      start = 26;
    			  	    }

    			  	    return res;
    			  	  };

    			  	  Red.prototype.convertTo = function convertTo (num) {
    			  	    var r = num.umod(this.m);

    			  	    return r === num ? r.clone() : r;
    			  	  };

    			  	  Red.prototype.convertFrom = function convertFrom (num) {
    			  	    var res = num.clone();
    			  	    res.red = null;
    			  	    return res;
    			  	  };

    			  	  //
    			  	  // Montgomery method engine
    			  	  //

    			  	  BN.mont = function mont (num) {
    			  	    return new Mont(num);
    			  	  };

    			  	  function Mont (m) {
    			  	    Red.call(this, m);

    			  	    this.shift = this.m.bitLength();
    			  	    if (this.shift % 26 !== 0) {
    			  	      this.shift += 26 - (this.shift % 26);
    			  	    }

    			  	    this.r = new BN(1).iushln(this.shift);
    			  	    this.r2 = this.imod(this.r.sqr());
    			  	    this.rinv = this.r._invmp(this.m);

    			  	    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    			  	    this.minv = this.minv.umod(this.r);
    			  	    this.minv = this.r.sub(this.minv);
    			  	  }
    			  	  inherits(Mont, Red);

    			  	  Mont.prototype.convertTo = function convertTo (num) {
    			  	    return this.imod(num.ushln(this.shift));
    			  	  };

    			  	  Mont.prototype.convertFrom = function convertFrom (num) {
    			  	    var r = this.imod(num.mul(this.rinv));
    			  	    r.red = null;
    			  	    return r;
    			  	  };

    			  	  Mont.prototype.imul = function imul (a, b) {
    			  	    if (a.isZero() || b.isZero()) {
    			  	      a.words[0] = 0;
    			  	      a.length = 1;
    			  	      return a;
    			  	    }

    			  	    var t = a.imul(b);
    			  	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    			  	    var u = t.isub(c).iushrn(this.shift);
    			  	    var res = u;

    			  	    if (u.cmp(this.m) >= 0) {
    			  	      res = u.isub(this.m);
    			  	    } else if (u.cmpn(0) < 0) {
    			  	      res = u.iadd(this.m);
    			  	    }

    			  	    return res._forceRed(this);
    			  	  };

    			  	  Mont.prototype.mul = function mul (a, b) {
    			  	    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    			  	    var t = a.mul(b);
    			  	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    			  	    var u = t.isub(c).iushrn(this.shift);
    			  	    var res = u;
    			  	    if (u.cmp(this.m) >= 0) {
    			  	      res = u.isub(this.m);
    			  	    } else if (u.cmpn(0) < 0) {
    			  	      res = u.iadd(this.m);
    			  	    }

    			  	    return res._forceRed(this);
    			  	  };

    			  	  Mont.prototype.invm = function invm (a) {
    			  	    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    			  	    var res = this.imod(a._invmp(this.m).mul(this.r2));
    			  	    return res._forceRed(this);
    			  	  };
    			  	})(module, commonjsGlobal$1$1); 
    			  } (bn));

    			  var bnExports = bn.exports;
    			  var BN = /*@__PURE__*/getDefaultExportFromCjs(bnExports);

    			  var long = Long;

    			  /**
    			   * wasm optimizations, to do native i64 multiplication and divide
    			   */
    			  var wasm = null;

    			  try {
    			    wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
    			      0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11
    			    ])), {}).exports;
    			  } catch (e) {
    			    // no wasm support :(
    			  }

    			  /**
    			   * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
    			   *  See the from* functions below for more convenient ways of constructing Longs.
    			   * @exports Long
    			   * @class A Long class for representing a 64 bit two's-complement integer value.
    			   * @param {number} low The low (signed) 32 bits of the long
    			   * @param {number} high The high (signed) 32 bits of the long
    			   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
    			   * @constructor
    			   */
    			  function Long(low, high, unsigned) {

    			      /**
    			       * The low 32 bits as a signed value.
    			       * @type {number}
    			       */
    			      this.low = low | 0;

    			      /**
    			       * The high 32 bits as a signed value.
    			       * @type {number}
    			       */
    			      this.high = high | 0;

    			      /**
    			       * Whether unsigned or not.
    			       * @type {boolean}
    			       */
    			      this.unsigned = !!unsigned;
    			  }

    			  // The internal representation of a long is the two given signed, 32-bit values.
    			  // We use 32-bit pieces because these are the size of integers on which
    			  // Javascript performs bit-operations.  For operations like addition and
    			  // multiplication, we split each number into 16 bit pieces, which can easily be
    			  // multiplied within Javascript's floating-point representation without overflow
    			  // or change in sign.
    			  //
    			  // In the algorithms below, we frequently reduce the negative case to the
    			  // positive case by negating the input(s) and then post-processing the result.
    			  // Note that we must ALWAYS check specially whether those values are MIN_VALUE
    			  // (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
    			  // a positive number, it overflows back into a negative).  Not handling this
    			  // case would often result in infinite recursion.
    			  //
    			  // Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
    			  // methods on which they depend.

    			  /**
    			   * An indicator used to reliably determine if an object is a Long or not.
    			   * @type {boolean}
    			   * @const
    			   * @private
    			   */
    			  Long.prototype.__isLong__;

    			  Object.defineProperty(Long.prototype, "__isLong__", { value: true });

    			  /**
    			   * @function
    			   * @param {*} obj Object
    			   * @returns {boolean}
    			   * @inner
    			   */
    			  function isLong$1(obj) {
    			      return (obj && obj["__isLong__"]) === true;
    			  }

    			  /**
    			   * Tests if the specified object is a Long.
    			   * @function
    			   * @param {*} obj Object
    			   * @returns {boolean}
    			   */
    			  Long.isLong = isLong$1;

    			  /**
    			   * A cache of the Long representations of small integer values.
    			   * @type {!Object}
    			   * @inner
    			   */
    			  var INT_CACHE = {};

    			  /**
    			   * A cache of the Long representations of small unsigned integer values.
    			   * @type {!Object}
    			   * @inner
    			   */
    			  var UINT_CACHE = {};

    			  /**
    			   * @param {number} value
    			   * @param {boolean=} unsigned
    			   * @returns {!Long}
    			   * @inner
    			   */
    			  function fromInt(value, unsigned) {
    			      var obj, cachedObj, cache;
    			      if (unsigned) {
    			          value >>>= 0;
    			          if (cache = (0 <= value && value < 256)) {
    			              cachedObj = UINT_CACHE[value];
    			              if (cachedObj)
    			                  return cachedObj;
    			          }
    			          obj = fromBits(value, (value | 0) < 0 ? -1 : 0, true);
    			          if (cache)
    			              UINT_CACHE[value] = obj;
    			          return obj;
    			      } else {
    			          value |= 0;
    			          if (cache = (-128 <= value && value < 128)) {
    			              cachedObj = INT_CACHE[value];
    			              if (cachedObj)
    			                  return cachedObj;
    			          }
    			          obj = fromBits(value, value < 0 ? -1 : 0, false);
    			          if (cache)
    			              INT_CACHE[value] = obj;
    			          return obj;
    			      }
    			  }

    			  /**
    			   * Returns a Long representing the given 32 bit integer value.
    			   * @function
    			   * @param {number} value The 32 bit integer in question
    			   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
    			   * @returns {!Long} The corresponding Long value
    			   */
    			  Long.fromInt = fromInt;

    			  /**
    			   * @param {number} value
    			   * @param {boolean=} unsigned
    			   * @returns {!Long}
    			   * @inner
    			   */
    			  function fromNumber(value, unsigned) {
    			      if (isNaN(value))
    			          return unsigned ? UZERO : ZERO;
    			      if (unsigned) {
    			          if (value < 0)
    			              return UZERO;
    			          if (value >= TWO_PWR_64_DBL)
    			              return MAX_UNSIGNED_VALUE;
    			      } else {
    			          if (value <= -TWO_PWR_63_DBL)
    			              return MIN_VALUE;
    			          if (value + 1 >= TWO_PWR_63_DBL)
    			              return MAX_VALUE;
    			      }
    			      if (value < 0)
    			          return fromNumber(-value, unsigned).neg();
    			      return fromBits((value % TWO_PWR_32_DBL) | 0, (value / TWO_PWR_32_DBL) | 0, unsigned);
    			  }

    			  /**
    			   * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
    			   * @function
    			   * @param {number} value The number in question
    			   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
    			   * @returns {!Long} The corresponding Long value
    			   */
    			  Long.fromNumber = fromNumber;

    			  /**
    			   * @param {number} lowBits
    			   * @param {number} highBits
    			   * @param {boolean=} unsigned
    			   * @returns {!Long}
    			   * @inner
    			   */
    			  function fromBits(lowBits, highBits, unsigned) {
    			      return new Long(lowBits, highBits, unsigned);
    			  }

    			  /**
    			   * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
    			   *  assumed to use 32 bits.
    			   * @function
    			   * @param {number} lowBits The low 32 bits
    			   * @param {number} highBits The high 32 bits
    			   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
    			   * @returns {!Long} The corresponding Long value
    			   */
    			  Long.fromBits = fromBits;

    			  /**
    			   * @function
    			   * @param {number} base
    			   * @param {number} exponent
    			   * @returns {number}
    			   * @inner
    			   */
    			  var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)

    			  /**
    			   * @param {string} str
    			   * @param {(boolean|number)=} unsigned
    			   * @param {number=} radix
    			   * @returns {!Long}
    			   * @inner
    			   */
    			  function fromString(str, unsigned, radix) {
    			      if (str.length === 0)
    			          throw Error('empty string');
    			      if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity")
    			          return ZERO;
    			      if (typeof unsigned === 'number') {
    			          // For goog.math.long compatibility
    			          radix = unsigned,
    			          unsigned = false;
    			      } else {
    			          unsigned = !! unsigned;
    			      }
    			      radix = radix || 10;
    			      if (radix < 2 || 36 < radix)
    			          throw RangeError('radix');

    			      var p;
    			      if ((p = str.indexOf('-')) > 0)
    			          throw Error('interior hyphen');
    			      else if (p === 0) {
    			          return fromString(str.substring(1), unsigned, radix).neg();
    			      }

    			      // Do several (8) digits each time through the loop, so as to
    			      // minimize the calls to the very expensive emulated div.
    			      var radixToPower = fromNumber(pow_dbl(radix, 8));

    			      var result = ZERO;
    			      for (var i = 0; i < str.length; i += 8) {
    			          var size = Math.min(8, str.length - i),
    			              value = parseInt(str.substring(i, i + size), radix);
    			          if (size < 8) {
    			              var power = fromNumber(pow_dbl(radix, size));
    			              result = result.mul(power).add(fromNumber(value));
    			          } else {
    			              result = result.mul(radixToPower);
    			              result = result.add(fromNumber(value));
    			          }
    			      }
    			      result.unsigned = unsigned;
    			      return result;
    			  }

    			  /**
    			   * Returns a Long representation of the given string, written using the specified radix.
    			   * @function
    			   * @param {string} str The textual representation of the Long
    			   * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
    			   * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
    			   * @returns {!Long} The corresponding Long value
    			   */
    			  Long.fromString = fromString;

    			  /**
    			   * @function
    			   * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
    			   * @param {boolean=} unsigned
    			   * @returns {!Long}
    			   * @inner
    			   */
    			  function fromValue(val, unsigned) {
    			      if (typeof val === 'number')
    			          return fromNumber(val, unsigned);
    			      if (typeof val === 'string')
    			          return fromString(val, unsigned);
    			      // Throws for non-objects, converts non-instanceof Long:
    			      return fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
    			  }

    			  /**
    			   * Converts the specified value to a Long using the appropriate from* function for its type.
    			   * @function
    			   * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
    			   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
    			   * @returns {!Long}
    			   */
    			  Long.fromValue = fromValue;

    			  // NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
    			  // no runtime penalty for these.

    			  /**
    			   * @type {number}
    			   * @const
    			   * @inner
    			   */
    			  var TWO_PWR_16_DBL = 1 << 16;

    			  /**
    			   * @type {number}
    			   * @const
    			   * @inner
    			   */
    			  var TWO_PWR_24_DBL = 1 << 24;

    			  /**
    			   * @type {number}
    			   * @const
    			   * @inner
    			   */
    			  var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;

    			  /**
    			   * @type {number}
    			   * @const
    			   * @inner
    			   */
    			  var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;

    			  /**
    			   * @type {number}
    			   * @const
    			   * @inner
    			   */
    			  var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;

    			  /**
    			   * @type {!Long}
    			   * @const
    			   * @inner
    			   */
    			  var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);

    			  /**
    			   * @type {!Long}
    			   * @inner
    			   */
    			  var ZERO = fromInt(0);

    			  /**
    			   * Signed zero.
    			   * @type {!Long}
    			   */
    			  Long.ZERO = ZERO;

    			  /**
    			   * @type {!Long}
    			   * @inner
    			   */
    			  var UZERO = fromInt(0, true);

    			  /**
    			   * Unsigned zero.
    			   * @type {!Long}
    			   */
    			  Long.UZERO = UZERO;

    			  /**
    			   * @type {!Long}
    			   * @inner
    			   */
    			  var ONE = fromInt(1);

    			  /**
    			   * Signed one.
    			   * @type {!Long}
    			   */
    			  Long.ONE = ONE;

    			  /**
    			   * @type {!Long}
    			   * @inner
    			   */
    			  var UONE = fromInt(1, true);

    			  /**
    			   * Unsigned one.
    			   * @type {!Long}
    			   */
    			  Long.UONE = UONE;

    			  /**
    			   * @type {!Long}
    			   * @inner
    			   */
    			  var NEG_ONE = fromInt(-1);

    			  /**
    			   * Signed negative one.
    			   * @type {!Long}
    			   */
    			  Long.NEG_ONE = NEG_ONE;

    			  /**
    			   * @type {!Long}
    			   * @inner
    			   */
    			  var MAX_VALUE = fromBits(0xFFFFFFFF|0, 0x7FFFFFFF|0, false);

    			  /**
    			   * Maximum signed value.
    			   * @type {!Long}
    			   */
    			  Long.MAX_VALUE = MAX_VALUE;

    			  /**
    			   * @type {!Long}
    			   * @inner
    			   */
    			  var MAX_UNSIGNED_VALUE = fromBits(0xFFFFFFFF|0, 0xFFFFFFFF|0, true);

    			  /**
    			   * Maximum unsigned value.
    			   * @type {!Long}
    			   */
    			  Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;

    			  /**
    			   * @type {!Long}
    			   * @inner
    			   */
    			  var MIN_VALUE = fromBits(0, 0x80000000|0, false);

    			  /**
    			   * Minimum signed value.
    			   * @type {!Long}
    			   */
    			  Long.MIN_VALUE = MIN_VALUE;

    			  /**
    			   * @alias Long.prototype
    			   * @inner
    			   */
    			  var LongPrototype = Long.prototype;

    			  /**
    			   * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
    			   * @returns {number}
    			   */
    			  LongPrototype.toInt = function toInt() {
    			      return this.unsigned ? this.low >>> 0 : this.low;
    			  };

    			  /**
    			   * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
    			   * @returns {number}
    			   */
    			  LongPrototype.toNumber = function toNumber() {
    			      if (this.unsigned)
    			          return ((this.high >>> 0) * TWO_PWR_32_DBL) + (this.low >>> 0);
    			      return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
    			  };

    			  /**
    			   * Converts the Long to a string written in the specified radix.
    			   * @param {number=} radix Radix (2-36), defaults to 10
    			   * @returns {string}
    			   * @override
    			   * @throws {RangeError} If `radix` is out of range
    			   */
    			  LongPrototype.toString = function toString(radix) {
    			      radix = radix || 10;
    			      if (radix < 2 || 36 < radix)
    			          throw RangeError('radix');
    			      if (this.isZero())
    			          return '0';
    			      if (this.isNegative()) { // Unsigned Longs are never negative
    			          if (this.eq(MIN_VALUE)) {
    			              // We need to change the Long value before it can be negated, so we remove
    			              // the bottom-most digit in this base and then recurse to do the rest.
    			              var radixLong = fromNumber(radix),
    			                  div = this.div(radixLong),
    			                  rem1 = div.mul(radixLong).sub(this);
    			              return div.toString(radix) + rem1.toInt().toString(radix);
    			          } else
    			              return '-' + this.neg().toString(radix);
    			      }

    			      // Do several (6) digits each time through the loop, so as to
    			      // minimize the calls to the very expensive emulated div.
    			      var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned),
    			          rem = this;
    			      var result = '';
    			      while (true) {
    			          var remDiv = rem.div(radixToPower),
    			              intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0,
    			              digits = intval.toString(radix);
    			          rem = remDiv;
    			          if (rem.isZero())
    			              return digits + result;
    			          else {
    			              while (digits.length < 6)
    			                  digits = '0' + digits;
    			              result = '' + digits + result;
    			          }
    			      }
    			  };

    			  /**
    			   * Gets the high 32 bits as a signed integer.
    			   * @returns {number} Signed high bits
    			   */
    			  LongPrototype.getHighBits = function getHighBits() {
    			      return this.high;
    			  };

    			  /**
    			   * Gets the high 32 bits as an unsigned integer.
    			   * @returns {number} Unsigned high bits
    			   */
    			  LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    			      return this.high >>> 0;
    			  };

    			  /**
    			   * Gets the low 32 bits as a signed integer.
    			   * @returns {number} Signed low bits
    			   */
    			  LongPrototype.getLowBits = function getLowBits() {
    			      return this.low;
    			  };

    			  /**
    			   * Gets the low 32 bits as an unsigned integer.
    			   * @returns {number} Unsigned low bits
    			   */
    			  LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    			      return this.low >>> 0;
    			  };

    			  /**
    			   * Gets the number of bits needed to represent the absolute value of this Long.
    			   * @returns {number}
    			   */
    			  LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    			      if (this.isNegative()) // Unsigned Longs are never negative
    			          return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    			      var val = this.high != 0 ? this.high : this.low;
    			      for (var bit = 31; bit > 0; bit--)
    			          if ((val & (1 << bit)) != 0)
    			              break;
    			      return this.high != 0 ? bit + 33 : bit + 1;
    			  };

    			  /**
    			   * Tests if this Long's value equals zero.
    			   * @returns {boolean}
    			   */
    			  LongPrototype.isZero = function isZero() {
    			      return this.high === 0 && this.low === 0;
    			  };

    			  /**
    			   * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
    			   * @returns {boolean}
    			   */
    			  LongPrototype.eqz = LongPrototype.isZero;

    			  /**
    			   * Tests if this Long's value is negative.
    			   * @returns {boolean}
    			   */
    			  LongPrototype.isNegative = function isNegative() {
    			      return !this.unsigned && this.high < 0;
    			  };

    			  /**
    			   * Tests if this Long's value is positive.
    			   * @returns {boolean}
    			   */
    			  LongPrototype.isPositive = function isPositive() {
    			      return this.unsigned || this.high >= 0;
    			  };

    			  /**
    			   * Tests if this Long's value is odd.
    			   * @returns {boolean}
    			   */
    			  LongPrototype.isOdd = function isOdd() {
    			      return (this.low & 1) === 1;
    			  };

    			  /**
    			   * Tests if this Long's value is even.
    			   * @returns {boolean}
    			   */
    			  LongPrototype.isEven = function isEven() {
    			      return (this.low & 1) === 0;
    			  };

    			  /**
    			   * Tests if this Long's value equals the specified's.
    			   * @param {!Long|number|string} other Other value
    			   * @returns {boolean}
    			   */
    			  LongPrototype.equals = function equals(other) {
    			      if (!isLong$1(other))
    			          other = fromValue(other);
    			      if (this.unsigned !== other.unsigned && (this.high >>> 31) === 1 && (other.high >>> 31) === 1)
    			          return false;
    			      return this.high === other.high && this.low === other.low;
    			  };

    			  /**
    			   * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
    			   * @function
    			   * @param {!Long|number|string} other Other value
    			   * @returns {boolean}
    			   */
    			  LongPrototype.eq = LongPrototype.equals;

    			  /**
    			   * Tests if this Long's value differs from the specified's.
    			   * @param {!Long|number|string} other Other value
    			   * @returns {boolean}
    			   */
    			  LongPrototype.notEquals = function notEquals(other) {
    			      return !this.eq(/* validates */ other);
    			  };

    			  /**
    			   * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
    			   * @function
    			   * @param {!Long|number|string} other Other value
    			   * @returns {boolean}
    			   */
    			  LongPrototype.neq = LongPrototype.notEquals;

    			  /**
    			   * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
    			   * @function
    			   * @param {!Long|number|string} other Other value
    			   * @returns {boolean}
    			   */
    			  LongPrototype.ne = LongPrototype.notEquals;

    			  /**
    			   * Tests if this Long's value is less than the specified's.
    			   * @param {!Long|number|string} other Other value
    			   * @returns {boolean}
    			   */
    			  LongPrototype.lessThan = function lessThan(other) {
    			      return this.comp(/* validates */ other) < 0;
    			  };

    			  /**
    			   * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
    			   * @function
    			   * @param {!Long|number|string} other Other value
    			   * @returns {boolean}
    			   */
    			  LongPrototype.lt = LongPrototype.lessThan;

    			  /**
    			   * Tests if this Long's value is less than or equal the specified's.
    			   * @param {!Long|number|string} other Other value
    			   * @returns {boolean}
    			   */
    			  LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    			      return this.comp(/* validates */ other) <= 0;
    			  };

    			  /**
    			   * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
    			   * @function
    			   * @param {!Long|number|string} other Other value
    			   * @returns {boolean}
    			   */
    			  LongPrototype.lte = LongPrototype.lessThanOrEqual;

    			  /**
    			   * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
    			   * @function
    			   * @param {!Long|number|string} other Other value
    			   * @returns {boolean}
    			   */
    			  LongPrototype.le = LongPrototype.lessThanOrEqual;

    			  /**
    			   * Tests if this Long's value is greater than the specified's.
    			   * @param {!Long|number|string} other Other value
    			   * @returns {boolean}
    			   */
    			  LongPrototype.greaterThan = function greaterThan(other) {
    			      return this.comp(/* validates */ other) > 0;
    			  };

    			  /**
    			   * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
    			   * @function
    			   * @param {!Long|number|string} other Other value
    			   * @returns {boolean}
    			   */
    			  LongPrototype.gt = LongPrototype.greaterThan;

    			  /**
    			   * Tests if this Long's value is greater than or equal the specified's.
    			   * @param {!Long|number|string} other Other value
    			   * @returns {boolean}
    			   */
    			  LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    			      return this.comp(/* validates */ other) >= 0;
    			  };

    			  /**
    			   * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
    			   * @function
    			   * @param {!Long|number|string} other Other value
    			   * @returns {boolean}
    			   */
    			  LongPrototype.gte = LongPrototype.greaterThanOrEqual;

    			  /**
    			   * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
    			   * @function
    			   * @param {!Long|number|string} other Other value
    			   * @returns {boolean}
    			   */
    			  LongPrototype.ge = LongPrototype.greaterThanOrEqual;

    			  /**
    			   * Compares this Long's value with the specified's.
    			   * @param {!Long|number|string} other Other value
    			   * @returns {number} 0 if they are the same, 1 if the this is greater and -1
    			   *  if the given one is greater
    			   */
    			  LongPrototype.compare = function compare(other) {
    			      if (!isLong$1(other))
    			          other = fromValue(other);
    			      if (this.eq(other))
    			          return 0;
    			      var thisNeg = this.isNegative(),
    			          otherNeg = other.isNegative();
    			      if (thisNeg && !otherNeg)
    			          return -1;
    			      if (!thisNeg && otherNeg)
    			          return 1;
    			      // At this point the sign bits are the same
    			      if (!this.unsigned)
    			          return this.sub(other).isNegative() ? -1 : 1;
    			      // Both are positive if at least one is unsigned
    			      return (other.high >>> 0) > (this.high >>> 0) || (other.high === this.high && (other.low >>> 0) > (this.low >>> 0)) ? -1 : 1;
    			  };

    			  /**
    			   * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
    			   * @function
    			   * @param {!Long|number|string} other Other value
    			   * @returns {number} 0 if they are the same, 1 if the this is greater and -1
    			   *  if the given one is greater
    			   */
    			  LongPrototype.comp = LongPrototype.compare;

    			  /**
    			   * Negates this Long's value.
    			   * @returns {!Long} Negated Long
    			   */
    			  LongPrototype.negate = function negate() {
    			      if (!this.unsigned && this.eq(MIN_VALUE))
    			          return MIN_VALUE;
    			      return this.not().add(ONE);
    			  };

    			  /**
    			   * Negates this Long's value. This is an alias of {@link Long#negate}.
    			   * @function
    			   * @returns {!Long} Negated Long
    			   */
    			  LongPrototype.neg = LongPrototype.negate;

    			  /**
    			   * Returns the sum of this and the specified Long.
    			   * @param {!Long|number|string} addend Addend
    			   * @returns {!Long} Sum
    			   */
    			  LongPrototype.add = function add(addend) {
    			      if (!isLong$1(addend))
    			          addend = fromValue(addend);

    			      // Divide each number into 4 chunks of 16 bits, and then sum the chunks.

    			      var a48 = this.high >>> 16;
    			      var a32 = this.high & 0xFFFF;
    			      var a16 = this.low >>> 16;
    			      var a00 = this.low & 0xFFFF;

    			      var b48 = addend.high >>> 16;
    			      var b32 = addend.high & 0xFFFF;
    			      var b16 = addend.low >>> 16;
    			      var b00 = addend.low & 0xFFFF;

    			      var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    			      c00 += a00 + b00;
    			      c16 += c00 >>> 16;
    			      c00 &= 0xFFFF;
    			      c16 += a16 + b16;
    			      c32 += c16 >>> 16;
    			      c16 &= 0xFFFF;
    			      c32 += a32 + b32;
    			      c48 += c32 >>> 16;
    			      c32 &= 0xFFFF;
    			      c48 += a48 + b48;
    			      c48 &= 0xFFFF;
    			      return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
    			  };

    			  /**
    			   * Returns the difference of this and the specified Long.
    			   * @param {!Long|number|string} subtrahend Subtrahend
    			   * @returns {!Long} Difference
    			   */
    			  LongPrototype.subtract = function subtract(subtrahend) {
    			      if (!isLong$1(subtrahend))
    			          subtrahend = fromValue(subtrahend);
    			      return this.add(subtrahend.neg());
    			  };

    			  /**
    			   * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
    			   * @function
    			   * @param {!Long|number|string} subtrahend Subtrahend
    			   * @returns {!Long} Difference
    			   */
    			  LongPrototype.sub = LongPrototype.subtract;

    			  /**
    			   * Returns the product of this and the specified Long.
    			   * @param {!Long|number|string} multiplier Multiplier
    			   * @returns {!Long} Product
    			   */
    			  LongPrototype.multiply = function multiply(multiplier) {
    			      if (this.isZero())
    			          return ZERO;
    			      if (!isLong$1(multiplier))
    			          multiplier = fromValue(multiplier);

    			      // use wasm support if present
    			      if (wasm) {
    			          var low = wasm.mul(this.low,
    			                             this.high,
    			                             multiplier.low,
    			                             multiplier.high);
    			          return fromBits(low, wasm.get_high(), this.unsigned);
    			      }

    			      if (multiplier.isZero())
    			          return ZERO;
    			      if (this.eq(MIN_VALUE))
    			          return multiplier.isOdd() ? MIN_VALUE : ZERO;
    			      if (multiplier.eq(MIN_VALUE))
    			          return this.isOdd() ? MIN_VALUE : ZERO;

    			      if (this.isNegative()) {
    			          if (multiplier.isNegative())
    			              return this.neg().mul(multiplier.neg());
    			          else
    			              return this.neg().mul(multiplier).neg();
    			      } else if (multiplier.isNegative())
    			          return this.mul(multiplier.neg()).neg();

    			      // If both longs are small, use float multiplication
    			      if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24))
    			          return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);

    			      // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    			      // We can skip products that would overflow.

    			      var a48 = this.high >>> 16;
    			      var a32 = this.high & 0xFFFF;
    			      var a16 = this.low >>> 16;
    			      var a00 = this.low & 0xFFFF;

    			      var b48 = multiplier.high >>> 16;
    			      var b32 = multiplier.high & 0xFFFF;
    			      var b16 = multiplier.low >>> 16;
    			      var b00 = multiplier.low & 0xFFFF;

    			      var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    			      c00 += a00 * b00;
    			      c16 += c00 >>> 16;
    			      c00 &= 0xFFFF;
    			      c16 += a16 * b00;
    			      c32 += c16 >>> 16;
    			      c16 &= 0xFFFF;
    			      c16 += a00 * b16;
    			      c32 += c16 >>> 16;
    			      c16 &= 0xFFFF;
    			      c32 += a32 * b00;
    			      c48 += c32 >>> 16;
    			      c32 &= 0xFFFF;
    			      c32 += a16 * b16;
    			      c48 += c32 >>> 16;
    			      c32 &= 0xFFFF;
    			      c32 += a00 * b32;
    			      c48 += c32 >>> 16;
    			      c32 &= 0xFFFF;
    			      c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    			      c48 &= 0xFFFF;
    			      return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
    			  };

    			  /**
    			   * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
    			   * @function
    			   * @param {!Long|number|string} multiplier Multiplier
    			   * @returns {!Long} Product
    			   */
    			  LongPrototype.mul = LongPrototype.multiply;

    			  /**
    			   * Returns this Long divided by the specified. The result is signed if this Long is signed or
    			   *  unsigned if this Long is unsigned.
    			   * @param {!Long|number|string} divisor Divisor
    			   * @returns {!Long} Quotient
    			   */
    			  LongPrototype.divide = function divide(divisor) {
    			      if (!isLong$1(divisor))
    			          divisor = fromValue(divisor);
    			      if (divisor.isZero())
    			          throw Error('division by zero');

    			      // use wasm support if present
    			      if (wasm) {
    			          // guard against signed division overflow: the largest
    			          // negative number / -1 would be 1 larger than the largest
    			          // positive number, due to two's complement.
    			          if (!this.unsigned &&
    			              this.high === -0x80000000 &&
    			              divisor.low === -1 && divisor.high === -1) {
    			              // be consistent with non-wasm code path
    			              return this;
    			          }
    			          var low = (this.unsigned ? wasm.div_u : wasm.div_s)(
    			              this.low,
    			              this.high,
    			              divisor.low,
    			              divisor.high
    			          );
    			          return fromBits(low, wasm.get_high(), this.unsigned);
    			      }

    			      if (this.isZero())
    			          return this.unsigned ? UZERO : ZERO;
    			      var approx, rem, res;
    			      if (!this.unsigned) {
    			          // This section is only relevant for signed longs and is derived from the
    			          // closure library as a whole.
    			          if (this.eq(MIN_VALUE)) {
    			              if (divisor.eq(ONE) || divisor.eq(NEG_ONE))
    			                  return MIN_VALUE;  // recall that -MIN_VALUE == MIN_VALUE
    			              else if (divisor.eq(MIN_VALUE))
    			                  return ONE;
    			              else {
    			                  // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
    			                  var halfThis = this.shr(1);
    			                  approx = halfThis.div(divisor).shl(1);
    			                  if (approx.eq(ZERO)) {
    			                      return divisor.isNegative() ? ONE : NEG_ONE;
    			                  } else {
    			                      rem = this.sub(divisor.mul(approx));
    			                      res = approx.add(rem.div(divisor));
    			                      return res;
    			                  }
    			              }
    			          } else if (divisor.eq(MIN_VALUE))
    			              return this.unsigned ? UZERO : ZERO;
    			          if (this.isNegative()) {
    			              if (divisor.isNegative())
    			                  return this.neg().div(divisor.neg());
    			              return this.neg().div(divisor).neg();
    			          } else if (divisor.isNegative())
    			              return this.div(divisor.neg()).neg();
    			          res = ZERO;
    			      } else {
    			          // The algorithm below has not been made for unsigned longs. It's therefore
    			          // required to take special care of the MSB prior to running it.
    			          if (!divisor.unsigned)
    			              divisor = divisor.toUnsigned();
    			          if (divisor.gt(this))
    			              return UZERO;
    			          if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
    			              return UONE;
    			          res = UZERO;
    			      }

    			      // Repeat the following until the remainder is less than other:  find a
    			      // floating-point that approximates remainder / other *from below*, add this
    			      // into the result, and subtract it from the remainder.  It is critical that
    			      // the approximate value is less than or equal to the real value so that the
    			      // remainder never becomes negative.
    			      rem = this;
    			      while (rem.gte(divisor)) {
    			          // Approximate the result of division. This may be a little greater or
    			          // smaller than the actual value.
    			          approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));

    			          // We will tweak the approximate result by changing it in the 48-th digit or
    			          // the smallest non-fractional digit, whichever is larger.
    			          var log2 = Math.ceil(Math.log(approx) / Math.LN2),
    			              delta = (log2 <= 48) ? 1 : pow_dbl(2, log2 - 48),

    			          // Decrease the approximation until it is smaller than the remainder.  Note
    			          // that if it is too large, the product overflows and is negative.
    			              approxRes = fromNumber(approx),
    			              approxRem = approxRes.mul(divisor);
    			          while (approxRem.isNegative() || approxRem.gt(rem)) {
    			              approx -= delta;
    			              approxRes = fromNumber(approx, this.unsigned);
    			              approxRem = approxRes.mul(divisor);
    			          }

    			          // We know the answer can't be zero... and actually, zero would cause
    			          // infinite recursion since we would make no progress.
    			          if (approxRes.isZero())
    			              approxRes = ONE;

    			          res = res.add(approxRes);
    			          rem = rem.sub(approxRem);
    			      }
    			      return res;
    			  };

    			  /**
    			   * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
    			   * @function
    			   * @param {!Long|number|string} divisor Divisor
    			   * @returns {!Long} Quotient
    			   */
    			  LongPrototype.div = LongPrototype.divide;

    			  /**
    			   * Returns this Long modulo the specified.
    			   * @param {!Long|number|string} divisor Divisor
    			   * @returns {!Long} Remainder
    			   */
    			  LongPrototype.modulo = function modulo(divisor) {
    			      if (!isLong$1(divisor))
    			          divisor = fromValue(divisor);

    			      // use wasm support if present
    			      if (wasm) {
    			          var low = (this.unsigned ? wasm.rem_u : wasm.rem_s)(
    			              this.low,
    			              this.high,
    			              divisor.low,
    			              divisor.high
    			          );
    			          return fromBits(low, wasm.get_high(), this.unsigned);
    			      }

    			      return this.sub(this.div(divisor).mul(divisor));
    			  };

    			  /**
    			   * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
    			   * @function
    			   * @param {!Long|number|string} divisor Divisor
    			   * @returns {!Long} Remainder
    			   */
    			  LongPrototype.mod = LongPrototype.modulo;

    			  /**
    			   * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
    			   * @function
    			   * @param {!Long|number|string} divisor Divisor
    			   * @returns {!Long} Remainder
    			   */
    			  LongPrototype.rem = LongPrototype.modulo;

    			  /**
    			   * Returns the bitwise NOT of this Long.
    			   * @returns {!Long}
    			   */
    			  LongPrototype.not = function not() {
    			      return fromBits(~this.low, ~this.high, this.unsigned);
    			  };

    			  /**
    			   * Returns the bitwise AND of this Long and the specified.
    			   * @param {!Long|number|string} other Other Long
    			   * @returns {!Long}
    			   */
    			  LongPrototype.and = function and(other) {
    			      if (!isLong$1(other))
    			          other = fromValue(other);
    			      return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
    			  };

    			  /**
    			   * Returns the bitwise OR of this Long and the specified.
    			   * @param {!Long|number|string} other Other Long
    			   * @returns {!Long}
    			   */
    			  LongPrototype.or = function or(other) {
    			      if (!isLong$1(other))
    			          other = fromValue(other);
    			      return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
    			  };

    			  /**
    			   * Returns the bitwise XOR of this Long and the given one.
    			   * @param {!Long|number|string} other Other Long
    			   * @returns {!Long}
    			   */
    			  LongPrototype.xor = function xor(other) {
    			      if (!isLong$1(other))
    			          other = fromValue(other);
    			      return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
    			  };

    			  /**
    			   * Returns this Long with bits shifted to the left by the given amount.
    			   * @param {number|!Long} numBits Number of bits
    			   * @returns {!Long} Shifted Long
    			   */
    			  LongPrototype.shiftLeft = function shiftLeft(numBits) {
    			      if (isLong$1(numBits))
    			          numBits = numBits.toInt();
    			      if ((numBits &= 63) === 0)
    			          return this;
    			      else if (numBits < 32)
    			          return fromBits(this.low << numBits, (this.high << numBits) | (this.low >>> (32 - numBits)), this.unsigned);
    			      else
    			          return fromBits(0, this.low << (numBits - 32), this.unsigned);
    			  };

    			  /**
    			   * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
    			   * @function
    			   * @param {number|!Long} numBits Number of bits
    			   * @returns {!Long} Shifted Long
    			   */
    			  LongPrototype.shl = LongPrototype.shiftLeft;

    			  /**
    			   * Returns this Long with bits arithmetically shifted to the right by the given amount.
    			   * @param {number|!Long} numBits Number of bits
    			   * @returns {!Long} Shifted Long
    			   */
    			  LongPrototype.shiftRight = function shiftRight(numBits) {
    			      if (isLong$1(numBits))
    			          numBits = numBits.toInt();
    			      if ((numBits &= 63) === 0)
    			          return this;
    			      else if (numBits < 32)
    			          return fromBits((this.low >>> numBits) | (this.high << (32 - numBits)), this.high >> numBits, this.unsigned);
    			      else
    			          return fromBits(this.high >> (numBits - 32), this.high >= 0 ? 0 : -1, this.unsigned);
    			  };

    			  /**
    			   * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
    			   * @function
    			   * @param {number|!Long} numBits Number of bits
    			   * @returns {!Long} Shifted Long
    			   */
    			  LongPrototype.shr = LongPrototype.shiftRight;

    			  /**
    			   * Returns this Long with bits logically shifted to the right by the given amount.
    			   * @param {number|!Long} numBits Number of bits
    			   * @returns {!Long} Shifted Long
    			   */
    			  LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    			      if (isLong$1(numBits))
    			          numBits = numBits.toInt();
    			      numBits &= 63;
    			      if (numBits === 0)
    			          return this;
    			      else {
    			          var high = this.high;
    			          if (numBits < 32) {
    			              var low = this.low;
    			              return fromBits((low >>> numBits) | (high << (32 - numBits)), high >>> numBits, this.unsigned);
    			          } else if (numBits === 32)
    			              return fromBits(high, 0, this.unsigned);
    			          else
    			              return fromBits(high >>> (numBits - 32), 0, this.unsigned);
    			      }
    			  };

    			  /**
    			   * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
    			   * @function
    			   * @param {number|!Long} numBits Number of bits
    			   * @returns {!Long} Shifted Long
    			   */
    			  LongPrototype.shru = LongPrototype.shiftRightUnsigned;

    			  /**
    			   * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
    			   * @function
    			   * @param {number|!Long} numBits Number of bits
    			   * @returns {!Long} Shifted Long
    			   */
    			  LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;

    			  /**
    			   * Converts this Long to signed.
    			   * @returns {!Long} Signed long
    			   */
    			  LongPrototype.toSigned = function toSigned() {
    			      if (!this.unsigned)
    			          return this;
    			      return fromBits(this.low, this.high, false);
    			  };

    			  /**
    			   * Converts this Long to unsigned.
    			   * @returns {!Long} Unsigned long
    			   */
    			  LongPrototype.toUnsigned = function toUnsigned() {
    			      if (this.unsigned)
    			          return this;
    			      return fromBits(this.low, this.high, true);
    			  };

    			  /**
    			   * Converts this Long to its byte representation.
    			   * @param {boolean=} le Whether little or big endian, defaults to big endian
    			   * @returns {!Array.<number>} Byte representation
    			   */
    			  LongPrototype.toBytes = function toBytes(le) {
    			      return le ? this.toBytesLE() : this.toBytesBE();
    			  };

    			  /**
    			   * Converts this Long to its little endian byte representation.
    			   * @returns {!Array.<number>} Little endian byte representation
    			   */
    			  LongPrototype.toBytesLE = function toBytesLE() {
    			      var hi = this.high,
    			          lo = this.low;
    			      return [
    			          lo        & 0xff,
    			          lo >>>  8 & 0xff,
    			          lo >>> 16 & 0xff,
    			          lo >>> 24       ,
    			          hi        & 0xff,
    			          hi >>>  8 & 0xff,
    			          hi >>> 16 & 0xff,
    			          hi >>> 24
    			      ];
    			  };

    			  /**
    			   * Converts this Long to its big endian byte representation.
    			   * @returns {!Array.<number>} Big endian byte representation
    			   */
    			  LongPrototype.toBytesBE = function toBytesBE() {
    			      var hi = this.high,
    			          lo = this.low;
    			      return [
    			          hi >>> 24       ,
    			          hi >>> 16 & 0xff,
    			          hi >>>  8 & 0xff,
    			          hi        & 0xff,
    			          lo >>> 24       ,
    			          lo >>> 16 & 0xff,
    			          lo >>>  8 & 0xff,
    			          lo        & 0xff
    			      ];
    			  };

    			  /**
    			   * Creates a Long from its byte representation.
    			   * @param {!Array.<number>} bytes Byte representation
    			   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
    			   * @param {boolean=} le Whether little or big endian, defaults to big endian
    			   * @returns {Long} The corresponding Long value
    			   */
    			  Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    			      return le ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
    			  };

    			  /**
    			   * Creates a Long from its little endian byte representation.
    			   * @param {!Array.<number>} bytes Little endian byte representation
    			   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
    			   * @returns {Long} The corresponding Long value
    			   */
    			  Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    			      return new Long(
    			          bytes[0]       |
    			          bytes[1] <<  8 |
    			          bytes[2] << 16 |
    			          bytes[3] << 24,
    			          bytes[4]       |
    			          bytes[5] <<  8 |
    			          bytes[6] << 16 |
    			          bytes[7] << 24,
    			          unsigned
    			      );
    			  };

    			  /**
    			   * Creates a Long from its big endian byte representation.
    			   * @param {!Array.<number>} bytes Big endian byte representation
    			   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
    			   * @returns {Long} The corresponding Long value
    			   */
    			  Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    			      return new Long(
    			          bytes[4] << 24 |
    			          bytes[5] << 16 |
    			          bytes[6] <<  8 |
    			          bytes[7],
    			          bytes[0] << 24 |
    			          bytes[1] << 16 |
    			          bytes[2] <<  8 |
    			          bytes[3],
    			          unsigned
    			      );
    			  };

    			  var Long$1 = /*@__PURE__*/getDefaultExportFromCjs(long);

    			  //  Copyright (C) 2018 Zilliqa
    			  var isAddress = function (address) {
    			      return isByteString(address, 40);
    			  };
    			  var isBech32 = function (raw) {
    			      return !!raw.match(/^zil1[qpzry9x8gf2tvdw0s3jn54khce6mua7l]{38}$/);
    			  };
    			  var isBase58 = function (raw) {
    			      return !!raw.match(/^[1-9ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]+$/);
    			  };
    			  var isPrivateKey = function (privateKey) {
    			      return isByteString(privateKey, 64);
    			  };
    			  var isPubKey = function (pubKey) {
    			      return isByteString(pubKey, 66);
    			  };
    			  var isSignature = function (sig) {
    			      return isByteString(sig, 128);
    			  };
    			  var isByteString = function (str, len) {
    			      return !!str.replace('0x', '').match("^[0-9a-fA-F]{".concat(len, "}$"));
    			  };
    			  var isNumber = function (x) {
    			      return typeof x === 'number';
    			  };
    			  var isBN = function (x) {
    			      return BN.isBN(x);
    			  };
    			  var isLong = function (x) {
    			      return Long$1.isLong(x);
    			  };
    			  var isString = function (x) {
    			      return typeof x === 'string';
    			  };
    			  var isPlainObject = function (x) {
    			      if (typeof x === 'object' && x !== null) {
    			          var proto = Object.getPrototypeOf(x);
    			          return proto === Object.prototype || proto === null;
    			      }
    			      return false;
    			  };
    			  var PRAGMA_REQUIRED = '@@ZJS_REQUIRED@@';
    			  var required = function (fn) {
    			      if (typeof fn === 'function') {
    			          return Object.defineProperty(fn, 'required', {
    			              value: PRAGMA_REQUIRED,
    			          });
    			      }
    			      throw new Error('fn is not a function');
    			  };
    			  var matchesObject = function (x, test) {
    			      var e_1, _a;
    			      if (isPlainObject(x)) {
    			          for (var key in test) {
    			              if (test.hasOwnProperty(key)) {
    			                  try {
    			                      for (var _b = (e_1 = void 0, __values(test[key])), _c = _b.next(); !_c.done; _c = _b.next()) {
    			                          var tester = _c.value;
    			                          var value = x[key];
    			                          if (typeof value === 'undefined' && tester.required) {
    			                              throw new Error('Key not found: ' + key);
    			                          }
    			                          else {
    			                              continue;
    			                          }
    			                      }
    			                  }
    			                  catch (e_1_1) { e_1 = { error: e_1_1 }; }
    			                  finally {
    			                      try {
    			                          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    			                      }
    			                      finally { if (e_1) throw e_1.error; }
    			                  }
    			              }
    			          }
    			      }
    			      return true;
    			  };

    			  var validation = /*#__PURE__*/Object.freeze({
    			    __proto__: null,
    			    isAddress: isAddress,
    			    isBech32: isBech32,
    			    isBase58: isBase58,
    			    isPrivateKey: isPrivateKey,
    			    isPubKey: isPubKey,
    			    isSignature: isSignature,
    			    isByteString: isByteString,
    			    isNumber: isNumber,
    			    isBN: isBN,
    			    isLong: isLong,
    			    isString: isString,
    			    isPlainObject: isPlainObject,
    			    required: required,
    			    matchesObject: matchesObject
    			  });

    			  //  Copyright (C) 2018 Zilliqa
    			  var Units;
    			  (function (Units) {
    			      Units["Zil"] = "zil";
    			      Units["Li"] = "li";
    			      Units["Qa"] = "qa";
    			  })(Units || (Units = {}));
    			  var DEFAULT_OPTIONS = {
    			      pad: false,
    			  };
    			  var unitMap = new Map([
    			      [Units.Qa, '1'],
    			      [Units.Li, '1000000'],
    			      [Units.Zil, '1000000000000'], // 1e12 qa
    			  ]);
    			  var numToStr = function (input) {
    			      if (typeof input === 'string') {
    			          if (!input.match(/^-?[0-9.]+$/)) {
    			              throw new Error("while converting number to string, invalid number value '".concat(input, "', should be a number matching (^-?[0-9.]+)."));
    			          }
    			          return input;
    			      }
    			      else if (typeof input === 'number') {
    			          return String(input);
    			      }
    			      else if (BN.isBN(input)) {
    			          return input.toString(10);
    			      }
    			      throw new Error("while converting number to string, invalid number value '".concat(input, "' type ").concat(typeof input, "."));
    			  };
    			  var fromQa = function (qa, unit, options) {
    			      if (options === void 0) { options = DEFAULT_OPTIONS; }
    			      if (unit === 'qa') {
    			          return qa.toString(10);
    			      }
    			      var baseStr = unitMap.get(unit);
    			      if (!baseStr) {
    			          throw new Error("No unit of type ".concat(unit, " exists."));
    			      }
    			      var base = new BN(baseStr, 10);
    			      var baseNumDecimals = baseStr.length - 1;
    			      var fraction = qa.abs().mod(base).toString(10);
    			      // prepend 0s to the fraction half
    			      while (fraction.length < baseNumDecimals) {
    			          fraction = "0".concat(fraction);
    			      }
    			      if (!options.pad) {
    			          fraction = (fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1]);
    			      }
    			      var whole = qa.div(base).toString(10);
    			      return fraction === '0' ? "".concat(whole) : "".concat(whole, ".").concat(fraction);
    			  };
    			  var toQa = function (input, unit) {
    			      var inputStr = numToStr(input);
    			      var baseStr = unitMap.get(unit);
    			      if (!baseStr) {
    			          throw new Error("No unit of type ".concat(unit, " exists."));
    			      }
    			      var baseNumDecimals = baseStr.length - 1;
    			      var base = new BN(baseStr, 10);
    			      // Is it negative?
    			      var isNegative = inputStr.substring(0, 1) === '-';
    			      if (isNegative) {
    			          inputStr = inputStr.substring(1);
    			      }
    			      if (inputStr === '.') {
    			          throw new Error("Cannot convert ".concat(inputStr, " to Qa."));
    			      }
    			      // Split it into a whole and fractional part
    			      var comps = inputStr.split('.'); // eslint-disable-line
    			      if (comps.length > 2) {
    			          throw new Error("Cannot convert ".concat(inputStr, " to Qa."));
    			      }
    			      var _a = __read(comps, 2), whole = _a[0], fraction = _a[1];
    			      if (!whole) {
    			          whole = '0';
    			      }
    			      if (!fraction) {
    			          fraction = '0';
    			      }
    			      if (fraction.length > baseNumDecimals) {
    			          throw new Error("Cannot convert ".concat(inputStr, " to Qa."));
    			      }
    			      while (fraction.length < baseNumDecimals) {
    			          fraction += '0';
    			      }
    			      var wholeBN = new BN(whole);
    			      var fractionBN = new BN(fraction);
    			      var wei = wholeBN.mul(base).add(fractionBN); // eslint-disable-line
    			      if (isNegative) {
    			          wei = wei.neg();
    			      }
    			      return new BN(wei.toString(10), 10);
    			  };

    			  var unit = /*#__PURE__*/Object.freeze({
    			    __proto__: null,
    			    get Units () { return Units; },
    			    fromQa: fromQa,
    			    toQa: toQa
    			  });

    			  exports.BN = BN;
    			  exports.Long = Long$1;
    			  exports.bytes = bytes;
    			  exports.units = unit;
    			  exports.validation = validation;

    			  Object.defineProperty(exports, '__esModule', { value: true });

    			}));
    			
    		} (bundle, bundle.exports));

    		var bundleExports = bundle.exports;

    		var cryptoJs$1 = {exports: {}};

    		function commonjsRequire(path) {
    			throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
    		}

    		var core = {exports: {}};

    		core.exports;

    		var hasRequiredCore;

    		function requireCore () {
    			if (hasRequiredCore) return core.exports;
    			hasRequiredCore = 1;
    			(function (module, exports) {
    		(function (root, factory) {
    					{
    						// CommonJS
    						module.exports = factory();
    					}
    				}(commonjsGlobal$1, function () {

    					/*globals window, global, require*/

    					/**
    					 * CryptoJS core components.
    					 */
    					var CryptoJS = CryptoJS || (function (Math, undefined$1) {

    					    var crypto;

    					    // Native crypto from window (Browser)
    					    if (typeof window !== 'undefined' && window.crypto) {
    					        crypto = window.crypto;
    					    }

    					    // Native crypto in web worker (Browser)
    					    if (typeof self !== 'undefined' && self.crypto) {
    					        crypto = self.crypto;
    					    }

    					    // Native crypto from worker
    					    if (typeof globalThis !== 'undefined' && globalThis.crypto) {
    					        crypto = globalThis.crypto;
    					    }

    					    // Native (experimental IE 11) crypto from window (Browser)
    					    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
    					        crypto = window.msCrypto;
    					    }

    					    // Native crypto from global (NodeJS)
    					    if (!crypto && typeof commonjsGlobal$1 !== 'undefined' && commonjsGlobal$1.crypto) {
    					        crypto = commonjsGlobal$1.crypto;
    					    }

    					    // Native crypto import via require (NodeJS)
    					    if (!crypto && typeof commonjsRequire === 'function') {
    					        try {
    					            crypto = require$$0$2;
    					        } catch (err) {}
    					    }

    					    /*
    					     * Cryptographically secure pseudorandom number generator
    					     *
    					     * As Math.random() is cryptographically not safe to use
    					     */
    					    var cryptoSecureRandomInt = function () {
    					        if (crypto) {
    					            // Use getRandomValues method (Browser)
    					            if (typeof crypto.getRandomValues === 'function') {
    					                try {
    					                    return crypto.getRandomValues(new Uint32Array(1))[0];
    					                } catch (err) {}
    					            }

    					            // Use randomBytes method (NodeJS)
    					            if (typeof crypto.randomBytes === 'function') {
    					                try {
    					                    return crypto.randomBytes(4).readInt32LE();
    					                } catch (err) {}
    					            }
    					        }

    					        throw new Error('Native crypto module could not be used to get secure random number.');
    					    };

    					    /*
    					     * Local polyfill of Object.create

    					     */
    					    var create = Object.create || (function () {
    					        function F() {}

    					        return function (obj) {
    					            var subtype;

    					            F.prototype = obj;

    					            subtype = new F();

    					            F.prototype = null;

    					            return subtype;
    					        };
    					    }());

    					    /**
    					     * CryptoJS namespace.
    					     */
    					    var C = {};

    					    /**
    					     * Library namespace.
    					     */
    					    var C_lib = C.lib = {};

    					    /**
    					     * Base object for prototypal inheritance.
    					     */
    					    var Base = C_lib.Base = (function () {


    					        return {
    					            /**
    					             * Creates a new object that inherits from this object.
    					             *
    					             * @param {Object} overrides Properties to copy into the new object.
    					             *
    					             * @return {Object} The new object.
    					             *
    					             * @static
    					             *
    					             * @example
    					             *
    					             *     var MyType = CryptoJS.lib.Base.extend({
    					             *         field: 'value',
    					             *
    					             *         method: function () {
    					             *         }
    					             *     });
    					             */
    					            extend: function (overrides) {
    					                // Spawn
    					                var subtype = create(this);

    					                // Augment
    					                if (overrides) {
    					                    subtype.mixIn(overrides);
    					                }

    					                // Create default initializer
    					                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
    					                    subtype.init = function () {
    					                        subtype.$super.init.apply(this, arguments);
    					                    };
    					                }

    					                // Initializer's prototype is the subtype object
    					                subtype.init.prototype = subtype;

    					                // Reference supertype
    					                subtype.$super = this;

    					                return subtype;
    					            },

    					            /**
    					             * Extends this object and runs the init method.
    					             * Arguments to create() will be passed to init().
    					             *
    					             * @return {Object} The new object.
    					             *
    					             * @static
    					             *
    					             * @example
    					             *
    					             *     var instance = MyType.create();
    					             */
    					            create: function () {
    					                var instance = this.extend();
    					                instance.init.apply(instance, arguments);

    					                return instance;
    					            },

    					            /**
    					             * Initializes a newly created object.
    					             * Override this method to add some logic when your objects are created.
    					             *
    					             * @example
    					             *
    					             *     var MyType = CryptoJS.lib.Base.extend({
    					             *         init: function () {
    					             *             // ...
    					             *         }
    					             *     });
    					             */
    					            init: function () {
    					            },

    					            /**
    					             * Copies properties into this object.
    					             *
    					             * @param {Object} properties The properties to mix in.
    					             *
    					             * @example
    					             *
    					             *     MyType.mixIn({
    					             *         field: 'value'
    					             *     });
    					             */
    					            mixIn: function (properties) {
    					                for (var propertyName in properties) {
    					                    if (properties.hasOwnProperty(propertyName)) {
    					                        this[propertyName] = properties[propertyName];
    					                    }
    					                }

    					                // IE won't copy toString using the loop above
    					                if (properties.hasOwnProperty('toString')) {
    					                    this.toString = properties.toString;
    					                }
    					            },

    					            /**
    					             * Creates a copy of this object.
    					             *
    					             * @return {Object} The clone.
    					             *
    					             * @example
    					             *
    					             *     var clone = instance.clone();
    					             */
    					            clone: function () {
    					                return this.init.prototype.extend(this);
    					            }
    					        };
    					    }());

    					    /**
    					     * An array of 32-bit words.
    					     *
    					     * @property {Array} words The array of 32-bit words.
    					     * @property {number} sigBytes The number of significant bytes in this word array.
    					     */
    					    var WordArray = C_lib.WordArray = Base.extend({
    					        /**
    					         * Initializes a newly created word array.
    					         *
    					         * @param {Array} words (Optional) An array of 32-bit words.
    					         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
    					         *
    					         * @example
    					         *
    					         *     var wordArray = CryptoJS.lib.WordArray.create();
    					         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
    					         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
    					         */
    					        init: function (words, sigBytes) {
    					            words = this.words = words || [];

    					            if (sigBytes != undefined$1) {
    					                this.sigBytes = sigBytes;
    					            } else {
    					                this.sigBytes = words.length * 4;
    					            }
    					        },

    					        /**
    					         * Converts this word array to a string.
    					         *
    					         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
    					         *
    					         * @return {string} The stringified word array.
    					         *
    					         * @example
    					         *
    					         *     var string = wordArray + '';
    					         *     var string = wordArray.toString();
    					         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
    					         */
    					        toString: function (encoder) {
    					            return (encoder || Hex).stringify(this);
    					        },

    					        /**
    					         * Concatenates a word array to this word array.
    					         *
    					         * @param {WordArray} wordArray The word array to append.
    					         *
    					         * @return {WordArray} This word array.
    					         *
    					         * @example
    					         *
    					         *     wordArray1.concat(wordArray2);
    					         */
    					        concat: function (wordArray) {
    					            // Shortcuts
    					            var thisWords = this.words;
    					            var thatWords = wordArray.words;
    					            var thisSigBytes = this.sigBytes;
    					            var thatSigBytes = wordArray.sigBytes;

    					            // Clamp excess bits
    					            this.clamp();

    					            // Concat
    					            if (thisSigBytes % 4) {
    					                // Copy one byte at a time
    					                for (var i = 0; i < thatSigBytes; i++) {
    					                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
    					                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
    					                }
    					            } else {
    					                // Copy one word at a time
    					                for (var j = 0; j < thatSigBytes; j += 4) {
    					                    thisWords[(thisSigBytes + j) >>> 2] = thatWords[j >>> 2];
    					                }
    					            }
    					            this.sigBytes += thatSigBytes;

    					            // Chainable
    					            return this;
    					        },

    					        /**
    					         * Removes insignificant bits.
    					         *
    					         * @example
    					         *
    					         *     wordArray.clamp();
    					         */
    					        clamp: function () {
    					            // Shortcuts
    					            var words = this.words;
    					            var sigBytes = this.sigBytes;

    					            // Clamp
    					            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
    					            words.length = Math.ceil(sigBytes / 4);
    					        },

    					        /**
    					         * Creates a copy of this word array.
    					         *
    					         * @return {WordArray} The clone.
    					         *
    					         * @example
    					         *
    					         *     var clone = wordArray.clone();
    					         */
    					        clone: function () {
    					            var clone = Base.clone.call(this);
    					            clone.words = this.words.slice(0);

    					            return clone;
    					        },

    					        /**
    					         * Creates a word array filled with random bytes.
    					         *
    					         * @param {number} nBytes The number of random bytes to generate.
    					         *
    					         * @return {WordArray} The random word array.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var wordArray = CryptoJS.lib.WordArray.random(16);
    					         */
    					        random: function (nBytes) {
    					            var words = [];

    					            for (var i = 0; i < nBytes; i += 4) {
    					                words.push(cryptoSecureRandomInt());
    					            }

    					            return new WordArray.init(words, nBytes);
    					        }
    					    });

    					    /**
    					     * Encoder namespace.
    					     */
    					    var C_enc = C.enc = {};

    					    /**
    					     * Hex encoding strategy.
    					     */
    					    var Hex = C_enc.Hex = {
    					        /**
    					         * Converts a word array to a hex string.
    					         *
    					         * @param {WordArray} wordArray The word array.
    					         *
    					         * @return {string} The hex string.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
    					         */
    					        stringify: function (wordArray) {
    					            // Shortcuts
    					            var words = wordArray.words;
    					            var sigBytes = wordArray.sigBytes;

    					            // Convert
    					            var hexChars = [];
    					            for (var i = 0; i < sigBytes; i++) {
    					                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
    					                hexChars.push((bite >>> 4).toString(16));
    					                hexChars.push((bite & 0x0f).toString(16));
    					            }

    					            return hexChars.join('');
    					        },

    					        /**
    					         * Converts a hex string to a word array.
    					         *
    					         * @param {string} hexStr The hex string.
    					         *
    					         * @return {WordArray} The word array.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
    					         */
    					        parse: function (hexStr) {
    					            // Shortcut
    					            var hexStrLength = hexStr.length;

    					            // Convert
    					            var words = [];
    					            for (var i = 0; i < hexStrLength; i += 2) {
    					                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
    					            }

    					            return new WordArray.init(words, hexStrLength / 2);
    					        }
    					    };

    					    /**
    					     * Latin1 encoding strategy.
    					     */
    					    var Latin1 = C_enc.Latin1 = {
    					        /**
    					         * Converts a word array to a Latin1 string.
    					         *
    					         * @param {WordArray} wordArray The word array.
    					         *
    					         * @return {string} The Latin1 string.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
    					         */
    					        stringify: function (wordArray) {
    					            // Shortcuts
    					            var words = wordArray.words;
    					            var sigBytes = wordArray.sigBytes;

    					            // Convert
    					            var latin1Chars = [];
    					            for (var i = 0; i < sigBytes; i++) {
    					                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
    					                latin1Chars.push(String.fromCharCode(bite));
    					            }

    					            return latin1Chars.join('');
    					        },

    					        /**
    					         * Converts a Latin1 string to a word array.
    					         *
    					         * @param {string} latin1Str The Latin1 string.
    					         *
    					         * @return {WordArray} The word array.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
    					         */
    					        parse: function (latin1Str) {
    					            // Shortcut
    					            var latin1StrLength = latin1Str.length;

    					            // Convert
    					            var words = [];
    					            for (var i = 0; i < latin1StrLength; i++) {
    					                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
    					            }

    					            return new WordArray.init(words, latin1StrLength);
    					        }
    					    };

    					    /**
    					     * UTF-8 encoding strategy.
    					     */
    					    var Utf8 = C_enc.Utf8 = {
    					        /**
    					         * Converts a word array to a UTF-8 string.
    					         *
    					         * @param {WordArray} wordArray The word array.
    					         *
    					         * @return {string} The UTF-8 string.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
    					         */
    					        stringify: function (wordArray) {
    					            try {
    					                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
    					            } catch (e) {
    					                throw new Error('Malformed UTF-8 data');
    					            }
    					        },

    					        /**
    					         * Converts a UTF-8 string to a word array.
    					         *
    					         * @param {string} utf8Str The UTF-8 string.
    					         *
    					         * @return {WordArray} The word array.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
    					         */
    					        parse: function (utf8Str) {
    					            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
    					        }
    					    };

    					    /**
    					     * Abstract buffered block algorithm template.
    					     *
    					     * The property blockSize must be implemented in a concrete subtype.
    					     *
    					     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
    					     */
    					    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
    					        /**
    					         * Resets this block algorithm's data buffer to its initial state.
    					         *
    					         * @example
    					         *
    					         *     bufferedBlockAlgorithm.reset();
    					         */
    					        reset: function () {
    					            // Initial values
    					            this._data = new WordArray.init();
    					            this._nDataBytes = 0;
    					        },

    					        /**
    					         * Adds new data to this block algorithm's buffer.
    					         *
    					         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
    					         *
    					         * @example
    					         *
    					         *     bufferedBlockAlgorithm._append('data');
    					         *     bufferedBlockAlgorithm._append(wordArray);
    					         */
    					        _append: function (data) {
    					            // Convert string to WordArray, else assume WordArray already
    					            if (typeof data == 'string') {
    					                data = Utf8.parse(data);
    					            }

    					            // Append
    					            this._data.concat(data);
    					            this._nDataBytes += data.sigBytes;
    					        },

    					        /**
    					         * Processes available data blocks.
    					         *
    					         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
    					         *
    					         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
    					         *
    					         * @return {WordArray} The processed data.
    					         *
    					         * @example
    					         *
    					         *     var processedData = bufferedBlockAlgorithm._process();
    					         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
    					         */
    					        _process: function (doFlush) {
    					            var processedWords;

    					            // Shortcuts
    					            var data = this._data;
    					            var dataWords = data.words;
    					            var dataSigBytes = data.sigBytes;
    					            var blockSize = this.blockSize;
    					            var blockSizeBytes = blockSize * 4;

    					            // Count blocks ready
    					            var nBlocksReady = dataSigBytes / blockSizeBytes;
    					            if (doFlush) {
    					                // Round up to include partial blocks
    					                nBlocksReady = Math.ceil(nBlocksReady);
    					            } else {
    					                // Round down to include only full blocks,
    					                // less the number of blocks that must remain in the buffer
    					                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
    					            }

    					            // Count words ready
    					            var nWordsReady = nBlocksReady * blockSize;

    					            // Count bytes ready
    					            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

    					            // Process blocks
    					            if (nWordsReady) {
    					                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
    					                    // Perform concrete-algorithm logic
    					                    this._doProcessBlock(dataWords, offset);
    					                }

    					                // Remove processed words
    					                processedWords = dataWords.splice(0, nWordsReady);
    					                data.sigBytes -= nBytesReady;
    					            }

    					            // Return processed words
    					            return new WordArray.init(processedWords, nBytesReady);
    					        },

    					        /**
    					         * Creates a copy of this object.
    					         *
    					         * @return {Object} The clone.
    					         *
    					         * @example
    					         *
    					         *     var clone = bufferedBlockAlgorithm.clone();
    					         */
    					        clone: function () {
    					            var clone = Base.clone.call(this);
    					            clone._data = this._data.clone();

    					            return clone;
    					        },

    					        _minBufferSize: 0
    					    });

    					    /**
    					     * Abstract hasher template.
    					     *
    					     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
    					     */
    					    C_lib.Hasher = BufferedBlockAlgorithm.extend({
    					        /**
    					         * Configuration options.
    					         */
    					        cfg: Base.extend(),

    					        /**
    					         * Initializes a newly created hasher.
    					         *
    					         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
    					         *
    					         * @example
    					         *
    					         *     var hasher = CryptoJS.algo.SHA256.create();
    					         */
    					        init: function (cfg) {
    					            // Apply config defaults
    					            this.cfg = this.cfg.extend(cfg);

    					            // Set initial values
    					            this.reset();
    					        },

    					        /**
    					         * Resets this hasher to its initial state.
    					         *
    					         * @example
    					         *
    					         *     hasher.reset();
    					         */
    					        reset: function () {
    					            // Reset data buffer
    					            BufferedBlockAlgorithm.reset.call(this);

    					            // Perform concrete-hasher logic
    					            this._doReset();
    					        },

    					        /**
    					         * Updates this hasher with a message.
    					         *
    					         * @param {WordArray|string} messageUpdate The message to append.
    					         *
    					         * @return {Hasher} This hasher.
    					         *
    					         * @example
    					         *
    					         *     hasher.update('message');
    					         *     hasher.update(wordArray);
    					         */
    					        update: function (messageUpdate) {
    					            // Append
    					            this._append(messageUpdate);

    					            // Update the hash
    					            this._process();

    					            // Chainable
    					            return this;
    					        },

    					        /**
    					         * Finalizes the hash computation.
    					         * Note that the finalize operation is effectively a destructive, read-once operation.
    					         *
    					         * @param {WordArray|string} messageUpdate (Optional) A final message update.
    					         *
    					         * @return {WordArray} The hash.
    					         *
    					         * @example
    					         *
    					         *     var hash = hasher.finalize();
    					         *     var hash = hasher.finalize('message');
    					         *     var hash = hasher.finalize(wordArray);
    					         */
    					        finalize: function (messageUpdate) {
    					            // Final message update
    					            if (messageUpdate) {
    					                this._append(messageUpdate);
    					            }

    					            // Perform concrete-hasher logic
    					            var hash = this._doFinalize();

    					            return hash;
    					        },

    					        blockSize: 512/32,

    					        /**
    					         * Creates a shortcut function to a hasher's object interface.
    					         *
    					         * @param {Hasher} hasher The hasher to create a helper for.
    					         *
    					         * @return {Function} The shortcut function.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
    					         */
    					        _createHelper: function (hasher) {
    					            return function (message, cfg) {
    					                return new hasher.init(cfg).finalize(message);
    					            };
    					        },

    					        /**
    					         * Creates a shortcut function to the HMAC's object interface.
    					         *
    					         * @param {Hasher} hasher The hasher to use in this HMAC helper.
    					         *
    					         * @return {Function} The shortcut function.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
    					         */
    					        _createHmacHelper: function (hasher) {
    					            return function (message, key) {
    					                return new C_algo.HMAC.init(hasher, key).finalize(message);
    					            };
    					        }
    					    });

    					    /**
    					     * Algorithm namespace.
    					     */
    					    var C_algo = C.algo = {};

    					    return C;
    					}(Math));


    					return CryptoJS;

    				})); 
    			} (core, core.exports));
    			return core.exports;
    		}

    		var x64Core = {exports: {}};

    		x64Core.exports;

    		var hasRequiredX64Core;

    		function requireX64Core () {
    			if (hasRequiredX64Core) return x64Core.exports;
    			hasRequiredX64Core = 1;
    			(function (module, exports) {
    		(function (root, factory) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function (undefined$1) {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var Base = C_lib.Base;
    					    var X32WordArray = C_lib.WordArray;

    					    /**
    					     * x64 namespace.
    					     */
    					    var C_x64 = C.x64 = {};

    					    /**
    					     * A 64-bit word.
    					     */
    					    C_x64.Word = Base.extend({
    					        /**
    					         * Initializes a newly created 64-bit word.
    					         *
    					         * @param {number} high The high 32 bits.
    					         * @param {number} low The low 32 bits.
    					         *
    					         * @example
    					         *
    					         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
    					         */
    					        init: function (high, low) {
    					            this.high = high;
    					            this.low = low;
    					        }

    					        /**
    					         * Bitwise NOTs this word.
    					         *
    					         * @return {X64Word} A new x64-Word object after negating.
    					         *
    					         * @example
    					         *
    					         *     var negated = x64Word.not();
    					         */
    					        // not: function () {
    					            // var high = ~this.high;
    					            // var low = ~this.low;

    					            // return X64Word.create(high, low);
    					        // },

    					        /**
    					         * Bitwise ANDs this word with the passed word.
    					         *
    					         * @param {X64Word} word The x64-Word to AND with this word.
    					         *
    					         * @return {X64Word} A new x64-Word object after ANDing.
    					         *
    					         * @example
    					         *
    					         *     var anded = x64Word.and(anotherX64Word);
    					         */
    					        // and: function (word) {
    					            // var high = this.high & word.high;
    					            // var low = this.low & word.low;

    					            // return X64Word.create(high, low);
    					        // },

    					        /**
    					         * Bitwise ORs this word with the passed word.
    					         *
    					         * @param {X64Word} word The x64-Word to OR with this word.
    					         *
    					         * @return {X64Word} A new x64-Word object after ORing.
    					         *
    					         * @example
    					         *
    					         *     var ored = x64Word.or(anotherX64Word);
    					         */
    					        // or: function (word) {
    					            // var high = this.high | word.high;
    					            // var low = this.low | word.low;

    					            // return X64Word.create(high, low);
    					        // },

    					        /**
    					         * Bitwise XORs this word with the passed word.
    					         *
    					         * @param {X64Word} word The x64-Word to XOR with this word.
    					         *
    					         * @return {X64Word} A new x64-Word object after XORing.
    					         *
    					         * @example
    					         *
    					         *     var xored = x64Word.xor(anotherX64Word);
    					         */
    					        // xor: function (word) {
    					            // var high = this.high ^ word.high;
    					            // var low = this.low ^ word.low;

    					            // return X64Word.create(high, low);
    					        // },

    					        /**
    					         * Shifts this word n bits to the left.
    					         *
    					         * @param {number} n The number of bits to shift.
    					         *
    					         * @return {X64Word} A new x64-Word object after shifting.
    					         *
    					         * @example
    					         *
    					         *     var shifted = x64Word.shiftL(25);
    					         */
    					        // shiftL: function (n) {
    					            // if (n < 32) {
    					                // var high = (this.high << n) | (this.low >>> (32 - n));
    					                // var low = this.low << n;
    					            // } else {
    					                // var high = this.low << (n - 32);
    					                // var low = 0;
    					            // }

    					            // return X64Word.create(high, low);
    					        // },

    					        /**
    					         * Shifts this word n bits to the right.
    					         *
    					         * @param {number} n The number of bits to shift.
    					         *
    					         * @return {X64Word} A new x64-Word object after shifting.
    					         *
    					         * @example
    					         *
    					         *     var shifted = x64Word.shiftR(7);
    					         */
    					        // shiftR: function (n) {
    					            // if (n < 32) {
    					                // var low = (this.low >>> n) | (this.high << (32 - n));
    					                // var high = this.high >>> n;
    					            // } else {
    					                // var low = this.high >>> (n - 32);
    					                // var high = 0;
    					            // }

    					            // return X64Word.create(high, low);
    					        // },

    					        /**
    					         * Rotates this word n bits to the left.
    					         *
    					         * @param {number} n The number of bits to rotate.
    					         *
    					         * @return {X64Word} A new x64-Word object after rotating.
    					         *
    					         * @example
    					         *
    					         *     var rotated = x64Word.rotL(25);
    					         */
    					        // rotL: function (n) {
    					            // return this.shiftL(n).or(this.shiftR(64 - n));
    					        // },

    					        /**
    					         * Rotates this word n bits to the right.
    					         *
    					         * @param {number} n The number of bits to rotate.
    					         *
    					         * @return {X64Word} A new x64-Word object after rotating.
    					         *
    					         * @example
    					         *
    					         *     var rotated = x64Word.rotR(7);
    					         */
    					        // rotR: function (n) {
    					            // return this.shiftR(n).or(this.shiftL(64 - n));
    					        // },

    					        /**
    					         * Adds this word with the passed word.
    					         *
    					         * @param {X64Word} word The x64-Word to add with this word.
    					         *
    					         * @return {X64Word} A new x64-Word object after adding.
    					         *
    					         * @example
    					         *
    					         *     var added = x64Word.add(anotherX64Word);
    					         */
    					        // add: function (word) {
    					            // var low = (this.low + word.low) | 0;
    					            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
    					            // var high = (this.high + word.high + carry) | 0;

    					            // return X64Word.create(high, low);
    					        // }
    					    });

    					    /**
    					     * An array of 64-bit words.
    					     *
    					     * @property {Array} words The array of CryptoJS.x64.Word objects.
    					     * @property {number} sigBytes The number of significant bytes in this word array.
    					     */
    					    C_x64.WordArray = Base.extend({
    					        /**
    					         * Initializes a newly created word array.
    					         *
    					         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
    					         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
    					         *
    					         * @example
    					         *
    					         *     var wordArray = CryptoJS.x64.WordArray.create();
    					         *
    					         *     var wordArray = CryptoJS.x64.WordArray.create([
    					         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
    					         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
    					         *     ]);
    					         *
    					         *     var wordArray = CryptoJS.x64.WordArray.create([
    					         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
    					         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
    					         *     ], 10);
    					         */
    					        init: function (words, sigBytes) {
    					            words = this.words = words || [];

    					            if (sigBytes != undefined$1) {
    					                this.sigBytes = sigBytes;
    					            } else {
    					                this.sigBytes = words.length * 8;
    					            }
    					        },

    					        /**
    					         * Converts this 64-bit word array to a 32-bit word array.
    					         *
    					         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
    					         *
    					         * @example
    					         *
    					         *     var x32WordArray = x64WordArray.toX32();
    					         */
    					        toX32: function () {
    					            // Shortcuts
    					            var x64Words = this.words;
    					            var x64WordsLength = x64Words.length;

    					            // Convert
    					            var x32Words = [];
    					            for (var i = 0; i < x64WordsLength; i++) {
    					                var x64Word = x64Words[i];
    					                x32Words.push(x64Word.high);
    					                x32Words.push(x64Word.low);
    					            }

    					            return X32WordArray.create(x32Words, this.sigBytes);
    					        },

    					        /**
    					         * Creates a copy of this word array.
    					         *
    					         * @return {X64WordArray} The clone.
    					         *
    					         * @example
    					         *
    					         *     var clone = x64WordArray.clone();
    					         */
    					        clone: function () {
    					            var clone = Base.clone.call(this);

    					            // Clone "words" array
    					            var words = clone.words = this.words.slice(0);

    					            // Clone each X64Word object
    					            var wordsLength = words.length;
    					            for (var i = 0; i < wordsLength; i++) {
    					                words[i] = words[i].clone();
    					            }

    					            return clone;
    					        }
    					    });
    					}());


    					return CryptoJS;

    				})); 
    			} (x64Core, x64Core.exports));
    			return x64Core.exports;
    		}

    		var libTypedarrays = {exports: {}};

    		libTypedarrays.exports;

    		var hasRequiredLibTypedarrays;

    		function requireLibTypedarrays () {
    			if (hasRequiredLibTypedarrays) return libTypedarrays.exports;
    			hasRequiredLibTypedarrays = 1;
    			(function (module, exports) {
    		(function (root, factory) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function () {
    					    // Check if typed arrays are supported
    					    if (typeof ArrayBuffer != 'function') {
    					        return;
    					    }

    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var WordArray = C_lib.WordArray;

    					    // Reference original init
    					    var superInit = WordArray.init;

    					    // Augment WordArray.init to handle typed arrays
    					    var subInit = WordArray.init = function (typedArray) {
    					        // Convert buffers to uint8
    					        if (typedArray instanceof ArrayBuffer) {
    					            typedArray = new Uint8Array(typedArray);
    					        }

    					        // Convert other array views to uint8
    					        if (
    					            typedArray instanceof Int8Array ||
    					            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
    					            typedArray instanceof Int16Array ||
    					            typedArray instanceof Uint16Array ||
    					            typedArray instanceof Int32Array ||
    					            typedArray instanceof Uint32Array ||
    					            typedArray instanceof Float32Array ||
    					            typedArray instanceof Float64Array
    					        ) {
    					            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
    					        }

    					        // Handle Uint8Array
    					        if (typedArray instanceof Uint8Array) {
    					            // Shortcut
    					            var typedArrayByteLength = typedArray.byteLength;

    					            // Extract bytes
    					            var words = [];
    					            for (var i = 0; i < typedArrayByteLength; i++) {
    					                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
    					            }

    					            // Initialize this word array
    					            superInit.call(this, words, typedArrayByteLength);
    					        } else {
    					            // Else call normal init
    					            superInit.apply(this, arguments);
    					        }
    					    };

    					    subInit.prototype = WordArray;
    					}());


    					return CryptoJS.lib.WordArray;

    				})); 
    			} (libTypedarrays, libTypedarrays.exports));
    			return libTypedarrays.exports;
    		}

    		var encUtf16 = {exports: {}};

    		encUtf16.exports;

    		var hasRequiredEncUtf16;

    		function requireEncUtf16 () {
    			if (hasRequiredEncUtf16) return encUtf16.exports;
    			hasRequiredEncUtf16 = 1;
    			(function (module, exports) {
    		(function (root, factory) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function () {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var WordArray = C_lib.WordArray;
    					    var C_enc = C.enc;

    					    /**
    					     * UTF-16 BE encoding strategy.
    					     */
    					    C_enc.Utf16 = C_enc.Utf16BE = {
    					        /**
    					         * Converts a word array to a UTF-16 BE string.
    					         *
    					         * @param {WordArray} wordArray The word array.
    					         *
    					         * @return {string} The UTF-16 BE string.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
    					         */
    					        stringify: function (wordArray) {
    					            // Shortcuts
    					            var words = wordArray.words;
    					            var sigBytes = wordArray.sigBytes;

    					            // Convert
    					            var utf16Chars = [];
    					            for (var i = 0; i < sigBytes; i += 2) {
    					                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
    					                utf16Chars.push(String.fromCharCode(codePoint));
    					            }

    					            return utf16Chars.join('');
    					        },

    					        /**
    					         * Converts a UTF-16 BE string to a word array.
    					         *
    					         * @param {string} utf16Str The UTF-16 BE string.
    					         *
    					         * @return {WordArray} The word array.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
    					         */
    					        parse: function (utf16Str) {
    					            // Shortcut
    					            var utf16StrLength = utf16Str.length;

    					            // Convert
    					            var words = [];
    					            for (var i = 0; i < utf16StrLength; i++) {
    					                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
    					            }

    					            return WordArray.create(words, utf16StrLength * 2);
    					        }
    					    };

    					    /**
    					     * UTF-16 LE encoding strategy.
    					     */
    					    C_enc.Utf16LE = {
    					        /**
    					         * Converts a word array to a UTF-16 LE string.
    					         *
    					         * @param {WordArray} wordArray The word array.
    					         *
    					         * @return {string} The UTF-16 LE string.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
    					         */
    					        stringify: function (wordArray) {
    					            // Shortcuts
    					            var words = wordArray.words;
    					            var sigBytes = wordArray.sigBytes;

    					            // Convert
    					            var utf16Chars = [];
    					            for (var i = 0; i < sigBytes; i += 2) {
    					                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
    					                utf16Chars.push(String.fromCharCode(codePoint));
    					            }

    					            return utf16Chars.join('');
    					        },

    					        /**
    					         * Converts a UTF-16 LE string to a word array.
    					         *
    					         * @param {string} utf16Str The UTF-16 LE string.
    					         *
    					         * @return {WordArray} The word array.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
    					         */
    					        parse: function (utf16Str) {
    					            // Shortcut
    					            var utf16StrLength = utf16Str.length;

    					            // Convert
    					            var words = [];
    					            for (var i = 0; i < utf16StrLength; i++) {
    					                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
    					            }

    					            return WordArray.create(words, utf16StrLength * 2);
    					        }
    					    };

    					    function swapEndian(word) {
    					        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
    					    }
    					}());


    					return CryptoJS.enc.Utf16;

    				})); 
    			} (encUtf16, encUtf16.exports));
    			return encUtf16.exports;
    		}

    		var encBase64 = {exports: {}};

    		encBase64.exports;

    		var hasRequiredEncBase64;

    		function requireEncBase64 () {
    			if (hasRequiredEncBase64) return encBase64.exports;
    			hasRequiredEncBase64 = 1;
    			(function (module, exports) {
    		(function (root, factory) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function () {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var WordArray = C_lib.WordArray;
    					    var C_enc = C.enc;

    					    /**
    					     * Base64 encoding strategy.
    					     */
    					    C_enc.Base64 = {
    					        /**
    					         * Converts a word array to a Base64 string.
    					         *
    					         * @param {WordArray} wordArray The word array.
    					         *
    					         * @return {string} The Base64 string.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
    					         */
    					        stringify: function (wordArray) {
    					            // Shortcuts
    					            var words = wordArray.words;
    					            var sigBytes = wordArray.sigBytes;
    					            var map = this._map;

    					            // Clamp excess bits
    					            wordArray.clamp();

    					            // Convert
    					            var base64Chars = [];
    					            for (var i = 0; i < sigBytes; i += 3) {
    					                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
    					                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
    					                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

    					                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

    					                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
    					                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
    					                }
    					            }

    					            // Add padding
    					            var paddingChar = map.charAt(64);
    					            if (paddingChar) {
    					                while (base64Chars.length % 4) {
    					                    base64Chars.push(paddingChar);
    					                }
    					            }

    					            return base64Chars.join('');
    					        },

    					        /**
    					         * Converts a Base64 string to a word array.
    					         *
    					         * @param {string} base64Str The Base64 string.
    					         *
    					         * @return {WordArray} The word array.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
    					         */
    					        parse: function (base64Str) {
    					            // Shortcuts
    					            var base64StrLength = base64Str.length;
    					            var map = this._map;
    					            var reverseMap = this._reverseMap;

    					            if (!reverseMap) {
    					                    reverseMap = this._reverseMap = [];
    					                    for (var j = 0; j < map.length; j++) {
    					                        reverseMap[map.charCodeAt(j)] = j;
    					                    }
    					            }

    					            // Ignore padding
    					            var paddingChar = map.charAt(64);
    					            if (paddingChar) {
    					                var paddingIndex = base64Str.indexOf(paddingChar);
    					                if (paddingIndex !== -1) {
    					                    base64StrLength = paddingIndex;
    					                }
    					            }

    					            // Convert
    					            return parseLoop(base64Str, base64StrLength, reverseMap);

    					        },

    					        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
    					    };

    					    function parseLoop(base64Str, base64StrLength, reverseMap) {
    					      var words = [];
    					      var nBytes = 0;
    					      for (var i = 0; i < base64StrLength; i++) {
    					          if (i % 4) {
    					              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
    					              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
    					              var bitsCombined = bits1 | bits2;
    					              words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8);
    					              nBytes++;
    					          }
    					      }
    					      return WordArray.create(words, nBytes);
    					    }
    					}());


    					return CryptoJS.enc.Base64;

    				})); 
    			} (encBase64, encBase64.exports));
    			return encBase64.exports;
    		}

    		var encBase64url = {exports: {}};

    		encBase64url.exports;

    		var hasRequiredEncBase64url;

    		function requireEncBase64url () {
    			if (hasRequiredEncBase64url) return encBase64url.exports;
    			hasRequiredEncBase64url = 1;
    			(function (module, exports) {
    		(function (root, factory) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function () {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var WordArray = C_lib.WordArray;
    					    var C_enc = C.enc;

    					    /**
    					     * Base64url encoding strategy.
    					     */
    					    C_enc.Base64url = {
    					        /**
    					         * Converts a word array to a Base64url string.
    					         *
    					         * @param {WordArray} wordArray The word array.
    					         *
    					         * @param {boolean} urlSafe Whether to use url safe
    					         *
    					         * @return {string} The Base64url string.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
    					         */
    					        stringify: function (wordArray, urlSafe) {
    					            if (urlSafe === undefined) {
    					                urlSafe = true;
    					            }
    					            // Shortcuts
    					            var words = wordArray.words;
    					            var sigBytes = wordArray.sigBytes;
    					            var map = urlSafe ? this._safe_map : this._map;

    					            // Clamp excess bits
    					            wordArray.clamp();

    					            // Convert
    					            var base64Chars = [];
    					            for (var i = 0; i < sigBytes; i += 3) {
    					                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
    					                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
    					                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

    					                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

    					                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
    					                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
    					                }
    					            }

    					            // Add padding
    					            var paddingChar = map.charAt(64);
    					            if (paddingChar) {
    					                while (base64Chars.length % 4) {
    					                    base64Chars.push(paddingChar);
    					                }
    					            }

    					            return base64Chars.join('');
    					        },

    					        /**
    					         * Converts a Base64url string to a word array.
    					         *
    					         * @param {string} base64Str The Base64url string.
    					         *
    					         * @param {boolean} urlSafe Whether to use url safe
    					         *
    					         * @return {WordArray} The word array.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
    					         */
    					        parse: function (base64Str, urlSafe) {
    					            if (urlSafe === undefined) {
    					                urlSafe = true;
    					            }

    					            // Shortcuts
    					            var base64StrLength = base64Str.length;
    					            var map = urlSafe ? this._safe_map : this._map;
    					            var reverseMap = this._reverseMap;

    					            if (!reverseMap) {
    					                reverseMap = this._reverseMap = [];
    					                for (var j = 0; j < map.length; j++) {
    					                    reverseMap[map.charCodeAt(j)] = j;
    					                }
    					            }

    					            // Ignore padding
    					            var paddingChar = map.charAt(64);
    					            if (paddingChar) {
    					                var paddingIndex = base64Str.indexOf(paddingChar);
    					                if (paddingIndex !== -1) {
    					                    base64StrLength = paddingIndex;
    					                }
    					            }

    					            // Convert
    					            return parseLoop(base64Str, base64StrLength, reverseMap);

    					        },

    					        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
    					        _safe_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_',
    					    };

    					    function parseLoop(base64Str, base64StrLength, reverseMap) {
    					        var words = [];
    					        var nBytes = 0;
    					        for (var i = 0; i < base64StrLength; i++) {
    					            if (i % 4) {
    					                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
    					                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
    					                var bitsCombined = bits1 | bits2;
    					                words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8);
    					                nBytes++;
    					            }
    					        }
    					        return WordArray.create(words, nBytes);
    					    }
    					}());


    					return CryptoJS.enc.Base64url;

    				})); 
    			} (encBase64url, encBase64url.exports));
    			return encBase64url.exports;
    		}

    		var md5$2 = {exports: {}};

    		md5$2.exports;

    		var hasRequiredMd5;

    		function requireMd5 () {
    			if (hasRequiredMd5) return md5$2.exports;
    			hasRequiredMd5 = 1;
    			(function (module, exports) {
    		(function (root, factory) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function (Math) {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var WordArray = C_lib.WordArray;
    					    var Hasher = C_lib.Hasher;
    					    var C_algo = C.algo;

    					    // Constants table
    					    var T = [];

    					    // Compute constants
    					    (function () {
    					        for (var i = 0; i < 64; i++) {
    					            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
    					        }
    					    }());

    					    /**
    					     * MD5 hash algorithm.
    					     */
    					    var MD5 = C_algo.MD5 = Hasher.extend({
    					        _doReset: function () {
    					            this._hash = new WordArray.init([
    					                0x67452301, 0xefcdab89,
    					                0x98badcfe, 0x10325476
    					            ]);
    					        },

    					        _doProcessBlock: function (M, offset) {
    					            // Swap endian
    					            for (var i = 0; i < 16; i++) {
    					                // Shortcuts
    					                var offset_i = offset + i;
    					                var M_offset_i = M[offset_i];

    					                M[offset_i] = (
    					                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
    					                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
    					                );
    					            }

    					            // Shortcuts
    					            var H = this._hash.words;

    					            var M_offset_0  = M[offset + 0];
    					            var M_offset_1  = M[offset + 1];
    					            var M_offset_2  = M[offset + 2];
    					            var M_offset_3  = M[offset + 3];
    					            var M_offset_4  = M[offset + 4];
    					            var M_offset_5  = M[offset + 5];
    					            var M_offset_6  = M[offset + 6];
    					            var M_offset_7  = M[offset + 7];
    					            var M_offset_8  = M[offset + 8];
    					            var M_offset_9  = M[offset + 9];
    					            var M_offset_10 = M[offset + 10];
    					            var M_offset_11 = M[offset + 11];
    					            var M_offset_12 = M[offset + 12];
    					            var M_offset_13 = M[offset + 13];
    					            var M_offset_14 = M[offset + 14];
    					            var M_offset_15 = M[offset + 15];

    					            // Working variables
    					            var a = H[0];
    					            var b = H[1];
    					            var c = H[2];
    					            var d = H[3];

    					            // Computation
    					            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
    					            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
    					            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
    					            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
    					            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
    					            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
    					            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
    					            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
    					            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
    					            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
    					            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
    					            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
    					            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
    					            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
    					            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
    					            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

    					            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
    					            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
    					            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
    					            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
    					            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
    					            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
    					            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
    					            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
    					            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
    					            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
    					            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
    					            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
    					            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
    					            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
    					            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
    					            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

    					            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
    					            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
    					            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
    					            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
    					            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
    					            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
    					            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
    					            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
    					            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
    					            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
    					            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
    					            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
    					            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
    					            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
    					            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
    					            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

    					            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
    					            d = II(d, a, b, c, M_offset_7,  10, T[49]);
    					            c = II(c, d, a, b, M_offset_14, 15, T[50]);
    					            b = II(b, c, d, a, M_offset_5,  21, T[51]);
    					            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
    					            d = II(d, a, b, c, M_offset_3,  10, T[53]);
    					            c = II(c, d, a, b, M_offset_10, 15, T[54]);
    					            b = II(b, c, d, a, M_offset_1,  21, T[55]);
    					            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
    					            d = II(d, a, b, c, M_offset_15, 10, T[57]);
    					            c = II(c, d, a, b, M_offset_6,  15, T[58]);
    					            b = II(b, c, d, a, M_offset_13, 21, T[59]);
    					            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
    					            d = II(d, a, b, c, M_offset_11, 10, T[61]);
    					            c = II(c, d, a, b, M_offset_2,  15, T[62]);
    					            b = II(b, c, d, a, M_offset_9,  21, T[63]);

    					            // Intermediate hash value
    					            H[0] = (H[0] + a) | 0;
    					            H[1] = (H[1] + b) | 0;
    					            H[2] = (H[2] + c) | 0;
    					            H[3] = (H[3] + d) | 0;
    					        },

    					        _doFinalize: function () {
    					            // Shortcuts
    					            var data = this._data;
    					            var dataWords = data.words;

    					            var nBitsTotal = this._nDataBytes * 8;
    					            var nBitsLeft = data.sigBytes * 8;

    					            // Add padding
    					            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

    					            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
    					            var nBitsTotalL = nBitsTotal;
    					            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
    					                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
    					                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
    					            );
    					            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
    					                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
    					                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
    					            );

    					            data.sigBytes = (dataWords.length + 1) * 4;

    					            // Hash final blocks
    					            this._process();

    					            // Shortcuts
    					            var hash = this._hash;
    					            var H = hash.words;

    					            // Swap endian
    					            for (var i = 0; i < 4; i++) {
    					                // Shortcut
    					                var H_i = H[i];

    					                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
    					                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
    					            }

    					            // Return final computed hash
    					            return hash;
    					        },

    					        clone: function () {
    					            var clone = Hasher.clone.call(this);
    					            clone._hash = this._hash.clone();

    					            return clone;
    					        }
    					    });

    					    function FF(a, b, c, d, x, s, t) {
    					        var n = a + ((b & c) | (~b & d)) + x + t;
    					        return ((n << s) | (n >>> (32 - s))) + b;
    					    }

    					    function GG(a, b, c, d, x, s, t) {
    					        var n = a + ((b & d) | (c & ~d)) + x + t;
    					        return ((n << s) | (n >>> (32 - s))) + b;
    					    }

    					    function HH(a, b, c, d, x, s, t) {
    					        var n = a + (b ^ c ^ d) + x + t;
    					        return ((n << s) | (n >>> (32 - s))) + b;
    					    }

    					    function II(a, b, c, d, x, s, t) {
    					        var n = a + (c ^ (b | ~d)) + x + t;
    					        return ((n << s) | (n >>> (32 - s))) + b;
    					    }

    					    /**
    					     * Shortcut function to the hasher's object interface.
    					     *
    					     * @param {WordArray|string} message The message to hash.
    					     *
    					     * @return {WordArray} The hash.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var hash = CryptoJS.MD5('message');
    					     *     var hash = CryptoJS.MD5(wordArray);
    					     */
    					    C.MD5 = Hasher._createHelper(MD5);

    					    /**
    					     * Shortcut function to the HMAC's object interface.
    					     *
    					     * @param {WordArray|string} message The message to hash.
    					     * @param {WordArray|string} key The secret key.
    					     *
    					     * @return {WordArray} The HMAC.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var hmac = CryptoJS.HmacMD5(message, key);
    					     */
    					    C.HmacMD5 = Hasher._createHmacHelper(MD5);
    					}(Math));


    					return CryptoJS.MD5;

    				})); 
    			} (md5$2, md5$2.exports));
    			return md5$2.exports;
    		}

    		var sha1$1 = {exports: {}};

    		sha1$1.exports;

    		var hasRequiredSha1;

    		function requireSha1 () {
    			if (hasRequiredSha1) return sha1$1.exports;
    			hasRequiredSha1 = 1;
    			(function (module, exports) {
    		(function (root, factory) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function () {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var WordArray = C_lib.WordArray;
    					    var Hasher = C_lib.Hasher;
    					    var C_algo = C.algo;

    					    // Reusable object
    					    var W = [];

    					    /**
    					     * SHA-1 hash algorithm.
    					     */
    					    var SHA1 = C_algo.SHA1 = Hasher.extend({
    					        _doReset: function () {
    					            this._hash = new WordArray.init([
    					                0x67452301, 0xefcdab89,
    					                0x98badcfe, 0x10325476,
    					                0xc3d2e1f0
    					            ]);
    					        },

    					        _doProcessBlock: function (M, offset) {
    					            // Shortcut
    					            var H = this._hash.words;

    					            // Working variables
    					            var a = H[0];
    					            var b = H[1];
    					            var c = H[2];
    					            var d = H[3];
    					            var e = H[4];

    					            // Computation
    					            for (var i = 0; i < 80; i++) {
    					                if (i < 16) {
    					                    W[i] = M[offset + i] | 0;
    					                } else {
    					                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    					                    W[i] = (n << 1) | (n >>> 31);
    					                }

    					                var t = ((a << 5) | (a >>> 27)) + e + W[i];
    					                if (i < 20) {
    					                    t += ((b & c) | (~b & d)) + 0x5a827999;
    					                } else if (i < 40) {
    					                    t += (b ^ c ^ d) + 0x6ed9eba1;
    					                } else if (i < 60) {
    					                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
    					                } else /* if (i < 80) */ {
    					                    t += (b ^ c ^ d) - 0x359d3e2a;
    					                }

    					                e = d;
    					                d = c;
    					                c = (b << 30) | (b >>> 2);
    					                b = a;
    					                a = t;
    					            }

    					            // Intermediate hash value
    					            H[0] = (H[0] + a) | 0;
    					            H[1] = (H[1] + b) | 0;
    					            H[2] = (H[2] + c) | 0;
    					            H[3] = (H[3] + d) | 0;
    					            H[4] = (H[4] + e) | 0;
    					        },

    					        _doFinalize: function () {
    					            // Shortcuts
    					            var data = this._data;
    					            var dataWords = data.words;

    					            var nBitsTotal = this._nDataBytes * 8;
    					            var nBitsLeft = data.sigBytes * 8;

    					            // Add padding
    					            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
    					            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
    					            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
    					            data.sigBytes = dataWords.length * 4;

    					            // Hash final blocks
    					            this._process();

    					            // Return final computed hash
    					            return this._hash;
    					        },

    					        clone: function () {
    					            var clone = Hasher.clone.call(this);
    					            clone._hash = this._hash.clone();

    					            return clone;
    					        }
    					    });

    					    /**
    					     * Shortcut function to the hasher's object interface.
    					     *
    					     * @param {WordArray|string} message The message to hash.
    					     *
    					     * @return {WordArray} The hash.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var hash = CryptoJS.SHA1('message');
    					     *     var hash = CryptoJS.SHA1(wordArray);
    					     */
    					    C.SHA1 = Hasher._createHelper(SHA1);

    					    /**
    					     * Shortcut function to the HMAC's object interface.
    					     *
    					     * @param {WordArray|string} message The message to hash.
    					     * @param {WordArray|string} key The secret key.
    					     *
    					     * @return {WordArray} The HMAC.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var hmac = CryptoJS.HmacSHA1(message, key);
    					     */
    					    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    					}());


    					return CryptoJS.SHA1;

    				})); 
    			} (sha1$1, sha1$1.exports));
    			return sha1$1.exports;
    		}

    		var sha256$1 = {exports: {}};

    		sha256$1.exports;

    		var hasRequiredSha256;

    		function requireSha256 () {
    			if (hasRequiredSha256) return sha256$1.exports;
    			hasRequiredSha256 = 1;
    			(function (module, exports) {
    		(function (root, factory) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function (Math) {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var WordArray = C_lib.WordArray;
    					    var Hasher = C_lib.Hasher;
    					    var C_algo = C.algo;

    					    // Initialization and round constants tables
    					    var H = [];
    					    var K = [];

    					    // Compute constants
    					    (function () {
    					        function isPrime(n) {
    					            var sqrtN = Math.sqrt(n);
    					            for (var factor = 2; factor <= sqrtN; factor++) {
    					                if (!(n % factor)) {
    					                    return false;
    					                }
    					            }

    					            return true;
    					        }

    					        function getFractionalBits(n) {
    					            return ((n - (n | 0)) * 0x100000000) | 0;
    					        }

    					        var n = 2;
    					        var nPrime = 0;
    					        while (nPrime < 64) {
    					            if (isPrime(n)) {
    					                if (nPrime < 8) {
    					                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
    					                }
    					                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

    					                nPrime++;
    					            }

    					            n++;
    					        }
    					    }());

    					    // Reusable object
    					    var W = [];

    					    /**
    					     * SHA-256 hash algorithm.
    					     */
    					    var SHA256 = C_algo.SHA256 = Hasher.extend({
    					        _doReset: function () {
    					            this._hash = new WordArray.init(H.slice(0));
    					        },

    					        _doProcessBlock: function (M, offset) {
    					            // Shortcut
    					            var H = this._hash.words;

    					            // Working variables
    					            var a = H[0];
    					            var b = H[1];
    					            var c = H[2];
    					            var d = H[3];
    					            var e = H[4];
    					            var f = H[5];
    					            var g = H[6];
    					            var h = H[7];

    					            // Computation
    					            for (var i = 0; i < 64; i++) {
    					                if (i < 16) {
    					                    W[i] = M[offset + i] | 0;
    					                } else {
    					                    var gamma0x = W[i - 15];
    					                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
    					                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
    					                                   (gamma0x >>> 3);

    					                    var gamma1x = W[i - 2];
    					                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
    					                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
    					                                   (gamma1x >>> 10);

    					                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
    					                }

    					                var ch  = (e & f) ^ (~e & g);
    					                var maj = (a & b) ^ (a & c) ^ (b & c);

    					                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
    					                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

    					                var t1 = h + sigma1 + ch + K[i] + W[i];
    					                var t2 = sigma0 + maj;

    					                h = g;
    					                g = f;
    					                f = e;
    					                e = (d + t1) | 0;
    					                d = c;
    					                c = b;
    					                b = a;
    					                a = (t1 + t2) | 0;
    					            }

    					            // Intermediate hash value
    					            H[0] = (H[0] + a) | 0;
    					            H[1] = (H[1] + b) | 0;
    					            H[2] = (H[2] + c) | 0;
    					            H[3] = (H[3] + d) | 0;
    					            H[4] = (H[4] + e) | 0;
    					            H[5] = (H[5] + f) | 0;
    					            H[6] = (H[6] + g) | 0;
    					            H[7] = (H[7] + h) | 0;
    					        },

    					        _doFinalize: function () {
    					            // Shortcuts
    					            var data = this._data;
    					            var dataWords = data.words;

    					            var nBitsTotal = this._nDataBytes * 8;
    					            var nBitsLeft = data.sigBytes * 8;

    					            // Add padding
    					            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
    					            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
    					            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
    					            data.sigBytes = dataWords.length * 4;

    					            // Hash final blocks
    					            this._process();

    					            // Return final computed hash
    					            return this._hash;
    					        },

    					        clone: function () {
    					            var clone = Hasher.clone.call(this);
    					            clone._hash = this._hash.clone();

    					            return clone;
    					        }
    					    });

    					    /**
    					     * Shortcut function to the hasher's object interface.
    					     *
    					     * @param {WordArray|string} message The message to hash.
    					     *
    					     * @return {WordArray} The hash.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var hash = CryptoJS.SHA256('message');
    					     *     var hash = CryptoJS.SHA256(wordArray);
    					     */
    					    C.SHA256 = Hasher._createHelper(SHA256);

    					    /**
    					     * Shortcut function to the HMAC's object interface.
    					     *
    					     * @param {WordArray|string} message The message to hash.
    					     * @param {WordArray|string} key The secret key.
    					     *
    					     * @return {WordArray} The HMAC.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var hmac = CryptoJS.HmacSHA256(message, key);
    					     */
    					    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    					}(Math));


    					return CryptoJS.SHA256;

    				})); 
    			} (sha256$1, sha256$1.exports));
    			return sha256$1.exports;
    		}

    		var sha224$1 = {exports: {}};

    		sha224$1.exports;

    		var hasRequiredSha224;

    		function requireSha224 () {
    			if (hasRequiredSha224) return sha224$1.exports;
    			hasRequiredSha224 = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireSha256());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function () {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var WordArray = C_lib.WordArray;
    					    var C_algo = C.algo;
    					    var SHA256 = C_algo.SHA256;

    					    /**
    					     * SHA-224 hash algorithm.
    					     */
    					    var SHA224 = C_algo.SHA224 = SHA256.extend({
    					        _doReset: function () {
    					            this._hash = new WordArray.init([
    					                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    					                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
    					            ]);
    					        },

    					        _doFinalize: function () {
    					            var hash = SHA256._doFinalize.call(this);

    					            hash.sigBytes -= 4;

    					            return hash;
    					        }
    					    });

    					    /**
    					     * Shortcut function to the hasher's object interface.
    					     *
    					     * @param {WordArray|string} message The message to hash.
    					     *
    					     * @return {WordArray} The hash.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var hash = CryptoJS.SHA224('message');
    					     *     var hash = CryptoJS.SHA224(wordArray);
    					     */
    					    C.SHA224 = SHA256._createHelper(SHA224);

    					    /**
    					     * Shortcut function to the HMAC's object interface.
    					     *
    					     * @param {WordArray|string} message The message to hash.
    					     * @param {WordArray|string} key The secret key.
    					     *
    					     * @return {WordArray} The HMAC.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var hmac = CryptoJS.HmacSHA224(message, key);
    					     */
    					    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
    					}());


    					return CryptoJS.SHA224;

    				})); 
    			} (sha224$1, sha224$1.exports));
    			return sha224$1.exports;
    		}

    		var sha512$1 = {exports: {}};

    		sha512$1.exports;

    		var hasRequiredSha512;

    		function requireSha512 () {
    			if (hasRequiredSha512) return sha512$1.exports;
    			hasRequiredSha512 = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireX64Core());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function () {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var Hasher = C_lib.Hasher;
    					    var C_x64 = C.x64;
    					    var X64Word = C_x64.Word;
    					    var X64WordArray = C_x64.WordArray;
    					    var C_algo = C.algo;

    					    function X64Word_create() {
    					        return X64Word.create.apply(X64Word, arguments);
    					    }

    					    // Constants
    					    var K = [
    					        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
    					        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
    					        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
    					        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
    					        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
    					        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
    					        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
    					        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
    					        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
    					        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
    					        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
    					        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
    					        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
    					        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
    					        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
    					        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
    					        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
    					        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
    					        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
    					        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
    					        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
    					        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
    					        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
    					        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
    					        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
    					        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
    					        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
    					        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
    					        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
    					        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
    					        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
    					        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
    					        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
    					        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
    					        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
    					        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
    					        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
    					        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
    					        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
    					        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
    					    ];

    					    // Reusable objects
    					    var W = [];
    					    (function () {
    					        for (var i = 0; i < 80; i++) {
    					            W[i] = X64Word_create();
    					        }
    					    }());

    					    /**
    					     * SHA-512 hash algorithm.
    					     */
    					    var SHA512 = C_algo.SHA512 = Hasher.extend({
    					        _doReset: function () {
    					            this._hash = new X64WordArray.init([
    					                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
    					                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
    					                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
    					                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
    					            ]);
    					        },

    					        _doProcessBlock: function (M, offset) {
    					            // Shortcuts
    					            var H = this._hash.words;

    					            var H0 = H[0];
    					            var H1 = H[1];
    					            var H2 = H[2];
    					            var H3 = H[3];
    					            var H4 = H[4];
    					            var H5 = H[5];
    					            var H6 = H[6];
    					            var H7 = H[7];

    					            var H0h = H0.high;
    					            var H0l = H0.low;
    					            var H1h = H1.high;
    					            var H1l = H1.low;
    					            var H2h = H2.high;
    					            var H2l = H2.low;
    					            var H3h = H3.high;
    					            var H3l = H3.low;
    					            var H4h = H4.high;
    					            var H4l = H4.low;
    					            var H5h = H5.high;
    					            var H5l = H5.low;
    					            var H6h = H6.high;
    					            var H6l = H6.low;
    					            var H7h = H7.high;
    					            var H7l = H7.low;

    					            // Working variables
    					            var ah = H0h;
    					            var al = H0l;
    					            var bh = H1h;
    					            var bl = H1l;
    					            var ch = H2h;
    					            var cl = H2l;
    					            var dh = H3h;
    					            var dl = H3l;
    					            var eh = H4h;
    					            var el = H4l;
    					            var fh = H5h;
    					            var fl = H5l;
    					            var gh = H6h;
    					            var gl = H6l;
    					            var hh = H7h;
    					            var hl = H7l;

    					            // Rounds
    					            for (var i = 0; i < 80; i++) {
    					                var Wil;
    					                var Wih;

    					                // Shortcut
    					                var Wi = W[i];

    					                // Extend message
    					                if (i < 16) {
    					                    Wih = Wi.high = M[offset + i * 2]     | 0;
    					                    Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
    					                } else {
    					                    // Gamma0
    					                    var gamma0x  = W[i - 15];
    					                    var gamma0xh = gamma0x.high;
    					                    var gamma0xl = gamma0x.low;
    					                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
    					                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

    					                    // Gamma1
    					                    var gamma1x  = W[i - 2];
    					                    var gamma1xh = gamma1x.high;
    					                    var gamma1xl = gamma1x.low;
    					                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
    					                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

    					                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    					                    var Wi7  = W[i - 7];
    					                    var Wi7h = Wi7.high;
    					                    var Wi7l = Wi7.low;

    					                    var Wi16  = W[i - 16];
    					                    var Wi16h = Wi16.high;
    					                    var Wi16l = Wi16.low;

    					                    Wil = gamma0l + Wi7l;
    					                    Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
    					                    Wil = Wil + gamma1l;
    					                    Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
    					                    Wil = Wil + Wi16l;
    					                    Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

    					                    Wi.high = Wih;
    					                    Wi.low  = Wil;
    					                }

    					                var chh  = (eh & fh) ^ (~eh & gh);
    					                var chl  = (el & fl) ^ (~el & gl);
    					                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
    					                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

    					                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
    					                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
    					                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
    					                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

    					                // t1 = h + sigma1 + ch + K[i] + W[i]
    					                var Ki  = K[i];
    					                var Kih = Ki.high;
    					                var Kil = Ki.low;

    					                var t1l = hl + sigma1l;
    					                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
    					                var t1l = t1l + chl;
    					                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
    					                var t1l = t1l + Kil;
    					                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
    					                var t1l = t1l + Wil;
    					                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

    					                // t2 = sigma0 + maj
    					                var t2l = sigma0l + majl;
    					                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

    					                // Update working variables
    					                hh = gh;
    					                hl = gl;
    					                gh = fh;
    					                gl = fl;
    					                fh = eh;
    					                fl = el;
    					                el = (dl + t1l) | 0;
    					                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
    					                dh = ch;
    					                dl = cl;
    					                ch = bh;
    					                cl = bl;
    					                bh = ah;
    					                bl = al;
    					                al = (t1l + t2l) | 0;
    					                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
    					            }

    					            // Intermediate hash value
    					            H0l = H0.low  = (H0l + al);
    					            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
    					            H1l = H1.low  = (H1l + bl);
    					            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
    					            H2l = H2.low  = (H2l + cl);
    					            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
    					            H3l = H3.low  = (H3l + dl);
    					            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
    					            H4l = H4.low  = (H4l + el);
    					            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
    					            H5l = H5.low  = (H5l + fl);
    					            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
    					            H6l = H6.low  = (H6l + gl);
    					            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
    					            H7l = H7.low  = (H7l + hl);
    					            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
    					        },

    					        _doFinalize: function () {
    					            // Shortcuts
    					            var data = this._data;
    					            var dataWords = data.words;

    					            var nBitsTotal = this._nDataBytes * 8;
    					            var nBitsLeft = data.sigBytes * 8;

    					            // Add padding
    					            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
    					            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
    					            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
    					            data.sigBytes = dataWords.length * 4;

    					            // Hash final blocks
    					            this._process();

    					            // Convert hash to 32-bit word array before returning
    					            var hash = this._hash.toX32();

    					            // Return final computed hash
    					            return hash;
    					        },

    					        clone: function () {
    					            var clone = Hasher.clone.call(this);
    					            clone._hash = this._hash.clone();

    					            return clone;
    					        },

    					        blockSize: 1024/32
    					    });

    					    /**
    					     * Shortcut function to the hasher's object interface.
    					     *
    					     * @param {WordArray|string} message The message to hash.
    					     *
    					     * @return {WordArray} The hash.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var hash = CryptoJS.SHA512('message');
    					     *     var hash = CryptoJS.SHA512(wordArray);
    					     */
    					    C.SHA512 = Hasher._createHelper(SHA512);

    					    /**
    					     * Shortcut function to the HMAC's object interface.
    					     *
    					     * @param {WordArray|string} message The message to hash.
    					     * @param {WordArray|string} key The secret key.
    					     *
    					     * @return {WordArray} The HMAC.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var hmac = CryptoJS.HmacSHA512(message, key);
    					     */
    					    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
    					}());


    					return CryptoJS.SHA512;

    				})); 
    			} (sha512$1, sha512$1.exports));
    			return sha512$1.exports;
    		}

    		var sha384$1 = {exports: {}};

    		sha384$1.exports;

    		var hasRequiredSha384;

    		function requireSha384 () {
    			if (hasRequiredSha384) return sha384$1.exports;
    			hasRequiredSha384 = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireX64Core(), requireSha512());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function () {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_x64 = C.x64;
    					    var X64Word = C_x64.Word;
    					    var X64WordArray = C_x64.WordArray;
    					    var C_algo = C.algo;
    					    var SHA512 = C_algo.SHA512;

    					    /**
    					     * SHA-384 hash algorithm.
    					     */
    					    var SHA384 = C_algo.SHA384 = SHA512.extend({
    					        _doReset: function () {
    					            this._hash = new X64WordArray.init([
    					                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
    					                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
    					                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
    					                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
    					            ]);
    					        },

    					        _doFinalize: function () {
    					            var hash = SHA512._doFinalize.call(this);

    					            hash.sigBytes -= 16;

    					            return hash;
    					        }
    					    });

    					    /**
    					     * Shortcut function to the hasher's object interface.
    					     *
    					     * @param {WordArray|string} message The message to hash.
    					     *
    					     * @return {WordArray} The hash.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var hash = CryptoJS.SHA384('message');
    					     *     var hash = CryptoJS.SHA384(wordArray);
    					     */
    					    C.SHA384 = SHA512._createHelper(SHA384);

    					    /**
    					     * Shortcut function to the HMAC's object interface.
    					     *
    					     * @param {WordArray|string} message The message to hash.
    					     * @param {WordArray|string} key The secret key.
    					     *
    					     * @return {WordArray} The HMAC.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var hmac = CryptoJS.HmacSHA384(message, key);
    					     */
    					    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
    					}());


    					return CryptoJS.SHA384;

    				})); 
    			} (sha384$1, sha384$1.exports));
    			return sha384$1.exports;
    		}

    		var sha3 = {exports: {}};

    		sha3.exports;

    		var hasRequiredSha3;

    		function requireSha3 () {
    			if (hasRequiredSha3) return sha3.exports;
    			hasRequiredSha3 = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireX64Core());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function (Math) {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var WordArray = C_lib.WordArray;
    					    var Hasher = C_lib.Hasher;
    					    var C_x64 = C.x64;
    					    var X64Word = C_x64.Word;
    					    var C_algo = C.algo;

    					    // Constants tables
    					    var RHO_OFFSETS = [];
    					    var PI_INDEXES  = [];
    					    var ROUND_CONSTANTS = [];

    					    // Compute Constants
    					    (function () {
    					        // Compute rho offset constants
    					        var x = 1, y = 0;
    					        for (var t = 0; t < 24; t++) {
    					            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

    					            var newX = y % 5;
    					            var newY = (2 * x + 3 * y) % 5;
    					            x = newX;
    					            y = newY;
    					        }

    					        // Compute pi index constants
    					        for (var x = 0; x < 5; x++) {
    					            for (var y = 0; y < 5; y++) {
    					                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
    					            }
    					        }

    					        // Compute round constants
    					        var LFSR = 0x01;
    					        for (var i = 0; i < 24; i++) {
    					            var roundConstantMsw = 0;
    					            var roundConstantLsw = 0;

    					            for (var j = 0; j < 7; j++) {
    					                if (LFSR & 0x01) {
    					                    var bitPosition = (1 << j) - 1;
    					                    if (bitPosition < 32) {
    					                        roundConstantLsw ^= 1 << bitPosition;
    					                    } else /* if (bitPosition >= 32) */ {
    					                        roundConstantMsw ^= 1 << (bitPosition - 32);
    					                    }
    					                }

    					                // Compute next LFSR
    					                if (LFSR & 0x80) {
    					                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
    					                    LFSR = (LFSR << 1) ^ 0x71;
    					                } else {
    					                    LFSR <<= 1;
    					                }
    					            }

    					            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
    					        }
    					    }());

    					    // Reusable objects for temporary values
    					    var T = [];
    					    (function () {
    					        for (var i = 0; i < 25; i++) {
    					            T[i] = X64Word.create();
    					        }
    					    }());

    					    /**
    					     * SHA-3 hash algorithm.
    					     */
    					    var SHA3 = C_algo.SHA3 = Hasher.extend({
    					        /**
    					         * Configuration options.
    					         *
    					         * @property {number} outputLength
    					         *   The desired number of bits in the output hash.
    					         *   Only values permitted are: 224, 256, 384, 512.
    					         *   Default: 512
    					         */
    					        cfg: Hasher.cfg.extend({
    					            outputLength: 512
    					        }),

    					        _doReset: function () {
    					            var state = this._state = [];
    					            for (var i = 0; i < 25; i++) {
    					                state[i] = new X64Word.init();
    					            }

    					            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
    					        },

    					        _doProcessBlock: function (M, offset) {
    					            // Shortcuts
    					            var state = this._state;
    					            var nBlockSizeLanes = this.blockSize / 2;

    					            // Absorb
    					            for (var i = 0; i < nBlockSizeLanes; i++) {
    					                // Shortcuts
    					                var M2i  = M[offset + 2 * i];
    					                var M2i1 = M[offset + 2 * i + 1];

    					                // Swap endian
    					                M2i = (
    					                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
    					                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
    					                );
    					                M2i1 = (
    					                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
    					                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
    					                );

    					                // Absorb message into state
    					                var lane = state[i];
    					                lane.high ^= M2i1;
    					                lane.low  ^= M2i;
    					            }

    					            // Rounds
    					            for (var round = 0; round < 24; round++) {
    					                // Theta
    					                for (var x = 0; x < 5; x++) {
    					                    // Mix column lanes
    					                    var tMsw = 0, tLsw = 0;
    					                    for (var y = 0; y < 5; y++) {
    					                        var lane = state[x + 5 * y];
    					                        tMsw ^= lane.high;
    					                        tLsw ^= lane.low;
    					                    }

    					                    // Temporary values
    					                    var Tx = T[x];
    					                    Tx.high = tMsw;
    					                    Tx.low  = tLsw;
    					                }
    					                for (var x = 0; x < 5; x++) {
    					                    // Shortcuts
    					                    var Tx4 = T[(x + 4) % 5];
    					                    var Tx1 = T[(x + 1) % 5];
    					                    var Tx1Msw = Tx1.high;
    					                    var Tx1Lsw = Tx1.low;

    					                    // Mix surrounding columns
    					                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
    					                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
    					                    for (var y = 0; y < 5; y++) {
    					                        var lane = state[x + 5 * y];
    					                        lane.high ^= tMsw;
    					                        lane.low  ^= tLsw;
    					                    }
    					                }

    					                // Rho Pi
    					                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
    					                    var tMsw;
    					                    var tLsw;

    					                    // Shortcuts
    					                    var lane = state[laneIndex];
    					                    var laneMsw = lane.high;
    					                    var laneLsw = lane.low;
    					                    var rhoOffset = RHO_OFFSETS[laneIndex];

    					                    // Rotate lanes
    					                    if (rhoOffset < 32) {
    					                        tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
    					                        tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
    					                    } else /* if (rhoOffset >= 32) */ {
    					                        tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
    					                        tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
    					                    }

    					                    // Transpose lanes
    					                    var TPiLane = T[PI_INDEXES[laneIndex]];
    					                    TPiLane.high = tMsw;
    					                    TPiLane.low  = tLsw;
    					                }

    					                // Rho pi at x = y = 0
    					                var T0 = T[0];
    					                var state0 = state[0];
    					                T0.high = state0.high;
    					                T0.low  = state0.low;

    					                // Chi
    					                for (var x = 0; x < 5; x++) {
    					                    for (var y = 0; y < 5; y++) {
    					                        // Shortcuts
    					                        var laneIndex = x + 5 * y;
    					                        var lane = state[laneIndex];
    					                        var TLane = T[laneIndex];
    					                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
    					                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

    					                        // Mix rows
    					                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
    					                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
    					                    }
    					                }

    					                // Iota
    					                var lane = state[0];
    					                var roundConstant = ROUND_CONSTANTS[round];
    					                lane.high ^= roundConstant.high;
    					                lane.low  ^= roundConstant.low;
    					            }
    					        },

    					        _doFinalize: function () {
    					            // Shortcuts
    					            var data = this._data;
    					            var dataWords = data.words;
    					            this._nDataBytes * 8;
    					            var nBitsLeft = data.sigBytes * 8;
    					            var blockSizeBits = this.blockSize * 32;

    					            // Add padding
    					            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
    					            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
    					            data.sigBytes = dataWords.length * 4;

    					            // Hash final blocks
    					            this._process();

    					            // Shortcuts
    					            var state = this._state;
    					            var outputLengthBytes = this.cfg.outputLength / 8;
    					            var outputLengthLanes = outputLengthBytes / 8;

    					            // Squeeze
    					            var hashWords = [];
    					            for (var i = 0; i < outputLengthLanes; i++) {
    					                // Shortcuts
    					                var lane = state[i];
    					                var laneMsw = lane.high;
    					                var laneLsw = lane.low;

    					                // Swap endian
    					                laneMsw = (
    					                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
    					                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
    					                );
    					                laneLsw = (
    					                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
    					                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
    					                );

    					                // Squeeze state to retrieve hash
    					                hashWords.push(laneLsw);
    					                hashWords.push(laneMsw);
    					            }

    					            // Return final computed hash
    					            return new WordArray.init(hashWords, outputLengthBytes);
    					        },

    					        clone: function () {
    					            var clone = Hasher.clone.call(this);

    					            var state = clone._state = this._state.slice(0);
    					            for (var i = 0; i < 25; i++) {
    					                state[i] = state[i].clone();
    					            }

    					            return clone;
    					        }
    					    });

    					    /**
    					     * Shortcut function to the hasher's object interface.
    					     *
    					     * @param {WordArray|string} message The message to hash.
    					     *
    					     * @return {WordArray} The hash.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var hash = CryptoJS.SHA3('message');
    					     *     var hash = CryptoJS.SHA3(wordArray);
    					     */
    					    C.SHA3 = Hasher._createHelper(SHA3);

    					    /**
    					     * Shortcut function to the HMAC's object interface.
    					     *
    					     * @param {WordArray|string} message The message to hash.
    					     * @param {WordArray|string} key The secret key.
    					     *
    					     * @return {WordArray} The HMAC.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var hmac = CryptoJS.HmacSHA3(message, key);
    					     */
    					    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    					}(Math));


    					return CryptoJS.SHA3;

    				})); 
    			} (sha3, sha3.exports));
    			return sha3.exports;
    		}

    		var ripemd160$1 = {exports: {}};

    		ripemd160$1.exports;

    		var hasRequiredRipemd160;

    		function requireRipemd160 () {
    			if (hasRequiredRipemd160) return ripemd160$1.exports;
    			hasRequiredRipemd160 = 1;
    			(function (module, exports) {
    		(function (root, factory) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					/** @preserve
    					(c) 2012 by Cédric Mesnil. All rights reserved.

    					Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

    					    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
    					    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

    					THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
    					*/

    					(function (Math) {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var WordArray = C_lib.WordArray;
    					    var Hasher = C_lib.Hasher;
    					    var C_algo = C.algo;

    					    // Constants table
    					    var _zl = WordArray.create([
    					        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
    					        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
    					        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
    					        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
    					        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
    					    var _zr = WordArray.create([
    					        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
    					        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
    					        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
    					        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
    					        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
    					    var _sl = WordArray.create([
    					         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
    					        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
    					        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
    					          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
    					        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
    					    var _sr = WordArray.create([
    					        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
    					        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
    					        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
    					        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
    					        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

    					    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
    					    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

    					    /**
    					     * RIPEMD160 hash algorithm.
    					     */
    					    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
    					        _doReset: function () {
    					            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
    					        },

    					        _doProcessBlock: function (M, offset) {

    					            // Swap endian
    					            for (var i = 0; i < 16; i++) {
    					                // Shortcuts
    					                var offset_i = offset + i;
    					                var M_offset_i = M[offset_i];

    					                // Swap
    					                M[offset_i] = (
    					                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
    					                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
    					                );
    					            }
    					            // Shortcut
    					            var H  = this._hash.words;
    					            var hl = _hl.words;
    					            var hr = _hr.words;
    					            var zl = _zl.words;
    					            var zr = _zr.words;
    					            var sl = _sl.words;
    					            var sr = _sr.words;

    					            // Working variables
    					            var al, bl, cl, dl, el;
    					            var ar, br, cr, dr, er;

    					            ar = al = H[0];
    					            br = bl = H[1];
    					            cr = cl = H[2];
    					            dr = dl = H[3];
    					            er = el = H[4];
    					            // Computation
    					            var t;
    					            for (var i = 0; i < 80; i += 1) {
    					                t = (al +  M[offset+zl[i]])|0;
    					                if (i<16){
    						            t +=  f1(bl,cl,dl) + hl[0];
    					                } else if (i<32) {
    						            t +=  f2(bl,cl,dl) + hl[1];
    					                } else if (i<48) {
    						            t +=  f3(bl,cl,dl) + hl[2];
    					                } else if (i<64) {
    						            t +=  f4(bl,cl,dl) + hl[3];
    					                } else {// if (i<80) {
    						            t +=  f5(bl,cl,dl) + hl[4];
    					                }
    					                t = t|0;
    					                t =  rotl(t,sl[i]);
    					                t = (t+el)|0;
    					                al = el;
    					                el = dl;
    					                dl = rotl(cl, 10);
    					                cl = bl;
    					                bl = t;

    					                t = (ar + M[offset+zr[i]])|0;
    					                if (i<16){
    						            t +=  f5(br,cr,dr) + hr[0];
    					                } else if (i<32) {
    						            t +=  f4(br,cr,dr) + hr[1];
    					                } else if (i<48) {
    						            t +=  f3(br,cr,dr) + hr[2];
    					                } else if (i<64) {
    						            t +=  f2(br,cr,dr) + hr[3];
    					                } else {// if (i<80) {
    						            t +=  f1(br,cr,dr) + hr[4];
    					                }
    					                t = t|0;
    					                t =  rotl(t,sr[i]) ;
    					                t = (t+er)|0;
    					                ar = er;
    					                er = dr;
    					                dr = rotl(cr, 10);
    					                cr = br;
    					                br = t;
    					            }
    					            // Intermediate hash value
    					            t    = (H[1] + cl + dr)|0;
    					            H[1] = (H[2] + dl + er)|0;
    					            H[2] = (H[3] + el + ar)|0;
    					            H[3] = (H[4] + al + br)|0;
    					            H[4] = (H[0] + bl + cr)|0;
    					            H[0] =  t;
    					        },

    					        _doFinalize: function () {
    					            // Shortcuts
    					            var data = this._data;
    					            var dataWords = data.words;

    					            var nBitsTotal = this._nDataBytes * 8;
    					            var nBitsLeft = data.sigBytes * 8;

    					            // Add padding
    					            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
    					            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
    					                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
    					                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
    					            );
    					            data.sigBytes = (dataWords.length + 1) * 4;

    					            // Hash final blocks
    					            this._process();

    					            // Shortcuts
    					            var hash = this._hash;
    					            var H = hash.words;

    					            // Swap endian
    					            for (var i = 0; i < 5; i++) {
    					                // Shortcut
    					                var H_i = H[i];

    					                // Swap
    					                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
    					                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
    					            }

    					            // Return final computed hash
    					            return hash;
    					        },

    					        clone: function () {
    					            var clone = Hasher.clone.call(this);
    					            clone._hash = this._hash.clone();

    					            return clone;
    					        }
    					    });


    					    function f1(x, y, z) {
    					        return ((x) ^ (y) ^ (z));

    					    }

    					    function f2(x, y, z) {
    					        return (((x)&(y)) | ((~x)&(z)));
    					    }

    					    function f3(x, y, z) {
    					        return (((x) | (~(y))) ^ (z));
    					    }

    					    function f4(x, y, z) {
    					        return (((x) & (z)) | ((y)&(~(z))));
    					    }

    					    function f5(x, y, z) {
    					        return ((x) ^ ((y) |(~(z))));

    					    }

    					    function rotl(x,n) {
    					        return (x<<n) | (x>>>(32-n));
    					    }


    					    /**
    					     * Shortcut function to the hasher's object interface.
    					     *
    					     * @param {WordArray|string} message The message to hash.
    					     *
    					     * @return {WordArray} The hash.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var hash = CryptoJS.RIPEMD160('message');
    					     *     var hash = CryptoJS.RIPEMD160(wordArray);
    					     */
    					    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

    					    /**
    					     * Shortcut function to the HMAC's object interface.
    					     *
    					     * @param {WordArray|string} message The message to hash.
    					     * @param {WordArray|string} key The secret key.
    					     *
    					     * @return {WordArray} The HMAC.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
    					     */
    					    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    					}());


    					return CryptoJS.RIPEMD160;

    				})); 
    			} (ripemd160$1, ripemd160$1.exports));
    			return ripemd160$1.exports;
    		}

    		var hmac = {exports: {}};

    		hmac.exports;

    		var hasRequiredHmac;

    		function requireHmac () {
    			if (hasRequiredHmac) return hmac.exports;
    			hasRequiredHmac = 1;
    			(function (module, exports) {
    		(function (root, factory) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function () {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var Base = C_lib.Base;
    					    var C_enc = C.enc;
    					    var Utf8 = C_enc.Utf8;
    					    var C_algo = C.algo;

    					    /**
    					     * HMAC algorithm.
    					     */
    					    C_algo.HMAC = Base.extend({
    					        /**
    					         * Initializes a newly created HMAC.
    					         *
    					         * @param {Hasher} hasher The hash algorithm to use.
    					         * @param {WordArray|string} key The secret key.
    					         *
    					         * @example
    					         *
    					         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
    					         */
    					        init: function (hasher, key) {
    					            // Init hasher
    					            hasher = this._hasher = new hasher.init();

    					            // Convert string to WordArray, else assume WordArray already
    					            if (typeof key == 'string') {
    					                key = Utf8.parse(key);
    					            }

    					            // Shortcuts
    					            var hasherBlockSize = hasher.blockSize;
    					            var hasherBlockSizeBytes = hasherBlockSize * 4;

    					            // Allow arbitrary length keys
    					            if (key.sigBytes > hasherBlockSizeBytes) {
    					                key = hasher.finalize(key);
    					            }

    					            // Clamp excess bits
    					            key.clamp();

    					            // Clone key for inner and outer pads
    					            var oKey = this._oKey = key.clone();
    					            var iKey = this._iKey = key.clone();

    					            // Shortcuts
    					            var oKeyWords = oKey.words;
    					            var iKeyWords = iKey.words;

    					            // XOR keys with pad constants
    					            for (var i = 0; i < hasherBlockSize; i++) {
    					                oKeyWords[i] ^= 0x5c5c5c5c;
    					                iKeyWords[i] ^= 0x36363636;
    					            }
    					            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

    					            // Set initial values
    					            this.reset();
    					        },

    					        /**
    					         * Resets this HMAC to its initial state.
    					         *
    					         * @example
    					         *
    					         *     hmacHasher.reset();
    					         */
    					        reset: function () {
    					            // Shortcut
    					            var hasher = this._hasher;

    					            // Reset
    					            hasher.reset();
    					            hasher.update(this._iKey);
    					        },

    					        /**
    					         * Updates this HMAC with a message.
    					         *
    					         * @param {WordArray|string} messageUpdate The message to append.
    					         *
    					         * @return {HMAC} This HMAC instance.
    					         *
    					         * @example
    					         *
    					         *     hmacHasher.update('message');
    					         *     hmacHasher.update(wordArray);
    					         */
    					        update: function (messageUpdate) {
    					            this._hasher.update(messageUpdate);

    					            // Chainable
    					            return this;
    					        },

    					        /**
    					         * Finalizes the HMAC computation.
    					         * Note that the finalize operation is effectively a destructive, read-once operation.
    					         *
    					         * @param {WordArray|string} messageUpdate (Optional) A final message update.
    					         *
    					         * @return {WordArray} The HMAC.
    					         *
    					         * @example
    					         *
    					         *     var hmac = hmacHasher.finalize();
    					         *     var hmac = hmacHasher.finalize('message');
    					         *     var hmac = hmacHasher.finalize(wordArray);
    					         */
    					        finalize: function (messageUpdate) {
    					            // Shortcut
    					            var hasher = this._hasher;

    					            // Compute HMAC
    					            var innerHash = hasher.finalize(messageUpdate);
    					            hasher.reset();
    					            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

    					            return hmac;
    					        }
    					    });
    					}());


    				})); 
    			} (hmac, hmac.exports));
    			return hmac.exports;
    		}

    		var pbkdf2$1 = {exports: {}};

    		pbkdf2$1.exports;

    		var hasRequiredPbkdf2;

    		function requirePbkdf2 () {
    			if (hasRequiredPbkdf2) return pbkdf2$1.exports;
    			hasRequiredPbkdf2 = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireSha256(), requireHmac());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function () {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var Base = C_lib.Base;
    					    var WordArray = C_lib.WordArray;
    					    var C_algo = C.algo;
    					    var SHA256 = C_algo.SHA256;
    					    var HMAC = C_algo.HMAC;

    					    /**
    					     * Password-Based Key Derivation Function 2 algorithm.
    					     */
    					    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
    					        /**
    					         * Configuration options.
    					         *
    					         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
    					         * @property {Hasher} hasher The hasher to use. Default: SHA256
    					         * @property {number} iterations The number of iterations to perform. Default: 250000
    					         */
    					        cfg: Base.extend({
    					            keySize: 128/32,
    					            hasher: SHA256,
    					            iterations: 250000
    					        }),

    					        /**
    					         * Initializes a newly created key derivation function.
    					         *
    					         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
    					         *
    					         * @example
    					         *
    					         *     var kdf = CryptoJS.algo.PBKDF2.create();
    					         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
    					         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
    					         */
    					        init: function (cfg) {
    					            this.cfg = this.cfg.extend(cfg);
    					        },

    					        /**
    					         * Computes the Password-Based Key Derivation Function 2.
    					         *
    					         * @param {WordArray|string} password The password.
    					         * @param {WordArray|string} salt A salt.
    					         *
    					         * @return {WordArray} The derived key.
    					         *
    					         * @example
    					         *
    					         *     var key = kdf.compute(password, salt);
    					         */
    					        compute: function (password, salt) {
    					            // Shortcut
    					            var cfg = this.cfg;

    					            // Init HMAC
    					            var hmac = HMAC.create(cfg.hasher, password);

    					            // Initial values
    					            var derivedKey = WordArray.create();
    					            var blockIndex = WordArray.create([0x00000001]);

    					            // Shortcuts
    					            var derivedKeyWords = derivedKey.words;
    					            var blockIndexWords = blockIndex.words;
    					            var keySize = cfg.keySize;
    					            var iterations = cfg.iterations;

    					            // Generate key
    					            while (derivedKeyWords.length < keySize) {
    					                var block = hmac.update(salt).finalize(blockIndex);
    					                hmac.reset();

    					                // Shortcuts
    					                var blockWords = block.words;
    					                var blockWordsLength = blockWords.length;

    					                // Iterations
    					                var intermediate = block;
    					                for (var i = 1; i < iterations; i++) {
    					                    intermediate = hmac.finalize(intermediate);
    					                    hmac.reset();

    					                    // Shortcut
    					                    var intermediateWords = intermediate.words;

    					                    // XOR intermediate with block
    					                    for (var j = 0; j < blockWordsLength; j++) {
    					                        blockWords[j] ^= intermediateWords[j];
    					                    }
    					                }

    					                derivedKey.concat(block);
    					                blockIndexWords[0]++;
    					            }
    					            derivedKey.sigBytes = keySize * 4;

    					            return derivedKey;
    					        }
    					    });

    					    /**
    					     * Computes the Password-Based Key Derivation Function 2.
    					     *
    					     * @param {WordArray|string} password The password.
    					     * @param {WordArray|string} salt A salt.
    					     * @param {Object} cfg (Optional) The configuration options to use for this computation.
    					     *
    					     * @return {WordArray} The derived key.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var key = CryptoJS.PBKDF2(password, salt);
    					     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
    					     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
    					     */
    					    C.PBKDF2 = function (password, salt, cfg) {
    					        return PBKDF2.create(cfg).compute(password, salt);
    					    };
    					}());


    					return CryptoJS.PBKDF2;

    				})); 
    			} (pbkdf2$1, pbkdf2$1.exports));
    			return pbkdf2$1.exports;
    		}

    		var evpkdf = {exports: {}};

    		evpkdf.exports;

    		var hasRequiredEvpkdf;

    		function requireEvpkdf () {
    			if (hasRequiredEvpkdf) return evpkdf.exports;
    			hasRequiredEvpkdf = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireSha1(), requireHmac());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function () {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var Base = C_lib.Base;
    					    var WordArray = C_lib.WordArray;
    					    var C_algo = C.algo;
    					    var MD5 = C_algo.MD5;

    					    /**
    					     * This key derivation function is meant to conform with EVP_BytesToKey.
    					     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
    					     */
    					    var EvpKDF = C_algo.EvpKDF = Base.extend({
    					        /**
    					         * Configuration options.
    					         *
    					         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
    					         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
    					         * @property {number} iterations The number of iterations to perform. Default: 1
    					         */
    					        cfg: Base.extend({
    					            keySize: 128/32,
    					            hasher: MD5,
    					            iterations: 1
    					        }),

    					        /**
    					         * Initializes a newly created key derivation function.
    					         *
    					         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
    					         *
    					         * @example
    					         *
    					         *     var kdf = CryptoJS.algo.EvpKDF.create();
    					         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
    					         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
    					         */
    					        init: function (cfg) {
    					            this.cfg = this.cfg.extend(cfg);
    					        },

    					        /**
    					         * Derives a key from a password.
    					         *
    					         * @param {WordArray|string} password The password.
    					         * @param {WordArray|string} salt A salt.
    					         *
    					         * @return {WordArray} The derived key.
    					         *
    					         * @example
    					         *
    					         *     var key = kdf.compute(password, salt);
    					         */
    					        compute: function (password, salt) {
    					            var block;

    					            // Shortcut
    					            var cfg = this.cfg;

    					            // Init hasher
    					            var hasher = cfg.hasher.create();

    					            // Initial values
    					            var derivedKey = WordArray.create();

    					            // Shortcuts
    					            var derivedKeyWords = derivedKey.words;
    					            var keySize = cfg.keySize;
    					            var iterations = cfg.iterations;

    					            // Generate key
    					            while (derivedKeyWords.length < keySize) {
    					                if (block) {
    					                    hasher.update(block);
    					                }
    					                block = hasher.update(password).finalize(salt);
    					                hasher.reset();

    					                // Iterations
    					                for (var i = 1; i < iterations; i++) {
    					                    block = hasher.finalize(block);
    					                    hasher.reset();
    					                }

    					                derivedKey.concat(block);
    					            }
    					            derivedKey.sigBytes = keySize * 4;

    					            return derivedKey;
    					        }
    					    });

    					    /**
    					     * Derives a key from a password.
    					     *
    					     * @param {WordArray|string} password The password.
    					     * @param {WordArray|string} salt A salt.
    					     * @param {Object} cfg (Optional) The configuration options to use for this computation.
    					     *
    					     * @return {WordArray} The derived key.
    					     *
    					     * @static
    					     *
    					     * @example
    					     *
    					     *     var key = CryptoJS.EvpKDF(password, salt);
    					     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
    					     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
    					     */
    					    C.EvpKDF = function (password, salt, cfg) {
    					        return EvpKDF.create(cfg).compute(password, salt);
    					    };
    					}());


    					return CryptoJS.EvpKDF;

    				})); 
    			} (evpkdf, evpkdf.exports));
    			return evpkdf.exports;
    		}

    		var cipherCore = {exports: {}};

    		cipherCore.exports;

    		var hasRequiredCipherCore;

    		function requireCipherCore () {
    			if (hasRequiredCipherCore) return cipherCore.exports;
    			hasRequiredCipherCore = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireEvpkdf());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					/**
    					 * Cipher core components.
    					 */
    					CryptoJS.lib.Cipher || (function (undefined$1) {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var Base = C_lib.Base;
    					    var WordArray = C_lib.WordArray;
    					    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
    					    var C_enc = C.enc;
    					    C_enc.Utf8;
    					    var Base64 = C_enc.Base64;
    					    var C_algo = C.algo;
    					    var EvpKDF = C_algo.EvpKDF;

    					    /**
    					     * Abstract base cipher template.
    					     *
    					     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
    					     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
    					     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
    					     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
    					     */
    					    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
    					        /**
    					         * Configuration options.
    					         *
    					         * @property {WordArray} iv The IV to use for this operation.
    					         */
    					        cfg: Base.extend(),

    					        /**
    					         * Creates this cipher in encryption mode.
    					         *
    					         * @param {WordArray} key The key.
    					         * @param {Object} cfg (Optional) The configuration options to use for this operation.
    					         *
    					         * @return {Cipher} A cipher instance.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
    					         */
    					        createEncryptor: function (key, cfg) {
    					            return this.create(this._ENC_XFORM_MODE, key, cfg);
    					        },

    					        /**
    					         * Creates this cipher in decryption mode.
    					         *
    					         * @param {WordArray} key The key.
    					         * @param {Object} cfg (Optional) The configuration options to use for this operation.
    					         *
    					         * @return {Cipher} A cipher instance.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
    					         */
    					        createDecryptor: function (key, cfg) {
    					            return this.create(this._DEC_XFORM_MODE, key, cfg);
    					        },

    					        /**
    					         * Initializes a newly created cipher.
    					         *
    					         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
    					         * @param {WordArray} key The key.
    					         * @param {Object} cfg (Optional) The configuration options to use for this operation.
    					         *
    					         * @example
    					         *
    					         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
    					         */
    					        init: function (xformMode, key, cfg) {
    					            // Apply config defaults
    					            this.cfg = this.cfg.extend(cfg);

    					            // Store transform mode and key
    					            this._xformMode = xformMode;
    					            this._key = key;

    					            // Set initial values
    					            this.reset();
    					        },

    					        /**
    					         * Resets this cipher to its initial state.
    					         *
    					         * @example
    					         *
    					         *     cipher.reset();
    					         */
    					        reset: function () {
    					            // Reset data buffer
    					            BufferedBlockAlgorithm.reset.call(this);

    					            // Perform concrete-cipher logic
    					            this._doReset();
    					        },

    					        /**
    					         * Adds data to be encrypted or decrypted.
    					         *
    					         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
    					         *
    					         * @return {WordArray} The data after processing.
    					         *
    					         * @example
    					         *
    					         *     var encrypted = cipher.process('data');
    					         *     var encrypted = cipher.process(wordArray);
    					         */
    					        process: function (dataUpdate) {
    					            // Append
    					            this._append(dataUpdate);

    					            // Process available blocks
    					            return this._process();
    					        },

    					        /**
    					         * Finalizes the encryption or decryption process.
    					         * Note that the finalize operation is effectively a destructive, read-once operation.
    					         *
    					         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
    					         *
    					         * @return {WordArray} The data after final processing.
    					         *
    					         * @example
    					         *
    					         *     var encrypted = cipher.finalize();
    					         *     var encrypted = cipher.finalize('data');
    					         *     var encrypted = cipher.finalize(wordArray);
    					         */
    					        finalize: function (dataUpdate) {
    					            // Final data update
    					            if (dataUpdate) {
    					                this._append(dataUpdate);
    					            }

    					            // Perform concrete-cipher logic
    					            var finalProcessedData = this._doFinalize();

    					            return finalProcessedData;
    					        },

    					        keySize: 128/32,

    					        ivSize: 128/32,

    					        _ENC_XFORM_MODE: 1,

    					        _DEC_XFORM_MODE: 2,

    					        /**
    					         * Creates shortcut functions to a cipher's object interface.
    					         *
    					         * @param {Cipher} cipher The cipher to create a helper for.
    					         *
    					         * @return {Object} An object with encrypt and decrypt shortcut functions.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
    					         */
    					        _createHelper: (function () {
    					            function selectCipherStrategy(key) {
    					                if (typeof key == 'string') {
    					                    return PasswordBasedCipher;
    					                } else {
    					                    return SerializableCipher;
    					                }
    					            }

    					            return function (cipher) {
    					                return {
    					                    encrypt: function (message, key, cfg) {
    					                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
    					                    },

    					                    decrypt: function (ciphertext, key, cfg) {
    					                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
    					                    }
    					                };
    					            };
    					        }())
    					    });

    					    /**
    					     * Abstract base stream cipher template.
    					     *
    					     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
    					     */
    					    C_lib.StreamCipher = Cipher.extend({
    					        _doFinalize: function () {
    					            // Process partial blocks
    					            var finalProcessedBlocks = this._process(!!'flush');

    					            return finalProcessedBlocks;
    					        },

    					        blockSize: 1
    					    });

    					    /**
    					     * Mode namespace.
    					     */
    					    var C_mode = C.mode = {};

    					    /**
    					     * Abstract base block cipher mode template.
    					     */
    					    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
    					        /**
    					         * Creates this mode for encryption.
    					         *
    					         * @param {Cipher} cipher A block cipher instance.
    					         * @param {Array} iv The IV words.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
    					         */
    					        createEncryptor: function (cipher, iv) {
    					            return this.Encryptor.create(cipher, iv);
    					        },

    					        /**
    					         * Creates this mode for decryption.
    					         *
    					         * @param {Cipher} cipher A block cipher instance.
    					         * @param {Array} iv The IV words.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
    					         */
    					        createDecryptor: function (cipher, iv) {
    					            return this.Decryptor.create(cipher, iv);
    					        },

    					        /**
    					         * Initializes a newly created mode.
    					         *
    					         * @param {Cipher} cipher A block cipher instance.
    					         * @param {Array} iv The IV words.
    					         *
    					         * @example
    					         *
    					         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
    					         */
    					        init: function (cipher, iv) {
    					            this._cipher = cipher;
    					            this._iv = iv;
    					        }
    					    });

    					    /**
    					     * Cipher Block Chaining mode.
    					     */
    					    var CBC = C_mode.CBC = (function () {
    					        /**
    					         * Abstract base CBC mode.
    					         */
    					        var CBC = BlockCipherMode.extend();

    					        /**
    					         * CBC encryptor.
    					         */
    					        CBC.Encryptor = CBC.extend({
    					            /**
    					             * Processes the data block at offset.
    					             *
    					             * @param {Array} words The data words to operate on.
    					             * @param {number} offset The offset where the block starts.
    					             *
    					             * @example
    					             *
    					             *     mode.processBlock(data.words, offset);
    					             */
    					            processBlock: function (words, offset) {
    					                // Shortcuts
    					                var cipher = this._cipher;
    					                var blockSize = cipher.blockSize;

    					                // XOR and encrypt
    					                xorBlock.call(this, words, offset, blockSize);
    					                cipher.encryptBlock(words, offset);

    					                // Remember this block to use with next block
    					                this._prevBlock = words.slice(offset, offset + blockSize);
    					            }
    					        });

    					        /**
    					         * CBC decryptor.
    					         */
    					        CBC.Decryptor = CBC.extend({
    					            /**
    					             * Processes the data block at offset.
    					             *
    					             * @param {Array} words The data words to operate on.
    					             * @param {number} offset The offset where the block starts.
    					             *
    					             * @example
    					             *
    					             *     mode.processBlock(data.words, offset);
    					             */
    					            processBlock: function (words, offset) {
    					                // Shortcuts
    					                var cipher = this._cipher;
    					                var blockSize = cipher.blockSize;

    					                // Remember this block to use with next block
    					                var thisBlock = words.slice(offset, offset + blockSize);

    					                // Decrypt and XOR
    					                cipher.decryptBlock(words, offset);
    					                xorBlock.call(this, words, offset, blockSize);

    					                // This block becomes the previous block
    					                this._prevBlock = thisBlock;
    					            }
    					        });

    					        function xorBlock(words, offset, blockSize) {
    					            var block;

    					            // Shortcut
    					            var iv = this._iv;

    					            // Choose mixing block
    					            if (iv) {
    					                block = iv;

    					                // Remove IV for subsequent blocks
    					                this._iv = undefined$1;
    					            } else {
    					                block = this._prevBlock;
    					            }

    					            // XOR blocks
    					            for (var i = 0; i < blockSize; i++) {
    					                words[offset + i] ^= block[i];
    					            }
    					        }

    					        return CBC;
    					    }());

    					    /**
    					     * Padding namespace.
    					     */
    					    var C_pad = C.pad = {};

    					    /**
    					     * PKCS #5/7 padding strategy.
    					     */
    					    var Pkcs7 = C_pad.Pkcs7 = {
    					        /**
    					         * Pads data using the algorithm defined in PKCS #5/7.
    					         *
    					         * @param {WordArray} data The data to pad.
    					         * @param {number} blockSize The multiple that the data should be padded to.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
    					         */
    					        pad: function (data, blockSize) {
    					            // Shortcut
    					            var blockSizeBytes = blockSize * 4;

    					            // Count padding bytes
    					            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

    					            // Create padding word
    					            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

    					            // Create padding
    					            var paddingWords = [];
    					            for (var i = 0; i < nPaddingBytes; i += 4) {
    					                paddingWords.push(paddingWord);
    					            }
    					            var padding = WordArray.create(paddingWords, nPaddingBytes);

    					            // Add padding
    					            data.concat(padding);
    					        },

    					        /**
    					         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
    					         *
    					         * @param {WordArray} data The data to unpad.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
    					         */
    					        unpad: function (data) {
    					            // Get number of padding bytes from last byte
    					            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

    					            // Remove padding
    					            data.sigBytes -= nPaddingBytes;
    					        }
    					    };

    					    /**
    					     * Abstract base block cipher template.
    					     *
    					     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
    					     */
    					    C_lib.BlockCipher = Cipher.extend({
    					        /**
    					         * Configuration options.
    					         *
    					         * @property {Mode} mode The block mode to use. Default: CBC
    					         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
    					         */
    					        cfg: Cipher.cfg.extend({
    					            mode: CBC,
    					            padding: Pkcs7
    					        }),

    					        reset: function () {
    					            var modeCreator;

    					            // Reset cipher
    					            Cipher.reset.call(this);

    					            // Shortcuts
    					            var cfg = this.cfg;
    					            var iv = cfg.iv;
    					            var mode = cfg.mode;

    					            // Reset block mode
    					            if (this._xformMode == this._ENC_XFORM_MODE) {
    					                modeCreator = mode.createEncryptor;
    					            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
    					                modeCreator = mode.createDecryptor;
    					                // Keep at least one block in the buffer for unpadding
    					                this._minBufferSize = 1;
    					            }

    					            if (this._mode && this._mode.__creator == modeCreator) {
    					                this._mode.init(this, iv && iv.words);
    					            } else {
    					                this._mode = modeCreator.call(mode, this, iv && iv.words);
    					                this._mode.__creator = modeCreator;
    					            }
    					        },

    					        _doProcessBlock: function (words, offset) {
    					            this._mode.processBlock(words, offset);
    					        },

    					        _doFinalize: function () {
    					            var finalProcessedBlocks;

    					            // Shortcut
    					            var padding = this.cfg.padding;

    					            // Finalize
    					            if (this._xformMode == this._ENC_XFORM_MODE) {
    					                // Pad data
    					                padding.pad(this._data, this.blockSize);

    					                // Process final blocks
    					                finalProcessedBlocks = this._process(!!'flush');
    					            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
    					                // Process final blocks
    					                finalProcessedBlocks = this._process(!!'flush');

    					                // Unpad data
    					                padding.unpad(finalProcessedBlocks);
    					            }

    					            return finalProcessedBlocks;
    					        },

    					        blockSize: 128/32
    					    });

    					    /**
    					     * A collection of cipher parameters.
    					     *
    					     * @property {WordArray} ciphertext The raw ciphertext.
    					     * @property {WordArray} key The key to this ciphertext.
    					     * @property {WordArray} iv The IV used in the ciphering operation.
    					     * @property {WordArray} salt The salt used with a key derivation function.
    					     * @property {Cipher} algorithm The cipher algorithm.
    					     * @property {Mode} mode The block mode used in the ciphering operation.
    					     * @property {Padding} padding The padding scheme used in the ciphering operation.
    					     * @property {number} blockSize The block size of the cipher.
    					     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
    					     */
    					    var CipherParams = C_lib.CipherParams = Base.extend({
    					        /**
    					         * Initializes a newly created cipher params object.
    					         *
    					         * @param {Object} cipherParams An object with any of the possible cipher parameters.
    					         *
    					         * @example
    					         *
    					         *     var cipherParams = CryptoJS.lib.CipherParams.create({
    					         *         ciphertext: ciphertextWordArray,
    					         *         key: keyWordArray,
    					         *         iv: ivWordArray,
    					         *         salt: saltWordArray,
    					         *         algorithm: CryptoJS.algo.AES,
    					         *         mode: CryptoJS.mode.CBC,
    					         *         padding: CryptoJS.pad.PKCS7,
    					         *         blockSize: 4,
    					         *         formatter: CryptoJS.format.OpenSSL
    					         *     });
    					         */
    					        init: function (cipherParams) {
    					            this.mixIn(cipherParams);
    					        },

    					        /**
    					         * Converts this cipher params object to a string.
    					         *
    					         * @param {Format} formatter (Optional) The formatting strategy to use.
    					         *
    					         * @return {string} The stringified cipher params.
    					         *
    					         * @throws Error If neither the formatter nor the default formatter is set.
    					         *
    					         * @example
    					         *
    					         *     var string = cipherParams + '';
    					         *     var string = cipherParams.toString();
    					         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
    					         */
    					        toString: function (formatter) {
    					            return (formatter || this.formatter).stringify(this);
    					        }
    					    });

    					    /**
    					     * Format namespace.
    					     */
    					    var C_format = C.format = {};

    					    /**
    					     * OpenSSL formatting strategy.
    					     */
    					    var OpenSSLFormatter = C_format.OpenSSL = {
    					        /**
    					         * Converts a cipher params object to an OpenSSL-compatible string.
    					         *
    					         * @param {CipherParams} cipherParams The cipher params object.
    					         *
    					         * @return {string} The OpenSSL-compatible string.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
    					         */
    					        stringify: function (cipherParams) {
    					            var wordArray;

    					            // Shortcuts
    					            var ciphertext = cipherParams.ciphertext;
    					            var salt = cipherParams.salt;

    					            // Format
    					            if (salt) {
    					                wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
    					            } else {
    					                wordArray = ciphertext;
    					            }

    					            return wordArray.toString(Base64);
    					        },

    					        /**
    					         * Converts an OpenSSL-compatible string to a cipher params object.
    					         *
    					         * @param {string} openSSLStr The OpenSSL-compatible string.
    					         *
    					         * @return {CipherParams} The cipher params object.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
    					         */
    					        parse: function (openSSLStr) {
    					            var salt;

    					            // Parse base64
    					            var ciphertext = Base64.parse(openSSLStr);

    					            // Shortcut
    					            var ciphertextWords = ciphertext.words;

    					            // Test for salt
    					            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
    					                // Extract salt
    					                salt = WordArray.create(ciphertextWords.slice(2, 4));

    					                // Remove salt from ciphertext
    					                ciphertextWords.splice(0, 4);
    					                ciphertext.sigBytes -= 16;
    					            }

    					            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
    					        }
    					    };

    					    /**
    					     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
    					     */
    					    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
    					        /**
    					         * Configuration options.
    					         *
    					         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
    					         */
    					        cfg: Base.extend({
    					            format: OpenSSLFormatter
    					        }),

    					        /**
    					         * Encrypts a message.
    					         *
    					         * @param {Cipher} cipher The cipher algorithm to use.
    					         * @param {WordArray|string} message The message to encrypt.
    					         * @param {WordArray} key The key.
    					         * @param {Object} cfg (Optional) The configuration options to use for this operation.
    					         *
    					         * @return {CipherParams} A cipher params object.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
    					         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
    					         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
    					         */
    					        encrypt: function (cipher, message, key, cfg) {
    					            // Apply config defaults
    					            cfg = this.cfg.extend(cfg);

    					            // Encrypt
    					            var encryptor = cipher.createEncryptor(key, cfg);
    					            var ciphertext = encryptor.finalize(message);

    					            // Shortcut
    					            var cipherCfg = encryptor.cfg;

    					            // Create and return serializable cipher params
    					            return CipherParams.create({
    					                ciphertext: ciphertext,
    					                key: key,
    					                iv: cipherCfg.iv,
    					                algorithm: cipher,
    					                mode: cipherCfg.mode,
    					                padding: cipherCfg.padding,
    					                blockSize: cipher.blockSize,
    					                formatter: cfg.format
    					            });
    					        },

    					        /**
    					         * Decrypts serialized ciphertext.
    					         *
    					         * @param {Cipher} cipher The cipher algorithm to use.
    					         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
    					         * @param {WordArray} key The key.
    					         * @param {Object} cfg (Optional) The configuration options to use for this operation.
    					         *
    					         * @return {WordArray} The plaintext.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
    					         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
    					         */
    					        decrypt: function (cipher, ciphertext, key, cfg) {
    					            // Apply config defaults
    					            cfg = this.cfg.extend(cfg);

    					            // Convert string to CipherParams
    					            ciphertext = this._parse(ciphertext, cfg.format);

    					            // Decrypt
    					            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

    					            return plaintext;
    					        },

    					        /**
    					         * Converts serialized ciphertext to CipherParams,
    					         * else assumed CipherParams already and returns ciphertext unchanged.
    					         *
    					         * @param {CipherParams|string} ciphertext The ciphertext.
    					         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
    					         *
    					         * @return {CipherParams} The unserialized ciphertext.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
    					         */
    					        _parse: function (ciphertext, format) {
    					            if (typeof ciphertext == 'string') {
    					                return format.parse(ciphertext, this);
    					            } else {
    					                return ciphertext;
    					            }
    					        }
    					    });

    					    /**
    					     * Key derivation function namespace.
    					     */
    					    var C_kdf = C.kdf = {};

    					    /**
    					     * OpenSSL key derivation function.
    					     */
    					    var OpenSSLKdf = C_kdf.OpenSSL = {
    					        /**
    					         * Derives a key and IV from a password.
    					         *
    					         * @param {string} password The password to derive from.
    					         * @param {number} keySize The size in words of the key to generate.
    					         * @param {number} ivSize The size in words of the IV to generate.
    					         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
    					         *
    					         * @return {CipherParams} A cipher params object with the key, IV, and salt.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
    					         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
    					         */
    					        execute: function (password, keySize, ivSize, salt, hasher) {
    					            // Generate random salt
    					            if (!salt) {
    					                salt = WordArray.random(64/8);
    					            }

    					            // Derive key and IV
    					            if (!hasher) {
    					                var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);
    					            } else {
    					                var key = EvpKDF.create({ keySize: keySize + ivSize, hasher: hasher }).compute(password, salt);
    					            }


    					            // Separate key and IV
    					            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
    					            key.sigBytes = keySize * 4;

    					            // Return params
    					            return CipherParams.create({ key: key, iv: iv, salt: salt });
    					        }
    					    };

    					    /**
    					     * A serializable cipher wrapper that derives the key from a password,
    					     * and returns ciphertext as a serializable cipher params object.
    					     */
    					    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
    					        /**
    					         * Configuration options.
    					         *
    					         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
    					         */
    					        cfg: SerializableCipher.cfg.extend({
    					            kdf: OpenSSLKdf
    					        }),

    					        /**
    					         * Encrypts a message using a password.
    					         *
    					         * @param {Cipher} cipher The cipher algorithm to use.
    					         * @param {WordArray|string} message The message to encrypt.
    					         * @param {string} password The password.
    					         * @param {Object} cfg (Optional) The configuration options to use for this operation.
    					         *
    					         * @return {CipherParams} A cipher params object.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
    					         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
    					         */
    					        encrypt: function (cipher, message, password, cfg) {
    					            // Apply config defaults
    					            cfg = this.cfg.extend(cfg);

    					            // Derive key and other params
    					            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);

    					            // Add IV to config
    					            cfg.iv = derivedParams.iv;

    					            // Encrypt
    					            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

    					            // Mix in derived params
    					            ciphertext.mixIn(derivedParams);

    					            return ciphertext;
    					        },

    					        /**
    					         * Decrypts serialized ciphertext using a password.
    					         *
    					         * @param {Cipher} cipher The cipher algorithm to use.
    					         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
    					         * @param {string} password The password.
    					         * @param {Object} cfg (Optional) The configuration options to use for this operation.
    					         *
    					         * @return {WordArray} The plaintext.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
    					         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
    					         */
    					        decrypt: function (cipher, ciphertext, password, cfg) {
    					            // Apply config defaults
    					            cfg = this.cfg.extend(cfg);

    					            // Convert string to CipherParams
    					            ciphertext = this._parse(ciphertext, cfg.format);

    					            // Derive key and other params
    					            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);

    					            // Add IV to config
    					            cfg.iv = derivedParams.iv;

    					            // Decrypt
    					            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

    					            return plaintext;
    					        }
    					    });
    					}());


    				})); 
    			} (cipherCore, cipherCore.exports));
    			return cipherCore.exports;
    		}

    		var modeCfb = {exports: {}};

    		modeCfb.exports;

    		var hasRequiredModeCfb;

    		function requireModeCfb () {
    			if (hasRequiredModeCfb) return modeCfb.exports;
    			hasRequiredModeCfb = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireCipherCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					/**
    					 * Cipher Feedback block mode.
    					 */
    					CryptoJS.mode.CFB = (function () {
    					    var CFB = CryptoJS.lib.BlockCipherMode.extend();

    					    CFB.Encryptor = CFB.extend({
    					        processBlock: function (words, offset) {
    					            // Shortcuts
    					            var cipher = this._cipher;
    					            var blockSize = cipher.blockSize;

    					            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

    					            // Remember this block to use with next block
    					            this._prevBlock = words.slice(offset, offset + blockSize);
    					        }
    					    });

    					    CFB.Decryptor = CFB.extend({
    					        processBlock: function (words, offset) {
    					            // Shortcuts
    					            var cipher = this._cipher;
    					            var blockSize = cipher.blockSize;

    					            // Remember this block to use with next block
    					            var thisBlock = words.slice(offset, offset + blockSize);

    					            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

    					            // This block becomes the previous block
    					            this._prevBlock = thisBlock;
    					        }
    					    });

    					    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
    					        var keystream;

    					        // Shortcut
    					        var iv = this._iv;

    					        // Generate keystream
    					        if (iv) {
    					            keystream = iv.slice(0);

    					            // Remove IV for subsequent blocks
    					            this._iv = undefined;
    					        } else {
    					            keystream = this._prevBlock;
    					        }
    					        cipher.encryptBlock(keystream, 0);

    					        // Encrypt
    					        for (var i = 0; i < blockSize; i++) {
    					            words[offset + i] ^= keystream[i];
    					        }
    					    }

    					    return CFB;
    					}());


    					return CryptoJS.mode.CFB;

    				})); 
    			} (modeCfb, modeCfb.exports));
    			return modeCfb.exports;
    		}

    		var modeCtr = {exports: {}};

    		modeCtr.exports;

    		var hasRequiredModeCtr;

    		function requireModeCtr () {
    			if (hasRequiredModeCtr) return modeCtr.exports;
    			hasRequiredModeCtr = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireCipherCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					/**
    					 * Counter block mode.
    					 */
    					CryptoJS.mode.CTR = (function () {
    					    var CTR = CryptoJS.lib.BlockCipherMode.extend();

    					    var Encryptor = CTR.Encryptor = CTR.extend({
    					        processBlock: function (words, offset) {
    					            // Shortcuts
    					            var cipher = this._cipher;
    					            var blockSize = cipher.blockSize;
    					            var iv = this._iv;
    					            var counter = this._counter;

    					            // Generate keystream
    					            if (iv) {
    					                counter = this._counter = iv.slice(0);

    					                // Remove IV for subsequent blocks
    					                this._iv = undefined;
    					            }
    					            var keystream = counter.slice(0);
    					            cipher.encryptBlock(keystream, 0);

    					            // Increment counter
    					            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0;

    					            // Encrypt
    					            for (var i = 0; i < blockSize; i++) {
    					                words[offset + i] ^= keystream[i];
    					            }
    					        }
    					    });

    					    CTR.Decryptor = Encryptor;

    					    return CTR;
    					}());


    					return CryptoJS.mode.CTR;

    				})); 
    			} (modeCtr, modeCtr.exports));
    			return modeCtr.exports;
    		}

    		var modeCtrGladman = {exports: {}};

    		modeCtrGladman.exports;

    		var hasRequiredModeCtrGladman;

    		function requireModeCtrGladman () {
    			if (hasRequiredModeCtrGladman) return modeCtrGladman.exports;
    			hasRequiredModeCtrGladman = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireCipherCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					/** @preserve
    					 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
    					 * derived from CryptoJS.mode.CTR
    					 * Jan Hruby jhruby.web@gmail.com
    					 */
    					CryptoJS.mode.CTRGladman = (function () {
    					    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

    						function incWord(word)
    						{
    							if (((word >> 24) & 0xff) === 0xff) { //overflow
    							var b1 = (word >> 16)&0xff;
    							var b2 = (word >> 8)&0xff;
    							var b3 = word & 0xff;

    							if (b1 === 0xff) // overflow b1
    							{
    							b1 = 0;
    							if (b2 === 0xff)
    							{
    								b2 = 0;
    								if (b3 === 0xff)
    								{
    									b3 = 0;
    								}
    								else
    								{
    									++b3;
    								}
    							}
    							else
    							{
    								++b2;
    							}
    							}
    							else
    							{
    							++b1;
    							}

    							word = 0;
    							word += (b1 << 16);
    							word += (b2 << 8);
    							word += b3;
    							}
    							else
    							{
    							word += (0x01 << 24);
    							}
    							return word;
    						}

    						function incCounter(counter)
    						{
    							if ((counter[0] = incWord(counter[0])) === 0)
    							{
    								// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
    								counter[1] = incWord(counter[1]);
    							}
    							return counter;
    						}

    					    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
    					        processBlock: function (words, offset) {
    					            // Shortcuts
    					            var cipher = this._cipher;
    					            var blockSize = cipher.blockSize;
    					            var iv = this._iv;
    					            var counter = this._counter;

    					            // Generate keystream
    					            if (iv) {
    					                counter = this._counter = iv.slice(0);

    					                // Remove IV for subsequent blocks
    					                this._iv = undefined;
    					            }

    								incCounter(counter);

    								var keystream = counter.slice(0);
    					            cipher.encryptBlock(keystream, 0);

    					            // Encrypt
    					            for (var i = 0; i < blockSize; i++) {
    					                words[offset + i] ^= keystream[i];
    					            }
    					        }
    					    });

    					    CTRGladman.Decryptor = Encryptor;

    					    return CTRGladman;
    					}());




    					return CryptoJS.mode.CTRGladman;

    				})); 
    			} (modeCtrGladman, modeCtrGladman.exports));
    			return modeCtrGladman.exports;
    		}

    		var modeOfb = {exports: {}};

    		modeOfb.exports;

    		var hasRequiredModeOfb;

    		function requireModeOfb () {
    			if (hasRequiredModeOfb) return modeOfb.exports;
    			hasRequiredModeOfb = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireCipherCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					/**
    					 * Output Feedback block mode.
    					 */
    					CryptoJS.mode.OFB = (function () {
    					    var OFB = CryptoJS.lib.BlockCipherMode.extend();

    					    var Encryptor = OFB.Encryptor = OFB.extend({
    					        processBlock: function (words, offset) {
    					            // Shortcuts
    					            var cipher = this._cipher;
    					            var blockSize = cipher.blockSize;
    					            var iv = this._iv;
    					            var keystream = this._keystream;

    					            // Generate keystream
    					            if (iv) {
    					                keystream = this._keystream = iv.slice(0);

    					                // Remove IV for subsequent blocks
    					                this._iv = undefined;
    					            }
    					            cipher.encryptBlock(keystream, 0);

    					            // Encrypt
    					            for (var i = 0; i < blockSize; i++) {
    					                words[offset + i] ^= keystream[i];
    					            }
    					        }
    					    });

    					    OFB.Decryptor = Encryptor;

    					    return OFB;
    					}());


    					return CryptoJS.mode.OFB;

    				})); 
    			} (modeOfb, modeOfb.exports));
    			return modeOfb.exports;
    		}

    		var modeEcb = {exports: {}};

    		modeEcb.exports;

    		var hasRequiredModeEcb;

    		function requireModeEcb () {
    			if (hasRequiredModeEcb) return modeEcb.exports;
    			hasRequiredModeEcb = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireCipherCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					/**
    					 * Electronic Codebook block mode.
    					 */
    					CryptoJS.mode.ECB = (function () {
    					    var ECB = CryptoJS.lib.BlockCipherMode.extend();

    					    ECB.Encryptor = ECB.extend({
    					        processBlock: function (words, offset) {
    					            this._cipher.encryptBlock(words, offset);
    					        }
    					    });

    					    ECB.Decryptor = ECB.extend({
    					        processBlock: function (words, offset) {
    					            this._cipher.decryptBlock(words, offset);
    					        }
    					    });

    					    return ECB;
    					}());


    					return CryptoJS.mode.ECB;

    				})); 
    			} (modeEcb, modeEcb.exports));
    			return modeEcb.exports;
    		}

    		var padAnsix923 = {exports: {}};

    		padAnsix923.exports;

    		var hasRequiredPadAnsix923;

    		function requirePadAnsix923 () {
    			if (hasRequiredPadAnsix923) return padAnsix923.exports;
    			hasRequiredPadAnsix923 = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireCipherCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					/**
    					 * ANSI X.923 padding strategy.
    					 */
    					CryptoJS.pad.AnsiX923 = {
    					    pad: function (data, blockSize) {
    					        // Shortcuts
    					        var dataSigBytes = data.sigBytes;
    					        var blockSizeBytes = blockSize * 4;

    					        // Count padding bytes
    					        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

    					        // Compute last byte position
    					        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

    					        // Pad
    					        data.clamp();
    					        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
    					        data.sigBytes += nPaddingBytes;
    					    },

    					    unpad: function (data) {
    					        // Get number of padding bytes from last byte
    					        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

    					        // Remove padding
    					        data.sigBytes -= nPaddingBytes;
    					    }
    					};


    					return CryptoJS.pad.Ansix923;

    				})); 
    			} (padAnsix923, padAnsix923.exports));
    			return padAnsix923.exports;
    		}

    		var padIso10126 = {exports: {}};

    		padIso10126.exports;

    		var hasRequiredPadIso10126;

    		function requirePadIso10126 () {
    			if (hasRequiredPadIso10126) return padIso10126.exports;
    			hasRequiredPadIso10126 = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireCipherCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					/**
    					 * ISO 10126 padding strategy.
    					 */
    					CryptoJS.pad.Iso10126 = {
    					    pad: function (data, blockSize) {
    					        // Shortcut
    					        var blockSizeBytes = blockSize * 4;

    					        // Count padding bytes
    					        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

    					        // Pad
    					        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
    					             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
    					    },

    					    unpad: function (data) {
    					        // Get number of padding bytes from last byte
    					        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

    					        // Remove padding
    					        data.sigBytes -= nPaddingBytes;
    					    }
    					};


    					return CryptoJS.pad.Iso10126;

    				})); 
    			} (padIso10126, padIso10126.exports));
    			return padIso10126.exports;
    		}

    		var padIso97971 = {exports: {}};

    		padIso97971.exports;

    		var hasRequiredPadIso97971;

    		function requirePadIso97971 () {
    			if (hasRequiredPadIso97971) return padIso97971.exports;
    			hasRequiredPadIso97971 = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireCipherCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					/**
    					 * ISO/IEC 9797-1 Padding Method 2.
    					 */
    					CryptoJS.pad.Iso97971 = {
    					    pad: function (data, blockSize) {
    					        // Add 0x80 byte
    					        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

    					        // Zero pad the rest
    					        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
    					    },

    					    unpad: function (data) {
    					        // Remove zero padding
    					        CryptoJS.pad.ZeroPadding.unpad(data);

    					        // Remove one more byte -- the 0x80 byte
    					        data.sigBytes--;
    					    }
    					};


    					return CryptoJS.pad.Iso97971;

    				})); 
    			} (padIso97971, padIso97971.exports));
    			return padIso97971.exports;
    		}

    		var padZeropadding = {exports: {}};

    		padZeropadding.exports;

    		var hasRequiredPadZeropadding;

    		function requirePadZeropadding () {
    			if (hasRequiredPadZeropadding) return padZeropadding.exports;
    			hasRequiredPadZeropadding = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireCipherCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					/**
    					 * Zero padding strategy.
    					 */
    					CryptoJS.pad.ZeroPadding = {
    					    pad: function (data, blockSize) {
    					        // Shortcut
    					        var blockSizeBytes = blockSize * 4;

    					        // Pad
    					        data.clamp();
    					        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
    					    },

    					    unpad: function (data) {
    					        // Shortcut
    					        var dataWords = data.words;

    					        // Unpad
    					        var i = data.sigBytes - 1;
    					        for (var i = data.sigBytes - 1; i >= 0; i--) {
    					            if (((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
    					                data.sigBytes = i + 1;
    					                break;
    					            }
    					        }
    					    }
    					};


    					return CryptoJS.pad.ZeroPadding;

    				})); 
    			} (padZeropadding, padZeropadding.exports));
    			return padZeropadding.exports;
    		}

    		var padNopadding = {exports: {}};

    		padNopadding.exports;

    		var hasRequiredPadNopadding;

    		function requirePadNopadding () {
    			if (hasRequiredPadNopadding) return padNopadding.exports;
    			hasRequiredPadNopadding = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireCipherCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					/**
    					 * A noop padding strategy.
    					 */
    					CryptoJS.pad.NoPadding = {
    					    pad: function () {
    					    },

    					    unpad: function () {
    					    }
    					};


    					return CryptoJS.pad.NoPadding;

    				})); 
    			} (padNopadding, padNopadding.exports));
    			return padNopadding.exports;
    		}

    		var formatHex = {exports: {}};

    		formatHex.exports;

    		var hasRequiredFormatHex;

    		function requireFormatHex () {
    			if (hasRequiredFormatHex) return formatHex.exports;
    			hasRequiredFormatHex = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireCipherCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function (undefined$1) {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var CipherParams = C_lib.CipherParams;
    					    var C_enc = C.enc;
    					    var Hex = C_enc.Hex;
    					    var C_format = C.format;

    					    C_format.Hex = {
    					        /**
    					         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
    					         *
    					         * @param {CipherParams} cipherParams The cipher params object.
    					         *
    					         * @return {string} The hexadecimally encoded string.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
    					         */
    					        stringify: function (cipherParams) {
    					            return cipherParams.ciphertext.toString(Hex);
    					        },

    					        /**
    					         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
    					         *
    					         * @param {string} input The hexadecimally encoded string.
    					         *
    					         * @return {CipherParams} The cipher params object.
    					         *
    					         * @static
    					         *
    					         * @example
    					         *
    					         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
    					         */
    					        parse: function (input) {
    					            var ciphertext = Hex.parse(input);
    					            return CipherParams.create({ ciphertext: ciphertext });
    					        }
    					    };
    					}());


    					return CryptoJS.format.Hex;

    				})); 
    			} (formatHex, formatHex.exports));
    			return formatHex.exports;
    		}

    		var aes$1 = {exports: {}};

    		aes$1.exports;

    		var hasRequiredAes;

    		function requireAes () {
    			if (hasRequiredAes) return aes$1.exports;
    			hasRequiredAes = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireEncBase64(), requireMd5(), requireEvpkdf(), requireCipherCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function () {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var BlockCipher = C_lib.BlockCipher;
    					    var C_algo = C.algo;

    					    // Lookup tables
    					    var SBOX = [];
    					    var INV_SBOX = [];
    					    var SUB_MIX_0 = [];
    					    var SUB_MIX_1 = [];
    					    var SUB_MIX_2 = [];
    					    var SUB_MIX_3 = [];
    					    var INV_SUB_MIX_0 = [];
    					    var INV_SUB_MIX_1 = [];
    					    var INV_SUB_MIX_2 = [];
    					    var INV_SUB_MIX_3 = [];

    					    // Compute lookup tables
    					    (function () {
    					        // Compute double table
    					        var d = [];
    					        for (var i = 0; i < 256; i++) {
    					            if (i < 128) {
    					                d[i] = i << 1;
    					            } else {
    					                d[i] = (i << 1) ^ 0x11b;
    					            }
    					        }

    					        // Walk GF(2^8)
    					        var x = 0;
    					        var xi = 0;
    					        for (var i = 0; i < 256; i++) {
    					            // Compute sbox
    					            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
    					            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
    					            SBOX[x] = sx;
    					            INV_SBOX[sx] = x;

    					            // Compute multiplication
    					            var x2 = d[x];
    					            var x4 = d[x2];
    					            var x8 = d[x4];

    					            // Compute sub bytes, mix columns tables
    					            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
    					            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
    					            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
    					            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
    					            SUB_MIX_3[x] = t;

    					            // Compute inv sub bytes, inv mix columns tables
    					            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
    					            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
    					            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
    					            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
    					            INV_SUB_MIX_3[sx] = t;

    					            // Compute next counter
    					            if (!x) {
    					                x = xi = 1;
    					            } else {
    					                x = x2 ^ d[d[d[x8 ^ x2]]];
    					                xi ^= d[d[xi]];
    					            }
    					        }
    					    }());

    					    // Precomputed Rcon lookup
    					    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

    					    /**
    					     * AES block cipher algorithm.
    					     */
    					    var AES = C_algo.AES = BlockCipher.extend({
    					        _doReset: function () {
    					            var t;

    					            // Skip reset of nRounds has been set before and key did not change
    					            if (this._nRounds && this._keyPriorReset === this._key) {
    					                return;
    					            }

    					            // Shortcuts
    					            var key = this._keyPriorReset = this._key;
    					            var keyWords = key.words;
    					            var keySize = key.sigBytes / 4;

    					            // Compute number of rounds
    					            var nRounds = this._nRounds = keySize + 6;

    					            // Compute number of key schedule rows
    					            var ksRows = (nRounds + 1) * 4;

    					            // Compute key schedule
    					            var keySchedule = this._keySchedule = [];
    					            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
    					                if (ksRow < keySize) {
    					                    keySchedule[ksRow] = keyWords[ksRow];
    					                } else {
    					                    t = keySchedule[ksRow - 1];

    					                    if (!(ksRow % keySize)) {
    					                        // Rot word
    					                        t = (t << 8) | (t >>> 24);

    					                        // Sub word
    					                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

    					                        // Mix Rcon
    					                        t ^= RCON[(ksRow / keySize) | 0] << 24;
    					                    } else if (keySize > 6 && ksRow % keySize == 4) {
    					                        // Sub word
    					                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
    					                    }

    					                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
    					                }
    					            }

    					            // Compute inv key schedule
    					            var invKeySchedule = this._invKeySchedule = [];
    					            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
    					                var ksRow = ksRows - invKsRow;

    					                if (invKsRow % 4) {
    					                    var t = keySchedule[ksRow];
    					                } else {
    					                    var t = keySchedule[ksRow - 4];
    					                }

    					                if (invKsRow < 4 || ksRow <= 4) {
    					                    invKeySchedule[invKsRow] = t;
    					                } else {
    					                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
    					                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
    					                }
    					            }
    					        },

    					        encryptBlock: function (M, offset) {
    					            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
    					        },

    					        decryptBlock: function (M, offset) {
    					            // Swap 2nd and 4th rows
    					            var t = M[offset + 1];
    					            M[offset + 1] = M[offset + 3];
    					            M[offset + 3] = t;

    					            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

    					            // Inv swap 2nd and 4th rows
    					            var t = M[offset + 1];
    					            M[offset + 1] = M[offset + 3];
    					            M[offset + 3] = t;
    					        },

    					        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
    					            // Shortcut
    					            var nRounds = this._nRounds;

    					            // Get input, add round key
    					            var s0 = M[offset]     ^ keySchedule[0];
    					            var s1 = M[offset + 1] ^ keySchedule[1];
    					            var s2 = M[offset + 2] ^ keySchedule[2];
    					            var s3 = M[offset + 3] ^ keySchedule[3];

    					            // Key schedule row counter
    					            var ksRow = 4;

    					            // Rounds
    					            for (var round = 1; round < nRounds; round++) {
    					                // Shift rows, sub bytes, mix columns, add round key
    					                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
    					                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
    					                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
    					                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

    					                // Update state
    					                s0 = t0;
    					                s1 = t1;
    					                s2 = t2;
    					                s3 = t3;
    					            }

    					            // Shift rows, sub bytes, add round key
    					            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    					            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    					            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    					            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

    					            // Set output
    					            M[offset]     = t0;
    					            M[offset + 1] = t1;
    					            M[offset + 2] = t2;
    					            M[offset + 3] = t3;
    					        },

    					        keySize: 256/32
    					    });

    					    /**
    					     * Shortcut functions to the cipher's object interface.
    					     *
    					     * @example
    					     *
    					     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
    					     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
    					     */
    					    C.AES = BlockCipher._createHelper(AES);
    					}());


    					return CryptoJS.AES;

    				})); 
    			} (aes$1, aes$1.exports));
    			return aes$1.exports;
    		}

    		var tripledes = {exports: {}};

    		tripledes.exports;

    		var hasRequiredTripledes;

    		function requireTripledes () {
    			if (hasRequiredTripledes) return tripledes.exports;
    			hasRequiredTripledes = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireEncBase64(), requireMd5(), requireEvpkdf(), requireCipherCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function () {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var WordArray = C_lib.WordArray;
    					    var BlockCipher = C_lib.BlockCipher;
    					    var C_algo = C.algo;

    					    // Permuted Choice 1 constants
    					    var PC1 = [
    					        57, 49, 41, 33, 25, 17, 9,  1,
    					        58, 50, 42, 34, 26, 18, 10, 2,
    					        59, 51, 43, 35, 27, 19, 11, 3,
    					        60, 52, 44, 36, 63, 55, 47, 39,
    					        31, 23, 15, 7,  62, 54, 46, 38,
    					        30, 22, 14, 6,  61, 53, 45, 37,
    					        29, 21, 13, 5,  28, 20, 12, 4
    					    ];

    					    // Permuted Choice 2 constants
    					    var PC2 = [
    					        14, 17, 11, 24, 1,  5,
    					        3,  28, 15, 6,  21, 10,
    					        23, 19, 12, 4,  26, 8,
    					        16, 7,  27, 20, 13, 2,
    					        41, 52, 31, 37, 47, 55,
    					        30, 40, 51, 45, 33, 48,
    					        44, 49, 39, 56, 34, 53,
    					        46, 42, 50, 36, 29, 32
    					    ];

    					    // Cumulative bit shift constants
    					    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

    					    // SBOXes and round permutation constants
    					    var SBOX_P = [
    					        {
    					            0x0: 0x808200,
    					            0x10000000: 0x8000,
    					            0x20000000: 0x808002,
    					            0x30000000: 0x2,
    					            0x40000000: 0x200,
    					            0x50000000: 0x808202,
    					            0x60000000: 0x800202,
    					            0x70000000: 0x800000,
    					            0x80000000: 0x202,
    					            0x90000000: 0x800200,
    					            0xa0000000: 0x8200,
    					            0xb0000000: 0x808000,
    					            0xc0000000: 0x8002,
    					            0xd0000000: 0x800002,
    					            0xe0000000: 0x0,
    					            0xf0000000: 0x8202,
    					            0x8000000: 0x0,
    					            0x18000000: 0x808202,
    					            0x28000000: 0x8202,
    					            0x38000000: 0x8000,
    					            0x48000000: 0x808200,
    					            0x58000000: 0x200,
    					            0x68000000: 0x808002,
    					            0x78000000: 0x2,
    					            0x88000000: 0x800200,
    					            0x98000000: 0x8200,
    					            0xa8000000: 0x808000,
    					            0xb8000000: 0x800202,
    					            0xc8000000: 0x800002,
    					            0xd8000000: 0x8002,
    					            0xe8000000: 0x202,
    					            0xf8000000: 0x800000,
    					            0x1: 0x8000,
    					            0x10000001: 0x2,
    					            0x20000001: 0x808200,
    					            0x30000001: 0x800000,
    					            0x40000001: 0x808002,
    					            0x50000001: 0x8200,
    					            0x60000001: 0x200,
    					            0x70000001: 0x800202,
    					            0x80000001: 0x808202,
    					            0x90000001: 0x808000,
    					            0xa0000001: 0x800002,
    					            0xb0000001: 0x8202,
    					            0xc0000001: 0x202,
    					            0xd0000001: 0x800200,
    					            0xe0000001: 0x8002,
    					            0xf0000001: 0x0,
    					            0x8000001: 0x808202,
    					            0x18000001: 0x808000,
    					            0x28000001: 0x800000,
    					            0x38000001: 0x200,
    					            0x48000001: 0x8000,
    					            0x58000001: 0x800002,
    					            0x68000001: 0x2,
    					            0x78000001: 0x8202,
    					            0x88000001: 0x8002,
    					            0x98000001: 0x800202,
    					            0xa8000001: 0x202,
    					            0xb8000001: 0x808200,
    					            0xc8000001: 0x800200,
    					            0xd8000001: 0x0,
    					            0xe8000001: 0x8200,
    					            0xf8000001: 0x808002
    					        },
    					        {
    					            0x0: 0x40084010,
    					            0x1000000: 0x4000,
    					            0x2000000: 0x80000,
    					            0x3000000: 0x40080010,
    					            0x4000000: 0x40000010,
    					            0x5000000: 0x40084000,
    					            0x6000000: 0x40004000,
    					            0x7000000: 0x10,
    					            0x8000000: 0x84000,
    					            0x9000000: 0x40004010,
    					            0xa000000: 0x40000000,
    					            0xb000000: 0x84010,
    					            0xc000000: 0x80010,
    					            0xd000000: 0x0,
    					            0xe000000: 0x4010,
    					            0xf000000: 0x40080000,
    					            0x800000: 0x40004000,
    					            0x1800000: 0x84010,
    					            0x2800000: 0x10,
    					            0x3800000: 0x40004010,
    					            0x4800000: 0x40084010,
    					            0x5800000: 0x40000000,
    					            0x6800000: 0x80000,
    					            0x7800000: 0x40080010,
    					            0x8800000: 0x80010,
    					            0x9800000: 0x0,
    					            0xa800000: 0x4000,
    					            0xb800000: 0x40080000,
    					            0xc800000: 0x40000010,
    					            0xd800000: 0x84000,
    					            0xe800000: 0x40084000,
    					            0xf800000: 0x4010,
    					            0x10000000: 0x0,
    					            0x11000000: 0x40080010,
    					            0x12000000: 0x40004010,
    					            0x13000000: 0x40084000,
    					            0x14000000: 0x40080000,
    					            0x15000000: 0x10,
    					            0x16000000: 0x84010,
    					            0x17000000: 0x4000,
    					            0x18000000: 0x4010,
    					            0x19000000: 0x80000,
    					            0x1a000000: 0x80010,
    					            0x1b000000: 0x40000010,
    					            0x1c000000: 0x84000,
    					            0x1d000000: 0x40004000,
    					            0x1e000000: 0x40000000,
    					            0x1f000000: 0x40084010,
    					            0x10800000: 0x84010,
    					            0x11800000: 0x80000,
    					            0x12800000: 0x40080000,
    					            0x13800000: 0x4000,
    					            0x14800000: 0x40004000,
    					            0x15800000: 0x40084010,
    					            0x16800000: 0x10,
    					            0x17800000: 0x40000000,
    					            0x18800000: 0x40084000,
    					            0x19800000: 0x40000010,
    					            0x1a800000: 0x40004010,
    					            0x1b800000: 0x80010,
    					            0x1c800000: 0x0,
    					            0x1d800000: 0x4010,
    					            0x1e800000: 0x40080010,
    					            0x1f800000: 0x84000
    					        },
    					        {
    					            0x0: 0x104,
    					            0x100000: 0x0,
    					            0x200000: 0x4000100,
    					            0x300000: 0x10104,
    					            0x400000: 0x10004,
    					            0x500000: 0x4000004,
    					            0x600000: 0x4010104,
    					            0x700000: 0x4010000,
    					            0x800000: 0x4000000,
    					            0x900000: 0x4010100,
    					            0xa00000: 0x10100,
    					            0xb00000: 0x4010004,
    					            0xc00000: 0x4000104,
    					            0xd00000: 0x10000,
    					            0xe00000: 0x4,
    					            0xf00000: 0x100,
    					            0x80000: 0x4010100,
    					            0x180000: 0x4010004,
    					            0x280000: 0x0,
    					            0x380000: 0x4000100,
    					            0x480000: 0x4000004,
    					            0x580000: 0x10000,
    					            0x680000: 0x10004,
    					            0x780000: 0x104,
    					            0x880000: 0x4,
    					            0x980000: 0x100,
    					            0xa80000: 0x4010000,
    					            0xb80000: 0x10104,
    					            0xc80000: 0x10100,
    					            0xd80000: 0x4000104,
    					            0xe80000: 0x4010104,
    					            0xf80000: 0x4000000,
    					            0x1000000: 0x4010100,
    					            0x1100000: 0x10004,
    					            0x1200000: 0x10000,
    					            0x1300000: 0x4000100,
    					            0x1400000: 0x100,
    					            0x1500000: 0x4010104,
    					            0x1600000: 0x4000004,
    					            0x1700000: 0x0,
    					            0x1800000: 0x4000104,
    					            0x1900000: 0x4000000,
    					            0x1a00000: 0x4,
    					            0x1b00000: 0x10100,
    					            0x1c00000: 0x4010000,
    					            0x1d00000: 0x104,
    					            0x1e00000: 0x10104,
    					            0x1f00000: 0x4010004,
    					            0x1080000: 0x4000000,
    					            0x1180000: 0x104,
    					            0x1280000: 0x4010100,
    					            0x1380000: 0x0,
    					            0x1480000: 0x10004,
    					            0x1580000: 0x4000100,
    					            0x1680000: 0x100,
    					            0x1780000: 0x4010004,
    					            0x1880000: 0x10000,
    					            0x1980000: 0x4010104,
    					            0x1a80000: 0x10104,
    					            0x1b80000: 0x4000004,
    					            0x1c80000: 0x4000104,
    					            0x1d80000: 0x4010000,
    					            0x1e80000: 0x4,
    					            0x1f80000: 0x10100
    					        },
    					        {
    					            0x0: 0x80401000,
    					            0x10000: 0x80001040,
    					            0x20000: 0x401040,
    					            0x30000: 0x80400000,
    					            0x40000: 0x0,
    					            0x50000: 0x401000,
    					            0x60000: 0x80000040,
    					            0x70000: 0x400040,
    					            0x80000: 0x80000000,
    					            0x90000: 0x400000,
    					            0xa0000: 0x40,
    					            0xb0000: 0x80001000,
    					            0xc0000: 0x80400040,
    					            0xd0000: 0x1040,
    					            0xe0000: 0x1000,
    					            0xf0000: 0x80401040,
    					            0x8000: 0x80001040,
    					            0x18000: 0x40,
    					            0x28000: 0x80400040,
    					            0x38000: 0x80001000,
    					            0x48000: 0x401000,
    					            0x58000: 0x80401040,
    					            0x68000: 0x0,
    					            0x78000: 0x80400000,
    					            0x88000: 0x1000,
    					            0x98000: 0x80401000,
    					            0xa8000: 0x400000,
    					            0xb8000: 0x1040,
    					            0xc8000: 0x80000000,
    					            0xd8000: 0x400040,
    					            0xe8000: 0x401040,
    					            0xf8000: 0x80000040,
    					            0x100000: 0x400040,
    					            0x110000: 0x401000,
    					            0x120000: 0x80000040,
    					            0x130000: 0x0,
    					            0x140000: 0x1040,
    					            0x150000: 0x80400040,
    					            0x160000: 0x80401000,
    					            0x170000: 0x80001040,
    					            0x180000: 0x80401040,
    					            0x190000: 0x80000000,
    					            0x1a0000: 0x80400000,
    					            0x1b0000: 0x401040,
    					            0x1c0000: 0x80001000,
    					            0x1d0000: 0x400000,
    					            0x1e0000: 0x40,
    					            0x1f0000: 0x1000,
    					            0x108000: 0x80400000,
    					            0x118000: 0x80401040,
    					            0x128000: 0x0,
    					            0x138000: 0x401000,
    					            0x148000: 0x400040,
    					            0x158000: 0x80000000,
    					            0x168000: 0x80001040,
    					            0x178000: 0x40,
    					            0x188000: 0x80000040,
    					            0x198000: 0x1000,
    					            0x1a8000: 0x80001000,
    					            0x1b8000: 0x80400040,
    					            0x1c8000: 0x1040,
    					            0x1d8000: 0x80401000,
    					            0x1e8000: 0x400000,
    					            0x1f8000: 0x401040
    					        },
    					        {
    					            0x0: 0x80,
    					            0x1000: 0x1040000,
    					            0x2000: 0x40000,
    					            0x3000: 0x20000000,
    					            0x4000: 0x20040080,
    					            0x5000: 0x1000080,
    					            0x6000: 0x21000080,
    					            0x7000: 0x40080,
    					            0x8000: 0x1000000,
    					            0x9000: 0x20040000,
    					            0xa000: 0x20000080,
    					            0xb000: 0x21040080,
    					            0xc000: 0x21040000,
    					            0xd000: 0x0,
    					            0xe000: 0x1040080,
    					            0xf000: 0x21000000,
    					            0x800: 0x1040080,
    					            0x1800: 0x21000080,
    					            0x2800: 0x80,
    					            0x3800: 0x1040000,
    					            0x4800: 0x40000,
    					            0x5800: 0x20040080,
    					            0x6800: 0x21040000,
    					            0x7800: 0x20000000,
    					            0x8800: 0x20040000,
    					            0x9800: 0x0,
    					            0xa800: 0x21040080,
    					            0xb800: 0x1000080,
    					            0xc800: 0x20000080,
    					            0xd800: 0x21000000,
    					            0xe800: 0x1000000,
    					            0xf800: 0x40080,
    					            0x10000: 0x40000,
    					            0x11000: 0x80,
    					            0x12000: 0x20000000,
    					            0x13000: 0x21000080,
    					            0x14000: 0x1000080,
    					            0x15000: 0x21040000,
    					            0x16000: 0x20040080,
    					            0x17000: 0x1000000,
    					            0x18000: 0x21040080,
    					            0x19000: 0x21000000,
    					            0x1a000: 0x1040000,
    					            0x1b000: 0x20040000,
    					            0x1c000: 0x40080,
    					            0x1d000: 0x20000080,
    					            0x1e000: 0x0,
    					            0x1f000: 0x1040080,
    					            0x10800: 0x21000080,
    					            0x11800: 0x1000000,
    					            0x12800: 0x1040000,
    					            0x13800: 0x20040080,
    					            0x14800: 0x20000000,
    					            0x15800: 0x1040080,
    					            0x16800: 0x80,
    					            0x17800: 0x21040000,
    					            0x18800: 0x40080,
    					            0x19800: 0x21040080,
    					            0x1a800: 0x0,
    					            0x1b800: 0x21000000,
    					            0x1c800: 0x1000080,
    					            0x1d800: 0x40000,
    					            0x1e800: 0x20040000,
    					            0x1f800: 0x20000080
    					        },
    					        {
    					            0x0: 0x10000008,
    					            0x100: 0x2000,
    					            0x200: 0x10200000,
    					            0x300: 0x10202008,
    					            0x400: 0x10002000,
    					            0x500: 0x200000,
    					            0x600: 0x200008,
    					            0x700: 0x10000000,
    					            0x800: 0x0,
    					            0x900: 0x10002008,
    					            0xa00: 0x202000,
    					            0xb00: 0x8,
    					            0xc00: 0x10200008,
    					            0xd00: 0x202008,
    					            0xe00: 0x2008,
    					            0xf00: 0x10202000,
    					            0x80: 0x10200000,
    					            0x180: 0x10202008,
    					            0x280: 0x8,
    					            0x380: 0x200000,
    					            0x480: 0x202008,
    					            0x580: 0x10000008,
    					            0x680: 0x10002000,
    					            0x780: 0x2008,
    					            0x880: 0x200008,
    					            0x980: 0x2000,
    					            0xa80: 0x10002008,
    					            0xb80: 0x10200008,
    					            0xc80: 0x0,
    					            0xd80: 0x10202000,
    					            0xe80: 0x202000,
    					            0xf80: 0x10000000,
    					            0x1000: 0x10002000,
    					            0x1100: 0x10200008,
    					            0x1200: 0x10202008,
    					            0x1300: 0x2008,
    					            0x1400: 0x200000,
    					            0x1500: 0x10000000,
    					            0x1600: 0x10000008,
    					            0x1700: 0x202000,
    					            0x1800: 0x202008,
    					            0x1900: 0x0,
    					            0x1a00: 0x8,
    					            0x1b00: 0x10200000,
    					            0x1c00: 0x2000,
    					            0x1d00: 0x10002008,
    					            0x1e00: 0x10202000,
    					            0x1f00: 0x200008,
    					            0x1080: 0x8,
    					            0x1180: 0x202000,
    					            0x1280: 0x200000,
    					            0x1380: 0x10000008,
    					            0x1480: 0x10002000,
    					            0x1580: 0x2008,
    					            0x1680: 0x10202008,
    					            0x1780: 0x10200000,
    					            0x1880: 0x10202000,
    					            0x1980: 0x10200008,
    					            0x1a80: 0x2000,
    					            0x1b80: 0x202008,
    					            0x1c80: 0x200008,
    					            0x1d80: 0x0,
    					            0x1e80: 0x10000000,
    					            0x1f80: 0x10002008
    					        },
    					        {
    					            0x0: 0x100000,
    					            0x10: 0x2000401,
    					            0x20: 0x400,
    					            0x30: 0x100401,
    					            0x40: 0x2100401,
    					            0x50: 0x0,
    					            0x60: 0x1,
    					            0x70: 0x2100001,
    					            0x80: 0x2000400,
    					            0x90: 0x100001,
    					            0xa0: 0x2000001,
    					            0xb0: 0x2100400,
    					            0xc0: 0x2100000,
    					            0xd0: 0x401,
    					            0xe0: 0x100400,
    					            0xf0: 0x2000000,
    					            0x8: 0x2100001,
    					            0x18: 0x0,
    					            0x28: 0x2000401,
    					            0x38: 0x2100400,
    					            0x48: 0x100000,
    					            0x58: 0x2000001,
    					            0x68: 0x2000000,
    					            0x78: 0x401,
    					            0x88: 0x100401,
    					            0x98: 0x2000400,
    					            0xa8: 0x2100000,
    					            0xb8: 0x100001,
    					            0xc8: 0x400,
    					            0xd8: 0x2100401,
    					            0xe8: 0x1,
    					            0xf8: 0x100400,
    					            0x100: 0x2000000,
    					            0x110: 0x100000,
    					            0x120: 0x2000401,
    					            0x130: 0x2100001,
    					            0x140: 0x100001,
    					            0x150: 0x2000400,
    					            0x160: 0x2100400,
    					            0x170: 0x100401,
    					            0x180: 0x401,
    					            0x190: 0x2100401,
    					            0x1a0: 0x100400,
    					            0x1b0: 0x1,
    					            0x1c0: 0x0,
    					            0x1d0: 0x2100000,
    					            0x1e0: 0x2000001,
    					            0x1f0: 0x400,
    					            0x108: 0x100400,
    					            0x118: 0x2000401,
    					            0x128: 0x2100001,
    					            0x138: 0x1,
    					            0x148: 0x2000000,
    					            0x158: 0x100000,
    					            0x168: 0x401,
    					            0x178: 0x2100400,
    					            0x188: 0x2000001,
    					            0x198: 0x2100000,
    					            0x1a8: 0x0,
    					            0x1b8: 0x2100401,
    					            0x1c8: 0x100401,
    					            0x1d8: 0x400,
    					            0x1e8: 0x2000400,
    					            0x1f8: 0x100001
    					        },
    					        {
    					            0x0: 0x8000820,
    					            0x1: 0x20000,
    					            0x2: 0x8000000,
    					            0x3: 0x20,
    					            0x4: 0x20020,
    					            0x5: 0x8020820,
    					            0x6: 0x8020800,
    					            0x7: 0x800,
    					            0x8: 0x8020000,
    					            0x9: 0x8000800,
    					            0xa: 0x20800,
    					            0xb: 0x8020020,
    					            0xc: 0x820,
    					            0xd: 0x0,
    					            0xe: 0x8000020,
    					            0xf: 0x20820,
    					            0x80000000: 0x800,
    					            0x80000001: 0x8020820,
    					            0x80000002: 0x8000820,
    					            0x80000003: 0x8000000,
    					            0x80000004: 0x8020000,
    					            0x80000005: 0x20800,
    					            0x80000006: 0x20820,
    					            0x80000007: 0x20,
    					            0x80000008: 0x8000020,
    					            0x80000009: 0x820,
    					            0x8000000a: 0x20020,
    					            0x8000000b: 0x8020800,
    					            0x8000000c: 0x0,
    					            0x8000000d: 0x8020020,
    					            0x8000000e: 0x8000800,
    					            0x8000000f: 0x20000,
    					            0x10: 0x20820,
    					            0x11: 0x8020800,
    					            0x12: 0x20,
    					            0x13: 0x800,
    					            0x14: 0x8000800,
    					            0x15: 0x8000020,
    					            0x16: 0x8020020,
    					            0x17: 0x20000,
    					            0x18: 0x0,
    					            0x19: 0x20020,
    					            0x1a: 0x8020000,
    					            0x1b: 0x8000820,
    					            0x1c: 0x8020820,
    					            0x1d: 0x20800,
    					            0x1e: 0x820,
    					            0x1f: 0x8000000,
    					            0x80000010: 0x20000,
    					            0x80000011: 0x800,
    					            0x80000012: 0x8020020,
    					            0x80000013: 0x20820,
    					            0x80000014: 0x20,
    					            0x80000015: 0x8020000,
    					            0x80000016: 0x8000000,
    					            0x80000017: 0x8000820,
    					            0x80000018: 0x8020820,
    					            0x80000019: 0x8000020,
    					            0x8000001a: 0x8000800,
    					            0x8000001b: 0x0,
    					            0x8000001c: 0x20800,
    					            0x8000001d: 0x820,
    					            0x8000001e: 0x20020,
    					            0x8000001f: 0x8020800
    					        }
    					    ];

    					    // Masks that select the SBOX input
    					    var SBOX_MASK = [
    					        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
    					        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
    					    ];

    					    /**
    					     * DES block cipher algorithm.
    					     */
    					    var DES = C_algo.DES = BlockCipher.extend({
    					        _doReset: function () {
    					            // Shortcuts
    					            var key = this._key;
    					            var keyWords = key.words;

    					            // Select 56 bits according to PC1
    					            var keyBits = [];
    					            for (var i = 0; i < 56; i++) {
    					                var keyBitPos = PC1[i] - 1;
    					                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
    					            }

    					            // Assemble 16 subkeys
    					            var subKeys = this._subKeys = [];
    					            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
    					                // Create subkey
    					                var subKey = subKeys[nSubKey] = [];

    					                // Shortcut
    					                var bitShift = BIT_SHIFTS[nSubKey];

    					                // Select 48 bits according to PC2
    					                for (var i = 0; i < 24; i++) {
    					                    // Select from the left 28 key bits
    					                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

    					                    // Select from the right 28 key bits
    					                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
    					                }

    					                // Since each subkey is applied to an expanded 32-bit input,
    					                // the subkey can be broken into 8 values scaled to 32-bits,
    					                // which allows the key to be used without expansion
    					                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
    					                for (var i = 1; i < 7; i++) {
    					                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
    					                }
    					                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
    					            }

    					            // Compute inverse subkeys
    					            var invSubKeys = this._invSubKeys = [];
    					            for (var i = 0; i < 16; i++) {
    					                invSubKeys[i] = subKeys[15 - i];
    					            }
    					        },

    					        encryptBlock: function (M, offset) {
    					            this._doCryptBlock(M, offset, this._subKeys);
    					        },

    					        decryptBlock: function (M, offset) {
    					            this._doCryptBlock(M, offset, this._invSubKeys);
    					        },

    					        _doCryptBlock: function (M, offset, subKeys) {
    					            // Get input
    					            this._lBlock = M[offset];
    					            this._rBlock = M[offset + 1];

    					            // Initial permutation
    					            exchangeLR.call(this, 4,  0x0f0f0f0f);
    					            exchangeLR.call(this, 16, 0x0000ffff);
    					            exchangeRL.call(this, 2,  0x33333333);
    					            exchangeRL.call(this, 8,  0x00ff00ff);
    					            exchangeLR.call(this, 1,  0x55555555);

    					            // Rounds
    					            for (var round = 0; round < 16; round++) {
    					                // Shortcuts
    					                var subKey = subKeys[round];
    					                var lBlock = this._lBlock;
    					                var rBlock = this._rBlock;

    					                // Feistel function
    					                var f = 0;
    					                for (var i = 0; i < 8; i++) {
    					                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
    					                }
    					                this._lBlock = rBlock;
    					                this._rBlock = lBlock ^ f;
    					            }

    					            // Undo swap from last round
    					            var t = this._lBlock;
    					            this._lBlock = this._rBlock;
    					            this._rBlock = t;

    					            // Final permutation
    					            exchangeLR.call(this, 1,  0x55555555);
    					            exchangeRL.call(this, 8,  0x00ff00ff);
    					            exchangeRL.call(this, 2,  0x33333333);
    					            exchangeLR.call(this, 16, 0x0000ffff);
    					            exchangeLR.call(this, 4,  0x0f0f0f0f);

    					            // Set output
    					            M[offset] = this._lBlock;
    					            M[offset + 1] = this._rBlock;
    					        },

    					        keySize: 64/32,

    					        ivSize: 64/32,

    					        blockSize: 64/32
    					    });

    					    // Swap bits across the left and right words
    					    function exchangeLR(offset, mask) {
    					        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
    					        this._rBlock ^= t;
    					        this._lBlock ^= t << offset;
    					    }

    					    function exchangeRL(offset, mask) {
    					        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
    					        this._lBlock ^= t;
    					        this._rBlock ^= t << offset;
    					    }

    					    /**
    					     * Shortcut functions to the cipher's object interface.
    					     *
    					     * @example
    					     *
    					     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
    					     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
    					     */
    					    C.DES = BlockCipher._createHelper(DES);

    					    /**
    					     * Triple-DES block cipher algorithm.
    					     */
    					    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
    					        _doReset: function () {
    					            // Shortcuts
    					            var key = this._key;
    					            var keyWords = key.words;
    					            // Make sure the key length is valid (64, 128 or >= 192 bit)
    					            if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) {
    					                throw new Error('Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.');
    					            }

    					            // Extend the key according to the keying options defined in 3DES standard
    					            var key1 = keyWords.slice(0, 2);
    					            var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
    					            var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);

    					            // Create DES instances
    					            this._des1 = DES.createEncryptor(WordArray.create(key1));
    					            this._des2 = DES.createEncryptor(WordArray.create(key2));
    					            this._des3 = DES.createEncryptor(WordArray.create(key3));
    					        },

    					        encryptBlock: function (M, offset) {
    					            this._des1.encryptBlock(M, offset);
    					            this._des2.decryptBlock(M, offset);
    					            this._des3.encryptBlock(M, offset);
    					        },

    					        decryptBlock: function (M, offset) {
    					            this._des3.decryptBlock(M, offset);
    					            this._des2.encryptBlock(M, offset);
    					            this._des1.decryptBlock(M, offset);
    					        },

    					        keySize: 192/32,

    					        ivSize: 64/32,

    					        blockSize: 64/32
    					    });

    					    /**
    					     * Shortcut functions to the cipher's object interface.
    					     *
    					     * @example
    					     *
    					     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
    					     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
    					     */
    					    C.TripleDES = BlockCipher._createHelper(TripleDES);
    					}());


    					return CryptoJS.TripleDES;

    				})); 
    			} (tripledes, tripledes.exports));
    			return tripledes.exports;
    		}

    		var rc4 = {exports: {}};

    		rc4.exports;

    		var hasRequiredRc4;

    		function requireRc4 () {
    			if (hasRequiredRc4) return rc4.exports;
    			hasRequiredRc4 = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireEncBase64(), requireMd5(), requireEvpkdf(), requireCipherCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function () {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var StreamCipher = C_lib.StreamCipher;
    					    var C_algo = C.algo;

    					    /**
    					     * RC4 stream cipher algorithm.
    					     */
    					    var RC4 = C_algo.RC4 = StreamCipher.extend({
    					        _doReset: function () {
    					            // Shortcuts
    					            var key = this._key;
    					            var keyWords = key.words;
    					            var keySigBytes = key.sigBytes;

    					            // Init sbox
    					            var S = this._S = [];
    					            for (var i = 0; i < 256; i++) {
    					                S[i] = i;
    					            }

    					            // Key setup
    					            for (var i = 0, j = 0; i < 256; i++) {
    					                var keyByteIndex = i % keySigBytes;
    					                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

    					                j = (j + S[i] + keyByte) % 256;

    					                // Swap
    					                var t = S[i];
    					                S[i] = S[j];
    					                S[j] = t;
    					            }

    					            // Counters
    					            this._i = this._j = 0;
    					        },

    					        _doProcessBlock: function (M, offset) {
    					            M[offset] ^= generateKeystreamWord.call(this);
    					        },

    					        keySize: 256/32,

    					        ivSize: 0
    					    });

    					    function generateKeystreamWord() {
    					        // Shortcuts
    					        var S = this._S;
    					        var i = this._i;
    					        var j = this._j;

    					        // Generate keystream word
    					        var keystreamWord = 0;
    					        for (var n = 0; n < 4; n++) {
    					            i = (i + 1) % 256;
    					            j = (j + S[i]) % 256;

    					            // Swap
    					            var t = S[i];
    					            S[i] = S[j];
    					            S[j] = t;

    					            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
    					        }

    					        // Update counters
    					        this._i = i;
    					        this._j = j;

    					        return keystreamWord;
    					    }

    					    /**
    					     * Shortcut functions to the cipher's object interface.
    					     *
    					     * @example
    					     *
    					     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
    					     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
    					     */
    					    C.RC4 = StreamCipher._createHelper(RC4);

    					    /**
    					     * Modified RC4 stream cipher algorithm.
    					     */
    					    var RC4Drop = C_algo.RC4Drop = RC4.extend({
    					        /**
    					         * Configuration options.
    					         *
    					         * @property {number} drop The number of keystream words to drop. Default 192
    					         */
    					        cfg: RC4.cfg.extend({
    					            drop: 192
    					        }),

    					        _doReset: function () {
    					            RC4._doReset.call(this);

    					            // Drop
    					            for (var i = this.cfg.drop; i > 0; i--) {
    					                generateKeystreamWord.call(this);
    					            }
    					        }
    					    });

    					    /**
    					     * Shortcut functions to the cipher's object interface.
    					     *
    					     * @example
    					     *
    					     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
    					     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
    					     */
    					    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
    					}());


    					return CryptoJS.RC4;

    				})); 
    			} (rc4, rc4.exports));
    			return rc4.exports;
    		}

    		var rabbit = {exports: {}};

    		rabbit.exports;

    		var hasRequiredRabbit;

    		function requireRabbit () {
    			if (hasRequiredRabbit) return rabbit.exports;
    			hasRequiredRabbit = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireEncBase64(), requireMd5(), requireEvpkdf(), requireCipherCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function () {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var StreamCipher = C_lib.StreamCipher;
    					    var C_algo = C.algo;

    					    // Reusable objects
    					    var S  = [];
    					    var C_ = [];
    					    var G  = [];

    					    /**
    					     * Rabbit stream cipher algorithm
    					     */
    					    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
    					        _doReset: function () {
    					            // Shortcuts
    					            var K = this._key.words;
    					            var iv = this.cfg.iv;

    					            // Swap endian
    					            for (var i = 0; i < 4; i++) {
    					                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
    					                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
    					            }

    					            // Generate initial state values
    					            var X = this._X = [
    					                K[0], (K[3] << 16) | (K[2] >>> 16),
    					                K[1], (K[0] << 16) | (K[3] >>> 16),
    					                K[2], (K[1] << 16) | (K[0] >>> 16),
    					                K[3], (K[2] << 16) | (K[1] >>> 16)
    					            ];

    					            // Generate initial counter values
    					            var C = this._C = [
    					                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
    					                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
    					                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
    					                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
    					            ];

    					            // Carry bit
    					            this._b = 0;

    					            // Iterate the system four times
    					            for (var i = 0; i < 4; i++) {
    					                nextState.call(this);
    					            }

    					            // Modify the counters
    					            for (var i = 0; i < 8; i++) {
    					                C[i] ^= X[(i + 4) & 7];
    					            }

    					            // IV setup
    					            if (iv) {
    					                // Shortcuts
    					                var IV = iv.words;
    					                var IV_0 = IV[0];
    					                var IV_1 = IV[1];

    					                // Generate four subvectors
    					                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
    					                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
    					                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
    					                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

    					                // Modify counter values
    					                C[0] ^= i0;
    					                C[1] ^= i1;
    					                C[2] ^= i2;
    					                C[3] ^= i3;
    					                C[4] ^= i0;
    					                C[5] ^= i1;
    					                C[6] ^= i2;
    					                C[7] ^= i3;

    					                // Iterate the system four times
    					                for (var i = 0; i < 4; i++) {
    					                    nextState.call(this);
    					                }
    					            }
    					        },

    					        _doProcessBlock: function (M, offset) {
    					            // Shortcut
    					            var X = this._X;

    					            // Iterate the system
    					            nextState.call(this);

    					            // Generate four keystream words
    					            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
    					            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
    					            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
    					            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

    					            for (var i = 0; i < 4; i++) {
    					                // Swap endian
    					                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
    					                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

    					                // Encrypt
    					                M[offset + i] ^= S[i];
    					            }
    					        },

    					        blockSize: 128/32,

    					        ivSize: 64/32
    					    });

    					    function nextState() {
    					        // Shortcuts
    					        var X = this._X;
    					        var C = this._C;

    					        // Save old counter values
    					        for (var i = 0; i < 8; i++) {
    					            C_[i] = C[i];
    					        }

    					        // Calculate new counter values
    					        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
    					        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
    					        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
    					        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
    					        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
    					        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
    					        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
    					        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
    					        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

    					        // Calculate the g-values
    					        for (var i = 0; i < 8; i++) {
    					            var gx = X[i] + C[i];

    					            // Construct high and low argument for squaring
    					            var ga = gx & 0xffff;
    					            var gb = gx >>> 16;

    					            // Calculate high and low result of squaring
    					            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
    					            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

    					            // High XOR low
    					            G[i] = gh ^ gl;
    					        }

    					        // Calculate new state values
    					        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
    					        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
    					        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
    					        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
    					        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
    					        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
    					        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
    					        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
    					    }

    					    /**
    					     * Shortcut functions to the cipher's object interface.
    					     *
    					     * @example
    					     *
    					     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
    					     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
    					     */
    					    C.Rabbit = StreamCipher._createHelper(Rabbit);
    					}());


    					return CryptoJS.Rabbit;

    				})); 
    			} (rabbit, rabbit.exports));
    			return rabbit.exports;
    		}

    		var rabbitLegacy = {exports: {}};

    		rabbitLegacy.exports;

    		var hasRequiredRabbitLegacy;

    		function requireRabbitLegacy () {
    			if (hasRequiredRabbitLegacy) return rabbitLegacy.exports;
    			hasRequiredRabbitLegacy = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireEncBase64(), requireMd5(), requireEvpkdf(), requireCipherCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function () {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var StreamCipher = C_lib.StreamCipher;
    					    var C_algo = C.algo;

    					    // Reusable objects
    					    var S  = [];
    					    var C_ = [];
    					    var G  = [];

    					    /**
    					     * Rabbit stream cipher algorithm.
    					     *
    					     * This is a legacy version that neglected to convert the key to little-endian.
    					     * This error doesn't affect the cipher's security,
    					     * but it does affect its compatibility with other implementations.
    					     */
    					    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
    					        _doReset: function () {
    					            // Shortcuts
    					            var K = this._key.words;
    					            var iv = this.cfg.iv;

    					            // Generate initial state values
    					            var X = this._X = [
    					                K[0], (K[3] << 16) | (K[2] >>> 16),
    					                K[1], (K[0] << 16) | (K[3] >>> 16),
    					                K[2], (K[1] << 16) | (K[0] >>> 16),
    					                K[3], (K[2] << 16) | (K[1] >>> 16)
    					            ];

    					            // Generate initial counter values
    					            var C = this._C = [
    					                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
    					                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
    					                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
    					                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
    					            ];

    					            // Carry bit
    					            this._b = 0;

    					            // Iterate the system four times
    					            for (var i = 0; i < 4; i++) {
    					                nextState.call(this);
    					            }

    					            // Modify the counters
    					            for (var i = 0; i < 8; i++) {
    					                C[i] ^= X[(i + 4) & 7];
    					            }

    					            // IV setup
    					            if (iv) {
    					                // Shortcuts
    					                var IV = iv.words;
    					                var IV_0 = IV[0];
    					                var IV_1 = IV[1];

    					                // Generate four subvectors
    					                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
    					                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
    					                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
    					                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

    					                // Modify counter values
    					                C[0] ^= i0;
    					                C[1] ^= i1;
    					                C[2] ^= i2;
    					                C[3] ^= i3;
    					                C[4] ^= i0;
    					                C[5] ^= i1;
    					                C[6] ^= i2;
    					                C[7] ^= i3;

    					                // Iterate the system four times
    					                for (var i = 0; i < 4; i++) {
    					                    nextState.call(this);
    					                }
    					            }
    					        },

    					        _doProcessBlock: function (M, offset) {
    					            // Shortcut
    					            var X = this._X;

    					            // Iterate the system
    					            nextState.call(this);

    					            // Generate four keystream words
    					            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
    					            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
    					            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
    					            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

    					            for (var i = 0; i < 4; i++) {
    					                // Swap endian
    					                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
    					                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

    					                // Encrypt
    					                M[offset + i] ^= S[i];
    					            }
    					        },

    					        blockSize: 128/32,

    					        ivSize: 64/32
    					    });

    					    function nextState() {
    					        // Shortcuts
    					        var X = this._X;
    					        var C = this._C;

    					        // Save old counter values
    					        for (var i = 0; i < 8; i++) {
    					            C_[i] = C[i];
    					        }

    					        // Calculate new counter values
    					        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
    					        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
    					        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
    					        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
    					        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
    					        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
    					        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
    					        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
    					        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

    					        // Calculate the g-values
    					        for (var i = 0; i < 8; i++) {
    					            var gx = X[i] + C[i];

    					            // Construct high and low argument for squaring
    					            var ga = gx & 0xffff;
    					            var gb = gx >>> 16;

    					            // Calculate high and low result of squaring
    					            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
    					            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

    					            // High XOR low
    					            G[i] = gh ^ gl;
    					        }

    					        // Calculate new state values
    					        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
    					        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
    					        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
    					        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
    					        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
    					        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
    					        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
    					        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
    					    }

    					    /**
    					     * Shortcut functions to the cipher's object interface.
    					     *
    					     * @example
    					     *
    					     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
    					     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
    					     */
    					    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
    					}());


    					return CryptoJS.RabbitLegacy;

    				})); 
    			} (rabbitLegacy, rabbitLegacy.exports));
    			return rabbitLegacy.exports;
    		}

    		var blowfish = {exports: {}};

    		blowfish.exports;

    		var hasRequiredBlowfish;

    		function requireBlowfish () {
    			if (hasRequiredBlowfish) return blowfish.exports;
    			hasRequiredBlowfish = 1;
    			(function (module, exports) {
    		(function (root, factory, undef) {
    					{
    						// CommonJS
    						module.exports = factory(requireCore(), requireEncBase64(), requireMd5(), requireEvpkdf(), requireCipherCore());
    					}
    				}(commonjsGlobal$1, function (CryptoJS) {

    					(function () {
    					    // Shortcuts
    					    var C = CryptoJS;
    					    var C_lib = C.lib;
    					    var BlockCipher = C_lib.BlockCipher;
    					    var C_algo = C.algo;

    					    const N = 16;

    					    //Origin pbox and sbox, derived from PI
    					    const ORIG_P = [
    					        0x243F6A88, 0x85A308D3, 0x13198A2E, 0x03707344,
    					        0xA4093822, 0x299F31D0, 0x082EFA98, 0xEC4E6C89,
    					        0x452821E6, 0x38D01377, 0xBE5466CF, 0x34E90C6C,
    					        0xC0AC29B7, 0xC97C50DD, 0x3F84D5B5, 0xB5470917,
    					        0x9216D5D9, 0x8979FB1B
    					    ];

    					    const ORIG_S = [
    					        [   0xD1310BA6, 0x98DFB5AC, 0x2FFD72DB, 0xD01ADFB7,
    					            0xB8E1AFED, 0x6A267E96, 0xBA7C9045, 0xF12C7F99,
    					            0x24A19947, 0xB3916CF7, 0x0801F2E2, 0x858EFC16,
    					            0x636920D8, 0x71574E69, 0xA458FEA3, 0xF4933D7E,
    					            0x0D95748F, 0x728EB658, 0x718BCD58, 0x82154AEE,
    					            0x7B54A41D, 0xC25A59B5, 0x9C30D539, 0x2AF26013,
    					            0xC5D1B023, 0x286085F0, 0xCA417918, 0xB8DB38EF,
    					            0x8E79DCB0, 0x603A180E, 0x6C9E0E8B, 0xB01E8A3E,
    					            0xD71577C1, 0xBD314B27, 0x78AF2FDA, 0x55605C60,
    					            0xE65525F3, 0xAA55AB94, 0x57489862, 0x63E81440,
    					            0x55CA396A, 0x2AAB10B6, 0xB4CC5C34, 0x1141E8CE,
    					            0xA15486AF, 0x7C72E993, 0xB3EE1411, 0x636FBC2A,
    					            0x2BA9C55D, 0x741831F6, 0xCE5C3E16, 0x9B87931E,
    					            0xAFD6BA33, 0x6C24CF5C, 0x7A325381, 0x28958677,
    					            0x3B8F4898, 0x6B4BB9AF, 0xC4BFE81B, 0x66282193,
    					            0x61D809CC, 0xFB21A991, 0x487CAC60, 0x5DEC8032,
    					            0xEF845D5D, 0xE98575B1, 0xDC262302, 0xEB651B88,
    					            0x23893E81, 0xD396ACC5, 0x0F6D6FF3, 0x83F44239,
    					            0x2E0B4482, 0xA4842004, 0x69C8F04A, 0x9E1F9B5E,
    					            0x21C66842, 0xF6E96C9A, 0x670C9C61, 0xABD388F0,
    					            0x6A51A0D2, 0xD8542F68, 0x960FA728, 0xAB5133A3,
    					            0x6EEF0B6C, 0x137A3BE4, 0xBA3BF050, 0x7EFB2A98,
    					            0xA1F1651D, 0x39AF0176, 0x66CA593E, 0x82430E88,
    					            0x8CEE8619, 0x456F9FB4, 0x7D84A5C3, 0x3B8B5EBE,
    					            0xE06F75D8, 0x85C12073, 0x401A449F, 0x56C16AA6,
    					            0x4ED3AA62, 0x363F7706, 0x1BFEDF72, 0x429B023D,
    					            0x37D0D724, 0xD00A1248, 0xDB0FEAD3, 0x49F1C09B,
    					            0x075372C9, 0x80991B7B, 0x25D479D8, 0xF6E8DEF7,
    					            0xE3FE501A, 0xB6794C3B, 0x976CE0BD, 0x04C006BA,
    					            0xC1A94FB6, 0x409F60C4, 0x5E5C9EC2, 0x196A2463,
    					            0x68FB6FAF, 0x3E6C53B5, 0x1339B2EB, 0x3B52EC6F,
    					            0x6DFC511F, 0x9B30952C, 0xCC814544, 0xAF5EBD09,
    					            0xBEE3D004, 0xDE334AFD, 0x660F2807, 0x192E4BB3,
    					            0xC0CBA857, 0x45C8740F, 0xD20B5F39, 0xB9D3FBDB,
    					            0x5579C0BD, 0x1A60320A, 0xD6A100C6, 0x402C7279,
    					            0x679F25FE, 0xFB1FA3CC, 0x8EA5E9F8, 0xDB3222F8,
    					            0x3C7516DF, 0xFD616B15, 0x2F501EC8, 0xAD0552AB,
    					            0x323DB5FA, 0xFD238760, 0x53317B48, 0x3E00DF82,
    					            0x9E5C57BB, 0xCA6F8CA0, 0x1A87562E, 0xDF1769DB,
    					            0xD542A8F6, 0x287EFFC3, 0xAC6732C6, 0x8C4F5573,
    					            0x695B27B0, 0xBBCA58C8, 0xE1FFA35D, 0xB8F011A0,
    					            0x10FA3D98, 0xFD2183B8, 0x4AFCB56C, 0x2DD1D35B,
    					            0x9A53E479, 0xB6F84565, 0xD28E49BC, 0x4BFB9790,
    					            0xE1DDF2DA, 0xA4CB7E33, 0x62FB1341, 0xCEE4C6E8,
    					            0xEF20CADA, 0x36774C01, 0xD07E9EFE, 0x2BF11FB4,
    					            0x95DBDA4D, 0xAE909198, 0xEAAD8E71, 0x6B93D5A0,
    					            0xD08ED1D0, 0xAFC725E0, 0x8E3C5B2F, 0x8E7594B7,
    					            0x8FF6E2FB, 0xF2122B64, 0x8888B812, 0x900DF01C,
    					            0x4FAD5EA0, 0x688FC31C, 0xD1CFF191, 0xB3A8C1AD,
    					            0x2F2F2218, 0xBE0E1777, 0xEA752DFE, 0x8B021FA1,
    					            0xE5A0CC0F, 0xB56F74E8, 0x18ACF3D6, 0xCE89E299,
    					            0xB4A84FE0, 0xFD13E0B7, 0x7CC43B81, 0xD2ADA8D9,
    					            0x165FA266, 0x80957705, 0x93CC7314, 0x211A1477,
    					            0xE6AD2065, 0x77B5FA86, 0xC75442F5, 0xFB9D35CF,
    					            0xEBCDAF0C, 0x7B3E89A0, 0xD6411BD3, 0xAE1E7E49,
    					            0x00250E2D, 0x2071B35E, 0x226800BB, 0x57B8E0AF,
    					            0x2464369B, 0xF009B91E, 0x5563911D, 0x59DFA6AA,
    					            0x78C14389, 0xD95A537F, 0x207D5BA2, 0x02E5B9C5,
    					            0x83260376, 0x6295CFA9, 0x11C81968, 0x4E734A41,
    					            0xB3472DCA, 0x7B14A94A, 0x1B510052, 0x9A532915,
    					            0xD60F573F, 0xBC9BC6E4, 0x2B60A476, 0x81E67400,
    					            0x08BA6FB5, 0x571BE91F, 0xF296EC6B, 0x2A0DD915,
    					            0xB6636521, 0xE7B9F9B6, 0xFF34052E, 0xC5855664,
    					            0x53B02D5D, 0xA99F8FA1, 0x08BA4799, 0x6E85076A   ],
    					        [   0x4B7A70E9, 0xB5B32944, 0xDB75092E, 0xC4192623,
    					            0xAD6EA6B0, 0x49A7DF7D, 0x9CEE60B8, 0x8FEDB266,
    					            0xECAA8C71, 0x699A17FF, 0x5664526C, 0xC2B19EE1,
    					            0x193602A5, 0x75094C29, 0xA0591340, 0xE4183A3E,
    					            0x3F54989A, 0x5B429D65, 0x6B8FE4D6, 0x99F73FD6,
    					            0xA1D29C07, 0xEFE830F5, 0x4D2D38E6, 0xF0255DC1,
    					            0x4CDD2086, 0x8470EB26, 0x6382E9C6, 0x021ECC5E,
    					            0x09686B3F, 0x3EBAEFC9, 0x3C971814, 0x6B6A70A1,
    					            0x687F3584, 0x52A0E286, 0xB79C5305, 0xAA500737,
    					            0x3E07841C, 0x7FDEAE5C, 0x8E7D44EC, 0x5716F2B8,
    					            0xB03ADA37, 0xF0500C0D, 0xF01C1F04, 0x0200B3FF,
    					            0xAE0CF51A, 0x3CB574B2, 0x25837A58, 0xDC0921BD,
    					            0xD19113F9, 0x7CA92FF6, 0x94324773, 0x22F54701,
    					            0x3AE5E581, 0x37C2DADC, 0xC8B57634, 0x9AF3DDA7,
    					            0xA9446146, 0x0FD0030E, 0xECC8C73E, 0xA4751E41,
    					            0xE238CD99, 0x3BEA0E2F, 0x3280BBA1, 0x183EB331,
    					            0x4E548B38, 0x4F6DB908, 0x6F420D03, 0xF60A04BF,
    					            0x2CB81290, 0x24977C79, 0x5679B072, 0xBCAF89AF,
    					            0xDE9A771F, 0xD9930810, 0xB38BAE12, 0xDCCF3F2E,
    					            0x5512721F, 0x2E6B7124, 0x501ADDE6, 0x9F84CD87,
    					            0x7A584718, 0x7408DA17, 0xBC9F9ABC, 0xE94B7D8C,
    					            0xEC7AEC3A, 0xDB851DFA, 0x63094366, 0xC464C3D2,
    					            0xEF1C1847, 0x3215D908, 0xDD433B37, 0x24C2BA16,
    					            0x12A14D43, 0x2A65C451, 0x50940002, 0x133AE4DD,
    					            0x71DFF89E, 0x10314E55, 0x81AC77D6, 0x5F11199B,
    					            0x043556F1, 0xD7A3C76B, 0x3C11183B, 0x5924A509,
    					            0xF28FE6ED, 0x97F1FBFA, 0x9EBABF2C, 0x1E153C6E,
    					            0x86E34570, 0xEAE96FB1, 0x860E5E0A, 0x5A3E2AB3,
    					            0x771FE71C, 0x4E3D06FA, 0x2965DCB9, 0x99E71D0F,
    					            0x803E89D6, 0x5266C825, 0x2E4CC978, 0x9C10B36A,
    					            0xC6150EBA, 0x94E2EA78, 0xA5FC3C53, 0x1E0A2DF4,
    					            0xF2F74EA7, 0x361D2B3D, 0x1939260F, 0x19C27960,
    					            0x5223A708, 0xF71312B6, 0xEBADFE6E, 0xEAC31F66,
    					            0xE3BC4595, 0xA67BC883, 0xB17F37D1, 0x018CFF28,
    					            0xC332DDEF, 0xBE6C5AA5, 0x65582185, 0x68AB9802,
    					            0xEECEA50F, 0xDB2F953B, 0x2AEF7DAD, 0x5B6E2F84,
    					            0x1521B628, 0x29076170, 0xECDD4775, 0x619F1510,
    					            0x13CCA830, 0xEB61BD96, 0x0334FE1E, 0xAA0363CF,
    					            0xB5735C90, 0x4C70A239, 0xD59E9E0B, 0xCBAADE14,
    					            0xEECC86BC, 0x60622CA7, 0x9CAB5CAB, 0xB2F3846E,
    					            0x648B1EAF, 0x19BDF0CA, 0xA02369B9, 0x655ABB50,
    					            0x40685A32, 0x3C2AB4B3, 0x319EE9D5, 0xC021B8F7,
    					            0x9B540B19, 0x875FA099, 0x95F7997E, 0x623D7DA8,
    					            0xF837889A, 0x97E32D77, 0x11ED935F, 0x16681281,
    					            0x0E358829, 0xC7E61FD6, 0x96DEDFA1, 0x7858BA99,
    					            0x57F584A5, 0x1B227263, 0x9B83C3FF, 0x1AC24696,
    					            0xCDB30AEB, 0x532E3054, 0x8FD948E4, 0x6DBC3128,
    					            0x58EBF2EF, 0x34C6FFEA, 0xFE28ED61, 0xEE7C3C73,
    					            0x5D4A14D9, 0xE864B7E3, 0x42105D14, 0x203E13E0,
    					            0x45EEE2B6, 0xA3AAABEA, 0xDB6C4F15, 0xFACB4FD0,
    					            0xC742F442, 0xEF6ABBB5, 0x654F3B1D, 0x41CD2105,
    					            0xD81E799E, 0x86854DC7, 0xE44B476A, 0x3D816250,
    					            0xCF62A1F2, 0x5B8D2646, 0xFC8883A0, 0xC1C7B6A3,
    					            0x7F1524C3, 0x69CB7492, 0x47848A0B, 0x5692B285,
    					            0x095BBF00, 0xAD19489D, 0x1462B174, 0x23820E00,
    					            0x58428D2A, 0x0C55F5EA, 0x1DADF43E, 0x233F7061,
    					            0x3372F092, 0x8D937E41, 0xD65FECF1, 0x6C223BDB,
    					            0x7CDE3759, 0xCBEE7460, 0x4085F2A7, 0xCE77326E,
    					            0xA6078084, 0x19F8509E, 0xE8EFD855, 0x61D99735,
    					            0xA969A7AA, 0xC50C06C2, 0x5A04ABFC, 0x800BCADC,
    					            0x9E447A2E, 0xC3453484, 0xFDD56705, 0x0E1E9EC9,
    					            0xDB73DBD3, 0x105588CD, 0x675FDA79, 0xE3674340,
    					            0xC5C43465, 0x713E38D8, 0x3D28F89E, 0xF16DFF20,
    					            0x153E21E7, 0x8FB03D4A, 0xE6E39F2B, 0xDB83ADF7   ],
    					        [   0xE93D5A68, 0x948140F7, 0xF64C261C, 0x94692934,
    					            0x411520F7, 0x7602D4F7, 0xBCF46B2E, 0xD4A20068,
    					            0xD4082471, 0x3320F46A, 0x43B7D4B7, 0x500061AF,
    					            0x1E39F62E, 0x97244546, 0x14214F74, 0xBF8B8840,
    					            0x4D95FC1D, 0x96B591AF, 0x70F4DDD3, 0x66A02F45,
    					            0xBFBC09EC, 0x03BD9785, 0x7FAC6DD0, 0x31CB8504,
    					            0x96EB27B3, 0x55FD3941, 0xDA2547E6, 0xABCA0A9A,
    					            0x28507825, 0x530429F4, 0x0A2C86DA, 0xE9B66DFB,
    					            0x68DC1462, 0xD7486900, 0x680EC0A4, 0x27A18DEE,
    					            0x4F3FFEA2, 0xE887AD8C, 0xB58CE006, 0x7AF4D6B6,
    					            0xAACE1E7C, 0xD3375FEC, 0xCE78A399, 0x406B2A42,
    					            0x20FE9E35, 0xD9F385B9, 0xEE39D7AB, 0x3B124E8B,
    					            0x1DC9FAF7, 0x4B6D1856, 0x26A36631, 0xEAE397B2,
    					            0x3A6EFA74, 0xDD5B4332, 0x6841E7F7, 0xCA7820FB,
    					            0xFB0AF54E, 0xD8FEB397, 0x454056AC, 0xBA489527,
    					            0x55533A3A, 0x20838D87, 0xFE6BA9B7, 0xD096954B,
    					            0x55A867BC, 0xA1159A58, 0xCCA92963, 0x99E1DB33,
    					            0xA62A4A56, 0x3F3125F9, 0x5EF47E1C, 0x9029317C,
    					            0xFDF8E802, 0x04272F70, 0x80BB155C, 0x05282CE3,
    					            0x95C11548, 0xE4C66D22, 0x48C1133F, 0xC70F86DC,
    					            0x07F9C9EE, 0x41041F0F, 0x404779A4, 0x5D886E17,
    					            0x325F51EB, 0xD59BC0D1, 0xF2BCC18F, 0x41113564,
    					            0x257B7834, 0x602A9C60, 0xDFF8E8A3, 0x1F636C1B,
    					            0x0E12B4C2, 0x02E1329E, 0xAF664FD1, 0xCAD18115,
    					            0x6B2395E0, 0x333E92E1, 0x3B240B62, 0xEEBEB922,
    					            0x85B2A20E, 0xE6BA0D99, 0xDE720C8C, 0x2DA2F728,
    					            0xD0127845, 0x95B794FD, 0x647D0862, 0xE7CCF5F0,
    					            0x5449A36F, 0x877D48FA, 0xC39DFD27, 0xF33E8D1E,
    					            0x0A476341, 0x992EFF74, 0x3A6F6EAB, 0xF4F8FD37,
    					            0xA812DC60, 0xA1EBDDF8, 0x991BE14C, 0xDB6E6B0D,
    					            0xC67B5510, 0x6D672C37, 0x2765D43B, 0xDCD0E804,
    					            0xF1290DC7, 0xCC00FFA3, 0xB5390F92, 0x690FED0B,
    					            0x667B9FFB, 0xCEDB7D9C, 0xA091CF0B, 0xD9155EA3,
    					            0xBB132F88, 0x515BAD24, 0x7B9479BF, 0x763BD6EB,
    					            0x37392EB3, 0xCC115979, 0x8026E297, 0xF42E312D,
    					            0x6842ADA7, 0xC66A2B3B, 0x12754CCC, 0x782EF11C,
    					            0x6A124237, 0xB79251E7, 0x06A1BBE6, 0x4BFB6350,
    					            0x1A6B1018, 0x11CAEDFA, 0x3D25BDD8, 0xE2E1C3C9,
    					            0x44421659, 0x0A121386, 0xD90CEC6E, 0xD5ABEA2A,
    					            0x64AF674E, 0xDA86A85F, 0xBEBFE988, 0x64E4C3FE,
    					            0x9DBC8057, 0xF0F7C086, 0x60787BF8, 0x6003604D,
    					            0xD1FD8346, 0xF6381FB0, 0x7745AE04, 0xD736FCCC,
    					            0x83426B33, 0xF01EAB71, 0xB0804187, 0x3C005E5F,
    					            0x77A057BE, 0xBDE8AE24, 0x55464299, 0xBF582E61,
    					            0x4E58F48F, 0xF2DDFDA2, 0xF474EF38, 0x8789BDC2,
    					            0x5366F9C3, 0xC8B38E74, 0xB475F255, 0x46FCD9B9,
    					            0x7AEB2661, 0x8B1DDF84, 0x846A0E79, 0x915F95E2,
    					            0x466E598E, 0x20B45770, 0x8CD55591, 0xC902DE4C,
    					            0xB90BACE1, 0xBB8205D0, 0x11A86248, 0x7574A99E,
    					            0xB77F19B6, 0xE0A9DC09, 0x662D09A1, 0xC4324633,
    					            0xE85A1F02, 0x09F0BE8C, 0x4A99A025, 0x1D6EFE10,
    					            0x1AB93D1D, 0x0BA5A4DF, 0xA186F20F, 0x2868F169,
    					            0xDCB7DA83, 0x573906FE, 0xA1E2CE9B, 0x4FCD7F52,
    					            0x50115E01, 0xA70683FA, 0xA002B5C4, 0x0DE6D027,
    					            0x9AF88C27, 0x773F8641, 0xC3604C06, 0x61A806B5,
    					            0xF0177A28, 0xC0F586E0, 0x006058AA, 0x30DC7D62,
    					            0x11E69ED7, 0x2338EA63, 0x53C2DD94, 0xC2C21634,
    					            0xBBCBEE56, 0x90BCB6DE, 0xEBFC7DA1, 0xCE591D76,
    					            0x6F05E409, 0x4B7C0188, 0x39720A3D, 0x7C927C24,
    					            0x86E3725F, 0x724D9DB9, 0x1AC15BB4, 0xD39EB8FC,
    					            0xED545578, 0x08FCA5B5, 0xD83D7CD3, 0x4DAD0FC4,
    					            0x1E50EF5E, 0xB161E6F8, 0xA28514D9, 0x6C51133C,
    					            0x6FD5C7E7, 0x56E14EC4, 0x362ABFCE, 0xDDC6C837,
    					            0xD79A3234, 0x92638212, 0x670EFA8E, 0x406000E0  ],
    					        [   0x3A39CE37, 0xD3FAF5CF, 0xABC27737, 0x5AC52D1B,
    					            0x5CB0679E, 0x4FA33742, 0xD3822740, 0x99BC9BBE,
    					            0xD5118E9D, 0xBF0F7315, 0xD62D1C7E, 0xC700C47B,
    					            0xB78C1B6B, 0x21A19045, 0xB26EB1BE, 0x6A366EB4,
    					            0x5748AB2F, 0xBC946E79, 0xC6A376D2, 0x6549C2C8,
    					            0x530FF8EE, 0x468DDE7D, 0xD5730A1D, 0x4CD04DC6,
    					            0x2939BBDB, 0xA9BA4650, 0xAC9526E8, 0xBE5EE304,
    					            0xA1FAD5F0, 0x6A2D519A, 0x63EF8CE2, 0x9A86EE22,
    					            0xC089C2B8, 0x43242EF6, 0xA51E03AA, 0x9CF2D0A4,
    					            0x83C061BA, 0x9BE96A4D, 0x8FE51550, 0xBA645BD6,
    					            0x2826A2F9, 0xA73A3AE1, 0x4BA99586, 0xEF5562E9,
    					            0xC72FEFD3, 0xF752F7DA, 0x3F046F69, 0x77FA0A59,
    					            0x80E4A915, 0x87B08601, 0x9B09E6AD, 0x3B3EE593,
    					            0xE990FD5A, 0x9E34D797, 0x2CF0B7D9, 0x022B8B51,
    					            0x96D5AC3A, 0x017DA67D, 0xD1CF3ED6, 0x7C7D2D28,
    					            0x1F9F25CF, 0xADF2B89B, 0x5AD6B472, 0x5A88F54C,
    					            0xE029AC71, 0xE019A5E6, 0x47B0ACFD, 0xED93FA9B,
    					            0xE8D3C48D, 0x283B57CC, 0xF8D56629, 0x79132E28,
    					            0x785F0191, 0xED756055, 0xF7960E44, 0xE3D35E8C,
    					            0x15056DD4, 0x88F46DBA, 0x03A16125, 0x0564F0BD,
    					            0xC3EB9E15, 0x3C9057A2, 0x97271AEC, 0xA93A072A,
    					            0x1B3F6D9B, 0x1E6321F5, 0xF59C66FB, 0x26DCF319,
    					            0x7533D928, 0xB155FDF5, 0x03563482, 0x8ABA3CBB,
    					            0x28517711, 0xC20AD9F8, 0xABCC5167, 0xCCAD925F,
    					            0x4DE81751, 0x3830DC8E, 0x379D5862, 0x9320F991,
    					            0xEA7A90C2, 0xFB3E7BCE, 0x5121CE64, 0x774FBE32,
    					            0xA8B6E37E, 0xC3293D46, 0x48DE5369, 0x6413E680,
    					            0xA2AE0810, 0xDD6DB224, 0x69852DFD, 0x09072166,
    					            0xB39A460A, 0x6445C0DD, 0x586CDECF, 0x1C20C8AE,
    					            0x5BBEF7DD, 0x1B588D40, 0xCCD2017F, 0x6BB4E3BB,
    					            0xDDA26A7E, 0x3A59FF45, 0x3E350A44, 0xBCB4CDD5,
    					            0x72EACEA8, 0xFA6484BB, 0x8D6612AE, 0xBF3C6F47,
    					            0xD29BE463, 0x542F5D9E, 0xAEC2771B, 0xF64E6370,
    					            0x740E0D8D, 0xE75B1357, 0xF8721671, 0xAF537D5D,
    					            0x4040CB08, 0x4EB4E2CC, 0x34D2466A, 0x0115AF84,
    					            0xE1B00428, 0x95983A1D, 0x06B89FB4, 0xCE6EA048,
    					            0x6F3F3B82, 0x3520AB82, 0x011A1D4B, 0x277227F8,
    					            0x611560B1, 0xE7933FDC, 0xBB3A792B, 0x344525BD,
    					            0xA08839E1, 0x51CE794B, 0x2F32C9B7, 0xA01FBAC9,
    					            0xE01CC87E, 0xBCC7D1F6, 0xCF0111C3, 0xA1E8AAC7,
    					            0x1A908749, 0xD44FBD9A, 0xD0DADECB, 0xD50ADA38,
    					            0x0339C32A, 0xC6913667, 0x8DF9317C, 0xE0B12B4F,
    					            0xF79E59B7, 0x43F5BB3A, 0xF2D519FF, 0x27D9459C,
    					            0xBF97222C, 0x15E6FC2A, 0x0F91FC71, 0x9B941525,
    					            0xFAE59361, 0xCEB69CEB, 0xC2A86459, 0x12BAA8D1,
    					            0xB6C1075E, 0xE3056A0C, 0x10D25065, 0xCB03A442,
    					            0xE0EC6E0E, 0x1698DB3B, 0x4C98A0BE, 0x3278E964,
    					            0x9F1F9532, 0xE0D392DF, 0xD3A0342B, 0x8971F21E,
    					            0x1B0A7441, 0x4BA3348C, 0xC5BE7120, 0xC37632D8,
    					            0xDF359F8D, 0x9B992F2E, 0xE60B6F47, 0x0FE3F11D,
    					            0xE54CDA54, 0x1EDAD891, 0xCE6279CF, 0xCD3E7E6F,
    					            0x1618B166, 0xFD2C1D05, 0x848FD2C5, 0xF6FB2299,
    					            0xF523F357, 0xA6327623, 0x93A83531, 0x56CCCD02,
    					            0xACF08162, 0x5A75EBB5, 0x6E163697, 0x88D273CC,
    					            0xDE966292, 0x81B949D0, 0x4C50901B, 0x71C65614,
    					            0xE6C6C7BD, 0x327A140A, 0x45E1D006, 0xC3F27B9A,
    					            0xC9AA53FD, 0x62A80F00, 0xBB25BFE2, 0x35BDD2F6,
    					            0x71126905, 0xB2040222, 0xB6CBCF7C, 0xCD769C2B,
    					            0x53113EC0, 0x1640E3D3, 0x38ABBD60, 0x2547ADF0,
    					            0xBA38209C, 0xF746CE76, 0x77AFA1C5, 0x20756060,
    					            0x85CBFE4E, 0x8AE88DD8, 0x7AAAF9B0, 0x4CF9AA7E,
    					            0x1948C25C, 0x02FB8A8C, 0x01C36AE4, 0xD6EBE1F9,
    					            0x90D4F869, 0xA65CDEA0, 0x3F09252D, 0xC208E69F,
    					            0xB74E6132, 0xCE77E25B, 0x578FDFE3, 0x3AC372E6  ]
    					    ];

    					    var BLOWFISH_CTX = {
    					        pbox: [],
    					        sbox: []
    					    };

    					    function F(ctx, x){
    					        let a = (x >> 24) & 0xFF;
    					        let b = (x >> 16) & 0xFF;
    					        let c = (x >> 8) & 0xFF;
    					        let d = x & 0xFF;

    					        let y = ctx.sbox[0][a] + ctx.sbox[1][b];
    					        y = y ^ ctx.sbox[2][c];
    					        y = y + ctx.sbox[3][d];

    					        return y;
    					    }

    					    function BlowFish_Encrypt(ctx, left, right){
    					        let Xl = left;
    					        let Xr = right;
    					        let temp;

    					        for(let i = 0; i < N; ++i){
    					            Xl = Xl ^ ctx.pbox[i];
    					            Xr = F(ctx, Xl) ^ Xr;

    					            temp = Xl;
    					            Xl = Xr;
    					            Xr = temp;
    					        }

    					        temp = Xl;
    					        Xl = Xr;
    					        Xr = temp;

    					        Xr = Xr ^ ctx.pbox[N];
    					        Xl = Xl ^ ctx.pbox[N + 1];

    					        return {left: Xl, right: Xr};
    					    }

    					    function BlowFish_Decrypt(ctx, left, right){
    					        let Xl = left;
    					        let Xr = right;
    					        let temp;

    					        for(let i = N + 1; i > 1; --i){
    					            Xl = Xl ^ ctx.pbox[i];
    					            Xr = F(ctx, Xl) ^ Xr;

    					            temp = Xl;
    					            Xl = Xr;
    					            Xr = temp;
    					        }

    					        temp = Xl;
    					        Xl = Xr;
    					        Xr = temp;

    					        Xr = Xr ^ ctx.pbox[1];
    					        Xl = Xl ^ ctx.pbox[0];

    					        return {left: Xl, right: Xr};
    					    }

    					    /**
    					     * Initialization ctx's pbox and sbox.
    					     *
    					     * @param {Object} ctx The object has pbox and sbox.
    					     * @param {Array} key An array of 32-bit words.
    					     * @param {int} keysize The length of the key.
    					     *
    					     * @example
    					     *
    					     *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
    					     */
    					    function BlowFishInit(ctx, key, keysize)
    					    {
    					        for(let Row = 0; Row < 4; Row++)
    					        {
    					            ctx.sbox[Row] = [];
    					            for(let Col = 0; Col < 256; Col++)
    					            {
    					                ctx.sbox[Row][Col] = ORIG_S[Row][Col];
    					            }
    					        }

    					        let keyIndex = 0;
    					        for(let index = 0; index < N + 2; index++)
    					        {
    					            ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
    					            keyIndex++;
    					            if(keyIndex >= keysize)
    					            {
    					                keyIndex = 0;
    					            }
    					        }

    					        let Data1 = 0;
    					        let Data2 = 0;
    					        let res = 0;
    					        for(let i = 0; i < N + 2; i += 2)
    					        {
    					            res = BlowFish_Encrypt(ctx, Data1, Data2);
    					            Data1 = res.left;
    					            Data2 = res.right;
    					            ctx.pbox[i] = Data1;
    					            ctx.pbox[i + 1] = Data2;
    					        }

    					        for(let i = 0; i < 4; i++)
    					        {
    					            for(let j = 0; j < 256; j += 2)
    					            {
    					                res = BlowFish_Encrypt(ctx, Data1, Data2);
    					                Data1 = res.left;
    					                Data2 = res.right;
    					                ctx.sbox[i][j] = Data1;
    					                ctx.sbox[i][j + 1] = Data2;
    					            }
    					        }

    					        return true;
    					    }

    					    /**
    					     * Blowfish block cipher algorithm.
    					     */
    					    var Blowfish = C_algo.Blowfish = BlockCipher.extend({
    					        _doReset: function () {
    					            // Skip reset of nRounds has been set before and key did not change
    					            if (this._keyPriorReset === this._key) {
    					                return;
    					            }

    					            // Shortcuts
    					            var key = this._keyPriorReset = this._key;
    					            var keyWords = key.words;
    					            var keySize = key.sigBytes / 4;

    					            //Initialization pbox and sbox
    					            BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
    					        },

    					        encryptBlock: function (M, offset) {
    					            var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
    					            M[offset] = res.left;
    					            M[offset + 1] = res.right;
    					        },

    					        decryptBlock: function (M, offset) {
    					            var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
    					            M[offset] = res.left;
    					            M[offset + 1] = res.right;
    					        },

    					        blockSize: 64/32,

    					        keySize: 128/32,

    					        ivSize: 64/32
    					    });

    					    /**
    					     * Shortcut functions to the cipher's object interface.
    					     *
    					     * @example
    					     *
    					     *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
    					     *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
    					     */
    					    C.Blowfish = BlockCipher._createHelper(Blowfish);
    					}());


    					return CryptoJS.Blowfish;

    				})); 
    			} (blowfish, blowfish.exports));
    			return blowfish.exports;
    		}

    		cryptoJs$1.exports;

    		(function (module, exports) {
    		(function (root, factory, undef) {
    				{
    					// CommonJS
    					module.exports = factory(requireCore(), requireX64Core(), requireLibTypedarrays(), requireEncUtf16(), requireEncBase64(), requireEncBase64url(), requireMd5(), requireSha1(), requireSha256(), requireSha224(), requireSha512(), requireSha384(), requireSha3(), requireRipemd160(), requireHmac(), requirePbkdf2(), requireEvpkdf(), requireCipherCore(), requireModeCfb(), requireModeCtr(), requireModeCtrGladman(), requireModeOfb(), requireModeEcb(), requirePadAnsix923(), requirePadIso10126(), requirePadIso97971(), requirePadZeropadding(), requirePadNopadding(), requireFormatHex(), requireAes(), requireTripledes(), requireRc4(), requireRabbit(), requireRabbitLegacy(), requireBlowfish());
    				}
    			}(commonjsGlobal$1, function (CryptoJS) {

    				return CryptoJS;

    			})); 
    		} (cryptoJs$1, cryptoJs$1.exports));

    		var cryptoJsExports = cryptoJs$1.exports;
    		var cryptoJs = /*@__PURE__*/getDefaultExportFromCjs(cryptoJsExports);

    		//  Copyright (C) 2018 Zilliqa
    		/**
    		 * Generates random bytes using native crypto module version available in the current execution environment.
    		 *
    		 * @param {number} bytes
    		 * @returns {string}
    		 */
    		var randomBytes = function (bytes) {
    		    return cryptoJs.lib.WordArray.random(bytes).toString(cryptoJs.enc.Hex);
    		};

    		/*!
    		 * schnorr.js - schnorr signatures for bcoin
    		 * Copyright (c) 2017, Christopher Jeffrey (MIT License).
    		 * https://github.com/bcoin-org/bcoin
    		 */
    		var ec = elliptic.ec;
    		var secp256k1$1 = new ec("secp256k1");
    		var curve = secp256k1$1.curve;
    		var PRIVKEY_SIZE_BYTES = 32;
    		// Public key is a point (x, y) on the curve.
    		// Each coordinate requires 32 bytes.
    		// In its compressed form it suffices to store the x co-ordinate
    		// and the sign for y.
    		// Hence a total of 33 bytes.
    		var PUBKEY_COMPRESSED_SIZE_BYTES = 33;
    		// Personalization string used for HMAC-DRBG instantiation.
    		var ALG = Buffer$c.from("Schnorr+SHA256  ", "ascii");
    		// The length in bytes of the string above.
    		var ALG_LEN = 16;
    		// The length in bytes of entropy inputs to HMAC-DRBG
    		var ENT_LEN = 32;
    		var HEX_ENC = "hex";
    		/**
    		 * generatePrivateKey
    		 *
    		 * @returns {string} - the hex-encoded private key
    		 */
    		var generatePrivateKey = function () {
    		    return secp256k1$1
    		        .genKeyPair({
    		        entropy: randomBytes(secp256k1$1.curve.n.byteLength()),
    		        entropyEnc: HEX_ENC,
    		        pers: "zilliqajs+secp256k1+SHA256",
    		    })
    		        .getPrivate()
    		        .toString(16, PRIVKEY_SIZE_BYTES * 2);
    		};
    		/**
    		 * Hash (r | M).
    		 * @param {Buffer} msg
    		 * @param {BN} r
    		 *
    		 * @returns {Buffer}
    		 */
    		var hash$1 = function (q, pubkey, msg) {
    		    var sha256 = hashjs.sha256();
    		    var totalLength = PUBKEY_COMPRESSED_SIZE_BYTES * 2 + msg.byteLength; // 33 q + 33 pubkey + variable msgLen
    		    var Q = q.toArrayLike(Buffer$c, "be", 33);
    		    var B = Buffer$c.allocUnsafe(totalLength);
    		    Q.copy(B, 0);
    		    pubkey.copy(B, 33);
    		    msg.copy(B, 66);
    		    return new bundleExports.BN(sha256.update(B).digest("hex"), 16);
    		};
    		/**
    		 * sign
    		 *
    		 * @param {Buffer} msg
    		 * @param {Buffer} key
    		 * @param {Buffer} pubkey
    		 *
    		 * @returns {Signature}
    		 */
    		var sign$1 = function (msg, privKey, pubKey) {
    		    var prv = new bundleExports.BN(privKey);
    		    var drbg = getDRBG(msg);
    		    var len = curve.n.byteLength();
    		    var sig;
    		    while (!sig) {
    		        var k = new bundleExports.BN(drbg.generate(len));
    		        sig = trySign(msg, k, prv, pubKey);
    		    }
    		    return sig;
    		};
    		/**
    		 * trySign
    		 *
    		 * @param {Buffer} msg - the message to sign over
    		 * @param {BN} k - output of the HMAC-DRBG
    		 * @param {BN} privateKey - the private key
    		 * @param {Buffer} pubKey - the public key
    		 *
    		 * @returns {Signature | null =>}
    		 */
    		var trySign = function (msg, k, privKey, pubKey) {
    		    if (privKey.isZero()) {
    		        throw new Error("Bad private key.");
    		    }
    		    if (privKey.gte(curve.n)) {
    		        throw new Error("Bad private key.");
    		    }
    		    // 1a. check that k is not 0
    		    if (k.isZero()) {
    		        return null;
    		    }
    		    // 1b. check that k is < the order of the group
    		    if (k.gte(curve.n)) {
    		        return null;
    		    }
    		    // 2. Compute commitment Q = kG, where g is the base point
    		    var Q = curve.g.mul(k);
    		    // convert the commitment to octets first
    		    var compressedQ = new bundleExports.BN(Q.encodeCompressed());
    		    // 3. Compute the challenge r = H(Q || pubKey || msg)
    		    // mod reduce the r value by the order of secp256k1, n
    		    var r = hash$1(compressedQ, pubKey, msg).umod(curve.n);
    		    var h = r.clone();
    		    if (h.isZero()) {
    		        return null;
    		    }
    		    // 4. Compute s = k - r * prv
    		    // 4a. Compute r * prv
    		    var s = h.imul(privKey).umod(curve.n);
    		    // 4b. Compute s = k - r * prv mod n
    		    s = k.isub(s).umod(curve.n);
    		    if (s.isZero()) {
    		        return null;
    		    }
    		    return new Signature({ r: r, s: s });
    		};
    		/**
    		 * Verify signature.
    		 *
    		 * @param {Buffer} msg
    		 * @param {Buffer} signature
    		 * @param {Buffer} key
    		 *
    		 * @returns {boolean}
    		 *
    		 * 1. Check if r,s is in [1, ..., order-1]
    		 * 2. Compute Q = sG + r*kpub
    		 * 3. If Q = O (the neutral point), return 0;
    		 * 4. r' = H(Q, kpub, m)
    		 * 5. return r' == r
    		 */
    		var verify = function (msg, signature, key) {
    		    var sig = new Signature(signature);
    		    if (sig.s.isZero() || sig.r.isZero()) {
    		        throw new Error("Invalid signature");
    		    }
    		    if (sig.s.isNeg() || sig.r.isNeg()) {
    		        throw new Error("Invalid signature");
    		    }
    		    if (sig.s.gte(curve.n) || sig.r.gte(curve.n)) {
    		        throw new Error("Invalid signature");
    		    }
    		    var kpub = curve.decodePoint(key);
    		    if (!curve.validate(kpub)) {
    		        throw new Error("Invalid public key");
    		    }
    		    var l = kpub.mul(sig.r);
    		    var r = curve.g.mul(sig.s);
    		    var Q = l.add(r);
    		    if (Q.isInfinity()) {
    		        throw new Error("Invalid intermediate point.");
    		    }
    		    var compressedQ = new bundleExports.BN(Q.encodeCompressed());
    		    var r1 = hash$1(compressedQ, key, msg).umod(curve.n);
    		    if (r1.isZero()) {
    		        throw new Error("Invalid hash.");
    		    }
    		    return r1.eq(sig.r);
    		};
    		var toSignature = function (serialised) {
    		    var r = serialised.slice(0, 64);
    		    var s = serialised.slice(64);
    		    return new Signature({ r: r, s: s });
    		};
    		/**
    		 * Instantiate an HMAC-DRBG.
    		 *
    		 * @param {Buffer} msg - used as nonce
    		 *
    		 * @returns {DRBG}
    		 */
    		var getDRBG = function (msg) {
    		    var entropy = randomBytes(ENT_LEN);
    		    var pers = Buffer$c.allocUnsafe(ALG_LEN + ENT_LEN);
    		    Buffer$c.from(randomBytes(ENT_LEN)).copy(pers, 0);
    		    ALG.copy(pers, ENT_LEN);
    		    return new DRBG({
    		        hash: hashjs.sha256,
    		        entropy: entropy,
    		        nonce: msg,
    		        pers: pers,
    		    });
    		};

    		var schnorr = /*#__PURE__*/Object.freeze({
    			__proto__: null,
    			generatePrivateKey: generatePrivateKey,
    			hash: hash$1,
    			sign: sign$1,
    			trySign: trySign,
    			verify: verify,
    			toSignature: toSignature
    		});

    		//  Copyright (C) 2018 Zilliqa
    		// This replaces `elliptic/lib/elliptic/ec/signature`.
    		// Q. Why do we replace `elliptic/lib/elliptic/ec/signature` with this?
    		// A. At the moment, Signature() in 'elliptic' is not exposed.
    		var Signature = /** @class */ (function () {
    		    function Signature(options) {
    		        var isValid = options.r && options.s;
    		        if (!isValid) {
    		            throw new Error("Signature without r or s");
    		        }
    		        this.r = new bundleExports.BN(options.r, 16);
    		        this.s = new bundleExports.BN(options.s, 16);
    		    }
    		    return Signature;
    		}());

    		//  Copyright (C) 2018 Zilliqa
    		var CHARSET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
    		var GENERATOR = [0x3b6a57b2, 0x26508e6d, 0x1ea119fa, 0x3d4233dd, 0x2a1462b3];
    		var polymod = function (values) {
    		    var chk = 1;
    		    for (var p = 0; p < values.length; ++p) {
    		        var top_1 = chk >> 25;
    		        chk = ((chk & 0x1ffffff) << 5) ^ values[p];
    		        for (var i = 0; i < 5; ++i) {
    		            if ((top_1 >> i) & 1) {
    		                chk ^= GENERATOR[i];
    		            }
    		        }
    		    }
    		    return chk;
    		};
    		var hrpExpand = function (hrp) {
    		    var ret = [];
    		    var p;
    		    for (p = 0; p < hrp.length; ++p) {
    		        ret.push(hrp.charCodeAt(p) >> 5);
    		    }
    		    ret.push(0);
    		    for (p = 0; p < hrp.length; ++p) {
    		        ret.push(hrp.charCodeAt(p) & 31);
    		    }
    		    return Buffer$c.from(ret);
    		};
    		function verifyChecksum(hrp, data) {
    		    return polymod(Buffer$c.concat([hrpExpand(hrp), data])) === 1;
    		}
    		function createChecksum(hrp, data) {
    		    var values = Buffer$c.concat([
    		        Buffer$c.from(hrpExpand(hrp)),
    		        data,
    		        Buffer$c.from([0, 0, 0, 0, 0, 0]),
    		    ]);
    		    // var values = hrpExpand(hrp).concat(data).concat([0, 0, 0, 0, 0, 0]);
    		    var mod = polymod(values) ^ 1;
    		    var ret = [];
    		    for (var p = 0; p < 6; ++p) {
    		        ret.push((mod >> (5 * (5 - p))) & 31);
    		    }
    		    return Buffer$c.from(ret);
    		}
    		var encode = function (hrp, data) {
    		    var combined = Buffer$c.concat([data, createChecksum(hrp, data)]);
    		    var ret = hrp + "1";
    		    for (var p = 0; p < combined.length; ++p) {
    		        ret += CHARSET.charAt(combined[p]);
    		    }
    		    return ret;
    		};
    		var decode = function (bechString) {
    		    var p;
    		    var hasLower = false;
    		    var hasUpper = false;
    		    for (p = 0; p < bechString.length; ++p) {
    		        if (bechString.charCodeAt(p) < 33 || bechString.charCodeAt(p) > 126) {
    		            return null;
    		        }
    		        if (bechString.charCodeAt(p) >= 97 && bechString.charCodeAt(p) <= 122) {
    		            hasLower = true;
    		        }
    		        if (bechString.charCodeAt(p) >= 65 && bechString.charCodeAt(p) <= 90) {
    		            hasUpper = true;
    		        }
    		    }
    		    if (hasLower && hasUpper) {
    		        return null;
    		    }
    		    bechString = bechString.toLowerCase();
    		    var pos = bechString.lastIndexOf("1");
    		    if (pos < 1 || pos + 7 > bechString.length || bechString.length > 90) {
    		        return null;
    		    }
    		    var hrp = bechString.substring(0, pos);
    		    var data = [];
    		    for (p = pos + 1; p < bechString.length; ++p) {
    		        var d = CHARSET.indexOf(bechString.charAt(p));
    		        if (d === -1) {
    		            return null;
    		        }
    		        data.push(d);
    		    }
    		    if (!verifyChecksum(hrp, Buffer$c.from(data))) {
    		        return null;
    		    }
    		    return { hrp: hrp, data: Buffer$c.from(data.slice(0, data.length - 6)) };
    		};
    		// HRP is the human-readable part of zilliqa bech32 addresses
    		var HRP = "zil";
    		/**
    		 * convertBits
    		 *
    		 * groups buffers of a certain width to buffers of the desired width.
    		 *
    		 * For example, converts byte buffers to buffers of maximum 5 bit numbers,
    		 * padding those numbers as necessary. Necessary for encoding Ethereum-style
    		 * addresses as bech32 ones.
    		 *
    		 * @param {Buffer} data
    		 * @param {number} fromWidth
    		 * @param {number} toWidth
    		 * @param {boolean} pad
    		 * @returns {Buffer|null}
    		 */
    		var convertBits = function (data, fromWidth, toWidth, pad) {
    		    if (pad === void 0) { pad = true; }
    		    var acc = 0;
    		    var bits = 0;
    		    var ret = [];
    		    var maxv = (1 << toWidth) - 1;
    		    for (var p = 0; p < data.length; ++p) {
    		        var value = data[p];
    		        if (value < 0 || value >> fromWidth !== 0) {
    		            return null;
    		        }
    		        acc = (acc << fromWidth) | value;
    		        bits += fromWidth;
    		        while (bits >= toWidth) {
    		            bits -= toWidth;
    		            ret.push((acc >> bits) & maxv);
    		        }
    		    }
    		    if (pad) {
    		        if (bits > 0) {
    		            ret.push((acc << (toWidth - bits)) & maxv);
    		        }
    		    }
    		    else if (bits >= fromWidth || (acc << (toWidth - bits)) & maxv) {
    		        return null;
    		    }
    		    return Buffer$c.from(ret);
    		};
    		/**
    		 * toBech32Address
    		 *
    		 * Encodes a canonical 20-byte Ethereum-style address as a bech32 zilliqa
    		 * address.
    		 *
    		 * The expected format is zil1<address><checksum> where address and checksum
    		 * are the result of bech32 encoding a Buffer containing the address bytes.
    		 *
    		 * @param {string} 20 byte canonical address
    		 * @returns {string} 38 char bech32 encoded zilliqa address
    		 */
    		var toBech32Address = function (address) {
    		    if (!bundleExports.validation.isAddress(address)) {
    		        throw new Error("Invalid address format.");
    		    }
    		    var addrBz = convertBits(Buffer$c.from(address.replace("0x", ""), "hex"), 8, 5);
    		    if (addrBz === null) {
    		        throw new Error("Could not convert byte Buffer to 5-bit Buffer");
    		    }
    		    return encode(HRP, addrBz);
    		};
    		/**
    		 * fromBech32Address
    		 *
    		 * @param {string} address - a valid Zilliqa bech32 address
    		 * @returns {string} a canonical 20-byte Ethereum-style address
    		 */
    		var fromBech32Address = function (address) {
    		    var res = decode(address);
    		    if (res === null) {
    		        throw new Error("Invalid bech32 address");
    		    }
    		    var hrp = res.hrp, data = res.data;
    		    var shouldBe = HRP;
    		    if (hrp !== shouldBe) {
    		        throw new Error("Expected hrp to be ".concat(shouldBe, " but got ").concat(hrp));
    		    }
    		    var buf = convertBits(data, 5, 8, false);
    		    if (buf === null) {
    		        throw new Error("Could not convert buffer to bytes");
    		    }
    		    return toChecksumAddress(buf.toString("hex"));
    		};

    		//  Copyright (C) 2018 Zilliqa
    		var secp256k1 = new elliptic.ec("secp256k1");
    		/**
    		 * getAddressFromPrivateKey
    		 *
    		 * takes a hex-encoded string (private key) and returns its corresponding
    		 * 20-byte hex-encoded address.
    		 *
    		 * @param {string} privateKey
    		 * @returns {string}
    		 */
    		var getAddressFromPrivateKey = function (privateKey) {
    		    var normalizedPrviateKey = normalizePrivateKey(privateKey);
    		    var keyPair = secp256k1.keyFromPrivate(normalizedPrviateKey, "hex");
    		    var pub = keyPair.getPublic(true, "hex");
    		    return toChecksumAddress(hashjs.sha256().update(pub, "hex").digest("hex").slice(24));
    		};
    		/**
    		 * getPubKeyFromPrivateKey
    		 *
    		 * takes a hex-encoded string (private key) and returns its corresponding
    		 * hex-encoded 33-byte public key.
    		 *
    		 * @param {string} privateKey
    		 * @returns {string}
    		 */
    		var getPubKeyFromPrivateKey = function (privateKey) {
    		    var normalizedPrviateKey = normalizePrivateKey(privateKey);
    		    var keyPair = secp256k1.keyFromPrivate(normalizedPrviateKey, "hex");
    		    return keyPair.getPublic(true, "hex");
    		};
    		/**
    		 * getAccountFrom0xPrivateKey
    		 *
    		 * Utility method for recovering account from 0x private key.
    		 * See https://github.com/Zilliqa/zilliqa-js/pull/159
    		 * @param privateKeyWith0x : private key with 0x prefix
    		 */
    		var getAccountFrom0xPrivateKey = function (privateKeyWith0x) {
    		    var privateKeyWithout0x = normalizePrivateKey(privateKeyWith0x);
    		    var keyPair = secp256k1.keyFromPrivate(privateKeyWith0x, "hex");
    		    var publicKeyWith0x = keyPair.getPublic(true, "hex");
    		    var addressWith0x = getAddressFromPublicKey(publicKeyWith0x);
    		    var bech32With0x = toBech32Address(addressWith0x);
    		    var with0x = {
    		        prv: privateKeyWith0x,
    		        pub: publicKeyWith0x,
    		        addr: addressWith0x,
    		        bech32: bech32With0x,
    		    };
    		    var keyPair2 = secp256k1.keyFromPrivate(privateKeyWithout0x, "hex");
    		    var publicKeyWithout0x = keyPair2.getPublic(true, "hex");
    		    var addressWithout0x = getAddressFromPublicKey(publicKeyWithout0x);
    		    var bech32Without0x = toBech32Address(addressWithout0x);
    		    var without0x = {
    		        prv: privateKeyWithout0x,
    		        pub: publicKeyWithout0x,
    		        addr: addressWithout0x,
    		        bech32: bech32Without0x,
    		    };
    		    var privateKeyAfterChange = keyPair.getPrivate("hex");
    		    var publicKeyAfterChange = keyPair.getPublic(true, "hex");
    		    var addressAfterChange = getAddressFromPublicKey(publicKeyAfterChange);
    		    var bech32AfterChange = toBech32Address(addressAfterChange);
    		    var changed = {
    		        prv: privateKeyAfterChange,
    		        pub: publicKeyAfterChange,
    		        addr: addressAfterChange,
    		        bech32: bech32AfterChange,
    		    };
    		    return {
    		        with0x: with0x,
    		        without0x: without0x,
    		        changed: changed,
    		    };
    		};
    		/**
    		 * compressPublicKey
    		 *
    		 * @param {string} publicKey - 65-byte public key, a point (x, y)
    		 *
    		 * @returns {string}
    		 */
    		var compressPublicKey = function (publicKey) {
    		    return secp256k1.keyFromPublic(publicKey, "hex").getPublic(true, "hex");
    		};
    		/**
    		 * getAddressFromPublicKey
    		 *
    		 * takes hex-encoded string and returns the corresponding address
    		 *
    		 * @param {string} pubKey
    		 * @returns {string}
    		 */
    		var getAddressFromPublicKey = function (publicKey) {
    		    var normalized = publicKey.toLowerCase().replace("0x", "");
    		    return toChecksumAddress(hashjs.sha256().update(normalized, "hex").digest("hex").slice(24));
    		};
    		/**
    		 * toChecksumAddress
    		 *
    		 * takes hex-encoded string and returns the corresponding address
    		 *
    		 * @param {string} address
    		 * @returns {string}
    		 */
    		var toChecksumAddress = function (address) {
    		    if (!bundleExports.validation.isAddress(address)) {
    		        throw new Error("".concat(address, " is not a valid base 16 address"));
    		    }
    		    address = address.toLowerCase().replace("0x", "");
    		    var hash = hashjs.sha256().update(address, "hex").digest("hex");
    		    var v = new bundleExports.BN(hash, "hex", "be");
    		    var ret = "0x";
    		    for (var i = 0; i < address.length; i++) {
    		        if ("0123456789".indexOf(address[i]) !== -1) {
    		            ret += address[i];
    		        }
    		        else {
    		            ret += v.and(new bundleExports.BN(2).pow(new bundleExports.BN(255 - 6 * i))).gte(new bundleExports.BN(1))
    		                ? address[i].toUpperCase()
    		                : address[i].toLowerCase();
    		        }
    		    }
    		    return ret;
    		};
    		/**
    		 * isValidChecksumAddress
    		 *
    		 * takes hex-encoded string and returns boolean if address is checksumed
    		 *
    		 * @param {string} address
    		 * @returns {boolean}
    		 */
    		var isValidChecksumAddress = function (address) {
    		    return (bundleExports.validation.isAddress(address.replace("0x", "")) &&
    		        toChecksumAddress(address) === address);
    		};
    		/**
    		 * normaliseAddress
    		 *
    		 * takes in a base16 address or a zilliqa bech32 encoded address
    		 * and returns a checksum base16 address. If the address is neither a base16
    		 * nor bech32 address, the code will return an error
    		 * @param {string)} address
    		 * @returns {string}
    		 */
    		var normaliseAddress = function (address) {
    		    if (bundleExports.validation.isBech32(address)) {
    		        return fromBech32Address(address);
    		    }
    		    if (!isValidChecksumAddress(address)) {
    		        throw Error("Wrong address format, should be either bech32 or checksummed address");
    		    }
    		    return address;
    		};
    		/**
    		 * encodeBase58 - may be required for DID public key
    		 * undeprecating this function after version 2.0.0
    		 *
    		 * @param {string} hex - base 16 encoded string
    		 * @returns {string} - big endian base 58 encoded string
    		 */
    		var encodeBase58 = function (hex) {
    		    var clean = hex.toLowerCase().replace("0x", "");
    		    var tbl = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
    		    var base = new bundleExports.BN(58);
    		    var zero = new bundleExports.BN(0);
    		    var x = new bundleExports.BN(clean, 16);
    		    var res = "";
    		    while (x.gt(zero)) {
    		        var rem = x.mod(base).toNumber(); // safe, always < 58
    		        // big endian
    		        res = tbl[rem] + res;
    		        // quotient, remainders thrown away in integer division
    		        x = x.div(base);
    		    }
    		    // convert to big endian in case the input hex is little endian
    		    var hexBE = x.toString("hex", clean.length);
    		    for (var i = 0; i < hexBE.length; i += 2) {
    		        if (hex[i] === "0" && hex[i + 1] === "0") {
    		            res = tbl[0] + res;
    		        }
    		        else {
    		            break;
    		        }
    		    }
    		    return res;
    		};
    		/**
    		 * decodeBase58 - may be required for DID public key
    		 * undeprecating this function after version 2.0.0
    		 *
    		 * @param {string} raw - base 58 string
    		 * @returns {string} - big endian base 16 string
    		 */
    		var decodeBase58 = function (raw) {
    		    var tbl = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
    		    var base = new bundleExports.BN(58);
    		    var zero = new bundleExports.BN(0);
    		    var isBreak = false;
    		    var n = new bundleExports.BN(0);
    		    var leader = "";
    		    for (var i = 0; i < raw.length; i++) {
    		        var char = raw.charAt(i);
    		        var weight = new bundleExports.BN(tbl.indexOf(char));
    		        n = n.mul(base).add(weight);
    		        // check if padding required
    		        if (!isBreak) {
    		            if (i - 1 > 0 && raw[i - 1] !== "1") {
    		                isBreak = true;
    		                continue;
    		            }
    		            if (char === "1") {
    		                leader += "00";
    		            }
    		        }
    		    }
    		    if (n.eq(zero)) {
    		        return leader;
    		    }
    		    var res = leader + n.toString("hex");
    		    if (res.length % 2 !== 0) {
    		        res = "0" + res;
    		    }
    		    return res;
    		};
    		/**
    		 * verifyPrivateKey
    		 *
    		 * @param {string|Buffer} privateKey
    		 * @returns {boolean}
    		 */
    		var verifyPrivateKey = function (privateKey) {
    		    var keyPair = secp256k1.keyFromPrivate(privateKey, "hex");
    		    var result = keyPair.validate().result;
    		    return result;
    		};
    		/**
    		 * normalizePrivateKey : normalise private key from 0x or without 0x prefix
    		 *
    		 * @param {string} privateKey
    		 * @returns {string}
    		 */
    		var normalizePrivateKey = function (privateKey) {
    		    try {
    		        if (!bundleExports.validation.isPrivateKey(privateKey)) {
    		            throw new Error("Private key is not correct");
    		        }
    		        var normalized = privateKey.toLowerCase().replace("0x", "");
    		        if (!verifyPrivateKey(normalized)) {
    		            throw new Error("Private key is not correct");
    		        }
    		        return normalized;
    		    }
    		    catch (error) {
    		        throw error;
    		    }
    		};

    		/******************************************************************************
    		Copyright (c) Microsoft Corporation.

    		Permission to use, copy, modify, and/or distribute this software for any
    		purpose with or without fee is hereby granted.

    		THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    		REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    		AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    		INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    		LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    		OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    		PERFORMANCE OF THIS SOFTWARE.
    		***************************************************************************** */

    		function __awaiter(thisArg, _arguments, P, generator) {
    		    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    		    return new (P || (P = Promise))(function (resolve, reject) {
    		        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
    		        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
    		        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
    		        step((generator = generator.apply(thisArg, _arguments || [])).next());
    		    });
    		}

    		function __generator(thisArg, body) {
    		    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    		    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    		    function verb(n) { return function (v) { return step([n, v]); }; }
    		    function step(op) {
    		        if (f) throw new TypeError("Generator is already executing.");
    		        while (g && (g = 0, op[0] && (_ = 0)), _) try {
    		            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
    		            if (y = 0, t) op = [op[0] & 2, t.value];
    		            switch (op[0]) {
    		                case 0: case 1: t = op; break;
    		                case 4: _.label++; return { value: op[1], done: false };
    		                case 5: _.label++; y = op[1]; op = [0]; continue;
    		                case 7: op = _.ops.pop(); _.trys.pop(); continue;
    		                default:
    		                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
    		                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
    		                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
    		                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
    		                    if (t[2]) _.ops.pop();
    		                    _.trys.pop(); continue;
    		            }
    		            op = body.call(thisArg, _);
    		        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
    		        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    		    }
    		}

    		var aesJs = {exports: {}};

    		/*! MIT License. Copyright 2015-2018 Richard Moore <me@ricmoo.com>. See LICENSE.txt. */
    		aesJs.exports;

    		(function (module, exports) {
    			(function(root) {

    			    function checkInt(value) {
    			        return (parseInt(value) === value);
    			    }

    			    function checkInts(arrayish) {
    			        if (!checkInt(arrayish.length)) { return false; }

    			        for (var i = 0; i < arrayish.length; i++) {
    			            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) {
    			                return false;
    			            }
    			        }

    			        return true;
    			    }

    			    function coerceArray(arg, copy) {

    			        // ArrayBuffer view
    			        if (arg.buffer && arg.name === 'Uint8Array') {

    			            if (copy) {
    			                if (arg.slice) {
    			                    arg = arg.slice();
    			                } else {
    			                    arg = Array.prototype.slice.call(arg);
    			                }
    			            }

    			            return arg;
    			        }

    			        // It's an array; check it is a valid representation of a byte
    			        if (Array.isArray(arg)) {
    			            if (!checkInts(arg)) {
    			                throw new Error('Array contains invalid value: ' + arg);
    			            }

    			            return new Uint8Array(arg);
    			        }

    			        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
    			        if (checkInt(arg.length) && checkInts(arg)) {
    			            return new Uint8Array(arg);
    			        }

    			        throw new Error('unsupported array-like object');
    			    }

    			    function createArray(length) {
    			        return new Uint8Array(length);
    			    }

    			    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
    			        if (sourceStart != null || sourceEnd != null) {
    			            if (sourceArray.slice) {
    			                sourceArray = sourceArray.slice(sourceStart, sourceEnd);
    			            } else {
    			                sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
    			            }
    			        }
    			        targetArray.set(sourceArray, targetStart);
    			    }



    			    var convertUtf8 = (function() {
    			        function toBytes(text) {
    			            var result = [], i = 0;
    			            text = encodeURI(text);
    			            while (i < text.length) {
    			                var c = text.charCodeAt(i++);

    			                // if it is a % sign, encode the following 2 bytes as a hex value
    			                if (c === 37) {
    			                    result.push(parseInt(text.substr(i, 2), 16));
    			                    i += 2;

    			                // otherwise, just the actual byte
    			                } else {
    			                    result.push(c);
    			                }
    			            }

    			            return coerceArray(result);
    			        }

    			        function fromBytes(bytes) {
    			            var result = [], i = 0;

    			            while (i < bytes.length) {
    			                var c = bytes[i];

    			                if (c < 128) {
    			                    result.push(String.fromCharCode(c));
    			                    i++;
    			                } else if (c > 191 && c < 224) {
    			                    result.push(String.fromCharCode(((c & 0x1f) << 6) | (bytes[i + 1] & 0x3f)));
    			                    i += 2;
    			                } else {
    			                    result.push(String.fromCharCode(((c & 0x0f) << 12) | ((bytes[i + 1] & 0x3f) << 6) | (bytes[i + 2] & 0x3f)));
    			                    i += 3;
    			                }
    			            }

    			            return result.join('');
    			        }

    			        return {
    			            toBytes: toBytes,
    			            fromBytes: fromBytes,
    			        }
    			    })();

    			    var convertHex = (function() {
    			        function toBytes(text) {
    			            var result = [];
    			            for (var i = 0; i < text.length; i += 2) {
    			                result.push(parseInt(text.substr(i, 2), 16));
    			            }

    			            return result;
    			        }

    			        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
    			        var Hex = '0123456789abcdef';

    			        function fromBytes(bytes) {
    			                var result = [];
    			                for (var i = 0; i < bytes.length; i++) {
    			                    var v = bytes[i];
    			                    result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
    			                }
    			                return result.join('');
    			        }

    			        return {
    			            toBytes: toBytes,
    			            fromBytes: fromBytes,
    			        }
    			    })();


    			    // Number of rounds by keysize
    			    var numberOfRounds = {16: 10, 24: 12, 32: 14};

    			    // Round constant words
    			    var rcon = [0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91];

    			    // S-box and Inverse S-box (S is for Substitution)
    			    var S = [0x63, 0x7c, 0x77, 0x7b, 0xf2, 0x6b, 0x6f, 0xc5, 0x30, 0x01, 0x67, 0x2b, 0xfe, 0xd7, 0xab, 0x76, 0xca, 0x82, 0xc9, 0x7d, 0xfa, 0x59, 0x47, 0xf0, 0xad, 0xd4, 0xa2, 0xaf, 0x9c, 0xa4, 0x72, 0xc0, 0xb7, 0xfd, 0x93, 0x26, 0x36, 0x3f, 0xf7, 0xcc, 0x34, 0xa5, 0xe5, 0xf1, 0x71, 0xd8, 0x31, 0x15, 0x04, 0xc7, 0x23, 0xc3, 0x18, 0x96, 0x05, 0x9a, 0x07, 0x12, 0x80, 0xe2, 0xeb, 0x27, 0xb2, 0x75, 0x09, 0x83, 0x2c, 0x1a, 0x1b, 0x6e, 0x5a, 0xa0, 0x52, 0x3b, 0xd6, 0xb3, 0x29, 0xe3, 0x2f, 0x84, 0x53, 0xd1, 0x00, 0xed, 0x20, 0xfc, 0xb1, 0x5b, 0x6a, 0xcb, 0xbe, 0x39, 0x4a, 0x4c, 0x58, 0xcf, 0xd0, 0xef, 0xaa, 0xfb, 0x43, 0x4d, 0x33, 0x85, 0x45, 0xf9, 0x02, 0x7f, 0x50, 0x3c, 0x9f, 0xa8, 0x51, 0xa3, 0x40, 0x8f, 0x92, 0x9d, 0x38, 0xf5, 0xbc, 0xb6, 0xda, 0x21, 0x10, 0xff, 0xf3, 0xd2, 0xcd, 0x0c, 0x13, 0xec, 0x5f, 0x97, 0x44, 0x17, 0xc4, 0xa7, 0x7e, 0x3d, 0x64, 0x5d, 0x19, 0x73, 0x60, 0x81, 0x4f, 0xdc, 0x22, 0x2a, 0x90, 0x88, 0x46, 0xee, 0xb8, 0x14, 0xde, 0x5e, 0x0b, 0xdb, 0xe0, 0x32, 0x3a, 0x0a, 0x49, 0x06, 0x24, 0x5c, 0xc2, 0xd3, 0xac, 0x62, 0x91, 0x95, 0xe4, 0x79, 0xe7, 0xc8, 0x37, 0x6d, 0x8d, 0xd5, 0x4e, 0xa9, 0x6c, 0x56, 0xf4, 0xea, 0x65, 0x7a, 0xae, 0x08, 0xba, 0x78, 0x25, 0x2e, 0x1c, 0xa6, 0xb4, 0xc6, 0xe8, 0xdd, 0x74, 0x1f, 0x4b, 0xbd, 0x8b, 0x8a, 0x70, 0x3e, 0xb5, 0x66, 0x48, 0x03, 0xf6, 0x0e, 0x61, 0x35, 0x57, 0xb9, 0x86, 0xc1, 0x1d, 0x9e, 0xe1, 0xf8, 0x98, 0x11, 0x69, 0xd9, 0x8e, 0x94, 0x9b, 0x1e, 0x87, 0xe9, 0xce, 0x55, 0x28, 0xdf, 0x8c, 0xa1, 0x89, 0x0d, 0xbf, 0xe6, 0x42, 0x68, 0x41, 0x99, 0x2d, 0x0f, 0xb0, 0x54, 0xbb, 0x16];
    			    var Si =[0x52, 0x09, 0x6a, 0xd5, 0x30, 0x36, 0xa5, 0x38, 0xbf, 0x40, 0xa3, 0x9e, 0x81, 0xf3, 0xd7, 0xfb, 0x7c, 0xe3, 0x39, 0x82, 0x9b, 0x2f, 0xff, 0x87, 0x34, 0x8e, 0x43, 0x44, 0xc4, 0xde, 0xe9, 0xcb, 0x54, 0x7b, 0x94, 0x32, 0xa6, 0xc2, 0x23, 0x3d, 0xee, 0x4c, 0x95, 0x0b, 0x42, 0xfa, 0xc3, 0x4e, 0x08, 0x2e, 0xa1, 0x66, 0x28, 0xd9, 0x24, 0xb2, 0x76, 0x5b, 0xa2, 0x49, 0x6d, 0x8b, 0xd1, 0x25, 0x72, 0xf8, 0xf6, 0x64, 0x86, 0x68, 0x98, 0x16, 0xd4, 0xa4, 0x5c, 0xcc, 0x5d, 0x65, 0xb6, 0x92, 0x6c, 0x70, 0x48, 0x50, 0xfd, 0xed, 0xb9, 0xda, 0x5e, 0x15, 0x46, 0x57, 0xa7, 0x8d, 0x9d, 0x84, 0x90, 0xd8, 0xab, 0x00, 0x8c, 0xbc, 0xd3, 0x0a, 0xf7, 0xe4, 0x58, 0x05, 0xb8, 0xb3, 0x45, 0x06, 0xd0, 0x2c, 0x1e, 0x8f, 0xca, 0x3f, 0x0f, 0x02, 0xc1, 0xaf, 0xbd, 0x03, 0x01, 0x13, 0x8a, 0x6b, 0x3a, 0x91, 0x11, 0x41, 0x4f, 0x67, 0xdc, 0xea, 0x97, 0xf2, 0xcf, 0xce, 0xf0, 0xb4, 0xe6, 0x73, 0x96, 0xac, 0x74, 0x22, 0xe7, 0xad, 0x35, 0x85, 0xe2, 0xf9, 0x37, 0xe8, 0x1c, 0x75, 0xdf, 0x6e, 0x47, 0xf1, 0x1a, 0x71, 0x1d, 0x29, 0xc5, 0x89, 0x6f, 0xb7, 0x62, 0x0e, 0xaa, 0x18, 0xbe, 0x1b, 0xfc, 0x56, 0x3e, 0x4b, 0xc6, 0xd2, 0x79, 0x20, 0x9a, 0xdb, 0xc0, 0xfe, 0x78, 0xcd, 0x5a, 0xf4, 0x1f, 0xdd, 0xa8, 0x33, 0x88, 0x07, 0xc7, 0x31, 0xb1, 0x12, 0x10, 0x59, 0x27, 0x80, 0xec, 0x5f, 0x60, 0x51, 0x7f, 0xa9, 0x19, 0xb5, 0x4a, 0x0d, 0x2d, 0xe5, 0x7a, 0x9f, 0x93, 0xc9, 0x9c, 0xef, 0xa0, 0xe0, 0x3b, 0x4d, 0xae, 0x2a, 0xf5, 0xb0, 0xc8, 0xeb, 0xbb, 0x3c, 0x83, 0x53, 0x99, 0x61, 0x17, 0x2b, 0x04, 0x7e, 0xba, 0x77, 0xd6, 0x26, 0xe1, 0x69, 0x14, 0x63, 0x55, 0x21, 0x0c, 0x7d];

    			    // Transformations for encryption
    			    var T1 = [0xc66363a5, 0xf87c7c84, 0xee777799, 0xf67b7b8d, 0xfff2f20d, 0xd66b6bbd, 0xde6f6fb1, 0x91c5c554, 0x60303050, 0x02010103, 0xce6767a9, 0x562b2b7d, 0xe7fefe19, 0xb5d7d762, 0x4dababe6, 0xec76769a, 0x8fcaca45, 0x1f82829d, 0x89c9c940, 0xfa7d7d87, 0xeffafa15, 0xb25959eb, 0x8e4747c9, 0xfbf0f00b, 0x41adadec, 0xb3d4d467, 0x5fa2a2fd, 0x45afafea, 0x239c9cbf, 0x53a4a4f7, 0xe4727296, 0x9bc0c05b, 0x75b7b7c2, 0xe1fdfd1c, 0x3d9393ae, 0x4c26266a, 0x6c36365a, 0x7e3f3f41, 0xf5f7f702, 0x83cccc4f, 0x6834345c, 0x51a5a5f4, 0xd1e5e534, 0xf9f1f108, 0xe2717193, 0xabd8d873, 0x62313153, 0x2a15153f, 0x0804040c, 0x95c7c752, 0x46232365, 0x9dc3c35e, 0x30181828, 0x379696a1, 0x0a05050f, 0x2f9a9ab5, 0x0e070709, 0x24121236, 0x1b80809b, 0xdfe2e23d, 0xcdebeb26, 0x4e272769, 0x7fb2b2cd, 0xea75759f, 0x1209091b, 0x1d83839e, 0x582c2c74, 0x341a1a2e, 0x361b1b2d, 0xdc6e6eb2, 0xb45a5aee, 0x5ba0a0fb, 0xa45252f6, 0x763b3b4d, 0xb7d6d661, 0x7db3b3ce, 0x5229297b, 0xdde3e33e, 0x5e2f2f71, 0x13848497, 0xa65353f5, 0xb9d1d168, 0x00000000, 0xc1eded2c, 0x40202060, 0xe3fcfc1f, 0x79b1b1c8, 0xb65b5bed, 0xd46a6abe, 0x8dcbcb46, 0x67bebed9, 0x7239394b, 0x944a4ade, 0x984c4cd4, 0xb05858e8, 0x85cfcf4a, 0xbbd0d06b, 0xc5efef2a, 0x4faaaae5, 0xedfbfb16, 0x864343c5, 0x9a4d4dd7, 0x66333355, 0x11858594, 0x8a4545cf, 0xe9f9f910, 0x04020206, 0xfe7f7f81, 0xa05050f0, 0x783c3c44, 0x259f9fba, 0x4ba8a8e3, 0xa25151f3, 0x5da3a3fe, 0x804040c0, 0x058f8f8a, 0x3f9292ad, 0x219d9dbc, 0x70383848, 0xf1f5f504, 0x63bcbcdf, 0x77b6b6c1, 0xafdada75, 0x42212163, 0x20101030, 0xe5ffff1a, 0xfdf3f30e, 0xbfd2d26d, 0x81cdcd4c, 0x180c0c14, 0x26131335, 0xc3ecec2f, 0xbe5f5fe1, 0x359797a2, 0x884444cc, 0x2e171739, 0x93c4c457, 0x55a7a7f2, 0xfc7e7e82, 0x7a3d3d47, 0xc86464ac, 0xba5d5de7, 0x3219192b, 0xe6737395, 0xc06060a0, 0x19818198, 0x9e4f4fd1, 0xa3dcdc7f, 0x44222266, 0x542a2a7e, 0x3b9090ab, 0x0b888883, 0x8c4646ca, 0xc7eeee29, 0x6bb8b8d3, 0x2814143c, 0xa7dede79, 0xbc5e5ee2, 0x160b0b1d, 0xaddbdb76, 0xdbe0e03b, 0x64323256, 0x743a3a4e, 0x140a0a1e, 0x924949db, 0x0c06060a, 0x4824246c, 0xb85c5ce4, 0x9fc2c25d, 0xbdd3d36e, 0x43acacef, 0xc46262a6, 0x399191a8, 0x319595a4, 0xd3e4e437, 0xf279798b, 0xd5e7e732, 0x8bc8c843, 0x6e373759, 0xda6d6db7, 0x018d8d8c, 0xb1d5d564, 0x9c4e4ed2, 0x49a9a9e0, 0xd86c6cb4, 0xac5656fa, 0xf3f4f407, 0xcfeaea25, 0xca6565af, 0xf47a7a8e, 0x47aeaee9, 0x10080818, 0x6fbabad5, 0xf0787888, 0x4a25256f, 0x5c2e2e72, 0x381c1c24, 0x57a6a6f1, 0x73b4b4c7, 0x97c6c651, 0xcbe8e823, 0xa1dddd7c, 0xe874749c, 0x3e1f1f21, 0x964b4bdd, 0x61bdbddc, 0x0d8b8b86, 0x0f8a8a85, 0xe0707090, 0x7c3e3e42, 0x71b5b5c4, 0xcc6666aa, 0x904848d8, 0x06030305, 0xf7f6f601, 0x1c0e0e12, 0xc26161a3, 0x6a35355f, 0xae5757f9, 0x69b9b9d0, 0x17868691, 0x99c1c158, 0x3a1d1d27, 0x279e9eb9, 0xd9e1e138, 0xebf8f813, 0x2b9898b3, 0x22111133, 0xd26969bb, 0xa9d9d970, 0x078e8e89, 0x339494a7, 0x2d9b9bb6, 0x3c1e1e22, 0x15878792, 0xc9e9e920, 0x87cece49, 0xaa5555ff, 0x50282878, 0xa5dfdf7a, 0x038c8c8f, 0x59a1a1f8, 0x09898980, 0x1a0d0d17, 0x65bfbfda, 0xd7e6e631, 0x844242c6, 0xd06868b8, 0x824141c3, 0x299999b0, 0x5a2d2d77, 0x1e0f0f11, 0x7bb0b0cb, 0xa85454fc, 0x6dbbbbd6, 0x2c16163a];
    			    var T2 = [0xa5c66363, 0x84f87c7c, 0x99ee7777, 0x8df67b7b, 0x0dfff2f2, 0xbdd66b6b, 0xb1de6f6f, 0x5491c5c5, 0x50603030, 0x03020101, 0xa9ce6767, 0x7d562b2b, 0x19e7fefe, 0x62b5d7d7, 0xe64dabab, 0x9aec7676, 0x458fcaca, 0x9d1f8282, 0x4089c9c9, 0x87fa7d7d, 0x15effafa, 0xebb25959, 0xc98e4747, 0x0bfbf0f0, 0xec41adad, 0x67b3d4d4, 0xfd5fa2a2, 0xea45afaf, 0xbf239c9c, 0xf753a4a4, 0x96e47272, 0x5b9bc0c0, 0xc275b7b7, 0x1ce1fdfd, 0xae3d9393, 0x6a4c2626, 0x5a6c3636, 0x417e3f3f, 0x02f5f7f7, 0x4f83cccc, 0x5c683434, 0xf451a5a5, 0x34d1e5e5, 0x08f9f1f1, 0x93e27171, 0x73abd8d8, 0x53623131, 0x3f2a1515, 0x0c080404, 0x5295c7c7, 0x65462323, 0x5e9dc3c3, 0x28301818, 0xa1379696, 0x0f0a0505, 0xb52f9a9a, 0x090e0707, 0x36241212, 0x9b1b8080, 0x3ddfe2e2, 0x26cdebeb, 0x694e2727, 0xcd7fb2b2, 0x9fea7575, 0x1b120909, 0x9e1d8383, 0x74582c2c, 0x2e341a1a, 0x2d361b1b, 0xb2dc6e6e, 0xeeb45a5a, 0xfb5ba0a0, 0xf6a45252, 0x4d763b3b, 0x61b7d6d6, 0xce7db3b3, 0x7b522929, 0x3edde3e3, 0x715e2f2f, 0x97138484, 0xf5a65353, 0x68b9d1d1, 0x00000000, 0x2cc1eded, 0x60402020, 0x1fe3fcfc, 0xc879b1b1, 0xedb65b5b, 0xbed46a6a, 0x468dcbcb, 0xd967bebe, 0x4b723939, 0xde944a4a, 0xd4984c4c, 0xe8b05858, 0x4a85cfcf, 0x6bbbd0d0, 0x2ac5efef, 0xe54faaaa, 0x16edfbfb, 0xc5864343, 0xd79a4d4d, 0x55663333, 0x94118585, 0xcf8a4545, 0x10e9f9f9, 0x06040202, 0x81fe7f7f, 0xf0a05050, 0x44783c3c, 0xba259f9f, 0xe34ba8a8, 0xf3a25151, 0xfe5da3a3, 0xc0804040, 0x8a058f8f, 0xad3f9292, 0xbc219d9d, 0x48703838, 0x04f1f5f5, 0xdf63bcbc, 0xc177b6b6, 0x75afdada, 0x63422121, 0x30201010, 0x1ae5ffff, 0x0efdf3f3, 0x6dbfd2d2, 0x4c81cdcd, 0x14180c0c, 0x35261313, 0x2fc3ecec, 0xe1be5f5f, 0xa2359797, 0xcc884444, 0x392e1717, 0x5793c4c4, 0xf255a7a7, 0x82fc7e7e, 0x477a3d3d, 0xacc86464, 0xe7ba5d5d, 0x2b321919, 0x95e67373, 0xa0c06060, 0x98198181, 0xd19e4f4f, 0x7fa3dcdc, 0x66442222, 0x7e542a2a, 0xab3b9090, 0x830b8888, 0xca8c4646, 0x29c7eeee, 0xd36bb8b8, 0x3c281414, 0x79a7dede, 0xe2bc5e5e, 0x1d160b0b, 0x76addbdb, 0x3bdbe0e0, 0x56643232, 0x4e743a3a, 0x1e140a0a, 0xdb924949, 0x0a0c0606, 0x6c482424, 0xe4b85c5c, 0x5d9fc2c2, 0x6ebdd3d3, 0xef43acac, 0xa6c46262, 0xa8399191, 0xa4319595, 0x37d3e4e4, 0x8bf27979, 0x32d5e7e7, 0x438bc8c8, 0x596e3737, 0xb7da6d6d, 0x8c018d8d, 0x64b1d5d5, 0xd29c4e4e, 0xe049a9a9, 0xb4d86c6c, 0xfaac5656, 0x07f3f4f4, 0x25cfeaea, 0xafca6565, 0x8ef47a7a, 0xe947aeae, 0x18100808, 0xd56fbaba, 0x88f07878, 0x6f4a2525, 0x725c2e2e, 0x24381c1c, 0xf157a6a6, 0xc773b4b4, 0x5197c6c6, 0x23cbe8e8, 0x7ca1dddd, 0x9ce87474, 0x213e1f1f, 0xdd964b4b, 0xdc61bdbd, 0x860d8b8b, 0x850f8a8a, 0x90e07070, 0x427c3e3e, 0xc471b5b5, 0xaacc6666, 0xd8904848, 0x05060303, 0x01f7f6f6, 0x121c0e0e, 0xa3c26161, 0x5f6a3535, 0xf9ae5757, 0xd069b9b9, 0x91178686, 0x5899c1c1, 0x273a1d1d, 0xb9279e9e, 0x38d9e1e1, 0x13ebf8f8, 0xb32b9898, 0x33221111, 0xbbd26969, 0x70a9d9d9, 0x89078e8e, 0xa7339494, 0xb62d9b9b, 0x223c1e1e, 0x92158787, 0x20c9e9e9, 0x4987cece, 0xffaa5555, 0x78502828, 0x7aa5dfdf, 0x8f038c8c, 0xf859a1a1, 0x80098989, 0x171a0d0d, 0xda65bfbf, 0x31d7e6e6, 0xc6844242, 0xb8d06868, 0xc3824141, 0xb0299999, 0x775a2d2d, 0x111e0f0f, 0xcb7bb0b0, 0xfca85454, 0xd66dbbbb, 0x3a2c1616];
    			    var T3 = [0x63a5c663, 0x7c84f87c, 0x7799ee77, 0x7b8df67b, 0xf20dfff2, 0x6bbdd66b, 0x6fb1de6f, 0xc55491c5, 0x30506030, 0x01030201, 0x67a9ce67, 0x2b7d562b, 0xfe19e7fe, 0xd762b5d7, 0xabe64dab, 0x769aec76, 0xca458fca, 0x829d1f82, 0xc94089c9, 0x7d87fa7d, 0xfa15effa, 0x59ebb259, 0x47c98e47, 0xf00bfbf0, 0xadec41ad, 0xd467b3d4, 0xa2fd5fa2, 0xafea45af, 0x9cbf239c, 0xa4f753a4, 0x7296e472, 0xc05b9bc0, 0xb7c275b7, 0xfd1ce1fd, 0x93ae3d93, 0x266a4c26, 0x365a6c36, 0x3f417e3f, 0xf702f5f7, 0xcc4f83cc, 0x345c6834, 0xa5f451a5, 0xe534d1e5, 0xf108f9f1, 0x7193e271, 0xd873abd8, 0x31536231, 0x153f2a15, 0x040c0804, 0xc75295c7, 0x23654623, 0xc35e9dc3, 0x18283018, 0x96a13796, 0x050f0a05, 0x9ab52f9a, 0x07090e07, 0x12362412, 0x809b1b80, 0xe23ddfe2, 0xeb26cdeb, 0x27694e27, 0xb2cd7fb2, 0x759fea75, 0x091b1209, 0x839e1d83, 0x2c74582c, 0x1a2e341a, 0x1b2d361b, 0x6eb2dc6e, 0x5aeeb45a, 0xa0fb5ba0, 0x52f6a452, 0x3b4d763b, 0xd661b7d6, 0xb3ce7db3, 0x297b5229, 0xe33edde3, 0x2f715e2f, 0x84971384, 0x53f5a653, 0xd168b9d1, 0x00000000, 0xed2cc1ed, 0x20604020, 0xfc1fe3fc, 0xb1c879b1, 0x5bedb65b, 0x6abed46a, 0xcb468dcb, 0xbed967be, 0x394b7239, 0x4ade944a, 0x4cd4984c, 0x58e8b058, 0xcf4a85cf, 0xd06bbbd0, 0xef2ac5ef, 0xaae54faa, 0xfb16edfb, 0x43c58643, 0x4dd79a4d, 0x33556633, 0x85941185, 0x45cf8a45, 0xf910e9f9, 0x02060402, 0x7f81fe7f, 0x50f0a050, 0x3c44783c, 0x9fba259f, 0xa8e34ba8, 0x51f3a251, 0xa3fe5da3, 0x40c08040, 0x8f8a058f, 0x92ad3f92, 0x9dbc219d, 0x38487038, 0xf504f1f5, 0xbcdf63bc, 0xb6c177b6, 0xda75afda, 0x21634221, 0x10302010, 0xff1ae5ff, 0xf30efdf3, 0xd26dbfd2, 0xcd4c81cd, 0x0c14180c, 0x13352613, 0xec2fc3ec, 0x5fe1be5f, 0x97a23597, 0x44cc8844, 0x17392e17, 0xc45793c4, 0xa7f255a7, 0x7e82fc7e, 0x3d477a3d, 0x64acc864, 0x5de7ba5d, 0x192b3219, 0x7395e673, 0x60a0c060, 0x81981981, 0x4fd19e4f, 0xdc7fa3dc, 0x22664422, 0x2a7e542a, 0x90ab3b90, 0x88830b88, 0x46ca8c46, 0xee29c7ee, 0xb8d36bb8, 0x143c2814, 0xde79a7de, 0x5ee2bc5e, 0x0b1d160b, 0xdb76addb, 0xe03bdbe0, 0x32566432, 0x3a4e743a, 0x0a1e140a, 0x49db9249, 0x060a0c06, 0x246c4824, 0x5ce4b85c, 0xc25d9fc2, 0xd36ebdd3, 0xacef43ac, 0x62a6c462, 0x91a83991, 0x95a43195, 0xe437d3e4, 0x798bf279, 0xe732d5e7, 0xc8438bc8, 0x37596e37, 0x6db7da6d, 0x8d8c018d, 0xd564b1d5, 0x4ed29c4e, 0xa9e049a9, 0x6cb4d86c, 0x56faac56, 0xf407f3f4, 0xea25cfea, 0x65afca65, 0x7a8ef47a, 0xaee947ae, 0x08181008, 0xbad56fba, 0x7888f078, 0x256f4a25, 0x2e725c2e, 0x1c24381c, 0xa6f157a6, 0xb4c773b4, 0xc65197c6, 0xe823cbe8, 0xdd7ca1dd, 0x749ce874, 0x1f213e1f, 0x4bdd964b, 0xbddc61bd, 0x8b860d8b, 0x8a850f8a, 0x7090e070, 0x3e427c3e, 0xb5c471b5, 0x66aacc66, 0x48d89048, 0x03050603, 0xf601f7f6, 0x0e121c0e, 0x61a3c261, 0x355f6a35, 0x57f9ae57, 0xb9d069b9, 0x86911786, 0xc15899c1, 0x1d273a1d, 0x9eb9279e, 0xe138d9e1, 0xf813ebf8, 0x98b32b98, 0x11332211, 0x69bbd269, 0xd970a9d9, 0x8e89078e, 0x94a73394, 0x9bb62d9b, 0x1e223c1e, 0x87921587, 0xe920c9e9, 0xce4987ce, 0x55ffaa55, 0x28785028, 0xdf7aa5df, 0x8c8f038c, 0xa1f859a1, 0x89800989, 0x0d171a0d, 0xbfda65bf, 0xe631d7e6, 0x42c68442, 0x68b8d068, 0x41c38241, 0x99b02999, 0x2d775a2d, 0x0f111e0f, 0xb0cb7bb0, 0x54fca854, 0xbbd66dbb, 0x163a2c16];
    			    var T4 = [0x6363a5c6, 0x7c7c84f8, 0x777799ee, 0x7b7b8df6, 0xf2f20dff, 0x6b6bbdd6, 0x6f6fb1de, 0xc5c55491, 0x30305060, 0x01010302, 0x6767a9ce, 0x2b2b7d56, 0xfefe19e7, 0xd7d762b5, 0xababe64d, 0x76769aec, 0xcaca458f, 0x82829d1f, 0xc9c94089, 0x7d7d87fa, 0xfafa15ef, 0x5959ebb2, 0x4747c98e, 0xf0f00bfb, 0xadadec41, 0xd4d467b3, 0xa2a2fd5f, 0xafafea45, 0x9c9cbf23, 0xa4a4f753, 0x727296e4, 0xc0c05b9b, 0xb7b7c275, 0xfdfd1ce1, 0x9393ae3d, 0x26266a4c, 0x36365a6c, 0x3f3f417e, 0xf7f702f5, 0xcccc4f83, 0x34345c68, 0xa5a5f451, 0xe5e534d1, 0xf1f108f9, 0x717193e2, 0xd8d873ab, 0x31315362, 0x15153f2a, 0x04040c08, 0xc7c75295, 0x23236546, 0xc3c35e9d, 0x18182830, 0x9696a137, 0x05050f0a, 0x9a9ab52f, 0x0707090e, 0x12123624, 0x80809b1b, 0xe2e23ddf, 0xebeb26cd, 0x2727694e, 0xb2b2cd7f, 0x75759fea, 0x09091b12, 0x83839e1d, 0x2c2c7458, 0x1a1a2e34, 0x1b1b2d36, 0x6e6eb2dc, 0x5a5aeeb4, 0xa0a0fb5b, 0x5252f6a4, 0x3b3b4d76, 0xd6d661b7, 0xb3b3ce7d, 0x29297b52, 0xe3e33edd, 0x2f2f715e, 0x84849713, 0x5353f5a6, 0xd1d168b9, 0x00000000, 0xeded2cc1, 0x20206040, 0xfcfc1fe3, 0xb1b1c879, 0x5b5bedb6, 0x6a6abed4, 0xcbcb468d, 0xbebed967, 0x39394b72, 0x4a4ade94, 0x4c4cd498, 0x5858e8b0, 0xcfcf4a85, 0xd0d06bbb, 0xefef2ac5, 0xaaaae54f, 0xfbfb16ed, 0x4343c586, 0x4d4dd79a, 0x33335566, 0x85859411, 0x4545cf8a, 0xf9f910e9, 0x02020604, 0x7f7f81fe, 0x5050f0a0, 0x3c3c4478, 0x9f9fba25, 0xa8a8e34b, 0x5151f3a2, 0xa3a3fe5d, 0x4040c080, 0x8f8f8a05, 0x9292ad3f, 0x9d9dbc21, 0x38384870, 0xf5f504f1, 0xbcbcdf63, 0xb6b6c177, 0xdada75af, 0x21216342, 0x10103020, 0xffff1ae5, 0xf3f30efd, 0xd2d26dbf, 0xcdcd4c81, 0x0c0c1418, 0x13133526, 0xecec2fc3, 0x5f5fe1be, 0x9797a235, 0x4444cc88, 0x1717392e, 0xc4c45793, 0xa7a7f255, 0x7e7e82fc, 0x3d3d477a, 0x6464acc8, 0x5d5de7ba, 0x19192b32, 0x737395e6, 0x6060a0c0, 0x81819819, 0x4f4fd19e, 0xdcdc7fa3, 0x22226644, 0x2a2a7e54, 0x9090ab3b, 0x8888830b, 0x4646ca8c, 0xeeee29c7, 0xb8b8d36b, 0x14143c28, 0xdede79a7, 0x5e5ee2bc, 0x0b0b1d16, 0xdbdb76ad, 0xe0e03bdb, 0x32325664, 0x3a3a4e74, 0x0a0a1e14, 0x4949db92, 0x06060a0c, 0x24246c48, 0x5c5ce4b8, 0xc2c25d9f, 0xd3d36ebd, 0xacacef43, 0x6262a6c4, 0x9191a839, 0x9595a431, 0xe4e437d3, 0x79798bf2, 0xe7e732d5, 0xc8c8438b, 0x3737596e, 0x6d6db7da, 0x8d8d8c01, 0xd5d564b1, 0x4e4ed29c, 0xa9a9e049, 0x6c6cb4d8, 0x5656faac, 0xf4f407f3, 0xeaea25cf, 0x6565afca, 0x7a7a8ef4, 0xaeaee947, 0x08081810, 0xbabad56f, 0x787888f0, 0x25256f4a, 0x2e2e725c, 0x1c1c2438, 0xa6a6f157, 0xb4b4c773, 0xc6c65197, 0xe8e823cb, 0xdddd7ca1, 0x74749ce8, 0x1f1f213e, 0x4b4bdd96, 0xbdbddc61, 0x8b8b860d, 0x8a8a850f, 0x707090e0, 0x3e3e427c, 0xb5b5c471, 0x6666aacc, 0x4848d890, 0x03030506, 0xf6f601f7, 0x0e0e121c, 0x6161a3c2, 0x35355f6a, 0x5757f9ae, 0xb9b9d069, 0x86869117, 0xc1c15899, 0x1d1d273a, 0x9e9eb927, 0xe1e138d9, 0xf8f813eb, 0x9898b32b, 0x11113322, 0x6969bbd2, 0xd9d970a9, 0x8e8e8907, 0x9494a733, 0x9b9bb62d, 0x1e1e223c, 0x87879215, 0xe9e920c9, 0xcece4987, 0x5555ffaa, 0x28287850, 0xdfdf7aa5, 0x8c8c8f03, 0xa1a1f859, 0x89898009, 0x0d0d171a, 0xbfbfda65, 0xe6e631d7, 0x4242c684, 0x6868b8d0, 0x4141c382, 0x9999b029, 0x2d2d775a, 0x0f0f111e, 0xb0b0cb7b, 0x5454fca8, 0xbbbbd66d, 0x16163a2c];

    			    // Transformations for decryption
    			    var T5 = [0x51f4a750, 0x7e416553, 0x1a17a4c3, 0x3a275e96, 0x3bab6bcb, 0x1f9d45f1, 0xacfa58ab, 0x4be30393, 0x2030fa55, 0xad766df6, 0x88cc7691, 0xf5024c25, 0x4fe5d7fc, 0xc52acbd7, 0x26354480, 0xb562a38f, 0xdeb15a49, 0x25ba1b67, 0x45ea0e98, 0x5dfec0e1, 0xc32f7502, 0x814cf012, 0x8d4697a3, 0x6bd3f9c6, 0x038f5fe7, 0x15929c95, 0xbf6d7aeb, 0x955259da, 0xd4be832d, 0x587421d3, 0x49e06929, 0x8ec9c844, 0x75c2896a, 0xf48e7978, 0x99583e6b, 0x27b971dd, 0xbee14fb6, 0xf088ad17, 0xc920ac66, 0x7dce3ab4, 0x63df4a18, 0xe51a3182, 0x97513360, 0x62537f45, 0xb16477e0, 0xbb6bae84, 0xfe81a01c, 0xf9082b94, 0x70486858, 0x8f45fd19, 0x94de6c87, 0x527bf8b7, 0xab73d323, 0x724b02e2, 0xe31f8f57, 0x6655ab2a, 0xb2eb2807, 0x2fb5c203, 0x86c57b9a, 0xd33708a5, 0x302887f2, 0x23bfa5b2, 0x02036aba, 0xed16825c, 0x8acf1c2b, 0xa779b492, 0xf307f2f0, 0x4e69e2a1, 0x65daf4cd, 0x0605bed5, 0xd134621f, 0xc4a6fe8a, 0x342e539d, 0xa2f355a0, 0x058ae132, 0xa4f6eb75, 0x0b83ec39, 0x4060efaa, 0x5e719f06, 0xbd6e1051, 0x3e218af9, 0x96dd063d, 0xdd3e05ae, 0x4de6bd46, 0x91548db5, 0x71c45d05, 0x0406d46f, 0x605015ff, 0x1998fb24, 0xd6bde997, 0x894043cc, 0x67d99e77, 0xb0e842bd, 0x07898b88, 0xe7195b38, 0x79c8eedb, 0xa17c0a47, 0x7c420fe9, 0xf8841ec9, 0x00000000, 0x09808683, 0x322bed48, 0x1e1170ac, 0x6c5a724e, 0xfd0efffb, 0x0f853856, 0x3daed51e, 0x362d3927, 0x0a0fd964, 0x685ca621, 0x9b5b54d1, 0x24362e3a, 0x0c0a67b1, 0x9357e70f, 0xb4ee96d2, 0x1b9b919e, 0x80c0c54f, 0x61dc20a2, 0x5a774b69, 0x1c121a16, 0xe293ba0a, 0xc0a02ae5, 0x3c22e043, 0x121b171d, 0x0e090d0b, 0xf28bc7ad, 0x2db6a8b9, 0x141ea9c8, 0x57f11985, 0xaf75074c, 0xee99ddbb, 0xa37f60fd, 0xf701269f, 0x5c72f5bc, 0x44663bc5, 0x5bfb7e34, 0x8b432976, 0xcb23c6dc, 0xb6edfc68, 0xb8e4f163, 0xd731dcca, 0x42638510, 0x13972240, 0x84c61120, 0x854a247d, 0xd2bb3df8, 0xaef93211, 0xc729a16d, 0x1d9e2f4b, 0xdcb230f3, 0x0d8652ec, 0x77c1e3d0, 0x2bb3166c, 0xa970b999, 0x119448fa, 0x47e96422, 0xa8fc8cc4, 0xa0f03f1a, 0x567d2cd8, 0x223390ef, 0x87494ec7, 0xd938d1c1, 0x8ccaa2fe, 0x98d40b36, 0xa6f581cf, 0xa57ade28, 0xdab78e26, 0x3fadbfa4, 0x2c3a9de4, 0x5078920d, 0x6a5fcc9b, 0x547e4662, 0xf68d13c2, 0x90d8b8e8, 0x2e39f75e, 0x82c3aff5, 0x9f5d80be, 0x69d0937c, 0x6fd52da9, 0xcf2512b3, 0xc8ac993b, 0x10187da7, 0xe89c636e, 0xdb3bbb7b, 0xcd267809, 0x6e5918f4, 0xec9ab701, 0x834f9aa8, 0xe6956e65, 0xaaffe67e, 0x21bccf08, 0xef15e8e6, 0xbae79bd9, 0x4a6f36ce, 0xea9f09d4, 0x29b07cd6, 0x31a4b2af, 0x2a3f2331, 0xc6a59430, 0x35a266c0, 0x744ebc37, 0xfc82caa6, 0xe090d0b0, 0x33a7d815, 0xf104984a, 0x41ecdaf7, 0x7fcd500e, 0x1791f62f, 0x764dd68d, 0x43efb04d, 0xccaa4d54, 0xe49604df, 0x9ed1b5e3, 0x4c6a881b, 0xc12c1fb8, 0x4665517f, 0x9d5eea04, 0x018c355d, 0xfa877473, 0xfb0b412e, 0xb3671d5a, 0x92dbd252, 0xe9105633, 0x6dd64713, 0x9ad7618c, 0x37a10c7a, 0x59f8148e, 0xeb133c89, 0xcea927ee, 0xb761c935, 0xe11ce5ed, 0x7a47b13c, 0x9cd2df59, 0x55f2733f, 0x1814ce79, 0x73c737bf, 0x53f7cdea, 0x5ffdaa5b, 0xdf3d6f14, 0x7844db86, 0xcaaff381, 0xb968c43e, 0x3824342c, 0xc2a3405f, 0x161dc372, 0xbce2250c, 0x283c498b, 0xff0d9541, 0x39a80171, 0x080cb3de, 0xd8b4e49c, 0x6456c190, 0x7bcb8461, 0xd532b670, 0x486c5c74, 0xd0b85742];
    			    var T6 = [0x5051f4a7, 0x537e4165, 0xc31a17a4, 0x963a275e, 0xcb3bab6b, 0xf11f9d45, 0xabacfa58, 0x934be303, 0x552030fa, 0xf6ad766d, 0x9188cc76, 0x25f5024c, 0xfc4fe5d7, 0xd7c52acb, 0x80263544, 0x8fb562a3, 0x49deb15a, 0x6725ba1b, 0x9845ea0e, 0xe15dfec0, 0x02c32f75, 0x12814cf0, 0xa38d4697, 0xc66bd3f9, 0xe7038f5f, 0x9515929c, 0xebbf6d7a, 0xda955259, 0x2dd4be83, 0xd3587421, 0x2949e069, 0x448ec9c8, 0x6a75c289, 0x78f48e79, 0x6b99583e, 0xdd27b971, 0xb6bee14f, 0x17f088ad, 0x66c920ac, 0xb47dce3a, 0x1863df4a, 0x82e51a31, 0x60975133, 0x4562537f, 0xe0b16477, 0x84bb6bae, 0x1cfe81a0, 0x94f9082b, 0x58704868, 0x198f45fd, 0x8794de6c, 0xb7527bf8, 0x23ab73d3, 0xe2724b02, 0x57e31f8f, 0x2a6655ab, 0x07b2eb28, 0x032fb5c2, 0x9a86c57b, 0xa5d33708, 0xf2302887, 0xb223bfa5, 0xba02036a, 0x5ced1682, 0x2b8acf1c, 0x92a779b4, 0xf0f307f2, 0xa14e69e2, 0xcd65daf4, 0xd50605be, 0x1fd13462, 0x8ac4a6fe, 0x9d342e53, 0xa0a2f355, 0x32058ae1, 0x75a4f6eb, 0x390b83ec, 0xaa4060ef, 0x065e719f, 0x51bd6e10, 0xf93e218a, 0x3d96dd06, 0xaedd3e05, 0x464de6bd, 0xb591548d, 0x0571c45d, 0x6f0406d4, 0xff605015, 0x241998fb, 0x97d6bde9, 0xcc894043, 0x7767d99e, 0xbdb0e842, 0x8807898b, 0x38e7195b, 0xdb79c8ee, 0x47a17c0a, 0xe97c420f, 0xc9f8841e, 0x00000000, 0x83098086, 0x48322bed, 0xac1e1170, 0x4e6c5a72, 0xfbfd0eff, 0x560f8538, 0x1e3daed5, 0x27362d39, 0x640a0fd9, 0x21685ca6, 0xd19b5b54, 0x3a24362e, 0xb10c0a67, 0x0f9357e7, 0xd2b4ee96, 0x9e1b9b91, 0x4f80c0c5, 0xa261dc20, 0x695a774b, 0x161c121a, 0x0ae293ba, 0xe5c0a02a, 0x433c22e0, 0x1d121b17, 0x0b0e090d, 0xadf28bc7, 0xb92db6a8, 0xc8141ea9, 0x8557f119, 0x4caf7507, 0xbbee99dd, 0xfda37f60, 0x9ff70126, 0xbc5c72f5, 0xc544663b, 0x345bfb7e, 0x768b4329, 0xdccb23c6, 0x68b6edfc, 0x63b8e4f1, 0xcad731dc, 0x10426385, 0x40139722, 0x2084c611, 0x7d854a24, 0xf8d2bb3d, 0x11aef932, 0x6dc729a1, 0x4b1d9e2f, 0xf3dcb230, 0xec0d8652, 0xd077c1e3, 0x6c2bb316, 0x99a970b9, 0xfa119448, 0x2247e964, 0xc4a8fc8c, 0x1aa0f03f, 0xd8567d2c, 0xef223390, 0xc787494e, 0xc1d938d1, 0xfe8ccaa2, 0x3698d40b, 0xcfa6f581, 0x28a57ade, 0x26dab78e, 0xa43fadbf, 0xe42c3a9d, 0x0d507892, 0x9b6a5fcc, 0x62547e46, 0xc2f68d13, 0xe890d8b8, 0x5e2e39f7, 0xf582c3af, 0xbe9f5d80, 0x7c69d093, 0xa96fd52d, 0xb3cf2512, 0x3bc8ac99, 0xa710187d, 0x6ee89c63, 0x7bdb3bbb, 0x09cd2678, 0xf46e5918, 0x01ec9ab7, 0xa8834f9a, 0x65e6956e, 0x7eaaffe6, 0x0821bccf, 0xe6ef15e8, 0xd9bae79b, 0xce4a6f36, 0xd4ea9f09, 0xd629b07c, 0xaf31a4b2, 0x312a3f23, 0x30c6a594, 0xc035a266, 0x37744ebc, 0xa6fc82ca, 0xb0e090d0, 0x1533a7d8, 0x4af10498, 0xf741ecda, 0x0e7fcd50, 0x2f1791f6, 0x8d764dd6, 0x4d43efb0, 0x54ccaa4d, 0xdfe49604, 0xe39ed1b5, 0x1b4c6a88, 0xb8c12c1f, 0x7f466551, 0x049d5eea, 0x5d018c35, 0x73fa8774, 0x2efb0b41, 0x5ab3671d, 0x5292dbd2, 0x33e91056, 0x136dd647, 0x8c9ad761, 0x7a37a10c, 0x8e59f814, 0x89eb133c, 0xeecea927, 0x35b761c9, 0xede11ce5, 0x3c7a47b1, 0x599cd2df, 0x3f55f273, 0x791814ce, 0xbf73c737, 0xea53f7cd, 0x5b5ffdaa, 0x14df3d6f, 0x867844db, 0x81caaff3, 0x3eb968c4, 0x2c382434, 0x5fc2a340, 0x72161dc3, 0x0cbce225, 0x8b283c49, 0x41ff0d95, 0x7139a801, 0xde080cb3, 0x9cd8b4e4, 0x906456c1, 0x617bcb84, 0x70d532b6, 0x74486c5c, 0x42d0b857];
    			    var T7 = [0xa75051f4, 0x65537e41, 0xa4c31a17, 0x5e963a27, 0x6bcb3bab, 0x45f11f9d, 0x58abacfa, 0x03934be3, 0xfa552030, 0x6df6ad76, 0x769188cc, 0x4c25f502, 0xd7fc4fe5, 0xcbd7c52a, 0x44802635, 0xa38fb562, 0x5a49deb1, 0x1b6725ba, 0x0e9845ea, 0xc0e15dfe, 0x7502c32f, 0xf012814c, 0x97a38d46, 0xf9c66bd3, 0x5fe7038f, 0x9c951592, 0x7aebbf6d, 0x59da9552, 0x832dd4be, 0x21d35874, 0x692949e0, 0xc8448ec9, 0x896a75c2, 0x7978f48e, 0x3e6b9958, 0x71dd27b9, 0x4fb6bee1, 0xad17f088, 0xac66c920, 0x3ab47dce, 0x4a1863df, 0x3182e51a, 0x33609751, 0x7f456253, 0x77e0b164, 0xae84bb6b, 0xa01cfe81, 0x2b94f908, 0x68587048, 0xfd198f45, 0x6c8794de, 0xf8b7527b, 0xd323ab73, 0x02e2724b, 0x8f57e31f, 0xab2a6655, 0x2807b2eb, 0xc2032fb5, 0x7b9a86c5, 0x08a5d337, 0x87f23028, 0xa5b223bf, 0x6aba0203, 0x825ced16, 0x1c2b8acf, 0xb492a779, 0xf2f0f307, 0xe2a14e69, 0xf4cd65da, 0xbed50605, 0x621fd134, 0xfe8ac4a6, 0x539d342e, 0x55a0a2f3, 0xe132058a, 0xeb75a4f6, 0xec390b83, 0xefaa4060, 0x9f065e71, 0x1051bd6e, 0x8af93e21, 0x063d96dd, 0x05aedd3e, 0xbd464de6, 0x8db59154, 0x5d0571c4, 0xd46f0406, 0x15ff6050, 0xfb241998, 0xe997d6bd, 0x43cc8940, 0x9e7767d9, 0x42bdb0e8, 0x8b880789, 0x5b38e719, 0xeedb79c8, 0x0a47a17c, 0x0fe97c42, 0x1ec9f884, 0x00000000, 0x86830980, 0xed48322b, 0x70ac1e11, 0x724e6c5a, 0xfffbfd0e, 0x38560f85, 0xd51e3dae, 0x3927362d, 0xd9640a0f, 0xa621685c, 0x54d19b5b, 0x2e3a2436, 0x67b10c0a, 0xe70f9357, 0x96d2b4ee, 0x919e1b9b, 0xc54f80c0, 0x20a261dc, 0x4b695a77, 0x1a161c12, 0xba0ae293, 0x2ae5c0a0, 0xe0433c22, 0x171d121b, 0x0d0b0e09, 0xc7adf28b, 0xa8b92db6, 0xa9c8141e, 0x198557f1, 0x074caf75, 0xddbbee99, 0x60fda37f, 0x269ff701, 0xf5bc5c72, 0x3bc54466, 0x7e345bfb, 0x29768b43, 0xc6dccb23, 0xfc68b6ed, 0xf163b8e4, 0xdccad731, 0x85104263, 0x22401397, 0x112084c6, 0x247d854a, 0x3df8d2bb, 0x3211aef9, 0xa16dc729, 0x2f4b1d9e, 0x30f3dcb2, 0x52ec0d86, 0xe3d077c1, 0x166c2bb3, 0xb999a970, 0x48fa1194, 0x642247e9, 0x8cc4a8fc, 0x3f1aa0f0, 0x2cd8567d, 0x90ef2233, 0x4ec78749, 0xd1c1d938, 0xa2fe8cca, 0x0b3698d4, 0x81cfa6f5, 0xde28a57a, 0x8e26dab7, 0xbfa43fad, 0x9de42c3a, 0x920d5078, 0xcc9b6a5f, 0x4662547e, 0x13c2f68d, 0xb8e890d8, 0xf75e2e39, 0xaff582c3, 0x80be9f5d, 0x937c69d0, 0x2da96fd5, 0x12b3cf25, 0x993bc8ac, 0x7da71018, 0x636ee89c, 0xbb7bdb3b, 0x7809cd26, 0x18f46e59, 0xb701ec9a, 0x9aa8834f, 0x6e65e695, 0xe67eaaff, 0xcf0821bc, 0xe8e6ef15, 0x9bd9bae7, 0x36ce4a6f, 0x09d4ea9f, 0x7cd629b0, 0xb2af31a4, 0x23312a3f, 0x9430c6a5, 0x66c035a2, 0xbc37744e, 0xcaa6fc82, 0xd0b0e090, 0xd81533a7, 0x984af104, 0xdaf741ec, 0x500e7fcd, 0xf62f1791, 0xd68d764d, 0xb04d43ef, 0x4d54ccaa, 0x04dfe496, 0xb5e39ed1, 0x881b4c6a, 0x1fb8c12c, 0x517f4665, 0xea049d5e, 0x355d018c, 0x7473fa87, 0x412efb0b, 0x1d5ab367, 0xd25292db, 0x5633e910, 0x47136dd6, 0x618c9ad7, 0x0c7a37a1, 0x148e59f8, 0x3c89eb13, 0x27eecea9, 0xc935b761, 0xe5ede11c, 0xb13c7a47, 0xdf599cd2, 0x733f55f2, 0xce791814, 0x37bf73c7, 0xcdea53f7, 0xaa5b5ffd, 0x6f14df3d, 0xdb867844, 0xf381caaf, 0xc43eb968, 0x342c3824, 0x405fc2a3, 0xc372161d, 0x250cbce2, 0x498b283c, 0x9541ff0d, 0x017139a8, 0xb3de080c, 0xe49cd8b4, 0xc1906456, 0x84617bcb, 0xb670d532, 0x5c74486c, 0x5742d0b8];
    			    var T8 = [0xf4a75051, 0x4165537e, 0x17a4c31a, 0x275e963a, 0xab6bcb3b, 0x9d45f11f, 0xfa58abac, 0xe303934b, 0x30fa5520, 0x766df6ad, 0xcc769188, 0x024c25f5, 0xe5d7fc4f, 0x2acbd7c5, 0x35448026, 0x62a38fb5, 0xb15a49de, 0xba1b6725, 0xea0e9845, 0xfec0e15d, 0x2f7502c3, 0x4cf01281, 0x4697a38d, 0xd3f9c66b, 0x8f5fe703, 0x929c9515, 0x6d7aebbf, 0x5259da95, 0xbe832dd4, 0x7421d358, 0xe0692949, 0xc9c8448e, 0xc2896a75, 0x8e7978f4, 0x583e6b99, 0xb971dd27, 0xe14fb6be, 0x88ad17f0, 0x20ac66c9, 0xce3ab47d, 0xdf4a1863, 0x1a3182e5, 0x51336097, 0x537f4562, 0x6477e0b1, 0x6bae84bb, 0x81a01cfe, 0x082b94f9, 0x48685870, 0x45fd198f, 0xde6c8794, 0x7bf8b752, 0x73d323ab, 0x4b02e272, 0x1f8f57e3, 0x55ab2a66, 0xeb2807b2, 0xb5c2032f, 0xc57b9a86, 0x3708a5d3, 0x2887f230, 0xbfa5b223, 0x036aba02, 0x16825ced, 0xcf1c2b8a, 0x79b492a7, 0x07f2f0f3, 0x69e2a14e, 0xdaf4cd65, 0x05bed506, 0x34621fd1, 0xa6fe8ac4, 0x2e539d34, 0xf355a0a2, 0x8ae13205, 0xf6eb75a4, 0x83ec390b, 0x60efaa40, 0x719f065e, 0x6e1051bd, 0x218af93e, 0xdd063d96, 0x3e05aedd, 0xe6bd464d, 0x548db591, 0xc45d0571, 0x06d46f04, 0x5015ff60, 0x98fb2419, 0xbde997d6, 0x4043cc89, 0xd99e7767, 0xe842bdb0, 0x898b8807, 0x195b38e7, 0xc8eedb79, 0x7c0a47a1, 0x420fe97c, 0x841ec9f8, 0x00000000, 0x80868309, 0x2bed4832, 0x1170ac1e, 0x5a724e6c, 0x0efffbfd, 0x8538560f, 0xaed51e3d, 0x2d392736, 0x0fd9640a, 0x5ca62168, 0x5b54d19b, 0x362e3a24, 0x0a67b10c, 0x57e70f93, 0xee96d2b4, 0x9b919e1b, 0xc0c54f80, 0xdc20a261, 0x774b695a, 0x121a161c, 0x93ba0ae2, 0xa02ae5c0, 0x22e0433c, 0x1b171d12, 0x090d0b0e, 0x8bc7adf2, 0xb6a8b92d, 0x1ea9c814, 0xf1198557, 0x75074caf, 0x99ddbbee, 0x7f60fda3, 0x01269ff7, 0x72f5bc5c, 0x663bc544, 0xfb7e345b, 0x4329768b, 0x23c6dccb, 0xedfc68b6, 0xe4f163b8, 0x31dccad7, 0x63851042, 0x97224013, 0xc6112084, 0x4a247d85, 0xbb3df8d2, 0xf93211ae, 0x29a16dc7, 0x9e2f4b1d, 0xb230f3dc, 0x8652ec0d, 0xc1e3d077, 0xb3166c2b, 0x70b999a9, 0x9448fa11, 0xe9642247, 0xfc8cc4a8, 0xf03f1aa0, 0x7d2cd856, 0x3390ef22, 0x494ec787, 0x38d1c1d9, 0xcaa2fe8c, 0xd40b3698, 0xf581cfa6, 0x7ade28a5, 0xb78e26da, 0xadbfa43f, 0x3a9de42c, 0x78920d50, 0x5fcc9b6a, 0x7e466254, 0x8d13c2f6, 0xd8b8e890, 0x39f75e2e, 0xc3aff582, 0x5d80be9f, 0xd0937c69, 0xd52da96f, 0x2512b3cf, 0xac993bc8, 0x187da710, 0x9c636ee8, 0x3bbb7bdb, 0x267809cd, 0x5918f46e, 0x9ab701ec, 0x4f9aa883, 0x956e65e6, 0xffe67eaa, 0xbccf0821, 0x15e8e6ef, 0xe79bd9ba, 0x6f36ce4a, 0x9f09d4ea, 0xb07cd629, 0xa4b2af31, 0x3f23312a, 0xa59430c6, 0xa266c035, 0x4ebc3774, 0x82caa6fc, 0x90d0b0e0, 0xa7d81533, 0x04984af1, 0xecdaf741, 0xcd500e7f, 0x91f62f17, 0x4dd68d76, 0xefb04d43, 0xaa4d54cc, 0x9604dfe4, 0xd1b5e39e, 0x6a881b4c, 0x2c1fb8c1, 0x65517f46, 0x5eea049d, 0x8c355d01, 0x877473fa, 0x0b412efb, 0x671d5ab3, 0xdbd25292, 0x105633e9, 0xd647136d, 0xd7618c9a, 0xa10c7a37, 0xf8148e59, 0x133c89eb, 0xa927eece, 0x61c935b7, 0x1ce5ede1, 0x47b13c7a, 0xd2df599c, 0xf2733f55, 0x14ce7918, 0xc737bf73, 0xf7cdea53, 0xfdaa5b5f, 0x3d6f14df, 0x44db8678, 0xaff381ca, 0x68c43eb9, 0x24342c38, 0xa3405fc2, 0x1dc37216, 0xe2250cbc, 0x3c498b28, 0x0d9541ff, 0xa8017139, 0x0cb3de08, 0xb4e49cd8, 0x56c19064, 0xcb84617b, 0x32b670d5, 0x6c5c7448, 0xb85742d0];

    			    // Transformations for decryption key expansion
    			    var U1 = [0x00000000, 0x0e090d0b, 0x1c121a16, 0x121b171d, 0x3824342c, 0x362d3927, 0x24362e3a, 0x2a3f2331, 0x70486858, 0x7e416553, 0x6c5a724e, 0x62537f45, 0x486c5c74, 0x4665517f, 0x547e4662, 0x5a774b69, 0xe090d0b0, 0xee99ddbb, 0xfc82caa6, 0xf28bc7ad, 0xd8b4e49c, 0xd6bde997, 0xc4a6fe8a, 0xcaaff381, 0x90d8b8e8, 0x9ed1b5e3, 0x8ccaa2fe, 0x82c3aff5, 0xa8fc8cc4, 0xa6f581cf, 0xb4ee96d2, 0xbae79bd9, 0xdb3bbb7b, 0xd532b670, 0xc729a16d, 0xc920ac66, 0xe31f8f57, 0xed16825c, 0xff0d9541, 0xf104984a, 0xab73d323, 0xa57ade28, 0xb761c935, 0xb968c43e, 0x9357e70f, 0x9d5eea04, 0x8f45fd19, 0x814cf012, 0x3bab6bcb, 0x35a266c0, 0x27b971dd, 0x29b07cd6, 0x038f5fe7, 0x0d8652ec, 0x1f9d45f1, 0x119448fa, 0x4be30393, 0x45ea0e98, 0x57f11985, 0x59f8148e, 0x73c737bf, 0x7dce3ab4, 0x6fd52da9, 0x61dc20a2, 0xad766df6, 0xa37f60fd, 0xb16477e0, 0xbf6d7aeb, 0x955259da, 0x9b5b54d1, 0x894043cc, 0x87494ec7, 0xdd3e05ae, 0xd33708a5, 0xc12c1fb8, 0xcf2512b3, 0xe51a3182, 0xeb133c89, 0xf9082b94, 0xf701269f, 0x4de6bd46, 0x43efb04d, 0x51f4a750, 0x5ffdaa5b, 0x75c2896a, 0x7bcb8461, 0x69d0937c, 0x67d99e77, 0x3daed51e, 0x33a7d815, 0x21bccf08, 0x2fb5c203, 0x058ae132, 0x0b83ec39, 0x1998fb24, 0x1791f62f, 0x764dd68d, 0x7844db86, 0x6a5fcc9b, 0x6456c190, 0x4e69e2a1, 0x4060efaa, 0x527bf8b7, 0x5c72f5bc, 0x0605bed5, 0x080cb3de, 0x1a17a4c3, 0x141ea9c8, 0x3e218af9, 0x302887f2, 0x223390ef, 0x2c3a9de4, 0x96dd063d, 0x98d40b36, 0x8acf1c2b, 0x84c61120, 0xaef93211, 0xa0f03f1a, 0xb2eb2807, 0xbce2250c, 0xe6956e65, 0xe89c636e, 0xfa877473, 0xf48e7978, 0xdeb15a49, 0xd0b85742, 0xc2a3405f, 0xccaa4d54, 0x41ecdaf7, 0x4fe5d7fc, 0x5dfec0e1, 0x53f7cdea, 0x79c8eedb, 0x77c1e3d0, 0x65daf4cd, 0x6bd3f9c6, 0x31a4b2af, 0x3fadbfa4, 0x2db6a8b9, 0x23bfa5b2, 0x09808683, 0x07898b88, 0x15929c95, 0x1b9b919e, 0xa17c0a47, 0xaf75074c, 0xbd6e1051, 0xb3671d5a, 0x99583e6b, 0x97513360, 0x854a247d, 0x8b432976, 0xd134621f, 0xdf3d6f14, 0xcd267809, 0xc32f7502, 0xe9105633, 0xe7195b38, 0xf5024c25, 0xfb0b412e, 0x9ad7618c, 0x94de6c87, 0x86c57b9a, 0x88cc7691, 0xa2f355a0, 0xacfa58ab, 0xbee14fb6, 0xb0e842bd, 0xea9f09d4, 0xe49604df, 0xf68d13c2, 0xf8841ec9, 0xd2bb3df8, 0xdcb230f3, 0xcea927ee, 0xc0a02ae5, 0x7a47b13c, 0x744ebc37, 0x6655ab2a, 0x685ca621, 0x42638510, 0x4c6a881b, 0x5e719f06, 0x5078920d, 0x0a0fd964, 0x0406d46f, 0x161dc372, 0x1814ce79, 0x322bed48, 0x3c22e043, 0x2e39f75e, 0x2030fa55, 0xec9ab701, 0xe293ba0a, 0xf088ad17, 0xfe81a01c, 0xd4be832d, 0xdab78e26, 0xc8ac993b, 0xc6a59430, 0x9cd2df59, 0x92dbd252, 0x80c0c54f, 0x8ec9c844, 0xa4f6eb75, 0xaaffe67e, 0xb8e4f163, 0xb6edfc68, 0x0c0a67b1, 0x02036aba, 0x10187da7, 0x1e1170ac, 0x342e539d, 0x3a275e96, 0x283c498b, 0x26354480, 0x7c420fe9, 0x724b02e2, 0x605015ff, 0x6e5918f4, 0x44663bc5, 0x4a6f36ce, 0x587421d3, 0x567d2cd8, 0x37a10c7a, 0x39a80171, 0x2bb3166c, 0x25ba1b67, 0x0f853856, 0x018c355d, 0x13972240, 0x1d9e2f4b, 0x47e96422, 0x49e06929, 0x5bfb7e34, 0x55f2733f, 0x7fcd500e, 0x71c45d05, 0x63df4a18, 0x6dd64713, 0xd731dcca, 0xd938d1c1, 0xcb23c6dc, 0xc52acbd7, 0xef15e8e6, 0xe11ce5ed, 0xf307f2f0, 0xfd0efffb, 0xa779b492, 0xa970b999, 0xbb6bae84, 0xb562a38f, 0x9f5d80be, 0x91548db5, 0x834f9aa8, 0x8d4697a3];
    			    var U2 = [0x00000000, 0x0b0e090d, 0x161c121a, 0x1d121b17, 0x2c382434, 0x27362d39, 0x3a24362e, 0x312a3f23, 0x58704868, 0x537e4165, 0x4e6c5a72, 0x4562537f, 0x74486c5c, 0x7f466551, 0x62547e46, 0x695a774b, 0xb0e090d0, 0xbbee99dd, 0xa6fc82ca, 0xadf28bc7, 0x9cd8b4e4, 0x97d6bde9, 0x8ac4a6fe, 0x81caaff3, 0xe890d8b8, 0xe39ed1b5, 0xfe8ccaa2, 0xf582c3af, 0xc4a8fc8c, 0xcfa6f581, 0xd2b4ee96, 0xd9bae79b, 0x7bdb3bbb, 0x70d532b6, 0x6dc729a1, 0x66c920ac, 0x57e31f8f, 0x5ced1682, 0x41ff0d95, 0x4af10498, 0x23ab73d3, 0x28a57ade, 0x35b761c9, 0x3eb968c4, 0x0f9357e7, 0x049d5eea, 0x198f45fd, 0x12814cf0, 0xcb3bab6b, 0xc035a266, 0xdd27b971, 0xd629b07c, 0xe7038f5f, 0xec0d8652, 0xf11f9d45, 0xfa119448, 0x934be303, 0x9845ea0e, 0x8557f119, 0x8e59f814, 0xbf73c737, 0xb47dce3a, 0xa96fd52d, 0xa261dc20, 0xf6ad766d, 0xfda37f60, 0xe0b16477, 0xebbf6d7a, 0xda955259, 0xd19b5b54, 0xcc894043, 0xc787494e, 0xaedd3e05, 0xa5d33708, 0xb8c12c1f, 0xb3cf2512, 0x82e51a31, 0x89eb133c, 0x94f9082b, 0x9ff70126, 0x464de6bd, 0x4d43efb0, 0x5051f4a7, 0x5b5ffdaa, 0x6a75c289, 0x617bcb84, 0x7c69d093, 0x7767d99e, 0x1e3daed5, 0x1533a7d8, 0x0821bccf, 0x032fb5c2, 0x32058ae1, 0x390b83ec, 0x241998fb, 0x2f1791f6, 0x8d764dd6, 0x867844db, 0x9b6a5fcc, 0x906456c1, 0xa14e69e2, 0xaa4060ef, 0xb7527bf8, 0xbc5c72f5, 0xd50605be, 0xde080cb3, 0xc31a17a4, 0xc8141ea9, 0xf93e218a, 0xf2302887, 0xef223390, 0xe42c3a9d, 0x3d96dd06, 0x3698d40b, 0x2b8acf1c, 0x2084c611, 0x11aef932, 0x1aa0f03f, 0x07b2eb28, 0x0cbce225, 0x65e6956e, 0x6ee89c63, 0x73fa8774, 0x78f48e79, 0x49deb15a, 0x42d0b857, 0x5fc2a340, 0x54ccaa4d, 0xf741ecda, 0xfc4fe5d7, 0xe15dfec0, 0xea53f7cd, 0xdb79c8ee, 0xd077c1e3, 0xcd65daf4, 0xc66bd3f9, 0xaf31a4b2, 0xa43fadbf, 0xb92db6a8, 0xb223bfa5, 0x83098086, 0x8807898b, 0x9515929c, 0x9e1b9b91, 0x47a17c0a, 0x4caf7507, 0x51bd6e10, 0x5ab3671d, 0x6b99583e, 0x60975133, 0x7d854a24, 0x768b4329, 0x1fd13462, 0x14df3d6f, 0x09cd2678, 0x02c32f75, 0x33e91056, 0x38e7195b, 0x25f5024c, 0x2efb0b41, 0x8c9ad761, 0x8794de6c, 0x9a86c57b, 0x9188cc76, 0xa0a2f355, 0xabacfa58, 0xb6bee14f, 0xbdb0e842, 0xd4ea9f09, 0xdfe49604, 0xc2f68d13, 0xc9f8841e, 0xf8d2bb3d, 0xf3dcb230, 0xeecea927, 0xe5c0a02a, 0x3c7a47b1, 0x37744ebc, 0x2a6655ab, 0x21685ca6, 0x10426385, 0x1b4c6a88, 0x065e719f, 0x0d507892, 0x640a0fd9, 0x6f0406d4, 0x72161dc3, 0x791814ce, 0x48322bed, 0x433c22e0, 0x5e2e39f7, 0x552030fa, 0x01ec9ab7, 0x0ae293ba, 0x17f088ad, 0x1cfe81a0, 0x2dd4be83, 0x26dab78e, 0x3bc8ac99, 0x30c6a594, 0x599cd2df, 0x5292dbd2, 0x4f80c0c5, 0x448ec9c8, 0x75a4f6eb, 0x7eaaffe6, 0x63b8e4f1, 0x68b6edfc, 0xb10c0a67, 0xba02036a, 0xa710187d, 0xac1e1170, 0x9d342e53, 0x963a275e, 0x8b283c49, 0x80263544, 0xe97c420f, 0xe2724b02, 0xff605015, 0xf46e5918, 0xc544663b, 0xce4a6f36, 0xd3587421, 0xd8567d2c, 0x7a37a10c, 0x7139a801, 0x6c2bb316, 0x6725ba1b, 0x560f8538, 0x5d018c35, 0x40139722, 0x4b1d9e2f, 0x2247e964, 0x2949e069, 0x345bfb7e, 0x3f55f273, 0x0e7fcd50, 0x0571c45d, 0x1863df4a, 0x136dd647, 0xcad731dc, 0xc1d938d1, 0xdccb23c6, 0xd7c52acb, 0xe6ef15e8, 0xede11ce5, 0xf0f307f2, 0xfbfd0eff, 0x92a779b4, 0x99a970b9, 0x84bb6bae, 0x8fb562a3, 0xbe9f5d80, 0xb591548d, 0xa8834f9a, 0xa38d4697];
    			    var U3 = [0x00000000, 0x0d0b0e09, 0x1a161c12, 0x171d121b, 0x342c3824, 0x3927362d, 0x2e3a2436, 0x23312a3f, 0x68587048, 0x65537e41, 0x724e6c5a, 0x7f456253, 0x5c74486c, 0x517f4665, 0x4662547e, 0x4b695a77, 0xd0b0e090, 0xddbbee99, 0xcaa6fc82, 0xc7adf28b, 0xe49cd8b4, 0xe997d6bd, 0xfe8ac4a6, 0xf381caaf, 0xb8e890d8, 0xb5e39ed1, 0xa2fe8cca, 0xaff582c3, 0x8cc4a8fc, 0x81cfa6f5, 0x96d2b4ee, 0x9bd9bae7, 0xbb7bdb3b, 0xb670d532, 0xa16dc729, 0xac66c920, 0x8f57e31f, 0x825ced16, 0x9541ff0d, 0x984af104, 0xd323ab73, 0xde28a57a, 0xc935b761, 0xc43eb968, 0xe70f9357, 0xea049d5e, 0xfd198f45, 0xf012814c, 0x6bcb3bab, 0x66c035a2, 0x71dd27b9, 0x7cd629b0, 0x5fe7038f, 0x52ec0d86, 0x45f11f9d, 0x48fa1194, 0x03934be3, 0x0e9845ea, 0x198557f1, 0x148e59f8, 0x37bf73c7, 0x3ab47dce, 0x2da96fd5, 0x20a261dc, 0x6df6ad76, 0x60fda37f, 0x77e0b164, 0x7aebbf6d, 0x59da9552, 0x54d19b5b, 0x43cc8940, 0x4ec78749, 0x05aedd3e, 0x08a5d337, 0x1fb8c12c, 0x12b3cf25, 0x3182e51a, 0x3c89eb13, 0x2b94f908, 0x269ff701, 0xbd464de6, 0xb04d43ef, 0xa75051f4, 0xaa5b5ffd, 0x896a75c2, 0x84617bcb, 0x937c69d0, 0x9e7767d9, 0xd51e3dae, 0xd81533a7, 0xcf0821bc, 0xc2032fb5, 0xe132058a, 0xec390b83, 0xfb241998, 0xf62f1791, 0xd68d764d, 0xdb867844, 0xcc9b6a5f, 0xc1906456, 0xe2a14e69, 0xefaa4060, 0xf8b7527b, 0xf5bc5c72, 0xbed50605, 0xb3de080c, 0xa4c31a17, 0xa9c8141e, 0x8af93e21, 0x87f23028, 0x90ef2233, 0x9de42c3a, 0x063d96dd, 0x0b3698d4, 0x1c2b8acf, 0x112084c6, 0x3211aef9, 0x3f1aa0f0, 0x2807b2eb, 0x250cbce2, 0x6e65e695, 0x636ee89c, 0x7473fa87, 0x7978f48e, 0x5a49deb1, 0x5742d0b8, 0x405fc2a3, 0x4d54ccaa, 0xdaf741ec, 0xd7fc4fe5, 0xc0e15dfe, 0xcdea53f7, 0xeedb79c8, 0xe3d077c1, 0xf4cd65da, 0xf9c66bd3, 0xb2af31a4, 0xbfa43fad, 0xa8b92db6, 0xa5b223bf, 0x86830980, 0x8b880789, 0x9c951592, 0x919e1b9b, 0x0a47a17c, 0x074caf75, 0x1051bd6e, 0x1d5ab367, 0x3e6b9958, 0x33609751, 0x247d854a, 0x29768b43, 0x621fd134, 0x6f14df3d, 0x7809cd26, 0x7502c32f, 0x5633e910, 0x5b38e719, 0x4c25f502, 0x412efb0b, 0x618c9ad7, 0x6c8794de, 0x7b9a86c5, 0x769188cc, 0x55a0a2f3, 0x58abacfa, 0x4fb6bee1, 0x42bdb0e8, 0x09d4ea9f, 0x04dfe496, 0x13c2f68d, 0x1ec9f884, 0x3df8d2bb, 0x30f3dcb2, 0x27eecea9, 0x2ae5c0a0, 0xb13c7a47, 0xbc37744e, 0xab2a6655, 0xa621685c, 0x85104263, 0x881b4c6a, 0x9f065e71, 0x920d5078, 0xd9640a0f, 0xd46f0406, 0xc372161d, 0xce791814, 0xed48322b, 0xe0433c22, 0xf75e2e39, 0xfa552030, 0xb701ec9a, 0xba0ae293, 0xad17f088, 0xa01cfe81, 0x832dd4be, 0x8e26dab7, 0x993bc8ac, 0x9430c6a5, 0xdf599cd2, 0xd25292db, 0xc54f80c0, 0xc8448ec9, 0xeb75a4f6, 0xe67eaaff, 0xf163b8e4, 0xfc68b6ed, 0x67b10c0a, 0x6aba0203, 0x7da71018, 0x70ac1e11, 0x539d342e, 0x5e963a27, 0x498b283c, 0x44802635, 0x0fe97c42, 0x02e2724b, 0x15ff6050, 0x18f46e59, 0x3bc54466, 0x36ce4a6f, 0x21d35874, 0x2cd8567d, 0x0c7a37a1, 0x017139a8, 0x166c2bb3, 0x1b6725ba, 0x38560f85, 0x355d018c, 0x22401397, 0x2f4b1d9e, 0x642247e9, 0x692949e0, 0x7e345bfb, 0x733f55f2, 0x500e7fcd, 0x5d0571c4, 0x4a1863df, 0x47136dd6, 0xdccad731, 0xd1c1d938, 0xc6dccb23, 0xcbd7c52a, 0xe8e6ef15, 0xe5ede11c, 0xf2f0f307, 0xfffbfd0e, 0xb492a779, 0xb999a970, 0xae84bb6b, 0xa38fb562, 0x80be9f5d, 0x8db59154, 0x9aa8834f, 0x97a38d46];
    			    var U4 = [0x00000000, 0x090d0b0e, 0x121a161c, 0x1b171d12, 0x24342c38, 0x2d392736, 0x362e3a24, 0x3f23312a, 0x48685870, 0x4165537e, 0x5a724e6c, 0x537f4562, 0x6c5c7448, 0x65517f46, 0x7e466254, 0x774b695a, 0x90d0b0e0, 0x99ddbbee, 0x82caa6fc, 0x8bc7adf2, 0xb4e49cd8, 0xbde997d6, 0xa6fe8ac4, 0xaff381ca, 0xd8b8e890, 0xd1b5e39e, 0xcaa2fe8c, 0xc3aff582, 0xfc8cc4a8, 0xf581cfa6, 0xee96d2b4, 0xe79bd9ba, 0x3bbb7bdb, 0x32b670d5, 0x29a16dc7, 0x20ac66c9, 0x1f8f57e3, 0x16825ced, 0x0d9541ff, 0x04984af1, 0x73d323ab, 0x7ade28a5, 0x61c935b7, 0x68c43eb9, 0x57e70f93, 0x5eea049d, 0x45fd198f, 0x4cf01281, 0xab6bcb3b, 0xa266c035, 0xb971dd27, 0xb07cd629, 0x8f5fe703, 0x8652ec0d, 0x9d45f11f, 0x9448fa11, 0xe303934b, 0xea0e9845, 0xf1198557, 0xf8148e59, 0xc737bf73, 0xce3ab47d, 0xd52da96f, 0xdc20a261, 0x766df6ad, 0x7f60fda3, 0x6477e0b1, 0x6d7aebbf, 0x5259da95, 0x5b54d19b, 0x4043cc89, 0x494ec787, 0x3e05aedd, 0x3708a5d3, 0x2c1fb8c1, 0x2512b3cf, 0x1a3182e5, 0x133c89eb, 0x082b94f9, 0x01269ff7, 0xe6bd464d, 0xefb04d43, 0xf4a75051, 0xfdaa5b5f, 0xc2896a75, 0xcb84617b, 0xd0937c69, 0xd99e7767, 0xaed51e3d, 0xa7d81533, 0xbccf0821, 0xb5c2032f, 0x8ae13205, 0x83ec390b, 0x98fb2419, 0x91f62f17, 0x4dd68d76, 0x44db8678, 0x5fcc9b6a, 0x56c19064, 0x69e2a14e, 0x60efaa40, 0x7bf8b752, 0x72f5bc5c, 0x05bed506, 0x0cb3de08, 0x17a4c31a, 0x1ea9c814, 0x218af93e, 0x2887f230, 0x3390ef22, 0x3a9de42c, 0xdd063d96, 0xd40b3698, 0xcf1c2b8a, 0xc6112084, 0xf93211ae, 0xf03f1aa0, 0xeb2807b2, 0xe2250cbc, 0x956e65e6, 0x9c636ee8, 0x877473fa, 0x8e7978f4, 0xb15a49de, 0xb85742d0, 0xa3405fc2, 0xaa4d54cc, 0xecdaf741, 0xe5d7fc4f, 0xfec0e15d, 0xf7cdea53, 0xc8eedb79, 0xc1e3d077, 0xdaf4cd65, 0xd3f9c66b, 0xa4b2af31, 0xadbfa43f, 0xb6a8b92d, 0xbfa5b223, 0x80868309, 0x898b8807, 0x929c9515, 0x9b919e1b, 0x7c0a47a1, 0x75074caf, 0x6e1051bd, 0x671d5ab3, 0x583e6b99, 0x51336097, 0x4a247d85, 0x4329768b, 0x34621fd1, 0x3d6f14df, 0x267809cd, 0x2f7502c3, 0x105633e9, 0x195b38e7, 0x024c25f5, 0x0b412efb, 0xd7618c9a, 0xde6c8794, 0xc57b9a86, 0xcc769188, 0xf355a0a2, 0xfa58abac, 0xe14fb6be, 0xe842bdb0, 0x9f09d4ea, 0x9604dfe4, 0x8d13c2f6, 0x841ec9f8, 0xbb3df8d2, 0xb230f3dc, 0xa927eece, 0xa02ae5c0, 0x47b13c7a, 0x4ebc3774, 0x55ab2a66, 0x5ca62168, 0x63851042, 0x6a881b4c, 0x719f065e, 0x78920d50, 0x0fd9640a, 0x06d46f04, 0x1dc37216, 0x14ce7918, 0x2bed4832, 0x22e0433c, 0x39f75e2e, 0x30fa5520, 0x9ab701ec, 0x93ba0ae2, 0x88ad17f0, 0x81a01cfe, 0xbe832dd4, 0xb78e26da, 0xac993bc8, 0xa59430c6, 0xd2df599c, 0xdbd25292, 0xc0c54f80, 0xc9c8448e, 0xf6eb75a4, 0xffe67eaa, 0xe4f163b8, 0xedfc68b6, 0x0a67b10c, 0x036aba02, 0x187da710, 0x1170ac1e, 0x2e539d34, 0x275e963a, 0x3c498b28, 0x35448026, 0x420fe97c, 0x4b02e272, 0x5015ff60, 0x5918f46e, 0x663bc544, 0x6f36ce4a, 0x7421d358, 0x7d2cd856, 0xa10c7a37, 0xa8017139, 0xb3166c2b, 0xba1b6725, 0x8538560f, 0x8c355d01, 0x97224013, 0x9e2f4b1d, 0xe9642247, 0xe0692949, 0xfb7e345b, 0xf2733f55, 0xcd500e7f, 0xc45d0571, 0xdf4a1863, 0xd647136d, 0x31dccad7, 0x38d1c1d9, 0x23c6dccb, 0x2acbd7c5, 0x15e8e6ef, 0x1ce5ede1, 0x07f2f0f3, 0x0efffbfd, 0x79b492a7, 0x70b999a9, 0x6bae84bb, 0x62a38fb5, 0x5d80be9f, 0x548db591, 0x4f9aa883, 0x4697a38d];

    			    function convertToInt32(bytes) {
    			        var result = [];
    			        for (var i = 0; i < bytes.length; i += 4) {
    			            result.push(
    			                (bytes[i    ] << 24) |
    			                (bytes[i + 1] << 16) |
    			                (bytes[i + 2] <<  8) |
    			                 bytes[i + 3]
    			            );
    			        }
    			        return result;
    			    }

    			    var AES = function(key) {
    			        if (!(this instanceof AES)) {
    			            throw Error('AES must be instanitated with `new`');
    			        }

    			        Object.defineProperty(this, 'key', {
    			            value: coerceArray(key, true)
    			        });

    			        this._prepare();
    			    };


    			    AES.prototype._prepare = function() {

    			        var rounds = numberOfRounds[this.key.length];
    			        if (rounds == null) {
    			            throw new Error('invalid key size (must be 16, 24 or 32 bytes)');
    			        }

    			        // encryption round keys
    			        this._Ke = [];

    			        // decryption round keys
    			        this._Kd = [];

    			        for (var i = 0; i <= rounds; i++) {
    			            this._Ke.push([0, 0, 0, 0]);
    			            this._Kd.push([0, 0, 0, 0]);
    			        }

    			        var roundKeyCount = (rounds + 1) * 4;
    			        var KC = this.key.length / 4;

    			        // convert the key into ints
    			        var tk = convertToInt32(this.key);

    			        // copy values into round key arrays
    			        var index;
    			        for (var i = 0; i < KC; i++) {
    			            index = i >> 2;
    			            this._Ke[index][i % 4] = tk[i];
    			            this._Kd[rounds - index][i % 4] = tk[i];
    			        }

    			        // key expansion (fips-197 section 5.2)
    			        var rconpointer = 0;
    			        var t = KC, tt;
    			        while (t < roundKeyCount) {
    			            tt = tk[KC - 1];
    			            tk[0] ^= ((S[(tt >> 16) & 0xFF] << 24) ^
    			                      (S[(tt >>  8) & 0xFF] << 16) ^
    			                      (S[ tt        & 0xFF] <<  8) ^
    			                       S[(tt >> 24) & 0xFF]        ^
    			                      (rcon[rconpointer] << 24));
    			            rconpointer += 1;

    			            // key expansion (for non-256 bit)
    			            if (KC != 8) {
    			                for (var i = 1; i < KC; i++) {
    			                    tk[i] ^= tk[i - 1];
    			                }

    			            // key expansion for 256-bit keys is "slightly different" (fips-197)
    			            } else {
    			                for (var i = 1; i < (KC / 2); i++) {
    			                    tk[i] ^= tk[i - 1];
    			                }
    			                tt = tk[(KC / 2) - 1];

    			                tk[KC / 2] ^= (S[ tt        & 0xFF]        ^
    			                              (S[(tt >>  8) & 0xFF] <<  8) ^
    			                              (S[(tt >> 16) & 0xFF] << 16) ^
    			                              (S[(tt >> 24) & 0xFF] << 24));

    			                for (var i = (KC / 2) + 1; i < KC; i++) {
    			                    tk[i] ^= tk[i - 1];
    			                }
    			            }

    			            // copy values into round key arrays
    			            var i = 0, r, c;
    			            while (i < KC && t < roundKeyCount) {
    			                r = t >> 2;
    			                c = t % 4;
    			                this._Ke[r][c] = tk[i];
    			                this._Kd[rounds - r][c] = tk[i++];
    			                t++;
    			            }
    			        }

    			        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
    			        for (var r = 1; r < rounds; r++) {
    			            for (var c = 0; c < 4; c++) {
    			                tt = this._Kd[r][c];
    			                this._Kd[r][c] = (U1[(tt >> 24) & 0xFF] ^
    			                                  U2[(tt >> 16) & 0xFF] ^
    			                                  U3[(tt >>  8) & 0xFF] ^
    			                                  U4[ tt        & 0xFF]);
    			            }
    			        }
    			    };

    			    AES.prototype.encrypt = function(plaintext) {
    			        if (plaintext.length != 16) {
    			            throw new Error('invalid plaintext size (must be 16 bytes)');
    			        }

    			        var rounds = this._Ke.length - 1;
    			        var a = [0, 0, 0, 0];

    			        // convert plaintext to (ints ^ key)
    			        var t = convertToInt32(plaintext);
    			        for (var i = 0; i < 4; i++) {
    			            t[i] ^= this._Ke[0][i];
    			        }

    			        // apply round transforms
    			        for (var r = 1; r < rounds; r++) {
    			            for (var i = 0; i < 4; i++) {
    			                a[i] = (T1[(t[ i         ] >> 24) & 0xff] ^
    			                        T2[(t[(i + 1) % 4] >> 16) & 0xff] ^
    			                        T3[(t[(i + 2) % 4] >>  8) & 0xff] ^
    			                        T4[ t[(i + 3) % 4]        & 0xff] ^
    			                        this._Ke[r][i]);
    			            }
    			            t = a.slice();
    			        }

    			        // the last round is special
    			        var result = createArray(16), tt;
    			        for (var i = 0; i < 4; i++) {
    			            tt = this._Ke[rounds][i];
    			            result[4 * i    ] = (S[(t[ i         ] >> 24) & 0xff] ^ (tt >> 24)) & 0xff;
    			            result[4 * i + 1] = (S[(t[(i + 1) % 4] >> 16) & 0xff] ^ (tt >> 16)) & 0xff;
    			            result[4 * i + 2] = (S[(t[(i + 2) % 4] >>  8) & 0xff] ^ (tt >>  8)) & 0xff;
    			            result[4 * i + 3] = (S[ t[(i + 3) % 4]        & 0xff] ^  tt       ) & 0xff;
    			        }

    			        return result;
    			    };

    			    AES.prototype.decrypt = function(ciphertext) {
    			        if (ciphertext.length != 16) {
    			            throw new Error('invalid ciphertext size (must be 16 bytes)');
    			        }

    			        var rounds = this._Kd.length - 1;
    			        var a = [0, 0, 0, 0];

    			        // convert plaintext to (ints ^ key)
    			        var t = convertToInt32(ciphertext);
    			        for (var i = 0; i < 4; i++) {
    			            t[i] ^= this._Kd[0][i];
    			        }

    			        // apply round transforms
    			        for (var r = 1; r < rounds; r++) {
    			            for (var i = 0; i < 4; i++) {
    			                a[i] = (T5[(t[ i          ] >> 24) & 0xff] ^
    			                        T6[(t[(i + 3) % 4] >> 16) & 0xff] ^
    			                        T7[(t[(i + 2) % 4] >>  8) & 0xff] ^
    			                        T8[ t[(i + 1) % 4]        & 0xff] ^
    			                        this._Kd[r][i]);
    			            }
    			            t = a.slice();
    			        }

    			        // the last round is special
    			        var result = createArray(16), tt;
    			        for (var i = 0; i < 4; i++) {
    			            tt = this._Kd[rounds][i];
    			            result[4 * i    ] = (Si[(t[ i         ] >> 24) & 0xff] ^ (tt >> 24)) & 0xff;
    			            result[4 * i + 1] = (Si[(t[(i + 3) % 4] >> 16) & 0xff] ^ (tt >> 16)) & 0xff;
    			            result[4 * i + 2] = (Si[(t[(i + 2) % 4] >>  8) & 0xff] ^ (tt >>  8)) & 0xff;
    			            result[4 * i + 3] = (Si[ t[(i + 1) % 4]        & 0xff] ^  tt       ) & 0xff;
    			        }

    			        return result;
    			    };


    			    /**
    			     *  Mode Of Operation - Electonic Codebook (ECB)
    			     */
    			    var ModeOfOperationECB = function(key) {
    			        if (!(this instanceof ModeOfOperationECB)) {
    			            throw Error('AES must be instanitated with `new`');
    			        }

    			        this.description = "Electronic Code Block";
    			        this.name = "ecb";

    			        this._aes = new AES(key);
    			    };

    			    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
    			        plaintext = coerceArray(plaintext);

    			        if ((plaintext.length % 16) !== 0) {
    			            throw new Error('invalid plaintext size (must be multiple of 16 bytes)');
    			        }

    			        var ciphertext = createArray(plaintext.length);
    			        var block = createArray(16);

    			        for (var i = 0; i < plaintext.length; i += 16) {
    			            copyArray(plaintext, block, 0, i, i + 16);
    			            block = this._aes.encrypt(block);
    			            copyArray(block, ciphertext, i);
    			        }

    			        return ciphertext;
    			    };

    			    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
    			        ciphertext = coerceArray(ciphertext);

    			        if ((ciphertext.length % 16) !== 0) {
    			            throw new Error('invalid ciphertext size (must be multiple of 16 bytes)');
    			        }

    			        var plaintext = createArray(ciphertext.length);
    			        var block = createArray(16);

    			        for (var i = 0; i < ciphertext.length; i += 16) {
    			            copyArray(ciphertext, block, 0, i, i + 16);
    			            block = this._aes.decrypt(block);
    			            copyArray(block, plaintext, i);
    			        }

    			        return plaintext;
    			    };


    			    /**
    			     *  Mode Of Operation - Cipher Block Chaining (CBC)
    			     */
    			    var ModeOfOperationCBC = function(key, iv) {
    			        if (!(this instanceof ModeOfOperationCBC)) {
    			            throw Error('AES must be instanitated with `new`');
    			        }

    			        this.description = "Cipher Block Chaining";
    			        this.name = "cbc";

    			        if (!iv) {
    			            iv = createArray(16);

    			        } else if (iv.length != 16) {
    			            throw new Error('invalid initialation vector size (must be 16 bytes)');
    			        }

    			        this._lastCipherblock = coerceArray(iv, true);

    			        this._aes = new AES(key);
    			    };

    			    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
    			        plaintext = coerceArray(plaintext);

    			        if ((plaintext.length % 16) !== 0) {
    			            throw new Error('invalid plaintext size (must be multiple of 16 bytes)');
    			        }

    			        var ciphertext = createArray(plaintext.length);
    			        var block = createArray(16);

    			        for (var i = 0; i < plaintext.length; i += 16) {
    			            copyArray(plaintext, block, 0, i, i + 16);

    			            for (var j = 0; j < 16; j++) {
    			                block[j] ^= this._lastCipherblock[j];
    			            }

    			            this._lastCipherblock = this._aes.encrypt(block);
    			            copyArray(this._lastCipherblock, ciphertext, i);
    			        }

    			        return ciphertext;
    			    };

    			    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
    			        ciphertext = coerceArray(ciphertext);

    			        if ((ciphertext.length % 16) !== 0) {
    			            throw new Error('invalid ciphertext size (must be multiple of 16 bytes)');
    			        }

    			        var plaintext = createArray(ciphertext.length);
    			        var block = createArray(16);

    			        for (var i = 0; i < ciphertext.length; i += 16) {
    			            copyArray(ciphertext, block, 0, i, i + 16);
    			            block = this._aes.decrypt(block);

    			            for (var j = 0; j < 16; j++) {
    			                plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
    			            }

    			            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
    			        }

    			        return plaintext;
    			    };


    			    /**
    			     *  Mode Of Operation - Cipher Feedback (CFB)
    			     */
    			    var ModeOfOperationCFB = function(key, iv, segmentSize) {
    			        if (!(this instanceof ModeOfOperationCFB)) {
    			            throw Error('AES must be instanitated with `new`');
    			        }

    			        this.description = "Cipher Feedback";
    			        this.name = "cfb";

    			        if (!iv) {
    			            iv = createArray(16);

    			        } else if (iv.length != 16) {
    			            throw new Error('invalid initialation vector size (must be 16 size)');
    			        }

    			        if (!segmentSize) { segmentSize = 1; }

    			        this.segmentSize = segmentSize;

    			        this._shiftRegister = coerceArray(iv, true);

    			        this._aes = new AES(key);
    			    };

    			    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
    			        if ((plaintext.length % this.segmentSize) != 0) {
    			            throw new Error('invalid plaintext size (must be segmentSize bytes)');
    			        }

    			        var encrypted = coerceArray(plaintext, true);

    			        var xorSegment;
    			        for (var i = 0; i < encrypted.length; i += this.segmentSize) {
    			            xorSegment = this._aes.encrypt(this._shiftRegister);
    			            for (var j = 0; j < this.segmentSize; j++) {
    			                encrypted[i + j] ^= xorSegment[j];
    			            }

    			            // Shift the register
    			            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
    			            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
    			        }

    			        return encrypted;
    			    };

    			    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
    			        if ((ciphertext.length % this.segmentSize) != 0) {
    			            throw new Error('invalid ciphertext size (must be segmentSize bytes)');
    			        }

    			        var plaintext = coerceArray(ciphertext, true);

    			        var xorSegment;
    			        for (var i = 0; i < plaintext.length; i += this.segmentSize) {
    			            xorSegment = this._aes.encrypt(this._shiftRegister);

    			            for (var j = 0; j < this.segmentSize; j++) {
    			                plaintext[i + j] ^= xorSegment[j];
    			            }

    			            // Shift the register
    			            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
    			            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
    			        }

    			        return plaintext;
    			    };

    			    /**
    			     *  Mode Of Operation - Output Feedback (OFB)
    			     */
    			    var ModeOfOperationOFB = function(key, iv) {
    			        if (!(this instanceof ModeOfOperationOFB)) {
    			            throw Error('AES must be instanitated with `new`');
    			        }

    			        this.description = "Output Feedback";
    			        this.name = "ofb";

    			        if (!iv) {
    			            iv = createArray(16);

    			        } else if (iv.length != 16) {
    			            throw new Error('invalid initialation vector size (must be 16 bytes)');
    			        }

    			        this._lastPrecipher = coerceArray(iv, true);
    			        this._lastPrecipherIndex = 16;

    			        this._aes = new AES(key);
    			    };

    			    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
    			        var encrypted = coerceArray(plaintext, true);

    			        for (var i = 0; i < encrypted.length; i++) {
    			            if (this._lastPrecipherIndex === 16) {
    			                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
    			                this._lastPrecipherIndex = 0;
    			            }
    			            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
    			        }

    			        return encrypted;
    			    };

    			    // Decryption is symetric
    			    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;


    			    /**
    			     *  Counter object for CTR common mode of operation
    			     */
    			    var Counter = function(initialValue) {
    			        if (!(this instanceof Counter)) {
    			            throw Error('Counter must be instanitated with `new`');
    			        }

    			        // We allow 0, but anything false-ish uses the default 1
    			        if (initialValue !== 0 && !initialValue) { initialValue = 1; }

    			        if (typeof(initialValue) === 'number') {
    			            this._counter = createArray(16);
    			            this.setValue(initialValue);

    			        } else {
    			            this.setBytes(initialValue);
    			        }
    			    };

    			    Counter.prototype.setValue = function(value) {
    			        if (typeof(value) !== 'number' || parseInt(value) != value) {
    			            throw new Error('invalid counter value (must be an integer)');
    			        }

    			        // We cannot safely handle numbers beyond the safe range for integers
    			        if (value > Number.MAX_SAFE_INTEGER) {
    			            throw new Error('integer value out of safe range');
    			        }

    			        for (var index = 15; index >= 0; --index) {
    			            this._counter[index] = value % 256;
    			            value = parseInt(value / 256);
    			        }
    			    };

    			    Counter.prototype.setBytes = function(bytes) {
    			        bytes = coerceArray(bytes, true);

    			        if (bytes.length != 16) {
    			            throw new Error('invalid counter bytes size (must be 16 bytes)');
    			        }

    			        this._counter = bytes;
    			    };

    			    Counter.prototype.increment = function() {
    			        for (var i = 15; i >= 0; i--) {
    			            if (this._counter[i] === 255) {
    			                this._counter[i] = 0;
    			            } else {
    			                this._counter[i]++;
    			                break;
    			            }
    			        }
    			    };


    			    /**
    			     *  Mode Of Operation - Counter (CTR)
    			     */
    			    var ModeOfOperationCTR = function(key, counter) {
    			        if (!(this instanceof ModeOfOperationCTR)) {
    			            throw Error('AES must be instanitated with `new`');
    			        }

    			        this.description = "Counter";
    			        this.name = "ctr";

    			        if (!(counter instanceof Counter)) {
    			            counter = new Counter(counter);
    			        }

    			        this._counter = counter;

    			        this._remainingCounter = null;
    			        this._remainingCounterIndex = 16;

    			        this._aes = new AES(key);
    			    };

    			    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
    			        var encrypted = coerceArray(plaintext, true);

    			        for (var i = 0; i < encrypted.length; i++) {
    			            if (this._remainingCounterIndex === 16) {
    			                this._remainingCounter = this._aes.encrypt(this._counter._counter);
    			                this._remainingCounterIndex = 0;
    			                this._counter.increment();
    			            }
    			            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
    			        }

    			        return encrypted;
    			    };

    			    // Decryption is symetric
    			    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;


    			    ///////////////////////
    			    // Padding

    			    // See:https://tools.ietf.org/html/rfc2315
    			    function pkcs7pad(data) {
    			        data = coerceArray(data, true);
    			        var padder = 16 - (data.length % 16);
    			        var result = createArray(data.length + padder);
    			        copyArray(data, result);
    			        for (var i = data.length; i < result.length; i++) {
    			            result[i] = padder;
    			        }
    			        return result;
    			    }

    			    function pkcs7strip(data) {
    			        data = coerceArray(data, true);
    			        if (data.length < 16) { throw new Error('PKCS#7 invalid length'); }

    			        var padder = data[data.length - 1];
    			        if (padder > 16) { throw new Error('PKCS#7 padding byte out of range'); }

    			        var length = data.length - padder;
    			        for (var i = 0; i < padder; i++) {
    			            if (data[length + i] !== padder) {
    			                throw new Error('PKCS#7 invalid padding byte');
    			            }
    			        }

    			        var result = createArray(length);
    			        copyArray(data, result, 0, 0, length);
    			        return result;
    			    }

    			    ///////////////////////
    			    // Exporting


    			    // The block cipher
    			    var aesjs = {
    			        AES: AES,
    			        Counter: Counter,

    			        ModeOfOperation: {
    			            ecb: ModeOfOperationECB,
    			            cbc: ModeOfOperationCBC,
    			            cfb: ModeOfOperationCFB,
    			            ofb: ModeOfOperationOFB,
    			            ctr: ModeOfOperationCTR
    			        },

    			        utils: {
    			            hex: convertHex,
    			            utf8: convertUtf8
    			        },

    			        padding: {
    			            pkcs7: {
    			                pad: pkcs7pad,
    			                strip: pkcs7strip
    			            }
    			        },

    			        _arrayTest: {
    			            coerceArray: coerceArray,
    			            createArray: createArray,
    			            copyArray: copyArray,
    			        }
    			    };


    			    // node.js
    			    {
    			        module.exports = aesjs;

    			    // RequireJS/AMD
    			    // http://www.requirejs.org/docs/api.html
    			    // https://github.com/amdjs/amdjs-api/wiki/AMD
    			    }


    			})(); 
    		} (aesJs, aesJs.exports));

    		var aesJsExports = aesJs.exports;
    		var aes = /*@__PURE__*/getDefaultExportFromCjs(aesJsExports);

    		var safeBuffer = {exports: {}};

    		/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
    		safeBuffer.exports;

    		(function (module, exports) {
    			/* eslint-disable node/no-deprecated-api */
    			var buffer = require$$0$3;
    			var Buffer = buffer.Buffer;

    			// alternative to using Object.keys for old browsers
    			function copyProps (src, dst) {
    			  for (var key in src) {
    			    dst[key] = src[key];
    			  }
    			}
    			if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
    			  module.exports = buffer;
    			} else {
    			  // Copy properties from require('buffer')
    			  copyProps(buffer, exports);
    			  exports.Buffer = SafeBuffer;
    			}

    			function SafeBuffer (arg, encodingOrOffset, length) {
    			  return Buffer(arg, encodingOrOffset, length)
    			}

    			SafeBuffer.prototype = Object.create(Buffer.prototype);

    			// Copy static methods from Buffer
    			copyProps(Buffer, SafeBuffer);

    			SafeBuffer.from = function (arg, encodingOrOffset, length) {
    			  if (typeof arg === 'number') {
    			    throw new TypeError('Argument must not be a number')
    			  }
    			  return Buffer(arg, encodingOrOffset, length)
    			};

    			SafeBuffer.alloc = function (size, fill, encoding) {
    			  if (typeof size !== 'number') {
    			    throw new TypeError('Argument must be a number')
    			  }
    			  var buf = Buffer(size);
    			  if (fill !== undefined) {
    			    if (typeof encoding === 'string') {
    			      buf.fill(fill, encoding);
    			    } else {
    			      buf.fill(fill);
    			    }
    			  } else {
    			    buf.fill(0);
    			  }
    			  return buf
    			};

    			SafeBuffer.allocUnsafe = function (size) {
    			  if (typeof size !== 'number') {
    			    throw new TypeError('Argument must be a number')
    			  }
    			  return Buffer(size)
    			};

    			SafeBuffer.allocUnsafeSlow = function (size) {
    			  if (typeof size !== 'number') {
    			    throw new TypeError('Argument must be a number')
    			  }
    			  return buffer.SlowBuffer(size)
    			}; 
    		} (safeBuffer, safeBuffer.exports));

    		var safeBufferExports = safeBuffer.exports;

    		var MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs

    		var precondition = function (iterations, keylen) {
    		  if (typeof iterations !== 'number') {
    		    throw new TypeError('Iterations not a number')
    		  }

    		  if (iterations < 0) {
    		    throw new TypeError('Bad iterations')
    		  }

    		  if (typeof keylen !== 'number') {
    		    throw new TypeError('Key length not a number')
    		  }

    		  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    		    throw new TypeError('Bad key length')
    		  }
    		};

    		var defaultEncoding$1;
    		/* istanbul ignore next */
    		if (commonjsGlobal$1.process && commonjsGlobal$1.process.browser) {
    		  defaultEncoding$1 = 'utf-8';
    		} else if (commonjsGlobal$1.process && commonjsGlobal$1.process.version) {
    		  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10);

    		  defaultEncoding$1 = pVersionMajor >= 6 ? 'utf-8' : 'binary';
    		} else {
    		  defaultEncoding$1 = 'utf-8';
    		}
    		var defaultEncoding_1 = defaultEncoding$1;

    		var readableBrowser = {exports: {}};

    		var domain;

    		// This constructor is used to store event handlers. Instantiating this is
    		// faster than explicitly calling `Object.create(null)` to get a "clean" empty
    		// object (tested with v8 v4.9).
    		function EventHandlers() {}
    		EventHandlers.prototype = Object.create(null);

    		function EventEmitter() {
    		  EventEmitter.init.call(this);
    		}

    		// nodejs oddity
    		// require('events') === require('events').EventEmitter
    		EventEmitter.EventEmitter = EventEmitter;

    		EventEmitter.usingDomains = false;

    		EventEmitter.prototype.domain = undefined;
    		EventEmitter.prototype._events = undefined;
    		EventEmitter.prototype._maxListeners = undefined;

    		// By default EventEmitters will print a warning if more than 10 listeners are
    		// added to it. This is a useful default which helps finding memory leaks.
    		EventEmitter.defaultMaxListeners = 10;

    		EventEmitter.init = function() {
    		  this.domain = null;
    		  if (EventEmitter.usingDomains) {
    		    // if there is an active domain, then attach to it.
    		    if (domain.active ) ;
    		  }

    		  if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
    		    this._events = new EventHandlers();
    		    this._eventsCount = 0;
    		  }

    		  this._maxListeners = this._maxListeners || undefined;
    		};

    		// Obviously not all Emitters should be limited to 10. This function allows
    		// that to be increased. Set to zero for unlimited.
    		EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    		  if (typeof n !== 'number' || n < 0 || isNaN(n))
    		    throw new TypeError('"n" argument must be a positive number');
    		  this._maxListeners = n;
    		  return this;
    		};

    		function $getMaxListeners(that) {
    		  if (that._maxListeners === undefined)
    		    return EventEmitter.defaultMaxListeners;
    		  return that._maxListeners;
    		}

    		EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    		  return $getMaxListeners(this);
    		};

    		// These standalone emit* functions are used to optimize calling of event
    		// handlers for fast cases because emit() itself often has a variable number of
    		// arguments and can be deoptimized because of that. These functions always have
    		// the same number of arguments and thus do not get deoptimized, so the code
    		// inside them can execute faster.
    		function emitNone(handler, isFn, self) {
    		  if (isFn)
    		    handler.call(self);
    		  else {
    		    var len = handler.length;
    		    var listeners = arrayClone(handler, len);
    		    for (var i = 0; i < len; ++i)
    		      listeners[i].call(self);
    		  }
    		}
    		function emitOne(handler, isFn, self, arg1) {
    		  if (isFn)
    		    handler.call(self, arg1);
    		  else {
    		    var len = handler.length;
    		    var listeners = arrayClone(handler, len);
    		    for (var i = 0; i < len; ++i)
    		      listeners[i].call(self, arg1);
    		  }
    		}
    		function emitTwo(handler, isFn, self, arg1, arg2) {
    		  if (isFn)
    		    handler.call(self, arg1, arg2);
    		  else {
    		    var len = handler.length;
    		    var listeners = arrayClone(handler, len);
    		    for (var i = 0; i < len; ++i)
    		      listeners[i].call(self, arg1, arg2);
    		  }
    		}
    		function emitThree(handler, isFn, self, arg1, arg2, arg3) {
    		  if (isFn)
    		    handler.call(self, arg1, arg2, arg3);
    		  else {
    		    var len = handler.length;
    		    var listeners = arrayClone(handler, len);
    		    for (var i = 0; i < len; ++i)
    		      listeners[i].call(self, arg1, arg2, arg3);
    		  }
    		}

    		function emitMany(handler, isFn, self, args) {
    		  if (isFn)
    		    handler.apply(self, args);
    		  else {
    		    var len = handler.length;
    		    var listeners = arrayClone(handler, len);
    		    for (var i = 0; i < len; ++i)
    		      listeners[i].apply(self, args);
    		  }
    		}

    		EventEmitter.prototype.emit = function emit(type) {
    		  var er, handler, len, args, i, events, domain;
    		  var doError = (type === 'error');

    		  events = this._events;
    		  if (events)
    		    doError = (doError && events.error == null);
    		  else if (!doError)
    		    return false;

    		  domain = this.domain;

    		  // If there is no 'error' event listener then throw.
    		  if (doError) {
    		    er = arguments[1];
    		    if (domain) {
    		      if (!er)
    		        er = new Error('Uncaught, unspecified "error" event');
    		      er.domainEmitter = this;
    		      er.domain = domain;
    		      er.domainThrown = false;
    		      domain.emit('error', er);
    		    } else if (er instanceof Error) {
    		      throw er; // Unhandled 'error' event
    		    } else {
    		      // At least give some kind of context to the user
    		      var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
    		      err.context = er;
    		      throw err;
    		    }
    		    return false;
    		  }

    		  handler = events[type];

    		  if (!handler)
    		    return false;

    		  var isFn = typeof handler === 'function';
    		  len = arguments.length;
    		  switch (len) {
    		    // fast cases
    		    case 1:
    		      emitNone(handler, isFn, this);
    		      break;
    		    case 2:
    		      emitOne(handler, isFn, this, arguments[1]);
    		      break;
    		    case 3:
    		      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
    		      break;
    		    case 4:
    		      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
    		      break;
    		    // slower
    		    default:
    		      args = new Array(len - 1);
    		      for (i = 1; i < len; i++)
    		        args[i - 1] = arguments[i];
    		      emitMany(handler, isFn, this, args);
    		  }

    		  return true;
    		};

    		function _addListener(target, type, listener, prepend) {
    		  var m;
    		  var events;
    		  var existing;

    		  if (typeof listener !== 'function')
    		    throw new TypeError('"listener" argument must be a function');

    		  events = target._events;
    		  if (!events) {
    		    events = target._events = new EventHandlers();
    		    target._eventsCount = 0;
    		  } else {
    		    // To avoid recursion in the case that type === "newListener"! Before
    		    // adding it to the listeners, first emit "newListener".
    		    if (events.newListener) {
    		      target.emit('newListener', type,
    		                  listener.listener ? listener.listener : listener);

    		      // Re-assign `events` because a newListener handler could have caused the
    		      // this._events to be assigned to a new object
    		      events = target._events;
    		    }
    		    existing = events[type];
    		  }

    		  if (!existing) {
    		    // Optimize the case of one listener. Don't need the extra array object.
    		    existing = events[type] = listener;
    		    ++target._eventsCount;
    		  } else {
    		    if (typeof existing === 'function') {
    		      // Adding the second element, need to change to array.
    		      existing = events[type] = prepend ? [listener, existing] :
    		                                          [existing, listener];
    		    } else {
    		      // If we've already got an array, just append.
    		      if (prepend) {
    		        existing.unshift(listener);
    		      } else {
    		        existing.push(listener);
    		      }
    		    }

    		    // Check for listener leak
    		    if (!existing.warned) {
    		      m = $getMaxListeners(target);
    		      if (m && m > 0 && existing.length > m) {
    		        existing.warned = true;
    		        var w = new Error('Possible EventEmitter memory leak detected. ' +
    		                            existing.length + ' ' + type + ' listeners added. ' +
    		                            'Use emitter.setMaxListeners() to increase limit');
    		        w.name = 'MaxListenersExceededWarning';
    		        w.emitter = target;
    		        w.type = type;
    		        w.count = existing.length;
    		        emitWarning(w);
    		      }
    		    }
    		  }

    		  return target;
    		}
    		function emitWarning(e) {
    		  typeof console.warn === 'function' ? console.warn(e) : console.log(e);
    		}
    		EventEmitter.prototype.addListener = function addListener(type, listener) {
    		  return _addListener(this, type, listener, false);
    		};

    		EventEmitter.prototype.on = EventEmitter.prototype.addListener;

    		EventEmitter.prototype.prependListener =
    		    function prependListener(type, listener) {
    		      return _addListener(this, type, listener, true);
    		    };

    		function _onceWrap(target, type, listener) {
    		  var fired = false;
    		  function g() {
    		    target.removeListener(type, g);
    		    if (!fired) {
    		      fired = true;
    		      listener.apply(target, arguments);
    		    }
    		  }
    		  g.listener = listener;
    		  return g;
    		}

    		EventEmitter.prototype.once = function once(type, listener) {
    		  if (typeof listener !== 'function')
    		    throw new TypeError('"listener" argument must be a function');
    		  this.on(type, _onceWrap(this, type, listener));
    		  return this;
    		};

    		EventEmitter.prototype.prependOnceListener =
    		    function prependOnceListener(type, listener) {
    		      if (typeof listener !== 'function')
    		        throw new TypeError('"listener" argument must be a function');
    		      this.prependListener(type, _onceWrap(this, type, listener));
    		      return this;
    		    };

    		// emits a 'removeListener' event iff the listener was removed
    		EventEmitter.prototype.removeListener =
    		    function removeListener(type, listener) {
    		      var list, events, position, i, originalListener;

    		      if (typeof listener !== 'function')
    		        throw new TypeError('"listener" argument must be a function');

    		      events = this._events;
    		      if (!events)
    		        return this;

    		      list = events[type];
    		      if (!list)
    		        return this;

    		      if (list === listener || (list.listener && list.listener === listener)) {
    		        if (--this._eventsCount === 0)
    		          this._events = new EventHandlers();
    		        else {
    		          delete events[type];
    		          if (events.removeListener)
    		            this.emit('removeListener', type, list.listener || listener);
    		        }
    		      } else if (typeof list !== 'function') {
    		        position = -1;

    		        for (i = list.length; i-- > 0;) {
    		          if (list[i] === listener ||
    		              (list[i].listener && list[i].listener === listener)) {
    		            originalListener = list[i].listener;
    		            position = i;
    		            break;
    		          }
    		        }

    		        if (position < 0)
    		          return this;

    		        if (list.length === 1) {
    		          list[0] = undefined;
    		          if (--this._eventsCount === 0) {
    		            this._events = new EventHandlers();
    		            return this;
    		          } else {
    		            delete events[type];
    		          }
    		        } else {
    		          spliceOne(list, position);
    		        }

    		        if (events.removeListener)
    		          this.emit('removeListener', type, originalListener || listener);
    		      }

    		      return this;
    		    };
    		    
    		// Alias for removeListener added in NodeJS 10.0
    		// https://nodejs.org/api/events.html#events_emitter_off_eventname_listener
    		EventEmitter.prototype.off = function(type, listener){
    		    return this.removeListener(type, listener);
    		};

    		EventEmitter.prototype.removeAllListeners =
    		    function removeAllListeners(type) {
    		      var listeners, events;

    		      events = this._events;
    		      if (!events)
    		        return this;

    		      // not listening for removeListener, no need to emit
    		      if (!events.removeListener) {
    		        if (arguments.length === 0) {
    		          this._events = new EventHandlers();
    		          this._eventsCount = 0;
    		        } else if (events[type]) {
    		          if (--this._eventsCount === 0)
    		            this._events = new EventHandlers();
    		          else
    		            delete events[type];
    		        }
    		        return this;
    		      }

    		      // emit removeListener for all listeners on all events
    		      if (arguments.length === 0) {
    		        var keys = Object.keys(events);
    		        for (var i = 0, key; i < keys.length; ++i) {
    		          key = keys[i];
    		          if (key === 'removeListener') continue;
    		          this.removeAllListeners(key);
    		        }
    		        this.removeAllListeners('removeListener');
    		        this._events = new EventHandlers();
    		        this._eventsCount = 0;
    		        return this;
    		      }

    		      listeners = events[type];

    		      if (typeof listeners === 'function') {
    		        this.removeListener(type, listeners);
    		      } else if (listeners) {
    		        // LIFO order
    		        do {
    		          this.removeListener(type, listeners[listeners.length - 1]);
    		        } while (listeners[0]);
    		      }

    		      return this;
    		    };

    		EventEmitter.prototype.listeners = function listeners(type) {
    		  var evlistener;
    		  var ret;
    		  var events = this._events;

    		  if (!events)
    		    ret = [];
    		  else {
    		    evlistener = events[type];
    		    if (!evlistener)
    		      ret = [];
    		    else if (typeof evlistener === 'function')
    		      ret = [evlistener.listener || evlistener];
    		    else
    		      ret = unwrapListeners(evlistener);
    		  }

    		  return ret;
    		};

    		EventEmitter.listenerCount = function(emitter, type) {
    		  if (typeof emitter.listenerCount === 'function') {
    		    return emitter.listenerCount(type);
    		  } else {
    		    return listenerCount.call(emitter, type);
    		  }
    		};

    		EventEmitter.prototype.listenerCount = listenerCount;
    		function listenerCount(type) {
    		  var events = this._events;

    		  if (events) {
    		    var evlistener = events[type];

    		    if (typeof evlistener === 'function') {
    		      return 1;
    		    } else if (evlistener) {
    		      return evlistener.length;
    		    }
    		  }

    		  return 0;
    		}

    		EventEmitter.prototype.eventNames = function eventNames() {
    		  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
    		};

    		// About 1.5x faster than the two-arg version of Array#splice().
    		function spliceOne(list, index) {
    		  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    		    list[i] = list[k];
    		  list.pop();
    		}

    		function arrayClone(arr, i) {
    		  var copy = new Array(i);
    		  while (i--)
    		    copy[i] = arr[i];
    		  return copy;
    		}

    		function unwrapListeners(arr) {
    		  var ret = new Array(arr.length);
    		  for (var i = 0; i < ret.length; ++i) {
    		    ret[i] = arr[i].listener || arr[i];
    		  }
    		  return ret;
    		}

    		var _polyfillNode_events = /*#__PURE__*/Object.freeze({
    			__proto__: null,
    			'default': EventEmitter,
    			EventEmitter: EventEmitter
    		});

    		var require$$0 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_events);

    		var streamBrowser = require$$0.EventEmitter;

    		// shim for using process in browser
    		// based off https://github.com/defunctzombie/node-process/blob/master/browser.js

    		function defaultSetTimout() {
    		    throw new Error('setTimeout has not been defined');
    		}
    		function defaultClearTimeout () {
    		    throw new Error('clearTimeout has not been defined');
    		}
    		var cachedSetTimeout = defaultSetTimout;
    		var cachedClearTimeout = defaultClearTimeout;
    		if (typeof global$1.setTimeout === 'function') {
    		    cachedSetTimeout = setTimeout;
    		}
    		if (typeof global$1.clearTimeout === 'function') {
    		    cachedClearTimeout = clearTimeout;
    		}

    		function runTimeout(fun) {
    		    if (cachedSetTimeout === setTimeout) {
    		        //normal enviroments in sane situations
    		        return setTimeout(fun, 0);
    		    }
    		    // if setTimeout wasn't available but was latter defined
    		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
    		        cachedSetTimeout = setTimeout;
    		        return setTimeout(fun, 0);
    		    }
    		    try {
    		        // when when somebody has screwed with setTimeout but no I.E. maddness
    		        return cachedSetTimeout(fun, 0);
    		    } catch(e){
    		        try {
    		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
    		            return cachedSetTimeout.call(null, fun, 0);
    		        } catch(e){
    		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
    		            return cachedSetTimeout.call(this, fun, 0);
    		        }
    		    }


    		}
    		function runClearTimeout(marker) {
    		    if (cachedClearTimeout === clearTimeout) {
    		        //normal enviroments in sane situations
    		        return clearTimeout(marker);
    		    }
    		    // if clearTimeout wasn't available but was latter defined
    		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
    		        cachedClearTimeout = clearTimeout;
    		        return clearTimeout(marker);
    		    }
    		    try {
    		        // when when somebody has screwed with setTimeout but no I.E. maddness
    		        return cachedClearTimeout(marker);
    		    } catch (e){
    		        try {
    		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
    		            return cachedClearTimeout.call(null, marker);
    		        } catch (e){
    		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
    		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
    		            return cachedClearTimeout.call(this, marker);
    		        }
    		    }



    		}
    		var queue = [];
    		var draining = false;
    		var currentQueue;
    		var queueIndex = -1;

    		function cleanUpNextTick() {
    		    if (!draining || !currentQueue) {
    		        return;
    		    }
    		    draining = false;
    		    if (currentQueue.length) {
    		        queue = currentQueue.concat(queue);
    		    } else {
    		        queueIndex = -1;
    		    }
    		    if (queue.length) {
    		        drainQueue();
    		    }
    		}

    		function drainQueue() {
    		    if (draining) {
    		        return;
    		    }
    		    var timeout = runTimeout(cleanUpNextTick);
    		    draining = true;

    		    var len = queue.length;
    		    while(len) {
    		        currentQueue = queue;
    		        queue = [];
    		        while (++queueIndex < len) {
    		            if (currentQueue) {
    		                currentQueue[queueIndex].run();
    		            }
    		        }
    		        queueIndex = -1;
    		        len = queue.length;
    		    }
    		    currentQueue = null;
    		    draining = false;
    		    runClearTimeout(timeout);
    		}
    		function nextTick(fun) {
    		    var args = new Array(arguments.length - 1);
    		    if (arguments.length > 1) {
    		        for (var i = 1; i < arguments.length; i++) {
    		            args[i - 1] = arguments[i];
    		        }
    		    }
    		    queue.push(new Item(fun, args));
    		    if (queue.length === 1 && !draining) {
    		        runTimeout(drainQueue);
    		    }
    		}
    		// v8 likes predictible objects
    		function Item(fun, array) {
    		    this.fun = fun;
    		    this.array = array;
    		}
    		Item.prototype.run = function () {
    		    this.fun.apply(null, this.array);
    		};
    		var title = 'browser';
    		var platform = 'browser';
    		var browser$1 = true;
    		var env = {};
    		var argv = [];
    		var version = ''; // empty string to avoid regexp issues
    		var versions = {};
    		var release = {};
    		var config$1 = {};

    		function noop$2() {}

    		var on = noop$2;
    		var addListener = noop$2;
    		var once$2 = noop$2;
    		var off = noop$2;
    		var removeListener = noop$2;
    		var removeAllListeners = noop$2;
    		var emit = noop$2;

    		function binding(name) {
    		    throw new Error('process.binding is not supported');
    		}

    		function cwd () { return '/' }
    		function chdir (dir) {
    		    throw new Error('process.chdir is not supported');
    		}function umask() { return 0; }

    		// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
    		var performance = global$1.performance || {};
    		var performanceNow =
    		  performance.now        ||
    		  performance.mozNow     ||
    		  performance.msNow      ||
    		  performance.oNow       ||
    		  performance.webkitNow  ||
    		  function(){ return (new Date()).getTime() };

    		// generate timestamp or delta
    		// see http://nodejs.org/api/process.html#process_process_hrtime
    		function hrtime(previousTimestamp){
    		  var clocktime = performanceNow.call(performance)*1e-3;
    		  var seconds = Math.floor(clocktime);
    		  var nanoseconds = Math.floor((clocktime%1)*1e9);
    		  if (previousTimestamp) {
    		    seconds = seconds - previousTimestamp[0];
    		    nanoseconds = nanoseconds - previousTimestamp[1];
    		    if (nanoseconds<0) {
    		      seconds--;
    		      nanoseconds += 1e9;
    		    }
    		  }
    		  return [seconds,nanoseconds]
    		}

    		var startTime = new Date();
    		function uptime() {
    		  var currentTime = new Date();
    		  var dif = currentTime - startTime;
    		  return dif / 1000;
    		}

    		var browser$1$1 = {
    		  nextTick: nextTick,
    		  title: title,
    		  browser: browser$1,
    		  env: env,
    		  argv: argv,
    		  version: version,
    		  versions: versions,
    		  on: on,
    		  addListener: addListener,
    		  once: once$2,
    		  off: off,
    		  removeListener: removeListener,
    		  removeAllListeners: removeAllListeners,
    		  emit: emit,
    		  binding: binding,
    		  cwd: cwd,
    		  chdir: chdir,
    		  umask: umask,
    		  hrtime: hrtime,
    		  platform: platform,
    		  release: release,
    		  config: config$1,
    		  uptime: uptime
    		};

    		var inherits$9;
    		if (typeof Object.create === 'function'){
    		  inherits$9 = function inherits(ctor, superCtor) {
    		    // implementation from standard node.js 'util' module
    		    ctor.super_ = superCtor;
    		    ctor.prototype = Object.create(superCtor.prototype, {
    		      constructor: {
    		        value: ctor,
    		        enumerable: false,
    		        writable: true,
    		        configurable: true
    		      }
    		    });
    		  };
    		} else {
    		  inherits$9 = function inherits(ctor, superCtor) {
    		    ctor.super_ = superCtor;
    		    var TempCtor = function () {};
    		    TempCtor.prototype = superCtor.prototype;
    		    ctor.prototype = new TempCtor();
    		    ctor.prototype.constructor = ctor;
    		  };
    		}
    		var inherits$a = inherits$9;

    		var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
    		  function getOwnPropertyDescriptors(obj) {
    		    var keys = Object.keys(obj);
    		    var descriptors = {};
    		    for (var i = 0; i < keys.length; i++) {
    		      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    		    }
    		    return descriptors;
    		  };

    		var formatRegExp = /%[sdj%]/g;
    		function format(f) {
    		  if (!isString(f)) {
    		    var objects = [];
    		    for (var i = 0; i < arguments.length; i++) {
    		      objects.push(inspect(arguments[i]));
    		    }
    		    return objects.join(' ');
    		  }

    		  var i = 1;
    		  var args = arguments;
    		  var len = args.length;
    		  var str = String(f).replace(formatRegExp, function(x) {
    		    if (x === '%%') return '%';
    		    if (i >= len) return x;
    		    switch (x) {
    		      case '%s': return String(args[i++]);
    		      case '%d': return Number(args[i++]);
    		      case '%j':
    		        try {
    		          return JSON.stringify(args[i++]);
    		        } catch (_) {
    		          return '[Circular]';
    		        }
    		      default:
    		        return x;
    		    }
    		  });
    		  for (var x = args[i]; i < len; x = args[++i]) {
    		    if (isNull(x) || !isObject(x)) {
    		      str += ' ' + x;
    		    } else {
    		      str += ' ' + inspect(x);
    		    }
    		  }
    		  return str;
    		}

    		// Mark that a method should not be used.
    		// Returns a modified function which warns once by default.
    		// If --no-deprecation is set, then it is a no-op.
    		function deprecate$1(fn, msg) {
    		  // Allow for deprecating things in the process of starting up.
    		  if (isUndefined(global$1.process)) {
    		    return function() {
    		      return deprecate$1(fn, msg).apply(this, arguments);
    		    };
    		  }

    		  if (browser$1$1.noDeprecation === true) {
    		    return fn;
    		  }

    		  var warned = false;
    		  function deprecated() {
    		    if (!warned) {
    		      if (browser$1$1.throwDeprecation) {
    		        throw new Error(msg);
    		      } else if (browser$1$1.traceDeprecation) {
    		        console.trace(msg);
    		      } else {
    		        console.error(msg);
    		      }
    		      warned = true;
    		    }
    		    return fn.apply(this, arguments);
    		  }

    		  return deprecated;
    		}

    		var debugs = {};
    		var debugEnviron;
    		function debuglog(set) {
    		  if (isUndefined(debugEnviron))
    		    debugEnviron = browser$1$1.env.NODE_DEBUG || '';
    		  set = set.toUpperCase();
    		  if (!debugs[set]) {
    		    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
    		      var pid = 0;
    		      debugs[set] = function() {
    		        var msg = format.apply(null, arguments);
    		        console.error('%s %d: %s', set, pid, msg);
    		      };
    		    } else {
    		      debugs[set] = function() {};
    		    }
    		  }
    		  return debugs[set];
    		}

    		/**
    		 * Echos the value of a value. Trys to print the value out
    		 * in the best way possible given the different types.
    		 *
    		 * @param {Object} obj The object to print out.
    		 * @param {Object} opts Optional options object that alters the output.
    		 */
    		/* legacy: obj, showHidden, depth, colors*/
    		function inspect(obj, opts) {
    		  // default options
    		  var ctx = {
    		    seen: [],
    		    stylize: stylizeNoColor
    		  };
    		  // legacy...
    		  if (arguments.length >= 3) ctx.depth = arguments[2];
    		  if (arguments.length >= 4) ctx.colors = arguments[3];
    		  if (isBoolean(opts)) {
    		    // legacy...
    		    ctx.showHidden = opts;
    		  } else if (opts) {
    		    // got an "options" object
    		    _extend(ctx, opts);
    		  }
    		  // set default options
    		  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
    		  if (isUndefined(ctx.depth)) ctx.depth = 2;
    		  if (isUndefined(ctx.colors)) ctx.colors = false;
    		  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
    		  if (ctx.colors) ctx.stylize = stylizeWithColor;
    		  return formatValue(ctx, obj, ctx.depth);
    		}

    		// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
    		inspect.colors = {
    		  'bold' : [1, 22],
    		  'italic' : [3, 23],
    		  'underline' : [4, 24],
    		  'inverse' : [7, 27],
    		  'white' : [37, 39],
    		  'grey' : [90, 39],
    		  'black' : [30, 39],
    		  'blue' : [34, 39],
    		  'cyan' : [36, 39],
    		  'green' : [32, 39],
    		  'magenta' : [35, 39],
    		  'red' : [31, 39],
    		  'yellow' : [33, 39]
    		};

    		// Don't use 'blue' not visible on cmd.exe
    		inspect.styles = {
    		  'special': 'cyan',
    		  'number': 'yellow',
    		  'boolean': 'yellow',
    		  'undefined': 'grey',
    		  'null': 'bold',
    		  'string': 'green',
    		  'date': 'magenta',
    		  // "name": intentionally not styling
    		  'regexp': 'red'
    		};


    		function stylizeWithColor(str, styleType) {
    		  var style = inspect.styles[styleType];

    		  if (style) {
    		    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
    		           '\u001b[' + inspect.colors[style][1] + 'm';
    		  } else {
    		    return str;
    		  }
    		}


    		function stylizeNoColor(str, styleType) {
    		  return str;
    		}


    		function arrayToHash(array) {
    		  var hash = {};

    		  array.forEach(function(val, idx) {
    		    hash[val] = true;
    		  });

    		  return hash;
    		}


    		function formatValue(ctx, value, recurseTimes) {
    		  // Provide a hook for user-specified inspect functions.
    		  // Check that value is an object with an inspect function on it
    		  if (ctx.customInspect &&
    		      value &&
    		      isFunction(value.inspect) &&
    		      // Filter out the util module, it's inspect function is special
    		      value.inspect !== inspect &&
    		      // Also filter out any prototype objects using the circular check.
    		      !(value.constructor && value.constructor.prototype === value)) {
    		    var ret = value.inspect(recurseTimes, ctx);
    		    if (!isString(ret)) {
    		      ret = formatValue(ctx, ret, recurseTimes);
    		    }
    		    return ret;
    		  }

    		  // Primitive types cannot have properties
    		  var primitive = formatPrimitive(ctx, value);
    		  if (primitive) {
    		    return primitive;
    		  }

    		  // Look up the keys of the object.
    		  var keys = Object.keys(value);
    		  var visibleKeys = arrayToHash(keys);

    		  if (ctx.showHidden) {
    		    keys = Object.getOwnPropertyNames(value);
    		  }

    		  // IE doesn't make error fields non-enumerable
    		  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    		  if (isError(value)
    		      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    		    return formatError(value);
    		  }

    		  // Some type of object without properties can be shortcutted.
    		  if (keys.length === 0) {
    		    if (isFunction(value)) {
    		      var name = value.name ? ': ' + value.name : '';
    		      return ctx.stylize('[Function' + name + ']', 'special');
    		    }
    		    if (isRegExp(value)) {
    		      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    		    }
    		    if (isDate(value)) {
    		      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    		    }
    		    if (isError(value)) {
    		      return formatError(value);
    		    }
    		  }

    		  var base = '', array = false, braces = ['{', '}'];

    		  // Make Array say that they are Array
    		  if (isArray(value)) {
    		    array = true;
    		    braces = ['[', ']'];
    		  }

    		  // Make functions say that they are functions
    		  if (isFunction(value)) {
    		    var n = value.name ? ': ' + value.name : '';
    		    base = ' [Function' + n + ']';
    		  }

    		  // Make RegExps say that they are RegExps
    		  if (isRegExp(value)) {
    		    base = ' ' + RegExp.prototype.toString.call(value);
    		  }

    		  // Make dates with properties first say the date
    		  if (isDate(value)) {
    		    base = ' ' + Date.prototype.toUTCString.call(value);
    		  }

    		  // Make error with message first say the error
    		  if (isError(value)) {
    		    base = ' ' + formatError(value);
    		  }

    		  if (keys.length === 0 && (!array || value.length == 0)) {
    		    return braces[0] + base + braces[1];
    		  }

    		  if (recurseTimes < 0) {
    		    if (isRegExp(value)) {
    		      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    		    } else {
    		      return ctx.stylize('[Object]', 'special');
    		    }
    		  }

    		  ctx.seen.push(value);

    		  var output;
    		  if (array) {
    		    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    		  } else {
    		    output = keys.map(function(key) {
    		      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    		    });
    		  }

    		  ctx.seen.pop();

    		  return reduceToSingleString(output, base, braces);
    		}


    		function formatPrimitive(ctx, value) {
    		  if (isUndefined(value))
    		    return ctx.stylize('undefined', 'undefined');
    		  if (isString(value)) {
    		    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
    		                                             .replace(/'/g, "\\'")
    		                                             .replace(/\\"/g, '"') + '\'';
    		    return ctx.stylize(simple, 'string');
    		  }
    		  if (isNumber(value))
    		    return ctx.stylize('' + value, 'number');
    		  if (isBoolean(value))
    		    return ctx.stylize('' + value, 'boolean');
    		  // For some reason typeof null is "object", so special case here.
    		  if (isNull(value))
    		    return ctx.stylize('null', 'null');
    		}


    		function formatError(value) {
    		  return '[' + Error.prototype.toString.call(value) + ']';
    		}


    		function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    		  var output = [];
    		  for (var i = 0, l = value.length; i < l; ++i) {
    		    if (hasOwnProperty(value, String(i))) {
    		      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
    		          String(i), true));
    		    } else {
    		      output.push('');
    		    }
    		  }
    		  keys.forEach(function(key) {
    		    if (!key.match(/^\d+$/)) {
    		      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
    		          key, true));
    		    }
    		  });
    		  return output;
    		}


    		function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    		  var name, str, desc;
    		  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
    		  if (desc.get) {
    		    if (desc.set) {
    		      str = ctx.stylize('[Getter/Setter]', 'special');
    		    } else {
    		      str = ctx.stylize('[Getter]', 'special');
    		    }
    		  } else {
    		    if (desc.set) {
    		      str = ctx.stylize('[Setter]', 'special');
    		    }
    		  }
    		  if (!hasOwnProperty(visibleKeys, key)) {
    		    name = '[' + key + ']';
    		  }
    		  if (!str) {
    		    if (ctx.seen.indexOf(desc.value) < 0) {
    		      if (isNull(recurseTimes)) {
    		        str = formatValue(ctx, desc.value, null);
    		      } else {
    		        str = formatValue(ctx, desc.value, recurseTimes - 1);
    		      }
    		      if (str.indexOf('\n') > -1) {
    		        if (array) {
    		          str = str.split('\n').map(function(line) {
    		            return '  ' + line;
    		          }).join('\n').substr(2);
    		        } else {
    		          str = '\n' + str.split('\n').map(function(line) {
    		            return '   ' + line;
    		          }).join('\n');
    		        }
    		      }
    		    } else {
    		      str = ctx.stylize('[Circular]', 'special');
    		    }
    		  }
    		  if (isUndefined(name)) {
    		    if (array && key.match(/^\d+$/)) {
    		      return str;
    		    }
    		    name = JSON.stringify('' + key);
    		    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
    		      name = name.substr(1, name.length - 2);
    		      name = ctx.stylize(name, 'name');
    		    } else {
    		      name = name.replace(/'/g, "\\'")
    		                 .replace(/\\"/g, '"')
    		                 .replace(/(^"|"$)/g, "'");
    		      name = ctx.stylize(name, 'string');
    		    }
    		  }

    		  return name + ': ' + str;
    		}


    		function reduceToSingleString(output, base, braces) {
    		  var length = output.reduce(function(prev, cur) {
    		    if (cur.indexOf('\n') >= 0) ;
    		    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    		  }, 0);

    		  if (length > 60) {
    		    return braces[0] +
    		           (base === '' ? '' : base + '\n ') +
    		           ' ' +
    		           output.join(',\n  ') +
    		           ' ' +
    		           braces[1];
    		  }

    		  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
    		}


    		// NOTE: These type checking functions intentionally don't use `instanceof`
    		// because it is fragile and can be easily faked with `Object.create()`.
    		function isArray(ar) {
    		  return Array.isArray(ar);
    		}

    		function isBoolean(arg) {
    		  return typeof arg === 'boolean';
    		}

    		function isNull(arg) {
    		  return arg === null;
    		}

    		function isNullOrUndefined(arg) {
    		  return arg == null;
    		}

    		function isNumber(arg) {
    		  return typeof arg === 'number';
    		}

    		function isString(arg) {
    		  return typeof arg === 'string';
    		}

    		function isSymbol(arg) {
    		  return typeof arg === 'symbol';
    		}

    		function isUndefined(arg) {
    		  return arg === void 0;
    		}

    		function isRegExp(re) {
    		  return isObject(re) && objectToString(re) === '[object RegExp]';
    		}

    		function isObject(arg) {
    		  return typeof arg === 'object' && arg !== null;
    		}

    		function isDate(d) {
    		  return isObject(d) && objectToString(d) === '[object Date]';
    		}

    		function isError(e) {
    		  return isObject(e) &&
    		      (objectToString(e) === '[object Error]' || e instanceof Error);
    		}

    		function isFunction(arg) {
    		  return typeof arg === 'function';
    		}

    		function isPrimitive(arg) {
    		  return arg === null ||
    		         typeof arg === 'boolean' ||
    		         typeof arg === 'number' ||
    		         typeof arg === 'string' ||
    		         typeof arg === 'symbol' ||  // ES6 symbol
    		         typeof arg === 'undefined';
    		}

    		function isBuffer(maybeBuf) {
    		  return Buffer$c.isBuffer(maybeBuf);
    		}

    		function objectToString(o) {
    		  return Object.prototype.toString.call(o);
    		}


    		function pad(n) {
    		  return n < 10 ? '0' + n.toString(10) : n.toString(10);
    		}


    		var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
    		              'Oct', 'Nov', 'Dec'];

    		// 26 Feb 16:19:34
    		function timestamp() {
    		  var d = new Date();
    		  var time = [pad(d.getHours()),
    		              pad(d.getMinutes()),
    		              pad(d.getSeconds())].join(':');
    		  return [d.getDate(), months[d.getMonth()], time].join(' ');
    		}


    		// log is just a thin wrapper to console.log that prepends a timestamp
    		function log() {
    		  console.log('%s - %s', timestamp(), format.apply(null, arguments));
    		}

    		function _extend(origin, add) {
    		  // Don't do anything if add isn't an object
    		  if (!add || !isObject(add)) return origin;

    		  var keys = Object.keys(add);
    		  var i = keys.length;
    		  while (i--) {
    		    origin[keys[i]] = add[keys[i]];
    		  }
    		  return origin;
    		}
    		function hasOwnProperty(obj, prop) {
    		  return Object.prototype.hasOwnProperty.call(obj, prop);
    		}

    		var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

    		function promisify(original) {
    		  if (typeof original !== 'function')
    		    throw new TypeError('The "original" argument must be of type Function');

    		  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    		    var fn = original[kCustomPromisifiedSymbol];
    		    if (typeof fn !== 'function') {
    		      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    		    }
    		    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    		      value: fn, enumerable: false, writable: false, configurable: true
    		    });
    		    return fn;
    		  }

    		  function fn() {
    		    var promiseResolve, promiseReject;
    		    var promise = new Promise(function (resolve, reject) {
    		      promiseResolve = resolve;
    		      promiseReject = reject;
    		    });

    		    var args = [];
    		    for (var i = 0; i < arguments.length; i++) {
    		      args.push(arguments[i]);
    		    }
    		    args.push(function (err, value) {
    		      if (err) {
    		        promiseReject(err);
    		      } else {
    		        promiseResolve(value);
    		      }
    		    });

    		    try {
    		      original.apply(this, args);
    		    } catch (err) {
    		      promiseReject(err);
    		    }

    		    return promise;
    		  }

    		  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

    		  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    		    value: fn, enumerable: false, writable: false, configurable: true
    		  });
    		  return Object.defineProperties(
    		    fn,
    		    getOwnPropertyDescriptors(original)
    		  );
    		}

    		promisify.custom = kCustomPromisifiedSymbol;

    		function callbackifyOnRejected(reason, cb) {
    		  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    		  // Because `null` is a special error value in callbacks which means "no error
    		  // occurred", we error-wrap so the callback consumer can distinguish between
    		  // "the promise rejected with null" or "the promise fulfilled with undefined".
    		  if (!reason) {
    		    var newReason = new Error('Promise was rejected with a falsy value');
    		    newReason.reason = reason;
    		    reason = newReason;
    		  }
    		  return cb(reason);
    		}

    		function callbackify(original) {
    		  if (typeof original !== 'function') {
    		    throw new TypeError('The "original" argument must be of type Function');
    		  }

    		  // We DO NOT return the promise as it gives the user a false sense that
    		  // the promise is actually somehow related to the callback's execution
    		  // and that the callback throwing will reject the promise.
    		  function callbackified() {
    		    var args = [];
    		    for (var i = 0; i < arguments.length; i++) {
    		      args.push(arguments[i]);
    		    }

    		    var maybeCb = args.pop();
    		    if (typeof maybeCb !== 'function') {
    		      throw new TypeError('The last argument must be of type Function');
    		    }
    		    var self = this;
    		    var cb = function() {
    		      return maybeCb.apply(self, arguments);
    		    };
    		    // In true node style we process the callback on `nextTick` with all the
    		    // implications (stack, `uncaughtException`, `async_hooks`)
    		    original.apply(this, args)
    		      .then(function(ret) { browser$1$1.nextTick(cb.bind(null, null, ret)); },
    		        function(rej) { browser$1$1.nextTick(callbackifyOnRejected.bind(null, rej, cb)); });
    		  }

    		  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    		  Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
    		  return callbackified;
    		}

    		var _polyfillNode_util = {
    		  inherits: inherits$a,
    		  _extend: _extend,
    		  log: log,
    		  isBuffer: isBuffer,
    		  isPrimitive: isPrimitive,
    		  isFunction: isFunction,
    		  isError: isError,
    		  isDate: isDate,
    		  isObject: isObject,
    		  isRegExp: isRegExp,
    		  isUndefined: isUndefined,
    		  isSymbol: isSymbol,
    		  isString: isString,
    		  isNumber: isNumber,
    		  isNullOrUndefined: isNullOrUndefined,
    		  isNull: isNull,
    		  isBoolean: isBoolean,
    		  isArray: isArray,
    		  inspect: inspect,
    		  deprecate: deprecate$1,
    		  format: format,
    		  debuglog: debuglog,
    		  promisify: promisify,
    		  callbackify: callbackify,
    		};

    		var _polyfillNode_util$1 = /*#__PURE__*/Object.freeze({
    			__proto__: null,
    			format: format,
    			deprecate: deprecate$1,
    			debuglog: debuglog,
    			inspect: inspect,
    			isArray: isArray,
    			isBoolean: isBoolean,
    			isNull: isNull,
    			isNullOrUndefined: isNullOrUndefined,
    			isNumber: isNumber,
    			isString: isString,
    			isSymbol: isSymbol,
    			isUndefined: isUndefined,
    			isRegExp: isRegExp,
    			isObject: isObject,
    			isDate: isDate,
    			isError: isError,
    			isFunction: isFunction,
    			isPrimitive: isPrimitive,
    			isBuffer: isBuffer,
    			log: log,
    			inherits: inherits$a,
    			_extend: _extend,
    			promisify: promisify,
    			callbackify: callbackify,
    			'default': _polyfillNode_util
    		});

    		var require$$3 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_util$1);

    		var buffer_list;
    		var hasRequiredBuffer_list;

    		function requireBuffer_list () {
    			if (hasRequiredBuffer_list) return buffer_list;
    			hasRequiredBuffer_list = 1;

    			function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
    			function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
    			function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
    			function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
    			function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
    			const _require = require$$0$3,
    			  Buffer = _require.Buffer;
    			const _require2 = require$$3,
    			  inspect = _require2.inspect;
    			const custom = inspect && inspect.custom || 'inspect';
    			function copyBuffer(src, target, offset) {
    			  Buffer.prototype.copy.call(src, target, offset);
    			}
    			buffer_list = class BufferList {
    			  constructor() {
    			    this.head = null;
    			    this.tail = null;
    			    this.length = 0;
    			  }
    			  push(v) {
    			    const entry = {
    			      data: v,
    			      next: null
    			    };
    			    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    			    this.tail = entry;
    			    ++this.length;
    			  }
    			  unshift(v) {
    			    const entry = {
    			      data: v,
    			      next: this.head
    			    };
    			    if (this.length === 0) this.tail = entry;
    			    this.head = entry;
    			    ++this.length;
    			  }
    			  shift() {
    			    if (this.length === 0) return;
    			    const ret = this.head.data;
    			    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    			    --this.length;
    			    return ret;
    			  }
    			  clear() {
    			    this.head = this.tail = null;
    			    this.length = 0;
    			  }
    			  join(s) {
    			    if (this.length === 0) return '';
    			    var p = this.head;
    			    var ret = '' + p.data;
    			    while (p = p.next) ret += s + p.data;
    			    return ret;
    			  }
    			  concat(n) {
    			    if (this.length === 0) return Buffer.alloc(0);
    			    const ret = Buffer.allocUnsafe(n >>> 0);
    			    var p = this.head;
    			    var i = 0;
    			    while (p) {
    			      copyBuffer(p.data, ret, i);
    			      i += p.data.length;
    			      p = p.next;
    			    }
    			    return ret;
    			  }

    			  // Consumes a specified amount of bytes or characters from the buffered data.
    			  consume(n, hasStrings) {
    			    var ret;
    			    if (n < this.head.data.length) {
    			      // `slice` is the same for buffers and strings.
    			      ret = this.head.data.slice(0, n);
    			      this.head.data = this.head.data.slice(n);
    			    } else if (n === this.head.data.length) {
    			      // First chunk is a perfect match.
    			      ret = this.shift();
    			    } else {
    			      // Result spans more than one buffer.
    			      ret = hasStrings ? this._getString(n) : this._getBuffer(n);
    			    }
    			    return ret;
    			  }
    			  first() {
    			    return this.head.data;
    			  }

    			  // Consumes a specified amount of characters from the buffered data.
    			  _getString(n) {
    			    var p = this.head;
    			    var c = 1;
    			    var ret = p.data;
    			    n -= ret.length;
    			    while (p = p.next) {
    			      const str = p.data;
    			      const nb = n > str.length ? str.length : n;
    			      if (nb === str.length) ret += str;else ret += str.slice(0, n);
    			      n -= nb;
    			      if (n === 0) {
    			        if (nb === str.length) {
    			          ++c;
    			          if (p.next) this.head = p.next;else this.head = this.tail = null;
    			        } else {
    			          this.head = p;
    			          p.data = str.slice(nb);
    			        }
    			        break;
    			      }
    			      ++c;
    			    }
    			    this.length -= c;
    			    return ret;
    			  }

    			  // Consumes a specified amount of bytes from the buffered data.
    			  _getBuffer(n) {
    			    const ret = Buffer.allocUnsafe(n);
    			    var p = this.head;
    			    var c = 1;
    			    p.data.copy(ret);
    			    n -= p.data.length;
    			    while (p = p.next) {
    			      const buf = p.data;
    			      const nb = n > buf.length ? buf.length : n;
    			      buf.copy(ret, ret.length - n, 0, nb);
    			      n -= nb;
    			      if (n === 0) {
    			        if (nb === buf.length) {
    			          ++c;
    			          if (p.next) this.head = p.next;else this.head = this.tail = null;
    			        } else {
    			          this.head = p;
    			          p.data = buf.slice(nb);
    			        }
    			        break;
    			      }
    			      ++c;
    			    }
    			    this.length -= c;
    			    return ret;
    			  }

    			  // Make sure the linked list only shows the minimal necessary information.
    			  [custom](_, options) {
    			    return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
    			      // Only inspect one level.
    			      depth: 0,
    			      // It should not recurse.
    			      customInspect: false
    			    }));
    			  }
    			};
    			return buffer_list;
    		}

    		// undocumented cb() API, needed for core, not for public API
    		function destroy(err, cb) {
    		  const readableDestroyed = this._readableState && this._readableState.destroyed;
    		  const writableDestroyed = this._writableState && this._writableState.destroyed;
    		  if (readableDestroyed || writableDestroyed) {
    		    if (cb) {
    		      cb(err);
    		    } else if (err) {
    		      if (!this._writableState) {
    		        process.nextTick(emitErrorNT, this, err);
    		      } else if (!this._writableState.errorEmitted) {
    		        this._writableState.errorEmitted = true;
    		        process.nextTick(emitErrorNT, this, err);
    		      }
    		    }
    		    return this;
    		  }

    		  // we set destroyed to true before firing error callbacks in order
    		  // to make it re-entrance safe in case destroy() is called within callbacks

    		  if (this._readableState) {
    		    this._readableState.destroyed = true;
    		  }

    		  // if this is a duplex stream mark the writable part as destroyed as well
    		  if (this._writableState) {
    		    this._writableState.destroyed = true;
    		  }
    		  this._destroy(err || null, err => {
    		    if (!cb && err) {
    		      if (!this._writableState) {
    		        process.nextTick(emitErrorAndCloseNT, this, err);
    		      } else if (!this._writableState.errorEmitted) {
    		        this._writableState.errorEmitted = true;
    		        process.nextTick(emitErrorAndCloseNT, this, err);
    		      } else {
    		        process.nextTick(emitCloseNT, this);
    		      }
    		    } else if (cb) {
    		      process.nextTick(emitCloseNT, this);
    		      cb(err);
    		    } else {
    		      process.nextTick(emitCloseNT, this);
    		    }
    		  });
    		  return this;
    		}
    		function emitErrorAndCloseNT(self, err) {
    		  emitErrorNT(self, err);
    		  emitCloseNT(self);
    		}
    		function emitCloseNT(self) {
    		  if (self._writableState && !self._writableState.emitClose) return;
    		  if (self._readableState && !self._readableState.emitClose) return;
    		  self.emit('close');
    		}
    		function undestroy() {
    		  if (this._readableState) {
    		    this._readableState.destroyed = false;
    		    this._readableState.reading = false;
    		    this._readableState.ended = false;
    		    this._readableState.endEmitted = false;
    		  }
    		  if (this._writableState) {
    		    this._writableState.destroyed = false;
    		    this._writableState.ended = false;
    		    this._writableState.ending = false;
    		    this._writableState.finalCalled = false;
    		    this._writableState.prefinished = false;
    		    this._writableState.finished = false;
    		    this._writableState.errorEmitted = false;
    		  }
    		}
    		function emitErrorNT(self, err) {
    		  self.emit('error', err);
    		}
    		function errorOrDestroy(stream, err) {
    		  // We have tests that rely on errors being emitted
    		  // in the same tick, so changing this is semver major.
    		  // For now when you opt-in to autoDestroy we allow
    		  // the error to be emitted nextTick. In a future
    		  // semver major update we should change the default to this.

    		  const rState = stream._readableState;
    		  const wState = stream._writableState;
    		  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
    		}
    		var destroy_1 = {
    		  destroy,
    		  undestroy,
    		  errorOrDestroy
    		};

    		var errorsBrowser = {};

    		function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

    		var codes = {};

    		function createErrorType(code, message, Base) {
    		  if (!Base) {
    		    Base = Error;
    		  }

    		  function getMessage(arg1, arg2, arg3) {
    		    if (typeof message === 'string') {
    		      return message;
    		    } else {
    		      return message(arg1, arg2, arg3);
    		    }
    		  }

    		  var NodeError =
    		  /*#__PURE__*/
    		  function (_Base) {
    		    _inheritsLoose(NodeError, _Base);

    		    function NodeError(arg1, arg2, arg3) {
    		      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    		    }

    		    return NodeError;
    		  }(Base);

    		  NodeError.prototype.name = Base.name;
    		  NodeError.prototype.code = code;
    		  codes[code] = NodeError;
    		} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


    		function oneOf(expected, thing) {
    		  if (Array.isArray(expected)) {
    		    var len = expected.length;
    		    expected = expected.map(function (i) {
    		      return String(i);
    		    });

    		    if (len > 2) {
    		      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    		    } else if (len === 2) {
    		      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    		    } else {
    		      return "of ".concat(thing, " ").concat(expected[0]);
    		    }
    		  } else {
    		    return "of ".concat(thing, " ").concat(String(expected));
    		  }
    		} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


    		function startsWith(str, search, pos) {
    		  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    		} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


    		function endsWith(str, search, this_len) {
    		  if (this_len === undefined || this_len > str.length) {
    		    this_len = str.length;
    		  }

    		  return str.substring(this_len - search.length, this_len) === search;
    		} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


    		function includes(str, search, start) {
    		  if (typeof start !== 'number') {
    		    start = 0;
    		  }

    		  if (start + search.length > str.length) {
    		    return false;
    		  } else {
    		    return str.indexOf(search, start) !== -1;
    		  }
    		}

    		createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
    		  return 'The value "' + value + '" is invalid for option "' + name + '"';
    		}, TypeError);
    		createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
    		  // determiner: 'must be' or 'must not be'
    		  var determiner;

    		  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    		    determiner = 'must not be';
    		    expected = expected.replace(/^not /, '');
    		  } else {
    		    determiner = 'must be';
    		  }

    		  var msg;

    		  if (endsWith(name, ' argument')) {
    		    // For cases like 'first argument'
    		    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
    		  } else {
    		    var type = includes(name, '.') ? 'property' : 'argument';
    		    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
    		  }

    		  msg += ". Received type ".concat(typeof actual);
    		  return msg;
    		}, TypeError);
    		createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
    		createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
    		  return 'The ' + name + ' method is not implemented';
    		});
    		createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
    		createErrorType('ERR_STREAM_DESTROYED', function (name) {
    		  return 'Cannot call ' + name + ' after a stream was destroyed';
    		});
    		createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
    		createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
    		createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
    		createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
    		createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
    		  return 'Unknown encoding: ' + arg;
    		}, TypeError);
    		createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
    		errorsBrowser.codes = codes;

    		const ERR_INVALID_OPT_VALUE = errorsBrowser.codes.ERR_INVALID_OPT_VALUE;
    		function highWaterMarkFrom(options, isDuplex, duplexKey) {
    		  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
    		}
    		function getHighWaterMark(state, options, duplexKey, isDuplex) {
    		  const hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
    		  if (hwm != null) {
    		    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
    		      const name = isDuplex ? duplexKey : 'highWaterMark';
    		      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    		    }
    		    return Math.floor(hwm);
    		  }

    		  // Default value
    		  return state.objectMode ? 16 : 16 * 1024;
    		}
    		var state = {
    		  getHighWaterMark
    		};

    		/**
    		 * Module exports.
    		 */

    		var browser = deprecate;

    		/**
    		 * Mark that a method should not be used.
    		 * Returns a modified function which warns once by default.
    		 *
    		 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
    		 *
    		 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
    		 * will throw an Error when invoked.
    		 *
    		 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
    		 * will invoke `console.trace()` instead of `console.error()`.
    		 *
    		 * @param {Function} fn - the function to deprecate
    		 * @param {String} msg - the string to print to the console when `fn` is invoked
    		 * @returns {Function} a new "deprecated" version of `fn`
    		 * @api public
    		 */

    		function deprecate (fn, msg) {
    		  if (config('noDeprecation')) {
    		    return fn;
    		  }

    		  var warned = false;
    		  function deprecated() {
    		    if (!warned) {
    		      if (config('throwDeprecation')) {
    		        throw new Error(msg);
    		      } else if (config('traceDeprecation')) {
    		        console.trace(msg);
    		      } else {
    		        console.warn(msg);
    		      }
    		      warned = true;
    		    }
    		    return fn.apply(this, arguments);
    		  }

    		  return deprecated;
    		}

    		/**
    		 * Checks `localStorage` for boolean values for the given `name`.
    		 *
    		 * @param {String} name
    		 * @returns {Boolean}
    		 * @api private
    		 */

    		function config (name) {
    		  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    		  try {
    		    if (!commonjsGlobal$1.localStorage) return false;
    		  } catch (_) {
    		    return false;
    		  }
    		  var val = commonjsGlobal$1.localStorage[name];
    		  if (null == val) return false;
    		  return String(val).toLowerCase() === 'true';
    		}

    		var _stream_writable;
    		var hasRequired_stream_writable;

    		function require_stream_writable () {
    			if (hasRequired_stream_writable) return _stream_writable;
    			hasRequired_stream_writable = 1;

    			_stream_writable = Writable;

    			// It seems a linked list but it is not
    			// there will be only 2 of these for each stream
    			function CorkedRequest(state) {
    			  this.next = null;
    			  this.entry = null;
    			  this.finish = () => {
    			    onCorkedFinish(this, state);
    			  };
    			}
    			/* </replacement> */

    			/*<replacement>*/
    			var Duplex;
    			/*</replacement>*/

    			Writable.WritableState = WritableState;

    			/*<replacement>*/
    			const internalUtil = {
    			  deprecate: browser
    			};
    			/*</replacement>*/

    			/*<replacement>*/
    			var Stream = streamBrowser;
    			/*</replacement>*/

    			const Buffer = require$$0$3.Buffer;
    			const OurUint8Array = (typeof commonjsGlobal$1 !== 'undefined' ? commonjsGlobal$1 : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
    			function _uint8ArrayToBuffer(chunk) {
    			  return Buffer.from(chunk);
    			}
    			function _isUint8Array(obj) {
    			  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
    			}
    			const destroyImpl = destroy_1;
    			const _require = state,
    			  getHighWaterMark = _require.getHighWaterMark;
    			const _require$codes = errorsBrowser.codes,
    			  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    			  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    			  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
    			  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
    			  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
    			  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
    			  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
    			  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
    			const errorOrDestroy = destroyImpl.errorOrDestroy;
    			require$$0$1(Writable, Stream);
    			function nop() {}
    			function WritableState(options, stream, isDuplex) {
    			  Duplex = Duplex || require_stream_duplex();
    			  options = options || {};

    			  // Duplex streams are both readable and writable, but share
    			  // the same options object.
    			  // However, some cases require setting options to different
    			  // values for the readable and the writable sides of the duplex stream,
    			  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    			  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

    			  // object stream flag to indicate whether or not this stream
    			  // contains buffers or objects.
    			  this.objectMode = !!options.objectMode;
    			  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

    			  // the point at which write() starts returning false
    			  // Note: 0 is a valid value, means that we always return false if
    			  // the entire buffer is not flushed immediately on write()
    			  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

    			  // if _final has been called
    			  this.finalCalled = false;

    			  // drain event flag.
    			  this.needDrain = false;
    			  // at the start of calling end()
    			  this.ending = false;
    			  // when end() has been called, and returned
    			  this.ended = false;
    			  // when 'finish' is emitted
    			  this.finished = false;

    			  // has it been destroyed
    			  this.destroyed = false;

    			  // should we decode strings into buffers before passing to _write?
    			  // this is here so that some node-core streams can optimize string
    			  // handling at a lower level.
    			  var noDecode = options.decodeStrings === false;
    			  this.decodeStrings = !noDecode;

    			  // Crypto is kind of old and crusty.  Historically, its default string
    			  // encoding is 'binary' so we have to make this configurable.
    			  // Everything else in the universe uses 'utf8', though.
    			  this.defaultEncoding = options.defaultEncoding || 'utf8';

    			  // not an actual buffer we keep track of, but a measurement
    			  // of how much we're waiting to get pushed to some underlying
    			  // socket or file.
    			  this.length = 0;

    			  // a flag to see when we're in the middle of a write.
    			  this.writing = false;

    			  // when true all writes will be buffered until .uncork() call
    			  this.corked = 0;

    			  // a flag to be able to tell if the onwrite cb is called immediately,
    			  // or on a later tick.  We set this to true at first, because any
    			  // actions that shouldn't happen until "later" should generally also
    			  // not happen before the first write call.
    			  this.sync = true;

    			  // a flag to know if we're processing previously buffered items, which
    			  // may call the _write() callback in the same tick, so that we don't
    			  // end up in an overlapped onwrite situation.
    			  this.bufferProcessing = false;

    			  // the callback that's passed to _write(chunk,cb)
    			  this.onwrite = function (er) {
    			    onwrite(stream, er);
    			  };

    			  // the callback that the user supplies to write(chunk,encoding,cb)
    			  this.writecb = null;

    			  // the amount that is being written when _write is called.
    			  this.writelen = 0;
    			  this.bufferedRequest = null;
    			  this.lastBufferedRequest = null;

    			  // number of pending user-supplied write callbacks
    			  // this must be 0 before 'finish' can be emitted
    			  this.pendingcb = 0;

    			  // emit prefinish if the only thing we're waiting for is _write cbs
    			  // This is relevant for synchronous Transform streams
    			  this.prefinished = false;

    			  // True if the error was already emitted and should not be thrown again
    			  this.errorEmitted = false;

    			  // Should close be emitted on destroy. Defaults to true.
    			  this.emitClose = options.emitClose !== false;

    			  // Should .destroy() be called after 'finish' (and potentially 'end')
    			  this.autoDestroy = !!options.autoDestroy;

    			  // count buffered requests
    			  this.bufferedRequestCount = 0;

    			  // allocate the first CorkedRequest, there is always
    			  // one allocated and free to use, and we maintain at most two
    			  this.corkedRequestsFree = new CorkedRequest(this);
    			}
    			WritableState.prototype.getBuffer = function getBuffer() {
    			  var current = this.bufferedRequest;
    			  var out = [];
    			  while (current) {
    			    out.push(current);
    			    current = current.next;
    			  }
    			  return out;
    			};
    			(function () {
    			  try {
    			    Object.defineProperty(WritableState.prototype, 'buffer', {
    			      get: internalUtil.deprecate(function writableStateBufferGetter() {
    			        return this.getBuffer();
    			      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    			    });
    			  } catch (_) {}
    			})();

    			// Test _writableState for inheritance to account for Duplex streams,
    			// whose prototype chain only points to Readable.
    			var realHasInstance;
    			if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    			  realHasInstance = Function.prototype[Symbol.hasInstance];
    			  Object.defineProperty(Writable, Symbol.hasInstance, {
    			    value: function value(object) {
    			      if (realHasInstance.call(this, object)) return true;
    			      if (this !== Writable) return false;
    			      return object && object._writableState instanceof WritableState;
    			    }
    			  });
    			} else {
    			  realHasInstance = function realHasInstance(object) {
    			    return object instanceof this;
    			  };
    			}
    			function Writable(options) {
    			  Duplex = Duplex || require_stream_duplex();

    			  // Writable ctor is applied to Duplexes, too.
    			  // `realHasInstance` is necessary because using plain `instanceof`
    			  // would return false, as no `_writableState` property is attached.

    			  // Trying to use the custom `instanceof` for Writable here will also break the
    			  // Node.js LazyTransform implementation, which has a non-trivial getter for
    			  // `_writableState` that would lead to infinite recursion.

    			  // Checking for a Stream.Duplex instance is faster here instead of inside
    			  // the WritableState constructor, at least with V8 6.5
    			  const isDuplex = this instanceof Duplex;
    			  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
    			  this._writableState = new WritableState(options, this, isDuplex);

    			  // legacy.
    			  this.writable = true;
    			  if (options) {
    			    if (typeof options.write === 'function') this._write = options.write;
    			    if (typeof options.writev === 'function') this._writev = options.writev;
    			    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    			    if (typeof options.final === 'function') this._final = options.final;
    			  }
    			  Stream.call(this);
    			}

    			// Otherwise people can pipe Writable streams, which is just wrong.
    			Writable.prototype.pipe = function () {
    			  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
    			};
    			function writeAfterEnd(stream, cb) {
    			  var er = new ERR_STREAM_WRITE_AFTER_END();
    			  // TODO: defer error events consistently everywhere, not just the cb
    			  errorOrDestroy(stream, er);
    			  process.nextTick(cb, er);
    			}

    			// Checks that a user-supplied chunk is valid, especially for the particular
    			// mode the stream is in. Currently this means that `null` is never accepted
    			// and undefined/non-string values are only allowed in object mode.
    			function validChunk(stream, state, chunk, cb) {
    			  var er;
    			  if (chunk === null) {
    			    er = new ERR_STREAM_NULL_VALUES();
    			  } else if (typeof chunk !== 'string' && !state.objectMode) {
    			    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
    			  }
    			  if (er) {
    			    errorOrDestroy(stream, er);
    			    process.nextTick(cb, er);
    			    return false;
    			  }
    			  return true;
    			}
    			Writable.prototype.write = function (chunk, encoding, cb) {
    			  var state = this._writableState;
    			  var ret = false;
    			  var isBuf = !state.objectMode && _isUint8Array(chunk);
    			  if (isBuf && !Buffer.isBuffer(chunk)) {
    			    chunk = _uint8ArrayToBuffer(chunk);
    			  }
    			  if (typeof encoding === 'function') {
    			    cb = encoding;
    			    encoding = null;
    			  }
    			  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
    			  if (typeof cb !== 'function') cb = nop;
    			  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    			    state.pendingcb++;
    			    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    			  }
    			  return ret;
    			};
    			Writable.prototype.cork = function () {
    			  this._writableState.corked++;
    			};
    			Writable.prototype.uncork = function () {
    			  var state = this._writableState;
    			  if (state.corked) {
    			    state.corked--;
    			    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    			  }
    			};
    			Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    			  // node::ParseEncoding() requires lower case.
    			  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    			  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
    			  this._writableState.defaultEncoding = encoding;
    			  return this;
    			};
    			Object.defineProperty(Writable.prototype, 'writableBuffer', {
    			  // making it explicit this property is not enumerable
    			  // because otherwise some prototype manipulation in
    			  // userland will fail
    			  enumerable: false,
    			  get: function get() {
    			    return this._writableState && this._writableState.getBuffer();
    			  }
    			});
    			function decodeChunk(state, chunk, encoding) {
    			  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    			    chunk = Buffer.from(chunk, encoding);
    			  }
    			  return chunk;
    			}
    			Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
    			  // making it explicit this property is not enumerable
    			  // because otherwise some prototype manipulation in
    			  // userland will fail
    			  enumerable: false,
    			  get: function get() {
    			    return this._writableState.highWaterMark;
    			  }
    			});

    			// if we're already writing something, then just put this
    			// in the queue, and wait our turn.  Otherwise, call _write
    			// If we return false, then we need a drain event, so set that flag.
    			function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    			  if (!isBuf) {
    			    var newChunk = decodeChunk(state, chunk, encoding);
    			    if (chunk !== newChunk) {
    			      isBuf = true;
    			      encoding = 'buffer';
    			      chunk = newChunk;
    			    }
    			  }
    			  var len = state.objectMode ? 1 : chunk.length;
    			  state.length += len;
    			  var ret = state.length < state.highWaterMark;
    			  // we must ensure that previous needDrain will not be reset to false.
    			  if (!ret) state.needDrain = true;
    			  if (state.writing || state.corked) {
    			    var last = state.lastBufferedRequest;
    			    state.lastBufferedRequest = {
    			      chunk,
    			      encoding,
    			      isBuf,
    			      callback: cb,
    			      next: null
    			    };
    			    if (last) {
    			      last.next = state.lastBufferedRequest;
    			    } else {
    			      state.bufferedRequest = state.lastBufferedRequest;
    			    }
    			    state.bufferedRequestCount += 1;
    			  } else {
    			    doWrite(stream, state, false, len, chunk, encoding, cb);
    			  }
    			  return ret;
    			}
    			function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    			  state.writelen = len;
    			  state.writecb = cb;
    			  state.writing = true;
    			  state.sync = true;
    			  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
    			  state.sync = false;
    			}
    			function onwriteError(stream, state, sync, er, cb) {
    			  --state.pendingcb;
    			  if (sync) {
    			    // defer the callback if we are being called synchronously
    			    // to avoid piling up things on the stack
    			    process.nextTick(cb, er);
    			    // this can emit finish, and it will always happen
    			    // after error
    			    process.nextTick(finishMaybe, stream, state);
    			    stream._writableState.errorEmitted = true;
    			    errorOrDestroy(stream, er);
    			  } else {
    			    // the caller expect this to happen before if
    			    // it is async
    			    cb(er);
    			    stream._writableState.errorEmitted = true;
    			    errorOrDestroy(stream, er);
    			    // this can emit finish, but finish must
    			    // always follow error
    			    finishMaybe(stream, state);
    			  }
    			}
    			function onwriteStateUpdate(state) {
    			  state.writing = false;
    			  state.writecb = null;
    			  state.length -= state.writelen;
    			  state.writelen = 0;
    			}
    			function onwrite(stream, er) {
    			  var state = stream._writableState;
    			  var sync = state.sync;
    			  var cb = state.writecb;
    			  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
    			  onwriteStateUpdate(state);
    			  if (er) onwriteError(stream, state, sync, er, cb);else {
    			    // Check if we're actually ready to finish, but don't emit yet
    			    var finished = needFinish(state) || stream.destroyed;
    			    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
    			      clearBuffer(stream, state);
    			    }
    			    if (sync) {
    			      process.nextTick(afterWrite, stream, state, finished, cb);
    			    } else {
    			      afterWrite(stream, state, finished, cb);
    			    }
    			  }
    			}
    			function afterWrite(stream, state, finished, cb) {
    			  if (!finished) onwriteDrain(stream, state);
    			  state.pendingcb--;
    			  cb();
    			  finishMaybe(stream, state);
    			}

    			// Must force callback to be called on nextTick, so that we don't
    			// emit 'drain' before the write() consumer gets the 'false' return
    			// value, and has a chance to attach a 'drain' listener.
    			function onwriteDrain(stream, state) {
    			  if (state.length === 0 && state.needDrain) {
    			    state.needDrain = false;
    			    stream.emit('drain');
    			  }
    			}

    			// if there's something in the buffer waiting, then process it
    			function clearBuffer(stream, state) {
    			  state.bufferProcessing = true;
    			  var entry = state.bufferedRequest;
    			  if (stream._writev && entry && entry.next) {
    			    // Fast case, write everything using _writev()
    			    var l = state.bufferedRequestCount;
    			    var buffer = new Array(l);
    			    var holder = state.corkedRequestsFree;
    			    holder.entry = entry;
    			    var count = 0;
    			    var allBuffers = true;
    			    while (entry) {
    			      buffer[count] = entry;
    			      if (!entry.isBuf) allBuffers = false;
    			      entry = entry.next;
    			      count += 1;
    			    }
    			    buffer.allBuffers = allBuffers;
    			    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    			    // doWrite is almost always async, defer these to save a bit of time
    			    // as the hot path ends with doWrite
    			    state.pendingcb++;
    			    state.lastBufferedRequest = null;
    			    if (holder.next) {
    			      state.corkedRequestsFree = holder.next;
    			      holder.next = null;
    			    } else {
    			      state.corkedRequestsFree = new CorkedRequest(state);
    			    }
    			    state.bufferedRequestCount = 0;
    			  } else {
    			    // Slow case, write chunks one-by-one
    			    while (entry) {
    			      var chunk = entry.chunk;
    			      var encoding = entry.encoding;
    			      var cb = entry.callback;
    			      var len = state.objectMode ? 1 : chunk.length;
    			      doWrite(stream, state, false, len, chunk, encoding, cb);
    			      entry = entry.next;
    			      state.bufferedRequestCount--;
    			      // if we didn't call the onwrite immediately, then
    			      // it means that we need to wait until it does.
    			      // also, that means that the chunk and cb are currently
    			      // being processed, so move the buffer counter past them.
    			      if (state.writing) {
    			        break;
    			      }
    			    }
    			    if (entry === null) state.lastBufferedRequest = null;
    			  }
    			  state.bufferedRequest = entry;
    			  state.bufferProcessing = false;
    			}
    			Writable.prototype._write = function (chunk, encoding, cb) {
    			  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
    			};
    			Writable.prototype._writev = null;
    			Writable.prototype.end = function (chunk, encoding, cb) {
    			  var state = this._writableState;
    			  if (typeof chunk === 'function') {
    			    cb = chunk;
    			    chunk = null;
    			    encoding = null;
    			  } else if (typeof encoding === 'function') {
    			    cb = encoding;
    			    encoding = null;
    			  }
    			  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

    			  // .end() fully uncorks
    			  if (state.corked) {
    			    state.corked = 1;
    			    this.uncork();
    			  }

    			  // ignore unnecessary end() calls.
    			  if (!state.ending) endWritable(this, state, cb);
    			  return this;
    			};
    			Object.defineProperty(Writable.prototype, 'writableLength', {
    			  // making it explicit this property is not enumerable
    			  // because otherwise some prototype manipulation in
    			  // userland will fail
    			  enumerable: false,
    			  get() {
    			    return this._writableState.length;
    			  }
    			});
    			function needFinish(state) {
    			  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
    			}
    			function callFinal(stream, state) {
    			  stream._final(err => {
    			    state.pendingcb--;
    			    if (err) {
    			      errorOrDestroy(stream, err);
    			    }
    			    state.prefinished = true;
    			    stream.emit('prefinish');
    			    finishMaybe(stream, state);
    			  });
    			}
    			function prefinish(stream, state) {
    			  if (!state.prefinished && !state.finalCalled) {
    			    if (typeof stream._final === 'function' && !state.destroyed) {
    			      state.pendingcb++;
    			      state.finalCalled = true;
    			      process.nextTick(callFinal, stream, state);
    			    } else {
    			      state.prefinished = true;
    			      stream.emit('prefinish');
    			    }
    			  }
    			}
    			function finishMaybe(stream, state) {
    			  var need = needFinish(state);
    			  if (need) {
    			    prefinish(stream, state);
    			    if (state.pendingcb === 0) {
    			      state.finished = true;
    			      stream.emit('finish');
    			      if (state.autoDestroy) {
    			        // In case of duplex streams we need a way to detect
    			        // if the readable side is ready for autoDestroy as well
    			        const rState = stream._readableState;
    			        if (!rState || rState.autoDestroy && rState.endEmitted) {
    			          stream.destroy();
    			        }
    			      }
    			    }
    			  }
    			  return need;
    			}
    			function endWritable(stream, state, cb) {
    			  state.ending = true;
    			  finishMaybe(stream, state);
    			  if (cb) {
    			    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
    			  }
    			  state.ended = true;
    			  stream.writable = false;
    			}
    			function onCorkedFinish(corkReq, state, err) {
    			  var entry = corkReq.entry;
    			  corkReq.entry = null;
    			  while (entry) {
    			    var cb = entry.callback;
    			    state.pendingcb--;
    			    cb(err);
    			    entry = entry.next;
    			  }

    			  // reuse the free corkReq.
    			  state.corkedRequestsFree.next = corkReq;
    			}
    			Object.defineProperty(Writable.prototype, 'destroyed', {
    			  // making it explicit this property is not enumerable
    			  // because otherwise some prototype manipulation in
    			  // userland will fail
    			  enumerable: false,
    			  get() {
    			    if (this._writableState === undefined) {
    			      return false;
    			    }
    			    return this._writableState.destroyed;
    			  },
    			  set(value) {
    			    // we ignore the value if the stream
    			    // has not been initialized yet
    			    if (!this._writableState) {
    			      return;
    			    }

    			    // backward compatibility, the user is explicitly
    			    // managing destroyed
    			    this._writableState.destroyed = value;
    			  }
    			});
    			Writable.prototype.destroy = destroyImpl.destroy;
    			Writable.prototype._undestroy = destroyImpl.undestroy;
    			Writable.prototype._destroy = function (err, cb) {
    			  cb(err);
    			};
    			return _stream_writable;
    		}

    		var _stream_duplex;
    		var hasRequired_stream_duplex;

    		function require_stream_duplex () {
    			if (hasRequired_stream_duplex) return _stream_duplex;
    			hasRequired_stream_duplex = 1;

    			/*<replacement>*/
    			var objectKeys = Object.keys || function (obj) {
    			  var keys = [];
    			  for (var key in obj) keys.push(key);
    			  return keys;
    			};
    			/*</replacement>*/

    			_stream_duplex = Duplex;
    			const Readable = require_stream_readable();
    			const Writable = require_stream_writable();
    			require$$0$1(Duplex, Readable);
    			{
    			  // Allow the keys array to be GC'ed.
    			  const keys = objectKeys(Writable.prototype);
    			  for (var v = 0; v < keys.length; v++) {
    			    const method = keys[v];
    			    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
    			  }
    			}
    			function Duplex(options) {
    			  if (!(this instanceof Duplex)) return new Duplex(options);
    			  Readable.call(this, options);
    			  Writable.call(this, options);
    			  this.allowHalfOpen = true;
    			  if (options) {
    			    if (options.readable === false) this.readable = false;
    			    if (options.writable === false) this.writable = false;
    			    if (options.allowHalfOpen === false) {
    			      this.allowHalfOpen = false;
    			      this.once('end', onend);
    			    }
    			  }
    			}
    			Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
    			  // making it explicit this property is not enumerable
    			  // because otherwise some prototype manipulation in
    			  // userland will fail
    			  enumerable: false,
    			  get() {
    			    return this._writableState.highWaterMark;
    			  }
    			});
    			Object.defineProperty(Duplex.prototype, 'writableBuffer', {
    			  // making it explicit this property is not enumerable
    			  // because otherwise some prototype manipulation in
    			  // userland will fail
    			  enumerable: false,
    			  get: function get() {
    			    return this._writableState && this._writableState.getBuffer();
    			  }
    			});
    			Object.defineProperty(Duplex.prototype, 'writableLength', {
    			  // making it explicit this property is not enumerable
    			  // because otherwise some prototype manipulation in
    			  // userland will fail
    			  enumerable: false,
    			  get() {
    			    return this._writableState.length;
    			  }
    			});

    			// the no-half-open enforcer
    			function onend() {
    			  // If the writable side ended, then we're ok.
    			  if (this._writableState.ended) return;

    			  // no more data can be written.
    			  // But allow more writes to happen in this tick.
    			  process.nextTick(onEndNT, this);
    			}
    			function onEndNT(self) {
    			  self.end();
    			}
    			Object.defineProperty(Duplex.prototype, 'destroyed', {
    			  // making it explicit this property is not enumerable
    			  // because otherwise some prototype manipulation in
    			  // userland will fail
    			  enumerable: false,
    			  get() {
    			    if (this._readableState === undefined || this._writableState === undefined) {
    			      return false;
    			    }
    			    return this._readableState.destroyed && this._writableState.destroyed;
    			  },
    			  set(value) {
    			    // we ignore the value if the stream
    			    // has not been initialized yet
    			    if (this._readableState === undefined || this._writableState === undefined) {
    			      return;
    			    }

    			    // backward compatibility, the user is explicitly
    			    // managing destroyed
    			    this._readableState.destroyed = value;
    			    this._writableState.destroyed = value;
    			  }
    			});
    			return _stream_duplex;
    		}

    		// Copyright Joyent, Inc. and other Node contributors.
    		var isBufferEncoding = Buffer$c.isEncoding
    		  || function(encoding) {
    		       switch (encoding && encoding.toLowerCase()) {
    		         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
    		         default: return false;
    		       }
    		     };


    		function assertEncoding(encoding) {
    		  if (encoding && !isBufferEncoding(encoding)) {
    		    throw new Error('Unknown encoding: ' + encoding);
    		  }
    		}

    		// StringDecoder provides an interface for efficiently splitting a series of
    		// buffers into a series of JS strings without breaking apart multi-byte
    		// characters. CESU-8 is handled as part of the UTF-8 encoding.
    		//
    		// @TODO Handling all encodings inside a single object makes it very difficult
    		// to reason about this code, so it should be split up in the future.
    		// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
    		// points as used by CESU-8.
    		function StringDecoder(encoding) {
    		  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
    		  assertEncoding(encoding);
    		  switch (this.encoding) {
    		    case 'utf8':
    		      // CESU-8 represents each of Surrogate Pair by 3-bytes
    		      this.surrogateSize = 3;
    		      break;
    		    case 'ucs2':
    		    case 'utf16le':
    		      // UTF-16 represents each of Surrogate Pair by 2-bytes
    		      this.surrogateSize = 2;
    		      this.detectIncompleteChar = utf16DetectIncompleteChar;
    		      break;
    		    case 'base64':
    		      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
    		      this.surrogateSize = 3;
    		      this.detectIncompleteChar = base64DetectIncompleteChar;
    		      break;
    		    default:
    		      this.write = passThroughWrite;
    		      return;
    		  }

    		  // Enough space to store all bytes of a single character. UTF-8 needs 4
    		  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
    		  this.charBuffer = new Buffer$c(6);
    		  // Number of bytes received for the current incomplete multi-byte character.
    		  this.charReceived = 0;
    		  // Number of bytes expected for the current incomplete multi-byte character.
    		  this.charLength = 0;
    		}

    		// write decodes the given buffer and returns it as JS string that is
    		// guaranteed to not contain any partial multi-byte characters. Any partial
    		// character found at the end of the buffer is buffered up, and will be
    		// returned when calling write again with the remaining bytes.
    		//
    		// Note: Converting a Buffer containing an orphan surrogate to a String
    		// currently works, but converting a String to a Buffer (via `new Buffer`, or
    		// Buffer#write) will replace incomplete surrogates with the unicode
    		// replacement character. See https://codereview.chromium.org/121173009/ .
    		StringDecoder.prototype.write = function(buffer) {
    		  var charStr = '';
    		  // if our last write ended with an incomplete multibyte character
    		  while (this.charLength) {
    		    // determine how many remaining bytes this buffer has to offer for this char
    		    var available = (buffer.length >= this.charLength - this.charReceived) ?
    		        this.charLength - this.charReceived :
    		        buffer.length;

    		    // add the new bytes to the char buffer
    		    buffer.copy(this.charBuffer, this.charReceived, 0, available);
    		    this.charReceived += available;

    		    if (this.charReceived < this.charLength) {
    		      // still not enough chars in this buffer? wait for more ...
    		      return '';
    		    }

    		    // remove bytes belonging to the current character from the buffer
    		    buffer = buffer.slice(available, buffer.length);

    		    // get the character that was split
    		    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);

    		    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
    		    var charCode = charStr.charCodeAt(charStr.length - 1);
    		    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
    		      this.charLength += this.surrogateSize;
    		      charStr = '';
    		      continue;
    		    }
    		    this.charReceived = this.charLength = 0;

    		    // if there are no more bytes in this buffer, just emit our char
    		    if (buffer.length === 0) {
    		      return charStr;
    		    }
    		    break;
    		  }

    		  // determine and set charLength / charReceived
    		  this.detectIncompleteChar(buffer);

    		  var end = buffer.length;
    		  if (this.charLength) {
    		    // buffer the incomplete character bytes we got
    		    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
    		    end -= this.charReceived;
    		  }

    		  charStr += buffer.toString(this.encoding, 0, end);

    		  var end = charStr.length - 1;
    		  var charCode = charStr.charCodeAt(end);
    		  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
    		  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
    		    var size = this.surrogateSize;
    		    this.charLength += size;
    		    this.charReceived += size;
    		    this.charBuffer.copy(this.charBuffer, size, 0, size);
    		    buffer.copy(this.charBuffer, 0, 0, size);
    		    return charStr.substring(0, end);
    		  }

    		  // or just emit the charStr
    		  return charStr;
    		};

    		// detectIncompleteChar determines if there is an incomplete UTF-8 character at
    		// the end of the given buffer. If so, it sets this.charLength to the byte
    		// length that character, and sets this.charReceived to the number of bytes
    		// that are available for this character.
    		StringDecoder.prototype.detectIncompleteChar = function(buffer) {
    		  // determine how many bytes we have to check at the end of this buffer
    		  var i = (buffer.length >= 3) ? 3 : buffer.length;

    		  // Figure out if one of the last i bytes of our buffer announces an
    		  // incomplete char.
    		  for (; i > 0; i--) {
    		    var c = buffer[buffer.length - i];

    		    // See http://en.wikipedia.org/wiki/UTF-8#Description

    		    // 110XXXXX
    		    if (i == 1 && c >> 5 == 0x06) {
    		      this.charLength = 2;
    		      break;
    		    }

    		    // 1110XXXX
    		    if (i <= 2 && c >> 4 == 0x0E) {
    		      this.charLength = 3;
    		      break;
    		    }

    		    // 11110XXX
    		    if (i <= 3 && c >> 3 == 0x1E) {
    		      this.charLength = 4;
    		      break;
    		    }
    		  }
    		  this.charReceived = i;
    		};

    		StringDecoder.prototype.end = function(buffer) {
    		  var res = '';
    		  if (buffer && buffer.length)
    		    res = this.write(buffer);

    		  if (this.charReceived) {
    		    var cr = this.charReceived;
    		    var buf = this.charBuffer;
    		    var enc = this.encoding;
    		    res += buf.slice(0, cr).toString(enc);
    		  }

    		  return res;
    		};

    		function passThroughWrite(buffer) {
    		  return buffer.toString(this.encoding);
    		}

    		function utf16DetectIncompleteChar(buffer) {
    		  this.charReceived = buffer.length % 2;
    		  this.charLength = this.charReceived ? 2 : 0;
    		}

    		function base64DetectIncompleteChar(buffer) {
    		  this.charReceived = buffer.length % 3;
    		  this.charLength = this.charReceived ? 3 : 0;
    		}

    		var _polyfillNode_string_decoder = /*#__PURE__*/Object.freeze({
    			__proto__: null,
    			StringDecoder: StringDecoder
    		});

    		var require$$10 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_string_decoder);

    		const ERR_STREAM_PREMATURE_CLOSE = errorsBrowser.codes.ERR_STREAM_PREMATURE_CLOSE;
    		function once$1(callback) {
    		  let called = false;
    		  return function () {
    		    if (called) return;
    		    called = true;
    		    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    		      args[_key] = arguments[_key];
    		    }
    		    callback.apply(this, args);
    		  };
    		}
    		function noop$1() {}
    		function isRequest$1(stream) {
    		  return stream.setHeader && typeof stream.abort === 'function';
    		}
    		function eos$1(stream, opts, callback) {
    		  if (typeof opts === 'function') return eos$1(stream, null, opts);
    		  if (!opts) opts = {};
    		  callback = once$1(callback || noop$1);
    		  let readable = opts.readable || opts.readable !== false && stream.readable;
    		  let writable = opts.writable || opts.writable !== false && stream.writable;
    		  const onlegacyfinish = () => {
    		    if (!stream.writable) onfinish();
    		  };
    		  var writableEnded = stream._writableState && stream._writableState.finished;
    		  const onfinish = () => {
    		    writable = false;
    		    writableEnded = true;
    		    if (!readable) callback.call(stream);
    		  };
    		  var readableEnded = stream._readableState && stream._readableState.endEmitted;
    		  const onend = () => {
    		    readable = false;
    		    readableEnded = true;
    		    if (!writable) callback.call(stream);
    		  };
    		  const onerror = err => {
    		    callback.call(stream, err);
    		  };
    		  const onclose = () => {
    		    let err;
    		    if (readable && !readableEnded) {
    		      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
    		      return callback.call(stream, err);
    		    }
    		    if (writable && !writableEnded) {
    		      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
    		      return callback.call(stream, err);
    		    }
    		  };
    		  const onrequest = () => {
    		    stream.req.on('finish', onfinish);
    		  };
    		  if (isRequest$1(stream)) {
    		    stream.on('complete', onfinish);
    		    stream.on('abort', onclose);
    		    if (stream.req) onrequest();else stream.on('request', onrequest);
    		  } else if (writable && !stream._writableState) {
    		    // legacy streams
    		    stream.on('end', onlegacyfinish);
    		    stream.on('close', onlegacyfinish);
    		  }
    		  stream.on('end', onend);
    		  stream.on('finish', onfinish);
    		  if (opts.error !== false) stream.on('error', onerror);
    		  stream.on('close', onclose);
    		  return function () {
    		    stream.removeListener('complete', onfinish);
    		    stream.removeListener('abort', onclose);
    		    stream.removeListener('request', onrequest);
    		    if (stream.req) stream.req.removeListener('finish', onfinish);
    		    stream.removeListener('end', onlegacyfinish);
    		    stream.removeListener('close', onlegacyfinish);
    		    stream.removeListener('finish', onfinish);
    		    stream.removeListener('end', onend);
    		    stream.removeListener('error', onerror);
    		    stream.removeListener('close', onclose);
    		  };
    		}
    		var endOfStream = eos$1;

    		var async_iterator;
    		var hasRequiredAsync_iterator;

    		function requireAsync_iterator () {
    			if (hasRequiredAsync_iterator) return async_iterator;
    			hasRequiredAsync_iterator = 1;

    			const finished = endOfStream;
    			const kLastResolve = Symbol('lastResolve');
    			const kLastReject = Symbol('lastReject');
    			const kError = Symbol('error');
    			const kEnded = Symbol('ended');
    			const kLastPromise = Symbol('lastPromise');
    			const kHandlePromise = Symbol('handlePromise');
    			const kStream = Symbol('stream');
    			function createIterResult(value, done) {
    			  return {
    			    value,
    			    done
    			  };
    			}
    			function readAndResolve(iter) {
    			  const resolve = iter[kLastResolve];
    			  if (resolve !== null) {
    			    const data = iter[kStream].read();
    			    // we defer if data is null
    			    // we can be expecting either 'end' or
    			    // 'error'
    			    if (data !== null) {
    			      iter[kLastPromise] = null;
    			      iter[kLastResolve] = null;
    			      iter[kLastReject] = null;
    			      resolve(createIterResult(data, false));
    			    }
    			  }
    			}
    			function onReadable(iter) {
    			  // we wait for the next tick, because it might
    			  // emit an error with process.nextTick
    			  process.nextTick(readAndResolve, iter);
    			}
    			function wrapForNext(lastPromise, iter) {
    			  return (resolve, reject) => {
    			    lastPromise.then(() => {
    			      if (iter[kEnded]) {
    			        resolve(createIterResult(undefined, true));
    			        return;
    			      }
    			      iter[kHandlePromise](resolve, reject);
    			    }, reject);
    			  };
    			}
    			const AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
    			const ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf({
    			  get stream() {
    			    return this[kStream];
    			  },
    			  next() {
    			    // if we have detected an error in the meanwhile
    			    // reject straight away
    			    const error = this[kError];
    			    if (error !== null) {
    			      return Promise.reject(error);
    			    }
    			    if (this[kEnded]) {
    			      return Promise.resolve(createIterResult(undefined, true));
    			    }
    			    if (this[kStream].destroyed) {
    			      // We need to defer via nextTick because if .destroy(err) is
    			      // called, the error will be emitted via nextTick, and
    			      // we cannot guarantee that there is no error lingering around
    			      // waiting to be emitted.
    			      return new Promise((resolve, reject) => {
    			        process.nextTick(() => {
    			          if (this[kError]) {
    			            reject(this[kError]);
    			          } else {
    			            resolve(createIterResult(undefined, true));
    			          }
    			        });
    			      });
    			    }

    			    // if we have multiple next() calls
    			    // we will wait for the previous Promise to finish
    			    // this logic is optimized to support for await loops,
    			    // where next() is only called once at a time
    			    const lastPromise = this[kLastPromise];
    			    let promise;
    			    if (lastPromise) {
    			      promise = new Promise(wrapForNext(lastPromise, this));
    			    } else {
    			      // fast path needed to support multiple this.push()
    			      // without triggering the next() queue
    			      const data = this[kStream].read();
    			      if (data !== null) {
    			        return Promise.resolve(createIterResult(data, false));
    			      }
    			      promise = new Promise(this[kHandlePromise]);
    			    }
    			    this[kLastPromise] = promise;
    			    return promise;
    			  },
    			  [Symbol.asyncIterator]() {
    			    return this;
    			  },
    			  return() {
    			    // destroy(err, cb) is a private API
    			    // we can guarantee we have that here, because we control the
    			    // Readable class this is attached to
    			    return new Promise((resolve, reject) => {
    			      this[kStream].destroy(null, err => {
    			        if (err) {
    			          reject(err);
    			          return;
    			        }
    			        resolve(createIterResult(undefined, true));
    			      });
    			    });
    			  }
    			}, AsyncIteratorPrototype);
    			const createReadableStreamAsyncIterator = stream => {
    			  const iterator = Object.create(ReadableStreamAsyncIteratorPrototype, {
    			    [kStream]: {
    			      value: stream,
    			      writable: true
    			    },
    			    [kLastResolve]: {
    			      value: null,
    			      writable: true
    			    },
    			    [kLastReject]: {
    			      value: null,
    			      writable: true
    			    },
    			    [kError]: {
    			      value: null,
    			      writable: true
    			    },
    			    [kEnded]: {
    			      value: stream._readableState.endEmitted,
    			      writable: true
    			    },
    			    // the function passed to new Promise
    			    // is cached so we avoid allocating a new
    			    // closure at every run
    			    [kHandlePromise]: {
    			      value: (resolve, reject) => {
    			        const data = iterator[kStream].read();
    			        if (data) {
    			          iterator[kLastPromise] = null;
    			          iterator[kLastResolve] = null;
    			          iterator[kLastReject] = null;
    			          resolve(createIterResult(data, false));
    			        } else {
    			          iterator[kLastResolve] = resolve;
    			          iterator[kLastReject] = reject;
    			        }
    			      },
    			      writable: true
    			    }
    			  });
    			  iterator[kLastPromise] = null;
    			  finished(stream, err => {
    			    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
    			      const reject = iterator[kLastReject];
    			      // reject if we are waiting for data in the Promise
    			      // returned by next() and store the error
    			      if (reject !== null) {
    			        iterator[kLastPromise] = null;
    			        iterator[kLastResolve] = null;
    			        iterator[kLastReject] = null;
    			        reject(err);
    			      }
    			      iterator[kError] = err;
    			      return;
    			    }
    			    const resolve = iterator[kLastResolve];
    			    if (resolve !== null) {
    			      iterator[kLastPromise] = null;
    			      iterator[kLastResolve] = null;
    			      iterator[kLastReject] = null;
    			      resolve(createIterResult(undefined, true));
    			    }
    			    iterator[kEnded] = true;
    			  });
    			  stream.on('readable', onReadable.bind(null, iterator));
    			  return iterator;
    			};
    			async_iterator = createReadableStreamAsyncIterator;
    			return async_iterator;
    		}

    		var fromBrowser;
    		var hasRequiredFromBrowser;

    		function requireFromBrowser () {
    			if (hasRequiredFromBrowser) return fromBrowser;
    			hasRequiredFromBrowser = 1;
    			fromBrowser = function () {
    			  throw new Error('Readable.from is not available in the browser')
    			};
    			return fromBrowser;
    		}

    		var _stream_readable;
    		var hasRequired_stream_readable;

    		function require_stream_readable () {
    			if (hasRequired_stream_readable) return _stream_readable;
    			hasRequired_stream_readable = 1;

    			_stream_readable = Readable;

    			/*<replacement>*/
    			var Duplex;
    			/*</replacement>*/

    			Readable.ReadableState = ReadableState;

    			/*<replacement>*/
    			require$$0.EventEmitter;
    			var EElistenerCount = function EElistenerCount(emitter, type) {
    			  return emitter.listeners(type).length;
    			};
    			/*</replacement>*/

    			/*<replacement>*/
    			var Stream = streamBrowser;
    			/*</replacement>*/

    			const Buffer = require$$0$3.Buffer;
    			const OurUint8Array = (typeof commonjsGlobal$1 !== 'undefined' ? commonjsGlobal$1 : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
    			function _uint8ArrayToBuffer(chunk) {
    			  return Buffer.from(chunk);
    			}
    			function _isUint8Array(obj) {
    			  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
    			}

    			/*<replacement>*/
    			const debugUtil = require$$3;
    			let debug;
    			if (debugUtil && debugUtil.debuglog) {
    			  debug = debugUtil.debuglog('stream');
    			} else {
    			  debug = function debug() {};
    			}
    			/*</replacement>*/

    			const BufferList = requireBuffer_list();
    			const destroyImpl = destroy_1;
    			const _require = state,
    			  getHighWaterMark = _require.getHighWaterMark;
    			const _require$codes = errorsBrowser.codes,
    			  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    			  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
    			  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    			  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

    			// Lazy loaded to improve the startup performance.
    			let StringDecoder;
    			let createReadableStreamAsyncIterator;
    			let from;
    			require$$0$1(Readable, Stream);
    			const errorOrDestroy = destroyImpl.errorOrDestroy;
    			const kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
    			function prependListener(emitter, event, fn) {
    			  // Sadly this is not cacheable as some libraries bundle their own
    			  // event emitter implementation with them.
    			  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

    			  // This is a hack to make sure that our error handler is attached before any
    			  // userland ones.  NEVER DO THIS. This is here only because this code needs
    			  // to continue to work with older versions of Node.js that do not include
    			  // the prependListener() method. The goal is to eventually remove this hack.
    			  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
    			}
    			function ReadableState(options, stream, isDuplex) {
    			  Duplex = Duplex || require_stream_duplex();
    			  options = options || {};

    			  // Duplex streams are both readable and writable, but share
    			  // the same options object.
    			  // However, some cases require setting options to different
    			  // values for the readable and the writable sides of the duplex stream.
    			  // These options can be provided separately as readableXXX and writableXXX.
    			  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

    			  // object stream flag. Used to make read(n) ignore n and to
    			  // make all the buffer merging and length checks go away
    			  this.objectMode = !!options.objectMode;
    			  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

    			  // the point at which it stops calling _read() to fill the buffer
    			  // Note: 0 is a valid value, means "don't call _read preemptively ever"
    			  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

    			  // A linked list is used to store data chunks instead of an array because the
    			  // linked list can remove elements from the beginning faster than
    			  // array.shift()
    			  this.buffer = new BufferList();
    			  this.length = 0;
    			  this.pipes = null;
    			  this.pipesCount = 0;
    			  this.flowing = null;
    			  this.ended = false;
    			  this.endEmitted = false;
    			  this.reading = false;

    			  // a flag to be able to tell if the event 'readable'/'data' is emitted
    			  // immediately, or on a later tick.  We set this to true at first, because
    			  // any actions that shouldn't happen until "later" should generally also
    			  // not happen before the first read call.
    			  this.sync = true;

    			  // whenever we return null, then we set a flag to say
    			  // that we're awaiting a 'readable' event emission.
    			  this.needReadable = false;
    			  this.emittedReadable = false;
    			  this.readableListening = false;
    			  this.resumeScheduled = false;
    			  this.paused = true;

    			  // Should close be emitted on destroy. Defaults to true.
    			  this.emitClose = options.emitClose !== false;

    			  // Should .destroy() be called after 'end' (and potentially 'finish')
    			  this.autoDestroy = !!options.autoDestroy;

    			  // has it been destroyed
    			  this.destroyed = false;

    			  // Crypto is kind of old and crusty.  Historically, its default string
    			  // encoding is 'binary' so we have to make this configurable.
    			  // Everything else in the universe uses 'utf8', though.
    			  this.defaultEncoding = options.defaultEncoding || 'utf8';

    			  // the number of writers that are awaiting a drain event in .pipe()s
    			  this.awaitDrain = 0;

    			  // if true, a maybeReadMore has been scheduled
    			  this.readingMore = false;
    			  this.decoder = null;
    			  this.encoding = null;
    			  if (options.encoding) {
    			    if (!StringDecoder) StringDecoder = require$$10.StringDecoder;
    			    this.decoder = new StringDecoder(options.encoding);
    			    this.encoding = options.encoding;
    			  }
    			}
    			function Readable(options) {
    			  Duplex = Duplex || require_stream_duplex();
    			  if (!(this instanceof Readable)) return new Readable(options);

    			  // Checking for a Stream.Duplex instance is faster here instead of inside
    			  // the ReadableState constructor, at least with V8 6.5
    			  const isDuplex = this instanceof Duplex;
    			  this._readableState = new ReadableState(options, this, isDuplex);

    			  // legacy
    			  this.readable = true;
    			  if (options) {
    			    if (typeof options.read === 'function') this._read = options.read;
    			    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    			  }
    			  Stream.call(this);
    			}
    			Object.defineProperty(Readable.prototype, 'destroyed', {
    			  // making it explicit this property is not enumerable
    			  // because otherwise some prototype manipulation in
    			  // userland will fail
    			  enumerable: false,
    			  get() {
    			    if (this._readableState === undefined) {
    			      return false;
    			    }
    			    return this._readableState.destroyed;
    			  },
    			  set(value) {
    			    // we ignore the value if the stream
    			    // has not been initialized yet
    			    if (!this._readableState) {
    			      return;
    			    }

    			    // backward compatibility, the user is explicitly
    			    // managing destroyed
    			    this._readableState.destroyed = value;
    			  }
    			});
    			Readable.prototype.destroy = destroyImpl.destroy;
    			Readable.prototype._undestroy = destroyImpl.undestroy;
    			Readable.prototype._destroy = function (err, cb) {
    			  cb(err);
    			};

    			// Manually shove something into the read() buffer.
    			// This returns true if the highWaterMark has not been hit yet,
    			// similar to how Writable.write() returns true if you should
    			// write() some more.
    			Readable.prototype.push = function (chunk, encoding) {
    			  var state = this._readableState;
    			  var skipChunkCheck;
    			  if (!state.objectMode) {
    			    if (typeof chunk === 'string') {
    			      encoding = encoding || state.defaultEncoding;
    			      if (encoding !== state.encoding) {
    			        chunk = Buffer.from(chunk, encoding);
    			        encoding = '';
    			      }
    			      skipChunkCheck = true;
    			    }
    			  } else {
    			    skipChunkCheck = true;
    			  }
    			  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
    			};

    			// Unshift should *always* be something directly out of read()
    			Readable.prototype.unshift = function (chunk) {
    			  return readableAddChunk(this, chunk, null, true, false);
    			};
    			function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    			  debug('readableAddChunk', chunk);
    			  var state = stream._readableState;
    			  if (chunk === null) {
    			    state.reading = false;
    			    onEofChunk(stream, state);
    			  } else {
    			    var er;
    			    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    			    if (er) {
    			      errorOrDestroy(stream, er);
    			    } else if (state.objectMode || chunk && chunk.length > 0) {
    			      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
    			        chunk = _uint8ArrayToBuffer(chunk);
    			      }
    			      if (addToFront) {
    			        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
    			      } else if (state.ended) {
    			        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
    			      } else if (state.destroyed) {
    			        return false;
    			      } else {
    			        state.reading = false;
    			        if (state.decoder && !encoding) {
    			          chunk = state.decoder.write(chunk);
    			          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
    			        } else {
    			          addChunk(stream, state, chunk, false);
    			        }
    			      }
    			    } else if (!addToFront) {
    			      state.reading = false;
    			      maybeReadMore(stream, state);
    			    }
    			  }

    			  // We can push more data if we are below the highWaterMark.
    			  // Also, if we have no data yet, we can stand some more bytes.
    			  // This is to work around cases where hwm=0, such as the repl.
    			  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
    			}
    			function addChunk(stream, state, chunk, addToFront) {
    			  if (state.flowing && state.length === 0 && !state.sync) {
    			    state.awaitDrain = 0;
    			    stream.emit('data', chunk);
    			  } else {
    			    // update the buffer info.
    			    state.length += state.objectMode ? 1 : chunk.length;
    			    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    			    if (state.needReadable) emitReadable(stream);
    			  }
    			  maybeReadMore(stream, state);
    			}
    			function chunkInvalid(state, chunk) {
    			  var er;
    			  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    			    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
    			  }
    			  return er;
    			}
    			Readable.prototype.isPaused = function () {
    			  return this._readableState.flowing === false;
    			};

    			// backwards compatibility.
    			Readable.prototype.setEncoding = function (enc) {
    			  if (!StringDecoder) StringDecoder = require$$10.StringDecoder;
    			  const decoder = new StringDecoder(enc);
    			  this._readableState.decoder = decoder;
    			  // If setEncoding(null), decoder.encoding equals utf8
    			  this._readableState.encoding = this._readableState.decoder.encoding;

    			  // Iterate over current buffer to convert already stored Buffers:
    			  let p = this._readableState.buffer.head;
    			  let content = '';
    			  while (p !== null) {
    			    content += decoder.write(p.data);
    			    p = p.next;
    			  }
    			  this._readableState.buffer.clear();
    			  if (content !== '') this._readableState.buffer.push(content);
    			  this._readableState.length = content.length;
    			  return this;
    			};

    			// Don't raise the hwm > 1GB
    			const MAX_HWM = 0x40000000;
    			function computeNewHighWaterMark(n) {
    			  if (n >= MAX_HWM) {
    			    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    			    n = MAX_HWM;
    			  } else {
    			    // Get the next highest power of 2 to prevent increasing hwm excessively in
    			    // tiny amounts
    			    n--;
    			    n |= n >>> 1;
    			    n |= n >>> 2;
    			    n |= n >>> 4;
    			    n |= n >>> 8;
    			    n |= n >>> 16;
    			    n++;
    			  }
    			  return n;
    			}

    			// This function is designed to be inlinable, so please take care when making
    			// changes to the function body.
    			function howMuchToRead(n, state) {
    			  if (n <= 0 || state.length === 0 && state.ended) return 0;
    			  if (state.objectMode) return 1;
    			  if (n !== n) {
    			    // Only flow one buffer at a time
    			    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
    			  }
    			  // If we're asking for more than the current hwm, then raise the hwm.
    			  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    			  if (n <= state.length) return n;
    			  // Don't have enough
    			  if (!state.ended) {
    			    state.needReadable = true;
    			    return 0;
    			  }
    			  return state.length;
    			}

    			// you can override either this method, or the async _read(n) below.
    			Readable.prototype.read = function (n) {
    			  debug('read', n);
    			  n = parseInt(n, 10);
    			  var state = this._readableState;
    			  var nOrig = n;
    			  if (n !== 0) state.emittedReadable = false;

    			  // if we're doing read(0) to trigger a readable event, but we
    			  // already have a bunch of data in the buffer, then just trigger
    			  // the 'readable' event and move on.
    			  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    			    debug('read: emitReadable', state.length, state.ended);
    			    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    			    return null;
    			  }
    			  n = howMuchToRead(n, state);

    			  // if we've ended, and we're now clear, then finish it up.
    			  if (n === 0 && state.ended) {
    			    if (state.length === 0) endReadable(this);
    			    return null;
    			  }

    			  // All the actual chunk generation logic needs to be
    			  // *below* the call to _read.  The reason is that in certain
    			  // synthetic stream cases, such as passthrough streams, _read
    			  // may be a completely synchronous operation which may change
    			  // the state of the read buffer, providing enough data when
    			  // before there was *not* enough.
    			  //
    			  // So, the steps are:
    			  // 1. Figure out what the state of things will be after we do
    			  // a read from the buffer.
    			  //
    			  // 2. If that resulting state will trigger a _read, then call _read.
    			  // Note that this may be asynchronous, or synchronous.  Yes, it is
    			  // deeply ugly to write APIs this way, but that still doesn't mean
    			  // that the Readable class should behave improperly, as streams are
    			  // designed to be sync/async agnostic.
    			  // Take note if the _read call is sync or async (ie, if the read call
    			  // has returned yet), so that we know whether or not it's safe to emit
    			  // 'readable' etc.
    			  //
    			  // 3. Actually pull the requested chunks out of the buffer and return.

    			  // if we need a readable event, then we need to do some reading.
    			  var doRead = state.needReadable;
    			  debug('need readable', doRead);

    			  // if we currently have less than the highWaterMark, then also read some
    			  if (state.length === 0 || state.length - n < state.highWaterMark) {
    			    doRead = true;
    			    debug('length less than watermark', doRead);
    			  }

    			  // however, if we've ended, then there's no point, and if we're already
    			  // reading, then it's unnecessary.
    			  if (state.ended || state.reading) {
    			    doRead = false;
    			    debug('reading or ended', doRead);
    			  } else if (doRead) {
    			    debug('do read');
    			    state.reading = true;
    			    state.sync = true;
    			    // if the length is currently zero, then we *need* a readable event.
    			    if (state.length === 0) state.needReadable = true;
    			    // call internal read method
    			    this._read(state.highWaterMark);
    			    state.sync = false;
    			    // If _read pushed data synchronously, then `reading` will be false,
    			    // and we need to re-evaluate how much data we can return to the user.
    			    if (!state.reading) n = howMuchToRead(nOrig, state);
    			  }
    			  var ret;
    			  if (n > 0) ret = fromList(n, state);else ret = null;
    			  if (ret === null) {
    			    state.needReadable = state.length <= state.highWaterMark;
    			    n = 0;
    			  } else {
    			    state.length -= n;
    			    state.awaitDrain = 0;
    			  }
    			  if (state.length === 0) {
    			    // If we have nothing in the buffer, then we want to know
    			    // as soon as we *do* get something into the buffer.
    			    if (!state.ended) state.needReadable = true;

    			    // If we tried to read() past the EOF, then emit end on the next tick.
    			    if (nOrig !== n && state.ended) endReadable(this);
    			  }
    			  if (ret !== null) this.emit('data', ret);
    			  return ret;
    			};
    			function onEofChunk(stream, state) {
    			  debug('onEofChunk');
    			  if (state.ended) return;
    			  if (state.decoder) {
    			    var chunk = state.decoder.end();
    			    if (chunk && chunk.length) {
    			      state.buffer.push(chunk);
    			      state.length += state.objectMode ? 1 : chunk.length;
    			    }
    			  }
    			  state.ended = true;
    			  if (state.sync) {
    			    // if we are sync, wait until next tick to emit the data.
    			    // Otherwise we risk emitting data in the flow()
    			    // the readable code triggers during a read() call
    			    emitReadable(stream);
    			  } else {
    			    // emit 'readable' now to make sure it gets picked up.
    			    state.needReadable = false;
    			    if (!state.emittedReadable) {
    			      state.emittedReadable = true;
    			      emitReadable_(stream);
    			    }
    			  }
    			}

    			// Don't emit readable right away in sync mode, because this can trigger
    			// another read() call => stack overflow.  This way, it might trigger
    			// a nextTick recursion warning, but that's not so bad.
    			function emitReadable(stream) {
    			  var state = stream._readableState;
    			  debug('emitReadable', state.needReadable, state.emittedReadable);
    			  state.needReadable = false;
    			  if (!state.emittedReadable) {
    			    debug('emitReadable', state.flowing);
    			    state.emittedReadable = true;
    			    process.nextTick(emitReadable_, stream);
    			  }
    			}
    			function emitReadable_(stream) {
    			  var state = stream._readableState;
    			  debug('emitReadable_', state.destroyed, state.length, state.ended);
    			  if (!state.destroyed && (state.length || state.ended)) {
    			    stream.emit('readable');
    			    state.emittedReadable = false;
    			  }

    			  // The stream needs another readable event if
    			  // 1. It is not flowing, as the flow mechanism will take
    			  //    care of it.
    			  // 2. It is not ended.
    			  // 3. It is below the highWaterMark, so we can schedule
    			  //    another readable later.
    			  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    			  flow(stream);
    			}

    			// at this point, the user has presumably seen the 'readable' event,
    			// and called read() to consume some data.  that may have triggered
    			// in turn another _read(n) call, in which case reading = true if
    			// it's in progress.
    			// However, if we're not ended, or reading, and the length < hwm,
    			// then go ahead and try to read some more preemptively.
    			function maybeReadMore(stream, state) {
    			  if (!state.readingMore) {
    			    state.readingMore = true;
    			    process.nextTick(maybeReadMore_, stream, state);
    			  }
    			}
    			function maybeReadMore_(stream, state) {
    			  // Attempt to read more data if we should.
    			  //
    			  // The conditions for reading more data are (one of):
    			  // - Not enough data buffered (state.length < state.highWaterMark). The loop
    			  //   is responsible for filling the buffer with enough data if such data
    			  //   is available. If highWaterMark is 0 and we are not in the flowing mode
    			  //   we should _not_ attempt to buffer any extra data. We'll get more data
    			  //   when the stream consumer calls read() instead.
    			  // - No data in the buffer, and the stream is in flowing mode. In this mode
    			  //   the loop below is responsible for ensuring read() is called. Failing to
    			  //   call read here would abort the flow and there's no other mechanism for
    			  //   continuing the flow if the stream consumer has just subscribed to the
    			  //   'data' event.
    			  //
    			  // In addition to the above conditions to keep reading data, the following
    			  // conditions prevent the data from being read:
    			  // - The stream has ended (state.ended).
    			  // - There is already a pending 'read' operation (state.reading). This is a
    			  //   case where the the stream has called the implementation defined _read()
    			  //   method, but they are processing the call asynchronously and have _not_
    			  //   called push() with new data. In this case we skip performing more
    			  //   read()s. The execution ends in this method again after the _read() ends
    			  //   up calling push() with more data.
    			  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    			    const len = state.length;
    			    debug('maybeReadMore read 0');
    			    stream.read(0);
    			    if (len === state.length)
    			      // didn't get any data, stop spinning.
    			      break;
    			  }
    			  state.readingMore = false;
    			}

    			// abstract method.  to be overridden in specific implementation classes.
    			// call cb(er, data) where data is <= n in length.
    			// for virtual (non-string, non-buffer) streams, "length" is somewhat
    			// arbitrary, and perhaps not very meaningful.
    			Readable.prototype._read = function (n) {
    			  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
    			};
    			Readable.prototype.pipe = function (dest, pipeOpts) {
    			  var src = this;
    			  var state = this._readableState;
    			  switch (state.pipesCount) {
    			    case 0:
    			      state.pipes = dest;
    			      break;
    			    case 1:
    			      state.pipes = [state.pipes, dest];
    			      break;
    			    default:
    			      state.pipes.push(dest);
    			      break;
    			  }
    			  state.pipesCount += 1;
    			  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    			  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
    			  var endFn = doEnd ? onend : unpipe;
    			  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
    			  dest.on('unpipe', onunpipe);
    			  function onunpipe(readable, unpipeInfo) {
    			    debug('onunpipe');
    			    if (readable === src) {
    			      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
    			        unpipeInfo.hasUnpiped = true;
    			        cleanup();
    			      }
    			    }
    			  }
    			  function onend() {
    			    debug('onend');
    			    dest.end();
    			  }

    			  // when the dest drains, it reduces the awaitDrain counter
    			  // on the source.  This would be more elegant with a .once()
    			  // handler in flow(), but adding and removing repeatedly is
    			  // too slow.
    			  var ondrain = pipeOnDrain(src);
    			  dest.on('drain', ondrain);
    			  var cleanedUp = false;
    			  function cleanup() {
    			    debug('cleanup');
    			    // cleanup event handlers once the pipe is broken
    			    dest.removeListener('close', onclose);
    			    dest.removeListener('finish', onfinish);
    			    dest.removeListener('drain', ondrain);
    			    dest.removeListener('error', onerror);
    			    dest.removeListener('unpipe', onunpipe);
    			    src.removeListener('end', onend);
    			    src.removeListener('end', unpipe);
    			    src.removeListener('data', ondata);
    			    cleanedUp = true;

    			    // if the reader is waiting for a drain event from this
    			    // specific writer, then it would cause it to never start
    			    // flowing again.
    			    // So, if this is awaiting a drain, then we just call it now.
    			    // If we don't know, then assume that we are waiting for one.
    			    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    			  }
    			  src.on('data', ondata);
    			  function ondata(chunk) {
    			    debug('ondata');
    			    var ret = dest.write(chunk);
    			    debug('dest.write', ret);
    			    if (ret === false) {
    			      // If the user unpiped during `dest.write()`, it is possible
    			      // to get stuck in a permanently paused state if that write
    			      // also returned false.
    			      // => Check whether `dest` is still a piping destination.
    			      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
    			        debug('false write response, pause', state.awaitDrain);
    			        state.awaitDrain++;
    			      }
    			      src.pause();
    			    }
    			  }

    			  // if the dest has an error, then stop piping into it.
    			  // however, don't suppress the throwing behavior for this.
    			  function onerror(er) {
    			    debug('onerror', er);
    			    unpipe();
    			    dest.removeListener('error', onerror);
    			    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
    			  }

    			  // Make sure our error handler is attached before userland ones.
    			  prependListener(dest, 'error', onerror);

    			  // Both close and finish should trigger unpipe, but only once.
    			  function onclose() {
    			    dest.removeListener('finish', onfinish);
    			    unpipe();
    			  }
    			  dest.once('close', onclose);
    			  function onfinish() {
    			    debug('onfinish');
    			    dest.removeListener('close', onclose);
    			    unpipe();
    			  }
    			  dest.once('finish', onfinish);
    			  function unpipe() {
    			    debug('unpipe');
    			    src.unpipe(dest);
    			  }

    			  // tell the dest that it's being piped to
    			  dest.emit('pipe', src);

    			  // start the flow if it hasn't been started already.
    			  if (!state.flowing) {
    			    debug('pipe resume');
    			    src.resume();
    			  }
    			  return dest;
    			};
    			function pipeOnDrain(src) {
    			  return function pipeOnDrainFunctionResult() {
    			    var state = src._readableState;
    			    debug('pipeOnDrain', state.awaitDrain);
    			    if (state.awaitDrain) state.awaitDrain--;
    			    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
    			      state.flowing = true;
    			      flow(src);
    			    }
    			  };
    			}
    			Readable.prototype.unpipe = function (dest) {
    			  var state = this._readableState;
    			  var unpipeInfo = {
    			    hasUnpiped: false
    			  };

    			  // if we're not piping anywhere, then do nothing.
    			  if (state.pipesCount === 0) return this;

    			  // just one destination.  most common case.
    			  if (state.pipesCount === 1) {
    			    // passed in one, but it's not the right one.
    			    if (dest && dest !== state.pipes) return this;
    			    if (!dest) dest = state.pipes;

    			    // got a match.
    			    state.pipes = null;
    			    state.pipesCount = 0;
    			    state.flowing = false;
    			    if (dest) dest.emit('unpipe', this, unpipeInfo);
    			    return this;
    			  }

    			  // slow case. multiple pipe destinations.

    			  if (!dest) {
    			    // remove all.
    			    var dests = state.pipes;
    			    var len = state.pipesCount;
    			    state.pipes = null;
    			    state.pipesCount = 0;
    			    state.flowing = false;
    			    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
    			      hasUnpiped: false
    			    });
    			    return this;
    			  }

    			  // try to find the right one.
    			  var index = indexOf(state.pipes, dest);
    			  if (index === -1) return this;
    			  state.pipes.splice(index, 1);
    			  state.pipesCount -= 1;
    			  if (state.pipesCount === 1) state.pipes = state.pipes[0];
    			  dest.emit('unpipe', this, unpipeInfo);
    			  return this;
    			};

    			// set up data events if they are asked for
    			// Ensure readable listeners eventually get something
    			Readable.prototype.on = function (ev, fn) {
    			  const res = Stream.prototype.on.call(this, ev, fn);
    			  const state = this._readableState;
    			  if (ev === 'data') {
    			    // update readableListening so that resume() may be a no-op
    			    // a few lines down. This is needed to support once('readable').
    			    state.readableListening = this.listenerCount('readable') > 0;

    			    // Try start flowing on next tick if stream isn't explicitly paused
    			    if (state.flowing !== false) this.resume();
    			  } else if (ev === 'readable') {
    			    if (!state.endEmitted && !state.readableListening) {
    			      state.readableListening = state.needReadable = true;
    			      state.flowing = false;
    			      state.emittedReadable = false;
    			      debug('on readable', state.length, state.reading);
    			      if (state.length) {
    			        emitReadable(this);
    			      } else if (!state.reading) {
    			        process.nextTick(nReadingNextTick, this);
    			      }
    			    }
    			  }
    			  return res;
    			};
    			Readable.prototype.addListener = Readable.prototype.on;
    			Readable.prototype.removeListener = function (ev, fn) {
    			  const res = Stream.prototype.removeListener.call(this, ev, fn);
    			  if (ev === 'readable') {
    			    // We need to check if there is someone still listening to
    			    // readable and reset the state. However this needs to happen
    			    // after readable has been emitted but before I/O (nextTick) to
    			    // support once('readable', fn) cycles. This means that calling
    			    // resume within the same tick will have no
    			    // effect.
    			    process.nextTick(updateReadableListening, this);
    			  }
    			  return res;
    			};
    			Readable.prototype.removeAllListeners = function (ev) {
    			  const res = Stream.prototype.removeAllListeners.apply(this, arguments);
    			  if (ev === 'readable' || ev === undefined) {
    			    // We need to check if there is someone still listening to
    			    // readable and reset the state. However this needs to happen
    			    // after readable has been emitted but before I/O (nextTick) to
    			    // support once('readable', fn) cycles. This means that calling
    			    // resume within the same tick will have no
    			    // effect.
    			    process.nextTick(updateReadableListening, this);
    			  }
    			  return res;
    			};
    			function updateReadableListening(self) {
    			  const state = self._readableState;
    			  state.readableListening = self.listenerCount('readable') > 0;
    			  if (state.resumeScheduled && !state.paused) {
    			    // flowing needs to be set to true now, otherwise
    			    // the upcoming resume will not flow.
    			    state.flowing = true;

    			    // crude way to check if we should resume
    			  } else if (self.listenerCount('data') > 0) {
    			    self.resume();
    			  }
    			}
    			function nReadingNextTick(self) {
    			  debug('readable nexttick read 0');
    			  self.read(0);
    			}

    			// pause() and resume() are remnants of the legacy readable stream API
    			// If the user uses them, then switch into old mode.
    			Readable.prototype.resume = function () {
    			  var state = this._readableState;
    			  if (!state.flowing) {
    			    debug('resume');
    			    // we flow only if there is no one listening
    			    // for readable, but we still have to call
    			    // resume()
    			    state.flowing = !state.readableListening;
    			    resume(this, state);
    			  }
    			  state.paused = false;
    			  return this;
    			};
    			function resume(stream, state) {
    			  if (!state.resumeScheduled) {
    			    state.resumeScheduled = true;
    			    process.nextTick(resume_, stream, state);
    			  }
    			}
    			function resume_(stream, state) {
    			  debug('resume', state.reading);
    			  if (!state.reading) {
    			    stream.read(0);
    			  }
    			  state.resumeScheduled = false;
    			  stream.emit('resume');
    			  flow(stream);
    			  if (state.flowing && !state.reading) stream.read(0);
    			}
    			Readable.prototype.pause = function () {
    			  debug('call pause flowing=%j', this._readableState.flowing);
    			  if (this._readableState.flowing !== false) {
    			    debug('pause');
    			    this._readableState.flowing = false;
    			    this.emit('pause');
    			  }
    			  this._readableState.paused = true;
    			  return this;
    			};
    			function flow(stream) {
    			  const state = stream._readableState;
    			  debug('flow', state.flowing);
    			  while (state.flowing && stream.read() !== null);
    			}

    			// wrap an old-style stream as the async data source.
    			// This is *not* part of the readable stream interface.
    			// It is an ugly unfortunate mess of history.
    			Readable.prototype.wrap = function (stream) {
    			  var state = this._readableState;
    			  var paused = false;
    			  stream.on('end', () => {
    			    debug('wrapped end');
    			    if (state.decoder && !state.ended) {
    			      var chunk = state.decoder.end();
    			      if (chunk && chunk.length) this.push(chunk);
    			    }
    			    this.push(null);
    			  });
    			  stream.on('data', chunk => {
    			    debug('wrapped data');
    			    if (state.decoder) chunk = state.decoder.write(chunk);

    			    // don't skip over falsy values in objectMode
    			    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    			    var ret = this.push(chunk);
    			    if (!ret) {
    			      paused = true;
    			      stream.pause();
    			    }
    			  });

    			  // proxy all the other methods.
    			  // important when wrapping filters and duplexes.
    			  for (var i in stream) {
    			    if (this[i] === undefined && typeof stream[i] === 'function') {
    			      this[i] = function methodWrap(method) {
    			        return function methodWrapReturnFunction() {
    			          return stream[method].apply(stream, arguments);
    			        };
    			      }(i);
    			    }
    			  }

    			  // proxy certain important events.
    			  for (var n = 0; n < kProxyEvents.length; n++) {
    			    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
    			  }

    			  // when we try to consume some more bytes, simply unpause the
    			  // underlying stream.
    			  this._read = n => {
    			    debug('wrapped _read', n);
    			    if (paused) {
    			      paused = false;
    			      stream.resume();
    			    }
    			  };
    			  return this;
    			};
    			if (typeof Symbol === 'function') {
    			  Readable.prototype[Symbol.asyncIterator] = function () {
    			    if (createReadableStreamAsyncIterator === undefined) {
    			      createReadableStreamAsyncIterator = requireAsync_iterator();
    			    }
    			    return createReadableStreamAsyncIterator(this);
    			  };
    			}
    			Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
    			  // making it explicit this property is not enumerable
    			  // because otherwise some prototype manipulation in
    			  // userland will fail
    			  enumerable: false,
    			  get: function get() {
    			    return this._readableState.highWaterMark;
    			  }
    			});
    			Object.defineProperty(Readable.prototype, 'readableBuffer', {
    			  // making it explicit this property is not enumerable
    			  // because otherwise some prototype manipulation in
    			  // userland will fail
    			  enumerable: false,
    			  get: function get() {
    			    return this._readableState && this._readableState.buffer;
    			  }
    			});
    			Object.defineProperty(Readable.prototype, 'readableFlowing', {
    			  // making it explicit this property is not enumerable
    			  // because otherwise some prototype manipulation in
    			  // userland will fail
    			  enumerable: false,
    			  get: function get() {
    			    return this._readableState.flowing;
    			  },
    			  set: function set(state) {
    			    if (this._readableState) {
    			      this._readableState.flowing = state;
    			    }
    			  }
    			});

    			// exposed for testing purposes only.
    			Readable._fromList = fromList;
    			Object.defineProperty(Readable.prototype, 'readableLength', {
    			  // making it explicit this property is not enumerable
    			  // because otherwise some prototype manipulation in
    			  // userland will fail
    			  enumerable: false,
    			  get() {
    			    return this._readableState.length;
    			  }
    			});

    			// Pluck off n bytes from an array of buffers.
    			// Length is the combined lengths of all the buffers in the list.
    			// This function is designed to be inlinable, so please take care when making
    			// changes to the function body.
    			function fromList(n, state) {
    			  // nothing buffered
    			  if (state.length === 0) return null;
    			  var ret;
    			  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    			    // read it all, truncate the list
    			    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    			    state.buffer.clear();
    			  } else {
    			    // read part of list
    			    ret = state.buffer.consume(n, state.decoder);
    			  }
    			  return ret;
    			}
    			function endReadable(stream) {
    			  var state = stream._readableState;
    			  debug('endReadable', state.endEmitted);
    			  if (!state.endEmitted) {
    			    state.ended = true;
    			    process.nextTick(endReadableNT, state, stream);
    			  }
    			}
    			function endReadableNT(state, stream) {
    			  debug('endReadableNT', state.endEmitted, state.length);

    			  // Check that we didn't get one last unshift.
    			  if (!state.endEmitted && state.length === 0) {
    			    state.endEmitted = true;
    			    stream.readable = false;
    			    stream.emit('end');
    			    if (state.autoDestroy) {
    			      // In case of duplex streams we need a way to detect
    			      // if the writable side is ready for autoDestroy as well
    			      const wState = stream._writableState;
    			      if (!wState || wState.autoDestroy && wState.finished) {
    			        stream.destroy();
    			      }
    			    }
    			  }
    			}
    			if (typeof Symbol === 'function') {
    			  Readable.from = function (iterable, opts) {
    			    if (from === undefined) {
    			      from = requireFromBrowser();
    			    }
    			    return from(Readable, iterable, opts);
    			  };
    			}
    			function indexOf(xs, x) {
    			  for (var i = 0, l = xs.length; i < l; i++) {
    			    if (xs[i] === x) return i;
    			  }
    			  return -1;
    			}
    			return _stream_readable;
    		}

    		var _stream_transform = Transform$2;
    		const _require$codes$1 = errorsBrowser.codes,
    		  ERR_METHOD_NOT_IMPLEMENTED = _require$codes$1.ERR_METHOD_NOT_IMPLEMENTED,
    		  ERR_MULTIPLE_CALLBACK = _require$codes$1.ERR_MULTIPLE_CALLBACK,
    		  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes$1.ERR_TRANSFORM_ALREADY_TRANSFORMING,
    		  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes$1.ERR_TRANSFORM_WITH_LENGTH_0;
    		const Duplex = require_stream_duplex();
    		require$$0$1(Transform$2, Duplex);
    		function afterTransform(er, data) {
    		  var ts = this._transformState;
    		  ts.transforming = false;
    		  var cb = ts.writecb;
    		  if (cb === null) {
    		    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
    		  }
    		  ts.writechunk = null;
    		  ts.writecb = null;
    		  if (data != null)
    		    // single equals check for both `null` and `undefined`
    		    this.push(data);
    		  cb(er);
    		  var rs = this._readableState;
    		  rs.reading = false;
    		  if (rs.needReadable || rs.length < rs.highWaterMark) {
    		    this._read(rs.highWaterMark);
    		  }
    		}
    		function Transform$2(options) {
    		  if (!(this instanceof Transform$2)) return new Transform$2(options);
    		  Duplex.call(this, options);
    		  this._transformState = {
    		    afterTransform: afterTransform.bind(this),
    		    needTransform: false,
    		    transforming: false,
    		    writecb: null,
    		    writechunk: null,
    		    writeencoding: null
    		  };

    		  // start out asking for a readable event once data is transformed.
    		  this._readableState.needReadable = true;

    		  // we have implemented the _read method, and done the other things
    		  // that Readable wants before the first _read call, so unset the
    		  // sync guard flag.
    		  this._readableState.sync = false;
    		  if (options) {
    		    if (typeof options.transform === 'function') this._transform = options.transform;
    		    if (typeof options.flush === 'function') this._flush = options.flush;
    		  }

    		  // When the writable side finishes, then flush out anything remaining.
    		  this.on('prefinish', prefinish);
    		}
    		function prefinish() {
    		  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    		    this._flush((er, data) => {
    		      done(this, er, data);
    		    });
    		  } else {
    		    done(this, null, null);
    		  }
    		}
    		Transform$2.prototype.push = function (chunk, encoding) {
    		  this._transformState.needTransform = false;
    		  return Duplex.prototype.push.call(this, chunk, encoding);
    		};

    		// This is the part where you do stuff!
    		// override this function in implementation classes.
    		// 'chunk' is an input chunk.
    		//
    		// Call `push(newChunk)` to pass along transformed output
    		// to the readable side.  You may call 'push' zero or more times.
    		//
    		// Call `cb(err)` when you are done with this chunk.  If you pass
    		// an error, then that'll put the hurt on the whole operation.  If you
    		// never call cb(), then you'll never get another chunk.
    		Transform$2.prototype._transform = function (chunk, encoding, cb) {
    		  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
    		};
    		Transform$2.prototype._write = function (chunk, encoding, cb) {
    		  var ts = this._transformState;
    		  ts.writecb = cb;
    		  ts.writechunk = chunk;
    		  ts.writeencoding = encoding;
    		  if (!ts.transforming) {
    		    var rs = this._readableState;
    		    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    		  }
    		};

    		// Doesn't matter what the args are here.
    		// _transform does all the work.
    		// That we got here means that the readable side wants more data.
    		Transform$2.prototype._read = function (n) {
    		  var ts = this._transformState;
    		  if (ts.writechunk !== null && !ts.transforming) {
    		    ts.transforming = true;
    		    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    		  } else {
    		    // mark that we need a transform, so that any data that comes in
    		    // will get processed, now that we've asked for it.
    		    ts.needTransform = true;
    		  }
    		};
    		Transform$2.prototype._destroy = function (err, cb) {
    		  Duplex.prototype._destroy.call(this, err, err2 => {
    		    cb(err2);
    		  });
    		};
    		function done(stream, er, data) {
    		  if (er) return stream.emit('error', er);
    		  if (data != null)
    		    // single equals check for both `null` and `undefined`
    		    stream.push(data);

    		  // TODO(BridgeAR): Write a test for these two error cases
    		  // if there's nothing in the write buffer, then that means
    		  // that nothing more will ever be provided
    		  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
    		  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
    		  return stream.push(null);
    		}

    		var _stream_passthrough = PassThrough;
    		const Transform$1 = _stream_transform;
    		require$$0$1(PassThrough, Transform$1);
    		function PassThrough(options) {
    		  if (!(this instanceof PassThrough)) return new PassThrough(options);
    		  Transform$1.call(this, options);
    		}
    		PassThrough.prototype._transform = function (chunk, encoding, cb) {
    		  cb(null, chunk);
    		};

    		let eos;
    		function once(callback) {
    		  let called = false;
    		  return function () {
    		    if (called) return;
    		    called = true;
    		    callback(...arguments);
    		  };
    		}
    		const _require$codes = errorsBrowser.codes,
    		  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
    		  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
    		function noop(err) {
    		  // Rethrow the error if it exists to avoid swallowing it
    		  if (err) throw err;
    		}
    		function isRequest(stream) {
    		  return stream.setHeader && typeof stream.abort === 'function';
    		}
    		function destroyer(stream, reading, writing, callback) {
    		  callback = once(callback);
    		  let closed = false;
    		  stream.on('close', () => {
    		    closed = true;
    		  });
    		  if (eos === undefined) eos = endOfStream;
    		  eos(stream, {
    		    readable: reading,
    		    writable: writing
    		  }, err => {
    		    if (err) return callback(err);
    		    closed = true;
    		    callback();
    		  });
    		  let destroyed = false;
    		  return err => {
    		    if (closed) return;
    		    if (destroyed) return;
    		    destroyed = true;

    		    // request.destroy just do .end - .abort is what we want
    		    if (isRequest(stream)) return stream.abort();
    		    if (typeof stream.destroy === 'function') return stream.destroy();
    		    callback(err || new ERR_STREAM_DESTROYED('pipe'));
    		  };
    		}
    		function call(fn) {
    		  fn();
    		}
    		function pipe(from, to) {
    		  return from.pipe(to);
    		}
    		function popCallback(streams) {
    		  if (!streams.length) return noop;
    		  if (typeof streams[streams.length - 1] !== 'function') return noop;
    		  return streams.pop();
    		}
    		function pipeline() {
    		  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    		    streams[_key] = arguments[_key];
    		  }
    		  const callback = popCallback(streams);
    		  if (Array.isArray(streams[0])) streams = streams[0];
    		  if (streams.length < 2) {
    		    throw new ERR_MISSING_ARGS('streams');
    		  }
    		  let error;
    		  const destroys = streams.map(function (stream, i) {
    		    const reading = i < streams.length - 1;
    		    const writing = i > 0;
    		    return destroyer(stream, reading, writing, function (err) {
    		      if (!error) error = err;
    		      if (err) destroys.forEach(call);
    		      if (reading) return;
    		      destroys.forEach(call);
    		      callback(error);
    		    });
    		  });
    		  return streams.reduce(pipe);
    		}
    		var pipeline_1 = pipeline;

    		readableBrowser.exports;

    		(function (module, exports) {
    			exports = module.exports = require_stream_readable();
    			exports.Stream = exports;
    			exports.Readable = exports;
    			exports.Writable = require_stream_writable();
    			exports.Duplex = require_stream_duplex();
    			exports.Transform = _stream_transform;
    			exports.PassThrough = _stream_passthrough;
    			exports.finished = endOfStream;
    			exports.pipeline = pipeline_1; 
    		} (readableBrowser, readableBrowser.exports));

    		var readableBrowserExports = readableBrowser.exports;

    		var Buffer$b = safeBufferExports.Buffer;
    		var Transform = readableBrowserExports.Transform;
    		var inherits$8 = require$$0$1;

    		function throwIfNotStringOrBuffer (val, prefix) {
    		  if (!Buffer$b.isBuffer(val) && typeof val !== 'string') {
    		    throw new TypeError(prefix + ' must be a string or a buffer')
    		  }
    		}

    		function HashBase$2 (blockSize) {
    		  Transform.call(this);

    		  this._block = Buffer$b.allocUnsafe(blockSize);
    		  this._blockSize = blockSize;
    		  this._blockOffset = 0;
    		  this._length = [0, 0, 0, 0];

    		  this._finalized = false;
    		}

    		inherits$8(HashBase$2, Transform);

    		HashBase$2.prototype._transform = function (chunk, encoding, callback) {
    		  var error = null;
    		  try {
    		    this.update(chunk, encoding);
    		  } catch (err) {
    		    error = err;
    		  }

    		  callback(error);
    		};

    		HashBase$2.prototype._flush = function (callback) {
    		  var error = null;
    		  try {
    		    this.push(this.digest());
    		  } catch (err) {
    		    error = err;
    		  }

    		  callback(error);
    		};

    		HashBase$2.prototype.update = function (data, encoding) {
    		  throwIfNotStringOrBuffer(data, 'Data');
    		  if (this._finalized) throw new Error('Digest already called')
    		  if (!Buffer$b.isBuffer(data)) data = Buffer$b.from(data, encoding);

    		  // consume data
    		  var block = this._block;
    		  var offset = 0;
    		  while (this._blockOffset + data.length - offset >= this._blockSize) {
    		    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++];
    		    this._update();
    		    this._blockOffset = 0;
    		  }
    		  while (offset < data.length) block[this._blockOffset++] = data[offset++];

    		  // update length
    		  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    		    this._length[j] += carry;
    		    carry = (this._length[j] / 0x0100000000) | 0;
    		    if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    		  }

    		  return this
    		};

    		HashBase$2.prototype._update = function () {
    		  throw new Error('_update is not implemented')
    		};

    		HashBase$2.prototype.digest = function (encoding) {
    		  if (this._finalized) throw new Error('Digest already called')
    		  this._finalized = true;

    		  var digest = this._digest();
    		  if (encoding !== undefined) digest = digest.toString(encoding);

    		  // reset state
    		  this._block.fill(0);
    		  this._blockOffset = 0;
    		  for (var i = 0; i < 4; ++i) this._length[i] = 0;

    		  return digest
    		};

    		HashBase$2.prototype._digest = function () {
    		  throw new Error('_digest is not implemented')
    		};

    		var hashBase = HashBase$2;

    		var inherits$7 = require$$0$1;
    		var HashBase$1 = hashBase;
    		var Buffer$a = safeBufferExports.Buffer;

    		var ARRAY16$1 = new Array(16);

    		function MD5$1 () {
    		  HashBase$1.call(this, 64);

    		  // state
    		  this._a = 0x67452301;
    		  this._b = 0xefcdab89;
    		  this._c = 0x98badcfe;
    		  this._d = 0x10325476;
    		}

    		inherits$7(MD5$1, HashBase$1);

    		MD5$1.prototype._update = function () {
    		  var M = ARRAY16$1;
    		  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4);

    		  var a = this._a;
    		  var b = this._b;
    		  var c = this._c;
    		  var d = this._d;

    		  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    		  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    		  c = fnF(c, d, a, b, M[2], 0x242070db, 17);
    		  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    		  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    		  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    		  c = fnF(c, d, a, b, M[6], 0xa8304613, 17);
    		  b = fnF(b, c, d, a, M[7], 0xfd469501, 22);
    		  a = fnF(a, b, c, d, M[8], 0x698098d8, 7);
    		  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    		  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    		  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    		  a = fnF(a, b, c, d, M[12], 0x6b901122, 7);
    		  d = fnF(d, a, b, c, M[13], 0xfd987193, 12);
    		  c = fnF(c, d, a, b, M[14], 0xa679438e, 17);
    		  b = fnF(b, c, d, a, M[15], 0x49b40821, 22);

    		  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    		  d = fnG(d, a, b, c, M[6], 0xc040b340, 9);
    		  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    		  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    		  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    		  d = fnG(d, a, b, c, M[10], 0x02441453, 9);
    		  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    		  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    		  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    		  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    		  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    		  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    		  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    		  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    		  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    		  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);

    		  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    		  d = fnH(d, a, b, c, M[8], 0x8771f681, 11);
    		  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    		  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    		  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    		  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    		  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    		  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    		  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    		  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    		  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    		  b = fnH(b, c, d, a, M[6], 0x04881d05, 23);
    		  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    		  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    		  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    		  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23);

    		  a = fnI(a, b, c, d, M[0], 0xf4292244, 6);
    		  d = fnI(d, a, b, c, M[7], 0x432aff97, 10);
    		  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    		  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    		  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    		  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    		  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    		  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    		  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    		  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    		  c = fnI(c, d, a, b, M[6], 0xa3014314, 15);
    		  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    		  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    		  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    		  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    		  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21);

    		  this._a = (this._a + a) | 0;
    		  this._b = (this._b + b) | 0;
    		  this._c = (this._c + c) | 0;
    		  this._d = (this._d + d) | 0;
    		};

    		MD5$1.prototype._digest = function () {
    		  // create padding and handle blocks
    		  this._block[this._blockOffset++] = 0x80;
    		  if (this._blockOffset > 56) {
    		    this._block.fill(0, this._blockOffset, 64);
    		    this._update();
    		    this._blockOffset = 0;
    		  }

    		  this._block.fill(0, this._blockOffset, 56);
    		  this._block.writeUInt32LE(this._length[0], 56);
    		  this._block.writeUInt32LE(this._length[1], 60);
    		  this._update();

    		  // produce result
    		  var buffer = Buffer$a.allocUnsafe(16);
    		  buffer.writeInt32LE(this._a, 0);
    		  buffer.writeInt32LE(this._b, 4);
    		  buffer.writeInt32LE(this._c, 8);
    		  buffer.writeInt32LE(this._d, 12);
    		  return buffer
    		};

    		function rotl$1 (x, n) {
    		  return (x << n) | (x >>> (32 - n))
    		}

    		function fnF (a, b, c, d, m, k, s) {
    		  return (rotl$1((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
    		}

    		function fnG (a, b, c, d, m, k, s) {
    		  return (rotl$1((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
    		}

    		function fnH (a, b, c, d, m, k, s) {
    		  return (rotl$1((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
    		}

    		function fnI (a, b, c, d, m, k, s) {
    		  return (rotl$1((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
    		}

    		var md5_js = MD5$1;

    		var MD5 = md5_js;

    		var md5$1 = function (buffer) {
    		  return new MD5().update(buffer).digest()
    		};

    		var Buffer$9 = require$$0$3.Buffer;
    		var inherits$6 = require$$0$1;
    		var HashBase = hashBase;

    		var ARRAY16 = new Array(16);

    		var zl = [
    		  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    		  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
    		  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
    		  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
    		  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
    		];

    		var zr = [
    		  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
    		  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
    		  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
    		  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
    		  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
    		];

    		var sl = [
    		  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
    		  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
    		  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
    		  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
    		  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
    		];

    		var sr = [
    		  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
    		  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
    		  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
    		  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
    		  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
    		];

    		var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e];
    		var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000];

    		function RIPEMD160$1 () {
    		  HashBase.call(this, 64);

    		  // state
    		  this._a = 0x67452301;
    		  this._b = 0xefcdab89;
    		  this._c = 0x98badcfe;
    		  this._d = 0x10325476;
    		  this._e = 0xc3d2e1f0;
    		}

    		inherits$6(RIPEMD160$1, HashBase);

    		RIPEMD160$1.prototype._update = function () {
    		  var words = ARRAY16;
    		  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4);

    		  var al = this._a | 0;
    		  var bl = this._b | 0;
    		  var cl = this._c | 0;
    		  var dl = this._d | 0;
    		  var el = this._e | 0;

    		  var ar = this._a | 0;
    		  var br = this._b | 0;
    		  var cr = this._c | 0;
    		  var dr = this._d | 0;
    		  var er = this._e | 0;

    		  // computation
    		  for (var i = 0; i < 80; i += 1) {
    		    var tl;
    		    var tr;
    		    if (i < 16) {
    		      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i]);
    		      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i]);
    		    } else if (i < 32) {
    		      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i]);
    		      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i]);
    		    } else if (i < 48) {
    		      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i]);
    		      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i]);
    		    } else if (i < 64) {
    		      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i]);
    		      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i]);
    		    } else { // if (i<80) {
    		      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i]);
    		      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i]);
    		    }

    		    al = el;
    		    el = dl;
    		    dl = rotl(cl, 10);
    		    cl = bl;
    		    bl = tl;

    		    ar = er;
    		    er = dr;
    		    dr = rotl(cr, 10);
    		    cr = br;
    		    br = tr;
    		  }

    		  // update state
    		  var t = (this._b + cl + dr) | 0;
    		  this._b = (this._c + dl + er) | 0;
    		  this._c = (this._d + el + ar) | 0;
    		  this._d = (this._e + al + br) | 0;
    		  this._e = (this._a + bl + cr) | 0;
    		  this._a = t;
    		};

    		RIPEMD160$1.prototype._digest = function () {
    		  // create padding and handle blocks
    		  this._block[this._blockOffset++] = 0x80;
    		  if (this._blockOffset > 56) {
    		    this._block.fill(0, this._blockOffset, 64);
    		    this._update();
    		    this._blockOffset = 0;
    		  }

    		  this._block.fill(0, this._blockOffset, 56);
    		  this._block.writeUInt32LE(this._length[0], 56);
    		  this._block.writeUInt32LE(this._length[1], 60);
    		  this._update();

    		  // produce result
    		  var buffer = Buffer$9.alloc ? Buffer$9.alloc(20) : new Buffer$9(20);
    		  buffer.writeInt32LE(this._a, 0);
    		  buffer.writeInt32LE(this._b, 4);
    		  buffer.writeInt32LE(this._c, 8);
    		  buffer.writeInt32LE(this._d, 12);
    		  buffer.writeInt32LE(this._e, 16);
    		  return buffer
    		};

    		function rotl (x, n) {
    		  return (x << n) | (x >>> (32 - n))
    		}

    		function fn1 (a, b, c, d, e, m, k, s) {
    		  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
    		}

    		function fn2 (a, b, c, d, e, m, k, s) {
    		  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
    		}

    		function fn3 (a, b, c, d, e, m, k, s) {
    		  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
    		}

    		function fn4 (a, b, c, d, e, m, k, s) {
    		  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
    		}

    		function fn5 (a, b, c, d, e, m, k, s) {
    		  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
    		}

    		var ripemd160 = RIPEMD160$1;

    		var sha_js = {exports: {}};

    		var Buffer$8 = safeBufferExports.Buffer;

    		// prototype class for hash functions
    		function Hash$6 (blockSize, finalSize) {
    		  this._block = Buffer$8.alloc(blockSize);
    		  this._finalSize = finalSize;
    		  this._blockSize = blockSize;
    		  this._len = 0;
    		}

    		Hash$6.prototype.update = function (data, enc) {
    		  if (typeof data === 'string') {
    		    enc = enc || 'utf8';
    		    data = Buffer$8.from(data, enc);
    		  }

    		  var block = this._block;
    		  var blockSize = this._blockSize;
    		  var length = data.length;
    		  var accum = this._len;

    		  for (var offset = 0; offset < length;) {
    		    var assigned = accum % blockSize;
    		    var remainder = Math.min(length - offset, blockSize - assigned);

    		    for (var i = 0; i < remainder; i++) {
    		      block[assigned + i] = data[offset + i];
    		    }

    		    accum += remainder;
    		    offset += remainder;

    		    if ((accum % blockSize) === 0) {
    		      this._update(block);
    		    }
    		  }

    		  this._len += length;
    		  return this
    		};

    		Hash$6.prototype.digest = function (enc) {
    		  var rem = this._len % this._blockSize;

    		  this._block[rem] = 0x80;

    		  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    		  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    		  this._block.fill(0, rem + 1);

    		  if (rem >= this._finalSize) {
    		    this._update(this._block);
    		    this._block.fill(0);
    		  }

    		  var bits = this._len * 8;

    		  // uint32
    		  if (bits <= 0xffffffff) {
    		    this._block.writeUInt32BE(bits, this._blockSize - 4);

    		  // uint64
    		  } else {
    		    var lowBits = (bits & 0xffffffff) >>> 0;
    		    var highBits = (bits - lowBits) / 0x100000000;

    		    this._block.writeUInt32BE(highBits, this._blockSize - 8);
    		    this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    		  }

    		  this._update(this._block);
    		  var hash = this._hash();

    		  return enc ? hash.toString(enc) : hash
    		};

    		Hash$6.prototype._update = function () {
    		  throw new Error('_update must be implemented by subclass')
    		};

    		var hash = Hash$6;

    		/*
    		 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
    		 * in FIPS PUB 180-1
    		 * This source code is derived from sha1.js of the same repository.
    		 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
    		 * operation was added.
    		 */

    		var inherits$5 = require$$0$1;
    		var Hash$5 = hash;
    		var Buffer$7 = safeBufferExports.Buffer;

    		var K$3 = [
    		  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
    		];

    		var W$5 = new Array(80);

    		function Sha () {
    		  this.init();
    		  this._w = W$5;

    		  Hash$5.call(this, 64, 56);
    		}

    		inherits$5(Sha, Hash$5);

    		Sha.prototype.init = function () {
    		  this._a = 0x67452301;
    		  this._b = 0xefcdab89;
    		  this._c = 0x98badcfe;
    		  this._d = 0x10325476;
    		  this._e = 0xc3d2e1f0;

    		  return this
    		};

    		function rotl5$1 (num) {
    		  return (num << 5) | (num >>> 27)
    		}

    		function rotl30$1 (num) {
    		  return (num << 30) | (num >>> 2)
    		}

    		function ft$1 (s, b, c, d) {
    		  if (s === 0) return (b & c) | ((~b) & d)
    		  if (s === 2) return (b & c) | (b & d) | (c & d)
    		  return b ^ c ^ d
    		}

    		Sha.prototype._update = function (M) {
    		  var W = this._w;

    		  var a = this._a | 0;
    		  var b = this._b | 0;
    		  var c = this._c | 0;
    		  var d = this._d | 0;
    		  var e = this._e | 0;

    		  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4);
    		  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];

    		  for (var j = 0; j < 80; ++j) {
    		    var s = ~~(j / 20);
    		    var t = (rotl5$1(a) + ft$1(s, b, c, d) + e + W[j] + K$3[s]) | 0;

    		    e = d;
    		    d = c;
    		    c = rotl30$1(b);
    		    b = a;
    		    a = t;
    		  }

    		  this._a = (a + this._a) | 0;
    		  this._b = (b + this._b) | 0;
    		  this._c = (c + this._c) | 0;
    		  this._d = (d + this._d) | 0;
    		  this._e = (e + this._e) | 0;
    		};

    		Sha.prototype._hash = function () {
    		  var H = Buffer$7.allocUnsafe(20);

    		  H.writeInt32BE(this._a | 0, 0);
    		  H.writeInt32BE(this._b | 0, 4);
    		  H.writeInt32BE(this._c | 0, 8);
    		  H.writeInt32BE(this._d | 0, 12);
    		  H.writeInt32BE(this._e | 0, 16);

    		  return H
    		};

    		var sha$1 = Sha;

    		/*
    		 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
    		 * in FIPS PUB 180-1
    		 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
    		 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
    		 * Distributed under the BSD License
    		 * See http://pajhome.org.uk/crypt/md5 for details.
    		 */

    		var inherits$4 = require$$0$1;
    		var Hash$4 = hash;
    		var Buffer$6 = safeBufferExports.Buffer;

    		var K$2 = [
    		  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
    		];

    		var W$4 = new Array(80);

    		function Sha1 () {
    		  this.init();
    		  this._w = W$4;

    		  Hash$4.call(this, 64, 56);
    		}

    		inherits$4(Sha1, Hash$4);

    		Sha1.prototype.init = function () {
    		  this._a = 0x67452301;
    		  this._b = 0xefcdab89;
    		  this._c = 0x98badcfe;
    		  this._d = 0x10325476;
    		  this._e = 0xc3d2e1f0;

    		  return this
    		};

    		function rotl1 (num) {
    		  return (num << 1) | (num >>> 31)
    		}

    		function rotl5 (num) {
    		  return (num << 5) | (num >>> 27)
    		}

    		function rotl30 (num) {
    		  return (num << 30) | (num >>> 2)
    		}

    		function ft (s, b, c, d) {
    		  if (s === 0) return (b & c) | ((~b) & d)
    		  if (s === 2) return (b & c) | (b & d) | (c & d)
    		  return b ^ c ^ d
    		}

    		Sha1.prototype._update = function (M) {
    		  var W = this._w;

    		  var a = this._a | 0;
    		  var b = this._b | 0;
    		  var c = this._c | 0;
    		  var d = this._d | 0;
    		  var e = this._e | 0;

    		  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4);
    		  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);

    		  for (var j = 0; j < 80; ++j) {
    		    var s = ~~(j / 20);
    		    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K$2[s]) | 0;

    		    e = d;
    		    d = c;
    		    c = rotl30(b);
    		    b = a;
    		    a = t;
    		  }

    		  this._a = (a + this._a) | 0;
    		  this._b = (b + this._b) | 0;
    		  this._c = (c + this._c) | 0;
    		  this._d = (d + this._d) | 0;
    		  this._e = (e + this._e) | 0;
    		};

    		Sha1.prototype._hash = function () {
    		  var H = Buffer$6.allocUnsafe(20);

    		  H.writeInt32BE(this._a | 0, 0);
    		  H.writeInt32BE(this._b | 0, 4);
    		  H.writeInt32BE(this._c | 0, 8);
    		  H.writeInt32BE(this._d | 0, 12);
    		  H.writeInt32BE(this._e | 0, 16);

    		  return H
    		};

    		var sha1 = Sha1;

    		/**
    		 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
    		 * in FIPS 180-2
    		 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
    		 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
    		 *
    		 */

    		var inherits$3 = require$$0$1;
    		var Hash$3 = hash;
    		var Buffer$5 = safeBufferExports.Buffer;

    		var K$1 = [
    		  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
    		  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
    		  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
    		  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
    		  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
    		  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
    		  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
    		  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
    		  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
    		  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
    		  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
    		  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
    		  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
    		  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
    		  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
    		  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
    		];

    		var W$3 = new Array(64);

    		function Sha256$1 () {
    		  this.init();

    		  this._w = W$3; // new Array(64)

    		  Hash$3.call(this, 64, 56);
    		}

    		inherits$3(Sha256$1, Hash$3);

    		Sha256$1.prototype.init = function () {
    		  this._a = 0x6a09e667;
    		  this._b = 0xbb67ae85;
    		  this._c = 0x3c6ef372;
    		  this._d = 0xa54ff53a;
    		  this._e = 0x510e527f;
    		  this._f = 0x9b05688c;
    		  this._g = 0x1f83d9ab;
    		  this._h = 0x5be0cd19;

    		  return this
    		};

    		function ch (x, y, z) {
    		  return z ^ (x & (y ^ z))
    		}

    		function maj$1 (x, y, z) {
    		  return (x & y) | (z & (x | y))
    		}

    		function sigma0$1 (x) {
    		  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
    		}

    		function sigma1$1 (x) {
    		  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
    		}

    		function gamma0 (x) {
    		  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
    		}

    		function gamma1 (x) {
    		  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
    		}

    		Sha256$1.prototype._update = function (M) {
    		  var W = this._w;

    		  var a = this._a | 0;
    		  var b = this._b | 0;
    		  var c = this._c | 0;
    		  var d = this._d | 0;
    		  var e = this._e | 0;
    		  var f = this._f | 0;
    		  var g = this._g | 0;
    		  var h = this._h | 0;

    		  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4);
    		  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0;

    		  for (var j = 0; j < 64; ++j) {
    		    var T1 = (h + sigma1$1(e) + ch(e, f, g) + K$1[j] + W[j]) | 0;
    		    var T2 = (sigma0$1(a) + maj$1(a, b, c)) | 0;

    		    h = g;
    		    g = f;
    		    f = e;
    		    e = (d + T1) | 0;
    		    d = c;
    		    c = b;
    		    b = a;
    		    a = (T1 + T2) | 0;
    		  }

    		  this._a = (a + this._a) | 0;
    		  this._b = (b + this._b) | 0;
    		  this._c = (c + this._c) | 0;
    		  this._d = (d + this._d) | 0;
    		  this._e = (e + this._e) | 0;
    		  this._f = (f + this._f) | 0;
    		  this._g = (g + this._g) | 0;
    		  this._h = (h + this._h) | 0;
    		};

    		Sha256$1.prototype._hash = function () {
    		  var H = Buffer$5.allocUnsafe(32);

    		  H.writeInt32BE(this._a, 0);
    		  H.writeInt32BE(this._b, 4);
    		  H.writeInt32BE(this._c, 8);
    		  H.writeInt32BE(this._d, 12);
    		  H.writeInt32BE(this._e, 16);
    		  H.writeInt32BE(this._f, 20);
    		  H.writeInt32BE(this._g, 24);
    		  H.writeInt32BE(this._h, 28);

    		  return H
    		};

    		var sha256 = Sha256$1;

    		/**
    		 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
    		 * in FIPS 180-2
    		 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
    		 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
    		 *
    		 */

    		var inherits$2 = require$$0$1;
    		var Sha256 = sha256;
    		var Hash$2 = hash;
    		var Buffer$4 = safeBufferExports.Buffer;

    		var W$2 = new Array(64);

    		function Sha224 () {
    		  this.init();

    		  this._w = W$2; // new Array(64)

    		  Hash$2.call(this, 64, 56);
    		}

    		inherits$2(Sha224, Sha256);

    		Sha224.prototype.init = function () {
    		  this._a = 0xc1059ed8;
    		  this._b = 0x367cd507;
    		  this._c = 0x3070dd17;
    		  this._d = 0xf70e5939;
    		  this._e = 0xffc00b31;
    		  this._f = 0x68581511;
    		  this._g = 0x64f98fa7;
    		  this._h = 0xbefa4fa4;

    		  return this
    		};

    		Sha224.prototype._hash = function () {
    		  var H = Buffer$4.allocUnsafe(28);

    		  H.writeInt32BE(this._a, 0);
    		  H.writeInt32BE(this._b, 4);
    		  H.writeInt32BE(this._c, 8);
    		  H.writeInt32BE(this._d, 12);
    		  H.writeInt32BE(this._e, 16);
    		  H.writeInt32BE(this._f, 20);
    		  H.writeInt32BE(this._g, 24);

    		  return H
    		};

    		var sha224 = Sha224;

    		var inherits$1 = require$$0$1;
    		var Hash$1 = hash;
    		var Buffer$3 = safeBufferExports.Buffer;

    		var K = [
    		  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
    		  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
    		  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
    		  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
    		  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
    		  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
    		  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
    		  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
    		  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
    		  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
    		  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
    		  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
    		  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
    		  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
    		  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
    		  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
    		  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
    		  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
    		  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
    		  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
    		  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
    		  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
    		  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
    		  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
    		  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
    		  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
    		  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
    		  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
    		  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
    		  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
    		  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
    		  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
    		  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
    		  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
    		  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
    		  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
    		  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
    		  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
    		  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
    		  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
    		];

    		var W$1 = new Array(160);

    		function Sha512 () {
    		  this.init();
    		  this._w = W$1;

    		  Hash$1.call(this, 128, 112);
    		}

    		inherits$1(Sha512, Hash$1);

    		Sha512.prototype.init = function () {
    		  this._ah = 0x6a09e667;
    		  this._bh = 0xbb67ae85;
    		  this._ch = 0x3c6ef372;
    		  this._dh = 0xa54ff53a;
    		  this._eh = 0x510e527f;
    		  this._fh = 0x9b05688c;
    		  this._gh = 0x1f83d9ab;
    		  this._hh = 0x5be0cd19;

    		  this._al = 0xf3bcc908;
    		  this._bl = 0x84caa73b;
    		  this._cl = 0xfe94f82b;
    		  this._dl = 0x5f1d36f1;
    		  this._el = 0xade682d1;
    		  this._fl = 0x2b3e6c1f;
    		  this._gl = 0xfb41bd6b;
    		  this._hl = 0x137e2179;

    		  return this
    		};

    		function Ch (x, y, z) {
    		  return z ^ (x & (y ^ z))
    		}

    		function maj (x, y, z) {
    		  return (x & y) | (z & (x | y))
    		}

    		function sigma0 (x, xl) {
    		  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
    		}

    		function sigma1 (x, xl) {
    		  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
    		}

    		function Gamma0 (x, xl) {
    		  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
    		}

    		function Gamma0l (x, xl) {
    		  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
    		}

    		function Gamma1 (x, xl) {
    		  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
    		}

    		function Gamma1l (x, xl) {
    		  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
    		}

    		function getCarry (a, b) {
    		  return (a >>> 0) < (b >>> 0) ? 1 : 0
    		}

    		Sha512.prototype._update = function (M) {
    		  var W = this._w;

    		  var ah = this._ah | 0;
    		  var bh = this._bh | 0;
    		  var ch = this._ch | 0;
    		  var dh = this._dh | 0;
    		  var eh = this._eh | 0;
    		  var fh = this._fh | 0;
    		  var gh = this._gh | 0;
    		  var hh = this._hh | 0;

    		  var al = this._al | 0;
    		  var bl = this._bl | 0;
    		  var cl = this._cl | 0;
    		  var dl = this._dl | 0;
    		  var el = this._el | 0;
    		  var fl = this._fl | 0;
    		  var gl = this._gl | 0;
    		  var hl = this._hl | 0;

    		  for (var i = 0; i < 32; i += 2) {
    		    W[i] = M.readInt32BE(i * 4);
    		    W[i + 1] = M.readInt32BE(i * 4 + 4);
    		  }
    		  for (; i < 160; i += 2) {
    		    var xh = W[i - 15 * 2];
    		    var xl = W[i - 15 * 2 + 1];
    		    var gamma0 = Gamma0(xh, xl);
    		    var gamma0l = Gamma0l(xl, xh);

    		    xh = W[i - 2 * 2];
    		    xl = W[i - 2 * 2 + 1];
    		    var gamma1 = Gamma1(xh, xl);
    		    var gamma1l = Gamma1l(xl, xh);

    		    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    		    var Wi7h = W[i - 7 * 2];
    		    var Wi7l = W[i - 7 * 2 + 1];

    		    var Wi16h = W[i - 16 * 2];
    		    var Wi16l = W[i - 16 * 2 + 1];

    		    var Wil = (gamma0l + Wi7l) | 0;
    		    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0;
    		    Wil = (Wil + gamma1l) | 0;
    		    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0;
    		    Wil = (Wil + Wi16l) | 0;
    		    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0;

    		    W[i] = Wih;
    		    W[i + 1] = Wil;
    		  }

    		  for (var j = 0; j < 160; j += 2) {
    		    Wih = W[j];
    		    Wil = W[j + 1];

    		    var majh = maj(ah, bh, ch);
    		    var majl = maj(al, bl, cl);

    		    var sigma0h = sigma0(ah, al);
    		    var sigma0l = sigma0(al, ah);
    		    var sigma1h = sigma1(eh, el);
    		    var sigma1l = sigma1(el, eh);

    		    // t1 = h + sigma1 + ch + K[j] + W[j]
    		    var Kih = K[j];
    		    var Kil = K[j + 1];

    		    var chh = Ch(eh, fh, gh);
    		    var chl = Ch(el, fl, gl);

    		    var t1l = (hl + sigma1l) | 0;
    		    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0;
    		    t1l = (t1l + chl) | 0;
    		    t1h = (t1h + chh + getCarry(t1l, chl)) | 0;
    		    t1l = (t1l + Kil) | 0;
    		    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0;
    		    t1l = (t1l + Wil) | 0;
    		    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0;

    		    // t2 = sigma0 + maj
    		    var t2l = (sigma0l + majl) | 0;
    		    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0;

    		    hh = gh;
    		    hl = gl;
    		    gh = fh;
    		    gl = fl;
    		    fh = eh;
    		    fl = el;
    		    el = (dl + t1l) | 0;
    		    eh = (dh + t1h + getCarry(el, dl)) | 0;
    		    dh = ch;
    		    dl = cl;
    		    ch = bh;
    		    cl = bl;
    		    bh = ah;
    		    bl = al;
    		    al = (t1l + t2l) | 0;
    		    ah = (t1h + t2h + getCarry(al, t1l)) | 0;
    		  }

    		  this._al = (this._al + al) | 0;
    		  this._bl = (this._bl + bl) | 0;
    		  this._cl = (this._cl + cl) | 0;
    		  this._dl = (this._dl + dl) | 0;
    		  this._el = (this._el + el) | 0;
    		  this._fl = (this._fl + fl) | 0;
    		  this._gl = (this._gl + gl) | 0;
    		  this._hl = (this._hl + hl) | 0;

    		  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0;
    		  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0;
    		  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0;
    		  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0;
    		  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0;
    		  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0;
    		  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0;
    		  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0;
    		};

    		Sha512.prototype._hash = function () {
    		  var H = Buffer$3.allocUnsafe(64);

    		  function writeInt64BE (h, l, offset) {
    		    H.writeInt32BE(h, offset);
    		    H.writeInt32BE(l, offset + 4);
    		  }

    		  writeInt64BE(this._ah, this._al, 0);
    		  writeInt64BE(this._bh, this._bl, 8);
    		  writeInt64BE(this._ch, this._cl, 16);
    		  writeInt64BE(this._dh, this._dl, 24);
    		  writeInt64BE(this._eh, this._el, 32);
    		  writeInt64BE(this._fh, this._fl, 40);
    		  writeInt64BE(this._gh, this._gl, 48);
    		  writeInt64BE(this._hh, this._hl, 56);

    		  return H
    		};

    		var sha512 = Sha512;

    		var inherits = require$$0$1;
    		var SHA512 = sha512;
    		var Hash = hash;
    		var Buffer$2 = safeBufferExports.Buffer;

    		var W = new Array(160);

    		function Sha384 () {
    		  this.init();
    		  this._w = W;

    		  Hash.call(this, 128, 112);
    		}

    		inherits(Sha384, SHA512);

    		Sha384.prototype.init = function () {
    		  this._ah = 0xcbbb9d5d;
    		  this._bh = 0x629a292a;
    		  this._ch = 0x9159015a;
    		  this._dh = 0x152fecd8;
    		  this._eh = 0x67332667;
    		  this._fh = 0x8eb44a87;
    		  this._gh = 0xdb0c2e0d;
    		  this._hh = 0x47b5481d;

    		  this._al = 0xc1059ed8;
    		  this._bl = 0x367cd507;
    		  this._cl = 0x3070dd17;
    		  this._dl = 0xf70e5939;
    		  this._el = 0xffc00b31;
    		  this._fl = 0x68581511;
    		  this._gl = 0x64f98fa7;
    		  this._hl = 0xbefa4fa4;

    		  return this
    		};

    		Sha384.prototype._hash = function () {
    		  var H = Buffer$2.allocUnsafe(48);

    		  function writeInt64BE (h, l, offset) {
    		    H.writeInt32BE(h, offset);
    		    H.writeInt32BE(l, offset + 4);
    		  }

    		  writeInt64BE(this._ah, this._al, 0);
    		  writeInt64BE(this._bh, this._bl, 8);
    		  writeInt64BE(this._ch, this._cl, 16);
    		  writeInt64BE(this._dh, this._dl, 24);
    		  writeInt64BE(this._eh, this._el, 32);
    		  writeInt64BE(this._fh, this._fl, 40);

    		  return H
    		};

    		var sha384 = Sha384;

    		var exports$1 = sha_js.exports = function SHA (algorithm) {
    		  algorithm = algorithm.toLowerCase();

    		  var Algorithm = exports$1[algorithm];
    		  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

    		  return new Algorithm()
    		};

    		exports$1.sha = sha$1;
    		exports$1.sha1 = sha1;
    		exports$1.sha224 = sha224;
    		exports$1.sha256 = sha256;
    		exports$1.sha384 = sha384;
    		exports$1.sha512 = sha512;

    		var sha_jsExports = sha_js.exports;

    		var Buffer$1 = safeBufferExports.Buffer;

    		var toBuffer$1 = function (thing, encoding, name) {
    		  if (Buffer$1.isBuffer(thing)) {
    		    return thing
    		  } else if (typeof thing === 'string') {
    		    return Buffer$1.from(thing, encoding)
    		  } else if (ArrayBuffer.isView(thing)) {
    		    return Buffer$1.from(thing.buffer)
    		  } else {
    		    throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView')
    		  }
    		};

    		var md5 = md5$1;
    		var RIPEMD160 = ripemd160;
    		var sha = sha_jsExports;
    		var Buffer = safeBufferExports.Buffer;

    		var checkParameters = precondition;
    		var defaultEncoding = defaultEncoding_1;
    		var toBuffer = toBuffer$1;

    		var ZEROS = Buffer.alloc(128);
    		var sizes = {
    		  md5: 16,
    		  sha1: 20,
    		  sha224: 28,
    		  sha256: 32,
    		  sha384: 48,
    		  sha512: 64,
    		  rmd160: 20,
    		  ripemd160: 20
    		};

    		function Hmac (alg, key, saltLen) {
    		  var hash = getDigest(alg);
    		  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64;

    		  if (key.length > blocksize) {
    		    key = hash(key);
    		  } else if (key.length < blocksize) {
    		    key = Buffer.concat([key, ZEROS], blocksize);
    		  }

    		  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg]);
    		  var opad = Buffer.allocUnsafe(blocksize + sizes[alg]);
    		  for (var i = 0; i < blocksize; i++) {
    		    ipad[i] = key[i] ^ 0x36;
    		    opad[i] = key[i] ^ 0x5C;
    		  }

    		  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4);
    		  ipad.copy(ipad1, 0, 0, blocksize);
    		  this.ipad1 = ipad1;
    		  this.ipad2 = ipad;
    		  this.opad = opad;
    		  this.alg = alg;
    		  this.blocksize = blocksize;
    		  this.hash = hash;
    		  this.size = sizes[alg];
    		}

    		Hmac.prototype.run = function (data, ipad) {
    		  data.copy(ipad, this.blocksize);
    		  var h = this.hash(ipad);
    		  h.copy(this.opad, this.blocksize);
    		  return this.hash(this.opad)
    		};

    		function getDigest (alg) {
    		  function shaFunc (data) {
    		    return sha(alg).update(data).digest()
    		  }
    		  function rmd160Func (data) {
    		    return new RIPEMD160().update(data).digest()
    		  }

    		  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
    		  if (alg === 'md5') return md5
    		  return shaFunc
    		}

    		function pbkdf2 (password, salt, iterations, keylen, digest) {
    		  checkParameters(iterations, keylen);
    		  password = toBuffer(password, defaultEncoding, 'Password');
    		  salt = toBuffer(salt, defaultEncoding, 'Salt');

    		  digest = digest || 'sha1';

    		  var hmac = new Hmac(digest, password, salt.length);

    		  var DK = Buffer.allocUnsafe(keylen);
    		  var block1 = Buffer.allocUnsafe(salt.length + 4);
    		  salt.copy(block1, 0, 0, salt.length);

    		  var destPos = 0;
    		  var hLen = sizes[digest];
    		  var l = Math.ceil(keylen / hLen);

    		  for (var i = 1; i <= l; i++) {
    		    block1.writeUInt32BE(i, salt.length);

    		    var T = hmac.run(block1, hmac.ipad1);
    		    var U = T;

    		    for (var j = 1; j < iterations; j++) {
    		      U = hmac.run(U, hmac.ipad2);
    		      for (var k = 0; k < hLen; k++) T[k] ^= U[k];
    		    }

    		    T.copy(DK, destPos);
    		    destPos += hLen;
    		  }

    		  return DK
    		}

    		var syncBrowser = pbkdf2;

    		safeBufferExports.Buffer;
    		commonjsGlobal$1.crypto && commonjsGlobal$1.crypto.subtle;

    		var pbkdf2Sync = syncBrowser;

    		var scrypt$1 = {exports: {}};

    		scrypt$1.exports;

    		(function (module, exports) {

    			(function(root) {
    			    const MAX_VALUE = 0x7fffffff;

    			    // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    			    // See: https://github.com/dchest/scrypt-async-js
    			    function SHA256(m) {
    			        const K = new Uint32Array([
    			           0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b,
    			           0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01,
    			           0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7,
    			           0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
    			           0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152,
    			           0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147,
    			           0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc,
    			           0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    			           0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819,
    			           0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08,
    			           0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f,
    			           0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
    			           0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
    			       ]);

    			        let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
    			        let h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
    			        const w = new Uint32Array(64);

    			        function blocks(p) {
    			            let off = 0, len = p.length;
    			            while (len >= 64) {
    			                let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u, i, j, t1, t2;

    			                for (i = 0; i < 16; i++) {
    			                    j = off + i*4;
    			                    w[i] = ((p[j] & 0xff)<<24) | ((p[j+1] & 0xff)<<16) |
    			                    ((p[j+2] & 0xff)<<8) | (p[j+3] & 0xff);
    			                }

    			                for (i = 16; i < 64; i++) {
    			                    u = w[i-2];
    			                    t1 = ((u>>>17) | (u<<(32-17))) ^ ((u>>>19) | (u<<(32-19))) ^ (u>>>10);

    			                    u = w[i-15];
    			                    t2 = ((u>>>7) | (u<<(32-7))) ^ ((u>>>18) | (u<<(32-18))) ^ (u>>>3);

    			                    w[i] = (((t1 + w[i-7]) | 0) + ((t2 + w[i-16]) | 0)) | 0;
    			                }

    			                for (i = 0; i < 64; i++) {
    			                    t1 = ((((((e>>>6) | (e<<(32-6))) ^ ((e>>>11) | (e<<(32-11))) ^
    			                             ((e>>>25) | (e<<(32-25)))) + ((e & f) ^ (~e & g))) | 0) +
    			                          ((h + ((K[i] + w[i]) | 0)) | 0)) | 0;

    			                    t2 = ((((a>>>2) | (a<<(32-2))) ^ ((a>>>13) | (a<<(32-13))) ^
    			                           ((a>>>22) | (a<<(32-22)))) + ((a & b) ^ (a & c) ^ (b & c))) | 0;

    			                    h = g;
    			                    g = f;
    			                    f = e;
    			                    e = (d + t1) | 0;
    			                    d = c;
    			                    c = b;
    			                    b = a;
    			                    a = (t1 + t2) | 0;
    			                }

    			                h0 = (h0 + a) | 0;
    			                h1 = (h1 + b) | 0;
    			                h2 = (h2 + c) | 0;
    			                h3 = (h3 + d) | 0;
    			                h4 = (h4 + e) | 0;
    			                h5 = (h5 + f) | 0;
    			                h6 = (h6 + g) | 0;
    			                h7 = (h7 + h) | 0;

    			                off += 64;
    			                len -= 64;
    			            }
    			        }

    			        blocks(m);

    			        let i, bytesLeft = m.length % 64,
    			        bitLenHi = (m.length / 0x20000000) | 0,
    			        bitLenLo = m.length << 3,
    			        numZeros = (bytesLeft < 56) ? 56 : 120,
    			        p = m.slice(m.length - bytesLeft, m.length);

    			        p.push(0x80);
    			        for (i = bytesLeft + 1; i < numZeros; i++) { p.push(0); }
    			        p.push((bitLenHi >>> 24) & 0xff);
    			        p.push((bitLenHi >>> 16) & 0xff);
    			        p.push((bitLenHi >>> 8)  & 0xff);
    			        p.push((bitLenHi >>> 0)  & 0xff);
    			        p.push((bitLenLo >>> 24) & 0xff);
    			        p.push((bitLenLo >>> 16) & 0xff);
    			        p.push((bitLenLo >>> 8)  & 0xff);
    			        p.push((bitLenLo >>> 0)  & 0xff);

    			        blocks(p);

    			        return [
    			            (h0 >>> 24) & 0xff, (h0 >>> 16) & 0xff, (h0 >>> 8) & 0xff, (h0 >>> 0) & 0xff,
    			            (h1 >>> 24) & 0xff, (h1 >>> 16) & 0xff, (h1 >>> 8) & 0xff, (h1 >>> 0) & 0xff,
    			            (h2 >>> 24) & 0xff, (h2 >>> 16) & 0xff, (h2 >>> 8) & 0xff, (h2 >>> 0) & 0xff,
    			            (h3 >>> 24) & 0xff, (h3 >>> 16) & 0xff, (h3 >>> 8) & 0xff, (h3 >>> 0) & 0xff,
    			            (h4 >>> 24) & 0xff, (h4 >>> 16) & 0xff, (h4 >>> 8) & 0xff, (h4 >>> 0) & 0xff,
    			            (h5 >>> 24) & 0xff, (h5 >>> 16) & 0xff, (h5 >>> 8) & 0xff, (h5 >>> 0) & 0xff,
    			            (h6 >>> 24) & 0xff, (h6 >>> 16) & 0xff, (h6 >>> 8) & 0xff, (h6 >>> 0) & 0xff,
    			            (h7 >>> 24) & 0xff, (h7 >>> 16) & 0xff, (h7 >>> 8) & 0xff, (h7 >>> 0) & 0xff
    			        ];
    			    }

    			    function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
    			        // compress password if it's longer than hash block length
    			        password = (password.length <= 64) ? password : SHA256(password);

    			        const innerLen = 64 + salt.length + 4;
    			        const inner = new Array(innerLen);
    			        const outerKey = new Array(64);

    			        let i;
    			        let dk = [];

    			        // inner = (password ^ ipad) || salt || counter
    			        for (i = 0; i < 64; i++) { inner[i] = 0x36; }
    			        for (i = 0; i < password.length; i++) { inner[i] ^= password[i]; }
    			        for (i = 0; i < salt.length; i++) { inner[64 + i] = salt[i]; }
    			        for (i = innerLen - 4; i < innerLen; i++) { inner[i] = 0; }

    			        // outerKey = password ^ opad
    			        for (i = 0; i < 64; i++) outerKey[i] = 0x5c;
    			        for (i = 0; i < password.length; i++) outerKey[i] ^= password[i];

    			        // increments counter inside inner
    			        function incrementCounter() {
    			            for (let i = innerLen - 1; i >= innerLen - 4; i--) {
    			                inner[i]++;
    			                if (inner[i] <= 0xff) return;
    			                inner[i] = 0;
    			            }
    			        }

    			        // output blocks = SHA256(outerKey || SHA256(inner)) ...
    			        while (dkLen >= 32) {
    			            incrementCounter();
    			            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
    			            dkLen -= 32;
    			        }
    			        if (dkLen > 0) {
    			            incrementCounter();
    			            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
    			        }

    			        return dk;
    			    }

    			    // The following is an adaptation of scryptsy
    			    // See: https://www.npmjs.com/package/scryptsy
    			    function blockmix_salsa8(BY, Yi, r, x, _X) {
    			        let i;

    			        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
    			        for (i = 0; i < 2 * r; i++) {
    			            blockxor(BY, i * 16, _X, 16);
    			            salsa20_8(_X, x);
    			            arraycopy(_X, 0, BY, Yi + (i * 16), 16);
    			        }

    			        for (i = 0; i < r; i++) {
    			            arraycopy(BY, Yi + (i * 2) * 16, BY, (i * 16), 16);
    			        }

    			        for (i = 0; i < r; i++) {
    			            arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
    			        }
    			    }

    			    function R(a, b) {
    			        return (a << b) | (a >>> (32 - b));
    			    }

    			    function salsa20_8(B, x) {
    			        arraycopy(B, 0, x, 0, 16);

    			        for (let i = 8; i > 0; i -= 2) {
    			            x[ 4] ^= R(x[ 0] + x[12], 7);
    			            x[ 8] ^= R(x[ 4] + x[ 0], 9);
    			            x[12] ^= R(x[ 8] + x[ 4], 13);
    			            x[ 0] ^= R(x[12] + x[ 8], 18);
    			            x[ 9] ^= R(x[ 5] + x[ 1], 7);
    			            x[13] ^= R(x[ 9] + x[ 5], 9);
    			            x[ 1] ^= R(x[13] + x[ 9], 13);
    			            x[ 5] ^= R(x[ 1] + x[13], 18);
    			            x[14] ^= R(x[10] + x[ 6], 7);
    			            x[ 2] ^= R(x[14] + x[10], 9);
    			            x[ 6] ^= R(x[ 2] + x[14], 13);
    			            x[10] ^= R(x[ 6] + x[ 2], 18);
    			            x[ 3] ^= R(x[15] + x[11], 7);
    			            x[ 7] ^= R(x[ 3] + x[15], 9);
    			            x[11] ^= R(x[ 7] + x[ 3], 13);
    			            x[15] ^= R(x[11] + x[ 7], 18);
    			            x[ 1] ^= R(x[ 0] + x[ 3], 7);
    			            x[ 2] ^= R(x[ 1] + x[ 0], 9);
    			            x[ 3] ^= R(x[ 2] + x[ 1], 13);
    			            x[ 0] ^= R(x[ 3] + x[ 2], 18);
    			            x[ 6] ^= R(x[ 5] + x[ 4], 7);
    			            x[ 7] ^= R(x[ 6] + x[ 5], 9);
    			            x[ 4] ^= R(x[ 7] + x[ 6], 13);
    			            x[ 5] ^= R(x[ 4] + x[ 7], 18);
    			            x[11] ^= R(x[10] + x[ 9], 7);
    			            x[ 8] ^= R(x[11] + x[10], 9);
    			            x[ 9] ^= R(x[ 8] + x[11], 13);
    			            x[10] ^= R(x[ 9] + x[ 8], 18);
    			            x[12] ^= R(x[15] + x[14], 7);
    			            x[13] ^= R(x[12] + x[15], 9);
    			            x[14] ^= R(x[13] + x[12], 13);
    			            x[15] ^= R(x[14] + x[13], 18);
    			        }

    			        for (let i = 0; i < 16; ++i) {
    			            B[i] += x[i];
    			        }
    			    }

    			    // naive approach... going back to loop unrolling may yield additional performance
    			    function blockxor(S, Si, D, len) {
    			        for (let i = 0; i < len; i++) {
    			            D[i] ^= S[Si + i];
    			        }
    			    }

    			    function arraycopy(src, srcPos, dest, destPos, length) {
    			        while (length--) {
    			            dest[destPos++] = src[srcPos++];
    			        }
    			    }

    			    function checkBufferish(o) {
    			        if (!o || typeof(o.length) !== 'number') { return false; }

    			        for (let i = 0; i < o.length; i++) {
    			            const v = o[i];
    			            if (typeof(v) !== 'number' || v % 1 || v < 0 || v >= 256) {
    			                return false;
    			            }
    			        }

    			        return true;
    			    }

    			    function ensureInteger(value, name) {
    			        if (typeof(value) !== "number" || (value % 1)) { throw new Error('invalid ' + name); }
    			        return value;
    			    }

    			    // N = Cpu cost, r = Memory cost, p = parallelization cost
    			    // callback(error, progress, key)
    			    function _scrypt(password, salt, N, r, p, dkLen, callback) {

    			        N = ensureInteger(N, 'N');
    			        r = ensureInteger(r, 'r');
    			        p = ensureInteger(p, 'p');

    			        dkLen = ensureInteger(dkLen, 'dkLen');

    			        if (N === 0 || (N & (N - 1)) !== 0) { throw new Error('N must be power of 2'); }

    			        if (N > MAX_VALUE / 128 / r) { throw new Error('N too large'); }
    			        if (r > MAX_VALUE / 128 / p) { throw new Error('r too large'); }

    			        if (!checkBufferish(password)) {
    			            throw new Error('password must be an array or buffer');
    			        }
    			        password = Array.prototype.slice.call(password);

    			        if (!checkBufferish(salt)) {
    			            throw new Error('salt must be an array or buffer');
    			        }
    			        salt = Array.prototype.slice.call(salt);

    			        let b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
    			        const B = new Uint32Array(p * 32 * r);
    			        for (let i = 0; i < B.length; i++) {
    			            const j = i * 4;
    			            B[i] = ((b[j + 3] & 0xff) << 24) |
    			                   ((b[j + 2] & 0xff) << 16) |
    			                   ((b[j + 1] & 0xff) << 8) |
    			                   ((b[j + 0] & 0xff) << 0);
    			        }

    			        const XY = new Uint32Array(64 * r);
    			        const V = new Uint32Array(32 * r * N);

    			        const Yi = 32 * r;

    			        // scratch space
    			        const x = new Uint32Array(16);       // salsa20_8
    			        const _X = new Uint32Array(16);      // blockmix_salsa8

    			        const totalOps = p * N * 2;
    			        let currentOp = 0;
    			        let lastPercent10 = null;

    			        // Set this to true to abandon the scrypt on the next step
    			        let stop = false;

    			        // State information
    			        let state = 0;
    			        let i0 = 0, i1;
    			        let Bi;

    			        // How many blockmix_salsa8 can we do per step?
    			        const limit = callback ? parseInt(1000 / r): 0xffffffff;

    			        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
    			        const nextTick = (typeof(setImmediate) !== 'undefined') ? setImmediate : setTimeout;

    			        // This is really all I changed; making scryptsy a state machine so we occasionally
    			        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
    			        const incrementalSMix = function() {
    			            if (stop) {
    			                return callback(new Error('cancelled'), currentOp / totalOps);
    			            }

    			            let steps;

    			            switch (state) {
    			                case 0:
    			                    // for (var i = 0; i < p; i++)...
    			                    Bi = i0 * 32 * r;

    			                    arraycopy(B, Bi, XY, 0, Yi);                       // ROMix - 1

    			                    state = 1;                                         // Move to ROMix 2
    			                    i1 = 0;

    			                    // Fall through

    			                case 1:

    			                    // Run up to 1000 steps of the first inner smix loop
    			                    steps = N - i1;
    			                    if (steps > limit) { steps = limit; }
    			                    for (let i = 0; i < steps; i++) {                  // ROMix - 2
    			                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi);         // ROMix - 3
    			                        blockmix_salsa8(XY, Yi, r, x, _X);             // ROMix - 4
    			                    }

    			                    // for (var i = 0; i < N; i++)
    			                    i1 += steps;
    			                    currentOp += steps;

    			                    if (callback) {
    			                        // Call the callback with the progress (optionally stopping us)
    			                        const percent10 = parseInt(1000 * currentOp / totalOps);
    			                        if (percent10 !== lastPercent10) {
    			                            stop = callback(null, currentOp / totalOps);
    			                            if (stop) { break; }
    			                            lastPercent10 = percent10;
    			                        }
    			                    }

    			                    if (i1 < N) { break; }

    			                    i1 = 0;                                          // Move to ROMix 6
    			                    state = 2;

    			                    // Fall through

    			                case 2:

    			                    // Run up to 1000 steps of the second inner smix loop
    			                    steps = N - i1;
    			                    if (steps > limit) { steps = limit; }
    			                    for (let i = 0; i < steps; i++) {                // ROMix - 6
    			                        const offset = (2 * r - 1) * 16;             // ROMix - 7
    			                        const j = XY[offset] & (N - 1);
    			                        blockxor(V, j * Yi, XY, Yi);                 // ROMix - 8 (inner)
    			                        blockmix_salsa8(XY, Yi, r, x, _X);           // ROMix - 9 (outer)
    			                    }

    			                    // for (var i = 0; i < N; i++)...
    			                    i1 += steps;
    			                    currentOp += steps;

    			                    // Call the callback with the progress (optionally stopping us)
    			                    if (callback) {
    			                        const percent10 = parseInt(1000 * currentOp / totalOps);
    			                        if (percent10 !== lastPercent10) {
    			                            stop = callback(null, currentOp / totalOps);
    			                            if (stop) { break; }
    			                            lastPercent10 = percent10;
    			                        }
    			                    }

    			                    if (i1 < N) { break; }

    			                    arraycopy(XY, 0, B, Bi, Yi);                     // ROMix - 10

    			                    // for (var i = 0; i < p; i++)...
    			                    i0++;
    			                    if (i0 < p) {
    			                        state = 0;
    			                        break;
    			                    }

    			                    b = [];
    			                    for (let i = 0; i < B.length; i++) {
    			                        b.push((B[i] >>  0) & 0xff);
    			                        b.push((B[i] >>  8) & 0xff);
    			                        b.push((B[i] >> 16) & 0xff);
    			                        b.push((B[i] >> 24) & 0xff);
    			                    }

    			                    const derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);

    			                    // Send the result to the callback
    			                    if (callback) { callback(null, 1.0, derivedKey); }

    			                    // Done; don't break (which would reschedule)
    			                    return derivedKey;
    			            }

    			            // Schedule the next steps
    			            if (callback) { nextTick(incrementalSMix); }
    			        };

    			        // Run the smix state machine until completion
    			        if (!callback) {
    			            while (true) {
    			                const derivedKey = incrementalSMix();
    			                if (derivedKey != undefined) { return derivedKey; }
    			            }
    			        }

    			        // Bootstrap the async incremental smix
    			        incrementalSMix();
    			    }

    			    const lib = {
    			        scrypt: function(password, salt, N, r, p, dkLen, progressCallback) {
    			            return new Promise(function(resolve, reject) {
    			                let lastProgress = 0;
    			                if (progressCallback) { progressCallback(0); }
    			                _scrypt(password, salt, N, r, p, dkLen, function(error, progress, key) {
    			                    if (error) {
    			                        reject(error);
    			                    } else if (key) {
    			                        if (progressCallback && lastProgress !== 1) {
    			                            progressCallback(1);
    			                        }
    			                        resolve(new Uint8Array(key));
    			                    } else if (progressCallback && progress !== lastProgress) {
    			                        lastProgress = progress;
    			                        return progressCallback(progress);
    			                    }
    			                });
    			            });
    			        },
    			        syncScrypt: function(password, salt, N, r, p, dkLen) {
    			            return new Uint8Array(_scrypt(password, salt, N, r, p, dkLen));
    			        }
    			    };

    			    // node.js
    			    {
    			       module.exports = lib;

    			    // RequireJS/AMD
    			    // http://www.requirejs.org/docs/api.html
    			    // https://github.com/amdjs/amdjs-api/wiki/AMD
    			    }

    			})(); 
    		} (scrypt$1, scrypt$1.exports));

    		var scryptExports = scrypt$1.exports;
    		var scrypt = /*@__PURE__*/getDefaultExportFromCjs(scryptExports);

    		// Unique ID creation requires a high quality random # generator. In the browser we therefore
    		// require the crypto API and do not support built-in fallback to lower quality random number
    		// generators (like Math.random()).
    		var getRandomValues;
    		var rnds8 = new Uint8Array(16);
    		function rng() {
    		  // lazy load so that environments that need to polyfill have a chance to do so
    		  if (!getRandomValues) {
    		    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    		    // find the complete implementation of crypto (msCrypto) on IE11.
    		    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    		    if (!getRandomValues) {
    		      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    		    }
    		  }

    		  return getRandomValues(rnds8);
    		}

    		var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

    		function validate(uuid) {
    		  return typeof uuid === 'string' && REGEX.test(uuid);
    		}

    		/**
    		 * Convert array of 16 byte values to UUID string format of the form:
    		 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
    		 */

    		var byteToHex = [];

    		for (var i = 0; i < 256; ++i) {
    		  byteToHex.push((i + 0x100).toString(16).substr(1));
    		}

    		function stringify(arr) {
    		  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    		  // Note: Be careful editing this code!  It's been tuned for performance
    		  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    		  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    		  // of the following:
    		  // - One or more input array values don't map to a hex octet (leading to
    		  // "undefined" in the uuid)
    		  // - Invalid input values for the RFC `version` or `variant` fields

    		  if (!validate(uuid)) {
    		    throw TypeError('Stringified UUID is invalid');
    		  }

    		  return uuid;
    		}

    		function v4(options, buf, offset) {
    		  options = options || {};
    		  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

    		  rnds[6] = rnds[6] & 0x0f | 0x40;
    		  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

    		  if (buf) {
    		    offset = offset || 0;

    		    for (var i = 0; i < 16; ++i) {
    		      buf[offset + i] = rnds[i];
    		    }

    		    return buf;
    		  }

    		  return stringify(rnds);
    		}

    		//  Copyright (C) 2018 Zilliqa
    		var ALGO_IDENTIFIER = "aes-128-ctr";
    		/**
    		 * getDerivedKey
    		 *
    		 * NOTE: only scrypt and pbkdf2 are supported.
    		 *
    		 * @param {Buffer} key - the passphrase
    		 * @param {KDF} kdf - the key derivation function to be used
    		 * @param {KDFParams} params - params for the kdf
    		 *
    		 * @returns {Promise<Buffer>}
    		 */
    		function getDerivedKey(key, kdf, params) {
    		    return __awaiter(this, void 0, void 0, function () {
    		        var salt, _a, c, dklen, _b, n, r, p, dklen, derivedKeyInt8Array;
    		        return __generator(this, function (_c) {
    		            salt = Buffer$c.from(params.salt, "hex");
    		            if (kdf === "pbkdf2") {
    		                _a = params, c = _a.c, dklen = _a.dklen;
    		                return [2 /*return*/, pbkdf2Sync(key, salt, c, dklen, "sha256")];
    		            }
    		            if (kdf === "scrypt") {
    		                _b = params, n = _b.n, r = _b.r, p = _b.p, dklen = _b.dklen;
    		                derivedKeyInt8Array = scrypt.syncScrypt(key, salt, n, r, p, dklen);
    		                return [2 /*return*/, Buffer$c.from(derivedKeyInt8Array)];
    		            }
    		            throw new Error("Only pbkdf2 and scrypt are supported");
    		        });
    		    });
    		}
    		/**
    		 * encryptPrivateKey
    		 *
    		 * Encodes and encrypts an account in the format specified by
    		 * https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition.
    		 * However, note that, in keeping with the hash function used by Zilliqa's
    		 * core protocol, the MAC is generated using sha256 instead of keccak.
    		 *
    		 * NOTE: only scrypt and pbkdf2 are supported.
    		 *
    		 * @param {KDF} kdf - the key derivation function to be used
    		 * @param {string} privateKey - hex-encoded private key
    		 * @param {string} passphrase - a passphrase used for encryption
    		 *
    		 * @returns {Promise<string>}
    		 */
    		var encryptPrivateKey = function (kdf, privateKey, passphrase) { return __awaiter(void 0, void 0, void 0, function () {
    		    var address, salt, iv, kdfparams, derivedKey, cipher, ciphertext;
    		    return __generator(this, function (_a) {
    		        switch (_a.label) {
    		            case 0:
    		                address = getAddressFromPrivateKey(privateKey);
    		                salt = randomBytes(32);
    		                iv = Buffer$c.from(randomBytes(16), "hex");
    		                kdfparams = {
    		                    salt: salt,
    		                    n: 8192,
    		                    c: 262144,
    		                    r: 8,
    		                    p: 1,
    		                    dklen: 32,
    		                };
    		                return [4 /*yield*/, getDerivedKey(Buffer$c.from(passphrase), kdf, kdfparams)];
    		            case 1:
    		                derivedKey = _a.sent();
    		                cipher = new aes.ModeOfOperation.ctr(derivedKey.slice(0, 16), new aes.Counter(iv));
    		                ciphertext = Buffer$c.from(cipher.encrypt(Buffer$c.from(privateKey, "hex")));
    		                return [2 /*return*/, JSON.stringify({
    		                        address: address,
    		                        crypto: {
    		                            cipher: ALGO_IDENTIFIER,
    		                            cipherparams: {
    		                                iv: iv.toString("hex"),
    		                            },
    		                            ciphertext: ciphertext.toString("hex"),
    		                            kdf: kdf,
    		                            kdfparams: kdfparams,
    		                            mac: hashjs
    		                                // @ts-ignore
    		                                .hmac(hashjs.sha256, derivedKey, "hex")
    		                                .update(Buffer$c.concat([
    		                                derivedKey.slice(16, 32),
    		                                ciphertext,
    		                                iv,
    		                                Buffer$c.from(ALGO_IDENTIFIER),
    		                            ]), "hex")
    		                                .digest("hex"),
    		                        },
    		                        id: v4({ random: bundleExports.bytes.hexToIntArray(randomBytes(16)) }),
    		                        version: 3,
    		                    })];
    		        }
    		    });
    		}); };
    		/**
    		 * decryptPrivateKey
    		 *
    		 * Recovers the private key from a keystore file using the given passphrase.
    		 *
    		 * @param {string} passphrase
    		 * @param {KeystoreV3} keystore
    		 * @returns {Promise<string>}
    		 */
    		var decryptPrivateKey = function (passphrase, keystore) { return __awaiter(void 0, void 0, void 0, function () {
    		    var ciphertext, iv, kdfparams, derivedKey, mac, cipher;
    		    return __generator(this, function (_a) {
    		        switch (_a.label) {
    		            case 0:
    		                ciphertext = Buffer$c.from(keystore.crypto.ciphertext, "hex");
    		                iv = Buffer$c.from(keystore.crypto.cipherparams.iv, "hex");
    		                kdfparams = keystore.crypto.kdfparams;
    		                return [4 /*yield*/, getDerivedKey(Buffer$c.from(passphrase), keystore.crypto.kdf, kdfparams)];
    		            case 1:
    		                derivedKey = _a.sent();
    		                mac = hashjs
    		                    // @ts-ignore
    		                    .hmac(hashjs.sha256, derivedKey, "hex")
    		                    .update(Buffer$c.concat([
    		                    derivedKey.slice(16, 32),
    		                    ciphertext,
    		                    iv,
    		                    Buffer$c.from(ALGO_IDENTIFIER),
    		                ]), "hex")
    		                    .digest("hex");
    		                // we need to do a byte-by-byte comparison to avoid non-constant time side
    		                // channel attacks.
    		                if (!bundleExports.bytes.isEqual(mac.toUpperCase(), keystore.crypto.mac.toUpperCase())) {
    		                    return [2 /*return*/, Promise.reject("Failed to decrypt.")];
    		                }
    		                cipher = new aes.ModeOfOperation.ctr(derivedKey.slice(0, 16), new aes.Counter(iv));
    		                return [2 /*return*/, Buffer$c.from(cipher.decrypt(ciphertext)).toString("hex")];
    		        }
    		    });
    		}); };

    		//  Copyright (C) 2018 Zilliqa
    		/**
    		 * sign
    		 *
    		 * @param {string} hash - hex-encoded hash of the data to be signed
    		 *
    		 * @returns {string} the signature
    		 */
    		var sign = function (msg, privateKey, pubKey) {
    		    var sig = sign$1(msg, Buffer$c.from(privateKey, "hex"), Buffer$c.from(pubKey, "hex"));
    		    var r = sig.r.toString("hex");
    		    var s = sig.s.toString("hex");
    		    while (r.length < 64) {
    		        r = "0" + r;
    		    }
    		    while (s.length < 64) {
    		        s = "0" + s;
    		    }
    		    return r + s;
    		};

    		exports.HRP = HRP;
    		exports.Signature = Signature;
    		exports.compressPublicKey = compressPublicKey;
    		exports.convertBits = convertBits;
    		exports.decode = decode;
    		exports.decodeBase58 = decodeBase58;
    		exports.decryptPrivateKey = decryptPrivateKey;
    		exports.encode = encode;
    		exports.encodeBase58 = encodeBase58;
    		exports.encryptPrivateKey = encryptPrivateKey;
    		exports.fromBech32Address = fromBech32Address;
    		exports.getAccountFrom0xPrivateKey = getAccountFrom0xPrivateKey;
    		exports.getAddressFromPrivateKey = getAddressFromPrivateKey;
    		exports.getAddressFromPublicKey = getAddressFromPublicKey;
    		exports.getPubKeyFromPrivateKey = getPubKeyFromPrivateKey;
    		exports.isValidChecksumAddress = isValidChecksumAddress;
    		exports.normaliseAddress = normaliseAddress;
    		exports.normalizePrivateKey = normalizePrivateKey;
    		exports.randomBytes = randomBytes;
    		exports.schnorr = schnorr;
    		exports.sign = sign;
    		exports.toBech32Address = toBech32Address;
    		exports.toChecksumAddress = toChecksumAddress;
    		exports.verifyPrivateKey = verifyPrivateKey;

    		Object.defineProperty(exports, '__esModule', { value: true });

    	}));
    	
    } (bundle, bundle.exports));

    var bundleExports = bundle.exports;

    //  Copyright (C) 2018 Zilliqa
    var Account = /** @class */ (function () {
        function Account(privateKey) {
            this.privateKey = this.normalizePrivateKey(privateKey);
            this.publicKey = bundleExports.getPubKeyFromPrivateKey(this.privateKey);
            this.address = bundleExports.getAddressFromPublicKey(this.publicKey);
            this.bech32Address = bundleExports.toBech32Address(this.address);
        }
        /**
         * fromFile
         *
         * Takes a JSON-encoded keystore and passphrase, returning a fully
         * instantiated Account instance.
         *
         * @param {string} file
         * @param {string} passphrase
         * @returns {Promise<Account>}
         */
        Account.fromFile = function (file, passphrase) {
            return __awaiter(this, void 0, void 0, function () {
                var keystore, privateKey;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            keystore = JSON.parse(file);
                            return [4 /*yield*/, bundleExports.decryptPrivateKey(passphrase, keystore)];
                        case 1:
                            privateKey = _a.sent();
                            return [2 /*return*/, new Account(privateKey)];
                        case 2:
                            _a.sent();
                            throw new Error("Could not decrypt keystore file.");
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * toFile
         *
         * @param {string} passphrase
         * @param {kdf} 'pbkdf2' | 'scrypt'
         * @returns {Promise<string>}
         */
        Account.prototype.toFile = function (passphrase, kdf) {
            if (kdf === void 0) { kdf = "scrypt"; }
            return __awaiter(this, void 0, void 0, function () {
                var keystore;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!passphrase || !passphrase.length) {
                                throw new Error("Passphrase cannot have a length of 0");
                            }
                            return [4 /*yield*/, bundleExports.encryptPrivateKey(kdf, this.privateKey, passphrase)];
                        case 1:
                            keystore = _a.sent();
                            return [2 /*return*/, keystore];
                    }
                });
            });
        };
        /**
         * signTransaction
         *
         * @param {Buffer} bytes - the data to be signed
         *
         * @returns {string} - the hex encoded signature. it is a concatenation of
         * the r and s values in hex, each padded to a length of 64.
         */
        Account.prototype.signTransaction = function (bytes) {
            return bundleExports.sign(bytes, this.privateKey, this.publicKey);
        };
        Account.prototype.normalizePrivateKey = function (privateKey) {
            return bundleExports.normalizePrivateKey(privateKey);
        };
        return Account;
    }());

    var safeBuffer = {exports: {}};

    var require$$0$3 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_buffer);

    /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
    safeBuffer.exports;

    (function (module, exports) {
    	/* eslint-disable node/no-deprecated-api */
    	var buffer = require$$0$3;
    	var Buffer = buffer.Buffer;

    	// alternative to using Object.keys for old browsers
    	function copyProps (src, dst) {
    	  for (var key in src) {
    	    dst[key] = src[key];
    	  }
    	}
    	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
    	  module.exports = buffer;
    	} else {
    	  // Copy properties from require('buffer')
    	  copyProps(buffer, exports);
    	  exports.Buffer = SafeBuffer;
    	}

    	function SafeBuffer (arg, encodingOrOffset, length) {
    	  return Buffer(arg, encodingOrOffset, length)
    	}

    	SafeBuffer.prototype = Object.create(Buffer.prototype);

    	// Copy static methods from Buffer
    	copyProps(Buffer, SafeBuffer);

    	SafeBuffer.from = function (arg, encodingOrOffset, length) {
    	  if (typeof arg === 'number') {
    	    throw new TypeError('Argument must not be a number')
    	  }
    	  return Buffer(arg, encodingOrOffset, length)
    	};

    	SafeBuffer.alloc = function (size, fill, encoding) {
    	  if (typeof size !== 'number') {
    	    throw new TypeError('Argument must be a number')
    	  }
    	  var buf = Buffer(size);
    	  if (fill !== undefined) {
    	    if (typeof encoding === 'string') {
    	      buf.fill(fill, encoding);
    	    } else {
    	      buf.fill(fill);
    	    }
    	  } else {
    	    buf.fill(0);
    	  }
    	  return buf
    	};

    	SafeBuffer.allocUnsafe = function (size) {
    	  if (typeof size !== 'number') {
    	    throw new TypeError('Argument must be a number')
    	  }
    	  return Buffer(size)
    	};

    	SafeBuffer.allocUnsafeSlow = function (size) {
    	  if (typeof size !== 'number') {
    	    throw new TypeError('Argument must be a number')
    	  }
    	  return buffer.SlowBuffer(size)
    	}; 
    } (safeBuffer, safeBuffer.exports));

    var safeBufferExports = safeBuffer.exports;

    var inherits$h;
    if (typeof Object.create === 'function'){
      inherits$h = function inherits(ctor, superCtor) {
        // implementation from standard node.js 'util' module
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
          constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
      };
    } else {
      inherits$h = function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function () {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
      };
    }
    var inherits$i = inherits$h;

    var _polyfillNode_inherits = /*#__PURE__*/Object.freeze({
        __proto__: null,
        'default': inherits$i
    });

    var require$$1$1 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_inherits);

    var readableBrowser = {exports: {}};

    var domain;

    // This constructor is used to store event handlers. Instantiating this is
    // faster than explicitly calling `Object.create(null)` to get a "clean" empty
    // object (tested with v8 v4.9).
    function EventHandlers() {}
    EventHandlers.prototype = Object.create(null);

    function EventEmitter() {
      EventEmitter.init.call(this);
    }

    // nodejs oddity
    // require('events') === require('events').EventEmitter
    EventEmitter.EventEmitter = EventEmitter;

    EventEmitter.usingDomains = false;

    EventEmitter.prototype.domain = undefined;
    EventEmitter.prototype._events = undefined;
    EventEmitter.prototype._maxListeners = undefined;

    // By default EventEmitters will print a warning if more than 10 listeners are
    // added to it. This is a useful default which helps finding memory leaks.
    EventEmitter.defaultMaxListeners = 10;

    EventEmitter.init = function() {
      this.domain = null;
      if (EventEmitter.usingDomains) {
        // if there is an active domain, then attach to it.
        if (domain.active ) ;
      }

      if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
        this._events = new EventHandlers();
        this._eventsCount = 0;
      }

      this._maxListeners = this._maxListeners || undefined;
    };

    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
      if (typeof n !== 'number' || n < 0 || isNaN(n))
        throw new TypeError('"n" argument must be a positive number');
      this._maxListeners = n;
      return this;
    };

    function $getMaxListeners(that) {
      if (that._maxListeners === undefined)
        return EventEmitter.defaultMaxListeners;
      return that._maxListeners;
    }

    EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
      return $getMaxListeners(this);
    };

    // These standalone emit* functions are used to optimize calling of event
    // handlers for fast cases because emit() itself often has a variable number of
    // arguments and can be deoptimized because of that. These functions always have
    // the same number of arguments and thus do not get deoptimized, so the code
    // inside them can execute faster.
    function emitNone(handler, isFn, self) {
      if (isFn)
        handler.call(self);
      else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for (var i = 0; i < len; ++i)
          listeners[i].call(self);
      }
    }
    function emitOne(handler, isFn, self, arg1) {
      if (isFn)
        handler.call(self, arg1);
      else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for (var i = 0; i < len; ++i)
          listeners[i].call(self, arg1);
      }
    }
    function emitTwo(handler, isFn, self, arg1, arg2) {
      if (isFn)
        handler.call(self, arg1, arg2);
      else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for (var i = 0; i < len; ++i)
          listeners[i].call(self, arg1, arg2);
      }
    }
    function emitThree(handler, isFn, self, arg1, arg2, arg3) {
      if (isFn)
        handler.call(self, arg1, arg2, arg3);
      else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for (var i = 0; i < len; ++i)
          listeners[i].call(self, arg1, arg2, arg3);
      }
    }

    function emitMany(handler, isFn, self, args) {
      if (isFn)
        handler.apply(self, args);
      else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for (var i = 0; i < len; ++i)
          listeners[i].apply(self, args);
      }
    }

    EventEmitter.prototype.emit = function emit(type) {
      var er, handler, len, args, i, events, domain;
      var doError = (type === 'error');

      events = this._events;
      if (events)
        doError = (doError && events.error == null);
      else if (!doError)
        return false;

      domain = this.domain;

      // If there is no 'error' event listener then throw.
      if (doError) {
        er = arguments[1];
        if (domain) {
          if (!er)
            er = new Error('Uncaught, unspecified "error" event');
          er.domainEmitter = this;
          er.domain = domain;
          er.domainThrown = false;
          domain.emit('error', er);
        } else if (er instanceof Error) {
          throw er; // Unhandled 'error' event
        } else {
          // At least give some kind of context to the user
          var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
          err.context = er;
          throw err;
        }
        return false;
      }

      handler = events[type];

      if (!handler)
        return false;

      var isFn = typeof handler === 'function';
      len = arguments.length;
      switch (len) {
        // fast cases
        case 1:
          emitNone(handler, isFn, this);
          break;
        case 2:
          emitOne(handler, isFn, this, arguments[1]);
          break;
        case 3:
          emitTwo(handler, isFn, this, arguments[1], arguments[2]);
          break;
        case 4:
          emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
          break;
        // slower
        default:
          args = new Array(len - 1);
          for (i = 1; i < len; i++)
            args[i - 1] = arguments[i];
          emitMany(handler, isFn, this, args);
      }

      return true;
    };

    function _addListener(target, type, listener, prepend) {
      var m;
      var events;
      var existing;

      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');

      events = target._events;
      if (!events) {
        events = target._events = new EventHandlers();
        target._eventsCount = 0;
      } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener) {
          target.emit('newListener', type,
                      listener.listener ? listener.listener : listener);

          // Re-assign `events` because a newListener handler could have caused the
          // this._events to be assigned to a new object
          events = target._events;
        }
        existing = events[type];
      }

      if (!existing) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
      } else {
        if (typeof existing === 'function') {
          // Adding the second element, need to change to array.
          existing = events[type] = prepend ? [listener, existing] :
                                              [existing, listener];
        } else {
          // If we've already got an array, just append.
          if (prepend) {
            existing.unshift(listener);
          } else {
            existing.push(listener);
          }
        }

        // Check for listener leak
        if (!existing.warned) {
          m = $getMaxListeners(target);
          if (m && m > 0 && existing.length > m) {
            existing.warned = true;
            var w = new Error('Possible EventEmitter memory leak detected. ' +
                                existing.length + ' ' + type + ' listeners added. ' +
                                'Use emitter.setMaxListeners() to increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            emitWarning(w);
          }
        }
      }

      return target;
    }
    function emitWarning(e) {
      typeof console.warn === 'function' ? console.warn(e) : console.log(e);
    }
    EventEmitter.prototype.addListener = function addListener(type, listener) {
      return _addListener(this, type, listener, false);
    };

    EventEmitter.prototype.on = EventEmitter.prototype.addListener;

    EventEmitter.prototype.prependListener =
        function prependListener(type, listener) {
          return _addListener(this, type, listener, true);
        };

    function _onceWrap(target, type, listener) {
      var fired = false;
      function g() {
        target.removeListener(type, g);
        if (!fired) {
          fired = true;
          listener.apply(target, arguments);
        }
      }
      g.listener = listener;
      return g;
    }

    EventEmitter.prototype.once = function once(type, listener) {
      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');
      this.on(type, _onceWrap(this, type, listener));
      return this;
    };

    EventEmitter.prototype.prependOnceListener =
        function prependOnceListener(type, listener) {
          if (typeof listener !== 'function')
            throw new TypeError('"listener" argument must be a function');
          this.prependListener(type, _onceWrap(this, type, listener));
          return this;
        };

    // emits a 'removeListener' event iff the listener was removed
    EventEmitter.prototype.removeListener =
        function removeListener(type, listener) {
          var list, events, position, i, originalListener;

          if (typeof listener !== 'function')
            throw new TypeError('"listener" argument must be a function');

          events = this._events;
          if (!events)
            return this;

          list = events[type];
          if (!list)
            return this;

          if (list === listener || (list.listener && list.listener === listener)) {
            if (--this._eventsCount === 0)
              this._events = new EventHandlers();
            else {
              delete events[type];
              if (events.removeListener)
                this.emit('removeListener', type, list.listener || listener);
            }
          } else if (typeof list !== 'function') {
            position = -1;

            for (i = list.length; i-- > 0;) {
              if (list[i] === listener ||
                  (list[i].listener && list[i].listener === listener)) {
                originalListener = list[i].listener;
                position = i;
                break;
              }
            }

            if (position < 0)
              return this;

            if (list.length === 1) {
              list[0] = undefined;
              if (--this._eventsCount === 0) {
                this._events = new EventHandlers();
                return this;
              } else {
                delete events[type];
              }
            } else {
              spliceOne(list, position);
            }

            if (events.removeListener)
              this.emit('removeListener', type, originalListener || listener);
          }

          return this;
        };
        
    // Alias for removeListener added in NodeJS 10.0
    // https://nodejs.org/api/events.html#events_emitter_off_eventname_listener
    EventEmitter.prototype.off = function(type, listener){
        return this.removeListener(type, listener);
    };

    EventEmitter.prototype.removeAllListeners =
        function removeAllListeners(type) {
          var listeners, events;

          events = this._events;
          if (!events)
            return this;

          // not listening for removeListener, no need to emit
          if (!events.removeListener) {
            if (arguments.length === 0) {
              this._events = new EventHandlers();
              this._eventsCount = 0;
            } else if (events[type]) {
              if (--this._eventsCount === 0)
                this._events = new EventHandlers();
              else
                delete events[type];
            }
            return this;
          }

          // emit removeListener for all listeners on all events
          if (arguments.length === 0) {
            var keys = Object.keys(events);
            for (var i = 0, key; i < keys.length; ++i) {
              key = keys[i];
              if (key === 'removeListener') continue;
              this.removeAllListeners(key);
            }
            this.removeAllListeners('removeListener');
            this._events = new EventHandlers();
            this._eventsCount = 0;
            return this;
          }

          listeners = events[type];

          if (typeof listeners === 'function') {
            this.removeListener(type, listeners);
          } else if (listeners) {
            // LIFO order
            do {
              this.removeListener(type, listeners[listeners.length - 1]);
            } while (listeners[0]);
          }

          return this;
        };

    EventEmitter.prototype.listeners = function listeners(type) {
      var evlistener;
      var ret;
      var events = this._events;

      if (!events)
        ret = [];
      else {
        evlistener = events[type];
        if (!evlistener)
          ret = [];
        else if (typeof evlistener === 'function')
          ret = [evlistener.listener || evlistener];
        else
          ret = unwrapListeners(evlistener);
      }

      return ret;
    };

    EventEmitter.listenerCount = function(emitter, type) {
      if (typeof emitter.listenerCount === 'function') {
        return emitter.listenerCount(type);
      } else {
        return listenerCount$1.call(emitter, type);
      }
    };

    EventEmitter.prototype.listenerCount = listenerCount$1;
    function listenerCount$1(type) {
      var events = this._events;

      if (events) {
        var evlistener = events[type];

        if (typeof evlistener === 'function') {
          return 1;
        } else if (evlistener) {
          return evlistener.length;
        }
      }

      return 0;
    }

    EventEmitter.prototype.eventNames = function eventNames() {
      return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
    };

    // About 1.5x faster than the two-arg version of Array#splice().
    function spliceOne(list, index) {
      for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
        list[i] = list[k];
      list.pop();
    }

    function arrayClone(arr, i) {
      var copy = new Array(i);
      while (i--)
        copy[i] = arr[i];
      return copy;
    }

    function unwrapListeners(arr) {
      var ret = new Array(arr.length);
      for (var i = 0; i < ret.length; ++i) {
        ret[i] = arr[i].listener || arr[i];
      }
      return ret;
    }

    var _polyfillNode_events = /*#__PURE__*/Object.freeze({
        __proto__: null,
        'default': EventEmitter,
        EventEmitter: EventEmitter
    });

    var require$$0$2 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_events);

    var streamBrowser = require$$0$2.EventEmitter;

    // shim for using process in browser
    // based off https://github.com/defunctzombie/node-process/blob/master/browser.js

    function defaultSetTimout() {
        throw new Error('setTimeout has not been defined');
    }
    function defaultClearTimeout () {
        throw new Error('clearTimeout has not been defined');
    }
    var cachedSetTimeout = defaultSetTimout;
    var cachedClearTimeout = defaultClearTimeout;
    if (typeof global$1.setTimeout === 'function') {
        cachedSetTimeout = setTimeout;
    }
    if (typeof global$1.clearTimeout === 'function') {
        cachedClearTimeout = clearTimeout;
    }

    function runTimeout(fun) {
        if (cachedSetTimeout === setTimeout) {
            //normal enviroments in sane situations
            return setTimeout(fun, 0);
        }
        // if setTimeout wasn't available but was latter defined
        if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
        }
        try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
        } catch(e){
            try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                return cachedSetTimeout.call(null, fun, 0);
            } catch(e){
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                return cachedSetTimeout.call(this, fun, 0);
            }
        }


    }
    function runClearTimeout(marker) {
        if (cachedClearTimeout === clearTimeout) {
            //normal enviroments in sane situations
            return clearTimeout(marker);
        }
        // if clearTimeout wasn't available but was latter defined
        if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
        }
        try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
        } catch (e){
            try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                return cachedClearTimeout.call(null, marker);
            } catch (e){
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                return cachedClearTimeout.call(this, marker);
            }
        }



    }
    var queue = [];
    var draining = false;
    var currentQueue;
    var queueIndex = -1;

    function cleanUpNextTick() {
        if (!draining || !currentQueue) {
            return;
        }
        draining = false;
        if (currentQueue.length) {
            queue = currentQueue.concat(queue);
        } else {
            queueIndex = -1;
        }
        if (queue.length) {
            drainQueue();
        }
    }

    function drainQueue() {
        if (draining) {
            return;
        }
        var timeout = runTimeout(cleanUpNextTick);
        draining = true;

        var len = queue.length;
        while(len) {
            currentQueue = queue;
            queue = [];
            while (++queueIndex < len) {
                if (currentQueue) {
                    currentQueue[queueIndex].run();
                }
            }
            queueIndex = -1;
            len = queue.length;
        }
        currentQueue = null;
        draining = false;
        runClearTimeout(timeout);
    }
    function nextTick$1(fun) {
        var args = new Array(arguments.length - 1);
        if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
                args[i - 1] = arguments[i];
            }
        }
        queue.push(new Item(fun, args));
        if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
        }
    }
    // v8 likes predictible objects
    function Item(fun, array) {
        this.fun = fun;
        this.array = array;
    }
    Item.prototype.run = function () {
        this.fun.apply(null, this.array);
    };
    var title = 'browser';
    var platform = 'browser';
    var browser$4 = true;
    var env = {};
    var argv = [];
    var version$1 = ''; // empty string to avoid regexp issues
    var versions = {};
    var release = {};
    var config$1 = {};

    function noop$2() {}

    var on = noop$2;
    var addListener = noop$2;
    var once$2 = noop$2;
    var off = noop$2;
    var removeListener = noop$2;
    var removeAllListeners = noop$2;
    var emit = noop$2;

    function binding(name) {
        throw new Error('process.binding is not supported');
    }

    function cwd () { return '/' }
    function chdir (dir) {
        throw new Error('process.chdir is not supported');
    }function umask() { return 0; }

    // from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
    var performance = global$1.performance || {};
    var performanceNow =
      performance.now        ||
      performance.mozNow     ||
      performance.msNow      ||
      performance.oNow       ||
      performance.webkitNow  ||
      function(){ return (new Date()).getTime() };

    // generate timestamp or delta
    // see http://nodejs.org/api/process.html#process_process_hrtime
    function hrtime(previousTimestamp){
      var clocktime = performanceNow.call(performance)*1e-3;
      var seconds = Math.floor(clocktime);
      var nanoseconds = Math.floor((clocktime%1)*1e9);
      if (previousTimestamp) {
        seconds = seconds - previousTimestamp[0];
        nanoseconds = nanoseconds - previousTimestamp[1];
        if (nanoseconds<0) {
          seconds--;
          nanoseconds += 1e9;
        }
      }
      return [seconds,nanoseconds]
    }

    var startTime = new Date();
    function uptime() {
      var currentTime = new Date();
      var dif = currentTime - startTime;
      return dif / 1000;
    }

    var browser$1$1 = {
      nextTick: nextTick$1,
      title: title,
      browser: browser$4,
      env: env,
      argv: argv,
      version: version$1,
      versions: versions,
      on: on,
      addListener: addListener,
      once: once$2,
      off: off,
      removeListener: removeListener,
      removeAllListeners: removeAllListeners,
      emit: emit,
      binding: binding,
      cwd: cwd,
      chdir: chdir,
      umask: umask,
      hrtime: hrtime,
      platform: platform,
      release: release,
      config: config$1,
      uptime: uptime
    };

    var inherits$f;
    if (typeof Object.create === 'function'){
      inherits$f = function inherits(ctor, superCtor) {
        // implementation from standard node.js 'util' module
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
          constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
      };
    } else {
      inherits$f = function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function () {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
      };
    }
    var inherits$g = inherits$f;

    var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
      function getOwnPropertyDescriptors(obj) {
        var keys = Object.keys(obj);
        var descriptors = {};
        for (var i = 0; i < keys.length; i++) {
          descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
        }
        return descriptors;
      };

    var formatRegExp = /%[sdj%]/g;
    function format(f) {
      if (!isString(f)) {
        var objects = [];
        for (var i = 0; i < arguments.length; i++) {
          objects.push(inspect$1(arguments[i]));
        }
        return objects.join(' ');
      }

      var i = 1;
      var args = arguments;
      var len = args.length;
      var str = String(f).replace(formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch (x) {
          case '%s': return String(args[i++]);
          case '%d': return Number(args[i++]);
          case '%j':
            try {
              return JSON.stringify(args[i++]);
            } catch (_) {
              return '[Circular]';
            }
          default:
            return x;
        }
      });
      for (var x = args[i]; i < len; x = args[++i]) {
        if (isNull(x) || !isObject(x)) {
          str += ' ' + x;
        } else {
          str += ' ' + inspect$1(x);
        }
      }
      return str;
    }

    // Mark that a method should not be used.
    // Returns a modified function which warns once by default.
    // If --no-deprecation is set, then it is a no-op.
    function deprecate$1(fn, msg) {
      // Allow for deprecating things in the process of starting up.
      if (isUndefined(global$1.process)) {
        return function() {
          return deprecate$1(fn, msg).apply(this, arguments);
        };
      }

      if (browser$1$1.noDeprecation === true) {
        return fn;
      }

      var warned = false;
      function deprecated() {
        if (!warned) {
          if (browser$1$1.throwDeprecation) {
            throw new Error(msg);
          } else if (browser$1$1.traceDeprecation) {
            console.trace(msg);
          } else {
            console.error(msg);
          }
          warned = true;
        }
        return fn.apply(this, arguments);
      }

      return deprecated;
    }

    var debugs = {};
    var debugEnviron;
    function debuglog(set) {
      if (isUndefined(debugEnviron))
        debugEnviron = browser$1$1.env.NODE_DEBUG || '';
      set = set.toUpperCase();
      if (!debugs[set]) {
        if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
          var pid = 0;
          debugs[set] = function() {
            var msg = format.apply(null, arguments);
            console.error('%s %d: %s', set, pid, msg);
          };
        } else {
          debugs[set] = function() {};
        }
      }
      return debugs[set];
    }

    /**
     * Echos the value of a value. Trys to print the value out
     * in the best way possible given the different types.
     *
     * @param {Object} obj The object to print out.
     * @param {Object} opts Optional options object that alters the output.
     */
    /* legacy: obj, showHidden, depth, colors*/
    function inspect$1(obj, opts) {
      // default options
      var ctx = {
        seen: [],
        stylize: stylizeNoColor
      };
      // legacy...
      if (arguments.length >= 3) ctx.depth = arguments[2];
      if (arguments.length >= 4) ctx.colors = arguments[3];
      if (isBoolean(opts)) {
        // legacy...
        ctx.showHidden = opts;
      } else if (opts) {
        // got an "options" object
        _extend(ctx, opts);
      }
      // set default options
      if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
      if (isUndefined(ctx.depth)) ctx.depth = 2;
      if (isUndefined(ctx.colors)) ctx.colors = false;
      if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
      if (ctx.colors) ctx.stylize = stylizeWithColor;
      return formatValue(ctx, obj, ctx.depth);
    }

    // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
    inspect$1.colors = {
      'bold' : [1, 22],
      'italic' : [3, 23],
      'underline' : [4, 24],
      'inverse' : [7, 27],
      'white' : [37, 39],
      'grey' : [90, 39],
      'black' : [30, 39],
      'blue' : [34, 39],
      'cyan' : [36, 39],
      'green' : [32, 39],
      'magenta' : [35, 39],
      'red' : [31, 39],
      'yellow' : [33, 39]
    };

    // Don't use 'blue' not visible on cmd.exe
    inspect$1.styles = {
      'special': 'cyan',
      'number': 'yellow',
      'boolean': 'yellow',
      'undefined': 'grey',
      'null': 'bold',
      'string': 'green',
      'date': 'magenta',
      // "name": intentionally not styling
      'regexp': 'red'
    };


    function stylizeWithColor(str, styleType) {
      var style = inspect$1.styles[styleType];

      if (style) {
        return '\u001b[' + inspect$1.colors[style][0] + 'm' + str +
               '\u001b[' + inspect$1.colors[style][1] + 'm';
      } else {
        return str;
      }
    }


    function stylizeNoColor(str, styleType) {
      return str;
    }


    function arrayToHash(array) {
      var hash = {};

      array.forEach(function(val, idx) {
        hash[val] = true;
      });

      return hash;
    }


    function formatValue(ctx, value, recurseTimes) {
      // Provide a hook for user-specified inspect functions.
      // Check that value is an object with an inspect function on it
      if (ctx.customInspect &&
          value &&
          isFunction(value.inspect) &&
          // Filter out the util module, it's inspect function is special
          value.inspect !== inspect$1 &&
          // Also filter out any prototype objects using the circular check.
          !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!isString(ret)) {
          ret = formatValue(ctx, ret, recurseTimes);
        }
        return ret;
      }

      // Primitive types cannot have properties
      var primitive = formatPrimitive(ctx, value);
      if (primitive) {
        return primitive;
      }

      // Look up the keys of the object.
      var keys = Object.keys(value);
      var visibleKeys = arrayToHash(keys);

      if (ctx.showHidden) {
        keys = Object.getOwnPropertyNames(value);
      }

      // IE doesn't make error fields non-enumerable
      // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
      if (isError(value)
          && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
        return formatError(value);
      }

      // Some type of object without properties can be shortcutted.
      if (keys.length === 0) {
        if (isFunction(value)) {
          var name = value.name ? ': ' + value.name : '';
          return ctx.stylize('[Function' + name + ']', 'special');
        }
        if (isRegExp(value)) {
          return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        }
        if (isDate(value)) {
          return ctx.stylize(Date.prototype.toString.call(value), 'date');
        }
        if (isError(value)) {
          return formatError(value);
        }
      }

      var base = '', array = false, braces = ['{', '}'];

      // Make Array say that they are Array
      if (isArray(value)) {
        array = true;
        braces = ['[', ']'];
      }

      // Make functions say that they are functions
      if (isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
      }

      // Make RegExps say that they are RegExps
      if (isRegExp(value)) {
        base = ' ' + RegExp.prototype.toString.call(value);
      }

      // Make dates with properties first say the date
      if (isDate(value)) {
        base = ' ' + Date.prototype.toUTCString.call(value);
      }

      // Make error with message first say the error
      if (isError(value)) {
        base = ' ' + formatError(value);
      }

      if (keys.length === 0 && (!array || value.length == 0)) {
        return braces[0] + base + braces[1];
      }

      if (recurseTimes < 0) {
        if (isRegExp(value)) {
          return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        } else {
          return ctx.stylize('[Object]', 'special');
        }
      }

      ctx.seen.push(value);

      var output;
      if (array) {
        output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
      } else {
        output = keys.map(function(key) {
          return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
        });
      }

      ctx.seen.pop();

      return reduceToSingleString(output, base, braces);
    }


    function formatPrimitive(ctx, value) {
      if (isUndefined(value))
        return ctx.stylize('undefined', 'undefined');
      if (isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                                 .replace(/'/g, "\\'")
                                                 .replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
      }
      if (isNumber(value))
        return ctx.stylize('' + value, 'number');
      if (isBoolean(value))
        return ctx.stylize('' + value, 'boolean');
      // For some reason typeof null is "object", so special case here.
      if (isNull(value))
        return ctx.stylize('null', 'null');
    }


    function formatError(value) {
      return '[' + Error.prototype.toString.call(value) + ']';
    }


    function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
      var output = [];
      for (var i = 0, l = value.length; i < l; ++i) {
        if (hasOwnProperty(value, String(i))) {
          output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
              String(i), true));
        } else {
          output.push('');
        }
      }
      keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) {
          output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
              key, true));
        }
      });
      return output;
    }


    function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
      var name, str, desc;
      desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
      if (desc.get) {
        if (desc.set) {
          str = ctx.stylize('[Getter/Setter]', 'special');
        } else {
          str = ctx.stylize('[Getter]', 'special');
        }
      } else {
        if (desc.set) {
          str = ctx.stylize('[Setter]', 'special');
        }
      }
      if (!hasOwnProperty(visibleKeys, key)) {
        name = '[' + key + ']';
      }
      if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
          if (isNull(recurseTimes)) {
            str = formatValue(ctx, desc.value, null);
          } else {
            str = formatValue(ctx, desc.value, recurseTimes - 1);
          }
          if (str.indexOf('\n') > -1) {
            if (array) {
              str = str.split('\n').map(function(line) {
                return '  ' + line;
              }).join('\n').substr(2);
            } else {
              str = '\n' + str.split('\n').map(function(line) {
                return '   ' + line;
              }).join('\n');
            }
          }
        } else {
          str = ctx.stylize('[Circular]', 'special');
        }
      }
      if (isUndefined(name)) {
        if (array && key.match(/^\d+$/)) {
          return str;
        }
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
          name = name.substr(1, name.length - 2);
          name = ctx.stylize(name, 'name');
        } else {
          name = name.replace(/'/g, "\\'")
                     .replace(/\\"/g, '"')
                     .replace(/(^"|"$)/g, "'");
          name = ctx.stylize(name, 'string');
        }
      }

      return name + ': ' + str;
    }


    function reduceToSingleString(output, base, braces) {
      var length = output.reduce(function(prev, cur) {
        if (cur.indexOf('\n') >= 0) ;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
      }, 0);

      if (length > 60) {
        return braces[0] +
               (base === '' ? '' : base + '\n ') +
               ' ' +
               output.join(',\n  ') +
               ' ' +
               braces[1];
      }

      return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
    }


    // NOTE: These type checking functions intentionally don't use `instanceof`
    // because it is fragile and can be easily faked with `Object.create()`.
    function isArray(ar) {
      return Array.isArray(ar);
    }

    function isBoolean(arg) {
      return typeof arg === 'boolean';
    }

    function isNull(arg) {
      return arg === null;
    }

    function isNullOrUndefined(arg) {
      return arg == null;
    }

    function isNumber(arg) {
      return typeof arg === 'number';
    }

    function isString(arg) {
      return typeof arg === 'string';
    }

    function isSymbol(arg) {
      return typeof arg === 'symbol';
    }

    function isUndefined(arg) {
      return arg === void 0;
    }

    function isRegExp(re) {
      return isObject(re) && objectToString(re) === '[object RegExp]';
    }

    function isObject(arg) {
      return typeof arg === 'object' && arg !== null;
    }

    function isDate(d) {
      return isObject(d) && objectToString(d) === '[object Date]';
    }

    function isError(e) {
      return isObject(e) &&
          (objectToString(e) === '[object Error]' || e instanceof Error);
    }

    function isFunction(arg) {
      return typeof arg === 'function';
    }

    function isPrimitive(arg) {
      return arg === null ||
             typeof arg === 'boolean' ||
             typeof arg === 'number' ||
             typeof arg === 'string' ||
             typeof arg === 'symbol' ||  // ES6 symbol
             typeof arg === 'undefined';
    }

    function isBuffer(maybeBuf) {
      return Buffer$l.isBuffer(maybeBuf);
    }

    function objectToString(o) {
      return Object.prototype.toString.call(o);
    }


    function pad(n) {
      return n < 10 ? '0' + n.toString(10) : n.toString(10);
    }


    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
                  'Oct', 'Nov', 'Dec'];

    // 26 Feb 16:19:34
    function timestamp() {
      var d = new Date();
      var time = [pad(d.getHours()),
                  pad(d.getMinutes()),
                  pad(d.getSeconds())].join(':');
      return [d.getDate(), months[d.getMonth()], time].join(' ');
    }


    // log is just a thin wrapper to console.log that prepends a timestamp
    function log() {
      console.log('%s - %s', timestamp(), format.apply(null, arguments));
    }

    function _extend(origin, add) {
      // Don't do anything if add isn't an object
      if (!add || !isObject(add)) return origin;

      var keys = Object.keys(add);
      var i = keys.length;
      while (i--) {
        origin[keys[i]] = add[keys[i]];
      }
      return origin;
    }
    function hasOwnProperty(obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    }

    var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

    function promisify(original) {
      if (typeof original !== 'function')
        throw new TypeError('The "original" argument must be of type Function');

      if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
        var fn = original[kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') {
          throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        }
        Object.defineProperty(fn, kCustomPromisifiedSymbol, {
          value: fn, enumerable: false, writable: false, configurable: true
        });
        return fn;
      }

      function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function (resolve, reject) {
          promiseResolve = resolve;
          promiseReject = reject;
        });

        var args = [];
        for (var i = 0; i < arguments.length; i++) {
          args.push(arguments[i]);
        }
        args.push(function (err, value) {
          if (err) {
            promiseReject(err);
          } else {
            promiseResolve(value);
          }
        });

        try {
          original.apply(this, args);
        } catch (err) {
          promiseReject(err);
        }

        return promise;
      }

      Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

      if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
        value: fn, enumerable: false, writable: false, configurable: true
      });
      return Object.defineProperties(
        fn,
        getOwnPropertyDescriptors(original)
      );
    }

    promisify.custom = kCustomPromisifiedSymbol;

    function callbackifyOnRejected(reason, cb) {
      // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
      // Because `null` is a special error value in callbacks which means "no error
      // occurred", we error-wrap so the callback consumer can distinguish between
      // "the promise rejected with null" or "the promise fulfilled with undefined".
      if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
      }
      return cb(reason);
    }

    function callbackify(original) {
      if (typeof original !== 'function') {
        throw new TypeError('The "original" argument must be of type Function');
      }

      // We DO NOT return the promise as it gives the user a false sense that
      // the promise is actually somehow related to the callback's execution
      // and that the callback throwing will reject the promise.
      function callbackified() {
        var args = [];
        for (var i = 0; i < arguments.length; i++) {
          args.push(arguments[i]);
        }

        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') {
          throw new TypeError('The last argument must be of type Function');
        }
        var self = this;
        var cb = function() {
          return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args)
          .then(function(ret) { browser$1$1.nextTick(cb.bind(null, null, ret)); },
            function(rej) { browser$1$1.nextTick(callbackifyOnRejected.bind(null, rej, cb)); });
      }

      Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
      Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
      return callbackified;
    }

    var _polyfillNode_util = {
      inherits: inherits$g,
      _extend: _extend,
      log: log,
      isBuffer: isBuffer,
      isPrimitive: isPrimitive,
      isFunction: isFunction,
      isError: isError,
      isDate: isDate,
      isObject: isObject,
      isRegExp: isRegExp,
      isUndefined: isUndefined,
      isSymbol: isSymbol,
      isString: isString,
      isNumber: isNumber,
      isNullOrUndefined: isNullOrUndefined,
      isNull: isNull,
      isBoolean: isBoolean,
      isArray: isArray,
      inspect: inspect$1,
      deprecate: deprecate$1,
      format: format,
      debuglog: debuglog,
      promisify: promisify,
      callbackify: callbackify,
    };

    var _polyfillNode_util$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        format: format,
        deprecate: deprecate$1,
        debuglog: debuglog,
        inspect: inspect$1,
        isArray: isArray,
        isBoolean: isBoolean,
        isNull: isNull,
        isNullOrUndefined: isNullOrUndefined,
        isNumber: isNumber,
        isString: isString,
        isSymbol: isSymbol,
        isUndefined: isUndefined,
        isRegExp: isRegExp,
        isObject: isObject,
        isDate: isDate,
        isError: isError,
        isFunction: isFunction,
        isPrimitive: isPrimitive,
        isBuffer: isBuffer,
        log: log,
        inherits: inherits$g,
        _extend: _extend,
        promisify: promisify,
        callbackify: callbackify,
        'default': _polyfillNode_util
    });

    var require$$3 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_util$1);

    var buffer_list;
    var hasRequiredBuffer_list;

    function requireBuffer_list () {
    	if (hasRequiredBuffer_list) return buffer_list;
    	hasRequiredBuffer_list = 1;

    	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
    	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
    	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
    	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
    	function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
    	const _require = require$$0$3,
    	  Buffer = _require.Buffer;
    	const _require2 = require$$3,
    	  inspect = _require2.inspect;
    	const custom = inspect && inspect.custom || 'inspect';
    	function copyBuffer(src, target, offset) {
    	  Buffer.prototype.copy.call(src, target, offset);
    	}
    	buffer_list = class BufferList {
    	  constructor() {
    	    this.head = null;
    	    this.tail = null;
    	    this.length = 0;
    	  }
    	  push(v) {
    	    const entry = {
    	      data: v,
    	      next: null
    	    };
    	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    	    this.tail = entry;
    	    ++this.length;
    	  }
    	  unshift(v) {
    	    const entry = {
    	      data: v,
    	      next: this.head
    	    };
    	    if (this.length === 0) this.tail = entry;
    	    this.head = entry;
    	    ++this.length;
    	  }
    	  shift() {
    	    if (this.length === 0) return;
    	    const ret = this.head.data;
    	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    	    --this.length;
    	    return ret;
    	  }
    	  clear() {
    	    this.head = this.tail = null;
    	    this.length = 0;
    	  }
    	  join(s) {
    	    if (this.length === 0) return '';
    	    var p = this.head;
    	    var ret = '' + p.data;
    	    while (p = p.next) ret += s + p.data;
    	    return ret;
    	  }
    	  concat(n) {
    	    if (this.length === 0) return Buffer.alloc(0);
    	    const ret = Buffer.allocUnsafe(n >>> 0);
    	    var p = this.head;
    	    var i = 0;
    	    while (p) {
    	      copyBuffer(p.data, ret, i);
    	      i += p.data.length;
    	      p = p.next;
    	    }
    	    return ret;
    	  }

    	  // Consumes a specified amount of bytes or characters from the buffered data.
    	  consume(n, hasStrings) {
    	    var ret;
    	    if (n < this.head.data.length) {
    	      // `slice` is the same for buffers and strings.
    	      ret = this.head.data.slice(0, n);
    	      this.head.data = this.head.data.slice(n);
    	    } else if (n === this.head.data.length) {
    	      // First chunk is a perfect match.
    	      ret = this.shift();
    	    } else {
    	      // Result spans more than one buffer.
    	      ret = hasStrings ? this._getString(n) : this._getBuffer(n);
    	    }
    	    return ret;
    	  }
    	  first() {
    	    return this.head.data;
    	  }

    	  // Consumes a specified amount of characters from the buffered data.
    	  _getString(n) {
    	    var p = this.head;
    	    var c = 1;
    	    var ret = p.data;
    	    n -= ret.length;
    	    while (p = p.next) {
    	      const str = p.data;
    	      const nb = n > str.length ? str.length : n;
    	      if (nb === str.length) ret += str;else ret += str.slice(0, n);
    	      n -= nb;
    	      if (n === 0) {
    	        if (nb === str.length) {
    	          ++c;
    	          if (p.next) this.head = p.next;else this.head = this.tail = null;
    	        } else {
    	          this.head = p;
    	          p.data = str.slice(nb);
    	        }
    	        break;
    	      }
    	      ++c;
    	    }
    	    this.length -= c;
    	    return ret;
    	  }

    	  // Consumes a specified amount of bytes from the buffered data.
    	  _getBuffer(n) {
    	    const ret = Buffer.allocUnsafe(n);
    	    var p = this.head;
    	    var c = 1;
    	    p.data.copy(ret);
    	    n -= p.data.length;
    	    while (p = p.next) {
    	      const buf = p.data;
    	      const nb = n > buf.length ? buf.length : n;
    	      buf.copy(ret, ret.length - n, 0, nb);
    	      n -= nb;
    	      if (n === 0) {
    	        if (nb === buf.length) {
    	          ++c;
    	          if (p.next) this.head = p.next;else this.head = this.tail = null;
    	        } else {
    	          this.head = p;
    	          p.data = buf.slice(nb);
    	        }
    	        break;
    	      }
    	      ++c;
    	    }
    	    this.length -= c;
    	    return ret;
    	  }

    	  // Make sure the linked list only shows the minimal necessary information.
    	  [custom](_, options) {
    	    return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
    	      // Only inspect one level.
    	      depth: 0,
    	      // It should not recurse.
    	      customInspect: false
    	    }));
    	  }
    	};
    	return buffer_list;
    }

    // undocumented cb() API, needed for core, not for public API
    function destroy(err, cb) {
      const readableDestroyed = this._readableState && this._readableState.destroyed;
      const writableDestroyed = this._writableState && this._writableState.destroyed;
      if (readableDestroyed || writableDestroyed) {
        if (cb) {
          cb(err);
        } else if (err) {
          if (!this._writableState) {
            process.nextTick(emitErrorNT, this, err);
          } else if (!this._writableState.errorEmitted) {
            this._writableState.errorEmitted = true;
            process.nextTick(emitErrorNT, this, err);
          }
        }
        return this;
      }

      // we set destroyed to true before firing error callbacks in order
      // to make it re-entrance safe in case destroy() is called within callbacks

      if (this._readableState) {
        this._readableState.destroyed = true;
      }

      // if this is a duplex stream mark the writable part as destroyed as well
      if (this._writableState) {
        this._writableState.destroyed = true;
      }
      this._destroy(err || null, err => {
        if (!cb && err) {
          if (!this._writableState) {
            process.nextTick(emitErrorAndCloseNT, this, err);
          } else if (!this._writableState.errorEmitted) {
            this._writableState.errorEmitted = true;
            process.nextTick(emitErrorAndCloseNT, this, err);
          } else {
            process.nextTick(emitCloseNT, this);
          }
        } else if (cb) {
          process.nextTick(emitCloseNT, this);
          cb(err);
        } else {
          process.nextTick(emitCloseNT, this);
        }
      });
      return this;
    }
    function emitErrorAndCloseNT(self, err) {
      emitErrorNT(self, err);
      emitCloseNT(self);
    }
    function emitCloseNT(self) {
      if (self._writableState && !self._writableState.emitClose) return;
      if (self._readableState && !self._readableState.emitClose) return;
      self.emit('close');
    }
    function undestroy() {
      if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
      }
      if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
      }
    }
    function emitErrorNT(self, err) {
      self.emit('error', err);
    }
    function errorOrDestroy(stream, err) {
      // We have tests that rely on errors being emitted
      // in the same tick, so changing this is semver major.
      // For now when you opt-in to autoDestroy we allow
      // the error to be emitted nextTick. In a future
      // semver major update we should change the default to this.

      const rState = stream._readableState;
      const wState = stream._writableState;
      if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
    }
    var destroy_1 = {
      destroy,
      undestroy,
      errorOrDestroy
    };

    var errorsBrowser = {};

    function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

    var codes = {};

    function createErrorType(code, message, Base) {
      if (!Base) {
        Base = Error;
      }

      function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') {
          return message;
        } else {
          return message(arg1, arg2, arg3);
        }
      }

      var NodeError =
      /*#__PURE__*/
      function (_Base) {
        _inheritsLoose(NodeError, _Base);

        function NodeError(arg1, arg2, arg3) {
          return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }

        return NodeError;
      }(Base);

      NodeError.prototype.name = Base.name;
      NodeError.prototype.code = code;
      codes[code] = NodeError;
    } // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


    function oneOf(expected, thing) {
      if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function (i) {
          return String(i);
        });

        if (len > 2) {
          return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        } else if (len === 2) {
          return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        } else {
          return "of ".concat(thing, " ").concat(expected[0]);
        }
      } else {
        return "of ".concat(thing, " ").concat(String(expected));
      }
    } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


    function startsWith(str, search, pos) {
      return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


    function endsWith(str, search, this_len) {
      if (this_len === undefined || this_len > str.length) {
        this_len = str.length;
      }

      return str.substring(this_len - search.length, this_len) === search;
    } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


    function includes(str, search, start) {
      if (typeof start !== 'number') {
        start = 0;
      }

      if (start + search.length > str.length) {
        return false;
      } else {
        return str.indexOf(search, start) !== -1;
      }
    }

    createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
      return 'The value "' + value + '" is invalid for option "' + name + '"';
    }, TypeError);
    createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
      // determiner: 'must be' or 'must not be'
      var determiner;

      if (typeof expected === 'string' && startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
      } else {
        determiner = 'must be';
      }

      var msg;

      if (endsWith(name, ' argument')) {
        // For cases like 'first argument'
        msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
      } else {
        var type = includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
      }

      msg += ". Received type ".concat(typeof actual);
      return msg;
    }, TypeError);
    createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
    createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
      return 'The ' + name + ' method is not implemented';
    });
    createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
    createErrorType('ERR_STREAM_DESTROYED', function (name) {
      return 'Cannot call ' + name + ' after a stream was destroyed';
    });
    createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
    createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
    createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
    createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
    createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
      return 'Unknown encoding: ' + arg;
    }, TypeError);
    createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
    errorsBrowser.codes = codes;

    const ERR_INVALID_OPT_VALUE = errorsBrowser.codes.ERR_INVALID_OPT_VALUE;
    function highWaterMarkFrom(options, isDuplex, duplexKey) {
      return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
    }
    function getHighWaterMark(state, options, duplexKey, isDuplex) {
      const hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
      if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
          const name = isDuplex ? duplexKey : 'highWaterMark';
          throw new ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
      }

      // Default value
      return state.objectMode ? 16 : 16 * 1024;
    }
    var state = {
      getHighWaterMark
    };

    /**
     * Module exports.
     */

    var browser$3 = deprecate;

    /**
     * Mark that a method should not be used.
     * Returns a modified function which warns once by default.
     *
     * If `localStorage.noDeprecation = true` is set, then it is a no-op.
     *
     * If `localStorage.throwDeprecation = true` is set, then deprecated functions
     * will throw an Error when invoked.
     *
     * If `localStorage.traceDeprecation = true` is set, then deprecated functions
     * will invoke `console.trace()` instead of `console.error()`.
     *
     * @param {Function} fn - the function to deprecate
     * @param {String} msg - the string to print to the console when `fn` is invoked
     * @returns {Function} a new "deprecated" version of `fn`
     * @api public
     */

    function deprecate (fn, msg) {
      if (config('noDeprecation')) {
        return fn;
      }

      var warned = false;
      function deprecated() {
        if (!warned) {
          if (config('throwDeprecation')) {
            throw new Error(msg);
          } else if (config('traceDeprecation')) {
            console.trace(msg);
          } else {
            console.warn(msg);
          }
          warned = true;
        }
        return fn.apply(this, arguments);
      }

      return deprecated;
    }

    /**
     * Checks `localStorage` for boolean values for the given `name`.
     *
     * @param {String} name
     * @returns {Boolean}
     * @api private
     */

    function config (name) {
      // accessing global.localStorage can trigger a DOMException in sandboxed iframes
      try {
        if (!commonjsGlobal.localStorage) return false;
      } catch (_) {
        return false;
      }
      var val = commonjsGlobal.localStorage[name];
      if (null == val) return false;
      return String(val).toLowerCase() === 'true';
    }

    var _stream_writable;
    var hasRequired_stream_writable;

    function require_stream_writable () {
    	if (hasRequired_stream_writable) return _stream_writable;
    	hasRequired_stream_writable = 1;

    	_stream_writable = Writable;

    	// It seems a linked list but it is not
    	// there will be only 2 of these for each stream
    	function CorkedRequest(state) {
    	  this.next = null;
    	  this.entry = null;
    	  this.finish = () => {
    	    onCorkedFinish(this, state);
    	  };
    	}
    	/* </replacement> */

    	/*<replacement>*/
    	var Duplex;
    	/*</replacement>*/

    	Writable.WritableState = WritableState;

    	/*<replacement>*/
    	const internalUtil = {
    	  deprecate: browser$3
    	};
    	/*</replacement>*/

    	/*<replacement>*/
    	var Stream = streamBrowser;
    	/*</replacement>*/

    	const Buffer = require$$0$3.Buffer;
    	const OurUint8Array = (typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
    	function _uint8ArrayToBuffer(chunk) {
    	  return Buffer.from(chunk);
    	}
    	function _isUint8Array(obj) {
    	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
    	}
    	const destroyImpl = destroy_1;
    	const _require = state,
    	  getHighWaterMark = _require.getHighWaterMark;
    	const _require$codes = errorsBrowser.codes,
    	  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    	  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    	  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
    	  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
    	  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
    	  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
    	  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
    	  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
    	const errorOrDestroy = destroyImpl.errorOrDestroy;
    	require$$1$1(Writable, Stream);
    	function nop() {}
    	function WritableState(options, stream, isDuplex) {
    	  Duplex = Duplex || require_stream_duplex();
    	  options = options || {};

    	  // Duplex streams are both readable and writable, but share
    	  // the same options object.
    	  // However, some cases require setting options to different
    	  // values for the readable and the writable sides of the duplex stream,
    	  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    	  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

    	  // object stream flag to indicate whether or not this stream
    	  // contains buffers or objects.
    	  this.objectMode = !!options.objectMode;
    	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

    	  // the point at which write() starts returning false
    	  // Note: 0 is a valid value, means that we always return false if
    	  // the entire buffer is not flushed immediately on write()
    	  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

    	  // if _final has been called
    	  this.finalCalled = false;

    	  // drain event flag.
    	  this.needDrain = false;
    	  // at the start of calling end()
    	  this.ending = false;
    	  // when end() has been called, and returned
    	  this.ended = false;
    	  // when 'finish' is emitted
    	  this.finished = false;

    	  // has it been destroyed
    	  this.destroyed = false;

    	  // should we decode strings into buffers before passing to _write?
    	  // this is here so that some node-core streams can optimize string
    	  // handling at a lower level.
    	  var noDecode = options.decodeStrings === false;
    	  this.decodeStrings = !noDecode;

    	  // Crypto is kind of old and crusty.  Historically, its default string
    	  // encoding is 'binary' so we have to make this configurable.
    	  // Everything else in the universe uses 'utf8', though.
    	  this.defaultEncoding = options.defaultEncoding || 'utf8';

    	  // not an actual buffer we keep track of, but a measurement
    	  // of how much we're waiting to get pushed to some underlying
    	  // socket or file.
    	  this.length = 0;

    	  // a flag to see when we're in the middle of a write.
    	  this.writing = false;

    	  // when true all writes will be buffered until .uncork() call
    	  this.corked = 0;

    	  // a flag to be able to tell if the onwrite cb is called immediately,
    	  // or on a later tick.  We set this to true at first, because any
    	  // actions that shouldn't happen until "later" should generally also
    	  // not happen before the first write call.
    	  this.sync = true;

    	  // a flag to know if we're processing previously buffered items, which
    	  // may call the _write() callback in the same tick, so that we don't
    	  // end up in an overlapped onwrite situation.
    	  this.bufferProcessing = false;

    	  // the callback that's passed to _write(chunk,cb)
    	  this.onwrite = function (er) {
    	    onwrite(stream, er);
    	  };

    	  // the callback that the user supplies to write(chunk,encoding,cb)
    	  this.writecb = null;

    	  // the amount that is being written when _write is called.
    	  this.writelen = 0;
    	  this.bufferedRequest = null;
    	  this.lastBufferedRequest = null;

    	  // number of pending user-supplied write callbacks
    	  // this must be 0 before 'finish' can be emitted
    	  this.pendingcb = 0;

    	  // emit prefinish if the only thing we're waiting for is _write cbs
    	  // This is relevant for synchronous Transform streams
    	  this.prefinished = false;

    	  // True if the error was already emitted and should not be thrown again
    	  this.errorEmitted = false;

    	  // Should close be emitted on destroy. Defaults to true.
    	  this.emitClose = options.emitClose !== false;

    	  // Should .destroy() be called after 'finish' (and potentially 'end')
    	  this.autoDestroy = !!options.autoDestroy;

    	  // count buffered requests
    	  this.bufferedRequestCount = 0;

    	  // allocate the first CorkedRequest, there is always
    	  // one allocated and free to use, and we maintain at most two
    	  this.corkedRequestsFree = new CorkedRequest(this);
    	}
    	WritableState.prototype.getBuffer = function getBuffer() {
    	  var current = this.bufferedRequest;
    	  var out = [];
    	  while (current) {
    	    out.push(current);
    	    current = current.next;
    	  }
    	  return out;
    	};
    	(function () {
    	  try {
    	    Object.defineProperty(WritableState.prototype, 'buffer', {
    	      get: internalUtil.deprecate(function writableStateBufferGetter() {
    	        return this.getBuffer();
    	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    	    });
    	  } catch (_) {}
    	})();

    	// Test _writableState for inheritance to account for Duplex streams,
    	// whose prototype chain only points to Readable.
    	var realHasInstance;
    	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    	  realHasInstance = Function.prototype[Symbol.hasInstance];
    	  Object.defineProperty(Writable, Symbol.hasInstance, {
    	    value: function value(object) {
    	      if (realHasInstance.call(this, object)) return true;
    	      if (this !== Writable) return false;
    	      return object && object._writableState instanceof WritableState;
    	    }
    	  });
    	} else {
    	  realHasInstance = function realHasInstance(object) {
    	    return object instanceof this;
    	  };
    	}
    	function Writable(options) {
    	  Duplex = Duplex || require_stream_duplex();

    	  // Writable ctor is applied to Duplexes, too.
    	  // `realHasInstance` is necessary because using plain `instanceof`
    	  // would return false, as no `_writableState` property is attached.

    	  // Trying to use the custom `instanceof` for Writable here will also break the
    	  // Node.js LazyTransform implementation, which has a non-trivial getter for
    	  // `_writableState` that would lead to infinite recursion.

    	  // Checking for a Stream.Duplex instance is faster here instead of inside
    	  // the WritableState constructor, at least with V8 6.5
    	  const isDuplex = this instanceof Duplex;
    	  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
    	  this._writableState = new WritableState(options, this, isDuplex);

    	  // legacy.
    	  this.writable = true;
    	  if (options) {
    	    if (typeof options.write === 'function') this._write = options.write;
    	    if (typeof options.writev === 'function') this._writev = options.writev;
    	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    	    if (typeof options.final === 'function') this._final = options.final;
    	  }
    	  Stream.call(this);
    	}

    	// Otherwise people can pipe Writable streams, which is just wrong.
    	Writable.prototype.pipe = function () {
    	  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
    	};
    	function writeAfterEnd(stream, cb) {
    	  var er = new ERR_STREAM_WRITE_AFTER_END();
    	  // TODO: defer error events consistently everywhere, not just the cb
    	  errorOrDestroy(stream, er);
    	  process.nextTick(cb, er);
    	}

    	// Checks that a user-supplied chunk is valid, especially for the particular
    	// mode the stream is in. Currently this means that `null` is never accepted
    	// and undefined/non-string values are only allowed in object mode.
    	function validChunk(stream, state, chunk, cb) {
    	  var er;
    	  if (chunk === null) {
    	    er = new ERR_STREAM_NULL_VALUES();
    	  } else if (typeof chunk !== 'string' && !state.objectMode) {
    	    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
    	  }
    	  if (er) {
    	    errorOrDestroy(stream, er);
    	    process.nextTick(cb, er);
    	    return false;
    	  }
    	  return true;
    	}
    	Writable.prototype.write = function (chunk, encoding, cb) {
    	  var state = this._writableState;
    	  var ret = false;
    	  var isBuf = !state.objectMode && _isUint8Array(chunk);
    	  if (isBuf && !Buffer.isBuffer(chunk)) {
    	    chunk = _uint8ArrayToBuffer(chunk);
    	  }
    	  if (typeof encoding === 'function') {
    	    cb = encoding;
    	    encoding = null;
    	  }
    	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
    	  if (typeof cb !== 'function') cb = nop;
    	  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    	    state.pendingcb++;
    	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    	  }
    	  return ret;
    	};
    	Writable.prototype.cork = function () {
    	  this._writableState.corked++;
    	};
    	Writable.prototype.uncork = function () {
    	  var state = this._writableState;
    	  if (state.corked) {
    	    state.corked--;
    	    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    	  }
    	};
    	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    	  // node::ParseEncoding() requires lower case.
    	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
    	  this._writableState.defaultEncoding = encoding;
    	  return this;
    	};
    	Object.defineProperty(Writable.prototype, 'writableBuffer', {
    	  // making it explicit this property is not enumerable
    	  // because otherwise some prototype manipulation in
    	  // userland will fail
    	  enumerable: false,
    	  get: function get() {
    	    return this._writableState && this._writableState.getBuffer();
    	  }
    	});
    	function decodeChunk(state, chunk, encoding) {
    	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    	    chunk = Buffer.from(chunk, encoding);
    	  }
    	  return chunk;
    	}
    	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
    	  // making it explicit this property is not enumerable
    	  // because otherwise some prototype manipulation in
    	  // userland will fail
    	  enumerable: false,
    	  get: function get() {
    	    return this._writableState.highWaterMark;
    	  }
    	});

    	// if we're already writing something, then just put this
    	// in the queue, and wait our turn.  Otherwise, call _write
    	// If we return false, then we need a drain event, so set that flag.
    	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    	  if (!isBuf) {
    	    var newChunk = decodeChunk(state, chunk, encoding);
    	    if (chunk !== newChunk) {
    	      isBuf = true;
    	      encoding = 'buffer';
    	      chunk = newChunk;
    	    }
    	  }
    	  var len = state.objectMode ? 1 : chunk.length;
    	  state.length += len;
    	  var ret = state.length < state.highWaterMark;
    	  // we must ensure that previous needDrain will not be reset to false.
    	  if (!ret) state.needDrain = true;
    	  if (state.writing || state.corked) {
    	    var last = state.lastBufferedRequest;
    	    state.lastBufferedRequest = {
    	      chunk,
    	      encoding,
    	      isBuf,
    	      callback: cb,
    	      next: null
    	    };
    	    if (last) {
    	      last.next = state.lastBufferedRequest;
    	    } else {
    	      state.bufferedRequest = state.lastBufferedRequest;
    	    }
    	    state.bufferedRequestCount += 1;
    	  } else {
    	    doWrite(stream, state, false, len, chunk, encoding, cb);
    	  }
    	  return ret;
    	}
    	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    	  state.writelen = len;
    	  state.writecb = cb;
    	  state.writing = true;
    	  state.sync = true;
    	  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
    	  state.sync = false;
    	}
    	function onwriteError(stream, state, sync, er, cb) {
    	  --state.pendingcb;
    	  if (sync) {
    	    // defer the callback if we are being called synchronously
    	    // to avoid piling up things on the stack
    	    process.nextTick(cb, er);
    	    // this can emit finish, and it will always happen
    	    // after error
    	    process.nextTick(finishMaybe, stream, state);
    	    stream._writableState.errorEmitted = true;
    	    errorOrDestroy(stream, er);
    	  } else {
    	    // the caller expect this to happen before if
    	    // it is async
    	    cb(er);
    	    stream._writableState.errorEmitted = true;
    	    errorOrDestroy(stream, er);
    	    // this can emit finish, but finish must
    	    // always follow error
    	    finishMaybe(stream, state);
    	  }
    	}
    	function onwriteStateUpdate(state) {
    	  state.writing = false;
    	  state.writecb = null;
    	  state.length -= state.writelen;
    	  state.writelen = 0;
    	}
    	function onwrite(stream, er) {
    	  var state = stream._writableState;
    	  var sync = state.sync;
    	  var cb = state.writecb;
    	  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
    	  onwriteStateUpdate(state);
    	  if (er) onwriteError(stream, state, sync, er, cb);else {
    	    // Check if we're actually ready to finish, but don't emit yet
    	    var finished = needFinish(state) || stream.destroyed;
    	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
    	      clearBuffer(stream, state);
    	    }
    	    if (sync) {
    	      process.nextTick(afterWrite, stream, state, finished, cb);
    	    } else {
    	      afterWrite(stream, state, finished, cb);
    	    }
    	  }
    	}
    	function afterWrite(stream, state, finished, cb) {
    	  if (!finished) onwriteDrain(stream, state);
    	  state.pendingcb--;
    	  cb();
    	  finishMaybe(stream, state);
    	}

    	// Must force callback to be called on nextTick, so that we don't
    	// emit 'drain' before the write() consumer gets the 'false' return
    	// value, and has a chance to attach a 'drain' listener.
    	function onwriteDrain(stream, state) {
    	  if (state.length === 0 && state.needDrain) {
    	    state.needDrain = false;
    	    stream.emit('drain');
    	  }
    	}

    	// if there's something in the buffer waiting, then process it
    	function clearBuffer(stream, state) {
    	  state.bufferProcessing = true;
    	  var entry = state.bufferedRequest;
    	  if (stream._writev && entry && entry.next) {
    	    // Fast case, write everything using _writev()
    	    var l = state.bufferedRequestCount;
    	    var buffer = new Array(l);
    	    var holder = state.corkedRequestsFree;
    	    holder.entry = entry;
    	    var count = 0;
    	    var allBuffers = true;
    	    while (entry) {
    	      buffer[count] = entry;
    	      if (!entry.isBuf) allBuffers = false;
    	      entry = entry.next;
    	      count += 1;
    	    }
    	    buffer.allBuffers = allBuffers;
    	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    	    // doWrite is almost always async, defer these to save a bit of time
    	    // as the hot path ends with doWrite
    	    state.pendingcb++;
    	    state.lastBufferedRequest = null;
    	    if (holder.next) {
    	      state.corkedRequestsFree = holder.next;
    	      holder.next = null;
    	    } else {
    	      state.corkedRequestsFree = new CorkedRequest(state);
    	    }
    	    state.bufferedRequestCount = 0;
    	  } else {
    	    // Slow case, write chunks one-by-one
    	    while (entry) {
    	      var chunk = entry.chunk;
    	      var encoding = entry.encoding;
    	      var cb = entry.callback;
    	      var len = state.objectMode ? 1 : chunk.length;
    	      doWrite(stream, state, false, len, chunk, encoding, cb);
    	      entry = entry.next;
    	      state.bufferedRequestCount--;
    	      // if we didn't call the onwrite immediately, then
    	      // it means that we need to wait until it does.
    	      // also, that means that the chunk and cb are currently
    	      // being processed, so move the buffer counter past them.
    	      if (state.writing) {
    	        break;
    	      }
    	    }
    	    if (entry === null) state.lastBufferedRequest = null;
    	  }
    	  state.bufferedRequest = entry;
    	  state.bufferProcessing = false;
    	}
    	Writable.prototype._write = function (chunk, encoding, cb) {
    	  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
    	};
    	Writable.prototype._writev = null;
    	Writable.prototype.end = function (chunk, encoding, cb) {
    	  var state = this._writableState;
    	  if (typeof chunk === 'function') {
    	    cb = chunk;
    	    chunk = null;
    	    encoding = null;
    	  } else if (typeof encoding === 'function') {
    	    cb = encoding;
    	    encoding = null;
    	  }
    	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

    	  // .end() fully uncorks
    	  if (state.corked) {
    	    state.corked = 1;
    	    this.uncork();
    	  }

    	  // ignore unnecessary end() calls.
    	  if (!state.ending) endWritable(this, state, cb);
    	  return this;
    	};
    	Object.defineProperty(Writable.prototype, 'writableLength', {
    	  // making it explicit this property is not enumerable
    	  // because otherwise some prototype manipulation in
    	  // userland will fail
    	  enumerable: false,
    	  get() {
    	    return this._writableState.length;
    	  }
    	});
    	function needFinish(state) {
    	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
    	}
    	function callFinal(stream, state) {
    	  stream._final(err => {
    	    state.pendingcb--;
    	    if (err) {
    	      errorOrDestroy(stream, err);
    	    }
    	    state.prefinished = true;
    	    stream.emit('prefinish');
    	    finishMaybe(stream, state);
    	  });
    	}
    	function prefinish(stream, state) {
    	  if (!state.prefinished && !state.finalCalled) {
    	    if (typeof stream._final === 'function' && !state.destroyed) {
    	      state.pendingcb++;
    	      state.finalCalled = true;
    	      process.nextTick(callFinal, stream, state);
    	    } else {
    	      state.prefinished = true;
    	      stream.emit('prefinish');
    	    }
    	  }
    	}
    	function finishMaybe(stream, state) {
    	  var need = needFinish(state);
    	  if (need) {
    	    prefinish(stream, state);
    	    if (state.pendingcb === 0) {
    	      state.finished = true;
    	      stream.emit('finish');
    	      if (state.autoDestroy) {
    	        // In case of duplex streams we need a way to detect
    	        // if the readable side is ready for autoDestroy as well
    	        const rState = stream._readableState;
    	        if (!rState || rState.autoDestroy && rState.endEmitted) {
    	          stream.destroy();
    	        }
    	      }
    	    }
    	  }
    	  return need;
    	}
    	function endWritable(stream, state, cb) {
    	  state.ending = true;
    	  finishMaybe(stream, state);
    	  if (cb) {
    	    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
    	  }
    	  state.ended = true;
    	  stream.writable = false;
    	}
    	function onCorkedFinish(corkReq, state, err) {
    	  var entry = corkReq.entry;
    	  corkReq.entry = null;
    	  while (entry) {
    	    var cb = entry.callback;
    	    state.pendingcb--;
    	    cb(err);
    	    entry = entry.next;
    	  }

    	  // reuse the free corkReq.
    	  state.corkedRequestsFree.next = corkReq;
    	}
    	Object.defineProperty(Writable.prototype, 'destroyed', {
    	  // making it explicit this property is not enumerable
    	  // because otherwise some prototype manipulation in
    	  // userland will fail
    	  enumerable: false,
    	  get() {
    	    if (this._writableState === undefined) {
    	      return false;
    	    }
    	    return this._writableState.destroyed;
    	  },
    	  set(value) {
    	    // we ignore the value if the stream
    	    // has not been initialized yet
    	    if (!this._writableState) {
    	      return;
    	    }

    	    // backward compatibility, the user is explicitly
    	    // managing destroyed
    	    this._writableState.destroyed = value;
    	  }
    	});
    	Writable.prototype.destroy = destroyImpl.destroy;
    	Writable.prototype._undestroy = destroyImpl.undestroy;
    	Writable.prototype._destroy = function (err, cb) {
    	  cb(err);
    	};
    	return _stream_writable;
    }

    var _stream_duplex;
    var hasRequired_stream_duplex;

    function require_stream_duplex () {
    	if (hasRequired_stream_duplex) return _stream_duplex;
    	hasRequired_stream_duplex = 1;

    	/*<replacement>*/
    	var objectKeys = Object.keys || function (obj) {
    	  var keys = [];
    	  for (var key in obj) keys.push(key);
    	  return keys;
    	};
    	/*</replacement>*/

    	_stream_duplex = Duplex;
    	const Readable = require_stream_readable();
    	const Writable = require_stream_writable();
    	require$$1$1(Duplex, Readable);
    	{
    	  // Allow the keys array to be GC'ed.
    	  const keys = objectKeys(Writable.prototype);
    	  for (var v = 0; v < keys.length; v++) {
    	    const method = keys[v];
    	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
    	  }
    	}
    	function Duplex(options) {
    	  if (!(this instanceof Duplex)) return new Duplex(options);
    	  Readable.call(this, options);
    	  Writable.call(this, options);
    	  this.allowHalfOpen = true;
    	  if (options) {
    	    if (options.readable === false) this.readable = false;
    	    if (options.writable === false) this.writable = false;
    	    if (options.allowHalfOpen === false) {
    	      this.allowHalfOpen = false;
    	      this.once('end', onend);
    	    }
    	  }
    	}
    	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
    	  // making it explicit this property is not enumerable
    	  // because otherwise some prototype manipulation in
    	  // userland will fail
    	  enumerable: false,
    	  get() {
    	    return this._writableState.highWaterMark;
    	  }
    	});
    	Object.defineProperty(Duplex.prototype, 'writableBuffer', {
    	  // making it explicit this property is not enumerable
    	  // because otherwise some prototype manipulation in
    	  // userland will fail
    	  enumerable: false,
    	  get: function get() {
    	    return this._writableState && this._writableState.getBuffer();
    	  }
    	});
    	Object.defineProperty(Duplex.prototype, 'writableLength', {
    	  // making it explicit this property is not enumerable
    	  // because otherwise some prototype manipulation in
    	  // userland will fail
    	  enumerable: false,
    	  get() {
    	    return this._writableState.length;
    	  }
    	});

    	// the no-half-open enforcer
    	function onend() {
    	  // If the writable side ended, then we're ok.
    	  if (this._writableState.ended) return;

    	  // no more data can be written.
    	  // But allow more writes to happen in this tick.
    	  process.nextTick(onEndNT, this);
    	}
    	function onEndNT(self) {
    	  self.end();
    	}
    	Object.defineProperty(Duplex.prototype, 'destroyed', {
    	  // making it explicit this property is not enumerable
    	  // because otherwise some prototype manipulation in
    	  // userland will fail
    	  enumerable: false,
    	  get() {
    	    if (this._readableState === undefined || this._writableState === undefined) {
    	      return false;
    	    }
    	    return this._readableState.destroyed && this._writableState.destroyed;
    	  },
    	  set(value) {
    	    // we ignore the value if the stream
    	    // has not been initialized yet
    	    if (this._readableState === undefined || this._writableState === undefined) {
    	      return;
    	    }

    	    // backward compatibility, the user is explicitly
    	    // managing destroyed
    	    this._readableState.destroyed = value;
    	    this._writableState.destroyed = value;
    	  }
    	});
    	return _stream_duplex;
    }

    // Copyright Joyent, Inc. and other Node contributors.
    var isBufferEncoding = Buffer$l.isEncoding
      || function(encoding) {
           switch (encoding && encoding.toLowerCase()) {
             case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
             default: return false;
           }
         };


    function assertEncoding(encoding) {
      if (encoding && !isBufferEncoding(encoding)) {
        throw new Error('Unknown encoding: ' + encoding);
      }
    }

    // StringDecoder provides an interface for efficiently splitting a series of
    // buffers into a series of JS strings without breaking apart multi-byte
    // characters. CESU-8 is handled as part of the UTF-8 encoding.
    //
    // @TODO Handling all encodings inside a single object makes it very difficult
    // to reason about this code, so it should be split up in the future.
    // @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
    // points as used by CESU-8.
    function StringDecoder$1(encoding) {
      this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
      assertEncoding(encoding);
      switch (this.encoding) {
        case 'utf8':
          // CESU-8 represents each of Surrogate Pair by 3-bytes
          this.surrogateSize = 3;
          break;
        case 'ucs2':
        case 'utf16le':
          // UTF-16 represents each of Surrogate Pair by 2-bytes
          this.surrogateSize = 2;
          this.detectIncompleteChar = utf16DetectIncompleteChar;
          break;
        case 'base64':
          // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
          this.surrogateSize = 3;
          this.detectIncompleteChar = base64DetectIncompleteChar;
          break;
        default:
          this.write = passThroughWrite;
          return;
      }

      // Enough space to store all bytes of a single character. UTF-8 needs 4
      // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
      this.charBuffer = new Buffer$l(6);
      // Number of bytes received for the current incomplete multi-byte character.
      this.charReceived = 0;
      // Number of bytes expected for the current incomplete multi-byte character.
      this.charLength = 0;
    }

    // write decodes the given buffer and returns it as JS string that is
    // guaranteed to not contain any partial multi-byte characters. Any partial
    // character found at the end of the buffer is buffered up, and will be
    // returned when calling write again with the remaining bytes.
    //
    // Note: Converting a Buffer containing an orphan surrogate to a String
    // currently works, but converting a String to a Buffer (via `new Buffer`, or
    // Buffer#write) will replace incomplete surrogates with the unicode
    // replacement character. See https://codereview.chromium.org/121173009/ .
    StringDecoder$1.prototype.write = function(buffer) {
      var charStr = '';
      // if our last write ended with an incomplete multibyte character
      while (this.charLength) {
        // determine how many remaining bytes this buffer has to offer for this char
        var available = (buffer.length >= this.charLength - this.charReceived) ?
            this.charLength - this.charReceived :
            buffer.length;

        // add the new bytes to the char buffer
        buffer.copy(this.charBuffer, this.charReceived, 0, available);
        this.charReceived += available;

        if (this.charReceived < this.charLength) {
          // still not enough chars in this buffer? wait for more ...
          return '';
        }

        // remove bytes belonging to the current character from the buffer
        buffer = buffer.slice(available, buffer.length);

        // get the character that was split
        charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);

        // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
        var charCode = charStr.charCodeAt(charStr.length - 1);
        if (charCode >= 0xD800 && charCode <= 0xDBFF) {
          this.charLength += this.surrogateSize;
          charStr = '';
          continue;
        }
        this.charReceived = this.charLength = 0;

        // if there are no more bytes in this buffer, just emit our char
        if (buffer.length === 0) {
          return charStr;
        }
        break;
      }

      // determine and set charLength / charReceived
      this.detectIncompleteChar(buffer);

      var end = buffer.length;
      if (this.charLength) {
        // buffer the incomplete character bytes we got
        buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
        end -= this.charReceived;
      }

      charStr += buffer.toString(this.encoding, 0, end);

      var end = charStr.length - 1;
      var charCode = charStr.charCodeAt(end);
      // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
      if (charCode >= 0xD800 && charCode <= 0xDBFF) {
        var size = this.surrogateSize;
        this.charLength += size;
        this.charReceived += size;
        this.charBuffer.copy(this.charBuffer, size, 0, size);
        buffer.copy(this.charBuffer, 0, 0, size);
        return charStr.substring(0, end);
      }

      // or just emit the charStr
      return charStr;
    };

    // detectIncompleteChar determines if there is an incomplete UTF-8 character at
    // the end of the given buffer. If so, it sets this.charLength to the byte
    // length that character, and sets this.charReceived to the number of bytes
    // that are available for this character.
    StringDecoder$1.prototype.detectIncompleteChar = function(buffer) {
      // determine how many bytes we have to check at the end of this buffer
      var i = (buffer.length >= 3) ? 3 : buffer.length;

      // Figure out if one of the last i bytes of our buffer announces an
      // incomplete char.
      for (; i > 0; i--) {
        var c = buffer[buffer.length - i];

        // See http://en.wikipedia.org/wiki/UTF-8#Description

        // 110XXXXX
        if (i == 1 && c >> 5 == 0x06) {
          this.charLength = 2;
          break;
        }

        // 1110XXXX
        if (i <= 2 && c >> 4 == 0x0E) {
          this.charLength = 3;
          break;
        }

        // 11110XXX
        if (i <= 3 && c >> 3 == 0x1E) {
          this.charLength = 4;
          break;
        }
      }
      this.charReceived = i;
    };

    StringDecoder$1.prototype.end = function(buffer) {
      var res = '';
      if (buffer && buffer.length)
        res = this.write(buffer);

      if (this.charReceived) {
        var cr = this.charReceived;
        var buf = this.charBuffer;
        var enc = this.encoding;
        res += buf.slice(0, cr).toString(enc);
      }

      return res;
    };

    function passThroughWrite(buffer) {
      return buffer.toString(this.encoding);
    }

    function utf16DetectIncompleteChar(buffer) {
      this.charReceived = buffer.length % 2;
      this.charLength = this.charReceived ? 2 : 0;
    }

    function base64DetectIncompleteChar(buffer) {
      this.charReceived = buffer.length % 3;
      this.charLength = this.charReceived ? 3 : 0;
    }

    var _polyfillNode_string_decoder = /*#__PURE__*/Object.freeze({
        __proto__: null,
        StringDecoder: StringDecoder$1
    });

    var require$$2$1 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_string_decoder);

    const ERR_STREAM_PREMATURE_CLOSE = errorsBrowser.codes.ERR_STREAM_PREMATURE_CLOSE;
    function once$1(callback) {
      let called = false;
      return function () {
        if (called) return;
        called = true;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        callback.apply(this, args);
      };
    }
    function noop$1() {}
    function isRequest$1(stream) {
      return stream.setHeader && typeof stream.abort === 'function';
    }
    function eos$1(stream, opts, callback) {
      if (typeof opts === 'function') return eos$1(stream, null, opts);
      if (!opts) opts = {};
      callback = once$1(callback || noop$1);
      let readable = opts.readable || opts.readable !== false && stream.readable;
      let writable = opts.writable || opts.writable !== false && stream.writable;
      const onlegacyfinish = () => {
        if (!stream.writable) onfinish();
      };
      var writableEnded = stream._writableState && stream._writableState.finished;
      const onfinish = () => {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
      };
      var readableEnded = stream._readableState && stream._readableState.endEmitted;
      const onend = () => {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
      };
      const onerror = err => {
        callback.call(stream, err);
      };
      const onclose = () => {
        let err;
        if (readable && !readableEnded) {
          if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
          return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
          if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
          return callback.call(stream, err);
        }
      };
      const onrequest = () => {
        stream.req.on('finish', onfinish);
      };
      if (isRequest$1(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();else stream.on('request', onrequest);
      } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
      }
      stream.on('end', onend);
      stream.on('finish', onfinish);
      if (opts.error !== false) stream.on('error', onerror);
      stream.on('close', onclose);
      return function () {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
      };
    }
    var endOfStream = eos$1;

    var async_iterator;
    var hasRequiredAsync_iterator;

    function requireAsync_iterator () {
    	if (hasRequiredAsync_iterator) return async_iterator;
    	hasRequiredAsync_iterator = 1;

    	const finished = endOfStream;
    	const kLastResolve = Symbol('lastResolve');
    	const kLastReject = Symbol('lastReject');
    	const kError = Symbol('error');
    	const kEnded = Symbol('ended');
    	const kLastPromise = Symbol('lastPromise');
    	const kHandlePromise = Symbol('handlePromise');
    	const kStream = Symbol('stream');
    	function createIterResult(value, done) {
    	  return {
    	    value,
    	    done
    	  };
    	}
    	function readAndResolve(iter) {
    	  const resolve = iter[kLastResolve];
    	  if (resolve !== null) {
    	    const data = iter[kStream].read();
    	    // we defer if data is null
    	    // we can be expecting either 'end' or
    	    // 'error'
    	    if (data !== null) {
    	      iter[kLastPromise] = null;
    	      iter[kLastResolve] = null;
    	      iter[kLastReject] = null;
    	      resolve(createIterResult(data, false));
    	    }
    	  }
    	}
    	function onReadable(iter) {
    	  // we wait for the next tick, because it might
    	  // emit an error with process.nextTick
    	  process.nextTick(readAndResolve, iter);
    	}
    	function wrapForNext(lastPromise, iter) {
    	  return (resolve, reject) => {
    	    lastPromise.then(() => {
    	      if (iter[kEnded]) {
    	        resolve(createIterResult(undefined, true));
    	        return;
    	      }
    	      iter[kHandlePromise](resolve, reject);
    	    }, reject);
    	  };
    	}
    	const AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
    	const ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf({
    	  get stream() {
    	    return this[kStream];
    	  },
    	  next() {
    	    // if we have detected an error in the meanwhile
    	    // reject straight away
    	    const error = this[kError];
    	    if (error !== null) {
    	      return Promise.reject(error);
    	    }
    	    if (this[kEnded]) {
    	      return Promise.resolve(createIterResult(undefined, true));
    	    }
    	    if (this[kStream].destroyed) {
    	      // We need to defer via nextTick because if .destroy(err) is
    	      // called, the error will be emitted via nextTick, and
    	      // we cannot guarantee that there is no error lingering around
    	      // waiting to be emitted.
    	      return new Promise((resolve, reject) => {
    	        process.nextTick(() => {
    	          if (this[kError]) {
    	            reject(this[kError]);
    	          } else {
    	            resolve(createIterResult(undefined, true));
    	          }
    	        });
    	      });
    	    }

    	    // if we have multiple next() calls
    	    // we will wait for the previous Promise to finish
    	    // this logic is optimized to support for await loops,
    	    // where next() is only called once at a time
    	    const lastPromise = this[kLastPromise];
    	    let promise;
    	    if (lastPromise) {
    	      promise = new Promise(wrapForNext(lastPromise, this));
    	    } else {
    	      // fast path needed to support multiple this.push()
    	      // without triggering the next() queue
    	      const data = this[kStream].read();
    	      if (data !== null) {
    	        return Promise.resolve(createIterResult(data, false));
    	      }
    	      promise = new Promise(this[kHandlePromise]);
    	    }
    	    this[kLastPromise] = promise;
    	    return promise;
    	  },
    	  [Symbol.asyncIterator]() {
    	    return this;
    	  },
    	  return() {
    	    // destroy(err, cb) is a private API
    	    // we can guarantee we have that here, because we control the
    	    // Readable class this is attached to
    	    return new Promise((resolve, reject) => {
    	      this[kStream].destroy(null, err => {
    	        if (err) {
    	          reject(err);
    	          return;
    	        }
    	        resolve(createIterResult(undefined, true));
    	      });
    	    });
    	  }
    	}, AsyncIteratorPrototype);
    	const createReadableStreamAsyncIterator = stream => {
    	  const iterator = Object.create(ReadableStreamAsyncIteratorPrototype, {
    	    [kStream]: {
    	      value: stream,
    	      writable: true
    	    },
    	    [kLastResolve]: {
    	      value: null,
    	      writable: true
    	    },
    	    [kLastReject]: {
    	      value: null,
    	      writable: true
    	    },
    	    [kError]: {
    	      value: null,
    	      writable: true
    	    },
    	    [kEnded]: {
    	      value: stream._readableState.endEmitted,
    	      writable: true
    	    },
    	    // the function passed to new Promise
    	    // is cached so we avoid allocating a new
    	    // closure at every run
    	    [kHandlePromise]: {
    	      value: (resolve, reject) => {
    	        const data = iterator[kStream].read();
    	        if (data) {
    	          iterator[kLastPromise] = null;
    	          iterator[kLastResolve] = null;
    	          iterator[kLastReject] = null;
    	          resolve(createIterResult(data, false));
    	        } else {
    	          iterator[kLastResolve] = resolve;
    	          iterator[kLastReject] = reject;
    	        }
    	      },
    	      writable: true
    	    }
    	  });
    	  iterator[kLastPromise] = null;
    	  finished(stream, err => {
    	    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
    	      const reject = iterator[kLastReject];
    	      // reject if we are waiting for data in the Promise
    	      // returned by next() and store the error
    	      if (reject !== null) {
    	        iterator[kLastPromise] = null;
    	        iterator[kLastResolve] = null;
    	        iterator[kLastReject] = null;
    	        reject(err);
    	      }
    	      iterator[kError] = err;
    	      return;
    	    }
    	    const resolve = iterator[kLastResolve];
    	    if (resolve !== null) {
    	      iterator[kLastPromise] = null;
    	      iterator[kLastResolve] = null;
    	      iterator[kLastReject] = null;
    	      resolve(createIterResult(undefined, true));
    	    }
    	    iterator[kEnded] = true;
    	  });
    	  stream.on('readable', onReadable.bind(null, iterator));
    	  return iterator;
    	};
    	async_iterator = createReadableStreamAsyncIterator;
    	return async_iterator;
    }

    var fromBrowser;
    var hasRequiredFromBrowser;

    function requireFromBrowser () {
    	if (hasRequiredFromBrowser) return fromBrowser;
    	hasRequiredFromBrowser = 1;
    	fromBrowser = function () {
    	  throw new Error('Readable.from is not available in the browser')
    	};
    	return fromBrowser;
    }

    var _stream_readable;
    var hasRequired_stream_readable;

    function require_stream_readable () {
    	if (hasRequired_stream_readable) return _stream_readable;
    	hasRequired_stream_readable = 1;

    	_stream_readable = Readable;

    	/*<replacement>*/
    	var Duplex;
    	/*</replacement>*/

    	Readable.ReadableState = ReadableState;

    	/*<replacement>*/
    	require$$0$2.EventEmitter;
    	var EElistenerCount = function EElistenerCount(emitter, type) {
    	  return emitter.listeners(type).length;
    	};
    	/*</replacement>*/

    	/*<replacement>*/
    	var Stream = streamBrowser;
    	/*</replacement>*/

    	const Buffer = require$$0$3.Buffer;
    	const OurUint8Array = (typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
    	function _uint8ArrayToBuffer(chunk) {
    	  return Buffer.from(chunk);
    	}
    	function _isUint8Array(obj) {
    	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
    	}

    	/*<replacement>*/
    	const debugUtil = require$$3;
    	let debug;
    	if (debugUtil && debugUtil.debuglog) {
    	  debug = debugUtil.debuglog('stream');
    	} else {
    	  debug = function debug() {};
    	}
    	/*</replacement>*/

    	const BufferList = requireBuffer_list();
    	const destroyImpl = destroy_1;
    	const _require = state,
    	  getHighWaterMark = _require.getHighWaterMark;
    	const _require$codes = errorsBrowser.codes,
    	  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    	  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
    	  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    	  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

    	// Lazy loaded to improve the startup performance.
    	let StringDecoder;
    	let createReadableStreamAsyncIterator;
    	let from;
    	require$$1$1(Readable, Stream);
    	const errorOrDestroy = destroyImpl.errorOrDestroy;
    	const kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
    	function prependListener(emitter, event, fn) {
    	  // Sadly this is not cacheable as some libraries bundle their own
    	  // event emitter implementation with them.
    	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

    	  // This is a hack to make sure that our error handler is attached before any
    	  // userland ones.  NEVER DO THIS. This is here only because this code needs
    	  // to continue to work with older versions of Node.js that do not include
    	  // the prependListener() method. The goal is to eventually remove this hack.
    	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
    	}
    	function ReadableState(options, stream, isDuplex) {
    	  Duplex = Duplex || require_stream_duplex();
    	  options = options || {};

    	  // Duplex streams are both readable and writable, but share
    	  // the same options object.
    	  // However, some cases require setting options to different
    	  // values for the readable and the writable sides of the duplex stream.
    	  // These options can be provided separately as readableXXX and writableXXX.
    	  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

    	  // object stream flag. Used to make read(n) ignore n and to
    	  // make all the buffer merging and length checks go away
    	  this.objectMode = !!options.objectMode;
    	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

    	  // the point at which it stops calling _read() to fill the buffer
    	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
    	  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

    	  // A linked list is used to store data chunks instead of an array because the
    	  // linked list can remove elements from the beginning faster than
    	  // array.shift()
    	  this.buffer = new BufferList();
    	  this.length = 0;
    	  this.pipes = null;
    	  this.pipesCount = 0;
    	  this.flowing = null;
    	  this.ended = false;
    	  this.endEmitted = false;
    	  this.reading = false;

    	  // a flag to be able to tell if the event 'readable'/'data' is emitted
    	  // immediately, or on a later tick.  We set this to true at first, because
    	  // any actions that shouldn't happen until "later" should generally also
    	  // not happen before the first read call.
    	  this.sync = true;

    	  // whenever we return null, then we set a flag to say
    	  // that we're awaiting a 'readable' event emission.
    	  this.needReadable = false;
    	  this.emittedReadable = false;
    	  this.readableListening = false;
    	  this.resumeScheduled = false;
    	  this.paused = true;

    	  // Should close be emitted on destroy. Defaults to true.
    	  this.emitClose = options.emitClose !== false;

    	  // Should .destroy() be called after 'end' (and potentially 'finish')
    	  this.autoDestroy = !!options.autoDestroy;

    	  // has it been destroyed
    	  this.destroyed = false;

    	  // Crypto is kind of old and crusty.  Historically, its default string
    	  // encoding is 'binary' so we have to make this configurable.
    	  // Everything else in the universe uses 'utf8', though.
    	  this.defaultEncoding = options.defaultEncoding || 'utf8';

    	  // the number of writers that are awaiting a drain event in .pipe()s
    	  this.awaitDrain = 0;

    	  // if true, a maybeReadMore has been scheduled
    	  this.readingMore = false;
    	  this.decoder = null;
    	  this.encoding = null;
    	  if (options.encoding) {
    	    if (!StringDecoder) StringDecoder = require$$2$1.StringDecoder;
    	    this.decoder = new StringDecoder(options.encoding);
    	    this.encoding = options.encoding;
    	  }
    	}
    	function Readable(options) {
    	  Duplex = Duplex || require_stream_duplex();
    	  if (!(this instanceof Readable)) return new Readable(options);

    	  // Checking for a Stream.Duplex instance is faster here instead of inside
    	  // the ReadableState constructor, at least with V8 6.5
    	  const isDuplex = this instanceof Duplex;
    	  this._readableState = new ReadableState(options, this, isDuplex);

    	  // legacy
    	  this.readable = true;
    	  if (options) {
    	    if (typeof options.read === 'function') this._read = options.read;
    	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    	  }
    	  Stream.call(this);
    	}
    	Object.defineProperty(Readable.prototype, 'destroyed', {
    	  // making it explicit this property is not enumerable
    	  // because otherwise some prototype manipulation in
    	  // userland will fail
    	  enumerable: false,
    	  get() {
    	    if (this._readableState === undefined) {
    	      return false;
    	    }
    	    return this._readableState.destroyed;
    	  },
    	  set(value) {
    	    // we ignore the value if the stream
    	    // has not been initialized yet
    	    if (!this._readableState) {
    	      return;
    	    }

    	    // backward compatibility, the user is explicitly
    	    // managing destroyed
    	    this._readableState.destroyed = value;
    	  }
    	});
    	Readable.prototype.destroy = destroyImpl.destroy;
    	Readable.prototype._undestroy = destroyImpl.undestroy;
    	Readable.prototype._destroy = function (err, cb) {
    	  cb(err);
    	};

    	// Manually shove something into the read() buffer.
    	// This returns true if the highWaterMark has not been hit yet,
    	// similar to how Writable.write() returns true if you should
    	// write() some more.
    	Readable.prototype.push = function (chunk, encoding) {
    	  var state = this._readableState;
    	  var skipChunkCheck;
    	  if (!state.objectMode) {
    	    if (typeof chunk === 'string') {
    	      encoding = encoding || state.defaultEncoding;
    	      if (encoding !== state.encoding) {
    	        chunk = Buffer.from(chunk, encoding);
    	        encoding = '';
    	      }
    	      skipChunkCheck = true;
    	    }
    	  } else {
    	    skipChunkCheck = true;
    	  }
    	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
    	};

    	// Unshift should *always* be something directly out of read()
    	Readable.prototype.unshift = function (chunk) {
    	  return readableAddChunk(this, chunk, null, true, false);
    	};
    	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    	  debug('readableAddChunk', chunk);
    	  var state = stream._readableState;
    	  if (chunk === null) {
    	    state.reading = false;
    	    onEofChunk(stream, state);
    	  } else {
    	    var er;
    	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    	    if (er) {
    	      errorOrDestroy(stream, er);
    	    } else if (state.objectMode || chunk && chunk.length > 0) {
    	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
    	        chunk = _uint8ArrayToBuffer(chunk);
    	      }
    	      if (addToFront) {
    	        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
    	      } else if (state.ended) {
    	        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
    	      } else if (state.destroyed) {
    	        return false;
    	      } else {
    	        state.reading = false;
    	        if (state.decoder && !encoding) {
    	          chunk = state.decoder.write(chunk);
    	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
    	        } else {
    	          addChunk(stream, state, chunk, false);
    	        }
    	      }
    	    } else if (!addToFront) {
    	      state.reading = false;
    	      maybeReadMore(stream, state);
    	    }
    	  }

    	  // We can push more data if we are below the highWaterMark.
    	  // Also, if we have no data yet, we can stand some more bytes.
    	  // This is to work around cases where hwm=0, such as the repl.
    	  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
    	}
    	function addChunk(stream, state, chunk, addToFront) {
    	  if (state.flowing && state.length === 0 && !state.sync) {
    	    state.awaitDrain = 0;
    	    stream.emit('data', chunk);
    	  } else {
    	    // update the buffer info.
    	    state.length += state.objectMode ? 1 : chunk.length;
    	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    	    if (state.needReadable) emitReadable(stream);
    	  }
    	  maybeReadMore(stream, state);
    	}
    	function chunkInvalid(state, chunk) {
    	  var er;
    	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    	    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
    	  }
    	  return er;
    	}
    	Readable.prototype.isPaused = function () {
    	  return this._readableState.flowing === false;
    	};

    	// backwards compatibility.
    	Readable.prototype.setEncoding = function (enc) {
    	  if (!StringDecoder) StringDecoder = require$$2$1.StringDecoder;
    	  const decoder = new StringDecoder(enc);
    	  this._readableState.decoder = decoder;
    	  // If setEncoding(null), decoder.encoding equals utf8
    	  this._readableState.encoding = this._readableState.decoder.encoding;

    	  // Iterate over current buffer to convert already stored Buffers:
    	  let p = this._readableState.buffer.head;
    	  let content = '';
    	  while (p !== null) {
    	    content += decoder.write(p.data);
    	    p = p.next;
    	  }
    	  this._readableState.buffer.clear();
    	  if (content !== '') this._readableState.buffer.push(content);
    	  this._readableState.length = content.length;
    	  return this;
    	};

    	// Don't raise the hwm > 1GB
    	const MAX_HWM = 0x40000000;
    	function computeNewHighWaterMark(n) {
    	  if (n >= MAX_HWM) {
    	    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    	    n = MAX_HWM;
    	  } else {
    	    // Get the next highest power of 2 to prevent increasing hwm excessively in
    	    // tiny amounts
    	    n--;
    	    n |= n >>> 1;
    	    n |= n >>> 2;
    	    n |= n >>> 4;
    	    n |= n >>> 8;
    	    n |= n >>> 16;
    	    n++;
    	  }
    	  return n;
    	}

    	// This function is designed to be inlinable, so please take care when making
    	// changes to the function body.
    	function howMuchToRead(n, state) {
    	  if (n <= 0 || state.length === 0 && state.ended) return 0;
    	  if (state.objectMode) return 1;
    	  if (n !== n) {
    	    // Only flow one buffer at a time
    	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
    	  }
    	  // If we're asking for more than the current hwm, then raise the hwm.
    	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    	  if (n <= state.length) return n;
    	  // Don't have enough
    	  if (!state.ended) {
    	    state.needReadable = true;
    	    return 0;
    	  }
    	  return state.length;
    	}

    	// you can override either this method, or the async _read(n) below.
    	Readable.prototype.read = function (n) {
    	  debug('read', n);
    	  n = parseInt(n, 10);
    	  var state = this._readableState;
    	  var nOrig = n;
    	  if (n !== 0) state.emittedReadable = false;

    	  // if we're doing read(0) to trigger a readable event, but we
    	  // already have a bunch of data in the buffer, then just trigger
    	  // the 'readable' event and move on.
    	  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    	    debug('read: emitReadable', state.length, state.ended);
    	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    	    return null;
    	  }
    	  n = howMuchToRead(n, state);

    	  // if we've ended, and we're now clear, then finish it up.
    	  if (n === 0 && state.ended) {
    	    if (state.length === 0) endReadable(this);
    	    return null;
    	  }

    	  // All the actual chunk generation logic needs to be
    	  // *below* the call to _read.  The reason is that in certain
    	  // synthetic stream cases, such as passthrough streams, _read
    	  // may be a completely synchronous operation which may change
    	  // the state of the read buffer, providing enough data when
    	  // before there was *not* enough.
    	  //
    	  // So, the steps are:
    	  // 1. Figure out what the state of things will be after we do
    	  // a read from the buffer.
    	  //
    	  // 2. If that resulting state will trigger a _read, then call _read.
    	  // Note that this may be asynchronous, or synchronous.  Yes, it is
    	  // deeply ugly to write APIs this way, but that still doesn't mean
    	  // that the Readable class should behave improperly, as streams are
    	  // designed to be sync/async agnostic.
    	  // Take note if the _read call is sync or async (ie, if the read call
    	  // has returned yet), so that we know whether or not it's safe to emit
    	  // 'readable' etc.
    	  //
    	  // 3. Actually pull the requested chunks out of the buffer and return.

    	  // if we need a readable event, then we need to do some reading.
    	  var doRead = state.needReadable;
    	  debug('need readable', doRead);

    	  // if we currently have less than the highWaterMark, then also read some
    	  if (state.length === 0 || state.length - n < state.highWaterMark) {
    	    doRead = true;
    	    debug('length less than watermark', doRead);
    	  }

    	  // however, if we've ended, then there's no point, and if we're already
    	  // reading, then it's unnecessary.
    	  if (state.ended || state.reading) {
    	    doRead = false;
    	    debug('reading or ended', doRead);
    	  } else if (doRead) {
    	    debug('do read');
    	    state.reading = true;
    	    state.sync = true;
    	    // if the length is currently zero, then we *need* a readable event.
    	    if (state.length === 0) state.needReadable = true;
    	    // call internal read method
    	    this._read(state.highWaterMark);
    	    state.sync = false;
    	    // If _read pushed data synchronously, then `reading` will be false,
    	    // and we need to re-evaluate how much data we can return to the user.
    	    if (!state.reading) n = howMuchToRead(nOrig, state);
    	  }
    	  var ret;
    	  if (n > 0) ret = fromList(n, state);else ret = null;
    	  if (ret === null) {
    	    state.needReadable = state.length <= state.highWaterMark;
    	    n = 0;
    	  } else {
    	    state.length -= n;
    	    state.awaitDrain = 0;
    	  }
    	  if (state.length === 0) {
    	    // If we have nothing in the buffer, then we want to know
    	    // as soon as we *do* get something into the buffer.
    	    if (!state.ended) state.needReadable = true;

    	    // If we tried to read() past the EOF, then emit end on the next tick.
    	    if (nOrig !== n && state.ended) endReadable(this);
    	  }
    	  if (ret !== null) this.emit('data', ret);
    	  return ret;
    	};
    	function onEofChunk(stream, state) {
    	  debug('onEofChunk');
    	  if (state.ended) return;
    	  if (state.decoder) {
    	    var chunk = state.decoder.end();
    	    if (chunk && chunk.length) {
    	      state.buffer.push(chunk);
    	      state.length += state.objectMode ? 1 : chunk.length;
    	    }
    	  }
    	  state.ended = true;
    	  if (state.sync) {
    	    // if we are sync, wait until next tick to emit the data.
    	    // Otherwise we risk emitting data in the flow()
    	    // the readable code triggers during a read() call
    	    emitReadable(stream);
    	  } else {
    	    // emit 'readable' now to make sure it gets picked up.
    	    state.needReadable = false;
    	    if (!state.emittedReadable) {
    	      state.emittedReadable = true;
    	      emitReadable_(stream);
    	    }
    	  }
    	}

    	// Don't emit readable right away in sync mode, because this can trigger
    	// another read() call => stack overflow.  This way, it might trigger
    	// a nextTick recursion warning, but that's not so bad.
    	function emitReadable(stream) {
    	  var state = stream._readableState;
    	  debug('emitReadable', state.needReadable, state.emittedReadable);
    	  state.needReadable = false;
    	  if (!state.emittedReadable) {
    	    debug('emitReadable', state.flowing);
    	    state.emittedReadable = true;
    	    process.nextTick(emitReadable_, stream);
    	  }
    	}
    	function emitReadable_(stream) {
    	  var state = stream._readableState;
    	  debug('emitReadable_', state.destroyed, state.length, state.ended);
    	  if (!state.destroyed && (state.length || state.ended)) {
    	    stream.emit('readable');
    	    state.emittedReadable = false;
    	  }

    	  // The stream needs another readable event if
    	  // 1. It is not flowing, as the flow mechanism will take
    	  //    care of it.
    	  // 2. It is not ended.
    	  // 3. It is below the highWaterMark, so we can schedule
    	  //    another readable later.
    	  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    	  flow(stream);
    	}

    	// at this point, the user has presumably seen the 'readable' event,
    	// and called read() to consume some data.  that may have triggered
    	// in turn another _read(n) call, in which case reading = true if
    	// it's in progress.
    	// However, if we're not ended, or reading, and the length < hwm,
    	// then go ahead and try to read some more preemptively.
    	function maybeReadMore(stream, state) {
    	  if (!state.readingMore) {
    	    state.readingMore = true;
    	    process.nextTick(maybeReadMore_, stream, state);
    	  }
    	}
    	function maybeReadMore_(stream, state) {
    	  // Attempt to read more data if we should.
    	  //
    	  // The conditions for reading more data are (one of):
    	  // - Not enough data buffered (state.length < state.highWaterMark). The loop
    	  //   is responsible for filling the buffer with enough data if such data
    	  //   is available. If highWaterMark is 0 and we are not in the flowing mode
    	  //   we should _not_ attempt to buffer any extra data. We'll get more data
    	  //   when the stream consumer calls read() instead.
    	  // - No data in the buffer, and the stream is in flowing mode. In this mode
    	  //   the loop below is responsible for ensuring read() is called. Failing to
    	  //   call read here would abort the flow and there's no other mechanism for
    	  //   continuing the flow if the stream consumer has just subscribed to the
    	  //   'data' event.
    	  //
    	  // In addition to the above conditions to keep reading data, the following
    	  // conditions prevent the data from being read:
    	  // - The stream has ended (state.ended).
    	  // - There is already a pending 'read' operation (state.reading). This is a
    	  //   case where the the stream has called the implementation defined _read()
    	  //   method, but they are processing the call asynchronously and have _not_
    	  //   called push() with new data. In this case we skip performing more
    	  //   read()s. The execution ends in this method again after the _read() ends
    	  //   up calling push() with more data.
    	  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    	    const len = state.length;
    	    debug('maybeReadMore read 0');
    	    stream.read(0);
    	    if (len === state.length)
    	      // didn't get any data, stop spinning.
    	      break;
    	  }
    	  state.readingMore = false;
    	}

    	// abstract method.  to be overridden in specific implementation classes.
    	// call cb(er, data) where data is <= n in length.
    	// for virtual (non-string, non-buffer) streams, "length" is somewhat
    	// arbitrary, and perhaps not very meaningful.
    	Readable.prototype._read = function (n) {
    	  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
    	};
    	Readable.prototype.pipe = function (dest, pipeOpts) {
    	  var src = this;
    	  var state = this._readableState;
    	  switch (state.pipesCount) {
    	    case 0:
    	      state.pipes = dest;
    	      break;
    	    case 1:
    	      state.pipes = [state.pipes, dest];
    	      break;
    	    default:
    	      state.pipes.push(dest);
    	      break;
    	  }
    	  state.pipesCount += 1;
    	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
    	  var endFn = doEnd ? onend : unpipe;
    	  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
    	  dest.on('unpipe', onunpipe);
    	  function onunpipe(readable, unpipeInfo) {
    	    debug('onunpipe');
    	    if (readable === src) {
    	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
    	        unpipeInfo.hasUnpiped = true;
    	        cleanup();
    	      }
    	    }
    	  }
    	  function onend() {
    	    debug('onend');
    	    dest.end();
    	  }

    	  // when the dest drains, it reduces the awaitDrain counter
    	  // on the source.  This would be more elegant with a .once()
    	  // handler in flow(), but adding and removing repeatedly is
    	  // too slow.
    	  var ondrain = pipeOnDrain(src);
    	  dest.on('drain', ondrain);
    	  var cleanedUp = false;
    	  function cleanup() {
    	    debug('cleanup');
    	    // cleanup event handlers once the pipe is broken
    	    dest.removeListener('close', onclose);
    	    dest.removeListener('finish', onfinish);
    	    dest.removeListener('drain', ondrain);
    	    dest.removeListener('error', onerror);
    	    dest.removeListener('unpipe', onunpipe);
    	    src.removeListener('end', onend);
    	    src.removeListener('end', unpipe);
    	    src.removeListener('data', ondata);
    	    cleanedUp = true;

    	    // if the reader is waiting for a drain event from this
    	    // specific writer, then it would cause it to never start
    	    // flowing again.
    	    // So, if this is awaiting a drain, then we just call it now.
    	    // If we don't know, then assume that we are waiting for one.
    	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    	  }
    	  src.on('data', ondata);
    	  function ondata(chunk) {
    	    debug('ondata');
    	    var ret = dest.write(chunk);
    	    debug('dest.write', ret);
    	    if (ret === false) {
    	      // If the user unpiped during `dest.write()`, it is possible
    	      // to get stuck in a permanently paused state if that write
    	      // also returned false.
    	      // => Check whether `dest` is still a piping destination.
    	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
    	        debug('false write response, pause', state.awaitDrain);
    	        state.awaitDrain++;
    	      }
    	      src.pause();
    	    }
    	  }

    	  // if the dest has an error, then stop piping into it.
    	  // however, don't suppress the throwing behavior for this.
    	  function onerror(er) {
    	    debug('onerror', er);
    	    unpipe();
    	    dest.removeListener('error', onerror);
    	    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
    	  }

    	  // Make sure our error handler is attached before userland ones.
    	  prependListener(dest, 'error', onerror);

    	  // Both close and finish should trigger unpipe, but only once.
    	  function onclose() {
    	    dest.removeListener('finish', onfinish);
    	    unpipe();
    	  }
    	  dest.once('close', onclose);
    	  function onfinish() {
    	    debug('onfinish');
    	    dest.removeListener('close', onclose);
    	    unpipe();
    	  }
    	  dest.once('finish', onfinish);
    	  function unpipe() {
    	    debug('unpipe');
    	    src.unpipe(dest);
    	  }

    	  // tell the dest that it's being piped to
    	  dest.emit('pipe', src);

    	  // start the flow if it hasn't been started already.
    	  if (!state.flowing) {
    	    debug('pipe resume');
    	    src.resume();
    	  }
    	  return dest;
    	};
    	function pipeOnDrain(src) {
    	  return function pipeOnDrainFunctionResult() {
    	    var state = src._readableState;
    	    debug('pipeOnDrain', state.awaitDrain);
    	    if (state.awaitDrain) state.awaitDrain--;
    	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
    	      state.flowing = true;
    	      flow(src);
    	    }
    	  };
    	}
    	Readable.prototype.unpipe = function (dest) {
    	  var state = this._readableState;
    	  var unpipeInfo = {
    	    hasUnpiped: false
    	  };

    	  // if we're not piping anywhere, then do nothing.
    	  if (state.pipesCount === 0) return this;

    	  // just one destination.  most common case.
    	  if (state.pipesCount === 1) {
    	    // passed in one, but it's not the right one.
    	    if (dest && dest !== state.pipes) return this;
    	    if (!dest) dest = state.pipes;

    	    // got a match.
    	    state.pipes = null;
    	    state.pipesCount = 0;
    	    state.flowing = false;
    	    if (dest) dest.emit('unpipe', this, unpipeInfo);
    	    return this;
    	  }

    	  // slow case. multiple pipe destinations.

    	  if (!dest) {
    	    // remove all.
    	    var dests = state.pipes;
    	    var len = state.pipesCount;
    	    state.pipes = null;
    	    state.pipesCount = 0;
    	    state.flowing = false;
    	    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
    	      hasUnpiped: false
    	    });
    	    return this;
    	  }

    	  // try to find the right one.
    	  var index = indexOf(state.pipes, dest);
    	  if (index === -1) return this;
    	  state.pipes.splice(index, 1);
    	  state.pipesCount -= 1;
    	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
    	  dest.emit('unpipe', this, unpipeInfo);
    	  return this;
    	};

    	// set up data events if they are asked for
    	// Ensure readable listeners eventually get something
    	Readable.prototype.on = function (ev, fn) {
    	  const res = Stream.prototype.on.call(this, ev, fn);
    	  const state = this._readableState;
    	  if (ev === 'data') {
    	    // update readableListening so that resume() may be a no-op
    	    // a few lines down. This is needed to support once('readable').
    	    state.readableListening = this.listenerCount('readable') > 0;

    	    // Try start flowing on next tick if stream isn't explicitly paused
    	    if (state.flowing !== false) this.resume();
    	  } else if (ev === 'readable') {
    	    if (!state.endEmitted && !state.readableListening) {
    	      state.readableListening = state.needReadable = true;
    	      state.flowing = false;
    	      state.emittedReadable = false;
    	      debug('on readable', state.length, state.reading);
    	      if (state.length) {
    	        emitReadable(this);
    	      } else if (!state.reading) {
    	        process.nextTick(nReadingNextTick, this);
    	      }
    	    }
    	  }
    	  return res;
    	};
    	Readable.prototype.addListener = Readable.prototype.on;
    	Readable.prototype.removeListener = function (ev, fn) {
    	  const res = Stream.prototype.removeListener.call(this, ev, fn);
    	  if (ev === 'readable') {
    	    // We need to check if there is someone still listening to
    	    // readable and reset the state. However this needs to happen
    	    // after readable has been emitted but before I/O (nextTick) to
    	    // support once('readable', fn) cycles. This means that calling
    	    // resume within the same tick will have no
    	    // effect.
    	    process.nextTick(updateReadableListening, this);
    	  }
    	  return res;
    	};
    	Readable.prototype.removeAllListeners = function (ev) {
    	  const res = Stream.prototype.removeAllListeners.apply(this, arguments);
    	  if (ev === 'readable' || ev === undefined) {
    	    // We need to check if there is someone still listening to
    	    // readable and reset the state. However this needs to happen
    	    // after readable has been emitted but before I/O (nextTick) to
    	    // support once('readable', fn) cycles. This means that calling
    	    // resume within the same tick will have no
    	    // effect.
    	    process.nextTick(updateReadableListening, this);
    	  }
    	  return res;
    	};
    	function updateReadableListening(self) {
    	  const state = self._readableState;
    	  state.readableListening = self.listenerCount('readable') > 0;
    	  if (state.resumeScheduled && !state.paused) {
    	    // flowing needs to be set to true now, otherwise
    	    // the upcoming resume will not flow.
    	    state.flowing = true;

    	    // crude way to check if we should resume
    	  } else if (self.listenerCount('data') > 0) {
    	    self.resume();
    	  }
    	}
    	function nReadingNextTick(self) {
    	  debug('readable nexttick read 0');
    	  self.read(0);
    	}

    	// pause() and resume() are remnants of the legacy readable stream API
    	// If the user uses them, then switch into old mode.
    	Readable.prototype.resume = function () {
    	  var state = this._readableState;
    	  if (!state.flowing) {
    	    debug('resume');
    	    // we flow only if there is no one listening
    	    // for readable, but we still have to call
    	    // resume()
    	    state.flowing = !state.readableListening;
    	    resume(this, state);
    	  }
    	  state.paused = false;
    	  return this;
    	};
    	function resume(stream, state) {
    	  if (!state.resumeScheduled) {
    	    state.resumeScheduled = true;
    	    process.nextTick(resume_, stream, state);
    	  }
    	}
    	function resume_(stream, state) {
    	  debug('resume', state.reading);
    	  if (!state.reading) {
    	    stream.read(0);
    	  }
    	  state.resumeScheduled = false;
    	  stream.emit('resume');
    	  flow(stream);
    	  if (state.flowing && !state.reading) stream.read(0);
    	}
    	Readable.prototype.pause = function () {
    	  debug('call pause flowing=%j', this._readableState.flowing);
    	  if (this._readableState.flowing !== false) {
    	    debug('pause');
    	    this._readableState.flowing = false;
    	    this.emit('pause');
    	  }
    	  this._readableState.paused = true;
    	  return this;
    	};
    	function flow(stream) {
    	  const state = stream._readableState;
    	  debug('flow', state.flowing);
    	  while (state.flowing && stream.read() !== null);
    	}

    	// wrap an old-style stream as the async data source.
    	// This is *not* part of the readable stream interface.
    	// It is an ugly unfortunate mess of history.
    	Readable.prototype.wrap = function (stream) {
    	  var state = this._readableState;
    	  var paused = false;
    	  stream.on('end', () => {
    	    debug('wrapped end');
    	    if (state.decoder && !state.ended) {
    	      var chunk = state.decoder.end();
    	      if (chunk && chunk.length) this.push(chunk);
    	    }
    	    this.push(null);
    	  });
    	  stream.on('data', chunk => {
    	    debug('wrapped data');
    	    if (state.decoder) chunk = state.decoder.write(chunk);

    	    // don't skip over falsy values in objectMode
    	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    	    var ret = this.push(chunk);
    	    if (!ret) {
    	      paused = true;
    	      stream.pause();
    	    }
    	  });

    	  // proxy all the other methods.
    	  // important when wrapping filters and duplexes.
    	  for (var i in stream) {
    	    if (this[i] === undefined && typeof stream[i] === 'function') {
    	      this[i] = function methodWrap(method) {
    	        return function methodWrapReturnFunction() {
    	          return stream[method].apply(stream, arguments);
    	        };
    	      }(i);
    	    }
    	  }

    	  // proxy certain important events.
    	  for (var n = 0; n < kProxyEvents.length; n++) {
    	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
    	  }

    	  // when we try to consume some more bytes, simply unpause the
    	  // underlying stream.
    	  this._read = n => {
    	    debug('wrapped _read', n);
    	    if (paused) {
    	      paused = false;
    	      stream.resume();
    	    }
    	  };
    	  return this;
    	};
    	if (typeof Symbol === 'function') {
    	  Readable.prototype[Symbol.asyncIterator] = function () {
    	    if (createReadableStreamAsyncIterator === undefined) {
    	      createReadableStreamAsyncIterator = requireAsync_iterator();
    	    }
    	    return createReadableStreamAsyncIterator(this);
    	  };
    	}
    	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
    	  // making it explicit this property is not enumerable
    	  // because otherwise some prototype manipulation in
    	  // userland will fail
    	  enumerable: false,
    	  get: function get() {
    	    return this._readableState.highWaterMark;
    	  }
    	});
    	Object.defineProperty(Readable.prototype, 'readableBuffer', {
    	  // making it explicit this property is not enumerable
    	  // because otherwise some prototype manipulation in
    	  // userland will fail
    	  enumerable: false,
    	  get: function get() {
    	    return this._readableState && this._readableState.buffer;
    	  }
    	});
    	Object.defineProperty(Readable.prototype, 'readableFlowing', {
    	  // making it explicit this property is not enumerable
    	  // because otherwise some prototype manipulation in
    	  // userland will fail
    	  enumerable: false,
    	  get: function get() {
    	    return this._readableState.flowing;
    	  },
    	  set: function set(state) {
    	    if (this._readableState) {
    	      this._readableState.flowing = state;
    	    }
    	  }
    	});

    	// exposed for testing purposes only.
    	Readable._fromList = fromList;
    	Object.defineProperty(Readable.prototype, 'readableLength', {
    	  // making it explicit this property is not enumerable
    	  // because otherwise some prototype manipulation in
    	  // userland will fail
    	  enumerable: false,
    	  get() {
    	    return this._readableState.length;
    	  }
    	});

    	// Pluck off n bytes from an array of buffers.
    	// Length is the combined lengths of all the buffers in the list.
    	// This function is designed to be inlinable, so please take care when making
    	// changes to the function body.
    	function fromList(n, state) {
    	  // nothing buffered
    	  if (state.length === 0) return null;
    	  var ret;
    	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    	    // read it all, truncate the list
    	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    	    state.buffer.clear();
    	  } else {
    	    // read part of list
    	    ret = state.buffer.consume(n, state.decoder);
    	  }
    	  return ret;
    	}
    	function endReadable(stream) {
    	  var state = stream._readableState;
    	  debug('endReadable', state.endEmitted);
    	  if (!state.endEmitted) {
    	    state.ended = true;
    	    process.nextTick(endReadableNT, state, stream);
    	  }
    	}
    	function endReadableNT(state, stream) {
    	  debug('endReadableNT', state.endEmitted, state.length);

    	  // Check that we didn't get one last unshift.
    	  if (!state.endEmitted && state.length === 0) {
    	    state.endEmitted = true;
    	    stream.readable = false;
    	    stream.emit('end');
    	    if (state.autoDestroy) {
    	      // In case of duplex streams we need a way to detect
    	      // if the writable side is ready for autoDestroy as well
    	      const wState = stream._writableState;
    	      if (!wState || wState.autoDestroy && wState.finished) {
    	        stream.destroy();
    	      }
    	    }
    	  }
    	}
    	if (typeof Symbol === 'function') {
    	  Readable.from = function (iterable, opts) {
    	    if (from === undefined) {
    	      from = requireFromBrowser();
    	    }
    	    return from(Readable, iterable, opts);
    	  };
    	}
    	function indexOf(xs, x) {
    	  for (var i = 0, l = xs.length; i < l; i++) {
    	    if (xs[i] === x) return i;
    	  }
    	  return -1;
    	}
    	return _stream_readable;
    }

    var _stream_transform = Transform$4;
    const _require$codes$1 = errorsBrowser.codes,
      ERR_METHOD_NOT_IMPLEMENTED = _require$codes$1.ERR_METHOD_NOT_IMPLEMENTED,
      ERR_MULTIPLE_CALLBACK = _require$codes$1.ERR_MULTIPLE_CALLBACK,
      ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes$1.ERR_TRANSFORM_ALREADY_TRANSFORMING,
      ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes$1.ERR_TRANSFORM_WITH_LENGTH_0;
    const Duplex$1 = require_stream_duplex();
    require$$1$1(Transform$4, Duplex$1);
    function afterTransform$1(er, data) {
      var ts = this._transformState;
      ts.transforming = false;
      var cb = ts.writecb;
      if (cb === null) {
        return this.emit('error', new ERR_MULTIPLE_CALLBACK());
      }
      ts.writechunk = null;
      ts.writecb = null;
      if (data != null)
        // single equals check for both `null` and `undefined`
        this.push(data);
      cb(er);
      var rs = this._readableState;
      rs.reading = false;
      if (rs.needReadable || rs.length < rs.highWaterMark) {
        this._read(rs.highWaterMark);
      }
    }
    function Transform$4(options) {
      if (!(this instanceof Transform$4)) return new Transform$4(options);
      Duplex$1.call(this, options);
      this._transformState = {
        afterTransform: afterTransform$1.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
      };

      // start out asking for a readable event once data is transformed.
      this._readableState.needReadable = true;

      // we have implemented the _read method, and done the other things
      // that Readable wants before the first _read call, so unset the
      // sync guard flag.
      this._readableState.sync = false;
      if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
      }

      // When the writable side finishes, then flush out anything remaining.
      this.on('prefinish', prefinish$1);
    }
    function prefinish$1() {
      if (typeof this._flush === 'function' && !this._readableState.destroyed) {
        this._flush((er, data) => {
          done$1(this, er, data);
        });
      } else {
        done$1(this, null, null);
      }
    }
    Transform$4.prototype.push = function (chunk, encoding) {
      this._transformState.needTransform = false;
      return Duplex$1.prototype.push.call(this, chunk, encoding);
    };

    // This is the part where you do stuff!
    // override this function in implementation classes.
    // 'chunk' is an input chunk.
    //
    // Call `push(newChunk)` to pass along transformed output
    // to the readable side.  You may call 'push' zero or more times.
    //
    // Call `cb(err)` when you are done with this chunk.  If you pass
    // an error, then that'll put the hurt on the whole operation.  If you
    // never call cb(), then you'll never get another chunk.
    Transform$4.prototype._transform = function (chunk, encoding, cb) {
      cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
    };
    Transform$4.prototype._write = function (chunk, encoding, cb) {
      var ts = this._transformState;
      ts.writecb = cb;
      ts.writechunk = chunk;
      ts.writeencoding = encoding;
      if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
      }
    };

    // Doesn't matter what the args are here.
    // _transform does all the work.
    // That we got here means that the readable side wants more data.
    Transform$4.prototype._read = function (n) {
      var ts = this._transformState;
      if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
      } else {
        // mark that we need a transform, so that any data that comes in
        // will get processed, now that we've asked for it.
        ts.needTransform = true;
      }
    };
    Transform$4.prototype._destroy = function (err, cb) {
      Duplex$1.prototype._destroy.call(this, err, err2 => {
        cb(err2);
      });
    };
    function done$1(stream, er, data) {
      if (er) return stream.emit('error', er);
      if (data != null)
        // single equals check for both `null` and `undefined`
        stream.push(data);

      // TODO(BridgeAR): Write a test for these two error cases
      // if there's nothing in the write buffer, then that means
      // that nothing more will ever be provided
      if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
      if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
      return stream.push(null);
    }

    var _stream_passthrough = PassThrough$1;
    const Transform$3 = _stream_transform;
    require$$1$1(PassThrough$1, Transform$3);
    function PassThrough$1(options) {
      if (!(this instanceof PassThrough$1)) return new PassThrough$1(options);
      Transform$3.call(this, options);
    }
    PassThrough$1.prototype._transform = function (chunk, encoding, cb) {
      cb(null, chunk);
    };

    let eos;
    function once(callback) {
      let called = false;
      return function () {
        if (called) return;
        called = true;
        callback(...arguments);
      };
    }
    const _require$codes = errorsBrowser.codes,
      ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
      ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
    function noop(err) {
      // Rethrow the error if it exists to avoid swallowing it
      if (err) throw err;
    }
    function isRequest(stream) {
      return stream.setHeader && typeof stream.abort === 'function';
    }
    function destroyer(stream, reading, writing, callback) {
      callback = once(callback);
      let closed = false;
      stream.on('close', () => {
        closed = true;
      });
      if (eos === undefined) eos = endOfStream;
      eos(stream, {
        readable: reading,
        writable: writing
      }, err => {
        if (err) return callback(err);
        closed = true;
        callback();
      });
      let destroyed = false;
      return err => {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;

        // request.destroy just do .end - .abort is what we want
        if (isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new ERR_STREAM_DESTROYED('pipe'));
      };
    }
    function call(fn) {
      fn();
    }
    function pipe(from, to) {
      return from.pipe(to);
    }
    function popCallback(streams) {
      if (!streams.length) return noop;
      if (typeof streams[streams.length - 1] !== 'function') return noop;
      return streams.pop();
    }
    function pipeline() {
      for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
        streams[_key] = arguments[_key];
      }
      const callback = popCallback(streams);
      if (Array.isArray(streams[0])) streams = streams[0];
      if (streams.length < 2) {
        throw new ERR_MISSING_ARGS('streams');
      }
      let error;
      const destroys = streams.map(function (stream, i) {
        const reading = i < streams.length - 1;
        const writing = i > 0;
        return destroyer(stream, reading, writing, function (err) {
          if (!error) error = err;
          if (err) destroys.forEach(call);
          if (reading) return;
          destroys.forEach(call);
          callback(error);
        });
      });
      return streams.reduce(pipe);
    }
    var pipeline_1 = pipeline;

    readableBrowser.exports;

    (function (module, exports) {
    	exports = module.exports = require_stream_readable();
    	exports.Stream = exports;
    	exports.Readable = exports;
    	exports.Writable = require_stream_writable();
    	exports.Duplex = require_stream_duplex();
    	exports.Transform = _stream_transform;
    	exports.PassThrough = _stream_passthrough;
    	exports.finished = endOfStream;
    	exports.pipeline = pipeline_1; 
    } (readableBrowser, readableBrowser.exports));

    var readableBrowserExports = readableBrowser.exports;

    var Buffer$k = safeBufferExports.Buffer;
    var Transform$2 = readableBrowserExports.Transform;
    var inherits$e = require$$1$1;

    function throwIfNotStringOrBuffer (val, prefix) {
      if (!Buffer$k.isBuffer(val) && typeof val !== 'string') {
        throw new TypeError(prefix + ' must be a string or a buffer')
      }
    }

    function HashBase$2 (blockSize) {
      Transform$2.call(this);

      this._block = Buffer$k.allocUnsafe(blockSize);
      this._blockSize = blockSize;
      this._blockOffset = 0;
      this._length = [0, 0, 0, 0];

      this._finalized = false;
    }

    inherits$e(HashBase$2, Transform$2);

    HashBase$2.prototype._transform = function (chunk, encoding, callback) {
      var error = null;
      try {
        this.update(chunk, encoding);
      } catch (err) {
        error = err;
      }

      callback(error);
    };

    HashBase$2.prototype._flush = function (callback) {
      var error = null;
      try {
        this.push(this.digest());
      } catch (err) {
        error = err;
      }

      callback(error);
    };

    HashBase$2.prototype.update = function (data, encoding) {
      throwIfNotStringOrBuffer(data, 'Data');
      if (this._finalized) throw new Error('Digest already called')
      if (!Buffer$k.isBuffer(data)) data = Buffer$k.from(data, encoding);

      // consume data
      var block = this._block;
      var offset = 0;
      while (this._blockOffset + data.length - offset >= this._blockSize) {
        for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
      }
      while (offset < data.length) block[this._blockOffset++] = data[offset++];

      // update length
      for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
        this._length[j] += carry;
        carry = (this._length[j] / 0x0100000000) | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
      }

      return this
    };

    HashBase$2.prototype._update = function () {
      throw new Error('_update is not implemented')
    };

    HashBase$2.prototype.digest = function (encoding) {
      if (this._finalized) throw new Error('Digest already called')
      this._finalized = true;

      var digest = this._digest();
      if (encoding !== undefined) digest = digest.toString(encoding);

      // reset state
      this._block.fill(0);
      this._blockOffset = 0;
      for (var i = 0; i < 4; ++i) this._length[i] = 0;

      return digest
    };

    HashBase$2.prototype._digest = function () {
      throw new Error('_digest is not implemented')
    };

    var hashBase = HashBase$2;

    var inherits$d = require$$1$1;
    var HashBase$1 = hashBase;
    var Buffer$j = safeBufferExports.Buffer;

    var ARRAY16$1 = new Array(16);

    function MD5$2 () {
      HashBase$1.call(this, 64);

      // state
      this._a = 0x67452301;
      this._b = 0xefcdab89;
      this._c = 0x98badcfe;
      this._d = 0x10325476;
    }

    inherits$d(MD5$2, HashBase$1);

    MD5$2.prototype._update = function () {
      var M = ARRAY16$1;
      for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4);

      var a = this._a;
      var b = this._b;
      var c = this._c;
      var d = this._d;

      a = fnF(a, b, c, d, M[0], 0xd76aa478, 7);
      d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
      c = fnF(c, d, a, b, M[2], 0x242070db, 17);
      b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
      a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
      d = fnF(d, a, b, c, M[5], 0x4787c62a, 12);
      c = fnF(c, d, a, b, M[6], 0xa8304613, 17);
      b = fnF(b, c, d, a, M[7], 0xfd469501, 22);
      a = fnF(a, b, c, d, M[8], 0x698098d8, 7);
      d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
      c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
      b = fnF(b, c, d, a, M[11], 0x895cd7be, 22);
      a = fnF(a, b, c, d, M[12], 0x6b901122, 7);
      d = fnF(d, a, b, c, M[13], 0xfd987193, 12);
      c = fnF(c, d, a, b, M[14], 0xa679438e, 17);
      b = fnF(b, c, d, a, M[15], 0x49b40821, 22);

      a = fnG(a, b, c, d, M[1], 0xf61e2562, 5);
      d = fnG(d, a, b, c, M[6], 0xc040b340, 9);
      c = fnG(c, d, a, b, M[11], 0x265e5a51, 14);
      b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
      a = fnG(a, b, c, d, M[5], 0xd62f105d, 5);
      d = fnG(d, a, b, c, M[10], 0x02441453, 9);
      c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
      b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
      a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
      d = fnG(d, a, b, c, M[14], 0xc33707d6, 9);
      c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
      b = fnG(b, c, d, a, M[8], 0x455a14ed, 20);
      a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
      d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
      c = fnG(c, d, a, b, M[7], 0x676f02d9, 14);
      b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);

      a = fnH(a, b, c, d, M[5], 0xfffa3942, 4);
      d = fnH(d, a, b, c, M[8], 0x8771f681, 11);
      c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
      b = fnH(b, c, d, a, M[14], 0xfde5380c, 23);
      a = fnH(a, b, c, d, M[1], 0xa4beea44, 4);
      d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
      c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
      b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
      a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
      d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
      c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
      b = fnH(b, c, d, a, M[6], 0x04881d05, 23);
      a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
      d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
      c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
      b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23);

      a = fnI(a, b, c, d, M[0], 0xf4292244, 6);
      d = fnI(d, a, b, c, M[7], 0x432aff97, 10);
      c = fnI(c, d, a, b, M[14], 0xab9423a7, 15);
      b = fnI(b, c, d, a, M[5], 0xfc93a039, 21);
      a = fnI(a, b, c, d, M[12], 0x655b59c3, 6);
      d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
      c = fnI(c, d, a, b, M[10], 0xffeff47d, 15);
      b = fnI(b, c, d, a, M[1], 0x85845dd1, 21);
      a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
      d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
      c = fnI(c, d, a, b, M[6], 0xa3014314, 15);
      b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
      a = fnI(a, b, c, d, M[4], 0xf7537e82, 6);
      d = fnI(d, a, b, c, M[11], 0xbd3af235, 10);
      c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
      b = fnI(b, c, d, a, M[9], 0xeb86d391, 21);

      this._a = (this._a + a) | 0;
      this._b = (this._b + b) | 0;
      this._c = (this._c + c) | 0;
      this._d = (this._d + d) | 0;
    };

    MD5$2.prototype._digest = function () {
      // create padding and handle blocks
      this._block[this._blockOffset++] = 0x80;
      if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
      }

      this._block.fill(0, this._blockOffset, 56);
      this._block.writeUInt32LE(this._length[0], 56);
      this._block.writeUInt32LE(this._length[1], 60);
      this._update();

      // produce result
      var buffer = Buffer$j.allocUnsafe(16);
      buffer.writeInt32LE(this._a, 0);
      buffer.writeInt32LE(this._b, 4);
      buffer.writeInt32LE(this._c, 8);
      buffer.writeInt32LE(this._d, 12);
      return buffer
    };

    function rotl$1 (x, n) {
      return (x << n) | (x >>> (32 - n))
    }

    function fnF (a, b, c, d, m, k, s) {
      return (rotl$1((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
    }

    function fnG (a, b, c, d, m, k, s) {
      return (rotl$1((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
    }

    function fnH (a, b, c, d, m, k, s) {
      return (rotl$1((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
    }

    function fnI (a, b, c, d, m, k, s) {
      return (rotl$1((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
    }

    var md5_js = MD5$2;

    var Buffer$i = require$$0$3.Buffer;
    var inherits$c = require$$1$1;
    var HashBase = hashBase;

    var ARRAY16 = new Array(16);

    var zl = [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
      7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
      3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
      1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
      4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
    ];

    var zr = [
      5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
      6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
      15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
      8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
      12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
    ];

    var sl = [
      11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
      7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
      11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
      11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
      9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
    ];

    var sr = [
      8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
      9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
      9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
      15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
      8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
    ];

    var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e];
    var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000];

    function RIPEMD160$3 () {
      HashBase.call(this, 64);

      // state
      this._a = 0x67452301;
      this._b = 0xefcdab89;
      this._c = 0x98badcfe;
      this._d = 0x10325476;
      this._e = 0xc3d2e1f0;
    }

    inherits$c(RIPEMD160$3, HashBase);

    RIPEMD160$3.prototype._update = function () {
      var words = ARRAY16;
      for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4);

      var al = this._a | 0;
      var bl = this._b | 0;
      var cl = this._c | 0;
      var dl = this._d | 0;
      var el = this._e | 0;

      var ar = this._a | 0;
      var br = this._b | 0;
      var cr = this._c | 0;
      var dr = this._d | 0;
      var er = this._e | 0;

      // computation
      for (var i = 0; i < 80; i += 1) {
        var tl;
        var tr;
        if (i < 16) {
          tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i]);
          tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i]);
        } else if (i < 32) {
          tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i]);
          tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i]);
        } else if (i < 48) {
          tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i]);
          tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i]);
        } else if (i < 64) {
          tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i]);
          tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i]);
        } else { // if (i<80) {
          tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i]);
          tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i]);
        }

        al = el;
        el = dl;
        dl = rotl(cl, 10);
        cl = bl;
        bl = tl;

        ar = er;
        er = dr;
        dr = rotl(cr, 10);
        cr = br;
        br = tr;
      }

      // update state
      var t = (this._b + cl + dr) | 0;
      this._b = (this._c + dl + er) | 0;
      this._c = (this._d + el + ar) | 0;
      this._d = (this._e + al + br) | 0;
      this._e = (this._a + bl + cr) | 0;
      this._a = t;
    };

    RIPEMD160$3.prototype._digest = function () {
      // create padding and handle blocks
      this._block[this._blockOffset++] = 0x80;
      if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
      }

      this._block.fill(0, this._blockOffset, 56);
      this._block.writeUInt32LE(this._length[0], 56);
      this._block.writeUInt32LE(this._length[1], 60);
      this._update();

      // produce result
      var buffer = Buffer$i.alloc ? Buffer$i.alloc(20) : new Buffer$i(20);
      buffer.writeInt32LE(this._a, 0);
      buffer.writeInt32LE(this._b, 4);
      buffer.writeInt32LE(this._c, 8);
      buffer.writeInt32LE(this._d, 12);
      buffer.writeInt32LE(this._e, 16);
      return buffer
    };

    function rotl (x, n) {
      return (x << n) | (x >>> (32 - n))
    }

    function fn1 (a, b, c, d, e, m, k, s) {
      return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
    }

    function fn2 (a, b, c, d, e, m, k, s) {
      return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
    }

    function fn3 (a, b, c, d, e, m, k, s) {
      return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
    }

    function fn4 (a, b, c, d, e, m, k, s) {
      return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
    }

    function fn5 (a, b, c, d, e, m, k, s) {
      return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
    }

    var ripemd160 = RIPEMD160$3;

    var sha_js = {exports: {}};

    var Buffer$h = safeBufferExports.Buffer;

    // prototype class for hash functions
    function Hash$7 (blockSize, finalSize) {
      this._block = Buffer$h.alloc(blockSize);
      this._finalSize = finalSize;
      this._blockSize = blockSize;
      this._len = 0;
    }

    Hash$7.prototype.update = function (data, enc) {
      if (typeof data === 'string') {
        enc = enc || 'utf8';
        data = Buffer$h.from(data, enc);
      }

      var block = this._block;
      var blockSize = this._blockSize;
      var length = data.length;
      var accum = this._len;

      for (var offset = 0; offset < length;) {
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);

        for (var i = 0; i < remainder; i++) {
          block[assigned + i] = data[offset + i];
        }

        accum += remainder;
        offset += remainder;

        if ((accum % blockSize) === 0) {
          this._update(block);
        }
      }

      this._len += length;
      return this
    };

    Hash$7.prototype.digest = function (enc) {
      var rem = this._len % this._blockSize;

      this._block[rem] = 0x80;

      // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
      // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
      this._block.fill(0, rem + 1);

      if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
      }

      var bits = this._len * 8;

      // uint32
      if (bits <= 0xffffffff) {
        this._block.writeUInt32BE(bits, this._blockSize - 4);

      // uint64
      } else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;

        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
      }

      this._update(this._block);
      var hash = this._hash();

      return enc ? hash.toString(enc) : hash
    };

    Hash$7.prototype._update = function () {
      throw new Error('_update must be implemented by subclass')
    };

    var hash$3 = Hash$7;

    /*
     * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
     * in FIPS PUB 180-1
     * This source code is derived from sha1.js of the same repository.
     * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
     * operation was added.
     */

    var inherits$b = require$$1$1;
    var Hash$6 = hash$3;
    var Buffer$g = safeBufferExports.Buffer;

    var K$4 = [
      0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
    ];

    var W$5 = new Array(80);

    function Sha () {
      this.init();
      this._w = W$5;

      Hash$6.call(this, 64, 56);
    }

    inherits$b(Sha, Hash$6);

    Sha.prototype.init = function () {
      this._a = 0x67452301;
      this._b = 0xefcdab89;
      this._c = 0x98badcfe;
      this._d = 0x10325476;
      this._e = 0xc3d2e1f0;

      return this
    };

    function rotl5$1 (num) {
      return (num << 5) | (num >>> 27)
    }

    function rotl30$1 (num) {
      return (num << 30) | (num >>> 2)
    }

    function ft$1 (s, b, c, d) {
      if (s === 0) return (b & c) | ((~b) & d)
      if (s === 2) return (b & c) | (b & d) | (c & d)
      return b ^ c ^ d
    }

    Sha.prototype._update = function (M) {
      var W = this._w;

      var a = this._a | 0;
      var b = this._b | 0;
      var c = this._c | 0;
      var d = this._d | 0;
      var e = this._e | 0;

      for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4);
      for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];

      for (var j = 0; j < 80; ++j) {
        var s = ~~(j / 20);
        var t = (rotl5$1(a) + ft$1(s, b, c, d) + e + W[j] + K$4[s]) | 0;

        e = d;
        d = c;
        c = rotl30$1(b);
        b = a;
        a = t;
      }

      this._a = (a + this._a) | 0;
      this._b = (b + this._b) | 0;
      this._c = (c + this._c) | 0;
      this._d = (d + this._d) | 0;
      this._e = (e + this._e) | 0;
    };

    Sha.prototype._hash = function () {
      var H = Buffer$g.allocUnsafe(20);

      H.writeInt32BE(this._a | 0, 0);
      H.writeInt32BE(this._b | 0, 4);
      H.writeInt32BE(this._c | 0, 8);
      H.writeInt32BE(this._d | 0, 12);
      H.writeInt32BE(this._e | 0, 16);

      return H
    };

    var sha$3 = Sha;

    /*
     * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
     * in FIPS PUB 180-1
     * Version 2.1a Copyright Paul Johnston 2000 - 2002.
     * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
     * Distributed under the BSD License
     * See http://pajhome.org.uk/crypt/md5 for details.
     */

    var inherits$a = require$$1$1;
    var Hash$5 = hash$3;
    var Buffer$f = safeBufferExports.Buffer;

    var K$3 = [
      0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
    ];

    var W$4 = new Array(80);

    function Sha1 () {
      this.init();
      this._w = W$4;

      Hash$5.call(this, 64, 56);
    }

    inherits$a(Sha1, Hash$5);

    Sha1.prototype.init = function () {
      this._a = 0x67452301;
      this._b = 0xefcdab89;
      this._c = 0x98badcfe;
      this._d = 0x10325476;
      this._e = 0xc3d2e1f0;

      return this
    };

    function rotl1 (num) {
      return (num << 1) | (num >>> 31)
    }

    function rotl5 (num) {
      return (num << 5) | (num >>> 27)
    }

    function rotl30 (num) {
      return (num << 30) | (num >>> 2)
    }

    function ft (s, b, c, d) {
      if (s === 0) return (b & c) | ((~b) & d)
      if (s === 2) return (b & c) | (b & d) | (c & d)
      return b ^ c ^ d
    }

    Sha1.prototype._update = function (M) {
      var W = this._w;

      var a = this._a | 0;
      var b = this._b | 0;
      var c = this._c | 0;
      var d = this._d | 0;
      var e = this._e | 0;

      for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4);
      for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);

      for (var j = 0; j < 80; ++j) {
        var s = ~~(j / 20);
        var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K$3[s]) | 0;

        e = d;
        d = c;
        c = rotl30(b);
        b = a;
        a = t;
      }

      this._a = (a + this._a) | 0;
      this._b = (b + this._b) | 0;
      this._c = (c + this._c) | 0;
      this._d = (d + this._d) | 0;
      this._e = (e + this._e) | 0;
    };

    Sha1.prototype._hash = function () {
      var H = Buffer$f.allocUnsafe(20);

      H.writeInt32BE(this._a | 0, 0);
      H.writeInt32BE(this._b | 0, 4);
      H.writeInt32BE(this._c | 0, 8);
      H.writeInt32BE(this._d | 0, 12);
      H.writeInt32BE(this._e | 0, 16);

      return H
    };

    var sha1 = Sha1;

    /**
     * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
     * in FIPS 180-2
     * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
     * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
     *
     */

    var inherits$9 = require$$1$1;
    var Hash$4 = hash$3;
    var Buffer$e = safeBufferExports.Buffer;

    var K$2 = [
      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
    ];

    var W$3 = new Array(64);

    function Sha256$1 () {
      this.init();

      this._w = W$3; // new Array(64)

      Hash$4.call(this, 64, 56);
    }

    inherits$9(Sha256$1, Hash$4);

    Sha256$1.prototype.init = function () {
      this._a = 0x6a09e667;
      this._b = 0xbb67ae85;
      this._c = 0x3c6ef372;
      this._d = 0xa54ff53a;
      this._e = 0x510e527f;
      this._f = 0x9b05688c;
      this._g = 0x1f83d9ab;
      this._h = 0x5be0cd19;

      return this
    };

    function ch (x, y, z) {
      return z ^ (x & (y ^ z))
    }

    function maj$1 (x, y, z) {
      return (x & y) | (z & (x | y))
    }

    function sigma0$1 (x) {
      return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
    }

    function sigma1$1 (x) {
      return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
    }

    function gamma0 (x) {
      return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
    }

    function gamma1 (x) {
      return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
    }

    Sha256$1.prototype._update = function (M) {
      var W = this._w;

      var a = this._a | 0;
      var b = this._b | 0;
      var c = this._c | 0;
      var d = this._d | 0;
      var e = this._e | 0;
      var f = this._f | 0;
      var g = this._g | 0;
      var h = this._h | 0;

      for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4);
      for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0;

      for (var j = 0; j < 64; ++j) {
        var T1 = (h + sigma1$1(e) + ch(e, f, g) + K$2[j] + W[j]) | 0;
        var T2 = (sigma0$1(a) + maj$1(a, b, c)) | 0;

        h = g;
        g = f;
        f = e;
        e = (d + T1) | 0;
        d = c;
        c = b;
        b = a;
        a = (T1 + T2) | 0;
      }

      this._a = (a + this._a) | 0;
      this._b = (b + this._b) | 0;
      this._c = (c + this._c) | 0;
      this._d = (d + this._d) | 0;
      this._e = (e + this._e) | 0;
      this._f = (f + this._f) | 0;
      this._g = (g + this._g) | 0;
      this._h = (h + this._h) | 0;
    };

    Sha256$1.prototype._hash = function () {
      var H = Buffer$e.allocUnsafe(32);

      H.writeInt32BE(this._a, 0);
      H.writeInt32BE(this._b, 4);
      H.writeInt32BE(this._c, 8);
      H.writeInt32BE(this._d, 12);
      H.writeInt32BE(this._e, 16);
      H.writeInt32BE(this._f, 20);
      H.writeInt32BE(this._g, 24);
      H.writeInt32BE(this._h, 28);

      return H
    };

    var sha256 = Sha256$1;

    /**
     * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
     * in FIPS 180-2
     * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
     * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
     *
     */

    var inherits$8 = require$$1$1;
    var Sha256 = sha256;
    var Hash$3 = hash$3;
    var Buffer$d = safeBufferExports.Buffer;

    var W$2 = new Array(64);

    function Sha224 () {
      this.init();

      this._w = W$2; // new Array(64)

      Hash$3.call(this, 64, 56);
    }

    inherits$8(Sha224, Sha256);

    Sha224.prototype.init = function () {
      this._a = 0xc1059ed8;
      this._b = 0x367cd507;
      this._c = 0x3070dd17;
      this._d = 0xf70e5939;
      this._e = 0xffc00b31;
      this._f = 0x68581511;
      this._g = 0x64f98fa7;
      this._h = 0xbefa4fa4;

      return this
    };

    Sha224.prototype._hash = function () {
      var H = Buffer$d.allocUnsafe(28);

      H.writeInt32BE(this._a, 0);
      H.writeInt32BE(this._b, 4);
      H.writeInt32BE(this._c, 8);
      H.writeInt32BE(this._d, 12);
      H.writeInt32BE(this._e, 16);
      H.writeInt32BE(this._f, 20);
      H.writeInt32BE(this._g, 24);

      return H
    };

    var sha224 = Sha224;

    var inherits$7 = require$$1$1;
    var Hash$2 = hash$3;
    var Buffer$c = safeBufferExports.Buffer;

    var K$1 = [
      0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
      0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
      0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
      0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
      0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
      0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
      0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
      0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
      0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
      0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
      0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
      0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
      0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
      0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
      0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
      0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
      0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
      0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
      0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
      0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
      0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
      0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
      0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
      0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
      0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
      0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
      0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
      0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
      0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
      0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
      0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
      0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
      0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
      0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
      0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
      0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
      0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
      0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
      0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
      0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
    ];

    var W$1 = new Array(160);

    function Sha512 () {
      this.init();
      this._w = W$1;

      Hash$2.call(this, 128, 112);
    }

    inherits$7(Sha512, Hash$2);

    Sha512.prototype.init = function () {
      this._ah = 0x6a09e667;
      this._bh = 0xbb67ae85;
      this._ch = 0x3c6ef372;
      this._dh = 0xa54ff53a;
      this._eh = 0x510e527f;
      this._fh = 0x9b05688c;
      this._gh = 0x1f83d9ab;
      this._hh = 0x5be0cd19;

      this._al = 0xf3bcc908;
      this._bl = 0x84caa73b;
      this._cl = 0xfe94f82b;
      this._dl = 0x5f1d36f1;
      this._el = 0xade682d1;
      this._fl = 0x2b3e6c1f;
      this._gl = 0xfb41bd6b;
      this._hl = 0x137e2179;

      return this
    };

    function Ch (x, y, z) {
      return z ^ (x & (y ^ z))
    }

    function maj (x, y, z) {
      return (x & y) | (z & (x | y))
    }

    function sigma0 (x, xl) {
      return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
    }

    function sigma1 (x, xl) {
      return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
    }

    function Gamma0 (x, xl) {
      return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
    }

    function Gamma0l (x, xl) {
      return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
    }

    function Gamma1 (x, xl) {
      return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
    }

    function Gamma1l (x, xl) {
      return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
    }

    function getCarry (a, b) {
      return (a >>> 0) < (b >>> 0) ? 1 : 0
    }

    Sha512.prototype._update = function (M) {
      var W = this._w;

      var ah = this._ah | 0;
      var bh = this._bh | 0;
      var ch = this._ch | 0;
      var dh = this._dh | 0;
      var eh = this._eh | 0;
      var fh = this._fh | 0;
      var gh = this._gh | 0;
      var hh = this._hh | 0;

      var al = this._al | 0;
      var bl = this._bl | 0;
      var cl = this._cl | 0;
      var dl = this._dl | 0;
      var el = this._el | 0;
      var fl = this._fl | 0;
      var gl = this._gl | 0;
      var hl = this._hl | 0;

      for (var i = 0; i < 32; i += 2) {
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
      }
      for (; i < 160; i += 2) {
        var xh = W[i - 15 * 2];
        var xl = W[i - 15 * 2 + 1];
        var gamma0 = Gamma0(xh, xl);
        var gamma0l = Gamma0l(xl, xh);

        xh = W[i - 2 * 2];
        xl = W[i - 2 * 2 + 1];
        var gamma1 = Gamma1(xh, xl);
        var gamma1l = Gamma1l(xl, xh);

        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 7 * 2];
        var Wi7l = W[i - 7 * 2 + 1];

        var Wi16h = W[i - 16 * 2];
        var Wi16l = W[i - 16 * 2 + 1];

        var Wil = (gamma0l + Wi7l) | 0;
        var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0;
        Wil = (Wil + gamma1l) | 0;
        Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0;
        Wil = (Wil + Wi16l) | 0;
        Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0;

        W[i] = Wih;
        W[i + 1] = Wil;
      }

      for (var j = 0; j < 160; j += 2) {
        Wih = W[j];
        Wil = W[j + 1];

        var majh = maj(ah, bh, ch);
        var majl = maj(al, bl, cl);

        var sigma0h = sigma0(ah, al);
        var sigma0l = sigma0(al, ah);
        var sigma1h = sigma1(eh, el);
        var sigma1l = sigma1(el, eh);

        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = K$1[j];
        var Kil = K$1[j + 1];

        var chh = Ch(eh, fh, gh);
        var chl = Ch(el, fl, gl);

        var t1l = (hl + sigma1l) | 0;
        var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0;
        t1l = (t1l + chl) | 0;
        t1h = (t1h + chh + getCarry(t1l, chl)) | 0;
        t1l = (t1l + Kil) | 0;
        t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0;
        t1l = (t1l + Wil) | 0;
        t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0;

        // t2 = sigma0 + maj
        var t2l = (sigma0l + majl) | 0;
        var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0;

        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = (dl + t1l) | 0;
        eh = (dh + t1h + getCarry(el, dl)) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = (t1l + t2l) | 0;
        ah = (t1h + t2h + getCarry(al, t1l)) | 0;
      }

      this._al = (this._al + al) | 0;
      this._bl = (this._bl + bl) | 0;
      this._cl = (this._cl + cl) | 0;
      this._dl = (this._dl + dl) | 0;
      this._el = (this._el + el) | 0;
      this._fl = (this._fl + fl) | 0;
      this._gl = (this._gl + gl) | 0;
      this._hl = (this._hl + hl) | 0;

      this._ah = (this._ah + ah + getCarry(this._al, al)) | 0;
      this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0;
      this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0;
      this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0;
      this._eh = (this._eh + eh + getCarry(this._el, el)) | 0;
      this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0;
      this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0;
      this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0;
    };

    Sha512.prototype._hash = function () {
      var H = Buffer$c.allocUnsafe(64);

      function writeInt64BE (h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
      }

      writeInt64BE(this._ah, this._al, 0);
      writeInt64BE(this._bh, this._bl, 8);
      writeInt64BE(this._ch, this._cl, 16);
      writeInt64BE(this._dh, this._dl, 24);
      writeInt64BE(this._eh, this._el, 32);
      writeInt64BE(this._fh, this._fl, 40);
      writeInt64BE(this._gh, this._gl, 48);
      writeInt64BE(this._hh, this._hl, 56);

      return H
    };

    var sha512 = Sha512;

    var inherits$6 = require$$1$1;
    var SHA512$2 = sha512;
    var Hash$1 = hash$3;
    var Buffer$b = safeBufferExports.Buffer;

    var W = new Array(160);

    function Sha384 () {
      this.init();
      this._w = W;

      Hash$1.call(this, 128, 112);
    }

    inherits$6(Sha384, SHA512$2);

    Sha384.prototype.init = function () {
      this._ah = 0xcbbb9d5d;
      this._bh = 0x629a292a;
      this._ch = 0x9159015a;
      this._dh = 0x152fecd8;
      this._eh = 0x67332667;
      this._fh = 0x8eb44a87;
      this._gh = 0xdb0c2e0d;
      this._hh = 0x47b5481d;

      this._al = 0xc1059ed8;
      this._bl = 0x367cd507;
      this._cl = 0x3070dd17;
      this._dl = 0xf70e5939;
      this._el = 0xffc00b31;
      this._fl = 0x68581511;
      this._gl = 0x64f98fa7;
      this._hl = 0xbefa4fa4;

      return this
    };

    Sha384.prototype._hash = function () {
      var H = Buffer$b.allocUnsafe(48);

      function writeInt64BE (h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
      }

      writeInt64BE(this._ah, this._al, 0);
      writeInt64BE(this._bh, this._bl, 8);
      writeInt64BE(this._ch, this._cl, 16);
      writeInt64BE(this._dh, this._dl, 24);
      writeInt64BE(this._eh, this._el, 32);
      writeInt64BE(this._fh, this._fl, 40);

      return H
    };

    var sha384 = Sha384;

    var exports$1 = sha_js.exports = function SHA (algorithm) {
      algorithm = algorithm.toLowerCase();

      var Algorithm = exports$1[algorithm];
      if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

      return new Algorithm()
    };

    exports$1.sha = sha$3;
    exports$1.sha1 = sha1;
    exports$1.sha224 = sha224;
    exports$1.sha256 = sha256;
    exports$1.sha384 = sha384;
    exports$1.sha512 = sha512;

    var sha_jsExports = sha_js.exports;

    function BufferList() {
      this.head = null;
      this.tail = null;
      this.length = 0;
    }

    BufferList.prototype.push = function (v) {
      var entry = { data: v, next: null };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    };

    BufferList.prototype.unshift = function (v) {
      var entry = { data: v, next: this.head };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    };

    BufferList.prototype.shift = function () {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    };

    BufferList.prototype.clear = function () {
      this.head = this.tail = null;
      this.length = 0;
    };

    BufferList.prototype.join = function (s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) {
        ret += s + p.data;
      }return ret;
    };

    BufferList.prototype.concat = function (n) {
      if (this.length === 0) return Buffer$l.alloc(0);
      if (this.length === 1) return this.head.data;
      var ret = Buffer$l.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        p.data.copy(ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    };

    Readable.ReadableState = ReadableState;

    var debug = debuglog('stream');
    inherits$g(Readable, EventEmitter);

    function prependListener(emitter, event, fn) {
      // Sadly this is not cacheable as some libraries bundle their own
      // event emitter implementation with them.
      if (typeof emitter.prependListener === 'function') {
        return emitter.prependListener(event, fn);
      } else {
        // This is a hack to make sure that our error handler is attached before any
        // userland ones.  NEVER DO THIS. This is here only because this code needs
        // to continue to work with older versions of Node.js that do not include
        // the prependListener() method. The goal is to eventually remove this hack.
        if (!emitter._events || !emitter._events[event])
          emitter.on(event, fn);
        else if (Array.isArray(emitter._events[event]))
          emitter._events[event].unshift(fn);
        else
          emitter._events[event] = [fn, emitter._events[event]];
      }
    }
    function listenerCount (emitter, type) {
      return emitter.listeners(type).length;
    }
    function ReadableState(options, stream) {

      options = options || {};

      // object stream flag. Used to make read(n) ignore n and to
      // make all the buffer merging and length checks go away
      this.objectMode = !!options.objectMode;

      if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

      // the point at which it stops calling _read() to fill the buffer
      // Note: 0 is a valid value, means "don't call _read preemptively ever"
      var hwm = options.highWaterMark;
      var defaultHwm = this.objectMode ? 16 : 16 * 1024;
      this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

      // cast to ints.
      this.highWaterMark = ~ ~this.highWaterMark;

      // A linked list is used to store data chunks instead of an array because the
      // linked list can remove elements from the beginning faster than
      // array.shift()
      this.buffer = new BufferList();
      this.length = 0;
      this.pipes = null;
      this.pipesCount = 0;
      this.flowing = null;
      this.ended = false;
      this.endEmitted = false;
      this.reading = false;

      // a flag to be able to tell if the onwrite cb is called immediately,
      // or on a later tick.  We set this to true at first, because any
      // actions that shouldn't happen until "later" should generally also
      // not happen before the first write call.
      this.sync = true;

      // whenever we return null, then we set a flag to say
      // that we're awaiting a 'readable' event emission.
      this.needReadable = false;
      this.emittedReadable = false;
      this.readableListening = false;
      this.resumeScheduled = false;

      // Crypto is kind of old and crusty.  Historically, its default string
      // encoding is 'binary' so we have to make this configurable.
      // Everything else in the universe uses 'utf8', though.
      this.defaultEncoding = options.defaultEncoding || 'utf8';

      // when piping, we only care about 'readable' events that happen
      // after read()ing all the bytes and not getting any pushback.
      this.ranOut = false;

      // the number of writers that are awaiting a drain event in .pipe()s
      this.awaitDrain = 0;

      // if true, a maybeReadMore has been scheduled
      this.readingMore = false;

      this.decoder = null;
      this.encoding = null;
      if (options.encoding) {
        this.decoder = new StringDecoder$1(options.encoding);
        this.encoding = options.encoding;
      }
    }
    function Readable(options) {

      if (!(this instanceof Readable)) return new Readable(options);

      this._readableState = new ReadableState(options, this);

      // legacy
      this.readable = true;

      if (options && typeof options.read === 'function') this._read = options.read;

      EventEmitter.call(this);
    }

    // Manually shove something into the read() buffer.
    // This returns true if the highWaterMark has not been hit yet,
    // similar to how Writable.write() returns true if you should
    // write() some more.
    Readable.prototype.push = function (chunk, encoding) {
      var state = this._readableState;

      if (!state.objectMode && typeof chunk === 'string') {
        encoding = encoding || state.defaultEncoding;
        if (encoding !== state.encoding) {
          chunk = Buffer$l.from(chunk, encoding);
          encoding = '';
        }
      }

      return readableAddChunk(this, state, chunk, encoding, false);
    };

    // Unshift should *always* be something directly out of read()
    Readable.prototype.unshift = function (chunk) {
      var state = this._readableState;
      return readableAddChunk(this, state, chunk, '', true);
    };

    Readable.prototype.isPaused = function () {
      return this._readableState.flowing === false;
    };

    function readableAddChunk(stream, state, chunk, encoding, addToFront) {
      var er = chunkInvalid(state, chunk);
      if (er) {
        stream.emit('error', er);
      } else if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
      } else if (state.objectMode || chunk && chunk.length > 0) {
        if (state.ended && !addToFront) {
          var e = new Error('stream.push() after EOF');
          stream.emit('error', e);
        } else if (state.endEmitted && addToFront) {
          var _e = new Error('stream.unshift() after end event');
          stream.emit('error', _e);
        } else {
          var skipAdd;
          if (state.decoder && !addToFront && !encoding) {
            chunk = state.decoder.write(chunk);
            skipAdd = !state.objectMode && chunk.length === 0;
          }

          if (!addToFront) state.reading = false;

          // Don't add to the buffer if we've decoded to an empty string chunk and
          // we're not in object mode
          if (!skipAdd) {
            // if we want the data now, just emit it.
            if (state.flowing && state.length === 0 && !state.sync) {
              stream.emit('data', chunk);
              stream.read(0);
            } else {
              // update the buffer info.
              state.length += state.objectMode ? 1 : chunk.length;
              if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

              if (state.needReadable) emitReadable(stream);
            }
          }

          maybeReadMore(stream, state);
        }
      } else if (!addToFront) {
        state.reading = false;
      }

      return needMoreData(state);
    }

    // if it's past the high water mark, we can push in some more.
    // Also, if we have no data yet, we can stand some
    // more bytes.  This is to work around cases where hwm=0,
    // such as the repl.  Also, if the push() triggered a
    // readable event, and the user called read(largeNumber) such that
    // needReadable was set, then we ought to push more, so that another
    // 'readable' event will be triggered.
    function needMoreData(state) {
      return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
    }

    // backwards compatibility.
    Readable.prototype.setEncoding = function (enc) {
      this._readableState.decoder = new StringDecoder$1(enc);
      this._readableState.encoding = enc;
      return this;
    };

    // Don't raise the hwm > 8MB
    var MAX_HWM = 0x800000;
    function computeNewHighWaterMark(n) {
      if (n >= MAX_HWM) {
        n = MAX_HWM;
      } else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
      }
      return n;
    }

    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.
    function howMuchToRead(n, state) {
      if (n <= 0 || state.length === 0 && state.ended) return 0;
      if (state.objectMode) return 1;
      if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
      }
      // If we're asking for more than the current hwm, then raise the hwm.
      if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
      if (n <= state.length) return n;
      // Don't have enough
      if (!state.ended) {
        state.needReadable = true;
        return 0;
      }
      return state.length;
    }

    // you can override either this method, or the async _read(n) below.
    Readable.prototype.read = function (n) {
      debug('read', n);
      n = parseInt(n, 10);
      var state = this._readableState;
      var nOrig = n;

      if (n !== 0) state.emittedReadable = false;

      // if we're doing read(0) to trigger a readable event, but we
      // already have a bunch of data in the buffer, then just trigger
      // the 'readable' event and move on.
      if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
        return null;
      }

      n = howMuchToRead(n, state);

      // if we've ended, and we're now clear, then finish it up.
      if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
      }

      // All the actual chunk generation logic needs to be
      // *below* the call to _read.  The reason is that in certain
      // synthetic stream cases, such as passthrough streams, _read
      // may be a completely synchronous operation which may change
      // the state of the read buffer, providing enough data when
      // before there was *not* enough.
      //
      // So, the steps are:
      // 1. Figure out what the state of things will be after we do
      // a read from the buffer.
      //
      // 2. If that resulting state will trigger a _read, then call _read.
      // Note that this may be asynchronous, or synchronous.  Yes, it is
      // deeply ugly to write APIs this way, but that still doesn't mean
      // that the Readable class should behave improperly, as streams are
      // designed to be sync/async agnostic.
      // Take note if the _read call is sync or async (ie, if the read call
      // has returned yet), so that we know whether or not it's safe to emit
      // 'readable' etc.
      //
      // 3. Actually pull the requested chunks out of the buffer and return.

      // if we need a readable event, then we need to do some reading.
      var doRead = state.needReadable;
      debug('need readable', doRead);

      // if we currently have less than the highWaterMark, then also read some
      if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug('length less than watermark', doRead);
      }

      // however, if we've ended, then there's no point, and if we're already
      // reading, then it's unnecessary.
      if (state.ended || state.reading) {
        doRead = false;
        debug('reading or ended', doRead);
      } else if (doRead) {
        debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = howMuchToRead(nOrig, state);
      }

      var ret;
      if (n > 0) ret = fromList(n, state);else ret = null;

      if (ret === null) {
        state.needReadable = true;
        n = 0;
      } else {
        state.length -= n;
      }

      if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;

        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) endReadable(this);
      }

      if (ret !== null) this.emit('data', ret);

      return ret;
    };

    function chunkInvalid(state, chunk) {
      var er = null;
      if (!Buffer$l.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
        er = new TypeError('Invalid non-string/buffer chunk');
      }
      return er;
    }

    function onEofChunk(stream, state) {
      if (state.ended) return;
      if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
          state.buffer.push(chunk);
          state.length += state.objectMode ? 1 : chunk.length;
        }
      }
      state.ended = true;

      // emit 'readable' now to make sure it gets picked up.
      emitReadable(stream);
    }

    // Don't emit readable right away in sync mode, because this can trigger
    // another read() call => stack overflow.  This way, it might trigger
    // a nextTick recursion warning, but that's not so bad.
    function emitReadable(stream) {
      var state = stream._readableState;
      state.needReadable = false;
      if (!state.emittedReadable) {
        debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) nextTick$1(emitReadable_, stream);else emitReadable_(stream);
      }
    }

    function emitReadable_(stream) {
      debug('emit readable');
      stream.emit('readable');
      flow(stream);
    }

    // at this point, the user has presumably seen the 'readable' event,
    // and called read() to consume some data.  that may have triggered
    // in turn another _read(n) call, in which case reading = true if
    // it's in progress.
    // However, if we're not ended, or reading, and the length < hwm,
    // then go ahead and try to read some more preemptively.
    function maybeReadMore(stream, state) {
      if (!state.readingMore) {
        state.readingMore = true;
        nextTick$1(maybeReadMore_, stream, state);
      }
    }

    function maybeReadMore_(stream, state) {
      var len = state.length;
      while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
        debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length)
          // didn't get any data, stop spinning.
          break;else len = state.length;
      }
      state.readingMore = false;
    }

    // abstract method.  to be overridden in specific implementation classes.
    // call cb(er, data) where data is <= n in length.
    // for virtual (non-string, non-buffer) streams, "length" is somewhat
    // arbitrary, and perhaps not very meaningful.
    Readable.prototype._read = function (n) {
      this.emit('error', new Error('not implemented'));
    };

    Readable.prototype.pipe = function (dest, pipeOpts) {
      var src = this;
      var state = this._readableState;

      switch (state.pipesCount) {
        case 0:
          state.pipes = dest;
          break;
        case 1:
          state.pipes = [state.pipes, dest];
          break;
        default:
          state.pipes.push(dest);
          break;
      }
      state.pipesCount += 1;
      debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

      var doEnd = (!pipeOpts || pipeOpts.end !== false);

      var endFn = doEnd ? onend : cleanup;
      if (state.endEmitted) nextTick$1(endFn);else src.once('end', endFn);

      dest.on('unpipe', onunpipe);
      function onunpipe(readable) {
        debug('onunpipe');
        if (readable === src) {
          cleanup();
        }
      }

      function onend() {
        debug('onend');
        dest.end();
      }

      // when the dest drains, it reduces the awaitDrain counter
      // on the source.  This would be more elegant with a .once()
      // handler in flow(), but adding and removing repeatedly is
      // too slow.
      var ondrain = pipeOnDrain(src);
      dest.on('drain', ondrain);

      var cleanedUp = false;
      function cleanup() {
        debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', cleanup);
        src.removeListener('data', ondata);

        cleanedUp = true;

        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
      }

      // If the user pushes more data while we're writing to dest then we'll end up
      // in ondata again. However, we only want to increase awaitDrain once because
      // dest will only emit one 'drain' event for the multiple writes.
      // => Introduce a guard on increasing awaitDrain.
      var increasedAwaitDrain = false;
      src.on('data', ondata);
      function ondata(chunk) {
        debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
          // If the user unpiped during `dest.write()`, it is possible
          // to get stuck in a permanently paused state if that write
          // also returned false.
          // => Check whether `dest` is still a piping destination.
          if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
            debug('false write response, pause', src._readableState.awaitDrain);
            src._readableState.awaitDrain++;
            increasedAwaitDrain = true;
          }
          src.pause();
        }
      }

      // if the dest has an error, then stop piping into it.
      // however, don't suppress the throwing behavior for this.
      function onerror(er) {
        debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (listenerCount(dest, 'error') === 0) dest.emit('error', er);
      }

      // Make sure our error handler is attached before userland ones.
      prependListener(dest, 'error', onerror);

      // Both close and finish should trigger unpipe, but only once.
      function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
      }
      dest.once('close', onclose);
      function onfinish() {
        debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
      }
      dest.once('finish', onfinish);

      function unpipe() {
        debug('unpipe');
        src.unpipe(dest);
      }

      // tell the dest that it's being piped to
      dest.emit('pipe', src);

      // start the flow if it hasn't been started already.
      if (!state.flowing) {
        debug('pipe resume');
        src.resume();
      }

      return dest;
    };

    function pipeOnDrain(src) {
      return function () {
        var state = src._readableState;
        debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && src.listeners('data').length) {
          state.flowing = true;
          flow(src);
        }
      };
    }

    Readable.prototype.unpipe = function (dest) {
      var state = this._readableState;

      // if we're not piping anywhere, then do nothing.
      if (state.pipesCount === 0) return this;

      // just one destination.  most common case.
      if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;

        if (!dest) dest = state.pipes;

        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this);
        return this;
      }

      // slow case. multiple pipe destinations.

      if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;

        for (var _i = 0; _i < len; _i++) {
          dests[_i].emit('unpipe', this);
        }return this;
      }

      // try to find the right one.
      var i = indexOf(state.pipes, dest);
      if (i === -1) return this;

      state.pipes.splice(i, 1);
      state.pipesCount -= 1;
      if (state.pipesCount === 1) state.pipes = state.pipes[0];

      dest.emit('unpipe', this);

      return this;
    };

    // set up data events if they are asked for
    // Ensure readable listeners eventually get something
    Readable.prototype.on = function (ev, fn) {
      var res = EventEmitter.prototype.on.call(this, ev, fn);

      if (ev === 'data') {
        // Start flowing on next tick if stream isn't explicitly paused
        if (this._readableState.flowing !== false) this.resume();
      } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
          state.readableListening = state.needReadable = true;
          state.emittedReadable = false;
          if (!state.reading) {
            nextTick$1(nReadingNextTick, this);
          } else if (state.length) {
            emitReadable(this);
          }
        }
      }

      return res;
    };
    Readable.prototype.addListener = Readable.prototype.on;

    function nReadingNextTick(self) {
      debug('readable nexttick read 0');
      self.read(0);
    }

    // pause() and resume() are remnants of the legacy readable stream API
    // If the user uses them, then switch into old mode.
    Readable.prototype.resume = function () {
      var state = this._readableState;
      if (!state.flowing) {
        debug('resume');
        state.flowing = true;
        resume(this, state);
      }
      return this;
    };

    function resume(stream, state) {
      if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        nextTick$1(resume_, stream, state);
      }
    }

    function resume_(stream, state) {
      if (!state.reading) {
        debug('resume read 0');
        stream.read(0);
      }

      state.resumeScheduled = false;
      state.awaitDrain = 0;
      stream.emit('resume');
      flow(stream);
      if (state.flowing && !state.reading) stream.read(0);
    }

    Readable.prototype.pause = function () {
      debug('call pause flowing=%j', this._readableState.flowing);
      if (false !== this._readableState.flowing) {
        debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
      }
      return this;
    };

    function flow(stream) {
      var state = stream._readableState;
      debug('flow', state.flowing);
      while (state.flowing && stream.read() !== null) {}
    }

    // wrap an old-style stream as the async data source.
    // This is *not* part of the readable stream interface.
    // It is an ugly unfortunate mess of history.
    Readable.prototype.wrap = function (stream) {
      var state = this._readableState;
      var paused = false;

      var self = this;
      stream.on('end', function () {
        debug('wrapped end');
        if (state.decoder && !state.ended) {
          var chunk = state.decoder.end();
          if (chunk && chunk.length) self.push(chunk);
        }

        self.push(null);
      });

      stream.on('data', function (chunk) {
        debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);

        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

        var ret = self.push(chunk);
        if (!ret) {
          paused = true;
          stream.pause();
        }
      });

      // proxy all the other methods.
      // important when wrapping filters and duplexes.
      for (var i in stream) {
        if (this[i] === undefined && typeof stream[i] === 'function') {
          this[i] = function (method) {
            return function () {
              return stream[method].apply(stream, arguments);
            };
          }(i);
        }
      }

      // proxy certain important events.
      var events = ['error', 'close', 'destroy', 'pause', 'resume'];
      forEach(events, function (ev) {
        stream.on(ev, self.emit.bind(self, ev));
      });

      // when we try to consume some more bytes, simply unpause the
      // underlying stream.
      self._read = function (n) {
        debug('wrapped _read', n);
        if (paused) {
          paused = false;
          stream.resume();
        }
      };

      return self;
    };

    // exposed for testing purposes only.
    Readable._fromList = fromList;

    // Pluck off n bytes from an array of buffers.
    // Length is the combined lengths of all the buffers in the list.
    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.
    function fromList(n, state) {
      // nothing buffered
      if (state.length === 0) return null;

      var ret;
      if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
        state.buffer.clear();
      } else {
        // read part of list
        ret = fromListPartial(n, state.buffer, state.decoder);
      }

      return ret;
    }

    // Extracts only enough buffered data to satisfy the amount requested.
    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.
    function fromListPartial(n, list, hasStrings) {
      var ret;
      if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
      } else if (n === list.head.data.length) {
        // first chunk is a perfect match
        ret = list.shift();
      } else {
        // result spans more than one buffer
        ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
      }
      return ret;
    }

    // Copies a specified amount of characters from the list of buffered data
    // chunks.
    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.
    function copyFromBufferString(n, list) {
      var p = list.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) list.head = p.next;else list.head = list.tail = null;
          } else {
            list.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      list.length -= c;
      return ret;
    }

    // Copies a specified amount of bytes from the list of buffered data chunks.
    // This function is designed to be inlinable, so please take care when making
    // changes to the function body.
    function copyFromBuffer(n, list) {
      var ret = Buffer$l.allocUnsafe(n);
      var p = list.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) list.head = p.next;else list.head = list.tail = null;
          } else {
            list.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      list.length -= c;
      return ret;
    }

    function endReadable(stream) {
      var state = stream._readableState;

      // If we get here before consuming all the bytes, then that is a
      // bug in node.  Should never happen.
      if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

      if (!state.endEmitted) {
        state.ended = true;
        nextTick$1(endReadableNT, state, stream);
      }
    }

    function endReadableNT(state, stream) {
      // Check that we didn't get one last unshift.
      if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
      }
    }

    function forEach(xs, f) {
      for (var i = 0, l = xs.length; i < l; i++) {
        f(xs[i], i);
      }
    }

    function indexOf(xs, x) {
      for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) return i;
      }
      return -1;
    }

    // A bit simpler than readable streams.
    Writable.WritableState = WritableState;
    inherits$g(Writable, EventEmitter);

    function nop() {}

    function WriteReq(chunk, encoding, cb) {
      this.chunk = chunk;
      this.encoding = encoding;
      this.callback = cb;
      this.next = null;
    }

    function WritableState(options, stream) {
      Object.defineProperty(this, 'buffer', {
        get: deprecate$1(function () {
          return this.getBuffer();
        }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
      });
      options = options || {};

      // object stream flag to indicate whether or not this stream
      // contains buffers or objects.
      this.objectMode = !!options.objectMode;

      if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

      // the point at which write() starts returning false
      // Note: 0 is a valid value, means that we always return false if
      // the entire buffer is not flushed immediately on write()
      var hwm = options.highWaterMark;
      var defaultHwm = this.objectMode ? 16 : 16 * 1024;
      this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

      // cast to ints.
      this.highWaterMark = ~ ~this.highWaterMark;

      this.needDrain = false;
      // at the start of calling end()
      this.ending = false;
      // when end() has been called, and returned
      this.ended = false;
      // when 'finish' is emitted
      this.finished = false;

      // should we decode strings into buffers before passing to _write?
      // this is here so that some node-core streams can optimize string
      // handling at a lower level.
      var noDecode = options.decodeStrings === false;
      this.decodeStrings = !noDecode;

      // Crypto is kind of old and crusty.  Historically, its default string
      // encoding is 'binary' so we have to make this configurable.
      // Everything else in the universe uses 'utf8', though.
      this.defaultEncoding = options.defaultEncoding || 'utf8';

      // not an actual buffer we keep track of, but a measurement
      // of how much we're waiting to get pushed to some underlying
      // socket or file.
      this.length = 0;

      // a flag to see when we're in the middle of a write.
      this.writing = false;

      // when true all writes will be buffered until .uncork() call
      this.corked = 0;

      // a flag to be able to tell if the onwrite cb is called immediately,
      // or on a later tick.  We set this to true at first, because any
      // actions that shouldn't happen until "later" should generally also
      // not happen before the first write call.
      this.sync = true;

      // a flag to know if we're processing previously buffered items, which
      // may call the _write() callback in the same tick, so that we don't
      // end up in an overlapped onwrite situation.
      this.bufferProcessing = false;

      // the callback that's passed to _write(chunk,cb)
      this.onwrite = function (er) {
        onwrite(stream, er);
      };

      // the callback that the user supplies to write(chunk,encoding,cb)
      this.writecb = null;

      // the amount that is being written when _write is called.
      this.writelen = 0;

      this.bufferedRequest = null;
      this.lastBufferedRequest = null;

      // number of pending user-supplied write callbacks
      // this must be 0 before 'finish' can be emitted
      this.pendingcb = 0;

      // emit prefinish if the only thing we're waiting for is _write cbs
      // This is relevant for synchronous Transform streams
      this.prefinished = false;

      // True if the error was already emitted and should not be thrown again
      this.errorEmitted = false;

      // count buffered requests
      this.bufferedRequestCount = 0;

      // allocate the first CorkedRequest, there is always
      // one allocated and free to use, and we maintain at most two
      this.corkedRequestsFree = new CorkedRequest(this);
    }

    WritableState.prototype.getBuffer = function writableStateGetBuffer() {
      var current = this.bufferedRequest;
      var out = [];
      while (current) {
        out.push(current);
        current = current.next;
      }
      return out;
    };
    function Writable(options) {

      // Writable ctor is applied to Duplexes, though they're not
      // instanceof Writable, they're instanceof Readable.
      if (!(this instanceof Writable) && !(this instanceof Duplex)) return new Writable(options);

      this._writableState = new WritableState(options, this);

      // legacy.
      this.writable = true;

      if (options) {
        if (typeof options.write === 'function') this._write = options.write;

        if (typeof options.writev === 'function') this._writev = options.writev;
      }

      EventEmitter.call(this);
    }

    // Otherwise people can pipe Writable streams, which is just wrong.
    Writable.prototype.pipe = function () {
      this.emit('error', new Error('Cannot pipe, not readable'));
    };

    function writeAfterEnd(stream, cb) {
      var er = new Error('write after end');
      // TODO: defer error events consistently everywhere, not just the cb
      stream.emit('error', er);
      nextTick$1(cb, er);
    }

    // If we get something that is not a buffer, string, null, or undefined,
    // and we're not in objectMode, then that's an error.
    // Otherwise stream chunks are all considered to be of length=1, and the
    // watermarks determine how many objects to keep in the buffer, rather than
    // how many bytes or characters.
    function validChunk(stream, state, chunk, cb) {
      var valid = true;
      var er = false;
      // Always throw error if a null is written
      // if we are not in object mode then throw
      // if it is not a buffer, string, or undefined.
      if (chunk === null) {
        er = new TypeError('May not write null values to stream');
      } else if (!Buffer$l.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
        er = new TypeError('Invalid non-string/buffer chunk');
      }
      if (er) {
        stream.emit('error', er);
        nextTick$1(cb, er);
        valid = false;
      }
      return valid;
    }

    Writable.prototype.write = function (chunk, encoding, cb) {
      var state = this._writableState;
      var ret = false;

      if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
      }

      if (Buffer$l.isBuffer(chunk)) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

      if (typeof cb !== 'function') cb = nop;

      if (state.ended) writeAfterEnd(this, cb);else if (validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, chunk, encoding, cb);
      }

      return ret;
    };

    Writable.prototype.cork = function () {
      var state = this._writableState;

      state.corked++;
    };

    Writable.prototype.uncork = function () {
      var state = this._writableState;

      if (state.corked) {
        state.corked--;

        if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
      }
    };

    Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
      // node::ParseEncoding() requires lower case.
      if (typeof encoding === 'string') encoding = encoding.toLowerCase();
      if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
      this._writableState.defaultEncoding = encoding;
      return this;
    };

    function decodeChunk(state, chunk, encoding) {
      if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
        chunk = Buffer$l.from(chunk, encoding);
      }
      return chunk;
    }

    // if we're already writing something, then just put this
    // in the queue, and wait our turn.  Otherwise, call _write
    // If we return false, then we need a drain event, so set that flag.
    function writeOrBuffer(stream, state, chunk, encoding, cb) {
      chunk = decodeChunk(state, chunk, encoding);

      if (Buffer$l.isBuffer(chunk)) encoding = 'buffer';
      var len = state.objectMode ? 1 : chunk.length;

      state.length += len;

      var ret = state.length < state.highWaterMark;
      // we must ensure that previous needDrain will not be reset to false.
      if (!ret) state.needDrain = true;

      if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
        if (last) {
          last.next = state.lastBufferedRequest;
        } else {
          state.bufferedRequest = state.lastBufferedRequest;
        }
        state.bufferedRequestCount += 1;
      } else {
        doWrite(stream, state, false, len, chunk, encoding, cb);
      }

      return ret;
    }

    function doWrite(stream, state, writev, len, chunk, encoding, cb) {
      state.writelen = len;
      state.writecb = cb;
      state.writing = true;
      state.sync = true;
      if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
      state.sync = false;
    }

    function onwriteError(stream, state, sync, er, cb) {
      --state.pendingcb;
      if (sync) nextTick$1(cb, er);else cb(er);

      stream._writableState.errorEmitted = true;
      stream.emit('error', er);
    }

    function onwriteStateUpdate(state) {
      state.writing = false;
      state.writecb = null;
      state.length -= state.writelen;
      state.writelen = 0;
    }

    function onwrite(stream, er) {
      var state = stream._writableState;
      var sync = state.sync;
      var cb = state.writecb;

      onwriteStateUpdate(state);

      if (er) onwriteError(stream, state, sync, er, cb);else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state);

        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
          clearBuffer(stream, state);
        }

        if (sync) {
          /*<replacement>*/
            nextTick$1(afterWrite, stream, state, finished, cb);
          /*</replacement>*/
        } else {
            afterWrite(stream, state, finished, cb);
          }
      }
    }

    function afterWrite(stream, state, finished, cb) {
      if (!finished) onwriteDrain(stream, state);
      state.pendingcb--;
      cb();
      finishMaybe(stream, state);
    }

    // Must force callback to be called on nextTick, so that we don't
    // emit 'drain' before the write() consumer gets the 'false' return
    // value, and has a chance to attach a 'drain' listener.
    function onwriteDrain(stream, state) {
      if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
      }
    }

    // if there's something in the buffer waiting, then process it
    function clearBuffer(stream, state) {
      state.bufferProcessing = true;
      var entry = state.bufferedRequest;

      if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;

        var count = 0;
        while (entry) {
          buffer[count] = entry;
          entry = entry.next;
          count += 1;
        }

        doWrite(stream, state, true, state.length, buffer, '', holder.finish);

        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
          state.corkedRequestsFree = holder.next;
          holder.next = null;
        } else {
          state.corkedRequestsFree = new CorkedRequest(state);
        }
      } else {
        // Slow case, write chunks one-by-one
        while (entry) {
          var chunk = entry.chunk;
          var encoding = entry.encoding;
          var cb = entry.callback;
          var len = state.objectMode ? 1 : chunk.length;

          doWrite(stream, state, false, len, chunk, encoding, cb);
          entry = entry.next;
          // if we didn't call the onwrite immediately, then
          // it means that we need to wait until it does.
          // also, that means that the chunk and cb are currently
          // being processed, so move the buffer counter past them.
          if (state.writing) {
            break;
          }
        }

        if (entry === null) state.lastBufferedRequest = null;
      }

      state.bufferedRequestCount = 0;
      state.bufferedRequest = entry;
      state.bufferProcessing = false;
    }

    Writable.prototype._write = function (chunk, encoding, cb) {
      cb(new Error('not implemented'));
    };

    Writable.prototype._writev = null;

    Writable.prototype.end = function (chunk, encoding, cb) {
      var state = this._writableState;

      if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
      } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
      }

      if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

      // .end() fully uncorks
      if (state.corked) {
        state.corked = 1;
        this.uncork();
      }

      // ignore unnecessary end() calls.
      if (!state.ending && !state.finished) endWritable(this, state, cb);
    };

    function needFinish(state) {
      return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
    }

    function prefinish(stream, state) {
      if (!state.prefinished) {
        state.prefinished = true;
        stream.emit('prefinish');
      }
    }

    function finishMaybe(stream, state) {
      var need = needFinish(state);
      if (need) {
        if (state.pendingcb === 0) {
          prefinish(stream, state);
          state.finished = true;
          stream.emit('finish');
        } else {
          prefinish(stream, state);
        }
      }
      return need;
    }

    function endWritable(stream, state, cb) {
      state.ending = true;
      finishMaybe(stream, state);
      if (cb) {
        if (state.finished) nextTick$1(cb);else stream.once('finish', cb);
      }
      state.ended = true;
      stream.writable = false;
    }

    // It seems a linked list but it is not
    // there will be only 2 of these for each stream
    function CorkedRequest(state) {
      var _this = this;

      this.next = null;
      this.entry = null;

      this.finish = function (err) {
        var entry = _this.entry;
        _this.entry = null;
        while (entry) {
          var cb = entry.callback;
          state.pendingcb--;
          cb(err);
          entry = entry.next;
        }
        if (state.corkedRequestsFree) {
          state.corkedRequestsFree.next = _this;
        } else {
          state.corkedRequestsFree = _this;
        }
      };
    }

    inherits$g(Duplex, Readable);

    var keys = Object.keys(Writable.prototype);
    for (var v = 0; v < keys.length; v++) {
      var method = keys[v];
      if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
    }
    function Duplex(options) {
      if (!(this instanceof Duplex)) return new Duplex(options);

      Readable.call(this, options);
      Writable.call(this, options);

      if (options && options.readable === false) this.readable = false;

      if (options && options.writable === false) this.writable = false;

      this.allowHalfOpen = true;
      if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

      this.once('end', onend);
    }

    // the no-half-open enforcer
    function onend() {
      // if we allow half-open state, or if the writable side ended,
      // then we're ok.
      if (this.allowHalfOpen || this._writableState.ended) return;

      // no more data can be written.
      // But allow more writes to happen in this tick.
      nextTick$1(onEndNT, this);
    }

    function onEndNT(self) {
      self.end();
    }

    // a transform stream is a readable/writable stream where you do
    inherits$g(Transform$1, Duplex);

    function TransformState(stream) {
      this.afterTransform = function (er, data) {
        return afterTransform(stream, er, data);
      };

      this.needTransform = false;
      this.transforming = false;
      this.writecb = null;
      this.writechunk = null;
      this.writeencoding = null;
    }

    function afterTransform(stream, er, data) {
      var ts = stream._transformState;
      ts.transforming = false;

      var cb = ts.writecb;

      if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));

      ts.writechunk = null;
      ts.writecb = null;

      if (data !== null && data !== undefined) stream.push(data);

      cb(er);

      var rs = stream._readableState;
      rs.reading = false;
      if (rs.needReadable || rs.length < rs.highWaterMark) {
        stream._read(rs.highWaterMark);
      }
    }
    function Transform$1(options) {
      if (!(this instanceof Transform$1)) return new Transform$1(options);

      Duplex.call(this, options);

      this._transformState = new TransformState(this);

      // when the writable side finishes, then flush out anything remaining.
      var stream = this;

      // start out asking for a readable event once data is transformed.
      this._readableState.needReadable = true;

      // we have implemented the _read method, and done the other things
      // that Readable wants before the first _read call, so unset the
      // sync guard flag.
      this._readableState.sync = false;

      if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;

        if (typeof options.flush === 'function') this._flush = options.flush;
      }

      this.once('prefinish', function () {
        if (typeof this._flush === 'function') this._flush(function (er) {
          done(stream, er);
        });else done(stream);
      });
    }

    Transform$1.prototype.push = function (chunk, encoding) {
      this._transformState.needTransform = false;
      return Duplex.prototype.push.call(this, chunk, encoding);
    };

    // This is the part where you do stuff!
    // override this function in implementation classes.
    // 'chunk' is an input chunk.
    //
    // Call `push(newChunk)` to pass along transformed output
    // to the readable side.  You may call 'push' zero or more times.
    //
    // Call `cb(err)` when you are done with this chunk.  If you pass
    // an error, then that'll put the hurt on the whole operation.  If you
    // never call cb(), then you'll never get another chunk.
    Transform$1.prototype._transform = function (chunk, encoding, cb) {
      throw new Error('Not implemented');
    };

    Transform$1.prototype._write = function (chunk, encoding, cb) {
      var ts = this._transformState;
      ts.writecb = cb;
      ts.writechunk = chunk;
      ts.writeencoding = encoding;
      if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
      }
    };

    // Doesn't matter what the args are here.
    // _transform does all the work.
    // That we got here means that the readable side wants more data.
    Transform$1.prototype._read = function (n) {
      var ts = this._transformState;

      if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
      } else {
        // mark that we need a transform, so that any data that comes in
        // will get processed, now that we've asked for it.
        ts.needTransform = true;
      }
    };

    function done(stream, er) {
      if (er) return stream.emit('error', er);

      // if there's nothing in the write buffer, then that means
      // that nothing more will ever be provided
      var ws = stream._writableState;
      var ts = stream._transformState;

      if (ws.length) throw new Error('Calling transform done when ws.length != 0');

      if (ts.transforming) throw new Error('Calling transform done when still transforming');

      return stream.push(null);
    }

    inherits$g(PassThrough, Transform$1);
    function PassThrough(options) {
      if (!(this instanceof PassThrough)) return new PassThrough(options);

      Transform$1.call(this, options);
    }

    PassThrough.prototype._transform = function (chunk, encoding, cb) {
      cb(null, chunk);
    };

    inherits$g(Stream, EventEmitter);
    Stream.Readable = Readable;
    Stream.Writable = Writable;
    Stream.Duplex = Duplex;
    Stream.Transform = Transform$1;
    Stream.PassThrough = PassThrough;

    // Backwards-compat with node 0.4.x
    Stream.Stream = Stream;

    // old-style streams.  Note that the pipe method (the only relevant
    // part of this class) is overridden in the Readable class.

    function Stream() {
      EventEmitter.call(this);
    }

    Stream.prototype.pipe = function(dest, options) {
      var source = this;

      function ondata(chunk) {
        if (dest.writable) {
          if (false === dest.write(chunk) && source.pause) {
            source.pause();
          }
        }
      }

      source.on('data', ondata);

      function ondrain() {
        if (source.readable && source.resume) {
          source.resume();
        }
      }

      dest.on('drain', ondrain);

      // If the 'end' option is not supplied, dest.end() will be called when
      // source gets the 'end' or 'close' events.  Only dest.end() once.
      if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
      }

      var didOnEnd = false;
      function onend() {
        if (didOnEnd) return;
        didOnEnd = true;

        dest.end();
      }


      function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;

        if (typeof dest.destroy === 'function') dest.destroy();
      }

      // don't leave dangling pipes when there are errors.
      function onerror(er) {
        cleanup();
        if (EventEmitter.listenerCount(this, 'error') === 0) {
          throw er; // Unhandled stream error in pipe.
        }
      }

      source.on('error', onerror);
      dest.on('error', onerror);

      // remove all the event listeners that were added.
      function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);

        source.removeListener('end', onend);
        source.removeListener('close', onclose);

        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);

        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);

        dest.removeListener('close', cleanup);
      }

      source.on('end', cleanup);
      source.on('close', cleanup);

      dest.on('close', cleanup);

      dest.emit('pipe', source);

      // Allow for unix-like usage: A.pipe(B).pipe(C)
      return dest;
    };

    var _polyfillNode_stream = /*#__PURE__*/Object.freeze({
        __proto__: null,
        'default': Stream,
        Readable: Readable,
        Writable: Writable,
        Duplex: Duplex,
        Transform: Transform$1,
        PassThrough: PassThrough,
        Stream: Stream
    });

    var require$$1 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_stream);

    var Buffer$a = safeBufferExports.Buffer;
    var Transform = require$$1.Transform;
    var StringDecoder = require$$2$1.StringDecoder;
    var inherits$5 = require$$1$1;

    function CipherBase (hashMode) {
      Transform.call(this);
      this.hashMode = typeof hashMode === 'string';
      if (this.hashMode) {
        this[hashMode] = this._finalOrDigest;
      } else {
        this.final = this._finalOrDigest;
      }
      if (this._final) {
        this.__final = this._final;
        this._final = null;
      }
      this._decoder = null;
      this._encoding = null;
    }
    inherits$5(CipherBase, Transform);

    CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
      if (typeof data === 'string') {
        data = Buffer$a.from(data, inputEnc);
      }

      var outData = this._update(data);
      if (this.hashMode) return this

      if (outputEnc) {
        outData = this._toString(outData, outputEnc);
      }

      return outData
    };

    CipherBase.prototype.setAutoPadding = function () {};
    CipherBase.prototype.getAuthTag = function () {
      throw new Error('trying to get auth tag in unsupported state')
    };

    CipherBase.prototype.setAuthTag = function () {
      throw new Error('trying to set auth tag in unsupported state')
    };

    CipherBase.prototype.setAAD = function () {
      throw new Error('trying to set aad in unsupported state')
    };

    CipherBase.prototype._transform = function (data, _, next) {
      var err;
      try {
        if (this.hashMode) {
          this._update(data);
        } else {
          this.push(this._update(data));
        }
      } catch (e) {
        err = e;
      } finally {
        next(err);
      }
    };
    CipherBase.prototype._flush = function (done) {
      var err;
      try {
        this.push(this.__final());
      } catch (e) {
        err = e;
      }

      done(err);
    };
    CipherBase.prototype._finalOrDigest = function (outputEnc) {
      var outData = this.__final() || Buffer$a.alloc(0);
      if (outputEnc) {
        outData = this._toString(outData, outputEnc, true);
      }
      return outData
    };

    CipherBase.prototype._toString = function (value, enc, fin) {
      if (!this._decoder) {
        this._decoder = new StringDecoder(enc);
        this._encoding = enc;
      }

      if (this._encoding !== enc) throw new Error('can\'t switch encodings')

      var out = this._decoder.write(value);
      if (fin) {
        out += this._decoder.end();
      }

      return out
    };

    var cipherBase = CipherBase;

    var inherits$4 = require$$1$1;
    var MD5$1 = md5_js;
    var RIPEMD160$2 = ripemd160;
    var sha$2 = sha_jsExports;
    var Base$3 = cipherBase;

    function Hash (hash) {
      Base$3.call(this, 'digest');

      this._hash = hash;
    }

    inherits$4(Hash, Base$3);

    Hash.prototype._update = function (data) {
      this._hash.update(data);
    };

    Hash.prototype._final = function () {
      return this._hash.digest()
    };

    var browser$2 = function createHash (alg) {
      alg = alg.toLowerCase();
      if (alg === 'md5') return new MD5$1()
      if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160$2()

      return new Hash(sha$2(alg))
    };

    var browser$1 = {};

    var MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs

    var precondition = function (iterations, keylen) {
      if (typeof iterations !== 'number') {
        throw new TypeError('Iterations not a number')
      }

      if (iterations < 0) {
        throw new TypeError('Bad iterations')
      }

      if (typeof keylen !== 'number') {
        throw new TypeError('Key length not a number')
      }

      if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
        throw new TypeError('Bad key length')
      }
    };

    var defaultEncoding$2;
    /* istanbul ignore next */
    if (commonjsGlobal.process && commonjsGlobal.process.browser) {
      defaultEncoding$2 = 'utf-8';
    } else if (commonjsGlobal.process && commonjsGlobal.process.version) {
      var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10);

      defaultEncoding$2 = pVersionMajor >= 6 ? 'utf-8' : 'binary';
    } else {
      defaultEncoding$2 = 'utf-8';
    }
    var defaultEncoding_1 = defaultEncoding$2;

    var MD5 = md5_js;

    var md5$1 = function (buffer) {
      return new MD5().update(buffer).digest()
    };

    var Buffer$9 = safeBufferExports.Buffer;

    var toBuffer$2 = function (thing, encoding, name) {
      if (Buffer$9.isBuffer(thing)) {
        return thing
      } else if (typeof thing === 'string') {
        return Buffer$9.from(thing, encoding)
      } else if (ArrayBuffer.isView(thing)) {
        return Buffer$9.from(thing.buffer)
      } else {
        throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView')
      }
    };

    var md5 = md5$1;
    var RIPEMD160$1 = ripemd160;
    var sha$1 = sha_jsExports;
    var Buffer$8 = safeBufferExports.Buffer;

    var checkParameters$1 = precondition;
    var defaultEncoding$1 = defaultEncoding_1;
    var toBuffer$1 = toBuffer$2;

    var ZEROS = Buffer$8.alloc(128);
    var sizes = {
      md5: 16,
      sha1: 20,
      sha224: 28,
      sha256: 32,
      sha384: 48,
      sha512: 64,
      rmd160: 20,
      ripemd160: 20
    };

    function Hmac$1 (alg, key, saltLen) {
      var hash = getDigest(alg);
      var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64;

      if (key.length > blocksize) {
        key = hash(key);
      } else if (key.length < blocksize) {
        key = Buffer$8.concat([key, ZEROS], blocksize);
      }

      var ipad = Buffer$8.allocUnsafe(blocksize + sizes[alg]);
      var opad = Buffer$8.allocUnsafe(blocksize + sizes[alg]);
      for (var i = 0; i < blocksize; i++) {
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
      }

      var ipad1 = Buffer$8.allocUnsafe(blocksize + saltLen + 4);
      ipad.copy(ipad1, 0, 0, blocksize);
      this.ipad1 = ipad1;
      this.ipad2 = ipad;
      this.opad = opad;
      this.alg = alg;
      this.blocksize = blocksize;
      this.hash = hash;
      this.size = sizes[alg];
    }

    Hmac$1.prototype.run = function (data, ipad) {
      data.copy(ipad, this.blocksize);
      var h = this.hash(ipad);
      h.copy(this.opad, this.blocksize);
      return this.hash(this.opad)
    };

    function getDigest (alg) {
      function shaFunc (data) {
        return sha$1(alg).update(data).digest()
      }
      function rmd160Func (data) {
        return new RIPEMD160$1().update(data).digest()
      }

      if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
      if (alg === 'md5') return md5
      return shaFunc
    }

    function pbkdf2$1 (password, salt, iterations, keylen, digest) {
      checkParameters$1(iterations, keylen);
      password = toBuffer$1(password, defaultEncoding$1, 'Password');
      salt = toBuffer$1(salt, defaultEncoding$1, 'Salt');

      digest = digest || 'sha1';

      var hmac = new Hmac$1(digest, password, salt.length);

      var DK = Buffer$8.allocUnsafe(keylen);
      var block1 = Buffer$8.allocUnsafe(salt.length + 4);
      salt.copy(block1, 0, 0, salt.length);

      var destPos = 0;
      var hLen = sizes[digest];
      var l = Math.ceil(keylen / hLen);

      for (var i = 1; i <= l; i++) {
        block1.writeUInt32BE(i, salt.length);

        var T = hmac.run(block1, hmac.ipad1);
        var U = T;

        for (var j = 1; j < iterations; j++) {
          U = hmac.run(U, hmac.ipad2);
          for (var k = 0; k < hLen; k++) T[k] ^= U[k];
        }

        T.copy(DK, destPos);
        destPos += hLen;
      }

      return DK
    }

    var syncBrowser = pbkdf2$1;

    var Buffer$7 = safeBufferExports.Buffer;

    var checkParameters = precondition;
    var defaultEncoding = defaultEncoding_1;
    var sync = syncBrowser;
    var toBuffer = toBuffer$2;

    var ZERO_BUF;
    var subtle = commonjsGlobal.crypto && commonjsGlobal.crypto.subtle;
    var toBrowser = {
      sha: 'SHA-1',
      'sha-1': 'SHA-1',
      sha1: 'SHA-1',
      sha256: 'SHA-256',
      'sha-256': 'SHA-256',
      sha384: 'SHA-384',
      'sha-384': 'SHA-384',
      'sha-512': 'SHA-512',
      sha512: 'SHA-512'
    };
    var checks = [];
    function checkNative (algo) {
      if (commonjsGlobal.process && !commonjsGlobal.process.browser) {
        return Promise.resolve(false)
      }
      if (!subtle || !subtle.importKey || !subtle.deriveBits) {
        return Promise.resolve(false)
      }
      if (checks[algo] !== undefined) {
        return checks[algo]
      }
      ZERO_BUF = ZERO_BUF || Buffer$7.alloc(8);
      var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
        .then(function () {
          return true
        }).catch(function () {
          return false
        });
      checks[algo] = prom;
      return prom
    }
    var nextTick;
    function getNextTick () {
      if (nextTick) {
        return nextTick
      }
      if (commonjsGlobal.process && commonjsGlobal.process.nextTick) {
        nextTick = commonjsGlobal.process.nextTick;
      } else if (commonjsGlobal.queueMicrotask) {
        nextTick = commonjsGlobal.queueMicrotask;
      } else if (commonjsGlobal.setImmediate) {
        nextTick = commonjsGlobal.setImmediate;
      } else {
        nextTick = commonjsGlobal.setTimeout;
      }
      return nextTick
    }
    function browserPbkdf2 (password, salt, iterations, length, algo) {
      return subtle.importKey(
        'raw', password, { name: 'PBKDF2' }, false, ['deriveBits']
      ).then(function (key) {
        return subtle.deriveBits({
          name: 'PBKDF2',
          salt: salt,
          iterations: iterations,
          hash: {
            name: algo
          }
        }, key, length << 3)
      }).then(function (res) {
        return Buffer$7.from(res)
      })
    }

    function resolvePromise (promise, callback) {
      promise.then(function (out) {
        getNextTick()(function () {
          callback(null, out);
        });
      }, function (e) {
        getNextTick()(function () {
          callback(e);
        });
      });
    }
    var async = function (password, salt, iterations, keylen, digest, callback) {
      if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
      }

      digest = digest || 'sha1';
      var algo = toBrowser[digest.toLowerCase()];

      if (!algo || typeof commonjsGlobal.Promise !== 'function') {
        getNextTick()(function () {
          var out;
          try {
            out = sync(password, salt, iterations, keylen, digest);
          } catch (e) {
            return callback(e)
          }
          callback(null, out);
        });
        return
      }

      checkParameters(iterations, keylen);
      password = toBuffer(password, defaultEncoding, 'Password');
      salt = toBuffer(salt, defaultEncoding, 'Salt');
      if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')

      resolvePromise(checkNative(algo).then(function (resp) {
        if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

        return sync(password, salt, iterations, keylen, digest)
      }), callback);
    };

    browser$1.pbkdf2 = async;
    browser$1.pbkdf2Sync = syncBrowser;

    var browser = {exports: {}};

    // limit of Crypto.getRandomValues()
    // https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
    var MAX_BYTES = 65536;

    // Node supports requesting up to this number of bytes
    // https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
    var MAX_UINT32 = 4294967295;

    function oldBrowser () {
      throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
    }

    var Buffer$6 = safeBufferExports.Buffer;
    var crypto$3 = commonjsGlobal.crypto || commonjsGlobal.msCrypto;

    if (crypto$3 && crypto$3.getRandomValues) {
      browser.exports = randomBytes$1;
    } else {
      browser.exports = oldBrowser;
    }

    function randomBytes$1 (size, cb) {
      // phantomjs needs to throw
      if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

      var bytes = Buffer$6.allocUnsafe(size);

      if (size > 0) {  // getRandomValues fails on IE if size == 0
        if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
          // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
          for (var generated = 0; generated < size; generated += MAX_BYTES) {
            // buffer.slice automatically checks if the end is past the end of
            // the buffer so we don't have to here
            crypto$3.getRandomValues(bytes.slice(generated, generated + MAX_BYTES));
          }
        } else {
          crypto$3.getRandomValues(bytes);
        }
      }

      if (typeof cb === 'function') {
        return process.nextTick(function () {
          cb(null, bytes);
        })
      }

      return bytes
    }

    var browserExports = browser.exports;

    var unorm$1 = {exports: {}};

    unorm$1.exports;

    (function (module) {
    	(function (root) {

    	/***** unorm.js *****/

    	/*
    	 * UnicodeNormalizer 1.0.0
    	 * Copyright (c) 2008 Matsuza
    	 * Dual licensed under the MIT (MIT-LICENSE.txt) and GPL (GPL-LICENSE.txt) licenses.
    	 * $Date: 2008-06-05 16:44:17 +0200 (Thu, 05 Jun 2008) $
    	 * $Rev: 13309 $
    	 */

    	   var DEFAULT_FEATURE = [null, 0, {}];
    	   var CACHE_THRESHOLD = 10;
    	   var SBase = 0xAC00, LBase = 0x1100, VBase = 0x1161, TBase = 0x11A7, LCount = 19, VCount = 21, TCount = 28;
    	   var NCount = VCount * TCount; // 588
    	   var SCount = LCount * NCount; // 11172

    	   var UChar = function(cp, feature){
    	      this.codepoint = cp;
    	      this.feature = feature;
    	   };

    	   // Strategies
    	   var cache = {};
    	   var cacheCounter = [];
    	   for (var i = 0; i <= 0xFF; ++i){
    	      cacheCounter[i] = 0;
    	   }

    	   function fromCache(next, cp, needFeature){
    	      var ret = cache[cp];
    	      if(!ret){
    	         ret = next(cp, needFeature);
    	         if(!!ret.feature && ++cacheCounter[(cp >> 8) & 0xFF] > CACHE_THRESHOLD){
    	            cache[cp] = ret;
    	         }
    	      }
    	      return ret;
    	   }

    	   function fromData(next, cp, needFeature){
    	      var hash = cp & 0xFF00;
    	      var dunit = UChar.udata[hash] || {};
    	      var f = dunit[cp];
    	      return f ? new UChar(cp, f) : new UChar(cp, DEFAULT_FEATURE);
    	   }
    	   function fromCpOnly(next, cp, needFeature){
    	      return !!needFeature ? next(cp, needFeature) : new UChar(cp, null);
    	   }
    	   function fromRuleBasedJamo(next, cp, needFeature){
    	      var j;
    	      if(cp < LBase || (LBase + LCount <= cp && cp < SBase) || (SBase + SCount < cp)){
    	         return next(cp, needFeature);
    	      }
    	      if(LBase <= cp && cp < LBase + LCount){
    	         var c = {};
    	         var base = (cp - LBase) * VCount;
    	         for (j = 0; j < VCount; ++j){
    	            c[VBase + j] = SBase + TCount * (j + base);
    	         }
    	         return new UChar(cp, [,,c]);
    	      }

    	      var SIndex = cp - SBase;
    	      var TIndex = SIndex % TCount;
    	      var feature = [];
    	      if(TIndex !== 0){
    	         feature[0] = [SBase + SIndex - TIndex, TBase + TIndex];
    	      } else {
    	         feature[0] = [LBase + Math.floor(SIndex / NCount), VBase + Math.floor((SIndex % NCount) / TCount)];
    	         feature[2] = {};
    	         for (j = 1; j < TCount; ++j){
    	            feature[2][TBase + j] = cp + j;
    	         }
    	      }
    	      return new UChar(cp, feature);
    	   }
    	   function fromCpFilter(next, cp, needFeature){
    	      return cp < 60 || 13311 < cp && cp < 42607 ? new UChar(cp, DEFAULT_FEATURE) : next(cp, needFeature);
    	   }

    	   var strategies = [fromCpFilter, fromCache, fromCpOnly, fromRuleBasedJamo, fromData];

    	   UChar.fromCharCode = strategies.reduceRight(function (next, strategy) {
    	      return function (cp, needFeature) {
    	         return strategy(next, cp, needFeature);
    	      };
    	   }, null);

    	   UChar.isHighSurrogate = function(cp){
    	      return cp >= 0xD800 && cp <= 0xDBFF;
    	   };
    	   UChar.isLowSurrogate = function(cp){
    	      return cp >= 0xDC00 && cp <= 0xDFFF;
    	   };

    	   UChar.prototype.prepFeature = function(){
    	      if(!this.feature){
    	         this.feature = UChar.fromCharCode(this.codepoint, true).feature;
    	      }
    	   };

    	   UChar.prototype.toString = function(){
    	      if(this.codepoint < 0x10000){
    	         return String.fromCharCode(this.codepoint);
    	      } else {
    	         var x = this.codepoint - 0x10000;
    	         return String.fromCharCode(Math.floor(x / 0x400) + 0xD800, x % 0x400 + 0xDC00);
    	      }
    	   };

    	   UChar.prototype.getDecomp = function(){
    	      this.prepFeature();
    	      return this.feature[0] || null;
    	   };

    	   UChar.prototype.isCompatibility = function(){
    	      this.prepFeature();
    	      return !!this.feature[1] && (this.feature[1] & (1 << 8));
    	   };
    	   UChar.prototype.isExclude = function(){
    	      this.prepFeature();
    	      return !!this.feature[1] && (this.feature[1] & (1 << 9));
    	   };
    	   UChar.prototype.getCanonicalClass = function(){
    	      this.prepFeature();
    	      return !!this.feature[1] ? (this.feature[1] & 0xff) : 0;
    	   };
    	   UChar.prototype.getComposite = function(following){
    	      this.prepFeature();
    	      if(!this.feature[2]){
    	         return null;
    	      }
    	      var cp = this.feature[2][following.codepoint];
    	      return cp ? UChar.fromCharCode(cp) : null;
    	   };

    	   var UCharIterator = function(str){
    	      this.str = str;
    	      this.cursor = 0;
    	   };
    	   UCharIterator.prototype.next = function(){
    	      if(!!this.str && this.cursor < this.str.length){
    	         var cp = this.str.charCodeAt(this.cursor++);
    	         var d;
    	         if(UChar.isHighSurrogate(cp) && this.cursor < this.str.length && UChar.isLowSurrogate((d = this.str.charCodeAt(this.cursor)))){
    	            cp = (cp - 0xD800) * 0x400 + (d -0xDC00) + 0x10000;
    	            ++this.cursor;
    	         }
    	         return UChar.fromCharCode(cp);
    	      } else {
    	         this.str = null;
    	         return null;
    	      }
    	   };

    	   var RecursDecompIterator = function(it, cano){
    	      this.it = it;
    	      this.canonical = cano;
    	      this.resBuf = [];
    	   };

    	   RecursDecompIterator.prototype.next = function(){
    	      function recursiveDecomp(cano, uchar){
    	         var decomp = uchar.getDecomp();
    	         if(!!decomp && !(cano && uchar.isCompatibility())){
    	            var ret = [];
    	            for(var i = 0; i < decomp.length; ++i){
    	               var a = recursiveDecomp(cano, UChar.fromCharCode(decomp[i]));
    	                ret = ret.concat(a);
    	            }
    	            return ret;
    	         } else {
    	            return [uchar];
    	         }
    	      }
    	      if(this.resBuf.length === 0){
    	         var uchar = this.it.next();
    	         if(!uchar){
    	            return null;
    	         }
    	         this.resBuf = recursiveDecomp(this.canonical, uchar);
    	      }
    	      return this.resBuf.shift();
    	   };

    	   var DecompIterator = function(it){
    	      this.it = it;
    	      this.resBuf = [];
    	   };

    	   DecompIterator.prototype.next = function(){
    	      var cc;
    	      if(this.resBuf.length === 0){
    	         do{
    	            var uchar = this.it.next();
    	            if(!uchar){
    	               break;
    	            }
    	            cc = uchar.getCanonicalClass();
    	            var inspt = this.resBuf.length;
    	            if(cc !== 0){
    	               for(; inspt > 0; --inspt){
    	                  var uchar2 = this.resBuf[inspt - 1];
    	                  var cc2 = uchar2.getCanonicalClass();
    	                  if(cc2 <= cc){
    	                     break;
    	                  }
    	               }
    	            }
    	            this.resBuf.splice(inspt, 0, uchar);
    	         } while(cc !== 0);
    	      }
    	      return this.resBuf.shift();
    	   };

    	   var CompIterator = function(it){
    	      this.it = it;
    	      this.procBuf = [];
    	      this.resBuf = [];
    	      this.lastClass = null;
    	   };

    	   CompIterator.prototype.next = function(){
    	      while(this.resBuf.length === 0){
    	         var uchar = this.it.next();
    	         if(!uchar){
    	            this.resBuf = this.procBuf;
    	            this.procBuf = [];
    	            break;
    	         }
    	         if(this.procBuf.length === 0){
    	            this.lastClass = uchar.getCanonicalClass();
    	            this.procBuf.push(uchar);
    	         } else {
    	            var starter = this.procBuf[0];
    	            var composite = starter.getComposite(uchar);
    	            var cc = uchar.getCanonicalClass();
    	            if(!!composite && (this.lastClass < cc || this.lastClass === 0)){
    	               this.procBuf[0] = composite;
    	            } else {
    	               if(cc === 0){
    	                  this.resBuf = this.procBuf;
    	                  this.procBuf = [];
    	               }
    	               this.lastClass = cc;
    	               this.procBuf.push(uchar);
    	            }
    	         }
    	      }
    	      return this.resBuf.shift();
    	   };

    	   var createIterator = function(mode, str){
    	      switch(mode){
    	         case "NFD":
    	            return new DecompIterator(new RecursDecompIterator(new UCharIterator(str), true));
    	         case "NFKD":
    	            return new DecompIterator(new RecursDecompIterator(new UCharIterator(str), false));
    	         case "NFC":
    	            return new CompIterator(new DecompIterator(new RecursDecompIterator(new UCharIterator(str), true)));
    	         case "NFKC":
    	            return new CompIterator(new DecompIterator(new RecursDecompIterator(new UCharIterator(str), false)));
    	      }
    	      throw mode + " is invalid";
    	   };
    	   var normalize = function(mode, str){
    	      var it = createIterator(mode, str);
    	      var ret = "";
    	      var uchar;
    	      while(!!(uchar = it.next())){
    	         ret += uchar.toString();
    	      }
    	      return ret;
    	   };

    	   /* API functions */
    	   function nfd(str){
    	      return normalize("NFD", str);
    	   }

    	   function nfkd(str){
    	      return normalize("NFKD", str);
    	   }

    	   function nfc(str){
    	      return normalize("NFC", str);
    	   }

    	   function nfkc(str){
    	      return normalize("NFKC", str);
    	   }

    	/* Unicode data */
    	UChar.udata={
    	0:{60:[,,{824:8814}],61:[,,{824:8800}],62:[,,{824:8815}],65:[,,{768:192,769:193,770:194,771:195,772:256,774:258,775:550,776:196,777:7842,778:197,780:461,783:512,785:514,803:7840,805:7680,808:260}],66:[,,{775:7682,803:7684,817:7686}],67:[,,{769:262,770:264,775:266,780:268,807:199}],68:[,,{775:7690,780:270,803:7692,807:7696,813:7698,817:7694}],69:[,,{768:200,769:201,770:202,771:7868,772:274,774:276,775:278,776:203,777:7866,780:282,783:516,785:518,803:7864,807:552,808:280,813:7704,816:7706}],70:[,,{775:7710}],71:[,,{769:500,770:284,772:7712,774:286,775:288,780:486,807:290}],72:[,,{770:292,775:7714,776:7718,780:542,803:7716,807:7720,814:7722}],73:[,,{768:204,769:205,770:206,771:296,772:298,774:300,775:304,776:207,777:7880,780:463,783:520,785:522,803:7882,808:302,816:7724}],74:[,,{770:308}],75:[,,{769:7728,780:488,803:7730,807:310,817:7732}],76:[,,{769:313,780:317,803:7734,807:315,813:7740,817:7738}],77:[,,{769:7742,775:7744,803:7746}],78:[,,{768:504,769:323,771:209,775:7748,780:327,803:7750,807:325,813:7754,817:7752}],79:[,,{768:210,769:211,770:212,771:213,772:332,774:334,775:558,776:214,777:7886,779:336,780:465,783:524,785:526,795:416,803:7884,808:490}],80:[,,{769:7764,775:7766}],82:[,,{769:340,775:7768,780:344,783:528,785:530,803:7770,807:342,817:7774}],83:[,,{769:346,770:348,775:7776,780:352,803:7778,806:536,807:350}],84:[,,{775:7786,780:356,803:7788,806:538,807:354,813:7792,817:7790}],85:[,,{768:217,769:218,770:219,771:360,772:362,774:364,776:220,777:7910,778:366,779:368,780:467,783:532,785:534,795:431,803:7908,804:7794,808:370,813:7798,816:7796}],86:[,,{771:7804,803:7806}],87:[,,{768:7808,769:7810,770:372,775:7814,776:7812,803:7816}],88:[,,{775:7818,776:7820}],89:[,,{768:7922,769:221,770:374,771:7928,772:562,775:7822,776:376,777:7926,803:7924}],90:[,,{769:377,770:7824,775:379,780:381,803:7826,817:7828}],97:[,,{768:224,769:225,770:226,771:227,772:257,774:259,775:551,776:228,777:7843,778:229,780:462,783:513,785:515,803:7841,805:7681,808:261}],98:[,,{775:7683,803:7685,817:7687}],99:[,,{769:263,770:265,775:267,780:269,807:231}],100:[,,{775:7691,780:271,803:7693,807:7697,813:7699,817:7695}],101:[,,{768:232,769:233,770:234,771:7869,772:275,774:277,775:279,776:235,777:7867,780:283,783:517,785:519,803:7865,807:553,808:281,813:7705,816:7707}],102:[,,{775:7711}],103:[,,{769:501,770:285,772:7713,774:287,775:289,780:487,807:291}],104:[,,{770:293,775:7715,776:7719,780:543,803:7717,807:7721,814:7723,817:7830}],105:[,,{768:236,769:237,770:238,771:297,772:299,774:301,776:239,777:7881,780:464,783:521,785:523,803:7883,808:303,816:7725}],106:[,,{770:309,780:496}],107:[,,{769:7729,780:489,803:7731,807:311,817:7733}],108:[,,{769:314,780:318,803:7735,807:316,813:7741,817:7739}],109:[,,{769:7743,775:7745,803:7747}],110:[,,{768:505,769:324,771:241,775:7749,780:328,803:7751,807:326,813:7755,817:7753}],111:[,,{768:242,769:243,770:244,771:245,772:333,774:335,775:559,776:246,777:7887,779:337,780:466,783:525,785:527,795:417,803:7885,808:491}],112:[,,{769:7765,775:7767}],114:[,,{769:341,775:7769,780:345,783:529,785:531,803:7771,807:343,817:7775}],115:[,,{769:347,770:349,775:7777,780:353,803:7779,806:537,807:351}],116:[,,{775:7787,776:7831,780:357,803:7789,806:539,807:355,813:7793,817:7791}],117:[,,{768:249,769:250,770:251,771:361,772:363,774:365,776:252,777:7911,778:367,779:369,780:468,783:533,785:535,795:432,803:7909,804:7795,808:371,813:7799,816:7797}],118:[,,{771:7805,803:7807}],119:[,,{768:7809,769:7811,770:373,775:7815,776:7813,778:7832,803:7817}],120:[,,{775:7819,776:7821}],121:[,,{768:7923,769:253,770:375,771:7929,772:563,775:7823,776:255,777:7927,778:7833,803:7925}],122:[,,{769:378,770:7825,775:380,780:382,803:7827,817:7829}],160:[[32],256],168:[[32,776],256,{768:8173,769:901,834:8129}],170:[[97],256],175:[[32,772],256],178:[[50],256],179:[[51],256],180:[[32,769],256],181:[[956],256],184:[[32,807],256],185:[[49],256],186:[[111],256],188:[[49,8260,52],256],189:[[49,8260,50],256],190:[[51,8260,52],256],192:[[65,768]],193:[[65,769]],194:[[65,770],,{768:7846,769:7844,771:7850,777:7848}],195:[[65,771]],196:[[65,776],,{772:478}],197:[[65,778],,{769:506}],198:[,,{769:508,772:482}],199:[[67,807],,{769:7688}],200:[[69,768]],201:[[69,769]],202:[[69,770],,{768:7872,769:7870,771:7876,777:7874}],203:[[69,776]],204:[[73,768]],205:[[73,769]],206:[[73,770]],207:[[73,776],,{769:7726}],209:[[78,771]],210:[[79,768]],211:[[79,769]],212:[[79,770],,{768:7890,769:7888,771:7894,777:7892}],213:[[79,771],,{769:7756,772:556,776:7758}],214:[[79,776],,{772:554}],216:[,,{769:510}],217:[[85,768]],218:[[85,769]],219:[[85,770]],220:[[85,776],,{768:475,769:471,772:469,780:473}],221:[[89,769]],224:[[97,768]],225:[[97,769]],226:[[97,770],,{768:7847,769:7845,771:7851,777:7849}],227:[[97,771]],228:[[97,776],,{772:479}],229:[[97,778],,{769:507}],230:[,,{769:509,772:483}],231:[[99,807],,{769:7689}],232:[[101,768]],233:[[101,769]],234:[[101,770],,{768:7873,769:7871,771:7877,777:7875}],235:[[101,776]],236:[[105,768]],237:[[105,769]],238:[[105,770]],239:[[105,776],,{769:7727}],241:[[110,771]],242:[[111,768]],243:[[111,769]],244:[[111,770],,{768:7891,769:7889,771:7895,777:7893}],245:[[111,771],,{769:7757,772:557,776:7759}],246:[[111,776],,{772:555}],248:[,,{769:511}],249:[[117,768]],250:[[117,769]],251:[[117,770]],252:[[117,776],,{768:476,769:472,772:470,780:474}],253:[[121,769]],255:[[121,776]]},
    	256:{256:[[65,772]],257:[[97,772]],258:[[65,774],,{768:7856,769:7854,771:7860,777:7858}],259:[[97,774],,{768:7857,769:7855,771:7861,777:7859}],260:[[65,808]],261:[[97,808]],262:[[67,769]],263:[[99,769]],264:[[67,770]],265:[[99,770]],266:[[67,775]],267:[[99,775]],268:[[67,780]],269:[[99,780]],270:[[68,780]],271:[[100,780]],274:[[69,772],,{768:7700,769:7702}],275:[[101,772],,{768:7701,769:7703}],276:[[69,774]],277:[[101,774]],278:[[69,775]],279:[[101,775]],280:[[69,808]],281:[[101,808]],282:[[69,780]],283:[[101,780]],284:[[71,770]],285:[[103,770]],286:[[71,774]],287:[[103,774]],288:[[71,775]],289:[[103,775]],290:[[71,807]],291:[[103,807]],292:[[72,770]],293:[[104,770]],296:[[73,771]],297:[[105,771]],298:[[73,772]],299:[[105,772]],300:[[73,774]],301:[[105,774]],302:[[73,808]],303:[[105,808]],304:[[73,775]],306:[[73,74],256],307:[[105,106],256],308:[[74,770]],309:[[106,770]],310:[[75,807]],311:[[107,807]],313:[[76,769]],314:[[108,769]],315:[[76,807]],316:[[108,807]],317:[[76,780]],318:[[108,780]],319:[[76,183],256],320:[[108,183],256],323:[[78,769]],324:[[110,769]],325:[[78,807]],326:[[110,807]],327:[[78,780]],328:[[110,780]],329:[[700,110],256],332:[[79,772],,{768:7760,769:7762}],333:[[111,772],,{768:7761,769:7763}],334:[[79,774]],335:[[111,774]],336:[[79,779]],337:[[111,779]],340:[[82,769]],341:[[114,769]],342:[[82,807]],343:[[114,807]],344:[[82,780]],345:[[114,780]],346:[[83,769],,{775:7780}],347:[[115,769],,{775:7781}],348:[[83,770]],349:[[115,770]],350:[[83,807]],351:[[115,807]],352:[[83,780],,{775:7782}],353:[[115,780],,{775:7783}],354:[[84,807]],355:[[116,807]],356:[[84,780]],357:[[116,780]],360:[[85,771],,{769:7800}],361:[[117,771],,{769:7801}],362:[[85,772],,{776:7802}],363:[[117,772],,{776:7803}],364:[[85,774]],365:[[117,774]],366:[[85,778]],367:[[117,778]],368:[[85,779]],369:[[117,779]],370:[[85,808]],371:[[117,808]],372:[[87,770]],373:[[119,770]],374:[[89,770]],375:[[121,770]],376:[[89,776]],377:[[90,769]],378:[[122,769]],379:[[90,775]],380:[[122,775]],381:[[90,780]],382:[[122,780]],383:[[115],256,{775:7835}],416:[[79,795],,{768:7900,769:7898,771:7904,777:7902,803:7906}],417:[[111,795],,{768:7901,769:7899,771:7905,777:7903,803:7907}],431:[[85,795],,{768:7914,769:7912,771:7918,777:7916,803:7920}],432:[[117,795],,{768:7915,769:7913,771:7919,777:7917,803:7921}],439:[,,{780:494}],452:[[68,381],256],453:[[68,382],256],454:[[100,382],256],455:[[76,74],256],456:[[76,106],256],457:[[108,106],256],458:[[78,74],256],459:[[78,106],256],460:[[110,106],256],461:[[65,780]],462:[[97,780]],463:[[73,780]],464:[[105,780]],465:[[79,780]],466:[[111,780]],467:[[85,780]],468:[[117,780]],469:[[220,772]],470:[[252,772]],471:[[220,769]],472:[[252,769]],473:[[220,780]],474:[[252,780]],475:[[220,768]],476:[[252,768]],478:[[196,772]],479:[[228,772]],480:[[550,772]],481:[[551,772]],482:[[198,772]],483:[[230,772]],486:[[71,780]],487:[[103,780]],488:[[75,780]],489:[[107,780]],490:[[79,808],,{772:492}],491:[[111,808],,{772:493}],492:[[490,772]],493:[[491,772]],494:[[439,780]],495:[[658,780]],496:[[106,780]],497:[[68,90],256],498:[[68,122],256],499:[[100,122],256],500:[[71,769]],501:[[103,769]],504:[[78,768]],505:[[110,768]],506:[[197,769]],507:[[229,769]],508:[[198,769]],509:[[230,769]],510:[[216,769]],511:[[248,769]],66045:[,220]},
    	512:{512:[[65,783]],513:[[97,783]],514:[[65,785]],515:[[97,785]],516:[[69,783]],517:[[101,783]],518:[[69,785]],519:[[101,785]],520:[[73,783]],521:[[105,783]],522:[[73,785]],523:[[105,785]],524:[[79,783]],525:[[111,783]],526:[[79,785]],527:[[111,785]],528:[[82,783]],529:[[114,783]],530:[[82,785]],531:[[114,785]],532:[[85,783]],533:[[117,783]],534:[[85,785]],535:[[117,785]],536:[[83,806]],537:[[115,806]],538:[[84,806]],539:[[116,806]],542:[[72,780]],543:[[104,780]],550:[[65,775],,{772:480}],551:[[97,775],,{772:481}],552:[[69,807],,{774:7708}],553:[[101,807],,{774:7709}],554:[[214,772]],555:[[246,772]],556:[[213,772]],557:[[245,772]],558:[[79,775],,{772:560}],559:[[111,775],,{772:561}],560:[[558,772]],561:[[559,772]],562:[[89,772]],563:[[121,772]],658:[,,{780:495}],688:[[104],256],689:[[614],256],690:[[106],256],691:[[114],256],692:[[633],256],693:[[635],256],694:[[641],256],695:[[119],256],696:[[121],256],728:[[32,774],256],729:[[32,775],256],730:[[32,778],256],731:[[32,808],256],732:[[32,771],256],733:[[32,779],256],736:[[611],256],737:[[108],256],738:[[115],256],739:[[120],256],740:[[661],256],66272:[,220]},
    	768:{768:[,230],769:[,230],770:[,230],771:[,230],772:[,230],773:[,230],774:[,230],775:[,230],776:[,230,{769:836}],777:[,230],778:[,230],779:[,230],780:[,230],781:[,230],782:[,230],783:[,230],784:[,230],785:[,230],786:[,230],787:[,230],788:[,230],789:[,232],790:[,220],791:[,220],792:[,220],793:[,220],794:[,232],795:[,216],796:[,220],797:[,220],798:[,220],799:[,220],800:[,220],801:[,202],802:[,202],803:[,220],804:[,220],805:[,220],806:[,220],807:[,202],808:[,202],809:[,220],810:[,220],811:[,220],812:[,220],813:[,220],814:[,220],815:[,220],816:[,220],817:[,220],818:[,220],819:[,220],820:[,1],821:[,1],822:[,1],823:[,1],824:[,1],825:[,220],826:[,220],827:[,220],828:[,220],829:[,230],830:[,230],831:[,230],832:[[768],230],833:[[769],230],834:[,230],835:[[787],230],836:[[776,769],230],837:[,240],838:[,230],839:[,220],840:[,220],841:[,220],842:[,230],843:[,230],844:[,230],845:[,220],846:[,220],848:[,230],849:[,230],850:[,230],851:[,220],852:[,220],853:[,220],854:[,220],855:[,230],856:[,232],857:[,220],858:[,220],859:[,230],860:[,233],861:[,234],862:[,234],863:[,233],864:[,234],865:[,234],866:[,233],867:[,230],868:[,230],869:[,230],870:[,230],871:[,230],872:[,230],873:[,230],874:[,230],875:[,230],876:[,230],877:[,230],878:[,230],879:[,230],884:[[697]],890:[[32,837],256],894:[[59]],900:[[32,769],256],901:[[168,769]],902:[[913,769]],903:[[183]],904:[[917,769]],905:[[919,769]],906:[[921,769]],908:[[927,769]],910:[[933,769]],911:[[937,769]],912:[[970,769]],913:[,,{768:8122,769:902,772:8121,774:8120,787:7944,788:7945,837:8124}],917:[,,{768:8136,769:904,787:7960,788:7961}],919:[,,{768:8138,769:905,787:7976,788:7977,837:8140}],921:[,,{768:8154,769:906,772:8153,774:8152,776:938,787:7992,788:7993}],927:[,,{768:8184,769:908,787:8008,788:8009}],929:[,,{788:8172}],933:[,,{768:8170,769:910,772:8169,774:8168,776:939,788:8025}],937:[,,{768:8186,769:911,787:8040,788:8041,837:8188}],938:[[921,776]],939:[[933,776]],940:[[945,769],,{837:8116}],941:[[949,769]],942:[[951,769],,{837:8132}],943:[[953,769]],944:[[971,769]],945:[,,{768:8048,769:940,772:8113,774:8112,787:7936,788:7937,834:8118,837:8115}],949:[,,{768:8050,769:941,787:7952,788:7953}],951:[,,{768:8052,769:942,787:7968,788:7969,834:8134,837:8131}],953:[,,{768:8054,769:943,772:8145,774:8144,776:970,787:7984,788:7985,834:8150}],959:[,,{768:8056,769:972,787:8000,788:8001}],961:[,,{787:8164,788:8165}],965:[,,{768:8058,769:973,772:8161,774:8160,776:971,787:8016,788:8017,834:8166}],969:[,,{768:8060,769:974,787:8032,788:8033,834:8182,837:8179}],970:[[953,776],,{768:8146,769:912,834:8151}],971:[[965,776],,{768:8162,769:944,834:8167}],972:[[959,769]],973:[[965,769]],974:[[969,769],,{837:8180}],976:[[946],256],977:[[952],256],978:[[933],256,{769:979,776:980}],979:[[978,769]],980:[[978,776]],981:[[966],256],982:[[960],256],1008:[[954],256],1009:[[961],256],1010:[[962],256],1012:[[920],256],1013:[[949],256],1017:[[931],256],66422:[,230],66423:[,230],66424:[,230],66425:[,230],66426:[,230]},
    	1024:{1024:[[1045,768]],1025:[[1045,776]],1027:[[1043,769]],1030:[,,{776:1031}],1031:[[1030,776]],1036:[[1050,769]],1037:[[1048,768]],1038:[[1059,774]],1040:[,,{774:1232,776:1234}],1043:[,,{769:1027}],1045:[,,{768:1024,774:1238,776:1025}],1046:[,,{774:1217,776:1244}],1047:[,,{776:1246}],1048:[,,{768:1037,772:1250,774:1049,776:1252}],1049:[[1048,774]],1050:[,,{769:1036}],1054:[,,{776:1254}],1059:[,,{772:1262,774:1038,776:1264,779:1266}],1063:[,,{776:1268}],1067:[,,{776:1272}],1069:[,,{776:1260}],1072:[,,{774:1233,776:1235}],1075:[,,{769:1107}],1077:[,,{768:1104,774:1239,776:1105}],1078:[,,{774:1218,776:1245}],1079:[,,{776:1247}],1080:[,,{768:1117,772:1251,774:1081,776:1253}],1081:[[1080,774]],1082:[,,{769:1116}],1086:[,,{776:1255}],1091:[,,{772:1263,774:1118,776:1265,779:1267}],1095:[,,{776:1269}],1099:[,,{776:1273}],1101:[,,{776:1261}],1104:[[1077,768]],1105:[[1077,776]],1107:[[1075,769]],1110:[,,{776:1111}],1111:[[1110,776]],1116:[[1082,769]],1117:[[1080,768]],1118:[[1091,774]],1140:[,,{783:1142}],1141:[,,{783:1143}],1142:[[1140,783]],1143:[[1141,783]],1155:[,230],1156:[,230],1157:[,230],1158:[,230],1159:[,230],1217:[[1046,774]],1218:[[1078,774]],1232:[[1040,774]],1233:[[1072,774]],1234:[[1040,776]],1235:[[1072,776]],1238:[[1045,774]],1239:[[1077,774]],1240:[,,{776:1242}],1241:[,,{776:1243}],1242:[[1240,776]],1243:[[1241,776]],1244:[[1046,776]],1245:[[1078,776]],1246:[[1047,776]],1247:[[1079,776]],1250:[[1048,772]],1251:[[1080,772]],1252:[[1048,776]],1253:[[1080,776]],1254:[[1054,776]],1255:[[1086,776]],1256:[,,{776:1258}],1257:[,,{776:1259}],1258:[[1256,776]],1259:[[1257,776]],1260:[[1069,776]],1261:[[1101,776]],1262:[[1059,772]],1263:[[1091,772]],1264:[[1059,776]],1265:[[1091,776]],1266:[[1059,779]],1267:[[1091,779]],1268:[[1063,776]],1269:[[1095,776]],1272:[[1067,776]],1273:[[1099,776]]},
    	1280:{1415:[[1381,1410],256],1425:[,220],1426:[,230],1427:[,230],1428:[,230],1429:[,230],1430:[,220],1431:[,230],1432:[,230],1433:[,230],1434:[,222],1435:[,220],1436:[,230],1437:[,230],1438:[,230],1439:[,230],1440:[,230],1441:[,230],1442:[,220],1443:[,220],1444:[,220],1445:[,220],1446:[,220],1447:[,220],1448:[,230],1449:[,230],1450:[,220],1451:[,230],1452:[,230],1453:[,222],1454:[,228],1455:[,230],1456:[,10],1457:[,11],1458:[,12],1459:[,13],1460:[,14],1461:[,15],1462:[,16],1463:[,17],1464:[,18],1465:[,19],1466:[,19],1467:[,20],1468:[,21],1469:[,22],1471:[,23],1473:[,24],1474:[,25],1476:[,230],1477:[,220],1479:[,18]},
    	1536:{1552:[,230],1553:[,230],1554:[,230],1555:[,230],1556:[,230],1557:[,230],1558:[,230],1559:[,230],1560:[,30],1561:[,31],1562:[,32],1570:[[1575,1619]],1571:[[1575,1620]],1572:[[1608,1620]],1573:[[1575,1621]],1574:[[1610,1620]],1575:[,,{1619:1570,1620:1571,1621:1573}],1608:[,,{1620:1572}],1610:[,,{1620:1574}],1611:[,27],1612:[,28],1613:[,29],1614:[,30],1615:[,31],1616:[,32],1617:[,33],1618:[,34],1619:[,230],1620:[,230],1621:[,220],1622:[,220],1623:[,230],1624:[,230],1625:[,230],1626:[,230],1627:[,230],1628:[,220],1629:[,230],1630:[,230],1631:[,220],1648:[,35],1653:[[1575,1652],256],1654:[[1608,1652],256],1655:[[1735,1652],256],1656:[[1610,1652],256],1728:[[1749,1620]],1729:[,,{1620:1730}],1730:[[1729,1620]],1746:[,,{1620:1747}],1747:[[1746,1620]],1749:[,,{1620:1728}],1750:[,230],1751:[,230],1752:[,230],1753:[,230],1754:[,230],1755:[,230],1756:[,230],1759:[,230],1760:[,230],1761:[,230],1762:[,230],1763:[,220],1764:[,230],1767:[,230],1768:[,230],1770:[,220],1771:[,230],1772:[,230],1773:[,220]},
    	1792:{1809:[,36],1840:[,230],1841:[,220],1842:[,230],1843:[,230],1844:[,220],1845:[,230],1846:[,230],1847:[,220],1848:[,220],1849:[,220],1850:[,230],1851:[,220],1852:[,220],1853:[,230],1854:[,220],1855:[,230],1856:[,230],1857:[,230],1858:[,220],1859:[,230],1860:[,220],1861:[,230],1862:[,220],1863:[,230],1864:[,220],1865:[,230],1866:[,230],2027:[,230],2028:[,230],2029:[,230],2030:[,230],2031:[,230],2032:[,230],2033:[,230],2034:[,220],2035:[,230]},
    	2048:{2070:[,230],2071:[,230],2072:[,230],2073:[,230],2075:[,230],2076:[,230],2077:[,230],2078:[,230],2079:[,230],2080:[,230],2081:[,230],2082:[,230],2083:[,230],2085:[,230],2086:[,230],2087:[,230],2089:[,230],2090:[,230],2091:[,230],2092:[,230],2093:[,230],2137:[,220],2138:[,220],2139:[,220],2276:[,230],2277:[,230],2278:[,220],2279:[,230],2280:[,230],2281:[,220],2282:[,230],2283:[,230],2284:[,230],2285:[,220],2286:[,220],2287:[,220],2288:[,27],2289:[,28],2290:[,29],2291:[,230],2292:[,230],2293:[,230],2294:[,220],2295:[,230],2296:[,230],2297:[,220],2298:[,220],2299:[,230],2300:[,230],2301:[,230],2302:[,230],2303:[,230]},
    	2304:{2344:[,,{2364:2345}],2345:[[2344,2364]],2352:[,,{2364:2353}],2353:[[2352,2364]],2355:[,,{2364:2356}],2356:[[2355,2364]],2364:[,7],2381:[,9],2385:[,230],2386:[,220],2387:[,230],2388:[,230],2392:[[2325,2364],512],2393:[[2326,2364],512],2394:[[2327,2364],512],2395:[[2332,2364],512],2396:[[2337,2364],512],2397:[[2338,2364],512],2398:[[2347,2364],512],2399:[[2351,2364],512],2492:[,7],2503:[,,{2494:2507,2519:2508}],2507:[[2503,2494]],2508:[[2503,2519]],2509:[,9],2524:[[2465,2492],512],2525:[[2466,2492],512],2527:[[2479,2492],512]},
    	2560:{2611:[[2610,2620],512],2614:[[2616,2620],512],2620:[,7],2637:[,9],2649:[[2582,2620],512],2650:[[2583,2620],512],2651:[[2588,2620],512],2654:[[2603,2620],512],2748:[,7],2765:[,9],68109:[,220],68111:[,230],68152:[,230],68153:[,1],68154:[,220],68159:[,9],68325:[,230],68326:[,220]},
    	2816:{2876:[,7],2887:[,,{2878:2891,2902:2888,2903:2892}],2888:[[2887,2902]],2891:[[2887,2878]],2892:[[2887,2903]],2893:[,9],2908:[[2849,2876],512],2909:[[2850,2876],512],2962:[,,{3031:2964}],2964:[[2962,3031]],3014:[,,{3006:3018,3031:3020}],3015:[,,{3006:3019}],3018:[[3014,3006]],3019:[[3015,3006]],3020:[[3014,3031]],3021:[,9]},
    	3072:{3142:[,,{3158:3144}],3144:[[3142,3158]],3149:[,9],3157:[,84],3158:[,91],3260:[,7],3263:[,,{3285:3264}],3264:[[3263,3285]],3270:[,,{3266:3274,3285:3271,3286:3272}],3271:[[3270,3285]],3272:[[3270,3286]],3274:[[3270,3266],,{3285:3275}],3275:[[3274,3285]],3277:[,9]},
    	3328:{3398:[,,{3390:3402,3415:3404}],3399:[,,{3390:3403}],3402:[[3398,3390]],3403:[[3399,3390]],3404:[[3398,3415]],3405:[,9],3530:[,9],3545:[,,{3530:3546,3535:3548,3551:3550}],3546:[[3545,3530]],3548:[[3545,3535],,{3530:3549}],3549:[[3548,3530]],3550:[[3545,3551]]},
    	3584:{3635:[[3661,3634],256],3640:[,103],3641:[,103],3642:[,9],3656:[,107],3657:[,107],3658:[,107],3659:[,107],3763:[[3789,3762],256],3768:[,118],3769:[,118],3784:[,122],3785:[,122],3786:[,122],3787:[,122],3804:[[3755,3737],256],3805:[[3755,3745],256]},
    	3840:{3852:[[3851],256],3864:[,220],3865:[,220],3893:[,220],3895:[,220],3897:[,216],3907:[[3906,4023],512],3917:[[3916,4023],512],3922:[[3921,4023],512],3927:[[3926,4023],512],3932:[[3931,4023],512],3945:[[3904,4021],512],3953:[,129],3954:[,130],3955:[[3953,3954],512],3956:[,132],3957:[[3953,3956],512],3958:[[4018,3968],512],3959:[[4018,3969],256],3960:[[4019,3968],512],3961:[[4019,3969],256],3962:[,130],3963:[,130],3964:[,130],3965:[,130],3968:[,130],3969:[[3953,3968],512],3970:[,230],3971:[,230],3972:[,9],3974:[,230],3975:[,230],3987:[[3986,4023],512],3997:[[3996,4023],512],4002:[[4001,4023],512],4007:[[4006,4023],512],4012:[[4011,4023],512],4025:[[3984,4021],512],4038:[,220]},
    	4096:{4133:[,,{4142:4134}],4134:[[4133,4142]],4151:[,7],4153:[,9],4154:[,9],4237:[,220],4348:[[4316],256],69702:[,9],69759:[,9],69785:[,,{69818:69786}],69786:[[69785,69818]],69787:[,,{69818:69788}],69788:[[69787,69818]],69797:[,,{69818:69803}],69803:[[69797,69818]],69817:[,9],69818:[,7]},
    	4352:{69888:[,230],69889:[,230],69890:[,230],69934:[[69937,69927]],69935:[[69938,69927]],69937:[,,{69927:69934}],69938:[,,{69927:69935}],69939:[,9],69940:[,9],70003:[,7],70080:[,9]},
    	4608:{70197:[,9],70198:[,7],70377:[,7],70378:[,9]},
    	4864:{4957:[,230],4958:[,230],4959:[,230],70460:[,7],70471:[,,{70462:70475,70487:70476}],70475:[[70471,70462]],70476:[[70471,70487]],70477:[,9],70502:[,230],70503:[,230],70504:[,230],70505:[,230],70506:[,230],70507:[,230],70508:[,230],70512:[,230],70513:[,230],70514:[,230],70515:[,230],70516:[,230]},
    	5120:{70841:[,,{70832:70844,70842:70843,70845:70846}],70843:[[70841,70842]],70844:[[70841,70832]],70846:[[70841,70845]],70850:[,9],70851:[,7]},
    	5376:{71096:[,,{71087:71098}],71097:[,,{71087:71099}],71098:[[71096,71087]],71099:[[71097,71087]],71103:[,9],71104:[,7]},
    	5632:{71231:[,9],71350:[,9],71351:[,7]},
    	5888:{5908:[,9],5940:[,9],6098:[,9],6109:[,230]},
    	6144:{6313:[,228]},
    	6400:{6457:[,222],6458:[,230],6459:[,220]},
    	6656:{6679:[,230],6680:[,220],6752:[,9],6773:[,230],6774:[,230],6775:[,230],6776:[,230],6777:[,230],6778:[,230],6779:[,230],6780:[,230],6783:[,220],6832:[,230],6833:[,230],6834:[,230],6835:[,230],6836:[,230],6837:[,220],6838:[,220],6839:[,220],6840:[,220],6841:[,220],6842:[,220],6843:[,230],6844:[,230],6845:[,220]},
    	6912:{6917:[,,{6965:6918}],6918:[[6917,6965]],6919:[,,{6965:6920}],6920:[[6919,6965]],6921:[,,{6965:6922}],6922:[[6921,6965]],6923:[,,{6965:6924}],6924:[[6923,6965]],6925:[,,{6965:6926}],6926:[[6925,6965]],6929:[,,{6965:6930}],6930:[[6929,6965]],6964:[,7],6970:[,,{6965:6971}],6971:[[6970,6965]],6972:[,,{6965:6973}],6973:[[6972,6965]],6974:[,,{6965:6976}],6975:[,,{6965:6977}],6976:[[6974,6965]],6977:[[6975,6965]],6978:[,,{6965:6979}],6979:[[6978,6965]],6980:[,9],7019:[,230],7020:[,220],7021:[,230],7022:[,230],7023:[,230],7024:[,230],7025:[,230],7026:[,230],7027:[,230],7082:[,9],7083:[,9],7142:[,7],7154:[,9],7155:[,9]},
    	7168:{7223:[,7],7376:[,230],7377:[,230],7378:[,230],7380:[,1],7381:[,220],7382:[,220],7383:[,220],7384:[,220],7385:[,220],7386:[,230],7387:[,230],7388:[,220],7389:[,220],7390:[,220],7391:[,220],7392:[,230],7394:[,1],7395:[,1],7396:[,1],7397:[,1],7398:[,1],7399:[,1],7400:[,1],7405:[,220],7412:[,230],7416:[,230],7417:[,230]},
    	7424:{7468:[[65],256],7469:[[198],256],7470:[[66],256],7472:[[68],256],7473:[[69],256],7474:[[398],256],7475:[[71],256],7476:[[72],256],7477:[[73],256],7478:[[74],256],7479:[[75],256],7480:[[76],256],7481:[[77],256],7482:[[78],256],7484:[[79],256],7485:[[546],256],7486:[[80],256],7487:[[82],256],7488:[[84],256],7489:[[85],256],7490:[[87],256],7491:[[97],256],7492:[[592],256],7493:[[593],256],7494:[[7426],256],7495:[[98],256],7496:[[100],256],7497:[[101],256],7498:[[601],256],7499:[[603],256],7500:[[604],256],7501:[[103],256],7503:[[107],256],7504:[[109],256],7505:[[331],256],7506:[[111],256],7507:[[596],256],7508:[[7446],256],7509:[[7447],256],7510:[[112],256],7511:[[116],256],7512:[[117],256],7513:[[7453],256],7514:[[623],256],7515:[[118],256],7516:[[7461],256],7517:[[946],256],7518:[[947],256],7519:[[948],256],7520:[[966],256],7521:[[967],256],7522:[[105],256],7523:[[114],256],7524:[[117],256],7525:[[118],256],7526:[[946],256],7527:[[947],256],7528:[[961],256],7529:[[966],256],7530:[[967],256],7544:[[1085],256],7579:[[594],256],7580:[[99],256],7581:[[597],256],7582:[[240],256],7583:[[604],256],7584:[[102],256],7585:[[607],256],7586:[[609],256],7587:[[613],256],7588:[[616],256],7589:[[617],256],7590:[[618],256],7591:[[7547],256],7592:[[669],256],7593:[[621],256],7594:[[7557],256],7595:[[671],256],7596:[[625],256],7597:[[624],256],7598:[[626],256],7599:[[627],256],7600:[[628],256],7601:[[629],256],7602:[[632],256],7603:[[642],256],7604:[[643],256],7605:[[427],256],7606:[[649],256],7607:[[650],256],7608:[[7452],256],7609:[[651],256],7610:[[652],256],7611:[[122],256],7612:[[656],256],7613:[[657],256],7614:[[658],256],7615:[[952],256],7616:[,230],7617:[,230],7618:[,220],7619:[,230],7620:[,230],7621:[,230],7622:[,230],7623:[,230],7624:[,230],7625:[,230],7626:[,220],7627:[,230],7628:[,230],7629:[,234],7630:[,214],7631:[,220],7632:[,202],7633:[,230],7634:[,230],7635:[,230],7636:[,230],7637:[,230],7638:[,230],7639:[,230],7640:[,230],7641:[,230],7642:[,230],7643:[,230],7644:[,230],7645:[,230],7646:[,230],7647:[,230],7648:[,230],7649:[,230],7650:[,230],7651:[,230],7652:[,230],7653:[,230],7654:[,230],7655:[,230],7656:[,230],7657:[,230],7658:[,230],7659:[,230],7660:[,230],7661:[,230],7662:[,230],7663:[,230],7664:[,230],7665:[,230],7666:[,230],7667:[,230],7668:[,230],7669:[,230],7676:[,233],7677:[,220],7678:[,230],7679:[,220]},
    	7680:{7680:[[65,805]],7681:[[97,805]],7682:[[66,775]],7683:[[98,775]],7684:[[66,803]],7685:[[98,803]],7686:[[66,817]],7687:[[98,817]],7688:[[199,769]],7689:[[231,769]],7690:[[68,775]],7691:[[100,775]],7692:[[68,803]],7693:[[100,803]],7694:[[68,817]],7695:[[100,817]],7696:[[68,807]],7697:[[100,807]],7698:[[68,813]],7699:[[100,813]],7700:[[274,768]],7701:[[275,768]],7702:[[274,769]],7703:[[275,769]],7704:[[69,813]],7705:[[101,813]],7706:[[69,816]],7707:[[101,816]],7708:[[552,774]],7709:[[553,774]],7710:[[70,775]],7711:[[102,775]],7712:[[71,772]],7713:[[103,772]],7714:[[72,775]],7715:[[104,775]],7716:[[72,803]],7717:[[104,803]],7718:[[72,776]],7719:[[104,776]],7720:[[72,807]],7721:[[104,807]],7722:[[72,814]],7723:[[104,814]],7724:[[73,816]],7725:[[105,816]],7726:[[207,769]],7727:[[239,769]],7728:[[75,769]],7729:[[107,769]],7730:[[75,803]],7731:[[107,803]],7732:[[75,817]],7733:[[107,817]],7734:[[76,803],,{772:7736}],7735:[[108,803],,{772:7737}],7736:[[7734,772]],7737:[[7735,772]],7738:[[76,817]],7739:[[108,817]],7740:[[76,813]],7741:[[108,813]],7742:[[77,769]],7743:[[109,769]],7744:[[77,775]],7745:[[109,775]],7746:[[77,803]],7747:[[109,803]],7748:[[78,775]],7749:[[110,775]],7750:[[78,803]],7751:[[110,803]],7752:[[78,817]],7753:[[110,817]],7754:[[78,813]],7755:[[110,813]],7756:[[213,769]],7757:[[245,769]],7758:[[213,776]],7759:[[245,776]],7760:[[332,768]],7761:[[333,768]],7762:[[332,769]],7763:[[333,769]],7764:[[80,769]],7765:[[112,769]],7766:[[80,775]],7767:[[112,775]],7768:[[82,775]],7769:[[114,775]],7770:[[82,803],,{772:7772}],7771:[[114,803],,{772:7773}],7772:[[7770,772]],7773:[[7771,772]],7774:[[82,817]],7775:[[114,817]],7776:[[83,775]],7777:[[115,775]],7778:[[83,803],,{775:7784}],7779:[[115,803],,{775:7785}],7780:[[346,775]],7781:[[347,775]],7782:[[352,775]],7783:[[353,775]],7784:[[7778,775]],7785:[[7779,775]],7786:[[84,775]],7787:[[116,775]],7788:[[84,803]],7789:[[116,803]],7790:[[84,817]],7791:[[116,817]],7792:[[84,813]],7793:[[116,813]],7794:[[85,804]],7795:[[117,804]],7796:[[85,816]],7797:[[117,816]],7798:[[85,813]],7799:[[117,813]],7800:[[360,769]],7801:[[361,769]],7802:[[362,776]],7803:[[363,776]],7804:[[86,771]],7805:[[118,771]],7806:[[86,803]],7807:[[118,803]],7808:[[87,768]],7809:[[119,768]],7810:[[87,769]],7811:[[119,769]],7812:[[87,776]],7813:[[119,776]],7814:[[87,775]],7815:[[119,775]],7816:[[87,803]],7817:[[119,803]],7818:[[88,775]],7819:[[120,775]],7820:[[88,776]],7821:[[120,776]],7822:[[89,775]],7823:[[121,775]],7824:[[90,770]],7825:[[122,770]],7826:[[90,803]],7827:[[122,803]],7828:[[90,817]],7829:[[122,817]],7830:[[104,817]],7831:[[116,776]],7832:[[119,778]],7833:[[121,778]],7834:[[97,702],256],7835:[[383,775]],7840:[[65,803],,{770:7852,774:7862}],7841:[[97,803],,{770:7853,774:7863}],7842:[[65,777]],7843:[[97,777]],7844:[[194,769]],7845:[[226,769]],7846:[[194,768]],7847:[[226,768]],7848:[[194,777]],7849:[[226,777]],7850:[[194,771]],7851:[[226,771]],7852:[[7840,770]],7853:[[7841,770]],7854:[[258,769]],7855:[[259,769]],7856:[[258,768]],7857:[[259,768]],7858:[[258,777]],7859:[[259,777]],7860:[[258,771]],7861:[[259,771]],7862:[[7840,774]],7863:[[7841,774]],7864:[[69,803],,{770:7878}],7865:[[101,803],,{770:7879}],7866:[[69,777]],7867:[[101,777]],7868:[[69,771]],7869:[[101,771]],7870:[[202,769]],7871:[[234,769]],7872:[[202,768]],7873:[[234,768]],7874:[[202,777]],7875:[[234,777]],7876:[[202,771]],7877:[[234,771]],7878:[[7864,770]],7879:[[7865,770]],7880:[[73,777]],7881:[[105,777]],7882:[[73,803]],7883:[[105,803]],7884:[[79,803],,{770:7896}],7885:[[111,803],,{770:7897}],7886:[[79,777]],7887:[[111,777]],7888:[[212,769]],7889:[[244,769]],7890:[[212,768]],7891:[[244,768]],7892:[[212,777]],7893:[[244,777]],7894:[[212,771]],7895:[[244,771]],7896:[[7884,770]],7897:[[7885,770]],7898:[[416,769]],7899:[[417,769]],7900:[[416,768]],7901:[[417,768]],7902:[[416,777]],7903:[[417,777]],7904:[[416,771]],7905:[[417,771]],7906:[[416,803]],7907:[[417,803]],7908:[[85,803]],7909:[[117,803]],7910:[[85,777]],7911:[[117,777]],7912:[[431,769]],7913:[[432,769]],7914:[[431,768]],7915:[[432,768]],7916:[[431,777]],7917:[[432,777]],7918:[[431,771]],7919:[[432,771]],7920:[[431,803]],7921:[[432,803]],7922:[[89,768]],7923:[[121,768]],7924:[[89,803]],7925:[[121,803]],7926:[[89,777]],7927:[[121,777]],7928:[[89,771]],7929:[[121,771]]},
    	7936:{7936:[[945,787],,{768:7938,769:7940,834:7942,837:8064}],7937:[[945,788],,{768:7939,769:7941,834:7943,837:8065}],7938:[[7936,768],,{837:8066}],7939:[[7937,768],,{837:8067}],7940:[[7936,769],,{837:8068}],7941:[[7937,769],,{837:8069}],7942:[[7936,834],,{837:8070}],7943:[[7937,834],,{837:8071}],7944:[[913,787],,{768:7946,769:7948,834:7950,837:8072}],7945:[[913,788],,{768:7947,769:7949,834:7951,837:8073}],7946:[[7944,768],,{837:8074}],7947:[[7945,768],,{837:8075}],7948:[[7944,769],,{837:8076}],7949:[[7945,769],,{837:8077}],7950:[[7944,834],,{837:8078}],7951:[[7945,834],,{837:8079}],7952:[[949,787],,{768:7954,769:7956}],7953:[[949,788],,{768:7955,769:7957}],7954:[[7952,768]],7955:[[7953,768]],7956:[[7952,769]],7957:[[7953,769]],7960:[[917,787],,{768:7962,769:7964}],7961:[[917,788],,{768:7963,769:7965}],7962:[[7960,768]],7963:[[7961,768]],7964:[[7960,769]],7965:[[7961,769]],7968:[[951,787],,{768:7970,769:7972,834:7974,837:8080}],7969:[[951,788],,{768:7971,769:7973,834:7975,837:8081}],7970:[[7968,768],,{837:8082}],7971:[[7969,768],,{837:8083}],7972:[[7968,769],,{837:8084}],7973:[[7969,769],,{837:8085}],7974:[[7968,834],,{837:8086}],7975:[[7969,834],,{837:8087}],7976:[[919,787],,{768:7978,769:7980,834:7982,837:8088}],7977:[[919,788],,{768:7979,769:7981,834:7983,837:8089}],7978:[[7976,768],,{837:8090}],7979:[[7977,768],,{837:8091}],7980:[[7976,769],,{837:8092}],7981:[[7977,769],,{837:8093}],7982:[[7976,834],,{837:8094}],7983:[[7977,834],,{837:8095}],7984:[[953,787],,{768:7986,769:7988,834:7990}],7985:[[953,788],,{768:7987,769:7989,834:7991}],7986:[[7984,768]],7987:[[7985,768]],7988:[[7984,769]],7989:[[7985,769]],7990:[[7984,834]],7991:[[7985,834]],7992:[[921,787],,{768:7994,769:7996,834:7998}],7993:[[921,788],,{768:7995,769:7997,834:7999}],7994:[[7992,768]],7995:[[7993,768]],7996:[[7992,769]],7997:[[7993,769]],7998:[[7992,834]],7999:[[7993,834]],8000:[[959,787],,{768:8002,769:8004}],8001:[[959,788],,{768:8003,769:8005}],8002:[[8000,768]],8003:[[8001,768]],8004:[[8000,769]],8005:[[8001,769]],8008:[[927,787],,{768:8010,769:8012}],8009:[[927,788],,{768:8011,769:8013}],8010:[[8008,768]],8011:[[8009,768]],8012:[[8008,769]],8013:[[8009,769]],8016:[[965,787],,{768:8018,769:8020,834:8022}],8017:[[965,788],,{768:8019,769:8021,834:8023}],8018:[[8016,768]],8019:[[8017,768]],8020:[[8016,769]],8021:[[8017,769]],8022:[[8016,834]],8023:[[8017,834]],8025:[[933,788],,{768:8027,769:8029,834:8031}],8027:[[8025,768]],8029:[[8025,769]],8031:[[8025,834]],8032:[[969,787],,{768:8034,769:8036,834:8038,837:8096}],8033:[[969,788],,{768:8035,769:8037,834:8039,837:8097}],8034:[[8032,768],,{837:8098}],8035:[[8033,768],,{837:8099}],8036:[[8032,769],,{837:8100}],8037:[[8033,769],,{837:8101}],8038:[[8032,834],,{837:8102}],8039:[[8033,834],,{837:8103}],8040:[[937,787],,{768:8042,769:8044,834:8046,837:8104}],8041:[[937,788],,{768:8043,769:8045,834:8047,837:8105}],8042:[[8040,768],,{837:8106}],8043:[[8041,768],,{837:8107}],8044:[[8040,769],,{837:8108}],8045:[[8041,769],,{837:8109}],8046:[[8040,834],,{837:8110}],8047:[[8041,834],,{837:8111}],8048:[[945,768],,{837:8114}],8049:[[940]],8050:[[949,768]],8051:[[941]],8052:[[951,768],,{837:8130}],8053:[[942]],8054:[[953,768]],8055:[[943]],8056:[[959,768]],8057:[[972]],8058:[[965,768]],8059:[[973]],8060:[[969,768],,{837:8178}],8061:[[974]],8064:[[7936,837]],8065:[[7937,837]],8066:[[7938,837]],8067:[[7939,837]],8068:[[7940,837]],8069:[[7941,837]],8070:[[7942,837]],8071:[[7943,837]],8072:[[7944,837]],8073:[[7945,837]],8074:[[7946,837]],8075:[[7947,837]],8076:[[7948,837]],8077:[[7949,837]],8078:[[7950,837]],8079:[[7951,837]],8080:[[7968,837]],8081:[[7969,837]],8082:[[7970,837]],8083:[[7971,837]],8084:[[7972,837]],8085:[[7973,837]],8086:[[7974,837]],8087:[[7975,837]],8088:[[7976,837]],8089:[[7977,837]],8090:[[7978,837]],8091:[[7979,837]],8092:[[7980,837]],8093:[[7981,837]],8094:[[7982,837]],8095:[[7983,837]],8096:[[8032,837]],8097:[[8033,837]],8098:[[8034,837]],8099:[[8035,837]],8100:[[8036,837]],8101:[[8037,837]],8102:[[8038,837]],8103:[[8039,837]],8104:[[8040,837]],8105:[[8041,837]],8106:[[8042,837]],8107:[[8043,837]],8108:[[8044,837]],8109:[[8045,837]],8110:[[8046,837]],8111:[[8047,837]],8112:[[945,774]],8113:[[945,772]],8114:[[8048,837]],8115:[[945,837]],8116:[[940,837]],8118:[[945,834],,{837:8119}],8119:[[8118,837]],8120:[[913,774]],8121:[[913,772]],8122:[[913,768]],8123:[[902]],8124:[[913,837]],8125:[[32,787],256],8126:[[953]],8127:[[32,787],256,{768:8141,769:8142,834:8143}],8128:[[32,834],256],8129:[[168,834]],8130:[[8052,837]],8131:[[951,837]],8132:[[942,837]],8134:[[951,834],,{837:8135}],8135:[[8134,837]],8136:[[917,768]],8137:[[904]],8138:[[919,768]],8139:[[905]],8140:[[919,837]],8141:[[8127,768]],8142:[[8127,769]],8143:[[8127,834]],8144:[[953,774]],8145:[[953,772]],8146:[[970,768]],8147:[[912]],8150:[[953,834]],8151:[[970,834]],8152:[[921,774]],8153:[[921,772]],8154:[[921,768]],8155:[[906]],8157:[[8190,768]],8158:[[8190,769]],8159:[[8190,834]],8160:[[965,774]],8161:[[965,772]],8162:[[971,768]],8163:[[944]],8164:[[961,787]],8165:[[961,788]],8166:[[965,834]],8167:[[971,834]],8168:[[933,774]],8169:[[933,772]],8170:[[933,768]],8171:[[910]],8172:[[929,788]],8173:[[168,768]],8174:[[901]],8175:[[96]],8178:[[8060,837]],8179:[[969,837]],8180:[[974,837]],8182:[[969,834],,{837:8183}],8183:[[8182,837]],8184:[[927,768]],8185:[[908]],8186:[[937,768]],8187:[[911]],8188:[[937,837]],8189:[[180]],8190:[[32,788],256,{768:8157,769:8158,834:8159}]},
    	8192:{8192:[[8194]],8193:[[8195]],8194:[[32],256],8195:[[32],256],8196:[[32],256],8197:[[32],256],8198:[[32],256],8199:[[32],256],8200:[[32],256],8201:[[32],256],8202:[[32],256],8209:[[8208],256],8215:[[32,819],256],8228:[[46],256],8229:[[46,46],256],8230:[[46,46,46],256],8239:[[32],256],8243:[[8242,8242],256],8244:[[8242,8242,8242],256],8246:[[8245,8245],256],8247:[[8245,8245,8245],256],8252:[[33,33],256],8254:[[32,773],256],8263:[[63,63],256],8264:[[63,33],256],8265:[[33,63],256],8279:[[8242,8242,8242,8242],256],8287:[[32],256],8304:[[48],256],8305:[[105],256],8308:[[52],256],8309:[[53],256],8310:[[54],256],8311:[[55],256],8312:[[56],256],8313:[[57],256],8314:[[43],256],8315:[[8722],256],8316:[[61],256],8317:[[40],256],8318:[[41],256],8319:[[110],256],8320:[[48],256],8321:[[49],256],8322:[[50],256],8323:[[51],256],8324:[[52],256],8325:[[53],256],8326:[[54],256],8327:[[55],256],8328:[[56],256],8329:[[57],256],8330:[[43],256],8331:[[8722],256],8332:[[61],256],8333:[[40],256],8334:[[41],256],8336:[[97],256],8337:[[101],256],8338:[[111],256],8339:[[120],256],8340:[[601],256],8341:[[104],256],8342:[[107],256],8343:[[108],256],8344:[[109],256],8345:[[110],256],8346:[[112],256],8347:[[115],256],8348:[[116],256],8360:[[82,115],256],8400:[,230],8401:[,230],8402:[,1],8403:[,1],8404:[,230],8405:[,230],8406:[,230],8407:[,230],8408:[,1],8409:[,1],8410:[,1],8411:[,230],8412:[,230],8417:[,230],8421:[,1],8422:[,1],8423:[,230],8424:[,220],8425:[,230],8426:[,1],8427:[,1],8428:[,220],8429:[,220],8430:[,220],8431:[,220],8432:[,230]},
    	8448:{8448:[[97,47,99],256],8449:[[97,47,115],256],8450:[[67],256],8451:[[176,67],256],8453:[[99,47,111],256],8454:[[99,47,117],256],8455:[[400],256],8457:[[176,70],256],8458:[[103],256],8459:[[72],256],8460:[[72],256],8461:[[72],256],8462:[[104],256],8463:[[295],256],8464:[[73],256],8465:[[73],256],8466:[[76],256],8467:[[108],256],8469:[[78],256],8470:[[78,111],256],8473:[[80],256],8474:[[81],256],8475:[[82],256],8476:[[82],256],8477:[[82],256],8480:[[83,77],256],8481:[[84,69,76],256],8482:[[84,77],256],8484:[[90],256],8486:[[937]],8488:[[90],256],8490:[[75]],8491:[[197]],8492:[[66],256],8493:[[67],256],8495:[[101],256],8496:[[69],256],8497:[[70],256],8499:[[77],256],8500:[[111],256],8501:[[1488],256],8502:[[1489],256],8503:[[1490],256],8504:[[1491],256],8505:[[105],256],8507:[[70,65,88],256],8508:[[960],256],8509:[[947],256],8510:[[915],256],8511:[[928],256],8512:[[8721],256],8517:[[68],256],8518:[[100],256],8519:[[101],256],8520:[[105],256],8521:[[106],256],8528:[[49,8260,55],256],8529:[[49,8260,57],256],8530:[[49,8260,49,48],256],8531:[[49,8260,51],256],8532:[[50,8260,51],256],8533:[[49,8260,53],256],8534:[[50,8260,53],256],8535:[[51,8260,53],256],8536:[[52,8260,53],256],8537:[[49,8260,54],256],8538:[[53,8260,54],256],8539:[[49,8260,56],256],8540:[[51,8260,56],256],8541:[[53,8260,56],256],8542:[[55,8260,56],256],8543:[[49,8260],256],8544:[[73],256],8545:[[73,73],256],8546:[[73,73,73],256],8547:[[73,86],256],8548:[[86],256],8549:[[86,73],256],8550:[[86,73,73],256],8551:[[86,73,73,73],256],8552:[[73,88],256],8553:[[88],256],8554:[[88,73],256],8555:[[88,73,73],256],8556:[[76],256],8557:[[67],256],8558:[[68],256],8559:[[77],256],8560:[[105],256],8561:[[105,105],256],8562:[[105,105,105],256],8563:[[105,118],256],8564:[[118],256],8565:[[118,105],256],8566:[[118,105,105],256],8567:[[118,105,105,105],256],8568:[[105,120],256],8569:[[120],256],8570:[[120,105],256],8571:[[120,105,105],256],8572:[[108],256],8573:[[99],256],8574:[[100],256],8575:[[109],256],8585:[[48,8260,51],256],8592:[,,{824:8602}],8594:[,,{824:8603}],8596:[,,{824:8622}],8602:[[8592,824]],8603:[[8594,824]],8622:[[8596,824]],8653:[[8656,824]],8654:[[8660,824]],8655:[[8658,824]],8656:[,,{824:8653}],8658:[,,{824:8655}],8660:[,,{824:8654}]},
    	8704:{8707:[,,{824:8708}],8708:[[8707,824]],8712:[,,{824:8713}],8713:[[8712,824]],8715:[,,{824:8716}],8716:[[8715,824]],8739:[,,{824:8740}],8740:[[8739,824]],8741:[,,{824:8742}],8742:[[8741,824]],8748:[[8747,8747],256],8749:[[8747,8747,8747],256],8751:[[8750,8750],256],8752:[[8750,8750,8750],256],8764:[,,{824:8769}],8769:[[8764,824]],8771:[,,{824:8772}],8772:[[8771,824]],8773:[,,{824:8775}],8775:[[8773,824]],8776:[,,{824:8777}],8777:[[8776,824]],8781:[,,{824:8813}],8800:[[61,824]],8801:[,,{824:8802}],8802:[[8801,824]],8804:[,,{824:8816}],8805:[,,{824:8817}],8813:[[8781,824]],8814:[[60,824]],8815:[[62,824]],8816:[[8804,824]],8817:[[8805,824]],8818:[,,{824:8820}],8819:[,,{824:8821}],8820:[[8818,824]],8821:[[8819,824]],8822:[,,{824:8824}],8823:[,,{824:8825}],8824:[[8822,824]],8825:[[8823,824]],8826:[,,{824:8832}],8827:[,,{824:8833}],8828:[,,{824:8928}],8829:[,,{824:8929}],8832:[[8826,824]],8833:[[8827,824]],8834:[,,{824:8836}],8835:[,,{824:8837}],8836:[[8834,824]],8837:[[8835,824]],8838:[,,{824:8840}],8839:[,,{824:8841}],8840:[[8838,824]],8841:[[8839,824]],8849:[,,{824:8930}],8850:[,,{824:8931}],8866:[,,{824:8876}],8872:[,,{824:8877}],8873:[,,{824:8878}],8875:[,,{824:8879}],8876:[[8866,824]],8877:[[8872,824]],8878:[[8873,824]],8879:[[8875,824]],8882:[,,{824:8938}],8883:[,,{824:8939}],8884:[,,{824:8940}],8885:[,,{824:8941}],8928:[[8828,824]],8929:[[8829,824]],8930:[[8849,824]],8931:[[8850,824]],8938:[[8882,824]],8939:[[8883,824]],8940:[[8884,824]],8941:[[8885,824]]},
    	8960:{9001:[[12296]],9002:[[12297]]},
    	9216:{9312:[[49],256],9313:[[50],256],9314:[[51],256],9315:[[52],256],9316:[[53],256],9317:[[54],256],9318:[[55],256],9319:[[56],256],9320:[[57],256],9321:[[49,48],256],9322:[[49,49],256],9323:[[49,50],256],9324:[[49,51],256],9325:[[49,52],256],9326:[[49,53],256],9327:[[49,54],256],9328:[[49,55],256],9329:[[49,56],256],9330:[[49,57],256],9331:[[50,48],256],9332:[[40,49,41],256],9333:[[40,50,41],256],9334:[[40,51,41],256],9335:[[40,52,41],256],9336:[[40,53,41],256],9337:[[40,54,41],256],9338:[[40,55,41],256],9339:[[40,56,41],256],9340:[[40,57,41],256],9341:[[40,49,48,41],256],9342:[[40,49,49,41],256],9343:[[40,49,50,41],256],9344:[[40,49,51,41],256],9345:[[40,49,52,41],256],9346:[[40,49,53,41],256],9347:[[40,49,54,41],256],9348:[[40,49,55,41],256],9349:[[40,49,56,41],256],9350:[[40,49,57,41],256],9351:[[40,50,48,41],256],9352:[[49,46],256],9353:[[50,46],256],9354:[[51,46],256],9355:[[52,46],256],9356:[[53,46],256],9357:[[54,46],256],9358:[[55,46],256],9359:[[56,46],256],9360:[[57,46],256],9361:[[49,48,46],256],9362:[[49,49,46],256],9363:[[49,50,46],256],9364:[[49,51,46],256],9365:[[49,52,46],256],9366:[[49,53,46],256],9367:[[49,54,46],256],9368:[[49,55,46],256],9369:[[49,56,46],256],9370:[[49,57,46],256],9371:[[50,48,46],256],9372:[[40,97,41],256],9373:[[40,98,41],256],9374:[[40,99,41],256],9375:[[40,100,41],256],9376:[[40,101,41],256],9377:[[40,102,41],256],9378:[[40,103,41],256],9379:[[40,104,41],256],9380:[[40,105,41],256],9381:[[40,106,41],256],9382:[[40,107,41],256],9383:[[40,108,41],256],9384:[[40,109,41],256],9385:[[40,110,41],256],9386:[[40,111,41],256],9387:[[40,112,41],256],9388:[[40,113,41],256],9389:[[40,114,41],256],9390:[[40,115,41],256],9391:[[40,116,41],256],9392:[[40,117,41],256],9393:[[40,118,41],256],9394:[[40,119,41],256],9395:[[40,120,41],256],9396:[[40,121,41],256],9397:[[40,122,41],256],9398:[[65],256],9399:[[66],256],9400:[[67],256],9401:[[68],256],9402:[[69],256],9403:[[70],256],9404:[[71],256],9405:[[72],256],9406:[[73],256],9407:[[74],256],9408:[[75],256],9409:[[76],256],9410:[[77],256],9411:[[78],256],9412:[[79],256],9413:[[80],256],9414:[[81],256],9415:[[82],256],9416:[[83],256],9417:[[84],256],9418:[[85],256],9419:[[86],256],9420:[[87],256],9421:[[88],256],9422:[[89],256],9423:[[90],256],9424:[[97],256],9425:[[98],256],9426:[[99],256],9427:[[100],256],9428:[[101],256],9429:[[102],256],9430:[[103],256],9431:[[104],256],9432:[[105],256],9433:[[106],256],9434:[[107],256],9435:[[108],256],9436:[[109],256],9437:[[110],256],9438:[[111],256],9439:[[112],256],9440:[[113],256],9441:[[114],256],9442:[[115],256],9443:[[116],256],9444:[[117],256],9445:[[118],256],9446:[[119],256],9447:[[120],256],9448:[[121],256],9449:[[122],256],9450:[[48],256]},
    	10752:{10764:[[8747,8747,8747,8747],256],10868:[[58,58,61],256],10869:[[61,61],256],10870:[[61,61,61],256],10972:[[10973,824],512]},
    	11264:{11388:[[106],256],11389:[[86],256],11503:[,230],11504:[,230],11505:[,230]},
    	11520:{11631:[[11617],256],11647:[,9],11744:[,230],11745:[,230],11746:[,230],11747:[,230],11748:[,230],11749:[,230],11750:[,230],11751:[,230],11752:[,230],11753:[,230],11754:[,230],11755:[,230],11756:[,230],11757:[,230],11758:[,230],11759:[,230],11760:[,230],11761:[,230],11762:[,230],11763:[,230],11764:[,230],11765:[,230],11766:[,230],11767:[,230],11768:[,230],11769:[,230],11770:[,230],11771:[,230],11772:[,230],11773:[,230],11774:[,230],11775:[,230]},
    	11776:{11935:[[27597],256],12019:[[40863],256]},
    	12032:{12032:[[19968],256],12033:[[20008],256],12034:[[20022],256],12035:[[20031],256],12036:[[20057],256],12037:[[20101],256],12038:[[20108],256],12039:[[20128],256],12040:[[20154],256],12041:[[20799],256],12042:[[20837],256],12043:[[20843],256],12044:[[20866],256],12045:[[20886],256],12046:[[20907],256],12047:[[20960],256],12048:[[20981],256],12049:[[20992],256],12050:[[21147],256],12051:[[21241],256],12052:[[21269],256],12053:[[21274],256],12054:[[21304],256],12055:[[21313],256],12056:[[21340],256],12057:[[21353],256],12058:[[21378],256],12059:[[21430],256],12060:[[21448],256],12061:[[21475],256],12062:[[22231],256],12063:[[22303],256],12064:[[22763],256],12065:[[22786],256],12066:[[22794],256],12067:[[22805],256],12068:[[22823],256],12069:[[22899],256],12070:[[23376],256],12071:[[23424],256],12072:[[23544],256],12073:[[23567],256],12074:[[23586],256],12075:[[23608],256],12076:[[23662],256],12077:[[23665],256],12078:[[24027],256],12079:[[24037],256],12080:[[24049],256],12081:[[24062],256],12082:[[24178],256],12083:[[24186],256],12084:[[24191],256],12085:[[24308],256],12086:[[24318],256],12087:[[24331],256],12088:[[24339],256],12089:[[24400],256],12090:[[24417],256],12091:[[24435],256],12092:[[24515],256],12093:[[25096],256],12094:[[25142],256],12095:[[25163],256],12096:[[25903],256],12097:[[25908],256],12098:[[25991],256],12099:[[26007],256],12100:[[26020],256],12101:[[26041],256],12102:[[26080],256],12103:[[26085],256],12104:[[26352],256],12105:[[26376],256],12106:[[26408],256],12107:[[27424],256],12108:[[27490],256],12109:[[27513],256],12110:[[27571],256],12111:[[27595],256],12112:[[27604],256],12113:[[27611],256],12114:[[27663],256],12115:[[27668],256],12116:[[27700],256],12117:[[28779],256],12118:[[29226],256],12119:[[29238],256],12120:[[29243],256],12121:[[29247],256],12122:[[29255],256],12123:[[29273],256],12124:[[29275],256],12125:[[29356],256],12126:[[29572],256],12127:[[29577],256],12128:[[29916],256],12129:[[29926],256],12130:[[29976],256],12131:[[29983],256],12132:[[29992],256],12133:[[30000],256],12134:[[30091],256],12135:[[30098],256],12136:[[30326],256],12137:[[30333],256],12138:[[30382],256],12139:[[30399],256],12140:[[30446],256],12141:[[30683],256],12142:[[30690],256],12143:[[30707],256],12144:[[31034],256],12145:[[31160],256],12146:[[31166],256],12147:[[31348],256],12148:[[31435],256],12149:[[31481],256],12150:[[31859],256],12151:[[31992],256],12152:[[32566],256],12153:[[32593],256],12154:[[32650],256],12155:[[32701],256],12156:[[32769],256],12157:[[32780],256],12158:[[32786],256],12159:[[32819],256],12160:[[32895],256],12161:[[32905],256],12162:[[33251],256],12163:[[33258],256],12164:[[33267],256],12165:[[33276],256],12166:[[33292],256],12167:[[33307],256],12168:[[33311],256],12169:[[33390],256],12170:[[33394],256],12171:[[33400],256],12172:[[34381],256],12173:[[34411],256],12174:[[34880],256],12175:[[34892],256],12176:[[34915],256],12177:[[35198],256],12178:[[35211],256],12179:[[35282],256],12180:[[35328],256],12181:[[35895],256],12182:[[35910],256],12183:[[35925],256],12184:[[35960],256],12185:[[35997],256],12186:[[36196],256],12187:[[36208],256],12188:[[36275],256],12189:[[36523],256],12190:[[36554],256],12191:[[36763],256],12192:[[36784],256],12193:[[36789],256],12194:[[37009],256],12195:[[37193],256],12196:[[37318],256],12197:[[37324],256],12198:[[37329],256],12199:[[38263],256],12200:[[38272],256],12201:[[38428],256],12202:[[38582],256],12203:[[38585],256],12204:[[38632],256],12205:[[38737],256],12206:[[38750],256],12207:[[38754],256],12208:[[38761],256],12209:[[38859],256],12210:[[38893],256],12211:[[38899],256],12212:[[38913],256],12213:[[39080],256],12214:[[39131],256],12215:[[39135],256],12216:[[39318],256],12217:[[39321],256],12218:[[39340],256],12219:[[39592],256],12220:[[39640],256],12221:[[39647],256],12222:[[39717],256],12223:[[39727],256],12224:[[39730],256],12225:[[39740],256],12226:[[39770],256],12227:[[40165],256],12228:[[40565],256],12229:[[40575],256],12230:[[40613],256],12231:[[40635],256],12232:[[40643],256],12233:[[40653],256],12234:[[40657],256],12235:[[40697],256],12236:[[40701],256],12237:[[40718],256],12238:[[40723],256],12239:[[40736],256],12240:[[40763],256],12241:[[40778],256],12242:[[40786],256],12243:[[40845],256],12244:[[40860],256],12245:[[40864],256]},
    	12288:{12288:[[32],256],12330:[,218],12331:[,228],12332:[,232],12333:[,222],12334:[,224],12335:[,224],12342:[[12306],256],12344:[[21313],256],12345:[[21316],256],12346:[[21317],256],12358:[,,{12441:12436}],12363:[,,{12441:12364}],12364:[[12363,12441]],12365:[,,{12441:12366}],12366:[[12365,12441]],12367:[,,{12441:12368}],12368:[[12367,12441]],12369:[,,{12441:12370}],12370:[[12369,12441]],12371:[,,{12441:12372}],12372:[[12371,12441]],12373:[,,{12441:12374}],12374:[[12373,12441]],12375:[,,{12441:12376}],12376:[[12375,12441]],12377:[,,{12441:12378}],12378:[[12377,12441]],12379:[,,{12441:12380}],12380:[[12379,12441]],12381:[,,{12441:12382}],12382:[[12381,12441]],12383:[,,{12441:12384}],12384:[[12383,12441]],12385:[,,{12441:12386}],12386:[[12385,12441]],12388:[,,{12441:12389}],12389:[[12388,12441]],12390:[,,{12441:12391}],12391:[[12390,12441]],12392:[,,{12441:12393}],12393:[[12392,12441]],12399:[,,{12441:12400,12442:12401}],12400:[[12399,12441]],12401:[[12399,12442]],12402:[,,{12441:12403,12442:12404}],12403:[[12402,12441]],12404:[[12402,12442]],12405:[,,{12441:12406,12442:12407}],12406:[[12405,12441]],12407:[[12405,12442]],12408:[,,{12441:12409,12442:12410}],12409:[[12408,12441]],12410:[[12408,12442]],12411:[,,{12441:12412,12442:12413}],12412:[[12411,12441]],12413:[[12411,12442]],12436:[[12358,12441]],12441:[,8],12442:[,8],12443:[[32,12441],256],12444:[[32,12442],256],12445:[,,{12441:12446}],12446:[[12445,12441]],12447:[[12424,12426],256],12454:[,,{12441:12532}],12459:[,,{12441:12460}],12460:[[12459,12441]],12461:[,,{12441:12462}],12462:[[12461,12441]],12463:[,,{12441:12464}],12464:[[12463,12441]],12465:[,,{12441:12466}],12466:[[12465,12441]],12467:[,,{12441:12468}],12468:[[12467,12441]],12469:[,,{12441:12470}],12470:[[12469,12441]],12471:[,,{12441:12472}],12472:[[12471,12441]],12473:[,,{12441:12474}],12474:[[12473,12441]],12475:[,,{12441:12476}],12476:[[12475,12441]],12477:[,,{12441:12478}],12478:[[12477,12441]],12479:[,,{12441:12480}],12480:[[12479,12441]],12481:[,,{12441:12482}],12482:[[12481,12441]],12484:[,,{12441:12485}],12485:[[12484,12441]],12486:[,,{12441:12487}],12487:[[12486,12441]],12488:[,,{12441:12489}],12489:[[12488,12441]],12495:[,,{12441:12496,12442:12497}],12496:[[12495,12441]],12497:[[12495,12442]],12498:[,,{12441:12499,12442:12500}],12499:[[12498,12441]],12500:[[12498,12442]],12501:[,,{12441:12502,12442:12503}],12502:[[12501,12441]],12503:[[12501,12442]],12504:[,,{12441:12505,12442:12506}],12505:[[12504,12441]],12506:[[12504,12442]],12507:[,,{12441:12508,12442:12509}],12508:[[12507,12441]],12509:[[12507,12442]],12527:[,,{12441:12535}],12528:[,,{12441:12536}],12529:[,,{12441:12537}],12530:[,,{12441:12538}],12532:[[12454,12441]],12535:[[12527,12441]],12536:[[12528,12441]],12537:[[12529,12441]],12538:[[12530,12441]],12541:[,,{12441:12542}],12542:[[12541,12441]],12543:[[12467,12488],256]},
    	12544:{12593:[[4352],256],12594:[[4353],256],12595:[[4522],256],12596:[[4354],256],12597:[[4524],256],12598:[[4525],256],12599:[[4355],256],12600:[[4356],256],12601:[[4357],256],12602:[[4528],256],12603:[[4529],256],12604:[[4530],256],12605:[[4531],256],12606:[[4532],256],12607:[[4533],256],12608:[[4378],256],12609:[[4358],256],12610:[[4359],256],12611:[[4360],256],12612:[[4385],256],12613:[[4361],256],12614:[[4362],256],12615:[[4363],256],12616:[[4364],256],12617:[[4365],256],12618:[[4366],256],12619:[[4367],256],12620:[[4368],256],12621:[[4369],256],12622:[[4370],256],12623:[[4449],256],12624:[[4450],256],12625:[[4451],256],12626:[[4452],256],12627:[[4453],256],12628:[[4454],256],12629:[[4455],256],12630:[[4456],256],12631:[[4457],256],12632:[[4458],256],12633:[[4459],256],12634:[[4460],256],12635:[[4461],256],12636:[[4462],256],12637:[[4463],256],12638:[[4464],256],12639:[[4465],256],12640:[[4466],256],12641:[[4467],256],12642:[[4468],256],12643:[[4469],256],12644:[[4448],256],12645:[[4372],256],12646:[[4373],256],12647:[[4551],256],12648:[[4552],256],12649:[[4556],256],12650:[[4558],256],12651:[[4563],256],12652:[[4567],256],12653:[[4569],256],12654:[[4380],256],12655:[[4573],256],12656:[[4575],256],12657:[[4381],256],12658:[[4382],256],12659:[[4384],256],12660:[[4386],256],12661:[[4387],256],12662:[[4391],256],12663:[[4393],256],12664:[[4395],256],12665:[[4396],256],12666:[[4397],256],12667:[[4398],256],12668:[[4399],256],12669:[[4402],256],12670:[[4406],256],12671:[[4416],256],12672:[[4423],256],12673:[[4428],256],12674:[[4593],256],12675:[[4594],256],12676:[[4439],256],12677:[[4440],256],12678:[[4441],256],12679:[[4484],256],12680:[[4485],256],12681:[[4488],256],12682:[[4497],256],12683:[[4498],256],12684:[[4500],256],12685:[[4510],256],12686:[[4513],256],12690:[[19968],256],12691:[[20108],256],12692:[[19977],256],12693:[[22235],256],12694:[[19978],256],12695:[[20013],256],12696:[[19979],256],12697:[[30002],256],12698:[[20057],256],12699:[[19993],256],12700:[[19969],256],12701:[[22825],256],12702:[[22320],256],12703:[[20154],256]},
    	12800:{12800:[[40,4352,41],256],12801:[[40,4354,41],256],12802:[[40,4355,41],256],12803:[[40,4357,41],256],12804:[[40,4358,41],256],12805:[[40,4359,41],256],12806:[[40,4361,41],256],12807:[[40,4363,41],256],12808:[[40,4364,41],256],12809:[[40,4366,41],256],12810:[[40,4367,41],256],12811:[[40,4368,41],256],12812:[[40,4369,41],256],12813:[[40,4370,41],256],12814:[[40,4352,4449,41],256],12815:[[40,4354,4449,41],256],12816:[[40,4355,4449,41],256],12817:[[40,4357,4449,41],256],12818:[[40,4358,4449,41],256],12819:[[40,4359,4449,41],256],12820:[[40,4361,4449,41],256],12821:[[40,4363,4449,41],256],12822:[[40,4364,4449,41],256],12823:[[40,4366,4449,41],256],12824:[[40,4367,4449,41],256],12825:[[40,4368,4449,41],256],12826:[[40,4369,4449,41],256],12827:[[40,4370,4449,41],256],12828:[[40,4364,4462,41],256],12829:[[40,4363,4457,4364,4453,4523,41],256],12830:[[40,4363,4457,4370,4462,41],256],12832:[[40,19968,41],256],12833:[[40,20108,41],256],12834:[[40,19977,41],256],12835:[[40,22235,41],256],12836:[[40,20116,41],256],12837:[[40,20845,41],256],12838:[[40,19971,41],256],12839:[[40,20843,41],256],12840:[[40,20061,41],256],12841:[[40,21313,41],256],12842:[[40,26376,41],256],12843:[[40,28779,41],256],12844:[[40,27700,41],256],12845:[[40,26408,41],256],12846:[[40,37329,41],256],12847:[[40,22303,41],256],12848:[[40,26085,41],256],12849:[[40,26666,41],256],12850:[[40,26377,41],256],12851:[[40,31038,41],256],12852:[[40,21517,41],256],12853:[[40,29305,41],256],12854:[[40,36001,41],256],12855:[[40,31069,41],256],12856:[[40,21172,41],256],12857:[[40,20195,41],256],12858:[[40,21628,41],256],12859:[[40,23398,41],256],12860:[[40,30435,41],256],12861:[[40,20225,41],256],12862:[[40,36039,41],256],12863:[[40,21332,41],256],12864:[[40,31085,41],256],12865:[[40,20241,41],256],12866:[[40,33258,41],256],12867:[[40,33267,41],256],12868:[[21839],256],12869:[[24188],256],12870:[[25991],256],12871:[[31631],256],12880:[[80,84,69],256],12881:[[50,49],256],12882:[[50,50],256],12883:[[50,51],256],12884:[[50,52],256],12885:[[50,53],256],12886:[[50,54],256],12887:[[50,55],256],12888:[[50,56],256],12889:[[50,57],256],12890:[[51,48],256],12891:[[51,49],256],12892:[[51,50],256],12893:[[51,51],256],12894:[[51,52],256],12895:[[51,53],256],12896:[[4352],256],12897:[[4354],256],12898:[[4355],256],12899:[[4357],256],12900:[[4358],256],12901:[[4359],256],12902:[[4361],256],12903:[[4363],256],12904:[[4364],256],12905:[[4366],256],12906:[[4367],256],12907:[[4368],256],12908:[[4369],256],12909:[[4370],256],12910:[[4352,4449],256],12911:[[4354,4449],256],12912:[[4355,4449],256],12913:[[4357,4449],256],12914:[[4358,4449],256],12915:[[4359,4449],256],12916:[[4361,4449],256],12917:[[4363,4449],256],12918:[[4364,4449],256],12919:[[4366,4449],256],12920:[[4367,4449],256],12921:[[4368,4449],256],12922:[[4369,4449],256],12923:[[4370,4449],256],12924:[[4366,4449,4535,4352,4457],256],12925:[[4364,4462,4363,4468],256],12926:[[4363,4462],256],12928:[[19968],256],12929:[[20108],256],12930:[[19977],256],12931:[[22235],256],12932:[[20116],256],12933:[[20845],256],12934:[[19971],256],12935:[[20843],256],12936:[[20061],256],12937:[[21313],256],12938:[[26376],256],12939:[[28779],256],12940:[[27700],256],12941:[[26408],256],12942:[[37329],256],12943:[[22303],256],12944:[[26085],256],12945:[[26666],256],12946:[[26377],256],12947:[[31038],256],12948:[[21517],256],12949:[[29305],256],12950:[[36001],256],12951:[[31069],256],12952:[[21172],256],12953:[[31192],256],12954:[[30007],256],12955:[[22899],256],12956:[[36969],256],12957:[[20778],256],12958:[[21360],256],12959:[[27880],256],12960:[[38917],256],12961:[[20241],256],12962:[[20889],256],12963:[[27491],256],12964:[[19978],256],12965:[[20013],256],12966:[[19979],256],12967:[[24038],256],12968:[[21491],256],12969:[[21307],256],12970:[[23447],256],12971:[[23398],256],12972:[[30435],256],12973:[[20225],256],12974:[[36039],256],12975:[[21332],256],12976:[[22812],256],12977:[[51,54],256],12978:[[51,55],256],12979:[[51,56],256],12980:[[51,57],256],12981:[[52,48],256],12982:[[52,49],256],12983:[[52,50],256],12984:[[52,51],256],12985:[[52,52],256],12986:[[52,53],256],12987:[[52,54],256],12988:[[52,55],256],12989:[[52,56],256],12990:[[52,57],256],12991:[[53,48],256],12992:[[49,26376],256],12993:[[50,26376],256],12994:[[51,26376],256],12995:[[52,26376],256],12996:[[53,26376],256],12997:[[54,26376],256],12998:[[55,26376],256],12999:[[56,26376],256],13000:[[57,26376],256],13001:[[49,48,26376],256],13002:[[49,49,26376],256],13003:[[49,50,26376],256],13004:[[72,103],256],13005:[[101,114,103],256],13006:[[101,86],256],13007:[[76,84,68],256],13008:[[12450],256],13009:[[12452],256],13010:[[12454],256],13011:[[12456],256],13012:[[12458],256],13013:[[12459],256],13014:[[12461],256],13015:[[12463],256],13016:[[12465],256],13017:[[12467],256],13018:[[12469],256],13019:[[12471],256],13020:[[12473],256],13021:[[12475],256],13022:[[12477],256],13023:[[12479],256],13024:[[12481],256],13025:[[12484],256],13026:[[12486],256],13027:[[12488],256],13028:[[12490],256],13029:[[12491],256],13030:[[12492],256],13031:[[12493],256],13032:[[12494],256],13033:[[12495],256],13034:[[12498],256],13035:[[12501],256],13036:[[12504],256],13037:[[12507],256],13038:[[12510],256],13039:[[12511],256],13040:[[12512],256],13041:[[12513],256],13042:[[12514],256],13043:[[12516],256],13044:[[12518],256],13045:[[12520],256],13046:[[12521],256],13047:[[12522],256],13048:[[12523],256],13049:[[12524],256],13050:[[12525],256],13051:[[12527],256],13052:[[12528],256],13053:[[12529],256],13054:[[12530],256]},
    	13056:{13056:[[12450,12497,12540,12488],256],13057:[[12450,12523,12501,12449],256],13058:[[12450,12531,12506,12450],256],13059:[[12450,12540,12523],256],13060:[[12452,12491,12531,12464],256],13061:[[12452,12531,12481],256],13062:[[12454,12457,12531],256],13063:[[12456,12473,12463,12540,12489],256],13064:[[12456,12540,12459,12540],256],13065:[[12458,12531,12473],256],13066:[[12458,12540,12512],256],13067:[[12459,12452,12522],256],13068:[[12459,12521,12483,12488],256],13069:[[12459,12525,12522,12540],256],13070:[[12460,12525,12531],256],13071:[[12460,12531,12510],256],13072:[[12462,12460],256],13073:[[12462,12491,12540],256],13074:[[12461,12517,12522,12540],256],13075:[[12462,12523,12480,12540],256],13076:[[12461,12525],256],13077:[[12461,12525,12464,12521,12512],256],13078:[[12461,12525,12513,12540,12488,12523],256],13079:[[12461,12525,12527,12483,12488],256],13080:[[12464,12521,12512],256],13081:[[12464,12521,12512,12488,12531],256],13082:[[12463,12523,12476,12452,12525],256],13083:[[12463,12525,12540,12493],256],13084:[[12465,12540,12473],256],13085:[[12467,12523,12490],256],13086:[[12467,12540,12509],256],13087:[[12469,12452,12463,12523],256],13088:[[12469,12531,12481,12540,12512],256],13089:[[12471,12522,12531,12464],256],13090:[[12475,12531,12481],256],13091:[[12475,12531,12488],256],13092:[[12480,12540,12473],256],13093:[[12487,12471],256],13094:[[12489,12523],256],13095:[[12488,12531],256],13096:[[12490,12494],256],13097:[[12494,12483,12488],256],13098:[[12495,12452,12484],256],13099:[[12497,12540,12475,12531,12488],256],13100:[[12497,12540,12484],256],13101:[[12496,12540,12524,12523],256],13102:[[12500,12450,12473,12488,12523],256],13103:[[12500,12463,12523],256],13104:[[12500,12467],256],13105:[[12499,12523],256],13106:[[12501,12449,12521,12483,12489],256],13107:[[12501,12451,12540,12488],256],13108:[[12502,12483,12471,12455,12523],256],13109:[[12501,12521,12531],256],13110:[[12504,12463,12479,12540,12523],256],13111:[[12506,12477],256],13112:[[12506,12491,12498],256],13113:[[12504,12523,12484],256],13114:[[12506,12531,12473],256],13115:[[12506,12540,12472],256],13116:[[12505,12540,12479],256],13117:[[12509,12452,12531,12488],256],13118:[[12508,12523,12488],256],13119:[[12507,12531],256],13120:[[12509,12531,12489],256],13121:[[12507,12540,12523],256],13122:[[12507,12540,12531],256],13123:[[12510,12452,12463,12525],256],13124:[[12510,12452,12523],256],13125:[[12510,12483,12495],256],13126:[[12510,12523,12463],256],13127:[[12510,12531,12471,12519,12531],256],13128:[[12511,12463,12525,12531],256],13129:[[12511,12522],256],13130:[[12511,12522,12496,12540,12523],256],13131:[[12513,12460],256],13132:[[12513,12460,12488,12531],256],13133:[[12513,12540,12488,12523],256],13134:[[12516,12540,12489],256],13135:[[12516,12540,12523],256],13136:[[12518,12450,12531],256],13137:[[12522,12483,12488,12523],256],13138:[[12522,12521],256],13139:[[12523,12500,12540],256],13140:[[12523,12540,12502,12523],256],13141:[[12524,12512],256],13142:[[12524,12531,12488,12466,12531],256],13143:[[12527,12483,12488],256],13144:[[48,28857],256],13145:[[49,28857],256],13146:[[50,28857],256],13147:[[51,28857],256],13148:[[52,28857],256],13149:[[53,28857],256],13150:[[54,28857],256],13151:[[55,28857],256],13152:[[56,28857],256],13153:[[57,28857],256],13154:[[49,48,28857],256],13155:[[49,49,28857],256],13156:[[49,50,28857],256],13157:[[49,51,28857],256],13158:[[49,52,28857],256],13159:[[49,53,28857],256],13160:[[49,54,28857],256],13161:[[49,55,28857],256],13162:[[49,56,28857],256],13163:[[49,57,28857],256],13164:[[50,48,28857],256],13165:[[50,49,28857],256],13166:[[50,50,28857],256],13167:[[50,51,28857],256],13168:[[50,52,28857],256],13169:[[104,80,97],256],13170:[[100,97],256],13171:[[65,85],256],13172:[[98,97,114],256],13173:[[111,86],256],13174:[[112,99],256],13175:[[100,109],256],13176:[[100,109,178],256],13177:[[100,109,179],256],13178:[[73,85],256],13179:[[24179,25104],256],13180:[[26157,21644],256],13181:[[22823,27491],256],13182:[[26126,27835],256],13183:[[26666,24335,20250,31038],256],13184:[[112,65],256],13185:[[110,65],256],13186:[[956,65],256],13187:[[109,65],256],13188:[[107,65],256],13189:[[75,66],256],13190:[[77,66],256],13191:[[71,66],256],13192:[[99,97,108],256],13193:[[107,99,97,108],256],13194:[[112,70],256],13195:[[110,70],256],13196:[[956,70],256],13197:[[956,103],256],13198:[[109,103],256],13199:[[107,103],256],13200:[[72,122],256],13201:[[107,72,122],256],13202:[[77,72,122],256],13203:[[71,72,122],256],13204:[[84,72,122],256],13205:[[956,8467],256],13206:[[109,8467],256],13207:[[100,8467],256],13208:[[107,8467],256],13209:[[102,109],256],13210:[[110,109],256],13211:[[956,109],256],13212:[[109,109],256],13213:[[99,109],256],13214:[[107,109],256],13215:[[109,109,178],256],13216:[[99,109,178],256],13217:[[109,178],256],13218:[[107,109,178],256],13219:[[109,109,179],256],13220:[[99,109,179],256],13221:[[109,179],256],13222:[[107,109,179],256],13223:[[109,8725,115],256],13224:[[109,8725,115,178],256],13225:[[80,97],256],13226:[[107,80,97],256],13227:[[77,80,97],256],13228:[[71,80,97],256],13229:[[114,97,100],256],13230:[[114,97,100,8725,115],256],13231:[[114,97,100,8725,115,178],256],13232:[[112,115],256],13233:[[110,115],256],13234:[[956,115],256],13235:[[109,115],256],13236:[[112,86],256],13237:[[110,86],256],13238:[[956,86],256],13239:[[109,86],256],13240:[[107,86],256],13241:[[77,86],256],13242:[[112,87],256],13243:[[110,87],256],13244:[[956,87],256],13245:[[109,87],256],13246:[[107,87],256],13247:[[77,87],256],13248:[[107,937],256],13249:[[77,937],256],13250:[[97,46,109,46],256],13251:[[66,113],256],13252:[[99,99],256],13253:[[99,100],256],13254:[[67,8725,107,103],256],13255:[[67,111,46],256],13256:[[100,66],256],13257:[[71,121],256],13258:[[104,97],256],13259:[[72,80],256],13260:[[105,110],256],13261:[[75,75],256],13262:[[75,77],256],13263:[[107,116],256],13264:[[108,109],256],13265:[[108,110],256],13266:[[108,111,103],256],13267:[[108,120],256],13268:[[109,98],256],13269:[[109,105,108],256],13270:[[109,111,108],256],13271:[[80,72],256],13272:[[112,46,109,46],256],13273:[[80,80,77],256],13274:[[80,82],256],13275:[[115,114],256],13276:[[83,118],256],13277:[[87,98],256],13278:[[86,8725,109],256],13279:[[65,8725,109],256],13280:[[49,26085],256],13281:[[50,26085],256],13282:[[51,26085],256],13283:[[52,26085],256],13284:[[53,26085],256],13285:[[54,26085],256],13286:[[55,26085],256],13287:[[56,26085],256],13288:[[57,26085],256],13289:[[49,48,26085],256],13290:[[49,49,26085],256],13291:[[49,50,26085],256],13292:[[49,51,26085],256],13293:[[49,52,26085],256],13294:[[49,53,26085],256],13295:[[49,54,26085],256],13296:[[49,55,26085],256],13297:[[49,56,26085],256],13298:[[49,57,26085],256],13299:[[50,48,26085],256],13300:[[50,49,26085],256],13301:[[50,50,26085],256],13302:[[50,51,26085],256],13303:[[50,52,26085],256],13304:[[50,53,26085],256],13305:[[50,54,26085],256],13306:[[50,55,26085],256],13307:[[50,56,26085],256],13308:[[50,57,26085],256],13309:[[51,48,26085],256],13310:[[51,49,26085],256],13311:[[103,97,108],256]},
    	27136:{92912:[,1],92913:[,1],92914:[,1],92915:[,1],92916:[,1]},
    	27392:{92976:[,230],92977:[,230],92978:[,230],92979:[,230],92980:[,230],92981:[,230],92982:[,230]},
    	42496:{42607:[,230],42612:[,230],42613:[,230],42614:[,230],42615:[,230],42616:[,230],42617:[,230],42618:[,230],42619:[,230],42620:[,230],42621:[,230],42652:[[1098],256],42653:[[1100],256],42655:[,230],42736:[,230],42737:[,230]},
    	42752:{42864:[[42863],256],43000:[[294],256],43001:[[339],256]},
    	43008:{43014:[,9],43204:[,9],43232:[,230],43233:[,230],43234:[,230],43235:[,230],43236:[,230],43237:[,230],43238:[,230],43239:[,230],43240:[,230],43241:[,230],43242:[,230],43243:[,230],43244:[,230],43245:[,230],43246:[,230],43247:[,230],43248:[,230],43249:[,230]},
    	43264:{43307:[,220],43308:[,220],43309:[,220],43347:[,9],43443:[,7],43456:[,9]},
    	43520:{43696:[,230],43698:[,230],43699:[,230],43700:[,220],43703:[,230],43704:[,230],43710:[,230],43711:[,230],43713:[,230],43766:[,9]},
    	43776:{43868:[[42791],256],43869:[[43831],256],43870:[[619],256],43871:[[43858],256],44013:[,9]},
    	48128:{113822:[,1]},
    	53504:{119134:[[119127,119141],512],119135:[[119128,119141],512],119136:[[119135,119150],512],119137:[[119135,119151],512],119138:[[119135,119152],512],119139:[[119135,119153],512],119140:[[119135,119154],512],119141:[,216],119142:[,216],119143:[,1],119144:[,1],119145:[,1],119149:[,226],119150:[,216],119151:[,216],119152:[,216],119153:[,216],119154:[,216],119163:[,220],119164:[,220],119165:[,220],119166:[,220],119167:[,220],119168:[,220],119169:[,220],119170:[,220],119173:[,230],119174:[,230],119175:[,230],119176:[,230],119177:[,230],119178:[,220],119179:[,220],119210:[,230],119211:[,230],119212:[,230],119213:[,230],119227:[[119225,119141],512],119228:[[119226,119141],512],119229:[[119227,119150],512],119230:[[119228,119150],512],119231:[[119227,119151],512],119232:[[119228,119151],512]},
    	53760:{119362:[,230],119363:[,230],119364:[,230]},
    	54272:{119808:[[65],256],119809:[[66],256],119810:[[67],256],119811:[[68],256],119812:[[69],256],119813:[[70],256],119814:[[71],256],119815:[[72],256],119816:[[73],256],119817:[[74],256],119818:[[75],256],119819:[[76],256],119820:[[77],256],119821:[[78],256],119822:[[79],256],119823:[[80],256],119824:[[81],256],119825:[[82],256],119826:[[83],256],119827:[[84],256],119828:[[85],256],119829:[[86],256],119830:[[87],256],119831:[[88],256],119832:[[89],256],119833:[[90],256],119834:[[97],256],119835:[[98],256],119836:[[99],256],119837:[[100],256],119838:[[101],256],119839:[[102],256],119840:[[103],256],119841:[[104],256],119842:[[105],256],119843:[[106],256],119844:[[107],256],119845:[[108],256],119846:[[109],256],119847:[[110],256],119848:[[111],256],119849:[[112],256],119850:[[113],256],119851:[[114],256],119852:[[115],256],119853:[[116],256],119854:[[117],256],119855:[[118],256],119856:[[119],256],119857:[[120],256],119858:[[121],256],119859:[[122],256],119860:[[65],256],119861:[[66],256],119862:[[67],256],119863:[[68],256],119864:[[69],256],119865:[[70],256],119866:[[71],256],119867:[[72],256],119868:[[73],256],119869:[[74],256],119870:[[75],256],119871:[[76],256],119872:[[77],256],119873:[[78],256],119874:[[79],256],119875:[[80],256],119876:[[81],256],119877:[[82],256],119878:[[83],256],119879:[[84],256],119880:[[85],256],119881:[[86],256],119882:[[87],256],119883:[[88],256],119884:[[89],256],119885:[[90],256],119886:[[97],256],119887:[[98],256],119888:[[99],256],119889:[[100],256],119890:[[101],256],119891:[[102],256],119892:[[103],256],119894:[[105],256],119895:[[106],256],119896:[[107],256],119897:[[108],256],119898:[[109],256],119899:[[110],256],119900:[[111],256],119901:[[112],256],119902:[[113],256],119903:[[114],256],119904:[[115],256],119905:[[116],256],119906:[[117],256],119907:[[118],256],119908:[[119],256],119909:[[120],256],119910:[[121],256],119911:[[122],256],119912:[[65],256],119913:[[66],256],119914:[[67],256],119915:[[68],256],119916:[[69],256],119917:[[70],256],119918:[[71],256],119919:[[72],256],119920:[[73],256],119921:[[74],256],119922:[[75],256],119923:[[76],256],119924:[[77],256],119925:[[78],256],119926:[[79],256],119927:[[80],256],119928:[[81],256],119929:[[82],256],119930:[[83],256],119931:[[84],256],119932:[[85],256],119933:[[86],256],119934:[[87],256],119935:[[88],256],119936:[[89],256],119937:[[90],256],119938:[[97],256],119939:[[98],256],119940:[[99],256],119941:[[100],256],119942:[[101],256],119943:[[102],256],119944:[[103],256],119945:[[104],256],119946:[[105],256],119947:[[106],256],119948:[[107],256],119949:[[108],256],119950:[[109],256],119951:[[110],256],119952:[[111],256],119953:[[112],256],119954:[[113],256],119955:[[114],256],119956:[[115],256],119957:[[116],256],119958:[[117],256],119959:[[118],256],119960:[[119],256],119961:[[120],256],119962:[[121],256],119963:[[122],256],119964:[[65],256],119966:[[67],256],119967:[[68],256],119970:[[71],256],119973:[[74],256],119974:[[75],256],119977:[[78],256],119978:[[79],256],119979:[[80],256],119980:[[81],256],119982:[[83],256],119983:[[84],256],119984:[[85],256],119985:[[86],256],119986:[[87],256],119987:[[88],256],119988:[[89],256],119989:[[90],256],119990:[[97],256],119991:[[98],256],119992:[[99],256],119993:[[100],256],119995:[[102],256],119997:[[104],256],119998:[[105],256],119999:[[106],256],120000:[[107],256],120001:[[108],256],120002:[[109],256],120003:[[110],256],120005:[[112],256],120006:[[113],256],120007:[[114],256],120008:[[115],256],120009:[[116],256],120010:[[117],256],120011:[[118],256],120012:[[119],256],120013:[[120],256],120014:[[121],256],120015:[[122],256],120016:[[65],256],120017:[[66],256],120018:[[67],256],120019:[[68],256],120020:[[69],256],120021:[[70],256],120022:[[71],256],120023:[[72],256],120024:[[73],256],120025:[[74],256],120026:[[75],256],120027:[[76],256],120028:[[77],256],120029:[[78],256],120030:[[79],256],120031:[[80],256],120032:[[81],256],120033:[[82],256],120034:[[83],256],120035:[[84],256],120036:[[85],256],120037:[[86],256],120038:[[87],256],120039:[[88],256],120040:[[89],256],120041:[[90],256],120042:[[97],256],120043:[[98],256],120044:[[99],256],120045:[[100],256],120046:[[101],256],120047:[[102],256],120048:[[103],256],120049:[[104],256],120050:[[105],256],120051:[[106],256],120052:[[107],256],120053:[[108],256],120054:[[109],256],120055:[[110],256],120056:[[111],256],120057:[[112],256],120058:[[113],256],120059:[[114],256],120060:[[115],256],120061:[[116],256],120062:[[117],256],120063:[[118],256]},
    	54528:{120064:[[119],256],120065:[[120],256],120066:[[121],256],120067:[[122],256],120068:[[65],256],120069:[[66],256],120071:[[68],256],120072:[[69],256],120073:[[70],256],120074:[[71],256],120077:[[74],256],120078:[[75],256],120079:[[76],256],120080:[[77],256],120081:[[78],256],120082:[[79],256],120083:[[80],256],120084:[[81],256],120086:[[83],256],120087:[[84],256],120088:[[85],256],120089:[[86],256],120090:[[87],256],120091:[[88],256],120092:[[89],256],120094:[[97],256],120095:[[98],256],120096:[[99],256],120097:[[100],256],120098:[[101],256],120099:[[102],256],120100:[[103],256],120101:[[104],256],120102:[[105],256],120103:[[106],256],120104:[[107],256],120105:[[108],256],120106:[[109],256],120107:[[110],256],120108:[[111],256],120109:[[112],256],120110:[[113],256],120111:[[114],256],120112:[[115],256],120113:[[116],256],120114:[[117],256],120115:[[118],256],120116:[[119],256],120117:[[120],256],120118:[[121],256],120119:[[122],256],120120:[[65],256],120121:[[66],256],120123:[[68],256],120124:[[69],256],120125:[[70],256],120126:[[71],256],120128:[[73],256],120129:[[74],256],120130:[[75],256],120131:[[76],256],120132:[[77],256],120134:[[79],256],120138:[[83],256],120139:[[84],256],120140:[[85],256],120141:[[86],256],120142:[[87],256],120143:[[88],256],120144:[[89],256],120146:[[97],256],120147:[[98],256],120148:[[99],256],120149:[[100],256],120150:[[101],256],120151:[[102],256],120152:[[103],256],120153:[[104],256],120154:[[105],256],120155:[[106],256],120156:[[107],256],120157:[[108],256],120158:[[109],256],120159:[[110],256],120160:[[111],256],120161:[[112],256],120162:[[113],256],120163:[[114],256],120164:[[115],256],120165:[[116],256],120166:[[117],256],120167:[[118],256],120168:[[119],256],120169:[[120],256],120170:[[121],256],120171:[[122],256],120172:[[65],256],120173:[[66],256],120174:[[67],256],120175:[[68],256],120176:[[69],256],120177:[[70],256],120178:[[71],256],120179:[[72],256],120180:[[73],256],120181:[[74],256],120182:[[75],256],120183:[[76],256],120184:[[77],256],120185:[[78],256],120186:[[79],256],120187:[[80],256],120188:[[81],256],120189:[[82],256],120190:[[83],256],120191:[[84],256],120192:[[85],256],120193:[[86],256],120194:[[87],256],120195:[[88],256],120196:[[89],256],120197:[[90],256],120198:[[97],256],120199:[[98],256],120200:[[99],256],120201:[[100],256],120202:[[101],256],120203:[[102],256],120204:[[103],256],120205:[[104],256],120206:[[105],256],120207:[[106],256],120208:[[107],256],120209:[[108],256],120210:[[109],256],120211:[[110],256],120212:[[111],256],120213:[[112],256],120214:[[113],256],120215:[[114],256],120216:[[115],256],120217:[[116],256],120218:[[117],256],120219:[[118],256],120220:[[119],256],120221:[[120],256],120222:[[121],256],120223:[[122],256],120224:[[65],256],120225:[[66],256],120226:[[67],256],120227:[[68],256],120228:[[69],256],120229:[[70],256],120230:[[71],256],120231:[[72],256],120232:[[73],256],120233:[[74],256],120234:[[75],256],120235:[[76],256],120236:[[77],256],120237:[[78],256],120238:[[79],256],120239:[[80],256],120240:[[81],256],120241:[[82],256],120242:[[83],256],120243:[[84],256],120244:[[85],256],120245:[[86],256],120246:[[87],256],120247:[[88],256],120248:[[89],256],120249:[[90],256],120250:[[97],256],120251:[[98],256],120252:[[99],256],120253:[[100],256],120254:[[101],256],120255:[[102],256],120256:[[103],256],120257:[[104],256],120258:[[105],256],120259:[[106],256],120260:[[107],256],120261:[[108],256],120262:[[109],256],120263:[[110],256],120264:[[111],256],120265:[[112],256],120266:[[113],256],120267:[[114],256],120268:[[115],256],120269:[[116],256],120270:[[117],256],120271:[[118],256],120272:[[119],256],120273:[[120],256],120274:[[121],256],120275:[[122],256],120276:[[65],256],120277:[[66],256],120278:[[67],256],120279:[[68],256],120280:[[69],256],120281:[[70],256],120282:[[71],256],120283:[[72],256],120284:[[73],256],120285:[[74],256],120286:[[75],256],120287:[[76],256],120288:[[77],256],120289:[[78],256],120290:[[79],256],120291:[[80],256],120292:[[81],256],120293:[[82],256],120294:[[83],256],120295:[[84],256],120296:[[85],256],120297:[[86],256],120298:[[87],256],120299:[[88],256],120300:[[89],256],120301:[[90],256],120302:[[97],256],120303:[[98],256],120304:[[99],256],120305:[[100],256],120306:[[101],256],120307:[[102],256],120308:[[103],256],120309:[[104],256],120310:[[105],256],120311:[[106],256],120312:[[107],256],120313:[[108],256],120314:[[109],256],120315:[[110],256],120316:[[111],256],120317:[[112],256],120318:[[113],256],120319:[[114],256]},
    	54784:{120320:[[115],256],120321:[[116],256],120322:[[117],256],120323:[[118],256],120324:[[119],256],120325:[[120],256],120326:[[121],256],120327:[[122],256],120328:[[65],256],120329:[[66],256],120330:[[67],256],120331:[[68],256],120332:[[69],256],120333:[[70],256],120334:[[71],256],120335:[[72],256],120336:[[73],256],120337:[[74],256],120338:[[75],256],120339:[[76],256],120340:[[77],256],120341:[[78],256],120342:[[79],256],120343:[[80],256],120344:[[81],256],120345:[[82],256],120346:[[83],256],120347:[[84],256],120348:[[85],256],120349:[[86],256],120350:[[87],256],120351:[[88],256],120352:[[89],256],120353:[[90],256],120354:[[97],256],120355:[[98],256],120356:[[99],256],120357:[[100],256],120358:[[101],256],120359:[[102],256],120360:[[103],256],120361:[[104],256],120362:[[105],256],120363:[[106],256],120364:[[107],256],120365:[[108],256],120366:[[109],256],120367:[[110],256],120368:[[111],256],120369:[[112],256],120370:[[113],256],120371:[[114],256],120372:[[115],256],120373:[[116],256],120374:[[117],256],120375:[[118],256],120376:[[119],256],120377:[[120],256],120378:[[121],256],120379:[[122],256],120380:[[65],256],120381:[[66],256],120382:[[67],256],120383:[[68],256],120384:[[69],256],120385:[[70],256],120386:[[71],256],120387:[[72],256],120388:[[73],256],120389:[[74],256],120390:[[75],256],120391:[[76],256],120392:[[77],256],120393:[[78],256],120394:[[79],256],120395:[[80],256],120396:[[81],256],120397:[[82],256],120398:[[83],256],120399:[[84],256],120400:[[85],256],120401:[[86],256],120402:[[87],256],120403:[[88],256],120404:[[89],256],120405:[[90],256],120406:[[97],256],120407:[[98],256],120408:[[99],256],120409:[[100],256],120410:[[101],256],120411:[[102],256],120412:[[103],256],120413:[[104],256],120414:[[105],256],120415:[[106],256],120416:[[107],256],120417:[[108],256],120418:[[109],256],120419:[[110],256],120420:[[111],256],120421:[[112],256],120422:[[113],256],120423:[[114],256],120424:[[115],256],120425:[[116],256],120426:[[117],256],120427:[[118],256],120428:[[119],256],120429:[[120],256],120430:[[121],256],120431:[[122],256],120432:[[65],256],120433:[[66],256],120434:[[67],256],120435:[[68],256],120436:[[69],256],120437:[[70],256],120438:[[71],256],120439:[[72],256],120440:[[73],256],120441:[[74],256],120442:[[75],256],120443:[[76],256],120444:[[77],256],120445:[[78],256],120446:[[79],256],120447:[[80],256],120448:[[81],256],120449:[[82],256],120450:[[83],256],120451:[[84],256],120452:[[85],256],120453:[[86],256],120454:[[87],256],120455:[[88],256],120456:[[89],256],120457:[[90],256],120458:[[97],256],120459:[[98],256],120460:[[99],256],120461:[[100],256],120462:[[101],256],120463:[[102],256],120464:[[103],256],120465:[[104],256],120466:[[105],256],120467:[[106],256],120468:[[107],256],120469:[[108],256],120470:[[109],256],120471:[[110],256],120472:[[111],256],120473:[[112],256],120474:[[113],256],120475:[[114],256],120476:[[115],256],120477:[[116],256],120478:[[117],256],120479:[[118],256],120480:[[119],256],120481:[[120],256],120482:[[121],256],120483:[[122],256],120484:[[305],256],120485:[[567],256],120488:[[913],256],120489:[[914],256],120490:[[915],256],120491:[[916],256],120492:[[917],256],120493:[[918],256],120494:[[919],256],120495:[[920],256],120496:[[921],256],120497:[[922],256],120498:[[923],256],120499:[[924],256],120500:[[925],256],120501:[[926],256],120502:[[927],256],120503:[[928],256],120504:[[929],256],120505:[[1012],256],120506:[[931],256],120507:[[932],256],120508:[[933],256],120509:[[934],256],120510:[[935],256],120511:[[936],256],120512:[[937],256],120513:[[8711],256],120514:[[945],256],120515:[[946],256],120516:[[947],256],120517:[[948],256],120518:[[949],256],120519:[[950],256],120520:[[951],256],120521:[[952],256],120522:[[953],256],120523:[[954],256],120524:[[955],256],120525:[[956],256],120526:[[957],256],120527:[[958],256],120528:[[959],256],120529:[[960],256],120530:[[961],256],120531:[[962],256],120532:[[963],256],120533:[[964],256],120534:[[965],256],120535:[[966],256],120536:[[967],256],120537:[[968],256],120538:[[969],256],120539:[[8706],256],120540:[[1013],256],120541:[[977],256],120542:[[1008],256],120543:[[981],256],120544:[[1009],256],120545:[[982],256],120546:[[913],256],120547:[[914],256],120548:[[915],256],120549:[[916],256],120550:[[917],256],120551:[[918],256],120552:[[919],256],120553:[[920],256],120554:[[921],256],120555:[[922],256],120556:[[923],256],120557:[[924],256],120558:[[925],256],120559:[[926],256],120560:[[927],256],120561:[[928],256],120562:[[929],256],120563:[[1012],256],120564:[[931],256],120565:[[932],256],120566:[[933],256],120567:[[934],256],120568:[[935],256],120569:[[936],256],120570:[[937],256],120571:[[8711],256],120572:[[945],256],120573:[[946],256],120574:[[947],256],120575:[[948],256]},
    	55040:{120576:[[949],256],120577:[[950],256],120578:[[951],256],120579:[[952],256],120580:[[953],256],120581:[[954],256],120582:[[955],256],120583:[[956],256],120584:[[957],256],120585:[[958],256],120586:[[959],256],120587:[[960],256],120588:[[961],256],120589:[[962],256],120590:[[963],256],120591:[[964],256],120592:[[965],256],120593:[[966],256],120594:[[967],256],120595:[[968],256],120596:[[969],256],120597:[[8706],256],120598:[[1013],256],120599:[[977],256],120600:[[1008],256],120601:[[981],256],120602:[[1009],256],120603:[[982],256],120604:[[913],256],120605:[[914],256],120606:[[915],256],120607:[[916],256],120608:[[917],256],120609:[[918],256],120610:[[919],256],120611:[[920],256],120612:[[921],256],120613:[[922],256],120614:[[923],256],120615:[[924],256],120616:[[925],256],120617:[[926],256],120618:[[927],256],120619:[[928],256],120620:[[929],256],120621:[[1012],256],120622:[[931],256],120623:[[932],256],120624:[[933],256],120625:[[934],256],120626:[[935],256],120627:[[936],256],120628:[[937],256],120629:[[8711],256],120630:[[945],256],120631:[[946],256],120632:[[947],256],120633:[[948],256],120634:[[949],256],120635:[[950],256],120636:[[951],256],120637:[[952],256],120638:[[953],256],120639:[[954],256],120640:[[955],256],120641:[[956],256],120642:[[957],256],120643:[[958],256],120644:[[959],256],120645:[[960],256],120646:[[961],256],120647:[[962],256],120648:[[963],256],120649:[[964],256],120650:[[965],256],120651:[[966],256],120652:[[967],256],120653:[[968],256],120654:[[969],256],120655:[[8706],256],120656:[[1013],256],120657:[[977],256],120658:[[1008],256],120659:[[981],256],120660:[[1009],256],120661:[[982],256],120662:[[913],256],120663:[[914],256],120664:[[915],256],120665:[[916],256],120666:[[917],256],120667:[[918],256],120668:[[919],256],120669:[[920],256],120670:[[921],256],120671:[[922],256],120672:[[923],256],120673:[[924],256],120674:[[925],256],120675:[[926],256],120676:[[927],256],120677:[[928],256],120678:[[929],256],120679:[[1012],256],120680:[[931],256],120681:[[932],256],120682:[[933],256],120683:[[934],256],120684:[[935],256],120685:[[936],256],120686:[[937],256],120687:[[8711],256],120688:[[945],256],120689:[[946],256],120690:[[947],256],120691:[[948],256],120692:[[949],256],120693:[[950],256],120694:[[951],256],120695:[[952],256],120696:[[953],256],120697:[[954],256],120698:[[955],256],120699:[[956],256],120700:[[957],256],120701:[[958],256],120702:[[959],256],120703:[[960],256],120704:[[961],256],120705:[[962],256],120706:[[963],256],120707:[[964],256],120708:[[965],256],120709:[[966],256],120710:[[967],256],120711:[[968],256],120712:[[969],256],120713:[[8706],256],120714:[[1013],256],120715:[[977],256],120716:[[1008],256],120717:[[981],256],120718:[[1009],256],120719:[[982],256],120720:[[913],256],120721:[[914],256],120722:[[915],256],120723:[[916],256],120724:[[917],256],120725:[[918],256],120726:[[919],256],120727:[[920],256],120728:[[921],256],120729:[[922],256],120730:[[923],256],120731:[[924],256],120732:[[925],256],120733:[[926],256],120734:[[927],256],120735:[[928],256],120736:[[929],256],120737:[[1012],256],120738:[[931],256],120739:[[932],256],120740:[[933],256],120741:[[934],256],120742:[[935],256],120743:[[936],256],120744:[[937],256],120745:[[8711],256],120746:[[945],256],120747:[[946],256],120748:[[947],256],120749:[[948],256],120750:[[949],256],120751:[[950],256],120752:[[951],256],120753:[[952],256],120754:[[953],256],120755:[[954],256],120756:[[955],256],120757:[[956],256],120758:[[957],256],120759:[[958],256],120760:[[959],256],120761:[[960],256],120762:[[961],256],120763:[[962],256],120764:[[963],256],120765:[[964],256],120766:[[965],256],120767:[[966],256],120768:[[967],256],120769:[[968],256],120770:[[969],256],120771:[[8706],256],120772:[[1013],256],120773:[[977],256],120774:[[1008],256],120775:[[981],256],120776:[[1009],256],120777:[[982],256],120778:[[988],256],120779:[[989],256],120782:[[48],256],120783:[[49],256],120784:[[50],256],120785:[[51],256],120786:[[52],256],120787:[[53],256],120788:[[54],256],120789:[[55],256],120790:[[56],256],120791:[[57],256],120792:[[48],256],120793:[[49],256],120794:[[50],256],120795:[[51],256],120796:[[52],256],120797:[[53],256],120798:[[54],256],120799:[[55],256],120800:[[56],256],120801:[[57],256],120802:[[48],256],120803:[[49],256],120804:[[50],256],120805:[[51],256],120806:[[52],256],120807:[[53],256],120808:[[54],256],120809:[[55],256],120810:[[56],256],120811:[[57],256],120812:[[48],256],120813:[[49],256],120814:[[50],256],120815:[[51],256],120816:[[52],256],120817:[[53],256],120818:[[54],256],120819:[[55],256],120820:[[56],256],120821:[[57],256],120822:[[48],256],120823:[[49],256],120824:[[50],256],120825:[[51],256],120826:[[52],256],120827:[[53],256],120828:[[54],256],120829:[[55],256],120830:[[56],256],120831:[[57],256]},
    	59392:{125136:[,220],125137:[,220],125138:[,220],125139:[,220],125140:[,220],125141:[,220],125142:[,220]},
    	60928:{126464:[[1575],256],126465:[[1576],256],126466:[[1580],256],126467:[[1583],256],126469:[[1608],256],126470:[[1586],256],126471:[[1581],256],126472:[[1591],256],126473:[[1610],256],126474:[[1603],256],126475:[[1604],256],126476:[[1605],256],126477:[[1606],256],126478:[[1587],256],126479:[[1593],256],126480:[[1601],256],126481:[[1589],256],126482:[[1602],256],126483:[[1585],256],126484:[[1588],256],126485:[[1578],256],126486:[[1579],256],126487:[[1582],256],126488:[[1584],256],126489:[[1590],256],126490:[[1592],256],126491:[[1594],256],126492:[[1646],256],126493:[[1722],256],126494:[[1697],256],126495:[[1647],256],126497:[[1576],256],126498:[[1580],256],126500:[[1607],256],126503:[[1581],256],126505:[[1610],256],126506:[[1603],256],126507:[[1604],256],126508:[[1605],256],126509:[[1606],256],126510:[[1587],256],126511:[[1593],256],126512:[[1601],256],126513:[[1589],256],126514:[[1602],256],126516:[[1588],256],126517:[[1578],256],126518:[[1579],256],126519:[[1582],256],126521:[[1590],256],126523:[[1594],256],126530:[[1580],256],126535:[[1581],256],126537:[[1610],256],126539:[[1604],256],126541:[[1606],256],126542:[[1587],256],126543:[[1593],256],126545:[[1589],256],126546:[[1602],256],126548:[[1588],256],126551:[[1582],256],126553:[[1590],256],126555:[[1594],256],126557:[[1722],256],126559:[[1647],256],126561:[[1576],256],126562:[[1580],256],126564:[[1607],256],126567:[[1581],256],126568:[[1591],256],126569:[[1610],256],126570:[[1603],256],126572:[[1605],256],126573:[[1606],256],126574:[[1587],256],126575:[[1593],256],126576:[[1601],256],126577:[[1589],256],126578:[[1602],256],126580:[[1588],256],126581:[[1578],256],126582:[[1579],256],126583:[[1582],256],126585:[[1590],256],126586:[[1592],256],126587:[[1594],256],126588:[[1646],256],126590:[[1697],256],126592:[[1575],256],126593:[[1576],256],126594:[[1580],256],126595:[[1583],256],126596:[[1607],256],126597:[[1608],256],126598:[[1586],256],126599:[[1581],256],126600:[[1591],256],126601:[[1610],256],126603:[[1604],256],126604:[[1605],256],126605:[[1606],256],126606:[[1587],256],126607:[[1593],256],126608:[[1601],256],126609:[[1589],256],126610:[[1602],256],126611:[[1585],256],126612:[[1588],256],126613:[[1578],256],126614:[[1579],256],126615:[[1582],256],126616:[[1584],256],126617:[[1590],256],126618:[[1592],256],126619:[[1594],256],126625:[[1576],256],126626:[[1580],256],126627:[[1583],256],126629:[[1608],256],126630:[[1586],256],126631:[[1581],256],126632:[[1591],256],126633:[[1610],256],126635:[[1604],256],126636:[[1605],256],126637:[[1606],256],126638:[[1587],256],126639:[[1593],256],126640:[[1601],256],126641:[[1589],256],126642:[[1602],256],126643:[[1585],256],126644:[[1588],256],126645:[[1578],256],126646:[[1579],256],126647:[[1582],256],126648:[[1584],256],126649:[[1590],256],126650:[[1592],256],126651:[[1594],256]},
    	61696:{127232:[[48,46],256],127233:[[48,44],256],127234:[[49,44],256],127235:[[50,44],256],127236:[[51,44],256],127237:[[52,44],256],127238:[[53,44],256],127239:[[54,44],256],127240:[[55,44],256],127241:[[56,44],256],127242:[[57,44],256],127248:[[40,65,41],256],127249:[[40,66,41],256],127250:[[40,67,41],256],127251:[[40,68,41],256],127252:[[40,69,41],256],127253:[[40,70,41],256],127254:[[40,71,41],256],127255:[[40,72,41],256],127256:[[40,73,41],256],127257:[[40,74,41],256],127258:[[40,75,41],256],127259:[[40,76,41],256],127260:[[40,77,41],256],127261:[[40,78,41],256],127262:[[40,79,41],256],127263:[[40,80,41],256],127264:[[40,81,41],256],127265:[[40,82,41],256],127266:[[40,83,41],256],127267:[[40,84,41],256],127268:[[40,85,41],256],127269:[[40,86,41],256],127270:[[40,87,41],256],127271:[[40,88,41],256],127272:[[40,89,41],256],127273:[[40,90,41],256],127274:[[12308,83,12309],256],127275:[[67],256],127276:[[82],256],127277:[[67,68],256],127278:[[87,90],256],127280:[[65],256],127281:[[66],256],127282:[[67],256],127283:[[68],256],127284:[[69],256],127285:[[70],256],127286:[[71],256],127287:[[72],256],127288:[[73],256],127289:[[74],256],127290:[[75],256],127291:[[76],256],127292:[[77],256],127293:[[78],256],127294:[[79],256],127295:[[80],256],127296:[[81],256],127297:[[82],256],127298:[[83],256],127299:[[84],256],127300:[[85],256],127301:[[86],256],127302:[[87],256],127303:[[88],256],127304:[[89],256],127305:[[90],256],127306:[[72,86],256],127307:[[77,86],256],127308:[[83,68],256],127309:[[83,83],256],127310:[[80,80,86],256],127311:[[87,67],256],127338:[[77,67],256],127339:[[77,68],256],127376:[[68,74],256]},
    	61952:{127488:[[12411,12363],256],127489:[[12467,12467],256],127490:[[12469],256],127504:[[25163],256],127505:[[23383],256],127506:[[21452],256],127507:[[12487],256],127508:[[20108],256],127509:[[22810],256],127510:[[35299],256],127511:[[22825],256],127512:[[20132],256],127513:[[26144],256],127514:[[28961],256],127515:[[26009],256],127516:[[21069],256],127517:[[24460],256],127518:[[20877],256],127519:[[26032],256],127520:[[21021],256],127521:[[32066],256],127522:[[29983],256],127523:[[36009],256],127524:[[22768],256],127525:[[21561],256],127526:[[28436],256],127527:[[25237],256],127528:[[25429],256],127529:[[19968],256],127530:[[19977],256],127531:[[36938],256],127532:[[24038],256],127533:[[20013],256],127534:[[21491],256],127535:[[25351],256],127536:[[36208],256],127537:[[25171],256],127538:[[31105],256],127539:[[31354],256],127540:[[21512],256],127541:[[28288],256],127542:[[26377],256],127543:[[26376],256],127544:[[30003],256],127545:[[21106],256],127546:[[21942],256],127552:[[12308,26412,12309],256],127553:[[12308,19977,12309],256],127554:[[12308,20108,12309],256],127555:[[12308,23433,12309],256],127556:[[12308,28857,12309],256],127557:[[12308,25171,12309],256],127558:[[12308,30423,12309],256],127559:[[12308,21213,12309],256],127560:[[12308,25943,12309],256],127568:[[24471],256],127569:[[21487],256]},
    	63488:{194560:[[20029]],194561:[[20024]],194562:[[20033]],194563:[[131362]],194564:[[20320]],194565:[[20398]],194566:[[20411]],194567:[[20482]],194568:[[20602]],194569:[[20633]],194570:[[20711]],194571:[[20687]],194572:[[13470]],194573:[[132666]],194574:[[20813]],194575:[[20820]],194576:[[20836]],194577:[[20855]],194578:[[132380]],194579:[[13497]],194580:[[20839]],194581:[[20877]],194582:[[132427]],194583:[[20887]],194584:[[20900]],194585:[[20172]],194586:[[20908]],194587:[[20917]],194588:[[168415]],194589:[[20981]],194590:[[20995]],194591:[[13535]],194592:[[21051]],194593:[[21062]],194594:[[21106]],194595:[[21111]],194596:[[13589]],194597:[[21191]],194598:[[21193]],194599:[[21220]],194600:[[21242]],194601:[[21253]],194602:[[21254]],194603:[[21271]],194604:[[21321]],194605:[[21329]],194606:[[21338]],194607:[[21363]],194608:[[21373]],194609:[[21375]],194610:[[21375]],194611:[[21375]],194612:[[133676]],194613:[[28784]],194614:[[21450]],194615:[[21471]],194616:[[133987]],194617:[[21483]],194618:[[21489]],194619:[[21510]],194620:[[21662]],194621:[[21560]],194622:[[21576]],194623:[[21608]],194624:[[21666]],194625:[[21750]],194626:[[21776]],194627:[[21843]],194628:[[21859]],194629:[[21892]],194630:[[21892]],194631:[[21913]],194632:[[21931]],194633:[[21939]],194634:[[21954]],194635:[[22294]],194636:[[22022]],194637:[[22295]],194638:[[22097]],194639:[[22132]],194640:[[20999]],194641:[[22766]],194642:[[22478]],194643:[[22516]],194644:[[22541]],194645:[[22411]],194646:[[22578]],194647:[[22577]],194648:[[22700]],194649:[[136420]],194650:[[22770]],194651:[[22775]],194652:[[22790]],194653:[[22810]],194654:[[22818]],194655:[[22882]],194656:[[136872]],194657:[[136938]],194658:[[23020]],194659:[[23067]],194660:[[23079]],194661:[[23000]],194662:[[23142]],194663:[[14062]],194664:[[14076]],194665:[[23304]],194666:[[23358]],194667:[[23358]],194668:[[137672]],194669:[[23491]],194670:[[23512]],194671:[[23527]],194672:[[23539]],194673:[[138008]],194674:[[23551]],194675:[[23558]],194676:[[24403]],194677:[[23586]],194678:[[14209]],194679:[[23648]],194680:[[23662]],194681:[[23744]],194682:[[23693]],194683:[[138724]],194684:[[23875]],194685:[[138726]],194686:[[23918]],194687:[[23915]],194688:[[23932]],194689:[[24033]],194690:[[24034]],194691:[[14383]],194692:[[24061]],194693:[[24104]],194694:[[24125]],194695:[[24169]],194696:[[14434]],194697:[[139651]],194698:[[14460]],194699:[[24240]],194700:[[24243]],194701:[[24246]],194702:[[24266]],194703:[[172946]],194704:[[24318]],194705:[[140081]],194706:[[140081]],194707:[[33281]],194708:[[24354]],194709:[[24354]],194710:[[14535]],194711:[[144056]],194712:[[156122]],194713:[[24418]],194714:[[24427]],194715:[[14563]],194716:[[24474]],194717:[[24525]],194718:[[24535]],194719:[[24569]],194720:[[24705]],194721:[[14650]],194722:[[14620]],194723:[[24724]],194724:[[141012]],194725:[[24775]],194726:[[24904]],194727:[[24908]],194728:[[24910]],194729:[[24908]],194730:[[24954]],194731:[[24974]],194732:[[25010]],194733:[[24996]],194734:[[25007]],194735:[[25054]],194736:[[25074]],194737:[[25078]],194738:[[25104]],194739:[[25115]],194740:[[25181]],194741:[[25265]],194742:[[25300]],194743:[[25424]],194744:[[142092]],194745:[[25405]],194746:[[25340]],194747:[[25448]],194748:[[25475]],194749:[[25572]],194750:[[142321]],194751:[[25634]],194752:[[25541]],194753:[[25513]],194754:[[14894]],194755:[[25705]],194756:[[25726]],194757:[[25757]],194758:[[25719]],194759:[[14956]],194760:[[25935]],194761:[[25964]],194762:[[143370]],194763:[[26083]],194764:[[26360]],194765:[[26185]],194766:[[15129]],194767:[[26257]],194768:[[15112]],194769:[[15076]],194770:[[20882]],194771:[[20885]],194772:[[26368]],194773:[[26268]],194774:[[32941]],194775:[[17369]],194776:[[26391]],194777:[[26395]],194778:[[26401]],194779:[[26462]],194780:[[26451]],194781:[[144323]],194782:[[15177]],194783:[[26618]],194784:[[26501]],194785:[[26706]],194786:[[26757]],194787:[[144493]],194788:[[26766]],194789:[[26655]],194790:[[26900]],194791:[[15261]],194792:[[26946]],194793:[[27043]],194794:[[27114]],194795:[[27304]],194796:[[145059]],194797:[[27355]],194798:[[15384]],194799:[[27425]],194800:[[145575]],194801:[[27476]],194802:[[15438]],194803:[[27506]],194804:[[27551]],194805:[[27578]],194806:[[27579]],194807:[[146061]],194808:[[138507]],194809:[[146170]],194810:[[27726]],194811:[[146620]],194812:[[27839]],194813:[[27853]],194814:[[27751]],194815:[[27926]]},
    	63744:{63744:[[35912]],63745:[[26356]],63746:[[36554]],63747:[[36040]],63748:[[28369]],63749:[[20018]],63750:[[21477]],63751:[[40860]],63752:[[40860]],63753:[[22865]],63754:[[37329]],63755:[[21895]],63756:[[22856]],63757:[[25078]],63758:[[30313]],63759:[[32645]],63760:[[34367]],63761:[[34746]],63762:[[35064]],63763:[[37007]],63764:[[27138]],63765:[[27931]],63766:[[28889]],63767:[[29662]],63768:[[33853]],63769:[[37226]],63770:[[39409]],63771:[[20098]],63772:[[21365]],63773:[[27396]],63774:[[29211]],63775:[[34349]],63776:[[40478]],63777:[[23888]],63778:[[28651]],63779:[[34253]],63780:[[35172]],63781:[[25289]],63782:[[33240]],63783:[[34847]],63784:[[24266]],63785:[[26391]],63786:[[28010]],63787:[[29436]],63788:[[37070]],63789:[[20358]],63790:[[20919]],63791:[[21214]],63792:[[25796]],63793:[[27347]],63794:[[29200]],63795:[[30439]],63796:[[32769]],63797:[[34310]],63798:[[34396]],63799:[[36335]],63800:[[38706]],63801:[[39791]],63802:[[40442]],63803:[[30860]],63804:[[31103]],63805:[[32160]],63806:[[33737]],63807:[[37636]],63808:[[40575]],63809:[[35542]],63810:[[22751]],63811:[[24324]],63812:[[31840]],63813:[[32894]],63814:[[29282]],63815:[[30922]],63816:[[36034]],63817:[[38647]],63818:[[22744]],63819:[[23650]],63820:[[27155]],63821:[[28122]],63822:[[28431]],63823:[[32047]],63824:[[32311]],63825:[[38475]],63826:[[21202]],63827:[[32907]],63828:[[20956]],63829:[[20940]],63830:[[31260]],63831:[[32190]],63832:[[33777]],63833:[[38517]],63834:[[35712]],63835:[[25295]],63836:[[27138]],63837:[[35582]],63838:[[20025]],63839:[[23527]],63840:[[24594]],63841:[[29575]],63842:[[30064]],63843:[[21271]],63844:[[30971]],63845:[[20415]],63846:[[24489]],63847:[[19981]],63848:[[27852]],63849:[[25976]],63850:[[32034]],63851:[[21443]],63852:[[22622]],63853:[[30465]],63854:[[33865]],63855:[[35498]],63856:[[27578]],63857:[[36784]],63858:[[27784]],63859:[[25342]],63860:[[33509]],63861:[[25504]],63862:[[30053]],63863:[[20142]],63864:[[20841]],63865:[[20937]],63866:[[26753]],63867:[[31975]],63868:[[33391]],63869:[[35538]],63870:[[37327]],63871:[[21237]],63872:[[21570]],63873:[[22899]],63874:[[24300]],63875:[[26053]],63876:[[28670]],63877:[[31018]],63878:[[38317]],63879:[[39530]],63880:[[40599]],63881:[[40654]],63882:[[21147]],63883:[[26310]],63884:[[27511]],63885:[[36706]],63886:[[24180]],63887:[[24976]],63888:[[25088]],63889:[[25754]],63890:[[28451]],63891:[[29001]],63892:[[29833]],63893:[[31178]],63894:[[32244]],63895:[[32879]],63896:[[36646]],63897:[[34030]],63898:[[36899]],63899:[[37706]],63900:[[21015]],63901:[[21155]],63902:[[21693]],63903:[[28872]],63904:[[35010]],63905:[[35498]],63906:[[24265]],63907:[[24565]],63908:[[25467]],63909:[[27566]],63910:[[31806]],63911:[[29557]],63912:[[20196]],63913:[[22265]],63914:[[23527]],63915:[[23994]],63916:[[24604]],63917:[[29618]],63918:[[29801]],63919:[[32666]],63920:[[32838]],63921:[[37428]],63922:[[38646]],63923:[[38728]],63924:[[38936]],63925:[[20363]],63926:[[31150]],63927:[[37300]],63928:[[38584]],63929:[[24801]],63930:[[20102]],63931:[[20698]],63932:[[23534]],63933:[[23615]],63934:[[26009]],63935:[[27138]],63936:[[29134]],63937:[[30274]],63938:[[34044]],63939:[[36988]],63940:[[40845]],63941:[[26248]],63942:[[38446]],63943:[[21129]],63944:[[26491]],63945:[[26611]],63946:[[27969]],63947:[[28316]],63948:[[29705]],63949:[[30041]],63950:[[30827]],63951:[[32016]],63952:[[39006]],63953:[[20845]],63954:[[25134]],63955:[[38520]],63956:[[20523]],63957:[[23833]],63958:[[28138]],63959:[[36650]],63960:[[24459]],63961:[[24900]],63962:[[26647]],63963:[[29575]],63964:[[38534]],63965:[[21033]],63966:[[21519]],63967:[[23653]],63968:[[26131]],63969:[[26446]],63970:[[26792]],63971:[[27877]],63972:[[29702]],63973:[[30178]],63974:[[32633]],63975:[[35023]],63976:[[35041]],63977:[[37324]],63978:[[38626]],63979:[[21311]],63980:[[28346]],63981:[[21533]],63982:[[29136]],63983:[[29848]],63984:[[34298]],63985:[[38563]],63986:[[40023]],63987:[[40607]],63988:[[26519]],63989:[[28107]],63990:[[33256]],63991:[[31435]],63992:[[31520]],63993:[[31890]],63994:[[29376]],63995:[[28825]],63996:[[35672]],63997:[[20160]],63998:[[33590]],63999:[[21050]],194816:[[27966]],194817:[[28023]],194818:[[27969]],194819:[[28009]],194820:[[28024]],194821:[[28037]],194822:[[146718]],194823:[[27956]],194824:[[28207]],194825:[[28270]],194826:[[15667]],194827:[[28363]],194828:[[28359]],194829:[[147153]],194830:[[28153]],194831:[[28526]],194832:[[147294]],194833:[[147342]],194834:[[28614]],194835:[[28729]],194836:[[28702]],194837:[[28699]],194838:[[15766]],194839:[[28746]],194840:[[28797]],194841:[[28791]],194842:[[28845]],194843:[[132389]],194844:[[28997]],194845:[[148067]],194846:[[29084]],194847:[[148395]],194848:[[29224]],194849:[[29237]],194850:[[29264]],194851:[[149000]],194852:[[29312]],194853:[[29333]],194854:[[149301]],194855:[[149524]],194856:[[29562]],194857:[[29579]],194858:[[16044]],194859:[[29605]],194860:[[16056]],194861:[[16056]],194862:[[29767]],194863:[[29788]],194864:[[29809]],194865:[[29829]],194866:[[29898]],194867:[[16155]],194868:[[29988]],194869:[[150582]],194870:[[30014]],194871:[[150674]],194872:[[30064]],194873:[[139679]],194874:[[30224]],194875:[[151457]],194876:[[151480]],194877:[[151620]],194878:[[16380]],194879:[[16392]],194880:[[30452]],194881:[[151795]],194882:[[151794]],194883:[[151833]],194884:[[151859]],194885:[[30494]],194886:[[30495]],194887:[[30495]],194888:[[30538]],194889:[[16441]],194890:[[30603]],194891:[[16454]],194892:[[16534]],194893:[[152605]],194894:[[30798]],194895:[[30860]],194896:[[30924]],194897:[[16611]],194898:[[153126]],194899:[[31062]],194900:[[153242]],194901:[[153285]],194902:[[31119]],194903:[[31211]],194904:[[16687]],194905:[[31296]],194906:[[31306]],194907:[[31311]],194908:[[153980]],194909:[[154279]],194910:[[154279]],194911:[[31470]],194912:[[16898]],194913:[[154539]],194914:[[31686]],194915:[[31689]],194916:[[16935]],194917:[[154752]],194918:[[31954]],194919:[[17056]],194920:[[31976]],194921:[[31971]],194922:[[32000]],194923:[[155526]],194924:[[32099]],194925:[[17153]],194926:[[32199]],194927:[[32258]],194928:[[32325]],194929:[[17204]],194930:[[156200]],194931:[[156231]],194932:[[17241]],194933:[[156377]],194934:[[32634]],194935:[[156478]],194936:[[32661]],194937:[[32762]],194938:[[32773]],194939:[[156890]],194940:[[156963]],194941:[[32864]],194942:[[157096]],194943:[[32880]],194944:[[144223]],194945:[[17365]],194946:[[32946]],194947:[[33027]],194948:[[17419]],194949:[[33086]],194950:[[23221]],194951:[[157607]],194952:[[157621]],194953:[[144275]],194954:[[144284]],194955:[[33281]],194956:[[33284]],194957:[[36766]],194958:[[17515]],194959:[[33425]],194960:[[33419]],194961:[[33437]],194962:[[21171]],194963:[[33457]],194964:[[33459]],194965:[[33469]],194966:[[33510]],194967:[[158524]],194968:[[33509]],194969:[[33565]],194970:[[33635]],194971:[[33709]],194972:[[33571]],194973:[[33725]],194974:[[33767]],194975:[[33879]],194976:[[33619]],194977:[[33738]],194978:[[33740]],194979:[[33756]],194980:[[158774]],194981:[[159083]],194982:[[158933]],194983:[[17707]],194984:[[34033]],194985:[[34035]],194986:[[34070]],194987:[[160714]],194988:[[34148]],194989:[[159532]],194990:[[17757]],194991:[[17761]],194992:[[159665]],194993:[[159954]],194994:[[17771]],194995:[[34384]],194996:[[34396]],194997:[[34407]],194998:[[34409]],194999:[[34473]],195000:[[34440]],195001:[[34574]],195002:[[34530]],195003:[[34681]],195004:[[34600]],195005:[[34667]],195006:[[34694]],195007:[[17879]],195008:[[34785]],195009:[[34817]],195010:[[17913]],195011:[[34912]],195012:[[34915]],195013:[[161383]],195014:[[35031]],195015:[[35038]],195016:[[17973]],195017:[[35066]],195018:[[13499]],195019:[[161966]],195020:[[162150]],195021:[[18110]],195022:[[18119]],195023:[[35488]],195024:[[35565]],195025:[[35722]],195026:[[35925]],195027:[[162984]],195028:[[36011]],195029:[[36033]],195030:[[36123]],195031:[[36215]],195032:[[163631]],195033:[[133124]],195034:[[36299]],195035:[[36284]],195036:[[36336]],195037:[[133342]],195038:[[36564]],195039:[[36664]],195040:[[165330]],195041:[[165357]],195042:[[37012]],195043:[[37105]],195044:[[37137]],195045:[[165678]],195046:[[37147]],195047:[[37432]],195048:[[37591]],195049:[[37592]],195050:[[37500]],195051:[[37881]],195052:[[37909]],195053:[[166906]],195054:[[38283]],195055:[[18837]],195056:[[38327]],195057:[[167287]],195058:[[18918]],195059:[[38595]],195060:[[23986]],195061:[[38691]],195062:[[168261]],195063:[[168474]],195064:[[19054]],195065:[[19062]],195066:[[38880]],195067:[[168970]],195068:[[19122]],195069:[[169110]],195070:[[38923]],195071:[[38923]]},
    	64000:{64000:[[20999]],64001:[[24230]],64002:[[25299]],64003:[[31958]],64004:[[23429]],64005:[[27934]],64006:[[26292]],64007:[[36667]],64008:[[34892]],64009:[[38477]],64010:[[35211]],64011:[[24275]],64012:[[20800]],64013:[[21952]],64016:[[22618]],64018:[[26228]],64021:[[20958]],64022:[[29482]],64023:[[30410]],64024:[[31036]],64025:[[31070]],64026:[[31077]],64027:[[31119]],64028:[[38742]],64029:[[31934]],64030:[[32701]],64032:[[34322]],64034:[[35576]],64037:[[36920]],64038:[[37117]],64042:[[39151]],64043:[[39164]],64044:[[39208]],64045:[[40372]],64046:[[37086]],64047:[[38583]],64048:[[20398]],64049:[[20711]],64050:[[20813]],64051:[[21193]],64052:[[21220]],64053:[[21329]],64054:[[21917]],64055:[[22022]],64056:[[22120]],64057:[[22592]],64058:[[22696]],64059:[[23652]],64060:[[23662]],64061:[[24724]],64062:[[24936]],64063:[[24974]],64064:[[25074]],64065:[[25935]],64066:[[26082]],64067:[[26257]],64068:[[26757]],64069:[[28023]],64070:[[28186]],64071:[[28450]],64072:[[29038]],64073:[[29227]],64074:[[29730]],64075:[[30865]],64076:[[31038]],64077:[[31049]],64078:[[31048]],64079:[[31056]],64080:[[31062]],64081:[[31069]],64082:[[31117]],64083:[[31118]],64084:[[31296]],64085:[[31361]],64086:[[31680]],64087:[[32244]],64088:[[32265]],64089:[[32321]],64090:[[32626]],64091:[[32773]],64092:[[33261]],64093:[[33401]],64094:[[33401]],64095:[[33879]],64096:[[35088]],64097:[[35222]],64098:[[35585]],64099:[[35641]],64100:[[36051]],64101:[[36104]],64102:[[36790]],64103:[[36920]],64104:[[38627]],64105:[[38911]],64106:[[38971]],64107:[[24693]],64108:[[148206]],64109:[[33304]],64112:[[20006]],64113:[[20917]],64114:[[20840]],64115:[[20352]],64116:[[20805]],64117:[[20864]],64118:[[21191]],64119:[[21242]],64120:[[21917]],64121:[[21845]],64122:[[21913]],64123:[[21986]],64124:[[22618]],64125:[[22707]],64126:[[22852]],64127:[[22868]],64128:[[23138]],64129:[[23336]],64130:[[24274]],64131:[[24281]],64132:[[24425]],64133:[[24493]],64134:[[24792]],64135:[[24910]],64136:[[24840]],64137:[[24974]],64138:[[24928]],64139:[[25074]],64140:[[25140]],64141:[[25540]],64142:[[25628]],64143:[[25682]],64144:[[25942]],64145:[[26228]],64146:[[26391]],64147:[[26395]],64148:[[26454]],64149:[[27513]],64150:[[27578]],64151:[[27969]],64152:[[28379]],64153:[[28363]],64154:[[28450]],64155:[[28702]],64156:[[29038]],64157:[[30631]],64158:[[29237]],64159:[[29359]],64160:[[29482]],64161:[[29809]],64162:[[29958]],64163:[[30011]],64164:[[30237]],64165:[[30239]],64166:[[30410]],64167:[[30427]],64168:[[30452]],64169:[[30538]],64170:[[30528]],64171:[[30924]],64172:[[31409]],64173:[[31680]],64174:[[31867]],64175:[[32091]],64176:[[32244]],64177:[[32574]],64178:[[32773]],64179:[[33618]],64180:[[33775]],64181:[[34681]],64182:[[35137]],64183:[[35206]],64184:[[35222]],64185:[[35519]],64186:[[35576]],64187:[[35531]],64188:[[35585]],64189:[[35582]],64190:[[35565]],64191:[[35641]],64192:[[35722]],64193:[[36104]],64194:[[36664]],64195:[[36978]],64196:[[37273]],64197:[[37494]],64198:[[38524]],64199:[[38627]],64200:[[38742]],64201:[[38875]],64202:[[38911]],64203:[[38923]],64204:[[38971]],64205:[[39698]],64206:[[40860]],64207:[[141386]],64208:[[141380]],64209:[[144341]],64210:[[15261]],64211:[[16408]],64212:[[16441]],64213:[[152137]],64214:[[154832]],64215:[[163539]],64216:[[40771]],64217:[[40846]],195072:[[38953]],195073:[[169398]],195074:[[39138]],195075:[[19251]],195076:[[39209]],195077:[[39335]],195078:[[39362]],195079:[[39422]],195080:[[19406]],195081:[[170800]],195082:[[39698]],195083:[[40000]],195084:[[40189]],195085:[[19662]],195086:[[19693]],195087:[[40295]],195088:[[172238]],195089:[[19704]],195090:[[172293]],195091:[[172558]],195092:[[172689]],195093:[[40635]],195094:[[19798]],195095:[[40697]],195096:[[40702]],195097:[[40709]],195098:[[40719]],195099:[[40726]],195100:[[40763]],195101:[[173568]]},
    	64256:{64256:[[102,102],256],64257:[[102,105],256],64258:[[102,108],256],64259:[[102,102,105],256],64260:[[102,102,108],256],64261:[[383,116],256],64262:[[115,116],256],64275:[[1396,1398],256],64276:[[1396,1381],256],64277:[[1396,1387],256],64278:[[1406,1398],256],64279:[[1396,1389],256],64285:[[1497,1460],512],64286:[,26],64287:[[1522,1463],512],64288:[[1506],256],64289:[[1488],256],64290:[[1491],256],64291:[[1492],256],64292:[[1499],256],64293:[[1500],256],64294:[[1501],256],64295:[[1512],256],64296:[[1514],256],64297:[[43],256],64298:[[1513,1473],512],64299:[[1513,1474],512],64300:[[64329,1473],512],64301:[[64329,1474],512],64302:[[1488,1463],512],64303:[[1488,1464],512],64304:[[1488,1468],512],64305:[[1489,1468],512],64306:[[1490,1468],512],64307:[[1491,1468],512],64308:[[1492,1468],512],64309:[[1493,1468],512],64310:[[1494,1468],512],64312:[[1496,1468],512],64313:[[1497,1468],512],64314:[[1498,1468],512],64315:[[1499,1468],512],64316:[[1500,1468],512],64318:[[1502,1468],512],64320:[[1504,1468],512],64321:[[1505,1468],512],64323:[[1507,1468],512],64324:[[1508,1468],512],64326:[[1510,1468],512],64327:[[1511,1468],512],64328:[[1512,1468],512],64329:[[1513,1468],512],64330:[[1514,1468],512],64331:[[1493,1465],512],64332:[[1489,1471],512],64333:[[1499,1471],512],64334:[[1508,1471],512],64335:[[1488,1500],256],64336:[[1649],256],64337:[[1649],256],64338:[[1659],256],64339:[[1659],256],64340:[[1659],256],64341:[[1659],256],64342:[[1662],256],64343:[[1662],256],64344:[[1662],256],64345:[[1662],256],64346:[[1664],256],64347:[[1664],256],64348:[[1664],256],64349:[[1664],256],64350:[[1658],256],64351:[[1658],256],64352:[[1658],256],64353:[[1658],256],64354:[[1663],256],64355:[[1663],256],64356:[[1663],256],64357:[[1663],256],64358:[[1657],256],64359:[[1657],256],64360:[[1657],256],64361:[[1657],256],64362:[[1700],256],64363:[[1700],256],64364:[[1700],256],64365:[[1700],256],64366:[[1702],256],64367:[[1702],256],64368:[[1702],256],64369:[[1702],256],64370:[[1668],256],64371:[[1668],256],64372:[[1668],256],64373:[[1668],256],64374:[[1667],256],64375:[[1667],256],64376:[[1667],256],64377:[[1667],256],64378:[[1670],256],64379:[[1670],256],64380:[[1670],256],64381:[[1670],256],64382:[[1671],256],64383:[[1671],256],64384:[[1671],256],64385:[[1671],256],64386:[[1677],256],64387:[[1677],256],64388:[[1676],256],64389:[[1676],256],64390:[[1678],256],64391:[[1678],256],64392:[[1672],256],64393:[[1672],256],64394:[[1688],256],64395:[[1688],256],64396:[[1681],256],64397:[[1681],256],64398:[[1705],256],64399:[[1705],256],64400:[[1705],256],64401:[[1705],256],64402:[[1711],256],64403:[[1711],256],64404:[[1711],256],64405:[[1711],256],64406:[[1715],256],64407:[[1715],256],64408:[[1715],256],64409:[[1715],256],64410:[[1713],256],64411:[[1713],256],64412:[[1713],256],64413:[[1713],256],64414:[[1722],256],64415:[[1722],256],64416:[[1723],256],64417:[[1723],256],64418:[[1723],256],64419:[[1723],256],64420:[[1728],256],64421:[[1728],256],64422:[[1729],256],64423:[[1729],256],64424:[[1729],256],64425:[[1729],256],64426:[[1726],256],64427:[[1726],256],64428:[[1726],256],64429:[[1726],256],64430:[[1746],256],64431:[[1746],256],64432:[[1747],256],64433:[[1747],256],64467:[[1709],256],64468:[[1709],256],64469:[[1709],256],64470:[[1709],256],64471:[[1735],256],64472:[[1735],256],64473:[[1734],256],64474:[[1734],256],64475:[[1736],256],64476:[[1736],256],64477:[[1655],256],64478:[[1739],256],64479:[[1739],256],64480:[[1733],256],64481:[[1733],256],64482:[[1737],256],64483:[[1737],256],64484:[[1744],256],64485:[[1744],256],64486:[[1744],256],64487:[[1744],256],64488:[[1609],256],64489:[[1609],256],64490:[[1574,1575],256],64491:[[1574,1575],256],64492:[[1574,1749],256],64493:[[1574,1749],256],64494:[[1574,1608],256],64495:[[1574,1608],256],64496:[[1574,1735],256],64497:[[1574,1735],256],64498:[[1574,1734],256],64499:[[1574,1734],256],64500:[[1574,1736],256],64501:[[1574,1736],256],64502:[[1574,1744],256],64503:[[1574,1744],256],64504:[[1574,1744],256],64505:[[1574,1609],256],64506:[[1574,1609],256],64507:[[1574,1609],256],64508:[[1740],256],64509:[[1740],256],64510:[[1740],256],64511:[[1740],256]},
    	64512:{64512:[[1574,1580],256],64513:[[1574,1581],256],64514:[[1574,1605],256],64515:[[1574,1609],256],64516:[[1574,1610],256],64517:[[1576,1580],256],64518:[[1576,1581],256],64519:[[1576,1582],256],64520:[[1576,1605],256],64521:[[1576,1609],256],64522:[[1576,1610],256],64523:[[1578,1580],256],64524:[[1578,1581],256],64525:[[1578,1582],256],64526:[[1578,1605],256],64527:[[1578,1609],256],64528:[[1578,1610],256],64529:[[1579,1580],256],64530:[[1579,1605],256],64531:[[1579,1609],256],64532:[[1579,1610],256],64533:[[1580,1581],256],64534:[[1580,1605],256],64535:[[1581,1580],256],64536:[[1581,1605],256],64537:[[1582,1580],256],64538:[[1582,1581],256],64539:[[1582,1605],256],64540:[[1587,1580],256],64541:[[1587,1581],256],64542:[[1587,1582],256],64543:[[1587,1605],256],64544:[[1589,1581],256],64545:[[1589,1605],256],64546:[[1590,1580],256],64547:[[1590,1581],256],64548:[[1590,1582],256],64549:[[1590,1605],256],64550:[[1591,1581],256],64551:[[1591,1605],256],64552:[[1592,1605],256],64553:[[1593,1580],256],64554:[[1593,1605],256],64555:[[1594,1580],256],64556:[[1594,1605],256],64557:[[1601,1580],256],64558:[[1601,1581],256],64559:[[1601,1582],256],64560:[[1601,1605],256],64561:[[1601,1609],256],64562:[[1601,1610],256],64563:[[1602,1581],256],64564:[[1602,1605],256],64565:[[1602,1609],256],64566:[[1602,1610],256],64567:[[1603,1575],256],64568:[[1603,1580],256],64569:[[1603,1581],256],64570:[[1603,1582],256],64571:[[1603,1604],256],64572:[[1603,1605],256],64573:[[1603,1609],256],64574:[[1603,1610],256],64575:[[1604,1580],256],64576:[[1604,1581],256],64577:[[1604,1582],256],64578:[[1604,1605],256],64579:[[1604,1609],256],64580:[[1604,1610],256],64581:[[1605,1580],256],64582:[[1605,1581],256],64583:[[1605,1582],256],64584:[[1605,1605],256],64585:[[1605,1609],256],64586:[[1605,1610],256],64587:[[1606,1580],256],64588:[[1606,1581],256],64589:[[1606,1582],256],64590:[[1606,1605],256],64591:[[1606,1609],256],64592:[[1606,1610],256],64593:[[1607,1580],256],64594:[[1607,1605],256],64595:[[1607,1609],256],64596:[[1607,1610],256],64597:[[1610,1580],256],64598:[[1610,1581],256],64599:[[1610,1582],256],64600:[[1610,1605],256],64601:[[1610,1609],256],64602:[[1610,1610],256],64603:[[1584,1648],256],64604:[[1585,1648],256],64605:[[1609,1648],256],64606:[[32,1612,1617],256],64607:[[32,1613,1617],256],64608:[[32,1614,1617],256],64609:[[32,1615,1617],256],64610:[[32,1616,1617],256],64611:[[32,1617,1648],256],64612:[[1574,1585],256],64613:[[1574,1586],256],64614:[[1574,1605],256],64615:[[1574,1606],256],64616:[[1574,1609],256],64617:[[1574,1610],256],64618:[[1576,1585],256],64619:[[1576,1586],256],64620:[[1576,1605],256],64621:[[1576,1606],256],64622:[[1576,1609],256],64623:[[1576,1610],256],64624:[[1578,1585],256],64625:[[1578,1586],256],64626:[[1578,1605],256],64627:[[1578,1606],256],64628:[[1578,1609],256],64629:[[1578,1610],256],64630:[[1579,1585],256],64631:[[1579,1586],256],64632:[[1579,1605],256],64633:[[1579,1606],256],64634:[[1579,1609],256],64635:[[1579,1610],256],64636:[[1601,1609],256],64637:[[1601,1610],256],64638:[[1602,1609],256],64639:[[1602,1610],256],64640:[[1603,1575],256],64641:[[1603,1604],256],64642:[[1603,1605],256],64643:[[1603,1609],256],64644:[[1603,1610],256],64645:[[1604,1605],256],64646:[[1604,1609],256],64647:[[1604,1610],256],64648:[[1605,1575],256],64649:[[1605,1605],256],64650:[[1606,1585],256],64651:[[1606,1586],256],64652:[[1606,1605],256],64653:[[1606,1606],256],64654:[[1606,1609],256],64655:[[1606,1610],256],64656:[[1609,1648],256],64657:[[1610,1585],256],64658:[[1610,1586],256],64659:[[1610,1605],256],64660:[[1610,1606],256],64661:[[1610,1609],256],64662:[[1610,1610],256],64663:[[1574,1580],256],64664:[[1574,1581],256],64665:[[1574,1582],256],64666:[[1574,1605],256],64667:[[1574,1607],256],64668:[[1576,1580],256],64669:[[1576,1581],256],64670:[[1576,1582],256],64671:[[1576,1605],256],64672:[[1576,1607],256],64673:[[1578,1580],256],64674:[[1578,1581],256],64675:[[1578,1582],256],64676:[[1578,1605],256],64677:[[1578,1607],256],64678:[[1579,1605],256],64679:[[1580,1581],256],64680:[[1580,1605],256],64681:[[1581,1580],256],64682:[[1581,1605],256],64683:[[1582,1580],256],64684:[[1582,1605],256],64685:[[1587,1580],256],64686:[[1587,1581],256],64687:[[1587,1582],256],64688:[[1587,1605],256],64689:[[1589,1581],256],64690:[[1589,1582],256],64691:[[1589,1605],256],64692:[[1590,1580],256],64693:[[1590,1581],256],64694:[[1590,1582],256],64695:[[1590,1605],256],64696:[[1591,1581],256],64697:[[1592,1605],256],64698:[[1593,1580],256],64699:[[1593,1605],256],64700:[[1594,1580],256],64701:[[1594,1605],256],64702:[[1601,1580],256],64703:[[1601,1581],256],64704:[[1601,1582],256],64705:[[1601,1605],256],64706:[[1602,1581],256],64707:[[1602,1605],256],64708:[[1603,1580],256],64709:[[1603,1581],256],64710:[[1603,1582],256],64711:[[1603,1604],256],64712:[[1603,1605],256],64713:[[1604,1580],256],64714:[[1604,1581],256],64715:[[1604,1582],256],64716:[[1604,1605],256],64717:[[1604,1607],256],64718:[[1605,1580],256],64719:[[1605,1581],256],64720:[[1605,1582],256],64721:[[1605,1605],256],64722:[[1606,1580],256],64723:[[1606,1581],256],64724:[[1606,1582],256],64725:[[1606,1605],256],64726:[[1606,1607],256],64727:[[1607,1580],256],64728:[[1607,1605],256],64729:[[1607,1648],256],64730:[[1610,1580],256],64731:[[1610,1581],256],64732:[[1610,1582],256],64733:[[1610,1605],256],64734:[[1610,1607],256],64735:[[1574,1605],256],64736:[[1574,1607],256],64737:[[1576,1605],256],64738:[[1576,1607],256],64739:[[1578,1605],256],64740:[[1578,1607],256],64741:[[1579,1605],256],64742:[[1579,1607],256],64743:[[1587,1605],256],64744:[[1587,1607],256],64745:[[1588,1605],256],64746:[[1588,1607],256],64747:[[1603,1604],256],64748:[[1603,1605],256],64749:[[1604,1605],256],64750:[[1606,1605],256],64751:[[1606,1607],256],64752:[[1610,1605],256],64753:[[1610,1607],256],64754:[[1600,1614,1617],256],64755:[[1600,1615,1617],256],64756:[[1600,1616,1617],256],64757:[[1591,1609],256],64758:[[1591,1610],256],64759:[[1593,1609],256],64760:[[1593,1610],256],64761:[[1594,1609],256],64762:[[1594,1610],256],64763:[[1587,1609],256],64764:[[1587,1610],256],64765:[[1588,1609],256],64766:[[1588,1610],256],64767:[[1581,1609],256]},
    	64768:{64768:[[1581,1610],256],64769:[[1580,1609],256],64770:[[1580,1610],256],64771:[[1582,1609],256],64772:[[1582,1610],256],64773:[[1589,1609],256],64774:[[1589,1610],256],64775:[[1590,1609],256],64776:[[1590,1610],256],64777:[[1588,1580],256],64778:[[1588,1581],256],64779:[[1588,1582],256],64780:[[1588,1605],256],64781:[[1588,1585],256],64782:[[1587,1585],256],64783:[[1589,1585],256],64784:[[1590,1585],256],64785:[[1591,1609],256],64786:[[1591,1610],256],64787:[[1593,1609],256],64788:[[1593,1610],256],64789:[[1594,1609],256],64790:[[1594,1610],256],64791:[[1587,1609],256],64792:[[1587,1610],256],64793:[[1588,1609],256],64794:[[1588,1610],256],64795:[[1581,1609],256],64796:[[1581,1610],256],64797:[[1580,1609],256],64798:[[1580,1610],256],64799:[[1582,1609],256],64800:[[1582,1610],256],64801:[[1589,1609],256],64802:[[1589,1610],256],64803:[[1590,1609],256],64804:[[1590,1610],256],64805:[[1588,1580],256],64806:[[1588,1581],256],64807:[[1588,1582],256],64808:[[1588,1605],256],64809:[[1588,1585],256],64810:[[1587,1585],256],64811:[[1589,1585],256],64812:[[1590,1585],256],64813:[[1588,1580],256],64814:[[1588,1581],256],64815:[[1588,1582],256],64816:[[1588,1605],256],64817:[[1587,1607],256],64818:[[1588,1607],256],64819:[[1591,1605],256],64820:[[1587,1580],256],64821:[[1587,1581],256],64822:[[1587,1582],256],64823:[[1588,1580],256],64824:[[1588,1581],256],64825:[[1588,1582],256],64826:[[1591,1605],256],64827:[[1592,1605],256],64828:[[1575,1611],256],64829:[[1575,1611],256],64848:[[1578,1580,1605],256],64849:[[1578,1581,1580],256],64850:[[1578,1581,1580],256],64851:[[1578,1581,1605],256],64852:[[1578,1582,1605],256],64853:[[1578,1605,1580],256],64854:[[1578,1605,1581],256],64855:[[1578,1605,1582],256],64856:[[1580,1605,1581],256],64857:[[1580,1605,1581],256],64858:[[1581,1605,1610],256],64859:[[1581,1605,1609],256],64860:[[1587,1581,1580],256],64861:[[1587,1580,1581],256],64862:[[1587,1580,1609],256],64863:[[1587,1605,1581],256],64864:[[1587,1605,1581],256],64865:[[1587,1605,1580],256],64866:[[1587,1605,1605],256],64867:[[1587,1605,1605],256],64868:[[1589,1581,1581],256],64869:[[1589,1581,1581],256],64870:[[1589,1605,1605],256],64871:[[1588,1581,1605],256],64872:[[1588,1581,1605],256],64873:[[1588,1580,1610],256],64874:[[1588,1605,1582],256],64875:[[1588,1605,1582],256],64876:[[1588,1605,1605],256],64877:[[1588,1605,1605],256],64878:[[1590,1581,1609],256],64879:[[1590,1582,1605],256],64880:[[1590,1582,1605],256],64881:[[1591,1605,1581],256],64882:[[1591,1605,1581],256],64883:[[1591,1605,1605],256],64884:[[1591,1605,1610],256],64885:[[1593,1580,1605],256],64886:[[1593,1605,1605],256],64887:[[1593,1605,1605],256],64888:[[1593,1605,1609],256],64889:[[1594,1605,1605],256],64890:[[1594,1605,1610],256],64891:[[1594,1605,1609],256],64892:[[1601,1582,1605],256],64893:[[1601,1582,1605],256],64894:[[1602,1605,1581],256],64895:[[1602,1605,1605],256],64896:[[1604,1581,1605],256],64897:[[1604,1581,1610],256],64898:[[1604,1581,1609],256],64899:[[1604,1580,1580],256],64900:[[1604,1580,1580],256],64901:[[1604,1582,1605],256],64902:[[1604,1582,1605],256],64903:[[1604,1605,1581],256],64904:[[1604,1605,1581],256],64905:[[1605,1581,1580],256],64906:[[1605,1581,1605],256],64907:[[1605,1581,1610],256],64908:[[1605,1580,1581],256],64909:[[1605,1580,1605],256],64910:[[1605,1582,1580],256],64911:[[1605,1582,1605],256],64914:[[1605,1580,1582],256],64915:[[1607,1605,1580],256],64916:[[1607,1605,1605],256],64917:[[1606,1581,1605],256],64918:[[1606,1581,1609],256],64919:[[1606,1580,1605],256],64920:[[1606,1580,1605],256],64921:[[1606,1580,1609],256],64922:[[1606,1605,1610],256],64923:[[1606,1605,1609],256],64924:[[1610,1605,1605],256],64925:[[1610,1605,1605],256],64926:[[1576,1582,1610],256],64927:[[1578,1580,1610],256],64928:[[1578,1580,1609],256],64929:[[1578,1582,1610],256],64930:[[1578,1582,1609],256],64931:[[1578,1605,1610],256],64932:[[1578,1605,1609],256],64933:[[1580,1605,1610],256],64934:[[1580,1581,1609],256],64935:[[1580,1605,1609],256],64936:[[1587,1582,1609],256],64937:[[1589,1581,1610],256],64938:[[1588,1581,1610],256],64939:[[1590,1581,1610],256],64940:[[1604,1580,1610],256],64941:[[1604,1605,1610],256],64942:[[1610,1581,1610],256],64943:[[1610,1580,1610],256],64944:[[1610,1605,1610],256],64945:[[1605,1605,1610],256],64946:[[1602,1605,1610],256],64947:[[1606,1581,1610],256],64948:[[1602,1605,1581],256],64949:[[1604,1581,1605],256],64950:[[1593,1605,1610],256],64951:[[1603,1605,1610],256],64952:[[1606,1580,1581],256],64953:[[1605,1582,1610],256],64954:[[1604,1580,1605],256],64955:[[1603,1605,1605],256],64956:[[1604,1580,1605],256],64957:[[1606,1580,1581],256],64958:[[1580,1581,1610],256],64959:[[1581,1580,1610],256],64960:[[1605,1580,1610],256],64961:[[1601,1605,1610],256],64962:[[1576,1581,1610],256],64963:[[1603,1605,1605],256],64964:[[1593,1580,1605],256],64965:[[1589,1605,1605],256],64966:[[1587,1582,1610],256],64967:[[1606,1580,1610],256],65008:[[1589,1604,1746],256],65009:[[1602,1604,1746],256],65010:[[1575,1604,1604,1607],256],65011:[[1575,1603,1576,1585],256],65012:[[1605,1581,1605,1583],256],65013:[[1589,1604,1593,1605],256],65014:[[1585,1587,1608,1604],256],65015:[[1593,1604,1610,1607],256],65016:[[1608,1587,1604,1605],256],65017:[[1589,1604,1609],256],65018:[[1589,1604,1609,32,1575,1604,1604,1607,32,1593,1604,1610,1607,32,1608,1587,1604,1605],256],65019:[[1580,1604,32,1580,1604,1575,1604,1607],256],65020:[[1585,1740,1575,1604],256]},
    	65024:{65040:[[44],256],65041:[[12289],256],65042:[[12290],256],65043:[[58],256],65044:[[59],256],65045:[[33],256],65046:[[63],256],65047:[[12310],256],65048:[[12311],256],65049:[[8230],256],65056:[,230],65057:[,230],65058:[,230],65059:[,230],65060:[,230],65061:[,230],65062:[,230],65063:[,220],65064:[,220],65065:[,220],65066:[,220],65067:[,220],65068:[,220],65069:[,220],65072:[[8229],256],65073:[[8212],256],65074:[[8211],256],65075:[[95],256],65076:[[95],256],65077:[[40],256],65078:[[41],256],65079:[[123],256],65080:[[125],256],65081:[[12308],256],65082:[[12309],256],65083:[[12304],256],65084:[[12305],256],65085:[[12298],256],65086:[[12299],256],65087:[[12296],256],65088:[[12297],256],65089:[[12300],256],65090:[[12301],256],65091:[[12302],256],65092:[[12303],256],65095:[[91],256],65096:[[93],256],65097:[[8254],256],65098:[[8254],256],65099:[[8254],256],65100:[[8254],256],65101:[[95],256],65102:[[95],256],65103:[[95],256],65104:[[44],256],65105:[[12289],256],65106:[[46],256],65108:[[59],256],65109:[[58],256],65110:[[63],256],65111:[[33],256],65112:[[8212],256],65113:[[40],256],65114:[[41],256],65115:[[123],256],65116:[[125],256],65117:[[12308],256],65118:[[12309],256],65119:[[35],256],65120:[[38],256],65121:[[42],256],65122:[[43],256],65123:[[45],256],65124:[[60],256],65125:[[62],256],65126:[[61],256],65128:[[92],256],65129:[[36],256],65130:[[37],256],65131:[[64],256],65136:[[32,1611],256],65137:[[1600,1611],256],65138:[[32,1612],256],65140:[[32,1613],256],65142:[[32,1614],256],65143:[[1600,1614],256],65144:[[32,1615],256],65145:[[1600,1615],256],65146:[[32,1616],256],65147:[[1600,1616],256],65148:[[32,1617],256],65149:[[1600,1617],256],65150:[[32,1618],256],65151:[[1600,1618],256],65152:[[1569],256],65153:[[1570],256],65154:[[1570],256],65155:[[1571],256],65156:[[1571],256],65157:[[1572],256],65158:[[1572],256],65159:[[1573],256],65160:[[1573],256],65161:[[1574],256],65162:[[1574],256],65163:[[1574],256],65164:[[1574],256],65165:[[1575],256],65166:[[1575],256],65167:[[1576],256],65168:[[1576],256],65169:[[1576],256],65170:[[1576],256],65171:[[1577],256],65172:[[1577],256],65173:[[1578],256],65174:[[1578],256],65175:[[1578],256],65176:[[1578],256],65177:[[1579],256],65178:[[1579],256],65179:[[1579],256],65180:[[1579],256],65181:[[1580],256],65182:[[1580],256],65183:[[1580],256],65184:[[1580],256],65185:[[1581],256],65186:[[1581],256],65187:[[1581],256],65188:[[1581],256],65189:[[1582],256],65190:[[1582],256],65191:[[1582],256],65192:[[1582],256],65193:[[1583],256],65194:[[1583],256],65195:[[1584],256],65196:[[1584],256],65197:[[1585],256],65198:[[1585],256],65199:[[1586],256],65200:[[1586],256],65201:[[1587],256],65202:[[1587],256],65203:[[1587],256],65204:[[1587],256],65205:[[1588],256],65206:[[1588],256],65207:[[1588],256],65208:[[1588],256],65209:[[1589],256],65210:[[1589],256],65211:[[1589],256],65212:[[1589],256],65213:[[1590],256],65214:[[1590],256],65215:[[1590],256],65216:[[1590],256],65217:[[1591],256],65218:[[1591],256],65219:[[1591],256],65220:[[1591],256],65221:[[1592],256],65222:[[1592],256],65223:[[1592],256],65224:[[1592],256],65225:[[1593],256],65226:[[1593],256],65227:[[1593],256],65228:[[1593],256],65229:[[1594],256],65230:[[1594],256],65231:[[1594],256],65232:[[1594],256],65233:[[1601],256],65234:[[1601],256],65235:[[1601],256],65236:[[1601],256],65237:[[1602],256],65238:[[1602],256],65239:[[1602],256],65240:[[1602],256],65241:[[1603],256],65242:[[1603],256],65243:[[1603],256],65244:[[1603],256],65245:[[1604],256],65246:[[1604],256],65247:[[1604],256],65248:[[1604],256],65249:[[1605],256],65250:[[1605],256],65251:[[1605],256],65252:[[1605],256],65253:[[1606],256],65254:[[1606],256],65255:[[1606],256],65256:[[1606],256],65257:[[1607],256],65258:[[1607],256],65259:[[1607],256],65260:[[1607],256],65261:[[1608],256],65262:[[1608],256],65263:[[1609],256],65264:[[1609],256],65265:[[1610],256],65266:[[1610],256],65267:[[1610],256],65268:[[1610],256],65269:[[1604,1570],256],65270:[[1604,1570],256],65271:[[1604,1571],256],65272:[[1604,1571],256],65273:[[1604,1573],256],65274:[[1604,1573],256],65275:[[1604,1575],256],65276:[[1604,1575],256]},
    	65280:{65281:[[33],256],65282:[[34],256],65283:[[35],256],65284:[[36],256],65285:[[37],256],65286:[[38],256],65287:[[39],256],65288:[[40],256],65289:[[41],256],65290:[[42],256],65291:[[43],256],65292:[[44],256],65293:[[45],256],65294:[[46],256],65295:[[47],256],65296:[[48],256],65297:[[49],256],65298:[[50],256],65299:[[51],256],65300:[[52],256],65301:[[53],256],65302:[[54],256],65303:[[55],256],65304:[[56],256],65305:[[57],256],65306:[[58],256],65307:[[59],256],65308:[[60],256],65309:[[61],256],65310:[[62],256],65311:[[63],256],65312:[[64],256],65313:[[65],256],65314:[[66],256],65315:[[67],256],65316:[[68],256],65317:[[69],256],65318:[[70],256],65319:[[71],256],65320:[[72],256],65321:[[73],256],65322:[[74],256],65323:[[75],256],65324:[[76],256],65325:[[77],256],65326:[[78],256],65327:[[79],256],65328:[[80],256],65329:[[81],256],65330:[[82],256],65331:[[83],256],65332:[[84],256],65333:[[85],256],65334:[[86],256],65335:[[87],256],65336:[[88],256],65337:[[89],256],65338:[[90],256],65339:[[91],256],65340:[[92],256],65341:[[93],256],65342:[[94],256],65343:[[95],256],65344:[[96],256],65345:[[97],256],65346:[[98],256],65347:[[99],256],65348:[[100],256],65349:[[101],256],65350:[[102],256],65351:[[103],256],65352:[[104],256],65353:[[105],256],65354:[[106],256],65355:[[107],256],65356:[[108],256],65357:[[109],256],65358:[[110],256],65359:[[111],256],65360:[[112],256],65361:[[113],256],65362:[[114],256],65363:[[115],256],65364:[[116],256],65365:[[117],256],65366:[[118],256],65367:[[119],256],65368:[[120],256],65369:[[121],256],65370:[[122],256],65371:[[123],256],65372:[[124],256],65373:[[125],256],65374:[[126],256],65375:[[10629],256],65376:[[10630],256],65377:[[12290],256],65378:[[12300],256],65379:[[12301],256],65380:[[12289],256],65381:[[12539],256],65382:[[12530],256],65383:[[12449],256],65384:[[12451],256],65385:[[12453],256],65386:[[12455],256],65387:[[12457],256],65388:[[12515],256],65389:[[12517],256],65390:[[12519],256],65391:[[12483],256],65392:[[12540],256],65393:[[12450],256],65394:[[12452],256],65395:[[12454],256],65396:[[12456],256],65397:[[12458],256],65398:[[12459],256],65399:[[12461],256],65400:[[12463],256],65401:[[12465],256],65402:[[12467],256],65403:[[12469],256],65404:[[12471],256],65405:[[12473],256],65406:[[12475],256],65407:[[12477],256],65408:[[12479],256],65409:[[12481],256],65410:[[12484],256],65411:[[12486],256],65412:[[12488],256],65413:[[12490],256],65414:[[12491],256],65415:[[12492],256],65416:[[12493],256],65417:[[12494],256],65418:[[12495],256],65419:[[12498],256],65420:[[12501],256],65421:[[12504],256],65422:[[12507],256],65423:[[12510],256],65424:[[12511],256],65425:[[12512],256],65426:[[12513],256],65427:[[12514],256],65428:[[12516],256],65429:[[12518],256],65430:[[12520],256],65431:[[12521],256],65432:[[12522],256],65433:[[12523],256],65434:[[12524],256],65435:[[12525],256],65436:[[12527],256],65437:[[12531],256],65438:[[12441],256],65439:[[12442],256],65440:[[12644],256],65441:[[12593],256],65442:[[12594],256],65443:[[12595],256],65444:[[12596],256],65445:[[12597],256],65446:[[12598],256],65447:[[12599],256],65448:[[12600],256],65449:[[12601],256],65450:[[12602],256],65451:[[12603],256],65452:[[12604],256],65453:[[12605],256],65454:[[12606],256],65455:[[12607],256],65456:[[12608],256],65457:[[12609],256],65458:[[12610],256],65459:[[12611],256],65460:[[12612],256],65461:[[12613],256],65462:[[12614],256],65463:[[12615],256],65464:[[12616],256],65465:[[12617],256],65466:[[12618],256],65467:[[12619],256],65468:[[12620],256],65469:[[12621],256],65470:[[12622],256],65474:[[12623],256],65475:[[12624],256],65476:[[12625],256],65477:[[12626],256],65478:[[12627],256],65479:[[12628],256],65482:[[12629],256],65483:[[12630],256],65484:[[12631],256],65485:[[12632],256],65486:[[12633],256],65487:[[12634],256],65490:[[12635],256],65491:[[12636],256],65492:[[12637],256],65493:[[12638],256],65494:[[12639],256],65495:[[12640],256],65498:[[12641],256],65499:[[12642],256],65500:[[12643],256],65504:[[162],256],65505:[[163],256],65506:[[172],256],65507:[[175],256],65508:[[166],256],65509:[[165],256],65510:[[8361],256],65512:[[9474],256],65513:[[8592],256],65514:[[8593],256],65515:[[8594],256],65516:[[8595],256],65517:[[9632],256],65518:[[9675],256]}

    	};

    	   /***** Module to export */
    	   var unorm = {
    	      nfc: nfc,
    	      nfd: nfd,
    	      nfkc: nfkc,
    	      nfkd: nfkd
    	   };

    	   /*globals module:true,define:true*/

    	   // CommonJS
    	   {
    	      module.exports = unorm;

    	   // AMD
    	   }

    	   /***** Export as shim for String::normalize method *****/
    	   /*
    	      http://wiki.ecmascript.org/doku.php?id=harmony:specification_drafts#november_8_2013_draft_rev_21

    	      21.1.3.12 String.prototype.normalize(form="NFC")
    	      When the normalize method is called with one argument form, the following steps are taken:

    	      1. Let O be CheckObjectCoercible(this value).
    	      2. Let S be ToString(O).
    	      3. ReturnIfAbrupt(S).
    	      4. If form is not provided or undefined let form be "NFC".
    	      5. Let f be ToString(form).
    	      6. ReturnIfAbrupt(f).
    	      7. If f is not one of "NFC", "NFD", "NFKC", or "NFKD", then throw a RangeError Exception.
    	      8. Let ns be the String value is the result of normalizing S into the normalization form named by f as specified in Unicode Standard Annex #15, UnicodeNormalizatoin Forms.
    	      9. Return ns.

    	      The length property of the normalize method is 0.

    	      *NOTE* The normalize function is intentionally generic; it does not require that its this value be a String object. Therefore it can be transferred to other kinds of objects for use as a method.
    	   */
    	    unorm.shimApplied = false;

    	   if (!String.prototype.normalize) {
    	      Object.defineProperty(String.prototype, "normalize", {
    	         enumerable: false,
    	         configurable: true,
    	         writable: true,
    	         value: function normalize (/*form*/) {
    	            
    	            var str = "" + this;
    	            var form = arguments[0] === undefined ? "NFC" : arguments[0];

    	            if (this === null || this === undefined) {
    	               throw new TypeError("Cannot call method on " + Object.prototype.toString.call(this));
    	            }

    	            if (form === "NFC") {
    	               return unorm.nfc(str);
    	            } else if (form === "NFD") {
    	               return unorm.nfd(str);
    	            } else if (form === "NFKC") {
    	               return unorm.nfkc(str);
    	            } else if (form === "NFKD") {
    	               return unorm.nfkd(str);
    	            } else {
    	               throw new RangeError("Invalid normalization form: " + form);
    	            }
    	         }
    	      });

    	      unorm.shimApplied = true;
    	   }
    	}()); 
    } (unorm$1));

    var unormExports = unorm$1.exports;

    var require$$5 = [
    	"的",
    	"一",
    	"是",
    	"在",
    	"不",
    	"了",
    	"有",
    	"和",
    	"人",
    	"这",
    	"中",
    	"大",
    	"为",
    	"上",
    	"个",
    	"国",
    	"我",
    	"以",
    	"要",
    	"他",
    	"时",
    	"来",
    	"用",
    	"们",
    	"生",
    	"到",
    	"作",
    	"地",
    	"于",
    	"出",
    	"就",
    	"分",
    	"对",
    	"成",
    	"会",
    	"可",
    	"主",
    	"发",
    	"年",
    	"动",
    	"同",
    	"工",
    	"也",
    	"能",
    	"下",
    	"过",
    	"子",
    	"说",
    	"产",
    	"种",
    	"面",
    	"而",
    	"方",
    	"后",
    	"多",
    	"定",
    	"行",
    	"学",
    	"法",
    	"所",
    	"民",
    	"得",
    	"经",
    	"十",
    	"三",
    	"之",
    	"进",
    	"着",
    	"等",
    	"部",
    	"度",
    	"家",
    	"电",
    	"力",
    	"里",
    	"如",
    	"水",
    	"化",
    	"高",
    	"自",
    	"二",
    	"理",
    	"起",
    	"小",
    	"物",
    	"现",
    	"实",
    	"加",
    	"量",
    	"都",
    	"两",
    	"体",
    	"制",
    	"机",
    	"当",
    	"使",
    	"点",
    	"从",
    	"业",
    	"本",
    	"去",
    	"把",
    	"性",
    	"好",
    	"应",
    	"开",
    	"它",
    	"合",
    	"还",
    	"因",
    	"由",
    	"其",
    	"些",
    	"然",
    	"前",
    	"外",
    	"天",
    	"政",
    	"四",
    	"日",
    	"那",
    	"社",
    	"义",
    	"事",
    	"平",
    	"形",
    	"相",
    	"全",
    	"表",
    	"间",
    	"样",
    	"与",
    	"关",
    	"各",
    	"重",
    	"新",
    	"线",
    	"内",
    	"数",
    	"正",
    	"心",
    	"反",
    	"你",
    	"明",
    	"看",
    	"原",
    	"又",
    	"么",
    	"利",
    	"比",
    	"或",
    	"但",
    	"质",
    	"气",
    	"第",
    	"向",
    	"道",
    	"命",
    	"此",
    	"变",
    	"条",
    	"只",
    	"没",
    	"结",
    	"解",
    	"问",
    	"意",
    	"建",
    	"月",
    	"公",
    	"无",
    	"系",
    	"军",
    	"很",
    	"情",
    	"者",
    	"最",
    	"立",
    	"代",
    	"想",
    	"已",
    	"通",
    	"并",
    	"提",
    	"直",
    	"题",
    	"党",
    	"程",
    	"展",
    	"五",
    	"果",
    	"料",
    	"象",
    	"员",
    	"革",
    	"位",
    	"入",
    	"常",
    	"文",
    	"总",
    	"次",
    	"品",
    	"式",
    	"活",
    	"设",
    	"及",
    	"管",
    	"特",
    	"件",
    	"长",
    	"求",
    	"老",
    	"头",
    	"基",
    	"资",
    	"边",
    	"流",
    	"路",
    	"级",
    	"少",
    	"图",
    	"山",
    	"统",
    	"接",
    	"知",
    	"较",
    	"将",
    	"组",
    	"见",
    	"计",
    	"别",
    	"她",
    	"手",
    	"角",
    	"期",
    	"根",
    	"论",
    	"运",
    	"农",
    	"指",
    	"几",
    	"九",
    	"区",
    	"强",
    	"放",
    	"决",
    	"西",
    	"被",
    	"干",
    	"做",
    	"必",
    	"战",
    	"先",
    	"回",
    	"则",
    	"任",
    	"取",
    	"据",
    	"处",
    	"队",
    	"南",
    	"给",
    	"色",
    	"光",
    	"门",
    	"即",
    	"保",
    	"治",
    	"北",
    	"造",
    	"百",
    	"规",
    	"热",
    	"领",
    	"七",
    	"海",
    	"口",
    	"东",
    	"导",
    	"器",
    	"压",
    	"志",
    	"世",
    	"金",
    	"增",
    	"争",
    	"济",
    	"阶",
    	"油",
    	"思",
    	"术",
    	"极",
    	"交",
    	"受",
    	"联",
    	"什",
    	"认",
    	"六",
    	"共",
    	"权",
    	"收",
    	"证",
    	"改",
    	"清",
    	"美",
    	"再",
    	"采",
    	"转",
    	"更",
    	"单",
    	"风",
    	"切",
    	"打",
    	"白",
    	"教",
    	"速",
    	"花",
    	"带",
    	"安",
    	"场",
    	"身",
    	"车",
    	"例",
    	"真",
    	"务",
    	"具",
    	"万",
    	"每",
    	"目",
    	"至",
    	"达",
    	"走",
    	"积",
    	"示",
    	"议",
    	"声",
    	"报",
    	"斗",
    	"完",
    	"类",
    	"八",
    	"离",
    	"华",
    	"名",
    	"确",
    	"才",
    	"科",
    	"张",
    	"信",
    	"马",
    	"节",
    	"话",
    	"米",
    	"整",
    	"空",
    	"元",
    	"况",
    	"今",
    	"集",
    	"温",
    	"传",
    	"土",
    	"许",
    	"步",
    	"群",
    	"广",
    	"石",
    	"记",
    	"需",
    	"段",
    	"研",
    	"界",
    	"拉",
    	"林",
    	"律",
    	"叫",
    	"且",
    	"究",
    	"观",
    	"越",
    	"织",
    	"装",
    	"影",
    	"算",
    	"低",
    	"持",
    	"音",
    	"众",
    	"书",
    	"布",
    	"复",
    	"容",
    	"儿",
    	"须",
    	"际",
    	"商",
    	"非",
    	"验",
    	"连",
    	"断",
    	"深",
    	"难",
    	"近",
    	"矿",
    	"千",
    	"周",
    	"委",
    	"素",
    	"技",
    	"备",
    	"半",
    	"办",
    	"青",
    	"省",
    	"列",
    	"习",
    	"响",
    	"约",
    	"支",
    	"般",
    	"史",
    	"感",
    	"劳",
    	"便",
    	"团",
    	"往",
    	"酸",
    	"历",
    	"市",
    	"克",
    	"何",
    	"除",
    	"消",
    	"构",
    	"府",
    	"称",
    	"太",
    	"准",
    	"精",
    	"值",
    	"号",
    	"率",
    	"族",
    	"维",
    	"划",
    	"选",
    	"标",
    	"写",
    	"存",
    	"候",
    	"毛",
    	"亲",
    	"快",
    	"效",
    	"斯",
    	"院",
    	"查",
    	"江",
    	"型",
    	"眼",
    	"王",
    	"按",
    	"格",
    	"养",
    	"易",
    	"置",
    	"派",
    	"层",
    	"片",
    	"始",
    	"却",
    	"专",
    	"状",
    	"育",
    	"厂",
    	"京",
    	"识",
    	"适",
    	"属",
    	"圆",
    	"包",
    	"火",
    	"住",
    	"调",
    	"满",
    	"县",
    	"局",
    	"照",
    	"参",
    	"红",
    	"细",
    	"引",
    	"听",
    	"该",
    	"铁",
    	"价",
    	"严",
    	"首",
    	"底",
    	"液",
    	"官",
    	"德",
    	"随",
    	"病",
    	"苏",
    	"失",
    	"尔",
    	"死",
    	"讲",
    	"配",
    	"女",
    	"黄",
    	"推",
    	"显",
    	"谈",
    	"罪",
    	"神",
    	"艺",
    	"呢",
    	"席",
    	"含",
    	"企",
    	"望",
    	"密",
    	"批",
    	"营",
    	"项",
    	"防",
    	"举",
    	"球",
    	"英",
    	"氧",
    	"势",
    	"告",
    	"李",
    	"台",
    	"落",
    	"木",
    	"帮",
    	"轮",
    	"破",
    	"亚",
    	"师",
    	"围",
    	"注",
    	"远",
    	"字",
    	"材",
    	"排",
    	"供",
    	"河",
    	"态",
    	"封",
    	"另",
    	"施",
    	"减",
    	"树",
    	"溶",
    	"怎",
    	"止",
    	"案",
    	"言",
    	"士",
    	"均",
    	"武",
    	"固",
    	"叶",
    	"鱼",
    	"波",
    	"视",
    	"仅",
    	"费",
    	"紧",
    	"爱",
    	"左",
    	"章",
    	"早",
    	"朝",
    	"害",
    	"续",
    	"轻",
    	"服",
    	"试",
    	"食",
    	"充",
    	"兵",
    	"源",
    	"判",
    	"护",
    	"司",
    	"足",
    	"某",
    	"练",
    	"差",
    	"致",
    	"板",
    	"田",
    	"降",
    	"黑",
    	"犯",
    	"负",
    	"击",
    	"范",
    	"继",
    	"兴",
    	"似",
    	"余",
    	"坚",
    	"曲",
    	"输",
    	"修",
    	"故",
    	"城",
    	"夫",
    	"够",
    	"送",
    	"笔",
    	"船",
    	"占",
    	"右",
    	"财",
    	"吃",
    	"富",
    	"春",
    	"职",
    	"觉",
    	"汉",
    	"画",
    	"功",
    	"巴",
    	"跟",
    	"虽",
    	"杂",
    	"飞",
    	"检",
    	"吸",
    	"助",
    	"升",
    	"阳",
    	"互",
    	"初",
    	"创",
    	"抗",
    	"考",
    	"投",
    	"坏",
    	"策",
    	"古",
    	"径",
    	"换",
    	"未",
    	"跑",
    	"留",
    	"钢",
    	"曾",
    	"端",
    	"责",
    	"站",
    	"简",
    	"述",
    	"钱",
    	"副",
    	"尽",
    	"帝",
    	"射",
    	"草",
    	"冲",
    	"承",
    	"独",
    	"令",
    	"限",
    	"阿",
    	"宣",
    	"环",
    	"双",
    	"请",
    	"超",
    	"微",
    	"让",
    	"控",
    	"州",
    	"良",
    	"轴",
    	"找",
    	"否",
    	"纪",
    	"益",
    	"依",
    	"优",
    	"顶",
    	"础",
    	"载",
    	"倒",
    	"房",
    	"突",
    	"坐",
    	"粉",
    	"敌",
    	"略",
    	"客",
    	"袁",
    	"冷",
    	"胜",
    	"绝",
    	"析",
    	"块",
    	"剂",
    	"测",
    	"丝",
    	"协",
    	"诉",
    	"念",
    	"陈",
    	"仍",
    	"罗",
    	"盐",
    	"友",
    	"洋",
    	"错",
    	"苦",
    	"夜",
    	"刑",
    	"移",
    	"频",
    	"逐",
    	"靠",
    	"混",
    	"母",
    	"短",
    	"皮",
    	"终",
    	"聚",
    	"汽",
    	"村",
    	"云",
    	"哪",
    	"既",
    	"距",
    	"卫",
    	"停",
    	"烈",
    	"央",
    	"察",
    	"烧",
    	"迅",
    	"境",
    	"若",
    	"印",
    	"洲",
    	"刻",
    	"括",
    	"激",
    	"孔",
    	"搞",
    	"甚",
    	"室",
    	"待",
    	"核",
    	"校",
    	"散",
    	"侵",
    	"吧",
    	"甲",
    	"游",
    	"久",
    	"菜",
    	"味",
    	"旧",
    	"模",
    	"湖",
    	"货",
    	"损",
    	"预",
    	"阻",
    	"毫",
    	"普",
    	"稳",
    	"乙",
    	"妈",
    	"植",
    	"息",
    	"扩",
    	"银",
    	"语",
    	"挥",
    	"酒",
    	"守",
    	"拿",
    	"序",
    	"纸",
    	"医",
    	"缺",
    	"雨",
    	"吗",
    	"针",
    	"刘",
    	"啊",
    	"急",
    	"唱",
    	"误",
    	"训",
    	"愿",
    	"审",
    	"附",
    	"获",
    	"茶",
    	"鲜",
    	"粮",
    	"斤",
    	"孩",
    	"脱",
    	"硫",
    	"肥",
    	"善",
    	"龙",
    	"演",
    	"父",
    	"渐",
    	"血",
    	"欢",
    	"械",
    	"掌",
    	"歌",
    	"沙",
    	"刚",
    	"攻",
    	"谓",
    	"盾",
    	"讨",
    	"晚",
    	"粒",
    	"乱",
    	"燃",
    	"矛",
    	"乎",
    	"杀",
    	"药",
    	"宁",
    	"鲁",
    	"贵",
    	"钟",
    	"煤",
    	"读",
    	"班",
    	"伯",
    	"香",
    	"介",
    	"迫",
    	"句",
    	"丰",
    	"培",
    	"握",
    	"兰",
    	"担",
    	"弦",
    	"蛋",
    	"沉",
    	"假",
    	"穿",
    	"执",
    	"答",
    	"乐",
    	"谁",
    	"顺",
    	"烟",
    	"缩",
    	"征",
    	"脸",
    	"喜",
    	"松",
    	"脚",
    	"困",
    	"异",
    	"免",
    	"背",
    	"星",
    	"福",
    	"买",
    	"染",
    	"井",
    	"概",
    	"慢",
    	"怕",
    	"磁",
    	"倍",
    	"祖",
    	"皇",
    	"促",
    	"静",
    	"补",
    	"评",
    	"翻",
    	"肉",
    	"践",
    	"尼",
    	"衣",
    	"宽",
    	"扬",
    	"棉",
    	"希",
    	"伤",
    	"操",
    	"垂",
    	"秋",
    	"宜",
    	"氢",
    	"套",
    	"督",
    	"振",
    	"架",
    	"亮",
    	"末",
    	"宪",
    	"庆",
    	"编",
    	"牛",
    	"触",
    	"映",
    	"雷",
    	"销",
    	"诗",
    	"座",
    	"居",
    	"抓",
    	"裂",
    	"胞",
    	"呼",
    	"娘",
    	"景",
    	"威",
    	"绿",
    	"晶",
    	"厚",
    	"盟",
    	"衡",
    	"鸡",
    	"孙",
    	"延",
    	"危",
    	"胶",
    	"屋",
    	"乡",
    	"临",
    	"陆",
    	"顾",
    	"掉",
    	"呀",
    	"灯",
    	"岁",
    	"措",
    	"束",
    	"耐",
    	"剧",
    	"玉",
    	"赵",
    	"跳",
    	"哥",
    	"季",
    	"课",
    	"凯",
    	"胡",
    	"额",
    	"款",
    	"绍",
    	"卷",
    	"齐",
    	"伟",
    	"蒸",
    	"殖",
    	"永",
    	"宗",
    	"苗",
    	"川",
    	"炉",
    	"岩",
    	"弱",
    	"零",
    	"杨",
    	"奏",
    	"沿",
    	"露",
    	"杆",
    	"探",
    	"滑",
    	"镇",
    	"饭",
    	"浓",
    	"航",
    	"怀",
    	"赶",
    	"库",
    	"夺",
    	"伊",
    	"灵",
    	"税",
    	"途",
    	"灭",
    	"赛",
    	"归",
    	"召",
    	"鼓",
    	"播",
    	"盘",
    	"裁",
    	"险",
    	"康",
    	"唯",
    	"录",
    	"菌",
    	"纯",
    	"借",
    	"糖",
    	"盖",
    	"横",
    	"符",
    	"私",
    	"努",
    	"堂",
    	"域",
    	"枪",
    	"润",
    	"幅",
    	"哈",
    	"竟",
    	"熟",
    	"虫",
    	"泽",
    	"脑",
    	"壤",
    	"碳",
    	"欧",
    	"遍",
    	"侧",
    	"寨",
    	"敢",
    	"彻",
    	"虑",
    	"斜",
    	"薄",
    	"庭",
    	"纳",
    	"弹",
    	"饲",
    	"伸",
    	"折",
    	"麦",
    	"湿",
    	"暗",
    	"荷",
    	"瓦",
    	"塞",
    	"床",
    	"筑",
    	"恶",
    	"户",
    	"访",
    	"塔",
    	"奇",
    	"透",
    	"梁",
    	"刀",
    	"旋",
    	"迹",
    	"卡",
    	"氯",
    	"遇",
    	"份",
    	"毒",
    	"泥",
    	"退",
    	"洗",
    	"摆",
    	"灰",
    	"彩",
    	"卖",
    	"耗",
    	"夏",
    	"择",
    	"忙",
    	"铜",
    	"献",
    	"硬",
    	"予",
    	"繁",
    	"圈",
    	"雪",
    	"函",
    	"亦",
    	"抽",
    	"篇",
    	"阵",
    	"阴",
    	"丁",
    	"尺",
    	"追",
    	"堆",
    	"雄",
    	"迎",
    	"泛",
    	"爸",
    	"楼",
    	"避",
    	"谋",
    	"吨",
    	"野",
    	"猪",
    	"旗",
    	"累",
    	"偏",
    	"典",
    	"馆",
    	"索",
    	"秦",
    	"脂",
    	"潮",
    	"爷",
    	"豆",
    	"忽",
    	"托",
    	"惊",
    	"塑",
    	"遗",
    	"愈",
    	"朱",
    	"替",
    	"纤",
    	"粗",
    	"倾",
    	"尚",
    	"痛",
    	"楚",
    	"谢",
    	"奋",
    	"购",
    	"磨",
    	"君",
    	"池",
    	"旁",
    	"碎",
    	"骨",
    	"监",
    	"捕",
    	"弟",
    	"暴",
    	"割",
    	"贯",
    	"殊",
    	"释",
    	"词",
    	"亡",
    	"壁",
    	"顿",
    	"宝",
    	"午",
    	"尘",
    	"闻",
    	"揭",
    	"炮",
    	"残",
    	"冬",
    	"桥",
    	"妇",
    	"警",
    	"综",
    	"招",
    	"吴",
    	"付",
    	"浮",
    	"遭",
    	"徐",
    	"您",
    	"摇",
    	"谷",
    	"赞",
    	"箱",
    	"隔",
    	"订",
    	"男",
    	"吹",
    	"园",
    	"纷",
    	"唐",
    	"败",
    	"宋",
    	"玻",
    	"巨",
    	"耕",
    	"坦",
    	"荣",
    	"闭",
    	"湾",
    	"键",
    	"凡",
    	"驻",
    	"锅",
    	"救",
    	"恩",
    	"剥",
    	"凝",
    	"碱",
    	"齿",
    	"截",
    	"炼",
    	"麻",
    	"纺",
    	"禁",
    	"废",
    	"盛",
    	"版",
    	"缓",
    	"净",
    	"睛",
    	"昌",
    	"婚",
    	"涉",
    	"筒",
    	"嘴",
    	"插",
    	"岸",
    	"朗",
    	"庄",
    	"街",
    	"藏",
    	"姑",
    	"贸",
    	"腐",
    	"奴",
    	"啦",
    	"惯",
    	"乘",
    	"伙",
    	"恢",
    	"匀",
    	"纱",
    	"扎",
    	"辩",
    	"耳",
    	"彪",
    	"臣",
    	"亿",
    	"璃",
    	"抵",
    	"脉",
    	"秀",
    	"萨",
    	"俄",
    	"网",
    	"舞",
    	"店",
    	"喷",
    	"纵",
    	"寸",
    	"汗",
    	"挂",
    	"洪",
    	"贺",
    	"闪",
    	"柬",
    	"爆",
    	"烯",
    	"津",
    	"稻",
    	"墙",
    	"软",
    	"勇",
    	"像",
    	"滚",
    	"厘",
    	"蒙",
    	"芳",
    	"肯",
    	"坡",
    	"柱",
    	"荡",
    	"腿",
    	"仪",
    	"旅",
    	"尾",
    	"轧",
    	"冰",
    	"贡",
    	"登",
    	"黎",
    	"削",
    	"钻",
    	"勒",
    	"逃",
    	"障",
    	"氨",
    	"郭",
    	"峰",
    	"币",
    	"港",
    	"伏",
    	"轨",
    	"亩",
    	"毕",
    	"擦",
    	"莫",
    	"刺",
    	"浪",
    	"秘",
    	"援",
    	"株",
    	"健",
    	"售",
    	"股",
    	"岛",
    	"甘",
    	"泡",
    	"睡",
    	"童",
    	"铸",
    	"汤",
    	"阀",
    	"休",
    	"汇",
    	"舍",
    	"牧",
    	"绕",
    	"炸",
    	"哲",
    	"磷",
    	"绩",
    	"朋",
    	"淡",
    	"尖",
    	"启",
    	"陷",
    	"柴",
    	"呈",
    	"徒",
    	"颜",
    	"泪",
    	"稍",
    	"忘",
    	"泵",
    	"蓝",
    	"拖",
    	"洞",
    	"授",
    	"镜",
    	"辛",
    	"壮",
    	"锋",
    	"贫",
    	"虚",
    	"弯",
    	"摩",
    	"泰",
    	"幼",
    	"廷",
    	"尊",
    	"窗",
    	"纲",
    	"弄",
    	"隶",
    	"疑",
    	"氏",
    	"宫",
    	"姐",
    	"震",
    	"瑞",
    	"怪",
    	"尤",
    	"琴",
    	"循",
    	"描",
    	"膜",
    	"违",
    	"夹",
    	"腰",
    	"缘",
    	"珠",
    	"穷",
    	"森",
    	"枝",
    	"竹",
    	"沟",
    	"催",
    	"绳",
    	"忆",
    	"邦",
    	"剩",
    	"幸",
    	"浆",
    	"栏",
    	"拥",
    	"牙",
    	"贮",
    	"礼",
    	"滤",
    	"钠",
    	"纹",
    	"罢",
    	"拍",
    	"咱",
    	"喊",
    	"袖",
    	"埃",
    	"勤",
    	"罚",
    	"焦",
    	"潜",
    	"伍",
    	"墨",
    	"欲",
    	"缝",
    	"姓",
    	"刊",
    	"饱",
    	"仿",
    	"奖",
    	"铝",
    	"鬼",
    	"丽",
    	"跨",
    	"默",
    	"挖",
    	"链",
    	"扫",
    	"喝",
    	"袋",
    	"炭",
    	"污",
    	"幕",
    	"诸",
    	"弧",
    	"励",
    	"梅",
    	"奶",
    	"洁",
    	"灾",
    	"舟",
    	"鉴",
    	"苯",
    	"讼",
    	"抱",
    	"毁",
    	"懂",
    	"寒",
    	"智",
    	"埔",
    	"寄",
    	"届",
    	"跃",
    	"渡",
    	"挑",
    	"丹",
    	"艰",
    	"贝",
    	"碰",
    	"拔",
    	"爹",
    	"戴",
    	"码",
    	"梦",
    	"芽",
    	"熔",
    	"赤",
    	"渔",
    	"哭",
    	"敬",
    	"颗",
    	"奔",
    	"铅",
    	"仲",
    	"虎",
    	"稀",
    	"妹",
    	"乏",
    	"珍",
    	"申",
    	"桌",
    	"遵",
    	"允",
    	"隆",
    	"螺",
    	"仓",
    	"魏",
    	"锐",
    	"晓",
    	"氮",
    	"兼",
    	"隐",
    	"碍",
    	"赫",
    	"拨",
    	"忠",
    	"肃",
    	"缸",
    	"牵",
    	"抢",
    	"博",
    	"巧",
    	"壳",
    	"兄",
    	"杜",
    	"讯",
    	"诚",
    	"碧",
    	"祥",
    	"柯",
    	"页",
    	"巡",
    	"矩",
    	"悲",
    	"灌",
    	"龄",
    	"伦",
    	"票",
    	"寻",
    	"桂",
    	"铺",
    	"圣",
    	"恐",
    	"恰",
    	"郑",
    	"趣",
    	"抬",
    	"荒",
    	"腾",
    	"贴",
    	"柔",
    	"滴",
    	"猛",
    	"阔",
    	"辆",
    	"妻",
    	"填",
    	"撤",
    	"储",
    	"签",
    	"闹",
    	"扰",
    	"紫",
    	"砂",
    	"递",
    	"戏",
    	"吊",
    	"陶",
    	"伐",
    	"喂",
    	"疗",
    	"瓶",
    	"婆",
    	"抚",
    	"臂",
    	"摸",
    	"忍",
    	"虾",
    	"蜡",
    	"邻",
    	"胸",
    	"巩",
    	"挤",
    	"偶",
    	"弃",
    	"槽",
    	"劲",
    	"乳",
    	"邓",
    	"吉",
    	"仁",
    	"烂",
    	"砖",
    	"租",
    	"乌",
    	"舰",
    	"伴",
    	"瓜",
    	"浅",
    	"丙",
    	"暂",
    	"燥",
    	"橡",
    	"柳",
    	"迷",
    	"暖",
    	"牌",
    	"秧",
    	"胆",
    	"详",
    	"簧",
    	"踏",
    	"瓷",
    	"谱",
    	"呆",
    	"宾",
    	"糊",
    	"洛",
    	"辉",
    	"愤",
    	"竞",
    	"隙",
    	"怒",
    	"粘",
    	"乃",
    	"绪",
    	"肩",
    	"籍",
    	"敏",
    	"涂",
    	"熙",
    	"皆",
    	"侦",
    	"悬",
    	"掘",
    	"享",
    	"纠",
    	"醒",
    	"狂",
    	"锁",
    	"淀",
    	"恨",
    	"牲",
    	"霸",
    	"爬",
    	"赏",
    	"逆",
    	"玩",
    	"陵",
    	"祝",
    	"秒",
    	"浙",
    	"貌",
    	"役",
    	"彼",
    	"悉",
    	"鸭",
    	"趋",
    	"凤",
    	"晨",
    	"畜",
    	"辈",
    	"秩",
    	"卵",
    	"署",
    	"梯",
    	"炎",
    	"滩",
    	"棋",
    	"驱",
    	"筛",
    	"峡",
    	"冒",
    	"啥",
    	"寿",
    	"译",
    	"浸",
    	"泉",
    	"帽",
    	"迟",
    	"硅",
    	"疆",
    	"贷",
    	"漏",
    	"稿",
    	"冠",
    	"嫩",
    	"胁",
    	"芯",
    	"牢",
    	"叛",
    	"蚀",
    	"奥",
    	"鸣",
    	"岭",
    	"羊",
    	"凭",
    	"串",
    	"塘",
    	"绘",
    	"酵",
    	"融",
    	"盆",
    	"锡",
    	"庙",
    	"筹",
    	"冻",
    	"辅",
    	"摄",
    	"袭",
    	"筋",
    	"拒",
    	"僚",
    	"旱",
    	"钾",
    	"鸟",
    	"漆",
    	"沈",
    	"眉",
    	"疏",
    	"添",
    	"棒",
    	"穗",
    	"硝",
    	"韩",
    	"逼",
    	"扭",
    	"侨",
    	"凉",
    	"挺",
    	"碗",
    	"栽",
    	"炒",
    	"杯",
    	"患",
    	"馏",
    	"劝",
    	"豪",
    	"辽",
    	"勃",
    	"鸿",
    	"旦",
    	"吏",
    	"拜",
    	"狗",
    	"埋",
    	"辊",
    	"掩",
    	"饮",
    	"搬",
    	"骂",
    	"辞",
    	"勾",
    	"扣",
    	"估",
    	"蒋",
    	"绒",
    	"雾",
    	"丈",
    	"朵",
    	"姆",
    	"拟",
    	"宇",
    	"辑",
    	"陕",
    	"雕",
    	"偿",
    	"蓄",
    	"崇",
    	"剪",
    	"倡",
    	"厅",
    	"咬",
    	"驶",
    	"薯",
    	"刷",
    	"斥",
    	"番",
    	"赋",
    	"奉",
    	"佛",
    	"浇",
    	"漫",
    	"曼",
    	"扇",
    	"钙",
    	"桃",
    	"扶",
    	"仔",
    	"返",
    	"俗",
    	"亏",
    	"腔",
    	"鞋",
    	"棱",
    	"覆",
    	"框",
    	"悄",
    	"叔",
    	"撞",
    	"骗",
    	"勘",
    	"旺",
    	"沸",
    	"孤",
    	"吐",
    	"孟",
    	"渠",
    	"屈",
    	"疾",
    	"妙",
    	"惜",
    	"仰",
    	"狠",
    	"胀",
    	"谐",
    	"抛",
    	"霉",
    	"桑",
    	"岗",
    	"嘛",
    	"衰",
    	"盗",
    	"渗",
    	"脏",
    	"赖",
    	"涌",
    	"甜",
    	"曹",
    	"阅",
    	"肌",
    	"哩",
    	"厉",
    	"烃",
    	"纬",
    	"毅",
    	"昨",
    	"伪",
    	"症",
    	"煮",
    	"叹",
    	"钉",
    	"搭",
    	"茎",
    	"笼",
    	"酷",
    	"偷",
    	"弓",
    	"锥",
    	"恒",
    	"杰",
    	"坑",
    	"鼻",
    	"翼",
    	"纶",
    	"叙",
    	"狱",
    	"逮",
    	"罐",
    	"络",
    	"棚",
    	"抑",
    	"膨",
    	"蔬",
    	"寺",
    	"骤",
    	"穆",
    	"冶",
    	"枯",
    	"册",
    	"尸",
    	"凸",
    	"绅",
    	"坯",
    	"牺",
    	"焰",
    	"轰",
    	"欣",
    	"晋",
    	"瘦",
    	"御",
    	"锭",
    	"锦",
    	"丧",
    	"旬",
    	"锻",
    	"垄",
    	"搜",
    	"扑",
    	"邀",
    	"亭",
    	"酯",
    	"迈",
    	"舒",
    	"脆",
    	"酶",
    	"闲",
    	"忧",
    	"酚",
    	"顽",
    	"羽",
    	"涨",
    	"卸",
    	"仗",
    	"陪",
    	"辟",
    	"惩",
    	"杭",
    	"姚",
    	"肚",
    	"捉",
    	"飘",
    	"漂",
    	"昆",
    	"欺",
    	"吾",
    	"郎",
    	"烷",
    	"汁",
    	"呵",
    	"饰",
    	"萧",
    	"雅",
    	"邮",
    	"迁",
    	"燕",
    	"撒",
    	"姻",
    	"赴",
    	"宴",
    	"烦",
    	"债",
    	"帐",
    	"斑",
    	"铃",
    	"旨",
    	"醇",
    	"董",
    	"饼",
    	"雏",
    	"姿",
    	"拌",
    	"傅",
    	"腹",
    	"妥",
    	"揉",
    	"贤",
    	"拆",
    	"歪",
    	"葡",
    	"胺",
    	"丢",
    	"浩",
    	"徽",
    	"昂",
    	"垫",
    	"挡",
    	"览",
    	"贪",
    	"慰",
    	"缴",
    	"汪",
    	"慌",
    	"冯",
    	"诺",
    	"姜",
    	"谊",
    	"凶",
    	"劣",
    	"诬",
    	"耀",
    	"昏",
    	"躺",
    	"盈",
    	"骑",
    	"乔",
    	"溪",
    	"丛",
    	"卢",
    	"抹",
    	"闷",
    	"咨",
    	"刮",
    	"驾",
    	"缆",
    	"悟",
    	"摘",
    	"铒",
    	"掷",
    	"颇",
    	"幻",
    	"柄",
    	"惠",
    	"惨",
    	"佳",
    	"仇",
    	"腊",
    	"窝",
    	"涤",
    	"剑",
    	"瞧",
    	"堡",
    	"泼",
    	"葱",
    	"罩",
    	"霍",
    	"捞",
    	"胎",
    	"苍",
    	"滨",
    	"俩",
    	"捅",
    	"湘",
    	"砍",
    	"霞",
    	"邵",
    	"萄",
    	"疯",
    	"淮",
    	"遂",
    	"熊",
    	"粪",
    	"烘",
    	"宿",
    	"档",
    	"戈",
    	"驳",
    	"嫂",
    	"裕",
    	"徙",
    	"箭",
    	"捐",
    	"肠",
    	"撑",
    	"晒",
    	"辨",
    	"殿",
    	"莲",
    	"摊",
    	"搅",
    	"酱",
    	"屏",
    	"疫",
    	"哀",
    	"蔡",
    	"堵",
    	"沫",
    	"皱",
    	"畅",
    	"叠",
    	"阁",
    	"莱",
    	"敲",
    	"辖",
    	"钩",
    	"痕",
    	"坝",
    	"巷",
    	"饿",
    	"祸",
    	"丘",
    	"玄",
    	"溜",
    	"曰",
    	"逻",
    	"彭",
    	"尝",
    	"卿",
    	"妨",
    	"艇",
    	"吞",
    	"韦",
    	"怨",
    	"矮",
    	"歇"
    ];

    var require$$6 = [
    	"的",
    	"一",
    	"是",
    	"在",
    	"不",
    	"了",
    	"有",
    	"和",
    	"人",
    	"這",
    	"中",
    	"大",
    	"為",
    	"上",
    	"個",
    	"國",
    	"我",
    	"以",
    	"要",
    	"他",
    	"時",
    	"來",
    	"用",
    	"們",
    	"生",
    	"到",
    	"作",
    	"地",
    	"於",
    	"出",
    	"就",
    	"分",
    	"對",
    	"成",
    	"會",
    	"可",
    	"主",
    	"發",
    	"年",
    	"動",
    	"同",
    	"工",
    	"也",
    	"能",
    	"下",
    	"過",
    	"子",
    	"說",
    	"產",
    	"種",
    	"面",
    	"而",
    	"方",
    	"後",
    	"多",
    	"定",
    	"行",
    	"學",
    	"法",
    	"所",
    	"民",
    	"得",
    	"經",
    	"十",
    	"三",
    	"之",
    	"進",
    	"著",
    	"等",
    	"部",
    	"度",
    	"家",
    	"電",
    	"力",
    	"裡",
    	"如",
    	"水",
    	"化",
    	"高",
    	"自",
    	"二",
    	"理",
    	"起",
    	"小",
    	"物",
    	"現",
    	"實",
    	"加",
    	"量",
    	"都",
    	"兩",
    	"體",
    	"制",
    	"機",
    	"當",
    	"使",
    	"點",
    	"從",
    	"業",
    	"本",
    	"去",
    	"把",
    	"性",
    	"好",
    	"應",
    	"開",
    	"它",
    	"合",
    	"還",
    	"因",
    	"由",
    	"其",
    	"些",
    	"然",
    	"前",
    	"外",
    	"天",
    	"政",
    	"四",
    	"日",
    	"那",
    	"社",
    	"義",
    	"事",
    	"平",
    	"形",
    	"相",
    	"全",
    	"表",
    	"間",
    	"樣",
    	"與",
    	"關",
    	"各",
    	"重",
    	"新",
    	"線",
    	"內",
    	"數",
    	"正",
    	"心",
    	"反",
    	"你",
    	"明",
    	"看",
    	"原",
    	"又",
    	"麼",
    	"利",
    	"比",
    	"或",
    	"但",
    	"質",
    	"氣",
    	"第",
    	"向",
    	"道",
    	"命",
    	"此",
    	"變",
    	"條",
    	"只",
    	"沒",
    	"結",
    	"解",
    	"問",
    	"意",
    	"建",
    	"月",
    	"公",
    	"無",
    	"系",
    	"軍",
    	"很",
    	"情",
    	"者",
    	"最",
    	"立",
    	"代",
    	"想",
    	"已",
    	"通",
    	"並",
    	"提",
    	"直",
    	"題",
    	"黨",
    	"程",
    	"展",
    	"五",
    	"果",
    	"料",
    	"象",
    	"員",
    	"革",
    	"位",
    	"入",
    	"常",
    	"文",
    	"總",
    	"次",
    	"品",
    	"式",
    	"活",
    	"設",
    	"及",
    	"管",
    	"特",
    	"件",
    	"長",
    	"求",
    	"老",
    	"頭",
    	"基",
    	"資",
    	"邊",
    	"流",
    	"路",
    	"級",
    	"少",
    	"圖",
    	"山",
    	"統",
    	"接",
    	"知",
    	"較",
    	"將",
    	"組",
    	"見",
    	"計",
    	"別",
    	"她",
    	"手",
    	"角",
    	"期",
    	"根",
    	"論",
    	"運",
    	"農",
    	"指",
    	"幾",
    	"九",
    	"區",
    	"強",
    	"放",
    	"決",
    	"西",
    	"被",
    	"幹",
    	"做",
    	"必",
    	"戰",
    	"先",
    	"回",
    	"則",
    	"任",
    	"取",
    	"據",
    	"處",
    	"隊",
    	"南",
    	"給",
    	"色",
    	"光",
    	"門",
    	"即",
    	"保",
    	"治",
    	"北",
    	"造",
    	"百",
    	"規",
    	"熱",
    	"領",
    	"七",
    	"海",
    	"口",
    	"東",
    	"導",
    	"器",
    	"壓",
    	"志",
    	"世",
    	"金",
    	"增",
    	"爭",
    	"濟",
    	"階",
    	"油",
    	"思",
    	"術",
    	"極",
    	"交",
    	"受",
    	"聯",
    	"什",
    	"認",
    	"六",
    	"共",
    	"權",
    	"收",
    	"證",
    	"改",
    	"清",
    	"美",
    	"再",
    	"採",
    	"轉",
    	"更",
    	"單",
    	"風",
    	"切",
    	"打",
    	"白",
    	"教",
    	"速",
    	"花",
    	"帶",
    	"安",
    	"場",
    	"身",
    	"車",
    	"例",
    	"真",
    	"務",
    	"具",
    	"萬",
    	"每",
    	"目",
    	"至",
    	"達",
    	"走",
    	"積",
    	"示",
    	"議",
    	"聲",
    	"報",
    	"鬥",
    	"完",
    	"類",
    	"八",
    	"離",
    	"華",
    	"名",
    	"確",
    	"才",
    	"科",
    	"張",
    	"信",
    	"馬",
    	"節",
    	"話",
    	"米",
    	"整",
    	"空",
    	"元",
    	"況",
    	"今",
    	"集",
    	"溫",
    	"傳",
    	"土",
    	"許",
    	"步",
    	"群",
    	"廣",
    	"石",
    	"記",
    	"需",
    	"段",
    	"研",
    	"界",
    	"拉",
    	"林",
    	"律",
    	"叫",
    	"且",
    	"究",
    	"觀",
    	"越",
    	"織",
    	"裝",
    	"影",
    	"算",
    	"低",
    	"持",
    	"音",
    	"眾",
    	"書",
    	"布",
    	"复",
    	"容",
    	"兒",
    	"須",
    	"際",
    	"商",
    	"非",
    	"驗",
    	"連",
    	"斷",
    	"深",
    	"難",
    	"近",
    	"礦",
    	"千",
    	"週",
    	"委",
    	"素",
    	"技",
    	"備",
    	"半",
    	"辦",
    	"青",
    	"省",
    	"列",
    	"習",
    	"響",
    	"約",
    	"支",
    	"般",
    	"史",
    	"感",
    	"勞",
    	"便",
    	"團",
    	"往",
    	"酸",
    	"歷",
    	"市",
    	"克",
    	"何",
    	"除",
    	"消",
    	"構",
    	"府",
    	"稱",
    	"太",
    	"準",
    	"精",
    	"值",
    	"號",
    	"率",
    	"族",
    	"維",
    	"劃",
    	"選",
    	"標",
    	"寫",
    	"存",
    	"候",
    	"毛",
    	"親",
    	"快",
    	"效",
    	"斯",
    	"院",
    	"查",
    	"江",
    	"型",
    	"眼",
    	"王",
    	"按",
    	"格",
    	"養",
    	"易",
    	"置",
    	"派",
    	"層",
    	"片",
    	"始",
    	"卻",
    	"專",
    	"狀",
    	"育",
    	"廠",
    	"京",
    	"識",
    	"適",
    	"屬",
    	"圓",
    	"包",
    	"火",
    	"住",
    	"調",
    	"滿",
    	"縣",
    	"局",
    	"照",
    	"參",
    	"紅",
    	"細",
    	"引",
    	"聽",
    	"該",
    	"鐵",
    	"價",
    	"嚴",
    	"首",
    	"底",
    	"液",
    	"官",
    	"德",
    	"隨",
    	"病",
    	"蘇",
    	"失",
    	"爾",
    	"死",
    	"講",
    	"配",
    	"女",
    	"黃",
    	"推",
    	"顯",
    	"談",
    	"罪",
    	"神",
    	"藝",
    	"呢",
    	"席",
    	"含",
    	"企",
    	"望",
    	"密",
    	"批",
    	"營",
    	"項",
    	"防",
    	"舉",
    	"球",
    	"英",
    	"氧",
    	"勢",
    	"告",
    	"李",
    	"台",
    	"落",
    	"木",
    	"幫",
    	"輪",
    	"破",
    	"亞",
    	"師",
    	"圍",
    	"注",
    	"遠",
    	"字",
    	"材",
    	"排",
    	"供",
    	"河",
    	"態",
    	"封",
    	"另",
    	"施",
    	"減",
    	"樹",
    	"溶",
    	"怎",
    	"止",
    	"案",
    	"言",
    	"士",
    	"均",
    	"武",
    	"固",
    	"葉",
    	"魚",
    	"波",
    	"視",
    	"僅",
    	"費",
    	"緊",
    	"愛",
    	"左",
    	"章",
    	"早",
    	"朝",
    	"害",
    	"續",
    	"輕",
    	"服",
    	"試",
    	"食",
    	"充",
    	"兵",
    	"源",
    	"判",
    	"護",
    	"司",
    	"足",
    	"某",
    	"練",
    	"差",
    	"致",
    	"板",
    	"田",
    	"降",
    	"黑",
    	"犯",
    	"負",
    	"擊",
    	"范",
    	"繼",
    	"興",
    	"似",
    	"餘",
    	"堅",
    	"曲",
    	"輸",
    	"修",
    	"故",
    	"城",
    	"夫",
    	"夠",
    	"送",
    	"筆",
    	"船",
    	"佔",
    	"右",
    	"財",
    	"吃",
    	"富",
    	"春",
    	"職",
    	"覺",
    	"漢",
    	"畫",
    	"功",
    	"巴",
    	"跟",
    	"雖",
    	"雜",
    	"飛",
    	"檢",
    	"吸",
    	"助",
    	"昇",
    	"陽",
    	"互",
    	"初",
    	"創",
    	"抗",
    	"考",
    	"投",
    	"壞",
    	"策",
    	"古",
    	"徑",
    	"換",
    	"未",
    	"跑",
    	"留",
    	"鋼",
    	"曾",
    	"端",
    	"責",
    	"站",
    	"簡",
    	"述",
    	"錢",
    	"副",
    	"盡",
    	"帝",
    	"射",
    	"草",
    	"衝",
    	"承",
    	"獨",
    	"令",
    	"限",
    	"阿",
    	"宣",
    	"環",
    	"雙",
    	"請",
    	"超",
    	"微",
    	"讓",
    	"控",
    	"州",
    	"良",
    	"軸",
    	"找",
    	"否",
    	"紀",
    	"益",
    	"依",
    	"優",
    	"頂",
    	"礎",
    	"載",
    	"倒",
    	"房",
    	"突",
    	"坐",
    	"粉",
    	"敵",
    	"略",
    	"客",
    	"袁",
    	"冷",
    	"勝",
    	"絕",
    	"析",
    	"塊",
    	"劑",
    	"測",
    	"絲",
    	"協",
    	"訴",
    	"念",
    	"陳",
    	"仍",
    	"羅",
    	"鹽",
    	"友",
    	"洋",
    	"錯",
    	"苦",
    	"夜",
    	"刑",
    	"移",
    	"頻",
    	"逐",
    	"靠",
    	"混",
    	"母",
    	"短",
    	"皮",
    	"終",
    	"聚",
    	"汽",
    	"村",
    	"雲",
    	"哪",
    	"既",
    	"距",
    	"衛",
    	"停",
    	"烈",
    	"央",
    	"察",
    	"燒",
    	"迅",
    	"境",
    	"若",
    	"印",
    	"洲",
    	"刻",
    	"括",
    	"激",
    	"孔",
    	"搞",
    	"甚",
    	"室",
    	"待",
    	"核",
    	"校",
    	"散",
    	"侵",
    	"吧",
    	"甲",
    	"遊",
    	"久",
    	"菜",
    	"味",
    	"舊",
    	"模",
    	"湖",
    	"貨",
    	"損",
    	"預",
    	"阻",
    	"毫",
    	"普",
    	"穩",
    	"乙",
    	"媽",
    	"植",
    	"息",
    	"擴",
    	"銀",
    	"語",
    	"揮",
    	"酒",
    	"守",
    	"拿",
    	"序",
    	"紙",
    	"醫",
    	"缺",
    	"雨",
    	"嗎",
    	"針",
    	"劉",
    	"啊",
    	"急",
    	"唱",
    	"誤",
    	"訓",
    	"願",
    	"審",
    	"附",
    	"獲",
    	"茶",
    	"鮮",
    	"糧",
    	"斤",
    	"孩",
    	"脫",
    	"硫",
    	"肥",
    	"善",
    	"龍",
    	"演",
    	"父",
    	"漸",
    	"血",
    	"歡",
    	"械",
    	"掌",
    	"歌",
    	"沙",
    	"剛",
    	"攻",
    	"謂",
    	"盾",
    	"討",
    	"晚",
    	"粒",
    	"亂",
    	"燃",
    	"矛",
    	"乎",
    	"殺",
    	"藥",
    	"寧",
    	"魯",
    	"貴",
    	"鐘",
    	"煤",
    	"讀",
    	"班",
    	"伯",
    	"香",
    	"介",
    	"迫",
    	"句",
    	"豐",
    	"培",
    	"握",
    	"蘭",
    	"擔",
    	"弦",
    	"蛋",
    	"沉",
    	"假",
    	"穿",
    	"執",
    	"答",
    	"樂",
    	"誰",
    	"順",
    	"煙",
    	"縮",
    	"徵",
    	"臉",
    	"喜",
    	"松",
    	"腳",
    	"困",
    	"異",
    	"免",
    	"背",
    	"星",
    	"福",
    	"買",
    	"染",
    	"井",
    	"概",
    	"慢",
    	"怕",
    	"磁",
    	"倍",
    	"祖",
    	"皇",
    	"促",
    	"靜",
    	"補",
    	"評",
    	"翻",
    	"肉",
    	"踐",
    	"尼",
    	"衣",
    	"寬",
    	"揚",
    	"棉",
    	"希",
    	"傷",
    	"操",
    	"垂",
    	"秋",
    	"宜",
    	"氫",
    	"套",
    	"督",
    	"振",
    	"架",
    	"亮",
    	"末",
    	"憲",
    	"慶",
    	"編",
    	"牛",
    	"觸",
    	"映",
    	"雷",
    	"銷",
    	"詩",
    	"座",
    	"居",
    	"抓",
    	"裂",
    	"胞",
    	"呼",
    	"娘",
    	"景",
    	"威",
    	"綠",
    	"晶",
    	"厚",
    	"盟",
    	"衡",
    	"雞",
    	"孫",
    	"延",
    	"危",
    	"膠",
    	"屋",
    	"鄉",
    	"臨",
    	"陸",
    	"顧",
    	"掉",
    	"呀",
    	"燈",
    	"歲",
    	"措",
    	"束",
    	"耐",
    	"劇",
    	"玉",
    	"趙",
    	"跳",
    	"哥",
    	"季",
    	"課",
    	"凱",
    	"胡",
    	"額",
    	"款",
    	"紹",
    	"卷",
    	"齊",
    	"偉",
    	"蒸",
    	"殖",
    	"永",
    	"宗",
    	"苗",
    	"川",
    	"爐",
    	"岩",
    	"弱",
    	"零",
    	"楊",
    	"奏",
    	"沿",
    	"露",
    	"桿",
    	"探",
    	"滑",
    	"鎮",
    	"飯",
    	"濃",
    	"航",
    	"懷",
    	"趕",
    	"庫",
    	"奪",
    	"伊",
    	"靈",
    	"稅",
    	"途",
    	"滅",
    	"賽",
    	"歸",
    	"召",
    	"鼓",
    	"播",
    	"盤",
    	"裁",
    	"險",
    	"康",
    	"唯",
    	"錄",
    	"菌",
    	"純",
    	"借",
    	"糖",
    	"蓋",
    	"橫",
    	"符",
    	"私",
    	"努",
    	"堂",
    	"域",
    	"槍",
    	"潤",
    	"幅",
    	"哈",
    	"竟",
    	"熟",
    	"蟲",
    	"澤",
    	"腦",
    	"壤",
    	"碳",
    	"歐",
    	"遍",
    	"側",
    	"寨",
    	"敢",
    	"徹",
    	"慮",
    	"斜",
    	"薄",
    	"庭",
    	"納",
    	"彈",
    	"飼",
    	"伸",
    	"折",
    	"麥",
    	"濕",
    	"暗",
    	"荷",
    	"瓦",
    	"塞",
    	"床",
    	"築",
    	"惡",
    	"戶",
    	"訪",
    	"塔",
    	"奇",
    	"透",
    	"梁",
    	"刀",
    	"旋",
    	"跡",
    	"卡",
    	"氯",
    	"遇",
    	"份",
    	"毒",
    	"泥",
    	"退",
    	"洗",
    	"擺",
    	"灰",
    	"彩",
    	"賣",
    	"耗",
    	"夏",
    	"擇",
    	"忙",
    	"銅",
    	"獻",
    	"硬",
    	"予",
    	"繁",
    	"圈",
    	"雪",
    	"函",
    	"亦",
    	"抽",
    	"篇",
    	"陣",
    	"陰",
    	"丁",
    	"尺",
    	"追",
    	"堆",
    	"雄",
    	"迎",
    	"泛",
    	"爸",
    	"樓",
    	"避",
    	"謀",
    	"噸",
    	"野",
    	"豬",
    	"旗",
    	"累",
    	"偏",
    	"典",
    	"館",
    	"索",
    	"秦",
    	"脂",
    	"潮",
    	"爺",
    	"豆",
    	"忽",
    	"托",
    	"驚",
    	"塑",
    	"遺",
    	"愈",
    	"朱",
    	"替",
    	"纖",
    	"粗",
    	"傾",
    	"尚",
    	"痛",
    	"楚",
    	"謝",
    	"奮",
    	"購",
    	"磨",
    	"君",
    	"池",
    	"旁",
    	"碎",
    	"骨",
    	"監",
    	"捕",
    	"弟",
    	"暴",
    	"割",
    	"貫",
    	"殊",
    	"釋",
    	"詞",
    	"亡",
    	"壁",
    	"頓",
    	"寶",
    	"午",
    	"塵",
    	"聞",
    	"揭",
    	"炮",
    	"殘",
    	"冬",
    	"橋",
    	"婦",
    	"警",
    	"綜",
    	"招",
    	"吳",
    	"付",
    	"浮",
    	"遭",
    	"徐",
    	"您",
    	"搖",
    	"谷",
    	"贊",
    	"箱",
    	"隔",
    	"訂",
    	"男",
    	"吹",
    	"園",
    	"紛",
    	"唐",
    	"敗",
    	"宋",
    	"玻",
    	"巨",
    	"耕",
    	"坦",
    	"榮",
    	"閉",
    	"灣",
    	"鍵",
    	"凡",
    	"駐",
    	"鍋",
    	"救",
    	"恩",
    	"剝",
    	"凝",
    	"鹼",
    	"齒",
    	"截",
    	"煉",
    	"麻",
    	"紡",
    	"禁",
    	"廢",
    	"盛",
    	"版",
    	"緩",
    	"淨",
    	"睛",
    	"昌",
    	"婚",
    	"涉",
    	"筒",
    	"嘴",
    	"插",
    	"岸",
    	"朗",
    	"莊",
    	"街",
    	"藏",
    	"姑",
    	"貿",
    	"腐",
    	"奴",
    	"啦",
    	"慣",
    	"乘",
    	"夥",
    	"恢",
    	"勻",
    	"紗",
    	"扎",
    	"辯",
    	"耳",
    	"彪",
    	"臣",
    	"億",
    	"璃",
    	"抵",
    	"脈",
    	"秀",
    	"薩",
    	"俄",
    	"網",
    	"舞",
    	"店",
    	"噴",
    	"縱",
    	"寸",
    	"汗",
    	"掛",
    	"洪",
    	"賀",
    	"閃",
    	"柬",
    	"爆",
    	"烯",
    	"津",
    	"稻",
    	"牆",
    	"軟",
    	"勇",
    	"像",
    	"滾",
    	"厘",
    	"蒙",
    	"芳",
    	"肯",
    	"坡",
    	"柱",
    	"盪",
    	"腿",
    	"儀",
    	"旅",
    	"尾",
    	"軋",
    	"冰",
    	"貢",
    	"登",
    	"黎",
    	"削",
    	"鑽",
    	"勒",
    	"逃",
    	"障",
    	"氨",
    	"郭",
    	"峰",
    	"幣",
    	"港",
    	"伏",
    	"軌",
    	"畝",
    	"畢",
    	"擦",
    	"莫",
    	"刺",
    	"浪",
    	"秘",
    	"援",
    	"株",
    	"健",
    	"售",
    	"股",
    	"島",
    	"甘",
    	"泡",
    	"睡",
    	"童",
    	"鑄",
    	"湯",
    	"閥",
    	"休",
    	"匯",
    	"舍",
    	"牧",
    	"繞",
    	"炸",
    	"哲",
    	"磷",
    	"績",
    	"朋",
    	"淡",
    	"尖",
    	"啟",
    	"陷",
    	"柴",
    	"呈",
    	"徒",
    	"顏",
    	"淚",
    	"稍",
    	"忘",
    	"泵",
    	"藍",
    	"拖",
    	"洞",
    	"授",
    	"鏡",
    	"辛",
    	"壯",
    	"鋒",
    	"貧",
    	"虛",
    	"彎",
    	"摩",
    	"泰",
    	"幼",
    	"廷",
    	"尊",
    	"窗",
    	"綱",
    	"弄",
    	"隸",
    	"疑",
    	"氏",
    	"宮",
    	"姐",
    	"震",
    	"瑞",
    	"怪",
    	"尤",
    	"琴",
    	"循",
    	"描",
    	"膜",
    	"違",
    	"夾",
    	"腰",
    	"緣",
    	"珠",
    	"窮",
    	"森",
    	"枝",
    	"竹",
    	"溝",
    	"催",
    	"繩",
    	"憶",
    	"邦",
    	"剩",
    	"幸",
    	"漿",
    	"欄",
    	"擁",
    	"牙",
    	"貯",
    	"禮",
    	"濾",
    	"鈉",
    	"紋",
    	"罷",
    	"拍",
    	"咱",
    	"喊",
    	"袖",
    	"埃",
    	"勤",
    	"罰",
    	"焦",
    	"潛",
    	"伍",
    	"墨",
    	"欲",
    	"縫",
    	"姓",
    	"刊",
    	"飽",
    	"仿",
    	"獎",
    	"鋁",
    	"鬼",
    	"麗",
    	"跨",
    	"默",
    	"挖",
    	"鏈",
    	"掃",
    	"喝",
    	"袋",
    	"炭",
    	"污",
    	"幕",
    	"諸",
    	"弧",
    	"勵",
    	"梅",
    	"奶",
    	"潔",
    	"災",
    	"舟",
    	"鑑",
    	"苯",
    	"訟",
    	"抱",
    	"毀",
    	"懂",
    	"寒",
    	"智",
    	"埔",
    	"寄",
    	"屆",
    	"躍",
    	"渡",
    	"挑",
    	"丹",
    	"艱",
    	"貝",
    	"碰",
    	"拔",
    	"爹",
    	"戴",
    	"碼",
    	"夢",
    	"芽",
    	"熔",
    	"赤",
    	"漁",
    	"哭",
    	"敬",
    	"顆",
    	"奔",
    	"鉛",
    	"仲",
    	"虎",
    	"稀",
    	"妹",
    	"乏",
    	"珍",
    	"申",
    	"桌",
    	"遵",
    	"允",
    	"隆",
    	"螺",
    	"倉",
    	"魏",
    	"銳",
    	"曉",
    	"氮",
    	"兼",
    	"隱",
    	"礙",
    	"赫",
    	"撥",
    	"忠",
    	"肅",
    	"缸",
    	"牽",
    	"搶",
    	"博",
    	"巧",
    	"殼",
    	"兄",
    	"杜",
    	"訊",
    	"誠",
    	"碧",
    	"祥",
    	"柯",
    	"頁",
    	"巡",
    	"矩",
    	"悲",
    	"灌",
    	"齡",
    	"倫",
    	"票",
    	"尋",
    	"桂",
    	"鋪",
    	"聖",
    	"恐",
    	"恰",
    	"鄭",
    	"趣",
    	"抬",
    	"荒",
    	"騰",
    	"貼",
    	"柔",
    	"滴",
    	"猛",
    	"闊",
    	"輛",
    	"妻",
    	"填",
    	"撤",
    	"儲",
    	"簽",
    	"鬧",
    	"擾",
    	"紫",
    	"砂",
    	"遞",
    	"戲",
    	"吊",
    	"陶",
    	"伐",
    	"餵",
    	"療",
    	"瓶",
    	"婆",
    	"撫",
    	"臂",
    	"摸",
    	"忍",
    	"蝦",
    	"蠟",
    	"鄰",
    	"胸",
    	"鞏",
    	"擠",
    	"偶",
    	"棄",
    	"槽",
    	"勁",
    	"乳",
    	"鄧",
    	"吉",
    	"仁",
    	"爛",
    	"磚",
    	"租",
    	"烏",
    	"艦",
    	"伴",
    	"瓜",
    	"淺",
    	"丙",
    	"暫",
    	"燥",
    	"橡",
    	"柳",
    	"迷",
    	"暖",
    	"牌",
    	"秧",
    	"膽",
    	"詳",
    	"簧",
    	"踏",
    	"瓷",
    	"譜",
    	"呆",
    	"賓",
    	"糊",
    	"洛",
    	"輝",
    	"憤",
    	"競",
    	"隙",
    	"怒",
    	"粘",
    	"乃",
    	"緒",
    	"肩",
    	"籍",
    	"敏",
    	"塗",
    	"熙",
    	"皆",
    	"偵",
    	"懸",
    	"掘",
    	"享",
    	"糾",
    	"醒",
    	"狂",
    	"鎖",
    	"淀",
    	"恨",
    	"牲",
    	"霸",
    	"爬",
    	"賞",
    	"逆",
    	"玩",
    	"陵",
    	"祝",
    	"秒",
    	"浙",
    	"貌",
    	"役",
    	"彼",
    	"悉",
    	"鴨",
    	"趨",
    	"鳳",
    	"晨",
    	"畜",
    	"輩",
    	"秩",
    	"卵",
    	"署",
    	"梯",
    	"炎",
    	"灘",
    	"棋",
    	"驅",
    	"篩",
    	"峽",
    	"冒",
    	"啥",
    	"壽",
    	"譯",
    	"浸",
    	"泉",
    	"帽",
    	"遲",
    	"矽",
    	"疆",
    	"貸",
    	"漏",
    	"稿",
    	"冠",
    	"嫩",
    	"脅",
    	"芯",
    	"牢",
    	"叛",
    	"蝕",
    	"奧",
    	"鳴",
    	"嶺",
    	"羊",
    	"憑",
    	"串",
    	"塘",
    	"繪",
    	"酵",
    	"融",
    	"盆",
    	"錫",
    	"廟",
    	"籌",
    	"凍",
    	"輔",
    	"攝",
    	"襲",
    	"筋",
    	"拒",
    	"僚",
    	"旱",
    	"鉀",
    	"鳥",
    	"漆",
    	"沈",
    	"眉",
    	"疏",
    	"添",
    	"棒",
    	"穗",
    	"硝",
    	"韓",
    	"逼",
    	"扭",
    	"僑",
    	"涼",
    	"挺",
    	"碗",
    	"栽",
    	"炒",
    	"杯",
    	"患",
    	"餾",
    	"勸",
    	"豪",
    	"遼",
    	"勃",
    	"鴻",
    	"旦",
    	"吏",
    	"拜",
    	"狗",
    	"埋",
    	"輥",
    	"掩",
    	"飲",
    	"搬",
    	"罵",
    	"辭",
    	"勾",
    	"扣",
    	"估",
    	"蔣",
    	"絨",
    	"霧",
    	"丈",
    	"朵",
    	"姆",
    	"擬",
    	"宇",
    	"輯",
    	"陝",
    	"雕",
    	"償",
    	"蓄",
    	"崇",
    	"剪",
    	"倡",
    	"廳",
    	"咬",
    	"駛",
    	"薯",
    	"刷",
    	"斥",
    	"番",
    	"賦",
    	"奉",
    	"佛",
    	"澆",
    	"漫",
    	"曼",
    	"扇",
    	"鈣",
    	"桃",
    	"扶",
    	"仔",
    	"返",
    	"俗",
    	"虧",
    	"腔",
    	"鞋",
    	"棱",
    	"覆",
    	"框",
    	"悄",
    	"叔",
    	"撞",
    	"騙",
    	"勘",
    	"旺",
    	"沸",
    	"孤",
    	"吐",
    	"孟",
    	"渠",
    	"屈",
    	"疾",
    	"妙",
    	"惜",
    	"仰",
    	"狠",
    	"脹",
    	"諧",
    	"拋",
    	"黴",
    	"桑",
    	"崗",
    	"嘛",
    	"衰",
    	"盜",
    	"滲",
    	"臟",
    	"賴",
    	"湧",
    	"甜",
    	"曹",
    	"閱",
    	"肌",
    	"哩",
    	"厲",
    	"烴",
    	"緯",
    	"毅",
    	"昨",
    	"偽",
    	"症",
    	"煮",
    	"嘆",
    	"釘",
    	"搭",
    	"莖",
    	"籠",
    	"酷",
    	"偷",
    	"弓",
    	"錐",
    	"恆",
    	"傑",
    	"坑",
    	"鼻",
    	"翼",
    	"綸",
    	"敘",
    	"獄",
    	"逮",
    	"罐",
    	"絡",
    	"棚",
    	"抑",
    	"膨",
    	"蔬",
    	"寺",
    	"驟",
    	"穆",
    	"冶",
    	"枯",
    	"冊",
    	"屍",
    	"凸",
    	"紳",
    	"坯",
    	"犧",
    	"焰",
    	"轟",
    	"欣",
    	"晉",
    	"瘦",
    	"禦",
    	"錠",
    	"錦",
    	"喪",
    	"旬",
    	"鍛",
    	"壟",
    	"搜",
    	"撲",
    	"邀",
    	"亭",
    	"酯",
    	"邁",
    	"舒",
    	"脆",
    	"酶",
    	"閒",
    	"憂",
    	"酚",
    	"頑",
    	"羽",
    	"漲",
    	"卸",
    	"仗",
    	"陪",
    	"闢",
    	"懲",
    	"杭",
    	"姚",
    	"肚",
    	"捉",
    	"飄",
    	"漂",
    	"昆",
    	"欺",
    	"吾",
    	"郎",
    	"烷",
    	"汁",
    	"呵",
    	"飾",
    	"蕭",
    	"雅",
    	"郵",
    	"遷",
    	"燕",
    	"撒",
    	"姻",
    	"赴",
    	"宴",
    	"煩",
    	"債",
    	"帳",
    	"斑",
    	"鈴",
    	"旨",
    	"醇",
    	"董",
    	"餅",
    	"雛",
    	"姿",
    	"拌",
    	"傅",
    	"腹",
    	"妥",
    	"揉",
    	"賢",
    	"拆",
    	"歪",
    	"葡",
    	"胺",
    	"丟",
    	"浩",
    	"徽",
    	"昂",
    	"墊",
    	"擋",
    	"覽",
    	"貪",
    	"慰",
    	"繳",
    	"汪",
    	"慌",
    	"馮",
    	"諾",
    	"姜",
    	"誼",
    	"兇",
    	"劣",
    	"誣",
    	"耀",
    	"昏",
    	"躺",
    	"盈",
    	"騎",
    	"喬",
    	"溪",
    	"叢",
    	"盧",
    	"抹",
    	"悶",
    	"諮",
    	"刮",
    	"駕",
    	"纜",
    	"悟",
    	"摘",
    	"鉺",
    	"擲",
    	"頗",
    	"幻",
    	"柄",
    	"惠",
    	"慘",
    	"佳",
    	"仇",
    	"臘",
    	"窩",
    	"滌",
    	"劍",
    	"瞧",
    	"堡",
    	"潑",
    	"蔥",
    	"罩",
    	"霍",
    	"撈",
    	"胎",
    	"蒼",
    	"濱",
    	"倆",
    	"捅",
    	"湘",
    	"砍",
    	"霞",
    	"邵",
    	"萄",
    	"瘋",
    	"淮",
    	"遂",
    	"熊",
    	"糞",
    	"烘",
    	"宿",
    	"檔",
    	"戈",
    	"駁",
    	"嫂",
    	"裕",
    	"徙",
    	"箭",
    	"捐",
    	"腸",
    	"撐",
    	"曬",
    	"辨",
    	"殿",
    	"蓮",
    	"攤",
    	"攪",
    	"醬",
    	"屏",
    	"疫",
    	"哀",
    	"蔡",
    	"堵",
    	"沫",
    	"皺",
    	"暢",
    	"疊",
    	"閣",
    	"萊",
    	"敲",
    	"轄",
    	"鉤",
    	"痕",
    	"壩",
    	"巷",
    	"餓",
    	"禍",
    	"丘",
    	"玄",
    	"溜",
    	"曰",
    	"邏",
    	"彭",
    	"嘗",
    	"卿",
    	"妨",
    	"艇",
    	"吞",
    	"韋",
    	"怨",
    	"矮",
    	"歇"
    ];

    var require$$7 = [
    	"abandon",
    	"ability",
    	"able",
    	"about",
    	"above",
    	"absent",
    	"absorb",
    	"abstract",
    	"absurd",
    	"abuse",
    	"access",
    	"accident",
    	"account",
    	"accuse",
    	"achieve",
    	"acid",
    	"acoustic",
    	"acquire",
    	"across",
    	"act",
    	"action",
    	"actor",
    	"actress",
    	"actual",
    	"adapt",
    	"add",
    	"addict",
    	"address",
    	"adjust",
    	"admit",
    	"adult",
    	"advance",
    	"advice",
    	"aerobic",
    	"affair",
    	"afford",
    	"afraid",
    	"again",
    	"age",
    	"agent",
    	"agree",
    	"ahead",
    	"aim",
    	"air",
    	"airport",
    	"aisle",
    	"alarm",
    	"album",
    	"alcohol",
    	"alert",
    	"alien",
    	"all",
    	"alley",
    	"allow",
    	"almost",
    	"alone",
    	"alpha",
    	"already",
    	"also",
    	"alter",
    	"always",
    	"amateur",
    	"amazing",
    	"among",
    	"amount",
    	"amused",
    	"analyst",
    	"anchor",
    	"ancient",
    	"anger",
    	"angle",
    	"angry",
    	"animal",
    	"ankle",
    	"announce",
    	"annual",
    	"another",
    	"answer",
    	"antenna",
    	"antique",
    	"anxiety",
    	"any",
    	"apart",
    	"apology",
    	"appear",
    	"apple",
    	"approve",
    	"april",
    	"arch",
    	"arctic",
    	"area",
    	"arena",
    	"argue",
    	"arm",
    	"armed",
    	"armor",
    	"army",
    	"around",
    	"arrange",
    	"arrest",
    	"arrive",
    	"arrow",
    	"art",
    	"artefact",
    	"artist",
    	"artwork",
    	"ask",
    	"aspect",
    	"assault",
    	"asset",
    	"assist",
    	"assume",
    	"asthma",
    	"athlete",
    	"atom",
    	"attack",
    	"attend",
    	"attitude",
    	"attract",
    	"auction",
    	"audit",
    	"august",
    	"aunt",
    	"author",
    	"auto",
    	"autumn",
    	"average",
    	"avocado",
    	"avoid",
    	"awake",
    	"aware",
    	"away",
    	"awesome",
    	"awful",
    	"awkward",
    	"axis",
    	"baby",
    	"bachelor",
    	"bacon",
    	"badge",
    	"bag",
    	"balance",
    	"balcony",
    	"ball",
    	"bamboo",
    	"banana",
    	"banner",
    	"bar",
    	"barely",
    	"bargain",
    	"barrel",
    	"base",
    	"basic",
    	"basket",
    	"battle",
    	"beach",
    	"bean",
    	"beauty",
    	"because",
    	"become",
    	"beef",
    	"before",
    	"begin",
    	"behave",
    	"behind",
    	"believe",
    	"below",
    	"belt",
    	"bench",
    	"benefit",
    	"best",
    	"betray",
    	"better",
    	"between",
    	"beyond",
    	"bicycle",
    	"bid",
    	"bike",
    	"bind",
    	"biology",
    	"bird",
    	"birth",
    	"bitter",
    	"black",
    	"blade",
    	"blame",
    	"blanket",
    	"blast",
    	"bleak",
    	"bless",
    	"blind",
    	"blood",
    	"blossom",
    	"blouse",
    	"blue",
    	"blur",
    	"blush",
    	"board",
    	"boat",
    	"body",
    	"boil",
    	"bomb",
    	"bone",
    	"bonus",
    	"book",
    	"boost",
    	"border",
    	"boring",
    	"borrow",
    	"boss",
    	"bottom",
    	"bounce",
    	"box",
    	"boy",
    	"bracket",
    	"brain",
    	"brand",
    	"brass",
    	"brave",
    	"bread",
    	"breeze",
    	"brick",
    	"bridge",
    	"brief",
    	"bright",
    	"bring",
    	"brisk",
    	"broccoli",
    	"broken",
    	"bronze",
    	"broom",
    	"brother",
    	"brown",
    	"brush",
    	"bubble",
    	"buddy",
    	"budget",
    	"buffalo",
    	"build",
    	"bulb",
    	"bulk",
    	"bullet",
    	"bundle",
    	"bunker",
    	"burden",
    	"burger",
    	"burst",
    	"bus",
    	"business",
    	"busy",
    	"butter",
    	"buyer",
    	"buzz",
    	"cabbage",
    	"cabin",
    	"cable",
    	"cactus",
    	"cage",
    	"cake",
    	"call",
    	"calm",
    	"camera",
    	"camp",
    	"can",
    	"canal",
    	"cancel",
    	"candy",
    	"cannon",
    	"canoe",
    	"canvas",
    	"canyon",
    	"capable",
    	"capital",
    	"captain",
    	"car",
    	"carbon",
    	"card",
    	"cargo",
    	"carpet",
    	"carry",
    	"cart",
    	"case",
    	"cash",
    	"casino",
    	"castle",
    	"casual",
    	"cat",
    	"catalog",
    	"catch",
    	"category",
    	"cattle",
    	"caught",
    	"cause",
    	"caution",
    	"cave",
    	"ceiling",
    	"celery",
    	"cement",
    	"census",
    	"century",
    	"cereal",
    	"certain",
    	"chair",
    	"chalk",
    	"champion",
    	"change",
    	"chaos",
    	"chapter",
    	"charge",
    	"chase",
    	"chat",
    	"cheap",
    	"check",
    	"cheese",
    	"chef",
    	"cherry",
    	"chest",
    	"chicken",
    	"chief",
    	"child",
    	"chimney",
    	"choice",
    	"choose",
    	"chronic",
    	"chuckle",
    	"chunk",
    	"churn",
    	"cigar",
    	"cinnamon",
    	"circle",
    	"citizen",
    	"city",
    	"civil",
    	"claim",
    	"clap",
    	"clarify",
    	"claw",
    	"clay",
    	"clean",
    	"clerk",
    	"clever",
    	"click",
    	"client",
    	"cliff",
    	"climb",
    	"clinic",
    	"clip",
    	"clock",
    	"clog",
    	"close",
    	"cloth",
    	"cloud",
    	"clown",
    	"club",
    	"clump",
    	"cluster",
    	"clutch",
    	"coach",
    	"coast",
    	"coconut",
    	"code",
    	"coffee",
    	"coil",
    	"coin",
    	"collect",
    	"color",
    	"column",
    	"combine",
    	"come",
    	"comfort",
    	"comic",
    	"common",
    	"company",
    	"concert",
    	"conduct",
    	"confirm",
    	"congress",
    	"connect",
    	"consider",
    	"control",
    	"convince",
    	"cook",
    	"cool",
    	"copper",
    	"copy",
    	"coral",
    	"core",
    	"corn",
    	"correct",
    	"cost",
    	"cotton",
    	"couch",
    	"country",
    	"couple",
    	"course",
    	"cousin",
    	"cover",
    	"coyote",
    	"crack",
    	"cradle",
    	"craft",
    	"cram",
    	"crane",
    	"crash",
    	"crater",
    	"crawl",
    	"crazy",
    	"cream",
    	"credit",
    	"creek",
    	"crew",
    	"cricket",
    	"crime",
    	"crisp",
    	"critic",
    	"crop",
    	"cross",
    	"crouch",
    	"crowd",
    	"crucial",
    	"cruel",
    	"cruise",
    	"crumble",
    	"crunch",
    	"crush",
    	"cry",
    	"crystal",
    	"cube",
    	"culture",
    	"cup",
    	"cupboard",
    	"curious",
    	"current",
    	"curtain",
    	"curve",
    	"cushion",
    	"custom",
    	"cute",
    	"cycle",
    	"dad",
    	"damage",
    	"damp",
    	"dance",
    	"danger",
    	"daring",
    	"dash",
    	"daughter",
    	"dawn",
    	"day",
    	"deal",
    	"debate",
    	"debris",
    	"decade",
    	"december",
    	"decide",
    	"decline",
    	"decorate",
    	"decrease",
    	"deer",
    	"defense",
    	"define",
    	"defy",
    	"degree",
    	"delay",
    	"deliver",
    	"demand",
    	"demise",
    	"denial",
    	"dentist",
    	"deny",
    	"depart",
    	"depend",
    	"deposit",
    	"depth",
    	"deputy",
    	"derive",
    	"describe",
    	"desert",
    	"design",
    	"desk",
    	"despair",
    	"destroy",
    	"detail",
    	"detect",
    	"develop",
    	"device",
    	"devote",
    	"diagram",
    	"dial",
    	"diamond",
    	"diary",
    	"dice",
    	"diesel",
    	"diet",
    	"differ",
    	"digital",
    	"dignity",
    	"dilemma",
    	"dinner",
    	"dinosaur",
    	"direct",
    	"dirt",
    	"disagree",
    	"discover",
    	"disease",
    	"dish",
    	"dismiss",
    	"disorder",
    	"display",
    	"distance",
    	"divert",
    	"divide",
    	"divorce",
    	"dizzy",
    	"doctor",
    	"document",
    	"dog",
    	"doll",
    	"dolphin",
    	"domain",
    	"donate",
    	"donkey",
    	"donor",
    	"door",
    	"dose",
    	"double",
    	"dove",
    	"draft",
    	"dragon",
    	"drama",
    	"drastic",
    	"draw",
    	"dream",
    	"dress",
    	"drift",
    	"drill",
    	"drink",
    	"drip",
    	"drive",
    	"drop",
    	"drum",
    	"dry",
    	"duck",
    	"dumb",
    	"dune",
    	"during",
    	"dust",
    	"dutch",
    	"duty",
    	"dwarf",
    	"dynamic",
    	"eager",
    	"eagle",
    	"early",
    	"earn",
    	"earth",
    	"easily",
    	"east",
    	"easy",
    	"echo",
    	"ecology",
    	"economy",
    	"edge",
    	"edit",
    	"educate",
    	"effort",
    	"egg",
    	"eight",
    	"either",
    	"elbow",
    	"elder",
    	"electric",
    	"elegant",
    	"element",
    	"elephant",
    	"elevator",
    	"elite",
    	"else",
    	"embark",
    	"embody",
    	"embrace",
    	"emerge",
    	"emotion",
    	"employ",
    	"empower",
    	"empty",
    	"enable",
    	"enact",
    	"end",
    	"endless",
    	"endorse",
    	"enemy",
    	"energy",
    	"enforce",
    	"engage",
    	"engine",
    	"enhance",
    	"enjoy",
    	"enlist",
    	"enough",
    	"enrich",
    	"enroll",
    	"ensure",
    	"enter",
    	"entire",
    	"entry",
    	"envelope",
    	"episode",
    	"equal",
    	"equip",
    	"era",
    	"erase",
    	"erode",
    	"erosion",
    	"error",
    	"erupt",
    	"escape",
    	"essay",
    	"essence",
    	"estate",
    	"eternal",
    	"ethics",
    	"evidence",
    	"evil",
    	"evoke",
    	"evolve",
    	"exact",
    	"example",
    	"excess",
    	"exchange",
    	"excite",
    	"exclude",
    	"excuse",
    	"execute",
    	"exercise",
    	"exhaust",
    	"exhibit",
    	"exile",
    	"exist",
    	"exit",
    	"exotic",
    	"expand",
    	"expect",
    	"expire",
    	"explain",
    	"expose",
    	"express",
    	"extend",
    	"extra",
    	"eye",
    	"eyebrow",
    	"fabric",
    	"face",
    	"faculty",
    	"fade",
    	"faint",
    	"faith",
    	"fall",
    	"false",
    	"fame",
    	"family",
    	"famous",
    	"fan",
    	"fancy",
    	"fantasy",
    	"farm",
    	"fashion",
    	"fat",
    	"fatal",
    	"father",
    	"fatigue",
    	"fault",
    	"favorite",
    	"feature",
    	"february",
    	"federal",
    	"fee",
    	"feed",
    	"feel",
    	"female",
    	"fence",
    	"festival",
    	"fetch",
    	"fever",
    	"few",
    	"fiber",
    	"fiction",
    	"field",
    	"figure",
    	"file",
    	"film",
    	"filter",
    	"final",
    	"find",
    	"fine",
    	"finger",
    	"finish",
    	"fire",
    	"firm",
    	"first",
    	"fiscal",
    	"fish",
    	"fit",
    	"fitness",
    	"fix",
    	"flag",
    	"flame",
    	"flash",
    	"flat",
    	"flavor",
    	"flee",
    	"flight",
    	"flip",
    	"float",
    	"flock",
    	"floor",
    	"flower",
    	"fluid",
    	"flush",
    	"fly",
    	"foam",
    	"focus",
    	"fog",
    	"foil",
    	"fold",
    	"follow",
    	"food",
    	"foot",
    	"force",
    	"forest",
    	"forget",
    	"fork",
    	"fortune",
    	"forum",
    	"forward",
    	"fossil",
    	"foster",
    	"found",
    	"fox",
    	"fragile",
    	"frame",
    	"frequent",
    	"fresh",
    	"friend",
    	"fringe",
    	"frog",
    	"front",
    	"frost",
    	"frown",
    	"frozen",
    	"fruit",
    	"fuel",
    	"fun",
    	"funny",
    	"furnace",
    	"fury",
    	"future",
    	"gadget",
    	"gain",
    	"galaxy",
    	"gallery",
    	"game",
    	"gap",
    	"garage",
    	"garbage",
    	"garden",
    	"garlic",
    	"garment",
    	"gas",
    	"gasp",
    	"gate",
    	"gather",
    	"gauge",
    	"gaze",
    	"general",
    	"genius",
    	"genre",
    	"gentle",
    	"genuine",
    	"gesture",
    	"ghost",
    	"giant",
    	"gift",
    	"giggle",
    	"ginger",
    	"giraffe",
    	"girl",
    	"give",
    	"glad",
    	"glance",
    	"glare",
    	"glass",
    	"glide",
    	"glimpse",
    	"globe",
    	"gloom",
    	"glory",
    	"glove",
    	"glow",
    	"glue",
    	"goat",
    	"goddess",
    	"gold",
    	"good",
    	"goose",
    	"gorilla",
    	"gospel",
    	"gossip",
    	"govern",
    	"gown",
    	"grab",
    	"grace",
    	"grain",
    	"grant",
    	"grape",
    	"grass",
    	"gravity",
    	"great",
    	"green",
    	"grid",
    	"grief",
    	"grit",
    	"grocery",
    	"group",
    	"grow",
    	"grunt",
    	"guard",
    	"guess",
    	"guide",
    	"guilt",
    	"guitar",
    	"gun",
    	"gym",
    	"habit",
    	"hair",
    	"half",
    	"hammer",
    	"hamster",
    	"hand",
    	"happy",
    	"harbor",
    	"hard",
    	"harsh",
    	"harvest",
    	"hat",
    	"have",
    	"hawk",
    	"hazard",
    	"head",
    	"health",
    	"heart",
    	"heavy",
    	"hedgehog",
    	"height",
    	"hello",
    	"helmet",
    	"help",
    	"hen",
    	"hero",
    	"hidden",
    	"high",
    	"hill",
    	"hint",
    	"hip",
    	"hire",
    	"history",
    	"hobby",
    	"hockey",
    	"hold",
    	"hole",
    	"holiday",
    	"hollow",
    	"home",
    	"honey",
    	"hood",
    	"hope",
    	"horn",
    	"horror",
    	"horse",
    	"hospital",
    	"host",
    	"hotel",
    	"hour",
    	"hover",
    	"hub",
    	"huge",
    	"human",
    	"humble",
    	"humor",
    	"hundred",
    	"hungry",
    	"hunt",
    	"hurdle",
    	"hurry",
    	"hurt",
    	"husband",
    	"hybrid",
    	"ice",
    	"icon",
    	"idea",
    	"identify",
    	"idle",
    	"ignore",
    	"ill",
    	"illegal",
    	"illness",
    	"image",
    	"imitate",
    	"immense",
    	"immune",
    	"impact",
    	"impose",
    	"improve",
    	"impulse",
    	"inch",
    	"include",
    	"income",
    	"increase",
    	"index",
    	"indicate",
    	"indoor",
    	"industry",
    	"infant",
    	"inflict",
    	"inform",
    	"inhale",
    	"inherit",
    	"initial",
    	"inject",
    	"injury",
    	"inmate",
    	"inner",
    	"innocent",
    	"input",
    	"inquiry",
    	"insane",
    	"insect",
    	"inside",
    	"inspire",
    	"install",
    	"intact",
    	"interest",
    	"into",
    	"invest",
    	"invite",
    	"involve",
    	"iron",
    	"island",
    	"isolate",
    	"issue",
    	"item",
    	"ivory",
    	"jacket",
    	"jaguar",
    	"jar",
    	"jazz",
    	"jealous",
    	"jeans",
    	"jelly",
    	"jewel",
    	"job",
    	"join",
    	"joke",
    	"journey",
    	"joy",
    	"judge",
    	"juice",
    	"jump",
    	"jungle",
    	"junior",
    	"junk",
    	"just",
    	"kangaroo",
    	"keen",
    	"keep",
    	"ketchup",
    	"key",
    	"kick",
    	"kid",
    	"kidney",
    	"kind",
    	"kingdom",
    	"kiss",
    	"kit",
    	"kitchen",
    	"kite",
    	"kitten",
    	"kiwi",
    	"knee",
    	"knife",
    	"knock",
    	"know",
    	"lab",
    	"label",
    	"labor",
    	"ladder",
    	"lady",
    	"lake",
    	"lamp",
    	"language",
    	"laptop",
    	"large",
    	"later",
    	"latin",
    	"laugh",
    	"laundry",
    	"lava",
    	"law",
    	"lawn",
    	"lawsuit",
    	"layer",
    	"lazy",
    	"leader",
    	"leaf",
    	"learn",
    	"leave",
    	"lecture",
    	"left",
    	"leg",
    	"legal",
    	"legend",
    	"leisure",
    	"lemon",
    	"lend",
    	"length",
    	"lens",
    	"leopard",
    	"lesson",
    	"letter",
    	"level",
    	"liar",
    	"liberty",
    	"library",
    	"license",
    	"life",
    	"lift",
    	"light",
    	"like",
    	"limb",
    	"limit",
    	"link",
    	"lion",
    	"liquid",
    	"list",
    	"little",
    	"live",
    	"lizard",
    	"load",
    	"loan",
    	"lobster",
    	"local",
    	"lock",
    	"logic",
    	"lonely",
    	"long",
    	"loop",
    	"lottery",
    	"loud",
    	"lounge",
    	"love",
    	"loyal",
    	"lucky",
    	"luggage",
    	"lumber",
    	"lunar",
    	"lunch",
    	"luxury",
    	"lyrics",
    	"machine",
    	"mad",
    	"magic",
    	"magnet",
    	"maid",
    	"mail",
    	"main",
    	"major",
    	"make",
    	"mammal",
    	"man",
    	"manage",
    	"mandate",
    	"mango",
    	"mansion",
    	"manual",
    	"maple",
    	"marble",
    	"march",
    	"margin",
    	"marine",
    	"market",
    	"marriage",
    	"mask",
    	"mass",
    	"master",
    	"match",
    	"material",
    	"math",
    	"matrix",
    	"matter",
    	"maximum",
    	"maze",
    	"meadow",
    	"mean",
    	"measure",
    	"meat",
    	"mechanic",
    	"medal",
    	"media",
    	"melody",
    	"melt",
    	"member",
    	"memory",
    	"mention",
    	"menu",
    	"mercy",
    	"merge",
    	"merit",
    	"merry",
    	"mesh",
    	"message",
    	"metal",
    	"method",
    	"middle",
    	"midnight",
    	"milk",
    	"million",
    	"mimic",
    	"mind",
    	"minimum",
    	"minor",
    	"minute",
    	"miracle",
    	"mirror",
    	"misery",
    	"miss",
    	"mistake",
    	"mix",
    	"mixed",
    	"mixture",
    	"mobile",
    	"model",
    	"modify",
    	"mom",
    	"moment",
    	"monitor",
    	"monkey",
    	"monster",
    	"month",
    	"moon",
    	"moral",
    	"more",
    	"morning",
    	"mosquito",
    	"mother",
    	"motion",
    	"motor",
    	"mountain",
    	"mouse",
    	"move",
    	"movie",
    	"much",
    	"muffin",
    	"mule",
    	"multiply",
    	"muscle",
    	"museum",
    	"mushroom",
    	"music",
    	"must",
    	"mutual",
    	"myself",
    	"mystery",
    	"myth",
    	"naive",
    	"name",
    	"napkin",
    	"narrow",
    	"nasty",
    	"nation",
    	"nature",
    	"near",
    	"neck",
    	"need",
    	"negative",
    	"neglect",
    	"neither",
    	"nephew",
    	"nerve",
    	"nest",
    	"net",
    	"network",
    	"neutral",
    	"never",
    	"news",
    	"next",
    	"nice",
    	"night",
    	"noble",
    	"noise",
    	"nominee",
    	"noodle",
    	"normal",
    	"north",
    	"nose",
    	"notable",
    	"note",
    	"nothing",
    	"notice",
    	"novel",
    	"now",
    	"nuclear",
    	"number",
    	"nurse",
    	"nut",
    	"oak",
    	"obey",
    	"object",
    	"oblige",
    	"obscure",
    	"observe",
    	"obtain",
    	"obvious",
    	"occur",
    	"ocean",
    	"october",
    	"odor",
    	"off",
    	"offer",
    	"office",
    	"often",
    	"oil",
    	"okay",
    	"old",
    	"olive",
    	"olympic",
    	"omit",
    	"once",
    	"one",
    	"onion",
    	"online",
    	"only",
    	"open",
    	"opera",
    	"opinion",
    	"oppose",
    	"option",
    	"orange",
    	"orbit",
    	"orchard",
    	"order",
    	"ordinary",
    	"organ",
    	"orient",
    	"original",
    	"orphan",
    	"ostrich",
    	"other",
    	"outdoor",
    	"outer",
    	"output",
    	"outside",
    	"oval",
    	"oven",
    	"over",
    	"own",
    	"owner",
    	"oxygen",
    	"oyster",
    	"ozone",
    	"pact",
    	"paddle",
    	"page",
    	"pair",
    	"palace",
    	"palm",
    	"panda",
    	"panel",
    	"panic",
    	"panther",
    	"paper",
    	"parade",
    	"parent",
    	"park",
    	"parrot",
    	"party",
    	"pass",
    	"patch",
    	"path",
    	"patient",
    	"patrol",
    	"pattern",
    	"pause",
    	"pave",
    	"payment",
    	"peace",
    	"peanut",
    	"pear",
    	"peasant",
    	"pelican",
    	"pen",
    	"penalty",
    	"pencil",
    	"people",
    	"pepper",
    	"perfect",
    	"permit",
    	"person",
    	"pet",
    	"phone",
    	"photo",
    	"phrase",
    	"physical",
    	"piano",
    	"picnic",
    	"picture",
    	"piece",
    	"pig",
    	"pigeon",
    	"pill",
    	"pilot",
    	"pink",
    	"pioneer",
    	"pipe",
    	"pistol",
    	"pitch",
    	"pizza",
    	"place",
    	"planet",
    	"plastic",
    	"plate",
    	"play",
    	"please",
    	"pledge",
    	"pluck",
    	"plug",
    	"plunge",
    	"poem",
    	"poet",
    	"point",
    	"polar",
    	"pole",
    	"police",
    	"pond",
    	"pony",
    	"pool",
    	"popular",
    	"portion",
    	"position",
    	"possible",
    	"post",
    	"potato",
    	"pottery",
    	"poverty",
    	"powder",
    	"power",
    	"practice",
    	"praise",
    	"predict",
    	"prefer",
    	"prepare",
    	"present",
    	"pretty",
    	"prevent",
    	"price",
    	"pride",
    	"primary",
    	"print",
    	"priority",
    	"prison",
    	"private",
    	"prize",
    	"problem",
    	"process",
    	"produce",
    	"profit",
    	"program",
    	"project",
    	"promote",
    	"proof",
    	"property",
    	"prosper",
    	"protect",
    	"proud",
    	"provide",
    	"public",
    	"pudding",
    	"pull",
    	"pulp",
    	"pulse",
    	"pumpkin",
    	"punch",
    	"pupil",
    	"puppy",
    	"purchase",
    	"purity",
    	"purpose",
    	"purse",
    	"push",
    	"put",
    	"puzzle",
    	"pyramid",
    	"quality",
    	"quantum",
    	"quarter",
    	"question",
    	"quick",
    	"quit",
    	"quiz",
    	"quote",
    	"rabbit",
    	"raccoon",
    	"race",
    	"rack",
    	"radar",
    	"radio",
    	"rail",
    	"rain",
    	"raise",
    	"rally",
    	"ramp",
    	"ranch",
    	"random",
    	"range",
    	"rapid",
    	"rare",
    	"rate",
    	"rather",
    	"raven",
    	"raw",
    	"razor",
    	"ready",
    	"real",
    	"reason",
    	"rebel",
    	"rebuild",
    	"recall",
    	"receive",
    	"recipe",
    	"record",
    	"recycle",
    	"reduce",
    	"reflect",
    	"reform",
    	"refuse",
    	"region",
    	"regret",
    	"regular",
    	"reject",
    	"relax",
    	"release",
    	"relief",
    	"rely",
    	"remain",
    	"remember",
    	"remind",
    	"remove",
    	"render",
    	"renew",
    	"rent",
    	"reopen",
    	"repair",
    	"repeat",
    	"replace",
    	"report",
    	"require",
    	"rescue",
    	"resemble",
    	"resist",
    	"resource",
    	"response",
    	"result",
    	"retire",
    	"retreat",
    	"return",
    	"reunion",
    	"reveal",
    	"review",
    	"reward",
    	"rhythm",
    	"rib",
    	"ribbon",
    	"rice",
    	"rich",
    	"ride",
    	"ridge",
    	"rifle",
    	"right",
    	"rigid",
    	"ring",
    	"riot",
    	"ripple",
    	"risk",
    	"ritual",
    	"rival",
    	"river",
    	"road",
    	"roast",
    	"robot",
    	"robust",
    	"rocket",
    	"romance",
    	"roof",
    	"rookie",
    	"room",
    	"rose",
    	"rotate",
    	"rough",
    	"round",
    	"route",
    	"royal",
    	"rubber",
    	"rude",
    	"rug",
    	"rule",
    	"run",
    	"runway",
    	"rural",
    	"sad",
    	"saddle",
    	"sadness",
    	"safe",
    	"sail",
    	"salad",
    	"salmon",
    	"salon",
    	"salt",
    	"salute",
    	"same",
    	"sample",
    	"sand",
    	"satisfy",
    	"satoshi",
    	"sauce",
    	"sausage",
    	"save",
    	"say",
    	"scale",
    	"scan",
    	"scare",
    	"scatter",
    	"scene",
    	"scheme",
    	"school",
    	"science",
    	"scissors",
    	"scorpion",
    	"scout",
    	"scrap",
    	"screen",
    	"script",
    	"scrub",
    	"sea",
    	"search",
    	"season",
    	"seat",
    	"second",
    	"secret",
    	"section",
    	"security",
    	"seed",
    	"seek",
    	"segment",
    	"select",
    	"sell",
    	"seminar",
    	"senior",
    	"sense",
    	"sentence",
    	"series",
    	"service",
    	"session",
    	"settle",
    	"setup",
    	"seven",
    	"shadow",
    	"shaft",
    	"shallow",
    	"share",
    	"shed",
    	"shell",
    	"sheriff",
    	"shield",
    	"shift",
    	"shine",
    	"ship",
    	"shiver",
    	"shock",
    	"shoe",
    	"shoot",
    	"shop",
    	"short",
    	"shoulder",
    	"shove",
    	"shrimp",
    	"shrug",
    	"shuffle",
    	"shy",
    	"sibling",
    	"sick",
    	"side",
    	"siege",
    	"sight",
    	"sign",
    	"silent",
    	"silk",
    	"silly",
    	"silver",
    	"similar",
    	"simple",
    	"since",
    	"sing",
    	"siren",
    	"sister",
    	"situate",
    	"six",
    	"size",
    	"skate",
    	"sketch",
    	"ski",
    	"skill",
    	"skin",
    	"skirt",
    	"skull",
    	"slab",
    	"slam",
    	"sleep",
    	"slender",
    	"slice",
    	"slide",
    	"slight",
    	"slim",
    	"slogan",
    	"slot",
    	"slow",
    	"slush",
    	"small",
    	"smart",
    	"smile",
    	"smoke",
    	"smooth",
    	"snack",
    	"snake",
    	"snap",
    	"sniff",
    	"snow",
    	"soap",
    	"soccer",
    	"social",
    	"sock",
    	"soda",
    	"soft",
    	"solar",
    	"soldier",
    	"solid",
    	"solution",
    	"solve",
    	"someone",
    	"song",
    	"soon",
    	"sorry",
    	"sort",
    	"soul",
    	"sound",
    	"soup",
    	"source",
    	"south",
    	"space",
    	"spare",
    	"spatial",
    	"spawn",
    	"speak",
    	"special",
    	"speed",
    	"spell",
    	"spend",
    	"sphere",
    	"spice",
    	"spider",
    	"spike",
    	"spin",
    	"spirit",
    	"split",
    	"spoil",
    	"sponsor",
    	"spoon",
    	"sport",
    	"spot",
    	"spray",
    	"spread",
    	"spring",
    	"spy",
    	"square",
    	"squeeze",
    	"squirrel",
    	"stable",
    	"stadium",
    	"staff",
    	"stage",
    	"stairs",
    	"stamp",
    	"stand",
    	"start",
    	"state",
    	"stay",
    	"steak",
    	"steel",
    	"stem",
    	"step",
    	"stereo",
    	"stick",
    	"still",
    	"sting",
    	"stock",
    	"stomach",
    	"stone",
    	"stool",
    	"story",
    	"stove",
    	"strategy",
    	"street",
    	"strike",
    	"strong",
    	"struggle",
    	"student",
    	"stuff",
    	"stumble",
    	"style",
    	"subject",
    	"submit",
    	"subway",
    	"success",
    	"such",
    	"sudden",
    	"suffer",
    	"sugar",
    	"suggest",
    	"suit",
    	"summer",
    	"sun",
    	"sunny",
    	"sunset",
    	"super",
    	"supply",
    	"supreme",
    	"sure",
    	"surface",
    	"surge",
    	"surprise",
    	"surround",
    	"survey",
    	"suspect",
    	"sustain",
    	"swallow",
    	"swamp",
    	"swap",
    	"swarm",
    	"swear",
    	"sweet",
    	"swift",
    	"swim",
    	"swing",
    	"switch",
    	"sword",
    	"symbol",
    	"symptom",
    	"syrup",
    	"system",
    	"table",
    	"tackle",
    	"tag",
    	"tail",
    	"talent",
    	"talk",
    	"tank",
    	"tape",
    	"target",
    	"task",
    	"taste",
    	"tattoo",
    	"taxi",
    	"teach",
    	"team",
    	"tell",
    	"ten",
    	"tenant",
    	"tennis",
    	"tent",
    	"term",
    	"test",
    	"text",
    	"thank",
    	"that",
    	"theme",
    	"then",
    	"theory",
    	"there",
    	"they",
    	"thing",
    	"this",
    	"thought",
    	"three",
    	"thrive",
    	"throw",
    	"thumb",
    	"thunder",
    	"ticket",
    	"tide",
    	"tiger",
    	"tilt",
    	"timber",
    	"time",
    	"tiny",
    	"tip",
    	"tired",
    	"tissue",
    	"title",
    	"toast",
    	"tobacco",
    	"today",
    	"toddler",
    	"toe",
    	"together",
    	"toilet",
    	"token",
    	"tomato",
    	"tomorrow",
    	"tone",
    	"tongue",
    	"tonight",
    	"tool",
    	"tooth",
    	"top",
    	"topic",
    	"topple",
    	"torch",
    	"tornado",
    	"tortoise",
    	"toss",
    	"total",
    	"tourist",
    	"toward",
    	"tower",
    	"town",
    	"toy",
    	"track",
    	"trade",
    	"traffic",
    	"tragic",
    	"train",
    	"transfer",
    	"trap",
    	"trash",
    	"travel",
    	"tray",
    	"treat",
    	"tree",
    	"trend",
    	"trial",
    	"tribe",
    	"trick",
    	"trigger",
    	"trim",
    	"trip",
    	"trophy",
    	"trouble",
    	"truck",
    	"true",
    	"truly",
    	"trumpet",
    	"trust",
    	"truth",
    	"try",
    	"tube",
    	"tuition",
    	"tumble",
    	"tuna",
    	"tunnel",
    	"turkey",
    	"turn",
    	"turtle",
    	"twelve",
    	"twenty",
    	"twice",
    	"twin",
    	"twist",
    	"two",
    	"type",
    	"typical",
    	"ugly",
    	"umbrella",
    	"unable",
    	"unaware",
    	"uncle",
    	"uncover",
    	"under",
    	"undo",
    	"unfair",
    	"unfold",
    	"unhappy",
    	"uniform",
    	"unique",
    	"unit",
    	"universe",
    	"unknown",
    	"unlock",
    	"until",
    	"unusual",
    	"unveil",
    	"update",
    	"upgrade",
    	"uphold",
    	"upon",
    	"upper",
    	"upset",
    	"urban",
    	"urge",
    	"usage",
    	"use",
    	"used",
    	"useful",
    	"useless",
    	"usual",
    	"utility",
    	"vacant",
    	"vacuum",
    	"vague",
    	"valid",
    	"valley",
    	"valve",
    	"van",
    	"vanish",
    	"vapor",
    	"various",
    	"vast",
    	"vault",
    	"vehicle",
    	"velvet",
    	"vendor",
    	"venture",
    	"venue",
    	"verb",
    	"verify",
    	"version",
    	"very",
    	"vessel",
    	"veteran",
    	"viable",
    	"vibrant",
    	"vicious",
    	"victory",
    	"video",
    	"view",
    	"village",
    	"vintage",
    	"violin",
    	"virtual",
    	"virus",
    	"visa",
    	"visit",
    	"visual",
    	"vital",
    	"vivid",
    	"vocal",
    	"voice",
    	"void",
    	"volcano",
    	"volume",
    	"vote",
    	"voyage",
    	"wage",
    	"wagon",
    	"wait",
    	"walk",
    	"wall",
    	"walnut",
    	"want",
    	"warfare",
    	"warm",
    	"warrior",
    	"wash",
    	"wasp",
    	"waste",
    	"water",
    	"wave",
    	"way",
    	"wealth",
    	"weapon",
    	"wear",
    	"weasel",
    	"weather",
    	"web",
    	"wedding",
    	"weekend",
    	"weird",
    	"welcome",
    	"west",
    	"wet",
    	"whale",
    	"what",
    	"wheat",
    	"wheel",
    	"when",
    	"where",
    	"whip",
    	"whisper",
    	"wide",
    	"width",
    	"wife",
    	"wild",
    	"will",
    	"win",
    	"window",
    	"wine",
    	"wing",
    	"wink",
    	"winner",
    	"winter",
    	"wire",
    	"wisdom",
    	"wise",
    	"wish",
    	"witness",
    	"wolf",
    	"woman",
    	"wonder",
    	"wood",
    	"wool",
    	"word",
    	"work",
    	"world",
    	"worry",
    	"worth",
    	"wrap",
    	"wreck",
    	"wrestle",
    	"wrist",
    	"write",
    	"wrong",
    	"yard",
    	"year",
    	"yellow",
    	"you",
    	"young",
    	"youth",
    	"zebra",
    	"zero",
    	"zone",
    	"zoo"
    ];

    var require$$8 = [
    	"abaisser",
    	"abandon",
    	"abdiquer",
    	"abeille",
    	"abolir",
    	"aborder",
    	"aboutir",
    	"aboyer",
    	"abrasif",
    	"abreuver",
    	"abriter",
    	"abroger",
    	"abrupt",
    	"absence",
    	"absolu",
    	"absurde",
    	"abusif",
    	"abyssal",
    	"académie",
    	"acajou",
    	"acarien",
    	"accabler",
    	"accepter",
    	"acclamer",
    	"accolade",
    	"accroche",
    	"accuser",
    	"acerbe",
    	"achat",
    	"acheter",
    	"aciduler",
    	"acier",
    	"acompte",
    	"acquérir",
    	"acronyme",
    	"acteur",
    	"actif",
    	"actuel",
    	"adepte",
    	"adéquat",
    	"adhésif",
    	"adjectif",
    	"adjuger",
    	"admettre",
    	"admirer",
    	"adopter",
    	"adorer",
    	"adoucir",
    	"adresse",
    	"adroit",
    	"adulte",
    	"adverbe",
    	"aérer",
    	"aéronef",
    	"affaire",
    	"affecter",
    	"affiche",
    	"affreux",
    	"affubler",
    	"agacer",
    	"agencer",
    	"agile",
    	"agiter",
    	"agrafer",
    	"agréable",
    	"agrume",
    	"aider",
    	"aiguille",
    	"ailier",
    	"aimable",
    	"aisance",
    	"ajouter",
    	"ajuster",
    	"alarmer",
    	"alchimie",
    	"alerte",
    	"algèbre",
    	"algue",
    	"aliéner",
    	"aliment",
    	"alléger",
    	"alliage",
    	"allouer",
    	"allumer",
    	"alourdir",
    	"alpaga",
    	"altesse",
    	"alvéole",
    	"amateur",
    	"ambigu",
    	"ambre",
    	"aménager",
    	"amertume",
    	"amidon",
    	"amiral",
    	"amorcer",
    	"amour",
    	"amovible",
    	"amphibie",
    	"ampleur",
    	"amusant",
    	"analyse",
    	"anaphore",
    	"anarchie",
    	"anatomie",
    	"ancien",
    	"anéantir",
    	"angle",
    	"angoisse",
    	"anguleux",
    	"animal",
    	"annexer",
    	"annonce",
    	"annuel",
    	"anodin",
    	"anomalie",
    	"anonyme",
    	"anormal",
    	"antenne",
    	"antidote",
    	"anxieux",
    	"apaiser",
    	"apéritif",
    	"aplanir",
    	"apologie",
    	"appareil",
    	"appeler",
    	"apporter",
    	"appuyer",
    	"aquarium",
    	"aqueduc",
    	"arbitre",
    	"arbuste",
    	"ardeur",
    	"ardoise",
    	"argent",
    	"arlequin",
    	"armature",
    	"armement",
    	"armoire",
    	"armure",
    	"arpenter",
    	"arracher",
    	"arriver",
    	"arroser",
    	"arsenic",
    	"artériel",
    	"article",
    	"aspect",
    	"asphalte",
    	"aspirer",
    	"assaut",
    	"asservir",
    	"assiette",
    	"associer",
    	"assurer",
    	"asticot",
    	"astre",
    	"astuce",
    	"atelier",
    	"atome",
    	"atrium",
    	"atroce",
    	"attaque",
    	"attentif",
    	"attirer",
    	"attraper",
    	"aubaine",
    	"auberge",
    	"audace",
    	"audible",
    	"augurer",
    	"aurore",
    	"automne",
    	"autruche",
    	"avaler",
    	"avancer",
    	"avarice",
    	"avenir",
    	"averse",
    	"aveugle",
    	"aviateur",
    	"avide",
    	"avion",
    	"aviser",
    	"avoine",
    	"avouer",
    	"avril",
    	"axial",
    	"axiome",
    	"badge",
    	"bafouer",
    	"bagage",
    	"baguette",
    	"baignade",
    	"balancer",
    	"balcon",
    	"baleine",
    	"balisage",
    	"bambin",
    	"bancaire",
    	"bandage",
    	"banlieue",
    	"bannière",
    	"banquier",
    	"barbier",
    	"baril",
    	"baron",
    	"barque",
    	"barrage",
    	"bassin",
    	"bastion",
    	"bataille",
    	"bateau",
    	"batterie",
    	"baudrier",
    	"bavarder",
    	"belette",
    	"bélier",
    	"belote",
    	"bénéfice",
    	"berceau",
    	"berger",
    	"berline",
    	"bermuda",
    	"besace",
    	"besogne",
    	"bétail",
    	"beurre",
    	"biberon",
    	"bicycle",
    	"bidule",
    	"bijou",
    	"bilan",
    	"bilingue",
    	"billard",
    	"binaire",
    	"biologie",
    	"biopsie",
    	"biotype",
    	"biscuit",
    	"bison",
    	"bistouri",
    	"bitume",
    	"bizarre",
    	"blafard",
    	"blague",
    	"blanchir",
    	"blessant",
    	"blinder",
    	"blond",
    	"bloquer",
    	"blouson",
    	"bobard",
    	"bobine",
    	"boire",
    	"boiser",
    	"bolide",
    	"bonbon",
    	"bondir",
    	"bonheur",
    	"bonifier",
    	"bonus",
    	"bordure",
    	"borne",
    	"botte",
    	"boucle",
    	"boueux",
    	"bougie",
    	"boulon",
    	"bouquin",
    	"bourse",
    	"boussole",
    	"boutique",
    	"boxeur",
    	"branche",
    	"brasier",
    	"brave",
    	"brebis",
    	"brèche",
    	"breuvage",
    	"bricoler",
    	"brigade",
    	"brillant",
    	"brioche",
    	"brique",
    	"brochure",
    	"broder",
    	"bronzer",
    	"brousse",
    	"broyeur",
    	"brume",
    	"brusque",
    	"brutal",
    	"bruyant",
    	"buffle",
    	"buisson",
    	"bulletin",
    	"bureau",
    	"burin",
    	"bustier",
    	"butiner",
    	"butoir",
    	"buvable",
    	"buvette",
    	"cabanon",
    	"cabine",
    	"cachette",
    	"cadeau",
    	"cadre",
    	"caféine",
    	"caillou",
    	"caisson",
    	"calculer",
    	"calepin",
    	"calibre",
    	"calmer",
    	"calomnie",
    	"calvaire",
    	"camarade",
    	"caméra",
    	"camion",
    	"campagne",
    	"canal",
    	"caneton",
    	"canon",
    	"cantine",
    	"canular",
    	"capable",
    	"caporal",
    	"caprice",
    	"capsule",
    	"capter",
    	"capuche",
    	"carabine",
    	"carbone",
    	"caresser",
    	"caribou",
    	"carnage",
    	"carotte",
    	"carreau",
    	"carton",
    	"cascade",
    	"casier",
    	"casque",
    	"cassure",
    	"causer",
    	"caution",
    	"cavalier",
    	"caverne",
    	"caviar",
    	"cédille",
    	"ceinture",
    	"céleste",
    	"cellule",
    	"cendrier",
    	"censurer",
    	"central",
    	"cercle",
    	"cérébral",
    	"cerise",
    	"cerner",
    	"cerveau",
    	"cesser",
    	"chagrin",
    	"chaise",
    	"chaleur",
    	"chambre",
    	"chance",
    	"chapitre",
    	"charbon",
    	"chasseur",
    	"chaton",
    	"chausson",
    	"chavirer",
    	"chemise",
    	"chenille",
    	"chéquier",
    	"chercher",
    	"cheval",
    	"chien",
    	"chiffre",
    	"chignon",
    	"chimère",
    	"chiot",
    	"chlorure",
    	"chocolat",
    	"choisir",
    	"chose",
    	"chouette",
    	"chrome",
    	"chute",
    	"cigare",
    	"cigogne",
    	"cimenter",
    	"cinéma",
    	"cintrer",
    	"circuler",
    	"cirer",
    	"cirque",
    	"citerne",
    	"citoyen",
    	"citron",
    	"civil",
    	"clairon",
    	"clameur",
    	"claquer",
    	"classe",
    	"clavier",
    	"client",
    	"cligner",
    	"climat",
    	"clivage",
    	"cloche",
    	"clonage",
    	"cloporte",
    	"cobalt",
    	"cobra",
    	"cocasse",
    	"cocotier",
    	"coder",
    	"codifier",
    	"coffre",
    	"cogner",
    	"cohésion",
    	"coiffer",
    	"coincer",
    	"colère",
    	"colibri",
    	"colline",
    	"colmater",
    	"colonel",
    	"combat",
    	"comédie",
    	"commande",
    	"compact",
    	"concert",
    	"conduire",
    	"confier",
    	"congeler",
    	"connoter",
    	"consonne",
    	"contact",
    	"convexe",
    	"copain",
    	"copie",
    	"corail",
    	"corbeau",
    	"cordage",
    	"corniche",
    	"corpus",
    	"correct",
    	"cortège",
    	"cosmique",
    	"costume",
    	"coton",
    	"coude",
    	"coupure",
    	"courage",
    	"couteau",
    	"couvrir",
    	"coyote",
    	"crabe",
    	"crainte",
    	"cravate",
    	"crayon",
    	"créature",
    	"créditer",
    	"crémeux",
    	"creuser",
    	"crevette",
    	"cribler",
    	"crier",
    	"cristal",
    	"critère",
    	"croire",
    	"croquer",
    	"crotale",
    	"crucial",
    	"cruel",
    	"crypter",
    	"cubique",
    	"cueillir",
    	"cuillère",
    	"cuisine",
    	"cuivre",
    	"culminer",
    	"cultiver",
    	"cumuler",
    	"cupide",
    	"curatif",
    	"curseur",
    	"cyanure",
    	"cycle",
    	"cylindre",
    	"cynique",
    	"daigner",
    	"damier",
    	"danger",
    	"danseur",
    	"dauphin",
    	"débattre",
    	"débiter",
    	"déborder",
    	"débrider",
    	"débutant",
    	"décaler",
    	"décembre",
    	"déchirer",
    	"décider",
    	"déclarer",
    	"décorer",
    	"décrire",
    	"décupler",
    	"dédale",
    	"déductif",
    	"déesse",
    	"défensif",
    	"défiler",
    	"défrayer",
    	"dégager",
    	"dégivrer",
    	"déglutir",
    	"dégrafer",
    	"déjeuner",
    	"délice",
    	"déloger",
    	"demander",
    	"demeurer",
    	"démolir",
    	"dénicher",
    	"dénouer",
    	"dentelle",
    	"dénuder",
    	"départ",
    	"dépenser",
    	"déphaser",
    	"déplacer",
    	"déposer",
    	"déranger",
    	"dérober",
    	"désastre",
    	"descente",
    	"désert",
    	"désigner",
    	"désobéir",
    	"dessiner",
    	"destrier",
    	"détacher",
    	"détester",
    	"détourer",
    	"détresse",
    	"devancer",
    	"devenir",
    	"deviner",
    	"devoir",
    	"diable",
    	"dialogue",
    	"diamant",
    	"dicter",
    	"différer",
    	"digérer",
    	"digital",
    	"digne",
    	"diluer",
    	"dimanche",
    	"diminuer",
    	"dioxyde",
    	"directif",
    	"diriger",
    	"discuter",
    	"disposer",
    	"dissiper",
    	"distance",
    	"divertir",
    	"diviser",
    	"docile",
    	"docteur",
    	"dogme",
    	"doigt",
    	"domaine",
    	"domicile",
    	"dompter",
    	"donateur",
    	"donjon",
    	"donner",
    	"dopamine",
    	"dortoir",
    	"dorure",
    	"dosage",
    	"doseur",
    	"dossier",
    	"dotation",
    	"douanier",
    	"double",
    	"douceur",
    	"douter",
    	"doyen",
    	"dragon",
    	"draper",
    	"dresser",
    	"dribbler",
    	"droiture",
    	"duperie",
    	"duplexe",
    	"durable",
    	"durcir",
    	"dynastie",
    	"éblouir",
    	"écarter",
    	"écharpe",
    	"échelle",
    	"éclairer",
    	"éclipse",
    	"éclore",
    	"écluse",
    	"école",
    	"économie",
    	"écorce",
    	"écouter",
    	"écraser",
    	"écrémer",
    	"écrivain",
    	"écrou",
    	"écume",
    	"écureuil",
    	"édifier",
    	"éduquer",
    	"effacer",
    	"effectif",
    	"effigie",
    	"effort",
    	"effrayer",
    	"effusion",
    	"égaliser",
    	"égarer",
    	"éjecter",
    	"élaborer",
    	"élargir",
    	"électron",
    	"élégant",
    	"éléphant",
    	"élève",
    	"éligible",
    	"élitisme",
    	"éloge",
    	"élucider",
    	"éluder",
    	"emballer",
    	"embellir",
    	"embryon",
    	"émeraude",
    	"émission",
    	"emmener",
    	"émotion",
    	"émouvoir",
    	"empereur",
    	"employer",
    	"emporter",
    	"emprise",
    	"émulsion",
    	"encadrer",
    	"enchère",
    	"enclave",
    	"encoche",
    	"endiguer",
    	"endosser",
    	"endroit",
    	"enduire",
    	"énergie",
    	"enfance",
    	"enfermer",
    	"enfouir",
    	"engager",
    	"engin",
    	"englober",
    	"énigme",
    	"enjamber",
    	"enjeu",
    	"enlever",
    	"ennemi",
    	"ennuyeux",
    	"enrichir",
    	"enrobage",
    	"enseigne",
    	"entasser",
    	"entendre",
    	"entier",
    	"entourer",
    	"entraver",
    	"énumérer",
    	"envahir",
    	"enviable",
    	"envoyer",
    	"enzyme",
    	"éolien",
    	"épaissir",
    	"épargne",
    	"épatant",
    	"épaule",
    	"épicerie",
    	"épidémie",
    	"épier",
    	"épilogue",
    	"épine",
    	"épisode",
    	"épitaphe",
    	"époque",
    	"épreuve",
    	"éprouver",
    	"épuisant",
    	"équerre",
    	"équipe",
    	"ériger",
    	"érosion",
    	"erreur",
    	"éruption",
    	"escalier",
    	"espadon",
    	"espèce",
    	"espiègle",
    	"espoir",
    	"esprit",
    	"esquiver",
    	"essayer",
    	"essence",
    	"essieu",
    	"essorer",
    	"estime",
    	"estomac",
    	"estrade",
    	"étagère",
    	"étaler",
    	"étanche",
    	"étatique",
    	"éteindre",
    	"étendoir",
    	"éternel",
    	"éthanol",
    	"éthique",
    	"ethnie",
    	"étirer",
    	"étoffer",
    	"étoile",
    	"étonnant",
    	"étourdir",
    	"étrange",
    	"étroit",
    	"étude",
    	"euphorie",
    	"évaluer",
    	"évasion",
    	"éventail",
    	"évidence",
    	"éviter",
    	"évolutif",
    	"évoquer",
    	"exact",
    	"exagérer",
    	"exaucer",
    	"exceller",
    	"excitant",
    	"exclusif",
    	"excuse",
    	"exécuter",
    	"exemple",
    	"exercer",
    	"exhaler",
    	"exhorter",
    	"exigence",
    	"exiler",
    	"exister",
    	"exotique",
    	"expédier",
    	"explorer",
    	"exposer",
    	"exprimer",
    	"exquis",
    	"extensif",
    	"extraire",
    	"exulter",
    	"fable",
    	"fabuleux",
    	"facette",
    	"facile",
    	"facture",
    	"faiblir",
    	"falaise",
    	"fameux",
    	"famille",
    	"farceur",
    	"farfelu",
    	"farine",
    	"farouche",
    	"fasciner",
    	"fatal",
    	"fatigue",
    	"faucon",
    	"fautif",
    	"faveur",
    	"favori",
    	"fébrile",
    	"féconder",
    	"fédérer",
    	"félin",
    	"femme",
    	"fémur",
    	"fendoir",
    	"féodal",
    	"fermer",
    	"féroce",
    	"ferveur",
    	"festival",
    	"feuille",
    	"feutre",
    	"février",
    	"fiasco",
    	"ficeler",
    	"fictif",
    	"fidèle",
    	"figure",
    	"filature",
    	"filetage",
    	"filière",
    	"filleul",
    	"filmer",
    	"filou",
    	"filtrer",
    	"financer",
    	"finir",
    	"fiole",
    	"firme",
    	"fissure",
    	"fixer",
    	"flairer",
    	"flamme",
    	"flasque",
    	"flatteur",
    	"fléau",
    	"flèche",
    	"fleur",
    	"flexion",
    	"flocon",
    	"flore",
    	"fluctuer",
    	"fluide",
    	"fluvial",
    	"folie",
    	"fonderie",
    	"fongible",
    	"fontaine",
    	"forcer",
    	"forgeron",
    	"formuler",
    	"fortune",
    	"fossile",
    	"foudre",
    	"fougère",
    	"fouiller",
    	"foulure",
    	"fourmi",
    	"fragile",
    	"fraise",
    	"franchir",
    	"frapper",
    	"frayeur",
    	"frégate",
    	"freiner",
    	"frelon",
    	"frémir",
    	"frénésie",
    	"frère",
    	"friable",
    	"friction",
    	"frisson",
    	"frivole",
    	"froid",
    	"fromage",
    	"frontal",
    	"frotter",
    	"fruit",
    	"fugitif",
    	"fuite",
    	"fureur",
    	"furieux",
    	"furtif",
    	"fusion",
    	"futur",
    	"gagner",
    	"galaxie",
    	"galerie",
    	"gambader",
    	"garantir",
    	"gardien",
    	"garnir",
    	"garrigue",
    	"gazelle",
    	"gazon",
    	"géant",
    	"gélatine",
    	"gélule",
    	"gendarme",
    	"général",
    	"génie",
    	"genou",
    	"gentil",
    	"géologie",
    	"géomètre",
    	"géranium",
    	"germe",
    	"gestuel",
    	"geyser",
    	"gibier",
    	"gicler",
    	"girafe",
    	"givre",
    	"glace",
    	"glaive",
    	"glisser",
    	"globe",
    	"gloire",
    	"glorieux",
    	"golfeur",
    	"gomme",
    	"gonfler",
    	"gorge",
    	"gorille",
    	"goudron",
    	"gouffre",
    	"goulot",
    	"goupille",
    	"gourmand",
    	"goutte",
    	"graduel",
    	"graffiti",
    	"graine",
    	"grand",
    	"grappin",
    	"gratuit",
    	"gravir",
    	"grenat",
    	"griffure",
    	"griller",
    	"grimper",
    	"grogner",
    	"gronder",
    	"grotte",
    	"groupe",
    	"gruger",
    	"grutier",
    	"gruyère",
    	"guépard",
    	"guerrier",
    	"guide",
    	"guimauve",
    	"guitare",
    	"gustatif",
    	"gymnaste",
    	"gyrostat",
    	"habitude",
    	"hachoir",
    	"halte",
    	"hameau",
    	"hangar",
    	"hanneton",
    	"haricot",
    	"harmonie",
    	"harpon",
    	"hasard",
    	"hélium",
    	"hématome",
    	"herbe",
    	"hérisson",
    	"hermine",
    	"héron",
    	"hésiter",
    	"heureux",
    	"hiberner",
    	"hibou",
    	"hilarant",
    	"histoire",
    	"hiver",
    	"homard",
    	"hommage",
    	"homogène",
    	"honneur",
    	"honorer",
    	"honteux",
    	"horde",
    	"horizon",
    	"horloge",
    	"hormone",
    	"horrible",
    	"houleux",
    	"housse",
    	"hublot",
    	"huileux",
    	"humain",
    	"humble",
    	"humide",
    	"humour",
    	"hurler",
    	"hydromel",
    	"hygiène",
    	"hymne",
    	"hypnose",
    	"idylle",
    	"ignorer",
    	"iguane",
    	"illicite",
    	"illusion",
    	"image",
    	"imbiber",
    	"imiter",
    	"immense",
    	"immobile",
    	"immuable",
    	"impact",
    	"impérial",
    	"implorer",
    	"imposer",
    	"imprimer",
    	"imputer",
    	"incarner",
    	"incendie",
    	"incident",
    	"incliner",
    	"incolore",
    	"indexer",
    	"indice",
    	"inductif",
    	"inédit",
    	"ineptie",
    	"inexact",
    	"infini",
    	"infliger",
    	"informer",
    	"infusion",
    	"ingérer",
    	"inhaler",
    	"inhiber",
    	"injecter",
    	"injure",
    	"innocent",
    	"inoculer",
    	"inonder",
    	"inscrire",
    	"insecte",
    	"insigne",
    	"insolite",
    	"inspirer",
    	"instinct",
    	"insulter",
    	"intact",
    	"intense",
    	"intime",
    	"intrigue",
    	"intuitif",
    	"inutile",
    	"invasion",
    	"inventer",
    	"inviter",
    	"invoquer",
    	"ironique",
    	"irradier",
    	"irréel",
    	"irriter",
    	"isoler",
    	"ivoire",
    	"ivresse",
    	"jaguar",
    	"jaillir",
    	"jambe",
    	"janvier",
    	"jardin",
    	"jauger",
    	"jaune",
    	"javelot",
    	"jetable",
    	"jeton",
    	"jeudi",
    	"jeunesse",
    	"joindre",
    	"joncher",
    	"jongler",
    	"joueur",
    	"jouissif",
    	"journal",
    	"jovial",
    	"joyau",
    	"joyeux",
    	"jubiler",
    	"jugement",
    	"junior",
    	"jupon",
    	"juriste",
    	"justice",
    	"juteux",
    	"juvénile",
    	"kayak",
    	"kimono",
    	"kiosque",
    	"label",
    	"labial",
    	"labourer",
    	"lacérer",
    	"lactose",
    	"lagune",
    	"laine",
    	"laisser",
    	"laitier",
    	"lambeau",
    	"lamelle",
    	"lampe",
    	"lanceur",
    	"langage",
    	"lanterne",
    	"lapin",
    	"largeur",
    	"larme",
    	"laurier",
    	"lavabo",
    	"lavoir",
    	"lecture",
    	"légal",
    	"léger",
    	"légume",
    	"lessive",
    	"lettre",
    	"levier",
    	"lexique",
    	"lézard",
    	"liasse",
    	"libérer",
    	"libre",
    	"licence",
    	"licorne",
    	"liège",
    	"lièvre",
    	"ligature",
    	"ligoter",
    	"ligue",
    	"limer",
    	"limite",
    	"limonade",
    	"limpide",
    	"linéaire",
    	"lingot",
    	"lionceau",
    	"liquide",
    	"lisière",
    	"lister",
    	"lithium",
    	"litige",
    	"littoral",
    	"livreur",
    	"logique",
    	"lointain",
    	"loisir",
    	"lombric",
    	"loterie",
    	"louer",
    	"lourd",
    	"loutre",
    	"louve",
    	"loyal",
    	"lubie",
    	"lucide",
    	"lucratif",
    	"lueur",
    	"lugubre",
    	"luisant",
    	"lumière",
    	"lunaire",
    	"lundi",
    	"luron",
    	"lutter",
    	"luxueux",
    	"machine",
    	"magasin",
    	"magenta",
    	"magique",
    	"maigre",
    	"maillon",
    	"maintien",
    	"mairie",
    	"maison",
    	"majorer",
    	"malaxer",
    	"maléfice",
    	"malheur",
    	"malice",
    	"mallette",
    	"mammouth",
    	"mandater",
    	"maniable",
    	"manquant",
    	"manteau",
    	"manuel",
    	"marathon",
    	"marbre",
    	"marchand",
    	"mardi",
    	"maritime",
    	"marqueur",
    	"marron",
    	"marteler",
    	"mascotte",
    	"massif",
    	"matériel",
    	"matière",
    	"matraque",
    	"maudire",
    	"maussade",
    	"mauve",
    	"maximal",
    	"méchant",
    	"méconnu",
    	"médaille",
    	"médecin",
    	"méditer",
    	"méduse",
    	"meilleur",
    	"mélange",
    	"mélodie",
    	"membre",
    	"mémoire",
    	"menacer",
    	"mener",
    	"menhir",
    	"mensonge",
    	"mentor",
    	"mercredi",
    	"mérite",
    	"merle",
    	"messager",
    	"mesure",
    	"métal",
    	"météore",
    	"méthode",
    	"métier",
    	"meuble",
    	"miauler",
    	"microbe",
    	"miette",
    	"mignon",
    	"migrer",
    	"milieu",
    	"million",
    	"mimique",
    	"mince",
    	"minéral",
    	"minimal",
    	"minorer",
    	"minute",
    	"miracle",
    	"miroiter",
    	"missile",
    	"mixte",
    	"mobile",
    	"moderne",
    	"moelleux",
    	"mondial",
    	"moniteur",
    	"monnaie",
    	"monotone",
    	"monstre",
    	"montagne",
    	"monument",
    	"moqueur",
    	"morceau",
    	"morsure",
    	"mortier",
    	"moteur",
    	"motif",
    	"mouche",
    	"moufle",
    	"moulin",
    	"mousson",
    	"mouton",
    	"mouvant",
    	"multiple",
    	"munition",
    	"muraille",
    	"murène",
    	"murmure",
    	"muscle",
    	"muséum",
    	"musicien",
    	"mutation",
    	"muter",
    	"mutuel",
    	"myriade",
    	"myrtille",
    	"mystère",
    	"mythique",
    	"nageur",
    	"nappe",
    	"narquois",
    	"narrer",
    	"natation",
    	"nation",
    	"nature",
    	"naufrage",
    	"nautique",
    	"navire",
    	"nébuleux",
    	"nectar",
    	"néfaste",
    	"négation",
    	"négliger",
    	"négocier",
    	"neige",
    	"nerveux",
    	"nettoyer",
    	"neurone",
    	"neutron",
    	"neveu",
    	"niche",
    	"nickel",
    	"nitrate",
    	"niveau",
    	"noble",
    	"nocif",
    	"nocturne",
    	"noirceur",
    	"noisette",
    	"nomade",
    	"nombreux",
    	"nommer",
    	"normatif",
    	"notable",
    	"notifier",
    	"notoire",
    	"nourrir",
    	"nouveau",
    	"novateur",
    	"novembre",
    	"novice",
    	"nuage",
    	"nuancer",
    	"nuire",
    	"nuisible",
    	"numéro",
    	"nuptial",
    	"nuque",
    	"nutritif",
    	"obéir",
    	"objectif",
    	"obliger",
    	"obscur",
    	"observer",
    	"obstacle",
    	"obtenir",
    	"obturer",
    	"occasion",
    	"occuper",
    	"océan",
    	"octobre",
    	"octroyer",
    	"octupler",
    	"oculaire",
    	"odeur",
    	"odorant",
    	"offenser",
    	"officier",
    	"offrir",
    	"ogive",
    	"oiseau",
    	"oisillon",
    	"olfactif",
    	"olivier",
    	"ombrage",
    	"omettre",
    	"onctueux",
    	"onduler",
    	"onéreux",
    	"onirique",
    	"opale",
    	"opaque",
    	"opérer",
    	"opinion",
    	"opportun",
    	"opprimer",
    	"opter",
    	"optique",
    	"orageux",
    	"orange",
    	"orbite",
    	"ordonner",
    	"oreille",
    	"organe",
    	"orgueil",
    	"orifice",
    	"ornement",
    	"orque",
    	"ortie",
    	"osciller",
    	"osmose",
    	"ossature",
    	"otarie",
    	"ouragan",
    	"ourson",
    	"outil",
    	"outrager",
    	"ouvrage",
    	"ovation",
    	"oxyde",
    	"oxygène",
    	"ozone",
    	"paisible",
    	"palace",
    	"palmarès",
    	"palourde",
    	"palper",
    	"panache",
    	"panda",
    	"pangolin",
    	"paniquer",
    	"panneau",
    	"panorama",
    	"pantalon",
    	"papaye",
    	"papier",
    	"papoter",
    	"papyrus",
    	"paradoxe",
    	"parcelle",
    	"paresse",
    	"parfumer",
    	"parler",
    	"parole",
    	"parrain",
    	"parsemer",
    	"partager",
    	"parure",
    	"parvenir",
    	"passion",
    	"pastèque",
    	"paternel",
    	"patience",
    	"patron",
    	"pavillon",
    	"pavoiser",
    	"payer",
    	"paysage",
    	"peigne",
    	"peintre",
    	"pelage",
    	"pélican",
    	"pelle",
    	"pelouse",
    	"peluche",
    	"pendule",
    	"pénétrer",
    	"pénible",
    	"pensif",
    	"pénurie",
    	"pépite",
    	"péplum",
    	"perdrix",
    	"perforer",
    	"période",
    	"permuter",
    	"perplexe",
    	"persil",
    	"perte",
    	"peser",
    	"pétale",
    	"petit",
    	"pétrir",
    	"peuple",
    	"pharaon",
    	"phobie",
    	"phoque",
    	"photon",
    	"phrase",
    	"physique",
    	"piano",
    	"pictural",
    	"pièce",
    	"pierre",
    	"pieuvre",
    	"pilote",
    	"pinceau",
    	"pipette",
    	"piquer",
    	"pirogue",
    	"piscine",
    	"piston",
    	"pivoter",
    	"pixel",
    	"pizza",
    	"placard",
    	"plafond",
    	"plaisir",
    	"planer",
    	"plaque",
    	"plastron",
    	"plateau",
    	"pleurer",
    	"plexus",
    	"pliage",
    	"plomb",
    	"plonger",
    	"pluie",
    	"plumage",
    	"pochette",
    	"poésie",
    	"poète",
    	"pointe",
    	"poirier",
    	"poisson",
    	"poivre",
    	"polaire",
    	"policier",
    	"pollen",
    	"polygone",
    	"pommade",
    	"pompier",
    	"ponctuel",
    	"pondérer",
    	"poney",
    	"portique",
    	"position",
    	"posséder",
    	"posture",
    	"potager",
    	"poteau",
    	"potion",
    	"pouce",
    	"poulain",
    	"poumon",
    	"pourpre",
    	"poussin",
    	"pouvoir",
    	"prairie",
    	"pratique",
    	"précieux",
    	"prédire",
    	"préfixe",
    	"prélude",
    	"prénom",
    	"présence",
    	"prétexte",
    	"prévoir",
    	"primitif",
    	"prince",
    	"prison",
    	"priver",
    	"problème",
    	"procéder",
    	"prodige",
    	"profond",
    	"progrès",
    	"proie",
    	"projeter",
    	"prologue",
    	"promener",
    	"propre",
    	"prospère",
    	"protéger",
    	"prouesse",
    	"proverbe",
    	"prudence",
    	"pruneau",
    	"psychose",
    	"public",
    	"puceron",
    	"puiser",
    	"pulpe",
    	"pulsar",
    	"punaise",
    	"punitif",
    	"pupitre",
    	"purifier",
    	"puzzle",
    	"pyramide",
    	"quasar",
    	"querelle",
    	"question",
    	"quiétude",
    	"quitter",
    	"quotient",
    	"racine",
    	"raconter",
    	"radieux",
    	"ragondin",
    	"raideur",
    	"raisin",
    	"ralentir",
    	"rallonge",
    	"ramasser",
    	"rapide",
    	"rasage",
    	"ratisser",
    	"ravager",
    	"ravin",
    	"rayonner",
    	"réactif",
    	"réagir",
    	"réaliser",
    	"réanimer",
    	"recevoir",
    	"réciter",
    	"réclamer",
    	"récolter",
    	"recruter",
    	"reculer",
    	"recycler",
    	"rédiger",
    	"redouter",
    	"refaire",
    	"réflexe",
    	"réformer",
    	"refrain",
    	"refuge",
    	"régalien",
    	"région",
    	"réglage",
    	"régulier",
    	"réitérer",
    	"rejeter",
    	"rejouer",
    	"relatif",
    	"relever",
    	"relief",
    	"remarque",
    	"remède",
    	"remise",
    	"remonter",
    	"remplir",
    	"remuer",
    	"renard",
    	"renfort",
    	"renifler",
    	"renoncer",
    	"rentrer",
    	"renvoi",
    	"replier",
    	"reporter",
    	"reprise",
    	"reptile",
    	"requin",
    	"réserve",
    	"résineux",
    	"résoudre",
    	"respect",
    	"rester",
    	"résultat",
    	"rétablir",
    	"retenir",
    	"réticule",
    	"retomber",
    	"retracer",
    	"réunion",
    	"réussir",
    	"revanche",
    	"revivre",
    	"révolte",
    	"révulsif",
    	"richesse",
    	"rideau",
    	"rieur",
    	"rigide",
    	"rigoler",
    	"rincer",
    	"riposter",
    	"risible",
    	"risque",
    	"rituel",
    	"rival",
    	"rivière",
    	"rocheux",
    	"romance",
    	"rompre",
    	"ronce",
    	"rondin",
    	"roseau",
    	"rosier",
    	"rotatif",
    	"rotor",
    	"rotule",
    	"rouge",
    	"rouille",
    	"rouleau",
    	"routine",
    	"royaume",
    	"ruban",
    	"rubis",
    	"ruche",
    	"ruelle",
    	"rugueux",
    	"ruiner",
    	"ruisseau",
    	"ruser",
    	"rustique",
    	"rythme",
    	"sabler",
    	"saboter",
    	"sabre",
    	"sacoche",
    	"safari",
    	"sagesse",
    	"saisir",
    	"salade",
    	"salive",
    	"salon",
    	"saluer",
    	"samedi",
    	"sanction",
    	"sanglier",
    	"sarcasme",
    	"sardine",
    	"saturer",
    	"saugrenu",
    	"saumon",
    	"sauter",
    	"sauvage",
    	"savant",
    	"savonner",
    	"scalpel",
    	"scandale",
    	"scélérat",
    	"scénario",
    	"sceptre",
    	"schéma",
    	"science",
    	"scinder",
    	"score",
    	"scrutin",
    	"sculpter",
    	"séance",
    	"sécable",
    	"sécher",
    	"secouer",
    	"sécréter",
    	"sédatif",
    	"séduire",
    	"seigneur",
    	"séjour",
    	"sélectif",
    	"semaine",
    	"sembler",
    	"semence",
    	"séminal",
    	"sénateur",
    	"sensible",
    	"sentence",
    	"séparer",
    	"séquence",
    	"serein",
    	"sergent",
    	"sérieux",
    	"serrure",
    	"sérum",
    	"service",
    	"sésame",
    	"sévir",
    	"sevrage",
    	"sextuple",
    	"sidéral",
    	"siècle",
    	"siéger",
    	"siffler",
    	"sigle",
    	"signal",
    	"silence",
    	"silicium",
    	"simple",
    	"sincère",
    	"sinistre",
    	"siphon",
    	"sirop",
    	"sismique",
    	"situer",
    	"skier",
    	"social",
    	"socle",
    	"sodium",
    	"soigneux",
    	"soldat",
    	"soleil",
    	"solitude",
    	"soluble",
    	"sombre",
    	"sommeil",
    	"somnoler",
    	"sonde",
    	"songeur",
    	"sonnette",
    	"sonore",
    	"sorcier",
    	"sortir",
    	"sosie",
    	"sottise",
    	"soucieux",
    	"soudure",
    	"souffle",
    	"soulever",
    	"soupape",
    	"source",
    	"soutirer",
    	"souvenir",
    	"spacieux",
    	"spatial",
    	"spécial",
    	"sphère",
    	"spiral",
    	"stable",
    	"station",
    	"sternum",
    	"stimulus",
    	"stipuler",
    	"strict",
    	"studieux",
    	"stupeur",
    	"styliste",
    	"sublime",
    	"substrat",
    	"subtil",
    	"subvenir",
    	"succès",
    	"sucre",
    	"suffixe",
    	"suggérer",
    	"suiveur",
    	"sulfate",
    	"superbe",
    	"supplier",
    	"surface",
    	"suricate",
    	"surmener",
    	"surprise",
    	"sursaut",
    	"survie",
    	"suspect",
    	"syllabe",
    	"symbole",
    	"symétrie",
    	"synapse",
    	"syntaxe",
    	"système",
    	"tabac",
    	"tablier",
    	"tactile",
    	"tailler",
    	"talent",
    	"talisman",
    	"talonner",
    	"tambour",
    	"tamiser",
    	"tangible",
    	"tapis",
    	"taquiner",
    	"tarder",
    	"tarif",
    	"tartine",
    	"tasse",
    	"tatami",
    	"tatouage",
    	"taupe",
    	"taureau",
    	"taxer",
    	"témoin",
    	"temporel",
    	"tenaille",
    	"tendre",
    	"teneur",
    	"tenir",
    	"tension",
    	"terminer",
    	"terne",
    	"terrible",
    	"tétine",
    	"texte",
    	"thème",
    	"théorie",
    	"thérapie",
    	"thorax",
    	"tibia",
    	"tiède",
    	"timide",
    	"tirelire",
    	"tiroir",
    	"tissu",
    	"titane",
    	"titre",
    	"tituber",
    	"toboggan",
    	"tolérant",
    	"tomate",
    	"tonique",
    	"tonneau",
    	"toponyme",
    	"torche",
    	"tordre",
    	"tornade",
    	"torpille",
    	"torrent",
    	"torse",
    	"tortue",
    	"totem",
    	"toucher",
    	"tournage",
    	"tousser",
    	"toxine",
    	"traction",
    	"trafic",
    	"tragique",
    	"trahir",
    	"train",
    	"trancher",
    	"travail",
    	"trèfle",
    	"tremper",
    	"trésor",
    	"treuil",
    	"triage",
    	"tribunal",
    	"tricoter",
    	"trilogie",
    	"triomphe",
    	"tripler",
    	"triturer",
    	"trivial",
    	"trombone",
    	"tronc",
    	"tropical",
    	"troupeau",
    	"tuile",
    	"tulipe",
    	"tumulte",
    	"tunnel",
    	"turbine",
    	"tuteur",
    	"tutoyer",
    	"tuyau",
    	"tympan",
    	"typhon",
    	"typique",
    	"tyran",
    	"ubuesque",
    	"ultime",
    	"ultrason",
    	"unanime",
    	"unifier",
    	"union",
    	"unique",
    	"unitaire",
    	"univers",
    	"uranium",
    	"urbain",
    	"urticant",
    	"usage",
    	"usine",
    	"usuel",
    	"usure",
    	"utile",
    	"utopie",
    	"vacarme",
    	"vaccin",
    	"vagabond",
    	"vague",
    	"vaillant",
    	"vaincre",
    	"vaisseau",
    	"valable",
    	"valise",
    	"vallon",
    	"valve",
    	"vampire",
    	"vanille",
    	"vapeur",
    	"varier",
    	"vaseux",
    	"vassal",
    	"vaste",
    	"vecteur",
    	"vedette",
    	"végétal",
    	"véhicule",
    	"veinard",
    	"véloce",
    	"vendredi",
    	"vénérer",
    	"venger",
    	"venimeux",
    	"ventouse",
    	"verdure",
    	"vérin",
    	"vernir",
    	"verrou",
    	"verser",
    	"vertu",
    	"veston",
    	"vétéran",
    	"vétuste",
    	"vexant",
    	"vexer",
    	"viaduc",
    	"viande",
    	"victoire",
    	"vidange",
    	"vidéo",
    	"vignette",
    	"vigueur",
    	"vilain",
    	"village",
    	"vinaigre",
    	"violon",
    	"vipère",
    	"virement",
    	"virtuose",
    	"virus",
    	"visage",
    	"viseur",
    	"vision",
    	"visqueux",
    	"visuel",
    	"vital",
    	"vitesse",
    	"viticole",
    	"vitrine",
    	"vivace",
    	"vivipare",
    	"vocation",
    	"voguer",
    	"voile",
    	"voisin",
    	"voiture",
    	"volaille",
    	"volcan",
    	"voltiger",
    	"volume",
    	"vorace",
    	"vortex",
    	"voter",
    	"vouloir",
    	"voyage",
    	"voyelle",
    	"wagon",
    	"xénon",
    	"yacht",
    	"zèbre",
    	"zénith",
    	"zeste",
    	"zoologie"
    ];

    var require$$9 = [
    	"abaco",
    	"abbaglio",
    	"abbinato",
    	"abete",
    	"abisso",
    	"abolire",
    	"abrasivo",
    	"abrogato",
    	"accadere",
    	"accenno",
    	"accusato",
    	"acetone",
    	"achille",
    	"acido",
    	"acqua",
    	"acre",
    	"acrilico",
    	"acrobata",
    	"acuto",
    	"adagio",
    	"addebito",
    	"addome",
    	"adeguato",
    	"aderire",
    	"adipe",
    	"adottare",
    	"adulare",
    	"affabile",
    	"affetto",
    	"affisso",
    	"affranto",
    	"aforisma",
    	"afoso",
    	"africano",
    	"agave",
    	"agente",
    	"agevole",
    	"aggancio",
    	"agire",
    	"agitare",
    	"agonismo",
    	"agricolo",
    	"agrumeto",
    	"aguzzo",
    	"alabarda",
    	"alato",
    	"albatro",
    	"alberato",
    	"albo",
    	"albume",
    	"alce",
    	"alcolico",
    	"alettone",
    	"alfa",
    	"algebra",
    	"aliante",
    	"alibi",
    	"alimento",
    	"allagato",
    	"allegro",
    	"allievo",
    	"allodola",
    	"allusivo",
    	"almeno",
    	"alogeno",
    	"alpaca",
    	"alpestre",
    	"altalena",
    	"alterno",
    	"alticcio",
    	"altrove",
    	"alunno",
    	"alveolo",
    	"alzare",
    	"amalgama",
    	"amanita",
    	"amarena",
    	"ambito",
    	"ambrato",
    	"ameba",
    	"america",
    	"ametista",
    	"amico",
    	"ammasso",
    	"ammenda",
    	"ammirare",
    	"ammonito",
    	"amore",
    	"ampio",
    	"ampliare",
    	"amuleto",
    	"anacardo",
    	"anagrafe",
    	"analista",
    	"anarchia",
    	"anatra",
    	"anca",
    	"ancella",
    	"ancora",
    	"andare",
    	"andrea",
    	"anello",
    	"angelo",
    	"angolare",
    	"angusto",
    	"anima",
    	"annegare",
    	"annidato",
    	"anno",
    	"annuncio",
    	"anonimo",
    	"anticipo",
    	"anzi",
    	"apatico",
    	"apertura",
    	"apode",
    	"apparire",
    	"appetito",
    	"appoggio",
    	"approdo",
    	"appunto",
    	"aprile",
    	"arabica",
    	"arachide",
    	"aragosta",
    	"araldica",
    	"arancio",
    	"aratura",
    	"arazzo",
    	"arbitro",
    	"archivio",
    	"ardito",
    	"arenile",
    	"argento",
    	"argine",
    	"arguto",
    	"aria",
    	"armonia",
    	"arnese",
    	"arredato",
    	"arringa",
    	"arrosto",
    	"arsenico",
    	"arso",
    	"artefice",
    	"arzillo",
    	"asciutto",
    	"ascolto",
    	"asepsi",
    	"asettico",
    	"asfalto",
    	"asino",
    	"asola",
    	"aspirato",
    	"aspro",
    	"assaggio",
    	"asse",
    	"assoluto",
    	"assurdo",
    	"asta",
    	"astenuto",
    	"astice",
    	"astratto",
    	"atavico",
    	"ateismo",
    	"atomico",
    	"atono",
    	"attesa",
    	"attivare",
    	"attorno",
    	"attrito",
    	"attuale",
    	"ausilio",
    	"austria",
    	"autista",
    	"autonomo",
    	"autunno",
    	"avanzato",
    	"avere",
    	"avvenire",
    	"avviso",
    	"avvolgere",
    	"azione",
    	"azoto",
    	"azzimo",
    	"azzurro",
    	"babele",
    	"baccano",
    	"bacino",
    	"baco",
    	"badessa",
    	"badilata",
    	"bagnato",
    	"baita",
    	"balcone",
    	"baldo",
    	"balena",
    	"ballata",
    	"balzano",
    	"bambino",
    	"bandire",
    	"baraonda",
    	"barbaro",
    	"barca",
    	"baritono",
    	"barlume",
    	"barocco",
    	"basilico",
    	"basso",
    	"batosta",
    	"battuto",
    	"baule",
    	"bava",
    	"bavosa",
    	"becco",
    	"beffa",
    	"belgio",
    	"belva",
    	"benda",
    	"benevole",
    	"benigno",
    	"benzina",
    	"bere",
    	"berlina",
    	"beta",
    	"bibita",
    	"bici",
    	"bidone",
    	"bifido",
    	"biga",
    	"bilancia",
    	"bimbo",
    	"binocolo",
    	"biologo",
    	"bipede",
    	"bipolare",
    	"birbante",
    	"birra",
    	"biscotto",
    	"bisesto",
    	"bisnonno",
    	"bisonte",
    	"bisturi",
    	"bizzarro",
    	"blando",
    	"blatta",
    	"bollito",
    	"bonifico",
    	"bordo",
    	"bosco",
    	"botanico",
    	"bottino",
    	"bozzolo",
    	"braccio",
    	"bradipo",
    	"brama",
    	"branca",
    	"bravura",
    	"bretella",
    	"brevetto",
    	"brezza",
    	"briglia",
    	"brillante",
    	"brindare",
    	"broccolo",
    	"brodo",
    	"bronzina",
    	"brullo",
    	"bruno",
    	"bubbone",
    	"buca",
    	"budino",
    	"buffone",
    	"buio",
    	"bulbo",
    	"buono",
    	"burlone",
    	"burrasca",
    	"bussola",
    	"busta",
    	"cadetto",
    	"caduco",
    	"calamaro",
    	"calcolo",
    	"calesse",
    	"calibro",
    	"calmo",
    	"caloria",
    	"cambusa",
    	"camerata",
    	"camicia",
    	"cammino",
    	"camola",
    	"campale",
    	"canapa",
    	"candela",
    	"cane",
    	"canino",
    	"canotto",
    	"cantina",
    	"capace",
    	"capello",
    	"capitolo",
    	"capogiro",
    	"cappero",
    	"capra",
    	"capsula",
    	"carapace",
    	"carcassa",
    	"cardo",
    	"carisma",
    	"carovana",
    	"carretto",
    	"cartolina",
    	"casaccio",
    	"cascata",
    	"caserma",
    	"caso",
    	"cassone",
    	"castello",
    	"casuale",
    	"catasta",
    	"catena",
    	"catrame",
    	"cauto",
    	"cavillo",
    	"cedibile",
    	"cedrata",
    	"cefalo",
    	"celebre",
    	"cellulare",
    	"cena",
    	"cenone",
    	"centesimo",
    	"ceramica",
    	"cercare",
    	"certo",
    	"cerume",
    	"cervello",
    	"cesoia",
    	"cespo",
    	"ceto",
    	"chela",
    	"chiaro",
    	"chicca",
    	"chiedere",
    	"chimera",
    	"china",
    	"chirurgo",
    	"chitarra",
    	"ciao",
    	"ciclismo",
    	"cifrare",
    	"cigno",
    	"cilindro",
    	"ciottolo",
    	"circa",
    	"cirrosi",
    	"citrico",
    	"cittadino",
    	"ciuffo",
    	"civetta",
    	"civile",
    	"classico",
    	"clinica",
    	"cloro",
    	"cocco",
    	"codardo",
    	"codice",
    	"coerente",
    	"cognome",
    	"collare",
    	"colmato",
    	"colore",
    	"colposo",
    	"coltivato",
    	"colza",
    	"coma",
    	"cometa",
    	"commando",
    	"comodo",
    	"computer",
    	"comune",
    	"conciso",
    	"condurre",
    	"conferma",
    	"congelare",
    	"coniuge",
    	"connesso",
    	"conoscere",
    	"consumo",
    	"continuo",
    	"convegno",
    	"coperto",
    	"copione",
    	"coppia",
    	"copricapo",
    	"corazza",
    	"cordata",
    	"coricato",
    	"cornice",
    	"corolla",
    	"corpo",
    	"corredo",
    	"corsia",
    	"cortese",
    	"cosmico",
    	"costante",
    	"cottura",
    	"covato",
    	"cratere",
    	"cravatta",
    	"creato",
    	"credere",
    	"cremoso",
    	"crescita",
    	"creta",
    	"criceto",
    	"crinale",
    	"crisi",
    	"critico",
    	"croce",
    	"cronaca",
    	"crostata",
    	"cruciale",
    	"crusca",
    	"cucire",
    	"cuculo",
    	"cugino",
    	"cullato",
    	"cupola",
    	"curatore",
    	"cursore",
    	"curvo",
    	"cuscino",
    	"custode",
    	"dado",
    	"daino",
    	"dalmata",
    	"damerino",
    	"daniela",
    	"dannoso",
    	"danzare",
    	"datato",
    	"davanti",
    	"davvero",
    	"debutto",
    	"decennio",
    	"deciso",
    	"declino",
    	"decollo",
    	"decreto",
    	"dedicato",
    	"definito",
    	"deforme",
    	"degno",
    	"delegare",
    	"delfino",
    	"delirio",
    	"delta",
    	"demenza",
    	"denotato",
    	"dentro",
    	"deposito",
    	"derapata",
    	"derivare",
    	"deroga",
    	"descritto",
    	"deserto",
    	"desiderio",
    	"desumere",
    	"detersivo",
    	"devoto",
    	"diametro",
    	"dicembre",
    	"diedro",
    	"difeso",
    	"diffuso",
    	"digerire",
    	"digitale",
    	"diluvio",
    	"dinamico",
    	"dinnanzi",
    	"dipinto",
    	"diploma",
    	"dipolo",
    	"diradare",
    	"dire",
    	"dirotto",
    	"dirupo",
    	"disagio",
    	"discreto",
    	"disfare",
    	"disgelo",
    	"disposto",
    	"distanza",
    	"disumano",
    	"dito",
    	"divano",
    	"divelto",
    	"dividere",
    	"divorato",
    	"doblone",
    	"docente",
    	"doganale",
    	"dogma",
    	"dolce",
    	"domato",
    	"domenica",
    	"dominare",
    	"dondolo",
    	"dono",
    	"dormire",
    	"dote",
    	"dottore",
    	"dovuto",
    	"dozzina",
    	"drago",
    	"druido",
    	"dubbio",
    	"dubitare",
    	"ducale",
    	"duna",
    	"duomo",
    	"duplice",
    	"duraturo",
    	"ebano",
    	"eccesso",
    	"ecco",
    	"eclissi",
    	"economia",
    	"edera",
    	"edicola",
    	"edile",
    	"editoria",
    	"educare",
    	"egemonia",
    	"egli",
    	"egoismo",
    	"egregio",
    	"elaborato",
    	"elargire",
    	"elegante",
    	"elencato",
    	"eletto",
    	"elevare",
    	"elfico",
    	"elica",
    	"elmo",
    	"elsa",
    	"eluso",
    	"emanato",
    	"emblema",
    	"emesso",
    	"emiro",
    	"emotivo",
    	"emozione",
    	"empirico",
    	"emulo",
    	"endemico",
    	"enduro",
    	"energia",
    	"enfasi",
    	"enoteca",
    	"entrare",
    	"enzima",
    	"epatite",
    	"epilogo",
    	"episodio",
    	"epocale",
    	"eppure",
    	"equatore",
    	"erario",
    	"erba",
    	"erboso",
    	"erede",
    	"eremita",
    	"erigere",
    	"ermetico",
    	"eroe",
    	"erosivo",
    	"errante",
    	"esagono",
    	"esame",
    	"esanime",
    	"esaudire",
    	"esca",
    	"esempio",
    	"esercito",
    	"esibito",
    	"esigente",
    	"esistere",
    	"esito",
    	"esofago",
    	"esortato",
    	"esoso",
    	"espanso",
    	"espresso",
    	"essenza",
    	"esso",
    	"esteso",
    	"estimare",
    	"estonia",
    	"estroso",
    	"esultare",
    	"etilico",
    	"etnico",
    	"etrusco",
    	"etto",
    	"euclideo",
    	"europa",
    	"evaso",
    	"evidenza",
    	"evitato",
    	"evoluto",
    	"evviva",
    	"fabbrica",
    	"faccenda",
    	"fachiro",
    	"falco",
    	"famiglia",
    	"fanale",
    	"fanfara",
    	"fango",
    	"fantasma",
    	"fare",
    	"farfalla",
    	"farinoso",
    	"farmaco",
    	"fascia",
    	"fastoso",
    	"fasullo",
    	"faticare",
    	"fato",
    	"favoloso",
    	"febbre",
    	"fecola",
    	"fede",
    	"fegato",
    	"felpa",
    	"feltro",
    	"femmina",
    	"fendere",
    	"fenomeno",
    	"fermento",
    	"ferro",
    	"fertile",
    	"fessura",
    	"festivo",
    	"fetta",
    	"feudo",
    	"fiaba",
    	"fiducia",
    	"fifa",
    	"figurato",
    	"filo",
    	"finanza",
    	"finestra",
    	"finire",
    	"fiore",
    	"fiscale",
    	"fisico",
    	"fiume",
    	"flacone",
    	"flamenco",
    	"flebo",
    	"flemma",
    	"florido",
    	"fluente",
    	"fluoro",
    	"fobico",
    	"focaccia",
    	"focoso",
    	"foderato",
    	"foglio",
    	"folata",
    	"folclore",
    	"folgore",
    	"fondente",
    	"fonetico",
    	"fonia",
    	"fontana",
    	"forbito",
    	"forchetta",
    	"foresta",
    	"formica",
    	"fornaio",
    	"foro",
    	"fortezza",
    	"forzare",
    	"fosfato",
    	"fosso",
    	"fracasso",
    	"frana",
    	"frassino",
    	"fratello",
    	"freccetta",
    	"frenata",
    	"fresco",
    	"frigo",
    	"frollino",
    	"fronde",
    	"frugale",
    	"frutta",
    	"fucilata",
    	"fucsia",
    	"fuggente",
    	"fulmine",
    	"fulvo",
    	"fumante",
    	"fumetto",
    	"fumoso",
    	"fune",
    	"funzione",
    	"fuoco",
    	"furbo",
    	"furgone",
    	"furore",
    	"fuso",
    	"futile",
    	"gabbiano",
    	"gaffe",
    	"galateo",
    	"gallina",
    	"galoppo",
    	"gambero",
    	"gamma",
    	"garanzia",
    	"garbo",
    	"garofano",
    	"garzone",
    	"gasdotto",
    	"gasolio",
    	"gastrico",
    	"gatto",
    	"gaudio",
    	"gazebo",
    	"gazzella",
    	"geco",
    	"gelatina",
    	"gelso",
    	"gemello",
    	"gemmato",
    	"gene",
    	"genitore",
    	"gennaio",
    	"genotipo",
    	"gergo",
    	"ghepardo",
    	"ghiaccio",
    	"ghisa",
    	"giallo",
    	"gilda",
    	"ginepro",
    	"giocare",
    	"gioiello",
    	"giorno",
    	"giove",
    	"girato",
    	"girone",
    	"gittata",
    	"giudizio",
    	"giurato",
    	"giusto",
    	"globulo",
    	"glutine",
    	"gnomo",
    	"gobba",
    	"golf",
    	"gomito",
    	"gommone",
    	"gonfio",
    	"gonna",
    	"governo",
    	"gracile",
    	"grado",
    	"grafico",
    	"grammo",
    	"grande",
    	"grattare",
    	"gravoso",
    	"grazia",
    	"greca",
    	"gregge",
    	"grifone",
    	"grigio",
    	"grinza",
    	"grotta",
    	"gruppo",
    	"guadagno",
    	"guaio",
    	"guanto",
    	"guardare",
    	"gufo",
    	"guidare",
    	"ibernato",
    	"icona",
    	"identico",
    	"idillio",
    	"idolo",
    	"idra",
    	"idrico",
    	"idrogeno",
    	"igiene",
    	"ignaro",
    	"ignorato",
    	"ilare",
    	"illeso",
    	"illogico",
    	"illudere",
    	"imballo",
    	"imbevuto",
    	"imbocco",
    	"imbuto",
    	"immane",
    	"immerso",
    	"immolato",
    	"impacco",
    	"impeto",
    	"impiego",
    	"importo",
    	"impronta",
    	"inalare",
    	"inarcare",
    	"inattivo",
    	"incanto",
    	"incendio",
    	"inchino",
    	"incisivo",
    	"incluso",
    	"incontro",
    	"incrocio",
    	"incubo",
    	"indagine",
    	"india",
    	"indole",
    	"inedito",
    	"infatti",
    	"infilare",
    	"inflitto",
    	"ingaggio",
    	"ingegno",
    	"inglese",
    	"ingordo",
    	"ingrosso",
    	"innesco",
    	"inodore",
    	"inoltrare",
    	"inondato",
    	"insano",
    	"insetto",
    	"insieme",
    	"insonnia",
    	"insulina",
    	"intasato",
    	"intero",
    	"intonaco",
    	"intuito",
    	"inumidire",
    	"invalido",
    	"invece",
    	"invito",
    	"iperbole",
    	"ipnotico",
    	"ipotesi",
    	"ippica",
    	"iride",
    	"irlanda",
    	"ironico",
    	"irrigato",
    	"irrorare",
    	"isolato",
    	"isotopo",
    	"isterico",
    	"istituto",
    	"istrice",
    	"italia",
    	"iterare",
    	"labbro",
    	"labirinto",
    	"lacca",
    	"lacerato",
    	"lacrima",
    	"lacuna",
    	"laddove",
    	"lago",
    	"lampo",
    	"lancetta",
    	"lanterna",
    	"lardoso",
    	"larga",
    	"laringe",
    	"lastra",
    	"latenza",
    	"latino",
    	"lattuga",
    	"lavagna",
    	"lavoro",
    	"legale",
    	"leggero",
    	"lembo",
    	"lentezza",
    	"lenza",
    	"leone",
    	"lepre",
    	"lesivo",
    	"lessato",
    	"lesto",
    	"letterale",
    	"leva",
    	"levigato",
    	"libero",
    	"lido",
    	"lievito",
    	"lilla",
    	"limatura",
    	"limitare",
    	"limpido",
    	"lineare",
    	"lingua",
    	"liquido",
    	"lira",
    	"lirica",
    	"lisca",
    	"lite",
    	"litigio",
    	"livrea",
    	"locanda",
    	"lode",
    	"logica",
    	"lombare",
    	"londra",
    	"longevo",
    	"loquace",
    	"lorenzo",
    	"loto",
    	"lotteria",
    	"luce",
    	"lucidato",
    	"lumaca",
    	"luminoso",
    	"lungo",
    	"lupo",
    	"luppolo",
    	"lusinga",
    	"lusso",
    	"lutto",
    	"macabro",
    	"macchina",
    	"macero",
    	"macinato",
    	"madama",
    	"magico",
    	"maglia",
    	"magnete",
    	"magro",
    	"maiolica",
    	"malafede",
    	"malgrado",
    	"malinteso",
    	"malsano",
    	"malto",
    	"malumore",
    	"mana",
    	"mancia",
    	"mandorla",
    	"mangiare",
    	"manifesto",
    	"mannaro",
    	"manovra",
    	"mansarda",
    	"mantide",
    	"manubrio",
    	"mappa",
    	"maratona",
    	"marcire",
    	"maretta",
    	"marmo",
    	"marsupio",
    	"maschera",
    	"massaia",
    	"mastino",
    	"materasso",
    	"matricola",
    	"mattone",
    	"maturo",
    	"mazurca",
    	"meandro",
    	"meccanico",
    	"mecenate",
    	"medesimo",
    	"meditare",
    	"mega",
    	"melassa",
    	"melis",
    	"melodia",
    	"meninge",
    	"meno",
    	"mensola",
    	"mercurio",
    	"merenda",
    	"merlo",
    	"meschino",
    	"mese",
    	"messere",
    	"mestolo",
    	"metallo",
    	"metodo",
    	"mettere",
    	"miagolare",
    	"mica",
    	"micelio",
    	"michele",
    	"microbo",
    	"midollo",
    	"miele",
    	"migliore",
    	"milano",
    	"milite",
    	"mimosa",
    	"minerale",
    	"mini",
    	"minore",
    	"mirino",
    	"mirtillo",
    	"miscela",
    	"missiva",
    	"misto",
    	"misurare",
    	"mitezza",
    	"mitigare",
    	"mitra",
    	"mittente",
    	"mnemonico",
    	"modello",
    	"modifica",
    	"modulo",
    	"mogano",
    	"mogio",
    	"mole",
    	"molosso",
    	"monastero",
    	"monco",
    	"mondina",
    	"monetario",
    	"monile",
    	"monotono",
    	"monsone",
    	"montato",
    	"monviso",
    	"mora",
    	"mordere",
    	"morsicato",
    	"mostro",
    	"motivato",
    	"motosega",
    	"motto",
    	"movenza",
    	"movimento",
    	"mozzo",
    	"mucca",
    	"mucosa",
    	"muffa",
    	"mughetto",
    	"mugnaio",
    	"mulatto",
    	"mulinello",
    	"multiplo",
    	"mummia",
    	"munto",
    	"muovere",
    	"murale",
    	"musa",
    	"muscolo",
    	"musica",
    	"mutevole",
    	"muto",
    	"nababbo",
    	"nafta",
    	"nanometro",
    	"narciso",
    	"narice",
    	"narrato",
    	"nascere",
    	"nastrare",
    	"naturale",
    	"nautica",
    	"naviglio",
    	"nebulosa",
    	"necrosi",
    	"negativo",
    	"negozio",
    	"nemmeno",
    	"neofita",
    	"neretto",
    	"nervo",
    	"nessuno",
    	"nettuno",
    	"neutrale",
    	"neve",
    	"nevrotico",
    	"nicchia",
    	"ninfa",
    	"nitido",
    	"nobile",
    	"nocivo",
    	"nodo",
    	"nome",
    	"nomina",
    	"nordico",
    	"normale",
    	"norvegese",
    	"nostrano",
    	"notare",
    	"notizia",
    	"notturno",
    	"novella",
    	"nucleo",
    	"nulla",
    	"numero",
    	"nuovo",
    	"nutrire",
    	"nuvola",
    	"nuziale",
    	"oasi",
    	"obbedire",
    	"obbligo",
    	"obelisco",
    	"oblio",
    	"obolo",
    	"obsoleto",
    	"occasione",
    	"occhio",
    	"occidente",
    	"occorrere",
    	"occultare",
    	"ocra",
    	"oculato",
    	"odierno",
    	"odorare",
    	"offerta",
    	"offrire",
    	"offuscato",
    	"oggetto",
    	"oggi",
    	"ognuno",
    	"olandese",
    	"olfatto",
    	"oliato",
    	"oliva",
    	"ologramma",
    	"oltre",
    	"omaggio",
    	"ombelico",
    	"ombra",
    	"omega",
    	"omissione",
    	"ondoso",
    	"onere",
    	"onice",
    	"onnivoro",
    	"onorevole",
    	"onta",
    	"operato",
    	"opinione",
    	"opposto",
    	"oracolo",
    	"orafo",
    	"ordine",
    	"orecchino",
    	"orefice",
    	"orfano",
    	"organico",
    	"origine",
    	"orizzonte",
    	"orma",
    	"ormeggio",
    	"ornativo",
    	"orologio",
    	"orrendo",
    	"orribile",
    	"ortensia",
    	"ortica",
    	"orzata",
    	"orzo",
    	"osare",
    	"oscurare",
    	"osmosi",
    	"ospedale",
    	"ospite",
    	"ossa",
    	"ossidare",
    	"ostacolo",
    	"oste",
    	"otite",
    	"otre",
    	"ottagono",
    	"ottimo",
    	"ottobre",
    	"ovale",
    	"ovest",
    	"ovino",
    	"oviparo",
    	"ovocito",
    	"ovunque",
    	"ovviare",
    	"ozio",
    	"pacchetto",
    	"pace",
    	"pacifico",
    	"padella",
    	"padrone",
    	"paese",
    	"paga",
    	"pagina",
    	"palazzina",
    	"palesare",
    	"pallido",
    	"palo",
    	"palude",
    	"pandoro",
    	"pannello",
    	"paolo",
    	"paonazzo",
    	"paprica",
    	"parabola",
    	"parcella",
    	"parere",
    	"pargolo",
    	"pari",
    	"parlato",
    	"parola",
    	"partire",
    	"parvenza",
    	"parziale",
    	"passivo",
    	"pasticca",
    	"patacca",
    	"patologia",
    	"pattume",
    	"pavone",
    	"peccato",
    	"pedalare",
    	"pedonale",
    	"peggio",
    	"peloso",
    	"penare",
    	"pendice",
    	"penisola",
    	"pennuto",
    	"penombra",
    	"pensare",
    	"pentola",
    	"pepe",
    	"pepita",
    	"perbene",
    	"percorso",
    	"perdonato",
    	"perforare",
    	"pergamena",
    	"periodo",
    	"permesso",
    	"perno",
    	"perplesso",
    	"persuaso",
    	"pertugio",
    	"pervaso",
    	"pesatore",
    	"pesista",
    	"peso",
    	"pestifero",
    	"petalo",
    	"pettine",
    	"petulante",
    	"pezzo",
    	"piacere",
    	"pianta",
    	"piattino",
    	"piccino",
    	"picozza",
    	"piega",
    	"pietra",
    	"piffero",
    	"pigiama",
    	"pigolio",
    	"pigro",
    	"pila",
    	"pilifero",
    	"pillola",
    	"pilota",
    	"pimpante",
    	"pineta",
    	"pinna",
    	"pinolo",
    	"pioggia",
    	"piombo",
    	"piramide",
    	"piretico",
    	"pirite",
    	"pirolisi",
    	"pitone",
    	"pizzico",
    	"placebo",
    	"planare",
    	"plasma",
    	"platano",
    	"plenario",
    	"pochezza",
    	"poderoso",
    	"podismo",
    	"poesia",
    	"poggiare",
    	"polenta",
    	"poligono",
    	"pollice",
    	"polmonite",
    	"polpetta",
    	"polso",
    	"poltrona",
    	"polvere",
    	"pomice",
    	"pomodoro",
    	"ponte",
    	"popoloso",
    	"porfido",
    	"poroso",
    	"porpora",
    	"porre",
    	"portata",
    	"posa",
    	"positivo",
    	"possesso",
    	"postulato",
    	"potassio",
    	"potere",
    	"pranzo",
    	"prassi",
    	"pratica",
    	"precluso",
    	"predica",
    	"prefisso",
    	"pregiato",
    	"prelievo",
    	"premere",
    	"prenotare",
    	"preparato",
    	"presenza",
    	"pretesto",
    	"prevalso",
    	"prima",
    	"principe",
    	"privato",
    	"problema",
    	"procura",
    	"produrre",
    	"profumo",
    	"progetto",
    	"prolunga",
    	"promessa",
    	"pronome",
    	"proposta",
    	"proroga",
    	"proteso",
    	"prova",
    	"prudente",
    	"prugna",
    	"prurito",
    	"psiche",
    	"pubblico",
    	"pudica",
    	"pugilato",
    	"pugno",
    	"pulce",
    	"pulito",
    	"pulsante",
    	"puntare",
    	"pupazzo",
    	"pupilla",
    	"puro",
    	"quadro",
    	"qualcosa",
    	"quasi",
    	"querela",
    	"quota",
    	"raccolto",
    	"raddoppio",
    	"radicale",
    	"radunato",
    	"raffica",
    	"ragazzo",
    	"ragione",
    	"ragno",
    	"ramarro",
    	"ramingo",
    	"ramo",
    	"randagio",
    	"rantolare",
    	"rapato",
    	"rapina",
    	"rappreso",
    	"rasatura",
    	"raschiato",
    	"rasente",
    	"rassegna",
    	"rastrello",
    	"rata",
    	"ravveduto",
    	"reale",
    	"recepire",
    	"recinto",
    	"recluta",
    	"recondito",
    	"recupero",
    	"reddito",
    	"redimere",
    	"regalato",
    	"registro",
    	"regola",
    	"regresso",
    	"relazione",
    	"remare",
    	"remoto",
    	"renna",
    	"replica",
    	"reprimere",
    	"reputare",
    	"resa",
    	"residente",
    	"responso",
    	"restauro",
    	"rete",
    	"retina",
    	"retorica",
    	"rettifica",
    	"revocato",
    	"riassunto",
    	"ribadire",
    	"ribelle",
    	"ribrezzo",
    	"ricarica",
    	"ricco",
    	"ricevere",
    	"riciclato",
    	"ricordo",
    	"ricreduto",
    	"ridicolo",
    	"ridurre",
    	"rifasare",
    	"riflesso",
    	"riforma",
    	"rifugio",
    	"rigare",
    	"rigettato",
    	"righello",
    	"rilassato",
    	"rilevato",
    	"rimanere",
    	"rimbalzo",
    	"rimedio",
    	"rimorchio",
    	"rinascita",
    	"rincaro",
    	"rinforzo",
    	"rinnovo",
    	"rinomato",
    	"rinsavito",
    	"rintocco",
    	"rinuncia",
    	"rinvenire",
    	"riparato",
    	"ripetuto",
    	"ripieno",
    	"riportare",
    	"ripresa",
    	"ripulire",
    	"risata",
    	"rischio",
    	"riserva",
    	"risibile",
    	"riso",
    	"rispetto",
    	"ristoro",
    	"risultato",
    	"risvolto",
    	"ritardo",
    	"ritegno",
    	"ritmico",
    	"ritrovo",
    	"riunione",
    	"riva",
    	"riverso",
    	"rivincita",
    	"rivolto",
    	"rizoma",
    	"roba",
    	"robotico",
    	"robusto",
    	"roccia",
    	"roco",
    	"rodaggio",
    	"rodere",
    	"roditore",
    	"rogito",
    	"rollio",
    	"romantico",
    	"rompere",
    	"ronzio",
    	"rosolare",
    	"rospo",
    	"rotante",
    	"rotondo",
    	"rotula",
    	"rovescio",
    	"rubizzo",
    	"rubrica",
    	"ruga",
    	"rullino",
    	"rumine",
    	"rumoroso",
    	"ruolo",
    	"rupe",
    	"russare",
    	"rustico",
    	"sabato",
    	"sabbiare",
    	"sabotato",
    	"sagoma",
    	"salasso",
    	"saldatura",
    	"salgemma",
    	"salivare",
    	"salmone",
    	"salone",
    	"saltare",
    	"saluto",
    	"salvo",
    	"sapere",
    	"sapido",
    	"saporito",
    	"saraceno",
    	"sarcasmo",
    	"sarto",
    	"sassoso",
    	"satellite",
    	"satira",
    	"satollo",
    	"saturno",
    	"savana",
    	"savio",
    	"saziato",
    	"sbadiglio",
    	"sbalzo",
    	"sbancato",
    	"sbarra",
    	"sbattere",
    	"sbavare",
    	"sbendare",
    	"sbirciare",
    	"sbloccato",
    	"sbocciato",
    	"sbrinare",
    	"sbruffone",
    	"sbuffare",
    	"scabroso",
    	"scadenza",
    	"scala",
    	"scambiare",
    	"scandalo",
    	"scapola",
    	"scarso",
    	"scatenare",
    	"scavato",
    	"scelto",
    	"scenico",
    	"scettro",
    	"scheda",
    	"schiena",
    	"sciarpa",
    	"scienza",
    	"scindere",
    	"scippo",
    	"sciroppo",
    	"scivolo",
    	"sclerare",
    	"scodella",
    	"scolpito",
    	"scomparto",
    	"sconforto",
    	"scoprire",
    	"scorta",
    	"scossone",
    	"scozzese",
    	"scriba",
    	"scrollare",
    	"scrutinio",
    	"scuderia",
    	"scultore",
    	"scuola",
    	"scuro",
    	"scusare",
    	"sdebitare",
    	"sdoganare",
    	"seccatura",
    	"secondo",
    	"sedano",
    	"seggiola",
    	"segnalato",
    	"segregato",
    	"seguito",
    	"selciato",
    	"selettivo",
    	"sella",
    	"selvaggio",
    	"semaforo",
    	"sembrare",
    	"seme",
    	"seminato",
    	"sempre",
    	"senso",
    	"sentire",
    	"sepolto",
    	"sequenza",
    	"serata",
    	"serbato",
    	"sereno",
    	"serio",
    	"serpente",
    	"serraglio",
    	"servire",
    	"sestina",
    	"setola",
    	"settimana",
    	"sfacelo",
    	"sfaldare",
    	"sfamato",
    	"sfarzoso",
    	"sfaticato",
    	"sfera",
    	"sfida",
    	"sfilato",
    	"sfinge",
    	"sfocato",
    	"sfoderare",
    	"sfogo",
    	"sfoltire",
    	"sforzato",
    	"sfratto",
    	"sfruttato",
    	"sfuggito",
    	"sfumare",
    	"sfuso",
    	"sgabello",
    	"sgarbato",
    	"sgonfiare",
    	"sgorbio",
    	"sgrassato",
    	"sguardo",
    	"sibilo",
    	"siccome",
    	"sierra",
    	"sigla",
    	"signore",
    	"silenzio",
    	"sillaba",
    	"simbolo",
    	"simpatico",
    	"simulato",
    	"sinfonia",
    	"singolo",
    	"sinistro",
    	"sino",
    	"sintesi",
    	"sinusoide",
    	"sipario",
    	"sisma",
    	"sistole",
    	"situato",
    	"slitta",
    	"slogatura",
    	"sloveno",
    	"smarrito",
    	"smemorato",
    	"smentito",
    	"smeraldo",
    	"smilzo",
    	"smontare",
    	"smottato",
    	"smussato",
    	"snellire",
    	"snervato",
    	"snodo",
    	"sobbalzo",
    	"sobrio",
    	"soccorso",
    	"sociale",
    	"sodale",
    	"soffitto",
    	"sogno",
    	"soldato",
    	"solenne",
    	"solido",
    	"sollazzo",
    	"solo",
    	"solubile",
    	"solvente",
    	"somatico",
    	"somma",
    	"sonda",
    	"sonetto",
    	"sonnifero",
    	"sopire",
    	"soppeso",
    	"sopra",
    	"sorgere",
    	"sorpasso",
    	"sorriso",
    	"sorso",
    	"sorteggio",
    	"sorvolato",
    	"sospiro",
    	"sosta",
    	"sottile",
    	"spada",
    	"spalla",
    	"spargere",
    	"spatola",
    	"spavento",
    	"spazzola",
    	"specie",
    	"spedire",
    	"spegnere",
    	"spelatura",
    	"speranza",
    	"spessore",
    	"spettrale",
    	"spezzato",
    	"spia",
    	"spigoloso",
    	"spillato",
    	"spinoso",
    	"spirale",
    	"splendido",
    	"sportivo",
    	"sposo",
    	"spranga",
    	"sprecare",
    	"spronato",
    	"spruzzo",
    	"spuntino",
    	"squillo",
    	"sradicare",
    	"srotolato",
    	"stabile",
    	"stacco",
    	"staffa",
    	"stagnare",
    	"stampato",
    	"stantio",
    	"starnuto",
    	"stasera",
    	"statuto",
    	"stelo",
    	"steppa",
    	"sterzo",
    	"stiletto",
    	"stima",
    	"stirpe",
    	"stivale",
    	"stizzoso",
    	"stonato",
    	"storico",
    	"strappo",
    	"stregato",
    	"stridulo",
    	"strozzare",
    	"strutto",
    	"stuccare",
    	"stufo",
    	"stupendo",
    	"subentro",
    	"succoso",
    	"sudore",
    	"suggerito",
    	"sugo",
    	"sultano",
    	"suonare",
    	"superbo",
    	"supporto",
    	"surgelato",
    	"surrogato",
    	"sussurro",
    	"sutura",
    	"svagare",
    	"svedese",
    	"sveglio",
    	"svelare",
    	"svenuto",
    	"svezia",
    	"sviluppo",
    	"svista",
    	"svizzera",
    	"svolta",
    	"svuotare",
    	"tabacco",
    	"tabulato",
    	"tacciare",
    	"taciturno",
    	"tale",
    	"talismano",
    	"tampone",
    	"tannino",
    	"tara",
    	"tardivo",
    	"targato",
    	"tariffa",
    	"tarpare",
    	"tartaruga",
    	"tasto",
    	"tattico",
    	"taverna",
    	"tavolata",
    	"tazza",
    	"teca",
    	"tecnico",
    	"telefono",
    	"temerario",
    	"tempo",
    	"temuto",
    	"tendone",
    	"tenero",
    	"tensione",
    	"tentacolo",
    	"teorema",
    	"terme",
    	"terrazzo",
    	"terzetto",
    	"tesi",
    	"tesserato",
    	"testato",
    	"tetro",
    	"tettoia",
    	"tifare",
    	"tigella",
    	"timbro",
    	"tinto",
    	"tipico",
    	"tipografo",
    	"tiraggio",
    	"tiro",
    	"titanio",
    	"titolo",
    	"titubante",
    	"tizio",
    	"tizzone",
    	"toccare",
    	"tollerare",
    	"tolto",
    	"tombola",
    	"tomo",
    	"tonfo",
    	"tonsilla",
    	"topazio",
    	"topologia",
    	"toppa",
    	"torba",
    	"tornare",
    	"torrone",
    	"tortora",
    	"toscano",
    	"tossire",
    	"tostatura",
    	"totano",
    	"trabocco",
    	"trachea",
    	"trafila",
    	"tragedia",
    	"tralcio",
    	"tramonto",
    	"transito",
    	"trapano",
    	"trarre",
    	"trasloco",
    	"trattato",
    	"trave",
    	"treccia",
    	"tremolio",
    	"trespolo",
    	"tributo",
    	"tricheco",
    	"trifoglio",
    	"trillo",
    	"trincea",
    	"trio",
    	"tristezza",
    	"triturato",
    	"trivella",
    	"tromba",
    	"trono",
    	"troppo",
    	"trottola",
    	"trovare",
    	"truccato",
    	"tubatura",
    	"tuffato",
    	"tulipano",
    	"tumulto",
    	"tunisia",
    	"turbare",
    	"turchino",
    	"tuta",
    	"tutela",
    	"ubicato",
    	"uccello",
    	"uccisore",
    	"udire",
    	"uditivo",
    	"uffa",
    	"ufficio",
    	"uguale",
    	"ulisse",
    	"ultimato",
    	"umano",
    	"umile",
    	"umorismo",
    	"uncinetto",
    	"ungere",
    	"ungherese",
    	"unicorno",
    	"unificato",
    	"unisono",
    	"unitario",
    	"unte",
    	"uovo",
    	"upupa",
    	"uragano",
    	"urgenza",
    	"urlo",
    	"usanza",
    	"usato",
    	"uscito",
    	"usignolo",
    	"usuraio",
    	"utensile",
    	"utilizzo",
    	"utopia",
    	"vacante",
    	"vaccinato",
    	"vagabondo",
    	"vagliato",
    	"valanga",
    	"valgo",
    	"valico",
    	"valletta",
    	"valoroso",
    	"valutare",
    	"valvola",
    	"vampata",
    	"vangare",
    	"vanitoso",
    	"vano",
    	"vantaggio",
    	"vanvera",
    	"vapore",
    	"varano",
    	"varcato",
    	"variante",
    	"vasca",
    	"vedetta",
    	"vedova",
    	"veduto",
    	"vegetale",
    	"veicolo",
    	"velcro",
    	"velina",
    	"velluto",
    	"veloce",
    	"venato",
    	"vendemmia",
    	"vento",
    	"verace",
    	"verbale",
    	"vergogna",
    	"verifica",
    	"vero",
    	"verruca",
    	"verticale",
    	"vescica",
    	"vessillo",
    	"vestale",
    	"veterano",
    	"vetrina",
    	"vetusto",
    	"viandante",
    	"vibrante",
    	"vicenda",
    	"vichingo",
    	"vicinanza",
    	"vidimare",
    	"vigilia",
    	"vigneto",
    	"vigore",
    	"vile",
    	"villano",
    	"vimini",
    	"vincitore",
    	"viola",
    	"vipera",
    	"virgola",
    	"virologo",
    	"virulento",
    	"viscoso",
    	"visione",
    	"vispo",
    	"vissuto",
    	"visura",
    	"vita",
    	"vitello",
    	"vittima",
    	"vivanda",
    	"vivido",
    	"viziare",
    	"voce",
    	"voga",
    	"volatile",
    	"volere",
    	"volpe",
    	"voragine",
    	"vulcano",
    	"zampogna",
    	"zanna",
    	"zappato",
    	"zattera",
    	"zavorra",
    	"zefiro",
    	"zelante",
    	"zelo",
    	"zenzero",
    	"zerbino",
    	"zibetto",
    	"zinco",
    	"zircone",
    	"zitto",
    	"zolla",
    	"zotico",
    	"zucchero",
    	"zufolo",
    	"zulu",
    	"zuppa"
    ];

    var require$$10 = [
    	"あいこくしん",
    	"あいさつ",
    	"あいだ",
    	"あおぞら",
    	"あかちゃん",
    	"あきる",
    	"あけがた",
    	"あける",
    	"あこがれる",
    	"あさい",
    	"あさひ",
    	"あしあと",
    	"あじわう",
    	"あずかる",
    	"あずき",
    	"あそぶ",
    	"あたえる",
    	"あたためる",
    	"あたりまえ",
    	"あたる",
    	"あつい",
    	"あつかう",
    	"あっしゅく",
    	"あつまり",
    	"あつめる",
    	"あてな",
    	"あてはまる",
    	"あひる",
    	"あぶら",
    	"あぶる",
    	"あふれる",
    	"あまい",
    	"あまど",
    	"あまやかす",
    	"あまり",
    	"あみもの",
    	"あめりか",
    	"あやまる",
    	"あゆむ",
    	"あらいぐま",
    	"あらし",
    	"あらすじ",
    	"あらためる",
    	"あらゆる",
    	"あらわす",
    	"ありがとう",
    	"あわせる",
    	"あわてる",
    	"あんい",
    	"あんがい",
    	"あんこ",
    	"あんぜん",
    	"あんてい",
    	"あんない",
    	"あんまり",
    	"いいだす",
    	"いおん",
    	"いがい",
    	"いがく",
    	"いきおい",
    	"いきなり",
    	"いきもの",
    	"いきる",
    	"いくじ",
    	"いくぶん",
    	"いけばな",
    	"いけん",
    	"いこう",
    	"いこく",
    	"いこつ",
    	"いさましい",
    	"いさん",
    	"いしき",
    	"いじゅう",
    	"いじょう",
    	"いじわる",
    	"いずみ",
    	"いずれ",
    	"いせい",
    	"いせえび",
    	"いせかい",
    	"いせき",
    	"いぜん",
    	"いそうろう",
    	"いそがしい",
    	"いだい",
    	"いだく",
    	"いたずら",
    	"いたみ",
    	"いたりあ",
    	"いちおう",
    	"いちじ",
    	"いちど",
    	"いちば",
    	"いちぶ",
    	"いちりゅう",
    	"いつか",
    	"いっしゅん",
    	"いっせい",
    	"いっそう",
    	"いったん",
    	"いっち",
    	"いってい",
    	"いっぽう",
    	"いてざ",
    	"いてん",
    	"いどう",
    	"いとこ",
    	"いない",
    	"いなか",
    	"いねむり",
    	"いのち",
    	"いのる",
    	"いはつ",
    	"いばる",
    	"いはん",
    	"いびき",
    	"いひん",
    	"いふく",
    	"いへん",
    	"いほう",
    	"いみん",
    	"いもうと",
    	"いもたれ",
    	"いもり",
    	"いやがる",
    	"いやす",
    	"いよかん",
    	"いよく",
    	"いらい",
    	"いらすと",
    	"いりぐち",
    	"いりょう",
    	"いれい",
    	"いれもの",
    	"いれる",
    	"いろえんぴつ",
    	"いわい",
    	"いわう",
    	"いわかん",
    	"いわば",
    	"いわゆる",
    	"いんげんまめ",
    	"いんさつ",
    	"いんしょう",
    	"いんよう",
    	"うえき",
    	"うえる",
    	"うおざ",
    	"うがい",
    	"うかぶ",
    	"うかべる",
    	"うきわ",
    	"うくらいな",
    	"うくれれ",
    	"うけたまわる",
    	"うけつけ",
    	"うけとる",
    	"うけもつ",
    	"うける",
    	"うごかす",
    	"うごく",
    	"うこん",
    	"うさぎ",
    	"うしなう",
    	"うしろがみ",
    	"うすい",
    	"うすぎ",
    	"うすぐらい",
    	"うすめる",
    	"うせつ",
    	"うちあわせ",
    	"うちがわ",
    	"うちき",
    	"うちゅう",
    	"うっかり",
    	"うつくしい",
    	"うったえる",
    	"うつる",
    	"うどん",
    	"うなぎ",
    	"うなじ",
    	"うなずく",
    	"うなる",
    	"うねる",
    	"うのう",
    	"うぶげ",
    	"うぶごえ",
    	"うまれる",
    	"うめる",
    	"うもう",
    	"うやまう",
    	"うよく",
    	"うらがえす",
    	"うらぐち",
    	"うらない",
    	"うりあげ",
    	"うりきれ",
    	"うるさい",
    	"うれしい",
    	"うれゆき",
    	"うれる",
    	"うろこ",
    	"うわき",
    	"うわさ",
    	"うんこう",
    	"うんちん",
    	"うんてん",
    	"うんどう",
    	"えいえん",
    	"えいが",
    	"えいきょう",
    	"えいご",
    	"えいせい",
    	"えいぶん",
    	"えいよう",
    	"えいわ",
    	"えおり",
    	"えがお",
    	"えがく",
    	"えきたい",
    	"えくせる",
    	"えしゃく",
    	"えすて",
    	"えつらん",
    	"えのぐ",
    	"えほうまき",
    	"えほん",
    	"えまき",
    	"えもじ",
    	"えもの",
    	"えらい",
    	"えらぶ",
    	"えりあ",
    	"えんえん",
    	"えんかい",
    	"えんぎ",
    	"えんげき",
    	"えんしゅう",
    	"えんぜつ",
    	"えんそく",
    	"えんちょう",
    	"えんとつ",
    	"おいかける",
    	"おいこす",
    	"おいしい",
    	"おいつく",
    	"おうえん",
    	"おうさま",
    	"おうじ",
    	"おうせつ",
    	"おうたい",
    	"おうふく",
    	"おうべい",
    	"おうよう",
    	"おえる",
    	"おおい",
    	"おおう",
    	"おおどおり",
    	"おおや",
    	"おおよそ",
    	"おかえり",
    	"おかず",
    	"おがむ",
    	"おかわり",
    	"おぎなう",
    	"おきる",
    	"おくさま",
    	"おくじょう",
    	"おくりがな",
    	"おくる",
    	"おくれる",
    	"おこす",
    	"おこなう",
    	"おこる",
    	"おさえる",
    	"おさない",
    	"おさめる",
    	"おしいれ",
    	"おしえる",
    	"おじぎ",
    	"おじさん",
    	"おしゃれ",
    	"おそらく",
    	"おそわる",
    	"おたがい",
    	"おたく",
    	"おだやか",
    	"おちつく",
    	"おっと",
    	"おつり",
    	"おでかけ",
    	"おとしもの",
    	"おとなしい",
    	"おどり",
    	"おどろかす",
    	"おばさん",
    	"おまいり",
    	"おめでとう",
    	"おもいで",
    	"おもう",
    	"おもたい",
    	"おもちゃ",
    	"おやつ",
    	"おやゆび",
    	"およぼす",
    	"おらんだ",
    	"おろす",
    	"おんがく",
    	"おんけい",
    	"おんしゃ",
    	"おんせん",
    	"おんだん",
    	"おんちゅう",
    	"おんどけい",
    	"かあつ",
    	"かいが",
    	"がいき",
    	"がいけん",
    	"がいこう",
    	"かいさつ",
    	"かいしゃ",
    	"かいすいよく",
    	"かいぜん",
    	"かいぞうど",
    	"かいつう",
    	"かいてん",
    	"かいとう",
    	"かいふく",
    	"がいへき",
    	"かいほう",
    	"かいよう",
    	"がいらい",
    	"かいわ",
    	"かえる",
    	"かおり",
    	"かかえる",
    	"かがく",
    	"かがし",
    	"かがみ",
    	"かくご",
    	"かくとく",
    	"かざる",
    	"がぞう",
    	"かたい",
    	"かたち",
    	"がちょう",
    	"がっきゅう",
    	"がっこう",
    	"がっさん",
    	"がっしょう",
    	"かなざわし",
    	"かのう",
    	"がはく",
    	"かぶか",
    	"かほう",
    	"かほご",
    	"かまう",
    	"かまぼこ",
    	"かめれおん",
    	"かゆい",
    	"かようび",
    	"からい",
    	"かるい",
    	"かろう",
    	"かわく",
    	"かわら",
    	"がんか",
    	"かんけい",
    	"かんこう",
    	"かんしゃ",
    	"かんそう",
    	"かんたん",
    	"かんち",
    	"がんばる",
    	"きあい",
    	"きあつ",
    	"きいろ",
    	"ぎいん",
    	"きうい",
    	"きうん",
    	"きえる",
    	"きおう",
    	"きおく",
    	"きおち",
    	"きおん",
    	"きかい",
    	"きかく",
    	"きかんしゃ",
    	"ききて",
    	"きくばり",
    	"きくらげ",
    	"きけんせい",
    	"きこう",
    	"きこえる",
    	"きこく",
    	"きさい",
    	"きさく",
    	"きさま",
    	"きさらぎ",
    	"ぎじかがく",
    	"ぎしき",
    	"ぎじたいけん",
    	"ぎじにってい",
    	"ぎじゅつしゃ",
    	"きすう",
    	"きせい",
    	"きせき",
    	"きせつ",
    	"きそう",
    	"きぞく",
    	"きぞん",
    	"きたえる",
    	"きちょう",
    	"きつえん",
    	"ぎっちり",
    	"きつつき",
    	"きつね",
    	"きてい",
    	"きどう",
    	"きどく",
    	"きない",
    	"きなが",
    	"きなこ",
    	"きぬごし",
    	"きねん",
    	"きのう",
    	"きのした",
    	"きはく",
    	"きびしい",
    	"きひん",
    	"きふく",
    	"きぶん",
    	"きぼう",
    	"きほん",
    	"きまる",
    	"きみつ",
    	"きむずかしい",
    	"きめる",
    	"きもだめし",
    	"きもち",
    	"きもの",
    	"きゃく",
    	"きやく",
    	"ぎゅうにく",
    	"きよう",
    	"きょうりゅう",
    	"きらい",
    	"きらく",
    	"きりん",
    	"きれい",
    	"きれつ",
    	"きろく",
    	"ぎろん",
    	"きわめる",
    	"ぎんいろ",
    	"きんかくじ",
    	"きんじょ",
    	"きんようび",
    	"ぐあい",
    	"くいず",
    	"くうかん",
    	"くうき",
    	"くうぐん",
    	"くうこう",
    	"ぐうせい",
    	"くうそう",
    	"ぐうたら",
    	"くうふく",
    	"くうぼ",
    	"くかん",
    	"くきょう",
    	"くげん",
    	"ぐこう",
    	"くさい",
    	"くさき",
    	"くさばな",
    	"くさる",
    	"くしゃみ",
    	"くしょう",
    	"くすのき",
    	"くすりゆび",
    	"くせげ",
    	"くせん",
    	"ぐたいてき",
    	"くださる",
    	"くたびれる",
    	"くちこみ",
    	"くちさき",
    	"くつした",
    	"ぐっすり",
    	"くつろぐ",
    	"くとうてん",
    	"くどく",
    	"くなん",
    	"くねくね",
    	"くのう",
    	"くふう",
    	"くみあわせ",
    	"くみたてる",
    	"くめる",
    	"くやくしょ",
    	"くらす",
    	"くらべる",
    	"くるま",
    	"くれる",
    	"くろう",
    	"くわしい",
    	"ぐんかん",
    	"ぐんしょく",
    	"ぐんたい",
    	"ぐんて",
    	"けあな",
    	"けいかく",
    	"けいけん",
    	"けいこ",
    	"けいさつ",
    	"げいじゅつ",
    	"けいたい",
    	"げいのうじん",
    	"けいれき",
    	"けいろ",
    	"けおとす",
    	"けおりもの",
    	"げきか",
    	"げきげん",
    	"げきだん",
    	"げきちん",
    	"げきとつ",
    	"げきは",
    	"げきやく",
    	"げこう",
    	"げこくじょう",
    	"げざい",
    	"けさき",
    	"げざん",
    	"けしき",
    	"けしごむ",
    	"けしょう",
    	"げすと",
    	"けたば",
    	"けちゃっぷ",
    	"けちらす",
    	"けつあつ",
    	"けつい",
    	"けつえき",
    	"けっこん",
    	"けつじょ",
    	"けっせき",
    	"けってい",
    	"けつまつ",
    	"げつようび",
    	"げつれい",
    	"けつろん",
    	"げどく",
    	"けとばす",
    	"けとる",
    	"けなげ",
    	"けなす",
    	"けなみ",
    	"けぬき",
    	"げねつ",
    	"けねん",
    	"けはい",
    	"げひん",
    	"けぶかい",
    	"げぼく",
    	"けまり",
    	"けみかる",
    	"けむし",
    	"けむり",
    	"けもの",
    	"けらい",
    	"けろけろ",
    	"けわしい",
    	"けんい",
    	"けんえつ",
    	"けんお",
    	"けんか",
    	"げんき",
    	"けんげん",
    	"けんこう",
    	"けんさく",
    	"けんしゅう",
    	"けんすう",
    	"げんそう",
    	"けんちく",
    	"けんてい",
    	"けんとう",
    	"けんない",
    	"けんにん",
    	"げんぶつ",
    	"けんま",
    	"けんみん",
    	"けんめい",
    	"けんらん",
    	"けんり",
    	"こあくま",
    	"こいぬ",
    	"こいびと",
    	"ごうい",
    	"こうえん",
    	"こうおん",
    	"こうかん",
    	"ごうきゅう",
    	"ごうけい",
    	"こうこう",
    	"こうさい",
    	"こうじ",
    	"こうすい",
    	"ごうせい",
    	"こうそく",
    	"こうたい",
    	"こうちゃ",
    	"こうつう",
    	"こうてい",
    	"こうどう",
    	"こうない",
    	"こうはい",
    	"ごうほう",
    	"ごうまん",
    	"こうもく",
    	"こうりつ",
    	"こえる",
    	"こおり",
    	"ごかい",
    	"ごがつ",
    	"ごかん",
    	"こくご",
    	"こくさい",
    	"こくとう",
    	"こくない",
    	"こくはく",
    	"こぐま",
    	"こけい",
    	"こける",
    	"ここのか",
    	"こころ",
    	"こさめ",
    	"こしつ",
    	"こすう",
    	"こせい",
    	"こせき",
    	"こぜん",
    	"こそだて",
    	"こたい",
    	"こたえる",
    	"こたつ",
    	"こちょう",
    	"こっか",
    	"こつこつ",
    	"こつばん",
    	"こつぶ",
    	"こてい",
    	"こてん",
    	"ことがら",
    	"ことし",
    	"ことば",
    	"ことり",
    	"こなごな",
    	"こねこね",
    	"このまま",
    	"このみ",
    	"このよ",
    	"ごはん",
    	"こひつじ",
    	"こふう",
    	"こふん",
    	"こぼれる",
    	"ごまあぶら",
    	"こまかい",
    	"ごますり",
    	"こまつな",
    	"こまる",
    	"こむぎこ",
    	"こもじ",
    	"こもち",
    	"こもの",
    	"こもん",
    	"こやく",
    	"こやま",
    	"こゆう",
    	"こゆび",
    	"こよい",
    	"こよう",
    	"こりる",
    	"これくしょん",
    	"ころっけ",
    	"こわもて",
    	"こわれる",
    	"こんいん",
    	"こんかい",
    	"こんき",
    	"こんしゅう",
    	"こんすい",
    	"こんだて",
    	"こんとん",
    	"こんなん",
    	"こんびに",
    	"こんぽん",
    	"こんまけ",
    	"こんや",
    	"こんれい",
    	"こんわく",
    	"ざいえき",
    	"さいかい",
    	"さいきん",
    	"ざいげん",
    	"ざいこ",
    	"さいしょ",
    	"さいせい",
    	"ざいたく",
    	"ざいちゅう",
    	"さいてき",
    	"ざいりょう",
    	"さうな",
    	"さかいし",
    	"さがす",
    	"さかな",
    	"さかみち",
    	"さがる",
    	"さぎょう",
    	"さくし",
    	"さくひん",
    	"さくら",
    	"さこく",
    	"さこつ",
    	"さずかる",
    	"ざせき",
    	"さたん",
    	"さつえい",
    	"ざつおん",
    	"ざっか",
    	"ざつがく",
    	"さっきょく",
    	"ざっし",
    	"さつじん",
    	"ざっそう",
    	"さつたば",
    	"さつまいも",
    	"さてい",
    	"さといも",
    	"さとう",
    	"さとおや",
    	"さとし",
    	"さとる",
    	"さのう",
    	"さばく",
    	"さびしい",
    	"さべつ",
    	"さほう",
    	"さほど",
    	"さます",
    	"さみしい",
    	"さみだれ",
    	"さむけ",
    	"さめる",
    	"さやえんどう",
    	"さゆう",
    	"さよう",
    	"さよく",
    	"さらだ",
    	"ざるそば",
    	"さわやか",
    	"さわる",
    	"さんいん",
    	"さんか",
    	"さんきゃく",
    	"さんこう",
    	"さんさい",
    	"ざんしょ",
    	"さんすう",
    	"さんせい",
    	"さんそ",
    	"さんち",
    	"さんま",
    	"さんみ",
    	"さんらん",
    	"しあい",
    	"しあげ",
    	"しあさって",
    	"しあわせ",
    	"しいく",
    	"しいん",
    	"しうち",
    	"しえい",
    	"しおけ",
    	"しかい",
    	"しかく",
    	"じかん",
    	"しごと",
    	"しすう",
    	"じだい",
    	"したうけ",
    	"したぎ",
    	"したて",
    	"したみ",
    	"しちょう",
    	"しちりん",
    	"しっかり",
    	"しつじ",
    	"しつもん",
    	"してい",
    	"してき",
    	"してつ",
    	"じてん",
    	"じどう",
    	"しなぎれ",
    	"しなもの",
    	"しなん",
    	"しねま",
    	"しねん",
    	"しのぐ",
    	"しのぶ",
    	"しはい",
    	"しばかり",
    	"しはつ",
    	"しはらい",
    	"しはん",
    	"しひょう",
    	"しふく",
    	"じぶん",
    	"しへい",
    	"しほう",
    	"しほん",
    	"しまう",
    	"しまる",
    	"しみん",
    	"しむける",
    	"じむしょ",
    	"しめい",
    	"しめる",
    	"しもん",
    	"しゃいん",
    	"しゃうん",
    	"しゃおん",
    	"じゃがいも",
    	"しやくしょ",
    	"しゃくほう",
    	"しゃけん",
    	"しゃこ",
    	"しゃざい",
    	"しゃしん",
    	"しゃせん",
    	"しゃそう",
    	"しゃたい",
    	"しゃちょう",
    	"しゃっきん",
    	"じゃま",
    	"しゃりん",
    	"しゃれい",
    	"じゆう",
    	"じゅうしょ",
    	"しゅくはく",
    	"じゅしん",
    	"しゅっせき",
    	"しゅみ",
    	"しゅらば",
    	"じゅんばん",
    	"しょうかい",
    	"しょくたく",
    	"しょっけん",
    	"しょどう",
    	"しょもつ",
    	"しらせる",
    	"しらべる",
    	"しんか",
    	"しんこう",
    	"じんじゃ",
    	"しんせいじ",
    	"しんちく",
    	"しんりん",
    	"すあげ",
    	"すあし",
    	"すあな",
    	"ずあん",
    	"すいえい",
    	"すいか",
    	"すいとう",
    	"ずいぶん",
    	"すいようび",
    	"すうがく",
    	"すうじつ",
    	"すうせん",
    	"すおどり",
    	"すきま",
    	"すくう",
    	"すくない",
    	"すける",
    	"すごい",
    	"すこし",
    	"ずさん",
    	"すずしい",
    	"すすむ",
    	"すすめる",
    	"すっかり",
    	"ずっしり",
    	"ずっと",
    	"すてき",
    	"すてる",
    	"すねる",
    	"すのこ",
    	"すはだ",
    	"すばらしい",
    	"ずひょう",
    	"ずぶぬれ",
    	"すぶり",
    	"すふれ",
    	"すべて",
    	"すべる",
    	"ずほう",
    	"すぼん",
    	"すまい",
    	"すめし",
    	"すもう",
    	"すやき",
    	"すらすら",
    	"するめ",
    	"すれちがう",
    	"すろっと",
    	"すわる",
    	"すんぜん",
    	"すんぽう",
    	"せあぶら",
    	"せいかつ",
    	"せいげん",
    	"せいじ",
    	"せいよう",
    	"せおう",
    	"せかいかん",
    	"せきにん",
    	"せきむ",
    	"せきゆ",
    	"せきらんうん",
    	"せけん",
    	"せこう",
    	"せすじ",
    	"せたい",
    	"せたけ",
    	"せっかく",
    	"せっきゃく",
    	"ぜっく",
    	"せっけん",
    	"せっこつ",
    	"せっさたくま",
    	"せつぞく",
    	"せつだん",
    	"せつでん",
    	"せっぱん",
    	"せつび",
    	"せつぶん",
    	"せつめい",
    	"せつりつ",
    	"せなか",
    	"せのび",
    	"せはば",
    	"せびろ",
    	"せぼね",
    	"せまい",
    	"せまる",
    	"せめる",
    	"せもたれ",
    	"せりふ",
    	"ぜんあく",
    	"せんい",
    	"せんえい",
    	"せんか",
    	"せんきょ",
    	"せんく",
    	"せんげん",
    	"ぜんご",
    	"せんさい",
    	"せんしゅ",
    	"せんすい",
    	"せんせい",
    	"せんぞ",
    	"せんたく",
    	"せんちょう",
    	"せんてい",
    	"せんとう",
    	"せんぬき",
    	"せんねん",
    	"せんぱい",
    	"ぜんぶ",
    	"ぜんぽう",
    	"せんむ",
    	"せんめんじょ",
    	"せんもん",
    	"せんやく",
    	"せんゆう",
    	"せんよう",
    	"ぜんら",
    	"ぜんりゃく",
    	"せんれい",
    	"せんろ",
    	"そあく",
    	"そいとげる",
    	"そいね",
    	"そうがんきょう",
    	"そうき",
    	"そうご",
    	"そうしん",
    	"そうだん",
    	"そうなん",
    	"そうび",
    	"そうめん",
    	"そうり",
    	"そえもの",
    	"そえん",
    	"そがい",
    	"そげき",
    	"そこう",
    	"そこそこ",
    	"そざい",
    	"そしな",
    	"そせい",
    	"そせん",
    	"そそぐ",
    	"そだてる",
    	"そつう",
    	"そつえん",
    	"そっかん",
    	"そつぎょう",
    	"そっけつ",
    	"そっこう",
    	"そっせん",
    	"そっと",
    	"そとがわ",
    	"そとづら",
    	"そなえる",
    	"そなた",
    	"そふぼ",
    	"そぼく",
    	"そぼろ",
    	"そまつ",
    	"そまる",
    	"そむく",
    	"そむりえ",
    	"そめる",
    	"そもそも",
    	"そよかぜ",
    	"そらまめ",
    	"そろう",
    	"そんかい",
    	"そんけい",
    	"そんざい",
    	"そんしつ",
    	"そんぞく",
    	"そんちょう",
    	"ぞんび",
    	"ぞんぶん",
    	"そんみん",
    	"たあい",
    	"たいいん",
    	"たいうん",
    	"たいえき",
    	"たいおう",
    	"だいがく",
    	"たいき",
    	"たいぐう",
    	"たいけん",
    	"たいこ",
    	"たいざい",
    	"だいじょうぶ",
    	"だいすき",
    	"たいせつ",
    	"たいそう",
    	"だいたい",
    	"たいちょう",
    	"たいてい",
    	"だいどころ",
    	"たいない",
    	"たいねつ",
    	"たいのう",
    	"たいはん",
    	"だいひょう",
    	"たいふう",
    	"たいへん",
    	"たいほ",
    	"たいまつばな",
    	"たいみんぐ",
    	"たいむ",
    	"たいめん",
    	"たいやき",
    	"たいよう",
    	"たいら",
    	"たいりょく",
    	"たいる",
    	"たいわん",
    	"たうえ",
    	"たえる",
    	"たおす",
    	"たおる",
    	"たおれる",
    	"たかい",
    	"たかね",
    	"たきび",
    	"たくさん",
    	"たこく",
    	"たこやき",
    	"たさい",
    	"たしざん",
    	"だじゃれ",
    	"たすける",
    	"たずさわる",
    	"たそがれ",
    	"たたかう",
    	"たたく",
    	"ただしい",
    	"たたみ",
    	"たちばな",
    	"だっかい",
    	"だっきゃく",
    	"だっこ",
    	"だっしゅつ",
    	"だったい",
    	"たてる",
    	"たとえる",
    	"たなばた",
    	"たにん",
    	"たぬき",
    	"たのしみ",
    	"たはつ",
    	"たぶん",
    	"たべる",
    	"たぼう",
    	"たまご",
    	"たまる",
    	"だむる",
    	"ためいき",
    	"ためす",
    	"ためる",
    	"たもつ",
    	"たやすい",
    	"たよる",
    	"たらす",
    	"たりきほんがん",
    	"たりょう",
    	"たりる",
    	"たると",
    	"たれる",
    	"たれんと",
    	"たろっと",
    	"たわむれる",
    	"だんあつ",
    	"たんい",
    	"たんおん",
    	"たんか",
    	"たんき",
    	"たんけん",
    	"たんご",
    	"たんさん",
    	"たんじょうび",
    	"だんせい",
    	"たんそく",
    	"たんたい",
    	"だんち",
    	"たんてい",
    	"たんとう",
    	"だんな",
    	"たんにん",
    	"だんねつ",
    	"たんのう",
    	"たんぴん",
    	"だんぼう",
    	"たんまつ",
    	"たんめい",
    	"だんれつ",
    	"だんろ",
    	"だんわ",
    	"ちあい",
    	"ちあん",
    	"ちいき",
    	"ちいさい",
    	"ちえん",
    	"ちかい",
    	"ちから",
    	"ちきゅう",
    	"ちきん",
    	"ちけいず",
    	"ちけん",
    	"ちこく",
    	"ちさい",
    	"ちしき",
    	"ちしりょう",
    	"ちせい",
    	"ちそう",
    	"ちたい",
    	"ちたん",
    	"ちちおや",
    	"ちつじょ",
    	"ちてき",
    	"ちてん",
    	"ちぬき",
    	"ちぬり",
    	"ちのう",
    	"ちひょう",
    	"ちへいせん",
    	"ちほう",
    	"ちまた",
    	"ちみつ",
    	"ちみどろ",
    	"ちめいど",
    	"ちゃんこなべ",
    	"ちゅうい",
    	"ちゆりょく",
    	"ちょうし",
    	"ちょさくけん",
    	"ちらし",
    	"ちらみ",
    	"ちりがみ",
    	"ちりょう",
    	"ちるど",
    	"ちわわ",
    	"ちんたい",
    	"ちんもく",
    	"ついか",
    	"ついたち",
    	"つうか",
    	"つうじょう",
    	"つうはん",
    	"つうわ",
    	"つかう",
    	"つかれる",
    	"つくね",
    	"つくる",
    	"つけね",
    	"つける",
    	"つごう",
    	"つたえる",
    	"つづく",
    	"つつじ",
    	"つつむ",
    	"つとめる",
    	"つながる",
    	"つなみ",
    	"つねづね",
    	"つのる",
    	"つぶす",
    	"つまらない",
    	"つまる",
    	"つみき",
    	"つめたい",
    	"つもり",
    	"つもる",
    	"つよい",
    	"つるぼ",
    	"つるみく",
    	"つわもの",
    	"つわり",
    	"てあし",
    	"てあて",
    	"てあみ",
    	"ていおん",
    	"ていか",
    	"ていき",
    	"ていけい",
    	"ていこく",
    	"ていさつ",
    	"ていし",
    	"ていせい",
    	"ていたい",
    	"ていど",
    	"ていねい",
    	"ていひょう",
    	"ていへん",
    	"ていぼう",
    	"てうち",
    	"ておくれ",
    	"てきとう",
    	"てくび",
    	"でこぼこ",
    	"てさぎょう",
    	"てさげ",
    	"てすり",
    	"てそう",
    	"てちがい",
    	"てちょう",
    	"てつがく",
    	"てつづき",
    	"でっぱ",
    	"てつぼう",
    	"てつや",
    	"でぬかえ",
    	"てぬき",
    	"てぬぐい",
    	"てのひら",
    	"てはい",
    	"てぶくろ",
    	"てふだ",
    	"てほどき",
    	"てほん",
    	"てまえ",
    	"てまきずし",
    	"てみじか",
    	"てみやげ",
    	"てらす",
    	"てれび",
    	"てわけ",
    	"てわたし",
    	"でんあつ",
    	"てんいん",
    	"てんかい",
    	"てんき",
    	"てんぐ",
    	"てんけん",
    	"てんごく",
    	"てんさい",
    	"てんし",
    	"てんすう",
    	"でんち",
    	"てんてき",
    	"てんとう",
    	"てんない",
    	"てんぷら",
    	"てんぼうだい",
    	"てんめつ",
    	"てんらんかい",
    	"でんりょく",
    	"でんわ",
    	"どあい",
    	"といれ",
    	"どうかん",
    	"とうきゅう",
    	"どうぐ",
    	"とうし",
    	"とうむぎ",
    	"とおい",
    	"とおか",
    	"とおく",
    	"とおす",
    	"とおる",
    	"とかい",
    	"とかす",
    	"ときおり",
    	"ときどき",
    	"とくい",
    	"とくしゅう",
    	"とくてん",
    	"とくに",
    	"とくべつ",
    	"とけい",
    	"とける",
    	"とこや",
    	"とさか",
    	"としょかん",
    	"とそう",
    	"とたん",
    	"とちゅう",
    	"とっきゅう",
    	"とっくん",
    	"とつぜん",
    	"とつにゅう",
    	"とどける",
    	"ととのえる",
    	"とない",
    	"となえる",
    	"となり",
    	"とのさま",
    	"とばす",
    	"どぶがわ",
    	"とほう",
    	"とまる",
    	"とめる",
    	"ともだち",
    	"ともる",
    	"どようび",
    	"とらえる",
    	"とんかつ",
    	"どんぶり",
    	"ないかく",
    	"ないこう",
    	"ないしょ",
    	"ないす",
    	"ないせん",
    	"ないそう",
    	"なおす",
    	"ながい",
    	"なくす",
    	"なげる",
    	"なこうど",
    	"なさけ",
    	"なたでここ",
    	"なっとう",
    	"なつやすみ",
    	"ななおし",
    	"なにごと",
    	"なにもの",
    	"なにわ",
    	"なのか",
    	"なふだ",
    	"なまいき",
    	"なまえ",
    	"なまみ",
    	"なみだ",
    	"なめらか",
    	"なめる",
    	"なやむ",
    	"ならう",
    	"ならび",
    	"ならぶ",
    	"なれる",
    	"なわとび",
    	"なわばり",
    	"にあう",
    	"にいがた",
    	"にうけ",
    	"におい",
    	"にかい",
    	"にがて",
    	"にきび",
    	"にくしみ",
    	"にくまん",
    	"にげる",
    	"にさんかたんそ",
    	"にしき",
    	"にせもの",
    	"にちじょう",
    	"にちようび",
    	"にっか",
    	"にっき",
    	"にっけい",
    	"にっこう",
    	"にっさん",
    	"にっしょく",
    	"にっすう",
    	"にっせき",
    	"にってい",
    	"になう",
    	"にほん",
    	"にまめ",
    	"にもつ",
    	"にやり",
    	"にゅういん",
    	"にりんしゃ",
    	"にわとり",
    	"にんい",
    	"にんか",
    	"にんき",
    	"にんげん",
    	"にんしき",
    	"にんずう",
    	"にんそう",
    	"にんたい",
    	"にんち",
    	"にんてい",
    	"にんにく",
    	"にんぷ",
    	"にんまり",
    	"にんむ",
    	"にんめい",
    	"にんよう",
    	"ぬいくぎ",
    	"ぬかす",
    	"ぬぐいとる",
    	"ぬぐう",
    	"ぬくもり",
    	"ぬすむ",
    	"ぬまえび",
    	"ぬめり",
    	"ぬらす",
    	"ぬんちゃく",
    	"ねあげ",
    	"ねいき",
    	"ねいる",
    	"ねいろ",
    	"ねぐせ",
    	"ねくたい",
    	"ねくら",
    	"ねこぜ",
    	"ねこむ",
    	"ねさげ",
    	"ねすごす",
    	"ねそべる",
    	"ねだん",
    	"ねつい",
    	"ねっしん",
    	"ねつぞう",
    	"ねったいぎょ",
    	"ねぶそく",
    	"ねふだ",
    	"ねぼう",
    	"ねほりはほり",
    	"ねまき",
    	"ねまわし",
    	"ねみみ",
    	"ねむい",
    	"ねむたい",
    	"ねもと",
    	"ねらう",
    	"ねわざ",
    	"ねんいり",
    	"ねんおし",
    	"ねんかん",
    	"ねんきん",
    	"ねんぐ",
    	"ねんざ",
    	"ねんし",
    	"ねんちゃく",
    	"ねんど",
    	"ねんぴ",
    	"ねんぶつ",
    	"ねんまつ",
    	"ねんりょう",
    	"ねんれい",
    	"のいず",
    	"のおづま",
    	"のがす",
    	"のきなみ",
    	"のこぎり",
    	"のこす",
    	"のこる",
    	"のせる",
    	"のぞく",
    	"のぞむ",
    	"のたまう",
    	"のちほど",
    	"のっく",
    	"のばす",
    	"のはら",
    	"のべる",
    	"のぼる",
    	"のみもの",
    	"のやま",
    	"のらいぬ",
    	"のらねこ",
    	"のりもの",
    	"のりゆき",
    	"のれん",
    	"のんき",
    	"ばあい",
    	"はあく",
    	"ばあさん",
    	"ばいか",
    	"ばいく",
    	"はいけん",
    	"はいご",
    	"はいしん",
    	"はいすい",
    	"はいせん",
    	"はいそう",
    	"はいち",
    	"ばいばい",
    	"はいれつ",
    	"はえる",
    	"はおる",
    	"はかい",
    	"ばかり",
    	"はかる",
    	"はくしゅ",
    	"はけん",
    	"はこぶ",
    	"はさみ",
    	"はさん",
    	"はしご",
    	"ばしょ",
    	"はしる",
    	"はせる",
    	"ぱそこん",
    	"はそん",
    	"はたん",
    	"はちみつ",
    	"はつおん",
    	"はっかく",
    	"はづき",
    	"はっきり",
    	"はっくつ",
    	"はっけん",
    	"はっこう",
    	"はっさん",
    	"はっしん",
    	"はったつ",
    	"はっちゅう",
    	"はってん",
    	"はっぴょう",
    	"はっぽう",
    	"はなす",
    	"はなび",
    	"はにかむ",
    	"はぶらし",
    	"はみがき",
    	"はむかう",
    	"はめつ",
    	"はやい",
    	"はやし",
    	"はらう",
    	"はろうぃん",
    	"はわい",
    	"はんい",
    	"はんえい",
    	"はんおん",
    	"はんかく",
    	"はんきょう",
    	"ばんぐみ",
    	"はんこ",
    	"はんしゃ",
    	"はんすう",
    	"はんだん",
    	"ぱんち",
    	"ぱんつ",
    	"はんてい",
    	"はんとし",
    	"はんのう",
    	"はんぱ",
    	"はんぶん",
    	"はんぺん",
    	"はんぼうき",
    	"はんめい",
    	"はんらん",
    	"はんろん",
    	"ひいき",
    	"ひうん",
    	"ひえる",
    	"ひかく",
    	"ひかり",
    	"ひかる",
    	"ひかん",
    	"ひくい",
    	"ひけつ",
    	"ひこうき",
    	"ひこく",
    	"ひさい",
    	"ひさしぶり",
    	"ひさん",
    	"びじゅつかん",
    	"ひしょ",
    	"ひそか",
    	"ひそむ",
    	"ひたむき",
    	"ひだり",
    	"ひたる",
    	"ひつぎ",
    	"ひっこし",
    	"ひっし",
    	"ひつじゅひん",
    	"ひっす",
    	"ひつぜん",
    	"ぴったり",
    	"ぴっちり",
    	"ひつよう",
    	"ひてい",
    	"ひとごみ",
    	"ひなまつり",
    	"ひなん",
    	"ひねる",
    	"ひはん",
    	"ひびく",
    	"ひひょう",
    	"ひほう",
    	"ひまわり",
    	"ひまん",
    	"ひみつ",
    	"ひめい",
    	"ひめじし",
    	"ひやけ",
    	"ひやす",
    	"ひよう",
    	"びょうき",
    	"ひらがな",
    	"ひらく",
    	"ひりつ",
    	"ひりょう",
    	"ひるま",
    	"ひるやすみ",
    	"ひれい",
    	"ひろい",
    	"ひろう",
    	"ひろき",
    	"ひろゆき",
    	"ひんかく",
    	"ひんけつ",
    	"ひんこん",
    	"ひんしゅ",
    	"ひんそう",
    	"ぴんち",
    	"ひんぱん",
    	"びんぼう",
    	"ふあん",
    	"ふいうち",
    	"ふうけい",
    	"ふうせん",
    	"ぷうたろう",
    	"ふうとう",
    	"ふうふ",
    	"ふえる",
    	"ふおん",
    	"ふかい",
    	"ふきん",
    	"ふくざつ",
    	"ふくぶくろ",
    	"ふこう",
    	"ふさい",
    	"ふしぎ",
    	"ふじみ",
    	"ふすま",
    	"ふせい",
    	"ふせぐ",
    	"ふそく",
    	"ぶたにく",
    	"ふたん",
    	"ふちょう",
    	"ふつう",
    	"ふつか",
    	"ふっかつ",
    	"ふっき",
    	"ふっこく",
    	"ぶどう",
    	"ふとる",
    	"ふとん",
    	"ふのう",
    	"ふはい",
    	"ふひょう",
    	"ふへん",
    	"ふまん",
    	"ふみん",
    	"ふめつ",
    	"ふめん",
    	"ふよう",
    	"ふりこ",
    	"ふりる",
    	"ふるい",
    	"ふんいき",
    	"ぶんがく",
    	"ぶんぐ",
    	"ふんしつ",
    	"ぶんせき",
    	"ふんそう",
    	"ぶんぽう",
    	"へいあん",
    	"へいおん",
    	"へいがい",
    	"へいき",
    	"へいげん",
    	"へいこう",
    	"へいさ",
    	"へいしゃ",
    	"へいせつ",
    	"へいそ",
    	"へいたく",
    	"へいてん",
    	"へいねつ",
    	"へいわ",
    	"へきが",
    	"へこむ",
    	"べにいろ",
    	"べにしょうが",
    	"へらす",
    	"へんかん",
    	"べんきょう",
    	"べんごし",
    	"へんさい",
    	"へんたい",
    	"べんり",
    	"ほあん",
    	"ほいく",
    	"ぼうぎょ",
    	"ほうこく",
    	"ほうそう",
    	"ほうほう",
    	"ほうもん",
    	"ほうりつ",
    	"ほえる",
    	"ほおん",
    	"ほかん",
    	"ほきょう",
    	"ぼきん",
    	"ほくろ",
    	"ほけつ",
    	"ほけん",
    	"ほこう",
    	"ほこる",
    	"ほしい",
    	"ほしつ",
    	"ほしゅ",
    	"ほしょう",
    	"ほせい",
    	"ほそい",
    	"ほそく",
    	"ほたて",
    	"ほたる",
    	"ぽちぶくろ",
    	"ほっきょく",
    	"ほっさ",
    	"ほったん",
    	"ほとんど",
    	"ほめる",
    	"ほんい",
    	"ほんき",
    	"ほんけ",
    	"ほんしつ",
    	"ほんやく",
    	"まいにち",
    	"まかい",
    	"まかせる",
    	"まがる",
    	"まける",
    	"まこと",
    	"まさつ",
    	"まじめ",
    	"ますく",
    	"まぜる",
    	"まつり",
    	"まとめ",
    	"まなぶ",
    	"まぬけ",
    	"まねく",
    	"まほう",
    	"まもる",
    	"まゆげ",
    	"まよう",
    	"まろやか",
    	"まわす",
    	"まわり",
    	"まわる",
    	"まんが",
    	"まんきつ",
    	"まんぞく",
    	"まんなか",
    	"みいら",
    	"みうち",
    	"みえる",
    	"みがく",
    	"みかた",
    	"みかん",
    	"みけん",
    	"みこん",
    	"みじかい",
    	"みすい",
    	"みすえる",
    	"みせる",
    	"みっか",
    	"みつかる",
    	"みつける",
    	"みてい",
    	"みとめる",
    	"みなと",
    	"みなみかさい",
    	"みねらる",
    	"みのう",
    	"みのがす",
    	"みほん",
    	"みもと",
    	"みやげ",
    	"みらい",
    	"みりょく",
    	"みわく",
    	"みんか",
    	"みんぞく",
    	"むいか",
    	"むえき",
    	"むえん",
    	"むかい",
    	"むかう",
    	"むかえ",
    	"むかし",
    	"むぎちゃ",
    	"むける",
    	"むげん",
    	"むさぼる",
    	"むしあつい",
    	"むしば",
    	"むじゅん",
    	"むしろ",
    	"むすう",
    	"むすこ",
    	"むすぶ",
    	"むすめ",
    	"むせる",
    	"むせん",
    	"むちゅう",
    	"むなしい",
    	"むのう",
    	"むやみ",
    	"むよう",
    	"むらさき",
    	"むりょう",
    	"むろん",
    	"めいあん",
    	"めいうん",
    	"めいえん",
    	"めいかく",
    	"めいきょく",
    	"めいさい",
    	"めいし",
    	"めいそう",
    	"めいぶつ",
    	"めいれい",
    	"めいわく",
    	"めぐまれる",
    	"めざす",
    	"めした",
    	"めずらしい",
    	"めだつ",
    	"めまい",
    	"めやす",
    	"めんきょ",
    	"めんせき",
    	"めんどう",
    	"もうしあげる",
    	"もうどうけん",
    	"もえる",
    	"もくし",
    	"もくてき",
    	"もくようび",
    	"もちろん",
    	"もどる",
    	"もらう",
    	"もんく",
    	"もんだい",
    	"やおや",
    	"やける",
    	"やさい",
    	"やさしい",
    	"やすい",
    	"やすたろう",
    	"やすみ",
    	"やせる",
    	"やそう",
    	"やたい",
    	"やちん",
    	"やっと",
    	"やっぱり",
    	"やぶる",
    	"やめる",
    	"ややこしい",
    	"やよい",
    	"やわらかい",
    	"ゆうき",
    	"ゆうびんきょく",
    	"ゆうべ",
    	"ゆうめい",
    	"ゆけつ",
    	"ゆしゅつ",
    	"ゆせん",
    	"ゆそう",
    	"ゆたか",
    	"ゆちゃく",
    	"ゆでる",
    	"ゆにゅう",
    	"ゆびわ",
    	"ゆらい",
    	"ゆれる",
    	"ようい",
    	"ようか",
    	"ようきゅう",
    	"ようじ",
    	"ようす",
    	"ようちえん",
    	"よかぜ",
    	"よかん",
    	"よきん",
    	"よくせい",
    	"よくぼう",
    	"よけい",
    	"よごれる",
    	"よさん",
    	"よしゅう",
    	"よそう",
    	"よそく",
    	"よっか",
    	"よてい",
    	"よどがわく",
    	"よねつ",
    	"よやく",
    	"よゆう",
    	"よろこぶ",
    	"よろしい",
    	"らいう",
    	"らくがき",
    	"らくご",
    	"らくさつ",
    	"らくだ",
    	"らしんばん",
    	"らせん",
    	"らぞく",
    	"らたい",
    	"らっか",
    	"られつ",
    	"りえき",
    	"りかい",
    	"りきさく",
    	"りきせつ",
    	"りくぐん",
    	"りくつ",
    	"りけん",
    	"りこう",
    	"りせい",
    	"りそう",
    	"りそく",
    	"りてん",
    	"りねん",
    	"りゆう",
    	"りゅうがく",
    	"りよう",
    	"りょうり",
    	"りょかん",
    	"りょくちゃ",
    	"りょこう",
    	"りりく",
    	"りれき",
    	"りろん",
    	"りんご",
    	"るいけい",
    	"るいさい",
    	"るいじ",
    	"るいせき",
    	"るすばん",
    	"るりがわら",
    	"れいかん",
    	"れいぎ",
    	"れいせい",
    	"れいぞうこ",
    	"れいとう",
    	"れいぼう",
    	"れきし",
    	"れきだい",
    	"れんあい",
    	"れんけい",
    	"れんこん",
    	"れんさい",
    	"れんしゅう",
    	"れんぞく",
    	"れんらく",
    	"ろうか",
    	"ろうご",
    	"ろうじん",
    	"ろうそく",
    	"ろくが",
    	"ろこつ",
    	"ろじうら",
    	"ろしゅつ",
    	"ろせん",
    	"ろてん",
    	"ろめん",
    	"ろれつ",
    	"ろんぎ",
    	"ろんぱ",
    	"ろんぶん",
    	"ろんり",
    	"わかす",
    	"わかめ",
    	"わかやま",
    	"わかれる",
    	"わしつ",
    	"わじまし",
    	"わすれもの",
    	"わらう",
    	"われる"
    ];

    var require$$11 = [
    	"가격",
    	"가끔",
    	"가난",
    	"가능",
    	"가득",
    	"가르침",
    	"가뭄",
    	"가방",
    	"가상",
    	"가슴",
    	"가운데",
    	"가을",
    	"가이드",
    	"가입",
    	"가장",
    	"가정",
    	"가족",
    	"가죽",
    	"각오",
    	"각자",
    	"간격",
    	"간부",
    	"간섭",
    	"간장",
    	"간접",
    	"간판",
    	"갈등",
    	"갈비",
    	"갈색",
    	"갈증",
    	"감각",
    	"감기",
    	"감소",
    	"감수성",
    	"감자",
    	"감정",
    	"갑자기",
    	"강남",
    	"강당",
    	"강도",
    	"강력히",
    	"강변",
    	"강북",
    	"강사",
    	"강수량",
    	"강아지",
    	"강원도",
    	"강의",
    	"강제",
    	"강조",
    	"같이",
    	"개구리",
    	"개나리",
    	"개방",
    	"개별",
    	"개선",
    	"개성",
    	"개인",
    	"객관적",
    	"거실",
    	"거액",
    	"거울",
    	"거짓",
    	"거품",
    	"걱정",
    	"건강",
    	"건물",
    	"건설",
    	"건조",
    	"건축",
    	"걸음",
    	"검사",
    	"검토",
    	"게시판",
    	"게임",
    	"겨울",
    	"견해",
    	"결과",
    	"결국",
    	"결론",
    	"결석",
    	"결승",
    	"결심",
    	"결정",
    	"결혼",
    	"경계",
    	"경고",
    	"경기",
    	"경력",
    	"경복궁",
    	"경비",
    	"경상도",
    	"경영",
    	"경우",
    	"경쟁",
    	"경제",
    	"경주",
    	"경찰",
    	"경치",
    	"경향",
    	"경험",
    	"계곡",
    	"계단",
    	"계란",
    	"계산",
    	"계속",
    	"계약",
    	"계절",
    	"계층",
    	"계획",
    	"고객",
    	"고구려",
    	"고궁",
    	"고급",
    	"고등학생",
    	"고무신",
    	"고민",
    	"고양이",
    	"고장",
    	"고전",
    	"고집",
    	"고춧가루",
    	"고통",
    	"고향",
    	"곡식",
    	"골목",
    	"골짜기",
    	"골프",
    	"공간",
    	"공개",
    	"공격",
    	"공군",
    	"공급",
    	"공기",
    	"공동",
    	"공무원",
    	"공부",
    	"공사",
    	"공식",
    	"공업",
    	"공연",
    	"공원",
    	"공장",
    	"공짜",
    	"공책",
    	"공통",
    	"공포",
    	"공항",
    	"공휴일",
    	"과목",
    	"과일",
    	"과장",
    	"과정",
    	"과학",
    	"관객",
    	"관계",
    	"관광",
    	"관념",
    	"관람",
    	"관련",
    	"관리",
    	"관습",
    	"관심",
    	"관점",
    	"관찰",
    	"광경",
    	"광고",
    	"광장",
    	"광주",
    	"괴로움",
    	"굉장히",
    	"교과서",
    	"교문",
    	"교복",
    	"교실",
    	"교양",
    	"교육",
    	"교장",
    	"교직",
    	"교통",
    	"교환",
    	"교훈",
    	"구경",
    	"구름",
    	"구멍",
    	"구별",
    	"구분",
    	"구석",
    	"구성",
    	"구속",
    	"구역",
    	"구입",
    	"구청",
    	"구체적",
    	"국가",
    	"국기",
    	"국내",
    	"국립",
    	"국물",
    	"국민",
    	"국수",
    	"국어",
    	"국왕",
    	"국적",
    	"국제",
    	"국회",
    	"군대",
    	"군사",
    	"군인",
    	"궁극적",
    	"권리",
    	"권위",
    	"권투",
    	"귀국",
    	"귀신",
    	"규정",
    	"규칙",
    	"균형",
    	"그날",
    	"그냥",
    	"그늘",
    	"그러나",
    	"그룹",
    	"그릇",
    	"그림",
    	"그제서야",
    	"그토록",
    	"극복",
    	"극히",
    	"근거",
    	"근교",
    	"근래",
    	"근로",
    	"근무",
    	"근본",
    	"근원",
    	"근육",
    	"근처",
    	"글씨",
    	"글자",
    	"금강산",
    	"금고",
    	"금년",
    	"금메달",
    	"금액",
    	"금연",
    	"금요일",
    	"금지",
    	"긍정적",
    	"기간",
    	"기관",
    	"기념",
    	"기능",
    	"기독교",
    	"기둥",
    	"기록",
    	"기름",
    	"기법",
    	"기본",
    	"기분",
    	"기쁨",
    	"기숙사",
    	"기술",
    	"기억",
    	"기업",
    	"기온",
    	"기운",
    	"기원",
    	"기적",
    	"기준",
    	"기침",
    	"기혼",
    	"기획",
    	"긴급",
    	"긴장",
    	"길이",
    	"김밥",
    	"김치",
    	"김포공항",
    	"깍두기",
    	"깜빡",
    	"깨달음",
    	"깨소금",
    	"껍질",
    	"꼭대기",
    	"꽃잎",
    	"나들이",
    	"나란히",
    	"나머지",
    	"나물",
    	"나침반",
    	"나흘",
    	"낙엽",
    	"난방",
    	"날개",
    	"날씨",
    	"날짜",
    	"남녀",
    	"남대문",
    	"남매",
    	"남산",
    	"남자",
    	"남편",
    	"남학생",
    	"낭비",
    	"낱말",
    	"내년",
    	"내용",
    	"내일",
    	"냄비",
    	"냄새",
    	"냇물",
    	"냉동",
    	"냉면",
    	"냉방",
    	"냉장고",
    	"넥타이",
    	"넷째",
    	"노동",
    	"노란색",
    	"노력",
    	"노인",
    	"녹음",
    	"녹차",
    	"녹화",
    	"논리",
    	"논문",
    	"논쟁",
    	"놀이",
    	"농구",
    	"농담",
    	"농민",
    	"농부",
    	"농업",
    	"농장",
    	"농촌",
    	"높이",
    	"눈동자",
    	"눈물",
    	"눈썹",
    	"뉴욕",
    	"느낌",
    	"늑대",
    	"능동적",
    	"능력",
    	"다방",
    	"다양성",
    	"다음",
    	"다이어트",
    	"다행",
    	"단계",
    	"단골",
    	"단독",
    	"단맛",
    	"단순",
    	"단어",
    	"단위",
    	"단점",
    	"단체",
    	"단추",
    	"단편",
    	"단풍",
    	"달걀",
    	"달러",
    	"달력",
    	"달리",
    	"닭고기",
    	"담당",
    	"담배",
    	"담요",
    	"담임",
    	"답변",
    	"답장",
    	"당근",
    	"당분간",
    	"당연히",
    	"당장",
    	"대규모",
    	"대낮",
    	"대단히",
    	"대답",
    	"대도시",
    	"대략",
    	"대량",
    	"대륙",
    	"대문",
    	"대부분",
    	"대신",
    	"대응",
    	"대장",
    	"대전",
    	"대접",
    	"대중",
    	"대책",
    	"대출",
    	"대충",
    	"대통령",
    	"대학",
    	"대한민국",
    	"대합실",
    	"대형",
    	"덩어리",
    	"데이트",
    	"도대체",
    	"도덕",
    	"도둑",
    	"도망",
    	"도서관",
    	"도심",
    	"도움",
    	"도입",
    	"도자기",
    	"도저히",
    	"도전",
    	"도중",
    	"도착",
    	"독감",
    	"독립",
    	"독서",
    	"독일",
    	"독창적",
    	"동화책",
    	"뒷모습",
    	"뒷산",
    	"딸아이",
    	"마누라",
    	"마늘",
    	"마당",
    	"마라톤",
    	"마련",
    	"마무리",
    	"마사지",
    	"마약",
    	"마요네즈",
    	"마을",
    	"마음",
    	"마이크",
    	"마중",
    	"마지막",
    	"마찬가지",
    	"마찰",
    	"마흔",
    	"막걸리",
    	"막내",
    	"막상",
    	"만남",
    	"만두",
    	"만세",
    	"만약",
    	"만일",
    	"만점",
    	"만족",
    	"만화",
    	"많이",
    	"말기",
    	"말씀",
    	"말투",
    	"맘대로",
    	"망원경",
    	"매년",
    	"매달",
    	"매력",
    	"매번",
    	"매스컴",
    	"매일",
    	"매장",
    	"맥주",
    	"먹이",
    	"먼저",
    	"먼지",
    	"멀리",
    	"메일",
    	"며느리",
    	"며칠",
    	"면담",
    	"멸치",
    	"명단",
    	"명령",
    	"명예",
    	"명의",
    	"명절",
    	"명칭",
    	"명함",
    	"모금",
    	"모니터",
    	"모델",
    	"모든",
    	"모범",
    	"모습",
    	"모양",
    	"모임",
    	"모조리",
    	"모집",
    	"모퉁이",
    	"목걸이",
    	"목록",
    	"목사",
    	"목소리",
    	"목숨",
    	"목적",
    	"목표",
    	"몰래",
    	"몸매",
    	"몸무게",
    	"몸살",
    	"몸속",
    	"몸짓",
    	"몸통",
    	"몹시",
    	"무관심",
    	"무궁화",
    	"무더위",
    	"무덤",
    	"무릎",
    	"무슨",
    	"무엇",
    	"무역",
    	"무용",
    	"무조건",
    	"무지개",
    	"무척",
    	"문구",
    	"문득",
    	"문법",
    	"문서",
    	"문제",
    	"문학",
    	"문화",
    	"물가",
    	"물건",
    	"물결",
    	"물고기",
    	"물론",
    	"물리학",
    	"물음",
    	"물질",
    	"물체",
    	"미국",
    	"미디어",
    	"미사일",
    	"미술",
    	"미역",
    	"미용실",
    	"미움",
    	"미인",
    	"미팅",
    	"미혼",
    	"민간",
    	"민족",
    	"민주",
    	"믿음",
    	"밀가루",
    	"밀리미터",
    	"밑바닥",
    	"바가지",
    	"바구니",
    	"바나나",
    	"바늘",
    	"바닥",
    	"바닷가",
    	"바람",
    	"바이러스",
    	"바탕",
    	"박물관",
    	"박사",
    	"박수",
    	"반대",
    	"반드시",
    	"반말",
    	"반발",
    	"반성",
    	"반응",
    	"반장",
    	"반죽",
    	"반지",
    	"반찬",
    	"받침",
    	"발가락",
    	"발걸음",
    	"발견",
    	"발달",
    	"발레",
    	"발목",
    	"발바닥",
    	"발생",
    	"발음",
    	"발자국",
    	"발전",
    	"발톱",
    	"발표",
    	"밤하늘",
    	"밥그릇",
    	"밥맛",
    	"밥상",
    	"밥솥",
    	"방금",
    	"방면",
    	"방문",
    	"방바닥",
    	"방법",
    	"방송",
    	"방식",
    	"방안",
    	"방울",
    	"방지",
    	"방학",
    	"방해",
    	"방향",
    	"배경",
    	"배꼽",
    	"배달",
    	"배드민턴",
    	"백두산",
    	"백색",
    	"백성",
    	"백인",
    	"백제",
    	"백화점",
    	"버릇",
    	"버섯",
    	"버튼",
    	"번개",
    	"번역",
    	"번지",
    	"번호",
    	"벌금",
    	"벌레",
    	"벌써",
    	"범위",
    	"범인",
    	"범죄",
    	"법률",
    	"법원",
    	"법적",
    	"법칙",
    	"베이징",
    	"벨트",
    	"변경",
    	"변동",
    	"변명",
    	"변신",
    	"변호사",
    	"변화",
    	"별도",
    	"별명",
    	"별일",
    	"병실",
    	"병아리",
    	"병원",
    	"보관",
    	"보너스",
    	"보라색",
    	"보람",
    	"보름",
    	"보상",
    	"보안",
    	"보자기",
    	"보장",
    	"보전",
    	"보존",
    	"보통",
    	"보편적",
    	"보험",
    	"복도",
    	"복사",
    	"복숭아",
    	"복습",
    	"볶음",
    	"본격적",
    	"본래",
    	"본부",
    	"본사",
    	"본성",
    	"본인",
    	"본질",
    	"볼펜",
    	"봉사",
    	"봉지",
    	"봉투",
    	"부근",
    	"부끄러움",
    	"부담",
    	"부동산",
    	"부문",
    	"부분",
    	"부산",
    	"부상",
    	"부엌",
    	"부인",
    	"부작용",
    	"부장",
    	"부정",
    	"부족",
    	"부지런히",
    	"부친",
    	"부탁",
    	"부품",
    	"부회장",
    	"북부",
    	"북한",
    	"분노",
    	"분량",
    	"분리",
    	"분명",
    	"분석",
    	"분야",
    	"분위기",
    	"분필",
    	"분홍색",
    	"불고기",
    	"불과",
    	"불교",
    	"불꽃",
    	"불만",
    	"불법",
    	"불빛",
    	"불안",
    	"불이익",
    	"불행",
    	"브랜드",
    	"비극",
    	"비난",
    	"비닐",
    	"비둘기",
    	"비디오",
    	"비로소",
    	"비만",
    	"비명",
    	"비밀",
    	"비바람",
    	"비빔밥",
    	"비상",
    	"비용",
    	"비율",
    	"비중",
    	"비타민",
    	"비판",
    	"빌딩",
    	"빗물",
    	"빗방울",
    	"빗줄기",
    	"빛깔",
    	"빨간색",
    	"빨래",
    	"빨리",
    	"사건",
    	"사계절",
    	"사나이",
    	"사냥",
    	"사람",
    	"사랑",
    	"사립",
    	"사모님",
    	"사물",
    	"사방",
    	"사상",
    	"사생활",
    	"사설",
    	"사슴",
    	"사실",
    	"사업",
    	"사용",
    	"사월",
    	"사장",
    	"사전",
    	"사진",
    	"사촌",
    	"사춘기",
    	"사탕",
    	"사투리",
    	"사흘",
    	"산길",
    	"산부인과",
    	"산업",
    	"산책",
    	"살림",
    	"살인",
    	"살짝",
    	"삼계탕",
    	"삼국",
    	"삼십",
    	"삼월",
    	"삼촌",
    	"상관",
    	"상금",
    	"상대",
    	"상류",
    	"상반기",
    	"상상",
    	"상식",
    	"상업",
    	"상인",
    	"상자",
    	"상점",
    	"상처",
    	"상추",
    	"상태",
    	"상표",
    	"상품",
    	"상황",
    	"새벽",
    	"색깔",
    	"색연필",
    	"생각",
    	"생명",
    	"생물",
    	"생방송",
    	"생산",
    	"생선",
    	"생신",
    	"생일",
    	"생활",
    	"서랍",
    	"서른",
    	"서명",
    	"서민",
    	"서비스",
    	"서양",
    	"서울",
    	"서적",
    	"서점",
    	"서쪽",
    	"서클",
    	"석사",
    	"석유",
    	"선거",
    	"선물",
    	"선배",
    	"선생",
    	"선수",
    	"선원",
    	"선장",
    	"선전",
    	"선택",
    	"선풍기",
    	"설거지",
    	"설날",
    	"설렁탕",
    	"설명",
    	"설문",
    	"설사",
    	"설악산",
    	"설치",
    	"설탕",
    	"섭씨",
    	"성공",
    	"성당",
    	"성명",
    	"성별",
    	"성인",
    	"성장",
    	"성적",
    	"성질",
    	"성함",
    	"세금",
    	"세미나",
    	"세상",
    	"세월",
    	"세종대왕",
    	"세탁",
    	"센터",
    	"센티미터",
    	"셋째",
    	"소규모",
    	"소극적",
    	"소금",
    	"소나기",
    	"소년",
    	"소득",
    	"소망",
    	"소문",
    	"소설",
    	"소속",
    	"소아과",
    	"소용",
    	"소원",
    	"소음",
    	"소중히",
    	"소지품",
    	"소질",
    	"소풍",
    	"소형",
    	"속담",
    	"속도",
    	"속옷",
    	"손가락",
    	"손길",
    	"손녀",
    	"손님",
    	"손등",
    	"손목",
    	"손뼉",
    	"손실",
    	"손질",
    	"손톱",
    	"손해",
    	"솔직히",
    	"솜씨",
    	"송아지",
    	"송이",
    	"송편",
    	"쇠고기",
    	"쇼핑",
    	"수건",
    	"수년",
    	"수단",
    	"수돗물",
    	"수동적",
    	"수면",
    	"수명",
    	"수박",
    	"수상",
    	"수석",
    	"수술",
    	"수시로",
    	"수업",
    	"수염",
    	"수영",
    	"수입",
    	"수준",
    	"수집",
    	"수출",
    	"수컷",
    	"수필",
    	"수학",
    	"수험생",
    	"수화기",
    	"숙녀",
    	"숙소",
    	"숙제",
    	"순간",
    	"순서",
    	"순수",
    	"순식간",
    	"순위",
    	"숟가락",
    	"술병",
    	"술집",
    	"숫자",
    	"스님",
    	"스물",
    	"스스로",
    	"스승",
    	"스웨터",
    	"스위치",
    	"스케이트",
    	"스튜디오",
    	"스트레스",
    	"스포츠",
    	"슬쩍",
    	"슬픔",
    	"습관",
    	"습기",
    	"승객",
    	"승리",
    	"승부",
    	"승용차",
    	"승진",
    	"시각",
    	"시간",
    	"시골",
    	"시금치",
    	"시나리오",
    	"시댁",
    	"시리즈",
    	"시멘트",
    	"시민",
    	"시부모",
    	"시선",
    	"시설",
    	"시스템",
    	"시아버지",
    	"시어머니",
    	"시월",
    	"시인",
    	"시일",
    	"시작",
    	"시장",
    	"시절",
    	"시점",
    	"시중",
    	"시즌",
    	"시집",
    	"시청",
    	"시합",
    	"시험",
    	"식구",
    	"식기",
    	"식당",
    	"식량",
    	"식료품",
    	"식물",
    	"식빵",
    	"식사",
    	"식생활",
    	"식초",
    	"식탁",
    	"식품",
    	"신고",
    	"신규",
    	"신념",
    	"신문",
    	"신발",
    	"신비",
    	"신사",
    	"신세",
    	"신용",
    	"신제품",
    	"신청",
    	"신체",
    	"신화",
    	"실감",
    	"실내",
    	"실력",
    	"실례",
    	"실망",
    	"실수",
    	"실습",
    	"실시",
    	"실장",
    	"실정",
    	"실질적",
    	"실천",
    	"실체",
    	"실컷",
    	"실태",
    	"실패",
    	"실험",
    	"실현",
    	"심리",
    	"심부름",
    	"심사",
    	"심장",
    	"심정",
    	"심판",
    	"쌍둥이",
    	"씨름",
    	"씨앗",
    	"아가씨",
    	"아나운서",
    	"아드님",
    	"아들",
    	"아쉬움",
    	"아스팔트",
    	"아시아",
    	"아울러",
    	"아저씨",
    	"아줌마",
    	"아직",
    	"아침",
    	"아파트",
    	"아프리카",
    	"아픔",
    	"아홉",
    	"아흔",
    	"악기",
    	"악몽",
    	"악수",
    	"안개",
    	"안경",
    	"안과",
    	"안내",
    	"안녕",
    	"안동",
    	"안방",
    	"안부",
    	"안주",
    	"알루미늄",
    	"알코올",
    	"암시",
    	"암컷",
    	"압력",
    	"앞날",
    	"앞문",
    	"애인",
    	"애정",
    	"액수",
    	"앨범",
    	"야간",
    	"야단",
    	"야옹",
    	"약간",
    	"약국",
    	"약속",
    	"약수",
    	"약점",
    	"약품",
    	"약혼녀",
    	"양념",
    	"양력",
    	"양말",
    	"양배추",
    	"양주",
    	"양파",
    	"어둠",
    	"어려움",
    	"어른",
    	"어젯밤",
    	"어쨌든",
    	"어쩌다가",
    	"어쩐지",
    	"언니",
    	"언덕",
    	"언론",
    	"언어",
    	"얼굴",
    	"얼른",
    	"얼음",
    	"얼핏",
    	"엄마",
    	"업무",
    	"업종",
    	"업체",
    	"엉덩이",
    	"엉망",
    	"엉터리",
    	"엊그제",
    	"에너지",
    	"에어컨",
    	"엔진",
    	"여건",
    	"여고생",
    	"여관",
    	"여군",
    	"여권",
    	"여대생",
    	"여덟",
    	"여동생",
    	"여든",
    	"여론",
    	"여름",
    	"여섯",
    	"여성",
    	"여왕",
    	"여인",
    	"여전히",
    	"여직원",
    	"여학생",
    	"여행",
    	"역사",
    	"역시",
    	"역할",
    	"연결",
    	"연구",
    	"연극",
    	"연기",
    	"연락",
    	"연설",
    	"연세",
    	"연속",
    	"연습",
    	"연애",
    	"연예인",
    	"연인",
    	"연장",
    	"연주",
    	"연출",
    	"연필",
    	"연합",
    	"연휴",
    	"열기",
    	"열매",
    	"열쇠",
    	"열심히",
    	"열정",
    	"열차",
    	"열흘",
    	"염려",
    	"엽서",
    	"영국",
    	"영남",
    	"영상",
    	"영양",
    	"영역",
    	"영웅",
    	"영원히",
    	"영하",
    	"영향",
    	"영혼",
    	"영화",
    	"옆구리",
    	"옆방",
    	"옆집",
    	"예감",
    	"예금",
    	"예방",
    	"예산",
    	"예상",
    	"예선",
    	"예술",
    	"예습",
    	"예식장",
    	"예약",
    	"예전",
    	"예절",
    	"예정",
    	"예컨대",
    	"옛날",
    	"오늘",
    	"오락",
    	"오랫동안",
    	"오렌지",
    	"오로지",
    	"오른발",
    	"오븐",
    	"오십",
    	"오염",
    	"오월",
    	"오전",
    	"오직",
    	"오징어",
    	"오페라",
    	"오피스텔",
    	"오히려",
    	"옥상",
    	"옥수수",
    	"온갖",
    	"온라인",
    	"온몸",
    	"온종일",
    	"온통",
    	"올가을",
    	"올림픽",
    	"올해",
    	"옷차림",
    	"와이셔츠",
    	"와인",
    	"완성",
    	"완전",
    	"왕비",
    	"왕자",
    	"왜냐하면",
    	"왠지",
    	"외갓집",
    	"외국",
    	"외로움",
    	"외삼촌",
    	"외출",
    	"외침",
    	"외할머니",
    	"왼발",
    	"왼손",
    	"왼쪽",
    	"요금",
    	"요일",
    	"요즘",
    	"요청",
    	"용기",
    	"용서",
    	"용어",
    	"우산",
    	"우선",
    	"우승",
    	"우연히",
    	"우정",
    	"우체국",
    	"우편",
    	"운동",
    	"운명",
    	"운반",
    	"운전",
    	"운행",
    	"울산",
    	"울음",
    	"움직임",
    	"웃어른",
    	"웃음",
    	"워낙",
    	"원고",
    	"원래",
    	"원서",
    	"원숭이",
    	"원인",
    	"원장",
    	"원피스",
    	"월급",
    	"월드컵",
    	"월세",
    	"월요일",
    	"웨이터",
    	"위반",
    	"위법",
    	"위성",
    	"위원",
    	"위험",
    	"위협",
    	"윗사람",
    	"유난히",
    	"유럽",
    	"유명",
    	"유물",
    	"유산",
    	"유적",
    	"유치원",
    	"유학",
    	"유행",
    	"유형",
    	"육군",
    	"육상",
    	"육십",
    	"육체",
    	"은행",
    	"음력",
    	"음료",
    	"음반",
    	"음성",
    	"음식",
    	"음악",
    	"음주",
    	"의견",
    	"의논",
    	"의문",
    	"의복",
    	"의식",
    	"의심",
    	"의외로",
    	"의욕",
    	"의원",
    	"의학",
    	"이것",
    	"이곳",
    	"이념",
    	"이놈",
    	"이달",
    	"이대로",
    	"이동",
    	"이렇게",
    	"이력서",
    	"이론적",
    	"이름",
    	"이민",
    	"이발소",
    	"이별",
    	"이불",
    	"이빨",
    	"이상",
    	"이성",
    	"이슬",
    	"이야기",
    	"이용",
    	"이웃",
    	"이월",
    	"이윽고",
    	"이익",
    	"이전",
    	"이중",
    	"이튿날",
    	"이틀",
    	"이혼",
    	"인간",
    	"인격",
    	"인공",
    	"인구",
    	"인근",
    	"인기",
    	"인도",
    	"인류",
    	"인물",
    	"인생",
    	"인쇄",
    	"인연",
    	"인원",
    	"인재",
    	"인종",
    	"인천",
    	"인체",
    	"인터넷",
    	"인하",
    	"인형",
    	"일곱",
    	"일기",
    	"일단",
    	"일대",
    	"일등",
    	"일반",
    	"일본",
    	"일부",
    	"일상",
    	"일생",
    	"일손",
    	"일요일",
    	"일월",
    	"일정",
    	"일종",
    	"일주일",
    	"일찍",
    	"일체",
    	"일치",
    	"일행",
    	"일회용",
    	"임금",
    	"임무",
    	"입대",
    	"입력",
    	"입맛",
    	"입사",
    	"입술",
    	"입시",
    	"입원",
    	"입장",
    	"입학",
    	"자가용",
    	"자격",
    	"자극",
    	"자동",
    	"자랑",
    	"자부심",
    	"자식",
    	"자신",
    	"자연",
    	"자원",
    	"자율",
    	"자전거",
    	"자정",
    	"자존심",
    	"자판",
    	"작가",
    	"작년",
    	"작성",
    	"작업",
    	"작용",
    	"작은딸",
    	"작품",
    	"잔디",
    	"잔뜩",
    	"잔치",
    	"잘못",
    	"잠깐",
    	"잠수함",
    	"잠시",
    	"잠옷",
    	"잠자리",
    	"잡지",
    	"장관",
    	"장군",
    	"장기간",
    	"장래",
    	"장례",
    	"장르",
    	"장마",
    	"장면",
    	"장모",
    	"장미",
    	"장비",
    	"장사",
    	"장소",
    	"장식",
    	"장애인",
    	"장인",
    	"장점",
    	"장차",
    	"장학금",
    	"재능",
    	"재빨리",
    	"재산",
    	"재생",
    	"재작년",
    	"재정",
    	"재채기",
    	"재판",
    	"재학",
    	"재활용",
    	"저것",
    	"저고리",
    	"저곳",
    	"저녁",
    	"저런",
    	"저렇게",
    	"저번",
    	"저울",
    	"저절로",
    	"저축",
    	"적극",
    	"적당히",
    	"적성",
    	"적용",
    	"적응",
    	"전개",
    	"전공",
    	"전기",
    	"전달",
    	"전라도",
    	"전망",
    	"전문",
    	"전반",
    	"전부",
    	"전세",
    	"전시",
    	"전용",
    	"전자",
    	"전쟁",
    	"전주",
    	"전철",
    	"전체",
    	"전통",
    	"전혀",
    	"전후",
    	"절대",
    	"절망",
    	"절반",
    	"절약",
    	"절차",
    	"점검",
    	"점수",
    	"점심",
    	"점원",
    	"점점",
    	"점차",
    	"접근",
    	"접시",
    	"접촉",
    	"젓가락",
    	"정거장",
    	"정도",
    	"정류장",
    	"정리",
    	"정말",
    	"정면",
    	"정문",
    	"정반대",
    	"정보",
    	"정부",
    	"정비",
    	"정상",
    	"정성",
    	"정오",
    	"정원",
    	"정장",
    	"정지",
    	"정치",
    	"정확히",
    	"제공",
    	"제과점",
    	"제대로",
    	"제목",
    	"제발",
    	"제법",
    	"제삿날",
    	"제안",
    	"제일",
    	"제작",
    	"제주도",
    	"제출",
    	"제품",
    	"제한",
    	"조각",
    	"조건",
    	"조금",
    	"조깅",
    	"조명",
    	"조미료",
    	"조상",
    	"조선",
    	"조용히",
    	"조절",
    	"조정",
    	"조직",
    	"존댓말",
    	"존재",
    	"졸업",
    	"졸음",
    	"종교",
    	"종로",
    	"종류",
    	"종소리",
    	"종업원",
    	"종종",
    	"종합",
    	"좌석",
    	"죄인",
    	"주관적",
    	"주름",
    	"주말",
    	"주머니",
    	"주먹",
    	"주문",
    	"주민",
    	"주방",
    	"주변",
    	"주식",
    	"주인",
    	"주일",
    	"주장",
    	"주전자",
    	"주택",
    	"준비",
    	"줄거리",
    	"줄기",
    	"줄무늬",
    	"중간",
    	"중계방송",
    	"중국",
    	"중년",
    	"중단",
    	"중독",
    	"중반",
    	"중부",
    	"중세",
    	"중소기업",
    	"중순",
    	"중앙",
    	"중요",
    	"중학교",
    	"즉석",
    	"즉시",
    	"즐거움",
    	"증가",
    	"증거",
    	"증권",
    	"증상",
    	"증세",
    	"지각",
    	"지갑",
    	"지경",
    	"지극히",
    	"지금",
    	"지급",
    	"지능",
    	"지름길",
    	"지리산",
    	"지방",
    	"지붕",
    	"지식",
    	"지역",
    	"지우개",
    	"지원",
    	"지적",
    	"지점",
    	"지진",
    	"지출",
    	"직선",
    	"직업",
    	"직원",
    	"직장",
    	"진급",
    	"진동",
    	"진로",
    	"진료",
    	"진리",
    	"진짜",
    	"진찰",
    	"진출",
    	"진통",
    	"진행",
    	"질문",
    	"질병",
    	"질서",
    	"짐작",
    	"집단",
    	"집안",
    	"집중",
    	"짜증",
    	"찌꺼기",
    	"차남",
    	"차라리",
    	"차량",
    	"차림",
    	"차별",
    	"차선",
    	"차츰",
    	"착각",
    	"찬물",
    	"찬성",
    	"참가",
    	"참기름",
    	"참새",
    	"참석",
    	"참여",
    	"참외",
    	"참조",
    	"찻잔",
    	"창가",
    	"창고",
    	"창구",
    	"창문",
    	"창밖",
    	"창작",
    	"창조",
    	"채널",
    	"채점",
    	"책가방",
    	"책방",
    	"책상",
    	"책임",
    	"챔피언",
    	"처벌",
    	"처음",
    	"천국",
    	"천둥",
    	"천장",
    	"천재",
    	"천천히",
    	"철도",
    	"철저히",
    	"철학",
    	"첫날",
    	"첫째",
    	"청년",
    	"청바지",
    	"청소",
    	"청춘",
    	"체계",
    	"체력",
    	"체온",
    	"체육",
    	"체중",
    	"체험",
    	"초등학생",
    	"초반",
    	"초밥",
    	"초상화",
    	"초순",
    	"초여름",
    	"초원",
    	"초저녁",
    	"초점",
    	"초청",
    	"초콜릿",
    	"촛불",
    	"총각",
    	"총리",
    	"총장",
    	"촬영",
    	"최근",
    	"최상",
    	"최선",
    	"최신",
    	"최악",
    	"최종",
    	"추석",
    	"추억",
    	"추진",
    	"추천",
    	"추측",
    	"축구",
    	"축소",
    	"축제",
    	"축하",
    	"출근",
    	"출발",
    	"출산",
    	"출신",
    	"출연",
    	"출입",
    	"출장",
    	"출판",
    	"충격",
    	"충고",
    	"충돌",
    	"충분히",
    	"충청도",
    	"취업",
    	"취직",
    	"취향",
    	"치약",
    	"친구",
    	"친척",
    	"칠십",
    	"칠월",
    	"칠판",
    	"침대",
    	"침묵",
    	"침실",
    	"칫솔",
    	"칭찬",
    	"카메라",
    	"카운터",
    	"칼국수",
    	"캐릭터",
    	"캠퍼스",
    	"캠페인",
    	"커튼",
    	"컨디션",
    	"컬러",
    	"컴퓨터",
    	"코끼리",
    	"코미디",
    	"콘서트",
    	"콜라",
    	"콤플렉스",
    	"콩나물",
    	"쾌감",
    	"쿠데타",
    	"크림",
    	"큰길",
    	"큰딸",
    	"큰소리",
    	"큰아들",
    	"큰어머니",
    	"큰일",
    	"큰절",
    	"클래식",
    	"클럽",
    	"킬로",
    	"타입",
    	"타자기",
    	"탁구",
    	"탁자",
    	"탄생",
    	"태권도",
    	"태양",
    	"태풍",
    	"택시",
    	"탤런트",
    	"터널",
    	"터미널",
    	"테니스",
    	"테스트",
    	"테이블",
    	"텔레비전",
    	"토론",
    	"토마토",
    	"토요일",
    	"통계",
    	"통과",
    	"통로",
    	"통신",
    	"통역",
    	"통일",
    	"통장",
    	"통제",
    	"통증",
    	"통합",
    	"통화",
    	"퇴근",
    	"퇴원",
    	"퇴직금",
    	"튀김",
    	"트럭",
    	"특급",
    	"특별",
    	"특성",
    	"특수",
    	"특징",
    	"특히",
    	"튼튼히",
    	"티셔츠",
    	"파란색",
    	"파일",
    	"파출소",
    	"판결",
    	"판단",
    	"판매",
    	"판사",
    	"팔십",
    	"팔월",
    	"팝송",
    	"패션",
    	"팩스",
    	"팩시밀리",
    	"팬티",
    	"퍼센트",
    	"페인트",
    	"편견",
    	"편의",
    	"편지",
    	"편히",
    	"평가",
    	"평균",
    	"평생",
    	"평소",
    	"평양",
    	"평일",
    	"평화",
    	"포스터",
    	"포인트",
    	"포장",
    	"포함",
    	"표면",
    	"표정",
    	"표준",
    	"표현",
    	"품목",
    	"품질",
    	"풍경",
    	"풍속",
    	"풍습",
    	"프랑스",
    	"프린터",
    	"플라스틱",
    	"피곤",
    	"피망",
    	"피아노",
    	"필름",
    	"필수",
    	"필요",
    	"필자",
    	"필통",
    	"핑계",
    	"하느님",
    	"하늘",
    	"하드웨어",
    	"하룻밤",
    	"하반기",
    	"하숙집",
    	"하순",
    	"하여튼",
    	"하지만",
    	"하천",
    	"하품",
    	"하필",
    	"학과",
    	"학교",
    	"학급",
    	"학기",
    	"학년",
    	"학력",
    	"학번",
    	"학부모",
    	"학비",
    	"학생",
    	"학술",
    	"학습",
    	"학용품",
    	"학원",
    	"학위",
    	"학자",
    	"학점",
    	"한계",
    	"한글",
    	"한꺼번에",
    	"한낮",
    	"한눈",
    	"한동안",
    	"한때",
    	"한라산",
    	"한마디",
    	"한문",
    	"한번",
    	"한복",
    	"한식",
    	"한여름",
    	"한쪽",
    	"할머니",
    	"할아버지",
    	"할인",
    	"함께",
    	"함부로",
    	"합격",
    	"합리적",
    	"항공",
    	"항구",
    	"항상",
    	"항의",
    	"해결",
    	"해군",
    	"해답",
    	"해당",
    	"해물",
    	"해석",
    	"해설",
    	"해수욕장",
    	"해안",
    	"핵심",
    	"핸드백",
    	"햄버거",
    	"햇볕",
    	"햇살",
    	"행동",
    	"행복",
    	"행사",
    	"행운",
    	"행위",
    	"향기",
    	"향상",
    	"향수",
    	"허락",
    	"허용",
    	"헬기",
    	"현관",
    	"현금",
    	"현대",
    	"현상",
    	"현실",
    	"현장",
    	"현재",
    	"현지",
    	"혈액",
    	"협력",
    	"형부",
    	"형사",
    	"형수",
    	"형식",
    	"형제",
    	"형태",
    	"형편",
    	"혜택",
    	"호기심",
    	"호남",
    	"호랑이",
    	"호박",
    	"호텔",
    	"호흡",
    	"혹시",
    	"홀로",
    	"홈페이지",
    	"홍보",
    	"홍수",
    	"홍차",
    	"화면",
    	"화분",
    	"화살",
    	"화요일",
    	"화장",
    	"화학",
    	"확보",
    	"확인",
    	"확장",
    	"확정",
    	"환갑",
    	"환경",
    	"환영",
    	"환율",
    	"환자",
    	"활기",
    	"활동",
    	"활발히",
    	"활용",
    	"활짝",
    	"회견",
    	"회관",
    	"회복",
    	"회색",
    	"회원",
    	"회장",
    	"회전",
    	"횟수",
    	"횡단보도",
    	"효율적",
    	"후반",
    	"후춧가루",
    	"훈련",
    	"훨씬",
    	"휴식",
    	"휴일",
    	"흉내",
    	"흐름",
    	"흑백",
    	"흑인",
    	"흔적",
    	"흔히",
    	"흥미",
    	"흥분",
    	"희곡",
    	"희망",
    	"희생",
    	"흰색",
    	"힘껏"
    ];

    var require$$12 = [
    	"ábaco",
    	"abdomen",
    	"abeja",
    	"abierto",
    	"abogado",
    	"abono",
    	"aborto",
    	"abrazo",
    	"abrir",
    	"abuelo",
    	"abuso",
    	"acabar",
    	"academia",
    	"acceso",
    	"acción",
    	"aceite",
    	"acelga",
    	"acento",
    	"aceptar",
    	"ácido",
    	"aclarar",
    	"acné",
    	"acoger",
    	"acoso",
    	"activo",
    	"acto",
    	"actriz",
    	"actuar",
    	"acudir",
    	"acuerdo",
    	"acusar",
    	"adicto",
    	"admitir",
    	"adoptar",
    	"adorno",
    	"aduana",
    	"adulto",
    	"aéreo",
    	"afectar",
    	"afición",
    	"afinar",
    	"afirmar",
    	"ágil",
    	"agitar",
    	"agonía",
    	"agosto",
    	"agotar",
    	"agregar",
    	"agrio",
    	"agua",
    	"agudo",
    	"águila",
    	"aguja",
    	"ahogo",
    	"ahorro",
    	"aire",
    	"aislar",
    	"ajedrez",
    	"ajeno",
    	"ajuste",
    	"alacrán",
    	"alambre",
    	"alarma",
    	"alba",
    	"álbum",
    	"alcalde",
    	"aldea",
    	"alegre",
    	"alejar",
    	"alerta",
    	"aleta",
    	"alfiler",
    	"alga",
    	"algodón",
    	"aliado",
    	"aliento",
    	"alivio",
    	"alma",
    	"almeja",
    	"almíbar",
    	"altar",
    	"alteza",
    	"altivo",
    	"alto",
    	"altura",
    	"alumno",
    	"alzar",
    	"amable",
    	"amante",
    	"amapola",
    	"amargo",
    	"amasar",
    	"ámbar",
    	"ámbito",
    	"ameno",
    	"amigo",
    	"amistad",
    	"amor",
    	"amparo",
    	"amplio",
    	"ancho",
    	"anciano",
    	"ancla",
    	"andar",
    	"andén",
    	"anemia",
    	"ángulo",
    	"anillo",
    	"ánimo",
    	"anís",
    	"anotar",
    	"antena",
    	"antiguo",
    	"antojo",
    	"anual",
    	"anular",
    	"anuncio",
    	"añadir",
    	"añejo",
    	"año",
    	"apagar",
    	"aparato",
    	"apetito",
    	"apio",
    	"aplicar",
    	"apodo",
    	"aporte",
    	"apoyo",
    	"aprender",
    	"aprobar",
    	"apuesta",
    	"apuro",
    	"arado",
    	"araña",
    	"arar",
    	"árbitro",
    	"árbol",
    	"arbusto",
    	"archivo",
    	"arco",
    	"arder",
    	"ardilla",
    	"arduo",
    	"área",
    	"árido",
    	"aries",
    	"armonía",
    	"arnés",
    	"aroma",
    	"arpa",
    	"arpón",
    	"arreglo",
    	"arroz",
    	"arruga",
    	"arte",
    	"artista",
    	"asa",
    	"asado",
    	"asalto",
    	"ascenso",
    	"asegurar",
    	"aseo",
    	"asesor",
    	"asiento",
    	"asilo",
    	"asistir",
    	"asno",
    	"asombro",
    	"áspero",
    	"astilla",
    	"astro",
    	"astuto",
    	"asumir",
    	"asunto",
    	"atajo",
    	"ataque",
    	"atar",
    	"atento",
    	"ateo",
    	"ático",
    	"atleta",
    	"átomo",
    	"atraer",
    	"atroz",
    	"atún",
    	"audaz",
    	"audio",
    	"auge",
    	"aula",
    	"aumento",
    	"ausente",
    	"autor",
    	"aval",
    	"avance",
    	"avaro",
    	"ave",
    	"avellana",
    	"avena",
    	"avestruz",
    	"avión",
    	"aviso",
    	"ayer",
    	"ayuda",
    	"ayuno",
    	"azafrán",
    	"azar",
    	"azote",
    	"azúcar",
    	"azufre",
    	"azul",
    	"baba",
    	"babor",
    	"bache",
    	"bahía",
    	"baile",
    	"bajar",
    	"balanza",
    	"balcón",
    	"balde",
    	"bambú",
    	"banco",
    	"banda",
    	"baño",
    	"barba",
    	"barco",
    	"barniz",
    	"barro",
    	"báscula",
    	"bastón",
    	"basura",
    	"batalla",
    	"batería",
    	"batir",
    	"batuta",
    	"baúl",
    	"bazar",
    	"bebé",
    	"bebida",
    	"bello",
    	"besar",
    	"beso",
    	"bestia",
    	"bicho",
    	"bien",
    	"bingo",
    	"blanco",
    	"bloque",
    	"blusa",
    	"boa",
    	"bobina",
    	"bobo",
    	"boca",
    	"bocina",
    	"boda",
    	"bodega",
    	"boina",
    	"bola",
    	"bolero",
    	"bolsa",
    	"bomba",
    	"bondad",
    	"bonito",
    	"bono",
    	"bonsái",
    	"borde",
    	"borrar",
    	"bosque",
    	"bote",
    	"botín",
    	"bóveda",
    	"bozal",
    	"bravo",
    	"brazo",
    	"brecha",
    	"breve",
    	"brillo",
    	"brinco",
    	"brisa",
    	"broca",
    	"broma",
    	"bronce",
    	"brote",
    	"bruja",
    	"brusco",
    	"bruto",
    	"buceo",
    	"bucle",
    	"bueno",
    	"buey",
    	"bufanda",
    	"bufón",
    	"búho",
    	"buitre",
    	"bulto",
    	"burbuja",
    	"burla",
    	"burro",
    	"buscar",
    	"butaca",
    	"buzón",
    	"caballo",
    	"cabeza",
    	"cabina",
    	"cabra",
    	"cacao",
    	"cadáver",
    	"cadena",
    	"caer",
    	"café",
    	"caída",
    	"caimán",
    	"caja",
    	"cajón",
    	"cal",
    	"calamar",
    	"calcio",
    	"caldo",
    	"calidad",
    	"calle",
    	"calma",
    	"calor",
    	"calvo",
    	"cama",
    	"cambio",
    	"camello",
    	"camino",
    	"campo",
    	"cáncer",
    	"candil",
    	"canela",
    	"canguro",
    	"canica",
    	"canto",
    	"caña",
    	"cañón",
    	"caoba",
    	"caos",
    	"capaz",
    	"capitán",
    	"capote",
    	"captar",
    	"capucha",
    	"cara",
    	"carbón",
    	"cárcel",
    	"careta",
    	"carga",
    	"cariño",
    	"carne",
    	"carpeta",
    	"carro",
    	"carta",
    	"casa",
    	"casco",
    	"casero",
    	"caspa",
    	"castor",
    	"catorce",
    	"catre",
    	"caudal",
    	"causa",
    	"cazo",
    	"cebolla",
    	"ceder",
    	"cedro",
    	"celda",
    	"célebre",
    	"celoso",
    	"célula",
    	"cemento",
    	"ceniza",
    	"centro",
    	"cerca",
    	"cerdo",
    	"cereza",
    	"cero",
    	"cerrar",
    	"certeza",
    	"césped",
    	"cetro",
    	"chacal",
    	"chaleco",
    	"champú",
    	"chancla",
    	"chapa",
    	"charla",
    	"chico",
    	"chiste",
    	"chivo",
    	"choque",
    	"choza",
    	"chuleta",
    	"chupar",
    	"ciclón",
    	"ciego",
    	"cielo",
    	"cien",
    	"cierto",
    	"cifra",
    	"cigarro",
    	"cima",
    	"cinco",
    	"cine",
    	"cinta",
    	"ciprés",
    	"circo",
    	"ciruela",
    	"cisne",
    	"cita",
    	"ciudad",
    	"clamor",
    	"clan",
    	"claro",
    	"clase",
    	"clave",
    	"cliente",
    	"clima",
    	"clínica",
    	"cobre",
    	"cocción",
    	"cochino",
    	"cocina",
    	"coco",
    	"código",
    	"codo",
    	"cofre",
    	"coger",
    	"cohete",
    	"cojín",
    	"cojo",
    	"cola",
    	"colcha",
    	"colegio",
    	"colgar",
    	"colina",
    	"collar",
    	"colmo",
    	"columna",
    	"combate",
    	"comer",
    	"comida",
    	"cómodo",
    	"compra",
    	"conde",
    	"conejo",
    	"conga",
    	"conocer",
    	"consejo",
    	"contar",
    	"copa",
    	"copia",
    	"corazón",
    	"corbata",
    	"corcho",
    	"cordón",
    	"corona",
    	"correr",
    	"coser",
    	"cosmos",
    	"costa",
    	"cráneo",
    	"cráter",
    	"crear",
    	"crecer",
    	"creído",
    	"crema",
    	"cría",
    	"crimen",
    	"cripta",
    	"crisis",
    	"cromo",
    	"crónica",
    	"croqueta",
    	"crudo",
    	"cruz",
    	"cuadro",
    	"cuarto",
    	"cuatro",
    	"cubo",
    	"cubrir",
    	"cuchara",
    	"cuello",
    	"cuento",
    	"cuerda",
    	"cuesta",
    	"cueva",
    	"cuidar",
    	"culebra",
    	"culpa",
    	"culto",
    	"cumbre",
    	"cumplir",
    	"cuna",
    	"cuneta",
    	"cuota",
    	"cupón",
    	"cúpula",
    	"curar",
    	"curioso",
    	"curso",
    	"curva",
    	"cutis",
    	"dama",
    	"danza",
    	"dar",
    	"dardo",
    	"dátil",
    	"deber",
    	"débil",
    	"década",
    	"decir",
    	"dedo",
    	"defensa",
    	"definir",
    	"dejar",
    	"delfín",
    	"delgado",
    	"delito",
    	"demora",
    	"denso",
    	"dental",
    	"deporte",
    	"derecho",
    	"derrota",
    	"desayuno",
    	"deseo",
    	"desfile",
    	"desnudo",
    	"destino",
    	"desvío",
    	"detalle",
    	"detener",
    	"deuda",
    	"día",
    	"diablo",
    	"diadema",
    	"diamante",
    	"diana",
    	"diario",
    	"dibujo",
    	"dictar",
    	"diente",
    	"dieta",
    	"diez",
    	"difícil",
    	"digno",
    	"dilema",
    	"diluir",
    	"dinero",
    	"directo",
    	"dirigir",
    	"disco",
    	"diseño",
    	"disfraz",
    	"diva",
    	"divino",
    	"doble",
    	"doce",
    	"dolor",
    	"domingo",
    	"don",
    	"donar",
    	"dorado",
    	"dormir",
    	"dorso",
    	"dos",
    	"dosis",
    	"dragón",
    	"droga",
    	"ducha",
    	"duda",
    	"duelo",
    	"dueño",
    	"dulce",
    	"dúo",
    	"duque",
    	"durar",
    	"dureza",
    	"duro",
    	"ébano",
    	"ebrio",
    	"echar",
    	"eco",
    	"ecuador",
    	"edad",
    	"edición",
    	"edificio",
    	"editor",
    	"educar",
    	"efecto",
    	"eficaz",
    	"eje",
    	"ejemplo",
    	"elefante",
    	"elegir",
    	"elemento",
    	"elevar",
    	"elipse",
    	"élite",
    	"elixir",
    	"elogio",
    	"eludir",
    	"embudo",
    	"emitir",
    	"emoción",
    	"empate",
    	"empeño",
    	"empleo",
    	"empresa",
    	"enano",
    	"encargo",
    	"enchufe",
    	"encía",
    	"enemigo",
    	"enero",
    	"enfado",
    	"enfermo",
    	"engaño",
    	"enigma",
    	"enlace",
    	"enorme",
    	"enredo",
    	"ensayo",
    	"enseñar",
    	"entero",
    	"entrar",
    	"envase",
    	"envío",
    	"época",
    	"equipo",
    	"erizo",
    	"escala",
    	"escena",
    	"escolar",
    	"escribir",
    	"escudo",
    	"esencia",
    	"esfera",
    	"esfuerzo",
    	"espada",
    	"espejo",
    	"espía",
    	"esposa",
    	"espuma",
    	"esquí",
    	"estar",
    	"este",
    	"estilo",
    	"estufa",
    	"etapa",
    	"eterno",
    	"ética",
    	"etnia",
    	"evadir",
    	"evaluar",
    	"evento",
    	"evitar",
    	"exacto",
    	"examen",
    	"exceso",
    	"excusa",
    	"exento",
    	"exigir",
    	"exilio",
    	"existir",
    	"éxito",
    	"experto",
    	"explicar",
    	"exponer",
    	"extremo",
    	"fábrica",
    	"fábula",
    	"fachada",
    	"fácil",
    	"factor",
    	"faena",
    	"faja",
    	"falda",
    	"fallo",
    	"falso",
    	"faltar",
    	"fama",
    	"familia",
    	"famoso",
    	"faraón",
    	"farmacia",
    	"farol",
    	"farsa",
    	"fase",
    	"fatiga",
    	"fauna",
    	"favor",
    	"fax",
    	"febrero",
    	"fecha",
    	"feliz",
    	"feo",
    	"feria",
    	"feroz",
    	"fértil",
    	"fervor",
    	"festín",
    	"fiable",
    	"fianza",
    	"fiar",
    	"fibra",
    	"ficción",
    	"ficha",
    	"fideo",
    	"fiebre",
    	"fiel",
    	"fiera",
    	"fiesta",
    	"figura",
    	"fijar",
    	"fijo",
    	"fila",
    	"filete",
    	"filial",
    	"filtro",
    	"fin",
    	"finca",
    	"fingir",
    	"finito",
    	"firma",
    	"flaco",
    	"flauta",
    	"flecha",
    	"flor",
    	"flota",
    	"fluir",
    	"flujo",
    	"flúor",
    	"fobia",
    	"foca",
    	"fogata",
    	"fogón",
    	"folio",
    	"folleto",
    	"fondo",
    	"forma",
    	"forro",
    	"fortuna",
    	"forzar",
    	"fosa",
    	"foto",
    	"fracaso",
    	"frágil",
    	"franja",
    	"frase",
    	"fraude",
    	"freír",
    	"freno",
    	"fresa",
    	"frío",
    	"frito",
    	"fruta",
    	"fuego",
    	"fuente",
    	"fuerza",
    	"fuga",
    	"fumar",
    	"función",
    	"funda",
    	"furgón",
    	"furia",
    	"fusil",
    	"fútbol",
    	"futuro",
    	"gacela",
    	"gafas",
    	"gaita",
    	"gajo",
    	"gala",
    	"galería",
    	"gallo",
    	"gamba",
    	"ganar",
    	"gancho",
    	"ganga",
    	"ganso",
    	"garaje",
    	"garza",
    	"gasolina",
    	"gastar",
    	"gato",
    	"gavilán",
    	"gemelo",
    	"gemir",
    	"gen",
    	"género",
    	"genio",
    	"gente",
    	"geranio",
    	"gerente",
    	"germen",
    	"gesto",
    	"gigante",
    	"gimnasio",
    	"girar",
    	"giro",
    	"glaciar",
    	"globo",
    	"gloria",
    	"gol",
    	"golfo",
    	"goloso",
    	"golpe",
    	"goma",
    	"gordo",
    	"gorila",
    	"gorra",
    	"gota",
    	"goteo",
    	"gozar",
    	"grada",
    	"gráfico",
    	"grano",
    	"grasa",
    	"gratis",
    	"grave",
    	"grieta",
    	"grillo",
    	"gripe",
    	"gris",
    	"grito",
    	"grosor",
    	"grúa",
    	"grueso",
    	"grumo",
    	"grupo",
    	"guante",
    	"guapo",
    	"guardia",
    	"guerra",
    	"guía",
    	"guiño",
    	"guion",
    	"guiso",
    	"guitarra",
    	"gusano",
    	"gustar",
    	"haber",
    	"hábil",
    	"hablar",
    	"hacer",
    	"hacha",
    	"hada",
    	"hallar",
    	"hamaca",
    	"harina",
    	"haz",
    	"hazaña",
    	"hebilla",
    	"hebra",
    	"hecho",
    	"helado",
    	"helio",
    	"hembra",
    	"herir",
    	"hermano",
    	"héroe",
    	"hervir",
    	"hielo",
    	"hierro",
    	"hígado",
    	"higiene",
    	"hijo",
    	"himno",
    	"historia",
    	"hocico",
    	"hogar",
    	"hoguera",
    	"hoja",
    	"hombre",
    	"hongo",
    	"honor",
    	"honra",
    	"hora",
    	"hormiga",
    	"horno",
    	"hostil",
    	"hoyo",
    	"hueco",
    	"huelga",
    	"huerta",
    	"hueso",
    	"huevo",
    	"huida",
    	"huir",
    	"humano",
    	"húmedo",
    	"humilde",
    	"humo",
    	"hundir",
    	"huracán",
    	"hurto",
    	"icono",
    	"ideal",
    	"idioma",
    	"ídolo",
    	"iglesia",
    	"iglú",
    	"igual",
    	"ilegal",
    	"ilusión",
    	"imagen",
    	"imán",
    	"imitar",
    	"impar",
    	"imperio",
    	"imponer",
    	"impulso",
    	"incapaz",
    	"índice",
    	"inerte",
    	"infiel",
    	"informe",
    	"ingenio",
    	"inicio",
    	"inmenso",
    	"inmune",
    	"innato",
    	"insecto",
    	"instante",
    	"interés",
    	"íntimo",
    	"intuir",
    	"inútil",
    	"invierno",
    	"ira",
    	"iris",
    	"ironía",
    	"isla",
    	"islote",
    	"jabalí",
    	"jabón",
    	"jamón",
    	"jarabe",
    	"jardín",
    	"jarra",
    	"jaula",
    	"jazmín",
    	"jefe",
    	"jeringa",
    	"jinete",
    	"jornada",
    	"joroba",
    	"joven",
    	"joya",
    	"juerga",
    	"jueves",
    	"juez",
    	"jugador",
    	"jugo",
    	"juguete",
    	"juicio",
    	"junco",
    	"jungla",
    	"junio",
    	"juntar",
    	"júpiter",
    	"jurar",
    	"justo",
    	"juvenil",
    	"juzgar",
    	"kilo",
    	"koala",
    	"labio",
    	"lacio",
    	"lacra",
    	"lado",
    	"ladrón",
    	"lagarto",
    	"lágrima",
    	"laguna",
    	"laico",
    	"lamer",
    	"lámina",
    	"lámpara",
    	"lana",
    	"lancha",
    	"langosta",
    	"lanza",
    	"lápiz",
    	"largo",
    	"larva",
    	"lástima",
    	"lata",
    	"látex",
    	"latir",
    	"laurel",
    	"lavar",
    	"lazo",
    	"leal",
    	"lección",
    	"leche",
    	"lector",
    	"leer",
    	"legión",
    	"legumbre",
    	"lejano",
    	"lengua",
    	"lento",
    	"leña",
    	"león",
    	"leopardo",
    	"lesión",
    	"letal",
    	"letra",
    	"leve",
    	"leyenda",
    	"libertad",
    	"libro",
    	"licor",
    	"líder",
    	"lidiar",
    	"lienzo",
    	"liga",
    	"ligero",
    	"lima",
    	"límite",
    	"limón",
    	"limpio",
    	"lince",
    	"lindo",
    	"línea",
    	"lingote",
    	"lino",
    	"linterna",
    	"líquido",
    	"liso",
    	"lista",
    	"litera",
    	"litio",
    	"litro",
    	"llaga",
    	"llama",
    	"llanto",
    	"llave",
    	"llegar",
    	"llenar",
    	"llevar",
    	"llorar",
    	"llover",
    	"lluvia",
    	"lobo",
    	"loción",
    	"loco",
    	"locura",
    	"lógica",
    	"logro",
    	"lombriz",
    	"lomo",
    	"lonja",
    	"lote",
    	"lucha",
    	"lucir",
    	"lugar",
    	"lujo",
    	"luna",
    	"lunes",
    	"lupa",
    	"lustro",
    	"luto",
    	"luz",
    	"maceta",
    	"macho",
    	"madera",
    	"madre",
    	"maduro",
    	"maestro",
    	"mafia",
    	"magia",
    	"mago",
    	"maíz",
    	"maldad",
    	"maleta",
    	"malla",
    	"malo",
    	"mamá",
    	"mambo",
    	"mamut",
    	"manco",
    	"mando",
    	"manejar",
    	"manga",
    	"maniquí",
    	"manjar",
    	"mano",
    	"manso",
    	"manta",
    	"mañana",
    	"mapa",
    	"máquina",
    	"mar",
    	"marco",
    	"marea",
    	"marfil",
    	"margen",
    	"marido",
    	"mármol",
    	"marrón",
    	"martes",
    	"marzo",
    	"masa",
    	"máscara",
    	"masivo",
    	"matar",
    	"materia",
    	"matiz",
    	"matriz",
    	"máximo",
    	"mayor",
    	"mazorca",
    	"mecha",
    	"medalla",
    	"medio",
    	"médula",
    	"mejilla",
    	"mejor",
    	"melena",
    	"melón",
    	"memoria",
    	"menor",
    	"mensaje",
    	"mente",
    	"menú",
    	"mercado",
    	"merengue",
    	"mérito",
    	"mes",
    	"mesón",
    	"meta",
    	"meter",
    	"método",
    	"metro",
    	"mezcla",
    	"miedo",
    	"miel",
    	"miembro",
    	"miga",
    	"mil",
    	"milagro",
    	"militar",
    	"millón",
    	"mimo",
    	"mina",
    	"minero",
    	"mínimo",
    	"minuto",
    	"miope",
    	"mirar",
    	"misa",
    	"miseria",
    	"misil",
    	"mismo",
    	"mitad",
    	"mito",
    	"mochila",
    	"moción",
    	"moda",
    	"modelo",
    	"moho",
    	"mojar",
    	"molde",
    	"moler",
    	"molino",
    	"momento",
    	"momia",
    	"monarca",
    	"moneda",
    	"monja",
    	"monto",
    	"moño",
    	"morada",
    	"morder",
    	"moreno",
    	"morir",
    	"morro",
    	"morsa",
    	"mortal",
    	"mosca",
    	"mostrar",
    	"motivo",
    	"mover",
    	"móvil",
    	"mozo",
    	"mucho",
    	"mudar",
    	"mueble",
    	"muela",
    	"muerte",
    	"muestra",
    	"mugre",
    	"mujer",
    	"mula",
    	"muleta",
    	"multa",
    	"mundo",
    	"muñeca",
    	"mural",
    	"muro",
    	"músculo",
    	"museo",
    	"musgo",
    	"música",
    	"muslo",
    	"nácar",
    	"nación",
    	"nadar",
    	"naipe",
    	"naranja",
    	"nariz",
    	"narrar",
    	"nasal",
    	"natal",
    	"nativo",
    	"natural",
    	"náusea",
    	"naval",
    	"nave",
    	"navidad",
    	"necio",
    	"néctar",
    	"negar",
    	"negocio",
    	"negro",
    	"neón",
    	"nervio",
    	"neto",
    	"neutro",
    	"nevar",
    	"nevera",
    	"nicho",
    	"nido",
    	"niebla",
    	"nieto",
    	"niñez",
    	"niño",
    	"nítido",
    	"nivel",
    	"nobleza",
    	"noche",
    	"nómina",
    	"noria",
    	"norma",
    	"norte",
    	"nota",
    	"noticia",
    	"novato",
    	"novela",
    	"novio",
    	"nube",
    	"nuca",
    	"núcleo",
    	"nudillo",
    	"nudo",
    	"nuera",
    	"nueve",
    	"nuez",
    	"nulo",
    	"número",
    	"nutria",
    	"oasis",
    	"obeso",
    	"obispo",
    	"objeto",
    	"obra",
    	"obrero",
    	"observar",
    	"obtener",
    	"obvio",
    	"oca",
    	"ocaso",
    	"océano",
    	"ochenta",
    	"ocho",
    	"ocio",
    	"ocre",
    	"octavo",
    	"octubre",
    	"oculto",
    	"ocupar",
    	"ocurrir",
    	"odiar",
    	"odio",
    	"odisea",
    	"oeste",
    	"ofensa",
    	"oferta",
    	"oficio",
    	"ofrecer",
    	"ogro",
    	"oído",
    	"oír",
    	"ojo",
    	"ola",
    	"oleada",
    	"olfato",
    	"olivo",
    	"olla",
    	"olmo",
    	"olor",
    	"olvido",
    	"ombligo",
    	"onda",
    	"onza",
    	"opaco",
    	"opción",
    	"ópera",
    	"opinar",
    	"oponer",
    	"optar",
    	"óptica",
    	"opuesto",
    	"oración",
    	"orador",
    	"oral",
    	"órbita",
    	"orca",
    	"orden",
    	"oreja",
    	"órgano",
    	"orgía",
    	"orgullo",
    	"oriente",
    	"origen",
    	"orilla",
    	"oro",
    	"orquesta",
    	"oruga",
    	"osadía",
    	"oscuro",
    	"osezno",
    	"oso",
    	"ostra",
    	"otoño",
    	"otro",
    	"oveja",
    	"óvulo",
    	"óxido",
    	"oxígeno",
    	"oyente",
    	"ozono",
    	"pacto",
    	"padre",
    	"paella",
    	"página",
    	"pago",
    	"país",
    	"pájaro",
    	"palabra",
    	"palco",
    	"paleta",
    	"pálido",
    	"palma",
    	"paloma",
    	"palpar",
    	"pan",
    	"panal",
    	"pánico",
    	"pantera",
    	"pañuelo",
    	"papá",
    	"papel",
    	"papilla",
    	"paquete",
    	"parar",
    	"parcela",
    	"pared",
    	"parir",
    	"paro",
    	"párpado",
    	"parque",
    	"párrafo",
    	"parte",
    	"pasar",
    	"paseo",
    	"pasión",
    	"paso",
    	"pasta",
    	"pata",
    	"patio",
    	"patria",
    	"pausa",
    	"pauta",
    	"pavo",
    	"payaso",
    	"peatón",
    	"pecado",
    	"pecera",
    	"pecho",
    	"pedal",
    	"pedir",
    	"pegar",
    	"peine",
    	"pelar",
    	"peldaño",
    	"pelea",
    	"peligro",
    	"pellejo",
    	"pelo",
    	"peluca",
    	"pena",
    	"pensar",
    	"peñón",
    	"peón",
    	"peor",
    	"pepino",
    	"pequeño",
    	"pera",
    	"percha",
    	"perder",
    	"pereza",
    	"perfil",
    	"perico",
    	"perla",
    	"permiso",
    	"perro",
    	"persona",
    	"pesa",
    	"pesca",
    	"pésimo",
    	"pestaña",
    	"pétalo",
    	"petróleo",
    	"pez",
    	"pezuña",
    	"picar",
    	"pichón",
    	"pie",
    	"piedra",
    	"pierna",
    	"pieza",
    	"pijama",
    	"pilar",
    	"piloto",
    	"pimienta",
    	"pino",
    	"pintor",
    	"pinza",
    	"piña",
    	"piojo",
    	"pipa",
    	"pirata",
    	"pisar",
    	"piscina",
    	"piso",
    	"pista",
    	"pitón",
    	"pizca",
    	"placa",
    	"plan",
    	"plata",
    	"playa",
    	"plaza",
    	"pleito",
    	"pleno",
    	"plomo",
    	"pluma",
    	"plural",
    	"pobre",
    	"poco",
    	"poder",
    	"podio",
    	"poema",
    	"poesía",
    	"poeta",
    	"polen",
    	"policía",
    	"pollo",
    	"polvo",
    	"pomada",
    	"pomelo",
    	"pomo",
    	"pompa",
    	"poner",
    	"porción",
    	"portal",
    	"posada",
    	"poseer",
    	"posible",
    	"poste",
    	"potencia",
    	"potro",
    	"pozo",
    	"prado",
    	"precoz",
    	"pregunta",
    	"premio",
    	"prensa",
    	"preso",
    	"previo",
    	"primo",
    	"príncipe",
    	"prisión",
    	"privar",
    	"proa",
    	"probar",
    	"proceso",
    	"producto",
    	"proeza",
    	"profesor",
    	"programa",
    	"prole",
    	"promesa",
    	"pronto",
    	"propio",
    	"próximo",
    	"prueba",
    	"público",
    	"puchero",
    	"pudor",
    	"pueblo",
    	"puerta",
    	"puesto",
    	"pulga",
    	"pulir",
    	"pulmón",
    	"pulpo",
    	"pulso",
    	"puma",
    	"punto",
    	"puñal",
    	"puño",
    	"pupa",
    	"pupila",
    	"puré",
    	"quedar",
    	"queja",
    	"quemar",
    	"querer",
    	"queso",
    	"quieto",
    	"química",
    	"quince",
    	"quitar",
    	"rábano",
    	"rabia",
    	"rabo",
    	"ración",
    	"radical",
    	"raíz",
    	"rama",
    	"rampa",
    	"rancho",
    	"rango",
    	"rapaz",
    	"rápido",
    	"rapto",
    	"rasgo",
    	"raspa",
    	"rato",
    	"rayo",
    	"raza",
    	"razón",
    	"reacción",
    	"realidad",
    	"rebaño",
    	"rebote",
    	"recaer",
    	"receta",
    	"rechazo",
    	"recoger",
    	"recreo",
    	"recto",
    	"recurso",
    	"red",
    	"redondo",
    	"reducir",
    	"reflejo",
    	"reforma",
    	"refrán",
    	"refugio",
    	"regalo",
    	"regir",
    	"regla",
    	"regreso",
    	"rehén",
    	"reino",
    	"reír",
    	"reja",
    	"relato",
    	"relevo",
    	"relieve",
    	"relleno",
    	"reloj",
    	"remar",
    	"remedio",
    	"remo",
    	"rencor",
    	"rendir",
    	"renta",
    	"reparto",
    	"repetir",
    	"reposo",
    	"reptil",
    	"res",
    	"rescate",
    	"resina",
    	"respeto",
    	"resto",
    	"resumen",
    	"retiro",
    	"retorno",
    	"retrato",
    	"reunir",
    	"revés",
    	"revista",
    	"rey",
    	"rezar",
    	"rico",
    	"riego",
    	"rienda",
    	"riesgo",
    	"rifa",
    	"rígido",
    	"rigor",
    	"rincón",
    	"riñón",
    	"río",
    	"riqueza",
    	"risa",
    	"ritmo",
    	"rito",
    	"rizo",
    	"roble",
    	"roce",
    	"rociar",
    	"rodar",
    	"rodeo",
    	"rodilla",
    	"roer",
    	"rojizo",
    	"rojo",
    	"romero",
    	"romper",
    	"ron",
    	"ronco",
    	"ronda",
    	"ropa",
    	"ropero",
    	"rosa",
    	"rosca",
    	"rostro",
    	"rotar",
    	"rubí",
    	"rubor",
    	"rudo",
    	"rueda",
    	"rugir",
    	"ruido",
    	"ruina",
    	"ruleta",
    	"rulo",
    	"rumbo",
    	"rumor",
    	"ruptura",
    	"ruta",
    	"rutina",
    	"sábado",
    	"saber",
    	"sabio",
    	"sable",
    	"sacar",
    	"sagaz",
    	"sagrado",
    	"sala",
    	"saldo",
    	"salero",
    	"salir",
    	"salmón",
    	"salón",
    	"salsa",
    	"salto",
    	"salud",
    	"salvar",
    	"samba",
    	"sanción",
    	"sandía",
    	"sanear",
    	"sangre",
    	"sanidad",
    	"sano",
    	"santo",
    	"sapo",
    	"saque",
    	"sardina",
    	"sartén",
    	"sastre",
    	"satán",
    	"sauna",
    	"saxofón",
    	"sección",
    	"seco",
    	"secreto",
    	"secta",
    	"sed",
    	"seguir",
    	"seis",
    	"sello",
    	"selva",
    	"semana",
    	"semilla",
    	"senda",
    	"sensor",
    	"señal",
    	"señor",
    	"separar",
    	"sepia",
    	"sequía",
    	"ser",
    	"serie",
    	"sermón",
    	"servir",
    	"sesenta",
    	"sesión",
    	"seta",
    	"setenta",
    	"severo",
    	"sexo",
    	"sexto",
    	"sidra",
    	"siesta",
    	"siete",
    	"siglo",
    	"signo",
    	"sílaba",
    	"silbar",
    	"silencio",
    	"silla",
    	"símbolo",
    	"simio",
    	"sirena",
    	"sistema",
    	"sitio",
    	"situar",
    	"sobre",
    	"socio",
    	"sodio",
    	"sol",
    	"solapa",
    	"soldado",
    	"soledad",
    	"sólido",
    	"soltar",
    	"solución",
    	"sombra",
    	"sondeo",
    	"sonido",
    	"sonoro",
    	"sonrisa",
    	"sopa",
    	"soplar",
    	"soporte",
    	"sordo",
    	"sorpresa",
    	"sorteo",
    	"sostén",
    	"sótano",
    	"suave",
    	"subir",
    	"suceso",
    	"sudor",
    	"suegra",
    	"suelo",
    	"sueño",
    	"suerte",
    	"sufrir",
    	"sujeto",
    	"sultán",
    	"sumar",
    	"superar",
    	"suplir",
    	"suponer",
    	"supremo",
    	"sur",
    	"surco",
    	"sureño",
    	"surgir",
    	"susto",
    	"sutil",
    	"tabaco",
    	"tabique",
    	"tabla",
    	"tabú",
    	"taco",
    	"tacto",
    	"tajo",
    	"talar",
    	"talco",
    	"talento",
    	"talla",
    	"talón",
    	"tamaño",
    	"tambor",
    	"tango",
    	"tanque",
    	"tapa",
    	"tapete",
    	"tapia",
    	"tapón",
    	"taquilla",
    	"tarde",
    	"tarea",
    	"tarifa",
    	"tarjeta",
    	"tarot",
    	"tarro",
    	"tarta",
    	"tatuaje",
    	"tauro",
    	"taza",
    	"tazón",
    	"teatro",
    	"techo",
    	"tecla",
    	"técnica",
    	"tejado",
    	"tejer",
    	"tejido",
    	"tela",
    	"teléfono",
    	"tema",
    	"temor",
    	"templo",
    	"tenaz",
    	"tender",
    	"tener",
    	"tenis",
    	"tenso",
    	"teoría",
    	"terapia",
    	"terco",
    	"término",
    	"ternura",
    	"terror",
    	"tesis",
    	"tesoro",
    	"testigo",
    	"tetera",
    	"texto",
    	"tez",
    	"tibio",
    	"tiburón",
    	"tiempo",
    	"tienda",
    	"tierra",
    	"tieso",
    	"tigre",
    	"tijera",
    	"tilde",
    	"timbre",
    	"tímido",
    	"timo",
    	"tinta",
    	"tío",
    	"típico",
    	"tipo",
    	"tira",
    	"tirón",
    	"titán",
    	"títere",
    	"título",
    	"tiza",
    	"toalla",
    	"tobillo",
    	"tocar",
    	"tocino",
    	"todo",
    	"toga",
    	"toldo",
    	"tomar",
    	"tono",
    	"tonto",
    	"topar",
    	"tope",
    	"toque",
    	"tórax",
    	"torero",
    	"tormenta",
    	"torneo",
    	"toro",
    	"torpedo",
    	"torre",
    	"torso",
    	"tortuga",
    	"tos",
    	"tosco",
    	"toser",
    	"tóxico",
    	"trabajo",
    	"tractor",
    	"traer",
    	"tráfico",
    	"trago",
    	"traje",
    	"tramo",
    	"trance",
    	"trato",
    	"trauma",
    	"trazar",
    	"trébol",
    	"tregua",
    	"treinta",
    	"tren",
    	"trepar",
    	"tres",
    	"tribu",
    	"trigo",
    	"tripa",
    	"triste",
    	"triunfo",
    	"trofeo",
    	"trompa",
    	"tronco",
    	"tropa",
    	"trote",
    	"trozo",
    	"truco",
    	"trueno",
    	"trufa",
    	"tubería",
    	"tubo",
    	"tuerto",
    	"tumba",
    	"tumor",
    	"túnel",
    	"túnica",
    	"turbina",
    	"turismo",
    	"turno",
    	"tutor",
    	"ubicar",
    	"úlcera",
    	"umbral",
    	"unidad",
    	"unir",
    	"universo",
    	"uno",
    	"untar",
    	"uña",
    	"urbano",
    	"urbe",
    	"urgente",
    	"urna",
    	"usar",
    	"usuario",
    	"útil",
    	"utopía",
    	"uva",
    	"vaca",
    	"vacío",
    	"vacuna",
    	"vagar",
    	"vago",
    	"vaina",
    	"vajilla",
    	"vale",
    	"válido",
    	"valle",
    	"valor",
    	"válvula",
    	"vampiro",
    	"vara",
    	"variar",
    	"varón",
    	"vaso",
    	"vecino",
    	"vector",
    	"vehículo",
    	"veinte",
    	"vejez",
    	"vela",
    	"velero",
    	"veloz",
    	"vena",
    	"vencer",
    	"venda",
    	"veneno",
    	"vengar",
    	"venir",
    	"venta",
    	"venus",
    	"ver",
    	"verano",
    	"verbo",
    	"verde",
    	"vereda",
    	"verja",
    	"verso",
    	"verter",
    	"vía",
    	"viaje",
    	"vibrar",
    	"vicio",
    	"víctima",
    	"vida",
    	"vídeo",
    	"vidrio",
    	"viejo",
    	"viernes",
    	"vigor",
    	"vil",
    	"villa",
    	"vinagre",
    	"vino",
    	"viñedo",
    	"violín",
    	"viral",
    	"virgo",
    	"virtud",
    	"visor",
    	"víspera",
    	"vista",
    	"vitamina",
    	"viudo",
    	"vivaz",
    	"vivero",
    	"vivir",
    	"vivo",
    	"volcán",
    	"volumen",
    	"volver",
    	"voraz",
    	"votar",
    	"voto",
    	"voz",
    	"vuelo",
    	"vulgar",
    	"yacer",
    	"yate",
    	"yegua",
    	"yema",
    	"yerno",
    	"yeso",
    	"yodo",
    	"yoga",
    	"yogur",
    	"zafiro",
    	"zanja",
    	"zapato",
    	"zarza",
    	"zona",
    	"zorro",
    	"zumo",
    	"zurdo"
    ];

    var Buffer$5 = safeBufferExports.Buffer;
    var createHash$1 = browser$2;
    var _pbkdf2 = browser$1;
    var pbkdf2 = _pbkdf2.pbkdf2Sync;
    var pbkdf2Async = _pbkdf2.pbkdf2;
    var randomBytes = browserExports;

    // use unorm until String.prototype.normalize gets better browser support
    var unorm = unormExports;

    var CHINESE_SIMPLIFIED_WORDLIST = require$$5;
    var CHINESE_TRADITIONAL_WORDLIST = require$$6;
    var ENGLISH_WORDLIST = require$$7;
    var FRENCH_WORDLIST = require$$8;
    var ITALIAN_WORDLIST = require$$9;
    var JAPANESE_WORDLIST = require$$10;
    var KOREAN_WORDLIST = require$$11;
    var SPANISH_WORDLIST = require$$12;
    var DEFAULT_WORDLIST = ENGLISH_WORDLIST;

    var INVALID_MNEMONIC = 'Invalid mnemonic';
    var INVALID_ENTROPY = 'Invalid entropy';
    var INVALID_CHECKSUM = 'Invalid mnemonic checksum';

    function lpad (str, padString, length) {
      while (str.length < length) str = padString + str;
      return str
    }

    function binaryToByte (bin) {
      return parseInt(bin, 2)
    }

    function bytesToBinary (bytes) {
      return bytes.map(function (x) {
        return lpad(x.toString(2), '0', 8)
      }).join('')
    }

    function deriveChecksumBits (entropyBuffer) {
      var ENT = entropyBuffer.length * 8;
      var CS = ENT / 32;
      var hash = createHash$1('sha256').update(entropyBuffer).digest();

      return bytesToBinary([].slice.call(hash)).slice(0, CS)
    }

    function salt (password) {
      return 'mnemonic' + (password || '')
    }

    function mnemonicToSeed (mnemonic, password) {
      var mnemonicBuffer = Buffer$5.from(unorm.nfkd(mnemonic), 'utf8');
      var saltBuffer = Buffer$5.from(salt(unorm.nfkd(password)), 'utf8');

      return pbkdf2(mnemonicBuffer, saltBuffer, 2048, 64, 'sha512')
    }

    function mnemonicToSeedHex (mnemonic, password) {
      return mnemonicToSeed(mnemonic, password).toString('hex')
    }

    function mnemonicToSeedAsync (mnemonic, password) {
      return new Promise(function (resolve, reject) {
        try {
          var mnemonicBuffer = Buffer$5.from(unorm.nfkd(mnemonic), 'utf8');
          var saltBuffer = Buffer$5.from(salt(unorm.nfkd(password)), 'utf8');
        } catch (error) {
          return reject(error)
        }

        pbkdf2Async(mnemonicBuffer, saltBuffer, 2048, 64, 'sha512', function (err, data) {
          if (err) return reject(err)
          else return resolve(data)
        });
      })
    }

    function mnemonicToSeedHexAsync (mnemonic, password) {
      return mnemonicToSeedAsync(mnemonic, password)
        .then(function (buf) { return buf.toString('hex') })
    }

    function mnemonicToEntropy (mnemonic, wordlist) {
      wordlist = wordlist || DEFAULT_WORDLIST;

      var words = unorm.nfkd(mnemonic).split(' ');
      if (words.length % 3 !== 0) throw new Error(INVALID_MNEMONIC)

      // convert word indices to 11 bit binary strings
      var bits = words.map(function (word) {
        var index = wordlist.indexOf(word);
        if (index === -1) throw new Error(INVALID_MNEMONIC)

        return lpad(index.toString(2), '0', 11)
      }).join('');

      // split the binary string into ENT/CS
      var dividerIndex = Math.floor(bits.length / 33) * 32;
      var entropyBits = bits.slice(0, dividerIndex);
      var checksumBits = bits.slice(dividerIndex);

      // calculate the checksum and compare
      var entropyBytes = entropyBits.match(/(.{1,8})/g).map(binaryToByte);
      if (entropyBytes.length < 16) throw new Error(INVALID_ENTROPY)
      if (entropyBytes.length > 32) throw new Error(INVALID_ENTROPY)
      if (entropyBytes.length % 4 !== 0) throw new Error(INVALID_ENTROPY)

      var entropy = Buffer$5.from(entropyBytes);
      var newChecksum = deriveChecksumBits(entropy);
      if (newChecksum !== checksumBits) throw new Error(INVALID_CHECKSUM)

      return entropy.toString('hex')
    }

    function entropyToMnemonic (entropy, wordlist) {
      if (!Buffer$5.isBuffer(entropy)) entropy = Buffer$5.from(entropy, 'hex');
      wordlist = wordlist || DEFAULT_WORDLIST;

      // 128 <= ENT <= 256
      if (entropy.length < 16) throw new TypeError(INVALID_ENTROPY)
      if (entropy.length > 32) throw new TypeError(INVALID_ENTROPY)
      if (entropy.length % 4 !== 0) throw new TypeError(INVALID_ENTROPY)

      var entropyBits = bytesToBinary([].slice.call(entropy));
      var checksumBits = deriveChecksumBits(entropy);

      var bits = entropyBits + checksumBits;
      var chunks = bits.match(/(.{1,11})/g);
      var words = chunks.map(function (binary) {
        var index = binaryToByte(binary);
        return wordlist[index]
      });

      return wordlist === JAPANESE_WORDLIST ? words.join('\u3000') : words.join(' ')
    }

    function generateMnemonic (strength, rng, wordlist) {
      strength = strength || 128;
      if (strength % 32 !== 0) throw new TypeError(INVALID_ENTROPY)
      rng = rng || randomBytes;

      return entropyToMnemonic(rng(strength / 8), wordlist)
    }

    function validateMnemonic (mnemonic, wordlist) {
      try {
        mnemonicToEntropy(mnemonic, wordlist);
      } catch (e) {
        return false
      }

      return true
    }

    var bip39 = {
      mnemonicToSeed: mnemonicToSeed,
      mnemonicToSeedAsync: mnemonicToSeedAsync,
      mnemonicToSeedHex: mnemonicToSeedHex,
      mnemonicToSeedHexAsync: mnemonicToSeedHexAsync,
      mnemonicToEntropy: mnemonicToEntropy,
      entropyToMnemonic: entropyToMnemonic,
      generateMnemonic: generateMnemonic,
      validateMnemonic: validateMnemonic,
      wordlists: {
        EN: ENGLISH_WORDLIST,
        JA: JAPANESE_WORDLIST,

        chinese_simplified: CHINESE_SIMPLIFIED_WORDLIST,
        chinese_traditional: CHINESE_TRADITIONAL_WORDLIST,
        english: ENGLISH_WORDLIST,
        french: FRENCH_WORDLIST,
        italian: ITALIAN_WORDLIST,
        japanese: JAPANESE_WORDLIST,
        korean: KOREAN_WORDLIST,
        spanish: SPANISH_WORDLIST
      }
    };

    var bip39$1 = /*@__PURE__*/getDefaultExportFromCjs(bip39);

    function compare(a, b) {
      if (a === b) {
        return 0;
      }

      var x = a.length;
      var y = b.length;

      for (var i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
          x = a[i];
          y = b[i];
          break;
        }
      }

      if (x < y) {
        return -1;
      }
      if (y < x) {
        return 1;
      }
      return 0;
    }
    var hasOwn = Object.prototype.hasOwnProperty;

    var objectKeys = Object.keys || function (obj) {
      var keys = [];
      for (var key in obj) {
        if (hasOwn.call(obj, key)) keys.push(key);
      }
      return keys;
    };
    var pSlice = Array.prototype.slice;
    var _functionsHaveNames;
    function functionsHaveNames() {
      if (typeof _functionsHaveNames !== 'undefined') {
        return _functionsHaveNames;
      }
      return _functionsHaveNames = (function () {
        return function foo() {}.name === 'foo';
      }());
    }
    function pToString (obj) {
      return Object.prototype.toString.call(obj);
    }
    function isView(arrbuf) {
      if (isBuffer$1(arrbuf)) {
        return false;
      }
      if (typeof global$1.ArrayBuffer !== 'function') {
        return false;
      }
      if (typeof ArrayBuffer.isView === 'function') {
        return ArrayBuffer.isView(arrbuf);
      }
      if (!arrbuf) {
        return false;
      }
      if (arrbuf instanceof DataView) {
        return true;
      }
      if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
        return true;
      }
      return false;
    }
    // 1. The assert module provides functions that throw
    // AssertionError's when particular conditions are not met. The
    // assert module must conform to the following interface.

    function assert$j(value, message) {
      if (!value) fail(value, true, message, '==', ok);
    }

    // 2. The AssertionError is defined in assert.
    // new assert.AssertionError({ message: message,
    //                             actual: actual,
    //                             expected: expected })

    var regex = /\s*function\s+([^\(\s]*)\s*/;
    // based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
    function getName(func) {
      if (!isFunction(func)) {
        return;
      }
      if (functionsHaveNames()) {
        return func.name;
      }
      var str = func.toString();
      var match = str.match(regex);
      return match && match[1];
    }
    assert$j.AssertionError = AssertionError;
    function AssertionError(options) {
      this.name = 'AssertionError';
      this.actual = options.actual;
      this.expected = options.expected;
      this.operator = options.operator;
      if (options.message) {
        this.message = options.message;
        this.generatedMessage = false;
      } else {
        this.message = getMessage(this);
        this.generatedMessage = true;
      }
      var stackStartFunction = options.stackStartFunction || fail;
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, stackStartFunction);
      } else {
        // non v8 browsers so we can have a stacktrace
        var err = new Error();
        if (err.stack) {
          var out = err.stack;

          // try to strip useless frames
          var fn_name = getName(stackStartFunction);
          var idx = out.indexOf('\n' + fn_name);
          if (idx >= 0) {
            // once we have located the function frame
            // we need to strip out everything before it (and its line)
            var next_line = out.indexOf('\n', idx + 1);
            out = out.substring(next_line + 1);
          }

          this.stack = out;
        }
      }
    }

    // assert.AssertionError instanceof Error
    inherits$g(AssertionError, Error);

    function truncate(s, n) {
      if (typeof s === 'string') {
        return s.length < n ? s : s.slice(0, n);
      } else {
        return s;
      }
    }
    function inspect(something) {
      if (functionsHaveNames() || !isFunction(something)) {
        return inspect$1(something);
      }
      var rawname = getName(something);
      var name = rawname ? ': ' + rawname : '';
      return '[Function' +  name + ']';
    }
    function getMessage(self) {
      return truncate(inspect(self.actual), 128) + ' ' +
             self.operator + ' ' +
             truncate(inspect(self.expected), 128);
    }

    // At present only the three keys mentioned above are used and
    // understood by the spec. Implementations or sub modules can pass
    // other keys to the AssertionError's constructor - they will be
    // ignored.

    // 3. All of the following functions must throw an AssertionError
    // when a corresponding condition is not met, with a message that
    // may be undefined if not provided.  All assertion methods provide
    // both the actual and expected values to the assertion error for
    // display purposes.

    function fail(actual, expected, message, operator, stackStartFunction) {
      throw new AssertionError({
        message: message,
        actual: actual,
        expected: expected,
        operator: operator,
        stackStartFunction: stackStartFunction
      });
    }

    // EXTENSION! allows for well behaved errors defined elsewhere.
    assert$j.fail = fail;

    // 4. Pure assertion tests whether a value is truthy, as determined
    // by !!guard.
    // assert.ok(guard, message_opt);
    // This statement is equivalent to assert.equal(true, !!guard,
    // message_opt);. To test strictly for the value true, use
    // assert.strictEqual(true, guard, message_opt);.

    function ok(value, message) {
      if (!value) fail(value, true, message, '==', ok);
    }
    assert$j.ok = ok;

    // 5. The equality assertion tests shallow, coercive equality with
    // ==.
    // assert.equal(actual, expected, message_opt);
    assert$j.equal = equal;
    function equal(actual, expected, message) {
      if (actual != expected) fail(actual, expected, message, '==', equal);
    }

    // 6. The non-equality assertion tests for whether two objects are not equal
    // with != assert.notEqual(actual, expected, message_opt);
    assert$j.notEqual = notEqual;
    function notEqual(actual, expected, message) {
      if (actual == expected) {
        fail(actual, expected, message, '!=', notEqual);
      }
    }

    // 7. The equivalence assertion tests a deep equality relation.
    // assert.deepEqual(actual, expected, message_opt);
    assert$j.deepEqual = deepEqual;
    function deepEqual(actual, expected, message) {
      if (!_deepEqual(actual, expected, false)) {
        fail(actual, expected, message, 'deepEqual', deepEqual);
      }
    }
    assert$j.deepStrictEqual = deepStrictEqual;
    function deepStrictEqual(actual, expected, message) {
      if (!_deepEqual(actual, expected, true)) {
        fail(actual, expected, message, 'deepStrictEqual', deepStrictEqual);
      }
    }

    function _deepEqual(actual, expected, strict, memos) {
      // 7.1. All identical values are equivalent, as determined by ===.
      if (actual === expected) {
        return true;
      } else if (isBuffer$1(actual) && isBuffer$1(expected)) {
        return compare(actual, expected) === 0;

      // 7.2. If the expected value is a Date object, the actual value is
      // equivalent if it is also a Date object that refers to the same time.
      } else if (isDate(actual) && isDate(expected)) {
        return actual.getTime() === expected.getTime();

      // 7.3 If the expected value is a RegExp object, the actual value is
      // equivalent if it is also a RegExp object with the same source and
      // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
      } else if (isRegExp(actual) && isRegExp(expected)) {
        return actual.source === expected.source &&
               actual.global === expected.global &&
               actual.multiline === expected.multiline &&
               actual.lastIndex === expected.lastIndex &&
               actual.ignoreCase === expected.ignoreCase;

      // 7.4. Other pairs that do not both pass typeof value == 'object',
      // equivalence is determined by ==.
      } else if ((actual === null || typeof actual !== 'object') &&
                 (expected === null || typeof expected !== 'object')) {
        return strict ? actual === expected : actual == expected;

      // If both values are instances of typed arrays, wrap their underlying
      // ArrayBuffers in a Buffer each to increase performance
      // This optimization requires the arrays to have the same type as checked by
      // Object.prototype.toString (aka pToString). Never perform binary
      // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
      // bit patterns are not identical.
      } else if (isView(actual) && isView(expected) &&
                 pToString(actual) === pToString(expected) &&
                 !(actual instanceof Float32Array ||
                   actual instanceof Float64Array)) {
        return compare(new Uint8Array(actual.buffer),
                       new Uint8Array(expected.buffer)) === 0;

      // 7.5 For all other Object pairs, including Array objects, equivalence is
      // determined by having the same number of owned properties (as verified
      // with Object.prototype.hasOwnProperty.call), the same set of keys
      // (although not necessarily the same order), equivalent values for every
      // corresponding key, and an identical 'prototype' property. Note: this
      // accounts for both named and indexed properties on Arrays.
      } else if (isBuffer$1(actual) !== isBuffer$1(expected)) {
        return false;
      } else {
        memos = memos || {actual: [], expected: []};

        var actualIndex = memos.actual.indexOf(actual);
        if (actualIndex !== -1) {
          if (actualIndex === memos.expected.indexOf(expected)) {
            return true;
          }
        }

        memos.actual.push(actual);
        memos.expected.push(expected);

        return objEquiv(actual, expected, strict, memos);
      }
    }

    function isArguments(object) {
      return Object.prototype.toString.call(object) == '[object Arguments]';
    }

    function objEquiv(a, b, strict, actualVisitedObjects) {
      if (a === null || a === undefined || b === null || b === undefined)
        return false;
      // if one is a primitive, the other must be same
      if (isPrimitive(a) || isPrimitive(b))
        return a === b;
      if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
        return false;
      var aIsArgs = isArguments(a);
      var bIsArgs = isArguments(b);
      if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
        return false;
      if (aIsArgs) {
        a = pSlice.call(a);
        b = pSlice.call(b);
        return _deepEqual(a, b, strict);
      }
      var ka = objectKeys(a);
      var kb = objectKeys(b);
      var key, i;
      // having the same number of owned properties (keys incorporates
      // hasOwnProperty)
      if (ka.length !== kb.length)
        return false;
      //the same set of keys (although not necessarily the same order),
      ka.sort();
      kb.sort();
      //~~~cheap key test
      for (i = ka.length - 1; i >= 0; i--) {
        if (ka[i] !== kb[i])
          return false;
      }
      //equivalent values for every corresponding key, and
      //~~~possibly expensive deep test
      for (i = ka.length - 1; i >= 0; i--) {
        key = ka[i];
        if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
          return false;
      }
      return true;
    }

    // 8. The non-equivalence assertion tests for any deep inequality.
    // assert.notDeepEqual(actual, expected, message_opt);
    assert$j.notDeepEqual = notDeepEqual;
    function notDeepEqual(actual, expected, message) {
      if (_deepEqual(actual, expected, false)) {
        fail(actual, expected, message, 'notDeepEqual', notDeepEqual);
      }
    }

    assert$j.notDeepStrictEqual = notDeepStrictEqual;
    function notDeepStrictEqual(actual, expected, message) {
      if (_deepEqual(actual, expected, true)) {
        fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
      }
    }


    // 9. The strict equality assertion tests strict equality, as determined by ===.
    // assert.strictEqual(actual, expected, message_opt);
    assert$j.strictEqual = strictEqual;
    function strictEqual(actual, expected, message) {
      if (actual !== expected) {
        fail(actual, expected, message, '===', strictEqual);
      }
    }

    // 10. The strict non-equality assertion tests for strict inequality, as
    // determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
    assert$j.notStrictEqual = notStrictEqual;
    function notStrictEqual(actual, expected, message) {
      if (actual === expected) {
        fail(actual, expected, message, '!==', notStrictEqual);
      }
    }

    function expectedException(actual, expected) {
      if (!actual || !expected) {
        return false;
      }

      if (Object.prototype.toString.call(expected) == '[object RegExp]') {
        return expected.test(actual);
      }

      try {
        if (actual instanceof expected) {
          return true;
        }
      } catch (e) {
        // Ignore.  The instanceof check doesn't work for arrow functions.
      }

      if (Error.isPrototypeOf(expected)) {
        return false;
      }

      return expected.call({}, actual) === true;
    }

    function _tryBlock(block) {
      var error;
      try {
        block();
      } catch (e) {
        error = e;
      }
      return error;
    }

    function _throws(shouldThrow, block, expected, message) {
      var actual;

      if (typeof block !== 'function') {
        throw new TypeError('"block" argument must be a function');
      }

      if (typeof expected === 'string') {
        message = expected;
        expected = null;
      }

      actual = _tryBlock(block);

      message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
                (message ? ' ' + message : '.');

      if (shouldThrow && !actual) {
        fail(actual, expected, 'Missing expected exception' + message);
      }

      var userProvidedMessage = typeof message === 'string';
      var isUnwantedException = !shouldThrow && isError(actual);
      var isUnexpectedException = !shouldThrow && actual && !expected;

      if ((isUnwantedException &&
          userProvidedMessage &&
          expectedException(actual, expected)) ||
          isUnexpectedException) {
        fail(actual, expected, 'Got unwanted exception' + message);
      }

      if ((shouldThrow && actual && expected &&
          !expectedException(actual, expected)) || (!shouldThrow && actual)) {
        throw actual;
      }
    }

    // 11. Expected to throw an error:
    // assert.throws(block, Error_opt, message_opt);
    assert$j.throws = throws;
    function throws(block, /*optional*/error, /*optional*/message) {
      _throws(true, block, error, message);
    }

    // EXTENSION! This is annoying to write outside this module.
    assert$j.doesNotThrow = doesNotThrow;
    function doesNotThrow(block, /*optional*/error, /*optional*/message) {
      _throws(false, block, error, message);
    }

    assert$j.ifError = ifError;
    function ifError(err) {
      if (err) throw err;
    }

    var _polyfillNode_assert = /*#__PURE__*/Object.freeze({
        __proto__: null,
        'default': assert$j,
        AssertionError: AssertionError,
        fail: fail,
        ok: ok,
        assert: ok,
        equal: equal,
        notEqual: notEqual,
        deepEqual: deepEqual,
        deepStrictEqual: deepStrictEqual,
        notDeepEqual: notDeepEqual,
        notDeepStrictEqual: notDeepStrictEqual,
        strictEqual: strictEqual,
        notStrictEqual: notStrictEqual,
        throws: throws,
        doesNotThrow: doesNotThrow,
        ifError: ifError
    });

    var require$$0$1 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_assert);

    var _polyfillNode_crypto = {};

    var _polyfillNode_crypto$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        'default': _polyfillNode_crypto
    });

    var require$$2 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_crypto$1);

    // base-x encoding / decoding
    // Copyright (c) 2018 base-x contributors
    // Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
    // Distributed under the MIT software license, see the accompanying
    // file LICENSE or http://www.opensource.org/licenses/mit-license.php.
    // @ts-ignore
    var _Buffer = safeBufferExports.Buffer;
    function base$2 (ALPHABET) {
      if (ALPHABET.length >= 255) { throw new TypeError('Alphabet too long') }
      var BASE_MAP = new Uint8Array(256);
      for (var j = 0; j < BASE_MAP.length; j++) {
        BASE_MAP[j] = 255;
      }
      for (var i = 0; i < ALPHABET.length; i++) {
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) { throw new TypeError(x + ' is ambiguous') }
        BASE_MAP[xc] = i;
      }
      var BASE = ALPHABET.length;
      var LEADER = ALPHABET.charAt(0);
      var FACTOR = Math.log(BASE) / Math.log(256); // log(BASE) / log(256), rounded up
      var iFACTOR = Math.log(256) / Math.log(BASE); // log(256) / log(BASE), rounded up
      function encode (source) {
        if (Array.isArray(source) || source instanceof Uint8Array) { source = _Buffer.from(source); }
        if (!_Buffer.isBuffer(source)) { throw new TypeError('Expected Buffer') }
        if (source.length === 0) { return '' }
            // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while (pbegin !== pend && source[pbegin] === 0) {
          pbegin++;
          zeroes++;
        }
            // Allocate enough space in big-endian base58 representation.
        var size = ((pend - pbegin) * iFACTOR + 1) >>> 0;
        var b58 = new Uint8Array(size);
            // Process the bytes.
        while (pbegin !== pend) {
          var carry = source[pbegin];
                // Apply "b58 = b58 * 256 + ch".
          var i = 0;
          for (var it1 = size - 1; (carry !== 0 || i < length) && (it1 !== -1); it1--, i++) {
            carry += (256 * b58[it1]) >>> 0;
            b58[it1] = (carry % BASE) >>> 0;
            carry = (carry / BASE) >>> 0;
          }
          if (carry !== 0) { throw new Error('Non-zero carry') }
          length = i;
          pbegin++;
        }
            // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while (it2 !== size && b58[it2] === 0) {
          it2++;
        }
            // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for (; it2 < size; ++it2) { str += ALPHABET.charAt(b58[it2]); }
        return str
      }
      function decodeUnsafe (source) {
        if (typeof source !== 'string') { throw new TypeError('Expected String') }
        if (source.length === 0) { return _Buffer.alloc(0) }
        var psz = 0;
            // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while (source[psz] === LEADER) {
          zeroes++;
          psz++;
        }
            // Allocate enough space in big-endian base256 representation.
        var size = (((source.length - psz) * FACTOR) + 1) >>> 0; // log(58) / log(256), rounded up.
        var b256 = new Uint8Array(size);
            // Process the characters.
        while (source[psz]) {
                // Decode character
          var carry = BASE_MAP[source.charCodeAt(psz)];
                // Invalid character
          if (carry === 255) { return }
          var i = 0;
          for (var it3 = size - 1; (carry !== 0 || i < length) && (it3 !== -1); it3--, i++) {
            carry += (BASE * b256[it3]) >>> 0;
            b256[it3] = (carry % 256) >>> 0;
            carry = (carry / 256) >>> 0;
          }
          if (carry !== 0) { throw new Error('Non-zero carry') }
          length = i;
          psz++;
        }
            // Skip leading zeroes in b256.
        var it4 = size - length;
        while (it4 !== size && b256[it4] === 0) {
          it4++;
        }
        var vch = _Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while (it4 !== size) {
          vch[j++] = b256[it4++];
        }
        return vch
      }
      function decode (string) {
        var buffer = decodeUnsafe(string);
        if (buffer) { return buffer }
        throw new Error('Non-base' + BASE + ' character')
      }
      return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
      }
    }
    var src = base$2;

    var basex = src;
    var ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';

    var bs58 = basex(ALPHABET);

    var base58 = bs58;
    var Buffer$4 = safeBufferExports.Buffer;

    var base$1 = function (checksumFn) {
      // Encode a buffer as a base58-check encoded string
      function encode (payload) {
        var checksum = checksumFn(payload);

        return base58.encode(Buffer$4.concat([
          payload,
          checksum
        ], payload.length + 4))
      }

      function decodeRaw (buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);

        if (checksum[0] ^ newChecksum[0] |
            checksum[1] ^ newChecksum[1] |
            checksum[2] ^ newChecksum[2] |
            checksum[3] ^ newChecksum[3]) return

        return payload
      }

      // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
      function decodeUnsafe (string) {
        var buffer = base58.decodeUnsafe(string);
        if (!buffer) return

        return decodeRaw(buffer)
      }

      function decode (string) {
        var buffer = base58.decode(string);
        var payload = decodeRaw(buffer);
        if (!payload) throw new Error('Invalid checksum')
        return payload
      }

      return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
      }
    };

    var createHash = browser$2;
    var bs58checkBase = base$1;

    // SHA256(SHA256(buffer))
    function sha256x2 (buffer) {
      var tmp = createHash('sha256').update(buffer).digest();
      return createHash('sha256').update(tmp).digest()
    }

    var bs58check$1 = bs58checkBase(sha256x2);

    var assert$i = {};

    var toString = Object.prototype.toString;

    // TypeError
    assert$i.isArray = function (value, message) {
      if (!Array.isArray(value)) throw TypeError(message)
    };

    assert$i.isBoolean = function (value, message) {
      if (toString.call(value) !== '[object Boolean]') throw TypeError(message)
    };

    assert$i.isBuffer = function (value, message) {
      if (!Buffer.isBuffer(value)) throw TypeError(message)
    };

    assert$i.isFunction = function (value, message) {
      if (toString.call(value) !== '[object Function]') throw TypeError(message)
    };

    assert$i.isNumber = function (value, message) {
      if (toString.call(value) !== '[object Number]') throw TypeError(message)
    };

    assert$i.isObject = function (value, message) {
      if (toString.call(value) !== '[object Object]') throw TypeError(message)
    };

    // RangeError
    assert$i.isBufferLength = function (buffer, length, message) {
      if (buffer.length !== length) throw RangeError(message)
    };

    assert$i.isBufferLength2 = function (buffer, length1, length2, message) {
      if (buffer.length !== length1 && buffer.length !== length2) throw RangeError(message)
    };

    assert$i.isLengthGTZero = function (value, message) {
      if (value.length === 0) throw RangeError(message)
    };

    assert$i.isNumberInInterval = function (number, x, y, message) {
      if (number <= x || number >= y) throw RangeError(message)
    };

    var der$1 = {};

    // Reference https://github.com/bitcoin/bips/blob/master/bip-0066.mediawiki
    // Format: 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
    // NOTE: SIGHASH byte ignored AND restricted, truncate before use

    var Buffer$3 = safeBufferExports.Buffer;

    function check (buffer) {
      if (buffer.length < 8) return false
      if (buffer.length > 72) return false
      if (buffer[0] !== 0x30) return false
      if (buffer[1] !== buffer.length - 2) return false
      if (buffer[2] !== 0x02) return false

      var lenR = buffer[3];
      if (lenR === 0) return false
      if (5 + lenR >= buffer.length) return false
      if (buffer[4 + lenR] !== 0x02) return false

      var lenS = buffer[5 + lenR];
      if (lenS === 0) return false
      if ((6 + lenR + lenS) !== buffer.length) return false

      if (buffer[4] & 0x80) return false
      if (lenR > 1 && (buffer[4] === 0x00) && !(buffer[5] & 0x80)) return false

      if (buffer[lenR + 6] & 0x80) return false
      if (lenS > 1 && (buffer[lenR + 6] === 0x00) && !(buffer[lenR + 7] & 0x80)) return false
      return true
    }

    function decode (buffer) {
      if (buffer.length < 8) throw new Error('DER sequence length is too short')
      if (buffer.length > 72) throw new Error('DER sequence length is too long')
      if (buffer[0] !== 0x30) throw new Error('Expected DER sequence')
      if (buffer[1] !== buffer.length - 2) throw new Error('DER sequence length is invalid')
      if (buffer[2] !== 0x02) throw new Error('Expected DER integer')

      var lenR = buffer[3];
      if (lenR === 0) throw new Error('R length is zero')
      if (5 + lenR >= buffer.length) throw new Error('R length is too long')
      if (buffer[4 + lenR] !== 0x02) throw new Error('Expected DER integer (2)')

      var lenS = buffer[5 + lenR];
      if (lenS === 0) throw new Error('S length is zero')
      if ((6 + lenR + lenS) !== buffer.length) throw new Error('S length is invalid')

      if (buffer[4] & 0x80) throw new Error('R value is negative')
      if (lenR > 1 && (buffer[4] === 0x00) && !(buffer[5] & 0x80)) throw new Error('R value excessively padded')

      if (buffer[lenR + 6] & 0x80) throw new Error('S value is negative')
      if (lenS > 1 && (buffer[lenR + 6] === 0x00) && !(buffer[lenR + 7] & 0x80)) throw new Error('S value excessively padded')

      // non-BIP66 - extract R, S values
      return {
        r: buffer.slice(4, 4 + lenR),
        s: buffer.slice(6 + lenR)
      }
    }

    /*
     * Expects r and s to be positive DER integers.
     *
     * The DER format uses the most significant bit as a sign bit (& 0x80).
     * If the significant bit is set AND the integer is positive, a 0x00 is prepended.
     *
     * Examples:
     *
     *      0 =>     0x00
     *      1 =>     0x01
     *     -1 =>     0xff
     *    127 =>     0x7f
     *   -127 =>     0x81
     *    128 =>   0x0080
     *   -128 =>     0x80
     *    255 =>   0x00ff
     *   -255 =>   0xff01
     *  16300 =>   0x3fac
     * -16300 =>   0xc054
     *  62300 => 0x00f35c
     * -62300 => 0xff0ca4
    */
    function encode (r, s) {
      var lenR = r.length;
      var lenS = s.length;
      if (lenR === 0) throw new Error('R length is zero')
      if (lenS === 0) throw new Error('S length is zero')
      if (lenR > 33) throw new Error('R length is too long')
      if (lenS > 33) throw new Error('S length is too long')
      if (r[0] & 0x80) throw new Error('R value is negative')
      if (s[0] & 0x80) throw new Error('S value is negative')
      if (lenR > 1 && (r[0] === 0x00) && !(r[1] & 0x80)) throw new Error('R value excessively padded')
      if (lenS > 1 && (s[0] === 0x00) && !(s[1] & 0x80)) throw new Error('S value excessively padded')

      var signature = Buffer$3.allocUnsafe(6 + lenR + lenS);

      // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
      signature[0] = 0x30;
      signature[1] = signature.length - 2;
      signature[2] = 0x02;
      signature[3] = r.length;
      r.copy(signature, 4);
      signature[4 + lenR] = 0x02;
      signature[5 + lenR] = s.length;
      s.copy(signature, 6 + lenR);

      return signature
    }

    var bip66$1 = {
      check: check,
      decode: decode,
      encode: encode
    };

    var Buffer$2 = safeBufferExports.Buffer;
    var bip66 = bip66$1;

    var EC_PRIVKEY_EXPORT_DER_COMPRESSED = Buffer$2.from([
      // begin
      0x30, 0x81, 0xd3, 0x02, 0x01, 0x01, 0x04, 0x20,
      // private key
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
      // middle
      0xa0, 0x81, 0x85, 0x30, 0x81, 0x82, 0x02, 0x01, 0x01, 0x30, 0x2c, 0x06, 0x07, 0x2a, 0x86, 0x48,
      0xcE, 0x3d, 0x01, 0x01, 0x02, 0x21, 0x00, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
      0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
      0xff, 0xff, 0xfE, 0xff, 0xff, 0xfc, 0x2f, 0x30, 0x06, 0x04, 0x01, 0x00, 0x04, 0x01, 0x07, 0x04,
      0x21, 0x02, 0x79, 0xbE, 0x66, 0x7E, 0xf9, 0xdc, 0xbb, 0xac, 0x55, 0xa0, 0x62, 0x95, 0xcE, 0x87,
      0x0b, 0x07, 0x02, 0x9b, 0xfc, 0xdb, 0x2d, 0xcE, 0x28, 0xd9, 0x59, 0xf2, 0x81, 0x5b, 0x16, 0xf8,
      0x17, 0x98, 0x02, 0x21, 0x00, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
      0xff, 0xff, 0xff, 0xff, 0xfE, 0xba, 0xaE, 0xdc, 0xE6, 0xaf, 0x48, 0xa0, 0x3b, 0xbf, 0xd2, 0x5E,
      0x8c, 0xd0, 0x36, 0x41, 0x41, 0x02, 0x01, 0x01, 0xa1, 0x24, 0x03, 0x22, 0x00,
      // public key
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
      0x00
    ]);

    var EC_PRIVKEY_EXPORT_DER_UNCOMPRESSED = Buffer$2.from([
      // begin
      0x30, 0x82, 0x01, 0x13, 0x02, 0x01, 0x01, 0x04, 0x20,
      // private key
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
      // middle
      0xa0, 0x81, 0xa5, 0x30, 0x81, 0xa2, 0x02, 0x01, 0x01, 0x30, 0x2c, 0x06, 0x07, 0x2a, 0x86, 0x48,
      0xcE, 0x3d, 0x01, 0x01, 0x02, 0x21, 0x00, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
      0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
      0xff, 0xff, 0xfE, 0xff, 0xff, 0xfc, 0x2f, 0x30, 0x06, 0x04, 0x01, 0x00, 0x04, 0x01, 0x07, 0x04,
      0x41, 0x04, 0x79, 0xbE, 0x66, 0x7E, 0xf9, 0xdc, 0xbb, 0xac, 0x55, 0xa0, 0x62, 0x95, 0xcE, 0x87,
      0x0b, 0x07, 0x02, 0x9b, 0xfc, 0xdb, 0x2d, 0xcE, 0x28, 0xd9, 0x59, 0xf2, 0x81, 0x5b, 0x16, 0xf8,
      0x17, 0x98, 0x48, 0x3a, 0xda, 0x77, 0x26, 0xa3, 0xc4, 0x65, 0x5d, 0xa4, 0xfb, 0xfc, 0x0E, 0x11,
      0x08, 0xa8, 0xfd, 0x17, 0xb4, 0x48, 0xa6, 0x85, 0x54, 0x19, 0x9c, 0x47, 0xd0, 0x8f, 0xfb, 0x10,
      0xd4, 0xb8, 0x02, 0x21, 0x00, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
      0xff, 0xff, 0xff, 0xff, 0xfE, 0xba, 0xaE, 0xdc, 0xE6, 0xaf, 0x48, 0xa0, 0x3b, 0xbf, 0xd2, 0x5E,
      0x8c, 0xd0, 0x36, 0x41, 0x41, 0x02, 0x01, 0x01, 0xa1, 0x44, 0x03, 0x42, 0x00,
      // public key
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
      0x00
    ]);

    der$1.privateKeyExport = function (privateKey, publicKey, compressed) {
      var result = Buffer$2.from(compressed ? EC_PRIVKEY_EXPORT_DER_COMPRESSED : EC_PRIVKEY_EXPORT_DER_UNCOMPRESSED);
      privateKey.copy(result, compressed ? 8 : 9);
      publicKey.copy(result, compressed ? 181 : 214);
      return result
    };

    der$1.privateKeyImport = function (privateKey) {
      var length = privateKey.length;

      // sequence header
      var index = 0;
      if (length < index + 1 || privateKey[index] !== 0x30) return
      index += 1;

      // sequence length constructor
      if (length < index + 1 || !(privateKey[index] & 0x80)) return

      var lenb = privateKey[index] & 0x7f;
      index += 1;
      if (lenb < 1 || lenb > 2) return
      if (length < index + lenb) return

      // sequence length
      var len = privateKey[index + lenb - 1] | (lenb > 1 ? privateKey[index + lenb - 2] << 8 : 0);
      index += lenb;
      if (length < index + len) return

      // sequence element 0: version number (=1)
      if (length < index + 3 ||
          privateKey[index] !== 0x02 ||
          privateKey[index + 1] !== 0x01 ||
          privateKey[index + 2] !== 0x01) {
        return
      }
      index += 3;

      // sequence element 1: octet string, up to 32 bytes
      if (length < index + 2 ||
          privateKey[index] !== 0x04 ||
          privateKey[index + 1] > 0x20 ||
          length < index + 2 + privateKey[index + 1]) {
        return
      }

      return privateKey.slice(index + 2, index + 2 + privateKey[index + 1])
    };

    der$1.signatureExport = function (sigObj) {
      var r = Buffer$2.concat([Buffer$2.from([0]), sigObj.r]);
      for (var lenR = 33, posR = 0; lenR > 1 && r[posR] === 0x00 && !(r[posR + 1] & 0x80); --lenR, ++posR);

      var s = Buffer$2.concat([Buffer$2.from([0]), sigObj.s]);
      for (var lenS = 33, posS = 0; lenS > 1 && s[posS] === 0x00 && !(s[posS + 1] & 0x80); --lenS, ++posS);

      return bip66.encode(r.slice(posR), s.slice(posS))
    };

    der$1.signatureImport = function (sig) {
      var r = Buffer$2.alloc(32, 0);
      var s = Buffer$2.alloc(32, 0);

      try {
        var sigObj = bip66.decode(sig);
        if (sigObj.r.length === 33 && sigObj.r[0] === 0x00) sigObj.r = sigObj.r.slice(1);
        if (sigObj.r.length > 32) throw new Error('R length is too long')
        if (sigObj.s.length === 33 && sigObj.s[0] === 0x00) sigObj.s = sigObj.s.slice(1);
        if (sigObj.s.length > 32) throw new Error('S length is too long')
      } catch (err) {
        return
      }

      sigObj.r.copy(r, 32 - sigObj.r.length);
      sigObj.s.copy(s, 32 - sigObj.s.length);

      return { r: r, s: s }
    };

    der$1.signatureImportLax = function (sig) {
      var r = Buffer$2.alloc(32, 0);
      var s = Buffer$2.alloc(32, 0);

      var length = sig.length;
      var index = 0;

      // sequence tag byte
      if (sig[index++] !== 0x30) return

      // sequence length byte
      var lenbyte = sig[index++];
      if (lenbyte & 0x80) {
        index += lenbyte - 0x80;
        if (index > length) return
      }

      // sequence tag byte for r
      if (sig[index++] !== 0x02) return

      // length for r
      var rlen = sig[index++];
      if (rlen & 0x80) {
        lenbyte = rlen - 0x80;
        if (index + lenbyte > length) return
        for (; lenbyte > 0 && sig[index] === 0x00; index += 1, lenbyte -= 1);
        for (rlen = 0; lenbyte > 0; index += 1, lenbyte -= 1) rlen = (rlen << 8) + sig[index];
      }
      if (rlen > length - index) return
      var rindex = index;
      index += rlen;

      // sequence tag byte for s
      if (sig[index++] !== 0x02) return

      // length for s
      var slen = sig[index++];
      if (slen & 0x80) {
        lenbyte = slen - 0x80;
        if (index + lenbyte > length) return
        for (; lenbyte > 0 && sig[index] === 0x00; index += 1, lenbyte -= 1);
        for (slen = 0; lenbyte > 0; index += 1, lenbyte -= 1) slen = (slen << 8) + sig[index];
      }
      if (slen > length - index) return
      var sindex = index;
      index += slen;

      // ignore leading zeros in r
      for (; rlen > 0 && sig[rindex] === 0x00; rlen -= 1, rindex += 1);
      // copy r value
      if (rlen > 32) return
      var rvalue = sig.slice(rindex, rindex + rlen);
      rvalue.copy(r, 32 - rvalue.length);

      // ignore leading zeros in s
      for (; slen > 0 && sig[sindex] === 0x00; slen -= 1, sindex += 1);
      // copy s value
      if (slen > 32) return
      var svalue = sig.slice(sindex, sindex + slen);
      svalue.copy(s, 32 - svalue.length);

      return { r: r, s: s }
    };

    var COMPRESSED_TYPE_INVALID = "compressed should be a boolean";
    var EC_PRIVATE_KEY_TYPE_INVALID = "private key should be a Buffer";
    var EC_PRIVATE_KEY_LENGTH_INVALID = "private key length is invalid";
    var EC_PRIVATE_KEY_RANGE_INVALID = "private key range is invalid";
    var EC_PRIVATE_KEY_TWEAK_ADD_FAIL = "tweak out of range or resulting private key is invalid";
    var EC_PRIVATE_KEY_TWEAK_MUL_FAIL = "tweak out of range";
    var EC_PRIVATE_KEY_EXPORT_DER_FAIL = "couldn't export to DER format";
    var EC_PRIVATE_KEY_IMPORT_DER_FAIL = "couldn't import from DER format";
    var EC_PUBLIC_KEYS_TYPE_INVALID = "public keys should be an Array";
    var EC_PUBLIC_KEYS_LENGTH_INVALID = "public keys Array should have at least 1 element";
    var EC_PUBLIC_KEY_TYPE_INVALID = "public key should be a Buffer";
    var EC_PUBLIC_KEY_LENGTH_INVALID = "public key length is invalid";
    var EC_PUBLIC_KEY_PARSE_FAIL = "the public key could not be parsed or is invalid";
    var EC_PUBLIC_KEY_CREATE_FAIL = "private was invalid, try again";
    var EC_PUBLIC_KEY_TWEAK_ADD_FAIL = "tweak out of range or resulting public key is invalid";
    var EC_PUBLIC_KEY_TWEAK_MUL_FAIL = "tweak out of range";
    var EC_PUBLIC_KEY_COMBINE_FAIL = "the sum of the public keys is not valid";
    var ECDH_FAIL = "scalar was invalid (zero or overflow)";
    var ECDSA_SIGNATURE_TYPE_INVALID = "signature should be a Buffer";
    var ECDSA_SIGNATURE_LENGTH_INVALID = "signature length is invalid";
    var ECDSA_SIGNATURE_PARSE_FAIL = "couldn't parse signature";
    var ECDSA_SIGNATURE_PARSE_DER_FAIL = "couldn't parse DER signature";
    var ECDSA_SIGNATURE_SERIALIZE_DER_FAIL = "couldn't serialize signature to DER format";
    var ECDSA_SIGN_FAIL = "nonce generation function failed or private key is invalid";
    var ECDSA_RECOVER_FAIL = "couldn't recover public key from signature";
    var MSG32_TYPE_INVALID = "message should be a Buffer";
    var MSG32_LENGTH_INVALID = "message length is invalid";
    var OPTIONS_TYPE_INVALID = "options should be an Object";
    var OPTIONS_DATA_TYPE_INVALID = "options.data should be a Buffer";
    var OPTIONS_DATA_LENGTH_INVALID = "options.data length is invalid";
    var OPTIONS_NONCEFN_TYPE_INVALID = "options.noncefn should be a Function";
    var RECOVERY_ID_TYPE_INVALID = "recovery should be a Number";
    var RECOVERY_ID_VALUE_INVALID = "recovery should have value between -1 and 4";
    var TWEAK_TYPE_INVALID = "tweak should be a Buffer";
    var TWEAK_LENGTH_INVALID = "tweak length is invalid";
    var require$$4 = {
    	COMPRESSED_TYPE_INVALID: COMPRESSED_TYPE_INVALID,
    	EC_PRIVATE_KEY_TYPE_INVALID: EC_PRIVATE_KEY_TYPE_INVALID,
    	EC_PRIVATE_KEY_LENGTH_INVALID: EC_PRIVATE_KEY_LENGTH_INVALID,
    	EC_PRIVATE_KEY_RANGE_INVALID: EC_PRIVATE_KEY_RANGE_INVALID,
    	EC_PRIVATE_KEY_TWEAK_ADD_FAIL: EC_PRIVATE_KEY_TWEAK_ADD_FAIL,
    	EC_PRIVATE_KEY_TWEAK_MUL_FAIL: EC_PRIVATE_KEY_TWEAK_MUL_FAIL,
    	EC_PRIVATE_KEY_EXPORT_DER_FAIL: EC_PRIVATE_KEY_EXPORT_DER_FAIL,
    	EC_PRIVATE_KEY_IMPORT_DER_FAIL: EC_PRIVATE_KEY_IMPORT_DER_FAIL,
    	EC_PUBLIC_KEYS_TYPE_INVALID: EC_PUBLIC_KEYS_TYPE_INVALID,
    	EC_PUBLIC_KEYS_LENGTH_INVALID: EC_PUBLIC_KEYS_LENGTH_INVALID,
    	EC_PUBLIC_KEY_TYPE_INVALID: EC_PUBLIC_KEY_TYPE_INVALID,
    	EC_PUBLIC_KEY_LENGTH_INVALID: EC_PUBLIC_KEY_LENGTH_INVALID,
    	EC_PUBLIC_KEY_PARSE_FAIL: EC_PUBLIC_KEY_PARSE_FAIL,
    	EC_PUBLIC_KEY_CREATE_FAIL: EC_PUBLIC_KEY_CREATE_FAIL,
    	EC_PUBLIC_KEY_TWEAK_ADD_FAIL: EC_PUBLIC_KEY_TWEAK_ADD_FAIL,
    	EC_PUBLIC_KEY_TWEAK_MUL_FAIL: EC_PUBLIC_KEY_TWEAK_MUL_FAIL,
    	EC_PUBLIC_KEY_COMBINE_FAIL: EC_PUBLIC_KEY_COMBINE_FAIL,
    	ECDH_FAIL: ECDH_FAIL,
    	ECDSA_SIGNATURE_TYPE_INVALID: ECDSA_SIGNATURE_TYPE_INVALID,
    	ECDSA_SIGNATURE_LENGTH_INVALID: ECDSA_SIGNATURE_LENGTH_INVALID,
    	ECDSA_SIGNATURE_PARSE_FAIL: ECDSA_SIGNATURE_PARSE_FAIL,
    	ECDSA_SIGNATURE_PARSE_DER_FAIL: ECDSA_SIGNATURE_PARSE_DER_FAIL,
    	ECDSA_SIGNATURE_SERIALIZE_DER_FAIL: ECDSA_SIGNATURE_SERIALIZE_DER_FAIL,
    	ECDSA_SIGN_FAIL: ECDSA_SIGN_FAIL,
    	ECDSA_RECOVER_FAIL: ECDSA_RECOVER_FAIL,
    	MSG32_TYPE_INVALID: MSG32_TYPE_INVALID,
    	MSG32_LENGTH_INVALID: MSG32_LENGTH_INVALID,
    	OPTIONS_TYPE_INVALID: OPTIONS_TYPE_INVALID,
    	OPTIONS_DATA_TYPE_INVALID: OPTIONS_DATA_TYPE_INVALID,
    	OPTIONS_DATA_LENGTH_INVALID: OPTIONS_DATA_LENGTH_INVALID,
    	OPTIONS_NONCEFN_TYPE_INVALID: OPTIONS_NONCEFN_TYPE_INVALID,
    	RECOVERY_ID_TYPE_INVALID: RECOVERY_ID_TYPE_INVALID,
    	RECOVERY_ID_VALUE_INVALID: RECOVERY_ID_VALUE_INVALID,
    	TWEAK_TYPE_INVALID: TWEAK_TYPE_INVALID,
    	TWEAK_LENGTH_INVALID: TWEAK_LENGTH_INVALID
    };

    var assert$h = assert$i;
    var der = der$1;
    var messages = require$$4;

    function initCompressedValue (value, defaultValue) {
      if (value === undefined) return defaultValue

      assert$h.isBoolean(value, messages.COMPRESSED_TYPE_INVALID);
      return value
    }

    var lib = function (secp256k1) {
      return {
        privateKeyVerify: function (privateKey) {
          assert$h.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID);
          return privateKey.length === 32 && secp256k1.privateKeyVerify(privateKey)
        },

        privateKeyExport: function (privateKey, compressed) {
          assert$h.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID);
          assert$h.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID);

          compressed = initCompressedValue(compressed, true);
          var publicKey = secp256k1.privateKeyExport(privateKey, compressed);

          return der.privateKeyExport(privateKey, publicKey, compressed)
        },

        privateKeyImport: function (privateKey) {
          assert$h.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID);

          privateKey = der.privateKeyImport(privateKey);
          if (privateKey && privateKey.length === 32 && secp256k1.privateKeyVerify(privateKey)) return privateKey

          throw new Error(messages.EC_PRIVATE_KEY_IMPORT_DER_FAIL)
        },

        privateKeyNegate: function (privateKey) {
          assert$h.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID);
          assert$h.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID);

          return secp256k1.privateKeyNegate(privateKey)
        },

        privateKeyModInverse: function (privateKey) {
          assert$h.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID);
          assert$h.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID);

          return secp256k1.privateKeyModInverse(privateKey)
        },

        privateKeyTweakAdd: function (privateKey, tweak) {
          assert$h.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID);
          assert$h.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID);

          assert$h.isBuffer(tweak, messages.TWEAK_TYPE_INVALID);
          assert$h.isBufferLength(tweak, 32, messages.TWEAK_LENGTH_INVALID);

          return secp256k1.privateKeyTweakAdd(privateKey, tweak)
        },

        privateKeyTweakMul: function (privateKey, tweak) {
          assert$h.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID);
          assert$h.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID);

          assert$h.isBuffer(tweak, messages.TWEAK_TYPE_INVALID);
          assert$h.isBufferLength(tweak, 32, messages.TWEAK_LENGTH_INVALID);

          return secp256k1.privateKeyTweakMul(privateKey, tweak)
        },

        publicKeyCreate: function (privateKey, compressed) {
          assert$h.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID);
          assert$h.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID);

          compressed = initCompressedValue(compressed, true);

          return secp256k1.publicKeyCreate(privateKey, compressed)
        },

        publicKeyConvert: function (publicKey, compressed) {
          assert$h.isBuffer(publicKey, messages.EC_PUBLIC_KEY_TYPE_INVALID);
          assert$h.isBufferLength2(publicKey, 33, 65, messages.EC_PUBLIC_KEY_LENGTH_INVALID);

          compressed = initCompressedValue(compressed, true);

          return secp256k1.publicKeyConvert(publicKey, compressed)
        },

        publicKeyVerify: function (publicKey) {
          assert$h.isBuffer(publicKey, messages.EC_PUBLIC_KEY_TYPE_INVALID);
          return secp256k1.publicKeyVerify(publicKey)
        },

        publicKeyTweakAdd: function (publicKey, tweak, compressed) {
          assert$h.isBuffer(publicKey, messages.EC_PUBLIC_KEY_TYPE_INVALID);
          assert$h.isBufferLength2(publicKey, 33, 65, messages.EC_PUBLIC_KEY_LENGTH_INVALID);

          assert$h.isBuffer(tweak, messages.TWEAK_TYPE_INVALID);
          assert$h.isBufferLength(tweak, 32, messages.TWEAK_LENGTH_INVALID);

          compressed = initCompressedValue(compressed, true);

          return secp256k1.publicKeyTweakAdd(publicKey, tweak, compressed)
        },

        publicKeyTweakMul: function (publicKey, tweak, compressed) {
          assert$h.isBuffer(publicKey, messages.EC_PUBLIC_KEY_TYPE_INVALID);
          assert$h.isBufferLength2(publicKey, 33, 65, messages.EC_PUBLIC_KEY_LENGTH_INVALID);

          assert$h.isBuffer(tweak, messages.TWEAK_TYPE_INVALID);
          assert$h.isBufferLength(tweak, 32, messages.TWEAK_LENGTH_INVALID);

          compressed = initCompressedValue(compressed, true);

          return secp256k1.publicKeyTweakMul(publicKey, tweak, compressed)
        },

        publicKeyCombine: function (publicKeys, compressed) {
          assert$h.isArray(publicKeys, messages.EC_PUBLIC_KEYS_TYPE_INVALID);
          assert$h.isLengthGTZero(publicKeys, messages.EC_PUBLIC_KEYS_LENGTH_INVALID);
          for (var i = 0; i < publicKeys.length; ++i) {
            assert$h.isBuffer(publicKeys[i], messages.EC_PUBLIC_KEY_TYPE_INVALID);
            assert$h.isBufferLength2(publicKeys[i], 33, 65, messages.EC_PUBLIC_KEY_LENGTH_INVALID);
          }

          compressed = initCompressedValue(compressed, true);

          return secp256k1.publicKeyCombine(publicKeys, compressed)
        },

        signatureNormalize: function (signature) {
          assert$h.isBuffer(signature, messages.ECDSA_SIGNATURE_TYPE_INVALID);
          assert$h.isBufferLength(signature, 64, messages.ECDSA_SIGNATURE_LENGTH_INVALID);

          return secp256k1.signatureNormalize(signature)
        },

        signatureExport: function (signature) {
          assert$h.isBuffer(signature, messages.ECDSA_SIGNATURE_TYPE_INVALID);
          assert$h.isBufferLength(signature, 64, messages.ECDSA_SIGNATURE_LENGTH_INVALID);

          var sigObj = secp256k1.signatureExport(signature);
          return der.signatureExport(sigObj)
        },

        signatureImport: function (sig) {
          assert$h.isBuffer(sig, messages.ECDSA_SIGNATURE_TYPE_INVALID);
          assert$h.isLengthGTZero(sig, messages.ECDSA_SIGNATURE_LENGTH_INVALID);

          var sigObj = der.signatureImport(sig);
          if (sigObj) return secp256k1.signatureImport(sigObj)

          throw new Error(messages.ECDSA_SIGNATURE_PARSE_DER_FAIL)
        },

        signatureImportLax: function (sig) {
          assert$h.isBuffer(sig, messages.ECDSA_SIGNATURE_TYPE_INVALID);
          assert$h.isLengthGTZero(sig, messages.ECDSA_SIGNATURE_LENGTH_INVALID);

          var sigObj = der.signatureImportLax(sig);
          if (sigObj) return secp256k1.signatureImport(sigObj)

          throw new Error(messages.ECDSA_SIGNATURE_PARSE_DER_FAIL)
        },

        sign: function (message, privateKey, options) {
          assert$h.isBuffer(message, messages.MSG32_TYPE_INVALID);
          assert$h.isBufferLength(message, 32, messages.MSG32_LENGTH_INVALID);

          assert$h.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID);
          assert$h.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID);

          var data = null;
          var noncefn = null;
          if (options !== undefined) {
            assert$h.isObject(options, messages.OPTIONS_TYPE_INVALID);

            if (options.data !== undefined) {
              assert$h.isBuffer(options.data, messages.OPTIONS_DATA_TYPE_INVALID);
              assert$h.isBufferLength(options.data, 32, messages.OPTIONS_DATA_LENGTH_INVALID);
              data = options.data;
            }

            if (options.noncefn !== undefined) {
              assert$h.isFunction(options.noncefn, messages.OPTIONS_NONCEFN_TYPE_INVALID);
              noncefn = options.noncefn;
            }
          }

          return secp256k1.sign(message, privateKey, noncefn, data)
        },

        verify: function (message, signature, publicKey) {
          assert$h.isBuffer(message, messages.MSG32_TYPE_INVALID);
          assert$h.isBufferLength(message, 32, messages.MSG32_LENGTH_INVALID);

          assert$h.isBuffer(signature, messages.ECDSA_SIGNATURE_TYPE_INVALID);
          assert$h.isBufferLength(signature, 64, messages.ECDSA_SIGNATURE_LENGTH_INVALID);

          assert$h.isBuffer(publicKey, messages.EC_PUBLIC_KEY_TYPE_INVALID);
          assert$h.isBufferLength2(publicKey, 33, 65, messages.EC_PUBLIC_KEY_LENGTH_INVALID);

          return secp256k1.verify(message, signature, publicKey)
        },

        recover: function (message, signature, recovery, compressed) {
          assert$h.isBuffer(message, messages.MSG32_TYPE_INVALID);
          assert$h.isBufferLength(message, 32, messages.MSG32_LENGTH_INVALID);

          assert$h.isBuffer(signature, messages.ECDSA_SIGNATURE_TYPE_INVALID);
          assert$h.isBufferLength(signature, 64, messages.ECDSA_SIGNATURE_LENGTH_INVALID);

          assert$h.isNumber(recovery, messages.RECOVERY_ID_TYPE_INVALID);
          assert$h.isNumberInInterval(recovery, -1, 4, messages.RECOVERY_ID_VALUE_INVALID);

          compressed = initCompressedValue(compressed, true);

          return secp256k1.recover(message, signature, recovery, compressed)
        },

        ecdh: function (publicKey, privateKey) {
          assert$h.isBuffer(publicKey, messages.EC_PUBLIC_KEY_TYPE_INVALID);
          assert$h.isBufferLength2(publicKey, 33, 65, messages.EC_PUBLIC_KEY_LENGTH_INVALID);

          assert$h.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID);
          assert$h.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID);

          return secp256k1.ecdh(publicKey, privateKey)
        },

        ecdhUnsafe: function (publicKey, privateKey, compressed) {
          assert$h.isBuffer(publicKey, messages.EC_PUBLIC_KEY_TYPE_INVALID);
          assert$h.isBufferLength2(publicKey, 33, 65, messages.EC_PUBLIC_KEY_LENGTH_INVALID);

          assert$h.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID);
          assert$h.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID);

          compressed = initCompressedValue(compressed, true);

          return secp256k1.ecdhUnsafe(publicKey, privateKey, compressed)
        }
      }
    };

    var elliptic$2 = {};

    var bn = {exports: {}};

    bn.exports;

    (function (module) {
    	(function (module, exports) {

    	  // Utils
    	  function assert (val, msg) {
    	    if (!val) throw new Error(msg || 'Assertion failed');
    	  }

    	  // Could use `inherits` module, but don't want to move from single file
    	  // architecture yet.
    	  function inherits (ctor, superCtor) {
    	    ctor.super_ = superCtor;
    	    var TempCtor = function () {};
    	    TempCtor.prototype = superCtor.prototype;
    	    ctor.prototype = new TempCtor();
    	    ctor.prototype.constructor = ctor;
    	  }

    	  // BN

    	  function BN (number, base, endian) {
    	    if (BN.isBN(number)) {
    	      return number;
    	    }

    	    this.negative = 0;
    	    this.words = null;
    	    this.length = 0;

    	    // Reduction context
    	    this.red = null;

    	    if (number !== null) {
    	      if (base === 'le' || base === 'be') {
    	        endian = base;
    	        base = 10;
    	      }

    	      this._init(number || 0, base || 10, endian || 'be');
    	    }
    	  }
    	  if (typeof module === 'object') {
    	    module.exports = BN;
    	  } else {
    	    exports.BN = BN;
    	  }

    	  BN.BN = BN;
    	  BN.wordSize = 26;

    	  var Buffer;
    	  try {
    	    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
    	      Buffer = window.Buffer;
    	    } else {
    	      Buffer = require$$0$3.Buffer;
    	    }
    	  } catch (e) {
    	  }

    	  BN.isBN = function isBN (num) {
    	    if (num instanceof BN) {
    	      return true;
    	    }

    	    return num !== null && typeof num === 'object' &&
    	      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    	  };

    	  BN.max = function max (left, right) {
    	    if (left.cmp(right) > 0) return left;
    	    return right;
    	  };

    	  BN.min = function min (left, right) {
    	    if (left.cmp(right) < 0) return left;
    	    return right;
    	  };

    	  BN.prototype._init = function init (number, base, endian) {
    	    if (typeof number === 'number') {
    	      return this._initNumber(number, base, endian);
    	    }

    	    if (typeof number === 'object') {
    	      return this._initArray(number, base, endian);
    	    }

    	    if (base === 'hex') {
    	      base = 16;
    	    }
    	    assert(base === (base | 0) && base >= 2 && base <= 36);

    	    number = number.toString().replace(/\s+/g, '');
    	    var start = 0;
    	    if (number[0] === '-') {
    	      start++;
    	      this.negative = 1;
    	    }

    	    if (start < number.length) {
    	      if (base === 16) {
    	        this._parseHex(number, start, endian);
    	      } else {
    	        this._parseBase(number, base, start);
    	        if (endian === 'le') {
    	          this._initArray(this.toArray(), base, endian);
    	        }
    	      }
    	    }
    	  };

    	  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    	    if (number < 0) {
    	      this.negative = 1;
    	      number = -number;
    	    }
    	    if (number < 0x4000000) {
    	      this.words = [ number & 0x3ffffff ];
    	      this.length = 1;
    	    } else if (number < 0x10000000000000) {
    	      this.words = [
    	        number & 0x3ffffff,
    	        (number / 0x4000000) & 0x3ffffff
    	      ];
    	      this.length = 2;
    	    } else {
    	      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
    	      this.words = [
    	        number & 0x3ffffff,
    	        (number / 0x4000000) & 0x3ffffff,
    	        1
    	      ];
    	      this.length = 3;
    	    }

    	    if (endian !== 'le') return;

    	    // Reverse the bytes
    	    this._initArray(this.toArray(), base, endian);
    	  };

    	  BN.prototype._initArray = function _initArray (number, base, endian) {
    	    // Perhaps a Uint8Array
    	    assert(typeof number.length === 'number');
    	    if (number.length <= 0) {
    	      this.words = [ 0 ];
    	      this.length = 1;
    	      return this;
    	    }

    	    this.length = Math.ceil(number.length / 3);
    	    this.words = new Array(this.length);
    	    for (var i = 0; i < this.length; i++) {
    	      this.words[i] = 0;
    	    }

    	    var j, w;
    	    var off = 0;
    	    if (endian === 'be') {
    	      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
    	        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
    	        this.words[j] |= (w << off) & 0x3ffffff;
    	        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
    	        off += 24;
    	        if (off >= 26) {
    	          off -= 26;
    	          j++;
    	        }
    	      }
    	    } else if (endian === 'le') {
    	      for (i = 0, j = 0; i < number.length; i += 3) {
    	        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
    	        this.words[j] |= (w << off) & 0x3ffffff;
    	        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
    	        off += 24;
    	        if (off >= 26) {
    	          off -= 26;
    	          j++;
    	        }
    	      }
    	    }
    	    return this.strip();
    	  };

    	  function parseHex4Bits (string, index) {
    	    var c = string.charCodeAt(index);
    	    // 'A' - 'F'
    	    if (c >= 65 && c <= 70) {
    	      return c - 55;
    	    // 'a' - 'f'
    	    } else if (c >= 97 && c <= 102) {
    	      return c - 87;
    	    // '0' - '9'
    	    } else {
    	      return (c - 48) & 0xf;
    	    }
    	  }

    	  function parseHexByte (string, lowerBound, index) {
    	    var r = parseHex4Bits(string, index);
    	    if (index - 1 >= lowerBound) {
    	      r |= parseHex4Bits(string, index - 1) << 4;
    	    }
    	    return r;
    	  }

    	  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    	    // Create possibly bigger array to ensure that it fits the number
    	    this.length = Math.ceil((number.length - start) / 6);
    	    this.words = new Array(this.length);
    	    for (var i = 0; i < this.length; i++) {
    	      this.words[i] = 0;
    	    }

    	    // 24-bits chunks
    	    var off = 0;
    	    var j = 0;

    	    var w;
    	    if (endian === 'be') {
    	      for (i = number.length - 1; i >= start; i -= 2) {
    	        w = parseHexByte(number, start, i) << off;
    	        this.words[j] |= w & 0x3ffffff;
    	        if (off >= 18) {
    	          off -= 18;
    	          j += 1;
    	          this.words[j] |= w >>> 26;
    	        } else {
    	          off += 8;
    	        }
    	      }
    	    } else {
    	      var parseLength = number.length - start;
    	      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
    	        w = parseHexByte(number, start, i) << off;
    	        this.words[j] |= w & 0x3ffffff;
    	        if (off >= 18) {
    	          off -= 18;
    	          j += 1;
    	          this.words[j] |= w >>> 26;
    	        } else {
    	          off += 8;
    	        }
    	      }
    	    }

    	    this.strip();
    	  };

    	  function parseBase (str, start, end, mul) {
    	    var r = 0;
    	    var len = Math.min(str.length, end);
    	    for (var i = start; i < len; i++) {
    	      var c = str.charCodeAt(i) - 48;

    	      r *= mul;

    	      // 'a'
    	      if (c >= 49) {
    	        r += c - 49 + 0xa;

    	      // 'A'
    	      } else if (c >= 17) {
    	        r += c - 17 + 0xa;

    	      // '0' - '9'
    	      } else {
    	        r += c;
    	      }
    	    }
    	    return r;
    	  }

    	  BN.prototype._parseBase = function _parseBase (number, base, start) {
    	    // Initialize as zero
    	    this.words = [ 0 ];
    	    this.length = 1;

    	    // Find length of limb in base
    	    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
    	      limbLen++;
    	    }
    	    limbLen--;
    	    limbPow = (limbPow / base) | 0;

    	    var total = number.length - start;
    	    var mod = total % limbLen;
    	    var end = Math.min(total, total - mod) + start;

    	    var word = 0;
    	    for (var i = start; i < end; i += limbLen) {
    	      word = parseBase(number, i, i + limbLen, base);

    	      this.imuln(limbPow);
    	      if (this.words[0] + word < 0x4000000) {
    	        this.words[0] += word;
    	      } else {
    	        this._iaddn(word);
    	      }
    	    }

    	    if (mod !== 0) {
    	      var pow = 1;
    	      word = parseBase(number, i, number.length, base);

    	      for (i = 0; i < mod; i++) {
    	        pow *= base;
    	      }

    	      this.imuln(pow);
    	      if (this.words[0] + word < 0x4000000) {
    	        this.words[0] += word;
    	      } else {
    	        this._iaddn(word);
    	      }
    	    }

    	    this.strip();
    	  };

    	  BN.prototype.copy = function copy (dest) {
    	    dest.words = new Array(this.length);
    	    for (var i = 0; i < this.length; i++) {
    	      dest.words[i] = this.words[i];
    	    }
    	    dest.length = this.length;
    	    dest.negative = this.negative;
    	    dest.red = this.red;
    	  };

    	  BN.prototype.clone = function clone () {
    	    var r = new BN(null);
    	    this.copy(r);
    	    return r;
    	  };

    	  BN.prototype._expand = function _expand (size) {
    	    while (this.length < size) {
    	      this.words[this.length++] = 0;
    	    }
    	    return this;
    	  };

    	  // Remove leading `0` from `this`
    	  BN.prototype.strip = function strip () {
    	    while (this.length > 1 && this.words[this.length - 1] === 0) {
    	      this.length--;
    	    }
    	    return this._normSign();
    	  };

    	  BN.prototype._normSign = function _normSign () {
    	    // -0 = 0
    	    if (this.length === 1 && this.words[0] === 0) {
    	      this.negative = 0;
    	    }
    	    return this;
    	  };

    	  BN.prototype.inspect = function inspect () {
    	    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    	  };

    	  /*

    	  var zeros = [];
    	  var groupSizes = [];
    	  var groupBases = [];

    	  var s = '';
    	  var i = -1;
    	  while (++i < BN.wordSize) {
    	    zeros[i] = s;
    	    s += '0';
    	  }
    	  groupSizes[0] = 0;
    	  groupSizes[1] = 0;
    	  groupBases[0] = 0;
    	  groupBases[1] = 0;
    	  var base = 2 - 1;
    	  while (++base < 36 + 1) {
    	    var groupSize = 0;
    	    var groupBase = 1;
    	    while (groupBase < (1 << BN.wordSize) / base) {
    	      groupBase *= base;
    	      groupSize += 1;
    	    }
    	    groupSizes[base] = groupSize;
    	    groupBases[base] = groupBase;
    	  }

    	  */

    	  var zeros = [
    	    '',
    	    '0',
    	    '00',
    	    '000',
    	    '0000',
    	    '00000',
    	    '000000',
    	    '0000000',
    	    '00000000',
    	    '000000000',
    	    '0000000000',
    	    '00000000000',
    	    '000000000000',
    	    '0000000000000',
    	    '00000000000000',
    	    '000000000000000',
    	    '0000000000000000',
    	    '00000000000000000',
    	    '000000000000000000',
    	    '0000000000000000000',
    	    '00000000000000000000',
    	    '000000000000000000000',
    	    '0000000000000000000000',
    	    '00000000000000000000000',
    	    '000000000000000000000000',
    	    '0000000000000000000000000'
    	  ];

    	  var groupSizes = [
    	    0, 0,
    	    25, 16, 12, 11, 10, 9, 8,
    	    8, 7, 7, 7, 7, 6, 6,
    	    6, 6, 6, 6, 6, 5, 5,
    	    5, 5, 5, 5, 5, 5, 5,
    	    5, 5, 5, 5, 5, 5, 5
    	  ];

    	  var groupBases = [
    	    0, 0,
    	    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    	    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    	    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    	    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    	    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
    	  ];

    	  BN.prototype.toString = function toString (base, padding) {
    	    base = base || 10;
    	    padding = padding | 0 || 1;

    	    var out;
    	    if (base === 16 || base === 'hex') {
    	      out = '';
    	      var off = 0;
    	      var carry = 0;
    	      for (var i = 0; i < this.length; i++) {
    	        var w = this.words[i];
    	        var word = (((w << off) | carry) & 0xffffff).toString(16);
    	        carry = (w >>> (24 - off)) & 0xffffff;
    	        if (carry !== 0 || i !== this.length - 1) {
    	          out = zeros[6 - word.length] + word + out;
    	        } else {
    	          out = word + out;
    	        }
    	        off += 2;
    	        if (off >= 26) {
    	          off -= 26;
    	          i--;
    	        }
    	      }
    	      if (carry !== 0) {
    	        out = carry.toString(16) + out;
    	      }
    	      while (out.length % padding !== 0) {
    	        out = '0' + out;
    	      }
    	      if (this.negative !== 0) {
    	        out = '-' + out;
    	      }
    	      return out;
    	    }

    	    if (base === (base | 0) && base >= 2 && base <= 36) {
    	      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
    	      var groupSize = groupSizes[base];
    	      // var groupBase = Math.pow(base, groupSize);
    	      var groupBase = groupBases[base];
    	      out = '';
    	      var c = this.clone();
    	      c.negative = 0;
    	      while (!c.isZero()) {
    	        var r = c.modn(groupBase).toString(base);
    	        c = c.idivn(groupBase);

    	        if (!c.isZero()) {
    	          out = zeros[groupSize - r.length] + r + out;
    	        } else {
    	          out = r + out;
    	        }
    	      }
    	      if (this.isZero()) {
    	        out = '0' + out;
    	      }
    	      while (out.length % padding !== 0) {
    	        out = '0' + out;
    	      }
    	      if (this.negative !== 0) {
    	        out = '-' + out;
    	      }
    	      return out;
    	    }

    	    assert(false, 'Base should be between 2 and 36');
    	  };

    	  BN.prototype.toNumber = function toNumber () {
    	    var ret = this.words[0];
    	    if (this.length === 2) {
    	      ret += this.words[1] * 0x4000000;
    	    } else if (this.length === 3 && this.words[2] === 0x01) {
    	      // NOTE: at this stage it is known that the top bit is set
    	      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    	    } else if (this.length > 2) {
    	      assert(false, 'Number can only safely store up to 53 bits');
    	    }
    	    return (this.negative !== 0) ? -ret : ret;
    	  };

    	  BN.prototype.toJSON = function toJSON () {
    	    return this.toString(16);
    	  };

    	  BN.prototype.toBuffer = function toBuffer (endian, length) {
    	    assert(typeof Buffer !== 'undefined');
    	    return this.toArrayLike(Buffer, endian, length);
    	  };

    	  BN.prototype.toArray = function toArray (endian, length) {
    	    return this.toArrayLike(Array, endian, length);
    	  };

    	  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    	    var byteLength = this.byteLength();
    	    var reqLength = length || Math.max(1, byteLength);
    	    assert(byteLength <= reqLength, 'byte array longer than desired length');
    	    assert(reqLength > 0, 'Requested array length <= 0');

    	    this.strip();
    	    var littleEndian = endian === 'le';
    	    var res = new ArrayType(reqLength);

    	    var b, i;
    	    var q = this.clone();
    	    if (!littleEndian) {
    	      // Assume big-endian
    	      for (i = 0; i < reqLength - byteLength; i++) {
    	        res[i] = 0;
    	      }

    	      for (i = 0; !q.isZero(); i++) {
    	        b = q.andln(0xff);
    	        q.iushrn(8);

    	        res[reqLength - i - 1] = b;
    	      }
    	    } else {
    	      for (i = 0; !q.isZero(); i++) {
    	        b = q.andln(0xff);
    	        q.iushrn(8);

    	        res[i] = b;
    	      }

    	      for (; i < reqLength; i++) {
    	        res[i] = 0;
    	      }
    	    }

    	    return res;
    	  };

    	  if (Math.clz32) {
    	    BN.prototype._countBits = function _countBits (w) {
    	      return 32 - Math.clz32(w);
    	    };
    	  } else {
    	    BN.prototype._countBits = function _countBits (w) {
    	      var t = w;
    	      var r = 0;
    	      if (t >= 0x1000) {
    	        r += 13;
    	        t >>>= 13;
    	      }
    	      if (t >= 0x40) {
    	        r += 7;
    	        t >>>= 7;
    	      }
    	      if (t >= 0x8) {
    	        r += 4;
    	        t >>>= 4;
    	      }
    	      if (t >= 0x02) {
    	        r += 2;
    	        t >>>= 2;
    	      }
    	      return r + t;
    	    };
    	  }

    	  BN.prototype._zeroBits = function _zeroBits (w) {
    	    // Short-cut
    	    if (w === 0) return 26;

    	    var t = w;
    	    var r = 0;
    	    if ((t & 0x1fff) === 0) {
    	      r += 13;
    	      t >>>= 13;
    	    }
    	    if ((t & 0x7f) === 0) {
    	      r += 7;
    	      t >>>= 7;
    	    }
    	    if ((t & 0xf) === 0) {
    	      r += 4;
    	      t >>>= 4;
    	    }
    	    if ((t & 0x3) === 0) {
    	      r += 2;
    	      t >>>= 2;
    	    }
    	    if ((t & 0x1) === 0) {
    	      r++;
    	    }
    	    return r;
    	  };

    	  // Return number of used bits in a BN
    	  BN.prototype.bitLength = function bitLength () {
    	    var w = this.words[this.length - 1];
    	    var hi = this._countBits(w);
    	    return (this.length - 1) * 26 + hi;
    	  };

    	  function toBitArray (num) {
    	    var w = new Array(num.bitLength());

    	    for (var bit = 0; bit < w.length; bit++) {
    	      var off = (bit / 26) | 0;
    	      var wbit = bit % 26;

    	      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    	    }

    	    return w;
    	  }

    	  // Number of trailing zero bits
    	  BN.prototype.zeroBits = function zeroBits () {
    	    if (this.isZero()) return 0;

    	    var r = 0;
    	    for (var i = 0; i < this.length; i++) {
    	      var b = this._zeroBits(this.words[i]);
    	      r += b;
    	      if (b !== 26) break;
    	    }
    	    return r;
    	  };

    	  BN.prototype.byteLength = function byteLength () {
    	    return Math.ceil(this.bitLength() / 8);
    	  };

    	  BN.prototype.toTwos = function toTwos (width) {
    	    if (this.negative !== 0) {
    	      return this.abs().inotn(width).iaddn(1);
    	    }
    	    return this.clone();
    	  };

    	  BN.prototype.fromTwos = function fromTwos (width) {
    	    if (this.testn(width - 1)) {
    	      return this.notn(width).iaddn(1).ineg();
    	    }
    	    return this.clone();
    	  };

    	  BN.prototype.isNeg = function isNeg () {
    	    return this.negative !== 0;
    	  };

    	  // Return negative clone of `this`
    	  BN.prototype.neg = function neg () {
    	    return this.clone().ineg();
    	  };

    	  BN.prototype.ineg = function ineg () {
    	    if (!this.isZero()) {
    	      this.negative ^= 1;
    	    }

    	    return this;
    	  };

    	  // Or `num` with `this` in-place
    	  BN.prototype.iuor = function iuor (num) {
    	    while (this.length < num.length) {
    	      this.words[this.length++] = 0;
    	    }

    	    for (var i = 0; i < num.length; i++) {
    	      this.words[i] = this.words[i] | num.words[i];
    	    }

    	    return this.strip();
    	  };

    	  BN.prototype.ior = function ior (num) {
    	    assert((this.negative | num.negative) === 0);
    	    return this.iuor(num);
    	  };

    	  // Or `num` with `this`
    	  BN.prototype.or = function or (num) {
    	    if (this.length > num.length) return this.clone().ior(num);
    	    return num.clone().ior(this);
    	  };

    	  BN.prototype.uor = function uor (num) {
    	    if (this.length > num.length) return this.clone().iuor(num);
    	    return num.clone().iuor(this);
    	  };

    	  // And `num` with `this` in-place
    	  BN.prototype.iuand = function iuand (num) {
    	    // b = min-length(num, this)
    	    var b;
    	    if (this.length > num.length) {
    	      b = num;
    	    } else {
    	      b = this;
    	    }

    	    for (var i = 0; i < b.length; i++) {
    	      this.words[i] = this.words[i] & num.words[i];
    	    }

    	    this.length = b.length;

    	    return this.strip();
    	  };

    	  BN.prototype.iand = function iand (num) {
    	    assert((this.negative | num.negative) === 0);
    	    return this.iuand(num);
    	  };

    	  // And `num` with `this`
    	  BN.prototype.and = function and (num) {
    	    if (this.length > num.length) return this.clone().iand(num);
    	    return num.clone().iand(this);
    	  };

    	  BN.prototype.uand = function uand (num) {
    	    if (this.length > num.length) return this.clone().iuand(num);
    	    return num.clone().iuand(this);
    	  };

    	  // Xor `num` with `this` in-place
    	  BN.prototype.iuxor = function iuxor (num) {
    	    // a.length > b.length
    	    var a;
    	    var b;
    	    if (this.length > num.length) {
    	      a = this;
    	      b = num;
    	    } else {
    	      a = num;
    	      b = this;
    	    }

    	    for (var i = 0; i < b.length; i++) {
    	      this.words[i] = a.words[i] ^ b.words[i];
    	    }

    	    if (this !== a) {
    	      for (; i < a.length; i++) {
    	        this.words[i] = a.words[i];
    	      }
    	    }

    	    this.length = a.length;

    	    return this.strip();
    	  };

    	  BN.prototype.ixor = function ixor (num) {
    	    assert((this.negative | num.negative) === 0);
    	    return this.iuxor(num);
    	  };

    	  // Xor `num` with `this`
    	  BN.prototype.xor = function xor (num) {
    	    if (this.length > num.length) return this.clone().ixor(num);
    	    return num.clone().ixor(this);
    	  };

    	  BN.prototype.uxor = function uxor (num) {
    	    if (this.length > num.length) return this.clone().iuxor(num);
    	    return num.clone().iuxor(this);
    	  };

    	  // Not ``this`` with ``width`` bitwidth
    	  BN.prototype.inotn = function inotn (width) {
    	    assert(typeof width === 'number' && width >= 0);

    	    var bytesNeeded = Math.ceil(width / 26) | 0;
    	    var bitsLeft = width % 26;

    	    // Extend the buffer with leading zeroes
    	    this._expand(bytesNeeded);

    	    if (bitsLeft > 0) {
    	      bytesNeeded--;
    	    }

    	    // Handle complete words
    	    for (var i = 0; i < bytesNeeded; i++) {
    	      this.words[i] = ~this.words[i] & 0x3ffffff;
    	    }

    	    // Handle the residue
    	    if (bitsLeft > 0) {
    	      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    	    }

    	    // And remove leading zeroes
    	    return this.strip();
    	  };

    	  BN.prototype.notn = function notn (width) {
    	    return this.clone().inotn(width);
    	  };

    	  // Set `bit` of `this`
    	  BN.prototype.setn = function setn (bit, val) {
    	    assert(typeof bit === 'number' && bit >= 0);

    	    var off = (bit / 26) | 0;
    	    var wbit = bit % 26;

    	    this._expand(off + 1);

    	    if (val) {
    	      this.words[off] = this.words[off] | (1 << wbit);
    	    } else {
    	      this.words[off] = this.words[off] & ~(1 << wbit);
    	    }

    	    return this.strip();
    	  };

    	  // Add `num` to `this` in-place
    	  BN.prototype.iadd = function iadd (num) {
    	    var r;

    	    // negative + positive
    	    if (this.negative !== 0 && num.negative === 0) {
    	      this.negative = 0;
    	      r = this.isub(num);
    	      this.negative ^= 1;
    	      return this._normSign();

    	    // positive + negative
    	    } else if (this.negative === 0 && num.negative !== 0) {
    	      num.negative = 0;
    	      r = this.isub(num);
    	      num.negative = 1;
    	      return r._normSign();
    	    }

    	    // a.length > b.length
    	    var a, b;
    	    if (this.length > num.length) {
    	      a = this;
    	      b = num;
    	    } else {
    	      a = num;
    	      b = this;
    	    }

    	    var carry = 0;
    	    for (var i = 0; i < b.length; i++) {
    	      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
    	      this.words[i] = r & 0x3ffffff;
    	      carry = r >>> 26;
    	    }
    	    for (; carry !== 0 && i < a.length; i++) {
    	      r = (a.words[i] | 0) + carry;
    	      this.words[i] = r & 0x3ffffff;
    	      carry = r >>> 26;
    	    }

    	    this.length = a.length;
    	    if (carry !== 0) {
    	      this.words[this.length] = carry;
    	      this.length++;
    	    // Copy the rest of the words
    	    } else if (a !== this) {
    	      for (; i < a.length; i++) {
    	        this.words[i] = a.words[i];
    	      }
    	    }

    	    return this;
    	  };

    	  // Add `num` to `this`
    	  BN.prototype.add = function add (num) {
    	    var res;
    	    if (num.negative !== 0 && this.negative === 0) {
    	      num.negative = 0;
    	      res = this.sub(num);
    	      num.negative ^= 1;
    	      return res;
    	    } else if (num.negative === 0 && this.negative !== 0) {
    	      this.negative = 0;
    	      res = num.sub(this);
    	      this.negative = 1;
    	      return res;
    	    }

    	    if (this.length > num.length) return this.clone().iadd(num);

    	    return num.clone().iadd(this);
    	  };

    	  // Subtract `num` from `this` in-place
    	  BN.prototype.isub = function isub (num) {
    	    // this - (-num) = this + num
    	    if (num.negative !== 0) {
    	      num.negative = 0;
    	      var r = this.iadd(num);
    	      num.negative = 1;
    	      return r._normSign();

    	    // -this - num = -(this + num)
    	    } else if (this.negative !== 0) {
    	      this.negative = 0;
    	      this.iadd(num);
    	      this.negative = 1;
    	      return this._normSign();
    	    }

    	    // At this point both numbers are positive
    	    var cmp = this.cmp(num);

    	    // Optimization - zeroify
    	    if (cmp === 0) {
    	      this.negative = 0;
    	      this.length = 1;
    	      this.words[0] = 0;
    	      return this;
    	    }

    	    // a > b
    	    var a, b;
    	    if (cmp > 0) {
    	      a = this;
    	      b = num;
    	    } else {
    	      a = num;
    	      b = this;
    	    }

    	    var carry = 0;
    	    for (var i = 0; i < b.length; i++) {
    	      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
    	      carry = r >> 26;
    	      this.words[i] = r & 0x3ffffff;
    	    }
    	    for (; carry !== 0 && i < a.length; i++) {
    	      r = (a.words[i] | 0) + carry;
    	      carry = r >> 26;
    	      this.words[i] = r & 0x3ffffff;
    	    }

    	    // Copy rest of the words
    	    if (carry === 0 && i < a.length && a !== this) {
    	      for (; i < a.length; i++) {
    	        this.words[i] = a.words[i];
    	      }
    	    }

    	    this.length = Math.max(this.length, i);

    	    if (a !== this) {
    	      this.negative = 1;
    	    }

    	    return this.strip();
    	  };

    	  // Subtract `num` from `this`
    	  BN.prototype.sub = function sub (num) {
    	    return this.clone().isub(num);
    	  };

    	  function smallMulTo (self, num, out) {
    	    out.negative = num.negative ^ self.negative;
    	    var len = (self.length + num.length) | 0;
    	    out.length = len;
    	    len = (len - 1) | 0;

    	    // Peel one iteration (compiler can't do it, because of code complexity)
    	    var a = self.words[0] | 0;
    	    var b = num.words[0] | 0;
    	    var r = a * b;

    	    var lo = r & 0x3ffffff;
    	    var carry = (r / 0x4000000) | 0;
    	    out.words[0] = lo;

    	    for (var k = 1; k < len; k++) {
    	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
    	      // note that ncarry could be >= 0x3ffffff
    	      var ncarry = carry >>> 26;
    	      var rword = carry & 0x3ffffff;
    	      var maxJ = Math.min(k, num.length - 1);
    	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
    	        var i = (k - j) | 0;
    	        a = self.words[i] | 0;
    	        b = num.words[j] | 0;
    	        r = a * b + rword;
    	        ncarry += (r / 0x4000000) | 0;
    	        rword = r & 0x3ffffff;
    	      }
    	      out.words[k] = rword | 0;
    	      carry = ncarry | 0;
    	    }
    	    if (carry !== 0) {
    	      out.words[k] = carry | 0;
    	    } else {
    	      out.length--;
    	    }

    	    return out.strip();
    	  }

    	  // TODO(indutny): it may be reasonable to omit it for users who don't need
    	  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    	  // multiplication (like elliptic secp256k1).
    	  var comb10MulTo = function comb10MulTo (self, num, out) {
    	    var a = self.words;
    	    var b = num.words;
    	    var o = out.words;
    	    var c = 0;
    	    var lo;
    	    var mid;
    	    var hi;
    	    var a0 = a[0] | 0;
    	    var al0 = a0 & 0x1fff;
    	    var ah0 = a0 >>> 13;
    	    var a1 = a[1] | 0;
    	    var al1 = a1 & 0x1fff;
    	    var ah1 = a1 >>> 13;
    	    var a2 = a[2] | 0;
    	    var al2 = a2 & 0x1fff;
    	    var ah2 = a2 >>> 13;
    	    var a3 = a[3] | 0;
    	    var al3 = a3 & 0x1fff;
    	    var ah3 = a3 >>> 13;
    	    var a4 = a[4] | 0;
    	    var al4 = a4 & 0x1fff;
    	    var ah4 = a4 >>> 13;
    	    var a5 = a[5] | 0;
    	    var al5 = a5 & 0x1fff;
    	    var ah5 = a5 >>> 13;
    	    var a6 = a[6] | 0;
    	    var al6 = a6 & 0x1fff;
    	    var ah6 = a6 >>> 13;
    	    var a7 = a[7] | 0;
    	    var al7 = a7 & 0x1fff;
    	    var ah7 = a7 >>> 13;
    	    var a8 = a[8] | 0;
    	    var al8 = a8 & 0x1fff;
    	    var ah8 = a8 >>> 13;
    	    var a9 = a[9] | 0;
    	    var al9 = a9 & 0x1fff;
    	    var ah9 = a9 >>> 13;
    	    var b0 = b[0] | 0;
    	    var bl0 = b0 & 0x1fff;
    	    var bh0 = b0 >>> 13;
    	    var b1 = b[1] | 0;
    	    var bl1 = b1 & 0x1fff;
    	    var bh1 = b1 >>> 13;
    	    var b2 = b[2] | 0;
    	    var bl2 = b2 & 0x1fff;
    	    var bh2 = b2 >>> 13;
    	    var b3 = b[3] | 0;
    	    var bl3 = b3 & 0x1fff;
    	    var bh3 = b3 >>> 13;
    	    var b4 = b[4] | 0;
    	    var bl4 = b4 & 0x1fff;
    	    var bh4 = b4 >>> 13;
    	    var b5 = b[5] | 0;
    	    var bl5 = b5 & 0x1fff;
    	    var bh5 = b5 >>> 13;
    	    var b6 = b[6] | 0;
    	    var bl6 = b6 & 0x1fff;
    	    var bh6 = b6 >>> 13;
    	    var b7 = b[7] | 0;
    	    var bl7 = b7 & 0x1fff;
    	    var bh7 = b7 >>> 13;
    	    var b8 = b[8] | 0;
    	    var bl8 = b8 & 0x1fff;
    	    var bh8 = b8 >>> 13;
    	    var b9 = b[9] | 0;
    	    var bl9 = b9 & 0x1fff;
    	    var bh9 = b9 >>> 13;

    	    out.negative = self.negative ^ num.negative;
    	    out.length = 19;
    	    /* k = 0 */
    	    lo = Math.imul(al0, bl0);
    	    mid = Math.imul(al0, bh0);
    	    mid = (mid + Math.imul(ah0, bl0)) | 0;
    	    hi = Math.imul(ah0, bh0);
    	    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    	    w0 &= 0x3ffffff;
    	    /* k = 1 */
    	    lo = Math.imul(al1, bl0);
    	    mid = Math.imul(al1, bh0);
    	    mid = (mid + Math.imul(ah1, bl0)) | 0;
    	    hi = Math.imul(ah1, bh0);
    	    lo = (lo + Math.imul(al0, bl1)) | 0;
    	    mid = (mid + Math.imul(al0, bh1)) | 0;
    	    mid = (mid + Math.imul(ah0, bl1)) | 0;
    	    hi = (hi + Math.imul(ah0, bh1)) | 0;
    	    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    	    w1 &= 0x3ffffff;
    	    /* k = 2 */
    	    lo = Math.imul(al2, bl0);
    	    mid = Math.imul(al2, bh0);
    	    mid = (mid + Math.imul(ah2, bl0)) | 0;
    	    hi = Math.imul(ah2, bh0);
    	    lo = (lo + Math.imul(al1, bl1)) | 0;
    	    mid = (mid + Math.imul(al1, bh1)) | 0;
    	    mid = (mid + Math.imul(ah1, bl1)) | 0;
    	    hi = (hi + Math.imul(ah1, bh1)) | 0;
    	    lo = (lo + Math.imul(al0, bl2)) | 0;
    	    mid = (mid + Math.imul(al0, bh2)) | 0;
    	    mid = (mid + Math.imul(ah0, bl2)) | 0;
    	    hi = (hi + Math.imul(ah0, bh2)) | 0;
    	    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    	    w2 &= 0x3ffffff;
    	    /* k = 3 */
    	    lo = Math.imul(al3, bl0);
    	    mid = Math.imul(al3, bh0);
    	    mid = (mid + Math.imul(ah3, bl0)) | 0;
    	    hi = Math.imul(ah3, bh0);
    	    lo = (lo + Math.imul(al2, bl1)) | 0;
    	    mid = (mid + Math.imul(al2, bh1)) | 0;
    	    mid = (mid + Math.imul(ah2, bl1)) | 0;
    	    hi = (hi + Math.imul(ah2, bh1)) | 0;
    	    lo = (lo + Math.imul(al1, bl2)) | 0;
    	    mid = (mid + Math.imul(al1, bh2)) | 0;
    	    mid = (mid + Math.imul(ah1, bl2)) | 0;
    	    hi = (hi + Math.imul(ah1, bh2)) | 0;
    	    lo = (lo + Math.imul(al0, bl3)) | 0;
    	    mid = (mid + Math.imul(al0, bh3)) | 0;
    	    mid = (mid + Math.imul(ah0, bl3)) | 0;
    	    hi = (hi + Math.imul(ah0, bh3)) | 0;
    	    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    	    w3 &= 0x3ffffff;
    	    /* k = 4 */
    	    lo = Math.imul(al4, bl0);
    	    mid = Math.imul(al4, bh0);
    	    mid = (mid + Math.imul(ah4, bl0)) | 0;
    	    hi = Math.imul(ah4, bh0);
    	    lo = (lo + Math.imul(al3, bl1)) | 0;
    	    mid = (mid + Math.imul(al3, bh1)) | 0;
    	    mid = (mid + Math.imul(ah3, bl1)) | 0;
    	    hi = (hi + Math.imul(ah3, bh1)) | 0;
    	    lo = (lo + Math.imul(al2, bl2)) | 0;
    	    mid = (mid + Math.imul(al2, bh2)) | 0;
    	    mid = (mid + Math.imul(ah2, bl2)) | 0;
    	    hi = (hi + Math.imul(ah2, bh2)) | 0;
    	    lo = (lo + Math.imul(al1, bl3)) | 0;
    	    mid = (mid + Math.imul(al1, bh3)) | 0;
    	    mid = (mid + Math.imul(ah1, bl3)) | 0;
    	    hi = (hi + Math.imul(ah1, bh3)) | 0;
    	    lo = (lo + Math.imul(al0, bl4)) | 0;
    	    mid = (mid + Math.imul(al0, bh4)) | 0;
    	    mid = (mid + Math.imul(ah0, bl4)) | 0;
    	    hi = (hi + Math.imul(ah0, bh4)) | 0;
    	    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    	    w4 &= 0x3ffffff;
    	    /* k = 5 */
    	    lo = Math.imul(al5, bl0);
    	    mid = Math.imul(al5, bh0);
    	    mid = (mid + Math.imul(ah5, bl0)) | 0;
    	    hi = Math.imul(ah5, bh0);
    	    lo = (lo + Math.imul(al4, bl1)) | 0;
    	    mid = (mid + Math.imul(al4, bh1)) | 0;
    	    mid = (mid + Math.imul(ah4, bl1)) | 0;
    	    hi = (hi + Math.imul(ah4, bh1)) | 0;
    	    lo = (lo + Math.imul(al3, bl2)) | 0;
    	    mid = (mid + Math.imul(al3, bh2)) | 0;
    	    mid = (mid + Math.imul(ah3, bl2)) | 0;
    	    hi = (hi + Math.imul(ah3, bh2)) | 0;
    	    lo = (lo + Math.imul(al2, bl3)) | 0;
    	    mid = (mid + Math.imul(al2, bh3)) | 0;
    	    mid = (mid + Math.imul(ah2, bl3)) | 0;
    	    hi = (hi + Math.imul(ah2, bh3)) | 0;
    	    lo = (lo + Math.imul(al1, bl4)) | 0;
    	    mid = (mid + Math.imul(al1, bh4)) | 0;
    	    mid = (mid + Math.imul(ah1, bl4)) | 0;
    	    hi = (hi + Math.imul(ah1, bh4)) | 0;
    	    lo = (lo + Math.imul(al0, bl5)) | 0;
    	    mid = (mid + Math.imul(al0, bh5)) | 0;
    	    mid = (mid + Math.imul(ah0, bl5)) | 0;
    	    hi = (hi + Math.imul(ah0, bh5)) | 0;
    	    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    	    w5 &= 0x3ffffff;
    	    /* k = 6 */
    	    lo = Math.imul(al6, bl0);
    	    mid = Math.imul(al6, bh0);
    	    mid = (mid + Math.imul(ah6, bl0)) | 0;
    	    hi = Math.imul(ah6, bh0);
    	    lo = (lo + Math.imul(al5, bl1)) | 0;
    	    mid = (mid + Math.imul(al5, bh1)) | 0;
    	    mid = (mid + Math.imul(ah5, bl1)) | 0;
    	    hi = (hi + Math.imul(ah5, bh1)) | 0;
    	    lo = (lo + Math.imul(al4, bl2)) | 0;
    	    mid = (mid + Math.imul(al4, bh2)) | 0;
    	    mid = (mid + Math.imul(ah4, bl2)) | 0;
    	    hi = (hi + Math.imul(ah4, bh2)) | 0;
    	    lo = (lo + Math.imul(al3, bl3)) | 0;
    	    mid = (mid + Math.imul(al3, bh3)) | 0;
    	    mid = (mid + Math.imul(ah3, bl3)) | 0;
    	    hi = (hi + Math.imul(ah3, bh3)) | 0;
    	    lo = (lo + Math.imul(al2, bl4)) | 0;
    	    mid = (mid + Math.imul(al2, bh4)) | 0;
    	    mid = (mid + Math.imul(ah2, bl4)) | 0;
    	    hi = (hi + Math.imul(ah2, bh4)) | 0;
    	    lo = (lo + Math.imul(al1, bl5)) | 0;
    	    mid = (mid + Math.imul(al1, bh5)) | 0;
    	    mid = (mid + Math.imul(ah1, bl5)) | 0;
    	    hi = (hi + Math.imul(ah1, bh5)) | 0;
    	    lo = (lo + Math.imul(al0, bl6)) | 0;
    	    mid = (mid + Math.imul(al0, bh6)) | 0;
    	    mid = (mid + Math.imul(ah0, bl6)) | 0;
    	    hi = (hi + Math.imul(ah0, bh6)) | 0;
    	    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    	    w6 &= 0x3ffffff;
    	    /* k = 7 */
    	    lo = Math.imul(al7, bl0);
    	    mid = Math.imul(al7, bh0);
    	    mid = (mid + Math.imul(ah7, bl0)) | 0;
    	    hi = Math.imul(ah7, bh0);
    	    lo = (lo + Math.imul(al6, bl1)) | 0;
    	    mid = (mid + Math.imul(al6, bh1)) | 0;
    	    mid = (mid + Math.imul(ah6, bl1)) | 0;
    	    hi = (hi + Math.imul(ah6, bh1)) | 0;
    	    lo = (lo + Math.imul(al5, bl2)) | 0;
    	    mid = (mid + Math.imul(al5, bh2)) | 0;
    	    mid = (mid + Math.imul(ah5, bl2)) | 0;
    	    hi = (hi + Math.imul(ah5, bh2)) | 0;
    	    lo = (lo + Math.imul(al4, bl3)) | 0;
    	    mid = (mid + Math.imul(al4, bh3)) | 0;
    	    mid = (mid + Math.imul(ah4, bl3)) | 0;
    	    hi = (hi + Math.imul(ah4, bh3)) | 0;
    	    lo = (lo + Math.imul(al3, bl4)) | 0;
    	    mid = (mid + Math.imul(al3, bh4)) | 0;
    	    mid = (mid + Math.imul(ah3, bl4)) | 0;
    	    hi = (hi + Math.imul(ah3, bh4)) | 0;
    	    lo = (lo + Math.imul(al2, bl5)) | 0;
    	    mid = (mid + Math.imul(al2, bh5)) | 0;
    	    mid = (mid + Math.imul(ah2, bl5)) | 0;
    	    hi = (hi + Math.imul(ah2, bh5)) | 0;
    	    lo = (lo + Math.imul(al1, bl6)) | 0;
    	    mid = (mid + Math.imul(al1, bh6)) | 0;
    	    mid = (mid + Math.imul(ah1, bl6)) | 0;
    	    hi = (hi + Math.imul(ah1, bh6)) | 0;
    	    lo = (lo + Math.imul(al0, bl7)) | 0;
    	    mid = (mid + Math.imul(al0, bh7)) | 0;
    	    mid = (mid + Math.imul(ah0, bl7)) | 0;
    	    hi = (hi + Math.imul(ah0, bh7)) | 0;
    	    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    	    w7 &= 0x3ffffff;
    	    /* k = 8 */
    	    lo = Math.imul(al8, bl0);
    	    mid = Math.imul(al8, bh0);
    	    mid = (mid + Math.imul(ah8, bl0)) | 0;
    	    hi = Math.imul(ah8, bh0);
    	    lo = (lo + Math.imul(al7, bl1)) | 0;
    	    mid = (mid + Math.imul(al7, bh1)) | 0;
    	    mid = (mid + Math.imul(ah7, bl1)) | 0;
    	    hi = (hi + Math.imul(ah7, bh1)) | 0;
    	    lo = (lo + Math.imul(al6, bl2)) | 0;
    	    mid = (mid + Math.imul(al6, bh2)) | 0;
    	    mid = (mid + Math.imul(ah6, bl2)) | 0;
    	    hi = (hi + Math.imul(ah6, bh2)) | 0;
    	    lo = (lo + Math.imul(al5, bl3)) | 0;
    	    mid = (mid + Math.imul(al5, bh3)) | 0;
    	    mid = (mid + Math.imul(ah5, bl3)) | 0;
    	    hi = (hi + Math.imul(ah5, bh3)) | 0;
    	    lo = (lo + Math.imul(al4, bl4)) | 0;
    	    mid = (mid + Math.imul(al4, bh4)) | 0;
    	    mid = (mid + Math.imul(ah4, bl4)) | 0;
    	    hi = (hi + Math.imul(ah4, bh4)) | 0;
    	    lo = (lo + Math.imul(al3, bl5)) | 0;
    	    mid = (mid + Math.imul(al3, bh5)) | 0;
    	    mid = (mid + Math.imul(ah3, bl5)) | 0;
    	    hi = (hi + Math.imul(ah3, bh5)) | 0;
    	    lo = (lo + Math.imul(al2, bl6)) | 0;
    	    mid = (mid + Math.imul(al2, bh6)) | 0;
    	    mid = (mid + Math.imul(ah2, bl6)) | 0;
    	    hi = (hi + Math.imul(ah2, bh6)) | 0;
    	    lo = (lo + Math.imul(al1, bl7)) | 0;
    	    mid = (mid + Math.imul(al1, bh7)) | 0;
    	    mid = (mid + Math.imul(ah1, bl7)) | 0;
    	    hi = (hi + Math.imul(ah1, bh7)) | 0;
    	    lo = (lo + Math.imul(al0, bl8)) | 0;
    	    mid = (mid + Math.imul(al0, bh8)) | 0;
    	    mid = (mid + Math.imul(ah0, bl8)) | 0;
    	    hi = (hi + Math.imul(ah0, bh8)) | 0;
    	    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    	    w8 &= 0x3ffffff;
    	    /* k = 9 */
    	    lo = Math.imul(al9, bl0);
    	    mid = Math.imul(al9, bh0);
    	    mid = (mid + Math.imul(ah9, bl0)) | 0;
    	    hi = Math.imul(ah9, bh0);
    	    lo = (lo + Math.imul(al8, bl1)) | 0;
    	    mid = (mid + Math.imul(al8, bh1)) | 0;
    	    mid = (mid + Math.imul(ah8, bl1)) | 0;
    	    hi = (hi + Math.imul(ah8, bh1)) | 0;
    	    lo = (lo + Math.imul(al7, bl2)) | 0;
    	    mid = (mid + Math.imul(al7, bh2)) | 0;
    	    mid = (mid + Math.imul(ah7, bl2)) | 0;
    	    hi = (hi + Math.imul(ah7, bh2)) | 0;
    	    lo = (lo + Math.imul(al6, bl3)) | 0;
    	    mid = (mid + Math.imul(al6, bh3)) | 0;
    	    mid = (mid + Math.imul(ah6, bl3)) | 0;
    	    hi = (hi + Math.imul(ah6, bh3)) | 0;
    	    lo = (lo + Math.imul(al5, bl4)) | 0;
    	    mid = (mid + Math.imul(al5, bh4)) | 0;
    	    mid = (mid + Math.imul(ah5, bl4)) | 0;
    	    hi = (hi + Math.imul(ah5, bh4)) | 0;
    	    lo = (lo + Math.imul(al4, bl5)) | 0;
    	    mid = (mid + Math.imul(al4, bh5)) | 0;
    	    mid = (mid + Math.imul(ah4, bl5)) | 0;
    	    hi = (hi + Math.imul(ah4, bh5)) | 0;
    	    lo = (lo + Math.imul(al3, bl6)) | 0;
    	    mid = (mid + Math.imul(al3, bh6)) | 0;
    	    mid = (mid + Math.imul(ah3, bl6)) | 0;
    	    hi = (hi + Math.imul(ah3, bh6)) | 0;
    	    lo = (lo + Math.imul(al2, bl7)) | 0;
    	    mid = (mid + Math.imul(al2, bh7)) | 0;
    	    mid = (mid + Math.imul(ah2, bl7)) | 0;
    	    hi = (hi + Math.imul(ah2, bh7)) | 0;
    	    lo = (lo + Math.imul(al1, bl8)) | 0;
    	    mid = (mid + Math.imul(al1, bh8)) | 0;
    	    mid = (mid + Math.imul(ah1, bl8)) | 0;
    	    hi = (hi + Math.imul(ah1, bh8)) | 0;
    	    lo = (lo + Math.imul(al0, bl9)) | 0;
    	    mid = (mid + Math.imul(al0, bh9)) | 0;
    	    mid = (mid + Math.imul(ah0, bl9)) | 0;
    	    hi = (hi + Math.imul(ah0, bh9)) | 0;
    	    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    	    w9 &= 0x3ffffff;
    	    /* k = 10 */
    	    lo = Math.imul(al9, bl1);
    	    mid = Math.imul(al9, bh1);
    	    mid = (mid + Math.imul(ah9, bl1)) | 0;
    	    hi = Math.imul(ah9, bh1);
    	    lo = (lo + Math.imul(al8, bl2)) | 0;
    	    mid = (mid + Math.imul(al8, bh2)) | 0;
    	    mid = (mid + Math.imul(ah8, bl2)) | 0;
    	    hi = (hi + Math.imul(ah8, bh2)) | 0;
    	    lo = (lo + Math.imul(al7, bl3)) | 0;
    	    mid = (mid + Math.imul(al7, bh3)) | 0;
    	    mid = (mid + Math.imul(ah7, bl3)) | 0;
    	    hi = (hi + Math.imul(ah7, bh3)) | 0;
    	    lo = (lo + Math.imul(al6, bl4)) | 0;
    	    mid = (mid + Math.imul(al6, bh4)) | 0;
    	    mid = (mid + Math.imul(ah6, bl4)) | 0;
    	    hi = (hi + Math.imul(ah6, bh4)) | 0;
    	    lo = (lo + Math.imul(al5, bl5)) | 0;
    	    mid = (mid + Math.imul(al5, bh5)) | 0;
    	    mid = (mid + Math.imul(ah5, bl5)) | 0;
    	    hi = (hi + Math.imul(ah5, bh5)) | 0;
    	    lo = (lo + Math.imul(al4, bl6)) | 0;
    	    mid = (mid + Math.imul(al4, bh6)) | 0;
    	    mid = (mid + Math.imul(ah4, bl6)) | 0;
    	    hi = (hi + Math.imul(ah4, bh6)) | 0;
    	    lo = (lo + Math.imul(al3, bl7)) | 0;
    	    mid = (mid + Math.imul(al3, bh7)) | 0;
    	    mid = (mid + Math.imul(ah3, bl7)) | 0;
    	    hi = (hi + Math.imul(ah3, bh7)) | 0;
    	    lo = (lo + Math.imul(al2, bl8)) | 0;
    	    mid = (mid + Math.imul(al2, bh8)) | 0;
    	    mid = (mid + Math.imul(ah2, bl8)) | 0;
    	    hi = (hi + Math.imul(ah2, bh8)) | 0;
    	    lo = (lo + Math.imul(al1, bl9)) | 0;
    	    mid = (mid + Math.imul(al1, bh9)) | 0;
    	    mid = (mid + Math.imul(ah1, bl9)) | 0;
    	    hi = (hi + Math.imul(ah1, bh9)) | 0;
    	    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    	    w10 &= 0x3ffffff;
    	    /* k = 11 */
    	    lo = Math.imul(al9, bl2);
    	    mid = Math.imul(al9, bh2);
    	    mid = (mid + Math.imul(ah9, bl2)) | 0;
    	    hi = Math.imul(ah9, bh2);
    	    lo = (lo + Math.imul(al8, bl3)) | 0;
    	    mid = (mid + Math.imul(al8, bh3)) | 0;
    	    mid = (mid + Math.imul(ah8, bl3)) | 0;
    	    hi = (hi + Math.imul(ah8, bh3)) | 0;
    	    lo = (lo + Math.imul(al7, bl4)) | 0;
    	    mid = (mid + Math.imul(al7, bh4)) | 0;
    	    mid = (mid + Math.imul(ah7, bl4)) | 0;
    	    hi = (hi + Math.imul(ah7, bh4)) | 0;
    	    lo = (lo + Math.imul(al6, bl5)) | 0;
    	    mid = (mid + Math.imul(al6, bh5)) | 0;
    	    mid = (mid + Math.imul(ah6, bl5)) | 0;
    	    hi = (hi + Math.imul(ah6, bh5)) | 0;
    	    lo = (lo + Math.imul(al5, bl6)) | 0;
    	    mid = (mid + Math.imul(al5, bh6)) | 0;
    	    mid = (mid + Math.imul(ah5, bl6)) | 0;
    	    hi = (hi + Math.imul(ah5, bh6)) | 0;
    	    lo = (lo + Math.imul(al4, bl7)) | 0;
    	    mid = (mid + Math.imul(al4, bh7)) | 0;
    	    mid = (mid + Math.imul(ah4, bl7)) | 0;
    	    hi = (hi + Math.imul(ah4, bh7)) | 0;
    	    lo = (lo + Math.imul(al3, bl8)) | 0;
    	    mid = (mid + Math.imul(al3, bh8)) | 0;
    	    mid = (mid + Math.imul(ah3, bl8)) | 0;
    	    hi = (hi + Math.imul(ah3, bh8)) | 0;
    	    lo = (lo + Math.imul(al2, bl9)) | 0;
    	    mid = (mid + Math.imul(al2, bh9)) | 0;
    	    mid = (mid + Math.imul(ah2, bl9)) | 0;
    	    hi = (hi + Math.imul(ah2, bh9)) | 0;
    	    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    	    w11 &= 0x3ffffff;
    	    /* k = 12 */
    	    lo = Math.imul(al9, bl3);
    	    mid = Math.imul(al9, bh3);
    	    mid = (mid + Math.imul(ah9, bl3)) | 0;
    	    hi = Math.imul(ah9, bh3);
    	    lo = (lo + Math.imul(al8, bl4)) | 0;
    	    mid = (mid + Math.imul(al8, bh4)) | 0;
    	    mid = (mid + Math.imul(ah8, bl4)) | 0;
    	    hi = (hi + Math.imul(ah8, bh4)) | 0;
    	    lo = (lo + Math.imul(al7, bl5)) | 0;
    	    mid = (mid + Math.imul(al7, bh5)) | 0;
    	    mid = (mid + Math.imul(ah7, bl5)) | 0;
    	    hi = (hi + Math.imul(ah7, bh5)) | 0;
    	    lo = (lo + Math.imul(al6, bl6)) | 0;
    	    mid = (mid + Math.imul(al6, bh6)) | 0;
    	    mid = (mid + Math.imul(ah6, bl6)) | 0;
    	    hi = (hi + Math.imul(ah6, bh6)) | 0;
    	    lo = (lo + Math.imul(al5, bl7)) | 0;
    	    mid = (mid + Math.imul(al5, bh7)) | 0;
    	    mid = (mid + Math.imul(ah5, bl7)) | 0;
    	    hi = (hi + Math.imul(ah5, bh7)) | 0;
    	    lo = (lo + Math.imul(al4, bl8)) | 0;
    	    mid = (mid + Math.imul(al4, bh8)) | 0;
    	    mid = (mid + Math.imul(ah4, bl8)) | 0;
    	    hi = (hi + Math.imul(ah4, bh8)) | 0;
    	    lo = (lo + Math.imul(al3, bl9)) | 0;
    	    mid = (mid + Math.imul(al3, bh9)) | 0;
    	    mid = (mid + Math.imul(ah3, bl9)) | 0;
    	    hi = (hi + Math.imul(ah3, bh9)) | 0;
    	    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    	    w12 &= 0x3ffffff;
    	    /* k = 13 */
    	    lo = Math.imul(al9, bl4);
    	    mid = Math.imul(al9, bh4);
    	    mid = (mid + Math.imul(ah9, bl4)) | 0;
    	    hi = Math.imul(ah9, bh4);
    	    lo = (lo + Math.imul(al8, bl5)) | 0;
    	    mid = (mid + Math.imul(al8, bh5)) | 0;
    	    mid = (mid + Math.imul(ah8, bl5)) | 0;
    	    hi = (hi + Math.imul(ah8, bh5)) | 0;
    	    lo = (lo + Math.imul(al7, bl6)) | 0;
    	    mid = (mid + Math.imul(al7, bh6)) | 0;
    	    mid = (mid + Math.imul(ah7, bl6)) | 0;
    	    hi = (hi + Math.imul(ah7, bh6)) | 0;
    	    lo = (lo + Math.imul(al6, bl7)) | 0;
    	    mid = (mid + Math.imul(al6, bh7)) | 0;
    	    mid = (mid + Math.imul(ah6, bl7)) | 0;
    	    hi = (hi + Math.imul(ah6, bh7)) | 0;
    	    lo = (lo + Math.imul(al5, bl8)) | 0;
    	    mid = (mid + Math.imul(al5, bh8)) | 0;
    	    mid = (mid + Math.imul(ah5, bl8)) | 0;
    	    hi = (hi + Math.imul(ah5, bh8)) | 0;
    	    lo = (lo + Math.imul(al4, bl9)) | 0;
    	    mid = (mid + Math.imul(al4, bh9)) | 0;
    	    mid = (mid + Math.imul(ah4, bl9)) | 0;
    	    hi = (hi + Math.imul(ah4, bh9)) | 0;
    	    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    	    w13 &= 0x3ffffff;
    	    /* k = 14 */
    	    lo = Math.imul(al9, bl5);
    	    mid = Math.imul(al9, bh5);
    	    mid = (mid + Math.imul(ah9, bl5)) | 0;
    	    hi = Math.imul(ah9, bh5);
    	    lo = (lo + Math.imul(al8, bl6)) | 0;
    	    mid = (mid + Math.imul(al8, bh6)) | 0;
    	    mid = (mid + Math.imul(ah8, bl6)) | 0;
    	    hi = (hi + Math.imul(ah8, bh6)) | 0;
    	    lo = (lo + Math.imul(al7, bl7)) | 0;
    	    mid = (mid + Math.imul(al7, bh7)) | 0;
    	    mid = (mid + Math.imul(ah7, bl7)) | 0;
    	    hi = (hi + Math.imul(ah7, bh7)) | 0;
    	    lo = (lo + Math.imul(al6, bl8)) | 0;
    	    mid = (mid + Math.imul(al6, bh8)) | 0;
    	    mid = (mid + Math.imul(ah6, bl8)) | 0;
    	    hi = (hi + Math.imul(ah6, bh8)) | 0;
    	    lo = (lo + Math.imul(al5, bl9)) | 0;
    	    mid = (mid + Math.imul(al5, bh9)) | 0;
    	    mid = (mid + Math.imul(ah5, bl9)) | 0;
    	    hi = (hi + Math.imul(ah5, bh9)) | 0;
    	    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    	    w14 &= 0x3ffffff;
    	    /* k = 15 */
    	    lo = Math.imul(al9, bl6);
    	    mid = Math.imul(al9, bh6);
    	    mid = (mid + Math.imul(ah9, bl6)) | 0;
    	    hi = Math.imul(ah9, bh6);
    	    lo = (lo + Math.imul(al8, bl7)) | 0;
    	    mid = (mid + Math.imul(al8, bh7)) | 0;
    	    mid = (mid + Math.imul(ah8, bl7)) | 0;
    	    hi = (hi + Math.imul(ah8, bh7)) | 0;
    	    lo = (lo + Math.imul(al7, bl8)) | 0;
    	    mid = (mid + Math.imul(al7, bh8)) | 0;
    	    mid = (mid + Math.imul(ah7, bl8)) | 0;
    	    hi = (hi + Math.imul(ah7, bh8)) | 0;
    	    lo = (lo + Math.imul(al6, bl9)) | 0;
    	    mid = (mid + Math.imul(al6, bh9)) | 0;
    	    mid = (mid + Math.imul(ah6, bl9)) | 0;
    	    hi = (hi + Math.imul(ah6, bh9)) | 0;
    	    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    	    w15 &= 0x3ffffff;
    	    /* k = 16 */
    	    lo = Math.imul(al9, bl7);
    	    mid = Math.imul(al9, bh7);
    	    mid = (mid + Math.imul(ah9, bl7)) | 0;
    	    hi = Math.imul(ah9, bh7);
    	    lo = (lo + Math.imul(al8, bl8)) | 0;
    	    mid = (mid + Math.imul(al8, bh8)) | 0;
    	    mid = (mid + Math.imul(ah8, bl8)) | 0;
    	    hi = (hi + Math.imul(ah8, bh8)) | 0;
    	    lo = (lo + Math.imul(al7, bl9)) | 0;
    	    mid = (mid + Math.imul(al7, bh9)) | 0;
    	    mid = (mid + Math.imul(ah7, bl9)) | 0;
    	    hi = (hi + Math.imul(ah7, bh9)) | 0;
    	    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    	    w16 &= 0x3ffffff;
    	    /* k = 17 */
    	    lo = Math.imul(al9, bl8);
    	    mid = Math.imul(al9, bh8);
    	    mid = (mid + Math.imul(ah9, bl8)) | 0;
    	    hi = Math.imul(ah9, bh8);
    	    lo = (lo + Math.imul(al8, bl9)) | 0;
    	    mid = (mid + Math.imul(al8, bh9)) | 0;
    	    mid = (mid + Math.imul(ah8, bl9)) | 0;
    	    hi = (hi + Math.imul(ah8, bh9)) | 0;
    	    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    	    w17 &= 0x3ffffff;
    	    /* k = 18 */
    	    lo = Math.imul(al9, bl9);
    	    mid = Math.imul(al9, bh9);
    	    mid = (mid + Math.imul(ah9, bl9)) | 0;
    	    hi = Math.imul(ah9, bh9);
    	    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    	    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    	    w18 &= 0x3ffffff;
    	    o[0] = w0;
    	    o[1] = w1;
    	    o[2] = w2;
    	    o[3] = w3;
    	    o[4] = w4;
    	    o[5] = w5;
    	    o[6] = w6;
    	    o[7] = w7;
    	    o[8] = w8;
    	    o[9] = w9;
    	    o[10] = w10;
    	    o[11] = w11;
    	    o[12] = w12;
    	    o[13] = w13;
    	    o[14] = w14;
    	    o[15] = w15;
    	    o[16] = w16;
    	    o[17] = w17;
    	    o[18] = w18;
    	    if (c !== 0) {
    	      o[19] = c;
    	      out.length++;
    	    }
    	    return out;
    	  };

    	  // Polyfill comb
    	  if (!Math.imul) {
    	    comb10MulTo = smallMulTo;
    	  }

    	  function bigMulTo (self, num, out) {
    	    out.negative = num.negative ^ self.negative;
    	    out.length = self.length + num.length;

    	    var carry = 0;
    	    var hncarry = 0;
    	    for (var k = 0; k < out.length - 1; k++) {
    	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
    	      // note that ncarry could be >= 0x3ffffff
    	      var ncarry = hncarry;
    	      hncarry = 0;
    	      var rword = carry & 0x3ffffff;
    	      var maxJ = Math.min(k, num.length - 1);
    	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
    	        var i = k - j;
    	        var a = self.words[i] | 0;
    	        var b = num.words[j] | 0;
    	        var r = a * b;

    	        var lo = r & 0x3ffffff;
    	        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
    	        lo = (lo + rword) | 0;
    	        rword = lo & 0x3ffffff;
    	        ncarry = (ncarry + (lo >>> 26)) | 0;

    	        hncarry += ncarry >>> 26;
    	        ncarry &= 0x3ffffff;
    	      }
    	      out.words[k] = rword;
    	      carry = ncarry;
    	      ncarry = hncarry;
    	    }
    	    if (carry !== 0) {
    	      out.words[k] = carry;
    	    } else {
    	      out.length--;
    	    }

    	    return out.strip();
    	  }

    	  function jumboMulTo (self, num, out) {
    	    var fftm = new FFTM();
    	    return fftm.mulp(self, num, out);
    	  }

    	  BN.prototype.mulTo = function mulTo (num, out) {
    	    var res;
    	    var len = this.length + num.length;
    	    if (this.length === 10 && num.length === 10) {
    	      res = comb10MulTo(this, num, out);
    	    } else if (len < 63) {
    	      res = smallMulTo(this, num, out);
    	    } else if (len < 1024) {
    	      res = bigMulTo(this, num, out);
    	    } else {
    	      res = jumboMulTo(this, num, out);
    	    }

    	    return res;
    	  };

    	  // Cooley-Tukey algorithm for FFT
    	  // slightly revisited to rely on looping instead of recursion

    	  function FFTM (x, y) {
    	    this.x = x;
    	    this.y = y;
    	  }

    	  FFTM.prototype.makeRBT = function makeRBT (N) {
    	    var t = new Array(N);
    	    var l = BN.prototype._countBits(N) - 1;
    	    for (var i = 0; i < N; i++) {
    	      t[i] = this.revBin(i, l, N);
    	    }

    	    return t;
    	  };

    	  // Returns binary-reversed representation of `x`
    	  FFTM.prototype.revBin = function revBin (x, l, N) {
    	    if (x === 0 || x === N - 1) return x;

    	    var rb = 0;
    	    for (var i = 0; i < l; i++) {
    	      rb |= (x & 1) << (l - i - 1);
    	      x >>= 1;
    	    }

    	    return rb;
    	  };

    	  // Performs "tweedling" phase, therefore 'emulating'
    	  // behaviour of the recursive algorithm
    	  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    	    for (var i = 0; i < N; i++) {
    	      rtws[i] = rws[rbt[i]];
    	      itws[i] = iws[rbt[i]];
    	    }
    	  };

    	  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    	    this.permute(rbt, rws, iws, rtws, itws, N);

    	    for (var s = 1; s < N; s <<= 1) {
    	      var l = s << 1;

    	      var rtwdf = Math.cos(2 * Math.PI / l);
    	      var itwdf = Math.sin(2 * Math.PI / l);

    	      for (var p = 0; p < N; p += l) {
    	        var rtwdf_ = rtwdf;
    	        var itwdf_ = itwdf;

    	        for (var j = 0; j < s; j++) {
    	          var re = rtws[p + j];
    	          var ie = itws[p + j];

    	          var ro = rtws[p + j + s];
    	          var io = itws[p + j + s];

    	          var rx = rtwdf_ * ro - itwdf_ * io;

    	          io = rtwdf_ * io + itwdf_ * ro;
    	          ro = rx;

    	          rtws[p + j] = re + ro;
    	          itws[p + j] = ie + io;

    	          rtws[p + j + s] = re - ro;
    	          itws[p + j + s] = ie - io;

    	          /* jshint maxdepth : false */
    	          if (j !== l) {
    	            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

    	            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
    	            rtwdf_ = rx;
    	          }
    	        }
    	      }
    	    }
    	  };

    	  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    	    var N = Math.max(m, n) | 1;
    	    var odd = N & 1;
    	    var i = 0;
    	    for (N = N / 2 | 0; N; N = N >>> 1) {
    	      i++;
    	    }

    	    return 1 << i + 1 + odd;
    	  };

    	  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    	    if (N <= 1) return;

    	    for (var i = 0; i < N / 2; i++) {
    	      var t = rws[i];

    	      rws[i] = rws[N - i - 1];
    	      rws[N - i - 1] = t;

    	      t = iws[i];

    	      iws[i] = -iws[N - i - 1];
    	      iws[N - i - 1] = -t;
    	    }
    	  };

    	  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    	    var carry = 0;
    	    for (var i = 0; i < N / 2; i++) {
    	      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
    	        Math.round(ws[2 * i] / N) +
    	        carry;

    	      ws[i] = w & 0x3ffffff;

    	      if (w < 0x4000000) {
    	        carry = 0;
    	      } else {
    	        carry = w / 0x4000000 | 0;
    	      }
    	    }

    	    return ws;
    	  };

    	  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    	    var carry = 0;
    	    for (var i = 0; i < len; i++) {
    	      carry = carry + (ws[i] | 0);

    	      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
    	      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    	    }

    	    // Pad with zeroes
    	    for (i = 2 * len; i < N; ++i) {
    	      rws[i] = 0;
    	    }

    	    assert(carry === 0);
    	    assert((carry & ~0x1fff) === 0);
    	  };

    	  FFTM.prototype.stub = function stub (N) {
    	    var ph = new Array(N);
    	    for (var i = 0; i < N; i++) {
    	      ph[i] = 0;
    	    }

    	    return ph;
    	  };

    	  FFTM.prototype.mulp = function mulp (x, y, out) {
    	    var N = 2 * this.guessLen13b(x.length, y.length);

    	    var rbt = this.makeRBT(N);

    	    var _ = this.stub(N);

    	    var rws = new Array(N);
    	    var rwst = new Array(N);
    	    var iwst = new Array(N);

    	    var nrws = new Array(N);
    	    var nrwst = new Array(N);
    	    var niwst = new Array(N);

    	    var rmws = out.words;
    	    rmws.length = N;

    	    this.convert13b(x.words, x.length, rws, N);
    	    this.convert13b(y.words, y.length, nrws, N);

    	    this.transform(rws, _, rwst, iwst, N, rbt);
    	    this.transform(nrws, _, nrwst, niwst, N, rbt);

    	    for (var i = 0; i < N; i++) {
    	      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
    	      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
    	      rwst[i] = rx;
    	    }

    	    this.conjugate(rwst, iwst, N);
    	    this.transform(rwst, iwst, rmws, _, N, rbt);
    	    this.conjugate(rmws, _, N);
    	    this.normalize13b(rmws, N);

    	    out.negative = x.negative ^ y.negative;
    	    out.length = x.length + y.length;
    	    return out.strip();
    	  };

    	  // Multiply `this` by `num`
    	  BN.prototype.mul = function mul (num) {
    	    var out = new BN(null);
    	    out.words = new Array(this.length + num.length);
    	    return this.mulTo(num, out);
    	  };

    	  // Multiply employing FFT
    	  BN.prototype.mulf = function mulf (num) {
    	    var out = new BN(null);
    	    out.words = new Array(this.length + num.length);
    	    return jumboMulTo(this, num, out);
    	  };

    	  // In-place Multiplication
    	  BN.prototype.imul = function imul (num) {
    	    return this.clone().mulTo(num, this);
    	  };

    	  BN.prototype.imuln = function imuln (num) {
    	    assert(typeof num === 'number');
    	    assert(num < 0x4000000);

    	    // Carry
    	    var carry = 0;
    	    for (var i = 0; i < this.length; i++) {
    	      var w = (this.words[i] | 0) * num;
    	      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
    	      carry >>= 26;
    	      carry += (w / 0x4000000) | 0;
    	      // NOTE: lo is 27bit maximum
    	      carry += lo >>> 26;
    	      this.words[i] = lo & 0x3ffffff;
    	    }

    	    if (carry !== 0) {
    	      this.words[i] = carry;
    	      this.length++;
    	    }

    	    return this;
    	  };

    	  BN.prototype.muln = function muln (num) {
    	    return this.clone().imuln(num);
    	  };

    	  // `this` * `this`
    	  BN.prototype.sqr = function sqr () {
    	    return this.mul(this);
    	  };

    	  // `this` * `this` in-place
    	  BN.prototype.isqr = function isqr () {
    	    return this.imul(this.clone());
    	  };

    	  // Math.pow(`this`, `num`)
    	  BN.prototype.pow = function pow (num) {
    	    var w = toBitArray(num);
    	    if (w.length === 0) return new BN(1);

    	    // Skip leading zeroes
    	    var res = this;
    	    for (var i = 0; i < w.length; i++, res = res.sqr()) {
    	      if (w[i] !== 0) break;
    	    }

    	    if (++i < w.length) {
    	      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
    	        if (w[i] === 0) continue;

    	        res = res.mul(q);
    	      }
    	    }

    	    return res;
    	  };

    	  // Shift-left in-place
    	  BN.prototype.iushln = function iushln (bits) {
    	    assert(typeof bits === 'number' && bits >= 0);
    	    var r = bits % 26;
    	    var s = (bits - r) / 26;
    	    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    	    var i;

    	    if (r !== 0) {
    	      var carry = 0;

    	      for (i = 0; i < this.length; i++) {
    	        var newCarry = this.words[i] & carryMask;
    	        var c = ((this.words[i] | 0) - newCarry) << r;
    	        this.words[i] = c | carry;
    	        carry = newCarry >>> (26 - r);
    	      }

    	      if (carry) {
    	        this.words[i] = carry;
    	        this.length++;
    	      }
    	    }

    	    if (s !== 0) {
    	      for (i = this.length - 1; i >= 0; i--) {
    	        this.words[i + s] = this.words[i];
    	      }

    	      for (i = 0; i < s; i++) {
    	        this.words[i] = 0;
    	      }

    	      this.length += s;
    	    }

    	    return this.strip();
    	  };

    	  BN.prototype.ishln = function ishln (bits) {
    	    // TODO(indutny): implement me
    	    assert(this.negative === 0);
    	    return this.iushln(bits);
    	  };

    	  // Shift-right in-place
    	  // NOTE: `hint` is a lowest bit before trailing zeroes
    	  // NOTE: if `extended` is present - it will be filled with destroyed bits
    	  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    	    assert(typeof bits === 'number' && bits >= 0);
    	    var h;
    	    if (hint) {
    	      h = (hint - (hint % 26)) / 26;
    	    } else {
    	      h = 0;
    	    }

    	    var r = bits % 26;
    	    var s = Math.min((bits - r) / 26, this.length);
    	    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    	    var maskedWords = extended;

    	    h -= s;
    	    h = Math.max(0, h);

    	    // Extended mode, copy masked part
    	    if (maskedWords) {
    	      for (var i = 0; i < s; i++) {
    	        maskedWords.words[i] = this.words[i];
    	      }
    	      maskedWords.length = s;
    	    }

    	    if (s === 0) ; else if (this.length > s) {
    	      this.length -= s;
    	      for (i = 0; i < this.length; i++) {
    	        this.words[i] = this.words[i + s];
    	      }
    	    } else {
    	      this.words[0] = 0;
    	      this.length = 1;
    	    }

    	    var carry = 0;
    	    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
    	      var word = this.words[i] | 0;
    	      this.words[i] = (carry << (26 - r)) | (word >>> r);
    	      carry = word & mask;
    	    }

    	    // Push carried bits as a mask
    	    if (maskedWords && carry !== 0) {
    	      maskedWords.words[maskedWords.length++] = carry;
    	    }

    	    if (this.length === 0) {
    	      this.words[0] = 0;
    	      this.length = 1;
    	    }

    	    return this.strip();
    	  };

    	  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    	    // TODO(indutny): implement me
    	    assert(this.negative === 0);
    	    return this.iushrn(bits, hint, extended);
    	  };

    	  // Shift-left
    	  BN.prototype.shln = function shln (bits) {
    	    return this.clone().ishln(bits);
    	  };

    	  BN.prototype.ushln = function ushln (bits) {
    	    return this.clone().iushln(bits);
    	  };

    	  // Shift-right
    	  BN.prototype.shrn = function shrn (bits) {
    	    return this.clone().ishrn(bits);
    	  };

    	  BN.prototype.ushrn = function ushrn (bits) {
    	    return this.clone().iushrn(bits);
    	  };

    	  // Test if n bit is set
    	  BN.prototype.testn = function testn (bit) {
    	    assert(typeof bit === 'number' && bit >= 0);
    	    var r = bit % 26;
    	    var s = (bit - r) / 26;
    	    var q = 1 << r;

    	    // Fast case: bit is much higher than all existing words
    	    if (this.length <= s) return false;

    	    // Check bit and return
    	    var w = this.words[s];

    	    return !!(w & q);
    	  };

    	  // Return only lowers bits of number (in-place)
    	  BN.prototype.imaskn = function imaskn (bits) {
    	    assert(typeof bits === 'number' && bits >= 0);
    	    var r = bits % 26;
    	    var s = (bits - r) / 26;

    	    assert(this.negative === 0, 'imaskn works only with positive numbers');

    	    if (this.length <= s) {
    	      return this;
    	    }

    	    if (r !== 0) {
    	      s++;
    	    }
    	    this.length = Math.min(s, this.length);

    	    if (r !== 0) {
    	      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    	      this.words[this.length - 1] &= mask;
    	    }

    	    return this.strip();
    	  };

    	  // Return only lowers bits of number
    	  BN.prototype.maskn = function maskn (bits) {
    	    return this.clone().imaskn(bits);
    	  };

    	  // Add plain number `num` to `this`
    	  BN.prototype.iaddn = function iaddn (num) {
    	    assert(typeof num === 'number');
    	    assert(num < 0x4000000);
    	    if (num < 0) return this.isubn(-num);

    	    // Possible sign change
    	    if (this.negative !== 0) {
    	      if (this.length === 1 && (this.words[0] | 0) < num) {
    	        this.words[0] = num - (this.words[0] | 0);
    	        this.negative = 0;
    	        return this;
    	      }

    	      this.negative = 0;
    	      this.isubn(num);
    	      this.negative = 1;
    	      return this;
    	    }

    	    // Add without checks
    	    return this._iaddn(num);
    	  };

    	  BN.prototype._iaddn = function _iaddn (num) {
    	    this.words[0] += num;

    	    // Carry
    	    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
    	      this.words[i] -= 0x4000000;
    	      if (i === this.length - 1) {
    	        this.words[i + 1] = 1;
    	      } else {
    	        this.words[i + 1]++;
    	      }
    	    }
    	    this.length = Math.max(this.length, i + 1);

    	    return this;
    	  };

    	  // Subtract plain number `num` from `this`
    	  BN.prototype.isubn = function isubn (num) {
    	    assert(typeof num === 'number');
    	    assert(num < 0x4000000);
    	    if (num < 0) return this.iaddn(-num);

    	    if (this.negative !== 0) {
    	      this.negative = 0;
    	      this.iaddn(num);
    	      this.negative = 1;
    	      return this;
    	    }

    	    this.words[0] -= num;

    	    if (this.length === 1 && this.words[0] < 0) {
    	      this.words[0] = -this.words[0];
    	      this.negative = 1;
    	    } else {
    	      // Carry
    	      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
    	        this.words[i] += 0x4000000;
    	        this.words[i + 1] -= 1;
    	      }
    	    }

    	    return this.strip();
    	  };

    	  BN.prototype.addn = function addn (num) {
    	    return this.clone().iaddn(num);
    	  };

    	  BN.prototype.subn = function subn (num) {
    	    return this.clone().isubn(num);
    	  };

    	  BN.prototype.iabs = function iabs () {
    	    this.negative = 0;

    	    return this;
    	  };

    	  BN.prototype.abs = function abs () {
    	    return this.clone().iabs();
    	  };

    	  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    	    var len = num.length + shift;
    	    var i;

    	    this._expand(len);

    	    var w;
    	    var carry = 0;
    	    for (i = 0; i < num.length; i++) {
    	      w = (this.words[i + shift] | 0) + carry;
    	      var right = (num.words[i] | 0) * mul;
    	      w -= right & 0x3ffffff;
    	      carry = (w >> 26) - ((right / 0x4000000) | 0);
    	      this.words[i + shift] = w & 0x3ffffff;
    	    }
    	    for (; i < this.length - shift; i++) {
    	      w = (this.words[i + shift] | 0) + carry;
    	      carry = w >> 26;
    	      this.words[i + shift] = w & 0x3ffffff;
    	    }

    	    if (carry === 0) return this.strip();

    	    // Subtraction overflow
    	    assert(carry === -1);
    	    carry = 0;
    	    for (i = 0; i < this.length; i++) {
    	      w = -(this.words[i] | 0) + carry;
    	      carry = w >> 26;
    	      this.words[i] = w & 0x3ffffff;
    	    }
    	    this.negative = 1;

    	    return this.strip();
    	  };

    	  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    	    var shift = this.length - num.length;

    	    var a = this.clone();
    	    var b = num;

    	    // Normalize
    	    var bhi = b.words[b.length - 1] | 0;
    	    var bhiBits = this._countBits(bhi);
    	    shift = 26 - bhiBits;
    	    if (shift !== 0) {
    	      b = b.ushln(shift);
    	      a.iushln(shift);
    	      bhi = b.words[b.length - 1] | 0;
    	    }

    	    // Initialize quotient
    	    var m = a.length - b.length;
    	    var q;

    	    if (mode !== 'mod') {
    	      q = new BN(null);
    	      q.length = m + 1;
    	      q.words = new Array(q.length);
    	      for (var i = 0; i < q.length; i++) {
    	        q.words[i] = 0;
    	      }
    	    }

    	    var diff = a.clone()._ishlnsubmul(b, 1, m);
    	    if (diff.negative === 0) {
    	      a = diff;
    	      if (q) {
    	        q.words[m] = 1;
    	      }
    	    }

    	    for (var j = m - 1; j >= 0; j--) {
    	      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
    	        (a.words[b.length + j - 1] | 0);

    	      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
    	      // (0x7ffffff)
    	      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

    	      a._ishlnsubmul(b, qj, j);
    	      while (a.negative !== 0) {
    	        qj--;
    	        a.negative = 0;
    	        a._ishlnsubmul(b, 1, j);
    	        if (!a.isZero()) {
    	          a.negative ^= 1;
    	        }
    	      }
    	      if (q) {
    	        q.words[j] = qj;
    	      }
    	    }
    	    if (q) {
    	      q.strip();
    	    }
    	    a.strip();

    	    // Denormalize
    	    if (mode !== 'div' && shift !== 0) {
    	      a.iushrn(shift);
    	    }

    	    return {
    	      div: q || null,
    	      mod: a
    	    };
    	  };

    	  // NOTE: 1) `mode` can be set to `mod` to request mod only,
    	  //       to `div` to request div only, or be absent to
    	  //       request both div & mod
    	  //       2) `positive` is true if unsigned mod is requested
    	  BN.prototype.divmod = function divmod (num, mode, positive) {
    	    assert(!num.isZero());

    	    if (this.isZero()) {
    	      return {
    	        div: new BN(0),
    	        mod: new BN(0)
    	      };
    	    }

    	    var div, mod, res;
    	    if (this.negative !== 0 && num.negative === 0) {
    	      res = this.neg().divmod(num, mode);

    	      if (mode !== 'mod') {
    	        div = res.div.neg();
    	      }

    	      if (mode !== 'div') {
    	        mod = res.mod.neg();
    	        if (positive && mod.negative !== 0) {
    	          mod.iadd(num);
    	        }
    	      }

    	      return {
    	        div: div,
    	        mod: mod
    	      };
    	    }

    	    if (this.negative === 0 && num.negative !== 0) {
    	      res = this.divmod(num.neg(), mode);

    	      if (mode !== 'mod') {
    	        div = res.div.neg();
    	      }

    	      return {
    	        div: div,
    	        mod: res.mod
    	      };
    	    }

    	    if ((this.negative & num.negative) !== 0) {
    	      res = this.neg().divmod(num.neg(), mode);

    	      if (mode !== 'div') {
    	        mod = res.mod.neg();
    	        if (positive && mod.negative !== 0) {
    	          mod.isub(num);
    	        }
    	      }

    	      return {
    	        div: res.div,
    	        mod: mod
    	      };
    	    }

    	    // Both numbers are positive at this point

    	    // Strip both numbers to approximate shift value
    	    if (num.length > this.length || this.cmp(num) < 0) {
    	      return {
    	        div: new BN(0),
    	        mod: this
    	      };
    	    }

    	    // Very short reduction
    	    if (num.length === 1) {
    	      if (mode === 'div') {
    	        return {
    	          div: this.divn(num.words[0]),
    	          mod: null
    	        };
    	      }

    	      if (mode === 'mod') {
    	        return {
    	          div: null,
    	          mod: new BN(this.modn(num.words[0]))
    	        };
    	      }

    	      return {
    	        div: this.divn(num.words[0]),
    	        mod: new BN(this.modn(num.words[0]))
    	      };
    	    }

    	    return this._wordDiv(num, mode);
    	  };

    	  // Find `this` / `num`
    	  BN.prototype.div = function div (num) {
    	    return this.divmod(num, 'div', false).div;
    	  };

    	  // Find `this` % `num`
    	  BN.prototype.mod = function mod (num) {
    	    return this.divmod(num, 'mod', false).mod;
    	  };

    	  BN.prototype.umod = function umod (num) {
    	    return this.divmod(num, 'mod', true).mod;
    	  };

    	  // Find Round(`this` / `num`)
    	  BN.prototype.divRound = function divRound (num) {
    	    var dm = this.divmod(num);

    	    // Fast case - exact division
    	    if (dm.mod.isZero()) return dm.div;

    	    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    	    var half = num.ushrn(1);
    	    var r2 = num.andln(1);
    	    var cmp = mod.cmp(half);

    	    // Round down
    	    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    	    // Round up
    	    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    	  };

    	  BN.prototype.modn = function modn (num) {
    	    assert(num <= 0x3ffffff);
    	    var p = (1 << 26) % num;

    	    var acc = 0;
    	    for (var i = this.length - 1; i >= 0; i--) {
    	      acc = (p * acc + (this.words[i] | 0)) % num;
    	    }

    	    return acc;
    	  };

    	  // In-place division by number
    	  BN.prototype.idivn = function idivn (num) {
    	    assert(num <= 0x3ffffff);

    	    var carry = 0;
    	    for (var i = this.length - 1; i >= 0; i--) {
    	      var w = (this.words[i] | 0) + carry * 0x4000000;
    	      this.words[i] = (w / num) | 0;
    	      carry = w % num;
    	    }

    	    return this.strip();
    	  };

    	  BN.prototype.divn = function divn (num) {
    	    return this.clone().idivn(num);
    	  };

    	  BN.prototype.egcd = function egcd (p) {
    	    assert(p.negative === 0);
    	    assert(!p.isZero());

    	    var x = this;
    	    var y = p.clone();

    	    if (x.negative !== 0) {
    	      x = x.umod(p);
    	    } else {
    	      x = x.clone();
    	    }

    	    // A * x + B * y = x
    	    var A = new BN(1);
    	    var B = new BN(0);

    	    // C * x + D * y = y
    	    var C = new BN(0);
    	    var D = new BN(1);

    	    var g = 0;

    	    while (x.isEven() && y.isEven()) {
    	      x.iushrn(1);
    	      y.iushrn(1);
    	      ++g;
    	    }

    	    var yp = y.clone();
    	    var xp = x.clone();

    	    while (!x.isZero()) {
    	      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
    	      if (i > 0) {
    	        x.iushrn(i);
    	        while (i-- > 0) {
    	          if (A.isOdd() || B.isOdd()) {
    	            A.iadd(yp);
    	            B.isub(xp);
    	          }

    	          A.iushrn(1);
    	          B.iushrn(1);
    	        }
    	      }

    	      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
    	      if (j > 0) {
    	        y.iushrn(j);
    	        while (j-- > 0) {
    	          if (C.isOdd() || D.isOdd()) {
    	            C.iadd(yp);
    	            D.isub(xp);
    	          }

    	          C.iushrn(1);
    	          D.iushrn(1);
    	        }
    	      }

    	      if (x.cmp(y) >= 0) {
    	        x.isub(y);
    	        A.isub(C);
    	        B.isub(D);
    	      } else {
    	        y.isub(x);
    	        C.isub(A);
    	        D.isub(B);
    	      }
    	    }

    	    return {
    	      a: C,
    	      b: D,
    	      gcd: y.iushln(g)
    	    };
    	  };

    	  // This is reduced incarnation of the binary EEA
    	  // above, designated to invert members of the
    	  // _prime_ fields F(p) at a maximal speed
    	  BN.prototype._invmp = function _invmp (p) {
    	    assert(p.negative === 0);
    	    assert(!p.isZero());

    	    var a = this;
    	    var b = p.clone();

    	    if (a.negative !== 0) {
    	      a = a.umod(p);
    	    } else {
    	      a = a.clone();
    	    }

    	    var x1 = new BN(1);
    	    var x2 = new BN(0);

    	    var delta = b.clone();

    	    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
    	      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
    	      if (i > 0) {
    	        a.iushrn(i);
    	        while (i-- > 0) {
    	          if (x1.isOdd()) {
    	            x1.iadd(delta);
    	          }

    	          x1.iushrn(1);
    	        }
    	      }

    	      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
    	      if (j > 0) {
    	        b.iushrn(j);
    	        while (j-- > 0) {
    	          if (x2.isOdd()) {
    	            x2.iadd(delta);
    	          }

    	          x2.iushrn(1);
    	        }
    	      }

    	      if (a.cmp(b) >= 0) {
    	        a.isub(b);
    	        x1.isub(x2);
    	      } else {
    	        b.isub(a);
    	        x2.isub(x1);
    	      }
    	    }

    	    var res;
    	    if (a.cmpn(1) === 0) {
    	      res = x1;
    	    } else {
    	      res = x2;
    	    }

    	    if (res.cmpn(0) < 0) {
    	      res.iadd(p);
    	    }

    	    return res;
    	  };

    	  BN.prototype.gcd = function gcd (num) {
    	    if (this.isZero()) return num.abs();
    	    if (num.isZero()) return this.abs();

    	    var a = this.clone();
    	    var b = num.clone();
    	    a.negative = 0;
    	    b.negative = 0;

    	    // Remove common factor of two
    	    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
    	      a.iushrn(1);
    	      b.iushrn(1);
    	    }

    	    do {
    	      while (a.isEven()) {
    	        a.iushrn(1);
    	      }
    	      while (b.isEven()) {
    	        b.iushrn(1);
    	      }

    	      var r = a.cmp(b);
    	      if (r < 0) {
    	        // Swap `a` and `b` to make `a` always bigger than `b`
    	        var t = a;
    	        a = b;
    	        b = t;
    	      } else if (r === 0 || b.cmpn(1) === 0) {
    	        break;
    	      }

    	      a.isub(b);
    	    } while (true);

    	    return b.iushln(shift);
    	  };

    	  // Invert number in the field F(num)
    	  BN.prototype.invm = function invm (num) {
    	    return this.egcd(num).a.umod(num);
    	  };

    	  BN.prototype.isEven = function isEven () {
    	    return (this.words[0] & 1) === 0;
    	  };

    	  BN.prototype.isOdd = function isOdd () {
    	    return (this.words[0] & 1) === 1;
    	  };

    	  // And first word and num
    	  BN.prototype.andln = function andln (num) {
    	    return this.words[0] & num;
    	  };

    	  // Increment at the bit position in-line
    	  BN.prototype.bincn = function bincn (bit) {
    	    assert(typeof bit === 'number');
    	    var r = bit % 26;
    	    var s = (bit - r) / 26;
    	    var q = 1 << r;

    	    // Fast case: bit is much higher than all existing words
    	    if (this.length <= s) {
    	      this._expand(s + 1);
    	      this.words[s] |= q;
    	      return this;
    	    }

    	    // Add bit and propagate, if needed
    	    var carry = q;
    	    for (var i = s; carry !== 0 && i < this.length; i++) {
    	      var w = this.words[i] | 0;
    	      w += carry;
    	      carry = w >>> 26;
    	      w &= 0x3ffffff;
    	      this.words[i] = w;
    	    }
    	    if (carry !== 0) {
    	      this.words[i] = carry;
    	      this.length++;
    	    }
    	    return this;
    	  };

    	  BN.prototype.isZero = function isZero () {
    	    return this.length === 1 && this.words[0] === 0;
    	  };

    	  BN.prototype.cmpn = function cmpn (num) {
    	    var negative = num < 0;

    	    if (this.negative !== 0 && !negative) return -1;
    	    if (this.negative === 0 && negative) return 1;

    	    this.strip();

    	    var res;
    	    if (this.length > 1) {
    	      res = 1;
    	    } else {
    	      if (negative) {
    	        num = -num;
    	      }

    	      assert(num <= 0x3ffffff, 'Number is too big');

    	      var w = this.words[0] | 0;
    	      res = w === num ? 0 : w < num ? -1 : 1;
    	    }
    	    if (this.negative !== 0) return -res | 0;
    	    return res;
    	  };

    	  // Compare two numbers and return:
    	  // 1 - if `this` > `num`
    	  // 0 - if `this` == `num`
    	  // -1 - if `this` < `num`
    	  BN.prototype.cmp = function cmp (num) {
    	    if (this.negative !== 0 && num.negative === 0) return -1;
    	    if (this.negative === 0 && num.negative !== 0) return 1;

    	    var res = this.ucmp(num);
    	    if (this.negative !== 0) return -res | 0;
    	    return res;
    	  };

    	  // Unsigned comparison
    	  BN.prototype.ucmp = function ucmp (num) {
    	    // At this point both numbers have the same sign
    	    if (this.length > num.length) return 1;
    	    if (this.length < num.length) return -1;

    	    var res = 0;
    	    for (var i = this.length - 1; i >= 0; i--) {
    	      var a = this.words[i] | 0;
    	      var b = num.words[i] | 0;

    	      if (a === b) continue;
    	      if (a < b) {
    	        res = -1;
    	      } else if (a > b) {
    	        res = 1;
    	      }
    	      break;
    	    }
    	    return res;
    	  };

    	  BN.prototype.gtn = function gtn (num) {
    	    return this.cmpn(num) === 1;
    	  };

    	  BN.prototype.gt = function gt (num) {
    	    return this.cmp(num) === 1;
    	  };

    	  BN.prototype.gten = function gten (num) {
    	    return this.cmpn(num) >= 0;
    	  };

    	  BN.prototype.gte = function gte (num) {
    	    return this.cmp(num) >= 0;
    	  };

    	  BN.prototype.ltn = function ltn (num) {
    	    return this.cmpn(num) === -1;
    	  };

    	  BN.prototype.lt = function lt (num) {
    	    return this.cmp(num) === -1;
    	  };

    	  BN.prototype.lten = function lten (num) {
    	    return this.cmpn(num) <= 0;
    	  };

    	  BN.prototype.lte = function lte (num) {
    	    return this.cmp(num) <= 0;
    	  };

    	  BN.prototype.eqn = function eqn (num) {
    	    return this.cmpn(num) === 0;
    	  };

    	  BN.prototype.eq = function eq (num) {
    	    return this.cmp(num) === 0;
    	  };

    	  //
    	  // A reduce context, could be using montgomery or something better, depending
    	  // on the `m` itself.
    	  //
    	  BN.red = function red (num) {
    	    return new Red(num);
    	  };

    	  BN.prototype.toRed = function toRed (ctx) {
    	    assert(!this.red, 'Already a number in reduction context');
    	    assert(this.negative === 0, 'red works only with positives');
    	    return ctx.convertTo(this)._forceRed(ctx);
    	  };

    	  BN.prototype.fromRed = function fromRed () {
    	    assert(this.red, 'fromRed works only with numbers in reduction context');
    	    return this.red.convertFrom(this);
    	  };

    	  BN.prototype._forceRed = function _forceRed (ctx) {
    	    this.red = ctx;
    	    return this;
    	  };

    	  BN.prototype.forceRed = function forceRed (ctx) {
    	    assert(!this.red, 'Already a number in reduction context');
    	    return this._forceRed(ctx);
    	  };

    	  BN.prototype.redAdd = function redAdd (num) {
    	    assert(this.red, 'redAdd works only with red numbers');
    	    return this.red.add(this, num);
    	  };

    	  BN.prototype.redIAdd = function redIAdd (num) {
    	    assert(this.red, 'redIAdd works only with red numbers');
    	    return this.red.iadd(this, num);
    	  };

    	  BN.prototype.redSub = function redSub (num) {
    	    assert(this.red, 'redSub works only with red numbers');
    	    return this.red.sub(this, num);
    	  };

    	  BN.prototype.redISub = function redISub (num) {
    	    assert(this.red, 'redISub works only with red numbers');
    	    return this.red.isub(this, num);
    	  };

    	  BN.prototype.redShl = function redShl (num) {
    	    assert(this.red, 'redShl works only with red numbers');
    	    return this.red.shl(this, num);
    	  };

    	  BN.prototype.redMul = function redMul (num) {
    	    assert(this.red, 'redMul works only with red numbers');
    	    this.red._verify2(this, num);
    	    return this.red.mul(this, num);
    	  };

    	  BN.prototype.redIMul = function redIMul (num) {
    	    assert(this.red, 'redMul works only with red numbers');
    	    this.red._verify2(this, num);
    	    return this.red.imul(this, num);
    	  };

    	  BN.prototype.redSqr = function redSqr () {
    	    assert(this.red, 'redSqr works only with red numbers');
    	    this.red._verify1(this);
    	    return this.red.sqr(this);
    	  };

    	  BN.prototype.redISqr = function redISqr () {
    	    assert(this.red, 'redISqr works only with red numbers');
    	    this.red._verify1(this);
    	    return this.red.isqr(this);
    	  };

    	  // Square root over p
    	  BN.prototype.redSqrt = function redSqrt () {
    	    assert(this.red, 'redSqrt works only with red numbers');
    	    this.red._verify1(this);
    	    return this.red.sqrt(this);
    	  };

    	  BN.prototype.redInvm = function redInvm () {
    	    assert(this.red, 'redInvm works only with red numbers');
    	    this.red._verify1(this);
    	    return this.red.invm(this);
    	  };

    	  // Return negative clone of `this` % `red modulo`
    	  BN.prototype.redNeg = function redNeg () {
    	    assert(this.red, 'redNeg works only with red numbers');
    	    this.red._verify1(this);
    	    return this.red.neg(this);
    	  };

    	  BN.prototype.redPow = function redPow (num) {
    	    assert(this.red && !num.red, 'redPow(normalNum)');
    	    this.red._verify1(this);
    	    return this.red.pow(this, num);
    	  };

    	  // Prime numbers with efficient reduction
    	  var primes = {
    	    k256: null,
    	    p224: null,
    	    p192: null,
    	    p25519: null
    	  };

    	  // Pseudo-Mersenne prime
    	  function MPrime (name, p) {
    	    // P = 2 ^ N - K
    	    this.name = name;
    	    this.p = new BN(p, 16);
    	    this.n = this.p.bitLength();
    	    this.k = new BN(1).iushln(this.n).isub(this.p);

    	    this.tmp = this._tmp();
    	  }

    	  MPrime.prototype._tmp = function _tmp () {
    	    var tmp = new BN(null);
    	    tmp.words = new Array(Math.ceil(this.n / 13));
    	    return tmp;
    	  };

    	  MPrime.prototype.ireduce = function ireduce (num) {
    	    // Assumes that `num` is less than `P^2`
    	    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    	    var r = num;
    	    var rlen;

    	    do {
    	      this.split(r, this.tmp);
    	      r = this.imulK(r);
    	      r = r.iadd(this.tmp);
    	      rlen = r.bitLength();
    	    } while (rlen > this.n);

    	    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    	    if (cmp === 0) {
    	      r.words[0] = 0;
    	      r.length = 1;
    	    } else if (cmp > 0) {
    	      r.isub(this.p);
    	    } else {
    	      if (r.strip !== undefined) {
    	        // r is BN v4 instance
    	        r.strip();
    	      } else {
    	        // r is BN v5 instance
    	        r._strip();
    	      }
    	    }

    	    return r;
    	  };

    	  MPrime.prototype.split = function split (input, out) {
    	    input.iushrn(this.n, 0, out);
    	  };

    	  MPrime.prototype.imulK = function imulK (num) {
    	    return num.imul(this.k);
    	  };

    	  function K256 () {
    	    MPrime.call(
    	      this,
    	      'k256',
    	      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    	  }
    	  inherits(K256, MPrime);

    	  K256.prototype.split = function split (input, output) {
    	    // 256 = 9 * 26 + 22
    	    var mask = 0x3fffff;

    	    var outLen = Math.min(input.length, 9);
    	    for (var i = 0; i < outLen; i++) {
    	      output.words[i] = input.words[i];
    	    }
    	    output.length = outLen;

    	    if (input.length <= 9) {
    	      input.words[0] = 0;
    	      input.length = 1;
    	      return;
    	    }

    	    // Shift by 9 limbs
    	    var prev = input.words[9];
    	    output.words[output.length++] = prev & mask;

    	    for (i = 10; i < input.length; i++) {
    	      var next = input.words[i] | 0;
    	      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
    	      prev = next;
    	    }
    	    prev >>>= 22;
    	    input.words[i - 10] = prev;
    	    if (prev === 0 && input.length > 10) {
    	      input.length -= 10;
    	    } else {
    	      input.length -= 9;
    	    }
    	  };

    	  K256.prototype.imulK = function imulK (num) {
    	    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    	    num.words[num.length] = 0;
    	    num.words[num.length + 1] = 0;
    	    num.length += 2;

    	    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    	    var lo = 0;
    	    for (var i = 0; i < num.length; i++) {
    	      var w = num.words[i] | 0;
    	      lo += w * 0x3d1;
    	      num.words[i] = lo & 0x3ffffff;
    	      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    	    }

    	    // Fast length reduction
    	    if (num.words[num.length - 1] === 0) {
    	      num.length--;
    	      if (num.words[num.length - 1] === 0) {
    	        num.length--;
    	      }
    	    }
    	    return num;
    	  };

    	  function P224 () {
    	    MPrime.call(
    	      this,
    	      'p224',
    	      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    	  }
    	  inherits(P224, MPrime);

    	  function P192 () {
    	    MPrime.call(
    	      this,
    	      'p192',
    	      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    	  }
    	  inherits(P192, MPrime);

    	  function P25519 () {
    	    // 2 ^ 255 - 19
    	    MPrime.call(
    	      this,
    	      '25519',
    	      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    	  }
    	  inherits(P25519, MPrime);

    	  P25519.prototype.imulK = function imulK (num) {
    	    // K = 0x13
    	    var carry = 0;
    	    for (var i = 0; i < num.length; i++) {
    	      var hi = (num.words[i] | 0) * 0x13 + carry;
    	      var lo = hi & 0x3ffffff;
    	      hi >>>= 26;

    	      num.words[i] = lo;
    	      carry = hi;
    	    }
    	    if (carry !== 0) {
    	      num.words[num.length++] = carry;
    	    }
    	    return num;
    	  };

    	  // Exported mostly for testing purposes, use plain name instead
    	  BN._prime = function prime (name) {
    	    // Cached version of prime
    	    if (primes[name]) return primes[name];

    	    var prime;
    	    if (name === 'k256') {
    	      prime = new K256();
    	    } else if (name === 'p224') {
    	      prime = new P224();
    	    } else if (name === 'p192') {
    	      prime = new P192();
    	    } else if (name === 'p25519') {
    	      prime = new P25519();
    	    } else {
    	      throw new Error('Unknown prime ' + name);
    	    }
    	    primes[name] = prime;

    	    return prime;
    	  };

    	  //
    	  // Base reduction engine
    	  //
    	  function Red (m) {
    	    if (typeof m === 'string') {
    	      var prime = BN._prime(m);
    	      this.m = prime.p;
    	      this.prime = prime;
    	    } else {
    	      assert(m.gtn(1), 'modulus must be greater than 1');
    	      this.m = m;
    	      this.prime = null;
    	    }
    	  }

    	  Red.prototype._verify1 = function _verify1 (a) {
    	    assert(a.negative === 0, 'red works only with positives');
    	    assert(a.red, 'red works only with red numbers');
    	  };

    	  Red.prototype._verify2 = function _verify2 (a, b) {
    	    assert((a.negative | b.negative) === 0, 'red works only with positives');
    	    assert(a.red && a.red === b.red,
    	      'red works only with red numbers');
    	  };

    	  Red.prototype.imod = function imod (a) {
    	    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    	    return a.umod(this.m)._forceRed(this);
    	  };

    	  Red.prototype.neg = function neg (a) {
    	    if (a.isZero()) {
    	      return a.clone();
    	    }

    	    return this.m.sub(a)._forceRed(this);
    	  };

    	  Red.prototype.add = function add (a, b) {
    	    this._verify2(a, b);

    	    var res = a.add(b);
    	    if (res.cmp(this.m) >= 0) {
    	      res.isub(this.m);
    	    }
    	    return res._forceRed(this);
    	  };

    	  Red.prototype.iadd = function iadd (a, b) {
    	    this._verify2(a, b);

    	    var res = a.iadd(b);
    	    if (res.cmp(this.m) >= 0) {
    	      res.isub(this.m);
    	    }
    	    return res;
    	  };

    	  Red.prototype.sub = function sub (a, b) {
    	    this._verify2(a, b);

    	    var res = a.sub(b);
    	    if (res.cmpn(0) < 0) {
    	      res.iadd(this.m);
    	    }
    	    return res._forceRed(this);
    	  };

    	  Red.prototype.isub = function isub (a, b) {
    	    this._verify2(a, b);

    	    var res = a.isub(b);
    	    if (res.cmpn(0) < 0) {
    	      res.iadd(this.m);
    	    }
    	    return res;
    	  };

    	  Red.prototype.shl = function shl (a, num) {
    	    this._verify1(a);
    	    return this.imod(a.ushln(num));
    	  };

    	  Red.prototype.imul = function imul (a, b) {
    	    this._verify2(a, b);
    	    return this.imod(a.imul(b));
    	  };

    	  Red.prototype.mul = function mul (a, b) {
    	    this._verify2(a, b);
    	    return this.imod(a.mul(b));
    	  };

    	  Red.prototype.isqr = function isqr (a) {
    	    return this.imul(a, a.clone());
    	  };

    	  Red.prototype.sqr = function sqr (a) {
    	    return this.mul(a, a);
    	  };

    	  Red.prototype.sqrt = function sqrt (a) {
    	    if (a.isZero()) return a.clone();

    	    var mod3 = this.m.andln(3);
    	    assert(mod3 % 2 === 1);

    	    // Fast case
    	    if (mod3 === 3) {
    	      var pow = this.m.add(new BN(1)).iushrn(2);
    	      return this.pow(a, pow);
    	    }

    	    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    	    //
    	    // Find Q and S, that Q * 2 ^ S = (P - 1)
    	    var q = this.m.subn(1);
    	    var s = 0;
    	    while (!q.isZero() && q.andln(1) === 0) {
    	      s++;
    	      q.iushrn(1);
    	    }
    	    assert(!q.isZero());

    	    var one = new BN(1).toRed(this);
    	    var nOne = one.redNeg();

    	    // Find quadratic non-residue
    	    // NOTE: Max is such because of generalized Riemann hypothesis.
    	    var lpow = this.m.subn(1).iushrn(1);
    	    var z = this.m.bitLength();
    	    z = new BN(2 * z * z).toRed(this);

    	    while (this.pow(z, lpow).cmp(nOne) !== 0) {
    	      z.redIAdd(nOne);
    	    }

    	    var c = this.pow(z, q);
    	    var r = this.pow(a, q.addn(1).iushrn(1));
    	    var t = this.pow(a, q);
    	    var m = s;
    	    while (t.cmp(one) !== 0) {
    	      var tmp = t;
    	      for (var i = 0; tmp.cmp(one) !== 0; i++) {
    	        tmp = tmp.redSqr();
    	      }
    	      assert(i < m);
    	      var b = this.pow(c, new BN(1).iushln(m - i - 1));

    	      r = r.redMul(b);
    	      c = b.redSqr();
    	      t = t.redMul(c);
    	      m = i;
    	    }

    	    return r;
    	  };

    	  Red.prototype.invm = function invm (a) {
    	    var inv = a._invmp(this.m);
    	    if (inv.negative !== 0) {
    	      inv.negative = 0;
    	      return this.imod(inv).redNeg();
    	    } else {
    	      return this.imod(inv);
    	    }
    	  };

    	  Red.prototype.pow = function pow (a, num) {
    	    if (num.isZero()) return new BN(1).toRed(this);
    	    if (num.cmpn(1) === 0) return a.clone();

    	    var windowSize = 4;
    	    var wnd = new Array(1 << windowSize);
    	    wnd[0] = new BN(1).toRed(this);
    	    wnd[1] = a;
    	    for (var i = 2; i < wnd.length; i++) {
    	      wnd[i] = this.mul(wnd[i - 1], a);
    	    }

    	    var res = wnd[0];
    	    var current = 0;
    	    var currentLen = 0;
    	    var start = num.bitLength() % 26;
    	    if (start === 0) {
    	      start = 26;
    	    }

    	    for (i = num.length - 1; i >= 0; i--) {
    	      var word = num.words[i];
    	      for (var j = start - 1; j >= 0; j--) {
    	        var bit = (word >> j) & 1;
    	        if (res !== wnd[0]) {
    	          res = this.sqr(res);
    	        }

    	        if (bit === 0 && current === 0) {
    	          currentLen = 0;
    	          continue;
    	        }

    	        current <<= 1;
    	        current |= bit;
    	        currentLen++;
    	        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

    	        res = this.mul(res, wnd[current]);
    	        currentLen = 0;
    	        current = 0;
    	      }
    	      start = 26;
    	    }

    	    return res;
    	  };

    	  Red.prototype.convertTo = function convertTo (num) {
    	    var r = num.umod(this.m);

    	    return r === num ? r.clone() : r;
    	  };

    	  Red.prototype.convertFrom = function convertFrom (num) {
    	    var res = num.clone();
    	    res.red = null;
    	    return res;
    	  };

    	  //
    	  // Montgomery method engine
    	  //

    	  BN.mont = function mont (num) {
    	    return new Mont(num);
    	  };

    	  function Mont (m) {
    	    Red.call(this, m);

    	    this.shift = this.m.bitLength();
    	    if (this.shift % 26 !== 0) {
    	      this.shift += 26 - (this.shift % 26);
    	    }

    	    this.r = new BN(1).iushln(this.shift);
    	    this.r2 = this.imod(this.r.sqr());
    	    this.rinv = this.r._invmp(this.m);

    	    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    	    this.minv = this.minv.umod(this.r);
    	    this.minv = this.r.sub(this.minv);
    	  }
    	  inherits(Mont, Red);

    	  Mont.prototype.convertTo = function convertTo (num) {
    	    return this.imod(num.ushln(this.shift));
    	  };

    	  Mont.prototype.convertFrom = function convertFrom (num) {
    	    var r = this.imod(num.mul(this.rinv));
    	    r.red = null;
    	    return r;
    	  };

    	  Mont.prototype.imul = function imul (a, b) {
    	    if (a.isZero() || b.isZero()) {
    	      a.words[0] = 0;
    	      a.length = 1;
    	      return a;
    	    }

    	    var t = a.imul(b);
    	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    	    var u = t.isub(c).iushrn(this.shift);
    	    var res = u;

    	    if (u.cmp(this.m) >= 0) {
    	      res = u.isub(this.m);
    	    } else if (u.cmpn(0) < 0) {
    	      res = u.iadd(this.m);
    	    }

    	    return res._forceRed(this);
    	  };

    	  Mont.prototype.mul = function mul (a, b) {
    	    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    	    var t = a.mul(b);
    	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    	    var u = t.isub(c).iushrn(this.shift);
    	    var res = u;
    	    if (u.cmp(this.m) >= 0) {
    	      res = u.isub(this.m);
    	    } else if (u.cmpn(0) < 0) {
    	      res = u.iadd(this.m);
    	    }

    	    return res._forceRed(this);
    	  };

    	  Mont.prototype.invm = function invm (a) {
    	    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    	    var res = this.imod(a._invmp(this.m).mul(this.r2));
    	    return res._forceRed(this);
    	  };
    	})(module, commonjsGlobal); 
    } (bn));

    var bnExports = bn.exports;

    var elliptic$1 = {};

    var name = "elliptic";
    var version = "6.5.4";
    var description = "EC cryptography";
    var main = "lib/elliptic.js";
    var files = [
    	"lib"
    ];
    var scripts = {
    	lint: "eslint lib test",
    	"lint:fix": "npm run lint -- --fix",
    	unit: "istanbul test _mocha --reporter=spec test/index.js",
    	test: "npm run lint && npm run unit",
    	version: "grunt dist && git add dist/"
    };
    var repository = {
    	type: "git",
    	url: "git@github.com:indutny/elliptic"
    };
    var keywords = [
    	"EC",
    	"Elliptic",
    	"curve",
    	"Cryptography"
    ];
    var author = "Fedor Indutny <fedor@indutny.com>";
    var license = "MIT";
    var bugs = {
    	url: "https://github.com/indutny/elliptic/issues"
    };
    var homepage = "https://github.com/indutny/elliptic";
    var devDependencies = {
    	brfs: "^2.0.2",
    	coveralls: "^3.1.0",
    	eslint: "^7.6.0",
    	grunt: "^1.2.1",
    	"grunt-browserify": "^5.3.0",
    	"grunt-cli": "^1.3.2",
    	"grunt-contrib-connect": "^3.0.0",
    	"grunt-contrib-copy": "^1.0.0",
    	"grunt-contrib-uglify": "^5.0.0",
    	"grunt-mocha-istanbul": "^5.0.2",
    	"grunt-saucelabs": "^9.0.1",
    	istanbul: "^0.4.5",
    	mocha: "^8.0.1"
    };
    var dependencies = {
    	"bn.js": "^4.11.9",
    	brorand: "^1.1.0",
    	"hash.js": "^1.0.0",
    	"hmac-drbg": "^1.0.1",
    	inherits: "^2.0.4",
    	"minimalistic-assert": "^1.0.1",
    	"minimalistic-crypto-utils": "^1.0.1"
    };
    var require$$0 = {
    	name: name,
    	version: version,
    	description: description,
    	main: main,
    	files: files,
    	scripts: scripts,
    	repository: repository,
    	keywords: keywords,
    	author: author,
    	license: license,
    	bugs: bugs,
    	homepage: homepage,
    	devDependencies: devDependencies,
    	dependencies: dependencies
    };

    var utils$m = {};

    var minimalisticAssert = assert$g;

    function assert$g(val, msg) {
      if (!val)
        throw new Error(msg || 'Assertion failed');
    }

    assert$g.equal = function assertEqual(l, r, msg) {
      if (l != r)
        throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
    };

    var utils$l = {};

    (function (exports) {

    	var utils = exports;

    	function toArray(msg, enc) {
    	  if (Array.isArray(msg))
    	    return msg.slice();
    	  if (!msg)
    	    return [];
    	  var res = [];
    	  if (typeof msg !== 'string') {
    	    for (var i = 0; i < msg.length; i++)
    	      res[i] = msg[i] | 0;
    	    return res;
    	  }
    	  if (enc === 'hex') {
    	    msg = msg.replace(/[^a-z0-9]+/ig, '');
    	    if (msg.length % 2 !== 0)
    	      msg = '0' + msg;
    	    for (var i = 0; i < msg.length; i += 2)
    	      res.push(parseInt(msg[i] + msg[i + 1], 16));
    	  } else {
    	    for (var i = 0; i < msg.length; i++) {
    	      var c = msg.charCodeAt(i);
    	      var hi = c >> 8;
    	      var lo = c & 0xff;
    	      if (hi)
    	        res.push(hi, lo);
    	      else
    	        res.push(lo);
    	    }
    	  }
    	  return res;
    	}
    	utils.toArray = toArray;

    	function zero2(word) {
    	  if (word.length === 1)
    	    return '0' + word;
    	  else
    	    return word;
    	}
    	utils.zero2 = zero2;

    	function toHex(msg) {
    	  var res = '';
    	  for (var i = 0; i < msg.length; i++)
    	    res += zero2(msg[i].toString(16));
    	  return res;
    	}
    	utils.toHex = toHex;

    	utils.encode = function encode(arr, enc) {
    	  if (enc === 'hex')
    	    return toHex(arr);
    	  else
    	    return arr;
    	}; 
    } (utils$l));

    (function (exports) {

    	var utils = exports;
    	var BN = bnExports;
    	var minAssert = minimalisticAssert;
    	var minUtils = utils$l;

    	utils.assert = minAssert;
    	utils.toArray = minUtils.toArray;
    	utils.zero2 = minUtils.zero2;
    	utils.toHex = minUtils.toHex;
    	utils.encode = minUtils.encode;

    	// Represent num in a w-NAF form
    	function getNAF(num, w, bits) {
    	  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    	  naf.fill(0);

    	  var ws = 1 << (w + 1);
    	  var k = num.clone();

    	  for (var i = 0; i < naf.length; i++) {
    	    var z;
    	    var mod = k.andln(ws - 1);
    	    if (k.isOdd()) {
    	      if (mod > (ws >> 1) - 1)
    	        z = (ws >> 1) - mod;
    	      else
    	        z = mod;
    	      k.isubn(z);
    	    } else {
    	      z = 0;
    	    }

    	    naf[i] = z;
    	    k.iushrn(1);
    	  }

    	  return naf;
    	}
    	utils.getNAF = getNAF;

    	// Represent k1, k2 in a Joint Sparse Form
    	function getJSF(k1, k2) {
    	  var jsf = [
    	    [],
    	    [],
    	  ];

    	  k1 = k1.clone();
    	  k2 = k2.clone();
    	  var d1 = 0;
    	  var d2 = 0;
    	  var m8;
    	  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
    	    // First phase
    	    var m14 = (k1.andln(3) + d1) & 3;
    	    var m24 = (k2.andln(3) + d2) & 3;
    	    if (m14 === 3)
    	      m14 = -1;
    	    if (m24 === 3)
    	      m24 = -1;
    	    var u1;
    	    if ((m14 & 1) === 0) {
    	      u1 = 0;
    	    } else {
    	      m8 = (k1.andln(7) + d1) & 7;
    	      if ((m8 === 3 || m8 === 5) && m24 === 2)
    	        u1 = -m14;
    	      else
    	        u1 = m14;
    	    }
    	    jsf[0].push(u1);

    	    var u2;
    	    if ((m24 & 1) === 0) {
    	      u2 = 0;
    	    } else {
    	      m8 = (k2.andln(7) + d2) & 7;
    	      if ((m8 === 3 || m8 === 5) && m14 === 2)
    	        u2 = -m24;
    	      else
    	        u2 = m24;
    	    }
    	    jsf[1].push(u2);

    	    // Second phase
    	    if (2 * d1 === u1 + 1)
    	      d1 = 1 - d1;
    	    if (2 * d2 === u2 + 1)
    	      d2 = 1 - d2;
    	    k1.iushrn(1);
    	    k2.iushrn(1);
    	  }

    	  return jsf;
    	}
    	utils.getJSF = getJSF;

    	function cachedProperty(obj, name, computer) {
    	  var key = '_' + name;
    	  obj.prototype[name] = function cachedProperty() {
    	    return this[key] !== undefined ? this[key] :
    	      this[key] = computer.call(this);
    	  };
    	}
    	utils.cachedProperty = cachedProperty;

    	function parseBytes(bytes) {
    	  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
    	    bytes;
    	}
    	utils.parseBytes = parseBytes;

    	function intFromLE(bytes) {
    	  return new BN(bytes, 'hex', 'le');
    	}
    	utils.intFromLE = intFromLE; 
    } (utils$m));

    var brorand = {exports: {}};

    var r$1;

    brorand.exports = function rand(len) {
      if (!r$1)
        r$1 = new Rand(null);

      return r$1.generate(len);
    };

    function Rand(rand) {
      this.rand = rand;
    }
    brorand.exports.Rand = Rand;

    Rand.prototype.generate = function generate(len) {
      return this._rand(len);
    };

    // Emulate crypto API using randy
    Rand.prototype._rand = function _rand(n) {
      if (this.rand.getBytes)
        return this.rand.getBytes(n);

      var res = new Uint8Array(n);
      for (var i = 0; i < res.length; i++)
        res[i] = this.rand.getByte();
      return res;
    };

    if (typeof self === 'object') {
      if (self.crypto && self.crypto.getRandomValues) {
        // Modern browsers
        Rand.prototype._rand = function _rand(n) {
          var arr = new Uint8Array(n);
          self.crypto.getRandomValues(arr);
          return arr;
        };
      } else if (self.msCrypto && self.msCrypto.getRandomValues) {
        // IE
        Rand.prototype._rand = function _rand(n) {
          var arr = new Uint8Array(n);
          self.msCrypto.getRandomValues(arr);
          return arr;
        };

      // Safari's WebWorkers do not have `crypto`
      } else if (typeof window === 'object') {
        // Old junk
        Rand.prototype._rand = function() {
          throw new Error('Not implemented yet');
        };
      }
    } else {
      // Node.js or Web worker with no crypto support
      try {
        var crypto$2 = require$$2;
        if (typeof crypto$2.randomBytes !== 'function')
          throw new Error('Not supported');

        Rand.prototype._rand = function _rand(n) {
          return crypto$2.randomBytes(n);
        };
      } catch (e) {
      }
    }

    var brorandExports = brorand.exports;

    var curve = {};

    var BN$7 = bnExports;
    var utils$k = utils$m;
    var getNAF = utils$k.getNAF;
    var getJSF = utils$k.getJSF;
    var assert$f = utils$k.assert;

    function BaseCurve(type, conf) {
      this.type = type;
      this.p = new BN$7(conf.p, 16);

      // Use Montgomery, when there is no fast reduction for the prime
      this.red = conf.prime ? BN$7.red(conf.prime) : BN$7.mont(this.p);

      // Useful for many curves
      this.zero = new BN$7(0).toRed(this.red);
      this.one = new BN$7(1).toRed(this.red);
      this.two = new BN$7(2).toRed(this.red);

      // Curve configuration, optional
      this.n = conf.n && new BN$7(conf.n, 16);
      this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

      // Temporary arrays
      this._wnafT1 = new Array(4);
      this._wnafT2 = new Array(4);
      this._wnafT3 = new Array(4);
      this._wnafT4 = new Array(4);

      this._bitLength = this.n ? this.n.bitLength() : 0;

      // Generalized Greg Maxwell's trick
      var adjustCount = this.n && this.p.div(this.n);
      if (!adjustCount || adjustCount.cmpn(100) > 0) {
        this.redN = null;
      } else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
      }
    }
    var base = BaseCurve;

    BaseCurve.prototype.point = function point() {
      throw new Error('Not implemented');
    };

    BaseCurve.prototype.validate = function validate() {
      throw new Error('Not implemented');
    };

    BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
      assert$f(p.precomputed);
      var doubles = p._getDoubles();

      var naf = getNAF(k, 1, this._bitLength);
      var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
      I /= 3;

      // Translate into more windowed form
      var repr = [];
      var j;
      var nafW;
      for (j = 0; j < naf.length; j += doubles.step) {
        nafW = 0;
        for (var l = j + doubles.step - 1; l >= j; l--)
          nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
      }

      var a = this.jpoint(null, null, null);
      var b = this.jpoint(null, null, null);
      for (var i = I; i > 0; i--) {
        for (j = 0; j < repr.length; j++) {
          nafW = repr[j];
          if (nafW === i)
            b = b.mixedAdd(doubles.points[j]);
          else if (nafW === -i)
            b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
      }
      return a.toP();
    };

    BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
      var w = 4;

      // Precompute window
      var nafPoints = p._getNAFPoints(w);
      w = nafPoints.wnd;
      var wnd = nafPoints.points;

      // Get NAF form
      var naf = getNAF(k, w, this._bitLength);

      // Add `this`*(N+1) for every w-NAF index
      var acc = this.jpoint(null, null, null);
      for (var i = naf.length - 1; i >= 0; i--) {
        // Count zeroes
        for (var l = 0; i >= 0 && naf[i] === 0; i--)
          l++;
        if (i >= 0)
          l++;
        acc = acc.dblp(l);

        if (i < 0)
          break;
        var z = naf[i];
        assert$f(z !== 0);
        if (p.type === 'affine') {
          // J +- P
          if (z > 0)
            acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
          else
            acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
        } else {
          // J +- J
          if (z > 0)
            acc = acc.add(wnd[(z - 1) >> 1]);
          else
            acc = acc.add(wnd[(-z - 1) >> 1].neg());
        }
      }
      return p.type === 'affine' ? acc.toP() : acc;
    };

    BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
      points,
      coeffs,
      len,
      jacobianResult) {
      var wndWidth = this._wnafT1;
      var wnd = this._wnafT2;
      var naf = this._wnafT3;

      // Fill all arrays
      var max = 0;
      var i;
      var j;
      var p;
      for (i = 0; i < len; i++) {
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
      }

      // Comb small window NAFs
      for (i = len - 1; i >= 1; i -= 2) {
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
          naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
          naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
          max = Math.max(naf[a].length, max);
          max = Math.max(naf[b].length, max);
          continue;
        }

        var comb = [
          points[a], /* 1 */
          null, /* 3 */
          null, /* 5 */
          points[b], /* 7 */
        ];

        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
          comb[1] = points[a].add(points[b]);
          comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
          comb[1] = points[a].toJ().mixedAdd(points[b]);
          comb[2] = points[a].add(points[b].neg());
        } else {
          comb[1] = points[a].toJ().mixedAdd(points[b]);
          comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }

        var index = [
          -3, /* -1 -1 */
          -1, /* -1 0 */
          -5, /* -1 1 */
          -7, /* 0 -1 */
          0, /* 0 0 */
          7, /* 0 1 */
          5, /* 1 -1 */
          1, /* 1 0 */
          3,  /* 1 1 */
        ];

        var jsf = getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for (j = 0; j < max; j++) {
          var ja = jsf[0][j] | 0;
          var jb = jsf[1][j] | 0;

          naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
          naf[b][j] = 0;
          wnd[a] = comb;
        }
      }

      var acc = this.jpoint(null, null, null);
      var tmp = this._wnafT4;
      for (i = max; i >= 0; i--) {
        var k = 0;

        while (i >= 0) {
          var zero = true;
          for (j = 0; j < len; j++) {
            tmp[j] = naf[j][i] | 0;
            if (tmp[j] !== 0)
              zero = false;
          }
          if (!zero)
            break;
          k++;
          i--;
        }
        if (i >= 0)
          k++;
        acc = acc.dblp(k);
        if (i < 0)
          break;

        for (j = 0; j < len; j++) {
          var z = tmp[j];
          if (z === 0)
            continue;
          else if (z > 0)
            p = wnd[j][(z - 1) >> 1];
          else if (z < 0)
            p = wnd[j][(-z - 1) >> 1].neg();

          if (p.type === 'affine')
            acc = acc.mixedAdd(p);
          else
            acc = acc.add(p);
        }
      }
      // Zeroify references
      for (i = 0; i < len; i++)
        wnd[i] = null;

      if (jacobianResult)
        return acc;
      else
        return acc.toP();
    };

    function BasePoint(curve, type) {
      this.curve = curve;
      this.type = type;
      this.precomputed = null;
    }
    BaseCurve.BasePoint = BasePoint;

    BasePoint.prototype.eq = function eq(/*other*/) {
      throw new Error('Not implemented');
    };

    BasePoint.prototype.validate = function validate() {
      return this.curve.validate(this);
    };

    BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
      bytes = utils$k.toArray(bytes, enc);

      var len = this.p.byteLength();

      // uncompressed, hybrid-odd, hybrid-even
      if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
          bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06)
          assert$f(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07)
          assert$f(bytes[bytes.length - 1] % 2 === 1);

        var res =  this.point(bytes.slice(1, 1 + len),
          bytes.slice(1 + len, 1 + 2 * len));

        return res;
      } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
                  bytes.length - 1 === len) {
        return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
      }
      throw new Error('Unknown point format');
    };

    BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
      return this.encode(enc, true);
    };

    BasePoint.prototype._encode = function _encode(compact) {
      var len = this.curve.p.byteLength();
      var x = this.getX().toArray('be', len);

      if (compact)
        return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

      return [ 0x04 ].concat(x, this.getY().toArray('be', len));
    };

    BasePoint.prototype.encode = function encode(enc, compact) {
      return utils$k.encode(this._encode(compact), enc);
    };

    BasePoint.prototype.precompute = function precompute(power) {
      if (this.precomputed)
        return this;

      var precomputed = {
        doubles: null,
        naf: null,
        beta: null,
      };
      precomputed.naf = this._getNAFPoints(8);
      precomputed.doubles = this._getDoubles(4, power);
      precomputed.beta = this._getBeta();
      this.precomputed = precomputed;

      return this;
    };

    BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
      if (!this.precomputed)
        return false;

      var doubles = this.precomputed.doubles;
      if (!doubles)
        return false;

      return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
    };

    BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
      if (this.precomputed && this.precomputed.doubles)
        return this.precomputed.doubles;

      var doubles = [ this ];
      var acc = this;
      for (var i = 0; i < power; i += step) {
        for (var j = 0; j < step; j++)
          acc = acc.dbl();
        doubles.push(acc);
      }
      return {
        step: step,
        points: doubles,
      };
    };

    BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
      if (this.precomputed && this.precomputed.naf)
        return this.precomputed.naf;

      var res = [ this ];
      var max = (1 << wnd) - 1;
      var dbl = max === 1 ? null : this.dbl();
      for (var i = 1; i < max; i++)
        res[i] = res[i - 1].add(dbl);
      return {
        wnd: wnd,
        points: res,
      };
    };

    BasePoint.prototype._getBeta = function _getBeta() {
      return null;
    };

    BasePoint.prototype.dblp = function dblp(k) {
      var r = this;
      for (var i = 0; i < k; i++)
        r = r.dbl();
      return r;
    };

    var utils$j = utils$m;
    var BN$6 = bnExports;
    var inherits$3 = require$$1$1;
    var Base$2 = base;

    var assert$e = utils$j.assert;

    function ShortCurve(conf) {
      Base$2.call(this, 'short', conf);

      this.a = new BN$6(conf.a, 16).toRed(this.red);
      this.b = new BN$6(conf.b, 16).toRed(this.red);
      this.tinv = this.two.redInvm();

      this.zeroA = this.a.fromRed().cmpn(0) === 0;
      this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

      // If the curve is endomorphic, precalculate beta and lambda
      this.endo = this._getEndomorphism(conf);
      this._endoWnafT1 = new Array(4);
      this._endoWnafT2 = new Array(4);
    }
    inherits$3(ShortCurve, Base$2);
    var short = ShortCurve;

    ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
      // No efficient endomorphism
      if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
        return;

      // Compute beta and lambda, that lambda * P = (beta * Px; Py)
      var beta;
      var lambda;
      if (conf.beta) {
        beta = new BN$6(conf.beta, 16).toRed(this.red);
      } else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
      }
      if (conf.lambda) {
        lambda = new BN$6(conf.lambda, 16);
      } else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
          lambda = lambdas[0];
        } else {
          lambda = lambdas[1];
          assert$e(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
      }

      // Get basis vectors, used for balanced length-two representation
      var basis;
      if (conf.basis) {
        basis = conf.basis.map(function(vec) {
          return {
            a: new BN$6(vec.a, 16),
            b: new BN$6(vec.b, 16),
          };
        });
      } else {
        basis = this._getEndoBasis(lambda);
      }

      return {
        beta: beta,
        lambda: lambda,
        basis: basis,
      };
    };

    ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
      // Find roots of for x^2 + x + 1 in F
      // Root = (-1 +- Sqrt(-3)) / 2
      //
      var red = num === this.p ? this.red : BN$6.mont(num);
      var tinv = new BN$6(2).toRed(red).redInvm();
      var ntinv = tinv.redNeg();

      var s = new BN$6(3).toRed(red).redNeg().redSqrt().redMul(tinv);

      var l1 = ntinv.redAdd(s).fromRed();
      var l2 = ntinv.redSub(s).fromRed();
      return [ l1, l2 ];
    };

    ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
      // aprxSqrt >= sqrt(this.n)
      var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

      // 3.74
      // Run EGCD, until r(L + 1) < aprxSqrt
      var u = lambda;
      var v = this.n.clone();
      var x1 = new BN$6(1);
      var y1 = new BN$6(0);
      var x2 = new BN$6(0);
      var y2 = new BN$6(1);

      // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
      var a0;
      var b0;
      // First vector
      var a1;
      var b1;
      // Second vector
      var a2;
      var b2;

      var prevR;
      var i = 0;
      var r;
      var x;
      while (u.cmpn(0) !== 0) {
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));

        if (!a1 && r.cmp(aprxSqrt) < 0) {
          a0 = prevR.neg();
          b0 = x1;
          a1 = r.neg();
          b1 = x;
        } else if (a1 && ++i === 2) {
          break;
        }
        prevR = r;

        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
      }
      a2 = r.neg();
      b2 = x;

      var len1 = a1.sqr().add(b1.sqr());
      var len2 = a2.sqr().add(b2.sqr());
      if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
      }

      // Normalize signs
      if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
      }
      if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
      }

      return [
        { a: a1, b: b1 },
        { a: a2, b: b2 },
      ];
    };

    ShortCurve.prototype._endoSplit = function _endoSplit(k) {
      var basis = this.endo.basis;
      var v1 = basis[0];
      var v2 = basis[1];

      var c1 = v2.b.mul(k).divRound(this.n);
      var c2 = v1.b.neg().mul(k).divRound(this.n);

      var p1 = c1.mul(v1.a);
      var p2 = c2.mul(v2.a);
      var q1 = c1.mul(v1.b);
      var q2 = c2.mul(v2.b);

      // Calculate answer
      var k1 = k.sub(p1).sub(p2);
      var k2 = q1.add(q2).neg();
      return { k1: k1, k2: k2 };
    };

    ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
      x = new BN$6(x, 16);
      if (!x.red)
        x = x.toRed(this.red);

      var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
      var y = y2.redSqrt();
      if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
        throw new Error('invalid point');

      // XXX Is there any way to tell if the number is odd without converting it
      // to non-red form?
      var isOdd = y.fromRed().isOdd();
      if (odd && !isOdd || !odd && isOdd)
        y = y.redNeg();

      return this.point(x, y);
    };

    ShortCurve.prototype.validate = function validate(point) {
      if (point.inf)
        return true;

      var x = point.x;
      var y = point.y;

      var ax = this.a.redMul(x);
      var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
      return y.redSqr().redISub(rhs).cmpn(0) === 0;
    };

    ShortCurve.prototype._endoWnafMulAdd =
        function _endoWnafMulAdd(points, coeffs, jacobianResult) {
          var npoints = this._endoWnafT1;
          var ncoeffs = this._endoWnafT2;
          for (var i = 0; i < points.length; i++) {
            var split = this._endoSplit(coeffs[i]);
            var p = points[i];
            var beta = p._getBeta();

            if (split.k1.negative) {
              split.k1.ineg();
              p = p.neg(true);
            }
            if (split.k2.negative) {
              split.k2.ineg();
              beta = beta.neg(true);
            }

            npoints[i * 2] = p;
            npoints[i * 2 + 1] = beta;
            ncoeffs[i * 2] = split.k1;
            ncoeffs[i * 2 + 1] = split.k2;
          }
          var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

          // Clean-up references to points and coefficients
          for (var j = 0; j < i * 2; j++) {
            npoints[j] = null;
            ncoeffs[j] = null;
          }
          return res;
        };

    function Point$2(curve, x, y, isRed) {
      Base$2.BasePoint.call(this, curve, 'affine');
      if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
      } else {
        this.x = new BN$6(x, 16);
        this.y = new BN$6(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
          this.x.forceRed(this.curve.red);
          this.y.forceRed(this.curve.red);
        }
        if (!this.x.red)
          this.x = this.x.toRed(this.curve.red);
        if (!this.y.red)
          this.y = this.y.toRed(this.curve.red);
        this.inf = false;
      }
    }
    inherits$3(Point$2, Base$2.BasePoint);

    ShortCurve.prototype.point = function point(x, y, isRed) {
      return new Point$2(this, x, y, isRed);
    };

    ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
      return Point$2.fromJSON(this, obj, red);
    };

    Point$2.prototype._getBeta = function _getBeta() {
      if (!this.curve.endo)
        return;

      var pre = this.precomputed;
      if (pre && pre.beta)
        return pre.beta;

      var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
          return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
          beta: null,
          naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: pre.naf.points.map(endoMul),
          },
          doubles: pre.doubles && {
            step: pre.doubles.step,
            points: pre.doubles.points.map(endoMul),
          },
        };
      }
      return beta;
    };

    Point$2.prototype.toJSON = function toJSON() {
      if (!this.precomputed)
        return [ this.x, this.y ];

      return [ this.x, this.y, this.precomputed && {
        doubles: this.precomputed.doubles && {
          step: this.precomputed.doubles.step,
          points: this.precomputed.doubles.points.slice(1),
        },
        naf: this.precomputed.naf && {
          wnd: this.precomputed.naf.wnd,
          points: this.precomputed.naf.points.slice(1),
        },
      } ];
    };

    Point$2.fromJSON = function fromJSON(curve, obj, red) {
      if (typeof obj === 'string')
        obj = JSON.parse(obj);
      var res = curve.point(obj[0], obj[1], red);
      if (!obj[2])
        return res;

      function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
      }

      var pre = obj[2];
      res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
          step: pre.doubles.step,
          points: [ res ].concat(pre.doubles.points.map(obj2point)),
        },
        naf: pre.naf && {
          wnd: pre.naf.wnd,
          points: [ res ].concat(pre.naf.points.map(obj2point)),
        },
      };
      return res;
    };

    Point$2.prototype.inspect = function inspect() {
      if (this.isInfinity())
        return '<EC Point Infinity>';
      return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
          ' y: ' + this.y.fromRed().toString(16, 2) + '>';
    };

    Point$2.prototype.isInfinity = function isInfinity() {
      return this.inf;
    };

    Point$2.prototype.add = function add(p) {
      // O + P = P
      if (this.inf)
        return p;

      // P + O = P
      if (p.inf)
        return this;

      // P + P = 2P
      if (this.eq(p))
        return this.dbl();

      // P + (-P) = O
      if (this.neg().eq(p))
        return this.curve.point(null, null);

      // P + Q = O
      if (this.x.cmp(p.x) === 0)
        return this.curve.point(null, null);

      var c = this.y.redSub(p.y);
      if (c.cmpn(0) !== 0)
        c = c.redMul(this.x.redSub(p.x).redInvm());
      var nx = c.redSqr().redISub(this.x).redISub(p.x);
      var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
      return this.curve.point(nx, ny);
    };

    Point$2.prototype.dbl = function dbl() {
      if (this.inf)
        return this;

      // 2P = O
      var ys1 = this.y.redAdd(this.y);
      if (ys1.cmpn(0) === 0)
        return this.curve.point(null, null);

      var a = this.curve.a;

      var x2 = this.x.redSqr();
      var dyinv = ys1.redInvm();
      var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

      var nx = c.redSqr().redISub(this.x.redAdd(this.x));
      var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
      return this.curve.point(nx, ny);
    };

    Point$2.prototype.getX = function getX() {
      return this.x.fromRed();
    };

    Point$2.prototype.getY = function getY() {
      return this.y.fromRed();
    };

    Point$2.prototype.mul = function mul(k) {
      k = new BN$6(k, 16);
      if (this.isInfinity())
        return this;
      else if (this._hasDoubles(k))
        return this.curve._fixedNafMul(this, k);
      else if (this.curve.endo)
        return this.curve._endoWnafMulAdd([ this ], [ k ]);
      else
        return this.curve._wnafMul(this, k);
    };

    Point$2.prototype.mulAdd = function mulAdd(k1, p2, k2) {
      var points = [ this, p2 ];
      var coeffs = [ k1, k2 ];
      if (this.curve.endo)
        return this.curve._endoWnafMulAdd(points, coeffs);
      else
        return this.curve._wnafMulAdd(1, points, coeffs, 2);
    };

    Point$2.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
      var points = [ this, p2 ];
      var coeffs = [ k1, k2 ];
      if (this.curve.endo)
        return this.curve._endoWnafMulAdd(points, coeffs, true);
      else
        return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
    };

    Point$2.prototype.eq = function eq(p) {
      return this === p ||
             this.inf === p.inf &&
                 (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
    };

    Point$2.prototype.neg = function neg(_precompute) {
      if (this.inf)
        return this;

      var res = this.curve.point(this.x, this.y.redNeg());
      if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
          return p.neg();
        };
        res.precomputed = {
          naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: pre.naf.points.map(negate),
          },
          doubles: pre.doubles && {
            step: pre.doubles.step,
            points: pre.doubles.points.map(negate),
          },
        };
      }
      return res;
    };

    Point$2.prototype.toJ = function toJ() {
      if (this.inf)
        return this.curve.jpoint(null, null, null);

      var res = this.curve.jpoint(this.x, this.y, this.curve.one);
      return res;
    };

    function JPoint(curve, x, y, z) {
      Base$2.BasePoint.call(this, curve, 'jacobian');
      if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new BN$6(0);
      } else {
        this.x = new BN$6(x, 16);
        this.y = new BN$6(y, 16);
        this.z = new BN$6(z, 16);
      }
      if (!this.x.red)
        this.x = this.x.toRed(this.curve.red);
      if (!this.y.red)
        this.y = this.y.toRed(this.curve.red);
      if (!this.z.red)
        this.z = this.z.toRed(this.curve.red);

      this.zOne = this.z === this.curve.one;
    }
    inherits$3(JPoint, Base$2.BasePoint);

    ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
      return new JPoint(this, x, y, z);
    };

    JPoint.prototype.toP = function toP() {
      if (this.isInfinity())
        return this.curve.point(null, null);

      var zinv = this.z.redInvm();
      var zinv2 = zinv.redSqr();
      var ax = this.x.redMul(zinv2);
      var ay = this.y.redMul(zinv2).redMul(zinv);

      return this.curve.point(ax, ay);
    };

    JPoint.prototype.neg = function neg() {
      return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
    };

    JPoint.prototype.add = function add(p) {
      // O + P = P
      if (this.isInfinity())
        return p;

      // P + O = P
      if (p.isInfinity())
        return this;

      // 12M + 4S + 7A
      var pz2 = p.z.redSqr();
      var z2 = this.z.redSqr();
      var u1 = this.x.redMul(pz2);
      var u2 = p.x.redMul(z2);
      var s1 = this.y.redMul(pz2.redMul(p.z));
      var s2 = p.y.redMul(z2.redMul(this.z));

      var h = u1.redSub(u2);
      var r = s1.redSub(s2);
      if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0)
          return this.curve.jpoint(null, null, null);
        else
          return this.dbl();
      }

      var h2 = h.redSqr();
      var h3 = h2.redMul(h);
      var v = u1.redMul(h2);

      var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
      var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
      var nz = this.z.redMul(p.z).redMul(h);

      return this.curve.jpoint(nx, ny, nz);
    };

    JPoint.prototype.mixedAdd = function mixedAdd(p) {
      // O + P = P
      if (this.isInfinity())
        return p.toJ();

      // P + O = P
      if (p.isInfinity())
        return this;

      // 8M + 3S + 7A
      var z2 = this.z.redSqr();
      var u1 = this.x;
      var u2 = p.x.redMul(z2);
      var s1 = this.y;
      var s2 = p.y.redMul(z2).redMul(this.z);

      var h = u1.redSub(u2);
      var r = s1.redSub(s2);
      if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0)
          return this.curve.jpoint(null, null, null);
        else
          return this.dbl();
      }

      var h2 = h.redSqr();
      var h3 = h2.redMul(h);
      var v = u1.redMul(h2);

      var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
      var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
      var nz = this.z.redMul(h);

      return this.curve.jpoint(nx, ny, nz);
    };

    JPoint.prototype.dblp = function dblp(pow) {
      if (pow === 0)
        return this;
      if (this.isInfinity())
        return this;
      if (!pow)
        return this.dbl();

      var i;
      if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for (i = 0; i < pow; i++)
          r = r.dbl();
        return r;
      }

      // 1M + 2S + 1A + N * (4S + 5M + 8A)
      // N = 1 => 6M + 6S + 9A
      var a = this.curve.a;
      var tinv = this.curve.tinv;

      var jx = this.x;
      var jy = this.y;
      var jz = this.z;
      var jz4 = jz.redSqr().redSqr();

      // Reuse results
      var jyd = jy.redAdd(jy);
      for (i = 0; i < pow; i++) {
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow)
          jz4 = jz4.redMul(jyd4);

        jx = nx;
        jz = nz;
        jyd = dny;
      }

      return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
    };

    JPoint.prototype.dbl = function dbl() {
      if (this.isInfinity())
        return this;

      if (this.curve.zeroA)
        return this._zeroDbl();
      else if (this.curve.threeA)
        return this._threeDbl();
      else
        return this._dbl();
    };

    JPoint.prototype._zeroDbl = function _zeroDbl() {
      var nx;
      var ny;
      var nz;
      // Z = 1
      if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A

        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);

        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);

        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
      } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A

        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();

        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);

        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
      }

      return this.curve.jpoint(nx, ny, nz);
    };

    JPoint.prototype._threeDbl = function _threeDbl() {
      var nx;
      var ny;
      var nz;
      // Z = 1
      if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A

        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
      } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S

        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
      }

      return this.curve.jpoint(nx, ny, nz);
    };

    JPoint.prototype._dbl = function _dbl() {
      var a = this.curve.a;

      // 4M + 6S + 10A
      var jx = this.x;
      var jy = this.y;
      var jz = this.z;
      var jz4 = jz.redSqr().redSqr();

      var jx2 = jx.redSqr();
      var jy2 = jy.redSqr();

      var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

      var jxd4 = jx.redAdd(jx);
      jxd4 = jxd4.redIAdd(jxd4);
      var t1 = jxd4.redMul(jy2);
      var nx = c.redSqr().redISub(t1.redAdd(t1));
      var t2 = t1.redISub(nx);

      var jyd8 = jy2.redSqr();
      jyd8 = jyd8.redIAdd(jyd8);
      jyd8 = jyd8.redIAdd(jyd8);
      jyd8 = jyd8.redIAdd(jyd8);
      var ny = c.redMul(t2).redISub(jyd8);
      var nz = jy.redAdd(jy).redMul(jz);

      return this.curve.jpoint(nx, ny, nz);
    };

    JPoint.prototype.trpl = function trpl() {
      if (!this.curve.zeroA)
        return this.dbl().add(this);

      // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
      // 5M + 10S + ...

      // XX = X1^2
      var xx = this.x.redSqr();
      // YY = Y1^2
      var yy = this.y.redSqr();
      // ZZ = Z1^2
      var zz = this.z.redSqr();
      // YYYY = YY^2
      var yyyy = yy.redSqr();
      // M = 3 * XX + a * ZZ2; a = 0
      var m = xx.redAdd(xx).redIAdd(xx);
      // MM = M^2
      var mm = m.redSqr();
      // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
      var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
      e = e.redIAdd(e);
      e = e.redAdd(e).redIAdd(e);
      e = e.redISub(mm);
      // EE = E^2
      var ee = e.redSqr();
      // T = 16*YYYY
      var t = yyyy.redIAdd(yyyy);
      t = t.redIAdd(t);
      t = t.redIAdd(t);
      t = t.redIAdd(t);
      // U = (M + E)^2 - MM - EE - T
      var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
      // X3 = 4 * (X1 * EE - 4 * YY * U)
      var yyu4 = yy.redMul(u);
      yyu4 = yyu4.redIAdd(yyu4);
      yyu4 = yyu4.redIAdd(yyu4);
      var nx = this.x.redMul(ee).redISub(yyu4);
      nx = nx.redIAdd(nx);
      nx = nx.redIAdd(nx);
      // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
      var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
      ny = ny.redIAdd(ny);
      ny = ny.redIAdd(ny);
      ny = ny.redIAdd(ny);
      // Z3 = (Z1 + E)^2 - ZZ - EE
      var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

      return this.curve.jpoint(nx, ny, nz);
    };

    JPoint.prototype.mul = function mul(k, kbase) {
      k = new BN$6(k, kbase);

      return this.curve._wnafMul(this, k);
    };

    JPoint.prototype.eq = function eq(p) {
      if (p.type === 'affine')
        return this.eq(p.toJ());

      if (this === p)
        return true;

      // x1 * z2^2 == x2 * z1^2
      var z2 = this.z.redSqr();
      var pz2 = p.z.redSqr();
      if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
        return false;

      // y1 * z2^3 == y2 * z1^3
      var z3 = z2.redMul(this.z);
      var pz3 = pz2.redMul(p.z);
      return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
    };

    JPoint.prototype.eqXToP = function eqXToP(x) {
      var zs = this.z.redSqr();
      var rx = x.toRed(this.curve.red).redMul(zs);
      if (this.x.cmp(rx) === 0)
        return true;

      var xc = x.clone();
      var t = this.curve.redN.redMul(zs);
      for (;;) {
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0)
          return false;

        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0)
          return true;
      }
    };

    JPoint.prototype.inspect = function inspect() {
      if (this.isInfinity())
        return '<EC JPoint Infinity>';
      return '<EC JPoint x: ' + this.x.toString(16, 2) +
          ' y: ' + this.y.toString(16, 2) +
          ' z: ' + this.z.toString(16, 2) + '>';
    };

    JPoint.prototype.isInfinity = function isInfinity() {
      // XXX This code assumes that zero is always zero in red
      return this.z.cmpn(0) === 0;
    };

    var BN$5 = bnExports;
    var inherits$2 = require$$1$1;
    var Base$1 = base;

    var utils$i = utils$m;

    function MontCurve(conf) {
      Base$1.call(this, 'mont', conf);

      this.a = new BN$5(conf.a, 16).toRed(this.red);
      this.b = new BN$5(conf.b, 16).toRed(this.red);
      this.i4 = new BN$5(4).toRed(this.red).redInvm();
      this.two = new BN$5(2).toRed(this.red);
      this.a24 = this.i4.redMul(this.a.redAdd(this.two));
    }
    inherits$2(MontCurve, Base$1);
    var mont = MontCurve;

    MontCurve.prototype.validate = function validate(point) {
      var x = point.normalize().x;
      var x2 = x.redSqr();
      var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
      var y = rhs.redSqrt();

      return y.redSqr().cmp(rhs) === 0;
    };

    function Point$1(curve, x, z) {
      Base$1.BasePoint.call(this, curve, 'projective');
      if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
      } else {
        this.x = new BN$5(x, 16);
        this.z = new BN$5(z, 16);
        if (!this.x.red)
          this.x = this.x.toRed(this.curve.red);
        if (!this.z.red)
          this.z = this.z.toRed(this.curve.red);
      }
    }
    inherits$2(Point$1, Base$1.BasePoint);

    MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
      return this.point(utils$i.toArray(bytes, enc), 1);
    };

    MontCurve.prototype.point = function point(x, z) {
      return new Point$1(this, x, z);
    };

    MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
      return Point$1.fromJSON(this, obj);
    };

    Point$1.prototype.precompute = function precompute() {
      // No-op
    };

    Point$1.prototype._encode = function _encode() {
      return this.getX().toArray('be', this.curve.p.byteLength());
    };

    Point$1.fromJSON = function fromJSON(curve, obj) {
      return new Point$1(curve, obj[0], obj[1] || curve.one);
    };

    Point$1.prototype.inspect = function inspect() {
      if (this.isInfinity())
        return '<EC Point Infinity>';
      return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
          ' z: ' + this.z.fromRed().toString(16, 2) + '>';
    };

    Point$1.prototype.isInfinity = function isInfinity() {
      // XXX This code assumes that zero is always zero in red
      return this.z.cmpn(0) === 0;
    };

    Point$1.prototype.dbl = function dbl() {
      // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
      // 2M + 2S + 4A

      // A = X1 + Z1
      var a = this.x.redAdd(this.z);
      // AA = A^2
      var aa = a.redSqr();
      // B = X1 - Z1
      var b = this.x.redSub(this.z);
      // BB = B^2
      var bb = b.redSqr();
      // C = AA - BB
      var c = aa.redSub(bb);
      // X3 = AA * BB
      var nx = aa.redMul(bb);
      // Z3 = C * (BB + A24 * C)
      var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
      return this.curve.point(nx, nz);
    };

    Point$1.prototype.add = function add() {
      throw new Error('Not supported on Montgomery curve');
    };

    Point$1.prototype.diffAdd = function diffAdd(p, diff) {
      // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
      // 4M + 2S + 6A

      // A = X2 + Z2
      var a = this.x.redAdd(this.z);
      // B = X2 - Z2
      var b = this.x.redSub(this.z);
      // C = X3 + Z3
      var c = p.x.redAdd(p.z);
      // D = X3 - Z3
      var d = p.x.redSub(p.z);
      // DA = D * A
      var da = d.redMul(a);
      // CB = C * B
      var cb = c.redMul(b);
      // X5 = Z1 * (DA + CB)^2
      var nx = diff.z.redMul(da.redAdd(cb).redSqr());
      // Z5 = X1 * (DA - CB)^2
      var nz = diff.x.redMul(da.redISub(cb).redSqr());
      return this.curve.point(nx, nz);
    };

    Point$1.prototype.mul = function mul(k) {
      var t = k.clone();
      var a = this; // (N / 2) * Q + Q
      var b = this.curve.point(null, null); // (N / 2) * Q
      var c = this; // Q

      for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
        bits.push(t.andln(1));

      for (var i = bits.length - 1; i >= 0; i--) {
        if (bits[i] === 0) {
          // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
          a = a.diffAdd(b, c);
          // N * Q = 2 * ((N / 2) * Q + Q))
          b = b.dbl();
        } else {
          // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
          b = a.diffAdd(b, c);
          // N * Q + Q = 2 * ((N / 2) * Q + Q)
          a = a.dbl();
        }
      }
      return b;
    };

    Point$1.prototype.mulAdd = function mulAdd() {
      throw new Error('Not supported on Montgomery curve');
    };

    Point$1.prototype.jumlAdd = function jumlAdd() {
      throw new Error('Not supported on Montgomery curve');
    };

    Point$1.prototype.eq = function eq(other) {
      return this.getX().cmp(other.getX()) === 0;
    };

    Point$1.prototype.normalize = function normalize() {
      this.x = this.x.redMul(this.z.redInvm());
      this.z = this.curve.one;
      return this;
    };

    Point$1.prototype.getX = function getX() {
      // Normalize coordinates
      this.normalize();

      return this.x.fromRed();
    };

    var utils$h = utils$m;
    var BN$4 = bnExports;
    var inherits$1 = require$$1$1;
    var Base = base;

    var assert$d = utils$h.assert;

    function EdwardsCurve(conf) {
      // NOTE: Important as we are creating point in Base.call()
      this.twisted = (conf.a | 0) !== 1;
      this.mOneA = this.twisted && (conf.a | 0) === -1;
      this.extended = this.mOneA;

      Base.call(this, 'edwards', conf);

      this.a = new BN$4(conf.a, 16).umod(this.red.m);
      this.a = this.a.toRed(this.red);
      this.c = new BN$4(conf.c, 16).toRed(this.red);
      this.c2 = this.c.redSqr();
      this.d = new BN$4(conf.d, 16).toRed(this.red);
      this.dd = this.d.redAdd(this.d);

      assert$d(!this.twisted || this.c.fromRed().cmpn(1) === 0);
      this.oneC = (conf.c | 0) === 1;
    }
    inherits$1(EdwardsCurve, Base);
    var edwards = EdwardsCurve;

    EdwardsCurve.prototype._mulA = function _mulA(num) {
      if (this.mOneA)
        return num.redNeg();
      else
        return this.a.redMul(num);
    };

    EdwardsCurve.prototype._mulC = function _mulC(num) {
      if (this.oneC)
        return num;
      else
        return this.c.redMul(num);
    };

    // Just for compatibility with Short curve
    EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
      return this.point(x, y, z, t);
    };

    EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
      x = new BN$4(x, 16);
      if (!x.red)
        x = x.toRed(this.red);

      var x2 = x.redSqr();
      var rhs = this.c2.redSub(this.a.redMul(x2));
      var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

      var y2 = rhs.redMul(lhs.redInvm());
      var y = y2.redSqrt();
      if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
        throw new Error('invalid point');

      var isOdd = y.fromRed().isOdd();
      if (odd && !isOdd || !odd && isOdd)
        y = y.redNeg();

      return this.point(x, y);
    };

    EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
      y = new BN$4(y, 16);
      if (!y.red)
        y = y.toRed(this.red);

      // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
      var y2 = y.redSqr();
      var lhs = y2.redSub(this.c2);
      var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
      var x2 = lhs.redMul(rhs.redInvm());

      if (x2.cmp(this.zero) === 0) {
        if (odd)
          throw new Error('invalid point');
        else
          return this.point(this.zero, y);
      }

      var x = x2.redSqrt();
      if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
        throw new Error('invalid point');

      if (x.fromRed().isOdd() !== odd)
        x = x.redNeg();

      return this.point(x, y);
    };

    EdwardsCurve.prototype.validate = function validate(point) {
      if (point.isInfinity())
        return true;

      // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
      point.normalize();

      var x2 = point.x.redSqr();
      var y2 = point.y.redSqr();
      var lhs = x2.redMul(this.a).redAdd(y2);
      var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

      return lhs.cmp(rhs) === 0;
    };

    function Point(curve, x, y, z, t) {
      Base.BasePoint.call(this, curve, 'projective');
      if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
      } else {
        this.x = new BN$4(x, 16);
        this.y = new BN$4(y, 16);
        this.z = z ? new BN$4(z, 16) : this.curve.one;
        this.t = t && new BN$4(t, 16);
        if (!this.x.red)
          this.x = this.x.toRed(this.curve.red);
        if (!this.y.red)
          this.y = this.y.toRed(this.curve.red);
        if (!this.z.red)
          this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red)
          this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;

        // Use extended coordinates
        if (this.curve.extended && !this.t) {
          this.t = this.x.redMul(this.y);
          if (!this.zOne)
            this.t = this.t.redMul(this.z.redInvm());
        }
      }
    }
    inherits$1(Point, Base.BasePoint);

    EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
      return Point.fromJSON(this, obj);
    };

    EdwardsCurve.prototype.point = function point(x, y, z, t) {
      return new Point(this, x, y, z, t);
    };

    Point.fromJSON = function fromJSON(curve, obj) {
      return new Point(curve, obj[0], obj[1], obj[2]);
    };

    Point.prototype.inspect = function inspect() {
      if (this.isInfinity())
        return '<EC Point Infinity>';
      return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
          ' y: ' + this.y.fromRed().toString(16, 2) +
          ' z: ' + this.z.fromRed().toString(16, 2) + '>';
    };

    Point.prototype.isInfinity = function isInfinity() {
      // XXX This code assumes that zero is always zero in red
      return this.x.cmpn(0) === 0 &&
        (this.y.cmp(this.z) === 0 ||
        (this.zOne && this.y.cmp(this.curve.c) === 0));
    };

    Point.prototype._extDbl = function _extDbl() {
      // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
      //     #doubling-dbl-2008-hwcd
      // 4M + 4S

      // A = X1^2
      var a = this.x.redSqr();
      // B = Y1^2
      var b = this.y.redSqr();
      // C = 2 * Z1^2
      var c = this.z.redSqr();
      c = c.redIAdd(c);
      // D = a * A
      var d = this.curve._mulA(a);
      // E = (X1 + Y1)^2 - A - B
      var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
      // G = D + B
      var g = d.redAdd(b);
      // F = G - C
      var f = g.redSub(c);
      // H = D - B
      var h = d.redSub(b);
      // X3 = E * F
      var nx = e.redMul(f);
      // Y3 = G * H
      var ny = g.redMul(h);
      // T3 = E * H
      var nt = e.redMul(h);
      // Z3 = F * G
      var nz = f.redMul(g);
      return this.curve.point(nx, ny, nz, nt);
    };

    Point.prototype._projDbl = function _projDbl() {
      // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
      //     #doubling-dbl-2008-bbjlp
      //     #doubling-dbl-2007-bl
      // and others
      // Generally 3M + 4S or 2M + 4S

      // B = (X1 + Y1)^2
      var b = this.x.redAdd(this.y).redSqr();
      // C = X1^2
      var c = this.x.redSqr();
      // D = Y1^2
      var d = this.y.redSqr();

      var nx;
      var ny;
      var nz;
      var e;
      var h;
      var j;
      if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
          // X3 = (B - C - D) * (F - 2)
          nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
          // Y3 = F * (E - D)
          ny = f.redMul(e.redSub(d));
          // Z3 = F^2 - 2 * F
          nz = f.redSqr().redSub(f).redSub(f);
        } else {
          // H = Z1^2
          h = this.z.redSqr();
          // J = F - 2 * H
          j = f.redSub(h).redISub(h);
          // X3 = (B-C-D)*J
          nx = b.redSub(c).redISub(d).redMul(j);
          // Y3 = F * (E - D)
          ny = f.redMul(e.redSub(d));
          // Z3 = F * J
          nz = f.redMul(j);
        }
      } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
      }
      return this.curve.point(nx, ny, nz);
    };

    Point.prototype.dbl = function dbl() {
      if (this.isInfinity())
        return this;

      // Double in extended coordinates
      if (this.curve.extended)
        return this._extDbl();
      else
        return this._projDbl();
    };

    Point.prototype._extAdd = function _extAdd(p) {
      // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
      //     #addition-add-2008-hwcd-3
      // 8M

      // A = (Y1 - X1) * (Y2 - X2)
      var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
      // B = (Y1 + X1) * (Y2 + X2)
      var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
      // C = T1 * k * T2
      var c = this.t.redMul(this.curve.dd).redMul(p.t);
      // D = Z1 * 2 * Z2
      var d = this.z.redMul(p.z.redAdd(p.z));
      // E = B - A
      var e = b.redSub(a);
      // F = D - C
      var f = d.redSub(c);
      // G = D + C
      var g = d.redAdd(c);
      // H = B + A
      var h = b.redAdd(a);
      // X3 = E * F
      var nx = e.redMul(f);
      // Y3 = G * H
      var ny = g.redMul(h);
      // T3 = E * H
      var nt = e.redMul(h);
      // Z3 = F * G
      var nz = f.redMul(g);
      return this.curve.point(nx, ny, nz, nt);
    };

    Point.prototype._projAdd = function _projAdd(p) {
      // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
      //     #addition-add-2008-bbjlp
      //     #addition-add-2007-bl
      // 10M + 1S

      // A = Z1 * Z2
      var a = this.z.redMul(p.z);
      // B = A^2
      var b = a.redSqr();
      // C = X1 * X2
      var c = this.x.redMul(p.x);
      // D = Y1 * Y2
      var d = this.y.redMul(p.y);
      // E = d * C * D
      var e = this.curve.d.redMul(c).redMul(d);
      // F = B - E
      var f = b.redSub(e);
      // G = B + E
      var g = b.redAdd(e);
      // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
      var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
      var nx = a.redMul(f).redMul(tmp);
      var ny;
      var nz;
      if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
      } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
      }
      return this.curve.point(nx, ny, nz);
    };

    Point.prototype.add = function add(p) {
      if (this.isInfinity())
        return p;
      if (p.isInfinity())
        return this;

      if (this.curve.extended)
        return this._extAdd(p);
      else
        return this._projAdd(p);
    };

    Point.prototype.mul = function mul(k) {
      if (this._hasDoubles(k))
        return this.curve._fixedNafMul(this, k);
      else
        return this.curve._wnafMul(this, k);
    };

    Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
      return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
    };

    Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
      return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
    };

    Point.prototype.normalize = function normalize() {
      if (this.zOne)
        return this;

      // Normalize coordinates
      var zi = this.z.redInvm();
      this.x = this.x.redMul(zi);
      this.y = this.y.redMul(zi);
      if (this.t)
        this.t = this.t.redMul(zi);
      this.z = this.curve.one;
      this.zOne = true;
      return this;
    };

    Point.prototype.neg = function neg() {
      return this.curve.point(this.x.redNeg(),
        this.y,
        this.z,
        this.t && this.t.redNeg());
    };

    Point.prototype.getX = function getX() {
      this.normalize();
      return this.x.fromRed();
    };

    Point.prototype.getY = function getY() {
      this.normalize();
      return this.y.fromRed();
    };

    Point.prototype.eq = function eq(other) {
      return this === other ||
             this.getX().cmp(other.getX()) === 0 &&
             this.getY().cmp(other.getY()) === 0;
    };

    Point.prototype.eqXToP = function eqXToP(x) {
      var rx = x.toRed(this.curve.red).redMul(this.z);
      if (this.x.cmp(rx) === 0)
        return true;

      var xc = x.clone();
      var t = this.curve.redN.redMul(this.z);
      for (;;) {
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0)
          return false;

        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0)
          return true;
      }
    };

    // Compatibility with BaseCurve
    Point.prototype.toP = Point.prototype.normalize;
    Point.prototype.mixedAdd = Point.prototype.add;

    (function (exports) {

    	var curve = exports;

    	curve.base = base;
    	curve.short = short;
    	curve.mont = mont;
    	curve.edwards = edwards; 
    } (curve));

    var curves$2 = {};

    var hash$2 = {};

    var utils$g = {};

    var assert$c = minimalisticAssert;
    var inherits = require$$1$1;

    utils$g.inherits = inherits;

    function isSurrogatePair(msg, i) {
      if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
        return false;
      }
      if (i < 0 || i + 1 >= msg.length) {
        return false;
      }
      return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
    }

    function toArray(msg, enc) {
      if (Array.isArray(msg))
        return msg.slice();
      if (!msg)
        return [];
      var res = [];
      if (typeof msg === 'string') {
        if (!enc) {
          // Inspired by stringToUtf8ByteArray() in closure-library by Google
          // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
          // Apache License 2.0
          // https://github.com/google/closure-library/blob/master/LICENSE
          var p = 0;
          for (var i = 0; i < msg.length; i++) {
            var c = msg.charCodeAt(i);
            if (c < 128) {
              res[p++] = c;
            } else if (c < 2048) {
              res[p++] = (c >> 6) | 192;
              res[p++] = (c & 63) | 128;
            } else if (isSurrogatePair(msg, i)) {
              c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
              res[p++] = (c >> 18) | 240;
              res[p++] = ((c >> 12) & 63) | 128;
              res[p++] = ((c >> 6) & 63) | 128;
              res[p++] = (c & 63) | 128;
            } else {
              res[p++] = (c >> 12) | 224;
              res[p++] = ((c >> 6) & 63) | 128;
              res[p++] = (c & 63) | 128;
            }
          }
        } else if (enc === 'hex') {
          msg = msg.replace(/[^a-z0-9]+/ig, '');
          if (msg.length % 2 !== 0)
            msg = '0' + msg;
          for (i = 0; i < msg.length; i += 2)
            res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
      } else {
        for (i = 0; i < msg.length; i++)
          res[i] = msg[i] | 0;
      }
      return res;
    }
    utils$g.toArray = toArray;

    function toHex(msg) {
      var res = '';
      for (var i = 0; i < msg.length; i++)
        res += zero2(msg[i].toString(16));
      return res;
    }
    utils$g.toHex = toHex;

    function htonl(w) {
      var res = (w >>> 24) |
                ((w >>> 8) & 0xff00) |
                ((w << 8) & 0xff0000) |
                ((w & 0xff) << 24);
      return res >>> 0;
    }
    utils$g.htonl = htonl;

    function toHex32(msg, endian) {
      var res = '';
      for (var i = 0; i < msg.length; i++) {
        var w = msg[i];
        if (endian === 'little')
          w = htonl(w);
        res += zero8(w.toString(16));
      }
      return res;
    }
    utils$g.toHex32 = toHex32;

    function zero2(word) {
      if (word.length === 1)
        return '0' + word;
      else
        return word;
    }
    utils$g.zero2 = zero2;

    function zero8(word) {
      if (word.length === 7)
        return '0' + word;
      else if (word.length === 6)
        return '00' + word;
      else if (word.length === 5)
        return '000' + word;
      else if (word.length === 4)
        return '0000' + word;
      else if (word.length === 3)
        return '00000' + word;
      else if (word.length === 2)
        return '000000' + word;
      else if (word.length === 1)
        return '0000000' + word;
      else
        return word;
    }
    utils$g.zero8 = zero8;

    function join32(msg, start, end, endian) {
      var len = end - start;
      assert$c(len % 4 === 0);
      var res = new Array(len / 4);
      for (var i = 0, k = start; i < res.length; i++, k += 4) {
        var w;
        if (endian === 'big')
          w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
        else
          w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
        res[i] = w >>> 0;
      }
      return res;
    }
    utils$g.join32 = join32;

    function split32(msg, endian) {
      var res = new Array(msg.length * 4);
      for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
        var m = msg[i];
        if (endian === 'big') {
          res[k] = m >>> 24;
          res[k + 1] = (m >>> 16) & 0xff;
          res[k + 2] = (m >>> 8) & 0xff;
          res[k + 3] = m & 0xff;
        } else {
          res[k + 3] = m >>> 24;
          res[k + 2] = (m >>> 16) & 0xff;
          res[k + 1] = (m >>> 8) & 0xff;
          res[k] = m & 0xff;
        }
      }
      return res;
    }
    utils$g.split32 = split32;

    function rotr32$1(w, b) {
      return (w >>> b) | (w << (32 - b));
    }
    utils$g.rotr32 = rotr32$1;

    function rotl32$2(w, b) {
      return (w << b) | (w >>> (32 - b));
    }
    utils$g.rotl32 = rotl32$2;

    function sum32$3(a, b) {
      return (a + b) >>> 0;
    }
    utils$g.sum32 = sum32$3;

    function sum32_3$1(a, b, c) {
      return (a + b + c) >>> 0;
    }
    utils$g.sum32_3 = sum32_3$1;

    function sum32_4$2(a, b, c, d) {
      return (a + b + c + d) >>> 0;
    }
    utils$g.sum32_4 = sum32_4$2;

    function sum32_5$2(a, b, c, d, e) {
      return (a + b + c + d + e) >>> 0;
    }
    utils$g.sum32_5 = sum32_5$2;

    function sum64$1(buf, pos, ah, al) {
      var bh = buf[pos];
      var bl = buf[pos + 1];

      var lo = (al + bl) >>> 0;
      var hi = (lo < al ? 1 : 0) + ah + bh;
      buf[pos] = hi >>> 0;
      buf[pos + 1] = lo;
    }
    utils$g.sum64 = sum64$1;

    function sum64_hi$1(ah, al, bh, bl) {
      var lo = (al + bl) >>> 0;
      var hi = (lo < al ? 1 : 0) + ah + bh;
      return hi >>> 0;
    }
    utils$g.sum64_hi = sum64_hi$1;

    function sum64_lo$1(ah, al, bh, bl) {
      var lo = al + bl;
      return lo >>> 0;
    }
    utils$g.sum64_lo = sum64_lo$1;

    function sum64_4_hi$1(ah, al, bh, bl, ch, cl, dh, dl) {
      var carry = 0;
      var lo = al;
      lo = (lo + bl) >>> 0;
      carry += lo < al ? 1 : 0;
      lo = (lo + cl) >>> 0;
      carry += lo < cl ? 1 : 0;
      lo = (lo + dl) >>> 0;
      carry += lo < dl ? 1 : 0;

      var hi = ah + bh + ch + dh + carry;
      return hi >>> 0;
    }
    utils$g.sum64_4_hi = sum64_4_hi$1;

    function sum64_4_lo$1(ah, al, bh, bl, ch, cl, dh, dl) {
      var lo = al + bl + cl + dl;
      return lo >>> 0;
    }
    utils$g.sum64_4_lo = sum64_4_lo$1;

    function sum64_5_hi$1(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
      var carry = 0;
      var lo = al;
      lo = (lo + bl) >>> 0;
      carry += lo < al ? 1 : 0;
      lo = (lo + cl) >>> 0;
      carry += lo < cl ? 1 : 0;
      lo = (lo + dl) >>> 0;
      carry += lo < dl ? 1 : 0;
      lo = (lo + el) >>> 0;
      carry += lo < el ? 1 : 0;

      var hi = ah + bh + ch + dh + eh + carry;
      return hi >>> 0;
    }
    utils$g.sum64_5_hi = sum64_5_hi$1;

    function sum64_5_lo$1(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
      var lo = al + bl + cl + dl + el;

      return lo >>> 0;
    }
    utils$g.sum64_5_lo = sum64_5_lo$1;

    function rotr64_hi$1(ah, al, num) {
      var r = (al << (32 - num)) | (ah >>> num);
      return r >>> 0;
    }
    utils$g.rotr64_hi = rotr64_hi$1;

    function rotr64_lo$1(ah, al, num) {
      var r = (ah << (32 - num)) | (al >>> num);
      return r >>> 0;
    }
    utils$g.rotr64_lo = rotr64_lo$1;

    function shr64_hi$1(ah, al, num) {
      return ah >>> num;
    }
    utils$g.shr64_hi = shr64_hi$1;

    function shr64_lo$1(ah, al, num) {
      var r = (ah << (32 - num)) | (al >>> num);
      return r >>> 0;
    }
    utils$g.shr64_lo = shr64_lo$1;

    var common$5 = {};

    var utils$f = utils$g;
    var assert$b = minimalisticAssert;

    function BlockHash$4() {
      this.pending = null;
      this.pendingTotal = 0;
      this.blockSize = this.constructor.blockSize;
      this.outSize = this.constructor.outSize;
      this.hmacStrength = this.constructor.hmacStrength;
      this.padLength = this.constructor.padLength / 8;
      this.endian = 'big';

      this._delta8 = this.blockSize / 8;
      this._delta32 = this.blockSize / 32;
    }
    common$5.BlockHash = BlockHash$4;

    BlockHash$4.prototype.update = function update(msg, enc) {
      // Convert message to array, pad it, and join into 32bit blocks
      msg = utils$f.toArray(msg, enc);
      if (!this.pending)
        this.pending = msg;
      else
        this.pending = this.pending.concat(msg);
      this.pendingTotal += msg.length;

      // Enough data, try updating
      if (this.pending.length >= this._delta8) {
        msg = this.pending;

        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0)
          this.pending = null;

        msg = utils$f.join32(msg, 0, msg.length - r, this.endian);
        for (var i = 0; i < msg.length; i += this._delta32)
          this._update(msg, i, i + this._delta32);
      }

      return this;
    };

    BlockHash$4.prototype.digest = function digest(enc) {
      this.update(this._pad());
      assert$b(this.pending === null);

      return this._digest(enc);
    };

    BlockHash$4.prototype._pad = function pad() {
      var len = this.pendingTotal;
      var bytes = this._delta8;
      var k = bytes - ((len + this.padLength) % bytes);
      var res = new Array(k + this.padLength);
      res[0] = 0x80;
      for (var i = 1; i < k; i++)
        res[i] = 0;

      // Append length
      len <<= 3;
      if (this.endian === 'big') {
        for (var t = 8; t < this.padLength; t++)
          res[i++] = 0;

        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = (len >>> 24) & 0xff;
        res[i++] = (len >>> 16) & 0xff;
        res[i++] = (len >>> 8) & 0xff;
        res[i++] = len & 0xff;
      } else {
        res[i++] = len & 0xff;
        res[i++] = (len >>> 8) & 0xff;
        res[i++] = (len >>> 16) & 0xff;
        res[i++] = (len >>> 24) & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;

        for (t = 8; t < this.padLength; t++)
          res[i++] = 0;
      }

      return res;
    };

    var sha = {};

    var common$4 = {};

    var utils$e = utils$g;
    var rotr32 = utils$e.rotr32;

    function ft_1$1(s, x, y, z) {
      if (s === 0)
        return ch32$1(x, y, z);
      if (s === 1 || s === 3)
        return p32(x, y, z);
      if (s === 2)
        return maj32$1(x, y, z);
    }
    common$4.ft_1 = ft_1$1;

    function ch32$1(x, y, z) {
      return (x & y) ^ ((~x) & z);
    }
    common$4.ch32 = ch32$1;

    function maj32$1(x, y, z) {
      return (x & y) ^ (x & z) ^ (y & z);
    }
    common$4.maj32 = maj32$1;

    function p32(x, y, z) {
      return x ^ y ^ z;
    }
    common$4.p32 = p32;

    function s0_256$1(x) {
      return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
    }
    common$4.s0_256 = s0_256$1;

    function s1_256$1(x) {
      return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
    }
    common$4.s1_256 = s1_256$1;

    function g0_256$1(x) {
      return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
    }
    common$4.g0_256 = g0_256$1;

    function g1_256$1(x) {
      return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
    }
    common$4.g1_256 = g1_256$1;

    var utils$d = utils$g;
    var common$3 = common$5;
    var shaCommon$1 = common$4;

    var rotl32$1 = utils$d.rotl32;
    var sum32$2 = utils$d.sum32;
    var sum32_5$1 = utils$d.sum32_5;
    var ft_1 = shaCommon$1.ft_1;
    var BlockHash$3 = common$3.BlockHash;

    var sha1_K = [
      0x5A827999, 0x6ED9EBA1,
      0x8F1BBCDC, 0xCA62C1D6
    ];

    function SHA1() {
      if (!(this instanceof SHA1))
        return new SHA1();

      BlockHash$3.call(this);
      this.h = [
        0x67452301, 0xefcdab89, 0x98badcfe,
        0x10325476, 0xc3d2e1f0 ];
      this.W = new Array(80);
    }

    utils$d.inherits(SHA1, BlockHash$3);
    var _1 = SHA1;

    SHA1.blockSize = 512;
    SHA1.outSize = 160;
    SHA1.hmacStrength = 80;
    SHA1.padLength = 64;

    SHA1.prototype._update = function _update(msg, start) {
      var W = this.W;

      for (var i = 0; i < 16; i++)
        W[i] = msg[start + i];

      for(; i < W.length; i++)
        W[i] = rotl32$1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

      var a = this.h[0];
      var b = this.h[1];
      var c = this.h[2];
      var d = this.h[3];
      var e = this.h[4];

      for (i = 0; i < W.length; i++) {
        var s = ~~(i / 20);
        var t = sum32_5$1(rotl32$1(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
        e = d;
        d = c;
        c = rotl32$1(b, 30);
        b = a;
        a = t;
      }

      this.h[0] = sum32$2(this.h[0], a);
      this.h[1] = sum32$2(this.h[1], b);
      this.h[2] = sum32$2(this.h[2], c);
      this.h[3] = sum32$2(this.h[3], d);
      this.h[4] = sum32$2(this.h[4], e);
    };

    SHA1.prototype._digest = function digest(enc) {
      if (enc === 'hex')
        return utils$d.toHex32(this.h, 'big');
      else
        return utils$d.split32(this.h, 'big');
    };

    var utils$c = utils$g;
    var common$2 = common$5;
    var shaCommon = common$4;
    var assert$a = minimalisticAssert;

    var sum32$1 = utils$c.sum32;
    var sum32_4$1 = utils$c.sum32_4;
    var sum32_5 = utils$c.sum32_5;
    var ch32 = shaCommon.ch32;
    var maj32 = shaCommon.maj32;
    var s0_256 = shaCommon.s0_256;
    var s1_256 = shaCommon.s1_256;
    var g0_256 = shaCommon.g0_256;
    var g1_256 = shaCommon.g1_256;

    var BlockHash$2 = common$2.BlockHash;

    var sha256_K = [
      0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
      0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
      0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
      0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
      0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
      0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
      0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
      0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
      0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
      0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
      0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
      0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
      0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
      0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
      0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
      0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
    ];

    function SHA256$1() {
      if (!(this instanceof SHA256$1))
        return new SHA256$1();

      BlockHash$2.call(this);
      this.h = [
        0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
        0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
      ];
      this.k = sha256_K;
      this.W = new Array(64);
    }
    utils$c.inherits(SHA256$1, BlockHash$2);
    var _256 = SHA256$1;

    SHA256$1.blockSize = 512;
    SHA256$1.outSize = 256;
    SHA256$1.hmacStrength = 192;
    SHA256$1.padLength = 64;

    SHA256$1.prototype._update = function _update(msg, start) {
      var W = this.W;

      for (var i = 0; i < 16; i++)
        W[i] = msg[start + i];
      for (; i < W.length; i++)
        W[i] = sum32_4$1(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

      var a = this.h[0];
      var b = this.h[1];
      var c = this.h[2];
      var d = this.h[3];
      var e = this.h[4];
      var f = this.h[5];
      var g = this.h[6];
      var h = this.h[7];

      assert$a(this.k.length === W.length);
      for (i = 0; i < W.length; i++) {
        var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
        var T2 = sum32$1(s0_256(a), maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = sum32$1(d, T1);
        d = c;
        c = b;
        b = a;
        a = sum32$1(T1, T2);
      }

      this.h[0] = sum32$1(this.h[0], a);
      this.h[1] = sum32$1(this.h[1], b);
      this.h[2] = sum32$1(this.h[2], c);
      this.h[3] = sum32$1(this.h[3], d);
      this.h[4] = sum32$1(this.h[4], e);
      this.h[5] = sum32$1(this.h[5], f);
      this.h[6] = sum32$1(this.h[6], g);
      this.h[7] = sum32$1(this.h[7], h);
    };

    SHA256$1.prototype._digest = function digest(enc) {
      if (enc === 'hex')
        return utils$c.toHex32(this.h, 'big');
      else
        return utils$c.split32(this.h, 'big');
    };

    var utils$b = utils$g;
    var SHA256 = _256;

    function SHA224() {
      if (!(this instanceof SHA224))
        return new SHA224();

      SHA256.call(this);
      this.h = [
        0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
        0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
    }
    utils$b.inherits(SHA224, SHA256);
    var _224 = SHA224;

    SHA224.blockSize = 512;
    SHA224.outSize = 224;
    SHA224.hmacStrength = 192;
    SHA224.padLength = 64;

    SHA224.prototype._digest = function digest(enc) {
      // Just truncate output
      if (enc === 'hex')
        return utils$b.toHex32(this.h.slice(0, 7), 'big');
      else
        return utils$b.split32(this.h.slice(0, 7), 'big');
    };

    var utils$a = utils$g;
    var common$1 = common$5;
    var assert$9 = minimalisticAssert;

    var rotr64_hi = utils$a.rotr64_hi;
    var rotr64_lo = utils$a.rotr64_lo;
    var shr64_hi = utils$a.shr64_hi;
    var shr64_lo = utils$a.shr64_lo;
    var sum64 = utils$a.sum64;
    var sum64_hi = utils$a.sum64_hi;
    var sum64_lo = utils$a.sum64_lo;
    var sum64_4_hi = utils$a.sum64_4_hi;
    var sum64_4_lo = utils$a.sum64_4_lo;
    var sum64_5_hi = utils$a.sum64_5_hi;
    var sum64_5_lo = utils$a.sum64_5_lo;

    var BlockHash$1 = common$1.BlockHash;

    var sha512_K = [
      0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
      0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
      0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
      0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
      0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
      0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
      0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
      0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
      0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
      0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
      0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
      0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
      0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
      0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
      0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
      0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
      0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
      0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
      0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
      0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
      0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
      0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
      0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
      0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
      0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
      0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
      0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
      0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
      0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
      0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
      0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
      0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
      0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
      0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
      0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
      0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
      0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
      0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
      0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
      0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
    ];

    function SHA512$1() {
      if (!(this instanceof SHA512$1))
        return new SHA512$1();

      BlockHash$1.call(this);
      this.h = [
        0x6a09e667, 0xf3bcc908,
        0xbb67ae85, 0x84caa73b,
        0x3c6ef372, 0xfe94f82b,
        0xa54ff53a, 0x5f1d36f1,
        0x510e527f, 0xade682d1,
        0x9b05688c, 0x2b3e6c1f,
        0x1f83d9ab, 0xfb41bd6b,
        0x5be0cd19, 0x137e2179 ];
      this.k = sha512_K;
      this.W = new Array(160);
    }
    utils$a.inherits(SHA512$1, BlockHash$1);
    var _512 = SHA512$1;

    SHA512$1.blockSize = 1024;
    SHA512$1.outSize = 512;
    SHA512$1.hmacStrength = 192;
    SHA512$1.padLength = 128;

    SHA512$1.prototype._prepareBlock = function _prepareBlock(msg, start) {
      var W = this.W;

      // 32 x 32bit words
      for (var i = 0; i < 32; i++)
        W[i] = msg[start + i];
      for (; i < W.length; i += 2) {
        var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
        var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14];  // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
        var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32];  // i - 16
        var c3_lo = W[i - 31];

        W[i] = sum64_4_hi(
          c0_hi, c0_lo,
          c1_hi, c1_lo,
          c2_hi, c2_lo,
          c3_hi, c3_lo);
        W[i + 1] = sum64_4_lo(
          c0_hi, c0_lo,
          c1_hi, c1_lo,
          c2_hi, c2_lo,
          c3_hi, c3_lo);
      }
    };

    SHA512$1.prototype._update = function _update(msg, start) {
      this._prepareBlock(msg, start);

      var W = this.W;

      var ah = this.h[0];
      var al = this.h[1];
      var bh = this.h[2];
      var bl = this.h[3];
      var ch = this.h[4];
      var cl = this.h[5];
      var dh = this.h[6];
      var dl = this.h[7];
      var eh = this.h[8];
      var el = this.h[9];
      var fh = this.h[10];
      var fl = this.h[11];
      var gh = this.h[12];
      var gl = this.h[13];
      var hh = this.h[14];
      var hl = this.h[15];

      assert$9(this.k.length === W.length);
      for (var i = 0; i < W.length; i += 2) {
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = s1_512_hi(eh, el);
        var c1_lo = s1_512_lo(eh, el);
        var c2_hi = ch64_hi(eh, el, fh, fl, gh);
        var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];

        var T1_hi = sum64_5_hi(
          c0_hi, c0_lo,
          c1_hi, c1_lo,
          c2_hi, c2_lo,
          c3_hi, c3_lo,
          c4_hi, c4_lo);
        var T1_lo = sum64_5_lo(
          c0_hi, c0_lo,
          c1_hi, c1_lo,
          c2_hi, c2_lo,
          c3_hi, c3_lo,
          c4_hi, c4_lo);

        c0_hi = s0_512_hi(ah, al);
        c0_lo = s0_512_lo(ah, al);
        c1_hi = maj64_hi(ah, al, bh, bl, ch);
        c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

        var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

        hh = gh;
        hl = gl;

        gh = fh;
        gl = fl;

        fh = eh;
        fl = el;

        eh = sum64_hi(dh, dl, T1_hi, T1_lo);
        el = sum64_lo(dl, dl, T1_hi, T1_lo);

        dh = ch;
        dl = cl;

        ch = bh;
        cl = bl;

        bh = ah;
        bl = al;

        ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
      }

      sum64(this.h, 0, ah, al);
      sum64(this.h, 2, bh, bl);
      sum64(this.h, 4, ch, cl);
      sum64(this.h, 6, dh, dl);
      sum64(this.h, 8, eh, el);
      sum64(this.h, 10, fh, fl);
      sum64(this.h, 12, gh, gl);
      sum64(this.h, 14, hh, hl);
    };

    SHA512$1.prototype._digest = function digest(enc) {
      if (enc === 'hex')
        return utils$a.toHex32(this.h, 'big');
      else
        return utils$a.split32(this.h, 'big');
    };

    function ch64_hi(xh, xl, yh, yl, zh) {
      var r = (xh & yh) ^ ((~xh) & zh);
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function ch64_lo(xh, xl, yh, yl, zh, zl) {
      var r = (xl & yl) ^ ((~xl) & zl);
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function maj64_hi(xh, xl, yh, yl, zh) {
      var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function maj64_lo(xh, xl, yh, yl, zh, zl) {
      var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function s0_512_hi(xh, xl) {
      var c0_hi = rotr64_hi(xh, xl, 28);
      var c1_hi = rotr64_hi(xl, xh, 2);  // 34
      var c2_hi = rotr64_hi(xl, xh, 7);  // 39

      var r = c0_hi ^ c1_hi ^ c2_hi;
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function s0_512_lo(xh, xl) {
      var c0_lo = rotr64_lo(xh, xl, 28);
      var c1_lo = rotr64_lo(xl, xh, 2);  // 34
      var c2_lo = rotr64_lo(xl, xh, 7);  // 39

      var r = c0_lo ^ c1_lo ^ c2_lo;
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function s1_512_hi(xh, xl) {
      var c0_hi = rotr64_hi(xh, xl, 14);
      var c1_hi = rotr64_hi(xh, xl, 18);
      var c2_hi = rotr64_hi(xl, xh, 9);  // 41

      var r = c0_hi ^ c1_hi ^ c2_hi;
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function s1_512_lo(xh, xl) {
      var c0_lo = rotr64_lo(xh, xl, 14);
      var c1_lo = rotr64_lo(xh, xl, 18);
      var c2_lo = rotr64_lo(xl, xh, 9);  // 41

      var r = c0_lo ^ c1_lo ^ c2_lo;
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function g0_512_hi(xh, xl) {
      var c0_hi = rotr64_hi(xh, xl, 1);
      var c1_hi = rotr64_hi(xh, xl, 8);
      var c2_hi = shr64_hi(xh, xl, 7);

      var r = c0_hi ^ c1_hi ^ c2_hi;
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function g0_512_lo(xh, xl) {
      var c0_lo = rotr64_lo(xh, xl, 1);
      var c1_lo = rotr64_lo(xh, xl, 8);
      var c2_lo = shr64_lo(xh, xl, 7);

      var r = c0_lo ^ c1_lo ^ c2_lo;
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function g1_512_hi(xh, xl) {
      var c0_hi = rotr64_hi(xh, xl, 19);
      var c1_hi = rotr64_hi(xl, xh, 29);  // 61
      var c2_hi = shr64_hi(xh, xl, 6);

      var r = c0_hi ^ c1_hi ^ c2_hi;
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function g1_512_lo(xh, xl) {
      var c0_lo = rotr64_lo(xh, xl, 19);
      var c1_lo = rotr64_lo(xl, xh, 29);  // 61
      var c2_lo = shr64_lo(xh, xl, 6);

      var r = c0_lo ^ c1_lo ^ c2_lo;
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    var utils$9 = utils$g;

    var SHA512 = _512;

    function SHA384() {
      if (!(this instanceof SHA384))
        return new SHA384();

      SHA512.call(this);
      this.h = [
        0xcbbb9d5d, 0xc1059ed8,
        0x629a292a, 0x367cd507,
        0x9159015a, 0x3070dd17,
        0x152fecd8, 0xf70e5939,
        0x67332667, 0xffc00b31,
        0x8eb44a87, 0x68581511,
        0xdb0c2e0d, 0x64f98fa7,
        0x47b5481d, 0xbefa4fa4 ];
    }
    utils$9.inherits(SHA384, SHA512);
    var _384 = SHA384;

    SHA384.blockSize = 1024;
    SHA384.outSize = 384;
    SHA384.hmacStrength = 192;
    SHA384.padLength = 128;

    SHA384.prototype._digest = function digest(enc) {
      if (enc === 'hex')
        return utils$9.toHex32(this.h.slice(0, 12), 'big');
      else
        return utils$9.split32(this.h.slice(0, 12), 'big');
    };

    sha.sha1 = _1;
    sha.sha224 = _224;
    sha.sha256 = _256;
    sha.sha384 = _384;
    sha.sha512 = _512;

    var ripemd = {};

    var utils$8 = utils$g;
    var common = common$5;

    var rotl32 = utils$8.rotl32;
    var sum32 = utils$8.sum32;
    var sum32_3 = utils$8.sum32_3;
    var sum32_4 = utils$8.sum32_4;
    var BlockHash = common.BlockHash;

    function RIPEMD160() {
      if (!(this instanceof RIPEMD160))
        return new RIPEMD160();

      BlockHash.call(this);

      this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
      this.endian = 'little';
    }
    utils$8.inherits(RIPEMD160, BlockHash);
    ripemd.ripemd160 = RIPEMD160;

    RIPEMD160.blockSize = 512;
    RIPEMD160.outSize = 160;
    RIPEMD160.hmacStrength = 192;
    RIPEMD160.padLength = 64;

    RIPEMD160.prototype._update = function update(msg, start) {
      var A = this.h[0];
      var B = this.h[1];
      var C = this.h[2];
      var D = this.h[3];
      var E = this.h[4];
      var Ah = A;
      var Bh = B;
      var Ch = C;
      var Dh = D;
      var Eh = E;
      for (var j = 0; j < 80; j++) {
        var T = sum32(
          rotl32(
            sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
            s[j]),
          E);
        A = E;
        E = D;
        D = rotl32(C, 10);
        C = B;
        B = T;
        T = sum32(
          rotl32(
            sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
            sh[j]),
          Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
      }
      T = sum32_3(this.h[1], C, Dh);
      this.h[1] = sum32_3(this.h[2], D, Eh);
      this.h[2] = sum32_3(this.h[3], E, Ah);
      this.h[3] = sum32_3(this.h[4], A, Bh);
      this.h[4] = sum32_3(this.h[0], B, Ch);
      this.h[0] = T;
    };

    RIPEMD160.prototype._digest = function digest(enc) {
      if (enc === 'hex')
        return utils$8.toHex32(this.h, 'little');
      else
        return utils$8.split32(this.h, 'little');
    };

    function f(j, x, y, z) {
      if (j <= 15)
        return x ^ y ^ z;
      else if (j <= 31)
        return (x & y) | ((~x) & z);
      else if (j <= 47)
        return (x | (~y)) ^ z;
      else if (j <= 63)
        return (x & z) | (y & (~z));
      else
        return x ^ (y | (~z));
    }

    function K(j) {
      if (j <= 15)
        return 0x00000000;
      else if (j <= 31)
        return 0x5a827999;
      else if (j <= 47)
        return 0x6ed9eba1;
      else if (j <= 63)
        return 0x8f1bbcdc;
      else
        return 0xa953fd4e;
    }

    function Kh(j) {
      if (j <= 15)
        return 0x50a28be6;
      else if (j <= 31)
        return 0x5c4dd124;
      else if (j <= 47)
        return 0x6d703ef3;
      else if (j <= 63)
        return 0x7a6d76e9;
      else
        return 0x00000000;
    }

    var r = [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
      7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
      3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
      1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
      4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
    ];

    var rh = [
      5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
      6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
      15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
      8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
      12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
    ];

    var s = [
      11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
      7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
      11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
      11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
      9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
    ];

    var sh = [
      8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
      9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
      9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
      15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
      8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
    ];

    var utils$7 = utils$g;
    var assert$8 = minimalisticAssert;

    function Hmac(hash, key, enc) {
      if (!(this instanceof Hmac))
        return new Hmac(hash, key, enc);
      this.Hash = hash;
      this.blockSize = hash.blockSize / 8;
      this.outSize = hash.outSize / 8;
      this.inner = null;
      this.outer = null;

      this._init(utils$7.toArray(key, enc));
    }
    var hmac = Hmac;

    Hmac.prototype._init = function init(key) {
      // Shorten key, if needed
      if (key.length > this.blockSize)
        key = new this.Hash().update(key).digest();
      assert$8(key.length <= this.blockSize);

      // Add padding to key
      for (var i = key.length; i < this.blockSize; i++)
        key.push(0);

      for (i = 0; i < key.length; i++)
        key[i] ^= 0x36;
      this.inner = new this.Hash().update(key);

      // 0x36 ^ 0x5c = 0x6a
      for (i = 0; i < key.length; i++)
        key[i] ^= 0x6a;
      this.outer = new this.Hash().update(key);
    };

    Hmac.prototype.update = function update(msg, enc) {
      this.inner.update(msg, enc);
      return this;
    };

    Hmac.prototype.digest = function digest(enc) {
      this.outer.update(this.inner.digest());
      return this.outer.digest(enc);
    };

    (function (exports) {
    	var hash = exports;

    	hash.utils = utils$g;
    	hash.common = common$5;
    	hash.sha = sha;
    	hash.ripemd = ripemd;
    	hash.hmac = hmac;

    	// Proxy hash functions to the main object
    	hash.sha1 = hash.sha.sha1;
    	hash.sha256 = hash.sha.sha256;
    	hash.sha224 = hash.sha.sha224;
    	hash.sha384 = hash.sha.sha384;
    	hash.sha512 = hash.sha.sha512;
    	hash.ripemd160 = hash.ripemd.ripemd160; 
    } (hash$2));

    var hashjs = /*@__PURE__*/getDefaultExportFromCjs(hash$2);

    var secp256k1$1;
    var hasRequiredSecp256k1;

    function requireSecp256k1 () {
    	if (hasRequiredSecp256k1) return secp256k1$1;
    	hasRequiredSecp256k1 = 1;
    	secp256k1$1 = {
    	  doubles: {
    	    step: 4,
    	    points: [
    	      [
    	        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
    	        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821',
    	      ],
    	      [
    	        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
    	        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf',
    	      ],
    	      [
    	        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
    	        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695',
    	      ],
    	      [
    	        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
    	        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9',
    	      ],
    	      [
    	        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
    	        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36',
    	      ],
    	      [
    	        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
    	        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f',
    	      ],
    	      [
    	        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
    	        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999',
    	      ],
    	      [
    	        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
    	        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09',
    	      ],
    	      [
    	        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
    	        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d',
    	      ],
    	      [
    	        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
    	        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088',
    	      ],
    	      [
    	        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
    	        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d',
    	      ],
    	      [
    	        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
    	        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8',
    	      ],
    	      [
    	        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
    	        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a',
    	      ],
    	      [
    	        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
    	        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453',
    	      ],
    	      [
    	        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
    	        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160',
    	      ],
    	      [
    	        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
    	        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0',
    	      ],
    	      [
    	        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
    	        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6',
    	      ],
    	      [
    	        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
    	        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589',
    	      ],
    	      [
    	        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
    	        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17',
    	      ],
    	      [
    	        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
    	        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda',
    	      ],
    	      [
    	        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
    	        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd',
    	      ],
    	      [
    	        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
    	        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2',
    	      ],
    	      [
    	        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
    	        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6',
    	      ],
    	      [
    	        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
    	        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f',
    	      ],
    	      [
    	        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
    	        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01',
    	      ],
    	      [
    	        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
    	        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3',
    	      ],
    	      [
    	        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
    	        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f',
    	      ],
    	      [
    	        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
    	        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7',
    	      ],
    	      [
    	        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
    	        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78',
    	      ],
    	      [
    	        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
    	        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1',
    	      ],
    	      [
    	        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
    	        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150',
    	      ],
    	      [
    	        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
    	        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82',
    	      ],
    	      [
    	        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
    	        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc',
    	      ],
    	      [
    	        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
    	        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b',
    	      ],
    	      [
    	        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
    	        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51',
    	      ],
    	      [
    	        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
    	        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45',
    	      ],
    	      [
    	        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
    	        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120',
    	      ],
    	      [
    	        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
    	        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84',
    	      ],
    	      [
    	        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
    	        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d',
    	      ],
    	      [
    	        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
    	        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d',
    	      ],
    	      [
    	        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
    	        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8',
    	      ],
    	      [
    	        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
    	        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8',
    	      ],
    	      [
    	        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
    	        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac',
    	      ],
    	      [
    	        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
    	        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f',
    	      ],
    	      [
    	        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
    	        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962',
    	      ],
    	      [
    	        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
    	        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907',
    	      ],
    	      [
    	        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
    	        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec',
    	      ],
    	      [
    	        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
    	        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d',
    	      ],
    	      [
    	        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
    	        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414',
    	      ],
    	      [
    	        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
    	        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd',
    	      ],
    	      [
    	        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
    	        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0',
    	      ],
    	      [
    	        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
    	        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811',
    	      ],
    	      [
    	        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
    	        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1',
    	      ],
    	      [
    	        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
    	        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c',
    	      ],
    	      [
    	        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
    	        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73',
    	      ],
    	      [
    	        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
    	        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd',
    	      ],
    	      [
    	        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
    	        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405',
    	      ],
    	      [
    	        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
    	        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589',
    	      ],
    	      [
    	        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
    	        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e',
    	      ],
    	      [
    	        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
    	        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27',
    	      ],
    	      [
    	        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
    	        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1',
    	      ],
    	      [
    	        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
    	        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482',
    	      ],
    	      [
    	        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
    	        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945',
    	      ],
    	      [
    	        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
    	        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573',
    	      ],
    	      [
    	        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
    	        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82',
    	      ],
    	    ],
    	  },
    	  naf: {
    	    wnd: 7,
    	    points: [
    	      [
    	        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
    	        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672',
    	      ],
    	      [
    	        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
    	        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6',
    	      ],
    	      [
    	        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
    	        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da',
    	      ],
    	      [
    	        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
    	        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37',
    	      ],
    	      [
    	        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
    	        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b',
    	      ],
    	      [
    	        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
    	        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81',
    	      ],
    	      [
    	        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
    	        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58',
    	      ],
    	      [
    	        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
    	        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77',
    	      ],
    	      [
    	        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
    	        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a',
    	      ],
    	      [
    	        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
    	        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c',
    	      ],
    	      [
    	        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
    	        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67',
    	      ],
    	      [
    	        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
    	        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402',
    	      ],
    	      [
    	        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
    	        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55',
    	      ],
    	      [
    	        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
    	        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482',
    	      ],
    	      [
    	        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
    	        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82',
    	      ],
    	      [
    	        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
    	        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396',
    	      ],
    	      [
    	        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
    	        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49',
    	      ],
    	      [
    	        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
    	        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf',
    	      ],
    	      [
    	        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
    	        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a',
    	      ],
    	      [
    	        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
    	        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7',
    	      ],
    	      [
    	        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
    	        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933',
    	      ],
    	      [
    	        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
    	        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a',
    	      ],
    	      [
    	        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
    	        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6',
    	      ],
    	      [
    	        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
    	        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37',
    	      ],
    	      [
    	        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
    	        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e',
    	      ],
    	      [
    	        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
    	        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6',
    	      ],
    	      [
    	        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
    	        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476',
    	      ],
    	      [
    	        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
    	        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40',
    	      ],
    	      [
    	        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
    	        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61',
    	      ],
    	      [
    	        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
    	        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683',
    	      ],
    	      [
    	        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
    	        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5',
    	      ],
    	      [
    	        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
    	        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b',
    	      ],
    	      [
    	        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
    	        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417',
    	      ],
    	      [
    	        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
    	        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868',
    	      ],
    	      [
    	        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
    	        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a',
    	      ],
    	      [
    	        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
    	        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6',
    	      ],
    	      [
    	        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
    	        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996',
    	      ],
    	      [
    	        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
    	        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e',
    	      ],
    	      [
    	        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
    	        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d',
    	      ],
    	      [
    	        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
    	        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2',
    	      ],
    	      [
    	        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
    	        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e',
    	      ],
    	      [
    	        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
    	        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437',
    	      ],
    	      [
    	        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
    	        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311',
    	      ],
    	      [
    	        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
    	        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4',
    	      ],
    	      [
    	        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
    	        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575',
    	      ],
    	      [
    	        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
    	        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d',
    	      ],
    	      [
    	        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
    	        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d',
    	      ],
    	      [
    	        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
    	        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629',
    	      ],
    	      [
    	        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
    	        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06',
    	      ],
    	      [
    	        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
    	        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374',
    	      ],
    	      [
    	        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
    	        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee',
    	      ],
    	      [
    	        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
    	        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1',
    	      ],
    	      [
    	        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
    	        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b',
    	      ],
    	      [
    	        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
    	        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661',
    	      ],
    	      [
    	        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
    	        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6',
    	      ],
    	      [
    	        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
    	        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e',
    	      ],
    	      [
    	        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
    	        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d',
    	      ],
    	      [
    	        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
    	        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc',
    	      ],
    	      [
    	        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
    	        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4',
    	      ],
    	      [
    	        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
    	        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c',
    	      ],
    	      [
    	        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
    	        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b',
    	      ],
    	      [
    	        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
    	        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913',
    	      ],
    	      [
    	        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
    	        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154',
    	      ],
    	      [
    	        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
    	        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865',
    	      ],
    	      [
    	        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
    	        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc',
    	      ],
    	      [
    	        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
    	        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224',
    	      ],
    	      [
    	        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
    	        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e',
    	      ],
    	      [
    	        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
    	        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6',
    	      ],
    	      [
    	        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
    	        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511',
    	      ],
    	      [
    	        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
    	        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b',
    	      ],
    	      [
    	        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
    	        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2',
    	      ],
    	      [
    	        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
    	        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c',
    	      ],
    	      [
    	        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
    	        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3',
    	      ],
    	      [
    	        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
    	        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d',
    	      ],
    	      [
    	        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
    	        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700',
    	      ],
    	      [
    	        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
    	        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4',
    	      ],
    	      [
    	        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
    	        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196',
    	      ],
    	      [
    	        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
    	        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4',
    	      ],
    	      [
    	        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
    	        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257',
    	      ],
    	      [
    	        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
    	        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13',
    	      ],
    	      [
    	        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
    	        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096',
    	      ],
    	      [
    	        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
    	        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38',
    	      ],
    	      [
    	        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
    	        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f',
    	      ],
    	      [
    	        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
    	        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448',
    	      ],
    	      [
    	        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
    	        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a',
    	      ],
    	      [
    	        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
    	        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4',
    	      ],
    	      [
    	        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
    	        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437',
    	      ],
    	      [
    	        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
    	        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7',
    	      ],
    	      [
    	        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
    	        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d',
    	      ],
    	      [
    	        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
    	        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a',
    	      ],
    	      [
    	        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
    	        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54',
    	      ],
    	      [
    	        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
    	        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77',
    	      ],
    	      [
    	        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
    	        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517',
    	      ],
    	      [
    	        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
    	        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10',
    	      ],
    	      [
    	        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
    	        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125',
    	      ],
    	      [
    	        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
    	        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e',
    	      ],
    	      [
    	        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
    	        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1',
    	      ],
    	      [
    	        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
    	        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2',
    	      ],
    	      [
    	        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
    	        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423',
    	      ],
    	      [
    	        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
    	        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8',
    	      ],
    	      [
    	        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
    	        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758',
    	      ],
    	      [
    	        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
    	        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375',
    	      ],
    	      [
    	        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
    	        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d',
    	      ],
    	      [
    	        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
    	        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec',
    	      ],
    	      [
    	        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
    	        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0',
    	      ],
    	      [
    	        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
    	        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c',
    	      ],
    	      [
    	        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
    	        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4',
    	      ],
    	      [
    	        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
    	        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f',
    	      ],
    	      [
    	        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
    	        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649',
    	      ],
    	      [
    	        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
    	        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826',
    	      ],
    	      [
    	        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
    	        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5',
    	      ],
    	      [
    	        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
    	        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87',
    	      ],
    	      [
    	        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
    	        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b',
    	      ],
    	      [
    	        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
    	        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc',
    	      ],
    	      [
    	        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
    	        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c',
    	      ],
    	      [
    	        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
    	        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f',
    	      ],
    	      [
    	        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
    	        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a',
    	      ],
    	      [
    	        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
    	        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46',
    	      ],
    	      [
    	        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
    	        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f',
    	      ],
    	      [
    	        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
    	        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03',
    	      ],
    	      [
    	        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
    	        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08',
    	      ],
    	      [
    	        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
    	        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8',
    	      ],
    	      [
    	        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
    	        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373',
    	      ],
    	      [
    	        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
    	        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3',
    	      ],
    	      [
    	        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
    	        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8',
    	      ],
    	      [
    	        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
    	        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1',
    	      ],
    	      [
    	        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
    	        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9',
    	      ],
    	    ],
    	  },
    	};
    	return secp256k1$1;
    }

    (function (exports) {

    	var curves = exports;

    	var hash = hash$2;
    	var curve$1 = curve;
    	var utils = utils$m;

    	var assert = utils.assert;

    	function PresetCurve(options) {
    	  if (options.type === 'short')
    	    this.curve = new curve$1.short(options);
    	  else if (options.type === 'edwards')
    	    this.curve = new curve$1.edwards(options);
    	  else
    	    this.curve = new curve$1.mont(options);
    	  this.g = this.curve.g;
    	  this.n = this.curve.n;
    	  this.hash = options.hash;

    	  assert(this.g.validate(), 'Invalid curve');
    	  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
    	}
    	curves.PresetCurve = PresetCurve;

    	function defineCurve(name, options) {
    	  Object.defineProperty(curves, name, {
    	    configurable: true,
    	    enumerable: true,
    	    get: function() {
    	      var curve = new PresetCurve(options);
    	      Object.defineProperty(curves, name, {
    	        configurable: true,
    	        enumerable: true,
    	        value: curve,
    	      });
    	      return curve;
    	    },
    	  });
    	}

    	defineCurve('p192', {
    	  type: 'short',
    	  prime: 'p192',
    	  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    	  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    	  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    	  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    	  hash: hash.sha256,
    	  gRed: false,
    	  g: [
    	    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    	    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
    	  ],
    	});

    	defineCurve('p224', {
    	  type: 'short',
    	  prime: 'p224',
    	  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    	  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    	  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    	  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    	  hash: hash.sha256,
    	  gRed: false,
    	  g: [
    	    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    	    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
    	  ],
    	});

    	defineCurve('p256', {
    	  type: 'short',
    	  prime: null,
    	  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    	  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    	  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    	  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    	  hash: hash.sha256,
    	  gRed: false,
    	  g: [
    	    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    	    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
    	  ],
    	});

    	defineCurve('p384', {
    	  type: 'short',
    	  prime: null,
    	  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
    	     'fffffffe ffffffff 00000000 00000000 ffffffff',
    	  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
    	     'fffffffe ffffffff 00000000 00000000 fffffffc',
    	  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
    	     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
    	  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
    	     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
    	  hash: hash.sha384,
    	  gRed: false,
    	  g: [
    	    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    	    '5502f25d bf55296c 3a545e38 72760ab7',
    	    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    	    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
    	  ],
    	});

    	defineCurve('p521', {
    	  type: 'short',
    	  prime: null,
    	  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
    	     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
    	     'ffffffff ffffffff ffffffff ffffffff ffffffff',
    	  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
    	     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
    	     'ffffffff ffffffff ffffffff ffffffff fffffffc',
    	  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
    	     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
    	     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
    	  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
    	     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
    	     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
    	  hash: hash.sha512,
    	  gRed: false,
    	  g: [
    	    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    	    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    	    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    	    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    	    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    	    '3fad0761 353c7086 a272c240 88be9476 9fd16650',
    	  ],
    	});

    	defineCurve('curve25519', {
    	  type: 'mont',
    	  prime: 'p25519',
    	  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    	  a: '76d06',
    	  b: '1',
    	  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    	  hash: hash.sha256,
    	  gRed: false,
    	  g: [
    	    '9',
    	  ],
    	});

    	defineCurve('ed25519', {
    	  type: 'edwards',
    	  prime: 'p25519',
    	  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    	  a: '-1',
    	  c: '1',
    	  // -121665 * (121666^(-1)) (mod P)
    	  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    	  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    	  hash: hash.sha256,
    	  gRed: false,
    	  g: [
    	    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    	    // 4/5
    	    '6666666666666666666666666666666666666666666666666666666666666658',
    	  ],
    	});

    	var pre;
    	try {
    	  pre = requireSecp256k1();
    	} catch (e) {
    	  pre = undefined;
    	}

    	defineCurve('secp256k1', {
    	  type: 'short',
    	  prime: 'k256',
    	  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    	  a: '0',
    	  b: '7',
    	  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    	  h: '1',
    	  hash: hash.sha256,

    	  // Precomputed endomorphism
    	  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    	  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    	  basis: [
    	    {
    	      a: '3086d221a7d46bcde86c90e49284eb15',
    	      b: '-e4437ed6010e88286f547fa90abfe4c3',
    	    },
    	    {
    	      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
    	      b: '3086d221a7d46bcde86c90e49284eb15',
    	    },
    	  ],

    	  gRed: false,
    	  g: [
    	    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    	    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    	    pre,
    	  ],
    	}); 
    } (curves$2));

    var hash$1 = hash$2;
    var utils$6 = utils$l;
    var assert$7 = minimalisticAssert;

    function HmacDRBG$1(options) {
      if (!(this instanceof HmacDRBG$1))
        return new HmacDRBG$1(options);
      this.hash = options.hash;
      this.predResist = !!options.predResist;

      this.outLen = this.hash.outSize;
      this.minEntropy = options.minEntropy || this.hash.hmacStrength;

      this._reseed = null;
      this.reseedInterval = null;
      this.K = null;
      this.V = null;

      var entropy = utils$6.toArray(options.entropy, options.entropyEnc || 'hex');
      var nonce = utils$6.toArray(options.nonce, options.nonceEnc || 'hex');
      var pers = utils$6.toArray(options.pers, options.persEnc || 'hex');
      assert$7(entropy.length >= (this.minEntropy / 8),
             'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
      this._init(entropy, nonce, pers);
    }
    var hmacDrbg = HmacDRBG$1;

    HmacDRBG$1.prototype._init = function init(entropy, nonce, pers) {
      var seed = entropy.concat(nonce).concat(pers);

      this.K = new Array(this.outLen / 8);
      this.V = new Array(this.outLen / 8);
      for (var i = 0; i < this.V.length; i++) {
        this.K[i] = 0x00;
        this.V[i] = 0x01;
      }

      this._update(seed);
      this._reseed = 1;
      this.reseedInterval = 0x1000000000000;  // 2^48
    };

    HmacDRBG$1.prototype._hmac = function hmac() {
      return new hash$1.hmac(this.hash, this.K);
    };

    HmacDRBG$1.prototype._update = function update(seed) {
      var kmac = this._hmac()
                     .update(this.V)
                     .update([ 0x00 ]);
      if (seed)
        kmac = kmac.update(seed);
      this.K = kmac.digest();
      this.V = this._hmac().update(this.V).digest();
      if (!seed)
        return;

      this.K = this._hmac()
                   .update(this.V)
                   .update([ 0x01 ])
                   .update(seed)
                   .digest();
      this.V = this._hmac().update(this.V).digest();
    };

    HmacDRBG$1.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
      // Optional entropy enc
      if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
      }

      entropy = utils$6.toArray(entropy, entropyEnc);
      add = utils$6.toArray(add, addEnc);

      assert$7(entropy.length >= (this.minEntropy / 8),
             'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

      this._update(entropy.concat(add || []));
      this._reseed = 1;
    };

    HmacDRBG$1.prototype.generate = function generate(len, enc, add, addEnc) {
      if (this._reseed > this.reseedInterval)
        throw new Error('Reseed is required');

      // Optional encoding
      if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
      }

      // Optional additional data
      if (add) {
        add = utils$6.toArray(add, addEnc || 'hex');
        this._update(add);
      }

      var temp = [];
      while (temp.length < len) {
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
      }

      var res = temp.slice(0, len);
      this._update(add);
      this._reseed++;
      return utils$6.encode(res, enc);
    };

    var BN$3 = bnExports;
    var utils$5 = utils$m;
    var assert$6 = utils$5.assert;

    function KeyPair$3(ec, options) {
      this.ec = ec;
      this.priv = null;
      this.pub = null;

      // KeyPair(ec, { priv: ..., pub: ... })
      if (options.priv)
        this._importPrivate(options.priv, options.privEnc);
      if (options.pub)
        this._importPublic(options.pub, options.pubEnc);
    }
    var key$1 = KeyPair$3;

    KeyPair$3.fromPublic = function fromPublic(ec, pub, enc) {
      if (pub instanceof KeyPair$3)
        return pub;

      return new KeyPair$3(ec, {
        pub: pub,
        pubEnc: enc,
      });
    };

    KeyPair$3.fromPrivate = function fromPrivate(ec, priv, enc) {
      if (priv instanceof KeyPair$3)
        return priv;

      return new KeyPair$3(ec, {
        priv: priv,
        privEnc: enc,
      });
    };

    KeyPair$3.prototype.validate = function validate() {
      var pub = this.getPublic();

      if (pub.isInfinity())
        return { result: false, reason: 'Invalid public key' };
      if (!pub.validate())
        return { result: false, reason: 'Public key is not a point' };
      if (!pub.mul(this.ec.curve.n).isInfinity())
        return { result: false, reason: 'Public key * N != O' };

      return { result: true, reason: null };
    };

    KeyPair$3.prototype.getPublic = function getPublic(compact, enc) {
      // compact is optional argument
      if (typeof compact === 'string') {
        enc = compact;
        compact = null;
      }

      if (!this.pub)
        this.pub = this.ec.g.mul(this.priv);

      if (!enc)
        return this.pub;

      return this.pub.encode(enc, compact);
    };

    KeyPair$3.prototype.getPrivate = function getPrivate(enc) {
      if (enc === 'hex')
        return this.priv.toString(16, 2);
      else
        return this.priv;
    };

    KeyPair$3.prototype._importPrivate = function _importPrivate(key, enc) {
      this.priv = new BN$3(key, enc || 16);

      // Ensure that the priv won't be bigger than n, otherwise we may fail
      // in fixed multiplication method
      this.priv = this.priv.umod(this.ec.curve.n);
    };

    KeyPair$3.prototype._importPublic = function _importPublic(key, enc) {
      if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') {
          assert$6(key.x, 'Need x coordinate');
        } else if (this.ec.curve.type === 'short' ||
                   this.ec.curve.type === 'edwards') {
          assert$6(key.x && key.y, 'Need both x and y coordinate');
        }
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
      }
      this.pub = this.ec.curve.decodePoint(key, enc);
    };

    // ECDH
    KeyPair$3.prototype.derive = function derive(pub) {
      if(!pub.validate()) {
        assert$6(pub.validate(), 'public point not validated');
      }
      return pub.mul(this.priv).getX();
    };

    // ECDSA
    KeyPair$3.prototype.sign = function sign(msg, enc, options) {
      return this.ec.sign(msg, this, enc, options);
    };

    KeyPair$3.prototype.verify = function verify(msg, signature) {
      return this.ec.verify(msg, signature, this);
    };

    KeyPair$3.prototype.inspect = function inspect() {
      return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
             ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
    };

    var BN$2 = bnExports;

    var utils$4 = utils$m;
    var assert$5 = utils$4.assert;

    function Signature$3(options, enc) {
      if (options instanceof Signature$3)
        return options;

      if (this._importDER(options, enc))
        return;

      assert$5(options.r && options.s, 'Signature without r or s');
      this.r = new BN$2(options.r, 16);
      this.s = new BN$2(options.s, 16);
      if (options.recoveryParam === undefined)
        this.recoveryParam = null;
      else
        this.recoveryParam = options.recoveryParam;
    }
    var signature$1 = Signature$3;

    function Position() {
      this.place = 0;
    }

    function getLength(buf, p) {
      var initial = buf[p.place++];
      if (!(initial & 0x80)) {
        return initial;
      }
      var octetLen = initial & 0xf;

      // Indefinite length or overflow
      if (octetLen === 0 || octetLen > 4) {
        return false;
      }

      var val = 0;
      for (var i = 0, off = p.place; i < octetLen; i++, off++) {
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
      }

      // Leading zeroes
      if (val <= 0x7f) {
        return false;
      }

      p.place = off;
      return val;
    }

    function rmPadding(buf) {
      var i = 0;
      var len = buf.length - 1;
      while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
        i++;
      }
      if (i === 0) {
        return buf;
      }
      return buf.slice(i);
    }

    Signature$3.prototype._importDER = function _importDER(data, enc) {
      data = utils$4.toArray(data, enc);
      var p = new Position();
      if (data[p.place++] !== 0x30) {
        return false;
      }
      var len = getLength(data, p);
      if (len === false) {
        return false;
      }
      if ((len + p.place) !== data.length) {
        return false;
      }
      if (data[p.place++] !== 0x02) {
        return false;
      }
      var rlen = getLength(data, p);
      if (rlen === false) {
        return false;
      }
      var r = data.slice(p.place, rlen + p.place);
      p.place += rlen;
      if (data[p.place++] !== 0x02) {
        return false;
      }
      var slen = getLength(data, p);
      if (slen === false) {
        return false;
      }
      if (data.length !== slen + p.place) {
        return false;
      }
      var s = data.slice(p.place, slen + p.place);
      if (r[0] === 0) {
        if (r[1] & 0x80) {
          r = r.slice(1);
        } else {
          // Leading zeroes
          return false;
        }
      }
      if (s[0] === 0) {
        if (s[1] & 0x80) {
          s = s.slice(1);
        } else {
          // Leading zeroes
          return false;
        }
      }

      this.r = new BN$2(r);
      this.s = new BN$2(s);
      this.recoveryParam = null;

      return true;
    };

    function constructLength(arr, len) {
      if (len < 0x80) {
        arr.push(len);
        return;
      }
      var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
      arr.push(octets | 0x80);
      while (--octets) {
        arr.push((len >>> (octets << 3)) & 0xff);
      }
      arr.push(len);
    }

    Signature$3.prototype.toDER = function toDER(enc) {
      var r = this.r.toArray();
      var s = this.s.toArray();

      // Pad values
      if (r[0] & 0x80)
        r = [ 0 ].concat(r);
      // Pad values
      if (s[0] & 0x80)
        s = [ 0 ].concat(s);

      r = rmPadding(r);
      s = rmPadding(s);

      while (!s[0] && !(s[1] & 0x80)) {
        s = s.slice(1);
      }
      var arr = [ 0x02 ];
      constructLength(arr, r.length);
      arr = arr.concat(r);
      arr.push(0x02);
      constructLength(arr, s.length);
      var backHalf = arr.concat(s);
      var res = [ 0x30 ];
      constructLength(res, backHalf.length);
      res = res.concat(backHalf);
      return utils$4.encode(res, enc);
    };

    var BN$1 = bnExports;
    var HmacDRBG = hmacDrbg;
    var utils$3 = utils$m;
    var curves$1 = curves$2;
    var rand = brorandExports;
    var assert$4 = utils$3.assert;

    var KeyPair$2 = key$1;
    var Signature$2 = signature$1;

    function EC(options) {
      if (!(this instanceof EC))
        return new EC(options);

      // Shortcut `elliptic.ec(curve-name)`
      if (typeof options === 'string') {
        assert$4(Object.prototype.hasOwnProperty.call(curves$1, options),
          'Unknown curve ' + options);

        options = curves$1[options];
      }

      // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
      if (options instanceof curves$1.PresetCurve)
        options = { curve: options };

      this.curve = options.curve.curve;
      this.n = this.curve.n;
      this.nh = this.n.ushrn(1);
      this.g = this.curve.g;

      // Point on curve
      this.g = options.curve.g;
      this.g.precompute(options.curve.n.bitLength() + 1);

      // Hash for function for DRBG
      this.hash = options.hash || options.curve.hash;
    }
    var ec = EC;

    EC.prototype.keyPair = function keyPair(options) {
      return new KeyPair$2(this, options);
    };

    EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
      return KeyPair$2.fromPrivate(this, priv, enc);
    };

    EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
      return KeyPair$2.fromPublic(this, pub, enc);
    };

    EC.prototype.genKeyPair = function genKeyPair(options) {
      if (!options)
        options = {};

      // Instantiate Hmac_DRBG
      var drbg = new HmacDRBG({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray(),
      });

      var bytes = this.n.byteLength();
      var ns2 = this.n.sub(new BN$1(2));
      for (;;) {
        var priv = new BN$1(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0)
          continue;

        priv.iaddn(1);
        return this.keyFromPrivate(priv);
      }
    };

    EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
      var delta = msg.byteLength() * 8 - this.n.bitLength();
      if (delta > 0)
        msg = msg.ushrn(delta);
      if (!truncOnly && msg.cmp(this.n) >= 0)
        return msg.sub(this.n);
      else
        return msg;
    };

    EC.prototype.sign = function sign(msg, key, enc, options) {
      if (typeof enc === 'object') {
        options = enc;
        enc = null;
      }
      if (!options)
        options = {};

      key = this.keyFromPrivate(key, enc);
      msg = this._truncateToN(new BN$1(msg, 16));

      // Zero-extend key to provide enough entropy
      var bytes = this.n.byteLength();
      var bkey = key.getPrivate().toArray('be', bytes);

      // Zero-extend nonce to have the same byte size as N
      var nonce = msg.toArray('be', bytes);

      // Instantiate Hmac_DRBG
      var drbg = new HmacDRBG({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
      });

      // Number of bytes to generate
      var ns1 = this.n.sub(new BN$1(1));

      for (var iter = 0; ; iter++) {
        var k = options.k ?
          options.k(iter) :
          new BN$1(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
          continue;

        var kp = this.g.mul(k);
        if (kp.isInfinity())
          continue;

        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0)
          continue;

        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0)
          continue;

        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                            (kpX.cmp(r) !== 0 ? 2 : 0);

        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
          s = this.n.sub(s);
          recoveryParam ^= 1;
        }

        return new Signature$2({ r: r, s: s, recoveryParam: recoveryParam });
      }
    };

    EC.prototype.verify = function verify(msg, signature, key, enc) {
      msg = this._truncateToN(new BN$1(msg, 16));
      key = this.keyFromPublic(key, enc);
      signature = new Signature$2(signature, 'hex');

      // Perform primitive values validation
      var r = signature.r;
      var s = signature.s;
      if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
        return false;
      if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
        return false;

      // Validate signature
      var sinv = s.invm(this.n);
      var u1 = sinv.mul(msg).umod(this.n);
      var u2 = sinv.mul(r).umod(this.n);
      var p;

      if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity())
          return false;

        return p.getX().umod(this.n).cmp(r) === 0;
      }

      // NOTE: Greg Maxwell's trick, inspired by:
      // https://git.io/vad3K

      p = this.g.jmulAdd(u1, key.getPublic(), u2);
      if (p.isInfinity())
        return false;

      // Compare `p.x` of Jacobian point with `r`,
      // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
      // inverse of `p.z^2`
      return p.eqXToP(r);
    };

    EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
      assert$4((3 & j) === j, 'The recovery param is more than two bits');
      signature = new Signature$2(signature, enc);

      var n = this.n;
      var e = new BN$1(msg);
      var r = signature.r;
      var s = signature.s;

      // A set LSB signifies that the y-coordinate is odd
      var isYOdd = j & 1;
      var isSecondKey = j >> 1;
      if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
        throw new Error('Unable to find sencond key candinate');

      // 1.1. Let x = r + jn.
      if (isSecondKey)
        r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
      else
        r = this.curve.pointFromX(r, isYOdd);

      var rInv = signature.r.invm(n);
      var s1 = n.sub(e).mul(rInv).umod(n);
      var s2 = s.mul(rInv).umod(n);

      // 1.6.1 Compute Q = r^-1 (sR -  eG)
      //               Q = r^-1 (sR + -eG)
      return this.g.mulAdd(s1, r, s2);
    };

    EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
      signature = new Signature$2(signature, enc);
      if (signature.recoveryParam !== null)
        return signature.recoveryParam;

      for (var i = 0; i < 4; i++) {
        var Qprime;
        try {
          Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
          continue;
        }

        if (Qprime.eq(Q))
          return i;
      }
      throw new Error('Unable to find valid recovery factor');
    };

    var utils$2 = utils$m;
    var assert$3 = utils$2.assert;
    var parseBytes$2 = utils$2.parseBytes;
    var cachedProperty$1 = utils$2.cachedProperty;

    /**
    * @param {EDDSA} eddsa - instance
    * @param {Object} params - public/private key parameters
    *
    * @param {Array<Byte>} [params.secret] - secret seed bytes
    * @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
    * @param {Array<Byte>} [params.pub] - public key point encoded as bytes
    *
    */
    function KeyPair$1(eddsa, params) {
      this.eddsa = eddsa;
      this._secret = parseBytes$2(params.secret);
      if (eddsa.isPoint(params.pub))
        this._pub = params.pub;
      else
        this._pubBytes = parseBytes$2(params.pub);
    }

    KeyPair$1.fromPublic = function fromPublic(eddsa, pub) {
      if (pub instanceof KeyPair$1)
        return pub;
      return new KeyPair$1(eddsa, { pub: pub });
    };

    KeyPair$1.fromSecret = function fromSecret(eddsa, secret) {
      if (secret instanceof KeyPair$1)
        return secret;
      return new KeyPair$1(eddsa, { secret: secret });
    };

    KeyPair$1.prototype.secret = function secret() {
      return this._secret;
    };

    cachedProperty$1(KeyPair$1, 'pubBytes', function pubBytes() {
      return this.eddsa.encodePoint(this.pub());
    });

    cachedProperty$1(KeyPair$1, 'pub', function pub() {
      if (this._pubBytes)
        return this.eddsa.decodePoint(this._pubBytes);
      return this.eddsa.g.mul(this.priv());
    });

    cachedProperty$1(KeyPair$1, 'privBytes', function privBytes() {
      var eddsa = this.eddsa;
      var hash = this.hash();
      var lastIx = eddsa.encodingLength - 1;

      var a = hash.slice(0, eddsa.encodingLength);
      a[0] &= 248;
      a[lastIx] &= 127;
      a[lastIx] |= 64;

      return a;
    });

    cachedProperty$1(KeyPair$1, 'priv', function priv() {
      return this.eddsa.decodeInt(this.privBytes());
    });

    cachedProperty$1(KeyPair$1, 'hash', function hash() {
      return this.eddsa.hash().update(this.secret()).digest();
    });

    cachedProperty$1(KeyPair$1, 'messagePrefix', function messagePrefix() {
      return this.hash().slice(this.eddsa.encodingLength);
    });

    KeyPair$1.prototype.sign = function sign(message) {
      assert$3(this._secret, 'KeyPair can only verify');
      return this.eddsa.sign(message, this);
    };

    KeyPair$1.prototype.verify = function verify(message, sig) {
      return this.eddsa.verify(message, sig, this);
    };

    KeyPair$1.prototype.getSecret = function getSecret(enc) {
      assert$3(this._secret, 'KeyPair is public only');
      return utils$2.encode(this.secret(), enc);
    };

    KeyPair$1.prototype.getPublic = function getPublic(enc) {
      return utils$2.encode(this.pubBytes(), enc);
    };

    var key = KeyPair$1;

    var BN = bnExports;
    var utils$1 = utils$m;
    var assert$2 = utils$1.assert;
    var cachedProperty = utils$1.cachedProperty;
    var parseBytes$1 = utils$1.parseBytes;

    /**
    * @param {EDDSA} eddsa - eddsa instance
    * @param {Array<Bytes>|Object} sig -
    * @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
    * @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
    * @param {Array<Bytes>} [sig.Rencoded] - R point encoded
    * @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
    */
    function Signature$1(eddsa, sig) {
      this.eddsa = eddsa;

      if (typeof sig !== 'object')
        sig = parseBytes$1(sig);

      if (Array.isArray(sig)) {
        sig = {
          R: sig.slice(0, eddsa.encodingLength),
          S: sig.slice(eddsa.encodingLength),
        };
      }

      assert$2(sig.R && sig.S, 'Signature without R or S');

      if (eddsa.isPoint(sig.R))
        this._R = sig.R;
      if (sig.S instanceof BN)
        this._S = sig.S;

      this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
      this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
    }

    cachedProperty(Signature$1, 'S', function S() {
      return this.eddsa.decodeInt(this.Sencoded());
    });

    cachedProperty(Signature$1, 'R', function R() {
      return this.eddsa.decodePoint(this.Rencoded());
    });

    cachedProperty(Signature$1, 'Rencoded', function Rencoded() {
      return this.eddsa.encodePoint(this.R());
    });

    cachedProperty(Signature$1, 'Sencoded', function Sencoded() {
      return this.eddsa.encodeInt(this.S());
    });

    Signature$1.prototype.toBytes = function toBytes() {
      return this.Rencoded().concat(this.Sencoded());
    };

    Signature$1.prototype.toHex = function toHex() {
      return utils$1.encode(this.toBytes(), 'hex').toUpperCase();
    };

    var signature = Signature$1;

    var hash = hash$2;
    var curves = curves$2;
    var utils = utils$m;
    var assert$1 = utils.assert;
    var parseBytes = utils.parseBytes;
    var KeyPair = key;
    var Signature = signature;

    function EDDSA(curve) {
      assert$1(curve === 'ed25519', 'only tested with ed25519 so far');

      if (!(this instanceof EDDSA))
        return new EDDSA(curve);

      curve = curves[curve].curve;
      this.curve = curve;
      this.g = curve.g;
      this.g.precompute(curve.n.bitLength() + 1);

      this.pointClass = curve.point().constructor;
      this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
      this.hash = hash.sha512;
    }

    var eddsa = EDDSA;

    /**
    * @param {Array|String} message - message bytes
    * @param {Array|String|KeyPair} secret - secret bytes or a keypair
    * @returns {Signature} - signature
    */
    EDDSA.prototype.sign = function sign(message, secret) {
      message = parseBytes(message);
      var key = this.keyFromSecret(secret);
      var r = this.hashInt(key.messagePrefix(), message);
      var R = this.g.mul(r);
      var Rencoded = this.encodePoint(R);
      var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
        .mul(key.priv());
      var S = r.add(s_).umod(this.curve.n);
      return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
    };

    /**
    * @param {Array} message - message bytes
    * @param {Array|String|Signature} sig - sig bytes
    * @param {Array|String|Point|KeyPair} pub - public key
    * @returns {Boolean} - true if public key matches sig of message
    */
    EDDSA.prototype.verify = function verify(message, sig, pub) {
      message = parseBytes(message);
      sig = this.makeSignature(sig);
      var key = this.keyFromPublic(pub);
      var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
      var SG = this.g.mul(sig.S());
      var RplusAh = sig.R().add(key.pub().mul(h));
      return RplusAh.eq(SG);
    };

    EDDSA.prototype.hashInt = function hashInt() {
      var hash = this.hash();
      for (var i = 0; i < arguments.length; i++)
        hash.update(arguments[i]);
      return utils.intFromLE(hash.digest()).umod(this.curve.n);
    };

    EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
      return KeyPair.fromPublic(this, pub);
    };

    EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
      return KeyPair.fromSecret(this, secret);
    };

    EDDSA.prototype.makeSignature = function makeSignature(sig) {
      if (sig instanceof Signature)
        return sig;
      return new Signature(this, sig);
    };

    /**
    * * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
    *
    * EDDSA defines methods for encoding and decoding points and integers. These are
    * helper convenience methods, that pass along to utility functions implied
    * parameters.
    *
    */
    EDDSA.prototype.encodePoint = function encodePoint(point) {
      var enc = point.getY().toArray('le', this.encodingLength);
      enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
      return enc;
    };

    EDDSA.prototype.decodePoint = function decodePoint(bytes) {
      bytes = utils.parseBytes(bytes);

      var lastIx = bytes.length - 1;
      var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
      var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

      var y = utils.intFromLE(normed);
      return this.curve.pointFromY(y, xIsOdd);
    };

    EDDSA.prototype.encodeInt = function encodeInt(num) {
      return num.toArray('le', this.encodingLength);
    };

    EDDSA.prototype.decodeInt = function decodeInt(bytes) {
      return utils.intFromLE(bytes);
    };

    EDDSA.prototype.isPoint = function isPoint(val) {
      return val instanceof this.pointClass;
    };

    (function (exports) {

    	var elliptic = exports;

    	elliptic.version = require$$0.version;
    	elliptic.utils = utils$m;
    	elliptic.rand = brorandExports;
    	elliptic.curve = curve;
    	elliptic.curves = curves$2;

    	// Protocols
    	elliptic.ec = ec;
    	elliptic.eddsa = eddsa; 
    } (elliptic$1));

    (function (exports) {
    	var Buffer = safeBufferExports.Buffer;
    	var createHash = browser$2;
    	var BN = bnExports;
    	var EC = elliptic$1.ec;

    	var messages = require$$4;

    	var ec = new EC('secp256k1');
    	var ecparams = ec.curve;

    	function loadCompressedPublicKey (first, xBuffer) {
    	  var x = new BN(xBuffer);

    	  // overflow
    	  if (x.cmp(ecparams.p) >= 0) return null
    	  x = x.toRed(ecparams.red);

    	  // compute corresponding Y
    	  var y = x.redSqr().redIMul(x).redIAdd(ecparams.b).redSqrt();
    	  if ((first === 0x03) !== y.isOdd()) y = y.redNeg();

    	  return ec.keyPair({ pub: { x: x, y: y } })
    	}

    	function loadUncompressedPublicKey (first, xBuffer, yBuffer) {
    	  var x = new BN(xBuffer);
    	  var y = new BN(yBuffer);

    	  // overflow
    	  if (x.cmp(ecparams.p) >= 0 || y.cmp(ecparams.p) >= 0) return null

    	  x = x.toRed(ecparams.red);
    	  y = y.toRed(ecparams.red);

    	  // is odd flag
    	  if ((first === 0x06 || first === 0x07) && y.isOdd() !== (first === 0x07)) return null

    	  // x*x*x + b = y*y
    	  var x3 = x.redSqr().redIMul(x);
    	  if (!y.redSqr().redISub(x3.redIAdd(ecparams.b)).isZero()) return null

    	  return ec.keyPair({ pub: { x: x, y: y } })
    	}

    	function loadPublicKey (publicKey) {
    	  var first = publicKey[0];
    	  switch (first) {
    	    case 0x02:
    	    case 0x03:
    	      if (publicKey.length !== 33) return null
    	      return loadCompressedPublicKey(first, publicKey.slice(1, 33))
    	    case 0x04:
    	    case 0x06:
    	    case 0x07:
    	      if (publicKey.length !== 65) return null
    	      return loadUncompressedPublicKey(first, publicKey.slice(1, 33), publicKey.slice(33, 65))
    	    default:
    	      return null
    	  }
    	}

    	exports.privateKeyVerify = function (privateKey) {
    	  var bn = new BN(privateKey);
    	  return bn.cmp(ecparams.n) < 0 && !bn.isZero()
    	};

    	exports.privateKeyExport = function (privateKey, compressed) {
    	  var d = new BN(privateKey);
    	  if (d.cmp(ecparams.n) >= 0 || d.isZero()) throw new Error(messages.EC_PRIVATE_KEY_EXPORT_DER_FAIL)

    	  return Buffer.from(ec.keyFromPrivate(privateKey).getPublic(compressed, true))
    	};

    	exports.privateKeyNegate = function (privateKey) {
    	  var bn = new BN(privateKey);
    	  return bn.isZero() ? Buffer.alloc(32) : ecparams.n.sub(bn).umod(ecparams.n).toArrayLike(Buffer, 'be', 32)
    	};

    	exports.privateKeyModInverse = function (privateKey) {
    	  var bn = new BN(privateKey);
    	  if (bn.cmp(ecparams.n) >= 0 || bn.isZero()) throw new Error(messages.EC_PRIVATE_KEY_RANGE_INVALID)

    	  return bn.invm(ecparams.n).toArrayLike(Buffer, 'be', 32)
    	};

    	exports.privateKeyTweakAdd = function (privateKey, tweak) {
    	  var bn = new BN(tweak);
    	  if (bn.cmp(ecparams.n) >= 0) throw new Error(messages.EC_PRIVATE_KEY_TWEAK_ADD_FAIL)

    	  bn.iadd(new BN(privateKey));
    	  if (bn.cmp(ecparams.n) >= 0) bn.isub(ecparams.n);
    	  if (bn.isZero()) throw new Error(messages.EC_PRIVATE_KEY_TWEAK_ADD_FAIL)

    	  return bn.toArrayLike(Buffer, 'be', 32)
    	};

    	exports.privateKeyTweakMul = function (privateKey, tweak) {
    	  var bn = new BN(tweak);
    	  if (bn.cmp(ecparams.n) >= 0 || bn.isZero()) throw new Error(messages.EC_PRIVATE_KEY_TWEAK_MUL_FAIL)

    	  bn.imul(new BN(privateKey));
    	  if (bn.cmp(ecparams.n)) bn = bn.umod(ecparams.n);

    	  return bn.toArrayLike(Buffer, 'be', 32)
    	};

    	exports.publicKeyCreate = function (privateKey, compressed) {
    	  var d = new BN(privateKey);
    	  if (d.cmp(ecparams.n) >= 0 || d.isZero()) throw new Error(messages.EC_PUBLIC_KEY_CREATE_FAIL)

    	  return Buffer.from(ec.keyFromPrivate(privateKey).getPublic(compressed, true))
    	};

    	exports.publicKeyConvert = function (publicKey, compressed) {
    	  var pair = loadPublicKey(publicKey);
    	  if (pair === null) throw new Error(messages.EC_PUBLIC_KEY_PARSE_FAIL)

    	  return Buffer.from(pair.getPublic(compressed, true))
    	};

    	exports.publicKeyVerify = function (publicKey) {
    	  return loadPublicKey(publicKey) !== null
    	};

    	exports.publicKeyTweakAdd = function (publicKey, tweak, compressed) {
    	  var pair = loadPublicKey(publicKey);
    	  if (pair === null) throw new Error(messages.EC_PUBLIC_KEY_PARSE_FAIL)

    	  tweak = new BN(tweak);
    	  if (tweak.cmp(ecparams.n) >= 0) throw new Error(messages.EC_PUBLIC_KEY_TWEAK_ADD_FAIL)

    	  var point = ecparams.g.mul(tweak).add(pair.pub);
    	  if (point.isInfinity()) throw new Error(messages.EC_PUBLIC_KEY_TWEAK_ADD_FAIL)

    	  return Buffer.from(point.encode(true, compressed))
    	};

    	exports.publicKeyTweakMul = function (publicKey, tweak, compressed) {
    	  var pair = loadPublicKey(publicKey);
    	  if (pair === null) throw new Error(messages.EC_PUBLIC_KEY_PARSE_FAIL)

    	  tweak = new BN(tweak);
    	  if (tweak.cmp(ecparams.n) >= 0 || tweak.isZero()) throw new Error(messages.EC_PUBLIC_KEY_TWEAK_MUL_FAIL)

    	  return Buffer.from(pair.pub.mul(tweak).encode(true, compressed))
    	};

    	exports.publicKeyCombine = function (publicKeys, compressed) {
    	  var pairs = new Array(publicKeys.length);
    	  for (var i = 0; i < publicKeys.length; ++i) {
    	    pairs[i] = loadPublicKey(publicKeys[i]);
    	    if (pairs[i] === null) throw new Error(messages.EC_PUBLIC_KEY_PARSE_FAIL)
    	  }

    	  var point = pairs[0].pub;
    	  for (var j = 1; j < pairs.length; ++j) point = point.add(pairs[j].pub);
    	  if (point.isInfinity()) throw new Error(messages.EC_PUBLIC_KEY_COMBINE_FAIL)

    	  return Buffer.from(point.encode(true, compressed))
    	};

    	exports.signatureNormalize = function (signature) {
    	  var r = new BN(signature.slice(0, 32));
    	  var s = new BN(signature.slice(32, 64));
    	  if (r.cmp(ecparams.n) >= 0 || s.cmp(ecparams.n) >= 0) throw new Error(messages.ECDSA_SIGNATURE_PARSE_FAIL)

    	  var result = Buffer.from(signature);
    	  if (s.cmp(ec.nh) === 1) ecparams.n.sub(s).toArrayLike(Buffer, 'be', 32).copy(result, 32);

    	  return result
    	};

    	exports.signatureExport = function (signature) {
    	  var r = signature.slice(0, 32);
    	  var s = signature.slice(32, 64);
    	  if (new BN(r).cmp(ecparams.n) >= 0 || new BN(s).cmp(ecparams.n) >= 0) throw new Error(messages.ECDSA_SIGNATURE_PARSE_FAIL)

    	  return { r: r, s: s }
    	};

    	exports.signatureImport = function (sigObj) {
    	  var r = new BN(sigObj.r);
    	  if (r.cmp(ecparams.n) >= 0) r = new BN(0);

    	  var s = new BN(sigObj.s);
    	  if (s.cmp(ecparams.n) >= 0) s = new BN(0);

    	  return Buffer.concat([
    	    r.toArrayLike(Buffer, 'be', 32),
    	    s.toArrayLike(Buffer, 'be', 32)
    	  ])
    	};

    	exports.sign = function (message, privateKey, noncefn, data) {
    	  if (typeof noncefn === 'function') {
    	    var getNonce = noncefn;
    	    noncefn = function (counter) {
    	      var nonce = getNonce(message, privateKey, null, data, counter);
    	      if (!Buffer.isBuffer(nonce) || nonce.length !== 32) throw new Error(messages.ECDSA_SIGN_FAIL)

    	      return new BN(nonce)
    	    };
    	  }

    	  var d = new BN(privateKey);
    	  if (d.cmp(ecparams.n) >= 0 || d.isZero()) throw new Error(messages.ECDSA_SIGN_FAIL)

    	  var result = ec.sign(message, privateKey, { canonical: true, k: noncefn, pers: data });
    	  return {
    	    signature: Buffer.concat([
    	      result.r.toArrayLike(Buffer, 'be', 32),
    	      result.s.toArrayLike(Buffer, 'be', 32)
    	    ]),
    	    recovery: result.recoveryParam
    	  }
    	};

    	exports.verify = function (message, signature, publicKey) {
    	  var sigObj = { r: signature.slice(0, 32), s: signature.slice(32, 64) };

    	  var sigr = new BN(sigObj.r);
    	  var sigs = new BN(sigObj.s);
    	  if (sigr.cmp(ecparams.n) >= 0 || sigs.cmp(ecparams.n) >= 0) throw new Error(messages.ECDSA_SIGNATURE_PARSE_FAIL)
    	  if (sigs.cmp(ec.nh) === 1 || sigr.isZero() || sigs.isZero()) return false

    	  var pair = loadPublicKey(publicKey);
    	  if (pair === null) throw new Error(messages.EC_PUBLIC_KEY_PARSE_FAIL)

    	  return ec.verify(message, sigObj, { x: pair.pub.x, y: pair.pub.y })
    	};

    	exports.recover = function (message, signature, recovery, compressed) {
    	  var sigObj = { r: signature.slice(0, 32), s: signature.slice(32, 64) };

    	  var sigr = new BN(sigObj.r);
    	  var sigs = new BN(sigObj.s);
    	  if (sigr.cmp(ecparams.n) >= 0 || sigs.cmp(ecparams.n) >= 0) throw new Error(messages.ECDSA_SIGNATURE_PARSE_FAIL)

    	  try {
    	    if (sigr.isZero() || sigs.isZero()) throw new Error()

    	    var point = ec.recoverPubKey(message, sigObj, recovery);
    	    return Buffer.from(point.encode(true, compressed))
    	  } catch (err) {
    	    throw new Error(messages.ECDSA_RECOVER_FAIL)
    	  }
    	};

    	exports.ecdh = function (publicKey, privateKey) {
    	  var shared = exports.ecdhUnsafe(publicKey, privateKey, true);
    	  return createHash('sha256').update(shared).digest()
    	};

    	exports.ecdhUnsafe = function (publicKey, privateKey, compressed) {
    	  var pair = loadPublicKey(publicKey);
    	  if (pair === null) throw new Error(messages.EC_PUBLIC_KEY_PARSE_FAIL)

    	  var scalar = new BN(privateKey);
    	  if (scalar.cmp(ecparams.n) >= 0 || scalar.isZero()) throw new Error(messages.ECDH_FAIL)

    	  return Buffer.from(pair.pub.mul(scalar).encode(true, compressed))
    	}; 
    } (elliptic$2));

    var elliptic = lib(elliptic$2);

    var assert = require$$0$1;
    var Buffer$1 = safeBufferExports.Buffer;
    var crypto$1 = require$$2;
    var bs58check = bs58check$1;
    var secp256k1 = elliptic;

    var MASTER_SECRET = Buffer$1.from('Bitcoin seed', 'utf8');
    var HARDENED_OFFSET = 0x80000000;
    var LEN = 78;

    // Bitcoin hardcoded by default, can use package `coininfo` for others
    var BITCOIN_VERSIONS = {private: 0x0488ADE4, public: 0x0488B21E};

    function HDKey (versions) {
      this.versions = versions || BITCOIN_VERSIONS;
      this.depth = 0;
      this.index = 0;
      this._privateKey = null;
      this._publicKey = null;
      this.chainCode = null;
      this._fingerprint = 0;
      this.parentFingerprint = 0;
    }

    Object.defineProperty(HDKey.prototype, 'fingerprint', { get: function () { return this._fingerprint } });
    Object.defineProperty(HDKey.prototype, 'identifier', { get: function () { return this._identifier } });
    Object.defineProperty(HDKey.prototype, 'pubKeyHash', { get: function () { return this.identifier } });

    Object.defineProperty(HDKey.prototype, 'privateKey', {
      get: function () {
        return this._privateKey
      },
      set: function (value) {
        assert.equal(value.length, 32, 'Private key must be 32 bytes.');
        assert(secp256k1.privateKeyVerify(value) === true, 'Invalid private key');

        this._privateKey = value;
        this._publicKey = secp256k1.publicKeyCreate(value, true);
        this._identifier = hash160(this.publicKey);
        this._fingerprint = this._identifier.slice(0, 4).readUInt32BE(0);
      }
    });

    Object.defineProperty(HDKey.prototype, 'publicKey', {
      get: function () {
        return this._publicKey
      },
      set: function (value) {
        assert(value.length === 33 || value.length === 65, 'Public key must be 33 or 65 bytes.');
        assert(secp256k1.publicKeyVerify(value) === true, 'Invalid public key');

        this._publicKey = secp256k1.publicKeyConvert(value, true); // force compressed point
        this._identifier = hash160(this.publicKey);
        this._fingerprint = this._identifier.slice(0, 4).readUInt32BE(0);
        this._privateKey = null;
      }
    });

    Object.defineProperty(HDKey.prototype, 'privateExtendedKey', {
      get: function () {
        if (this._privateKey) return bs58check.encode(serialize(this, this.versions.private, Buffer$1.concat([Buffer$1.alloc(1, 0), this.privateKey])))
        else return null
      }
    });

    Object.defineProperty(HDKey.prototype, 'publicExtendedKey', {
      get: function () {
        return bs58check.encode(serialize(this, this.versions.public, this.publicKey))
      }
    });

    HDKey.prototype.derive = function (path) {
      if (path === 'm' || path === 'M' || path === "m'" || path === "M'") {
        return this
      }

      var entries = path.split('/');
      var hdkey = this;
      entries.forEach(function (c, i) {
        if (i === 0) {
          assert(/^[mM]{1}/.test(c), 'Path must start with "m" or "M"');
          return
        }

        var hardened = (c.length > 1) && (c[c.length - 1] === "'");
        var childIndex = parseInt(c, 10); // & (HARDENED_OFFSET - 1)
        assert(childIndex < HARDENED_OFFSET, 'Invalid index');
        if (hardened) childIndex += HARDENED_OFFSET;

        hdkey = hdkey.deriveChild(childIndex);
      });

      return hdkey
    };

    HDKey.prototype.deriveChild = function (index) {
      var isHardened = index >= HARDENED_OFFSET;
      var indexBuffer = Buffer$1.allocUnsafe(4);
      indexBuffer.writeUInt32BE(index, 0);

      var data;

      if (isHardened) { // Hardened child
        assert(this.privateKey, 'Could not derive hardened child key');

        var pk = this.privateKey;
        var zb = Buffer$1.alloc(1, 0);
        pk = Buffer$1.concat([zb, pk]);

        // data = 0x00 || ser256(kpar) || ser32(index)
        data = Buffer$1.concat([pk, indexBuffer]);
      } else { // Normal child
        // data = serP(point(kpar)) || ser32(index)
        //      = serP(Kpar) || ser32(index)
        data = Buffer$1.concat([this.publicKey, indexBuffer]);
      }

      var I = crypto$1.createHmac('sha512', this.chainCode).update(data).digest();
      var IL = I.slice(0, 32);
      var IR = I.slice(32);

      var hd = new HDKey(this.versions);

      // Private parent key -> private child key
      if (this.privateKey) {
        // ki = parse256(IL) + kpar (mod n)
        try {
          hd.privateKey = secp256k1.privateKeyTweakAdd(this.privateKey, IL);
          // throw if IL >= n || (privateKey + IL) === 0
        } catch (err) {
          // In case parse256(IL) >= n or ki == 0, one should proceed with the next value for i
          return this.deriveChild(index + 1)
        }
      // Public parent key -> public child key
      } else {
        // Ki = point(parse256(IL)) + Kpar
        //    = G*IL + Kpar
        try {
          hd.publicKey = secp256k1.publicKeyTweakAdd(this.publicKey, IL, true);
          // throw if IL >= n || (g**IL + publicKey) is infinity
        } catch (err) {
          // In case parse256(IL) >= n or Ki is the point at infinity, one should proceed with the next value for i
          return this.deriveChild(index + 1)
        }
      }

      hd.chainCode = IR;
      hd.depth = this.depth + 1;
      hd.parentFingerprint = this.fingerprint;// .readUInt32BE(0)
      hd.index = index;

      return hd
    };

    HDKey.prototype.sign = function (hash) {
      return secp256k1.sign(hash, this.privateKey).signature
    };

    HDKey.prototype.verify = function (hash, signature) {
      return secp256k1.verify(hash, signature, this.publicKey)
    };

    HDKey.prototype.wipePrivateData = function () {
      if (this._privateKey) crypto$1.randomBytes(this._privateKey.length).copy(this._privateKey);
      this._privateKey = null;
      return this
    };

    HDKey.prototype.toJSON = function () {
      return {
        xpriv: this.privateExtendedKey,
        xpub: this.publicExtendedKey
      }
    };

    HDKey.fromMasterSeed = function (seedBuffer, versions) {
      var I = crypto$1.createHmac('sha512', MASTER_SECRET).update(seedBuffer).digest();
      var IL = I.slice(0, 32);
      var IR = I.slice(32);

      var hdkey = new HDKey(versions);
      hdkey.chainCode = IR;
      hdkey.privateKey = IL;

      return hdkey
    };

    HDKey.fromExtendedKey = function (base58key, versions) {
      // => version(4) || depth(1) || fingerprint(4) || index(4) || chain(32) || key(33)
      versions = versions || BITCOIN_VERSIONS;
      var hdkey = new HDKey(versions);

      var keyBuffer = bs58check.decode(base58key);

      var version = keyBuffer.readUInt32BE(0);
      assert(version === versions.private || version === versions.public, 'Version mismatch: does not match private or public');

      hdkey.depth = keyBuffer.readUInt8(4);
      hdkey.parentFingerprint = keyBuffer.readUInt32BE(5);
      hdkey.index = keyBuffer.readUInt32BE(9);
      hdkey.chainCode = keyBuffer.slice(13, 45);

      var key = keyBuffer.slice(45);
      if (key.readUInt8(0) === 0) { // private
        assert(version === versions.private, 'Version mismatch: version does not match private');
        hdkey.privateKey = key.slice(1); // cut off first 0x0 byte
      } else {
        assert(version === versions.public, 'Version mismatch: version does not match public');
        hdkey.publicKey = key;
      }

      return hdkey
    };

    HDKey.fromJSON = function (obj) {
      return HDKey.fromExtendedKey(obj.xpriv)
    };

    function serialize (hdkey, version, key) {
      // => version(4) || depth(1) || fingerprint(4) || index(4) || chain(32) || key(33)
      var buffer = Buffer$1.allocUnsafe(LEN);

      buffer.writeUInt32BE(version, 0);
      buffer.writeUInt8(hdkey.depth, 4);

      var fingerprint = hdkey.depth ? hdkey.parentFingerprint : 0x00000000;
      buffer.writeUInt32BE(fingerprint, 5);
      buffer.writeUInt32BE(hdkey.index, 9);

      hdkey.chainCode.copy(buffer, 13);
      key.copy(buffer, 45);

      return buffer
    }

    function hash160 (buf) {
      var sha = crypto$1.createHash('sha256').update(buf).digest();
      return crypto$1.createHash('ripemd160').update(sha).digest()
    }

    HDKey.HARDENED_OFFSET = HARDENED_OFFSET;
    var hdkey = HDKey;

    var hdkey$1 = /*@__PURE__*/getDefaultExportFromCjs(hdkey);

    //  Copyright (C) 2018 Zilliqa
    var Wallet = /** @class */ (function (_super) {
        __extends(Wallet, _super);
        /**
         * constructor
         *
         * Takes an array of Account objects and instantiates a Wallet instance.
         *
         * @param {Account[]} accounts
         */
        function Wallet(provider, accounts) {
            if (accounts === void 0) { accounts = []; }
            var _this = _super.call(this) || this;
            _this.accounts = {};
            if (accounts.length) {
                _this.accounts = accounts.reduce(function (acc, account) {
                    var _a;
                    return __assign(__assign({}, acc), (_a = {}, _a[account.address] = account, _a));
                }, {});
            }
            _this.provider = provider;
            _this.defaultAccount = accounts[0];
            return _this;
        }
        /**
         * create
         *
         * Creates a new keypair with a randomly-generated private key. The new
         * account is accessible by address.
         *
         * @returns {string} - address of the new account
         */
        Wallet.prototype.create = function () {
            var _a;
            var privateKey = bundleExports.schnorr.generatePrivateKey();
            var newAccount = new Account(privateKey);
            this.accounts = __assign(__assign({}, this.accounts), (_a = {}, _a[newAccount.address] = newAccount, _a));
            if (!this.defaultAccount) {
                this.defaultAccount = newAccount;
            }
            return newAccount.address;
        };
        /**
         * addByPrivateKey
         *
         * Adds an account to the wallet by private key.
         *
         * @param {string} privateKey - hex-encoded private key
         * @returns {string} - the corresponing address, computer from the private
         * key.
         */
        Wallet.prototype.addByPrivateKey = function (privateKey) {
            var _a;
            var newAccount = new Account(privateKey);
            this.accounts = __assign(__assign({}, this.accounts), (_a = {}, _a[newAccount.address] = newAccount, _a));
            if (!this.defaultAccount) {
                this.defaultAccount = newAccount;
            }
            return newAccount.address;
        };
        /**
         * addByKeystore
         *
         * Adds an account by keystore. This method is asynchronous and returns
         * a Promise<string>, in order not to block on the underlying decryption
         * operation.
         *
         * @param {string} keystore
         * @param {string} passphrase
         * @returns {Promise<string>}
         */
        Wallet.prototype.addByKeystore = function (keystore, passphrase) {
            return __awaiter(this, void 0, void 0, function () {
                var newAccount;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, Account.fromFile(keystore, passphrase)];
                        case 1:
                            newAccount = _b.sent();
                            this.accounts = __assign(__assign({}, this.accounts), (_a = {}, _a[newAccount.address] = newAccount, _a));
                            if (!this.defaultAccount) {
                                this.defaultAccount = newAccount;
                            }
                            return [2 /*return*/, newAccount.address];
                    }
                });
            });
        };
        /**
         * addByMnemonic
         *
         * Adds an `Account` by use of a mnemonic as specified in BIP-32 and BIP-39
         *
         * @param {string} phrase - 12-word mnemonic phrase
         * @param {number} index=0 - the number of the child key to add
         * @returns {string} - the corresponding address
         */
        Wallet.prototype.addByMnemonic = function (phrase, index) {
            if (index === void 0) { index = 0; }
            if (!this.isValidMnemonic(phrase)) {
                throw new Error("Invalid mnemonic phrase: ".concat(phrase));
            }
            var seed = bip39$1.mnemonicToSeed(phrase);
            var hdKey = hdkey$1.fromMasterSeed(seed);
            var childKey = hdKey.derive("m/44'/313'/0'/0/".concat(index));
            var privateKey = childKey.privateKey.toString('hex');
            return this.addByPrivateKey(privateKey);
        };
        /**
         * addByMnemonicLedger
         *
         * Adds an `Account` by use of a mnemonic as specified in BIP-32 and BIP-39
         * The key derivation path used in Ledger is different from that of
         * addByMnemonic.
         *
         * @param {string} phrase - 12-word mnemonic phrase
         * @param {number} index=0 - the number of the child key to add
         * @returns {string} - the corresponding address
         */
        Wallet.prototype.addByMnemonicLedger = function (phrase, index) {
            if (index === void 0) { index = 0; }
            if (!this.isValidMnemonic(phrase)) {
                throw new Error("Invalid mnemonic phrase: ".concat(phrase));
            }
            var seed = bip39$1.mnemonicToSeed(phrase);
            var hdKey = hdkey$1.fromMasterSeed(seed);
            var childKey = hdKey.derive("m/44'/313'/".concat(index, "'/0'/0'"));
            var privateKey = childKey.privateKey.toString('hex');
            return this.addByPrivateKey(privateKey);
        };
        /**
         * export
         *
         * Exports the specified account as a keystore file.
         *
         * @param {string} address
         * @param {string} passphrase
         * @param {KDF} kdf='scrypt'
         * @returns {Promise<string>}
         */
        Wallet.prototype.export = function (address, passphrase, kdf) {
            if (kdf === void 0) { kdf = 'scrypt'; }
            if (!this.accounts[address]) {
                throw new Error("No account with address ".concat(address, " exists"));
            }
            return this.accounts[address].toFile(passphrase, kdf);
        };
        /**
         * remove
         *
         * Removes an account from the wallet and returns boolean to indicate
         * failure or success.
         *
         * @param {string} address
         * @returns {boolean}
         */
        Wallet.prototype.remove = function (address) {
            if (this.accounts[address]) {
                var _a = this.accounts, _b = address; _a[_b]; var rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                this.accounts = rest;
                return true;
            }
            return false;
        };
        /**
         * setDefault
         *
         * Sets the default account of the wallet.
         *
         * @param {string} address
         */
        Wallet.prototype.setDefault = function (address) {
            this.defaultAccount = this.accounts[address];
        };
        /**
         * sign
         *
         * signs an unsigned transaction with the default account.
         *
         * @param {Transaction} tx
         * @param {boolean} offlineSign
         * @returns {Transaction}
         */
        Wallet.prototype.sign = function (tx, offlineSign) {
            if (tx.txParams && tx.txParams.pubKey) {
                // attempt to find the address
                var senderAddress = bundleExports.getAddressFromPublicKey(tx.txParams.pubKey);
                if (!this.accounts[senderAddress]) {
                    throw new Error("Could not sign the transaction with ".concat(senderAddress, " as it does not exist"));
                }
                return this.signWith(tx, senderAddress, offlineSign);
            }
            if (!this.defaultAccount) {
                throw new Error('This wallet has no default account.');
            }
            return this.signWith(tx, this.defaultAccount.address, offlineSign);
        };
        Wallet.prototype.signBatch = function (txList) {
            return __awaiter(this, void 0, void 0, function () {
                var batchResults, signer_1, balance, nextNonce, _loop_1, this_1, index, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            batchResults = [];
                            if (!this.defaultAccount) {
                                throw new Error('This wallet has no default account.');
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 7, , 8]);
                            signer_1 = this.accounts[this.defaultAccount.address];
                            return [4 /*yield*/, this.provider.send(bundleExports$2.RPCMethod.GetBalance, signer_1.address.replace('0x', '').toLowerCase())];
                        case 2:
                            balance = _a.sent();
                            if (balance.result === undefined) {
                                throw new Error('Could not get balance');
                            }
                            if (typeof balance.result.nonce !== 'number') {
                                throw new Error('Could not get nonce');
                            }
                            nextNonce = balance.result.nonce + 1;
                            _loop_1 = function (index) {
                                var currentNonce, withNonceTx, signedTx;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            currentNonce = index + nextNonce;
                                            withNonceTx = txList[index].map(function (txObj) {
                                                return __assign(__assign({}, txObj), { nonce: currentNonce, pubKey: signer_1.publicKey });
                                            });
                                            return [4 /*yield*/, this_1.sign(withNonceTx)];
                                        case 1:
                                            signedTx = _b.sent();
                                            batchResults.push(signedTx);
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            index = 0;
                            _a.label = 3;
                        case 3:
                            if (!(index < txList.length)) return [3 /*break*/, 6];
                            return [5 /*yield**/, _loop_1(index)];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5:
                            index++;
                            return [3 /*break*/, 3];
                        case 6: return [3 /*break*/, 8];
                        case 7:
                            err_1 = _a.sent();
                            throw err_1;
                        case 8: return [2 /*return*/, batchResults];
                    }
                });
            });
        };
        /**
         * signWith
         *
         * @param {Transaction} tx
         * @param {string} account
         * @param {boolean} offlineSign
         * @returns {Transaction}
         */
        Wallet.prototype.signWith = function (tx, account, offlineSign) {
            return __awaiter(this, void 0, void 0, function () {
                var signer, gasPrice, gasLimit, debt, currNonce, balance, bal, withNonce_1, withPublicKey, err_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.accounts[account]) {
                                throw new Error('The selected account does not exist on this Wallet instance.');
                            }
                            signer = this.accounts[account];
                            gasPrice = tx.txParams.gasPrice;
                            gasLimit = new bundleExports$1.BN(tx.txParams.gasLimit.toString());
                            debt = gasPrice.mul(gasLimit).add(tx.txParams.amount);
                            currNonce = 0;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 5, , 6]);
                            if (!!tx.txParams.nonce) return [3 /*break*/, 4];
                            if (offlineSign) {
                                throw new Error('No nonce detected in tx params when signing in offline mode');
                            }
                            if (!(typeof offlineSign === 'undefined' || !offlineSign)) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.provider.send(bundleExports$2.RPCMethod.GetBalance, signer.address.replace('0x', '').toLowerCase())];
                        case 2:
                            balance = _a.sent();
                            if (balance.result === undefined) {
                                throw new Error('Could not get balance');
                            }
                            bal = new bundleExports$1.BN(balance.result.balance);
                            if (debt.gt(bal)) {
                                throw new Error('You do not have enough funds, need ' +
                                    debt.toString() +
                                    ' but only have ' +
                                    bal.toString());
                            }
                            if (typeof balance.result.nonce !== 'number') {
                                throw new Error('Could not get nonce');
                            }
                            currNonce = balance.result.nonce;
                            _a.label = 3;
                        case 3:
                            withNonce_1 = tx.map(function (txObj) {
                                return __assign(__assign({}, txObj), { nonce: txObj.nonce || currNonce + 1, pubKey: signer.publicKey });
                            });
                            return [2 /*return*/, withNonce_1.map(function (txObj) {
                                    // @ts-ignore
                                    return __assign(__assign({}, txObj), { signature: signer.signTransaction(withNonce_1.bytes) });
                                })];
                        case 4:
                            withPublicKey = tx.map(function (txObj) {
                                return __assign(__assign({}, txObj), { pubKey: signer.publicKey });
                            });
                            return [2 /*return*/, withPublicKey.map(function (txObj) {
                                    return __assign(__assign({}, txObj), { signature: signer.signTransaction(tx.bytes) });
                                })];
                        case 5:
                            err_2 = _a.sent();
                            throw err_2;
                        case 6: return [2 /*return*/];
                    }
                });
            });
        };
        Wallet.prototype.isValidMnemonic = function (phrase) {
            if (phrase.trim().split(/\s+/g).length < 12) {
                return false;
            }
            return bip39$1.validateMnemonic(phrase);
        };
        return Wallet;
    }(bundleExports$2.Signer));

    //  Copyright (C) 2018 Zilliqa
    //
    //  This file is part of zilliqa-js
    //
    //  This program is free software: you can redistribute it and/or modify
    //  it under the terms of the GNU General Public License as published by
    //  the Free Software Foundation, either version 3 of the License, or
    //  (at your option) any later version.
    //
    //  This program is distributed in the hope that it will be useful,
    //  but WITHOUT ANY WARRANTY; without even the implied warranty of
    //  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    //  GNU General Public License for more details.
    //
    //  You should have received a copy of the GNU General Public License
    //  along with this program.  If not, see <https://www.gnu.org/licenses/>.
    exports.TxStatus = void 0;
    (function (TxStatus) {
        TxStatus[TxStatus["Initialised"] = 0] = "Initialised";
        TxStatus[TxStatus["Pending"] = 1] = "Pending";
        TxStatus[TxStatus["Confirmed"] = 2] = "Confirmed";
        TxStatus[TxStatus["Rejected"] = 3] = "Rejected";
    })(exports.TxStatus || (exports.TxStatus = {}));
    exports.TxEventName = void 0;
    (function (TxEventName) {
        TxEventName["Error"] = "error";
        TxEventName["Receipt"] = "receipt";
        TxEventName["Track"] = "track";
    })(exports.TxEventName || (exports.TxEventName = {}));

    //  Copyright (C) 2018 Zilliqa
    /**
     * Transaction
     *
     * Transaction is a functor. Its purpose is to encode the possible states a
     * Transaction can be in:  Confirmed, Rejected, Pending, or Initialised (i.e., not broadcasted).
     */
    var Transaction = /** @class */ (function () {
        function Transaction(params, provider, status, toDS, enableSecureToAddress) {
            if (status === void 0) { status = exports.TxStatus.Initialised; }
            if (toDS === void 0) { toDS = false; }
            if (enableSecureToAddress === void 0) { enableSecureToAddress = true; }
            this.code = "";
            this.data = "";
            // private members
            this.version = params.version;
            this.toAddr = enableSecureToAddress
                ? bundleExports.normaliseAddress(params.toAddr)
                : bundleExports.toChecksumAddress(params.toAddr);
            this.nonce = params.nonce;
            this.pubKey = params.pubKey;
            this.amount = params.amount;
            this.code = params.code || "";
            this.data = params.data || "";
            this.signature = params.signature;
            this.gasPrice = params.gasPrice;
            this.gasLimit = params.gasLimit;
            this.receipt = params.receipt;
            // public members
            this.provider = provider;
            this.status = status;
            this.toDS = toDS;
            this.blockConfirmation = 0;
            this.eventEmitter = new bundleExports$2.EventEmitter();
        }
        /**
         * confirm
         *
         * constructs an already-confirmed transaction.
         *
         * @static
         * @param {BaseTx} params
         */
        Transaction.confirm = function (params, provider) {
            return new Transaction(params, provider, exports.TxStatus.Confirmed);
        };
        /**
         * reject
         *
         * constructs an already-rejected transaction.
         *
         * @static
         * @param {BaseTx} params
         */
        Transaction.reject = function (params, provider) {
            return new Transaction(params, provider, exports.TxStatus.Rejected);
        };
        Object.defineProperty(Transaction.prototype, "hash", {
            /**
             * to get hash or transaction id of this transaction
             * this can be identical returned by zilliqa network while calling CreateTransaction
             */
            get: function () {
                var payload = this.bytes.toString("hex");
                return hashjs.sha256().update(payload, "hex").digest("hex");
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Transaction.prototype, "bytes", {
            get: function () {
                return encodeTransactionProto(this.txParams);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Transaction.prototype, "senderAddress", {
            get: function () {
                if (!this.pubKey) {
                    return "0".repeat(40);
                }
                return bundleExports.getAddressFromPublicKey(this.pubKey);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Transaction.prototype, "txParams", {
            get: function () {
                return {
                    version: this.version,
                    toAddr: bundleExports.normaliseAddress(this.toAddr),
                    nonce: this.nonce,
                    pubKey: this.pubKey,
                    amount: this.amount,
                    gasPrice: this.gasPrice,
                    gasLimit: this.gasLimit,
                    code: this.code,
                    data: this.data,
                    signature: this.signature,
                    receipt: this.receipt,
                };
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Transaction.prototype, "payload", {
            get: function () {
                return {
                    version: this.version,
                    toAddr: this.toAddr,
                    nonce: this.nonce,
                    pubKey: this.pubKey,
                    amount: this.amount.toString(),
                    gasPrice: this.gasPrice.toString(),
                    gasLimit: this.gasLimit.toString(),
                    code: this.code,
                    data: this.data,
                    signature: this.signature,
                    receipt: this.receipt,
                };
            },
            enumerable: false,
            configurable: true
        });
        /**
         * isPending
         *
         * @returns {boolean}
         */
        Transaction.prototype.isPending = function () {
            return this.status === exports.TxStatus.Pending;
        };
        /**
         * isInitialised
         *
         * @returns {boolean}
         */
        Transaction.prototype.isInitialised = function () {
            return this.status === exports.TxStatus.Initialised;
        };
        Transaction.prototype.getReceipt = function () {
            return this.receipt;
        };
        /**
         * isConfirmed
         *
         * @returns {boolean}
         */
        Transaction.prototype.isConfirmed = function () {
            return this.status === exports.TxStatus.Confirmed;
        };
        /**
         * isRejected
         *
         * @returns {boolean}
         */
        Transaction.prototype.isRejected = function () {
            return this.status === exports.TxStatus.Rejected;
        };
        /**
         * setProvider
         *
         * Sets the provider on this instance.
         *
         * @param {Provider} provider
         */
        Transaction.prototype.setProvider = function (provider) {
            this.provider = provider;
        };
        /**
         * setStatus
         *
         * Escape hatch to imperatively set the state of the transaction.
         *
         * @param {TxStatus} status
         * @returns {undefined}
         */
        Transaction.prototype.setStatus = function (status) {
            this.status = status;
            return this;
        };
        Transaction.prototype.observed = function () {
            return this.eventEmitter;
        };
        /**
         * blockConfirm
         *
         * Use `RPCMethod.GetLatestBlock` to get latest blockNumber
         * Use interval to get the latestBlockNumber
         * After BlockNumber change, then we use `RPCMethod.GetTransaction` to get the receipt
         *
         * @param {string} txHash
         * @param {number} maxblockCount
         * @param {number} interval interval in milliseconds
         * @returns {Promise<Transaction>}
         */
        Transaction.prototype.blockConfirm = function (txHash, maxblockCount, interval) {
            if (maxblockCount === void 0) { maxblockCount = 4; }
            if (interval === void 0) { interval = 1000; }
            return __awaiter(this, void 0, void 0, function () {
                var blockStart, blockChecked, attempt, blockLatest, blockNext, err_1, blockFailed, errorMessage;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.status = exports.TxStatus.Pending;
                            return [4 /*yield*/, this.getBlockNumber()];
                        case 1:
                            blockStart = _a.sent();
                            blockChecked = blockStart;
                            attempt = 0;
                            _a.label = 2;
                        case 2:
                            if (!(attempt < maxblockCount)) return [3 /*break*/, 12];
                            _a.label = 3;
                        case 3:
                            _a.trys.push([3, 8, , 9]);
                            return [4 /*yield*/, this.getBlockNumber()];
                        case 4:
                            blockLatest = _a.sent();
                            blockNext = blockChecked.add(new bundleExports$1.BN(attempt === 0 ? attempt : 1));
                            if (!blockLatest.gte(blockNext)) return [3 /*break*/, 6];
                            blockChecked = blockLatest;
                            this.emit(exports.TxEventName.Track, {
                                txHash: txHash,
                                attempt: attempt,
                                currentBlock: blockChecked.toString(),
                            });
                            return [4 /*yield*/, this.trackTx(txHash)];
                        case 5:
                            if (_a.sent()) {
                                this.blockConfirmation = blockLatest.sub(blockStart).toNumber();
                                return [2 /*return*/, this];
                            }
                            return [3 /*break*/, 7];
                        case 6:
                            attempt = attempt - 1 >= 0 ? attempt - 1 : 0;
                            _a.label = 7;
                        case 7: return [3 /*break*/, 9];
                        case 8:
                            err_1 = _a.sent();
                            this.status = exports.TxStatus.Rejected;
                            throw err_1;
                        case 9:
                            if (!(attempt + 1 < maxblockCount)) return [3 /*break*/, 11];
                            return [4 /*yield*/, sleep(interval)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            attempt += 1;
                            return [3 /*break*/, 2];
                        case 12: return [4 /*yield*/, this.getBlockNumber()];
                        case 13:
                            blockFailed = _a.sent();
                            this.blockConfirmation = blockFailed.sub(blockStart).toNumber();
                            this.status = exports.TxStatus.Rejected;
                            errorMessage = "The transaction is still not confirmed after ".concat(maxblockCount, " blocks.");
                            throw new Error(errorMessage);
                    }
                });
            });
        };
        /**
         * confirmReceipt
         *
         * Similar to the Promise API. This sets the Transaction instance to a state
         * of pending. Calling this function kicks off a passive loop that polls the
         * lookup node for confirmation on the txHash.
         *
         * The polls are performed with a linear backoff:
         *
         * `const delay = interval * attempt`
         *
         * This is a low-level method that you should generally not have to use
         * directly.
         *
         * @param {string} txHash
         * @param {number} maxAttempts
         * @param {number} initial interval in milliseconds
         * @returns {Promise<Transaction>}
         */
        Transaction.prototype.confirm = function (txHash, maxAttempts, interval) {
            if (maxAttempts === void 0) { maxAttempts = bundleExports$2.GET_TX_ATTEMPTS; }
            if (interval === void 0) { interval = 1000; }
            return __awaiter(this, void 0, void 0, function () {
                var attempt, err_2, errorMessage;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.status = exports.TxStatus.Pending;
                            attempt = 0;
                            _a.label = 1;
                        case 1:
                            if (!(attempt < maxAttempts)) return [3 /*break*/, 8];
                            this.emit(exports.TxEventName.Track, {
                                txHash: txHash,
                                attempt: attempt,
                            });
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, this.trackTx(txHash)];
                        case 3:
                            if (_a.sent()) {
                                return [2 /*return*/, this];
                            }
                            return [3 /*break*/, 5];
                        case 4:
                            err_2 = _a.sent();
                            this.status = exports.TxStatus.Rejected;
                            throw err_2;
                        case 5:
                            if (!(attempt + 1 < maxAttempts)) return [3 /*break*/, 7];
                            return [4 /*yield*/, sleep(interval * attempt)];
                        case 6:
                            _a.sent();
                            _a.label = 7;
                        case 7:
                            attempt++;
                            return [3 /*break*/, 1];
                        case 8:
                            this.status = exports.TxStatus.Rejected;
                            errorMessage = "The transaction is still not confirmed after ".concat(maxAttempts, " attempts.");
                            throw new Error(errorMessage);
                    }
                });
            });
        };
        /**
         * map
         *
         * maps over the transaction, allowing for manipulation.
         *
         * @param {(prev: TxParams) => TxParams} fn - mapper
         * @returns {Transaction}
         */
        Transaction.prototype.map = function (fn) {
            var newParams = fn(this.txParams);
            this.setParams(newParams);
            return this;
        };
        Transaction.prototype.setParams = function (params) {
            this.version = params.version;
            this.toAddr = bundleExports.normaliseAddress(params.toAddr);
            this.nonce = params.nonce;
            this.pubKey = params.pubKey;
            this.amount = params.amount;
            this.code = params.code || "";
            this.data = params.data || "";
            this.signature = params.signature;
            this.gasPrice = params.gasPrice;
            this.gasLimit = params.gasLimit;
            this.receipt = params.receipt;
        };
        Transaction.prototype.trackTx = function (txHash) {
            return __awaiter(this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.provider.send(bundleExports$2.RPCMethod.GetTransaction, txHash)];
                        case 1:
                            res = _a.sent();
                            if (res.error) {
                                this.emit(exports.TxEventName.Error, res.error);
                                return [2 /*return*/, false];
                            }
                            this.id = res.result.ID;
                            this.receipt = __assign(__assign({}, res.result.receipt), { cumulative_gas: parseInt(res.result.receipt.cumulative_gas, 10) });
                            this.emit(exports.TxEventName.Receipt, this.receipt);
                            this.status =
                                this.receipt && this.receipt.success
                                    ? exports.TxStatus.Confirmed
                                    : exports.TxStatus.Rejected;
                            return [2 /*return*/, true];
                    }
                });
            });
        };
        Transaction.prototype.getBlockNumber = function () {
            return __awaiter(this, void 0, void 0, function () {
                var res, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.provider.send(bundleExports$2.RPCMethod.GetLatestTxBlock)];
                        case 1:
                            res = _a.sent();
                            if (res.error === undefined && res.result.header.BlockNum) {
                                // if blockNumber is too high, we use BN to be safer
                                return [2 /*return*/, new bundleExports$1.BN(res.result.header.BlockNum)];
                            }
                            else {
                                throw new Error("Can not get latest BlockNumber");
                            }
                        case 2:
                            error_1 = _a.sent();
                            throw error_1;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        Transaction.prototype.emit = function (event, txEvent) {
            this.eventEmitter.emit(event, __assign(__assign({}, txEvent), { event: event }));
        };
        return Transaction;
    }());

    //  Copyright (C) 2018 Zilliqa
    var TransactionFactory = /** @class */ (function () {
        function TransactionFactory(provider, signer) {
            this.provider = provider;
            this.provider.middleware.request.use(formatOutgoingTx, bundleExports$2.RPCMethod.CreateTransaction);
            this.signer = signer;
        }
        TransactionFactory.prototype.new = function (txParams, toDs, enableSecureAddress) {
            if (toDs === void 0) { toDs = false; }
            if (enableSecureAddress === void 0) { enableSecureAddress = true; }
            return new Transaction(txParams, this.provider, exports.TxStatus.Initialised, toDs, enableSecureAddress);
        };
        /**
         * This constructor could help you to check if there is a default account to be used, and further more, if it has
         * sufficient fund to do the transfer.
         * @param txParams
         */
        TransactionFactory.prototype.payment = function (txParams) {
            return __awaiter(this, void 0, void 0, function () {
                var defaultAccount, addr, response, fund;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            defaultAccount = this.signer.defaultAccount;
                            if (!(defaultAccount !== undefined)) return [3 /*break*/, 2];
                            addr = defaultAccount.address;
                            return [4 /*yield*/, this.provider.send(bundleExports$2.RPCMethod.GetBalance, addr.replace('0x', '').toLowerCase())];
                        case 1:
                            response = _a.sent();
                            if (response.error) {
                                throw response.error;
                            }
                            fund = new bundleExports$1.BN(response.result.balance);
                            if (txParams.amount.cmp(fund) === 1) {
                                throw new Error('No sufficient fund');
                            }
                            return [3 /*break*/, 3];
                        case 2: throw new Error('No default wallet');
                        case 3: return [2 /*return*/, this.new(txParams, true)];
                    }
                });
            });
        };
        return TransactionFactory;
    }());

    exports.Account = Account;
    exports.Transaction = Transaction;
    exports.TransactionFactory = TransactionFactory;
    exports.Wallet = Wallet;
    exports.util = util;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=bundle.js.map
